/*
 * Atlas - Uma biblioteca de componentes desenvolvida pelo Asaas
 * @version 27.7.0
 * @link https://github.com/asaasdev/atlas
 * @link https://doc.atlas.asaas.com/
 */
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __reflectGet = Reflect.get;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __export = (target, all) => {
  for (var name2 in all) __defProp(target, name2, {
    get: all[name2],
    enumerable: true
  });
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
var __superGet = (cls, obj, key) => __reflectGet(__getProtoOf(cls), key, obj);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = value => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = value => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = x => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/internals/prototypes.ts
HTMLElement.prototype.showElement = function showElement() {
  this.hidden = false;
  if (this.classList.contains("hide")) {
    this.classList.remove("hide");
  }
};
HTMLElement.prototype.hideElement = function hideElement() {
  this.hidden = true;
  if (!this.classList.contains("hide")) {
    this.classList.add("hide");
  }
};
HTMLElement.prototype.toggleElement = function toggleElement(forceState) {
  if (forceState !== void 0 && forceState !== null) {
    this.hidden = !forceState;
    if (forceState) {
      this.classList.remove("hide");
    } else {
      this.classList.add("hide");
    }
  } else {
    this.hidden = !this.hidden;
    if (this.hidden) {
      this.classList.add("hide");
    } else {
      this.classList.remove("hide");
    }
  }
};
HTMLElement.prototype.isVisibleInViewport = function isVisibleInViewport() {
  const rect = this.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;
  const vertInView = rect.top <= windowHeight && rect.bottom >= 0;
  const horInView = rect.left <= windowWidth && rect.right >= 0;
  return vertInView && horInView;
};

// src/internals/polyfills.ts
import "mdn-polyfills/Element.prototype.getAttributeNames.js";
import "mdn-polyfills/Element.prototype.toggleAttribute.js";

// src/internals/polyfills/assigned-elements.ts
if (typeof HTMLSlotElement.prototype.assignedElements === "undefined") {
  HTMLSlotElement.prototype.assignedElements = function (...args) {
    return HTMLSlotElement.prototype.assignedNodes.apply(this, args).filter(n => n instanceof Element);
  };
}

// src/internals/polyfills.ts
import "globalthis/auto.js";

// src/helpers/validations.ts
var validations_exports = {};
__export(validations_exports, {
  isEmptyValue: () => isEmptyValue
});
var isEmptyValue = value => {
  if (value === null || value === void 0 || value === "") {
    return true;
  }
  if (Array.isArray(value)) {
    return value.length === 0;
  }
  if (typeof value === "object") {
    return Object.keys(value).length === 0;
  }
  return false;
};

// src/internals/events.ts
var ALLOWED_ELEMENT_ATTRIBUTES = ["label", "placeholder", "header", "description", "id"];
function extractElementProps(el) {
  const attrs = el.attributes;
  const extractedProps = {};
  for (let i = 0; i < attrs.length; i++) {
    const isInWhiteList = ALLOWED_ELEMENT_ATTRIBUTES.includes(attrs[i].nodeName);
    const isTrackProp = attrs[i].nodeName.startsWith("data-track-");
    if (isInWhiteList || isTrackProp) {
      extractedProps[attrs[i].nodeName.replace("data-track-", "").replace(/-/g, "_")] = attrs[i].nodeValue;
    }
  }
  return extractedProps;
}
function getElementContainers(el) {
  var _a, _b, _c, _d;
  return {
    "panel": (_a = el.closest("atlas-panel")) == null ? void 0 : _a.getAttribute("header"),
    "section": (_b = el.closest("atlas-section")) == null ? void 0 : _b.getAttribute("header"),
    "card": (_c = el.closest("atlas-card")) == null ? void 0 : _c.getAttribute("header"),
    "wizard-step": (_d = el.closest("atlas-wizard-step")) == null ? void 0 : _d.getAttribute("header")
  };
}
function canEmitTrack(el, options) {
  if (options == null ? void 0 : options.trackDisable) return false;
  if (!(el instanceof HTMLElement)) return true;
  if (el.hasAttribute("data-track-enable")) return true;
  if (el.hasAttribute("data-track-disable")) return false;
  const closestTrackDisable = el.closest("[data-track-disable]");
  const closestTrackEnable = el.closest("[data-track-enable]");
  return closestTrackDisable ? closestTrackDisable == null ? void 0 : closestTrackDisable.contains(closestTrackEnable) : true;
}
function getTrackDetails(el, options) {
  let trackDetails = (options == null ? void 0 : options.detail) || {};
  if (el instanceof HTMLElement) {
    trackDetails = __spreadValues(__spreadValues(__spreadValues({}, trackDetails), getElementContainers(el)), extractElementProps(el));
  }
  return Object.keys(trackDetails).reduce((acc, detail) => {
    if (isEmptyValue(trackDetails[detail])) {
      return acc;
    }
    return __spreadProps(__spreadValues({}, acc), {
      [detail]: trackDetails[detail]
    });
  }, {});
}
function emitTrackEvent(el, name2, options) {
  if (!canEmitTrack(el, options)) return;
  const trackDetails = getTrackDetails(el, options);
  if (Object.keys(trackDetails).length === 0) return;
  const trackEvent = new CustomEvent("atlas-track-event", {
    bubbles: true,
    cancelable: false,
    composed: true,
    detail: __spreadValues({
      action: name2
    }, trackDetails)
  });
  el.dispatchEvent(trackEvent);
}
function emit(el, name2, options) {
  const event = new CustomEvent(name2, __spreadValues({
    bubbles: true,
    cancelable: true,
    composed: true,
    detail: {}
  }, options));
  el.dispatchEvent(event);
  emitTrackEvent(el, name2, options);
  return event;
}

// src/internals/custom-elements.ts
var findUndefinedElements = root => {
  const rootTagName = root instanceof Element ? root.tagName.toLowerCase() : "";
  const rootIsCustomElement = rootTagName == null ? void 0 : rootTagName.startsWith("atlas-");
  const tags = [...root.querySelectorAll(":not(:defined)")].map(el => el.tagName.toLowerCase()).filter(tag => tag.startsWith("atlas-"));
  if (rootIsCustomElement && !customElements.get(rootTagName)) {
    tags.push(rootTagName);
  }
  return [...new Set(tags)];
};
var waitAllElementsDefine = () => __async(null, null, function* () {
  const atlasElements = findUndefinedElements(document.body);
  const definePromises = atlasElements.map(tagName => window.customElements.whenDefined(tagName));
  yield Promise.all(definePromises);
  emit(document, "AtlasContentLoaded", {
    trackDisable: true
  });
});
document.addEventListener("DOMContentLoaded", () => {
  waitAllElementsDefine();
});

// src/components/chart/atlas-column-chart/atlas-column-chart.ts
import { html as html2 } from "lit";
import { customElement, property as property2, query } from "lit/decorators.js";
import Chart from "chart.js/auto";
import pattern from "patternomaly";

// src/decorators/watch.ts
function Watch(propName, waitFirstUpdate = false) {
  return (proto, decoratedFunction) => {
    const {
      update
    } = proto;
    const props = Array.isArray(propName) ? propName : [propName];
    const filteredProps = props.filter(prop => prop in proto);
    if (filteredProps.length > 0) {
      proto.update = function (changedProps) {
        const changedPropsMap = /* @__PURE__ */new Map();
        filteredProps.forEach(prop => {
          if (changedProps.has(prop)) {
            const propNameKey = prop;
            const oldValue = changedProps.get(prop);
            const newValue = this[propNameKey];
            if (oldValue !== newValue) {
              changedPropsMap.set(prop, {
                oldValue,
                newValue
              });
            }
          }
        });
        if (changedPropsMap.size > 0 && (!waitFirstUpdate || this.hasUpdated)) {
          if (changedPropsMap.size === 1) {
            const firstEntry = changedPropsMap.entries().next().value;
            this[decoratedFunction](firstEntry[1].oldValue, firstEntry[1].newValue);
          } else {
            this[decoratedFunction](changedPropsMap);
          }
        }
        update.call(this, changedProps);
      };
    }
  };
}

// src/components/atlas-element.ts
import { LitElement, html } from "lit";
import { property } from "lit/decorators.js";
import { when } from "lit/directives/when.js";
var AtlasElement = class extends LitElement {
  applySkeleton() {
    return __async(this, null, function* () {
      yield this.updateComplete;
      const allElements = this.shadowRoot.querySelectorAll("*");
      allElements.forEach(element => {
        if (element.tagName === "SLOT") {
          this.setLoadingSlot(element);
        } else {
          element.toggleAttribute("skeleton-loading", this.skeletonLoading);
        }
      });
      emit(this, "atlas-element-change-skeleton", {
        trackDisable: true
      });
    });
  }
  update(changedProperties) {
    super.update(changedProperties);
    if (this.hasUpdated) {
      this.updateComplete.then(() => {
        emit(this, "atlas-element-update", {
          detail: changedProperties,
          trackDisable: true
        });
      });
    }
  }
  renderSkeleton() {
    return html``;
  }
  renderElement() {
    return html``;
  }
  setLoadingSlot(slot) {
    const elements = slot.assignedElements();
    elements.forEach(element => {
      element.toggleAttribute("skeleton-loading", this.skeletonLoading);
    });
  }
  /** @internal */
  render() {
    return when(this.skeletonLoading, () => this.renderSkeleton(), () => this.renderElement());
  }
};
__decorateClass([property({
  type: Boolean,
  attribute: "hide-on-desktop",
  reflect: true
})], AtlasElement.prototype, "hideOnDesktop", 2);
__decorateClass([property({
  type: Boolean,
  attribute: "hide-on-mobile",
  reflect: true
})], AtlasElement.prototype, "hideOnMobile", 2);
__decorateClass([property({
  type: Boolean,
  attribute: "skeleton-loading",
  reflect: true
})], AtlasElement.prototype, "skeletonLoading", 2);
__decorateClass([Watch("skeletonLoading")], AtlasElement.prototype, "applySkeleton", 1);

// src/components/chart/chart-colors.scss
import { css } from "lit-element/lit-element.js";
var chart_colors_default = css`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* stylelint-disable */
inflow {
  color: rgb(117, 183, 152.4);
}

outflow {
  color: rgb(234, 133.8, 143.4);
}

overall {
  color: rgb(102, 130.8, 213);
}

real {
  color: rgb(102, 130.8, 213);
}

goal {
  color: #6c757d;
}

atlas-primary-100 {
  color: rgb(204, 213.6, 241);
}

atlas-primary-200 {
  color: rgb(153, 172.2, 227);
}

atlas-primary-300 {
  color: rgb(102, 130.8, 213);
}

atlas-primary-400 {
  color: rgb(51, 89.4, 199);
}

atlas-primary-500 {
  color: #0030b9;
}

atlas-primary-600 {
  color: rgb(0, 38.4, 148);
}

atlas-primary-700 {
  color: rgb(0, 28.8, 111);
}

atlas-primary-800 {
  color: rgb(0, 19.2, 74);
}

atlas-primary-900 {
  color: rgb(0, 9.6, 37);
}

atlas-secondary-100 {
  color: #e9ecef;
}

atlas-secondary-200 {
  color: #dee2e6;
}

atlas-secondary-300 {
  color: #ced4da;
}

atlas-secondary-400 {
  color: #adb5bd;
}

atlas-secondary-500 {
  color: #6c757d;
}

atlas-secondary-600 {
  color: #495057;
}

atlas-secondary-700 {
  color: #343a40;
}

atlas-secondary-800 {
  color: #212529;
}

atlas-secondary-900 {
  color: #1a1e21;
}

atlas-success-100 {
  color: rgb(209, 231, 220.8);
}

atlas-success-200 {
  color: rgb(163, 207, 186.6);
}

atlas-success-300 {
  color: rgb(117, 183, 152.4);
}

atlas-success-400 {
  color: rgb(71, 159, 118.2);
}

atlas-success-500 {
  color: #198754;
}

atlas-success-600 {
  color: rgb(20, 108, 67.2);
}

atlas-success-700 {
  color: rgb(15, 81, 50.4);
}

atlas-success-800 {
  color: rgb(10, 54, 33.6);
}

atlas-success-900 {
  color: rgb(5, 27, 16.8);
}

atlas-warning-100 {
  color: rgb(251.2, 225.4, 204);
}

atlas-warning-200 {
  color: rgb(247.4, 195.8, 153);
}

atlas-warning-300 {
  color: rgb(243.6, 166.2, 102);
}

atlas-warning-400 {
  color: rgb(239.8, 136.6, 51);
}

atlas-warning-500 {
  color: #ec6b00;
}

atlas-warning-600 {
  color: rgb(188.8, 85.6, 0);
}

atlas-warning-700 {
  color: rgb(141.6, 64.2, 0);
}

atlas-warning-800 {
  color: rgb(94.4, 42.8, 0);
}

atlas-warning-900 {
  color: rgb(47.2, 21.4, 0);
}

atlas-danger-100 {
  color: rgb(248, 214.6, 217.8);
}

atlas-danger-200 {
  color: rgb(241, 174.2, 180.6);
}

atlas-danger-300 {
  color: rgb(234, 133.8, 143.4);
}

atlas-danger-400 {
  color: rgb(227, 93.4, 106.2);
}

atlas-danger-500 {
  color: #dc3545;
}

atlas-danger-600 {
  color: rgb(176, 42.4, 55.2);
}

atlas-danger-700 {
  color: rgb(132, 31.8, 41.4);
}

atlas-danger-800 {
  color: rgb(88, 21.2, 27.6);
}

atlas-danger-900 {
  color: rgb(44, 10.6, 13.8);
}

atlas-highlight-100 {
  color: rgb(204, 213.6, 241);
}

atlas-highlight-200 {
  color: rgb(153, 172.2, 227);
}

atlas-highlight-300 {
  color: rgb(102, 130.8, 213);
}

atlas-highlight-400 {
  color: rgb(51, 89.4, 199);
}

atlas-highlight-500 {
  color: #0030b9;
}

atlas-highlight-600 {
  color: rgb(0, 38.4, 148);
}

atlas-highlight-700 {
  color: rgb(0, 28.8, 111);
}

atlas-highlight-800 {
  color: rgb(0, 19.2, 74);
}

atlas-highlight-900 {
  color: rgb(0, 9.6, 37);
}

atlas-info-100 {
  color: rgb(205.2, 225.4, 239.8);
}

atlas-info-200 {
  color: rgb(155.4, 195.8, 224.6);
}

atlas-info-300 {
  color: rgb(105.6, 166.2, 209.4);
}

atlas-info-400 {
  color: rgb(55.8, 136.6, 194.2);
}

atlas-info-500 {
  color: #066bb3;
}

atlas-info-600 {
  color: rgb(4.8, 85.6, 143.2);
}

atlas-info-700 {
  color: rgb(3.6, 64.2, 107.4);
}

atlas-info-800 {
  color: rgb(2.4, 42.8, 71.6);
}

atlas-info-900 {
  color: rgb(1.2, 21.4, 35.8);
}

/* stylelint-enable */`;

// src/components/chart/atlas-column-chart/atlas-column-chart.scss
import { css as css2 } from "lit-element/lit-element.js";
var atlas_column_chart_default = css2`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: contents;
}

.chart-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.legend-list {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  padding: 0;
  margin-bottom: 1.5rem;
}
.legend-list .legend-item {
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
  align-items: center;
}
.legend-list .legend-item .legend-color {
  width: 8px;
  height: 8px;
  border-radius: 8px;
}
.legend-list .legend-item .legend-item {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  line-height: 1.5;
  font-weight: 700;
  color: #212529;
  margin: 0;
}
.legend-list .legend-item:hover {
  cursor: pointer;
}

.atlas-chart-tooltip {
  width: max-content;
  min-width: 40px;
  position: absolute;
  pointer-events: none;
  translate: -50% -115%;
  border-radius: 4px;
  box-sizing: border-box;
  background: #000000;
  opacity: 0;
}
.atlas-chart-tooltip::after {
  content: " ";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -7px;
  margin-top: -1px;
  border-width: 7px;
  border-style: solid;
  border-color: #000000 transparent transparent;
}
.atlas-chart-tooltip .tooltip-inner {
  display: flex;
  flex-direction: column;
  padding: 4px 8px;
  gap: 0.5rem;
  text-align: left;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 0.875rem;
  line-height: 1.5;
  font-weight: 700;
  color: #ffffff;
}`;

// src/helpers/base-path.ts
var base_path_exports = {};
__export(base_path_exports, {
  getAssetPath: () => getAssetPath,
  getAtlasBasePath: () => getAtlasBasePath,
  setAtlasBasePath: () => setAtlasBasePath
});
var atlasBasePath = "";
function setAtlasBasePath(path) {
  atlasBasePath = path;
}
function getAtlasBasePath() {
  if (!atlasBasePath) {
    const scripts = [...document.getElementsByTagName("script")];
    const atlasScript = scripts.find(s => /atlas(\.min)?\.js($|\?)/.test(s.src));
    let path = "";
    if (atlasScript) {
      path = atlasScript.getAttribute("src");
    }
    setAtlasBasePath(path.split("/").slice(0, -1).join("/"));
  }
  return atlasBasePath.replace(/\/$/, "");
}
function getAssetPath(assetPath) {
  return `${getAtlasBasePath()}/${assetPath.replace(/^\//, "")}`;
}

// src/helpers/formatters.ts
var formatters_exports = {};
__export(formatters_exports, {
  convertToDecimalFormat: () => convertToDecimalFormat,
  formatMoney: () => formatMoney,
  removeLeadingZeros: () => removeLeadingZeros,
  removeNegativeSign: () => removeNegativeSign,
  removeNonNumeric: () => removeNonNumeric,
  stringToNumber: () => stringToNumber,
  toCamelCase: () => toCamelCase,
  toKebabCase: () => toKebabCase
});
var stringToNumber = value => {
  if (typeof value === "number") return value;
  if (typeof value !== "string") return 0;
  if (value === void 0 || value === null) return 0;
  let stringValue = value;
  if (stringValue.indexOf("R$ ") >= 0) {
    stringValue = stringValue.replace("R$ ", "");
  }
  if (stringValue.indexOf(",") >= 0) {
    stringValue = stringValue.replace(/\./g, "").replace(/,/g, ".");
  }
  const valueNumber = Number.parseFloat(stringValue);
  return Number.isNaN(valueNumber) ? 0 : valueNumber;
};
var toKebabCase = text => text.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? "-" : "") + $.toLowerCase());
var toCamelCase = text => text.replace(/-\w/g, string => string.replace(/-/, "").toUpperCase());
var removeNonNumeric = (value, options = {}) => {
  if (!value) return "";
  const {
    allowNegative = false
  } = options;
  const nonNumericRegex = new RegExp(/\D/g);
  const sanitizedValue = value.replace(nonNumericRegex, "");
  const isNegative = allowNegative && value.startsWith("-");
  return isNegative ? `-${sanitizedValue}` : sanitizedValue;
};
var formatMoney = value => {
  const decimalPlace = 2;
  const valueAsString = value.toString();
  const valueAsNumber = Number(value);
  const fullNumber = parseInt(valueAsString, 10);
  let fixedNumber;
  if (Number.isNaN(valueAsNumber)) {
    fixedNumber = 0 .toFixed(decimalPlace);
  } else {
    fixedNumber = valueAsNumber.toFixed(decimalPlace);
  }
  const decimalPoint = ",";
  const numberDivisor = ".";
  const prefix = fullNumber < 0 ? "-" : "";
  const numberWithoutDecimalPlace = parseInt(fixedNumber, 10).toString();
  const firstPartDecimalPlaces = numberWithoutDecimalPlace.length > 3 ? numberWithoutDecimalPlace.length % 3 : 0;
  let wholeNumberPart = "";
  if (firstPartDecimalPlaces) {
    wholeNumberPart += numberWithoutDecimalPlace.substring(0, firstPartDecimalPlaces) + numberDivisor;
  }
  wholeNumberPart += numberWithoutDecimalPlace.substring(firstPartDecimalPlaces).replace(/(\d{3})(?=\d)/g, `$1${numberDivisor}`);
  const decimalPlacePart = decimalPoint + Math.abs(valueAsNumber - parseInt(numberWithoutDecimalPlace, 10)).toFixed(decimalPlace).slice(2);
  return prefix + wholeNumberPart + decimalPlacePart;
};
var removeLeadingZeros = (value, options = {}) => {
  if (!value) return "";
  const {
    allowNegative = false
  } = options;
  const isNegative = allowNegative && value.startsWith("-");
  const valueToSanitize = removeNegativeSign(value);
  const sanitizedValue = valueToSanitize.replace(/^0+(?!$)/, "");
  return isNegative ? `-${sanitizedValue}` : sanitizedValue;
};
var removeNegativeSign = value => {
  if (!value) return "";
  return value.replace(/^-/, "");
};
var convertToDecimalFormat = (value, options = {}) => {
  if (!value) return "";
  const {
    decimalPrecision = 0,
    allowNegative = false
  } = options;
  const isNegative = allowNegative && value.startsWith("-");
  const valueWithoutNegativeSign = removeNegativeSign(value);
  const integerPartLength = valueWithoutNegativeSign.length - decimalPrecision;
  const integerPart = integerPartLength > 0 ? valueWithoutNegativeSign.slice(0, integerPartLength) : "0";
  const decimalPart = valueWithoutNegativeSign.slice(Math.max(0, integerPartLength)).padStart(decimalPrecision, "0");
  const formattedValue = `${integerPart},${decimalPart}`;
  return isNegative ? `-${formattedValue}` : formattedValue;
};

// src/components/chart/chart-plugins-handlers.ts
var clearTooltipContent = tooltipElement => {
  const innerTooltip = tooltipElement.querySelector(".tooltip-inner");
  while (innerTooltip.firstChild) {
    innerTooltip.firstChild.remove();
  }
};
var createTooltipContent = (tooltipElement, chartDataPoints, hostElement) => {
  const {
    label
  } = chartDataPoints[0];
  const span = document.createElement("span");
  const heading = span.cloneNode(true);
  heading.innerText = label;
  const innerTooltip = tooltipElement.querySelector(".tooltip-inner");
  innerTooltip.appendChild(heading);
  chartDataPoints.forEach(line => {
    const lineInfo = span.cloneNode(true);
    const {
      options
    } = line.element;
    if (line.datasetIndex === 0) {
      options.pointStyle = "circle";
    } else {
      options.pointStyle = "rectRot";
    }
    let dataType = "";
    let value = `R$ ${formatMoney(line.parsed.y)}`;
    const dataLabel = line.dataset.label;
    if (hostElement.hasAttribute("data-type")) {
      dataType = hostElement.getAttribute("data-type");
      if (dataType !== "money") {
        value = line.parsed.y;
      }
    }
    if (hostElement.hasAttribute("private-key")) {
      lineInfo.innerHTML = `
                ${dataLabel}: <br/>
                <atlas-private-content private-key="${hostElement.getAttribute("private-key")}" placeholder-prefix="R$">
                    ${value}
                </atlas-private-content>
            `;
    } else {
      lineInfo.innerHTML = `
                ${dataLabel}: <br/>
                ${value}
            `;
    }
    innerTooltip.appendChild(lineInfo);
  });
};
var getTooltipYPosition = (chart, tooltip) => {
  const {
    canvas
  } = chart;
  const {
    offsetTop: canvasYPosition
  } = canvas;
  const lineYPosition = [];
  tooltip.dataPoints.forEach(dataPoint => {
    const {
      y
    } = dataPoint.element;
    lineYPosition.push(y);
  });
  return `${canvasYPosition + Math.min(...lineYPosition)}px`;
};
var getTooltipXPosition = (chart, tooltip) => {
  const {
    offsetLeft: positionX
  } = chart.canvas;
  return `${positionX + tooltip.caretX}px`;
};
var externalTooltipHandler = context => {
  const {
    chart,
    tooltip
  } = context;
  const hostElement = chart.canvas.getRootNode().host;
  const tooltipElement = hostElement.shadowRoot.querySelector(".atlas-chart-tooltip");
  if (!tooltipElement) return;
  clearTooltipContent(tooltipElement);
  if (tooltip.opacity === 0) {
    tooltipElement.style.opacity = "0";
    return;
  }
  const chartDataPoints = tooltip.dataPoints;
  if (!tooltip || chartDataPoints.length < 1) return;
  createTooltipContent(tooltipElement, chartDataPoints, hostElement);
  tooltipElement.style.opacity = "1";
  tooltipElement.style.left = getTooltipXPosition(chart, tooltip);
  tooltipElement.style.top = getTooltipYPosition(chart, tooltip);
};
var externalLegendHandler = {
  id: "externalLegendHandler",
  // @ts-expect-error
  afterUpdate(chart, args, options) {
    const chartElement = chart.canvas.getRootNode().host;
    const legendList = chartElement.legendList;
    const legendItemTemplate = chartElement.legendItemTemplate;
    while (legendList.firstChild) {
      legendList.firstChild.remove();
    }
    const chartLegendLabels = chart.options.plugins.legend.labels.generateLabels(chart);
    chartLegendLabels.forEach(legendObject => {
      const legendItemElement = legendItemTemplate.cloneNode(true);
      legendItemElement.addEventListener("click", () => {
        const {
          type
        } = chart.config;
        if (type === "pie" || type === "doughnut") {
          chart.toggleDataVisibility(legendObject.index);
        } else {
          chart.setDatasetVisibility(legendObject.datasetIndex, !chart.isDatasetVisible(legendObject.datasetIndex));
        }
        chart.update();
      });
      const legendColor = legendItemElement.querySelector(".legend-color");
      const context = legendColor.getContext("2d");
      context.fillStyle = legendObject.fillStyle;
      context.fillRect(0, 0, legendColor.width, legendColor.height);
      const {
        isFlowChart
      } = options;
      if (isFlowChart) {
        const {
          inflowLabel,
          outflowLabel
        } = options.labels;
        if (legendObject.text === inflowLabel) {
          legendColor.style.background = `url('${getAssetPath(flowChartInflowPattern)}')`;
        } else if (legendObject.text === outflowLabel) {
          legendColor.style.background = `url('${getAssetPath(flowChartOutflowPattern)}')`;
        }
      }
      const title = legendItemElement.querySelector(".legend-text");
      title.innerText = legendObject.text;
      title.style.textDecoration = legendObject.hidden ? "line-through" : "";
      legendItemElement.hidden = false;
      legendList.appendChild(legendItemElement);
    });
  }
};

// src/components/chart/chart-config.ts
var chartBaseOptions = {
  responsive: true,
  maintainAspectRatio: true,
  aspectRatio: 4,
  layout: {
    padding: {
      top: 0
    }
  },
  scales: {
    x: {
      grid: {
        display: false
      }
    },
    y: {
      display: true,
      max: 1e4,
      ticks: {
        count: 5
      }
    }
  },
  elements: {
    point: {
      pointStyle: false
    }
  },
  interaction: {
    intersect: false,
    mode: "nearest",
    axis: "x"
  }
};
var flowChartBaseOptions = __spreadProps(__spreadValues({}, chartBaseOptions), {
  datasets: {
    bar: {
      barThickness: 16,
      borderRadius: 4
    }
  }
});
var columnChartBaseOptions = flowChartBaseOptions;
var flowChartInflowPattern = "assets/images/chart-inflow-pattern.svg";
var flowChartOutflowPattern = "assets/images/chart-outflow-pattern.svg";

// src/components/chart/atlas-column-chart/atlas-column-chart.ts
var AtlasColumnChart = /*#__PURE__*/(() => {
  let AtlasColumnChart = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.xAxisKey = "key";
      this.yAxisKey = "value";
      this.dataType = "monetary";
      this._chartBackgroundColors = {};
    }
    /** @internal */
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.buildColorsFromCSS();
      this.updateComplete.then(() => {
        this.buildChart();
      });
    }
    /** @internal */
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
    }
    buildColorsFromCSS() {
      const {
        cssRules
      } = chart_colors_default.styleSheet;
      const colors = {};
      for (const rule of cssRules) {
        const key = rule.selectorText;
        const value = rule.style.getPropertyValue("color");
        colors[key] = value;
      }
      this._chartBackgroundColors = colors;
    }
    buildOptions() {
      const options = columnChartBaseOptions;
      options.parsing = {
        xAxisKey: this.xAxisKey,
        yAxisKey: this.yAxisKey
      };
      options.plugins = {
        // @ts-expect-error
        externalLegendHandler: {},
        legend: {
          display: false
        },
        tooltip: {
          enabled: false,
          position: "average",
          external: externalTooltipHandler
        }
      };
      options.scales.y.max = this.maxYValue;
      return options;
    }
    createPattern(backgroundPattern, backgroundColor) {
      return pattern.draw(backgroundPattern, backgroundColor);
    }
    getDataBackground(backgroundPattern, backgroundColor) {
      const backgroundColorRGB = this._chartBackgroundColors[backgroundColor] || backgroundColor;
      if (backgroundPattern) {
        return this.createPattern(backgroundPattern, backgroundColorRGB);
      }
      return backgroundColorRGB;
    }
    buildData() {
      if (!this.data) return {};
      if (!this.orderKeys) {
        this.orderKeys = Object.keys(this.data);
      }
      const chartData = this.orderKeys.map(key => {
        const columnData = this.data[key];
        if (!columnData) return null;
        const {
          label,
          backgroundColor,
          backgroundPattern,
          order,
          data
        } = columnData;
        return {
          type: "bar",
          label,
          backgroundColor: this.getDataBackground(backgroundPattern, backgroundColor),
          order,
          data
        };
      }).filter(Boolean);
      return {
        datasets: chartData
      };
    }
    updateMaxValue() {
      if (!this._chartObject) return;
      this._chartObject.options.scales.y.max = this.maxYValue;
      this._chartObject.update();
    }
    buildChart() {
      if (this._chartObject) this._chartObject.destroy();
      const config2 = {
        data: this.buildData(),
        options: this.buildOptions(),
        plugins: [externalLegendHandler]
      };
      this._chartObject = new Chart(this.chartElement, config2);
    }
    renderLegendItemTemplate() {
      return html2`
            <li class="legend-item" hidden>
                <canvas class="legend-color"></canvas>
                <span class="legend-text"></span>
            </li>
        `;
    }
    renderLegend() {
      return html2`
            <ul class="legend-list"></ul>

            ${this.renderLegendItemTemplate()}
        `;
    }
    renderTooltip() {
      return html2`
            <div class="atlas-chart-tooltip" role="tooltip" aria-labelledby="tooltip-slot">
                <div class="tooltip-inner"></div>
            </div>
        `;
    }
    /** @intenal */
    render() {
      return html2`
            ${this.renderLegend()}
            <div class="chart-container">
                <canvas class="chart"></canvas>
                ${this.renderTooltip()}
            </div>
        `;
    }
  };
  AtlasColumnChart.styles = atlas_column_chart_default;
  return AtlasColumnChart;
})();
__decorateClass([property2({
  type: String,
  attribute: "x-axis-key"
})], AtlasColumnChart.prototype, "xAxisKey", 2);
__decorateClass([property2({
  type: String,
  attribute: "y-axis-key"
})], AtlasColumnChart.prototype, "yAxisKey", 2);
__decorateClass([property2({
  type: Array,
  attribute: "order-keys"
})], AtlasColumnChart.prototype, "orderKeys", 2);
__decorateClass([property2({
  type: Array
})], AtlasColumnChart.prototype, "data", 2);
__decorateClass([property2({
  type: Number,
  attribute: "max-y-value"
})], AtlasColumnChart.prototype, "maxYValue", 2);
__decorateClass([property2({
  type: String,
  attribute: "data-type"
})], AtlasColumnChart.prototype, "dataType", 2);
__decorateClass([query(".legend-list")], AtlasColumnChart.prototype, "legendList", 2);
__decorateClass([query(".legend-item")], AtlasColumnChart.prototype, "legendItemTemplate", 2);
__decorateClass([query(".chart")], AtlasColumnChart.prototype, "chartElement", 2);
__decorateClass([Watch("maxYValue", true)], AtlasColumnChart.prototype, "updateMaxValue", 1);
__decorateClass([Watch(["data", "xAxisKey, yAxisKey, orderKeys"], true)], AtlasColumnChart.prototype, "buildChart", 1);
AtlasColumnChart = __decorateClass([customElement("atlas-column-chart")], AtlasColumnChart);

// src/components/chart/atlas-comparison-chart/atlas-comparison-chart.ts
import { html as html4 } from "lit";
import { customElement as customElement3, property as property4 } from "lit/decorators.js";
import Chart2 from "chart.js/auto";

// src/helpers/privacy.ts
var privacy_exports = {};
__export(privacy_exports, {
  getClassifiedContent: () => getClassifiedContent,
  hideClassifiedContent: () => hideClassifiedContent,
  showClassifiedContent: () => showClassifiedContent,
  toggleClassifiedContent: () => toggleClassifiedContent
});
var ATLAS_CLASSIFIED_CONTENT_KEY = "atlas-classified-content";
var getClassifiedContent = () => {
  const currentContent = localStorage.getItem(ATLAS_CLASSIFIED_CONTENT_KEY);
  if (currentContent) {
    return JSON.parse(currentContent);
  }
  return [];
};
var toggleClassifiedContent = (privateKey, forceState) => {
  if (!privateKey) return;
  let classifiedContent = getClassifiedContent();
  let showContent = false;
  if (forceState !== void 0 && forceState !== null) {
    showContent = forceState;
  } else {
    showContent = classifiedContent.includes(privateKey);
  }
  if (showContent) {
    classifiedContent = classifiedContent.filter(key => key !== privateKey);
  } else {
    classifiedContent.push(privateKey);
    classifiedContent = [...new Set(classifiedContent)];
  }
  localStorage.setItem(ATLAS_CLASSIFIED_CONTENT_KEY, JSON.stringify(classifiedContent));
  emit(window, "atlas-private-state-change", {
    detail: classifiedContent
  });
};
var showClassifiedContent = privateKey => {
  toggleClassifiedContent(privateKey, true);
};
var hideClassifiedContent = privateKey => {
  toggleClassifiedContent(privateKey, false);
};

// src/components/chart/atlas-comparison-chart/atlas-comparison-chart.scss
import { css as css3 } from "lit-element/lit-element.js";
var atlas_comparison_chart_default = css3`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: contents;
}

.chart-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.legend-list {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  padding: 0;
  margin-bottom: 1.5rem;
}
.legend-list .legend-item {
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
  align-items: center;
}
.legend-list .legend-item .legend-color {
  width: 8px;
  height: 8px;
  border-radius: 8px;
}
.legend-list .legend-item .legend-item {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  line-height: 1.5;
  font-weight: 700;
  color: #212529;
  margin: 0;
}
.legend-list .legend-item:hover {
  cursor: pointer;
}

.atlas-chart-tooltip {
  width: max-content;
  min-width: 40px;
  position: absolute;
  pointer-events: none;
  translate: -50% -115%;
  border-radius: 4px;
  box-sizing: border-box;
  background: #000000;
  opacity: 0;
}
.atlas-chart-tooltip::after {
  content: " ";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -7px;
  margin-top: -1px;
  border-width: 7px;
  border-style: solid;
  border-color: #000000 transparent transparent;
}
.atlas-chart-tooltip .tooltip-inner {
  display: flex;
  flex-direction: column;
  padding: 4px 8px;
  gap: 0.5rem;
  text-align: left;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 0.875rem;
  line-height: 1.5;
  font-weight: 700;
  color: #ffffff;
}`;

// src/components/display/atlas-private-content/atlas-private-content.ts
import { html as html3 } from "lit";
import { customElement as customElement2, property as property3 } from "lit/decorators.js";
import { when as when2 } from "lit/directives/when.js";

// src/components/display/atlas-private-content/atlas-private-content.scss
import { css as css4 } from "lit-element/lit-element.js";
var atlas_private_content_default = css4`:host {
  display: contents;
}`;

// src/controllers/trigger-controller.ts
var TriggerController = class {
  constructor(host, trigger) {
    this.host = host;
    this.trigger = trigger;
    host.addController(this);
    this.syncTriggerElement = this.syncTriggerElement.bind(this);
    this.handleTriggerFocus = this.handleTriggerFocus.bind(this);
    this.handleTriggerBlur = this.handleTriggerBlur.bind(this);
    this.handleTriggerClick = this.handleTriggerClick.bind(this);
    this.handleTriggerMouseEnter = this.handleTriggerMouseEnter.bind(this);
    this.handleTriggerMouseLeave = this.handleTriggerMouseLeave.bind(this);
  }
  /**
   * @internal
   */
  hostConnected() {
    if (!this.hostParentNode) {
      this.hostParentNode = this.host.parentNode;
    }
    this.syncTriggerElement();
  }
  /**
   * @internal
   */
  hostDisconnected() {
    this.clearTriggerEvents();
  }
  /**
   * @internal
   */
  show() {
    if (this.disabled) {
      return;
    }
    this.open = true;
    this.host.onTriggerActivate();
  }
  /**
   * @internal
   */
  hide() {
    this.open = false;
    this.host.onTriggerActivate();
  }
  /**
   * @internal
   */
  toggle() {
    if (this.open) {
      this.hide();
    } else {
      this.show();
    }
  }
  /**
   * @internal
   */
  syncTriggerElement(triggerElement) {
    this.clearTriggerEvents();
    this.clearTriggerProperties();
    this.triggerElement = triggerElement || this.findTriggerElement(this.hostParentNode);
    this.setTriggerProperties();
    this.bindTriggerEvents();
  }
  bindTriggerEvents() {
    var _a, _b, _c, _d, _e;
    (_a = this.triggerElement) == null ? void 0 : _a.addEventListener("focus", this.handleTriggerFocus, true);
    (_b = this.triggerElement) == null ? void 0 : _b.addEventListener("blur", this.handleTriggerBlur, true);
    (_c = this.triggerElement) == null ? void 0 : _c.addEventListener("click", this.handleTriggerClick);
    (_d = this.triggerElement) == null ? void 0 : _d.addEventListener("mouseenter", this.handleTriggerMouseEnter);
    (_e = this.triggerElement) == null ? void 0 : _e.addEventListener("mouseleave", this.handleTriggerMouseLeave);
  }
  clearTriggerEvents() {
    var _a, _b, _c, _d, _e;
    (_a = this.triggerElement) == null ? void 0 : _a.removeEventListener("focus", this.handleTriggerFocus, true);
    (_b = this.triggerElement) == null ? void 0 : _b.removeEventListener("blur", this.handleTriggerBlur, true);
    (_c = this.triggerElement) == null ? void 0 : _c.removeEventListener("click", this.handleTriggerClick);
    (_d = this.triggerElement) == null ? void 0 : _d.removeEventListener("mouseenter", this.handleTriggerMouseEnter);
    (_e = this.triggerElement) == null ? void 0 : _e.removeEventListener("mouseleave", this.handleTriggerMouseLeave);
  }
  setTriggerProperties() {
    if (!this.triggerElement) return;
    this.triggerElement.toggleAttribute("data-atlas-trigger-element", true);
    this.triggerElement.trigger = this.trigger;
  }
  clearTriggerProperties() {
    if (!this.triggerElement) return;
    this.triggerElement.toggleAttribute("data-atlas-trigger-element", false);
    delete this.triggerElement.trigger;
  }
  findTriggerElement(parentNode) {
    if (!this.host.id) return null;
    const hostTagName = this.host.tagName.toLowerCase();
    const selector = `[data-${hostTagName}=${this.host.id}]`;
    let element = null;
    if (parentNode instanceof ShadowRoot) {
      element = parentNode.querySelector(selector);
      if (!element) {
        element = this.findTriggerElement(parentNode.host.parentNode);
      }
    } else if (parentNode instanceof Document) {
      element = parentNode.querySelector(selector);
    } else if (parentNode === parentNode.getRootNode()) {
      element = parentNode;
    } else {
      element = this.findTriggerElement(parentNode.getRootNode());
    }
    if (element && element.tagName === "ATLAS-INPUT") {
      element = element._formControl;
    }
    return element;
  }
  hasTrigger(triggerType) {
    return this.trigger.split(" ").includes(triggerType);
  }
  handleTriggerFocus() {
    if (this.hasTrigger("focus")) {
      this.show();
    }
  }
  handleTriggerBlur() {
    if (this.hasTrigger("focus")) {
      this.hide();
    }
  }
  handleTriggerChildClick(triggerChildElement) {
    var _a;
    if (!((_a = triggerChildElement == null ? void 0 : triggerChildElement.trigger) == null ? void 0 : _a.split(" ").includes("click"))) return;
    this.hide();
  }
  handleTriggerClick(event) {
    const target = event.target;
    const closestTriggerElement = target.closest("[data-atlas-trigger-element]");
    if (closestTriggerElement && closestTriggerElement !== this.triggerElement) {
      this.handleTriggerChildClick(closestTriggerElement);
      return;
    }
    if (this.hasTrigger("click")) {
      this.toggle();
    }
  }
  handleTriggerMouseEnter() {
    if (this.hasTrigger("hover")) {
      this.show();
    }
  }
  handleTriggerMouseLeave() {
    if (this.hasTrigger("hover")) {
      this.hide();
    }
  }
};

// src/components/display/atlas-private-content/atlas-private-content.ts
var AtlasPrivateContent = /*#__PURE__*/(() => {
  let AtlasPrivateContent = class extends AtlasElement {
    constructor() {
      super();
      this.placeholder = "***";
      this.placeholderPrefix = "";
      this._triggerController = new TriggerController(this, "click");
    }
    /** @internal */
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.toggleIsCovered = this.toggleIsCovered.bind(this);
      window.addEventListener("atlas-private-state-change", this.toggleIsCovered);
      this.toggleIsCovered();
    }
    /** @internal */
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      window.removeEventListener("atlas-private-state-change", this.toggleIsCovered);
    }
    /**
     * @internal
     */
    onTriggerActivate() {
      var _a;
      this.cover = this._triggerController.open;
      (_a = this._triggerController.triggerElement) == null ? void 0 : _a.blur();
    }
    emitVisibilityEvent() {
      emit(this, `atlas-private-content-${!this.cover ? "visible" : "hidden"}`, {
        trackDisable: true
      });
    }
    toggleIsCovered() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        if (!this.privateKey) return;
        this.cover = getClassifiedContent().includes(this.privateKey);
        this.emitVisibilityEvent();
      });
    }
    renderPlaceholderContent() {
      return html3`${this.placeholderPrefix} ${this.placeholder}`;
    }
    /** @internal */
    render() {
      return when2(this.cover, () => this.renderPlaceholderContent(), () => html3`<slot></slot>`);
    }
  };
  AtlasPrivateContent.styles = atlas_private_content_default;
  return AtlasPrivateContent;
})();
__decorateClass([property3({
  type: String,
  attribute: "private-key"
})], AtlasPrivateContent.prototype, "privateKey", 2);
__decorateClass([property3({
  type: Boolean,
  reflect: true
})], AtlasPrivateContent.prototype, "cover", 2);
__decorateClass([property3({
  type: String
})], AtlasPrivateContent.prototype, "placeholder", 2);
__decorateClass([property3({
  type: String,
  attribute: "placeholder-prefix"
})], AtlasPrivateContent.prototype, "placeholderPrefix", 2);
AtlasPrivateContent = __decorateClass([customElement2("atlas-private-content")], AtlasPrivateContent);

// src/components/chart/atlas-comparison-chart/atlas-comparison-chart.ts
var AtlasComparisonChart = /*#__PURE__*/(() => {
  let AtlasComparisonChart = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.xAxisKey = "key";
      this.yAxisKey = "value";
      this.goalLabel = "Meta";
      this.realLabel = "Vendas";
    }
    /** @internal */
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.onPrivateStateChange = this.onPrivateStateChange.bind(this);
      this.buildColorsFromCSS();
      this.updateComplete.then(() => {
        this.legendList = this.shadowRoot.querySelector(".legend-list");
        this.legendItemTemplate = this.shadowRoot.querySelector(".legend-item");
        this.chartElement = this.shadowRoot.querySelector(".chart");
        this.buildChart();
      });
      window.addEventListener("atlas-private-state-change", this.onPrivateStateChange);
    }
    /** @internal */
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      window.removeEventListener("atlas-private-state-change", this.onPrivateStateChange);
    }
    buildColorsFromCSS() {
      const {
        cssRules
      } = chart_colors_default.styleSheet;
      const colors = {
        amount: "",
        goal: ""
      };
      for (const rule of cssRules) {
        const key = rule.selectorText;
        const value = rule.style.getPropertyValue("color");
        Object.assign(colors, {
          [`${key}`]: value
        });
      }
      this._chartColors = colors;
    }
    getDataColor(dataType) {
      return this._chartColors[dataType];
    }
    buildRealLine() {
      if (!this.realData || this.realData.length === 0) return null;
      const line = {
        type: "line",
        label: this.realLabel,
        backgroundColor: this.getDataColor("real"),
        borderColor: this.getDataColor("real"),
        borderWidth: 2,
        order: 1,
        data: this.realData
      };
      return line;
    }
    buildGoalLine() {
      if (!this.goalData || this.goalData.length === 0) return null;
      const line = {
        type: "line",
        label: this.goalLabel,
        backgroundColor: this.getDataColor("goal"),
        borderColor: this.getDataColor("goal"),
        borderDash: [5, 5],
        borderWidth: 2,
        order: 2,
        data: this.goalData
      };
      return line;
    }
    buildData() {
      const realLine = this.buildRealLine();
      const goalLine = this.buildGoalLine();
      return {
        datasets: [realLine, goalLine].filter(line => line !== null)
      };
    }
    buildOptions() {
      const options = chartBaseOptions;
      options.parsing = {
        xAxisKey: this.xAxisKey,
        yAxisKey: this.yAxisKey
      };
      options.plugins = {
        // @ts-expect-error
        externalLegendHandler: {
          isFlowChart: false
        },
        legend: {
          display: false
        },
        tooltip: {
          enabled: false,
          position: "average",
          external: externalTooltipHandler
        }
      };
      options.scales.y.max = this.maxYValue;
      options.scales.y.ticks.callback = value => {
        if (this.privateKey) {
          if (getClassifiedContent().includes(this.privateKey)) {
            return `R$ ***`;
          }
        }
        return `R$ ${formatMoney(value)}`;
      };
      return options;
    }
    buildChart() {
      if (this._chartObject) this._chartObject.destroy();
      const config2 = {
        data: this.buildData(),
        options: this.buildOptions(),
        plugins: [externalLegendHandler]
      };
      this._chartObject = new Chart2(this.chartElement, config2);
    }
    updateMaxValue() {
      if (!this._chartObject) return;
      this._chartObject.options.scales.y.max = this.maxYValue;
      this._chartObject.update();
    }
    onPrivateStateChange() {
      this._chartObject.update();
    }
    renderLegendItemTemplate() {
      return html4`
            <li class="legend-item" hidden>
                <canvas class="legend-color"></canvas>
                <span class="legend-text"></span>
            </li>
        `;
    }
    renderLegend() {
      return html4`
            <ul class="legend-list"></ul>

            ${this.renderLegendItemTemplate()}
        `;
    }
    renderTooltip() {
      return html4`
            <div class="atlas-chart-tooltip" role="tooltip" aria-labelledby="tooltip-slot">
                <div class="tooltip-inner"></div>
            </div>
        `;
    }
    /** @internal */
    render() {
      return html4`
            ${this.renderLegend()}
            <div class="chart-container">
                <canvas class="chart"></canvas>
                ${this.renderTooltip()}
            </div>
        `;
    }
  };
  AtlasComparisonChart.styles = atlas_comparison_chart_default;
  return AtlasComparisonChart;
})();
__decorateClass([property4({
  type: String,
  attribute: "x-axis-key"
})], AtlasComparisonChart.prototype, "xAxisKey", 2);
__decorateClass([property4({
  type: String,
  attribute: "y-axis-key"
})], AtlasComparisonChart.prototype, "yAxisKey", 2);
__decorateClass([property4({
  type: String,
  attribute: "goal-label"
})], AtlasComparisonChart.prototype, "goalLabel", 2);
__decorateClass([property4({
  type: String,
  attribute: "real-label"
})], AtlasComparisonChart.prototype, "realLabel", 2);
__decorateClass([property4({
  type: Number,
  attribute: "max-y-value"
})], AtlasComparisonChart.prototype, "maxYValue", 2);
__decorateClass([property4({
  type: Array,
  attribute: "goal-data"
})], AtlasComparisonChart.prototype, "goalData", 2);
__decorateClass([property4({
  type: Array,
  attribute: "real-data"
})], AtlasComparisonChart.prototype, "realData", 2);
__decorateClass([property4({
  type: String,
  attribute: "private-key",
  reflect: true
})], AtlasComparisonChart.prototype, "privateKey", 2);
__decorateClass([Watch("maxYValue", true)], AtlasComparisonChart.prototype, "updateMaxValue", 1);
__decorateClass([Watch("privateKey", true)], AtlasComparisonChart.prototype, "onPrivateStateChange", 1);
AtlasComparisonChart = __decorateClass([customElement3("atlas-comparison-chart")], AtlasComparisonChart);

// src/components/chart/atlas-flow-chart/atlas-flow-chart.ts
import { html as html5 } from "lit";
import { customElement as customElement4, property as property5 } from "lit/decorators.js";
import Chart3 from "chart.js/auto";

// src/components/chart/atlas-flow-chart/atlas-flow-chart.scss
import { css as css5 } from "lit-element/lit-element.js";
var atlas_flow_chart_default = css5`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: contents;
}

.chart-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.legend-list {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  padding: 0;
  margin-bottom: 1.5rem;
}
.legend-list .legend-item {
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
  align-items: center;
}
.legend-list .legend-item .legend-color {
  width: 8px;
  height: 8px;
  border-radius: 8px;
}
.legend-list .legend-item .legend-item {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  line-height: 1.5;
  font-weight: 700;
  color: #212529;
  margin: 0;
}
.legend-list .legend-item:hover {
  cursor: pointer;
}

.atlas-chart-tooltip {
  width: max-content;
  min-width: 40px;
  position: absolute;
  pointer-events: none;
  translate: -50% -115%;
  border-radius: 4px;
  box-sizing: border-box;
  background: #000000;
  opacity: 0;
}
.atlas-chart-tooltip::after {
  content: " ";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -7px;
  margin-top: -1px;
  border-width: 7px;
  border-style: solid;
  border-color: #000000 transparent transparent;
}
.atlas-chart-tooltip .tooltip-inner {
  display: flex;
  flex-direction: column;
  padding: 4px 8px;
  gap: 0.5rem;
  text-align: left;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 0.875rem;
  line-height: 1.5;
  font-weight: 700;
  color: #ffffff;
}`;

// src/components/chart/atlas-flow-chart/atlas-flow-chart.ts
var AtlasFlowChart = /*#__PURE__*/(() => {
  let AtlasFlowChart = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.xAxisKey = "key";
      this.yAxisKey = "value";
      this.inflowlabel = "Recebimentos";
      this.outflowLabel = "Pagamentos";
      this.overallLabel = "Saldo";
      this._chartPatterns = {
        inflow: flowChartInflowPattern,
        outflow: flowChartOutflowPattern,
        overall: ""
      };
    }
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.buildColorsFromCSS();
      this.updateComplete.then(() => {
        this.legendList = this.shadowRoot.querySelector(".legend-list");
        this.legendItemTemplate = this.shadowRoot.querySelector(".legend-item");
        this.chartElement = this.shadowRoot.querySelector(".chart");
        this.buildChartLabels();
        this.buildChart();
      });
    }
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
    }
    buildColorsFromCSS() {
      const {
        cssRules
      } = chart_colors_default.styleSheet;
      const colors = {
        inflow: "",
        outflow: "",
        overall: ""
      };
      for (const rule of cssRules) {
        const key = rule.selectorText;
        const value = rule.style.getPropertyValue("color");
        Object.assign(colors, {
          [`${key}`]: value
        });
      }
      this._chartColors = colors;
    }
    buildChartLabels() {
      this._chartLabels = {
        inflow: this.inflowlabel,
        outflow: this.outflowLabel,
        overall: this.overallLabel
      };
    }
    loadImage(url, element) {
      return new Promise((resolve, reject) => {
        element.onload = () => resolve(element);
        element.onerror = () => reject();
        element.src = url;
      });
    }
    getDataLabel(dataType) {
      return this._chartLabels[dataType];
    }
    getDataFallbackColor(dataType) {
      return this._chartColors[dataType];
    }
    getDataPatternPath(dataType) {
      return this._chartPatterns[dataType];
    }
    getChartBackgroundColor(dataType) {
      return __async(this, null, function* () {
        const fallbackColor = this.getDataFallbackColor(dataType);
        const patternPath = getAssetPath(this.getDataPatternPath(dataType));
        return this.loadImage(patternPath, new Image(8, 8)).then(image => {
          const canvas = new OffscreenCanvas(8, 8);
          const canvasContext = canvas.getContext("2d");
          return canvasContext.createPattern(image, "repeat");
        }, () => fallbackColor);
      });
    }
    buildBaseBarChartDataset(dataType) {
      return __async(this, null, function* () {
        return {
          type: "bar",
          label: this.getDataLabel(dataType),
          backgroundColor: yield this.getChartBackgroundColor(dataType),
          order: 2,
          data: [{}]
        };
      });
    }
    buildBaseLineChartDataset() {
      const color = this.getDataFallbackColor("overall");
      return {
        type: "line",
        label: this.getDataLabel("overall"),
        backgroundColor: color,
        borderColor: color,
        borderWidth: 2,
        order: 1,
        data: [{}]
      };
    }
    buildOutflowChartBar() {
      return __async(this, null, function* () {
        const outflowBar = yield this.buildBaseBarChartDataset("outflow");
        outflowBar.data = this.outflowData;
        return outflowBar;
      });
    }
    buildInflowChartBar() {
      return __async(this, null, function* () {
        const inflowBar = yield this.buildBaseBarChartDataset("inflow");
        inflowBar.data = this.inflowData;
        return inflowBar;
      });
    }
    buildOverallChartLine() {
      const overallLine = this.buildBaseLineChartDataset();
      overallLine.data = this.overallData;
      return overallLine;
    }
    buildData() {
      return __async(this, null, function* () {
        const inflowChartBar = yield this.buildInflowChartBar();
        const outflowChartBar = yield this.buildOutflowChartBar();
        const overallChartLine = this.buildOverallChartLine();
        return {
          datasets: [inflowChartBar, outflowChartBar, overallChartLine]
        };
      });
    }
    buildOptions() {
      const options = flowChartBaseOptions;
      options.parsing = {
        xAxisKey: this.xAxisKey,
        yAxisKey: this.yAxisKey
      };
      options.plugins = {
        // @ts-expect-error
        externalLegendHandler: {
          isFlowChart: true,
          labels: {
            inflowLabel: this.inflowlabel,
            outflowLabel: this.outflowLabel,
            overallLabel: this.overallLabel
          }
        },
        legend: {
          display: false
        },
        tooltip: {
          enabled: false,
          position: "average",
          external: externalTooltipHandler
        }
      };
      options.scales.y.max = this.maxYValue;
      return options;
    }
    updateMaxValue() {
      if (!this._chartObject) return;
      this._chartObject.options.scales.y.max = this.maxYValue;
      this._chartObject.update();
    }
    buildChart() {
      return __async(this, null, function* () {
        if (this._chartObject) this._chartObject.destroy();
        const config2 = {
          data: yield this.buildData(),
          options: this.buildOptions(),
          plugins: [externalLegendHandler]
        };
        this._chartObject = new Chart3(this.chartElement, config2);
      });
    }
    renderLegendItemTemplate() {
      return html5`
            <li class="legend-item" hidden>
                <canvas class="legend-color"></canvas>
                <span class="legend-text"></span>
            </li>
        `;
    }
    renderLegend() {
      return html5`
            <ul class="legend-list"></ul>

            ${this.renderLegendItemTemplate()}
        `;
    }
    renderTooltip() {
      return html5`
            <div class="atlas-chart-tooltip" role="tooltip" aria-labelledby="tooltip-slot">
                <div class="tooltip-inner"></div>
            </div>
        `;
    }
    /** @intenal */
    render() {
      return html5`
            ${this.renderLegend()}
            <div class="chart-container">
                <canvas class="chart"></canvas>
                ${this.renderTooltip()}
            </div>
        `;
    }
  };
  AtlasFlowChart.styles = atlas_flow_chart_default;
  return AtlasFlowChart;
})();
__decorateClass([property5({
  type: String,
  attribute: "x-axis-key"
})], AtlasFlowChart.prototype, "xAxisKey", 2);
__decorateClass([property5({
  type: String,
  attribute: "y-axis-key"
})], AtlasFlowChart.prototype, "yAxisKey", 2);
__decorateClass([property5({
  type: String,
  attribute: "inflow-label"
})], AtlasFlowChart.prototype, "inflowlabel", 2);
__decorateClass([property5({
  type: String,
  attribute: "outflow-label"
})], AtlasFlowChart.prototype, "outflowLabel", 2);
__decorateClass([property5({
  type: String,
  attribute: "overall-label"
})], AtlasFlowChart.prototype, "overallLabel", 2);
__decorateClass([property5({
  type: Array,
  attribute: "inflow-data"
})], AtlasFlowChart.prototype, "inflowData", 2);
__decorateClass([property5({
  type: Array,
  attribute: "outflow-data"
})], AtlasFlowChart.prototype, "outflowData", 2);
__decorateClass([property5({
  type: Array,
  attribute: "overall-data"
})], AtlasFlowChart.prototype, "overallData", 2);
__decorateClass([property5({
  type: Number,
  attribute: "max-y-value"
})], AtlasFlowChart.prototype, "maxYValue", 2);
__decorateClass([Watch("maxYValue", true)], AtlasFlowChart.prototype, "updateMaxValue", 1);
__decorateClass([Watch(["inflowValues", "outflowValues", "overallValues", "inflowLabel", "outflowLabel", "overallLabel", "xAxisKey", "yAxisKey"], true)], AtlasFlowChart.prototype, "buildChart", 1);
AtlasFlowChart = __decorateClass([customElement4("atlas-flow-chart")], AtlasFlowChart);

// src/components/dashboard/atlas-bar-chart-item/atlas-bar-chart-item.ts
import { LitElement as LitElement3, html as html8 } from "lit";
import { customElement as customElement6, property as property9 } from "lit/decorators.js";
import { classMap as classMap2 } from "lit/directives/class-map.js";

// src/internals/mixins/with-tooltip-mixin.ts
import { html as html7 } from "lit";
import { property as property8 } from "lit/decorators.js";
import { when as when3 } from "lit/directives/when.js";

// src/components/display/atlas-tooltip/atlas-tooltip.ts
import { html as html6 } from "lit";
import { customElement as customElement5, query as query2, property as property7 } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { arrow } from "@floating-ui/dom";

// src/components/display/overlay-element.ts
import { property as property6 } from "lit/decorators.js";

// src/controllers/floating-ui-controller.ts
import { autoUpdate, computePosition, flip, offset, shift } from "@floating-ui/dom";
var FloatingUiController = class {
  constructor(host, placement) {
    this.customMiddlewares = [];
    this.host = host;
    this.placement = placement || "bottom";
    host.addController(this);
    this.updatePosition = this.updatePosition.bind(this);
  }
  hostConnected() {}
  hostDisconnected() {}
  getMiddlewares() {
    var _a;
    const defaultMiddlewares = [offset(8), flip(), shift({
      padding: 8
    })];
    return [...defaultMiddlewares, ...(((_a = this.getCustomMiddlewares) == null ? void 0 : _a.call(this)) || [])];
  }
  updatePosition() {
    computePosition(this.anchorElement, this.floatingElement, {
      placement: this.placement,
      strategy: "fixed",
      middleware: this.getMiddlewares()
    }).then(({
      x,
      y,
      placement,
      middlewareData
    }) => {
      var _a;
      this.floatingElement.setAttribute("data-popper-placement", placement);
      Object.assign(this.floatingElement.style, {
        left: `${x}px`,
        top: `${y}px`
      });
      const arrowMiddleware = this.getMiddlewares().find(middleware => middleware.name === "arrow");
      const {
        arrow: arrow3
      } = middlewareData;
      const arrowEl = (_a = arrowMiddleware == null ? void 0 : arrowMiddleware.options) == null ? void 0 : _a.element;
      if (arrow3 && arrowEl) {
        Object.assign(arrowEl.style, {
          left: arrow3.x != null ? `${arrow3.x}px` : "",
          top: arrow3.y != null ? `${arrow3.y}px` : ""
        });
      }
    });
  }
  registerFloatingElement() {
    this.floatingUiCleanup = autoUpdate(this.anchorElement, this.floatingElement, this.updatePosition);
  }
  unregisterFloatingElement() {
    var _a;
    (_a = this.floatingUiCleanup) == null ? void 0 : _a.call(this);
  }
};

// src/components/display/overlay-element.ts
var OverlayElement = class extends AtlasElement {
  constructor(defaultTrigger, defaultPlacement) {
    super();
    this._defaultPlacement = defaultPlacement || "bottom";
    this._defaultTrigger = defaultTrigger || "hover focus";
    this.placement = this._defaultPlacement;
    this.trigger = this._defaultTrigger;
    this._triggerController = new TriggerController(this, this.trigger);
    this._floatingUiController = new FloatingUiController(this, this.placement);
    this.updatePosition = this.updatePosition.bind(this);
  }
  connectedCallback() {
    var _a;
    (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
    this.setAttribute("tabindex", "-1");
  }
  onOpenChange() {
    if (this.open) {
      this.onOpenOverlay();
    } else {
      this.onCloseOverlay();
    }
  }
  /**
   * Mostra o {overlay}
   */
  show() {
    this._triggerController.show();
  }
  /**
   * Esconde o {overlay}
   */
  hide() {
    this._triggerController.hide();
  }
  /**
   * Alterna a visibilidade do {overlay}
   */
  toggle() {
    this._triggerController.toggle();
  }
  /**
   * @internal
   */
  onTriggerActivate() {
    this.open = this._triggerController.open;
  }
  /**
   * @internal
   */
  getFloatingElement() {
    return this;
  }
  /**
   * @internal
   */
  syncTriggerElement(triggerElement) {
    this._triggerController.syncTriggerElement(triggerElement);
  }
  /**
   * @internal
   */
  updatePosition() {
    if (this.open) {
      this._floatingUiController.updatePosition();
    }
  }
  onUpdateProperties() {
    this._floatingUiController.placement = this.placement || this._defaultPlacement;
    this._triggerController.trigger = this.trigger || this._defaultTrigger;
    this._triggerController.disabled = this.disabled;
  }
  onOpenOverlay() {
    return __async(this, null, function* () {
      yield this.updateComplete;
      this.removeAttribute("tabindex");
      this._floatingUiController.anchorElement = this._triggerController.triggerElement;
      this._floatingUiController.floatingElement = this.getFloatingElement();
      this._floatingUiController.registerFloatingElement();
      setTimeout(() => {
        emit(this, `${this.tagName.toLowerCase()}-opened`, {
          trackDisable: true
        });
      }, 0);
    });
  }
  onCloseOverlay() {
    return __async(this, null, function* () {
      yield this.updateComplete;
      this.setAttribute("tabindex", "-1");
      this._floatingUiController.unregisterFloatingElement();
      setTimeout(() => {
        emit(this, `${this.tagName.toLowerCase()}-closed`, {
          trackDisable: true
        });
      }, 0);
    });
  }
};
__decorateClass([property6({
  type: Boolean,
  reflect: true
})], OverlayElement.prototype, "open", 2);
__decorateClass([property6({
  type: Boolean
})], OverlayElement.prototype, "disabled", 2);
__decorateClass([property6({
  type: String
})], OverlayElement.prototype, "trigger", 2);
__decorateClass([property6({
  type: String
})], OverlayElement.prototype, "placement", 2);
__decorateClass([Watch("open")], OverlayElement.prototype, "onOpenChange", 1);
__decorateClass([Watch(["placement", "trigger", "disabled"])], OverlayElement.prototype, "onUpdateProperties", 1);

// src/components/display/atlas-tooltip/atlas-tooltip.scss
import { css as css6 } from "lit-element/lit-element.js";
var atlas_tooltip_default = css6`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Z-index mapping for the floating elements */
/* Transitions */
.fade {
  transition: opacity 0.25s ease;
}
.fade:not(.show) {
  opacity: 0;
}

.fade-and-scale {
  opacity: 0;
  transform: scale(0.7);
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.fade-and-scale.scale-vertically {
  transform: scale(1, 0.7);
}
.fade-and-scale.show {
  opacity: 1;
  transform: scale(1);
}

:host([data-popper-placement=top]),
:host([data-popper-placement=top]) .fade-and-scale,
div[data-popper-placement=top].fade-and-scale,
div[data-popper-placement=top] > .fade-and-scale,
.fade-and-scale.scale-top {
  transform-origin: center bottom;
}

:host([data-popper-placement=top-start]),
:host([data-popper-placement=top-start]) .fade-and-scale,
div[data-popper-placement=top-start].fade-and-scale,
div[data-popper-placement=top-start] > .fade-and-scale,
.fade-and-scale.scale-top-start {
  transform-origin: left bottom;
}

:host([data-popper-placement=top-end]),
:host([data-popper-placement=top-end]) .fade-and-scale,
div[data-popper-placement=top-end].fade-and-scale,
div[data-popper-placement=top-end] > .fade-and-scale,
.fade-and-scale.scale-top-end {
  transform-origin: right bottom;
}

:host([data-popper-placement=bottom]),
:host([data-popper-placement=bottom]) .fade-and-scale,
div[data-popper-placement=bottom].fade-and-scale,
div[data-popper-placement=bottom] > .fade-and-scale,
.fade-and-scale.scale-bottom {
  transform-origin: center top;
}

:host([data-popper-placement=bottom-start]),
:host([data-popper-placement=bottom-start]) .fade-and-scale,
div[data-popper-placement=bottom-start].fade-and-scale,
div[data-popper-placement=bottom-start] > .fade-and-scale,
.fade-and-scale.scale-bottom-start {
  transform-origin: left top;
}

:host([data-popper-placement=bottom-end]),
:host([data-popper-placement=bottom-end]) .fade-and-scale,
div[data-popper-placement=bottom-end].fade-and-scale,
div[data-popper-placement=bottom-end] > .fade-and-scale,
.fade-and-scale.scale-bottom-end {
  transform-origin: right top;
}

:host([data-popper-placement=left]),
:host([data-popper-placement=left]) .fade-and-scale,
div[data-popper-placement=left].fade-and-scale,
div[data-popper-placement=left] > .fade-and-scale,
.fade-and-scale.scale-left {
  transform-origin: right center;
}

:host([data-popper-placement=left-start]),
:host([data-popper-placement=left-start]) .fade-and-scale,
div[data-popper-placement=left-start].fade-and-scale,
div[data-popper-placement=left-start] > .fade-and-scale,
.fade-and-scale.scale-left-start {
  transform-origin: right top;
}

:host([data-popper-placement=left-end]),
:host([data-popper-placement=left-end]) .fade-and-scale,
div[data-popper-placement=left-end].fade-and-scale,
div[data-popper-placement=left-end] > .fade-and-scale,
.fade-and-scale.scale-left-end {
  transform-origin: right bottom;
}

:host([data-popper-placement=right]),
:host([data-popper-placement=right]) .fade-and-scale,
div[data-popper-placement=right].fade-and-scale,
div[data-popper-placement=right] > .fade-and-scale,
.fade-and-scale.scale-right {
  transform-origin: left center;
}

:host([data-popper-placement=right-start]),
:host([data-popper-placement=right-start]) .fade-and-scale,
div[data-popper-placement=right-start].fade-and-scale,
div[data-popper-placement=right-start] > .fade-and-scale,
.fade-and-scale.scale-right-start {
  transform-origin: left top;
}

:host([data-popper-placement=right-end]),
:host([data-popper-placement=right-end]) .fade-and-scale,
div[data-popper-placement=right-end].fade-and-scale,
div[data-popper-placement=right-end] > .fade-and-scale,
.fade-and-scale.scale-right-end {
  transform-origin: left bottom;
}

:host {
  width: 1px;
  height: 1px;
  position: fixed;
  z-index: 3000;
}

:host(:not([open])) {
  pointer-events: none;
}

.tooltip {
  display: block;
  margin: 0;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  line-height: 1.5;
  font-weight: 700;
  font-size: 0.875rem;
  word-wrap: break-word;
  width: max-content;
  opacity: 0;
  z-index: 3000;
  position: relative;
}
.tooltip.show {
  opacity: 0.9;
}
.tooltip .tooltip-arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #ffffff;
  text-align: center;
  background-color: #000000;
  border-radius: 0.25rem;
  white-space: normal;
}

.tooltip-auto[data-popper-placement^=top] .tooltip-arrow, .tooltip-top .tooltip-arrow {
  bottom: -0.4rem;
}
.tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip-top .tooltip-arrow::before {
  top: -1px;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #000000;
}

.tooltip-auto[data-popper-placement^=right] .tooltip-arrow, .tooltip-end .tooltip-arrow {
  left: -0.4rem;
  width: 0.4rem;
  height: 0.8rem;
}
.tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip-end .tooltip-arrow::before {
  right: -1px;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000000;
}

.tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow, .tooltip-bottom .tooltip-arrow {
  top: -0.4rem;
}
.tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip-bottom .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #000000;
}

.tooltip-auto[data-popper-placement^=left] .tooltip-arrow, .tooltip-start .tooltip-arrow {
  right: -0.4rem;
  width: 0.4rem;
  height: 0.8rem;
}
.tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip-start .tooltip-arrow::before {
  left: -1px;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #000000;
}`;

// src/components/display/atlas-tooltip/atlas-tooltip.ts
var AtlasTooltip = /*#__PURE__*/(() => {
  let AtlasTooltip = class extends OverlayElement {
    constructor() {
      super("hover focus", "bottom");
      this.placeholderPrefix = "";
      this._floatingUiController.getCustomMiddlewares = this.getFloatingCustomMiddlewares.bind(this);
    }
    /** @internal @override */
    getFloatingElement() {
      return this.tooltip || this;
    }
    getFloatingCustomMiddlewares() {
      return [arrow({
        element: this.shadowRoot.querySelector(".tooltip-arrow")
      })];
    }
    onOpenOverlay() {
      return __async(this, null, function* () {
        yield __superGet(AtlasTooltip.prototype, this, "onOpenOverlay").call(this);
        this.tooltip.hidden = false;
      });
    }
    onCloseOverlay() {
      return __async(this, null, function* () {
        yield __superGet(AtlasTooltip.prototype, this, "onCloseOverlay").call(this);
        setTimeout(() => {
          this.tooltip.hidden = true;
        }, 250);
      });
    }
    /** @internal */
    render() {
      const tooltipClass = {
        "tooltip": true,
        "tooltip-auto": true,
        "fade": true,
        "show": this.open
      };
      return html6`
            <div
                class=${classMap(tooltipClass)}
                role="tooltip"
                aria-hidden=${this.open ? "false" : "true"}
                aria-labelledby="tooltip-slot"
            >
                <div class="tooltip-arrow"></div>
                <div class="tooltip-inner">
                    <atlas-private-content private-key=${this.privateKey} placeholder-prefix=${this.placeholderPrefix}>
                        <slot id="tooltip-slot"></slot>
                    </atlas-private-content>
                </div>
            </div>
        `;
    }
  };
  AtlasTooltip.styles = atlas_tooltip_default;
  return AtlasTooltip;
})();
__decorateClass([property7({
  type: String,
  attribute: "private-key"
})], AtlasTooltip.prototype, "privateKey", 2);
__decorateClass([property7({
  type: String,
  attribute: "placeholder-prefix"
})], AtlasTooltip.prototype, "placeholderPrefix", 2);
__decorateClass([query2(".tooltip")], AtlasTooltip.prototype, "tooltip", 2);
AtlasTooltip = __decorateClass([customElement5("atlas-tooltip")], AtlasTooltip);

// src/internals/mixins/with-tooltip-mixin.ts
var WithTooltipMixin = superClass => {
  class WithTooltipClass extends superClass {
    constructor() {
      super(...arguments);
      this.tooltipPlacement = "bottom";
      this.tooltipTrigger = "hover focus";
      this.hideTooltip = false;
    }
    hasTooltip() {
      return this.hasMainTooltip() || this.hasTooltipDisabledReason();
    }
    renderTooltip(id) {
      return when3(this.hasTooltip(), () => html7`
                    <atlas-tooltip id=${id} placement=${this.tooltipPlacement} trigger=${this.tooltipTrigger}>
                        ${this.getTooltipText()}
                    </atlas-tooltip>
                `);
    }
    hasMainTooltip() {
      return !this.hideTooltip && !!this.tooltip;
    }
    hasTooltipDisabledReason() {
      if (!("disabled" in this)) return false;
      return this.disabled && !!this.tooltipDisabledReason;
    }
    getTooltipText() {
      if (this.hasTooltipDisabledReason()) return this.tooltipDisabledReason;
      return this.tooltip;
    }
  }
  __decorateClass([property8({
    type: String,
    reflect: true
  })], WithTooltipClass.prototype, "tooltip", 2);
  __decorateClass([property8({
    type: String,
    attribute: "tooltip-disabled-reason",
    reflect: true
  })], WithTooltipClass.prototype, "tooltipDisabledReason", 2);
  __decorateClass([property8({
    type: String,
    attribute: "tooltip-placement",
    reflect: true
  })], WithTooltipClass.prototype, "tooltipPlacement", 2);
  __decorateClass([property8({
    type: String,
    attribute: "tooltip-trigger",
    reflect: true
  })], WithTooltipClass.prototype, "tooltipTrigger", 2);
  __decorateClass([property8({
    type: Boolean,
    attribute: "hide-tooltip",
    reflect: true
  })], WithTooltipClass.prototype, "hideTooltip", 2);
  return WithTooltipClass;
};

// src/components/dashboard/atlas-bar-chart-item/atlas-bar-chart-item.scss
import { css as css7 } from "lit-element/lit-element.js";
var atlas_bar_chart_item_default = css7`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
:host {
  display: contents;
}

.bar-chart {
  height: 100%;
  padding: 0;
  transition: all 0.2s ease-out;
  border-radius: inherit;
}
.bar-chart:hover {
  margin: 0;
  padding: 0.125rem 0;
}

.bar-chart-primary.bar-chart-100 {
  background-color: var(--atlas-primary-100);
}
.bar-chart-primary.bar-chart-200 {
  background-color: var(--atlas-primary-200);
}
.bar-chart-primary.bar-chart-300 {
  background-color: var(--atlas-primary-300);
}
.bar-chart-primary.bar-chart-400 {
  background-color: var(--atlas-primary-400);
}
.bar-chart-primary.bar-chart-500 {
  background-color: var(--atlas-primary-500);
}
.bar-chart-primary.bar-chart-600 {
  background-color: var(--atlas-primary-600);
}
.bar-chart-primary.bar-chart-700 {
  background-color: var(--atlas-primary-700);
}
.bar-chart-primary.bar-chart-800 {
  background-color: var(--atlas-primary-800);
}
.bar-chart-primary.bar-chart-900 {
  background-color: var(--atlas-primary-900);
}

.bar-chart-secondary.bar-chart-100 {
  background-color: var(--atlas-secondary-100);
}
.bar-chart-secondary.bar-chart-200 {
  background-color: var(--atlas-secondary-200);
}
.bar-chart-secondary.bar-chart-300 {
  background-color: var(--atlas-secondary-300);
}
.bar-chart-secondary.bar-chart-400 {
  background-color: var(--atlas-secondary-400);
}
.bar-chart-secondary.bar-chart-500 {
  background-color: var(--atlas-secondary-500);
}
.bar-chart-secondary.bar-chart-600 {
  background-color: var(--atlas-secondary-600);
}
.bar-chart-secondary.bar-chart-700 {
  background-color: var(--atlas-secondary-700);
}
.bar-chart-secondary.bar-chart-800 {
  background-color: var(--atlas-secondary-800);
}
.bar-chart-secondary.bar-chart-900 {
  background-color: var(--atlas-secondary-900);
}

.bar-chart-success.bar-chart-100 {
  background-color: var(--atlas-success-100);
}
.bar-chart-success.bar-chart-200 {
  background-color: var(--atlas-success-200);
}
.bar-chart-success.bar-chart-300 {
  background-color: var(--atlas-success-300);
}
.bar-chart-success.bar-chart-400 {
  background-color: var(--atlas-success-400);
}
.bar-chart-success.bar-chart-500 {
  background-color: var(--atlas-success-500);
}
.bar-chart-success.bar-chart-600 {
  background-color: var(--atlas-success-600);
}
.bar-chart-success.bar-chart-700 {
  background-color: var(--atlas-success-700);
}
.bar-chart-success.bar-chart-800 {
  background-color: var(--atlas-success-800);
}
.bar-chart-success.bar-chart-900 {
  background-color: var(--atlas-success-900);
}

.bar-chart-warning.bar-chart-100 {
  background-color: var(--atlas-warning-100);
}
.bar-chart-warning.bar-chart-200 {
  background-color: var(--atlas-warning-200);
}
.bar-chart-warning.bar-chart-300 {
  background-color: var(--atlas-warning-300);
}
.bar-chart-warning.bar-chart-400 {
  background-color: var(--atlas-warning-400);
}
.bar-chart-warning.bar-chart-500 {
  background-color: var(--atlas-warning-500);
}
.bar-chart-warning.bar-chart-600 {
  background-color: var(--atlas-warning-600);
}
.bar-chart-warning.bar-chart-700 {
  background-color: var(--atlas-warning-700);
}
.bar-chart-warning.bar-chart-800 {
  background-color: var(--atlas-warning-800);
}
.bar-chart-warning.bar-chart-900 {
  background-color: var(--atlas-warning-900);
}

.bar-chart-danger.bar-chart-100 {
  background-color: var(--atlas-danger-100);
}
.bar-chart-danger.bar-chart-200 {
  background-color: var(--atlas-danger-200);
}
.bar-chart-danger.bar-chart-300 {
  background-color: var(--atlas-danger-300);
}
.bar-chart-danger.bar-chart-400 {
  background-color: var(--atlas-danger-400);
}
.bar-chart-danger.bar-chart-500 {
  background-color: var(--atlas-danger-500);
}
.bar-chart-danger.bar-chart-600 {
  background-color: var(--atlas-danger-600);
}
.bar-chart-danger.bar-chart-700 {
  background-color: var(--atlas-danger-700);
}
.bar-chart-danger.bar-chart-800 {
  background-color: var(--atlas-danger-800);
}
.bar-chart-danger.bar-chart-900 {
  background-color: var(--atlas-danger-900);
}

.bar-chart-highlight.bar-chart-100 {
  background-color: var(--atlas-highlight-100);
}
.bar-chart-highlight.bar-chart-200 {
  background-color: var(--atlas-highlight-200);
}
.bar-chart-highlight.bar-chart-300 {
  background-color: var(--atlas-highlight-300);
}
.bar-chart-highlight.bar-chart-400 {
  background-color: var(--atlas-highlight-400);
}
.bar-chart-highlight.bar-chart-500 {
  background-color: var(--atlas-highlight-500);
}
.bar-chart-highlight.bar-chart-600 {
  background-color: var(--atlas-highlight-600);
}
.bar-chart-highlight.bar-chart-700 {
  background-color: var(--atlas-highlight-700);
}
.bar-chart-highlight.bar-chart-800 {
  background-color: var(--atlas-highlight-800);
}
.bar-chart-highlight.bar-chart-900 {
  background-color: var(--atlas-highlight-900);
}

.bar-chart-info.bar-chart-100 {
  background-color: var(--atlas-info-100);
}
.bar-chart-info.bar-chart-200 {
  background-color: var(--atlas-info-200);
}
.bar-chart-info.bar-chart-300 {
  background-color: var(--atlas-info-300);
}
.bar-chart-info.bar-chart-400 {
  background-color: var(--atlas-info-400);
}
.bar-chart-info.bar-chart-500 {
  background-color: var(--atlas-info-500);
}
.bar-chart-info.bar-chart-600 {
  background-color: var(--atlas-info-600);
}
.bar-chart-info.bar-chart-700 {
  background-color: var(--atlas-info-700);
}
.bar-chart-info.bar-chart-800 {
  background-color: var(--atlas-info-800);
}
.bar-chart-info.bar-chart-900 {
  background-color: var(--atlas-info-900);
}`;

// src/components/dashboard/atlas-bar-chart-item/atlas-bar-chart-item.ts
var AtlasBarChartItem = /*#__PURE__*/(() => {
  let AtlasBarChartItem = class extends WithTooltipMixin(LitElement3) {
    constructor() {
      super(...arguments);
      this.width = 100;
    }
    render() {
      const barChartClass = {
        "bar-chart": true,
        [`bar-chart-${this.theme}`]: !!this.theme,
        [`bar-chart-${this.variation}`]: !!this.variation
      };
      return html8`
            <div
                class="${classMap2(barChartClass)}"
                data-atlas-tooltip="bar-chart-tooltip"
                style="width: ${this.width}%"
            ></div>
            ${this.renderTooltip("bar-chart-tooltip")}
        `;
    }
  };
  AtlasBarChartItem.styles = atlas_bar_chart_item_default;
  return AtlasBarChartItem;
})();
__decorateClass([property9({
  type: String
})], AtlasBarChartItem.prototype, "theme", 2);
__decorateClass([property9({
  type: String
})], AtlasBarChartItem.prototype, "variation", 2);
__decorateClass([property9({
  type: Number
})], AtlasBarChartItem.prototype, "width", 2);
AtlasBarChartItem = __decorateClass([customElement6("atlas-bar-chart-item")], AtlasBarChartItem);

// src/components/dashboard/atlas-calendar/atlas-calendar.ts
import { html as html16 } from "lit";
import { customElement as customElement12, property as property17, query as query5, state as state4 } from "lit/decorators.js";
import { classMap as classMap8 } from "lit/directives/class-map.js";
import { when as when10 } from "lit/directives/when.js";

// src/vendors/datepicker-utils.ts
import Datepicker from "vanillajs-datepicker/Datepicker";
var DatepickerExtended = class _DatepickerExtended extends Datepicker {
  static get dateFormat() {
    return "dd/mm/yyyy";
  }
  static get locales() {
    return __spreadProps(__spreadValues({}, Datepicker.locales), {
      "pt-BR": {
        days: ["Domingo", "Segunda", "Ter\xE7a", "Quarta", "Quinta", "Sexta", "S\xE1bado"],
        daysShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "S\xE1b"],
        daysMin: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "S\xE1b"],
        months: ["Janeiro", "Fevereiro", "Mar\xE7o", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
        monthsShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
        today: "Hoje",
        monthsTitle: "Meses",
        clear: "Limpar",
        format: _DatepickerExtended.dateFormat
      }
    });
  }
  static getDateTitle(date) {
    let dateObject = date;
    if (!date) {
      dateObject = /* @__PURE__ */new Date();
    }
    let title = `${dateObject.getFullYear()}/`;
    title += `${this.locales["pt-BR"].daysShort[dateObject.getDay()]}, `;
    title += `${dateObject.getDate()} de `;
    title += this.locales["pt-BR"].months[dateObject.getMonth()];
    return title;
  }
  static getDatepickerMinDate(preventPastDate, minDate) {
    if (minDate) {
      const parsedDate = Datepicker.parseDate(minDate, _DatepickerExtended.dateFormat);
      return new Date(parsedDate);
    }
    if (preventPastDate) {
      const currentDate = /* @__PURE__ */new Date();
      currentDate.setHours(0, 0, 0, 0);
      return currentDate;
    }
    return new Date(Datepicker.parseDate("01/01/1000", _DatepickerExtended.dateFormat));
  }
  static getDatepickerMaxDate(preventLaterDate, maxDate) {
    if (maxDate) {
      const parsedDate = Datepicker.parseDate(maxDate, _DatepickerExtended.dateFormat);
      return new Date(parsedDate);
    }
    const currentDate = /* @__PURE__ */new Date();
    const currentYear = currentDate.getFullYear();
    return new Date(preventLaterDate ? currentYear : currentYear + 80, currentDate.getMonth(), currentDate.getDate());
  }
  static getDateAsTimestamp(date) {
    const parsedDate = Datepicker.parseDate(date, _DatepickerExtended.dateFormat);
    const dateObj = new Date(parsedDate);
    dateObj.setHours(0, 0, 0, 0);
    return dateObj.getTime();
  }
  static getTodayDate() {
    const currentDate = /* @__PURE__ */new Date();
    currentDate.setHours(0, 0, 0, 0);
    return currentDate;
  }
  /**
   * @override
   * Overwriting the method to not revert the date on closing the picker
   */
  update(options) {
    super.update(Object.assign(options || {}, {
      revert: false
    }));
  }
};

// src/components/dashboard/atlas-calendar/atlas-calendar.scss
import { css as css8 } from "lit-element/lit-element.js";
var atlas_calendar_default = css8`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Z-index mapping for the floating elements */
/* Transitions */
.datepicker {
  width: min-content;
}
.datepicker:not(.active) {
  display: none;
}

.datepicker-dropdown {
  position: absolute;
  z-index: 20;
  padding-top: 4px;
}
.datepicker-dropdown.datepicker-orient-top {
  padding-top: 0;
  padding-bottom: 4px;
}

.datepicker-picker {
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  background-color: hsl(0, 0%, 100%);
}
.datepicker-dropdown .datepicker-picker {
  box-shadow: 0 2px 3px rgba(10.2, 10.2, 10.2, 0.1), 0 0 0 1px rgba(10.2, 10.2, 10.2, 0.1);
}

.datepicker-main {
  flex: auto;
  padding: 2px;
}

.datepicker-footer {
  box-shadow: inset 0 1px 1px rgba(10.2, 10.2, 10.2, 0.1);
  background-color: hsl(0, 0%, 96%);
}

.datepicker-title {
  box-shadow: inset 0 -1px 1px rgba(10.2, 10.2, 10.2, 0.1);
  background-color: hsl(0, 0%, 96%);
  padding: 0.375rem 0.75rem;
  text-align: center;
  font-weight: 700;
}

.datepicker-controls {
  display: flex;
}
.datepicker-header .datepicker-controls {
  padding: 2px 2px 0;
}
.datepicker-controls .button {
  display: inline-flex;
  position: relative;
  align-items: center;
  justify-content: center;
  margin: 0;
  border: 1px solid hsl(0, 0%, 86.4%);
  border-radius: 4px;
  box-shadow: none;
  background-color: hsl(0, 0%, 100%);
  cursor: pointer;
  padding: calc(0.375em - 1px) 0.75em;
  height: 2.25em;
  vertical-align: top;
  text-align: center;
  line-height: 1.5;
  white-space: nowrap;
  color: hsl(0, 0%, 21%);
  font-size: 1rem;
}
.datepicker-controls .button:focus, .datepicker-controls .button:active {
  outline: none;
}
.datepicker-controls .button:hover {
  border-color: hsl(0, 0%, 72%);
  color: hsl(0, 0%, 21%);
}
.datepicker-controls .button:focus {
  border-color: hsl(217, 71%, 53%);
  color: hsl(0, 0%, 21%);
}
.datepicker-controls .button:focus:not(:active) {
  box-shadow: 0 0 0 0.125em rgba(50.0565, 115.29485, 220.2435, 0.25);
}
.datepicker-controls .button:active {
  border-color: hsl(0, 0%, 28%);
  color: hsl(0, 0%, 21%);
}
.datepicker-controls .button[disabled] {
  cursor: not-allowed;
}
.datepicker-header .datepicker-controls .button {
  border-color: transparent;
  font-weight: bold;
}
.datepicker-header .datepicker-controls .button:hover {
  background-color: hsl(0, 0%, 97.5%);
}
.datepicker-header .datepicker-controls .button:active {
  background-color: hsl(0, 0%, 95%);
}
.datepicker-footer .datepicker-controls .button {
  flex: auto;
  margin: calc(0.375rem - 1px) 0.375rem;
  border-radius: 2px;
  font-size: 0.75rem;
}
.datepicker-controls .view-switch {
  flex: auto;
}
.datepicker-controls .prev-button,
.datepicker-controls .next-button {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
  flex: 0 0 14.2857142857%;
}
.datepicker-controls .prev-button.disabled,
.datepicker-controls .next-button.disabled {
  visibility: hidden;
}

.datepicker-view,
.datepicker-grid {
  display: flex;
}

.datepicker-view {
  align-items: stretch;
  width: 15.75rem;
}

.datepicker-grid {
  flex-wrap: wrap;
  flex: auto;
}

.datepicker .days {
  display: flex;
  flex-direction: column;
  flex: auto;
}
.datepicker .days-of-week {
  display: flex;
}
.datepicker .week-numbers {
  display: flex;
  flex-direction: column;
  flex: 0 0 9.6774193548%;
}
.datepicker .weeks {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: auto;
}
.datepicker span {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: default;
  -webkit-touch-callout: none;
  user-select: none;
}
.datepicker .dow {
  height: 1.5rem;
  font-size: 0.875rem;
  font-weight: 700;
}
.datepicker .week {
  flex: auto;
  color: hsl(0, 0%, 72%);
  font-size: 0.75rem;
}

.datepicker-cell, .datepicker .days .dow {
  flex-basis: 14.2857142857%;
}

.datepicker-cell {
  height: 2.25rem;
}
.datepicker-cell:not(.day) {
  flex-basis: 25%;
  height: 4.5rem;
}
.datepicker-cell:not(.disabled):hover {
  background-color: hsl(0, 0%, 97.5%);
  cursor: pointer;
}
.datepicker-cell.focused:not(.selected) {
  background-color: #ced4da;
}
.datepicker-cell.selected, .datepicker-cell.selected:hover {
  background-color: var(--atlas-primary);
  color: #ffffff;
  font-weight: 600;
}
.datepicker-cell.disabled {
  color: #687078;
}
.datepicker-cell.prev:not(.disabled), .datepicker-cell.next:not(.disabled) {
  color: #687078;
}
.datepicker-cell.prev.selected, .datepicker-cell.next.selected {
  color: rgb(229.5, 229.5, 229.5);
}
.datepicker-cell.highlighted:not(.selected):not(.range):not(.today) {
  border-radius: 0;
  background-color: hsl(0, 0%, 96%);
}
.datepicker-cell.highlighted:not(.selected):not(.range):not(.today):not(.disabled):hover {
  background-color: hsl(0, 0%, 93.6%);
}
.datepicker-cell.highlighted:not(.selected):not(.range):not(.today).focused {
  background-color: #ced4da;
}
.datepicker-cell.today:not(.selected) {
  background-color: hsl(171, 100%, 41%);
}
.datepicker-cell.today:not(.selected):not(.disabled) {
  color: #fff;
}
.datepicker-cell.today.focused:not(.selected) {
  background-color: hsl(171, 100%, 39.975%);
}
.datepicker-cell.range-end:not(.selected), .datepicker-cell.range-start:not(.selected) {
  background-color: hsl(0, 0%, 72%);
  color: #ffffff;
}
.datepicker-cell.range-end.focused:not(.selected), .datepicker-cell.range-start.focused:not(.selected) {
  background-color: hsl(0, 0%, 70.2%);
}
.datepicker-cell.range-start:not(.range-end) {
  border-radius: 4px 0 0 4px;
}
.datepicker-cell.range-end:not(.range-start) {
  border-radius: 0 4px 4px 0;
}
.datepicker-cell.range {
  border-radius: 0;
  background-color: hsl(0, 0%, 86.4%);
}
.datepicker-cell.range:not(.disabled):not(.focused):not(.today):hover {
  background-color: hsl(0, 0%, 84.24%);
}
.datepicker-cell.range.disabled {
  color: hsl(0, 0%, 77.76%);
}
.datepicker-cell.range.focused {
  background-color: hsl(0, 0%, 82.08%);
}

.datepicker-input.in-edit {
  border-color: hsl(217, 71%, 50.35%);
}
.datepicker-input.in-edit:focus, .datepicker-input.in-edit:active {
  box-shadow: 0 0 0.25em 0.25em rgba(38.501175, 107.4178575, 218.283825, 0.2);
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@font-face {
  font-family: "Atlas-Icons";
  src: url("fonts/Atlas-Icons.eot?ku8bqy");
  src: url("fonts/Atlas-Icons.eot?ku8bqy#iefix") format("embedded-opentype"), url("fonts/Atlas-Icons.ttf?ku8bqy") format("truetype"), url("fonts/Atlas-Icons.woff?ku8bqy") format("woff"), url("fonts/Atlas-Icons.svg?ku8bqy#Atlas-Icons") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
.atlas-icon {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "Atlas-Icons" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.ati-address-book:before {
  content: "\\e905";
}

.ati-alert:before {
  content: "\\e96f";
}

.ati-alert-circle:before {
  content: "\\e902";
}

.ati-alert-triangle:before {
  content: "\\e904";
}

.ati-align-justify:before {
  content: "\\e906";
}

.ati-apps:before {
  content: "\\e907";
}

.ati-arrow-down:before {
  content: "\\e90c";
}

.ati-arrow-down-circle:before {
  content: "\\e90d";
}

.ati-arrow-left:before {
  content: "\\e910";
}

.ati-arrow-right:before {
  content: "\\e912";
}

.ati-arrow-right-left:before {
  content: "\\e908";
}

.ati-arrow-up:before {
  content: "\\e914";
}

.ati-arrow-up-circle:before {
  content: "\\e93f";
}

.ati-arrow-up-right:before {
  content: "\\e909";
}

.ati-asaas-logo:before {
  content: "\\e90a";
}

.ati-backspace:before {
  content: "\\e970";
}

.ati-banco-do-brasil:before {
  content: "\\e976";
}

.ati-bank:before {
  content: "\\e932";
}

.ati-bar-chart:before {
  content: "\\e91b";
}

.ati-barcode:before {
  content: "\\e921";
}

.ati-bars:before {
  content: "\\e998";
}

.ati-base-logo:before {
  content: "\\e93e";
}

.ati-bell:before {
  content: "\\e91e";
}

.ati-box:before {
  content: "\\e923";
}

.ati-briefcase:before {
  content: "\\e926";
}

.ati-caixa:before {
  content: "\\e977";
}

.ati-calendar:before {
  content: "\\e93b";
}

.ati-calendar-sync:before {
  content: "\\e96d";
}

.ati-camera:before {
  content: "\\e90b";
}

.ati-card:before {
  content: "\\e951";
}

.ati-card-mastercard:before {
  content: "\\e953";
}

.ati-celebrate:before {
  content: "\\e948";
}

.ati-check:before {
  content: "\\e92b";
}

.ati-check-circle:before {
  content: "\\e92c";
}

.ati-check-filled:before {
  content: "\\e95d";
}

.ati-chevron-down:before {
  content: "\\e92e";
}

.ati-chevron-left:before {
  content: "\\e92f";
}

.ati-chevron-right:before {
  content: "\\e930";
}

.ati-chevron-up:before {
  content: "\\e931";
}

.ati-circle:before {
  content: "\\e937";
}

.ati-clock:before {
  content: "\\e939";
}

.ati-clock-filled:before {
  content: "\\e95e";
}

.ati-cog:before {
  content: "\\e9cf";
}

.ati-concentric-circles:before {
  content: "\\e93a";
}

.ati-contactless:before {
  content: "\\e959";
}

.ati-copy:before {
  content: "\\e947";
}

.ati-corner-up-right:before {
  content: "\\e94f";
}

.ati-credisis:before {
  content: "\\e978";
}

.ati-dashboard:before {
  content: "\\e90e";
}

.ati-dollar-sign:before {
  content: "\\e957";
}

.ati-dollar-zap:before {
  content: "\\e903";
}

.ati-double-check:before {
  content: "\\e971";
}

.ati-download:before {
  content: "\\e958";
}

.ati-envelope:before {
  content: "\\e992";
}

.ati-eye:before {
  content: "\\e95f";
}

.ati-eye-filled:before {
  content: "\\e966";
}

.ati-eye-off:before {
  content: "\\e960";
}

.ati-facebook:before {
  content: "\\e943";
}

.ati-file:before {
  content: "\\e965";
}

.ati-file-check:before {
  content: "\\e96c";
}

.ati-file-dollar:before {
  content: "\\e901";
}

.ati-file-text:before {
  content: "\\e968";
}

.ati-file-users:before {
  content: "\\e96b";
}

.ati-files:before {
  content: "\\e90f";
}

.ati-filter:before {
  content: "\\e96a";
}

.ati-flapp-store-logo:before {
  content: "\\e96e";
}

.ati-flash:before {
  content: "\\e973";
}

.ati-gift:before {
  content: "\\e92d";
}

.ati-github:before {
  content: "\\e94a";
}

.ati-globe:before {
  content: "\\e94d";
}

.ati-hammer:before {
  content: "\\e974";
}

.ati-hand-card:before {
  content: "\\e952";
}

.ati-hand-holding-money:before {
  content: "\\e946";
}

.ati-hand-shake:before {
  content: "\\e911";
}

.ati-help-circle:before {
  content: "\\e97e";
}

.ati-hierarchy:before {
  content: "\\e945";
}

.ati-home:before {
  content: "\\e938";
}

.ati-id-card:before {
  content: "\\e933";
}

.ati-info:before {
  content: "\\e983";
}

.ati-instagram:before {
  content: "\\e984";
}

.ati-inter:before {
  content: "\\e979";
}

.ati-invoice:before {
  content: "\\e900";
}

.ati-itau:before {
  content: "\\e97a";
}

.ati-key:before {
  content: "\\e913";
}

.ati-keyboard:before {
  content: "\\ea1a";
}

.ati-link:before {
  content: "\\e98a";
}

.ati-linkedin:before {
  content: "\\e944";
}

.ati-list:before {
  content: "\\e98d";
}

.ati-loader:before {
  content: "\\e934";
}

.ati-lock:before {
  content: "\\e98f";
}

.ati-lock-filled:before {
  content: "\\e963";
}

.ati-log-in:before {
  content: "\\e990";
}

.ati-magnifier:before {
  content: "\\e9cc";
}

.ati-mail-box:before {
  content: "\\e915";
}

.ati-map-pin:before {
  content: "\\e954";
}

.ati-market-pin:before {
  content: "\\e97d";
}

.ati-maximize:before {
  content: "\\e967";
}

.ati-megaphone:before {
  content: "\\e936";
}

.ati-message-circle:before {
  content: "\\e999";
}

.ati-mic:before {
  content: "\\e97f";
}

.ati-minus:before {
  content: "\\e99f";
}

.ati-minus-circle:before {
  content: "\\e9a0";
}

.ati-money:before {
  content: "\\e916";
}

.ati-money-filled:before {
  content: "\\e961";
}

.ati-money-notes:before {
  content: "\\e949";
}

.ati-monitor:before {
  content: "\\e9a2";
}

.ati-monitor-chart-up:before {
  content: "\\e924";
}

.ati-moon:before {
  content: "\\e94e";
}

.ati-nubank:before {
  content: "\\e97b";
}

.ati-open-finance:before {
  content: "\\e91c";
}

.ati-paperclip:before {
  content: "\\e9ad";
}

.ati-pencil:before {
  content: "\\e95c";
}

.ati-phone:before {
  content: "\\e9b2";
}

.ati-pix:before {
  content: "\\e922";
}

.ati-plus:before {
  content: "\\e9bc";
}

.ati-plus-circle:before {
  content: "\\e9bd";
}

.ati-power:before {
  content: "\\e9c0";
}

.ati-printer:before {
  content: "\\e9c1";
}

.ati-receipt:before {
  content: "\\e975";
}

.ati-refresh:before {
  content: "\\e9c3";
}

.ati-refresh-dollar:before {
  content: "\\e917";
}

.ati-repeat:before {
  content: "\\e929";
}

.ati-rotate:before {
  content: "\\e9c8";
}

.ati-rotate-dollar:before {
  content: "\\e918";
}

.ati-santander:before {
  content: "\\e97c";
}

.ati-send:before {
  content: "\\e9cd";
}

.ati-serasa:before {
  content: "\\e919";
}

.ati-share:before {
  content: "\\e941";
}

.ati-shield:before {
  content: "\\e91a";
}

.ati-shopping-bag:before {
  content: "\\e95a";
}

.ati-shopping-cart-down:before {
  content: "\\e925";
}

.ati-shopping-cart-right:before {
  content: "\\e969";
}

.ati-slash:before {
  content: "\\e9db";
}

.ati-sliders:before {
  content: "\\e9dc";
}

.ati-smartphone:before {
  content: "\\e9dd";
}

.ati-smartphone-contactless:before {
  content: "\\e972";
}

.ati-sort:before {
  content: "\\e935";
}

.ati-spanner:before {
  content: "\\e927";
}

.ati-split-arrows:before {
  content: "\\e93d";
}

.ati-square:before {
  content: "\\e9e0";
}

.ati-square-signs:before {
  content: "\\e91d";
}

.ati-star:before {
  content: "\\e940";
}

.ati-star-filled:before {
  content: "\\e964";
}

.ati-sun:before {
  content: "\\e950";
}

.ati-tag:before {
  content: "\\e9e7";
}

.ati-three-dots:before {
  content: "\\e9a5";
}

.ati-three-dots-horinzontal:before {
  content: "\\e93c";
}

.ati-thumbs-down:before {
  content: "\\e94c";
}

.ati-thumbs-up:before {
  content: "\\e94b";
}

.ati-ticket:before {
  content: "\\e956";
}

.ati-trash:before {
  content: "\\e9f1";
}

.ati-truck:before {
  content: "\\e9f6";
}

.ati-unlink:before {
  content: "\\e980";
}

.ati-unlock:before {
  content: "\\e955";
}

.ati-upload:before {
  content: "\\e9fe";
}

.ati-user:before {
  content: "\\ea00";
}

.ati-user-filled:before {
  content: "\\e95b";
}

.ati-user-plus:before {
  content: "\\ea03";
}

.ati-users:before {
  content: "\\ea05";
}

.ati-video:before {
  content: "\\e92a";
}

.ati-virtual-card:before {
  content: "\\e91f";
}

.ati-wallet:before {
  content: "\\e920";
}

.ati-whatsapp:before {
  content: "\\e928";
}

.ati-x:before {
  content: "\\ea11";
}

.ati-x-filled:before {
  content: "\\e962";
}

.ati-youtube:before {
  content: "\\e942";
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.color-white {
  color: #ffffff !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.color-primary {
  color: var(--atlas-primary) !important;
}

.bg-primary {
  background-color: var(--atlas-primary) !important;
}

.color-primary-100 {
  color: var(--atlas-primary-100) !important;
}

.bg-primary-100 {
  background-color: var(--atlas-primary-100) !important;
}

.color-primary-200 {
  color: var(--atlas-primary-200) !important;
}

.bg-primary-200 {
  background-color: var(--atlas-primary-200) !important;
}

.color-primary-300 {
  color: var(--atlas-primary-300) !important;
}

.bg-primary-300 {
  background-color: var(--atlas-primary-300) !important;
}

.color-primary-400 {
  color: var(--atlas-primary-400) !important;
}

.bg-primary-400 {
  background-color: var(--atlas-primary-400) !important;
}

.color-primary-500 {
  color: var(--atlas-primary-500) !important;
}

.bg-primary-500 {
  background-color: var(--atlas-primary-500) !important;
}

.color-primary-600 {
  color: var(--atlas-primary-600) !important;
}

.bg-primary-600 {
  background-color: var(--atlas-primary-600) !important;
}

.color-primary-700 {
  color: var(--atlas-primary-700) !important;
}

.bg-primary-700 {
  background-color: var(--atlas-primary-700) !important;
}

.color-primary-800 {
  color: var(--atlas-primary-800) !important;
}

.bg-primary-800 {
  background-color: var(--atlas-primary-800) !important;
}

.color-primary-900 {
  color: var(--atlas-primary-900) !important;
}

.bg-primary-900 {
  background-color: var(--atlas-primary-900) !important;
}

.active-primary[active], .active-primary.active, .active-primary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-secondary {
  color: var(--atlas-secondary) !important;
}

.bg-secondary {
  background-color: var(--atlas-secondary) !important;
}

.color-secondary-100 {
  color: var(--atlas-secondary-100) !important;
}

.bg-secondary-100 {
  background-color: var(--atlas-secondary-100) !important;
}

.color-secondary-200 {
  color: var(--atlas-secondary-200) !important;
}

.bg-secondary-200 {
  background-color: var(--atlas-secondary-200) !important;
}

.color-secondary-300 {
  color: var(--atlas-secondary-300) !important;
}

.bg-secondary-300 {
  background-color: var(--atlas-secondary-300) !important;
}

.color-secondary-400 {
  color: var(--atlas-secondary-400) !important;
}

.bg-secondary-400 {
  background-color: var(--atlas-secondary-400) !important;
}

.color-secondary-500 {
  color: var(--atlas-secondary-500) !important;
}

.bg-secondary-500 {
  background-color: var(--atlas-secondary-500) !important;
}

.color-secondary-600 {
  color: var(--atlas-secondary-600) !important;
}

.bg-secondary-600 {
  background-color: var(--atlas-secondary-600) !important;
}

.color-secondary-700 {
  color: var(--atlas-secondary-700) !important;
}

.bg-secondary-700 {
  background-color: var(--atlas-secondary-700) !important;
}

.color-secondary-800 {
  color: var(--atlas-secondary-800) !important;
}

.bg-secondary-800 {
  background-color: var(--atlas-secondary-800) !important;
}

.color-secondary-900 {
  color: var(--atlas-secondary-900) !important;
}

.bg-secondary-900 {
  background-color: var(--atlas-secondary-900) !important;
}

.active-secondary[active], .active-secondary.active, .active-secondary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-success {
  color: var(--atlas-success) !important;
}

.bg-success {
  background-color: var(--atlas-success) !important;
}

.color-success-100 {
  color: var(--atlas-success-100) !important;
}

.bg-success-100 {
  background-color: var(--atlas-success-100) !important;
}

.color-success-200 {
  color: var(--atlas-success-200) !important;
}

.bg-success-200 {
  background-color: var(--atlas-success-200) !important;
}

.color-success-300 {
  color: var(--atlas-success-300) !important;
}

.bg-success-300 {
  background-color: var(--atlas-success-300) !important;
}

.color-success-400 {
  color: var(--atlas-success-400) !important;
}

.bg-success-400 {
  background-color: var(--atlas-success-400) !important;
}

.color-success-500 {
  color: var(--atlas-success-500) !important;
}

.bg-success-500 {
  background-color: var(--atlas-success-500) !important;
}

.color-success-600 {
  color: var(--atlas-success-600) !important;
}

.bg-success-600 {
  background-color: var(--atlas-success-600) !important;
}

.color-success-700 {
  color: var(--atlas-success-700) !important;
}

.bg-success-700 {
  background-color: var(--atlas-success-700) !important;
}

.color-success-800 {
  color: var(--atlas-success-800) !important;
}

.bg-success-800 {
  background-color: var(--atlas-success-800) !important;
}

.color-success-900 {
  color: var(--atlas-success-900) !important;
}

.bg-success-900 {
  background-color: var(--atlas-success-900) !important;
}

.active-success[active], .active-success.active, .active-success:active {
  background-color: var(--atlas-success) !important;
  color: var(--atlas-contrast-success) !important;
}

.color-warning {
  color: var(--atlas-warning) !important;
}

.bg-warning {
  background-color: var(--atlas-warning) !important;
}

.color-warning-100 {
  color: var(--atlas-warning-100) !important;
}

.bg-warning-100 {
  background-color: var(--atlas-warning-100) !important;
}

.color-warning-200 {
  color: var(--atlas-warning-200) !important;
}

.bg-warning-200 {
  background-color: var(--atlas-warning-200) !important;
}

.color-warning-300 {
  color: var(--atlas-warning-300) !important;
}

.bg-warning-300 {
  background-color: var(--atlas-warning-300) !important;
}

.color-warning-400 {
  color: var(--atlas-warning-400) !important;
}

.bg-warning-400 {
  background-color: var(--atlas-warning-400) !important;
}

.color-warning-500 {
  color: var(--atlas-warning-500) !important;
}

.bg-warning-500 {
  background-color: var(--atlas-warning-500) !important;
}

.color-warning-600 {
  color: var(--atlas-warning-600) !important;
}

.bg-warning-600 {
  background-color: var(--atlas-warning-600) !important;
}

.color-warning-700 {
  color: var(--atlas-warning-700) !important;
}

.bg-warning-700 {
  background-color: var(--atlas-warning-700) !important;
}

.color-warning-800 {
  color: var(--atlas-warning-800) !important;
}

.bg-warning-800 {
  background-color: var(--atlas-warning-800) !important;
}

.color-warning-900 {
  color: var(--atlas-warning-900) !important;
}

.bg-warning-900 {
  background-color: var(--atlas-warning-900) !important;
}

.active-warning[active], .active-warning.active, .active-warning:active {
  background-color: var(--atlas-warning) !important;
  color: var(--atlas-contrast-warning) !important;
}

.color-danger {
  color: var(--atlas-danger) !important;
}

.bg-danger {
  background-color: var(--atlas-danger) !important;
}

.color-danger-100 {
  color: var(--atlas-danger-100) !important;
}

.bg-danger-100 {
  background-color: var(--atlas-danger-100) !important;
}

.color-danger-200 {
  color: var(--atlas-danger-200) !important;
}

.bg-danger-200 {
  background-color: var(--atlas-danger-200) !important;
}

.color-danger-300 {
  color: var(--atlas-danger-300) !important;
}

.bg-danger-300 {
  background-color: var(--atlas-danger-300) !important;
}

.color-danger-400 {
  color: var(--atlas-danger-400) !important;
}

.bg-danger-400 {
  background-color: var(--atlas-danger-400) !important;
}

.color-danger-500 {
  color: var(--atlas-danger-500) !important;
}

.bg-danger-500 {
  background-color: var(--atlas-danger-500) !important;
}

.color-danger-600 {
  color: var(--atlas-danger-600) !important;
}

.bg-danger-600 {
  background-color: var(--atlas-danger-600) !important;
}

.color-danger-700 {
  color: var(--atlas-danger-700) !important;
}

.bg-danger-700 {
  background-color: var(--atlas-danger-700) !important;
}

.color-danger-800 {
  color: var(--atlas-danger-800) !important;
}

.bg-danger-800 {
  background-color: var(--atlas-danger-800) !important;
}

.color-danger-900 {
  color: var(--atlas-danger-900) !important;
}

.bg-danger-900 {
  background-color: var(--atlas-danger-900) !important;
}

.active-danger[active], .active-danger.active, .active-danger:active {
  background-color: var(--atlas-danger) !important;
  color: var(--atlas-contrast-danger) !important;
}

.color-highlight {
  color: var(--atlas-highlight) !important;
}

.bg-highlight {
  background-color: var(--atlas-highlight) !important;
}

.color-highlight-100 {
  color: var(--atlas-highlight-100) !important;
}

.bg-highlight-100 {
  background-color: var(--atlas-highlight-100) !important;
}

.color-highlight-200 {
  color: var(--atlas-highlight-200) !important;
}

.bg-highlight-200 {
  background-color: var(--atlas-highlight-200) !important;
}

.color-highlight-300 {
  color: var(--atlas-highlight-300) !important;
}

.bg-highlight-300 {
  background-color: var(--atlas-highlight-300) !important;
}

.color-highlight-400 {
  color: var(--atlas-highlight-400) !important;
}

.bg-highlight-400 {
  background-color: var(--atlas-highlight-400) !important;
}

.color-highlight-500 {
  color: var(--atlas-highlight-500) !important;
}

.bg-highlight-500 {
  background-color: var(--atlas-highlight-500) !important;
}

.color-highlight-600 {
  color: var(--atlas-highlight-600) !important;
}

.bg-highlight-600 {
  background-color: var(--atlas-highlight-600) !important;
}

.color-highlight-700 {
  color: var(--atlas-highlight-700) !important;
}

.bg-highlight-700 {
  background-color: var(--atlas-highlight-700) !important;
}

.color-highlight-800 {
  color: var(--atlas-highlight-800) !important;
}

.bg-highlight-800 {
  background-color: var(--atlas-highlight-800) !important;
}

.color-highlight-900 {
  color: var(--atlas-highlight-900) !important;
}

.bg-highlight-900 {
  background-color: var(--atlas-highlight-900) !important;
}

.active-highlight[active], .active-highlight.active, .active-highlight:active {
  background-color: var(--atlas-highlight) !important;
  color: var(--atlas-contrast-highlight) !important;
}

.color-info {
  color: var(--atlas-info) !important;
}

.bg-info {
  background-color: var(--atlas-info) !important;
}

.color-info-100 {
  color: var(--atlas-info-100) !important;
}

.bg-info-100 {
  background-color: var(--atlas-info-100) !important;
}

.color-info-200 {
  color: var(--atlas-info-200) !important;
}

.bg-info-200 {
  background-color: var(--atlas-info-200) !important;
}

.color-info-300 {
  color: var(--atlas-info-300) !important;
}

.bg-info-300 {
  background-color: var(--atlas-info-300) !important;
}

.color-info-400 {
  color: var(--atlas-info-400) !important;
}

.bg-info-400 {
  background-color: var(--atlas-info-400) !important;
}

.color-info-500 {
  color: var(--atlas-info-500) !important;
}

.bg-info-500 {
  background-color: var(--atlas-info-500) !important;
}

.color-info-600 {
  color: var(--atlas-info-600) !important;
}

.bg-info-600 {
  background-color: var(--atlas-info-600) !important;
}

.color-info-700 {
  color: var(--atlas-info-700) !important;
}

.bg-info-700 {
  background-color: var(--atlas-info-700) !important;
}

.color-info-800 {
  color: var(--atlas-info-800) !important;
}

.bg-info-800 {
  background-color: var(--atlas-info-800) !important;
}

.color-info-900 {
  color: var(--atlas-info-900) !important;
}

.bg-info-900 {
  background-color: var(--atlas-info-900) !important;
}

.active-info[active], .active-info.active, .active-info:active {
  background-color: var(--atlas-info) !important;
  color: var(--atlas-contrast-info) !important;
}

/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: inline-flex;
}

:host([data-atlas-popover]) {
  cursor: pointer;
}

.atlas-icon {
  line-height: normal;
  animation: none;
}
.atlas-icon.disabled {
  opacity: 0.35;
}

.ati-loader {
  animation: spin 4s linear infinite;
}

.atlas-icon.ati-1x {
  font-size: 8px;
  width: 8px;
  height: 8px;
}

.atlas-icon.ati-2x {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.atlas-icon.ati-3x {
  font-size: 24px;
  width: 24px;
  height: 24px;
}

.atlas-icon.ati-4x {
  font-size: 32px;
  width: 32px;
  height: 32px;
}

.atlas-icon.ati-5x {
  font-size: 40px;
  width: 40px;
  height: 40px;
}

.atlas-icon.ati-6x {
  font-size: 48px;
  width: 48px;
  height: 48px;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.color-white {
  color: #ffffff !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.color-primary {
  color: var(--atlas-primary) !important;
}

.bg-primary {
  background-color: var(--atlas-primary) !important;
}

.color-primary-100 {
  color: var(--atlas-primary-100) !important;
}

.bg-primary-100 {
  background-color: var(--atlas-primary-100) !important;
}

.color-primary-200 {
  color: var(--atlas-primary-200) !important;
}

.bg-primary-200 {
  background-color: var(--atlas-primary-200) !important;
}

.color-primary-300 {
  color: var(--atlas-primary-300) !important;
}

.bg-primary-300 {
  background-color: var(--atlas-primary-300) !important;
}

.color-primary-400 {
  color: var(--atlas-primary-400) !important;
}

.bg-primary-400 {
  background-color: var(--atlas-primary-400) !important;
}

.color-primary-500 {
  color: var(--atlas-primary-500) !important;
}

.bg-primary-500 {
  background-color: var(--atlas-primary-500) !important;
}

.color-primary-600 {
  color: var(--atlas-primary-600) !important;
}

.bg-primary-600 {
  background-color: var(--atlas-primary-600) !important;
}

.color-primary-700 {
  color: var(--atlas-primary-700) !important;
}

.bg-primary-700 {
  background-color: var(--atlas-primary-700) !important;
}

.color-primary-800 {
  color: var(--atlas-primary-800) !important;
}

.bg-primary-800 {
  background-color: var(--atlas-primary-800) !important;
}

.color-primary-900 {
  color: var(--atlas-primary-900) !important;
}

.bg-primary-900 {
  background-color: var(--atlas-primary-900) !important;
}

.active-primary[active], .active-primary.active, .active-primary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-secondary {
  color: var(--atlas-secondary) !important;
}

.bg-secondary {
  background-color: var(--atlas-secondary) !important;
}

.color-secondary-100 {
  color: var(--atlas-secondary-100) !important;
}

.bg-secondary-100 {
  background-color: var(--atlas-secondary-100) !important;
}

.color-secondary-200 {
  color: var(--atlas-secondary-200) !important;
}

.bg-secondary-200 {
  background-color: var(--atlas-secondary-200) !important;
}

.color-secondary-300 {
  color: var(--atlas-secondary-300) !important;
}

.bg-secondary-300 {
  background-color: var(--atlas-secondary-300) !important;
}

.color-secondary-400 {
  color: var(--atlas-secondary-400) !important;
}

.bg-secondary-400 {
  background-color: var(--atlas-secondary-400) !important;
}

.color-secondary-500 {
  color: var(--atlas-secondary-500) !important;
}

.bg-secondary-500 {
  background-color: var(--atlas-secondary-500) !important;
}

.color-secondary-600 {
  color: var(--atlas-secondary-600) !important;
}

.bg-secondary-600 {
  background-color: var(--atlas-secondary-600) !important;
}

.color-secondary-700 {
  color: var(--atlas-secondary-700) !important;
}

.bg-secondary-700 {
  background-color: var(--atlas-secondary-700) !important;
}

.color-secondary-800 {
  color: var(--atlas-secondary-800) !important;
}

.bg-secondary-800 {
  background-color: var(--atlas-secondary-800) !important;
}

.color-secondary-900 {
  color: var(--atlas-secondary-900) !important;
}

.bg-secondary-900 {
  background-color: var(--atlas-secondary-900) !important;
}

.active-secondary[active], .active-secondary.active, .active-secondary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-success {
  color: var(--atlas-success) !important;
}

.bg-success {
  background-color: var(--atlas-success) !important;
}

.color-success-100 {
  color: var(--atlas-success-100) !important;
}

.bg-success-100 {
  background-color: var(--atlas-success-100) !important;
}

.color-success-200 {
  color: var(--atlas-success-200) !important;
}

.bg-success-200 {
  background-color: var(--atlas-success-200) !important;
}

.color-success-300 {
  color: var(--atlas-success-300) !important;
}

.bg-success-300 {
  background-color: var(--atlas-success-300) !important;
}

.color-success-400 {
  color: var(--atlas-success-400) !important;
}

.bg-success-400 {
  background-color: var(--atlas-success-400) !important;
}

.color-success-500 {
  color: var(--atlas-success-500) !important;
}

.bg-success-500 {
  background-color: var(--atlas-success-500) !important;
}

.color-success-600 {
  color: var(--atlas-success-600) !important;
}

.bg-success-600 {
  background-color: var(--atlas-success-600) !important;
}

.color-success-700 {
  color: var(--atlas-success-700) !important;
}

.bg-success-700 {
  background-color: var(--atlas-success-700) !important;
}

.color-success-800 {
  color: var(--atlas-success-800) !important;
}

.bg-success-800 {
  background-color: var(--atlas-success-800) !important;
}

.color-success-900 {
  color: var(--atlas-success-900) !important;
}

.bg-success-900 {
  background-color: var(--atlas-success-900) !important;
}

.active-success[active], .active-success.active, .active-success:active {
  background-color: var(--atlas-success) !important;
  color: var(--atlas-contrast-success) !important;
}

.color-warning {
  color: var(--atlas-warning) !important;
}

.bg-warning {
  background-color: var(--atlas-warning) !important;
}

.color-warning-100 {
  color: var(--atlas-warning-100) !important;
}

.bg-warning-100 {
  background-color: var(--atlas-warning-100) !important;
}

.color-warning-200 {
  color: var(--atlas-warning-200) !important;
}

.bg-warning-200 {
  background-color: var(--atlas-warning-200) !important;
}

.color-warning-300 {
  color: var(--atlas-warning-300) !important;
}

.bg-warning-300 {
  background-color: var(--atlas-warning-300) !important;
}

.color-warning-400 {
  color: var(--atlas-warning-400) !important;
}

.bg-warning-400 {
  background-color: var(--atlas-warning-400) !important;
}

.color-warning-500 {
  color: var(--atlas-warning-500) !important;
}

.bg-warning-500 {
  background-color: var(--atlas-warning-500) !important;
}

.color-warning-600 {
  color: var(--atlas-warning-600) !important;
}

.bg-warning-600 {
  background-color: var(--atlas-warning-600) !important;
}

.color-warning-700 {
  color: var(--atlas-warning-700) !important;
}

.bg-warning-700 {
  background-color: var(--atlas-warning-700) !important;
}

.color-warning-800 {
  color: var(--atlas-warning-800) !important;
}

.bg-warning-800 {
  background-color: var(--atlas-warning-800) !important;
}

.color-warning-900 {
  color: var(--atlas-warning-900) !important;
}

.bg-warning-900 {
  background-color: var(--atlas-warning-900) !important;
}

.active-warning[active], .active-warning.active, .active-warning:active {
  background-color: var(--atlas-warning) !important;
  color: var(--atlas-contrast-warning) !important;
}

.color-danger {
  color: var(--atlas-danger) !important;
}

.bg-danger {
  background-color: var(--atlas-danger) !important;
}

.color-danger-100 {
  color: var(--atlas-danger-100) !important;
}

.bg-danger-100 {
  background-color: var(--atlas-danger-100) !important;
}

.color-danger-200 {
  color: var(--atlas-danger-200) !important;
}

.bg-danger-200 {
  background-color: var(--atlas-danger-200) !important;
}

.color-danger-300 {
  color: var(--atlas-danger-300) !important;
}

.bg-danger-300 {
  background-color: var(--atlas-danger-300) !important;
}

.color-danger-400 {
  color: var(--atlas-danger-400) !important;
}

.bg-danger-400 {
  background-color: var(--atlas-danger-400) !important;
}

.color-danger-500 {
  color: var(--atlas-danger-500) !important;
}

.bg-danger-500 {
  background-color: var(--atlas-danger-500) !important;
}

.color-danger-600 {
  color: var(--atlas-danger-600) !important;
}

.bg-danger-600 {
  background-color: var(--atlas-danger-600) !important;
}

.color-danger-700 {
  color: var(--atlas-danger-700) !important;
}

.bg-danger-700 {
  background-color: var(--atlas-danger-700) !important;
}

.color-danger-800 {
  color: var(--atlas-danger-800) !important;
}

.bg-danger-800 {
  background-color: var(--atlas-danger-800) !important;
}

.color-danger-900 {
  color: var(--atlas-danger-900) !important;
}

.bg-danger-900 {
  background-color: var(--atlas-danger-900) !important;
}

.active-danger[active], .active-danger.active, .active-danger:active {
  background-color: var(--atlas-danger) !important;
  color: var(--atlas-contrast-danger) !important;
}

.color-highlight {
  color: var(--atlas-highlight) !important;
}

.bg-highlight {
  background-color: var(--atlas-highlight) !important;
}

.color-highlight-100 {
  color: var(--atlas-highlight-100) !important;
}

.bg-highlight-100 {
  background-color: var(--atlas-highlight-100) !important;
}

.color-highlight-200 {
  color: var(--atlas-highlight-200) !important;
}

.bg-highlight-200 {
  background-color: var(--atlas-highlight-200) !important;
}

.color-highlight-300 {
  color: var(--atlas-highlight-300) !important;
}

.bg-highlight-300 {
  background-color: var(--atlas-highlight-300) !important;
}

.color-highlight-400 {
  color: var(--atlas-highlight-400) !important;
}

.bg-highlight-400 {
  background-color: var(--atlas-highlight-400) !important;
}

.color-highlight-500 {
  color: var(--atlas-highlight-500) !important;
}

.bg-highlight-500 {
  background-color: var(--atlas-highlight-500) !important;
}

.color-highlight-600 {
  color: var(--atlas-highlight-600) !important;
}

.bg-highlight-600 {
  background-color: var(--atlas-highlight-600) !important;
}

.color-highlight-700 {
  color: var(--atlas-highlight-700) !important;
}

.bg-highlight-700 {
  background-color: var(--atlas-highlight-700) !important;
}

.color-highlight-800 {
  color: var(--atlas-highlight-800) !important;
}

.bg-highlight-800 {
  background-color: var(--atlas-highlight-800) !important;
}

.color-highlight-900 {
  color: var(--atlas-highlight-900) !important;
}

.bg-highlight-900 {
  background-color: var(--atlas-highlight-900) !important;
}

.active-highlight[active], .active-highlight.active, .active-highlight:active {
  background-color: var(--atlas-highlight) !important;
  color: var(--atlas-contrast-highlight) !important;
}

.color-info {
  color: var(--atlas-info) !important;
}

.bg-info {
  background-color: var(--atlas-info) !important;
}

.color-info-100 {
  color: var(--atlas-info-100) !important;
}

.bg-info-100 {
  background-color: var(--atlas-info-100) !important;
}

.color-info-200 {
  color: var(--atlas-info-200) !important;
}

.bg-info-200 {
  background-color: var(--atlas-info-200) !important;
}

.color-info-300 {
  color: var(--atlas-info-300) !important;
}

.bg-info-300 {
  background-color: var(--atlas-info-300) !important;
}

.color-info-400 {
  color: var(--atlas-info-400) !important;
}

.bg-info-400 {
  background-color: var(--atlas-info-400) !important;
}

.color-info-500 {
  color: var(--atlas-info-500) !important;
}

.bg-info-500 {
  background-color: var(--atlas-info-500) !important;
}

.color-info-600 {
  color: var(--atlas-info-600) !important;
}

.bg-info-600 {
  background-color: var(--atlas-info-600) !important;
}

.color-info-700 {
  color: var(--atlas-info-700) !important;
}

.bg-info-700 {
  background-color: var(--atlas-info-700) !important;
}

.color-info-800 {
  color: var(--atlas-info-800) !important;
}

.bg-info-800 {
  background-color: var(--atlas-info-800) !important;
}

.color-info-900 {
  color: var(--atlas-info-900) !important;
}

.bg-info-900 {
  background-color: var(--atlas-info-900) !important;
}

.active-info[active], .active-info.active, .active-info:active {
  background-color: var(--atlas-info) !important;
  color: var(--atlas-contrast-info) !important;
}

/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  box-sizing: border-box;
  position: relative;
  width: 100%;
}

.calendar-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.calendar-flags {
  display: flex;
  gap: 2rem;
}
.calendar-flags .flag-item {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1;
}
.calendar-flags .flag-item .flag-badge {
  width: 8px;
  height: 8px;
  border-radius: 1px;
}
.calendar-flags .flag-item .flag-badge.circle {
  border-radius: 50%;
}
.calendar-flags .flag-item atlas-icon-button {
  margin-left: 0.25rem;
}

.atlas-calendar {
  width: 100%;
}
.atlas-calendar .skeleton {
  display: none;
}
.atlas-calendar[skeleton-loading] .skeleton {
  display: block;
}
.atlas-calendar[skeleton-loading] .skeleton ~ * {
  display: none;
}

.datepicker {
  width: 100%;
}
.datepicker .datepicker-picker {
  border: 1px solid #ced4da;
}

.datepicker-header .datepicker-controls {
  padding: 1rem 0;
  width: 84%;
  margin: 0 auto;
  align-items: center;
}
.datepicker-header .datepicker-controls .atlas-datepicker-button {
  display: inline-flex;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  justify-content: center;
}
.datepicker-header .datepicker-controls .atlas-datepicker-button span {
  cursor: pointer;
}
.datepicker-header .datepicker-controls .view-switch {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  line-height: 1;
  color: #212529;
}

.datepicker-main {
  padding: 0 1.5rem 1rem;
  box-sizing: border-box;
  width: 100%;
}
.datepicker-main .datepicker-view {
  width: 100%;
}
.datepicker-main .datepicker-view .days-of-week {
  margin-bottom: 1rem;
}
.datepicker-main .datepicker-view .days-of-week span {
  text-align: center;
  color: var(--atlas-primary);
  font-weight: 400;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}
.datepicker-main .datepicker-grid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  row-gap: 0.5rem;
}
.datepicker-main .datepicker-grid.months, .datepicker-main .datepicker-grid.years {
  grid-template-columns: repeat(4, 1fr);
  row-gap: 1.5rem;
}

.datepicker-cell {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  position: relative;
  height: auto;
  pointer-events: none;
}
.datepicker-cell .badge-container {
  display: flex;
  gap: 0.06rem;
  position: absolute;
  bottom: 1px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  pointer-events: all;
}
.datepicker-cell .badge-container .badge {
  width: 8px;
  height: 8px;
  border-radius: 1px;
}
.datepicker-cell .badge-container .badge.circle {
  border-radius: 50%;
}
.datepicker-cell .cell-content {
  width: 2rem;
  height: 2rem;
  border-radius: 0.25rem;
  box-sizing: border-box;
  pointer-events: all;
  cursor: pointer;
  z-index: 1;
  outline: 1px solid transparent;
  transition: all 0.25s ease;
}
.datepicker-cell .cell-content.skeleton {
  pointer-events: none;
}
.datepicker-cell.month .cell-content, .datepicker-cell.year .cell-content {
  width: 3.75rem;
  height: 3.75rem;
}
.datepicker-cell.in-range {
  background: transparent;
}
.datepicker-cell.in-range .cell-content {
  background: var(--atlas-primary-200);
  color: #ffffff;
  font-weight: 700;
}
.datepicker-cell.in-range .badge {
  background: #ffffff !important;
}
.datepicker-cell.in-range.in-range-no-after .cell-content, .datepicker-cell.in-range.in-range-no-before .cell-content {
  transition: none;
}
.datepicker-cell::after, .datepicker-cell::before {
  content: "";
  top: 0;
  width: 0%;
  height: 100%;
  position: absolute;
  background-color: white;
  transition: width 0.25s linear;
  z-index: 0;
}
.datepicker-cell::before {
  left: 0;
}
.datepicker-cell::after {
  left: 50%;
}
.datepicker-cell.range-start::after, .datepicker-cell.in-range:not(.in-range-no-after)::after {
  background: var(--atlas-primary-200);
  width: 50%;
}
.datepicker-cell.range-end::before, .datepicker-cell.in-range:not(.in-range-no-before)::before {
  background: var(--atlas-primary-200);
  width: 50%;
}
.datepicker-cell.range-end:not(.selected), .datepicker-cell.range-start:not(.selected) {
  background-color: transparent;
}
.datepicker-cell.range-end:not(.selected) .cell-content, .datepicker-cell.range-start:not(.selected) .cell-content {
  background-color: var(--atlas-primary-200);
}
.datepicker-cell:nth-child(1).range-start::before, .datepicker-cell:nth-child(1).in-range::before, .datepicker-cell:nth-child(1).range-end:not(.in-range-no-after)::before, .datepicker-cell:nth-child(7n+8).range-start::before, .datepicker-cell:nth-child(7n+8).in-range::before, .datepicker-cell:nth-child(7n+8).range-end:not(.in-range-no-after)::before {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.datepicker-cell:nth-child(7n).range-start::after, .datepicker-cell:nth-child(7n).in-range:not(.in-range-no-after)::after {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.datepicker-cell.selected, .datepicker-cell.selected:hover {
  background: transparent;
  /* stylelint-disable-next-line no-descending-specificity */
  /* stylelint-enable-next-line no-descending-specificity */
}
.datepicker-cell.selected .cell-content, .datepicker-cell.selected:hover .cell-content {
  background: var(--atlas-primary);
  color: #ffffff;
  font-weight: 700;
}
.datepicker-cell.selected .badge, .datepicker-cell.selected:hover .badge {
  background: #ffffff !important;
}
.datepicker-cell:not(.disabled):hover {
  background: transparent;
}
.datepicker-cell:not(.disabled):hover .cell-content {
  outline: 1px solid var(--atlas-primary);
}
.datepicker-cell.focused:not(.selected) {
  background: transparent;
}`;

// src/components/display/atlas-icon-button/atlas-icon-button.ts
import { customElement as customElement11, property as property16 } from "lit/decorators.js";
import { classMap as classMap7 } from "lit/directives/class-map.js";
import { ifDefined as ifDefined3 } from "lit/directives/if-defined.js";
import { when as when9 } from "lit/directives/when.js";
import { html as html15, literal as literal2 } from "lit/static-html.js";

// src/helpers/device.ts
var device_exports = {};
__export(device_exports, {
  isAndroid: () => isAndroid,
  isBlackBerry: () => isBlackBerry,
  isIOS: () => isIOS,
  isMobile: () => isMobile,
  isMobileScreen: () => isMobileScreen,
  isOpera: () => isOpera,
  isWindows: () => isWindows
});
function isAndroid() {
  return navigator.userAgent.match(/Android/i);
}
function isBlackBerry() {
  return navigator.userAgent.match(/BlackBerry/i);
}
function isIOS() {
  return navigator.userAgent.match(/iPhone|iPad|iPod/i);
}
function isOpera() {
  return navigator.userAgent.match(/Opera Mini/i);
}
function isWindows() {
  return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
}
function isMobile() {
  return Boolean(isAndroid() || isBlackBerry() || isIOS() || isOpera() || isWindows());
}
function isMobileScreen() {
  return window.matchMedia("screen and (max-width: 992px)").matches;
}

// src/controllers/device-controller.ts
var DeviceController = class {
  constructor(host, onChangeScreenType) {
    this.isMobile = false;
    this.host = host;
    this.cbChangeScreenType = onChangeScreenType;
    host.addController(this);
    this.onScreenResize = this.onScreenResize.bind(this);
  }
  hostConnected() {
    window.addEventListener("resize", this.onScreenResize);
    this.onScreenResize();
  }
  hostDisconnected() {
    window.removeEventListener("resize", this.onScreenResize);
  }
  setScreenChangeCallback(callback) {
    this.cbChangeScreenType = callback;
  }
  onScreenResize() {
    var _a;
    const {
      isMobile: prevIsMobile
    } = this;
    this.isMobile = isMobileScreen();
    if (prevIsMobile !== this.isMobile) {
      this.host.requestUpdate();
      (_a = this.cbChangeScreenType) == null ? void 0 : _a.call(this);
    }
  }
};

// src/internals/mixins/with-popover-mixin.ts
import { html as html11 } from "lit";
import { property as property12, state as state2 } from "lit/decorators.js";
import { when as when6 } from "lit/directives/when.js";
import { styleMap } from "lit/directives/style-map.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

// src/components/display/atlas-popover/atlas-popover.ts
import { html as html10 } from "lit";
import { customElement as customElement8, property as property11, query as query3, state } from "lit/decorators.js";
import { classMap as classMap4 } from "lit/directives/class-map.js";
import { when as when5 } from "lit/directives/when.js";
import { arrow as arrow2, offset as offset2 } from "@floating-ui/dom";

// src/components/display/atlas-popover/atlas-popover.scss
import { css as css9 } from "lit-element/lit-element.js";
var atlas_popover_default = css9`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Z-index mapping for the floating elements */
/* Transitions */
.fade {
  transition: opacity 0.25s ease;
}
.fade:not(.show) {
  opacity: 0;
}

.fade-and-scale {
  opacity: 0;
  transform: scale(0.7);
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.fade-and-scale.scale-vertically {
  transform: scale(1, 0.7);
}
.fade-and-scale.show {
  opacity: 1;
  transform: scale(1);
}

:host([data-popper-placement=top]),
:host([data-popper-placement=top]) .fade-and-scale,
div[data-popper-placement=top].fade-and-scale,
div[data-popper-placement=top] > .fade-and-scale,
.fade-and-scale.scale-top {
  transform-origin: center bottom;
}

:host([data-popper-placement=top-start]),
:host([data-popper-placement=top-start]) .fade-and-scale,
div[data-popper-placement=top-start].fade-and-scale,
div[data-popper-placement=top-start] > .fade-and-scale,
.fade-and-scale.scale-top-start {
  transform-origin: left bottom;
}

:host([data-popper-placement=top-end]),
:host([data-popper-placement=top-end]) .fade-and-scale,
div[data-popper-placement=top-end].fade-and-scale,
div[data-popper-placement=top-end] > .fade-and-scale,
.fade-and-scale.scale-top-end {
  transform-origin: right bottom;
}

:host([data-popper-placement=bottom]),
:host([data-popper-placement=bottom]) .fade-and-scale,
div[data-popper-placement=bottom].fade-and-scale,
div[data-popper-placement=bottom] > .fade-and-scale,
.fade-and-scale.scale-bottom {
  transform-origin: center top;
}

:host([data-popper-placement=bottom-start]),
:host([data-popper-placement=bottom-start]) .fade-and-scale,
div[data-popper-placement=bottom-start].fade-and-scale,
div[data-popper-placement=bottom-start] > .fade-and-scale,
.fade-and-scale.scale-bottom-start {
  transform-origin: left top;
}

:host([data-popper-placement=bottom-end]),
:host([data-popper-placement=bottom-end]) .fade-and-scale,
div[data-popper-placement=bottom-end].fade-and-scale,
div[data-popper-placement=bottom-end] > .fade-and-scale,
.fade-and-scale.scale-bottom-end {
  transform-origin: right top;
}

:host([data-popper-placement=left]),
:host([data-popper-placement=left]) .fade-and-scale,
div[data-popper-placement=left].fade-and-scale,
div[data-popper-placement=left] > .fade-and-scale,
.fade-and-scale.scale-left {
  transform-origin: right center;
}

:host([data-popper-placement=left-start]),
:host([data-popper-placement=left-start]) .fade-and-scale,
div[data-popper-placement=left-start].fade-and-scale,
div[data-popper-placement=left-start] > .fade-and-scale,
.fade-and-scale.scale-left-start {
  transform-origin: right top;
}

:host([data-popper-placement=left-end]),
:host([data-popper-placement=left-end]) .fade-and-scale,
div[data-popper-placement=left-end].fade-and-scale,
div[data-popper-placement=left-end] > .fade-and-scale,
.fade-and-scale.scale-left-end {
  transform-origin: right bottom;
}

:host([data-popper-placement=right]),
:host([data-popper-placement=right]) .fade-and-scale,
div[data-popper-placement=right].fade-and-scale,
div[data-popper-placement=right] > .fade-and-scale,
.fade-and-scale.scale-right {
  transform-origin: left center;
}

:host([data-popper-placement=right-start]),
:host([data-popper-placement=right-start]) .fade-and-scale,
div[data-popper-placement=right-start].fade-and-scale,
div[data-popper-placement=right-start] > .fade-and-scale,
.fade-and-scale.scale-right-start {
  transform-origin: left top;
}

:host([data-popper-placement=right-end]),
:host([data-popper-placement=right-end]) .fade-and-scale,
div[data-popper-placement=right-end].fade-and-scale,
div[data-popper-placement=right-end] > .fade-and-scale,
.fade-and-scale.scale-right-end {
  transform-origin: left bottom;
}

*[hidden] {
  display: none !important;
}

:host {
  position: fixed;
  z-index: 2000;
  width: 1px;
  height: 1px;
}

:host(:not([open])) {
  pointer-events: none;
}

:host([in-menu-context]) {
  position: absolute;
  top: 19.5px;
  left: 100%;
  transform: translateX(-100%);
}

.atlas-popover-backdrop {
  width: 100vw;
  height: 100vh;
  background: rgba(var(--atlas-dark-rgb), 40%);
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1050;
  visibility: hidden;
}
.atlas-popover-backdrop.show {
  visibility: visible;
}

.popover {
  display: block;
  max-width: 276px;
  min-width: 100px;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  line-height: 1.5;
  font-weight: 400;
  font-size: 0.8rem;
  word-wrap: break-word;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  box-shadow: none;
  z-index: 2000;
  position: relative;
}
.popover .popover-arrow {
  display: block;
  width: 1rem;
  height: 0.5rem;
  position: absolute;
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}
.popover.in-menu-context {
  border: none;
  border-radius: 1rem;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.5);
  max-width: 280px;
  max-height: 400px !important;
  position: absolute;
  top: -40px !important;
  left: 100% !important;
}
.popover.in-menu-context .popover-arrow {
  top: 40px !important;
  transform: translateY(-50%);
}
.popover.in-menu-context .popover-body {
  line-height: 0 !important;
  padding: 0 !important;
  overflow: hidden;
  border-radius: 1rem;
}

atlas-icon-button {
  float: right;
  margin: 1.2rem 1rem 0.5rem 0.5rem;
}

.popover-content {
  font-size: 1rem;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  color: #212529;
}
.popover-content .popover-header {
  font-weight: 600;
  padding: 1rem 1rem 0;
}
.popover-content .popover-header-container {
  display: flex;
}
.popover-content .popover-header-container i {
  cursor: pointer;
}
.popover-content .popover-image {
  display: none;
  object-fit: contain;
  width: 100%;
  padding-top: 0.5em;
}
.popover-content .popover-image slot[name=image]::slotted(img) {
  width: 100%;
  height: 137px;
  object-fit: cover;
}
.popover-content .popover-body {
  padding: 1rem;
  font-size: 0.875rem;
  text-wrap: wrap;
}
.popover-content .popover-body-container {
  display: flex;
  flex-direction: column;
}
.popover-content .popover-body .popover-button-link {
  display: none;
  margin-top: 1em;
  justify-content: flex-end;
}
.popover-content .popover-body.has-title {
  padding-top: 0.5rem;
}

.popover.has-image .popover-image {
  display: block;
}

.popover.has-button-link .popover-button-link {
  display: flex;
}

.popover.mobile-popover {
  position: fixed !important;
  width: 80% !important;
  max-width: 80% !important;
  display: block;
  inset: auto auto 50vh 50% !important;
  transform: translate(-50%, 50%) !important;
}
.popover.mobile-popover .popover-arrow {
  display: none;
}
.popover.mobile-popover .popover-header {
  font-size: 1.25rem;
}
.popover.mobile-popover .popover-body.has-title {
  padding: 1rem;
}
.popover.mobile-popover .popover-image {
  padding-top: 1rem;
}

.popover-auto[data-popper-placement^=top] > .popover-arrow, .popover-top > .popover-arrow {
  bottom: calc(-0.5rem - 1px);
}
.popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-top > .popover-arrow::before, .popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-top > .popover-arrow::after {
  border-width: 0.5rem 0.5rem 0;
}
.popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-top > .popover-arrow::before {
  bottom: 0;
  border-top-color: #ced4da;
}
.popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-top > .popover-arrow::after {
  bottom: 1px;
  border-top-color: #ffffff;
}

.popover-auto[data-popper-placement^=right] > .popover-arrow, .popover-end > .popover-arrow {
  left: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
}
.popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-end > .popover-arrow::before, .popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-end > .popover-arrow::after {
  border-width: 0.5rem 0.5rem 0.5rem 0;
}
.popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-end > .popover-arrow::before {
  left: 0;
  border-right-color: #ced4da;
}
.popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-end > .popover-arrow::after {
  left: 1px;
  border-right-color: #ffffff;
}

.popover-auto[data-popper-placement^=bottom] > .popover-arrow, .popover-bottom > .popover-arrow {
  top: calc(-0.5rem - 1px);
}
.popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-bottom > .popover-arrow::before, .popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-bottom > .popover-arrow::after {
  border-width: 0 0.5rem 0.5rem;
}
.popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-bottom > .popover-arrow::before {
  top: 0;
  border-bottom-color: #ced4da;
}
.popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-bottom > .popover-arrow::after {
  top: 1px;
  border-bottom-color: #ffffff;
}
.popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-bottom .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 1px solid #ffffff;
}

.popover-auto[data-popper-placement^=left] > .popover-arrow, .popover-start > .popover-arrow {
  right: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
}
.popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-start > .popover-arrow::before, .popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-start > .popover-arrow::after {
  border-width: 0.5rem 0 0.5rem 0.5rem;
}
.popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-start > .popover-arrow::before {
  right: 0;
  border-left-color: #ced4da;
}
.popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-start > .popover-arrow::after {
  right: 1px;
  border-left-color: #ffffff;
}`;

// src/components/display/atlas-icon/atlas-icon.ts
import { html as html9 } from "lit";
import { customElement as customElement7, property as property10 } from "lit/decorators.js";
import { classMap as classMap3 } from "lit/directives/class-map.js";
import { ifDefined } from "lit/directives/if-defined.js";
import { when as when4 } from "lit/directives/when.js";

// src/components/display/atlas-icon/atlas-icon.scss
import { css as css10 } from "lit-element/lit-element.js";
var atlas_icon_default = css10`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@font-face {
  font-family: "Atlas-Icons";
  src: url("fonts/Atlas-Icons.eot?ku8bqy");
  src: url("fonts/Atlas-Icons.eot?ku8bqy#iefix") format("embedded-opentype"), url("fonts/Atlas-Icons.ttf?ku8bqy") format("truetype"), url("fonts/Atlas-Icons.woff?ku8bqy") format("woff"), url("fonts/Atlas-Icons.svg?ku8bqy#Atlas-Icons") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
.atlas-icon {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "Atlas-Icons" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.ati-address-book:before {
  content: "\\e905";
}

.ati-alert:before {
  content: "\\e96f";
}

.ati-alert-circle:before {
  content: "\\e902";
}

.ati-alert-triangle:before {
  content: "\\e904";
}

.ati-align-justify:before {
  content: "\\e906";
}

.ati-apps:before {
  content: "\\e907";
}

.ati-arrow-down:before {
  content: "\\e90c";
}

.ati-arrow-down-circle:before {
  content: "\\e90d";
}

.ati-arrow-left:before {
  content: "\\e910";
}

.ati-arrow-right:before {
  content: "\\e912";
}

.ati-arrow-right-left:before {
  content: "\\e908";
}

.ati-arrow-up:before {
  content: "\\e914";
}

.ati-arrow-up-circle:before {
  content: "\\e93f";
}

.ati-arrow-up-right:before {
  content: "\\e909";
}

.ati-asaas-logo:before {
  content: "\\e90a";
}

.ati-backspace:before {
  content: "\\e970";
}

.ati-banco-do-brasil:before {
  content: "\\e976";
}

.ati-bank:before {
  content: "\\e932";
}

.ati-bar-chart:before {
  content: "\\e91b";
}

.ati-barcode:before {
  content: "\\e921";
}

.ati-bars:before {
  content: "\\e998";
}

.ati-base-logo:before {
  content: "\\e93e";
}

.ati-bell:before {
  content: "\\e91e";
}

.ati-box:before {
  content: "\\e923";
}

.ati-briefcase:before {
  content: "\\e926";
}

.ati-caixa:before {
  content: "\\e977";
}

.ati-calendar:before {
  content: "\\e93b";
}

.ati-calendar-sync:before {
  content: "\\e96d";
}

.ati-camera:before {
  content: "\\e90b";
}

.ati-card:before {
  content: "\\e951";
}

.ati-card-mastercard:before {
  content: "\\e953";
}

.ati-celebrate:before {
  content: "\\e948";
}

.ati-check:before {
  content: "\\e92b";
}

.ati-check-circle:before {
  content: "\\e92c";
}

.ati-check-filled:before {
  content: "\\e95d";
}

.ati-chevron-down:before {
  content: "\\e92e";
}

.ati-chevron-left:before {
  content: "\\e92f";
}

.ati-chevron-right:before {
  content: "\\e930";
}

.ati-chevron-up:before {
  content: "\\e931";
}

.ati-circle:before {
  content: "\\e937";
}

.ati-clock:before {
  content: "\\e939";
}

.ati-clock-filled:before {
  content: "\\e95e";
}

.ati-cog:before {
  content: "\\e9cf";
}

.ati-concentric-circles:before {
  content: "\\e93a";
}

.ati-contactless:before {
  content: "\\e959";
}

.ati-copy:before {
  content: "\\e947";
}

.ati-corner-up-right:before {
  content: "\\e94f";
}

.ati-credisis:before {
  content: "\\e978";
}

.ati-dashboard:before {
  content: "\\e90e";
}

.ati-dollar-sign:before {
  content: "\\e957";
}

.ati-dollar-zap:before {
  content: "\\e903";
}

.ati-double-check:before {
  content: "\\e971";
}

.ati-download:before {
  content: "\\e958";
}

.ati-envelope:before {
  content: "\\e992";
}

.ati-eye:before {
  content: "\\e95f";
}

.ati-eye-filled:before {
  content: "\\e966";
}

.ati-eye-off:before {
  content: "\\e960";
}

.ati-facebook:before {
  content: "\\e943";
}

.ati-file:before {
  content: "\\e965";
}

.ati-file-check:before {
  content: "\\e96c";
}

.ati-file-dollar:before {
  content: "\\e901";
}

.ati-file-text:before {
  content: "\\e968";
}

.ati-file-users:before {
  content: "\\e96b";
}

.ati-files:before {
  content: "\\e90f";
}

.ati-filter:before {
  content: "\\e96a";
}

.ati-flapp-store-logo:before {
  content: "\\e96e";
}

.ati-flash:before {
  content: "\\e973";
}

.ati-gift:before {
  content: "\\e92d";
}

.ati-github:before {
  content: "\\e94a";
}

.ati-globe:before {
  content: "\\e94d";
}

.ati-hammer:before {
  content: "\\e974";
}

.ati-hand-card:before {
  content: "\\e952";
}

.ati-hand-holding-money:before {
  content: "\\e946";
}

.ati-hand-shake:before {
  content: "\\e911";
}

.ati-help-circle:before {
  content: "\\e97e";
}

.ati-hierarchy:before {
  content: "\\e945";
}

.ati-home:before {
  content: "\\e938";
}

.ati-id-card:before {
  content: "\\e933";
}

.ati-info:before {
  content: "\\e983";
}

.ati-instagram:before {
  content: "\\e984";
}

.ati-inter:before {
  content: "\\e979";
}

.ati-invoice:before {
  content: "\\e900";
}

.ati-itau:before {
  content: "\\e97a";
}

.ati-key:before {
  content: "\\e913";
}

.ati-keyboard:before {
  content: "\\ea1a";
}

.ati-link:before {
  content: "\\e98a";
}

.ati-linkedin:before {
  content: "\\e944";
}

.ati-list:before {
  content: "\\e98d";
}

.ati-loader:before {
  content: "\\e934";
}

.ati-lock:before {
  content: "\\e98f";
}

.ati-lock-filled:before {
  content: "\\e963";
}

.ati-log-in:before {
  content: "\\e990";
}

.ati-magnifier:before {
  content: "\\e9cc";
}

.ati-mail-box:before {
  content: "\\e915";
}

.ati-map-pin:before {
  content: "\\e954";
}

.ati-market-pin:before {
  content: "\\e97d";
}

.ati-maximize:before {
  content: "\\e967";
}

.ati-megaphone:before {
  content: "\\e936";
}

.ati-message-circle:before {
  content: "\\e999";
}

.ati-mic:before {
  content: "\\e97f";
}

.ati-minus:before {
  content: "\\e99f";
}

.ati-minus-circle:before {
  content: "\\e9a0";
}

.ati-money:before {
  content: "\\e916";
}

.ati-money-filled:before {
  content: "\\e961";
}

.ati-money-notes:before {
  content: "\\e949";
}

.ati-monitor:before {
  content: "\\e9a2";
}

.ati-monitor-chart-up:before {
  content: "\\e924";
}

.ati-moon:before {
  content: "\\e94e";
}

.ati-nubank:before {
  content: "\\e97b";
}

.ati-open-finance:before {
  content: "\\e91c";
}

.ati-paperclip:before {
  content: "\\e9ad";
}

.ati-pencil:before {
  content: "\\e95c";
}

.ati-phone:before {
  content: "\\e9b2";
}

.ati-pix:before {
  content: "\\e922";
}

.ati-plus:before {
  content: "\\e9bc";
}

.ati-plus-circle:before {
  content: "\\e9bd";
}

.ati-power:before {
  content: "\\e9c0";
}

.ati-printer:before {
  content: "\\e9c1";
}

.ati-receipt:before {
  content: "\\e975";
}

.ati-refresh:before {
  content: "\\e9c3";
}

.ati-refresh-dollar:before {
  content: "\\e917";
}

.ati-repeat:before {
  content: "\\e929";
}

.ati-rotate:before {
  content: "\\e9c8";
}

.ati-rotate-dollar:before {
  content: "\\e918";
}

.ati-santander:before {
  content: "\\e97c";
}

.ati-send:before {
  content: "\\e9cd";
}

.ati-serasa:before {
  content: "\\e919";
}

.ati-share:before {
  content: "\\e941";
}

.ati-shield:before {
  content: "\\e91a";
}

.ati-shopping-bag:before {
  content: "\\e95a";
}

.ati-shopping-cart-down:before {
  content: "\\e925";
}

.ati-shopping-cart-right:before {
  content: "\\e969";
}

.ati-slash:before {
  content: "\\e9db";
}

.ati-sliders:before {
  content: "\\e9dc";
}

.ati-smartphone:before {
  content: "\\e9dd";
}

.ati-smartphone-contactless:before {
  content: "\\e972";
}

.ati-sort:before {
  content: "\\e935";
}

.ati-spanner:before {
  content: "\\e927";
}

.ati-split-arrows:before {
  content: "\\e93d";
}

.ati-square:before {
  content: "\\e9e0";
}

.ati-square-signs:before {
  content: "\\e91d";
}

.ati-star:before {
  content: "\\e940";
}

.ati-star-filled:before {
  content: "\\e964";
}

.ati-sun:before {
  content: "\\e950";
}

.ati-tag:before {
  content: "\\e9e7";
}

.ati-three-dots:before {
  content: "\\e9a5";
}

.ati-three-dots-horinzontal:before {
  content: "\\e93c";
}

.ati-thumbs-down:before {
  content: "\\e94c";
}

.ati-thumbs-up:before {
  content: "\\e94b";
}

.ati-ticket:before {
  content: "\\e956";
}

.ati-trash:before {
  content: "\\e9f1";
}

.ati-truck:before {
  content: "\\e9f6";
}

.ati-unlink:before {
  content: "\\e980";
}

.ati-unlock:before {
  content: "\\e955";
}

.ati-upload:before {
  content: "\\e9fe";
}

.ati-user:before {
  content: "\\ea00";
}

.ati-user-filled:before {
  content: "\\e95b";
}

.ati-user-plus:before {
  content: "\\ea03";
}

.ati-users:before {
  content: "\\ea05";
}

.ati-video:before {
  content: "\\e92a";
}

.ati-virtual-card:before {
  content: "\\e91f";
}

.ati-wallet:before {
  content: "\\e920";
}

.ati-whatsapp:before {
  content: "\\e928";
}

.ati-x:before {
  content: "\\ea11";
}

.ati-x-filled:before {
  content: "\\e962";
}

.ati-youtube:before {
  content: "\\e942";
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.color-white {
  color: #ffffff !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.color-primary {
  color: var(--atlas-primary) !important;
}

.bg-primary {
  background-color: var(--atlas-primary) !important;
}

.color-primary-100 {
  color: var(--atlas-primary-100) !important;
}

.bg-primary-100 {
  background-color: var(--atlas-primary-100) !important;
}

.color-primary-200 {
  color: var(--atlas-primary-200) !important;
}

.bg-primary-200 {
  background-color: var(--atlas-primary-200) !important;
}

.color-primary-300 {
  color: var(--atlas-primary-300) !important;
}

.bg-primary-300 {
  background-color: var(--atlas-primary-300) !important;
}

.color-primary-400 {
  color: var(--atlas-primary-400) !important;
}

.bg-primary-400 {
  background-color: var(--atlas-primary-400) !important;
}

.color-primary-500 {
  color: var(--atlas-primary-500) !important;
}

.bg-primary-500 {
  background-color: var(--atlas-primary-500) !important;
}

.color-primary-600 {
  color: var(--atlas-primary-600) !important;
}

.bg-primary-600 {
  background-color: var(--atlas-primary-600) !important;
}

.color-primary-700 {
  color: var(--atlas-primary-700) !important;
}

.bg-primary-700 {
  background-color: var(--atlas-primary-700) !important;
}

.color-primary-800 {
  color: var(--atlas-primary-800) !important;
}

.bg-primary-800 {
  background-color: var(--atlas-primary-800) !important;
}

.color-primary-900 {
  color: var(--atlas-primary-900) !important;
}

.bg-primary-900 {
  background-color: var(--atlas-primary-900) !important;
}

.active-primary[active], .active-primary.active, .active-primary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-secondary {
  color: var(--atlas-secondary) !important;
}

.bg-secondary {
  background-color: var(--atlas-secondary) !important;
}

.color-secondary-100 {
  color: var(--atlas-secondary-100) !important;
}

.bg-secondary-100 {
  background-color: var(--atlas-secondary-100) !important;
}

.color-secondary-200 {
  color: var(--atlas-secondary-200) !important;
}

.bg-secondary-200 {
  background-color: var(--atlas-secondary-200) !important;
}

.color-secondary-300 {
  color: var(--atlas-secondary-300) !important;
}

.bg-secondary-300 {
  background-color: var(--atlas-secondary-300) !important;
}

.color-secondary-400 {
  color: var(--atlas-secondary-400) !important;
}

.bg-secondary-400 {
  background-color: var(--atlas-secondary-400) !important;
}

.color-secondary-500 {
  color: var(--atlas-secondary-500) !important;
}

.bg-secondary-500 {
  background-color: var(--atlas-secondary-500) !important;
}

.color-secondary-600 {
  color: var(--atlas-secondary-600) !important;
}

.bg-secondary-600 {
  background-color: var(--atlas-secondary-600) !important;
}

.color-secondary-700 {
  color: var(--atlas-secondary-700) !important;
}

.bg-secondary-700 {
  background-color: var(--atlas-secondary-700) !important;
}

.color-secondary-800 {
  color: var(--atlas-secondary-800) !important;
}

.bg-secondary-800 {
  background-color: var(--atlas-secondary-800) !important;
}

.color-secondary-900 {
  color: var(--atlas-secondary-900) !important;
}

.bg-secondary-900 {
  background-color: var(--atlas-secondary-900) !important;
}

.active-secondary[active], .active-secondary.active, .active-secondary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-success {
  color: var(--atlas-success) !important;
}

.bg-success {
  background-color: var(--atlas-success) !important;
}

.color-success-100 {
  color: var(--atlas-success-100) !important;
}

.bg-success-100 {
  background-color: var(--atlas-success-100) !important;
}

.color-success-200 {
  color: var(--atlas-success-200) !important;
}

.bg-success-200 {
  background-color: var(--atlas-success-200) !important;
}

.color-success-300 {
  color: var(--atlas-success-300) !important;
}

.bg-success-300 {
  background-color: var(--atlas-success-300) !important;
}

.color-success-400 {
  color: var(--atlas-success-400) !important;
}

.bg-success-400 {
  background-color: var(--atlas-success-400) !important;
}

.color-success-500 {
  color: var(--atlas-success-500) !important;
}

.bg-success-500 {
  background-color: var(--atlas-success-500) !important;
}

.color-success-600 {
  color: var(--atlas-success-600) !important;
}

.bg-success-600 {
  background-color: var(--atlas-success-600) !important;
}

.color-success-700 {
  color: var(--atlas-success-700) !important;
}

.bg-success-700 {
  background-color: var(--atlas-success-700) !important;
}

.color-success-800 {
  color: var(--atlas-success-800) !important;
}

.bg-success-800 {
  background-color: var(--atlas-success-800) !important;
}

.color-success-900 {
  color: var(--atlas-success-900) !important;
}

.bg-success-900 {
  background-color: var(--atlas-success-900) !important;
}

.active-success[active], .active-success.active, .active-success:active {
  background-color: var(--atlas-success) !important;
  color: var(--atlas-contrast-success) !important;
}

.color-warning {
  color: var(--atlas-warning) !important;
}

.bg-warning {
  background-color: var(--atlas-warning) !important;
}

.color-warning-100 {
  color: var(--atlas-warning-100) !important;
}

.bg-warning-100 {
  background-color: var(--atlas-warning-100) !important;
}

.color-warning-200 {
  color: var(--atlas-warning-200) !important;
}

.bg-warning-200 {
  background-color: var(--atlas-warning-200) !important;
}

.color-warning-300 {
  color: var(--atlas-warning-300) !important;
}

.bg-warning-300 {
  background-color: var(--atlas-warning-300) !important;
}

.color-warning-400 {
  color: var(--atlas-warning-400) !important;
}

.bg-warning-400 {
  background-color: var(--atlas-warning-400) !important;
}

.color-warning-500 {
  color: var(--atlas-warning-500) !important;
}

.bg-warning-500 {
  background-color: var(--atlas-warning-500) !important;
}

.color-warning-600 {
  color: var(--atlas-warning-600) !important;
}

.bg-warning-600 {
  background-color: var(--atlas-warning-600) !important;
}

.color-warning-700 {
  color: var(--atlas-warning-700) !important;
}

.bg-warning-700 {
  background-color: var(--atlas-warning-700) !important;
}

.color-warning-800 {
  color: var(--atlas-warning-800) !important;
}

.bg-warning-800 {
  background-color: var(--atlas-warning-800) !important;
}

.color-warning-900 {
  color: var(--atlas-warning-900) !important;
}

.bg-warning-900 {
  background-color: var(--atlas-warning-900) !important;
}

.active-warning[active], .active-warning.active, .active-warning:active {
  background-color: var(--atlas-warning) !important;
  color: var(--atlas-contrast-warning) !important;
}

.color-danger {
  color: var(--atlas-danger) !important;
}

.bg-danger {
  background-color: var(--atlas-danger) !important;
}

.color-danger-100 {
  color: var(--atlas-danger-100) !important;
}

.bg-danger-100 {
  background-color: var(--atlas-danger-100) !important;
}

.color-danger-200 {
  color: var(--atlas-danger-200) !important;
}

.bg-danger-200 {
  background-color: var(--atlas-danger-200) !important;
}

.color-danger-300 {
  color: var(--atlas-danger-300) !important;
}

.bg-danger-300 {
  background-color: var(--atlas-danger-300) !important;
}

.color-danger-400 {
  color: var(--atlas-danger-400) !important;
}

.bg-danger-400 {
  background-color: var(--atlas-danger-400) !important;
}

.color-danger-500 {
  color: var(--atlas-danger-500) !important;
}

.bg-danger-500 {
  background-color: var(--atlas-danger-500) !important;
}

.color-danger-600 {
  color: var(--atlas-danger-600) !important;
}

.bg-danger-600 {
  background-color: var(--atlas-danger-600) !important;
}

.color-danger-700 {
  color: var(--atlas-danger-700) !important;
}

.bg-danger-700 {
  background-color: var(--atlas-danger-700) !important;
}

.color-danger-800 {
  color: var(--atlas-danger-800) !important;
}

.bg-danger-800 {
  background-color: var(--atlas-danger-800) !important;
}

.color-danger-900 {
  color: var(--atlas-danger-900) !important;
}

.bg-danger-900 {
  background-color: var(--atlas-danger-900) !important;
}

.active-danger[active], .active-danger.active, .active-danger:active {
  background-color: var(--atlas-danger) !important;
  color: var(--atlas-contrast-danger) !important;
}

.color-highlight {
  color: var(--atlas-highlight) !important;
}

.bg-highlight {
  background-color: var(--atlas-highlight) !important;
}

.color-highlight-100 {
  color: var(--atlas-highlight-100) !important;
}

.bg-highlight-100 {
  background-color: var(--atlas-highlight-100) !important;
}

.color-highlight-200 {
  color: var(--atlas-highlight-200) !important;
}

.bg-highlight-200 {
  background-color: var(--atlas-highlight-200) !important;
}

.color-highlight-300 {
  color: var(--atlas-highlight-300) !important;
}

.bg-highlight-300 {
  background-color: var(--atlas-highlight-300) !important;
}

.color-highlight-400 {
  color: var(--atlas-highlight-400) !important;
}

.bg-highlight-400 {
  background-color: var(--atlas-highlight-400) !important;
}

.color-highlight-500 {
  color: var(--atlas-highlight-500) !important;
}

.bg-highlight-500 {
  background-color: var(--atlas-highlight-500) !important;
}

.color-highlight-600 {
  color: var(--atlas-highlight-600) !important;
}

.bg-highlight-600 {
  background-color: var(--atlas-highlight-600) !important;
}

.color-highlight-700 {
  color: var(--atlas-highlight-700) !important;
}

.bg-highlight-700 {
  background-color: var(--atlas-highlight-700) !important;
}

.color-highlight-800 {
  color: var(--atlas-highlight-800) !important;
}

.bg-highlight-800 {
  background-color: var(--atlas-highlight-800) !important;
}

.color-highlight-900 {
  color: var(--atlas-highlight-900) !important;
}

.bg-highlight-900 {
  background-color: var(--atlas-highlight-900) !important;
}

.active-highlight[active], .active-highlight.active, .active-highlight:active {
  background-color: var(--atlas-highlight) !important;
  color: var(--atlas-contrast-highlight) !important;
}

.color-info {
  color: var(--atlas-info) !important;
}

.bg-info {
  background-color: var(--atlas-info) !important;
}

.color-info-100 {
  color: var(--atlas-info-100) !important;
}

.bg-info-100 {
  background-color: var(--atlas-info-100) !important;
}

.color-info-200 {
  color: var(--atlas-info-200) !important;
}

.bg-info-200 {
  background-color: var(--atlas-info-200) !important;
}

.color-info-300 {
  color: var(--atlas-info-300) !important;
}

.bg-info-300 {
  background-color: var(--atlas-info-300) !important;
}

.color-info-400 {
  color: var(--atlas-info-400) !important;
}

.bg-info-400 {
  background-color: var(--atlas-info-400) !important;
}

.color-info-500 {
  color: var(--atlas-info-500) !important;
}

.bg-info-500 {
  background-color: var(--atlas-info-500) !important;
}

.color-info-600 {
  color: var(--atlas-info-600) !important;
}

.bg-info-600 {
  background-color: var(--atlas-info-600) !important;
}

.color-info-700 {
  color: var(--atlas-info-700) !important;
}

.bg-info-700 {
  background-color: var(--atlas-info-700) !important;
}

.color-info-800 {
  color: var(--atlas-info-800) !important;
}

.bg-info-800 {
  background-color: var(--atlas-info-800) !important;
}

.color-info-900 {
  color: var(--atlas-info-900) !important;
}

.bg-info-900 {
  background-color: var(--atlas-info-900) !important;
}

.active-info[active], .active-info.active, .active-info:active {
  background-color: var(--atlas-info) !important;
  color: var(--atlas-contrast-info) !important;
}

/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: inline-flex;
}

:host([data-atlas-popover]) {
  cursor: pointer;
}

.atlas-icon {
  line-height: normal;
  animation: none;
}
.atlas-icon.disabled {
  opacity: 0.35;
}

.ati-loader {
  animation: spin 4s linear infinite;
}

.atlas-icon.ati-1x {
  font-size: 8px;
  width: 8px;
  height: 8px;
}

.atlas-icon.ati-2x {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.atlas-icon.ati-3x {
  font-size: 24px;
  width: 24px;
  height: 24px;
}

.atlas-icon.ati-4x {
  font-size: 32px;
  width: 32px;
  height: 32px;
}

.atlas-icon.ati-5x {
  font-size: 40px;
  width: 40px;
  height: 40px;
}

.atlas-icon.ati-6x {
  font-size: 48px;
  width: 48px;
  height: 48px;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}`;

// src/components/display/atlas-icon/atlas-icon.ts
var AtlasIcon = /*#__PURE__*/(() => {
  let AtlasIcon = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.size = "3x";
      this.disabled = false;
      this.tooltipPlacement = "bottom";
      this.tooltipTrigger = "hover focus";
    }
    getThemeClass() {
      if (this.white) {
        return "color-white";
      }
      if (this.theme) {
        if (this.themeVariation) {
          return `color-${this.theme}-${this.themeVariation}`;
        }
        return `color-${this.theme}`;
      }
      return "";
    }
    renderTooltip() {
      return when4(!!this.tooltip, () => html9`
                <atlas-tooltip id="icon-tooltip" placement=${this.tooltipPlacement} trigger=${this.tooltipTrigger}>
                    ${this.tooltip}
                </atlas-tooltip>
            `);
    }
    renderElement() {
      const themeClass = this.getThemeClass();
      const iconClass = {
        "atlas-icon": true,
        [`ati-${this.name}`]: true,
        [`ati-${this.size}`]: true,
        [themeClass]: !!themeClass,
        "disabled": this.disabled
      };
      return html9`
            <i
                class="${classMap3(iconClass)}"
                aria-hidden="true"
                data-atlas-tooltip=${ifDefined(this.tooltip ? "icon-tooltip" : void 0)}
                data-chromatic=${ifDefined(this.name === "loader" ? "ignore" : void 0)}
            ></i>
            ${this.renderTooltip()}
        `;
    }
    renderSkeleton() {
      return html9` <div class="skeleton atlas-icon ati-${this.size}"></div> `;
    }
  };
  AtlasIcon.styles = atlas_icon_default;
  return AtlasIcon;
})();
__decorateClass([property10({
  type: String
})], AtlasIcon.prototype, "name", 2);
__decorateClass([property10({
  type: String
})], AtlasIcon.prototype, "theme", 2);
__decorateClass([property10({
  type: Number,
  attribute: "theme-variation"
})], AtlasIcon.prototype, "themeVariation", 2);
__decorateClass([property10({
  type: Boolean
})], AtlasIcon.prototype, "white", 2);
__decorateClass([property10({
  type: String
})], AtlasIcon.prototype, "size", 2);
__decorateClass([property10({
  type: Boolean
})], AtlasIcon.prototype, "disabled", 2);
__decorateClass([property10({
  type: String
})], AtlasIcon.prototype, "tooltip", 2);
__decorateClass([property10({
  type: String,
  attribute: "tooltip-placement"
})], AtlasIcon.prototype, "tooltipPlacement", 2);
__decorateClass([property10({
  type: String,
  attribute: "tooltip-trigger"
})], AtlasIcon.prototype, "tooltipTrigger", 2);
AtlasIcon = __decorateClass([customElement7("atlas-icon")], AtlasIcon);

// src/components/display/atlas-popover/atlas-popover.ts
var AtlasPopover = /*#__PURE__*/(() => {
  let AtlasPopover = class extends OverlayElement {
    constructor() {
      super("click", "top");
      this.autoCloseTrigger = "outside";
      this.inMenuContext = false;
      this.hasImage = false;
      this.hasButtonLink = false;
      this._deviceController = new DeviceController(this);
      this._floatingUiController.getCustomMiddlewares = this.getFloatingCustomMiddlewares.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
    }
    getFloatingElement() {
      return this._popover || this;
    }
    getFloatingCustomMiddlewares() {
      const middlewares = [];
      if (this.inMenuContext) middlewares.push(offset2({
        mainAxis: -8
      }));
      middlewares.push(arrow2({
        element: this.shadowRoot.querySelector(".popover-arrow")
      }));
      return middlewares;
    }
    onOpenOverlay() {
      return __async(this, null, function* () {
        yield __superGet(AtlasPopover.prototype, this, "onOpenOverlay").call(this);
        document.addEventListener("click", this.onDocumentClick);
        this._triggerController.triggerElement.setAttribute("active", "");
        this._triggerController.triggerElement.setAttribute("aria-expanded", "true");
      });
    }
    onCloseOverlay() {
      return __async(this, null, function* () {
        yield __superGet(AtlasPopover.prototype, this, "onCloseOverlay").call(this);
        document.removeEventListener("click", this.onDocumentClick);
        this._triggerController.triggerElement.removeAttribute("active");
        this._triggerController.triggerElement.setAttribute("aria-expanded", "false");
      });
    }
    onDocumentClick(event) {
      if (this.disableAutoClose || !this.open) {
        return;
      }
      const composedPath = event.composedPath();
      const isToggleTarget = composedPath.includes(this._triggerController.triggerElement);
      const isMenuTarget = composedPath.includes(this._popover);
      if (isToggleTarget || this.autoCloseTrigger === "inside" && !isMenuTarget || this.autoCloseTrigger === "outside" && isMenuTarget) {
        return;
      }
      this.hide();
    }
    renderImage() {
      this.hasImage = true;
    }
    renderButtonLink() {
      this.hasButtonLink = true;
    }
    renderCloseButton() {
      return when5(!this.inMenuContext, () => html10`
                <atlas-icon-button icon="x" size="2x" theme="secondary" @atlas-icon-button-click=${this.hide}>
                </atlas-icon-button>
            `);
    }
    render() {
      const maxHeight = this.maxHeight > 180 ? `${this.maxHeight}px` : "none";
      const width = this.width > 0 ? `${this.width}px` : "max-content";
      const popoverClasses = {
        "popover": true,
        "popover-auto": true,
        "has-image": this.hasImage,
        "has-button-link": this.hasButtonLink,
        "mobile-popover": this._deviceController.isMobile,
        "fade": true,
        "show": this.open,
        "in-menu-context": this.inMenuContext
      };
      const bodyClasses = {
        "popover-body": true,
        "has-title": !!this.header
      };
      const backdropClass = {
        "atlas-popover-backdrop": true,
        "show": this.open && this._deviceController.isMobile
      };
      return html10`
            <div class="${classMap4(popoverClasses)}" style="max-height: ${maxHeight}; width: ${width}">
                <div class="popover-arrow"></div>
                ${this.renderCloseButton()}
                <div class="popover-content">
                    <div class="popover-header" ?hidden=${!this.header}>${this.header}</div>
                    <div class="popover-image">
                        <slot name="image" @slotchange="${this.renderImage}"></slot>
                    </div>
                    <div class="${classMap4(bodyClasses)}">
                        <slot></slot>

                        <div class="popover-button-link">
                            <slot name="button-link" @slotchange="${this.renderButtonLink}"></slot>
                        </div>
                    </div>
                </div>
            </div>
            <div class="${classMap4(backdropClass)}"></div>
        `;
    }
  };
  AtlasPopover.styles = atlas_popover_default;
  return AtlasPopover;
})();
__decorateClass([property11({
  type: String
})], AtlasPopover.prototype, "header", 2);
__decorateClass([property11({
  type: Number
})], AtlasPopover.prototype, "width", 2);
__decorateClass([property11({
  type: Number,
  attribute: "max-height"
})], AtlasPopover.prototype, "maxHeight", 2);
__decorateClass([property11({
  type: String,
  attribute: "auto-close-trigger"
})], AtlasPopover.prototype, "autoCloseTrigger", 2);
__decorateClass([property11({
  type: Boolean,
  attribute: "disable-auto-close"
})], AtlasPopover.prototype, "disableAutoClose", 2);
__decorateClass([property11({
  type: Boolean,
  attribute: "in-menu-context"
})], AtlasPopover.prototype, "inMenuContext", 2);
__decorateClass([state()], AtlasPopover.prototype, "hasImage", 2);
__decorateClass([state()], AtlasPopover.prototype, "hasButtonLink", 2);
__decorateClass([query3(".popover")], AtlasPopover.prototype, "_popover", 2);
AtlasPopover = __decorateClass([customElement8("atlas-popover")], AtlasPopover);

// src/internals/mixins/with-popover-mixin.ts
var WithPopoverMixin = superClass => {
  class WithPopoverClass extends superClass {
    constructor() {
      super(...arguments);
      this._hasSlottedPopover = false;
    }
    renderPopover(id) {
      return when6(!!this.popoverContent, () => this.renderPopoverText(id), () => this.renderPopoverSlot(id));
    }
    renderPopoverInfoIcon(size2 = "2x") {
      return html11`
                <atlas-icon-button
                    icon="info"
                    theme="primary"
                    size="${size2}"
                    popover-title=${this.popoverTitle}
                    popover-content=${this.popoverContent}
                >
                    ${this.renderNamedPopoverSlot()}
                </atlas-icon-button>
            `;
    }
    renderNamedPopoverSlot() {
      return html11` <slot name="popover" slot="popover"></slot> `;
    }
    hasPopover() {
      if (this.popoverContent || this._hasSlottedPopover) return true;
      const iconButton = this.shadowRoot.querySelector("atlas-icon-button");
      if (!iconButton) return false;
      return iconButton.hasPopover();
    }
    onPopoverContentChange() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        if (!this.popoverContent) return;
        const popoverElement = this.shadowRoot.querySelector("atlas-popover");
        this.syncPopoverTriggerElement(popoverElement);
      });
    }
    renderPopoverText(id) {
      return html11`
                <atlas-popover id=${id} header=${this.popoverTitle}> ${unsafeHTML(this.popoverContent)} </atlas-popover>
            `;
    }
    renderPopoverSlot(id) {
      const slotStyle = {
        display: this._hasSlottedPopover ? "contents" : "none"
      };
      return html11`
                <slot
                    name="popover"
                    style=${styleMap(slotStyle)}
                    @slotchange=${() => this.onPopoverSlotChange(id)}
                ></slot>
            `;
    }
    onPopoverSlotChange(id) {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const slot = this.shadowRoot.querySelector("slot[name=popover]");
        if (!slot) return;
        const assignedElements = slot.assignedElements({
          flatten: true
        });
        const popoverElement = assignedElements.find(({
          tagName
        }) => tagName === "ATLAS-POPOVER");
        this.syncPopoverTriggerElement(popoverElement);
        this._hasSlottedPopover = !!popoverElement;
        if (!this._hasSlottedPopover) return;
        popoverElement.setAttribute("id", id);
      });
    }
    syncPopoverTriggerElement(popoverElement) {
      const triggerElement = this.shadowRoot.querySelector("[data-atlas-popover]");
      if (!triggerElement) return;
      if (!popoverElement) {
        this.style.display = "none";
        return;
      }
      this.style.display = "";
      popoverElement.syncTriggerElement(triggerElement);
    }
  }
  __decorateClass([property12({
    type: String,
    attribute: "popover-title"
  })], WithPopoverClass.prototype, "popoverTitle", 2);
  __decorateClass([property12({
    type: String,
    attribute: "popover-content"
  })], WithPopoverClass.prototype, "popoverContent", 2);
  __decorateClass([state2()], WithPopoverClass.prototype, "_hasSlottedPopover", 2);
  __decorateClass([Watch("popoverContent", true)], WithPopoverClass.prototype, "onPopoverContentChange", 1);
  return WithPopoverClass;
};

// src/components/display/atlas-icon-button/atlas-icon-button.scss
import { css as css11 } from "lit-element/lit-element.js";
var atlas_icon_button_default = css11`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: inline-flex;
  position: relative;
  line-height: 1;
  height: fit-content;
}

.btn-wrapper {
  display: inline-flex;
  position: relative;
}

.icon-button {
  cursor: pointer;
  text-decoration: none;
  background: transparent;
  border: none;
  padding: 0;
  color: #687078;
  position: relative;
  display: inline-flex;
  border-radius: 50%;
  transition: background 0.25s ease, color 0.25s ease, box-shadow 0.25s ease;
}
.icon-button atlas-badge {
  position: absolute;
  top: -4px;
  right: -4px;
}
.icon-button.hoverable {
  padding: var(--atlas-icon-button-hoverable-padding, 8px);
}
.icon-button.hoverable .badge {
  top: 2px;
  right: 4px;
}
.icon-button.hoverable:hover {
  background: #dee2e6;
}
.icon-button:focus, .icon-button.active, .icon-button:active {
  color: var(--atlas-primary) !important;
  background: var(--atlas-primary-100) !important;
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-500-rgb), 0.25);
}
.icon-button[disabled], .icon-button.disabled {
  pointer-events: none;
}

slot[name=hotspot]::slotted(atlas-hotspot) {
  position: absolute;
  top: -20px;
  right: -20px;
}

.icon-button.theme-primary:not(.theme-on-interactions) {
  color: var(--atlas-primary);
}
.icon-button.theme-primary:hover {
  color: var(--atlas-primary);
  background: rgba(var(--atlas-primary-rgb), 10%);
}
.icon-button.theme-primary:focus, .icon-button.theme-primary.active, .icon-button.theme-primary:active {
  color: var(--atlas-primary) !important;
  background: rgba(var(--atlas-primary-rgb), 10%) !important;
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-500-rgb), 0.25);
}

.icon-button.theme-secondary:not(.theme-on-interactions) {
  color: var(--atlas-secondary);
}
.icon-button.theme-secondary:hover {
  color: var(--atlas-secondary);
  background: rgba(var(--atlas-secondary-rgb), 10%);
}
.icon-button.theme-secondary:focus, .icon-button.theme-secondary.active, .icon-button.theme-secondary:active {
  color: var(--atlas-secondary) !important;
  background: rgba(var(--atlas-secondary-rgb), 10%) !important;
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-secondary-500-rgb), 0.25);
}

.icon-button.theme-success:not(.theme-on-interactions) {
  color: var(--atlas-success);
}
.icon-button.theme-success:hover {
  color: var(--atlas-success);
  background: rgba(var(--atlas-success-rgb), 10%);
}
.icon-button.theme-success:focus, .icon-button.theme-success.active, .icon-button.theme-success:active {
  color: var(--atlas-success) !important;
  background: rgba(var(--atlas-success-rgb), 10%) !important;
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
}

.icon-button.theme-warning:not(.theme-on-interactions) {
  color: var(--atlas-warning);
}
.icon-button.theme-warning:hover {
  color: var(--atlas-warning);
  background: rgba(var(--atlas-warning-rgb), 10%);
}
.icon-button.theme-warning:focus, .icon-button.theme-warning.active, .icon-button.theme-warning:active {
  color: var(--atlas-warning) !important;
  background: rgba(var(--atlas-warning-rgb), 10%) !important;
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
}

.icon-button.theme-danger:not(.theme-on-interactions) {
  color: var(--atlas-danger);
}
.icon-button.theme-danger:hover {
  color: var(--atlas-danger);
  background: rgba(var(--atlas-danger-rgb), 10%);
}
.icon-button.theme-danger:focus, .icon-button.theme-danger.active, .icon-button.theme-danger:active {
  color: var(--atlas-danger) !important;
  background: rgba(var(--atlas-danger-rgb), 10%) !important;
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
}

.icon-button.theme-highlight:not(.theme-on-interactions) {
  color: var(--atlas-highlight);
}
.icon-button.theme-highlight:hover {
  color: var(--atlas-highlight);
  background: rgba(var(--atlas-highlight-rgb), 10%);
}
.icon-button.theme-highlight:focus, .icon-button.theme-highlight.active, .icon-button.theme-highlight:active {
  color: var(--atlas-highlight) !important;
  background: rgba(var(--atlas-highlight-rgb), 10%) !important;
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-highlight-500-rgb), 0.25);
}

.icon-button.theme-info:not(.theme-on-interactions) {
  color: var(--atlas-info);
}
.icon-button.theme-info:hover {
  color: var(--atlas-info);
  background: rgba(var(--atlas-info-rgb), 10%);
}
.icon-button.theme-info:focus, .icon-button.theme-info.active, .icon-button.theme-info:active {
  color: var(--atlas-info) !important;
  background: rgba(var(--atlas-info-rgb), 10%) !important;
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-info-500-rgb), 0.25);
}`;

// src/components/display/atlas-badge/atlas-badge.ts
import { html as html14, literal } from "lit/static-html.js";
import { customElement as customElement10, property as property15 } from "lit/decorators.js";
import { classMap as classMap6 } from "lit/directives/class-map.js";
import { ifDefined as ifDefined2 } from "lit/directives/if-defined.js";
import { when as when8 } from "lit/directives/when.js";

// src/components/display/atlas-badge/atlas-badge.scss
import { css as css12 } from "lit-element/lit-element.js";
var atlas_badge_default = css12`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: inline-flex;
}

.badge {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 1rem;
  height: 1rem;
  border: 0;
  border-radius: 9999px;
  box-shadow: 0 0 0 1px var(--atlas-badge-border-color);
  background-color: var(--atlas-badge-bg);
  gap: 0.25rem;
  transition: box-shadow 0.25s ease;
}
.badge.with-tooltip:focus-visible {
  outline: none;
  box-shadow: 0 0 0 1px var(--atlas-badge-border-color), var(--atlas-badge-focus-box-shadow);
}
.badge.with-tooltip:hover {
  cursor: pointer;
}
.badge.with-content {
  width: auto;
  height: 1.5rem;
  padding: 0.25rem 0.5rem;
}
.badge.with-content.in-table-col {
  height: auto;
  min-height: 1.5rem;
}
.badge.small {
  width: 0.5rem;
  height: 0.5rem;
  padding: 0;
}
.badge.small .content {
  display: none;
}
.badge.counter {
  width: 1rem;
  height: 1rem;
  padding: 0;
  position: relative;
  justify-content: center;
}
.badge.skeleton {
  background-color: var(--atlas-secondary-100);
}

.badge-filled-primary {
  --atlas-badge-bg: var(--atlas-primary);
  --atlas-badge-border-color: #ffffff;
  --atlas-badge-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-rgb), 0.25);
}

.badge-outlined-primary {
  --atlas-badge-bg: transparent;
  --atlas-badge-border-color: var(--atlas-primary);
  --atlas-badge-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-rgb), 0.25);
}

.badge-filled-secondary {
  --atlas-badge-bg: var(--atlas-secondary);
  --atlas-badge-border-color: #ffffff;
  --atlas-badge-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-secondary-rgb), 0.25);
}

.badge-outlined-secondary {
  --atlas-badge-bg: transparent;
  --atlas-badge-border-color: var(--atlas-secondary);
  --atlas-badge-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-secondary-rgb), 0.25);
}

.badge-filled-success {
  --atlas-badge-bg: var(--atlas-success);
  --atlas-badge-border-color: #ffffff;
  --atlas-badge-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-rgb), 0.25);
}

.badge-outlined-success {
  --atlas-badge-bg: transparent;
  --atlas-badge-border-color: var(--atlas-success);
  --atlas-badge-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-rgb), 0.25);
}

.badge-filled-warning {
  --atlas-badge-bg: var(--atlas-warning);
  --atlas-badge-border-color: #ffffff;
  --atlas-badge-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-rgb), 0.25);
}

.badge-outlined-warning {
  --atlas-badge-bg: transparent;
  --atlas-badge-border-color: var(--atlas-warning);
  --atlas-badge-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-rgb), 0.25);
}

.badge-filled-danger {
  --atlas-badge-bg: var(--atlas-danger);
  --atlas-badge-border-color: #ffffff;
  --atlas-badge-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-rgb), 0.25);
}

.badge-outlined-danger {
  --atlas-badge-bg: transparent;
  --atlas-badge-border-color: var(--atlas-danger);
  --atlas-badge-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-rgb), 0.25);
}

.badge-filled-highlight {
  --atlas-badge-bg: var(--atlas-highlight);
  --atlas-badge-border-color: #ffffff;
  --atlas-badge-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-highlight-rgb), 0.25);
}

.badge-outlined-highlight {
  --atlas-badge-bg: transparent;
  --atlas-badge-border-color: var(--atlas-highlight);
  --atlas-badge-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-highlight-rgb), 0.25);
}

.badge-filled-info {
  --atlas-badge-bg: var(--atlas-info);
  --atlas-badge-border-color: #ffffff;
  --atlas-badge-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-info-rgb), 0.25);
}

.badge-outlined-info {
  --atlas-badge-bg: transparent;
  --atlas-badge-border-color: var(--atlas-info);
  --atlas-badge-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-info-rgb), 0.25);
}`;

// src/components/display/atlas-caption/atlas-caption.ts
import { html as html13 } from "lit";
import { customElement as customElement9, property as property14 } from "lit/decorators.js";
import { classMap as classMap5 } from "lit/directives/class-map.js";
import { styleMap as styleMap2 } from "lit/directives/style-map.js";

// src/components/display/text-element.ts
import { html as html12 } from "lit";
import { property as property13, query as query4, state as state3 } from "lit/decorators.js";
import { when as when7 } from "lit/directives/when.js";

// src/internals/elements.ts
var filterEmptyNodes = function (nodes) {
  return nodes.filter(node => {
    if (node.nodeName === "#text") {
      return node.textContent.trim() !== "";
    }
    return true;
  });
};
var filterElementsByTagNames = function (elements, tagNames) {
  const tagNamesSet = new Set(tagNames);
  return elements.filter(({
    tagName
  }) => tagNamesSet.has(tagName));
};
var findElementByTagName = function (elements, tagName) {
  return elements.find(element => element.tagName === tagName);
};

// src/internals/slot.ts
var isEmptySlot = (host, slotName) => {
  const query24 = slotName ? `slot[name=${slotName}]` : "slot:not([name])";
  const slotElement = host.shadowRoot.querySelector(query24);
  if (!slotElement) return true;
  const filteredNodes = filterEmptyNodes(slotElement.assignedNodes({
    flatten: true
  }));
  return filteredNodes.length === 0;
};
function getSlotTextContent(slot, includeTextFromElements) {
  const nodes = slot.assignedNodes({
    flatten: true
  });
  let text = "";
  [...nodes].forEach(node => {
    if (node.nodeType === Node.TEXT_NODE) {
      text += node.textContent;
    } else if (includeTextFromElements && node.nodeType === Node.ELEMENT_NODE) {
      text += node.textContent;
    }
  });
  return text;
}
function getSlotInnerHTML(slot) {
  const nodes = slot.assignedNodes({
    flatten: true
  });
  let html150 = "";
  [...nodes].forEach(node => {
    if (node.nodeType === Node.TEXT_NODE) {
      html150 += node.textContent;
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      html150 += node.outerHTML;
    }
  });
  return html150;
}

// src/components/display/text-element.ts
var TextElement = class extends AtlasElement {
  constructor() {
    super(...arguments);
    this.showLineClampTooltip = false;
    this._tooltipText = "";
  }
  /** @internal */
  connectedCallback() {
    var _a;
    (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
    this.observeTextResize();
  }
  /** @internal */
  disconnectedCallback() {
    var _a, _b;
    (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
    (_b = this._resizeObserver) == null ? void 0 : _b.disconnect();
  }
  /** @internal */
  getTextWrapper() {
    return this._textWrapperReference;
  }
  observeTextResize() {
    return __async(this, null, function* () {
      var _a;
      (_a = this._resizeObserver) == null ? void 0 : _a.disconnect();
      yield this.updateComplete;
      if (!this._textWrapperReference) return;
      this._resizeObserver = new ResizeObserver(() => {
        this.onTextResize();
      });
      this._resizeObserver.observe(this._textWrapperReference);
    });
  }
  getTextClasses() {
    const themeClass = this.getThemeClass();
    return {
      "text-wrapper": true,
      "text-muted": this.muted,
      "text-white": this.white,
      "ellipsis": this.ellipsis,
      "line-clamp": !!this.lineClamp,
      [`text-align-${this.alignment}`]: !!this.alignment,
      [themeClass]: !!themeClass
    };
  }
  getTextStyles() {
    return {
      "-webkit-line-clamp": this.lineClamp
    };
  }
  onTextResize() {
    return __async(this, null, function* () {
      yield this.updateComplete;
      this._tooltipText = "";
      const shouldShowTooltip = this.ellipsis || this.lineClamp >= 1 && this.showLineClampTooltip;
      if (!shouldShowTooltip || this.skeletonLoading || isEmptySlot(this)) return;
      if (this.lineClamp && this.showLineClampTooltip) {
        const contentWrapper2 = this._textWrapperReference;
        const compensationHeightValue = 2;
        const contentHeight = contentWrapper2.getBoundingClientRect().height;
        if (Math.round(contentHeight) + compensationHeightValue < contentWrapper2.scrollHeight) {
          this._tooltipText = getSlotTextContent(this.shadowRoot.querySelector("slot:not([name])"), true);
        }
        return;
      }
      const contentWrapper = this._textWrapperReference;
      const contentWidth = contentWrapper.getBoundingClientRect().width;
      if (Math.ceil(contentWidth) < contentWrapper.scrollWidth) {
        this._tooltipText = getSlotTextContent(this.shadowRoot.querySelector("slot:not([name])"), true);
      }
    });
  }
  renderEllipsisTooltip() {
    return when7(!!this._tooltipText && !this.hideEllipsisTooltip, () => html12`<atlas-tooltip id="text-tooltip" placement="bottom">${this._tooltipText}</atlas-tooltip>`);
  }
  renderContentSlot() {
    return html12`<slot></slot>`;
  }
  getThemeClass() {
    if (this.theme) {
      if (this.themeVariation) {
        return `color-${this.theme}-${this.themeVariation}`;
      }
      return `color-${this.theme}`;
    }
    return "";
  }
};
__decorateClass([property13({
  type: String
})], TextElement.prototype, "theme", 2);
__decorateClass([property13({
  type: Number,
  attribute: "theme-variation"
})], TextElement.prototype, "themeVariation", 2);
__decorateClass([property13({
  type: Boolean
})], TextElement.prototype, "muted", 2);
__decorateClass([property13({
  type: Boolean
})], TextElement.prototype, "white", 2);
__decorateClass([property13({
  type: Boolean
})], TextElement.prototype, "ellipsis", 2);
__decorateClass([property13({
  type: Number,
  attribute: "line-clamp"
})], TextElement.prototype, "lineClamp", 2);
__decorateClass([property13({
  type: String,
  reflect: true
})], TextElement.prototype, "alignment", 2);
__decorateClass([property13({
  type: Boolean,
  attribute: "hide-ellipsis-tooltip"
})], TextElement.prototype, "hideEllipsisTooltip", 2);
__decorateClass([property13({
  type: Boolean,
  attribute: "show-line-clamp-tooltip"
})], TextElement.prototype, "showLineClampTooltip", 2);
__decorateClass([state3()], TextElement.prototype, "_tooltipText", 2);
__decorateClass([query4(".text-wrapper")], TextElement.prototype, "_textWrapperReference", 2);
__decorateClass([Watch("skeletonLoading", true)], TextElement.prototype, "observeTextResize", 1);

// src/components/display/atlas-caption/atlas-caption.scss
import { css as css13 } from "lit-element/lit-element.js";
var atlas_caption_default = css13`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.color-white {
  color: #ffffff !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.color-primary {
  color: var(--atlas-primary) !important;
}

.bg-primary {
  background-color: var(--atlas-primary) !important;
}

.color-primary-100 {
  color: var(--atlas-primary-100) !important;
}

.bg-primary-100 {
  background-color: var(--atlas-primary-100) !important;
}

.color-primary-200 {
  color: var(--atlas-primary-200) !important;
}

.bg-primary-200 {
  background-color: var(--atlas-primary-200) !important;
}

.color-primary-300 {
  color: var(--atlas-primary-300) !important;
}

.bg-primary-300 {
  background-color: var(--atlas-primary-300) !important;
}

.color-primary-400 {
  color: var(--atlas-primary-400) !important;
}

.bg-primary-400 {
  background-color: var(--atlas-primary-400) !important;
}

.color-primary-500 {
  color: var(--atlas-primary-500) !important;
}

.bg-primary-500 {
  background-color: var(--atlas-primary-500) !important;
}

.color-primary-600 {
  color: var(--atlas-primary-600) !important;
}

.bg-primary-600 {
  background-color: var(--atlas-primary-600) !important;
}

.color-primary-700 {
  color: var(--atlas-primary-700) !important;
}

.bg-primary-700 {
  background-color: var(--atlas-primary-700) !important;
}

.color-primary-800 {
  color: var(--atlas-primary-800) !important;
}

.bg-primary-800 {
  background-color: var(--atlas-primary-800) !important;
}

.color-primary-900 {
  color: var(--atlas-primary-900) !important;
}

.bg-primary-900 {
  background-color: var(--atlas-primary-900) !important;
}

.active-primary[active], .active-primary.active, .active-primary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-secondary {
  color: var(--atlas-secondary) !important;
}

.bg-secondary {
  background-color: var(--atlas-secondary) !important;
}

.color-secondary-100 {
  color: var(--atlas-secondary-100) !important;
}

.bg-secondary-100 {
  background-color: var(--atlas-secondary-100) !important;
}

.color-secondary-200 {
  color: var(--atlas-secondary-200) !important;
}

.bg-secondary-200 {
  background-color: var(--atlas-secondary-200) !important;
}

.color-secondary-300 {
  color: var(--atlas-secondary-300) !important;
}

.bg-secondary-300 {
  background-color: var(--atlas-secondary-300) !important;
}

.color-secondary-400 {
  color: var(--atlas-secondary-400) !important;
}

.bg-secondary-400 {
  background-color: var(--atlas-secondary-400) !important;
}

.color-secondary-500 {
  color: var(--atlas-secondary-500) !important;
}

.bg-secondary-500 {
  background-color: var(--atlas-secondary-500) !important;
}

.color-secondary-600 {
  color: var(--atlas-secondary-600) !important;
}

.bg-secondary-600 {
  background-color: var(--atlas-secondary-600) !important;
}

.color-secondary-700 {
  color: var(--atlas-secondary-700) !important;
}

.bg-secondary-700 {
  background-color: var(--atlas-secondary-700) !important;
}

.color-secondary-800 {
  color: var(--atlas-secondary-800) !important;
}

.bg-secondary-800 {
  background-color: var(--atlas-secondary-800) !important;
}

.color-secondary-900 {
  color: var(--atlas-secondary-900) !important;
}

.bg-secondary-900 {
  background-color: var(--atlas-secondary-900) !important;
}

.active-secondary[active], .active-secondary.active, .active-secondary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-success {
  color: var(--atlas-success) !important;
}

.bg-success {
  background-color: var(--atlas-success) !important;
}

.color-success-100 {
  color: var(--atlas-success-100) !important;
}

.bg-success-100 {
  background-color: var(--atlas-success-100) !important;
}

.color-success-200 {
  color: var(--atlas-success-200) !important;
}

.bg-success-200 {
  background-color: var(--atlas-success-200) !important;
}

.color-success-300 {
  color: var(--atlas-success-300) !important;
}

.bg-success-300 {
  background-color: var(--atlas-success-300) !important;
}

.color-success-400 {
  color: var(--atlas-success-400) !important;
}

.bg-success-400 {
  background-color: var(--atlas-success-400) !important;
}

.color-success-500 {
  color: var(--atlas-success-500) !important;
}

.bg-success-500 {
  background-color: var(--atlas-success-500) !important;
}

.color-success-600 {
  color: var(--atlas-success-600) !important;
}

.bg-success-600 {
  background-color: var(--atlas-success-600) !important;
}

.color-success-700 {
  color: var(--atlas-success-700) !important;
}

.bg-success-700 {
  background-color: var(--atlas-success-700) !important;
}

.color-success-800 {
  color: var(--atlas-success-800) !important;
}

.bg-success-800 {
  background-color: var(--atlas-success-800) !important;
}

.color-success-900 {
  color: var(--atlas-success-900) !important;
}

.bg-success-900 {
  background-color: var(--atlas-success-900) !important;
}

.active-success[active], .active-success.active, .active-success:active {
  background-color: var(--atlas-success) !important;
  color: var(--atlas-contrast-success) !important;
}

.color-warning {
  color: var(--atlas-warning) !important;
}

.bg-warning {
  background-color: var(--atlas-warning) !important;
}

.color-warning-100 {
  color: var(--atlas-warning-100) !important;
}

.bg-warning-100 {
  background-color: var(--atlas-warning-100) !important;
}

.color-warning-200 {
  color: var(--atlas-warning-200) !important;
}

.bg-warning-200 {
  background-color: var(--atlas-warning-200) !important;
}

.color-warning-300 {
  color: var(--atlas-warning-300) !important;
}

.bg-warning-300 {
  background-color: var(--atlas-warning-300) !important;
}

.color-warning-400 {
  color: var(--atlas-warning-400) !important;
}

.bg-warning-400 {
  background-color: var(--atlas-warning-400) !important;
}

.color-warning-500 {
  color: var(--atlas-warning-500) !important;
}

.bg-warning-500 {
  background-color: var(--atlas-warning-500) !important;
}

.color-warning-600 {
  color: var(--atlas-warning-600) !important;
}

.bg-warning-600 {
  background-color: var(--atlas-warning-600) !important;
}

.color-warning-700 {
  color: var(--atlas-warning-700) !important;
}

.bg-warning-700 {
  background-color: var(--atlas-warning-700) !important;
}

.color-warning-800 {
  color: var(--atlas-warning-800) !important;
}

.bg-warning-800 {
  background-color: var(--atlas-warning-800) !important;
}

.color-warning-900 {
  color: var(--atlas-warning-900) !important;
}

.bg-warning-900 {
  background-color: var(--atlas-warning-900) !important;
}

.active-warning[active], .active-warning.active, .active-warning:active {
  background-color: var(--atlas-warning) !important;
  color: var(--atlas-contrast-warning) !important;
}

.color-danger {
  color: var(--atlas-danger) !important;
}

.bg-danger {
  background-color: var(--atlas-danger) !important;
}

.color-danger-100 {
  color: var(--atlas-danger-100) !important;
}

.bg-danger-100 {
  background-color: var(--atlas-danger-100) !important;
}

.color-danger-200 {
  color: var(--atlas-danger-200) !important;
}

.bg-danger-200 {
  background-color: var(--atlas-danger-200) !important;
}

.color-danger-300 {
  color: var(--atlas-danger-300) !important;
}

.bg-danger-300 {
  background-color: var(--atlas-danger-300) !important;
}

.color-danger-400 {
  color: var(--atlas-danger-400) !important;
}

.bg-danger-400 {
  background-color: var(--atlas-danger-400) !important;
}

.color-danger-500 {
  color: var(--atlas-danger-500) !important;
}

.bg-danger-500 {
  background-color: var(--atlas-danger-500) !important;
}

.color-danger-600 {
  color: var(--atlas-danger-600) !important;
}

.bg-danger-600 {
  background-color: var(--atlas-danger-600) !important;
}

.color-danger-700 {
  color: var(--atlas-danger-700) !important;
}

.bg-danger-700 {
  background-color: var(--atlas-danger-700) !important;
}

.color-danger-800 {
  color: var(--atlas-danger-800) !important;
}

.bg-danger-800 {
  background-color: var(--atlas-danger-800) !important;
}

.color-danger-900 {
  color: var(--atlas-danger-900) !important;
}

.bg-danger-900 {
  background-color: var(--atlas-danger-900) !important;
}

.active-danger[active], .active-danger.active, .active-danger:active {
  background-color: var(--atlas-danger) !important;
  color: var(--atlas-contrast-danger) !important;
}

.color-highlight {
  color: var(--atlas-highlight) !important;
}

.bg-highlight {
  background-color: var(--atlas-highlight) !important;
}

.color-highlight-100 {
  color: var(--atlas-highlight-100) !important;
}

.bg-highlight-100 {
  background-color: var(--atlas-highlight-100) !important;
}

.color-highlight-200 {
  color: var(--atlas-highlight-200) !important;
}

.bg-highlight-200 {
  background-color: var(--atlas-highlight-200) !important;
}

.color-highlight-300 {
  color: var(--atlas-highlight-300) !important;
}

.bg-highlight-300 {
  background-color: var(--atlas-highlight-300) !important;
}

.color-highlight-400 {
  color: var(--atlas-highlight-400) !important;
}

.bg-highlight-400 {
  background-color: var(--atlas-highlight-400) !important;
}

.color-highlight-500 {
  color: var(--atlas-highlight-500) !important;
}

.bg-highlight-500 {
  background-color: var(--atlas-highlight-500) !important;
}

.color-highlight-600 {
  color: var(--atlas-highlight-600) !important;
}

.bg-highlight-600 {
  background-color: var(--atlas-highlight-600) !important;
}

.color-highlight-700 {
  color: var(--atlas-highlight-700) !important;
}

.bg-highlight-700 {
  background-color: var(--atlas-highlight-700) !important;
}

.color-highlight-800 {
  color: var(--atlas-highlight-800) !important;
}

.bg-highlight-800 {
  background-color: var(--atlas-highlight-800) !important;
}

.color-highlight-900 {
  color: var(--atlas-highlight-900) !important;
}

.bg-highlight-900 {
  background-color: var(--atlas-highlight-900) !important;
}

.active-highlight[active], .active-highlight.active, .active-highlight:active {
  background-color: var(--atlas-highlight) !important;
  color: var(--atlas-contrast-highlight) !important;
}

.color-info {
  color: var(--atlas-info) !important;
}

.bg-info {
  background-color: var(--atlas-info) !important;
}

.color-info-100 {
  color: var(--atlas-info-100) !important;
}

.bg-info-100 {
  background-color: var(--atlas-info-100) !important;
}

.color-info-200 {
  color: var(--atlas-info-200) !important;
}

.bg-info-200 {
  background-color: var(--atlas-info-200) !important;
}

.color-info-300 {
  color: var(--atlas-info-300) !important;
}

.bg-info-300 {
  background-color: var(--atlas-info-300) !important;
}

.color-info-400 {
  color: var(--atlas-info-400) !important;
}

.bg-info-400 {
  background-color: var(--atlas-info-400) !important;
}

.color-info-500 {
  color: var(--atlas-info-500) !important;
}

.bg-info-500 {
  background-color: var(--atlas-info-500) !important;
}

.color-info-600 {
  color: var(--atlas-info-600) !important;
}

.bg-info-600 {
  background-color: var(--atlas-info-600) !important;
}

.color-info-700 {
  color: var(--atlas-info-700) !important;
}

.bg-info-700 {
  background-color: var(--atlas-info-700) !important;
}

.color-info-800 {
  color: var(--atlas-info-800) !important;
}

.bg-info-800 {
  background-color: var(--atlas-info-800) !important;
}

.color-info-900 {
  color: var(--atlas-info-900) !important;
}

.bg-info-900 {
  background-color: var(--atlas-info-900) !important;
}

.active-info[active], .active-info.active, .active-info:active {
  background-color: var(--atlas-info) !important;
  color: var(--atlas-contrast-info) !important;
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
:host([alignment=left]),
.text-align-left {
  text-align: left;
}

:host([alignment=center]),
.text-align-center {
  text-align: center;
}

:host([alignment=right]),
.text-align-right {
  text-align: right;
}

:host([alignment=justify]),
.text-align-justify {
  text-align: justify;
}

.text-muted {
  color: #687078 !important;
}

.text-white {
  color: #ffffff !important;
}

:host([ellipsis]) {
  width: 100%;
  overflow: hidden;
}

.ellipsis {
  display: block !important;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.line-clamp {
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

:host {
  display: block;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}

.atlas-caption {
  display: block;
  font-size: 0.75rem;
  line-height: 1;
  font-weight: 600;
  color: #212529;
}
.atlas-caption.small {
  font-size: 0.5rem;
}
.atlas-caption.skeleton {
  height: 0.75rem;
}
.atlas-caption.skeleton.small {
  height: 0.5rem;
}`;

// src/components/display/atlas-caption/atlas-caption.ts
var AtlasCaption = /*#__PURE__*/(() => {
  let AtlasCaption = class extends TextElement {
    /** @internal */
    renderSkeleton() {
      const skeletonClass = {
        "atlas-caption": true,
        "skeleton": true,
        "small": this.small
      };
      return html13`<div class="${classMap5(skeletonClass)}"></div>`;
    }
    /** @internal */
    renderElement() {
      const captionClass = __spreadValues({
        "atlas-caption": true,
        "small": this.small
      }, this.getTextClasses());
      return html13`
            <span
                class=${classMap5(captionClass)}
                style=${styleMap2(this.getTextStyles())}
                data-atlas-tooltip="text-tooltip"
            >
                ${this.renderContentSlot()}
            </span>
            ${this.renderEllipsisTooltip()}
        `;
    }
  };
  AtlasCaption.styles = atlas_caption_default;
  return AtlasCaption;
})();
__decorateClass([property14({
  type: Boolean
})], AtlasCaption.prototype, "small", 2);
AtlasCaption = __decorateClass([customElement9("atlas-caption")], AtlasCaption);

// src/components/display/atlas-badge/atlas-badge.ts
var AtlasBadge = /*#__PURE__*/(() => {
  let AtlasBadge = class extends WithTooltipMixin(AtlasElement) {
    constructor() {
      super(...arguments);
      this.type = "filled";
      this.theme = "danger";
      this.isCounter = false;
      this.showZero = false;
      this.inTableCol = false;
      this.deviceController = new DeviceController(this);
    }
    onClickBadge() {
      emit(this, "atlas-badge-click");
    }
    getEffectiveLineClamp() {
      if (!this.inTableCol) return void 0;
      if (!this.lineClamp) return 2;
      return Math.min(Math.max(this.lineClamp, 1), 2);
    }
    getTextContent() {
      if (this.isCounter) {
        let number = parseInt(this.text, 10);
        if (Number.isNaN(number)) {
          number = 0;
        }
        if (!this.showZero && number === 0) {
          return "";
        }
        return number > 9 ? "9+" : `${number}`;
      }
      return this.text;
    }
    renderIcon() {
      return when8(!!this.icon && !this.isCounter, () => html14`
                <atlas-icon
                    size="2x"
                    name="${this.icon}"
                    theme=${this.type === "outlined" ? this.theme : ""}
                    ?white=${this.type === "filled"}
                ></atlas-icon>
            `);
    }
    renderBadgeText(textContent) {
      const effectiveLineClamp = this.getEffectiveLineClamp();
      return when8(!!textContent, () => html14`
                <atlas-caption
                    theme=${this.type === "outlined" ? this.theme : ""}
                    ?white=${this.type === "filled"}
                    ?small=${this.isCounter}
                    line-clamp=${ifDefined2(effectiveLineClamp)}
                    ?show-line-clamp-tooltip=${!!effectiveLineClamp}
                >
                    ${textContent}
                </atlas-caption>
            `);
    }
    /**
     * @internal
     */
    renderElement() {
      const textContent = this.getTextContent();
      const hasContent = textContent || this.icon;
      const badgeClass = {
        "badge": true,
        "small": this.deviceController.isMobile && (this.isCounter || !hasContent),
        "counter": this.isCounter,
        "with-content": hasContent,
        "with-tooltip": !!this.tooltip,
        "in-table-col": this.inTableCol,
        [`badge-${this.type}-${this.theme}`]: !!this.theme
      };
      const tag = this.tooltip ? literal`button` : literal`span`;
      return html14`
            <${tag}
                class=${classMap6(badgeClass)}
                data-atlas-tooltip="badge-tooltip"
                @click=${ifDefined2(this.tooltip ? this.onClickBadge : void 0)}
            >
                ${this.renderIcon()}
                ${this.renderBadgeText(textContent)}
            </${tag}>
            ${this.renderTooltip("badge-tooltip")}
        `;
    }
    /**
     * @internal
     */
    renderSkeleton() {
      return html14` <div class="badge skeleton"></div> `;
    }
  };
  AtlasBadge.styles = atlas_badge_default;
  return AtlasBadge;
})();
__decorateClass([property15({
  type: String
})], AtlasBadge.prototype, "type", 2);
__decorateClass([property15({
  type: String
})], AtlasBadge.prototype, "text", 2);
__decorateClass([property15({
  type: String
})], AtlasBadge.prototype, "icon", 2);
__decorateClass([property15({
  type: String
})], AtlasBadge.prototype, "theme", 2);
__decorateClass([property15({
  type: Boolean,
  attribute: "is-counter"
})], AtlasBadge.prototype, "isCounter", 2);
__decorateClass([property15({
  type: Boolean,
  attribute: "show-zero"
})], AtlasBadge.prototype, "showZero", 2);
__decorateClass([property15({
  type: Number,
  attribute: "line-clamp"
})], AtlasBadge.prototype, "lineClamp", 2);
__decorateClass([property15({
  type: Boolean,
  attribute: "in-table-col"
})], AtlasBadge.prototype, "inTableCol", 2);
AtlasBadge = __decorateClass([customElement10("atlas-badge")], AtlasBadge);

// src/components/display/atlas-icon-button/atlas-icon-button.ts
var ComposedClass = WithPopoverMixin(WithTooltipMixin(AtlasElement));
var AtlasIconButton = /*#__PURE__*/(() => {
  let AtlasIconButton = class extends ComposedClass {
    constructor() {
      super(...arguments);
      this.size = "3x";
      this.disabled = false;
      this.hoverable = false;
      this.active = false;
      this.showBadge = false;
      this.deviceController = new DeviceController(this);
    }
    /**
     * Executa o clique do mouse no botão
     */
    click() {
      this.shadowRoot.querySelector(".icon-button").click();
    }
    onIconButtonClick() {
      emit(this, "atlas-icon-button-click");
    }
    renderBadge() {
      return when9(this.showBadge, () => html15`<atlas-badge text=${this.badgeNumber} is-counter></atlas-badge>`);
    }
    renderHotspotSlot() {
      return html15`<slot name="hotspot"></slot>`;
    }
    /** @internal */
    render() {
      const buttonClass = {
        "icon-button": true,
        "disabled": this.disabled || this.loading,
        "hoverable": this.hoverable && !this.deviceController.isMobile,
        "active": this.active,
        [`theme-${this.theme}`]: !!this.theme,
        "theme-on-interactions": this.themeOnInteractions
      };
      const tag = this.href ? literal2`a` : literal2`button`;
      return html15`
            <div
                class="btn-wrapper"
                tabindex=${this.disabled ? "0" : "-1"}
                data-atlas-tooltip="btn-icon-tooltip"
                data-atlas-popover="btn-icon-popover"
            >
                ${this.renderHotspotSlot()}
                <${tag}
                    class=${classMap7(buttonClass)}
                    ?disabled=${this.disabled || this.loading}
                    aria-label=${this.description}
                    @click=${this.onIconButtonClick}
                    href=${ifDefined3(this.href ? this.href : void 0)}
                    rel="${ifDefined3(this.href && this.isExternalLink ? "noreferrer" : void 0)}"
                    target="${ifDefined3(this.href && this.isExternalLink ? "_blank" : void 0)}"
                >
                    <atlas-icon
                        name=${this.loading ? "loader" : this.icon}
                        size=${this.size}
                        ?disabled=${this.disabled || this.loading}
                    ></atlas-icon>
                    ${this.renderBadge()}
                </${tag}>
            </div>
            ${this.renderTooltip("btn-icon-tooltip")}${this.renderPopover("btn-icon-popover")}
        `;
    }
  };
  AtlasIconButton.styles = atlas_icon_button_default;
  return AtlasIconButton;
})();
__decorateClass([property16({
  type: String,
  reflect: true
})], AtlasIconButton.prototype, "icon", 2);
__decorateClass([property16({
  type: String,
  reflect: true
})], AtlasIconButton.prototype, "theme", 2);
__decorateClass([property16({
  type: Boolean,
  reflect: true,
  attribute: "theme-on-interactions"
})], AtlasIconButton.prototype, "themeOnInteractions", 2);
__decorateClass([property16({
  type: String,
  reflect: true
})], AtlasIconButton.prototype, "size", 2);
__decorateClass([property16({
  type: Boolean,
  reflect: true
})], AtlasIconButton.prototype, "disabled", 2);
__decorateClass([property16({
  type: Boolean,
  reflect: true
})], AtlasIconButton.prototype, "hoverable", 2);
__decorateClass([property16({
  type: Boolean,
  reflect: true
})], AtlasIconButton.prototype, "active", 2);
__decorateClass([property16({
  type: Boolean,
  attribute: "show-badge",
  reflect: true
})], AtlasIconButton.prototype, "showBadge", 2);
__decorateClass([property16({
  type: Number,
  attribute: "badge-number",
  reflect: true
})], AtlasIconButton.prototype, "badgeNumber", 2);
__decorateClass([property16({
  type: Boolean,
  reflect: true
})], AtlasIconButton.prototype, "loading", 2);
__decorateClass([property16({
  type: String,
  reflect: true
})], AtlasIconButton.prototype, "description", 2);
__decorateClass([property16({
  type: String
})], AtlasIconButton.prototype, "href", 2);
__decorateClass([property16({
  type: Boolean,
  attribute: "is-external-link"
})], AtlasIconButton.prototype, "isExternalLink", 2);
AtlasIconButton = __decorateClass([customElement11("atlas-icon-button")], AtlasIconButton);

// src/components/dashboard/atlas-calendar/atlas-calendar.ts
var AtlasCalendar = /*#__PURE__*/(() => {
  let AtlasCalendar = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.flags = [];
      this.flaggedDates = [];
      this.rangeLimitDays = 31;
      this.tooltipPrivatePlaceholderPrefix = "";
      this._enableHoverRange = false;
    }
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.onSelectDate = this.onSelectDate.bind(this);
      this.onChangeMonth = this.onChangeMonth.bind(this);
      this.onChangeView = this.onChangeView.bind(this);
      this.onMouseLeaveCalendar = this.onMouseLeaveCalendar.bind(this);
      this.onChangeSkeletonLoading = this.onChangeSkeletonLoading.bind(this);
      this.addEventListener("atlas-element-change-skeleton", this.onChangeSkeletonLoading);
      this.updateComplete.then(() => {
        const currentDate = this.currentDate ? new Date(DatepickerExtended.parseDate(this.currentDate, DatepickerExtended.dateFormat)) : /* @__PURE__ */new Date();
        currentDate.setHours(0, 0, 0, 0);
        this._viewDate = currentDate;
        this.createCalendar();
      });
    }
    disconnectedCallback() {
      this.removeEventListener("atlas-element-change-skeleton", this.onChangeSkeletonLoading);
    }
    /**
     * Retorna a instância do Datepicker.
     * @returns {Datepicker} - A instância do Datepicker
     */
    getDatepickerInstance() {
      return this._datepicker;
    }
    onChangeSkeletonLoading() {
      if (this.skeletonLoading) {
        this.removeRangesOnCalendar();
      } else {
        this.setRangesOnCalendar();
      }
    }
    /**
     * Retorna as datas selecionadas no calendário.
     * @returns {Object} - Um objeto contendo a data de início e fim do intervalo selecionado (se houver)
     */
    getDates() {
      let startDate = this._rangeStart;
      let endDate = this._rangeEnd;
      if (endDate && startDate > endDate) {
        [startDate, endDate] = [endDate, startDate];
      }
      return {
        startDate: new Date(startDate),
        endDate: endDate ? new Date(endDate) : null
      };
    }
    /**
     * Retorna as datas selecionadas no calendário, com formatação.
     * @returns {Object} - Um objeto contendo as datas formatadas no padrão dd/mm/yyyy
     */
    getFormattedDates() {
      const {
        startDate,
        endDate
      } = this.getDates();
      return {
        startDate: DatepickerExtended.formatDate(startDate, DatepickerExtended.dateFormat),
        endDate: endDate ? DatepickerExtended.formatDate(endDate, DatepickerExtended.dateFormat) : null
      };
    }
    /**
     * Lista os marcadores (flags) que serão aplicados ao calendário.
     */
    setFlags(flags) {
      this.flags = [...flags];
    }
    /**
     * Lista as datas que serão marcadas, destacando-as visualmente no calendário.
     */
    setFlaggedDates(flaggedDates) {
      this.flaggedDates = [...flaggedDates];
    }
    buildLeftArrowIcon() {
      return `
            <div class="skeleton" style="width:1rem; height: 1rem"></div>
            <i class="atlas-icon ati-chevron-left ati-3x color-secondary"></i>
        `;
    }
    buildRightArrowIcon() {
      return `
            <div class="skeleton" style="width:1rem; height: 1rem"></div>
            <i class="atlas-icon ati-chevron-right ati-3x color-secondary"></i>
        `;
    }
    buildDayCell(date) {
      return `
            <div class="skeleton" style="width: 50%; height: 1rem; margin: 0.5rem 0"></div>
            <span class="cell-content">${date.getDate()}</span>
        `;
    }
    createCalendar() {
      this._datepicker = new DatepickerExtended(this._calendarContainer, {
        format: DatepickerExtended.dateFormat,
        maxView: 2,
        maxNumberOfDates: 3,
        language: "pt-BR",
        buttonClass: `atlas-datepicker-button`,
        prevArrow: this.buildLeftArrowIcon(),
        nextArrow: this.buildRightArrowIcon(),
        defaultViewDate: this._viewDate,
        beforeShowDay: date => ({
          content: this.buildDayCell(date)
        }),
        beforeShowMonth: date => ({
          content: `
                    <span class="cell-content">
                        ${DatepickerExtended.locales["pt-BR"].monthsShort[date.getMonth()]}
                    </span>
                `
        }),
        beforeShowYear: date => ({
          content: `<span class="cell-content">${date.getFullYear()}</span>`
        }),
        beforeShowDecade: date => ({
          content: `<span class="cell-content">${date.getFullYear()}</span>`
        })
      });
      const currentDate = this.currentDate ? new Date(DatepickerExtended.parseDate(this.currentDate, DatepickerExtended.dateFormat)) : /* @__PURE__ */new Date();
      currentDate.setHours(0, 0, 0, 0);
      if (this._viewDate.getTime() === currentDate.getTime()) {
        this._datepicker.setDate(currentDate.getTime());
        this._rangeStart = currentDate.getTime();
        this._rangeEnd = currentDate.getTime();
        this._currentMonth = currentDate.getMonth();
      }
      this._calendarContainer.addEventListener("changeMonth", this.onChangeMonth);
      this._calendarContainer.addEventListener("changeView", this.onChangeView);
      this._calendarContainer.addEventListener("changeDate", this.onSelectDate);
      this._calendarContainer.addEventListener("mouseleave", this.onMouseLeaveCalendar);
      this.setDateLimit();
      this.addHoverListener();
      this.setFlaggedDatesOnCalendar();
      this.createMonthSkeletonElement();
      this.createWeekDaysSkeletonElement();
    }
    createWeekDaysSkeletonElement() {
      const skeletonElement = document.createElement("div");
      skeletonElement.classList.add("skeleton");
      skeletonElement.style.height = "16px";
      skeletonElement.style.width = "50%";
      this._calendarContainer.querySelectorAll(".dow").forEach(dowElement => {
        const textNode = dowElement.innerHTML;
        dowElement.innerHTML = "";
        const spanElement = document.createElement("span");
        spanElement.innerText = textNode;
        dowElement.prepend(spanElement);
        dowElement.prepend(skeletonElement.cloneNode(false));
      });
    }
    createMonthSkeletonElement() {
      const skeletonElement = document.createElement("div");
      skeletonElement.classList.add("skeleton");
      skeletonElement.style.margin = "4px 0";
      skeletonElement.style.height = "16px";
      skeletonElement.style.width = "50%";
      const textNode = this._calendarContainer.querySelector(".view-switch").innerHTML;
      this._calendarContainer.querySelector(".view-switch").innerHTML = "";
      const spanElement = document.createElement("span");
      spanElement.innerText = textNode;
      this._calendarContainer.querySelector(".view-switch").prepend(spanElement);
      this._calendarContainer.querySelector(".view-switch").prepend(skeletonElement);
    }
    addHoverListener() {
      this._calendarContainer.querySelectorAll(".datepicker-grid .datepicker-cell").forEach(cell => {
        cell.addEventListener("mouseover", () => {
          if (!this._enableHoverRange) return;
          this._rangeHover = parseInt(cell.dataset.date, 10);
          this.setRangesOnCalendar();
        });
      });
    }
    clearRanges() {
      this._rangeStart = null;
      this._rangeEnd = null;
    }
    onMouseLeaveCalendar() {
      this._rangeHover = null;
      this.setRangesOnCalendar();
    }
    onChangeMonth(event) {
      this.createMonthSkeletonElement();
      this._viewDate = event.detail.viewDate;
      this._currentMonth = event.detail.viewDate.getMonth();
      this.addHoverListener();
      this.setFlaggedDatesOnCalendar();
      this.setRangesOnCalendar();
      emit(this, "atlas-calendar-month-change", {
        detail: {
          currentDate: event.detail.date,
          viewingDate: event.detail.viewDate
        }
      });
    }
    onChangeView(event) {
      const {
        viewId,
        viewDate
      } = event.detail;
      if (viewId === 0 && viewDate.getMonth() === this._currentMonth) {
        this.onChangeMonth(event);
      }
    }
    onSelectDate(event) {
      const {
        date,
        viewDate
      } = event.detail;
      let timestamp = viewDate.getTime();
      switch (date.length) {
        case 1:
          if (timestamp === this._rangeEnd) {
            timestamp = this._rangeStart;
            this.clearRanges();
            this._datepicker.setDate(timestamp, {
              clear: true
            });
          } else if (timestamp === this._rangeStart) {
            timestamp = this._rangeEnd;
            this.clearRanges();
            this._datepicker.setDate(timestamp, {
              clear: true
            });
          } else {
            this._rangeStart = timestamp;
            this._enableHoverRange = true;
            emit(this, "atlas-calendar-date-change", {
              detail: this.getDates()
            });
          }
          break;
        case 2:
          if (this._rangeStart === this._rangeEnd) {
            this.clearRanges();
            this._datepicker.setDate(timestamp, {
              clear: true
            });
            return;
          }
          if (timestamp < this._rangeStart) {
            this._rangeEnd = this._rangeStart;
            this._rangeStart = timestamp;
          } else {
            this._rangeEnd = timestamp;
          }
          this._enableHoverRange = false;
          this._rangeHover = null;
          emit(this, "atlas-calendar-date-change", {
            detail: this.getDates()
          });
          break;
        case 3:
          this.clearRanges();
          this._datepicker.setDate(timestamp, {
            clear: true
          });
          break;
        default:
          timestamp = this._rangeStart;
          this.clearRanges();
          this._datepicker.setDate(timestamp, {
            clear: true
          });
      }
      this.setDateLimit();
      this.setRangesOnCalendar();
      this.setFlaggedDatesOnCalendar();
      this.createMonthSkeletonElement();
    }
    setDateLimit() {
      this._datepicker.setOptions({
        datesDisabled: (date, viewId) => {
          if (!this.isSelectingRange()) return false;
          const {
            minDate,
            maxDate
          } = this.getRangeDateLimit();
          if (viewId === 0 && (date.getTime() < minDate.getTime() || date.getTime() > maxDate.getTime())) {
            return true;
          }
          return false;
        }
      });
    }
    isSelectingRange() {
      return this._rangeStart && !this._rangeEnd;
    }
    getRangeDateLimit() {
      const minDate = new Date(this._rangeStart);
      const maxDate = new Date(this._rangeStart);
      minDate.setDate(minDate.getDate() - this.rangeLimitDays);
      maxDate.setDate(maxDate.getDate() + this.rangeLimitDays);
      return {
        minDate,
        maxDate
      };
    }
    getAllDaysInRange() {
      let startDate = this._rangeStart;
      let endDate = this._rangeEnd || this._rangeHover || this._rangeStart;
      if (startDate > endDate) {
        [startDate, endDate] = [endDate, startDate];
      }
      const daysInRange = [];
      const dayInMilli = 60 * 60 * 24 * 1e3;
      for (let i = startDate; i <= endDate; i += dayInMilli) {
        daysInRange.push(i);
      }
      return daysInRange;
    }
    getRangeCellData() {
      const daysInRange = this.getAllDaysInRange();
      const cellData = {
        disabledTooltipElement: null,
        elements: []
      };
      daysInRange.forEach(day => {
        const cell = this._calendarContainer.querySelector(`.datepicker-grid span[data-date='${day}']`);
        if (!cell) return;
        if (cell.classList.contains("disabled")) {
          if (day === this._rangeHover) {
            cellData.disabledTooltipElement = cell;
          }
          return;
        }
        cellData.elements.push(cell);
      });
      return cellData;
    }
    setRangesOnCalendar() {
      const rangeCellData = this.getRangeCellData();
      this.removeRangePickFeedbackTooltip();
      this.removeRangesOnCalendar();
      if (rangeCellData.disabledTooltipElement) {
        this.createRangePickFeedbackTooltip(rangeCellData.disabledTooltipElement);
      }
      if (rangeCellData.elements.length <= 1) return;
      rangeCellData.elements.forEach((cell, index) => {
        if (!this._rangeEnd) {
          cell.classList.add("in-range");
          if (index === rangeCellData.elements.length - 1) {
            cell.classList.add("in-range-no-after");
          } else if (index === 0) {
            cell.classList.add("in-range-no-before");
          }
        } else if (index === 0) {
          cell.classList.add("range-start");
        } else if (index === rangeCellData.elements.length - 1) {
          cell.classList.add("range-end");
        } else {
          cell.classList.add("in-range");
        }
      });
    }
    removeRangesOnCalendar() {
      this._calendarContainer.querySelectorAll(".datepicker-grid span").forEach(cell => {
        cell.classList.remove("range-start");
        cell.classList.remove("range-end");
        cell.classList.remove("in-range");
        cell.classList.remove("in-range-no-after");
        cell.classList.remove("in-range-no-before");
      });
    }
    removeRangePickFeedbackTooltip() {
      this.shadowRoot.querySelectorAll(`[data-atlas-tooltip="cell-disabled-range-tooltip"]`).forEach(cell => {
        var _a;
        cell.removeAttribute("data-atlas-tooltip");
        (_a = cell.querySelector("atlas-tooltip")) == null ? void 0 : _a.remove();
      });
    }
    createRangePickFeedbackTooltip(cell) {
      this.removeRangePickFeedbackTooltip();
      const tooltipId = `cell-disabled-range-tooltip`;
      cell.setAttribute("data-atlas-tooltip", tooltipId);
      const tooltip = document.createElement("atlas-tooltip");
      tooltip.id = tooltipId;
      tooltip.placement = "bottom";
      tooltip.trigger = "hover";
      const tooltipMessage = "N\xE3o \xE9 poss\xEDvel selecionar esta data pois ultrapassa o limite de filtro de ";
      const tooltipDaySuffix = this.rangeLimitDays > 1 ? "dias" : "dia";
      tooltip.appendChild(document.createTextNode(`
                ${tooltipMessage}
                ${this.rangeLimitDays}
                ${tooltipDaySuffix}
            `));
      cell.appendChild(tooltip);
    }
    setFlaggedDatesOnCalendar() {
      var _a;
      this._calendarContainer.querySelectorAll(".datepicker-grid span").forEach(cell => {
        var _a2;
        (_a2 = cell.querySelector(".badge-container")) == null ? void 0 : _a2.remove();
      });
      (_a = this.flags) == null ? void 0 : _a.forEach(flag => {
        var _a2, _b;
        (_b = (_a2 = this.flaggedDates) == null ? void 0 : _a2.filter(flaggedDate => flag.name === flaggedDate.flag)) == null ? void 0 : _b.forEach(flaggedDate => this.createFlagOnCalendar(flag, flaggedDate));
      });
    }
    createFlagOnCalendar(flag, flaggedDate) {
      const date = DatepickerExtended.getDateAsTimestamp(flaggedDate.date);
      const cell = this._calendarContainer.querySelector(`.datepicker-grid span[data-date='${date}']`);
      if (!cell) return;
      let badgeContainer = cell.querySelector(".badge-container");
      if (!badgeContainer) {
        badgeContainer = document.createElement("div");
        badgeContainer.classList.add("badge-container");
        cell.appendChild(badgeContainer);
      }
      const tooltipId = `cell-${date}-${flag.name}-tooltip`;
      const badge = document.createElement("div");
      badge.classList.add("badge");
      badge.classList.add(`bg-${flag.theme}`);
      badge.classList.toggle(`bg-${flag.theme}-${flag["theme-variation"]}`, !!flag["theme-variation"]);
      badge.classList.toggle("circle", flag.type === "circle");
      badge.setAttribute("data-atlas-tooltip", tooltipId);
      badgeContainer.appendChild(badge);
      const tooltip = document.createElement("atlas-tooltip");
      tooltip.id = tooltipId;
      tooltip.placement = "bottom";
      tooltip.trigger = "hover";
      tooltip.placeholderPrefix = this.tooltipPrivatePlaceholderPrefix;
      tooltip.privateKey = this.tooltipPrivateKey;
      tooltip.appendChild(document.createTextNode(flaggedDate.value));
      badgeContainer.appendChild(tooltip);
    }
    renderFlagPopover(flag) {
      return when10(flag["popover-content"], () => html16`
                <atlas-icon-button
                    icon="info"
                    theme="primary"
                    size="2x"
                    popover-title=${flag["popover-title"]}
                    popover-content=${flag["popover-content"]}
                ></atlas-icon-button>
            `);
    }
    renderFlagItems() {
      if (this.skeletonLoading) {
        return html16`
                <div class="flag-item">
                    <div class="skeleton" style="width: 10px; height: 10px"></div>
                    <div class="skeleton" style="width: 100px; height: 16px; margin: 2px 0"></div>
                </div>
            `;
      }
      return this.flags.map(flag => {
        const flagClass = {
          "flag-item": true
        };
        const badgeClass = {
          "flag-badge": true,
          "circle": flag.type === "circle",
          [`bg-${flag.theme}`]: true,
          [`bg-${flag.theme}-${flag["theme-variation"]}`]: !!flag["theme-variation"]
        };
        return html16`
                <div class=${classMap8(flagClass)}>
                    <div class=${classMap8(badgeClass)}></div>
                    <atlas-caption size="xs">${flag.label}</atlas-caption> ${this.renderFlagPopover(flag)}
                </div>
            `;
      });
    }
    render() {
      const hasFlags = !!this.flags && this.flags.length > 0;
      return html16`
            <div class="calendar-wrapper">
                ${when10(hasFlags, () => html16`<div class="calendar-flags">${this.renderFlagItems()}</div>`)}
                <div class="atlas-calendar"></div>
            </div>
        `;
    }
  };
  AtlasCalendar.styles = atlas_calendar_default;
  return AtlasCalendar;
})();
__decorateClass([property17({
  type: Array
})], AtlasCalendar.prototype, "flags", 2);
__decorateClass([property17({
  type: Array,
  attribute: "flagged-dates"
})], AtlasCalendar.prototype, "flaggedDates", 2);
__decorateClass([property17({
  type: Number,
  attribute: "range-limit-days"
})], AtlasCalendar.prototype, "rangeLimitDays", 2);
__decorateClass([property17({
  type: String,
  attribute: "current-date"
})], AtlasCalendar.prototype, "currentDate", 2);
__decorateClass([property17({
  type: String,
  attribute: "tooltip-private-key"
})], AtlasCalendar.prototype, "tooltipPrivateKey", 2);
__decorateClass([property17({
  type: String,
  attribute: "tooltip-private-placeholder-prefix"
})], AtlasCalendar.prototype, "tooltipPrivatePlaceholderPrefix", 2);
__decorateClass([state4()], AtlasCalendar.prototype, "_rangeStart", 2);
__decorateClass([state4()], AtlasCalendar.prototype, "_rangeEnd", 2);
__decorateClass([state4()], AtlasCalendar.prototype, "_rangeHover", 2);
__decorateClass([state4()], AtlasCalendar.prototype, "_enableHoverRange", 2);
__decorateClass([state4()], AtlasCalendar.prototype, "_currentMonth", 2);
__decorateClass([query5(".atlas-calendar")], AtlasCalendar.prototype, "_calendarContainer", 2);
__decorateClass([Watch("flaggedDates", true), Watch("flags", true)], AtlasCalendar.prototype, "setFlaggedDatesOnCalendar", 1);
AtlasCalendar = __decorateClass([customElement12("atlas-calendar")], AtlasCalendar);

// src/components/dashboard/atlas-calendar-timeline/atlas-calendar-timeline.ts
import { html as html18, literal as literal4 } from "lit/static-html.js";
import { customElement as customElement14, property as property19 } from "lit/decorators.js";
import { ifDefined as ifDefined4 } from "lit/directives/if-defined.js";
import { when as when11 } from "lit/directives/when.js";

// src/components/dashboard/atlas-calendar-timeline/atlas-calendar-timeline.scss
import { css as css14 } from "lit-element/lit-element.js";
var atlas_calendar_timeline_default = css14`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.timeline {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: relative;
  width: 100%;
  box-sizing: border-box;
}

.timeline-header {
  padding: 0 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  width: 100%;
  border: 1px solid transparent;
  box-sizing: border-box;
}
.timeline-header .timeline-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.timeline-header .timeline-title atlas-icon {
  z-index: 9;
  background: #ffffff;
}
.timeline-header .timeline-button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  padding: 0 0 0 0.5rem;
  background: none;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  line-height: 1.5;
  color: var(--atlas-primary);
  text-decoration: none;
  cursor: pointer;
}
.timeline-header .timeline-button span {
  flex-grow: 1;
}
.timeline-header .timeline-button:focus-visible {
  outline: none;
  border-color: #adb5bd;
}
.timeline-header .timeline-button:hover, .timeline-header .timeline-button:active {
  background: rgba(var(--atlas-primary-rgb), 5%);
}
.timeline-header .timeline-button:disabled {
  opacity: 0.65;
  pointer-events: none;
}

.timeline-body {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}`;

// src/components/display/atlas-heading/atlas-heading.ts
import { literal as literal3, html as html17, unsafeStatic } from "lit/static-html.js";
import { customElement as customElement13, property as property18 } from "lit/decorators.js";
import { classMap as classMap9 } from "lit/directives/class-map.js";
import { styleMap as styleMap3 } from "lit/directives/style-map.js";

// src/components/display/atlas-heading/atlas-heading.scss
import { css as css15 } from "lit-element/lit-element.js";
var atlas_heading_default = css15`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.color-white {
  color: #ffffff !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.color-primary {
  color: var(--atlas-primary) !important;
}

.bg-primary {
  background-color: var(--atlas-primary) !important;
}

.color-primary-100 {
  color: var(--atlas-primary-100) !important;
}

.bg-primary-100 {
  background-color: var(--atlas-primary-100) !important;
}

.color-primary-200 {
  color: var(--atlas-primary-200) !important;
}

.bg-primary-200 {
  background-color: var(--atlas-primary-200) !important;
}

.color-primary-300 {
  color: var(--atlas-primary-300) !important;
}

.bg-primary-300 {
  background-color: var(--atlas-primary-300) !important;
}

.color-primary-400 {
  color: var(--atlas-primary-400) !important;
}

.bg-primary-400 {
  background-color: var(--atlas-primary-400) !important;
}

.color-primary-500 {
  color: var(--atlas-primary-500) !important;
}

.bg-primary-500 {
  background-color: var(--atlas-primary-500) !important;
}

.color-primary-600 {
  color: var(--atlas-primary-600) !important;
}

.bg-primary-600 {
  background-color: var(--atlas-primary-600) !important;
}

.color-primary-700 {
  color: var(--atlas-primary-700) !important;
}

.bg-primary-700 {
  background-color: var(--atlas-primary-700) !important;
}

.color-primary-800 {
  color: var(--atlas-primary-800) !important;
}

.bg-primary-800 {
  background-color: var(--atlas-primary-800) !important;
}

.color-primary-900 {
  color: var(--atlas-primary-900) !important;
}

.bg-primary-900 {
  background-color: var(--atlas-primary-900) !important;
}

.active-primary[active], .active-primary.active, .active-primary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-secondary {
  color: var(--atlas-secondary) !important;
}

.bg-secondary {
  background-color: var(--atlas-secondary) !important;
}

.color-secondary-100 {
  color: var(--atlas-secondary-100) !important;
}

.bg-secondary-100 {
  background-color: var(--atlas-secondary-100) !important;
}

.color-secondary-200 {
  color: var(--atlas-secondary-200) !important;
}

.bg-secondary-200 {
  background-color: var(--atlas-secondary-200) !important;
}

.color-secondary-300 {
  color: var(--atlas-secondary-300) !important;
}

.bg-secondary-300 {
  background-color: var(--atlas-secondary-300) !important;
}

.color-secondary-400 {
  color: var(--atlas-secondary-400) !important;
}

.bg-secondary-400 {
  background-color: var(--atlas-secondary-400) !important;
}

.color-secondary-500 {
  color: var(--atlas-secondary-500) !important;
}

.bg-secondary-500 {
  background-color: var(--atlas-secondary-500) !important;
}

.color-secondary-600 {
  color: var(--atlas-secondary-600) !important;
}

.bg-secondary-600 {
  background-color: var(--atlas-secondary-600) !important;
}

.color-secondary-700 {
  color: var(--atlas-secondary-700) !important;
}

.bg-secondary-700 {
  background-color: var(--atlas-secondary-700) !important;
}

.color-secondary-800 {
  color: var(--atlas-secondary-800) !important;
}

.bg-secondary-800 {
  background-color: var(--atlas-secondary-800) !important;
}

.color-secondary-900 {
  color: var(--atlas-secondary-900) !important;
}

.bg-secondary-900 {
  background-color: var(--atlas-secondary-900) !important;
}

.active-secondary[active], .active-secondary.active, .active-secondary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-success {
  color: var(--atlas-success) !important;
}

.bg-success {
  background-color: var(--atlas-success) !important;
}

.color-success-100 {
  color: var(--atlas-success-100) !important;
}

.bg-success-100 {
  background-color: var(--atlas-success-100) !important;
}

.color-success-200 {
  color: var(--atlas-success-200) !important;
}

.bg-success-200 {
  background-color: var(--atlas-success-200) !important;
}

.color-success-300 {
  color: var(--atlas-success-300) !important;
}

.bg-success-300 {
  background-color: var(--atlas-success-300) !important;
}

.color-success-400 {
  color: var(--atlas-success-400) !important;
}

.bg-success-400 {
  background-color: var(--atlas-success-400) !important;
}

.color-success-500 {
  color: var(--atlas-success-500) !important;
}

.bg-success-500 {
  background-color: var(--atlas-success-500) !important;
}

.color-success-600 {
  color: var(--atlas-success-600) !important;
}

.bg-success-600 {
  background-color: var(--atlas-success-600) !important;
}

.color-success-700 {
  color: var(--atlas-success-700) !important;
}

.bg-success-700 {
  background-color: var(--atlas-success-700) !important;
}

.color-success-800 {
  color: var(--atlas-success-800) !important;
}

.bg-success-800 {
  background-color: var(--atlas-success-800) !important;
}

.color-success-900 {
  color: var(--atlas-success-900) !important;
}

.bg-success-900 {
  background-color: var(--atlas-success-900) !important;
}

.active-success[active], .active-success.active, .active-success:active {
  background-color: var(--atlas-success) !important;
  color: var(--atlas-contrast-success) !important;
}

.color-warning {
  color: var(--atlas-warning) !important;
}

.bg-warning {
  background-color: var(--atlas-warning) !important;
}

.color-warning-100 {
  color: var(--atlas-warning-100) !important;
}

.bg-warning-100 {
  background-color: var(--atlas-warning-100) !important;
}

.color-warning-200 {
  color: var(--atlas-warning-200) !important;
}

.bg-warning-200 {
  background-color: var(--atlas-warning-200) !important;
}

.color-warning-300 {
  color: var(--atlas-warning-300) !important;
}

.bg-warning-300 {
  background-color: var(--atlas-warning-300) !important;
}

.color-warning-400 {
  color: var(--atlas-warning-400) !important;
}

.bg-warning-400 {
  background-color: var(--atlas-warning-400) !important;
}

.color-warning-500 {
  color: var(--atlas-warning-500) !important;
}

.bg-warning-500 {
  background-color: var(--atlas-warning-500) !important;
}

.color-warning-600 {
  color: var(--atlas-warning-600) !important;
}

.bg-warning-600 {
  background-color: var(--atlas-warning-600) !important;
}

.color-warning-700 {
  color: var(--atlas-warning-700) !important;
}

.bg-warning-700 {
  background-color: var(--atlas-warning-700) !important;
}

.color-warning-800 {
  color: var(--atlas-warning-800) !important;
}

.bg-warning-800 {
  background-color: var(--atlas-warning-800) !important;
}

.color-warning-900 {
  color: var(--atlas-warning-900) !important;
}

.bg-warning-900 {
  background-color: var(--atlas-warning-900) !important;
}

.active-warning[active], .active-warning.active, .active-warning:active {
  background-color: var(--atlas-warning) !important;
  color: var(--atlas-contrast-warning) !important;
}

.color-danger {
  color: var(--atlas-danger) !important;
}

.bg-danger {
  background-color: var(--atlas-danger) !important;
}

.color-danger-100 {
  color: var(--atlas-danger-100) !important;
}

.bg-danger-100 {
  background-color: var(--atlas-danger-100) !important;
}

.color-danger-200 {
  color: var(--atlas-danger-200) !important;
}

.bg-danger-200 {
  background-color: var(--atlas-danger-200) !important;
}

.color-danger-300 {
  color: var(--atlas-danger-300) !important;
}

.bg-danger-300 {
  background-color: var(--atlas-danger-300) !important;
}

.color-danger-400 {
  color: var(--atlas-danger-400) !important;
}

.bg-danger-400 {
  background-color: var(--atlas-danger-400) !important;
}

.color-danger-500 {
  color: var(--atlas-danger-500) !important;
}

.bg-danger-500 {
  background-color: var(--atlas-danger-500) !important;
}

.color-danger-600 {
  color: var(--atlas-danger-600) !important;
}

.bg-danger-600 {
  background-color: var(--atlas-danger-600) !important;
}

.color-danger-700 {
  color: var(--atlas-danger-700) !important;
}

.bg-danger-700 {
  background-color: var(--atlas-danger-700) !important;
}

.color-danger-800 {
  color: var(--atlas-danger-800) !important;
}

.bg-danger-800 {
  background-color: var(--atlas-danger-800) !important;
}

.color-danger-900 {
  color: var(--atlas-danger-900) !important;
}

.bg-danger-900 {
  background-color: var(--atlas-danger-900) !important;
}

.active-danger[active], .active-danger.active, .active-danger:active {
  background-color: var(--atlas-danger) !important;
  color: var(--atlas-contrast-danger) !important;
}

.color-highlight {
  color: var(--atlas-highlight) !important;
}

.bg-highlight {
  background-color: var(--atlas-highlight) !important;
}

.color-highlight-100 {
  color: var(--atlas-highlight-100) !important;
}

.bg-highlight-100 {
  background-color: var(--atlas-highlight-100) !important;
}

.color-highlight-200 {
  color: var(--atlas-highlight-200) !important;
}

.bg-highlight-200 {
  background-color: var(--atlas-highlight-200) !important;
}

.color-highlight-300 {
  color: var(--atlas-highlight-300) !important;
}

.bg-highlight-300 {
  background-color: var(--atlas-highlight-300) !important;
}

.color-highlight-400 {
  color: var(--atlas-highlight-400) !important;
}

.bg-highlight-400 {
  background-color: var(--atlas-highlight-400) !important;
}

.color-highlight-500 {
  color: var(--atlas-highlight-500) !important;
}

.bg-highlight-500 {
  background-color: var(--atlas-highlight-500) !important;
}

.color-highlight-600 {
  color: var(--atlas-highlight-600) !important;
}

.bg-highlight-600 {
  background-color: var(--atlas-highlight-600) !important;
}

.color-highlight-700 {
  color: var(--atlas-highlight-700) !important;
}

.bg-highlight-700 {
  background-color: var(--atlas-highlight-700) !important;
}

.color-highlight-800 {
  color: var(--atlas-highlight-800) !important;
}

.bg-highlight-800 {
  background-color: var(--atlas-highlight-800) !important;
}

.color-highlight-900 {
  color: var(--atlas-highlight-900) !important;
}

.bg-highlight-900 {
  background-color: var(--atlas-highlight-900) !important;
}

.active-highlight[active], .active-highlight.active, .active-highlight:active {
  background-color: var(--atlas-highlight) !important;
  color: var(--atlas-contrast-highlight) !important;
}

.color-info {
  color: var(--atlas-info) !important;
}

.bg-info {
  background-color: var(--atlas-info) !important;
}

.color-info-100 {
  color: var(--atlas-info-100) !important;
}

.bg-info-100 {
  background-color: var(--atlas-info-100) !important;
}

.color-info-200 {
  color: var(--atlas-info-200) !important;
}

.bg-info-200 {
  background-color: var(--atlas-info-200) !important;
}

.color-info-300 {
  color: var(--atlas-info-300) !important;
}

.bg-info-300 {
  background-color: var(--atlas-info-300) !important;
}

.color-info-400 {
  color: var(--atlas-info-400) !important;
}

.bg-info-400 {
  background-color: var(--atlas-info-400) !important;
}

.color-info-500 {
  color: var(--atlas-info-500) !important;
}

.bg-info-500 {
  background-color: var(--atlas-info-500) !important;
}

.color-info-600 {
  color: var(--atlas-info-600) !important;
}

.bg-info-600 {
  background-color: var(--atlas-info-600) !important;
}

.color-info-700 {
  color: var(--atlas-info-700) !important;
}

.bg-info-700 {
  background-color: var(--atlas-info-700) !important;
}

.color-info-800 {
  color: var(--atlas-info-800) !important;
}

.bg-info-800 {
  background-color: var(--atlas-info-800) !important;
}

.color-info-900 {
  color: var(--atlas-info-900) !important;
}

.bg-info-900 {
  background-color: var(--atlas-info-900) !important;
}

.active-info[active], .active-info.active, .active-info:active {
  background-color: var(--atlas-info) !important;
  color: var(--atlas-contrast-info) !important;
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
:host([alignment=left]),
.text-align-left {
  text-align: left;
}

:host([alignment=center]),
.text-align-center {
  text-align: center;
}

:host([alignment=right]),
.text-align-right {
  text-align: right;
}

:host([alignment=justify]),
.text-align-justify {
  text-align: justify;
}

.text-muted {
  color: #687078 !important;
}

.text-white {
  color: #ffffff !important;
}

:host([ellipsis]) {
  width: 100%;
  overflow: hidden;
}

.ellipsis {
  display: block !important;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.line-clamp {
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

:host {
  display: block;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}

.atlas-heading {
  display: block;
  line-height: 1.25;
  font-weight: 600;
  color: var(--atlas-heading-color, #212529);
}

.h1 {
  font-size: 2.5rem;
  margin: 0;
}
.h1.skeleton {
  height: 3.125rem;
}

.h2 {
  font-size: 2rem;
  margin: 0;
}
.h2.skeleton {
  height: 2.5rem;
}

.h3 {
  font-size: 1.75rem;
  margin: 0;
}
.h3.skeleton {
  height: 2.1875rem;
}

.h4 {
  font-size: 1.5rem;
  margin: 0;
}
.h4.skeleton {
  height: 1.875rem;
}

.h5 {
  font-size: 1.25rem;
  margin: 0;
}
.h5.skeleton {
  height: 1.5625rem;
}

.h6 {
  font-size: 1rem;
  margin: 0;
}
.h6.skeleton {
  height: 1.25rem;
}`;

// src/components/display/atlas-heading/atlas-heading.ts
var AtlasHeading = /*#__PURE__*/(() => {
  let AtlasHeading = class extends TextElement {
    constructor() {
      super(...arguments);
      this.size = "h4";
    }
    /** @internal */
    renderSkeleton() {
      const skeletonClass = {
        "atlas-heading": true,
        "skeleton": true,
        [this.size]: !!this.size
      };
      return html17`<div class="${classMap9(skeletonClass)}"></div>`;
    }
    /** @internal */
    renderElement() {
      const headingClass = __spreadValues({
        "atlas-heading": true,
        [this.size]: !!this.size
      }, this.getTextClasses());
      const tag = this.size ? unsafeStatic(this.size) : literal3`h4`;
      return html17`
            <${tag}
                class=${classMap9(headingClass)}
                style=${styleMap3(this.getTextStyles())}
                data-atlas-tooltip="text-tooltip"
            >
                ${this.renderContentSlot()}
            </${tag}>
            ${this.renderEllipsisTooltip()}
        `;
    }
  };
  AtlasHeading.styles = atlas_heading_default;
  return AtlasHeading;
})();
__decorateClass([property18({
  type: String
})], AtlasHeading.prototype, "size", 2);
AtlasHeading = __decorateClass([customElement13("atlas-heading")], AtlasHeading);

// src/components/dashboard/atlas-calendar-timeline/atlas-calendar-timeline.ts
var AtlasCalendarTimeline = /*#__PURE__*/(() => {
  let AtlasCalendarTimeline = class extends AtlasElement {
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.onItemsChange = this.onItemsChange.bind(this);
      this.addEventListener("atlas-timeline-item-hidden-change", this.onItemsChange);
    }
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      this.removeEventListener("atlas-timeline-item-hidden-change", this.onItemsChange);
    }
    onItemsChange() {
      const slotElement = this.shadowRoot.querySelector("slot");
      const timelineCalendarItems = slotElement.assignedElements();
      timelineCalendarItems.forEach(timelineCalendarElement => {
        timelineCalendarElement.toggleAttribute("is-last-child", false);
      });
      const visibleElements = timelineCalendarItems.filter(element => !element.hidden);
      if (visibleElements.length === 0) return;
      const lastVisibleElement = visibleElements[visibleElements.length - 1];
      lastVisibleElement.toggleAttribute("is-last-child", true);
    }
    handleButtonClick() {
      emit(this, "atlas-timeline-button-click");
    }
    renderButton() {
      const tag = this.buttonLink ? literal4`a` : literal4`button`;
      return when11(!!this.buttonText, () => html18`
                <${tag} 
                    class="timeline-button" 
                    ?disabled=${this.buttonDisabled}
                    href=${ifDefined4(this.buttonLink ? this.buttonLink : void 0)}
                >
                    <span>${this.buttonText}</span>
                    <atlas-icon name="chevron-right" theme="primary" size="3x"></atlas-icon>
                </${tag}>
            `);
    }
    renderElement() {
      return html18`
            <div class="timeline">
                <div class="timeline-header">
                    <div class="timeline-title">
                        <atlas-icon name=${this.icon} theme="primary" size="3x"></atlas-icon>
                        <atlas-heading size="h6" theme="primary">${this.header}</atlas-heading>
                    </div>
                    ${this.renderButton()}
                </div>
                <div class="timeline-body">
                    <slot @slotchange=${this.onItemsChange}></slot>
                </div>
            </div>
        `;
    }
    renderSkeleton() {
      return html18`
            <div class="timeline">
                <div class="timeline-header" style="margin-bottom: 16px">
                    <div class="skeleton" style="width: 86px">
                        <atlas-text></atlas-text>
                    </div>
                    <div class="skeleton" style="width: 56px">
                        <atlas-text></atlas-text>
                    </div>
                </div>
                <div class="timeline-body">
                    <slot></slot>
                </div>
            </div>
        `;
    }
  };
  AtlasCalendarTimeline.styles = atlas_calendar_timeline_default;
  return AtlasCalendarTimeline;
})();
__decorateClass([property19({
  type: String
})], AtlasCalendarTimeline.prototype, "header", 2);
__decorateClass([property19({
  type: String
})], AtlasCalendarTimeline.prototype, "icon", 2);
__decorateClass([property19({
  type: String,
  attribute: "button-text"
})], AtlasCalendarTimeline.prototype, "buttonText", 2);
__decorateClass([property19({
  type: String,
  attribute: "button-link"
})], AtlasCalendarTimeline.prototype, "buttonLink", 2);
__decorateClass([property19({
  type: Boolean,
  attribute: "button-disabled"
})], AtlasCalendarTimeline.prototype, "buttonDisabled", 2);
AtlasCalendarTimeline = __decorateClass([customElement14("atlas-calendar-timeline")], AtlasCalendarTimeline);

// src/components/dashboard/atlas-calendar-timeline-item/atlas-calendar-timeline-item.ts
import { html as html20 } from "lit";
import { customElement as customElement16, property as property21, state as state5 } from "lit/decorators.js";
import { ifDefined as ifDefined5 } from "lit/directives/if-defined.js";

// src/components/dashboard/atlas-calendar-timeline-item/atlas-calendar-timeline-item.scss
import { css as css16 } from "lit-element/lit-element.js";
var atlas_calendar_timeline_item_default = css16`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  position: relative;
}
:host::after, :host::before {
  content: "";
  position: absolute;
  border: 1px solid #ced4da;
  height: 100%;
  left: 20px;
  z-index: 1;
}
:host::after {
  top: 0;
}
:host::before {
  top: -50%;
}

:host([is-last-child])::after {
  content: none !important;
}

:host(:first-of-type)::before {
  content: "";
  position: absolute;
  border: 1px solid #ced4da;
  height: 100%;
  left: 20px;
  top: -50%;
  z-index: 1;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
}
:host([skeleton-loading])::before, :host([skeleton-loading])::after {
  display: none;
}

.timeline-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  background: white;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  cursor: pointer;
  box-sizing: border-box;
  text-decoration: none;
  color: #212529;
  transition: 0.15s ease;
}
.timeline-item atlas-icon {
  transition: 0.15s ease;
  background-color: white;
  z-index: 9;
}
.timeline-item:focus-visible {
  outline: none;
  border-color: #adb5bd;
}
.timeline-item:hover, .timeline-item:active {
  background: var(--atlas-secondary-100);
}
.timeline-item:hover atlas-icon, .timeline-item:active atlas-icon {
  background-color: var(--atlas-secondary-100);
}

.timeline-item-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 0.25rem;
  align-items: flex-start;
}`;

// src/components/display/atlas-text/atlas-text.ts
import { html as html19 } from "lit";
import { customElement as customElement15, property as property20 } from "lit/decorators.js";
import { classMap as classMap10 } from "lit/directives/class-map.js";
import { styleMap as styleMap4 } from "lit/directives/style-map.js";

// src/components/display/atlas-text/atlas-text.scss
import { css as css17 } from "lit-element/lit-element.js";
var atlas_text_default = css17`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.color-white {
  color: #ffffff !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.color-primary {
  color: var(--atlas-primary) !important;
}

.bg-primary {
  background-color: var(--atlas-primary) !important;
}

.color-primary-100 {
  color: var(--atlas-primary-100) !important;
}

.bg-primary-100 {
  background-color: var(--atlas-primary-100) !important;
}

.color-primary-200 {
  color: var(--atlas-primary-200) !important;
}

.bg-primary-200 {
  background-color: var(--atlas-primary-200) !important;
}

.color-primary-300 {
  color: var(--atlas-primary-300) !important;
}

.bg-primary-300 {
  background-color: var(--atlas-primary-300) !important;
}

.color-primary-400 {
  color: var(--atlas-primary-400) !important;
}

.bg-primary-400 {
  background-color: var(--atlas-primary-400) !important;
}

.color-primary-500 {
  color: var(--atlas-primary-500) !important;
}

.bg-primary-500 {
  background-color: var(--atlas-primary-500) !important;
}

.color-primary-600 {
  color: var(--atlas-primary-600) !important;
}

.bg-primary-600 {
  background-color: var(--atlas-primary-600) !important;
}

.color-primary-700 {
  color: var(--atlas-primary-700) !important;
}

.bg-primary-700 {
  background-color: var(--atlas-primary-700) !important;
}

.color-primary-800 {
  color: var(--atlas-primary-800) !important;
}

.bg-primary-800 {
  background-color: var(--atlas-primary-800) !important;
}

.color-primary-900 {
  color: var(--atlas-primary-900) !important;
}

.bg-primary-900 {
  background-color: var(--atlas-primary-900) !important;
}

.active-primary[active], .active-primary.active, .active-primary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-secondary {
  color: var(--atlas-secondary) !important;
}

.bg-secondary {
  background-color: var(--atlas-secondary) !important;
}

.color-secondary-100 {
  color: var(--atlas-secondary-100) !important;
}

.bg-secondary-100 {
  background-color: var(--atlas-secondary-100) !important;
}

.color-secondary-200 {
  color: var(--atlas-secondary-200) !important;
}

.bg-secondary-200 {
  background-color: var(--atlas-secondary-200) !important;
}

.color-secondary-300 {
  color: var(--atlas-secondary-300) !important;
}

.bg-secondary-300 {
  background-color: var(--atlas-secondary-300) !important;
}

.color-secondary-400 {
  color: var(--atlas-secondary-400) !important;
}

.bg-secondary-400 {
  background-color: var(--atlas-secondary-400) !important;
}

.color-secondary-500 {
  color: var(--atlas-secondary-500) !important;
}

.bg-secondary-500 {
  background-color: var(--atlas-secondary-500) !important;
}

.color-secondary-600 {
  color: var(--atlas-secondary-600) !important;
}

.bg-secondary-600 {
  background-color: var(--atlas-secondary-600) !important;
}

.color-secondary-700 {
  color: var(--atlas-secondary-700) !important;
}

.bg-secondary-700 {
  background-color: var(--atlas-secondary-700) !important;
}

.color-secondary-800 {
  color: var(--atlas-secondary-800) !important;
}

.bg-secondary-800 {
  background-color: var(--atlas-secondary-800) !important;
}

.color-secondary-900 {
  color: var(--atlas-secondary-900) !important;
}

.bg-secondary-900 {
  background-color: var(--atlas-secondary-900) !important;
}

.active-secondary[active], .active-secondary.active, .active-secondary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-success {
  color: var(--atlas-success) !important;
}

.bg-success {
  background-color: var(--atlas-success) !important;
}

.color-success-100 {
  color: var(--atlas-success-100) !important;
}

.bg-success-100 {
  background-color: var(--atlas-success-100) !important;
}

.color-success-200 {
  color: var(--atlas-success-200) !important;
}

.bg-success-200 {
  background-color: var(--atlas-success-200) !important;
}

.color-success-300 {
  color: var(--atlas-success-300) !important;
}

.bg-success-300 {
  background-color: var(--atlas-success-300) !important;
}

.color-success-400 {
  color: var(--atlas-success-400) !important;
}

.bg-success-400 {
  background-color: var(--atlas-success-400) !important;
}

.color-success-500 {
  color: var(--atlas-success-500) !important;
}

.bg-success-500 {
  background-color: var(--atlas-success-500) !important;
}

.color-success-600 {
  color: var(--atlas-success-600) !important;
}

.bg-success-600 {
  background-color: var(--atlas-success-600) !important;
}

.color-success-700 {
  color: var(--atlas-success-700) !important;
}

.bg-success-700 {
  background-color: var(--atlas-success-700) !important;
}

.color-success-800 {
  color: var(--atlas-success-800) !important;
}

.bg-success-800 {
  background-color: var(--atlas-success-800) !important;
}

.color-success-900 {
  color: var(--atlas-success-900) !important;
}

.bg-success-900 {
  background-color: var(--atlas-success-900) !important;
}

.active-success[active], .active-success.active, .active-success:active {
  background-color: var(--atlas-success) !important;
  color: var(--atlas-contrast-success) !important;
}

.color-warning {
  color: var(--atlas-warning) !important;
}

.bg-warning {
  background-color: var(--atlas-warning) !important;
}

.color-warning-100 {
  color: var(--atlas-warning-100) !important;
}

.bg-warning-100 {
  background-color: var(--atlas-warning-100) !important;
}

.color-warning-200 {
  color: var(--atlas-warning-200) !important;
}

.bg-warning-200 {
  background-color: var(--atlas-warning-200) !important;
}

.color-warning-300 {
  color: var(--atlas-warning-300) !important;
}

.bg-warning-300 {
  background-color: var(--atlas-warning-300) !important;
}

.color-warning-400 {
  color: var(--atlas-warning-400) !important;
}

.bg-warning-400 {
  background-color: var(--atlas-warning-400) !important;
}

.color-warning-500 {
  color: var(--atlas-warning-500) !important;
}

.bg-warning-500 {
  background-color: var(--atlas-warning-500) !important;
}

.color-warning-600 {
  color: var(--atlas-warning-600) !important;
}

.bg-warning-600 {
  background-color: var(--atlas-warning-600) !important;
}

.color-warning-700 {
  color: var(--atlas-warning-700) !important;
}

.bg-warning-700 {
  background-color: var(--atlas-warning-700) !important;
}

.color-warning-800 {
  color: var(--atlas-warning-800) !important;
}

.bg-warning-800 {
  background-color: var(--atlas-warning-800) !important;
}

.color-warning-900 {
  color: var(--atlas-warning-900) !important;
}

.bg-warning-900 {
  background-color: var(--atlas-warning-900) !important;
}

.active-warning[active], .active-warning.active, .active-warning:active {
  background-color: var(--atlas-warning) !important;
  color: var(--atlas-contrast-warning) !important;
}

.color-danger {
  color: var(--atlas-danger) !important;
}

.bg-danger {
  background-color: var(--atlas-danger) !important;
}

.color-danger-100 {
  color: var(--atlas-danger-100) !important;
}

.bg-danger-100 {
  background-color: var(--atlas-danger-100) !important;
}

.color-danger-200 {
  color: var(--atlas-danger-200) !important;
}

.bg-danger-200 {
  background-color: var(--atlas-danger-200) !important;
}

.color-danger-300 {
  color: var(--atlas-danger-300) !important;
}

.bg-danger-300 {
  background-color: var(--atlas-danger-300) !important;
}

.color-danger-400 {
  color: var(--atlas-danger-400) !important;
}

.bg-danger-400 {
  background-color: var(--atlas-danger-400) !important;
}

.color-danger-500 {
  color: var(--atlas-danger-500) !important;
}

.bg-danger-500 {
  background-color: var(--atlas-danger-500) !important;
}

.color-danger-600 {
  color: var(--atlas-danger-600) !important;
}

.bg-danger-600 {
  background-color: var(--atlas-danger-600) !important;
}

.color-danger-700 {
  color: var(--atlas-danger-700) !important;
}

.bg-danger-700 {
  background-color: var(--atlas-danger-700) !important;
}

.color-danger-800 {
  color: var(--atlas-danger-800) !important;
}

.bg-danger-800 {
  background-color: var(--atlas-danger-800) !important;
}

.color-danger-900 {
  color: var(--atlas-danger-900) !important;
}

.bg-danger-900 {
  background-color: var(--atlas-danger-900) !important;
}

.active-danger[active], .active-danger.active, .active-danger:active {
  background-color: var(--atlas-danger) !important;
  color: var(--atlas-contrast-danger) !important;
}

.color-highlight {
  color: var(--atlas-highlight) !important;
}

.bg-highlight {
  background-color: var(--atlas-highlight) !important;
}

.color-highlight-100 {
  color: var(--atlas-highlight-100) !important;
}

.bg-highlight-100 {
  background-color: var(--atlas-highlight-100) !important;
}

.color-highlight-200 {
  color: var(--atlas-highlight-200) !important;
}

.bg-highlight-200 {
  background-color: var(--atlas-highlight-200) !important;
}

.color-highlight-300 {
  color: var(--atlas-highlight-300) !important;
}

.bg-highlight-300 {
  background-color: var(--atlas-highlight-300) !important;
}

.color-highlight-400 {
  color: var(--atlas-highlight-400) !important;
}

.bg-highlight-400 {
  background-color: var(--atlas-highlight-400) !important;
}

.color-highlight-500 {
  color: var(--atlas-highlight-500) !important;
}

.bg-highlight-500 {
  background-color: var(--atlas-highlight-500) !important;
}

.color-highlight-600 {
  color: var(--atlas-highlight-600) !important;
}

.bg-highlight-600 {
  background-color: var(--atlas-highlight-600) !important;
}

.color-highlight-700 {
  color: var(--atlas-highlight-700) !important;
}

.bg-highlight-700 {
  background-color: var(--atlas-highlight-700) !important;
}

.color-highlight-800 {
  color: var(--atlas-highlight-800) !important;
}

.bg-highlight-800 {
  background-color: var(--atlas-highlight-800) !important;
}

.color-highlight-900 {
  color: var(--atlas-highlight-900) !important;
}

.bg-highlight-900 {
  background-color: var(--atlas-highlight-900) !important;
}

.active-highlight[active], .active-highlight.active, .active-highlight:active {
  background-color: var(--atlas-highlight) !important;
  color: var(--atlas-contrast-highlight) !important;
}

.color-info {
  color: var(--atlas-info) !important;
}

.bg-info {
  background-color: var(--atlas-info) !important;
}

.color-info-100 {
  color: var(--atlas-info-100) !important;
}

.bg-info-100 {
  background-color: var(--atlas-info-100) !important;
}

.color-info-200 {
  color: var(--atlas-info-200) !important;
}

.bg-info-200 {
  background-color: var(--atlas-info-200) !important;
}

.color-info-300 {
  color: var(--atlas-info-300) !important;
}

.bg-info-300 {
  background-color: var(--atlas-info-300) !important;
}

.color-info-400 {
  color: var(--atlas-info-400) !important;
}

.bg-info-400 {
  background-color: var(--atlas-info-400) !important;
}

.color-info-500 {
  color: var(--atlas-info-500) !important;
}

.bg-info-500 {
  background-color: var(--atlas-info-500) !important;
}

.color-info-600 {
  color: var(--atlas-info-600) !important;
}

.bg-info-600 {
  background-color: var(--atlas-info-600) !important;
}

.color-info-700 {
  color: var(--atlas-info-700) !important;
}

.bg-info-700 {
  background-color: var(--atlas-info-700) !important;
}

.color-info-800 {
  color: var(--atlas-info-800) !important;
}

.bg-info-800 {
  background-color: var(--atlas-info-800) !important;
}

.color-info-900 {
  color: var(--atlas-info-900) !important;
}

.bg-info-900 {
  background-color: var(--atlas-info-900) !important;
}

.active-info[active], .active-info.active, .active-info:active {
  background-color: var(--atlas-info) !important;
  color: var(--atlas-contrast-info) !important;
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
:host([alignment=left]),
.text-align-left {
  text-align: left;
}

:host([alignment=center]),
.text-align-center {
  text-align: center;
}

:host([alignment=right]),
.text-align-right {
  text-align: right;
}

:host([alignment=justify]),
.text-align-justify {
  text-align: justify;
}

.text-muted {
  color: #687078 !important;
}

.text-white {
  color: #ffffff !important;
}

:host([ellipsis]) {
  width: 100%;
  overflow: hidden;
}

.ellipsis {
  display: block !important;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.line-clamp {
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

:host {
  display: inline;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}

.atlas-text {
  display: inline;
  line-height: 1.5;
  font-weight: 400;
  color: var(--atlas-text-color, #212529);
}

.bold {
  font-weight: 700;
}

.italic {
  font-style: italic;
}

.underline {
  text-decoration: underline;
}

.strikethrough {
  text-decoration: line-through;
}

.lg {
  font-size: 1.25rem;
}
.lg.skeleton {
  display: block;
  height: 1.875rem;
}

.md {
  font-size: 1rem;
}
.md.skeleton {
  display: block;
  height: 1.5rem;
}

.sm {
  font-size: 0.875rem;
}
.sm.skeleton {
  display: block;
  height: 1.3125rem;
}

.xs {
  font-size: 0.8rem;
}
.xs.skeleton {
  display: block;
  height: 1.2rem;
}`;

// src/components/display/atlas-text/atlas-text.ts
var AtlasText = /*#__PURE__*/(() => {
  let AtlasText = class extends TextElement {
    constructor() {
      super(...arguments);
      this.size = "md";
      this.bold = false;
      this.italic = false;
      this.underline = false;
      this.strikethrough = false;
    }
    /** @internal */
    renderSkeleton() {
      const skeletonClass = {
        "atlas-text": true,
        "skeleton": true,
        [this.size]: !!this.size
      };
      return html19`<div class="${classMap10(skeletonClass)}"></div>`;
    }
    /** @internal */
    renderElement() {
      const textClass = __spreadValues({
        "atlas-text": true,
        "italic": this.italic,
        "underline": this.underline,
        "bold": this.bold,
        "strikethrough": this.strikethrough,
        [this.size]: !!this.size
      }, this.getTextClasses());
      return html19`<span class="${classMap10(textClass)}" style=${styleMap4(this.getTextStyles())} data-atlas-tooltip="text-tooltip">${this.renderContentSlot()}</span>${this.renderEllipsisTooltip()}`;
    }
  };
  AtlasText.styles = atlas_text_default;
  return AtlasText;
})();
__decorateClass([property20({
  type: String
})], AtlasText.prototype, "size", 2);
__decorateClass([property20({
  type: Boolean
})], AtlasText.prototype, "bold", 2);
__decorateClass([property20({
  type: Boolean
})], AtlasText.prototype, "italic", 2);
__decorateClass([property20({
  type: Boolean
})], AtlasText.prototype, "underline", 2);
__decorateClass([property20({
  type: Boolean
})], AtlasText.prototype, "strikethrough", 2);
AtlasText = __decorateClass([customElement15("atlas-text")], AtlasText);

// src/components/dashboard/atlas-calendar-timeline-item/atlas-calendar-timeline-item.ts
var AtlasCalendarTimelineItem = /*#__PURE__*/(() => {
  let AtlasCalendarTimelineItem = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.isLastChild = false;
      this.hidden = false;
      this._hasSlottedDescription = false;
    }
    onChangeHidden() {
      this.toggleAttribute("hidden", this.hidden);
      emit(this, "atlas-timeline-item-hidden-change", {
        trackDisable: true
      });
    }
    handleItemClick() {
      emit(this, "atlas-timeline-item-click");
    }
    onDescriptionChange() {
      this._hasSlottedDescription = !isEmptySlot(this);
    }
    renderDescription() {
      if (this.description) {
        return html20`<atlas-heading size="h5">${this.description}</atlas-heading>`;
      }
      return html20`
            <atlas-heading size="h5" style="${!this._hasSlottedDescription ? "display: none;" : ""}">
                <slot @slotchange=${this.onDescriptionChange}></slot>
            </atlas-heading>
        `;
    }
    renderElement() {
      return html20`
            <a class="timeline-item" href=${ifDefined5(this.href)} @click=${this.handleItemClick} tabindex="0">
                <atlas-icon
                    name=${this.icon}
                    theme=${this.iconTheme}
                    size="3x"
                    theme-variation=${this.iconTheme === "warning" ? 700 : 500}
                ></atlas-icon>
                <div class="timeline-item-content">
                    <atlas-text size="xs">${this.label}</atlas-text>
                    ${this.renderDescription()}
                </div>
                <atlas-icon name="chevron-right" theme="secondary" size="3x"></atlas-icon>
            </a>
        `;
    }
    renderSkeleton() {
      return html20`
            <div class="timeline-item">
                <atlas-heading size="h5"></atlas-heading>
            </div>
        `;
    }
  };
  AtlasCalendarTimelineItem.styles = atlas_calendar_timeline_item_default;
  return AtlasCalendarTimelineItem;
})();
__decorateClass([property21({
  type: String
})], AtlasCalendarTimelineItem.prototype, "label", 2);
__decorateClass([property21({
  type: String
})], AtlasCalendarTimelineItem.prototype, "description", 2);
__decorateClass([property21({
  type: String
})], AtlasCalendarTimelineItem.prototype, "icon", 2);
__decorateClass([property21({
  type: String,
  attribute: "icon-theme"
})], AtlasCalendarTimelineItem.prototype, "iconTheme", 2);
__decorateClass([property21({
  type: String
})], AtlasCalendarTimelineItem.prototype, "href", 2);
__decorateClass([property21({
  type: Boolean,
  attribute: "is-last-child"
})], AtlasCalendarTimelineItem.prototype, "isLastChild", 2);
__decorateClass([property21({
  type: Boolean
})], AtlasCalendarTimelineItem.prototype, "hidden", 2);
__decorateClass([state5()], AtlasCalendarTimelineItem.prototype, "_hasSlottedDescription", 2);
__decorateClass([Watch("hidden", true)], AtlasCalendarTimelineItem.prototype, "onChangeHidden", 1);
AtlasCalendarTimelineItem = __decorateClass([customElement16("atlas-calendar-timeline-item")], AtlasCalendarTimelineItem);

// src/components/dashboard/atlas-chart/atlas-chart.ts
import { html as html21 } from "lit";
import { customElement as customElement17, property as property22, state as state6 } from "lit/decorators.js";
import { classMap as classMap11 } from "lit/directives/class-map.js";
import { when as when12 } from "lit/directives/when.js";

// src/components/dashboard/atlas-chart/billing-type.ts
var BillingType = ["UNDEFINED", "BOLETO", "CREDIT_CARD", "MUNDIPAGG_CIELO", "TRANSFER", "DEPOSIT", "DEBIT_CARD", "PIX", "RECEIVED_IN_CASH"];
var BillingTypeTooltips = {
  RECEIVED_IN_CASH: "em Dinheiro",
  CREDIT_CARD: "no Cart\xE3o de Cr\xE9dito",
  MUNDIPAGG_CIELO: "no Cart\xE3o de Cr\xE9dito",
  DEBIT_CARD: "no Cart\xE3o de D\xE9bito",
  BOLETO: "no Boleto Banc\xE1rio",
  PIX: "no Pix",
  UNDEFINED: "no Pergunte ao cliente",
  DEPOSIT: "no Dep\xF3sito",
  TRANSFER: "pro Transfer\xEAncia",
  BANK_SLIP_WTIH_PIX: "no Boleto Banc\xE1rio/Pix"
};

// src/components/dashboard/atlas-chart/atlas-chart.scss
import { css as css18 } from "lit-element/lit-element.js";
var atlas_chart_default = css18`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.color-white {
  color: #ffffff !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.color-primary {
  color: var(--atlas-primary) !important;
}

.bg-primary {
  background-color: var(--atlas-primary) !important;
}

.color-primary-100 {
  color: var(--atlas-primary-100) !important;
}

.bg-primary-100 {
  background-color: var(--atlas-primary-100) !important;
}

.color-primary-200 {
  color: var(--atlas-primary-200) !important;
}

.bg-primary-200 {
  background-color: var(--atlas-primary-200) !important;
}

.color-primary-300 {
  color: var(--atlas-primary-300) !important;
}

.bg-primary-300 {
  background-color: var(--atlas-primary-300) !important;
}

.color-primary-400 {
  color: var(--atlas-primary-400) !important;
}

.bg-primary-400 {
  background-color: var(--atlas-primary-400) !important;
}

.color-primary-500 {
  color: var(--atlas-primary-500) !important;
}

.bg-primary-500 {
  background-color: var(--atlas-primary-500) !important;
}

.color-primary-600 {
  color: var(--atlas-primary-600) !important;
}

.bg-primary-600 {
  background-color: var(--atlas-primary-600) !important;
}

.color-primary-700 {
  color: var(--atlas-primary-700) !important;
}

.bg-primary-700 {
  background-color: var(--atlas-primary-700) !important;
}

.color-primary-800 {
  color: var(--atlas-primary-800) !important;
}

.bg-primary-800 {
  background-color: var(--atlas-primary-800) !important;
}

.color-primary-900 {
  color: var(--atlas-primary-900) !important;
}

.bg-primary-900 {
  background-color: var(--atlas-primary-900) !important;
}

.active-primary[active], .active-primary.active, .active-primary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-secondary {
  color: var(--atlas-secondary) !important;
}

.bg-secondary {
  background-color: var(--atlas-secondary) !important;
}

.color-secondary-100 {
  color: var(--atlas-secondary-100) !important;
}

.bg-secondary-100 {
  background-color: var(--atlas-secondary-100) !important;
}

.color-secondary-200 {
  color: var(--atlas-secondary-200) !important;
}

.bg-secondary-200 {
  background-color: var(--atlas-secondary-200) !important;
}

.color-secondary-300 {
  color: var(--atlas-secondary-300) !important;
}

.bg-secondary-300 {
  background-color: var(--atlas-secondary-300) !important;
}

.color-secondary-400 {
  color: var(--atlas-secondary-400) !important;
}

.bg-secondary-400 {
  background-color: var(--atlas-secondary-400) !important;
}

.color-secondary-500 {
  color: var(--atlas-secondary-500) !important;
}

.bg-secondary-500 {
  background-color: var(--atlas-secondary-500) !important;
}

.color-secondary-600 {
  color: var(--atlas-secondary-600) !important;
}

.bg-secondary-600 {
  background-color: var(--atlas-secondary-600) !important;
}

.color-secondary-700 {
  color: var(--atlas-secondary-700) !important;
}

.bg-secondary-700 {
  background-color: var(--atlas-secondary-700) !important;
}

.color-secondary-800 {
  color: var(--atlas-secondary-800) !important;
}

.bg-secondary-800 {
  background-color: var(--atlas-secondary-800) !important;
}

.color-secondary-900 {
  color: var(--atlas-secondary-900) !important;
}

.bg-secondary-900 {
  background-color: var(--atlas-secondary-900) !important;
}

.active-secondary[active], .active-secondary.active, .active-secondary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-success {
  color: var(--atlas-success) !important;
}

.bg-success {
  background-color: var(--atlas-success) !important;
}

.color-success-100 {
  color: var(--atlas-success-100) !important;
}

.bg-success-100 {
  background-color: var(--atlas-success-100) !important;
}

.color-success-200 {
  color: var(--atlas-success-200) !important;
}

.bg-success-200 {
  background-color: var(--atlas-success-200) !important;
}

.color-success-300 {
  color: var(--atlas-success-300) !important;
}

.bg-success-300 {
  background-color: var(--atlas-success-300) !important;
}

.color-success-400 {
  color: var(--atlas-success-400) !important;
}

.bg-success-400 {
  background-color: var(--atlas-success-400) !important;
}

.color-success-500 {
  color: var(--atlas-success-500) !important;
}

.bg-success-500 {
  background-color: var(--atlas-success-500) !important;
}

.color-success-600 {
  color: var(--atlas-success-600) !important;
}

.bg-success-600 {
  background-color: var(--atlas-success-600) !important;
}

.color-success-700 {
  color: var(--atlas-success-700) !important;
}

.bg-success-700 {
  background-color: var(--atlas-success-700) !important;
}

.color-success-800 {
  color: var(--atlas-success-800) !important;
}

.bg-success-800 {
  background-color: var(--atlas-success-800) !important;
}

.color-success-900 {
  color: var(--atlas-success-900) !important;
}

.bg-success-900 {
  background-color: var(--atlas-success-900) !important;
}

.active-success[active], .active-success.active, .active-success:active {
  background-color: var(--atlas-success) !important;
  color: var(--atlas-contrast-success) !important;
}

.color-warning {
  color: var(--atlas-warning) !important;
}

.bg-warning {
  background-color: var(--atlas-warning) !important;
}

.color-warning-100 {
  color: var(--atlas-warning-100) !important;
}

.bg-warning-100 {
  background-color: var(--atlas-warning-100) !important;
}

.color-warning-200 {
  color: var(--atlas-warning-200) !important;
}

.bg-warning-200 {
  background-color: var(--atlas-warning-200) !important;
}

.color-warning-300 {
  color: var(--atlas-warning-300) !important;
}

.bg-warning-300 {
  background-color: var(--atlas-warning-300) !important;
}

.color-warning-400 {
  color: var(--atlas-warning-400) !important;
}

.bg-warning-400 {
  background-color: var(--atlas-warning-400) !important;
}

.color-warning-500 {
  color: var(--atlas-warning-500) !important;
}

.bg-warning-500 {
  background-color: var(--atlas-warning-500) !important;
}

.color-warning-600 {
  color: var(--atlas-warning-600) !important;
}

.bg-warning-600 {
  background-color: var(--atlas-warning-600) !important;
}

.color-warning-700 {
  color: var(--atlas-warning-700) !important;
}

.bg-warning-700 {
  background-color: var(--atlas-warning-700) !important;
}

.color-warning-800 {
  color: var(--atlas-warning-800) !important;
}

.bg-warning-800 {
  background-color: var(--atlas-warning-800) !important;
}

.color-warning-900 {
  color: var(--atlas-warning-900) !important;
}

.bg-warning-900 {
  background-color: var(--atlas-warning-900) !important;
}

.active-warning[active], .active-warning.active, .active-warning:active {
  background-color: var(--atlas-warning) !important;
  color: var(--atlas-contrast-warning) !important;
}

.color-danger {
  color: var(--atlas-danger) !important;
}

.bg-danger {
  background-color: var(--atlas-danger) !important;
}

.color-danger-100 {
  color: var(--atlas-danger-100) !important;
}

.bg-danger-100 {
  background-color: var(--atlas-danger-100) !important;
}

.color-danger-200 {
  color: var(--atlas-danger-200) !important;
}

.bg-danger-200 {
  background-color: var(--atlas-danger-200) !important;
}

.color-danger-300 {
  color: var(--atlas-danger-300) !important;
}

.bg-danger-300 {
  background-color: var(--atlas-danger-300) !important;
}

.color-danger-400 {
  color: var(--atlas-danger-400) !important;
}

.bg-danger-400 {
  background-color: var(--atlas-danger-400) !important;
}

.color-danger-500 {
  color: var(--atlas-danger-500) !important;
}

.bg-danger-500 {
  background-color: var(--atlas-danger-500) !important;
}

.color-danger-600 {
  color: var(--atlas-danger-600) !important;
}

.bg-danger-600 {
  background-color: var(--atlas-danger-600) !important;
}

.color-danger-700 {
  color: var(--atlas-danger-700) !important;
}

.bg-danger-700 {
  background-color: var(--atlas-danger-700) !important;
}

.color-danger-800 {
  color: var(--atlas-danger-800) !important;
}

.bg-danger-800 {
  background-color: var(--atlas-danger-800) !important;
}

.color-danger-900 {
  color: var(--atlas-danger-900) !important;
}

.bg-danger-900 {
  background-color: var(--atlas-danger-900) !important;
}

.active-danger[active], .active-danger.active, .active-danger:active {
  background-color: var(--atlas-danger) !important;
  color: var(--atlas-contrast-danger) !important;
}

.color-highlight {
  color: var(--atlas-highlight) !important;
}

.bg-highlight {
  background-color: var(--atlas-highlight) !important;
}

.color-highlight-100 {
  color: var(--atlas-highlight-100) !important;
}

.bg-highlight-100 {
  background-color: var(--atlas-highlight-100) !important;
}

.color-highlight-200 {
  color: var(--atlas-highlight-200) !important;
}

.bg-highlight-200 {
  background-color: var(--atlas-highlight-200) !important;
}

.color-highlight-300 {
  color: var(--atlas-highlight-300) !important;
}

.bg-highlight-300 {
  background-color: var(--atlas-highlight-300) !important;
}

.color-highlight-400 {
  color: var(--atlas-highlight-400) !important;
}

.bg-highlight-400 {
  background-color: var(--atlas-highlight-400) !important;
}

.color-highlight-500 {
  color: var(--atlas-highlight-500) !important;
}

.bg-highlight-500 {
  background-color: var(--atlas-highlight-500) !important;
}

.color-highlight-600 {
  color: var(--atlas-highlight-600) !important;
}

.bg-highlight-600 {
  background-color: var(--atlas-highlight-600) !important;
}

.color-highlight-700 {
  color: var(--atlas-highlight-700) !important;
}

.bg-highlight-700 {
  background-color: var(--atlas-highlight-700) !important;
}

.color-highlight-800 {
  color: var(--atlas-highlight-800) !important;
}

.bg-highlight-800 {
  background-color: var(--atlas-highlight-800) !important;
}

.color-highlight-900 {
  color: var(--atlas-highlight-900) !important;
}

.bg-highlight-900 {
  background-color: var(--atlas-highlight-900) !important;
}

.active-highlight[active], .active-highlight.active, .active-highlight:active {
  background-color: var(--atlas-highlight) !important;
  color: var(--atlas-contrast-highlight) !important;
}

.color-info {
  color: var(--atlas-info) !important;
}

.bg-info {
  background-color: var(--atlas-info) !important;
}

.color-info-100 {
  color: var(--atlas-info-100) !important;
}

.bg-info-100 {
  background-color: var(--atlas-info-100) !important;
}

.color-info-200 {
  color: var(--atlas-info-200) !important;
}

.bg-info-200 {
  background-color: var(--atlas-info-200) !important;
}

.color-info-300 {
  color: var(--atlas-info-300) !important;
}

.bg-info-300 {
  background-color: var(--atlas-info-300) !important;
}

.color-info-400 {
  color: var(--atlas-info-400) !important;
}

.bg-info-400 {
  background-color: var(--atlas-info-400) !important;
}

.color-info-500 {
  color: var(--atlas-info-500) !important;
}

.bg-info-500 {
  background-color: var(--atlas-info-500) !important;
}

.color-info-600 {
  color: var(--atlas-info-600) !important;
}

.bg-info-600 {
  background-color: var(--atlas-info-600) !important;
}

.color-info-700 {
  color: var(--atlas-info-700) !important;
}

.bg-info-700 {
  background-color: var(--atlas-info-700) !important;
}

.color-info-800 {
  color: var(--atlas-info-800) !important;
}

.bg-info-800 {
  background-color: var(--atlas-info-800) !important;
}

.color-info-900 {
  color: var(--atlas-info-900) !important;
}

.bg-info-900 {
  background-color: var(--atlas-info-900) !important;
}

.active-info[active], .active-info.active, .active-info:active {
  background-color: var(--atlas-info) !important;
  color: var(--atlas-contrast-info) !important;
}

.atlas-chart {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 1rem;
  margin: 0.125rem 0;
  border-radius: 0.25rem;
  background-size: auto;
  background-image: url('data:image/svg+xml,%3csvg xmlns="http://www.w3.org/2000/svg" width="19" height="16" viewBox="0 0 19 16" fill="none"%3e%3cpath d="M9.42257 2.62239e-07L18.0419 8.34465e-06L8.80414 16L0.185939 16.0001L9.42257 2.62239e-07Z" fill="white" fill-opacity="0.65"/%3e%3c/svg%3e');
}
.atlas-chart .chart-wrap {
  height: 100%;
  transition: all 0.35s ease-out;
  width: 0;
  display: flex;
  align-items: center;
}
.atlas-chart.has-chart .chart-wrap {
  width: 100%;
}
.atlas-chart atlas-bar-chart-item:first-child {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.atlas-chart atlas-bar-chart-item:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.chart.skeleton {
  height: 1.25rem;
}`;

// src/components/dashboard/atlas-chart/atlas-chart.ts
var AtlasChart = /*#__PURE__*/(() => {
  let AtlasChart = class extends WithTooltipMixin(AtlasElement) {
    constructor() {
      super(...arguments);
      this.type = "bar";
      this.ignoreBillingType = false;
      this._chartValues = [];
      this._billingTypeArray = BillingType;
      this._defaultTooltipMessage = "N\xE3o h\xE1 dados para visualizar";
      this._itemMinWidth = 10;
    }
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.updateComplete.then(() => {
        if (this._chartValues.length === 0) {
          this.tooltip = this._defaultTooltipMessage;
        }
      });
    }
    /**
     * Define os valores do gráfico
     * @param {object} options - Objeto que contém os valores a serem exibidos e atribuídos ao gráfico
     */
    setValues(values) {
      this.values = values;
    }
    /** Limpa os valores do gráfico, restaurando o estado inicial */
    cleanValues() {
      this._hasValues = false;
      setTimeout(() => {
        this.tooltip = this._defaultTooltipMessage;
        this._chartValues = [];
        this.values = [];
      }, 350);
    }
    onChangeChartValues() {
      this._hasValues = this.values && Object.keys(this.values).length > 0;
      this.tooltip = !this._hasValues ? this._defaultTooltipMessage : "";
      this.buildChartValuesArray();
      this.sortDescendingOrderValues();
    }
    buildChartValuesArray() {
      this._chartValues = [];
      if (this.ignoreBillingType) {
        const objKeys = Object.keys(this.values);
        objKeys.forEach(key => {
          const value = parseFloat(this.values[key]);
          if (value > 0) this._chartValues.push({
            type: key,
            value
          });
        });
        return;
      }
      this._billingTypeArray.forEach(type => {
        if (!this.values[type]) return;
        const value = parseFloat(this.values[type]);
        if (value > 0) this._chartValues.push({
          type,
          value
        });
      });
    }
    sortDescendingOrderValues() {
      this._chartValues.sort((objectA, objectB) => objectB.value - objectA.value);
    }
    getTotalValue() {
      if (this._chartValues.length === 0) return 0;
      const sumValues = this._chartValues.reduce((acc, object) => acc + object.value, 0);
      if (typeof this.totalValue === "undefined") return sumValues;
      return sumValues > this.totalValue ? sumValues : this.totalValue;
    }
    getWidth(index) {
      const width = this._chartValues[index].value / this.getTotalValue() * 100;
      return width < this._itemMinWidth ? this._itemMinWidth : width;
    }
    getVariation(index) {
      const maxChartItems = 7;
      const themeVariation = this.initialThemeVariation / 100 || maxChartItems;
      return `${themeVariation - index}00`;
    }
    getTooltip(chartObject) {
      if (this.customTooltipValues && this.customTooltipValues[chartObject.type]) {
        return `R$ 
                ${formatMoney(chartObject.value)} 
                ${this.customTooltipValues[chartObject.type]}
            `;
      }
      if (BillingTypeTooltips[chartObject.type]) {
        return `R$ 
                ${formatMoney(chartObject.value)}
                ${BillingTypeTooltips[chartObject.type]}
            `;
      }
      return "";
    }
    renderBar() {
      return this._chartValues.map((chartObject, index) => html21`
                <atlas-bar-chart-item
                    theme="${this.theme}"
                    variation="${this.getVariation(index)}"
                    width="${this.getWidth(index)}"
                    tooltip="${this.getTooltip(chartObject)}"
                ></atlas-bar-chart-item>
            `);
    }
    renderElement() {
      const chartClass = {
        "atlas-chart": true,
        [`bg-${this.theme}-200`]: true,
        "has-chart": this._hasValues
      };
      return html21`
            <div class="${classMap11(chartClass)}" data-atlas-tooltip="chart-tooltip">
                <div class="chart-wrap">${when12(this.type === "bar", () => this.renderBar())}</div>
            </div>
            ${this.renderTooltip("chart-tooltip")}
        `;
    }
    renderSkeleton() {
      return html21` <div class="chart skeleton"></div> `;
    }
  };
  AtlasChart.styles = atlas_chart_default;
  return AtlasChart;
})();
__decorateClass([property22({
  type: String
})], AtlasChart.prototype, "type", 2);
__decorateClass([property22({
  type: String
})], AtlasChart.prototype, "theme", 2);
__decorateClass([property22({
  type: Object
})], AtlasChart.prototype, "values", 2);
__decorateClass([property22({
  type: Boolean,
  attribute: "ignore-billing-type",
  reflect: true
})], AtlasChart.prototype, "ignoreBillingType", 2);
__decorateClass([property22({
  type: Object,
  attribute: "custom-tooltip-values"
})], AtlasChart.prototype, "customTooltipValues", 2);
__decorateClass([property22({
  type: Number,
  attribute: "initial-theme-variation"
})], AtlasChart.prototype, "initialThemeVariation", 2);
__decorateClass([property22({
  type: Number,
  attribute: "total-value"
})], AtlasChart.prototype, "totalValue", 2);
__decorateClass([state6()], AtlasChart.prototype, "_hasValues", 2);
__decorateClass([state6()], AtlasChart.prototype, "_chartValues", 2);
__decorateClass([state6()], AtlasChart.prototype, "_billingTypeArray", 2);
__decorateClass([Watch("values")], AtlasChart.prototype, "onChangeChartValues", 1);
AtlasChart = __decorateClass([customElement17("atlas-chart")], AtlasChart);

// src/components/dashboard/atlas-onboarding/atlas-onboarding.ts
import { LitElement as LitElement5, html as html23 } from "lit";
import { customElement as customElement19, property as property24, state as state7 } from "lit/decorators.js";
import { classMap as classMap13 } from "lit/directives/class-map.js";
import { styleMap as styleMap5 } from "lit/directives/style-map.js";

// src/components/dashboard/atlas-onboarding/atlas-onboarding.scss
import { css as css19 } from "lit-element/lit-element.js";
var atlas_onboarding_default = css19`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
.onboarding {
  display: flex;
  flex-direction: column;
  border-radius: 0.5rem;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  width: 100%;
  background: #ffffff;
}

.onboarding-illustration {
  width: 348px;
  flex-shrink: 0;
  padding: 3rem 2rem;
  box-sizing: border-box;
  display: none;
  align-items: center;
  background: linear-gradient(5deg, #001e97 8.33%, #0023a5 24.48%, #002cbd 38.54%, #0033ce 59%, #0037d8 72%, #0039dc 89%);
}
.onboarding-illustration.bg-theme-primary-100 {
  background: linear-gradient(to bottom, var(--atlas-primary-100), var(--atlas-primary-200));
}
.onboarding-illustration.bg-theme-primary-200 {
  background: linear-gradient(to bottom, var(--atlas-primary-200), var(--atlas-primary-300));
}
.onboarding-illustration.bg-theme-primary-300 {
  background: linear-gradient(to bottom, var(--atlas-primary-300), var(--atlas-primary-400));
}
.onboarding-illustration.bg-theme-primary-400 {
  background: linear-gradient(to bottom, var(--atlas-primary-400), var(--atlas-primary-500));
}
.onboarding-illustration.bg-theme-primary-500 {
  background: linear-gradient(to bottom, var(--atlas-primary-500), var(--atlas-primary-600));
}
.onboarding-illustration.bg-theme-primary-600 {
  background: linear-gradient(to bottom, var(--atlas-primary-600), var(--atlas-primary-700));
}
.onboarding-illustration.bg-theme-primary-700 {
  background: linear-gradient(to bottom, var(--atlas-primary-700), var(--atlas-primary-800));
}
.onboarding-illustration.bg-theme-primary-800 {
  background: linear-gradient(to bottom, var(--atlas-primary-800), var(--atlas-primary-900));
}
.onboarding-illustration.bg-theme-primary-900 {
  background: linear-gradient(to bottom, var(--atlas-primary-900), var(--atlas-primary-100));
}
.onboarding-illustration.bg-theme-secondary-100 {
  background: linear-gradient(to bottom, var(--atlas-secondary-100), var(--atlas-secondary-200));
}
.onboarding-illustration.bg-theme-secondary-200 {
  background: linear-gradient(to bottom, var(--atlas-secondary-200), var(--atlas-secondary-300));
}
.onboarding-illustration.bg-theme-secondary-300 {
  background: linear-gradient(to bottom, var(--atlas-secondary-300), var(--atlas-secondary-400));
}
.onboarding-illustration.bg-theme-secondary-400 {
  background: linear-gradient(to bottom, var(--atlas-secondary-400), var(--atlas-secondary-500));
}
.onboarding-illustration.bg-theme-secondary-500 {
  background: linear-gradient(to bottom, var(--atlas-secondary-500), var(--atlas-secondary-600));
}
.onboarding-illustration.bg-theme-secondary-600 {
  background: linear-gradient(to bottom, var(--atlas-secondary-600), var(--atlas-secondary-700));
}
.onboarding-illustration.bg-theme-secondary-700 {
  background: linear-gradient(to bottom, var(--atlas-secondary-700), var(--atlas-secondary-800));
}
.onboarding-illustration.bg-theme-secondary-800 {
  background: linear-gradient(to bottom, var(--atlas-secondary-800), var(--atlas-secondary-900));
}
.onboarding-illustration.bg-theme-secondary-900 {
  background: linear-gradient(to bottom, var(--atlas-secondary-900), var(--atlas-secondary-100));
}
.onboarding-illustration.bg-theme-success-100 {
  background: linear-gradient(to bottom, var(--atlas-success-100), var(--atlas-success-200));
}
.onboarding-illustration.bg-theme-success-200 {
  background: linear-gradient(to bottom, var(--atlas-success-200), var(--atlas-success-300));
}
.onboarding-illustration.bg-theme-success-300 {
  background: linear-gradient(to bottom, var(--atlas-success-300), var(--atlas-success-400));
}
.onboarding-illustration.bg-theme-success-400 {
  background: linear-gradient(to bottom, var(--atlas-success-400), var(--atlas-success-500));
}
.onboarding-illustration.bg-theme-success-500 {
  background: linear-gradient(to bottom, var(--atlas-success-500), var(--atlas-success-600));
}
.onboarding-illustration.bg-theme-success-600 {
  background: linear-gradient(to bottom, var(--atlas-success-600), var(--atlas-success-700));
}
.onboarding-illustration.bg-theme-success-700 {
  background: linear-gradient(to bottom, var(--atlas-success-700), var(--atlas-success-800));
}
.onboarding-illustration.bg-theme-success-800 {
  background: linear-gradient(to bottom, var(--atlas-success-800), var(--atlas-success-900));
}
.onboarding-illustration.bg-theme-success-900 {
  background: linear-gradient(to bottom, var(--atlas-success-900), var(--atlas-success-100));
}
.onboarding-illustration.bg-theme-warning-100 {
  background: linear-gradient(to bottom, var(--atlas-warning-100), var(--atlas-warning-200));
}
.onboarding-illustration.bg-theme-warning-200 {
  background: linear-gradient(to bottom, var(--atlas-warning-200), var(--atlas-warning-300));
}
.onboarding-illustration.bg-theme-warning-300 {
  background: linear-gradient(to bottom, var(--atlas-warning-300), var(--atlas-warning-400));
}
.onboarding-illustration.bg-theme-warning-400 {
  background: linear-gradient(to bottom, var(--atlas-warning-400), var(--atlas-warning-500));
}
.onboarding-illustration.bg-theme-warning-500 {
  background: linear-gradient(to bottom, var(--atlas-warning-500), var(--atlas-warning-600));
}
.onboarding-illustration.bg-theme-warning-600 {
  background: linear-gradient(to bottom, var(--atlas-warning-600), var(--atlas-warning-700));
}
.onboarding-illustration.bg-theme-warning-700 {
  background: linear-gradient(to bottom, var(--atlas-warning-700), var(--atlas-warning-800));
}
.onboarding-illustration.bg-theme-warning-800 {
  background: linear-gradient(to bottom, var(--atlas-warning-800), var(--atlas-warning-900));
}
.onboarding-illustration.bg-theme-warning-900 {
  background: linear-gradient(to bottom, var(--atlas-warning-900), var(--atlas-warning-100));
}
.onboarding-illustration.bg-theme-danger-100 {
  background: linear-gradient(to bottom, var(--atlas-danger-100), var(--atlas-danger-200));
}
.onboarding-illustration.bg-theme-danger-200 {
  background: linear-gradient(to bottom, var(--atlas-danger-200), var(--atlas-danger-300));
}
.onboarding-illustration.bg-theme-danger-300 {
  background: linear-gradient(to bottom, var(--atlas-danger-300), var(--atlas-danger-400));
}
.onboarding-illustration.bg-theme-danger-400 {
  background: linear-gradient(to bottom, var(--atlas-danger-400), var(--atlas-danger-500));
}
.onboarding-illustration.bg-theme-danger-500 {
  background: linear-gradient(to bottom, var(--atlas-danger-500), var(--atlas-danger-600));
}
.onboarding-illustration.bg-theme-danger-600 {
  background: linear-gradient(to bottom, var(--atlas-danger-600), var(--atlas-danger-700));
}
.onboarding-illustration.bg-theme-danger-700 {
  background: linear-gradient(to bottom, var(--atlas-danger-700), var(--atlas-danger-800));
}
.onboarding-illustration.bg-theme-danger-800 {
  background: linear-gradient(to bottom, var(--atlas-danger-800), var(--atlas-danger-900));
}
.onboarding-illustration.bg-theme-danger-900 {
  background: linear-gradient(to bottom, var(--atlas-danger-900), var(--atlas-danger-100));
}
.onboarding-illustration.bg-theme-highlight-100 {
  background: linear-gradient(to bottom, var(--atlas-highlight-100), var(--atlas-highlight-200));
}
.onboarding-illustration.bg-theme-highlight-200 {
  background: linear-gradient(to bottom, var(--atlas-highlight-200), var(--atlas-highlight-300));
}
.onboarding-illustration.bg-theme-highlight-300 {
  background: linear-gradient(to bottom, var(--atlas-highlight-300), var(--atlas-highlight-400));
}
.onboarding-illustration.bg-theme-highlight-400 {
  background: linear-gradient(to bottom, var(--atlas-highlight-400), var(--atlas-highlight-500));
}
.onboarding-illustration.bg-theme-highlight-500 {
  background: linear-gradient(to bottom, var(--atlas-highlight-500), var(--atlas-highlight-600));
}
.onboarding-illustration.bg-theme-highlight-600 {
  background: linear-gradient(to bottom, var(--atlas-highlight-600), var(--atlas-highlight-700));
}
.onboarding-illustration.bg-theme-highlight-700 {
  background: linear-gradient(to bottom, var(--atlas-highlight-700), var(--atlas-highlight-800));
}
.onboarding-illustration.bg-theme-highlight-800 {
  background: linear-gradient(to bottom, var(--atlas-highlight-800), var(--atlas-highlight-900));
}
.onboarding-illustration.bg-theme-highlight-900 {
  background: linear-gradient(to bottom, var(--atlas-highlight-900), var(--atlas-highlight-100));
}
.onboarding-illustration.bg-theme-info-100 {
  background: linear-gradient(to bottom, var(--atlas-info-100), var(--atlas-info-200));
}
.onboarding-illustration.bg-theme-info-200 {
  background: linear-gradient(to bottom, var(--atlas-info-200), var(--atlas-info-300));
}
.onboarding-illustration.bg-theme-info-300 {
  background: linear-gradient(to bottom, var(--atlas-info-300), var(--atlas-info-400));
}
.onboarding-illustration.bg-theme-info-400 {
  background: linear-gradient(to bottom, var(--atlas-info-400), var(--atlas-info-500));
}
.onboarding-illustration.bg-theme-info-500 {
  background: linear-gradient(to bottom, var(--atlas-info-500), var(--atlas-info-600));
}
.onboarding-illustration.bg-theme-info-600 {
  background: linear-gradient(to bottom, var(--atlas-info-600), var(--atlas-info-700));
}
.onboarding-illustration.bg-theme-info-700 {
  background: linear-gradient(to bottom, var(--atlas-info-700), var(--atlas-info-800));
}
.onboarding-illustration.bg-theme-info-800 {
  background: linear-gradient(to bottom, var(--atlas-info-800), var(--atlas-info-900));
}
.onboarding-illustration.bg-theme-info-900 {
  background: linear-gradient(to bottom, var(--atlas-info-900), var(--atlas-info-100));
}

.onboarding-content {
  flex: 1 1 100%;
  padding: 1rem;
  display: flex;
  flex-direction: column;
}

.onboarding-stepper-wrapper {
  box-sizing: border-box;
  display: flex;
  padding-top: 1rem;
}
.onboarding-stepper-wrapper .onboarding-stepper {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  position: relative;
  width: 100%;
}
.onboarding-stepper-wrapper .onboarding-stepper .step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  z-index: 1;
}
.onboarding-stepper-wrapper .onboarding-stepper .step atlas-icon {
  background: #ffffff;
  padding: 0.25rem;
}
.onboarding-stepper-wrapper .onboarding-stepper .step atlas-text {
  display: none;
}
.onboarding-stepper-wrapper .onboarding-stepper .stepper-line {
  position: absolute;
  background: #ced4da;
  top: 0.75rem;
  height: 1px;
}

@media screen and (min-width: 992px) {
  .onboarding {
    flex-direction: row;
  }
  .onboarding-illustration {
    padding: 3rem 2rem;
    display: flex;
  }
  .onboarding-content {
    padding: 2rem;
  }
  .onboarding-stepper-wrapper {
    margin-top: auto;
  }
  .onboarding-stepper-wrapper .onboarding-stepper .step atlas-text {
    display: inline-flex;
  }
}`;

// src/components/display/atlas-illustration/atlas-illustration.ts
import { html as html22 } from "lit";
import { customElement as customElement18, property as property23 } from "lit/decorators.js";
import { classMap as classMap12 } from "lit/directives/class-map.js";

// src/components/display/atlas-illustration/atlas-illustration.scss
import { css as css20 } from "lit-element/lit-element.js";
var atlas_illustration_default = css20`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: contents;
}

.atlas-illustration {
  box-sizing: border-box;
  width: 100%;
}
.atlas-illustration img {
  width: 100%;
  height: 100%;
}
.atlas-illustration.xs {
  height: 120px;
}
.atlas-illustration.sm {
  height: 160px;
}
.atlas-illustration.md {
  height: 200px;
}
.atlas-illustration.lg {
  height: 240px;
}
.atlas-illustration.xlg {
  height: 280px;
}
.atlas-illustration.skeleton img {
  visibility: hidden;
}
.atlas-illustration.scale-vertically {
  width: auto;
  height: 100%;
}
.atlas-illustration.scale-vertically img {
  width: auto;
  height: 100%;
}`;

// src/components/display/atlas-illustration/atlas-illustration.ts
var AtlasIllustration = /*#__PURE__*/(() => {
  let AtlasIllustration = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.size = "md";
    }
    getIllustrationPath() {
      return getAssetPath(`assets/illustrations/${this.name}.svg`);
    }
    render() {
      const illustrationClass = {
        "atlas-illustration": true,
        "scale-vertically": this.scaleVertically,
        [`${this.size}`]: !!this.size,
        "skeleton": this.skeletonLoading
      };
      return html22`
            <div class=${classMap12(illustrationClass)}>
                <img src="${this.getIllustrationPath()}" alt="${this.alt}" />
            </div>
        `;
    }
  };
  AtlasIllustration.styles = atlas_illustration_default;
  return AtlasIllustration;
})();
__decorateClass([property23({
  type: String
})], AtlasIllustration.prototype, "name", 2);
__decorateClass([property23({
  type: String
})], AtlasIllustration.prototype, "size", 2);
__decorateClass([property23({
  type: String
})], AtlasIllustration.prototype, "alt", 2);
__decorateClass([property23({
  type: Boolean,
  attribute: "scale-vertically"
})], AtlasIllustration.prototype, "scaleVertically", 2);
AtlasIllustration = __decorateClass([customElement18("atlas-illustration")], AtlasIllustration);

// src/components/dashboard/atlas-onboarding/atlas-onboarding.ts
var AtlasOnboarding = /*#__PURE__*/(() => {
  let AtlasOnboarding = class extends LitElement5 {
    constructor() {
      super(...arguments);
      this.themeVariation = 500;
      this._stepperLinePosition = {
        left: "0px",
        width: "0px"
      };
      this._deviceController = new DeviceController(this);
    }
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.syncSteps = this.syncSteps.bind(this);
      this.calculateStepperLinePosition = this.calculateStepperLinePosition.bind(this);
      this.addEventListener("atlas-onboarding-step-change", this.syncSteps);
      this._deviceController.setScreenChangeCallback(this.calculateStepperLinePosition);
    }
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      this.removeEventListener("atlas-onboarding-step-change", this.syncSteps);
    }
    calculateStepperLinePosition() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const stepsElement = this.shadowRoot.querySelectorAll(".step");
        const firstStep = stepsElement[0];
        const lastStep = stepsElement[stepsElement.length - 1];
        const firstStepWidth = firstStep.getBoundingClientRect().width;
        const lastStepWidth = lastStep.getBoundingClientRect().width;
        this._stepperLinePosition = {
          left: `${firstStepWidth / 2}px`,
          width: `calc(100% - ${firstStepWidth / 2 + lastStepWidth / 2}px)`
        };
      });
    }
    syncSteps() {
      this._steps = this.shadowRoot.querySelector("slot").assignedElements().map(step => {
        if (step.name === this.currentStep) {
          this._currentIllustration = step.illustration;
        }
        return step;
      });
      this.calculateStepperLinePosition();
    }
    setVisibleStep() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this._steps.forEach(step => {
          if (step.name === this.currentStep) {
            step.setVisible(true);
            this._currentIllustration = step.illustration;
          } else {
            step.setVisible(false);
          }
        });
      });
    }
    renderOnboardingSteps() {
      var _a;
      return (_a = this._steps) == null ? void 0 : _a.map(step => {
        const isActive = step.name === this.currentStep;
        const icon = step.getStatusIcon();
        const theme = step.getStatusTheme();
        const stepClass = {
          step: true,
          active: isActive
        };
        return html23`
                <div class=${classMap13(stepClass)}>
                    <atlas-icon
                        name=${isActive && step.status === "pending" ? "concentric-circles" : icon}
                        theme=${isActive && step.status === "pending" ? "primary" : theme}
                        size="2x"
                        ?disabled=${!isActive && step.status === "pending"}
                    ></atlas-icon>
                    <atlas-text size="xs" ?muted=${!isActive}>${step.label}</atlas-text>
                </div>
            `;
      });
    }
    render() {
      const chartClass = {
        "onboarding-illustration": true,
        [`bg-theme-${this.theme}-${this.themeVariation}`]: this.theme && this.themeVariation
      };
      return html23`
            <div class="onboarding">
                <div class="${classMap13(chartClass)}">
                    <atlas-illustration name=${this._currentIllustration}></atlas-illustration>
                </div>
                <div class="onboarding-content">
                    <slot @slotchange=${this.syncSteps}></slot>
                    <div class="onboarding-stepper-wrapper">
                        <div class="onboarding-stepper">
                            ${this.renderOnboardingSteps()}
                            <div class="stepper-line" style=${styleMap5(this._stepperLinePosition)}></div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
  };
  AtlasOnboarding.styles = atlas_onboarding_default;
  return AtlasOnboarding;
})();
__decorateClass([property24({
  type: String,
  attribute: "current-step"
})], AtlasOnboarding.prototype, "currentStep", 2);
__decorateClass([property24({
  type: String,
  attribute: "theme"
})], AtlasOnboarding.prototype, "theme", 2);
__decorateClass([property24({
  type: Number,
  attribute: "theme-variation"
})], AtlasOnboarding.prototype, "themeVariation", 2);
__decorateClass([state7()], AtlasOnboarding.prototype, "_steps", 2);
__decorateClass([state7()], AtlasOnboarding.prototype, "_currentIllustration", 2);
__decorateClass([state7()], AtlasOnboarding.prototype, "_stepperLinePosition", 2);
__decorateClass([Watch("currentStep")], AtlasOnboarding.prototype, "setVisibleStep", 1);
AtlasOnboarding = __decorateClass([customElement19("atlas-onboarding")], AtlasOnboarding);

// src/components/dashboard/atlas-onboarding-step/atlas-onboarding-step.ts
import { LitElement as LitElement7, html as html26 } from "lit";
import { customElement as customElement21, property as property27, state as state8 } from "lit/decorators.js";
import { classMap as classMap15 } from "lit/directives/class-map.js";
import { when as when14 } from "lit/directives/when.js";

// src/internals/mixins/with-badge-mixin.ts
import { html as html24 } from "lit";
import { property as property25 } from "lit/decorators.js";
import { when as when13 } from "lit/directives/when.js";
var WithBadgeMixin = superClass => {
  class WithBadgeClass extends superClass {
    constructor() {
      super(...arguments);
      this.badgeType = "filled";
      this.badgeIsCounter = false;
      this.badgeShowZero = false;
      this.badgeTooltipPlacement = "bottom";
      this.badgeTooltipTrigger = "hover focus";
    }
    getAllBadgeProps() {
      return {
        "badge-type": this.badgeType,
        "badge-text": this.badgeText,
        "badge-icon": this.badgeIcon,
        "badge-theme": this.badgeTheme,
        "badge-is-counter": this.badgeIsCounter,
        "badge-show-zero": this.badgeShowZero,
        "badge-tooltip": this.badgeTooltip,
        "badge-tooltip-placement": this.badgeTooltipPlacement,
        "badge-tooltip-trigger": this.badgeTooltipTrigger
      };
    }
    hasBadge() {
      return !!this.badgeText;
    }
    renderBadge() {
      return when13(!!this.hasBadge(), () => html24`
                    <atlas-badge
                        icon=${this.badgeIcon}
                        text=${this.badgeText}
                        theme=${this.badgeTheme || "primary"}
                        type=${this.badgeType}
                        tooltip=${this.badgeTooltip}
                        tooltip-placement=${this.badgeTooltipPlacement}
                        tooltip-trigger=${this.badgeTooltipTrigger}
                        ?is-counter=${this.badgeIsCounter}
                        ?show-zero=${this.badgeShowZero}
                    ></atlas-badge>
                `);
    }
  }
  __decorateClass([property25({
    type: String,
    attribute: "badge-type"
  })], WithBadgeClass.prototype, "badgeType", 2);
  __decorateClass([property25({
    type: String,
    attribute: "badge-text"
  })], WithBadgeClass.prototype, "badgeText", 2);
  __decorateClass([property25({
    type: String,
    attribute: "badge-icon"
  })], WithBadgeClass.prototype, "badgeIcon", 2);
  __decorateClass([property25({
    type: String,
    attribute: "badge-theme"
  })], WithBadgeClass.prototype, "badgeTheme", 2);
  __decorateClass([property25({
    type: Boolean,
    attribute: "badge-is-counter"
  })], WithBadgeClass.prototype, "badgeIsCounter", 2);
  __decorateClass([property25({
    type: Boolean,
    attribute: "badge-show-zero"
  })], WithBadgeClass.prototype, "badgeShowZero", 2);
  __decorateClass([property25({
    type: String,
    attribute: "badge-tooltip"
  })], WithBadgeClass.prototype, "badgeTooltip", 2);
  __decorateClass([property25({
    type: String,
    attribute: "badge-tooltip-placement"
  })], WithBadgeClass.prototype, "badgeTooltipPlacement", 2);
  __decorateClass([property25({
    type: String,
    attribute: "badge-tooltip-trigger"
  })], WithBadgeClass.prototype, "badgeTooltipTrigger", 2);
  return WithBadgeClass;
};

// src/components/dashboard/atlas-onboarding-step/atlas-onboarding-step.scss
import { css as css21 } from "lit-element/lit-element.js";
var atlas_onboarding_step_default = css21`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.color-white {
  color: #ffffff !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.color-primary {
  color: var(--atlas-primary) !important;
}

.bg-primary {
  background-color: var(--atlas-primary) !important;
}

.color-primary-100 {
  color: var(--atlas-primary-100) !important;
}

.bg-primary-100 {
  background-color: var(--atlas-primary-100) !important;
}

.color-primary-200 {
  color: var(--atlas-primary-200) !important;
}

.bg-primary-200 {
  background-color: var(--atlas-primary-200) !important;
}

.color-primary-300 {
  color: var(--atlas-primary-300) !important;
}

.bg-primary-300 {
  background-color: var(--atlas-primary-300) !important;
}

.color-primary-400 {
  color: var(--atlas-primary-400) !important;
}

.bg-primary-400 {
  background-color: var(--atlas-primary-400) !important;
}

.color-primary-500 {
  color: var(--atlas-primary-500) !important;
}

.bg-primary-500 {
  background-color: var(--atlas-primary-500) !important;
}

.color-primary-600 {
  color: var(--atlas-primary-600) !important;
}

.bg-primary-600 {
  background-color: var(--atlas-primary-600) !important;
}

.color-primary-700 {
  color: var(--atlas-primary-700) !important;
}

.bg-primary-700 {
  background-color: var(--atlas-primary-700) !important;
}

.color-primary-800 {
  color: var(--atlas-primary-800) !important;
}

.bg-primary-800 {
  background-color: var(--atlas-primary-800) !important;
}

.color-primary-900 {
  color: var(--atlas-primary-900) !important;
}

.bg-primary-900 {
  background-color: var(--atlas-primary-900) !important;
}

.active-primary[active], .active-primary.active, .active-primary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-secondary {
  color: var(--atlas-secondary) !important;
}

.bg-secondary {
  background-color: var(--atlas-secondary) !important;
}

.color-secondary-100 {
  color: var(--atlas-secondary-100) !important;
}

.bg-secondary-100 {
  background-color: var(--atlas-secondary-100) !important;
}

.color-secondary-200 {
  color: var(--atlas-secondary-200) !important;
}

.bg-secondary-200 {
  background-color: var(--atlas-secondary-200) !important;
}

.color-secondary-300 {
  color: var(--atlas-secondary-300) !important;
}

.bg-secondary-300 {
  background-color: var(--atlas-secondary-300) !important;
}

.color-secondary-400 {
  color: var(--atlas-secondary-400) !important;
}

.bg-secondary-400 {
  background-color: var(--atlas-secondary-400) !important;
}

.color-secondary-500 {
  color: var(--atlas-secondary-500) !important;
}

.bg-secondary-500 {
  background-color: var(--atlas-secondary-500) !important;
}

.color-secondary-600 {
  color: var(--atlas-secondary-600) !important;
}

.bg-secondary-600 {
  background-color: var(--atlas-secondary-600) !important;
}

.color-secondary-700 {
  color: var(--atlas-secondary-700) !important;
}

.bg-secondary-700 {
  background-color: var(--atlas-secondary-700) !important;
}

.color-secondary-800 {
  color: var(--atlas-secondary-800) !important;
}

.bg-secondary-800 {
  background-color: var(--atlas-secondary-800) !important;
}

.color-secondary-900 {
  color: var(--atlas-secondary-900) !important;
}

.bg-secondary-900 {
  background-color: var(--atlas-secondary-900) !important;
}

.active-secondary[active], .active-secondary.active, .active-secondary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-success {
  color: var(--atlas-success) !important;
}

.bg-success {
  background-color: var(--atlas-success) !important;
}

.color-success-100 {
  color: var(--atlas-success-100) !important;
}

.bg-success-100 {
  background-color: var(--atlas-success-100) !important;
}

.color-success-200 {
  color: var(--atlas-success-200) !important;
}

.bg-success-200 {
  background-color: var(--atlas-success-200) !important;
}

.color-success-300 {
  color: var(--atlas-success-300) !important;
}

.bg-success-300 {
  background-color: var(--atlas-success-300) !important;
}

.color-success-400 {
  color: var(--atlas-success-400) !important;
}

.bg-success-400 {
  background-color: var(--atlas-success-400) !important;
}

.color-success-500 {
  color: var(--atlas-success-500) !important;
}

.bg-success-500 {
  background-color: var(--atlas-success-500) !important;
}

.color-success-600 {
  color: var(--atlas-success-600) !important;
}

.bg-success-600 {
  background-color: var(--atlas-success-600) !important;
}

.color-success-700 {
  color: var(--atlas-success-700) !important;
}

.bg-success-700 {
  background-color: var(--atlas-success-700) !important;
}

.color-success-800 {
  color: var(--atlas-success-800) !important;
}

.bg-success-800 {
  background-color: var(--atlas-success-800) !important;
}

.color-success-900 {
  color: var(--atlas-success-900) !important;
}

.bg-success-900 {
  background-color: var(--atlas-success-900) !important;
}

.active-success[active], .active-success.active, .active-success:active {
  background-color: var(--atlas-success) !important;
  color: var(--atlas-contrast-success) !important;
}

.color-warning {
  color: var(--atlas-warning) !important;
}

.bg-warning {
  background-color: var(--atlas-warning) !important;
}

.color-warning-100 {
  color: var(--atlas-warning-100) !important;
}

.bg-warning-100 {
  background-color: var(--atlas-warning-100) !important;
}

.color-warning-200 {
  color: var(--atlas-warning-200) !important;
}

.bg-warning-200 {
  background-color: var(--atlas-warning-200) !important;
}

.color-warning-300 {
  color: var(--atlas-warning-300) !important;
}

.bg-warning-300 {
  background-color: var(--atlas-warning-300) !important;
}

.color-warning-400 {
  color: var(--atlas-warning-400) !important;
}

.bg-warning-400 {
  background-color: var(--atlas-warning-400) !important;
}

.color-warning-500 {
  color: var(--atlas-warning-500) !important;
}

.bg-warning-500 {
  background-color: var(--atlas-warning-500) !important;
}

.color-warning-600 {
  color: var(--atlas-warning-600) !important;
}

.bg-warning-600 {
  background-color: var(--atlas-warning-600) !important;
}

.color-warning-700 {
  color: var(--atlas-warning-700) !important;
}

.bg-warning-700 {
  background-color: var(--atlas-warning-700) !important;
}

.color-warning-800 {
  color: var(--atlas-warning-800) !important;
}

.bg-warning-800 {
  background-color: var(--atlas-warning-800) !important;
}

.color-warning-900 {
  color: var(--atlas-warning-900) !important;
}

.bg-warning-900 {
  background-color: var(--atlas-warning-900) !important;
}

.active-warning[active], .active-warning.active, .active-warning:active {
  background-color: var(--atlas-warning) !important;
  color: var(--atlas-contrast-warning) !important;
}

.color-danger {
  color: var(--atlas-danger) !important;
}

.bg-danger {
  background-color: var(--atlas-danger) !important;
}

.color-danger-100 {
  color: var(--atlas-danger-100) !important;
}

.bg-danger-100 {
  background-color: var(--atlas-danger-100) !important;
}

.color-danger-200 {
  color: var(--atlas-danger-200) !important;
}

.bg-danger-200 {
  background-color: var(--atlas-danger-200) !important;
}

.color-danger-300 {
  color: var(--atlas-danger-300) !important;
}

.bg-danger-300 {
  background-color: var(--atlas-danger-300) !important;
}

.color-danger-400 {
  color: var(--atlas-danger-400) !important;
}

.bg-danger-400 {
  background-color: var(--atlas-danger-400) !important;
}

.color-danger-500 {
  color: var(--atlas-danger-500) !important;
}

.bg-danger-500 {
  background-color: var(--atlas-danger-500) !important;
}

.color-danger-600 {
  color: var(--atlas-danger-600) !important;
}

.bg-danger-600 {
  background-color: var(--atlas-danger-600) !important;
}

.color-danger-700 {
  color: var(--atlas-danger-700) !important;
}

.bg-danger-700 {
  background-color: var(--atlas-danger-700) !important;
}

.color-danger-800 {
  color: var(--atlas-danger-800) !important;
}

.bg-danger-800 {
  background-color: var(--atlas-danger-800) !important;
}

.color-danger-900 {
  color: var(--atlas-danger-900) !important;
}

.bg-danger-900 {
  background-color: var(--atlas-danger-900) !important;
}

.active-danger[active], .active-danger.active, .active-danger:active {
  background-color: var(--atlas-danger) !important;
  color: var(--atlas-contrast-danger) !important;
}

.color-highlight {
  color: var(--atlas-highlight) !important;
}

.bg-highlight {
  background-color: var(--atlas-highlight) !important;
}

.color-highlight-100 {
  color: var(--atlas-highlight-100) !important;
}

.bg-highlight-100 {
  background-color: var(--atlas-highlight-100) !important;
}

.color-highlight-200 {
  color: var(--atlas-highlight-200) !important;
}

.bg-highlight-200 {
  background-color: var(--atlas-highlight-200) !important;
}

.color-highlight-300 {
  color: var(--atlas-highlight-300) !important;
}

.bg-highlight-300 {
  background-color: var(--atlas-highlight-300) !important;
}

.color-highlight-400 {
  color: var(--atlas-highlight-400) !important;
}

.bg-highlight-400 {
  background-color: var(--atlas-highlight-400) !important;
}

.color-highlight-500 {
  color: var(--atlas-highlight-500) !important;
}

.bg-highlight-500 {
  background-color: var(--atlas-highlight-500) !important;
}

.color-highlight-600 {
  color: var(--atlas-highlight-600) !important;
}

.bg-highlight-600 {
  background-color: var(--atlas-highlight-600) !important;
}

.color-highlight-700 {
  color: var(--atlas-highlight-700) !important;
}

.bg-highlight-700 {
  background-color: var(--atlas-highlight-700) !important;
}

.color-highlight-800 {
  color: var(--atlas-highlight-800) !important;
}

.bg-highlight-800 {
  background-color: var(--atlas-highlight-800) !important;
}

.color-highlight-900 {
  color: var(--atlas-highlight-900) !important;
}

.bg-highlight-900 {
  background-color: var(--atlas-highlight-900) !important;
}

.active-highlight[active], .active-highlight.active, .active-highlight:active {
  background-color: var(--atlas-highlight) !important;
  color: var(--atlas-contrast-highlight) !important;
}

.color-info {
  color: var(--atlas-info) !important;
}

.bg-info {
  background-color: var(--atlas-info) !important;
}

.color-info-100 {
  color: var(--atlas-info-100) !important;
}

.bg-info-100 {
  background-color: var(--atlas-info-100) !important;
}

.color-info-200 {
  color: var(--atlas-info-200) !important;
}

.bg-info-200 {
  background-color: var(--atlas-info-200) !important;
}

.color-info-300 {
  color: var(--atlas-info-300) !important;
}

.bg-info-300 {
  background-color: var(--atlas-info-300) !important;
}

.color-info-400 {
  color: var(--atlas-info-400) !important;
}

.bg-info-400 {
  background-color: var(--atlas-info-400) !important;
}

.color-info-500 {
  color: var(--atlas-info-500) !important;
}

.bg-info-500 {
  background-color: var(--atlas-info-500) !important;
}

.color-info-600 {
  color: var(--atlas-info-600) !important;
}

.bg-info-600 {
  background-color: var(--atlas-info-600) !important;
}

.color-info-700 {
  color: var(--atlas-info-700) !important;
}

.bg-info-700 {
  background-color: var(--atlas-info-700) !important;
}

.color-info-800 {
  color: var(--atlas-info-800) !important;
}

.bg-info-800 {
  background-color: var(--atlas-info-800) !important;
}

.color-info-900 {
  color: var(--atlas-info-900) !important;
}

.bg-info-900 {
  background-color: var(--atlas-info-900) !important;
}

.active-info[active], .active-info.active, .active-info:active {
  background-color: var(--atlas-info) !important;
  color: var(--atlas-contrast-info) !important;
}

/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
.onboarding-step {
  display: none;
}
.onboarding-step.visible {
  display: block;
}

.step-title {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.step-title .status-text {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 20px;
}
.step-title slot[name=hotspot]::slotted(atlas-hotspot) {
  position: relative;
  margin: -1.5rem 0;
}

.step-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
}`;

// src/components/layout/atlas-layout/atlas-layout.ts
import { html as html25 } from "lit";
import { customElement as customElement20, property as property26 } from "lit/decorators.js";
import { classMap as classMap14 } from "lit/directives/class-map.js";
import { styleMap as styleMap6 } from "lit/directives/style-map.js";

// src/components/layout/atlas-layout/atlas-layout.scss
import { css as css22 } from "lit-element/lit-element.js";
var atlas_layout_default = css22`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  width: 100%;
}

:host([auto]) {
  width: auto;
}

:host([fluid]) {
  width: 100%;
  height: 100%;
}

.atlas-layout {
  margin: 0;
  padding: 0;
  width: 100%;
  box-sizing: border-box;
  align-items: normal;
}
.atlas-layout.grid {
  display: grid;
}
.atlas-layout.grid.mobile {
  grid-template-columns: 1fr;
}
.atlas-layout.grid.mobile slot::slotted(*) {
  grid-column: 1 !important;
}
.atlas-layout:not(.grid) {
  display: flex;
  flex-direction: column;
}
.atlas-layout:not(.grid).wrap {
  flex-wrap: wrap;
}
.atlas-layout:not(.grid).inline {
  flex-direction: row;
}
.atlas-layout.fluid {
  height: 100%;
}
.atlas-layout.align-top {
  align-items: flex-start;
}
.atlas-layout.align-center {
  align-items: center;
}
.atlas-layout.align-bottom {
  align-items: flex-end;
}
.atlas-layout.justify-start {
  justify-content: flex-start;
}
.atlas-layout.justify-center {
  justify-content: center;
}
.atlas-layout.justify-end {
  justify-content: flex-end;
}
.atlas-layout.justify-space-between {
  justify-content: space-between;
}
.atlas-layout.justify-space-around {
  justify-content: space-around;
}
.atlas-layout.justify-space-evenly {
  justify-content: space-evenly;
}
.atlas-layout.mobile:not(.inline) slot::slotted(*:not(.no-expand)) {
  width: 100% !important;
}

.gap-0 {
  gap: 0;
}

.grid.row-gap-0 {
  row-gap: 0;
}
.grid.column-gap-0 {
  column-gap: 0;
}

.mobile-gap-0 {
  gap: 0 !important;
}
.mobile-gap-0.grid {
  row-gap: 0 !important;
  column-gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem;
}

.grid.row-gap-1 {
  row-gap: 0.25rem;
}
.grid.column-gap-1 {
  column-gap: 0.25rem;
}

.mobile-gap-1 {
  gap: 0.25rem !important;
}
.mobile-gap-1.grid {
  row-gap: 0.25rem !important;
  column-gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem;
}

.grid.row-gap-2 {
  row-gap: 0.5rem;
}
.grid.column-gap-2 {
  column-gap: 0.5rem;
}

.mobile-gap-2 {
  gap: 0.5rem !important;
}
.mobile-gap-2.grid {
  row-gap: 0.5rem !important;
  column-gap: 0.5rem !important;
}

.gap-3 {
  gap: 0.75rem;
}

.grid.row-gap-3 {
  row-gap: 0.75rem;
}
.grid.column-gap-3 {
  column-gap: 0.75rem;
}

.mobile-gap-3 {
  gap: 0.75rem !important;
}
.mobile-gap-3.grid {
  row-gap: 0.75rem !important;
  column-gap: 0.75rem !important;
}

.gap-4 {
  gap: 1rem;
}

.grid.row-gap-4 {
  row-gap: 1rem;
}
.grid.column-gap-4 {
  column-gap: 1rem;
}

.mobile-gap-4 {
  gap: 1rem !important;
}
.mobile-gap-4.grid {
  row-gap: 1rem !important;
  column-gap: 1rem !important;
}

.gap-5 {
  gap: 1.25rem;
}

.grid.row-gap-5 {
  row-gap: 1.25rem;
}
.grid.column-gap-5 {
  column-gap: 1.25rem;
}

.mobile-gap-5 {
  gap: 1.25rem !important;
}
.mobile-gap-5.grid {
  row-gap: 1.25rem !important;
  column-gap: 1.25rem !important;
}

.gap-6 {
  gap: 1.5rem;
}

.grid.row-gap-6 {
  row-gap: 1.5rem;
}
.grid.column-gap-6 {
  column-gap: 1.5rem;
}

.mobile-gap-6 {
  gap: 1.5rem !important;
}
.mobile-gap-6.grid {
  row-gap: 1.5rem !important;
  column-gap: 1.5rem !important;
}

.gap-7 {
  gap: 2rem;
}

.grid.row-gap-7 {
  row-gap: 2rem;
}
.grid.column-gap-7 {
  column-gap: 2rem;
}

.mobile-gap-7 {
  gap: 2rem !important;
}
.mobile-gap-7.grid {
  row-gap: 2rem !important;
  column-gap: 2rem !important;
}

.gap-8 {
  gap: 2.5rem;
}

.grid.row-gap-8 {
  row-gap: 2.5rem;
}
.grid.column-gap-8 {
  column-gap: 2.5rem;
}

.mobile-gap-8 {
  gap: 2.5rem !important;
}
.mobile-gap-8.grid {
  row-gap: 2.5rem !important;
  column-gap: 2.5rem !important;
}

.gap-9 {
  gap: 3rem;
}

.grid.row-gap-9 {
  row-gap: 3rem;
}
.grid.column-gap-9 {
  column-gap: 3rem;
}

.mobile-gap-9 {
  gap: 3rem !important;
}
.mobile-gap-9.grid {
  row-gap: 3rem !important;
  column-gap: 3rem !important;
}`;

// src/components/layout/atlas-layout/atlas-layout.ts
var AtlasLayout = /*#__PURE__*/(() => {
  let AtlasLayout = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.auto = false;
      this.inline = false;
      this.fluid = false;
      this.grid = false;
      this.wrap = false;
      this.mobileInline = false;
      this._deviceController = new DeviceController(this, this.onSlotChange.bind(this));
      this._maxGridCols = 12;
    }
    getIsInline() {
      return !this._deviceController.isMobile && this.inline || this._deviceController.isMobile && this.mobileInline;
    }
    onSlotChange() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const slottedElements = this.shadowRoot.querySelector("slot").assignedElements();
        const buttonElements = ["ATLAS-BUTTON", "ATLAS-DROPDOWN-BUTTON"];
        slottedElements.filter(element => buttonElements.includes(element.tagName)).forEach(element => {
          const hasBlock = this._deviceController.isMobile || element.initialBlock;
          element.toggleAttribute("block", hasBlock);
        });
        slottedElements.filter(element => element.hasAttribute("data-atlas-layout-col-span")).forEach(element => {
          element.setAttribute("style", `grid-column: span ${this.getSlottedElementColSpan(element)}`);
        });
      });
    }
    getGridCols() {
      if (!this.gridCols || this.gridCols < 1) return 1;
      if (this.gridCols > this._maxGridCols) return this._maxGridCols;
      return this.gridCols;
    }
    getSlottedElementColSpan(slottedElement) {
      const colSpan = parseInt(slottedElement.getAttribute("data-atlas-layout-col-span"), 10) || 1;
      const gridCols = this.getGridCols();
      if (colSpan > gridCols) return gridCols;
      if (colSpan < 1) return 1;
      return colSpan;
    }
    /** @internal */
    render() {
      const layoutClass = {
        "atlas-layout": true,
        "inline": this.getIsInline(),
        "mobile": this._deviceController.isMobile,
        "fluid": this.fluid,
        "grid": this.grid,
        "wrap": this.wrap,
        [`align-${this.alignment}`]: !!this.alignment,
        [`justify-${this.justify}`]: !!this.justify,
        [`gap-${this.gap}`]: !!this.gap,
        [`row-gap-${this.rowGap}`]: this.grid && !isEmptyValue(this.rowGap),
        [`column-gap-${this.columnGap}`]: this.grid && !isEmptyValue(this.columnGap),
        [`mobile-gap-${this.mobileGap}`]: !!this.mobileGap && this._deviceController.isMobile
      };
      const shouldApplyGridCols = this.grid && !this._deviceController.isMobile;
      const layoutStyle = {
        "grid-template-columns": shouldApplyGridCols ? `repeat(${this.getGridCols()}, 1fr)` : null
      };
      return html25`
            <div class="${classMap14(layoutClass)}" style="${styleMap6(layoutStyle)}">
                <slot @slotchange=${this.onSlotChange}></slot>
            </div>
        `;
    }
  };
  AtlasLayout.styles = atlas_layout_default;
  return AtlasLayout;
})();
__decorateClass([property26({
  type: Number
})], AtlasLayout.prototype, "gap", 2);
__decorateClass([property26({
  type: Number,
  attribute: "row-gap"
})], AtlasLayout.prototype, "rowGap", 2);
__decorateClass([property26({
  type: Number,
  attribute: "column-gap"
})], AtlasLayout.prototype, "columnGap", 2);
__decorateClass([property26({
  type: Boolean
})], AtlasLayout.prototype, "auto", 2);
__decorateClass([property26({
  type: Boolean
})], AtlasLayout.prototype, "inline", 2);
__decorateClass([property26({
  type: Boolean
})], AtlasLayout.prototype, "fluid", 2);
__decorateClass([property26({
  type: Boolean
})], AtlasLayout.prototype, "grid", 2);
__decorateClass([property26({
  type: Number,
  attribute: "grid-cols"
})], AtlasLayout.prototype, "gridCols", 2);
__decorateClass([property26({
  type: Boolean
})], AtlasLayout.prototype, "wrap", 2);
__decorateClass([property26({
  type: String
})], AtlasLayout.prototype, "alignment", 2);
__decorateClass([property26({
  type: String
})], AtlasLayout.prototype, "justify", 2);
__decorateClass([property26({
  type: Number,
  attribute: "mobile-gap"
})], AtlasLayout.prototype, "mobileGap", 2);
__decorateClass([property26({
  type: Boolean,
  attribute: "mobile-inline"
})], AtlasLayout.prototype, "mobileInline", 2);
AtlasLayout = __decorateClass([customElement20("atlas-layout")], AtlasLayout);

// src/components/dashboard/atlas-onboarding-step/atlas-onboarding-step.ts
var STATUS_MAP = {
  pending: {
    icon: "circle",
    text: "Pendente",
    theme: "secondary"
  },
  review: {
    icon: "clock",
    text: "Em an\xE1lise",
    theme: "warning"
  },
  approved: {
    icon: "check-circle",
    text: "",
    theme: "success"
  },
  attention: {
    icon: "alert-circle",
    text: "Precisa de aten\xE7\xE3o",
    theme: "danger"
  }
};
var AtlasOnboardingStep = /*#__PURE__*/(() => {
  let AtlasOnboardingStep = class extends WithBadgeMixin(LitElement7) {
    constructor() {
      super();
      this.status = "pending";
      this._visible = false;
      this.badgeTheme = this.badgeTheme || "primary";
    }
    /**
     * Especifica a visibilidade do componente
     * @param {boolean} visible - Define se o componente deve estar visível (true) ou oculto (false)
     */
    setVisible(visible) {
      this._visible = visible;
    }
    /**
     * Retorna o ícone associado ao status atual do componente
     * @returns {string | undefined} - O ícone correspondente ao status atual, ou "undefined" se não houver um ícone associado
     */
    getStatusIcon() {
      var _a;
      return (_a = STATUS_MAP[this.status]) == null ? void 0 : _a.icon;
    }
    /**
     * Retorna o tema associado ao status atual do componente
     * @returns {string | undefined} - O tema correspondente ao status atual, ou "undefined" se não houver um tema associado
     */
    getStatusTheme() {
      var _a;
      return this.statusTheme || ((_a = STATUS_MAP[this.status]) == null ? void 0 : _a.theme);
    }
    onStatusChange() {
      emit(this, "atlas-onboarding-step-change");
    }
    renderStatusText() {
      var _a;
      const statusText = this.statusText || ((_a = STATUS_MAP[this.status]) == null ? void 0 : _a.text);
      const statusTheme = this.getStatusTheme();
      if (!statusText) return null;
      const stepStatusClass = {
        "status-text": true,
        [`color-${statusTheme}`]: !!statusTheme
      };
      return html26`<span class=${classMap15(stepStatusClass)}>${statusText}</span>`;
    }
    renderIcon() {
      return when14(!!this.icon, () => html26`<atlas-icon name=${this.icon} size="4x"></atlas-icon>`);
    }
    renderHotspotSlot() {
      return html26`<slot name="hotspot"></slot>`;
    }
    render() {
      const stepClass = {
        "onboarding-step": true,
        "visible": this._visible
      };
      return html26`
            <div class=${classMap15(stepClass)}>
                <div class="step-title">
                    <atlas-layout inline mobile-inline gap="2" alignment="center">
                        <atlas-heading size="h5"> ${this.header} </atlas-heading>
                        ${this.renderIcon()} ${this.renderBadge()} ${this.renderHotspotSlot()}
                    </atlas-layout>
                    ${this.renderStatusText()}
                </div>
                <div class="step-content">
                    <slot></slot>
                </div>
            </div>
        `;
    }
  };
  AtlasOnboardingStep.styles = atlas_onboarding_step_default;
  return AtlasOnboardingStep;
})();
__decorateClass([property27({
  type: String
})], AtlasOnboardingStep.prototype, "name", 2);
__decorateClass([property27({
  type: String
})], AtlasOnboardingStep.prototype, "label", 2);
__decorateClass([property27({
  type: String
})], AtlasOnboardingStep.prototype, "header", 2);
__decorateClass([property27({
  type: String,
  attribute: "icon"
})], AtlasOnboardingStep.prototype, "icon", 2);
__decorateClass([property27({
  type: String
})], AtlasOnboardingStep.prototype, "status", 2);
__decorateClass([property27({
  type: String,
  attribute: "status-text"
})], AtlasOnboardingStep.prototype, "statusText", 2);
__decorateClass([property27({
  type: String,
  attribute: "status-theme"
})], AtlasOnboardingStep.prototype, "statusTheme", 2);
__decorateClass([property27({
  type: String
})], AtlasOnboardingStep.prototype, "illustration", 2);
__decorateClass([state8()], AtlasOnboardingStep.prototype, "_visible", 2);
__decorateClass([Watch(["status", "illustration"])], AtlasOnboardingStep.prototype, "onStatusChange", 1);
AtlasOnboardingStep = __decorateClass([customElement21("atlas-onboarding-step")], AtlasOnboardingStep);

// src/components/display/atlas-alert/atlas-alert.ts
import { LitElement as LitElement8, html as html27 } from "lit";
import { customElement as customElement22, property as property28, state as state9 } from "lit/decorators.js";
import { when as when15 } from "lit/directives/when.js";
import { classMap as classMap16 } from "lit/directives/class-map.js";

// src/components/display/atlas-alert/atlas-alert.scss
import { css as css23 } from "lit-element/lit-element.js";
var atlas_alert_default = css23`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Transitions */
.fade {
  transition: opacity 0.25s ease;
}
.fade:not(.show) {
  opacity: 0;
}

.fade-and-scale {
  opacity: 0;
  transform: scale(0.7);
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.fade-and-scale.scale-vertically {
  transform: scale(1, 0.7);
}
.fade-and-scale.show {
  opacity: 1;
  transform: scale(1);
}

:host([data-popper-placement=top]),
:host([data-popper-placement=top]) .fade-and-scale,
div[data-popper-placement=top].fade-and-scale,
div[data-popper-placement=top] > .fade-and-scale,
.fade-and-scale.scale-top {
  transform-origin: center bottom;
}

:host([data-popper-placement=top-start]),
:host([data-popper-placement=top-start]) .fade-and-scale,
div[data-popper-placement=top-start].fade-and-scale,
div[data-popper-placement=top-start] > .fade-and-scale,
.fade-and-scale.scale-top-start {
  transform-origin: left bottom;
}

:host([data-popper-placement=top-end]),
:host([data-popper-placement=top-end]) .fade-and-scale,
div[data-popper-placement=top-end].fade-and-scale,
div[data-popper-placement=top-end] > .fade-and-scale,
.fade-and-scale.scale-top-end {
  transform-origin: right bottom;
}

:host([data-popper-placement=bottom]),
:host([data-popper-placement=bottom]) .fade-and-scale,
div[data-popper-placement=bottom].fade-and-scale,
div[data-popper-placement=bottom] > .fade-and-scale,
.fade-and-scale.scale-bottom {
  transform-origin: center top;
}

:host([data-popper-placement=bottom-start]),
:host([data-popper-placement=bottom-start]) .fade-and-scale,
div[data-popper-placement=bottom-start].fade-and-scale,
div[data-popper-placement=bottom-start] > .fade-and-scale,
.fade-and-scale.scale-bottom-start {
  transform-origin: left top;
}

:host([data-popper-placement=bottom-end]),
:host([data-popper-placement=bottom-end]) .fade-and-scale,
div[data-popper-placement=bottom-end].fade-and-scale,
div[data-popper-placement=bottom-end] > .fade-and-scale,
.fade-and-scale.scale-bottom-end {
  transform-origin: right top;
}

:host([data-popper-placement=left]),
:host([data-popper-placement=left]) .fade-and-scale,
div[data-popper-placement=left].fade-and-scale,
div[data-popper-placement=left] > .fade-and-scale,
.fade-and-scale.scale-left {
  transform-origin: right center;
}

:host([data-popper-placement=left-start]),
:host([data-popper-placement=left-start]) .fade-and-scale,
div[data-popper-placement=left-start].fade-and-scale,
div[data-popper-placement=left-start] > .fade-and-scale,
.fade-and-scale.scale-left-start {
  transform-origin: right top;
}

:host([data-popper-placement=left-end]),
:host([data-popper-placement=left-end]) .fade-and-scale,
div[data-popper-placement=left-end].fade-and-scale,
div[data-popper-placement=left-end] > .fade-and-scale,
.fade-and-scale.scale-left-end {
  transform-origin: right bottom;
}

:host([data-popper-placement=right]),
:host([data-popper-placement=right]) .fade-and-scale,
div[data-popper-placement=right].fade-and-scale,
div[data-popper-placement=right] > .fade-and-scale,
.fade-and-scale.scale-right {
  transform-origin: left center;
}

:host([data-popper-placement=right-start]),
:host([data-popper-placement=right-start]) .fade-and-scale,
div[data-popper-placement=right-start].fade-and-scale,
div[data-popper-placement=right-start] > .fade-and-scale,
.fade-and-scale.scale-right-start {
  transform-origin: left top;
}

:host([data-popper-placement=right-end]),
:host([data-popper-placement=right-end]) .fade-and-scale,
div[data-popper-placement=right-end].fade-and-scale,
div[data-popper-placement=right-end] > .fade-and-scale,
.fade-and-scale.scale-right-end {
  transform-origin: left bottom;
}

:host {
  --atlas-link-weight: 700;
  display: block;
}

.alert {
  position: relative;
  align-items: flex-start;
  display: grid;
  grid-template-columns: 1.5rem auto 1.5rem;
  min-height: 56px;
  width: 100%;
  padding: 1rem;
  gap: 1rem;
  border-radius: 0.25rem;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  margin-bottom: 1.5rem;
}
.alert .alert-text {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  line-height: 1.5;
  align-self: center;
}
.alert .alert-close {
  cursor: pointer;
  position: relative;
  justify-self: center;
  align-self: flex-start;
  background: transparent;
  display: flex;
  top: 0;
  right: 0;
  height: 24px;
  width: 24px;
  border: 0;
  box-sizing: content-box;
  color: #6c757d;
}
.alert .alert-content {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.alert ::slotted(ul) {
  margin: 0 !important;
  padding-left: 1.5rem !important;
}

.alert-info {
  --atlas-link-color: var(--atlas-info-800);
  --atlas-link-color-hover: var(--atlas-info-900);
  color: var(--atlas-info-800);
  background-color: var(--atlas-info-100);
}

.alert-success {
  --atlas-link-color: var(--atlas-success-800);
  --atlas-link-color-hover: var(--atlas-success-900);
  color: var(--atlas-success-800);
  background-color: var(--atlas-success-100);
}

.alert-error {
  --atlas-link-color: var(--atlas-danger-800);
  --atlas-link-color-hover: var(--atlas-danger-900);
  color: var(--atlas-danger-800);
  background-color: var(--atlas-danger-100);
}

.alert-warning {
  --atlas-link-color: var(--atlas-warning-800);
  --atlas-link-color-hover: var(--atlas-warning-900);
  color: var(--atlas-warning-800);
  background-color: var(--atlas-warning-100);
}

.alert-primary {
  --atlas-link-color: var(--atlas-primary-800);
  --atlas-link-color-hover: var(--atlas-primary-900);
  color: var(--atlas-primary-800);
  background-color: var(--atlas-primary-100);
}`;

// src/components/display/atlas-alert/atlas-alert.ts
var AtlasAlert = /*#__PURE__*/(() => {
  let AtlasAlert = class extends LitElement8 {
    constructor() {
      super();
      this.message = "";
      this.type = "info";
      this._visible = false;
      this.show = this.show.bind(this);
      this.close = this.close.bind(this);
      this.destroy = this.destroy.bind(this);
    }
    /** @internal */
    firstUpdated() {
      setTimeout(this.show, 100);
    }
    /**
     * Exibe o alert
     */
    show() {
      this._visible = true;
      emit(this, "atlas-alert-show", {
        trackDisable: true
      });
    }
    /**
     * Fecha o alert
     */
    close() {
      this._visible = false;
      emit(this, "atlas-alert-close", {
        trackDisable: true
      });
    }
    /**
     * Fecha o alert e remove o elemento do DOM
     */
    destroy() {
      this.close();
      setTimeout(() => {
        this.remove();
      }, 150);
    }
    getTypeInfo() {
      return {
        success: {
          className: "alert-success",
          wrapperClass: "js-alert-success",
          icon: "check"
        },
        error: {
          className: "alert-error",
          wrapperClass: "js-alert-error",
          icon: "alert-triangle"
        },
        warning: {
          className: "alert-warning",
          wrapperClass: "js-alert-warning",
          icon: "alert-triangle"
        },
        info: {
          className: "alert-info",
          wrapperClass: "js-alert-info",
          icon: "info"
        },
        primary: {
          className: "alert-primary",
          wrapperClass: "js-alert-primary",
          icon: "primary"
        }
      }[this.type];
    }
    renderCloseButton() {
      return when15(this.type !== "success", () => html27`
                <button type="button" class="alert-close close" aria-label="Fechar" @click=${this.destroy}>
                    <atlas-icon name="x" size="3x"></atlas-icon>
                </button>
            `);
    }
    render() {
      const typeInfo = this.getTypeInfo();
      const alertClass = {
        "alert": true,
        "alert-dismissible": true,
        "fade": true,
        "show": this._visible,
        [typeInfo.className]: true
      };
      return html27`
            <div role="alert" class=${classMap16(alertClass)}>
                <atlas-icon name="${typeInfo.icon}" size="3x"></atlas-icon>
                <span class="alert-text">
                    ${when15(!!this.message, () => this.message, () => html27`<slot></slot>`)}
                </span>
                ${this.renderCloseButton()}
            </div>
        `;
    }
  };
  AtlasAlert.styles = atlas_alert_default;
  return AtlasAlert;
})();
__decorateClass([property28({
  type: String
})], AtlasAlert.prototype, "message", 2);
__decorateClass([property28({
  type: String
})], AtlasAlert.prototype, "type", 2);
__decorateClass([state9()], AtlasAlert.prototype, "_visible", 2);
AtlasAlert = __decorateClass([customElement22("atlas-alert")], AtlasAlert);

// src/components/display/atlas-avatar/atlas-avatar.ts
import { html as html28 } from "lit";
import { customElement as customElement23, property as property29 } from "lit/decorators.js";
import { when as when16 } from "lit/directives/when.js";

// src/components/display/atlas-avatar/atlas-avatar.scss
import { css as css24 } from "lit-element/lit-element.js";
var atlas_avatar_default = css24`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border-radius: 9999px;
  user-select: none;
  position: relative;
}

:host([skeleton-loading]) {
  display: inline-flex;
}

.avatar-img {
  height: 44px !important;
  width: 44px !important;
  border-radius: 50% !important;
}

atlas-badge {
  position: absolute;
  top: -4px;
  left: 32px;
}

@media screen and (min-width: 992px) {
  :host([hoverable]) {
    cursor: pointer;
    padding: 8px;
    transition: background 0.25s ease;
  }
  :host([hoverable]) atlas-icon {
    color: #687078;
    transition: transform 0.35s ease, color 0.25s ease;
  }
  :host([hoverable]) atlas-badge {
    top: 6px;
    left: 40px;
  }
  :host([hoverable]:hover) {
    background: #dee2e6;
  }
  :host([hoverable][active]) {
    background: var(--atlas-primary-100);
  }
  :host([hoverable][active]) atlas-icon {
    color: var(--atlas-primary);
    transform: rotate(-180deg);
  }
  :host([hoverable][show-carret]) {
    padding: 4px 8px;
  }
  :host([hoverable][show-carret]) atlas-badge {
    top: 2px;
    left: 40px;
  }
}`;

// src/components/display/atlas-avatar/atlas-avatar.ts
var AtlasAvatar = /*#__PURE__*/(() => {
  let AtlasAvatar = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.hoverable = false;
      this.active = false;
      this.showCarret = false;
      this.showIconMobile = false;
      this.showBadge = false;
      this.deviceController = new DeviceController(this);
    }
    getAvatarPath() {
      return this.image || getAssetPath("assets/images/user-icon.svg");
    }
    renderBadge() {
      return when16(this.showBadge, () => html28`<atlas-badge></atlas-badge>`);
    }
    renderSkeleton() {
      return html28`
            <atlas-layout gap="1" alignment="center" inline>
                <div class="avatar-img skeleton-circle"></div>
                ${when16(this.showCarret, () => html28`<atlas-icon></atlas-icon>`)}
            </atlas-layout>
        `;
    }
    renderElement() {
      return when16(this.showIconMobile && this.deviceController.isMobile, () => html28`
                <atlas-icon-button
                    icon="user"
                    size="3x"
                    ?active=${this.active}
                    ?show-badge=${this.showBadge}
                ></atlas-icon-button>
            `, () => html28`
                <img class="avatar-img" src=${this.getAvatarPath()} alt=${this.userName} />
                ${this.renderBadge()}
                ${when16(this.showCarret, () => html28`<atlas-icon name="chevron-down"></atlas-icon>`)}
            `);
    }
  };
  AtlasAvatar.styles = atlas_avatar_default;
  return AtlasAvatar;
})();
__decorateClass([property29({
  type: String
})], AtlasAvatar.prototype, "image", 2);
__decorateClass([property29({
  type: String,
  attribute: "user-name"
})], AtlasAvatar.prototype, "userName", 2);
__decorateClass([property29({
  type: Boolean,
  reflect: true
})], AtlasAvatar.prototype, "hoverable", 2);
__decorateClass([property29({
  type: Boolean
})], AtlasAvatar.prototype, "active", 2);
__decorateClass([property29({
  type: Boolean,
  attribute: "show-carret"
})], AtlasAvatar.prototype, "showCarret", 2);
__decorateClass([property29({
  type: Boolean,
  attribute: "show-icon-mobile"
})], AtlasAvatar.prototype, "showIconMobile", 2);
__decorateClass([property29({
  type: Boolean,
  attribute: "show-badge"
})], AtlasAvatar.prototype, "showBadge", 2);
AtlasAvatar = __decorateClass([customElement23("atlas-avatar")], AtlasAvatar);

// src/components/display/atlas-bottom-sheet/atlas-bottom-sheet.ts
import { LitElement as LitElement10, html as html32 } from "lit";
import { customElement as customElement26, property as property33, query as query7, state as state11 } from "lit/decorators.js";
import { classMap as classMap19 } from "lit/directives/class-map.js";
import { styleMap as styleMap7 } from "lit/directives/style-map.js";
import { when as when18 } from "lit/directives/when.js";

// src/components/display/atlas-bottom-sheet/atlas-bottom-sheet.scss
import { css as css25 } from "lit-element/lit-element.js";
var atlas_bottom_sheet_default = css25`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Transitions */
/* Z-index mapping for the floating elements */
/* Transitions */
.fade {
  transition: opacity 0.25s ease;
}
.fade:not(.show) {
  opacity: 0;
}

.fade-and-scale {
  opacity: 0;
  transform: scale(0.7);
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.fade-and-scale.scale-vertically {
  transform: scale(1, 0.7);
}
.fade-and-scale.show {
  opacity: 1;
  transform: scale(1);
}

:host([data-popper-placement=top]),
:host([data-popper-placement=top]) .fade-and-scale,
div[data-popper-placement=top].fade-and-scale,
div[data-popper-placement=top] > .fade-and-scale,
.fade-and-scale.scale-top {
  transform-origin: center bottom;
}

:host([data-popper-placement=top-start]),
:host([data-popper-placement=top-start]) .fade-and-scale,
div[data-popper-placement=top-start].fade-and-scale,
div[data-popper-placement=top-start] > .fade-and-scale,
.fade-and-scale.scale-top-start {
  transform-origin: left bottom;
}

:host([data-popper-placement=top-end]),
:host([data-popper-placement=top-end]) .fade-and-scale,
div[data-popper-placement=top-end].fade-and-scale,
div[data-popper-placement=top-end] > .fade-and-scale,
.fade-and-scale.scale-top-end {
  transform-origin: right bottom;
}

:host([data-popper-placement=bottom]),
:host([data-popper-placement=bottom]) .fade-and-scale,
div[data-popper-placement=bottom].fade-and-scale,
div[data-popper-placement=bottom] > .fade-and-scale,
.fade-and-scale.scale-bottom {
  transform-origin: center top;
}

:host([data-popper-placement=bottom-start]),
:host([data-popper-placement=bottom-start]) .fade-and-scale,
div[data-popper-placement=bottom-start].fade-and-scale,
div[data-popper-placement=bottom-start] > .fade-and-scale,
.fade-and-scale.scale-bottom-start {
  transform-origin: left top;
}

:host([data-popper-placement=bottom-end]),
:host([data-popper-placement=bottom-end]) .fade-and-scale,
div[data-popper-placement=bottom-end].fade-and-scale,
div[data-popper-placement=bottom-end] > .fade-and-scale,
.fade-and-scale.scale-bottom-end {
  transform-origin: right top;
}

:host([data-popper-placement=left]),
:host([data-popper-placement=left]) .fade-and-scale,
div[data-popper-placement=left].fade-and-scale,
div[data-popper-placement=left] > .fade-and-scale,
.fade-and-scale.scale-left {
  transform-origin: right center;
}

:host([data-popper-placement=left-start]),
:host([data-popper-placement=left-start]) .fade-and-scale,
div[data-popper-placement=left-start].fade-and-scale,
div[data-popper-placement=left-start] > .fade-and-scale,
.fade-and-scale.scale-left-start {
  transform-origin: right top;
}

:host([data-popper-placement=left-end]),
:host([data-popper-placement=left-end]) .fade-and-scale,
div[data-popper-placement=left-end].fade-and-scale,
div[data-popper-placement=left-end] > .fade-and-scale,
.fade-and-scale.scale-left-end {
  transform-origin: right bottom;
}

:host([data-popper-placement=right]),
:host([data-popper-placement=right]) .fade-and-scale,
div[data-popper-placement=right].fade-and-scale,
div[data-popper-placement=right] > .fade-and-scale,
.fade-and-scale.scale-right {
  transform-origin: left center;
}

:host([data-popper-placement=right-start]),
:host([data-popper-placement=right-start]) .fade-and-scale,
div[data-popper-placement=right-start].fade-and-scale,
div[data-popper-placement=right-start] > .fade-and-scale,
.fade-and-scale.scale-right-start {
  transform-origin: left top;
}

:host([data-popper-placement=right-end]),
:host([data-popper-placement=right-end]) .fade-and-scale,
div[data-popper-placement=right-end].fade-and-scale,
div[data-popper-placement=right-end] > .fade-and-scale,
.fade-and-scale.scale-right-end {
  transform-origin: left bottom;
}

:host {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: fixed;
  overflow: hidden;
  z-index: 1000;
  pointer-events: none;
}

:host([open]) {
  pointer-events: all;
}

.bottom-sheet-wrapper {
  width: 100%;
  height: 100%;
  background: rgba(var(--atlas-dark-rgb), 40%);
  position: relative;
}

.bottom-sheet {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  max-height: 70%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background: #ffffff;
  border-radius: 0.5rem 0.5rem 0 0;
  padding: 2rem 0 1rem;
  box-sizing: border-box;
  transform: translateY(100%);
  transition: transform 0.5s ease;
}
.bottom-sheet .bottom-sheet-header {
  padding: 0 1rem;
  position: relative;
  display: flex;
  flex-direction: column;
}
.bottom-sheet .bottom-sheet-header .drag-anchor {
  position: absolute;
  top: -1rem;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 4px;
  border-radius: 9999px;
  background: var(--atlas-secondary);
}
.bottom-sheet .bottom-sheet-header .bottom-sheet-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.bottom-sheet .bottom-sheet-header slot[name=subheading] {
  display: none;
  flex-direction: column;
  margin: 1rem 0 1.5rem;
}
.bottom-sheet .bottom-sheet-body {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  overflow: auto;
  overscroll-behavior: none;
}
.bottom-sheet.dragging {
  transition: none;
}
.bottom-sheet.fullscreen {
  max-height: unset;
  height: 100%;
}
.bottom-sheet.spaced-content {
  padding: 2rem 1rem;
}
.bottom-sheet.spaced-content .bottom-sheet-header {
  padding: 0;
}
.bottom-sheet .dropdown-buttons {
  position: relative;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1rem 1rem 0;
  border-top: 1px solid #ced4da;
  background-color: #ffffff;
  box-sizing: border-box;
}

.bottom-sheet-wrapper.show .bottom-sheet {
  transform: translateY(0%);
}

:host(.has-subheading) .bottom-sheet {
  gap: 0;
}
:host(.has-subheading) .bottom-sheet .bottom-sheet-header {
  border-bottom: 1px solid #ced4da;
}
:host(.has-subheading) .bottom-sheet .bottom-sheet-header slot[name=subheading] {
  display: flex;
}`;

// src/components/display/atlas-button/atlas-button.ts
import { literal as literal5, html as html31 } from "lit/static-html.js";
import { customElement as customElement25, property as property32 } from "lit/decorators.js";
import { classMap as classMap18 } from "lit/directives/class-map.js";
import { ifDefined as ifDefined6 } from "lit/directives/if-defined.js";

// src/components/display/atlas-button/atlas-button-base.ts
import { html as html29 } from "lit";
import { property as property30 } from "lit/decorators.js";
import { classMap as classMap17 } from "lit/directives/class-map.js";
import { when as when17 } from "lit/directives/when.js";

// src/components/display/atlas-button/atlas-button.scss
import { css as css26 } from "lit-element/lit-element.js";
var atlas_button_default = css26`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
.btn {
  --atlas-btn-padding-x: 1rem;
  --atlas-btn-padding-y: 0.5rem;
  --atlas-btn-font-size: 1rem;
  --atlas-btn-color: #000000;
  --atlas-btn-bg: transparent;
  --atlas-btn-border-color: transparent;
  --atlas-btn-border-radius: 0.25rem;
  --atlas-btn-hover-border-color: transparent;
  --atlas-btn-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-rgb), 40%);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-300-rgb), 0.25);
  --atlas-btn-min-height: 2.625rem;
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  box-sizing: border-box;
  padding: var(--atlas-btn-padding-y) var(--atlas-btn-padding-x);
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: var(--atlas-btn-font-size);
  font-weight: 400;
  line-height: 1.5;
  color: var(--atlas-btn-color);
  min-height: var(--atlas-btn-min-height);
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border: 1px solid var(--atlas-btn-border-color);
  border-radius: var(--atlas-btn-border-radius);
  background: var(--atlas-btn-bg);
  box-shadow: var(--atlas-btn-box-shadow);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.btn:hover {
  color: var(--atlas-btn-hover-color);
  background-color: var(--atlas-btn-hover-bg);
  border-color: var(--atlas-btn-hover-border-color);
}
.btn:focus-visible {
  color: var(--atlas-btn-color);
  background: var(--atlas-btn-bg);
  border-color: var(--atlas-btn-border-color);
  box-shadow: var(--atlas-btn-focus-box-shadow);
  outline: 0;
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--atlas-btn-disabled-color);
  pointer-events: none;
  background-color: var(--atlas-btn-disabled-bg);
  background-image: none;
  border-color: var(--atlas-btn-disabled-border-color);
  opacity: 0.35;
  box-shadow: none;
}
.btn-check + .btn:hover {
  color: var(--atlas-btn-check-hover-color);
  background-color: var(--atlas-btn-check-hover-bg);
  border-color: var(--atlas-btn-check-hover-border-color);
}
.btn-check:focus-visible + .btn {
  border-color: var(--atlas-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--atlas-btn-focus-box-shadow);
}
.btn-check:checked + .btn {
  color: var(--atlas-btn-checked-color);
  background-color: var(--atlas-btn-checked-bg);
  border-color: var(--atlas-btn-checked-border-color);
}
:not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--atlas-btn-active-color);
  background-color: var(--atlas-btn-active-bg);
  background-image: none;
  border-color: var(--atlas-btn-active-border-color);
  box-shadow: var(--atlas-btn-active-shadow);
}
:not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--atlas-btn-focus-box-shadow);
}
.btn-check:checked + .btn:hover {
  color: var(--atlas-btn-hover-color);
  background-color: var(--atlas-btn-hover-bg);
  border-color: var(--atlas-btn-hover-border-color);
}
.btn atlas-icon {
  font-size: 1.25rem;
}

.btn-sm {
  --atlas-btn-padding-y: 0.25rem;
  --atlas-btn-padding-x: 0.5rem;
  --atlas-btn-font-size: 0.875rem;
  --atlas-btn-border-radius: 0.25rem;
  --atlas-btn-min-height: 1.9375rem;
}
.btn-sm atlas-icon {
  font-size: 1rem;
}

.btn-lg {
  --atlas-btn-padding-y: 0.5rem;
  --atlas-btn-padding-x: 1rem;
  --atlas-btn-font-size: 1.25rem;
  --atlas-btn-border-radius: 0.25rem;
  --atlas-btn-min-height: 3rem;
}
.btn-lg atlas-icon {
  font-size: 1.5rem;
}

.skeleton.btn-sm {
  height: 1.9375rem;
  width: 100px;
}
.skeleton.btn-md {
  height: 2.625rem;
  width: 120px;
}
.skeleton.btn-lg {
  height: 3rem;
  width: 140px;
}

.btn-block {
  width: 100% !important;
}

.rounded-pill {
  border-radius: 9999px;
}

slot[name=hotspot]::slotted(atlas-hotspot) {
  position: absolute;
  top: -20px;
  right: -20px;
}

.btn-primary {
  --atlas-btn-bg: var(--atlas-primary);
  --atlas-btn-color: var(--atlas-contrast-primary);
  --atlas-btn-border-color: var(--atlas-primary);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-primary-600);
  --atlas-btn-hover-border-color: var(--atlas-primary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-primary-700);
  --atlas-btn-active-border-color: var(--atlas-primary-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-primary);
  --atlas-btn-disabled-border-color: var(--atlas-primary);
  --atlas-btn-disabled-bg: var(--atlas-primary);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-primary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-primary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-primary-500);
  --atlas-btn-checked-border-color: var(--atlas-primary-500);
}

.btn-outline-primary {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-primary);
  --atlas-btn-border-color: var(--atlas-primary);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-primary-600);
  --atlas-btn-hover-border-color: var(--atlas-primary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-primary-700);
  --atlas-btn-active-border-color: var(--atlas-primary-700);
  --atlas-btn-disabled-color: var(--atlas-primary);
  --atlas-btn-disabled-bg: var(--atlas-primary-100);
  --atlas-btn-disabled-border-color: var(--atlas-primary);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-primary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-primary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-primary-500);
  --atlas-btn-checked-border-color: var(--atlas-primary-500);
}

.btn-ghost-primary {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-primary);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-primary-600);
  --atlas-btn-hover-border-color: var(--atlas-primary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-primary-700);
  --atlas-btn-active-border-color: var(--atlas-primary-700);
  --atlas-btn-disabled-color: var(--atlas-primary);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-primary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-primary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-primary-500);
  --atlas-btn-checked-border-color: var(--atlas-primary-500);
}

.btn-primary-white {
  --atlas-btn-bg: #f8f9fa;
  --atlas-btn-color: var(--atlas-primary);
  --atlas-btn-border-color: #f8f9fa;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-primary);
  --atlas-btn-hover-bg: rgb(198.4, 199.2, 200);
  --atlas-btn-hover-border-color: rgb(198.4, 199.2, 200);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(#f8f9fa, 0.25);
  --atlas-btn-active-color: var(--atlas-primary);
  --atlas-btn-active-bg: rgb(148.8, 149.4, 150);
  --atlas-btn-active-border-color: rgb(148.8, 149.4, 150);
  --atlas-btn-disabled-color: var(--atlas-primary);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-disabled-bg: #f8f9fa;
  --atlas-btn-check-hover-color: none;
  --atlas-btn-check-hover-bg: none;
  --atlas-btn-check-hover-border-color: none;
  --atlas-btn-checked-color: none;
  --atlas-btn-checked-bg: none;
  --atlas-btn-checked-border-color: none;
}

.btn-outline-primary-white {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: #f8f9fa;
  --atlas-btn-border-color: #f8f9fa;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-primary);
  --atlas-btn-hover-bg: rgb(198.4, 199.2, 200);
  --atlas-btn-hover-border-color: rgb(198.4, 199.2, 200);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(#f8f9fa, 0.25);
  --atlas-btn-active-color: var(--atlas-primary);
  --atlas-btn-active-bg: rgb(148.8, 149.4, 150);
  --atlas-btn-active-border-color: rgb(148.8, 149.4, 150);
  --atlas-btn-disabled-color: var(--atlas-primary);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-disabled-bg: #f8f9fa;
  --atlas-btn-check-hover-color: none;
  --atlas-btn-check-hover-bg: none;
  --atlas-btn-check-hover-border-color: none;
  --atlas-btn-checked-color: none;
  --atlas-btn-checked-bg: none;
  --atlas-btn-checked-border-color: none;
}

.btn-secondary {
  --atlas-btn-bg: var(--atlas-secondary);
  --atlas-btn-color: var(--atlas-contrast-secondary);
  --atlas-btn-border-color: var(--atlas-secondary);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-secondary);
  --atlas-btn-hover-bg: var(--atlas-secondary-600);
  --atlas-btn-hover-border-color: var(--atlas-secondary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-secondary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-secondary);
  --atlas-btn-active-bg: var(--atlas-secondary-700);
  --atlas-btn-active-border-color: var(--atlas-secondary-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-secondary);
  --atlas-btn-disabled-border-color: var(--atlas-secondary);
  --atlas-btn-disabled-bg: var(--atlas-secondary);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-secondary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-secondary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-secondary-500);
  --atlas-btn-checked-border-color: var(--atlas-secondary-500);
}

.btn-outline-secondary {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-secondary);
  --atlas-btn-border-color: var(--atlas-secondary);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-secondary-600);
  --atlas-btn-hover-border-color: var(--atlas-secondary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-secondary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-secondary-700);
  --atlas-btn-active-border-color: var(--atlas-secondary-700);
  --atlas-btn-disabled-color: var(--atlas-secondary);
  --atlas-btn-disabled-bg: var(--atlas-secondary-100);
  --atlas-btn-disabled-border-color: var(--atlas-secondary);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-secondary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-secondary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-secondary-500);
  --atlas-btn-checked-border-color: var(--atlas-secondary-500);
}

.btn-ghost-secondary {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-secondary);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-secondary-600);
  --atlas-btn-hover-border-color: var(--atlas-secondary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-secondary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-secondary-700);
  --atlas-btn-active-border-color: var(--atlas-secondary-700);
  --atlas-btn-disabled-color: var(--atlas-secondary);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-secondary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-secondary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-secondary-500);
  --atlas-btn-checked-border-color: var(--atlas-secondary-500);
}

.btn-success {
  --atlas-btn-bg: var(--atlas-success);
  --atlas-btn-color: var(--atlas-contrast-success);
  --atlas-btn-border-color: var(--atlas-success);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-success);
  --atlas-btn-hover-bg: var(--atlas-success-600);
  --atlas-btn-hover-border-color: var(--atlas-success-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-success);
  --atlas-btn-active-bg: var(--atlas-success-700);
  --atlas-btn-active-border-color: var(--atlas-success-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-success);
  --atlas-btn-disabled-border-color: var(--atlas-success);
  --atlas-btn-disabled-bg: var(--atlas-success);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-success-400);
  --atlas-btn-check-hover-border-color: var(--atlas-success-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-success-500);
  --atlas-btn-checked-border-color: var(--atlas-success-500);
}

.btn-outline-success {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-success);
  --atlas-btn-border-color: var(--atlas-success);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-success-600);
  --atlas-btn-hover-border-color: var(--atlas-success-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-success-700);
  --atlas-btn-active-border-color: var(--atlas-success-700);
  --atlas-btn-disabled-color: var(--atlas-success);
  --atlas-btn-disabled-bg: var(--atlas-success-100);
  --atlas-btn-disabled-border-color: var(--atlas-success);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-success-400);
  --atlas-btn-check-hover-border-color: var(--atlas-success-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-success-500);
  --atlas-btn-checked-border-color: var(--atlas-success-500);
}

.btn-ghost-success {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-success);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-success-600);
  --atlas-btn-hover-border-color: var(--atlas-success-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-success-700);
  --atlas-btn-active-border-color: var(--atlas-success-700);
  --atlas-btn-disabled-color: var(--atlas-success);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-success-400);
  --atlas-btn-check-hover-border-color: var(--atlas-success-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-success-500);
  --atlas-btn-checked-border-color: var(--atlas-success-500);
}

.btn-warning {
  --atlas-btn-bg: var(--atlas-warning);
  --atlas-btn-color: var(--atlas-contrast-warning);
  --atlas-btn-border-color: var(--atlas-warning);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-warning);
  --atlas-btn-hover-bg: var(--atlas-warning-600);
  --atlas-btn-hover-border-color: var(--atlas-warning-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-warning);
  --atlas-btn-active-bg: var(--atlas-warning-700);
  --atlas-btn-active-border-color: var(--atlas-warning-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-warning);
  --atlas-btn-disabled-border-color: var(--atlas-warning);
  --atlas-btn-disabled-bg: var(--atlas-warning);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-warning-400);
  --atlas-btn-check-hover-border-color: var(--atlas-warning-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-warning-500);
  --atlas-btn-checked-border-color: var(--atlas-warning-500);
}

.btn-outline-warning {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-warning);
  --atlas-btn-border-color: var(--atlas-warning);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-warning-600);
  --atlas-btn-hover-border-color: var(--atlas-warning-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-warning-700);
  --atlas-btn-active-border-color: var(--atlas-warning-700);
  --atlas-btn-disabled-color: var(--atlas-warning);
  --atlas-btn-disabled-bg: var(--atlas-warning-100);
  --atlas-btn-disabled-border-color: var(--atlas-warning);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-warning-400);
  --atlas-btn-check-hover-border-color: var(--atlas-warning-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-warning-500);
  --atlas-btn-checked-border-color: var(--atlas-warning-500);
}

.btn-ghost-warning {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-warning);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-warning-600);
  --atlas-btn-hover-border-color: var(--atlas-warning-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-warning-700);
  --atlas-btn-active-border-color: var(--atlas-warning-700);
  --atlas-btn-disabled-color: var(--atlas-warning);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-warning-400);
  --atlas-btn-check-hover-border-color: var(--atlas-warning-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-warning-500);
  --atlas-btn-checked-border-color: var(--atlas-warning-500);
}

.btn-danger {
  --atlas-btn-bg: var(--atlas-danger);
  --atlas-btn-color: var(--atlas-contrast-danger);
  --atlas-btn-border-color: var(--atlas-danger);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-danger);
  --atlas-btn-hover-bg: var(--atlas-danger-600);
  --atlas-btn-hover-border-color: var(--atlas-danger-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-danger);
  --atlas-btn-active-bg: var(--atlas-danger-700);
  --atlas-btn-active-border-color: var(--atlas-danger-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-danger);
  --atlas-btn-disabled-border-color: var(--atlas-danger);
  --atlas-btn-disabled-bg: var(--atlas-danger);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-danger-400);
  --atlas-btn-check-hover-border-color: var(--atlas-danger-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-danger-500);
  --atlas-btn-checked-border-color: var(--atlas-danger-500);
}

.btn-outline-danger {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-danger);
  --atlas-btn-border-color: var(--atlas-danger);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-danger-600);
  --atlas-btn-hover-border-color: var(--atlas-danger-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-danger-700);
  --atlas-btn-active-border-color: var(--atlas-danger-700);
  --atlas-btn-disabled-color: var(--atlas-danger);
  --atlas-btn-disabled-bg: var(--atlas-danger-100);
  --atlas-btn-disabled-border-color: var(--atlas-danger);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-danger-400);
  --atlas-btn-check-hover-border-color: var(--atlas-danger-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-danger-500);
  --atlas-btn-checked-border-color: var(--atlas-danger-500);
}

.btn-ghost-danger {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-danger);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-danger-600);
  --atlas-btn-hover-border-color: var(--atlas-danger-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-danger-700);
  --atlas-btn-active-border-color: var(--atlas-danger-700);
  --atlas-btn-disabled-color: var(--atlas-danger);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-danger-400);
  --atlas-btn-check-hover-border-color: var(--atlas-danger-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-danger-500);
  --atlas-btn-checked-border-color: var(--atlas-danger-500);
}

.btn-highlight {
  --atlas-btn-bg: var(--atlas-highlight);
  --atlas-btn-color: var(--atlas-contrast-highlight);
  --atlas-btn-border-color: var(--atlas-highlight);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-highlight);
  --atlas-btn-hover-bg: var(--atlas-highlight-600);
  --atlas-btn-hover-border-color: var(--atlas-highlight-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-highlight-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-highlight);
  --atlas-btn-active-bg: var(--atlas-highlight-700);
  --atlas-btn-active-border-color: var(--atlas-highlight-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-highlight);
  --atlas-btn-disabled-border-color: var(--atlas-highlight);
  --atlas-btn-disabled-bg: var(--atlas-highlight);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-highlight-400);
  --atlas-btn-check-hover-border-color: var(--atlas-highlight-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-highlight-500);
  --atlas-btn-checked-border-color: var(--atlas-highlight-500);
}

.btn-outline-highlight {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-highlight);
  --atlas-btn-border-color: var(--atlas-highlight);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-highlight-600);
  --atlas-btn-hover-border-color: var(--atlas-highlight-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-highlight-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-highlight-700);
  --atlas-btn-active-border-color: var(--atlas-highlight-700);
  --atlas-btn-disabled-color: var(--atlas-highlight);
  --atlas-btn-disabled-bg: var(--atlas-highlight-100);
  --atlas-btn-disabled-border-color: var(--atlas-highlight);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-highlight-400);
  --atlas-btn-check-hover-border-color: var(--atlas-highlight-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-highlight-500);
  --atlas-btn-checked-border-color: var(--atlas-highlight-500);
}

.btn-ghost-highlight {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-highlight);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-highlight-600);
  --atlas-btn-hover-border-color: var(--atlas-highlight-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-highlight-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-highlight-700);
  --atlas-btn-active-border-color: var(--atlas-highlight-700);
  --atlas-btn-disabled-color: var(--atlas-highlight);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-highlight-400);
  --atlas-btn-check-hover-border-color: var(--atlas-highlight-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-highlight-500);
  --atlas-btn-checked-border-color: var(--atlas-highlight-500);
}

.btn-info {
  --atlas-btn-bg: var(--atlas-info);
  --atlas-btn-color: var(--atlas-contrast-info);
  --atlas-btn-border-color: var(--atlas-info);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-info);
  --atlas-btn-hover-bg: var(--atlas-info-600);
  --atlas-btn-hover-border-color: var(--atlas-info-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-info-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-info);
  --atlas-btn-active-bg: var(--atlas-info-700);
  --atlas-btn-active-border-color: var(--atlas-info-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-info);
  --atlas-btn-disabled-border-color: var(--atlas-info);
  --atlas-btn-disabled-bg: var(--atlas-info);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-info-400);
  --atlas-btn-check-hover-border-color: var(--atlas-info-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-info-500);
  --atlas-btn-checked-border-color: var(--atlas-info-500);
}

.btn-outline-info {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-info);
  --atlas-btn-border-color: var(--atlas-info);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-info-600);
  --atlas-btn-hover-border-color: var(--atlas-info-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-info-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-info-700);
  --atlas-btn-active-border-color: var(--atlas-info-700);
  --atlas-btn-disabled-color: var(--atlas-info);
  --atlas-btn-disabled-bg: var(--atlas-info-100);
  --atlas-btn-disabled-border-color: var(--atlas-info);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-info-400);
  --atlas-btn-check-hover-border-color: var(--atlas-info-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-info-500);
  --atlas-btn-checked-border-color: var(--atlas-info-500);
}

.btn-ghost-info {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-info);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-info-600);
  --atlas-btn-hover-border-color: var(--atlas-info-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-info-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-info-700);
  --atlas-btn-active-border-color: var(--atlas-info-700);
  --atlas-btn-disabled-color: var(--atlas-info);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-info-400);
  --atlas-btn-check-hover-border-color: var(--atlas-info-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-info-500);
  --atlas-btn-checked-border-color: var(--atlas-info-500);
}

.btn-wrapper {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}

:host {
  display: block;
}

:host:not([block]) {
  width: fit-content;
}

.btn {
  position: relative;
}
.btn atlas-badge {
  position: absolute;
  top: -8px;
  right: -8px;
}

:host([in-group-first]) .btn,
:host([in-group]) .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

:host([in-group-last]) .btn,
:host([in-group]) .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}`;

// src/components/display/atlas-button/atlas-button-base.ts
var AtlasButtonBase = /*#__PURE__*/(() => {
  let AtlasButtonBase = class extends WithTooltipMixin(AtlasElement) {
    constructor() {
      super(...arguments);
      this.type = "filled";
      this.size = "md";
      this.theme = "primary";
      this.showBadge = false;
      this.hideDescriptionOnMobile = false;
      this.hideDescription = false;
      this.hideIcon = false;
      this._deviceController = new DeviceController(this);
    }
    connectedCallback() {
      var _a, _b;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this._initialBlock = (_b = this.block) != null ? _b : false;
    }
    /**
     * @internal
     * Retorna o estado inicial do atributo block
     */
    get initialBlock() {
      return this._initialBlock;
    }
    /**
     * Habilita o botão
     */
    enable() {
      this.disabled = false;
    }
    /**
     * Desabilita o botão
     */
    disable() {
      this.disabled = true;
    }
    handleButtonClick() {
      emit(this, "atlas-button-click");
    }
    isDisabled() {
      return this.disabled || this.loading;
    }
    shouldShowDescription() {
      if (!this.description || this.hideDescription) return false;
      if (!this._deviceController.isMobile) return true;
      return !this.hideDescriptionOnMobile;
    }
    isPrimaryWhiteButton() {
      return this.white && this.theme === "primary";
    }
    getButtonClasses() {
      return {
        "btn": true,
        "btn-block": this.block,
        "disabled": this.disabled,
        [`btn-${this.size}`]: true,
        [`btn-${this.theme}`]: this.type === "filled",
        [`btn-outline-${this.theme}`]: this.type === "outlined",
        [`btn-ghost-${this.theme}`]: this.type === "ghost",
        "btn-primary-white": this.isPrimaryWhiteButton() && this.type === "filled",
        "btn-outline-primary-white": this.isPrimaryWhiteButton() && this.type === "outlined"
      };
    }
    getCurrentIcon() {
      if (this.loading) return "loader";
      return this.hideIcon ? null : this.icon;
    }
    getButtonIcon(icon) {
      return when17(!!icon, () => html29`<atlas-icon size="auto" name="${icon}"></atlas-icon>`);
    }
    getButtonText() {
      return when17(this.shouldShowDescription(), () => html29`<span>${this.description}</span>`);
    }
    renderBadge() {
      return when17(this.showBadge, () => html29`<atlas-badge theme="${this.theme}" text=${this.badgeNumber} is-counter></atlas-badge>`);
    }
    renderHotspotSlot() {
      return html29`<slot name="hotspot"></slot>`;
    }
    renderSkeleton() {
      const skeletonButtonClass = {
        "skeleton": true,
        "btn-block": this.block,
        [`btn-${this.size}`]: true
      };
      return html29`<div class=${classMap17(skeletonButtonClass)}></div>`;
    }
  };
  AtlasButtonBase.styles = atlas_button_default;
  return AtlasButtonBase;
})();
__decorateClass([property30({
  type: String,
  reflect: true
})], AtlasButtonBase.prototype, "type", 2);
__decorateClass([property30({
  type: String,
  reflect: true
})], AtlasButtonBase.prototype, "size", 2);
__decorateClass([property30({
  type: String,
  reflect: true
})], AtlasButtonBase.prototype, "theme", 2);
__decorateClass([property30({
  type: String,
  reflect: true
})], AtlasButtonBase.prototype, "description", 2);
__decorateClass([property30({
  type: Boolean,
  reflect: true
})], AtlasButtonBase.prototype, "disabled", 2);
__decorateClass([property30({
  type: Boolean,
  reflect: true
})], AtlasButtonBase.prototype, "block", 2);
__decorateClass([property30({
  type: Boolean,
  reflect: true
})], AtlasButtonBase.prototype, "pill", 2);
__decorateClass([property30({
  type: Boolean,
  reflect: true
})], AtlasButtonBase.prototype, "white", 2);
__decorateClass([property30({
  type: Boolean,
  reflect: true
})], AtlasButtonBase.prototype, "loading", 2);
__decorateClass([property30({
  type: String,
  reflect: true
})], AtlasButtonBase.prototype, "icon", 2);
__decorateClass([property30({
  type: String,
  reflect: true
})], AtlasButtonBase.prototype, "href", 2);
__decorateClass([property30({
  type: Boolean,
  attribute: "is-external-link",
  reflect: true
})], AtlasButtonBase.prototype, "isExternalLink", 2);
__decorateClass([property30({
  type: Boolean,
  attribute: "show-badge",
  reflect: true
})], AtlasButtonBase.prototype, "showBadge", 2);
__decorateClass([property30({
  type: Number,
  attribute: "badge-number",
  reflect: true
})], AtlasButtonBase.prototype, "badgeNumber", 2);
__decorateClass([property30({
  type: Boolean,
  attribute: "hide-description-on-mobile"
})], AtlasButtonBase.prototype, "hideDescriptionOnMobile", 2);
__decorateClass([property30({
  type: Boolean,
  attribute: "hide-description"
})], AtlasButtonBase.prototype, "hideDescription", 2);
__decorateClass([property30({
  type: Boolean,
  attribute: "hide-icon"
})], AtlasButtonBase.prototype, "hideIcon", 2);

// src/components/form/atlas-form/atlas-form.ts
import { LitElement as LitElement9, html as html30 } from "lit";
import { customElement as customElement24, property as property31, query as query6, state as state10 } from "lit/decorators.js";

// src/helpers/form.ts
var form_exports = {};
__export(form_exports, {
  CHECK_ELEMENTS: () => CHECK_ELEMENTS,
  INPUT_ELEMENTS: () => INPUT_ELEMENTS,
  SELECT_ELEMENTS: () => SELECT_ELEMENTS,
  checkFormValidity: () => checkFormValidity,
  getAllFormElements: () => getAllFormElements,
  getFormValues: () => getFormValues,
  reportFormValidity: () => reportFormValidity,
  resetFormData: () => resetFormData,
  syncFormElementsInitialValue: () => syncFormElementsInitialValue
});
var INPUT_ELEMENTS = ["atlas-autocomplete", "atlas-card-number", "atlas-date-picker", "atlas-date-range", "atlas-float-input", "atlas-input", "atlas-integer-input", "atlas-masked-input", "atlas-money", "atlas-password-input", "atlas-percentage", "atlas-postal-code", "atlas-textarea"];
var CHECK_ELEMENTS = ["atlas-checkbox", "atlas-radio", "atlas-selection-card", "atlas-switch"];
var SELECT_ELEMENTS = ["atlas-multiselect", "atlas-select", "atlas-toggle"];
var FORM_ELEMENTS = ["atlas-autocomplete", "atlas-card-number", "atlas-checkbox", "atlas-date-picker", "atlas-date-range", "atlas-editor", "atlas-element-group", "atlas-float-input", "atlas-input", "atlas-integer-input", "atlas-masked-input", "atlas-money", "atlas-multiselect", "atlas-password-input", "atlas-percentage", "atlas-postal-code", "atlas-radio", "atlas-rating", "atlas-select", "atlas-selection-card", "atlas-switch", "atlas-textarea", "atlas-toggle", "atlas-uploader"];
var belongsToAtlasElementGroup = element => {
  const atlasElementGroup = element.closest("atlas-element-group");
  const isInsideAtlasElementGroup = atlasElementGroup !== null && !isAtlasElementGroup(element);
  return isInsideAtlasElementGroup && !!atlasElementGroup.name;
};
var isAtlasElementGroup = element => {
  return element.tagName === "ATLAS-ELEMENT-GROUP";
};
var isCheckboxElement = element => {
  const isCheckbox = element.tagName === "ATLAS-CHECKBOX";
  const isCardWithCheckbox = element.tagName === "ATLAS-SELECTION-CARD" && element.getAttribute("type") === "checkbox";
  return isCheckbox || isCardWithCheckbox;
};
var isRadioElement = element => {
  const isRadio = element.tagName === "ATLAS-RADIO";
  const isCardWithRadio = element.tagName === "ATLAS-SELECTION-CARD" && element.getAttribute("type") === "radio";
  return isRadio || isCardWithRadio;
};
var shouldGetValueCheckedAttribute = element => {
  const isCheckbox = isCheckboxElement(element);
  const isRadio = isRadioElement(element);
  if (!isCheckbox && !isRadio) return false;
  const belongsToAtlasFilter = element.closest("atlas-filter") !== null;
  if (belongsToAtlasFilter) return false;
  if (isRadio) return !element.value;
  return !element.value && !element.indeterminate;
};
var appendValuesToFormData = (formData, element, elementValue) => {
  if (formData.has(element.name) && elementValue === "") {
    return;
  }
  const isCheckbox = isCheckboxElement(element);
  const isRadio = isRadioElement(element);
  const isUploader = element.tagName === "ATLAS-UPLOADER";
  const isDateRange = element.tagName === "ATLAS-DATE-RANGE";
  if (shouldGetValueCheckedAttribute(element)) {
    const checkedElement = element;
    formData.append(element.name, checkedElement.checked.toString());
    return;
  }
  if ((isRadio || isCheckbox) && !element.checked) {
    return;
  }
  if (isUploader) {
    const uploadedFiles = elementValue;
    uploadedFiles.forEach(file => {
      formData.append(`${element.name}[tempFileId]`, `${file.tempFileId}`);
      formData.append(`${element.name}[tempFileName]`, `${file.tempFileName}`);
    });
    return;
  }
  if (isDateRange) {
    const dateRangeElement = element;
    const {
      start,
      end
    } = dateRangeElement.getSelectedRange();
    formData.append(dateRangeElement.getInputName("start"), start);
    formData.append(dateRangeElement.getInputName("end"), end);
    return;
  }
  formData.append(element.name, elementValue);
};
var appendValuesToObject = (object, element, elementValue) => {
  const isCheckbox = isCheckboxElement(element);
  const isRadio = isRadioElement(element);
  const isDateRange = element.tagName === "ATLAS-DATE-RANGE";
  const key = element.name;
  if (shouldGetValueCheckedAttribute(element)) {
    const checkedElement = element;
    Object.assign(object, {
      [key]: checkedElement.checked
    });
    return;
  }
  if ((isRadio || isCheckbox) && !element.checked) {
    return;
  }
  if (!object[key] && !isCheckbox && !isRadio) {
    if (isDateRange) {
      const dateRangeElement = element;
      const {
        start,
        end
      } = dateRangeElement.getSelectedRange();
      Object.assign(object, {
        [dateRangeElement.getInputName("start")]: start
      });
      Object.assign(object, {
        [dateRangeElement.getInputName("end")]: end
      });
      return;
    }
    Object.assign(object, {
      [key]: elementValue
    });
    return;
  }
  if ((isCheckbox || isRadio) && typeof object[key] === "undefined") {
    Object.assign(object, {
      [key]: elementValue
    });
    return;
  }
  if (!Array.isArray(object[key])) {
    Object.assign(object, {
      [key]: [object[key]]
    });
  }
  Object.assign(object, {
    [key]: [...object[key], elementValue]
  });
};
var getFormElementsFromContainer = container => {
  const formElements = container.querySelectorAll(FORM_ELEMENTS.toString());
  return [].concat(...formElements);
};
var getFormElementsFromSlot = slot => {
  const slottedElements = slot.assignedElements({
    flatten: true
  });
  const slottedFormElements = [];
  slottedElements.forEach(slottedElement => {
    if (FORM_ELEMENTS.includes(slottedElement.tagName.toLowerCase())) {
      slottedFormElements.push(slottedElement);
    } else {
      slottedFormElements.push(...getFormElementsFromContainer(slottedElement));
    }
  });
  return slottedFormElements;
};
var getAllFormElements = container => {
  let containerElement;
  if (container instanceof HTMLElement) {
    containerElement = container;
  } else if (container) {
    containerElement = document.querySelector(container);
  } else {
    containerElement = document.body;
  }
  const elements = getFormElementsFromContainer(containerElement);
  containerElement.querySelectorAll("slot").forEach(slotElement => {
    elements.push(...getFormElementsFromSlot(slotElement));
  });
  return elements;
};
var getFormValues = (container, asFormData) => {
  const formData = asFormData ? new FormData() : {};
  const formElements = getAllFormElements(container).filter(element => {
    if (isAtlasElementGroup(element)) return !!element.name;
    return !belongsToAtlasElementGroup(element);
  });
  formElements.forEach(element => {
    var _a;
    const value = (_a = element.getElementValue) == null ? void 0 : _a.call(element);
    if (asFormData) {
      appendValuesToFormData(formData, element, value);
    } else {
      appendValuesToObject(formData, element, value);
    }
  });
  return formData;
};
var checkFormValidity = container => {
  const formElements = getAllFormElements(container);
  return formElements.every(element => element.checkValidity ? element.checkValidity() : false);
};
var reportFormValidity = container => {
  const formElements = getAllFormElements(container);
  let hasFocusOnFirstInvalidElement = false;
  let hasInvalidElement = false;
  formElements.forEach(element => {
    if (!element.reportValidity || !element.reportValidity()) {
      hasInvalidElement = true;
      if (!hasFocusOnFirstInvalidElement) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "nearest"
        });
        setTimeout(() => {
          element.focus({
            preventScroll: false
          });
        }, 500);
        hasFocusOnFirstInvalidElement = true;
      }
    }
  });
  return !hasInvalidElement;
};
var resetFormData = container => {
  const formElements = getAllFormElements(container);
  formElements.forEach(element => {
    element.reset();
  });
};
var syncFormElementsInitialValue = container => {
  const formElements = getAllFormElements(container);
  formElements.forEach(element => {
    element.syncInitialValue();
  });
};

// src/components/form/atlas-form/atlas-form.scss
import { css as css27 } from "lit-element/lit-element.js";
var atlas_form_default = css27`:host {
  display: inherit;
  width: 100%;
}`;

// src/components/form/atlas-form/atlas-form.ts
var AtlasForm = /*#__PURE__*/(() => {
  let AtlasForm = class extends LitElement9 {
    constructor() {
      super(...arguments);
      this.method = "get";
      this.customAction = "";
      this._steps = [];
      this._currentStepIndex = 0;
    }
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.handleFormData = this.handleFormData.bind(this);
      this.onSlottedButtonClick = this.onSlottedButtonClick.bind(this);
      this.updateComplete.then(() => {
        this.associatedForm.addEventListener("formdata", this.handleFormData);
        this.addEventListener("atlas-button-click", this.onSlottedButtonClick);
      });
    }
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      this.associatedForm.removeEventListener("formdata", this.handleFormData);
      this.removeEventListener("atlas-button-click", this.onSlottedButtonClick);
    }
    getStepByName(stepName) {
      return this._steps.find(step => step.name === stepName);
    }
    getStepByIndex(index) {
      return this._steps[index];
    }
    getCurrentStep() {
      return this._steps[this._currentStepIndex];
    }
    getFormValues(asFormData) {
      return getFormValues(this, asFormData);
    }
    getFormStepValues(stepName, asFormData) {
      var _a;
      return (_a = this.getStepByName(stepName)) == null ? void 0 : _a.getStepValues(asFormData);
    }
    getFormValuesWithStep() {
      return this._steps.reduce((acc, step) => __spreadProps(__spreadValues({}, acc), {
        [step.name]: step.getStepValues()
      }), {});
    }
    reset() {
      resetFormData(this);
    }
    submit(formAction) {
      const fieldsContainer = this._steps.length > 0 ? this.getCurrentStep() : this;
      const isValid = reportFormValidity(fieldsContainer);
      this.customAction = "";
      if (isValid) {
        const submitEvent = emit(this, "atlas-form-submit");
        if (!submitEvent.defaultPrevented) {
          this.customAction = formAction || "";
          this.associatedForm.requestSubmit();
        }
      }
    }
    handleFormSubmit() {
      this.associatedForm.action = this.customAction || this.action;
    }
    handleFormData(event) {
      const formValues = this.getFormValues(true);
      formValues.forEach((value, key) => {
        event.formData.append(key, value);
      });
    }
    onSlottedButtonClick(event) {
      const targetButton = event.target;
      if (targetButton.hasAttribute("data-atlas-form-next-step")) {
        this.goToNextStep();
      } else if (targetButton.hasAttribute("data-atlas-form-previous-step")) {
        this.goToPreviousStep();
      } else if (targetButton.hasAttribute("data-atlas-form-submit")) {
        this.submit();
      }
    }
    onChangeSlot() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this.syncSteps();
        if (this._steps.length === 0) return;
        this._currentStepIndex = 0;
        this.changeStep(this._currentStepIndex);
      });
    }
    syncSteps() {
      this._steps = this.shadowRoot.querySelector("slot").assignedElements({
        flatten: true
      }).filter(element => element.tagName === "ATLAS-FORM-STEP").map(element => element);
    }
    goToNextStep() {
      const nextStepEvent = emit(this, "atlas-form-next-step", {
        detail: {
          currentStepIndex: this._currentStepIndex,
          nextStepIndex: this._currentStepIndex + 1
        }
      });
      if (!nextStepEvent.defaultPrevented) {
        this.changeStep(this._currentStepIndex + 1);
      }
    }
    goToPreviousStep() {
      const previousStepEvent = emit(this, "atlas-form-previous-step", {
        detail: {
          currentStepIndex: this._currentStepIndex,
          nextStepIndex: this._currentStepIndex - 1
        }
      });
      if (!previousStepEvent.defaultPrevented) {
        this.changeStep(this._currentStepIndex - 1);
      }
    }
    canChangeStep(stepIndex) {
      if (stepIndex <= this._currentStepIndex) {
        return true;
      }
      return this.getCurrentStep().validate();
    }
    changeStep(stepIndex) {
      return __async(this, null, function* () {
        const canChange = this.canChangeStep(stepIndex);
        if (!canChange) return;
        const changeStepEvent = emit(this, "atlas-form-change-step", {
          detail: {
            step: this.getStepByIndex(stepIndex),
            previousStep: this.getCurrentStep()
          }
        });
        if (changeStepEvent.defaultPrevented) return;
        this._currentStepIndex = stepIndex;
        this._currentStepName = this.getCurrentStep().name;
        this.showCurrentStep();
      });
    }
    showCurrentStep() {
      this._steps.forEach(step => {
        const isVisible = step.name === this._currentStepName;
        step.toggleStep(isVisible);
      });
    }
    render() {
      return html30`
            <form method=${this.method} target=${this.target} @submit=${this.handleFormSubmit}></form>
            <slot @slotchange=${this.onChangeSlot}></slot>
        `;
    }
  };
  AtlasForm.styles = atlas_form_default;
  return AtlasForm;
})();
__decorateClass([property31({
  type: String
})], AtlasForm.prototype, "action", 2);
__decorateClass([property31({
  type: String
})], AtlasForm.prototype, "method", 2);
__decorateClass([property31({
  type: String
})], AtlasForm.prototype, "target", 2);
__decorateClass([query6("form")], AtlasForm.prototype, "associatedForm", 2);
__decorateClass([state10()], AtlasForm.prototype, "customAction", 2);
__decorateClass([state10()], AtlasForm.prototype, "_steps", 2);
__decorateClass([state10()], AtlasForm.prototype, "_currentStepName", 2);
__decorateClass([state10()], AtlasForm.prototype, "_currentStepIndex", 2);
AtlasForm = __decorateClass([customElement24("atlas-form")], AtlasForm);

// src/components/display/atlas-button/atlas-button.ts
var AtlasButton = class extends AtlasButtonBase {
  /**
   * Executa o clique do mouse no botão
   */
  click() {
    this.shadowRoot.querySelector(".btn").click();
  }
  handleButtonClick() {
    const closestForm = this.closest("atlas-form,form");
    if (this.submit && closestForm) {
      if (closestForm instanceof AtlasForm) {
        closestForm.submit(this.formaction);
      } else {
        closestForm.requestSubmit();
      }
    } else {
      super.handleButtonClick();
    }
  }
  renderElement() {
    const containerClass = {
      "btn-wrapper": true,
      "btn-block": this.block
    };
    const buttonClass = __spreadProps(__spreadValues({}, this.getButtonClasses()), {
      "rounded-pill": this.pill,
      "disabled": this.isDisabled()
    });
    const buttonType = this.submit ? "submit" : "button";
    const tag = this.href ? literal5`a` : literal5`button`;
    return html31`
            <div
                tabindex=${this.isDisabled() ? "0" : "-1"}
                class="${classMap18(containerClass)}"
                data-atlas-tooltip="button-tooltip"
            >
                ${this.renderHotspotSlot()}
                <${tag}
                    class=${classMap18(buttonClass)}
                    type=${buttonType}
                    ?disabled=${this.isDisabled()}
                    @click=${this.handleButtonClick}
                    href=${ifDefined6(this.href ? this.href : void 0)}
                    rel="${ifDefined6(this.href && this.isExternalLink ? "noreferrer" : void 0)}"
                    target="${ifDefined6(this.href && this.isExternalLink ? "_blank" : void 0)}"
                    tabindex="${ifDefined6(this.disabled ? "-1" : "0")}"
                    aria-label=${this.ariaLabel}
                >
                    ${this.getButtonIcon(this.getCurrentIcon())} ${this.getButtonText()} ${this.renderBadge()}
                </${tag}>
            </div>
            ${this.renderTooltip("button-tooltip")}
        `;
  }
};
__decorateClass([property32({
  type: Boolean
})], AtlasButton.prototype, "submit", 2);
__decorateClass([property32({
  type: String
})], AtlasButton.prototype, "formaction", 2);
AtlasButton = __decorateClass([customElement25("atlas-button")], AtlasButton);

// src/components/display/atlas-bottom-sheet/atlas-bottom-sheet.ts
var AtlasBottomSheet = /*#__PURE__*/(() => {
  let AtlasBottomSheet = class extends LitElement10 {
    constructor() {
      super(...arguments);
      this._selectedCount = 0;
      this._previousSelectedCount = 0;
    }
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.onAnchorDragStart = this.onAnchorDragStart.bind(this);
      this.onAnchorDrag = this.onAnchorDrag.bind(this);
      this.onAnchorDragEnd = this.onAnchorDragEnd.bind(this);
      this.onClickBottomSheet = this.onClickBottomSheet.bind(this);
      this.updateComplete.then(() => {
        this._bottomSheet.addEventListener("touchstart", this.onAnchorDragStart);
        this._bottomSheet.addEventListener("touchmove", this.onAnchorDrag);
        this._bottomSheet.addEventListener("touchend", this.onAnchorDragEnd);
        this.addEventListener("atlas-select-item-click", this.changeOptionsCount);
      });
    }
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      this._bottomSheet.removeEventListener("touchstart", this.onAnchorDragStart);
      this._bottomSheet.removeEventListener("touchmove", this.onAnchorDrag);
      this._bottomSheet.removeEventListener("touchend", this.onAnchorDragEnd);
      this.removeEventListener("atlas-select-item-click", this.changeOptionsCount);
    }
    changeOptionsCount(event) {
      const {
        shouldRemove
      } = event.detail;
      const isSelectAll = event.target.selectAll;
      if (isSelectAll) {
        this._selectedCount = shouldRemove ? 0 : this.getSelectItems().length;
      } else {
        this._selectedCount = this._previousSelectedCount + (shouldRemove ? -1 : 1);
      }
      this._previousSelectedCount = this._selectedCount;
    }
    canResizeOnDrag(event) {
      const bottomSheetBody = this.shadowRoot.querySelector(".bottom-sheet-body");
      const composedPath = event.composedPath();
      const isBodyTarget = composedPath.includes(bottomSheetBody);
      if (!isBodyTarget) {
        return true;
      }
      return bottomSheetBody.scrollTop === 0;
    }
    onAnchorDragStart(event) {
      if (this.canResizeOnDrag(event)) {
        this._dragging = true;
        this._startPosition = event.changedTouches[0].clientY;
        this._bottomSheetHeight = this._bottomSheet.getBoundingClientRect().height;
      }
    }
    onAnchorDrag(event) {
      if (!this._dragging) return;
      const positionY = event.touches[0].clientY;
      const heightDiff = positionY - this._startPosition;
      if (heightDiff > 0) {
        this._currentTranslate = heightDiff * 100 / this._bottomSheetHeight;
      }
    }
    onAnchorDragEnd() {
      if (!this._dragging) return;
      this._dragging = false;
      if (this._currentTranslate > 30) {
        this._currentTranslate = 100;
        setTimeout(() => {
          this.closeBottomSheet();
        }, 200);
      } else {
        this._currentTranslate = null;
        this._startPosition = null;
      }
    }
    onClickBottomSheet(event) {
      if (!this.open) {
        return;
      }
      const composedPath = event.composedPath();
      const isBottomSheetTarget = composedPath.includes(this._bottomSheet);
      if (!isBottomSheetTarget) {
        this.closeBottomSheet();
      }
    }
    closeBottomSheet() {
      emit(this, "atlas-bottom-sheet-close", {
        trackDisable: true
      });
    }
    getSelectItems() {
      return this.querySelector("slot:not([name])").assignedElements().filter(element => element.tagName === "ATLAS-SELECT-ITEM" && !element.isGroupTitle && !element.selectAll);
    }
    countOptions() {
      const selectedOptions = this.getSelectItems().filter(element => element.selected);
      this._previousSelectedCount = selectedOptions.length;
      this._selectedCount = 0;
    }
    onOpenChange() {
      if (!this.open) return;
      this._currentTranslate = null;
      this._startPosition = null;
      this.countOptions();
    }
    renderCloseButton() {
      return html32`
            <atlas-icon-button
                icon="x"
                size="3x"
                theme="secondary"
                @click=${this.closeBottomSheet}
            ></atlas-icon-button>
        `;
    }
    renderTitle() {
      if (!this.header) return null;
      return html32`
            <atlas-heading size="h5" muted>${this.header}</atlas-heading>
            ${when18(this.fullscreen || this.showCloseButton, () => this.renderCloseButton())}
        `;
    }
    getSelectButtonDescription() {
      return this._selectedCount > 0 ? `Selecionar (${this._selectedCount})` : "Selecionar";
    }
    renderFooter() {
      return when18(this.hasFooter && this.fullscreen, () => html32`
                <div class="dropdown-buttons">
                    <atlas-button
                        theme="secondary"
                        description="Fechar"
                        @click=${this.closeBottomSheet}
                        class="dropdown-button"
                    >
                        Cancelar
                    </atlas-button>
                    <atlas-button
                        theme="primary"
                        description="${this.getSelectButtonDescription()}"
                        @click=${this.closeBottomSheet}
                        class="dropdown-button"
                    >
                        Selecionar
                    </atlas-button>
                </div>
            `);
    }
    render() {
      const bottomSheetWrapperClass = {
        "bottom-sheet-wrapper": true,
        "fade": true,
        "show": this.open
      };
      const bottomSheetClass = {
        "bottom-sheet": true,
        "fullscreen": this.fullscreen,
        "dragging": this._dragging,
        "spaced-content": this.spacedContent
      };
      const bottomSheetStyle = {
        transform: this._currentTranslate ? `translateY(${this._currentTranslate}%)` : null
      };
      return html32`
            <div class=${classMap19(bottomSheetWrapperClass)} @click=${this.onClickBottomSheet}>
                <div class=${classMap19(bottomSheetClass)} style=${styleMap7(bottomSheetStyle)} draggable="true">
                    <div class="bottom-sheet-header">
                        <div class="drag-anchor"></div>
                        <div class="bottom-sheet-title">${this.renderTitle()}</div>
                        <slot name="subheading"></slot>
                    </div>
                    <div class="bottom-sheet-body">
                        <slot></slot>
                    </div>
                    ${this.renderFooter()}
                </div>
            </div>
        `;
    }
  };
  AtlasBottomSheet.styles = atlas_bottom_sheet_default;
  return AtlasBottomSheet;
})();
__decorateClass([property33({
  type: String
})], AtlasBottomSheet.prototype, "header", 2);
__decorateClass([property33({
  type: Boolean
})], AtlasBottomSheet.prototype, "open", 2);
__decorateClass([property33({
  type: Boolean
})], AtlasBottomSheet.prototype, "fullscreen", 2);
__decorateClass([property33({
  type: Boolean,
  attribute: "has-footer"
})], AtlasBottomSheet.prototype, "hasFooter", 2);
__decorateClass([property33({
  type: Boolean,
  attribute: "spaced-content"
})], AtlasBottomSheet.prototype, "spacedContent", 2);
__decorateClass([property33({
  type: Boolean,
  attribute: "show-close-button"
})], AtlasBottomSheet.prototype, "showCloseButton", 2);
__decorateClass([state11()], AtlasBottomSheet.prototype, "_bottomSheetHeight", 2);
__decorateClass([state11()], AtlasBottomSheet.prototype, "_currentTranslate", 2);
__decorateClass([state11()], AtlasBottomSheet.prototype, "_startPosition", 2);
__decorateClass([state11()], AtlasBottomSheet.prototype, "_dragging", 2);
__decorateClass([state11()], AtlasBottomSheet.prototype, "_selectedCount", 2);
__decorateClass([query7(".bottom-sheet")], AtlasBottomSheet.prototype, "_bottomSheet", 2);
__decorateClass([Watch("open")], AtlasBottomSheet.prototype, "onOpenChange", 1);
AtlasBottomSheet = __decorateClass([customElement26("atlas-bottom-sheet")], AtlasBottomSheet);

// src/components/display/atlas-breadcrumb/atlas-breadcrumb.ts
import { html as html33 } from "lit";
import { customElement as customElement27 } from "lit/decorators.js";

// src/components/display/atlas-breadcrumb/atlas-breadcrumb.scss
import { css as css28 } from "lit-element/lit-element.js";
var atlas_breadcrumb_default = css28`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.breadcrumb {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.breadcrumb .breadcrumb-items {
  display: flex;
  gap: 0.5rem;
}`;

// src/components/display/atlas-breadcrumb/atlas-breadcrumb.ts
var AtlasBreadcrumb = /*#__PURE__*/(() => {
  let AtlasBreadcrumb = class extends AtlasElement {
    onSlotChange() {
      const items = this.shadowRoot.querySelector("slot").assignedElements();
      items.forEach((item, index) => {
        item.toggleAttribute("is-first-item", index === 0);
        item.toggleAttribute("is-last-item", index === items.length - 1);
      });
    }
    /** @internal */
    render() {
      return html33`
            <div class="breadcrumb">
                <div class="breadcrumb-items">
                    <slot @slotchange=${this.onSlotChange}></slot>
                </div>
            </div>
        `;
    }
  };
  AtlasBreadcrumb.styles = atlas_breadcrumb_default;
  return AtlasBreadcrumb;
})();
AtlasBreadcrumb = __decorateClass([customElement27("atlas-breadcrumb")], AtlasBreadcrumb);

// src/components/display/atlas-breadcrumb-item/atlas-breadcrumb-item.ts
import { html as html34 } from "lit";
import { customElement as customElement28, property as property34 } from "lit/decorators.js";
import { classMap as classMap20 } from "lit/directives/class-map.js";
import { when as when19 } from "lit/directives/when.js";

// src/components/display/atlas-breadcrumb-item/atlas-breadcrumb-item.scss
import { css as css29 } from "lit-element/lit-element.js";
var atlas_breadcrumb_item_default = css29`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.breadcrumb-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.breadcrumb-item .breadcrumb-item-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #687078;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  text-decoration: none;
  padding: 0 0.5rem;
  margin: 0 -0.5rem;
}
.breadcrumb-item a.breadcrumb-item-content:hover {
  color: var(--atlas-primary);
}
.breadcrumb-item a.breadcrumb-item-content:focus-visible {
  outline: none;
  color: var(--atlas-primary);
  background: rgba(var(--atlas-primary-300-rgb), 0.25);
  border-radius: 0.25rem;
}
.breadcrumb-item a.breadcrumb-item-content:focus-visible .breadcrumb-item-text {
  text-decoration: underline;
}

:host([is-last-item]:not([is-first-item])) .breadcrumb-item-content {
  color: #212529;
}`;

// src/components/display/atlas-breadcrumb-item/atlas-breadcrumb-item.ts
var AtlasBreadcrumbItem = /*#__PURE__*/(() => {
  let AtlasBreadcrumbItem = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.isFirstItem = false;
      this.isLastItem = false;
    }
    renderArrow() {
      return when19(!this.isFirstItem, () => html34`<atlas-icon name="chevron-right" size="2x" theme="secondary"></atlas-icon>`);
    }
    renderIcon() {
      return when19(this.isFirstItem, () => html34`<atlas-icon name=${this.icon} size="2x"></atlas-icon>`);
    }
    renderText() {
      const textClass = {
        "breadcrumb-item-text": true,
        "skeleton-pill": this.skeletonLoading
      };
      return html34`<span class=${classMap20(textClass)}>${this.text}</span>`;
    }
    renderContent() {
      return when19(!!this.href && !this.isLastItem, () => html34`
                <a class="breadcrumb-item-content" href=${this.href}> ${this.renderIcon()} ${this.renderText()} </a>
            `, () => html34` <div class="breadcrumb-item-content">${this.renderIcon()} ${this.renderText()}</div> `);
    }
    /** @internal */
    render() {
      return html34`<div class="breadcrumb-item">${this.renderArrow()} ${this.renderContent()}</div>`;
    }
  };
  AtlasBreadcrumbItem.styles = atlas_breadcrumb_item_default;
  return AtlasBreadcrumbItem;
})();
__decorateClass([property34({
  type: String
})], AtlasBreadcrumbItem.prototype, "text", 2);
__decorateClass([property34({
  type: String
})], AtlasBreadcrumbItem.prototype, "icon", 2);
__decorateClass([property34({
  type: String
})], AtlasBreadcrumbItem.prototype, "href", 2);
__decorateClass([property34({
  type: Boolean,
  attribute: "is-first-item"
})], AtlasBreadcrumbItem.prototype, "isFirstItem", 2);
__decorateClass([property34({
  type: Boolean,
  attribute: "is-last-item"
})], AtlasBreadcrumbItem.prototype, "isLastItem", 2);
AtlasBreadcrumbItem = __decorateClass([customElement28("atlas-breadcrumb-item")], AtlasBreadcrumbItem);

// src/components/display/atlas-button-group/atlas-button-group.ts
import { html as html39, unsafeStatic as unsafeStatic2 } from "lit/static-html.js";
import { customElement as customElement33, property as property39, state as state13 } from "lit/decorators.js";
import { classMap as classMap25 } from "lit/directives/class-map.js";
import { ifDefined as ifDefined8 } from "lit/directives/if-defined.js";
import { when as when23 } from "lit/directives/when.js";

// src/components/display/atlas-button-group/atlas-button-group.scss
import { css as css30 } from "lit-element/lit-element.js";
var atlas_button_group_default = css30`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 0.75rem !important;
}

.gap-4 {
  gap: 1rem !important;
}

.gap-5 {
  gap: 1.25rem !important;
}

.gap-6 {
  gap: 1.5rem !important;
}

.gap-7 {
  gap: 2rem !important;
}

.gap-8 {
  gap: 2.5rem !important;
}

.gap-9 {
  gap: 3rem !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 0.75rem !important;
}

.mt-4 {
  margin-top: 1rem !important;
}

.mt-5 {
  margin-top: 1.25rem !important;
}

.mt-6 {
  margin-top: 1.5rem !important;
}

.mt-7 {
  margin-top: 2rem !important;
}

.mt-8 {
  margin-top: 2.5rem !important;
}

.mt-9 {
  margin-top: 3rem !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 0.75rem !important;
}

.mb-4 {
  margin-bottom: 1rem !important;
}

.mb-5 {
  margin-bottom: 1.25rem !important;
}

.mb-6 {
  margin-bottom: 1.5rem !important;
}

.mb-7 {
  margin-bottom: 2rem !important;
}

.mb-8 {
  margin-bottom: 2.5rem !important;
}

.mb-9 {
  margin-bottom: 3rem !important;
}

.container {
  flex: 1 1 100%;
  box-sizing: border-box;
  padding: 0.5rem 1rem 1rem;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
@media screen and (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}
@media screen and (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}
@media screen and (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}
@media screen and (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}
@media screen and (min-width: 1400px) {
  .container {
    max-width: 1320px;
  }
}

.button-group {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

slot {
  display: none;
}

@media screen and (min-width: 1400px) {
  .button-group {
    flex-wrap: nowrap;
  }
}`;

// src/components/display/atlas-dropdown/atlas-dropdown.ts
import { html as html38 } from "lit";
import { customElement as customElement32, property as property38, state as state12 } from "lit/decorators.js";
import { classMap as classMap24 } from "lit/directives/class-map.js";
import { styleMap as styleMap9 } from "lit/directives/style-map.js";
import { when as when22 } from "lit/directives/when.js";
import { size } from "@floating-ui/dom";

// src/components/display/atlas-dropdown-item/atlas-dropdown-item.ts
import { LitElement as LitElement11, html as html35 } from "lit";
import { customElement as customElement29, property as property35 } from "lit/decorators.js";
import { classMap as classMap21 } from "lit/directives/class-map.js";
import { ifDefined as ifDefined7 } from "lit/directives/if-defined.js";
import { when as when20 } from "lit/directives/when.js";

// src/components/display/atlas-dropdown-item/atlas-dropdown-item.scss
import { css as css31 } from "lit-element/lit-element.js";
var atlas_dropdown_item_default = css31`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Shadows */
/* Elevations */
:host(:not[hidden]) {
  display: inline-flex;
}

.dropdown-item-wrapper {
  width: 100%;
}

.dropdown-item {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 1rem;
  clear: both;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
  color: #212529;
  text-align: inherit;
  text-decoration: none;
  background-color: transparent;
  border: 0;
  box-sizing: border-box;
  cursor: pointer;
}
.dropdown-item:hover {
  background-color: var(--atlas-primary-100);
}
.dropdown-item:focus, .dropdown-item:focus-visible, .dropdown-item:focus-within {
  appearance: none;
  outline: none;
  border: none;
  box-shadow: none;
}
.dropdown-item.focused {
  border: 0.25rem solid rgba(var(--atlas-primary-500-rgb), 0.25);
  border-radius: 0.25rem;
  padding: 0.75rem;
}
@media screen and (min-width: 992px) {
  .dropdown-item.focused {
    padding: 0.25rem 0.75rem;
  }
}
.dropdown-item:active, .dropdown-item.active, .dropdown-item.selected {
  background: var(--atlas-primary);
  color: var(--atlas-contrast-primary);
}
.dropdown-item:disabled, .dropdown-item.disabled, .dropdown-item.loading {
  opacity: 0.35;
  pointer-events: none;
}
.dropdown-item:focus-visible {
  outline: none;
}
@media screen and (min-width: 992px) {
  .dropdown-item {
    padding: 0.5rem 1rem;
  }
}

.dropdown-item-primary:hover {
  background-color: var(--atlas-primary-100);
}
.dropdown-item-primary:focus, .dropdown-item-primary:focus-visible, .dropdown-item-primary:focus-within {
  appearance: none;
  outline: none;
  border: none;
  box-shadow: none;
}
.dropdown-item-primary.focused {
  border: 0.25rem solid rgba(var(--atlas-primary-500-rgb), 0.25);
  border-radius: 0.25rem;
  padding: 0.75rem;
}
@media screen and (min-width: 992px) {
  .dropdown-item-primary.focused {
    padding: 0.25rem 0.75rem;
  }
}
.dropdown-item-primary:active, .dropdown-item-primary.active, .dropdown-item-primary.selected {
  background: var(--atlas-primary);
  color: var(--atlas-contrast-primary);
}

.dropdown-item-secondary {
  color: var(--atlas-secondary);
}
.dropdown-item-secondary:hover {
  background-color: var(--atlas-primary-100);
}
.dropdown-item-secondary:focus, .dropdown-item-secondary:focus-visible, .dropdown-item-secondary:focus-within {
  appearance: none;
  outline: none;
  border: none;
  box-shadow: none;
}
.dropdown-item-secondary.focused {
  border: 0.25rem solid rgba(var(--atlas-secondary-500-rgb), 0.25);
  border-radius: 0.25rem;
  padding: 0.75rem;
}
@media screen and (min-width: 992px) {
  .dropdown-item-secondary.focused {
    padding: 0.25rem 0.75rem;
  }
}
.dropdown-item-secondary:active, .dropdown-item-secondary.active, .dropdown-item-secondary.selected {
  background: var(--atlas-primary);
  color: var(--atlas-contrast-primary);
}

.dropdown-item-success {
  color: var(--atlas-success);
}
.dropdown-item-success:hover {
  background-color: var(--atlas-success-100);
}
.dropdown-item-success:focus, .dropdown-item-success:focus-visible, .dropdown-item-success:focus-within {
  appearance: none;
  outline: none;
  border: none;
  box-shadow: none;
}
.dropdown-item-success.focused {
  border: 0.25rem solid rgba(var(--atlas-success-500-rgb), 0.25);
  border-radius: 0.25rem;
  padding: 0.75rem;
}
@media screen and (min-width: 992px) {
  .dropdown-item-success.focused {
    padding: 0.25rem 0.75rem;
  }
}
.dropdown-item-success:active, .dropdown-item-success.active, .dropdown-item-success.selected {
  background: var(--atlas-success);
  color: var(--atlas-contrast-success);
}

.dropdown-item-warning {
  color: var(--atlas-warning);
}
.dropdown-item-warning:hover {
  background-color: var(--atlas-warning-100);
}
.dropdown-item-warning:focus, .dropdown-item-warning:focus-visible, .dropdown-item-warning:focus-within {
  appearance: none;
  outline: none;
  border: none;
  box-shadow: none;
}
.dropdown-item-warning.focused {
  border: 0.25rem solid rgba(var(--atlas-warning-500-rgb), 0.25);
  border-radius: 0.25rem;
  padding: 0.75rem;
}
@media screen and (min-width: 992px) {
  .dropdown-item-warning.focused {
    padding: 0.25rem 0.75rem;
  }
}
.dropdown-item-warning:active, .dropdown-item-warning.active, .dropdown-item-warning.selected {
  background: var(--atlas-warning);
  color: var(--atlas-contrast-warning);
}

.dropdown-item-danger {
  color: var(--atlas-danger);
}
.dropdown-item-danger:hover {
  background-color: var(--atlas-danger-100);
}
.dropdown-item-danger:focus, .dropdown-item-danger:focus-visible, .dropdown-item-danger:focus-within {
  appearance: none;
  outline: none;
  border: none;
  box-shadow: none;
}
.dropdown-item-danger.focused {
  border: 0.25rem solid rgba(var(--atlas-danger-500-rgb), 0.25);
  border-radius: 0.25rem;
  padding: 0.75rem;
}
@media screen and (min-width: 992px) {
  .dropdown-item-danger.focused {
    padding: 0.25rem 0.75rem;
  }
}
.dropdown-item-danger:active, .dropdown-item-danger.active, .dropdown-item-danger.selected {
  background: var(--atlas-danger);
  color: var(--atlas-contrast-danger);
}

.dropdown-item-highlight {
  color: var(--atlas-highlight);
}
.dropdown-item-highlight:hover {
  background-color: var(--atlas-highlight-100);
}
.dropdown-item-highlight:focus, .dropdown-item-highlight:focus-visible, .dropdown-item-highlight:focus-within {
  appearance: none;
  outline: none;
  border: none;
  box-shadow: none;
}
.dropdown-item-highlight.focused {
  border: 0.25rem solid rgba(var(--atlas-highlight-500-rgb), 0.25);
  border-radius: 0.25rem;
  padding: 0.75rem;
}
@media screen and (min-width: 992px) {
  .dropdown-item-highlight.focused {
    padding: 0.25rem 0.75rem;
  }
}
.dropdown-item-highlight:active, .dropdown-item-highlight.active, .dropdown-item-highlight.selected {
  background: var(--atlas-highlight);
  color: var(--atlas-contrast-highlight);
}

.dropdown-item-info {
  color: var(--atlas-info);
}
.dropdown-item-info:hover {
  background-color: var(--atlas-info-100);
}
.dropdown-item-info:focus, .dropdown-item-info:focus-visible, .dropdown-item-info:focus-within {
  appearance: none;
  outline: none;
  border: none;
  box-shadow: none;
}
.dropdown-item-info.focused {
  border: 0.25rem solid rgba(var(--atlas-info-500-rgb), 0.25);
  border-radius: 0.25rem;
  padding: 0.75rem;
}
@media screen and (min-width: 992px) {
  .dropdown-item-info.focused {
    padding: 0.25rem 0.75rem;
  }
}
.dropdown-item-info:active, .dropdown-item-info.active, .dropdown-item-info.selected {
  background: var(--atlas-info);
  color: var(--atlas-contrast-info);
}`;

// src/components/display/atlas-dropdown-item/atlas-dropdown-item.ts
var AtlasDropdownItem = /*#__PURE__*/(() => {
  let AtlasDropdownItem = class extends WithTooltipMixin(LitElement11) {
    constructor() {
      super(...arguments);
      this.external = false;
      this.active = false;
      this.disabled = false;
      this.isNew = false;
    }
    onChangeTagNew() {
      emit(this, "atlas-changed-is-new", {
        trackDisable: true
      });
    }
    handleItemClick(event) {
      if (this.disabled || this.loading) {
        return;
      }
      if (this.href) event.stopPropagation();
      const itemClick = emit(this, "atlas-dropdown-item-click");
      if (itemClick.defaultPrevented) {
        event.stopPropagation();
        event.preventDefault();
      }
    }
    getThemeClass() {
      return this.theme ? `dropdown-item-${this.theme}` : "";
    }
    renderIcon() {
      return when20(!!this.icon || this.loading, () => html35`<atlas-icon name=${this.loading ? "loader" : this.icon} size="2x"></atlas-icon>`);
    }
    /** @internal */
    render() {
      const itemClass = {
        "dropdown-item": true,
        [this.getThemeClass()]: true,
        "active": this.active,
        "disabled": this.disabled || this.loading,
        "loading": this.loading
      };
      return html35`
            <div class="dropdown-item-wrapper" data-atlas-tooltip="dropdown-item-tooltip">
                <a
                    class=${classMap21(itemClass)}
                    href="${ifDefined7(this.href || void 0)}"
                    rel="${ifDefined7(this.external ? "noreferrer noopener" : void 0)}"
                    target="${ifDefined7(this.external ? "_blank" : void 0)}"
                    @click=${this.handleItemClick}
                >
                    ${this.renderIcon()}
                    <span>
                        <slot></slot>
                    </span>
                    ${when20(this.isNew, () => html35`<atlas-badge text="Novo"></atlas-badge>`)}
                </a>
            </div>
            ${this.renderTooltip("dropdown-item-tooltip")}
        `;
    }
  };
  AtlasDropdownItem.styles = atlas_dropdown_item_default;
  return AtlasDropdownItem;
})();
__decorateClass([property35({
  type: String
})], AtlasDropdownItem.prototype, "href", 2);
__decorateClass([property35({
  type: String
})], AtlasDropdownItem.prototype, "icon", 2);
__decorateClass([property35({
  type: String
})], AtlasDropdownItem.prototype, "theme", 2);
__decorateClass([property35({
  type: Boolean
})], AtlasDropdownItem.prototype, "external", 2);
__decorateClass([property35({
  type: Boolean
})], AtlasDropdownItem.prototype, "active", 2);
__decorateClass([property35({
  type: Boolean
})], AtlasDropdownItem.prototype, "disabled", 2);
__decorateClass([property35({
  type: Boolean,
  attribute: "is-new",
  reflect: true
})], AtlasDropdownItem.prototype, "isNew", 2);
__decorateClass([property35({
  type: Boolean
})], AtlasDropdownItem.prototype, "loading", 2);
__decorateClass([Watch("isNew", true)], AtlasDropdownItem.prototype, "onChangeTagNew", 1);
AtlasDropdownItem = __decorateClass([customElement29("atlas-dropdown-item")], AtlasDropdownItem);

// src/components/display/atlas-desktop-dropdown/atlas-desktop-dropdown.ts
import { html as html36, LitElement as LitElement12 } from "lit";
import { customElement as customElement30, property as property36 } from "lit/decorators.js";
import { classMap as classMap22 } from "lit/directives/class-map.js";
import { styleMap as styleMap8 } from "lit/directives/style-map.js";
import { when as when21 } from "lit/directives/when.js";

// src/components/display/atlas-desktop-dropdown/atlas-desktop-dropdown.scss
import { css as css32 } from "lit-element/lit-element.js";
var atlas_desktop_dropdown_default = css32`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Z-index mapping for the floating elements */
/* Transitions */
.fade {
  transition: opacity 0.25s ease;
}
.fade:not(.show) {
  opacity: 0;
}

.fade-and-scale {
  opacity: 0;
  transform: scale(0.7);
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.fade-and-scale.scale-vertically {
  transform: scale(1, 0.7);
}
.fade-and-scale.show {
  opacity: 1;
  transform: scale(1);
}

:host([data-popper-placement=top]),
:host([data-popper-placement=top]) .fade-and-scale,
div[data-popper-placement=top].fade-and-scale,
div[data-popper-placement=top] > .fade-and-scale,
.fade-and-scale.scale-top {
  transform-origin: center bottom;
}

:host([data-popper-placement=top-start]),
:host([data-popper-placement=top-start]) .fade-and-scale,
div[data-popper-placement=top-start].fade-and-scale,
div[data-popper-placement=top-start] > .fade-and-scale,
.fade-and-scale.scale-top-start {
  transform-origin: left bottom;
}

:host([data-popper-placement=top-end]),
:host([data-popper-placement=top-end]) .fade-and-scale,
div[data-popper-placement=top-end].fade-and-scale,
div[data-popper-placement=top-end] > .fade-and-scale,
.fade-and-scale.scale-top-end {
  transform-origin: right bottom;
}

:host([data-popper-placement=bottom]),
:host([data-popper-placement=bottom]) .fade-and-scale,
div[data-popper-placement=bottom].fade-and-scale,
div[data-popper-placement=bottom] > .fade-and-scale,
.fade-and-scale.scale-bottom {
  transform-origin: center top;
}

:host([data-popper-placement=bottom-start]),
:host([data-popper-placement=bottom-start]) .fade-and-scale,
div[data-popper-placement=bottom-start].fade-and-scale,
div[data-popper-placement=bottom-start] > .fade-and-scale,
.fade-and-scale.scale-bottom-start {
  transform-origin: left top;
}

:host([data-popper-placement=bottom-end]),
:host([data-popper-placement=bottom-end]) .fade-and-scale,
div[data-popper-placement=bottom-end].fade-and-scale,
div[data-popper-placement=bottom-end] > .fade-and-scale,
.fade-and-scale.scale-bottom-end {
  transform-origin: right top;
}

:host([data-popper-placement=left]),
:host([data-popper-placement=left]) .fade-and-scale,
div[data-popper-placement=left].fade-and-scale,
div[data-popper-placement=left] > .fade-and-scale,
.fade-and-scale.scale-left {
  transform-origin: right center;
}

:host([data-popper-placement=left-start]),
:host([data-popper-placement=left-start]) .fade-and-scale,
div[data-popper-placement=left-start].fade-and-scale,
div[data-popper-placement=left-start] > .fade-and-scale,
.fade-and-scale.scale-left-start {
  transform-origin: right top;
}

:host([data-popper-placement=left-end]),
:host([data-popper-placement=left-end]) .fade-and-scale,
div[data-popper-placement=left-end].fade-and-scale,
div[data-popper-placement=left-end] > .fade-and-scale,
.fade-and-scale.scale-left-end {
  transform-origin: right bottom;
}

:host([data-popper-placement=right]),
:host([data-popper-placement=right]) .fade-and-scale,
div[data-popper-placement=right].fade-and-scale,
div[data-popper-placement=right] > .fade-and-scale,
.fade-and-scale.scale-right {
  transform-origin: left center;
}

:host([data-popper-placement=right-start]),
:host([data-popper-placement=right-start]) .fade-and-scale,
div[data-popper-placement=right-start].fade-and-scale,
div[data-popper-placement=right-start] > .fade-and-scale,
.fade-and-scale.scale-right-start {
  transform-origin: left top;
}

:host([data-popper-placement=right-end]),
:host([data-popper-placement=right-end]) .fade-and-scale,
div[data-popper-placement=right-end].fade-and-scale,
div[data-popper-placement=right-end] > .fade-and-scale,
.fade-and-scale.scale-right-end {
  transform-origin: left bottom;
}

:host {
  position: fixed;
  z-index: 1000;
  width: max-content;
}

:host(:not([open])) {
  pointer-events: none;
}

.dropdown {
  color: #212529;
  text-align: left;
  width: auto;
  min-width: 160px;
  max-width: 540px;
  height: 100%;
  background-color: #ffffff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  box-sizing: border-box;
  overflow: visible;
  display: flex;
  flex-direction: column;
}
.dropdown .dropdown-title {
  flex-shrink: 0;
  padding: 1.5rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.dropdown ::slotted(atlas-dropdown-item:nth-child(1 of :not([hidden]))),
.dropdown ::slotted(atlas-select-item:nth-child(1 of :not([hidden]))) {
  margin-top: 0.5rem !important;
}
.dropdown ::slotted(atlas-dropdown-item:nth-last-child(1 of :not([hidden]))),
.dropdown ::slotted(atlas-select-item:nth-last-child(1 of :not([hidden]))) {
  margin-bottom: 0.5rem !important;
}

:host(.has-subheading) .dropdown-title {
  border-bottom: 1px solid #ced4da;
  margin-bottom: 0.5rem;
}

.dropdown-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow: auto;
  overscroll-behavior: none;
}

.dropdown.spaced-content .dropdown-content {
  padding: 0 24px 16px;
}

.dropdown.no-gap .dropdown-header {
  margin-bottom: 0;
}
.dropdown.no-gap .dropdown-content {
  gap: 0;
}

.dropdown.has-width {
  max-width: unset;
}

.dropdown.overflow .dropdown-content {
  overflow: visible;
}`;

// src/components/display/atlas-desktop-dropdown/atlas-desktop-dropdown.ts
var AtlasDesktopDropdown = /*#__PURE__*/(() => {
  let AtlasDesktopDropdown = class extends LitElement12 {
    renderHeader() {
      return when21(this.header && this.header.trim(), () => html36`
                <div class="dropdown-title">
                    <atlas-heading ellipsis size="h5" title=${this.header}>${this.header}</atlas-heading>
                    <slot name="subheading"></slot>
                </div>
            `);
    }
    render() {
      const dropdownClass = {
        "dropdown": true,
        "fade-and-scale": true,
        "scale-vertically": this.scaleVertically,
        "show": this.open,
        "spaced-content": this.spacedContent,
        "no-gap": this.noGap,
        "overflow": this.overflow,
        "has-width": !!this.width
      };
      const dropdownStyles = {
        maxHeight: this.maxHeight > 0 ? `${this.maxHeight}px` : "none",
        maxWidth: this.maxWidth === "unset" ? "unset" : "540px",
        width: this.width > 0 ? `${this.width}px` : "auto"
      };
      return html36`
            <div class=${classMap22(dropdownClass)} style=${styleMap8(dropdownStyles)}>
                ${this.renderHeader()}
                <div class="dropdown-content">
                    <slot></slot>
                </div>
            </div>
        `;
    }
  };
  AtlasDesktopDropdown.styles = atlas_desktop_dropdown_default;
  return AtlasDesktopDropdown;
})();
__decorateClass([property36({
  type: String
})], AtlasDesktopDropdown.prototype, "header", 2);
__decorateClass([property36({
  type: Number
})], AtlasDesktopDropdown.prototype, "width", 2);
__decorateClass([property36({
  type: Boolean
})], AtlasDesktopDropdown.prototype, "open", 2);
__decorateClass([property36({
  type: Boolean
})], AtlasDesktopDropdown.prototype, "overflow", 2);
__decorateClass([property36({
  type: String,
  attribute: "max-width"
})], AtlasDesktopDropdown.prototype, "maxWidth", 2);
__decorateClass([property36({
  type: Number,
  attribute: "max-height"
})], AtlasDesktopDropdown.prototype, "maxHeight", 2);
__decorateClass([property36({
  type: Boolean,
  attribute: "spaced-content"
})], AtlasDesktopDropdown.prototype, "spacedContent", 2);
__decorateClass([property36({
  type: Boolean,
  attribute: "no-gap"
})], AtlasDesktopDropdown.prototype, "noGap", 2);
__decorateClass([property36({
  type: Boolean,
  attribute: "scale-vertically"
})], AtlasDesktopDropdown.prototype, "scaleVertically", 2);
AtlasDesktopDropdown = __decorateClass([customElement30("atlas-desktop-dropdown")], AtlasDesktopDropdown);

// src/components/display/atlas-navbar-dropdown/atlas-navbar-dropdown.ts
import { html as html37, LitElement as LitElement13 } from "lit";
import { customElement as customElement31, property as property37 } from "lit/decorators.js";
import { classMap as classMap23 } from "lit/directives/class-map.js";

// src/components/display/atlas-navbar-dropdown/atlas-navbar-dropdown.scss
import { css as css33 } from "lit-element/lit-element.js";
var atlas_navbar_dropdown_default = css33`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Z-index mapping for the floating elements */
/* Transitions */
.fade {
  transition: opacity 0.25s ease;
}
.fade:not(.show) {
  opacity: 0;
}

.fade-and-scale {
  opacity: 0;
  transform: scale(0.7);
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.fade-and-scale.scale-vertically {
  transform: scale(1, 0.7);
}
.fade-and-scale.show {
  opacity: 1;
  transform: scale(1);
}

:host([data-popper-placement=top]),
:host([data-popper-placement=top]) .fade-and-scale,
div[data-popper-placement=top].fade-and-scale,
div[data-popper-placement=top] > .fade-and-scale,
.fade-and-scale.scale-top {
  transform-origin: center bottom;
}

:host([data-popper-placement=top-start]),
:host([data-popper-placement=top-start]) .fade-and-scale,
div[data-popper-placement=top-start].fade-and-scale,
div[data-popper-placement=top-start] > .fade-and-scale,
.fade-and-scale.scale-top-start {
  transform-origin: left bottom;
}

:host([data-popper-placement=top-end]),
:host([data-popper-placement=top-end]) .fade-and-scale,
div[data-popper-placement=top-end].fade-and-scale,
div[data-popper-placement=top-end] > .fade-and-scale,
.fade-and-scale.scale-top-end {
  transform-origin: right bottom;
}

:host([data-popper-placement=bottom]),
:host([data-popper-placement=bottom]) .fade-and-scale,
div[data-popper-placement=bottom].fade-and-scale,
div[data-popper-placement=bottom] > .fade-and-scale,
.fade-and-scale.scale-bottom {
  transform-origin: center top;
}

:host([data-popper-placement=bottom-start]),
:host([data-popper-placement=bottom-start]) .fade-and-scale,
div[data-popper-placement=bottom-start].fade-and-scale,
div[data-popper-placement=bottom-start] > .fade-and-scale,
.fade-and-scale.scale-bottom-start {
  transform-origin: left top;
}

:host([data-popper-placement=bottom-end]),
:host([data-popper-placement=bottom-end]) .fade-and-scale,
div[data-popper-placement=bottom-end].fade-and-scale,
div[data-popper-placement=bottom-end] > .fade-and-scale,
.fade-and-scale.scale-bottom-end {
  transform-origin: right top;
}

:host([data-popper-placement=left]),
:host([data-popper-placement=left]) .fade-and-scale,
div[data-popper-placement=left].fade-and-scale,
div[data-popper-placement=left] > .fade-and-scale,
.fade-and-scale.scale-left {
  transform-origin: right center;
}

:host([data-popper-placement=left-start]),
:host([data-popper-placement=left-start]) .fade-and-scale,
div[data-popper-placement=left-start].fade-and-scale,
div[data-popper-placement=left-start] > .fade-and-scale,
.fade-and-scale.scale-left-start {
  transform-origin: right top;
}

:host([data-popper-placement=left-end]),
:host([data-popper-placement=left-end]) .fade-and-scale,
div[data-popper-placement=left-end].fade-and-scale,
div[data-popper-placement=left-end] > .fade-and-scale,
.fade-and-scale.scale-left-end {
  transform-origin: right bottom;
}

:host([data-popper-placement=right]),
:host([data-popper-placement=right]) .fade-and-scale,
div[data-popper-placement=right].fade-and-scale,
div[data-popper-placement=right] > .fade-and-scale,
.fade-and-scale.scale-right {
  transform-origin: left center;
}

:host([data-popper-placement=right-start]),
:host([data-popper-placement=right-start]) .fade-and-scale,
div[data-popper-placement=right-start].fade-and-scale,
div[data-popper-placement=right-start] > .fade-and-scale,
.fade-and-scale.scale-right-start {
  transform-origin: left top;
}

:host([data-popper-placement=right-end]),
:host([data-popper-placement=right-end]) .fade-and-scale,
div[data-popper-placement=right-end].fade-and-scale,
div[data-popper-placement=right-end] > .fade-and-scale,
.fade-and-scale.scale-right-end {
  transform-origin: left bottom;
}

:host {
  position: fixed;
  overflow: hidden;
  z-index: 1000;
  pointer-events: none;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}

:host([open]) {
  pointer-events: all;
}

.dropdown {
  color: #212529;
  text-align: left;
  padding: 0 0 8px;
  height: 100%;
  width: 100%;
  background-color: #ffffff;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.dropdown-header {
  flex: 0 0 64px;
  width: 100%;
  display: flex;
  align-items: center;
  background: #ffffff;
  border-bottom: 1px solid #ced4da;
  padding: 1rem 2rem;
  margin-bottom: 0.5rem;
  box-sizing: border-box;
  justify-content: space-between;
  gap: 24px;
}
.dropdown-header .title {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 1.25;
  color: #687078;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dropdown-header .close-mobile {
  display: inline-flex;
  background: none;
  padding: 0;
  border: 0;
  cursor: pointer;
  align-self: flex-start;
}
.dropdown-header .dropdown-title {
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
@media screen and (min-width: 992px) {
  .dropdown-header {
    flex: 0 0 80px;
  }
}

.dropdown-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow: auto;
  overscroll-behavior: none;
}

.dropdown.spaced-content .dropdown-content {
  padding: 0 16px 16px;
}

.dropdown.no-gap .dropdown-header {
  margin-bottom: 0;
}
.dropdown.no-gap .dropdown-content {
  gap: 0;
}`;

// src/components/display/atlas-navbar-dropdown/atlas-navbar-dropdown.ts
var AtlasNavbarDropdown = /*#__PURE__*/(() => {
  let AtlasNavbarDropdown = class extends LitElement13 {
    constructor() {
      super(...arguments);
      this.spacedContent = false;
      this.noGap = false;
    }
    handleClickClose(event) {
      event.stopPropagation();
      emit(this, "atlas-dropdown-trigger-close", {
        trackDisable: true
      });
    }
    renderHeader() {
      return html37`
            <div class="dropdown-header">
                <div class="dropdown-title">
                    <atlas-heading ellipsis size="h5" title=${this.header}>${this.header}</atlas-heading>
                    <slot name="subheading"></slot>
                </div>
                <button class="close-mobile" @click=${this.handleClickClose}>
                    <atlas-icon name="x" size="3x" theme="primary"></atlas-icon>
                </button>
            </div>
        `;
    }
    render() {
      const dropdownClass = {
        "dropdown": true,
        "fade": true,
        "show": this.open,
        "spaced-content": this.spacedContent,
        "no-gap": this.noGap
      };
      return html37`
            <div class=${classMap23(dropdownClass)}>
                ${this.renderHeader()}
                <div class="dropdown-content">
                    <slot></slot>
                </div>
            </div>
        `;
    }
  };
  AtlasNavbarDropdown.styles = atlas_navbar_dropdown_default;
  return AtlasNavbarDropdown;
})();
__decorateClass([property37({
  type: String
})], AtlasNavbarDropdown.prototype, "header", 2);
__decorateClass([property37({
  type: Boolean
})], AtlasNavbarDropdown.prototype, "open", 2);
__decorateClass([property37({
  type: Boolean,
  attribute: "spaced-content"
})], AtlasNavbarDropdown.prototype, "spacedContent", 2);
__decorateClass([property37({
  type: Boolean,
  attribute: "no-gap"
})], AtlasNavbarDropdown.prototype, "noGap", 2);
AtlasNavbarDropdown = __decorateClass([customElement31("atlas-navbar-dropdown")], AtlasNavbarDropdown);

// src/components/display/atlas-dropdown/atlas-dropdown.ts
var AtlasDropdown = class extends OverlayElement {
  constructor() {
    super("click", "bottom-start");
    this.autoCloseTrigger = "any";
    this._onNavbarContext = false;
    this._hasSlottedSubheading = false;
    this._deviceController = new DeviceController(this);
    this._floatingUiController.getCustomMiddlewares = this.getFloatingCustomMiddlewares.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.syncTriggerWithContent = this.syncTriggerWithContent.bind(this);
    this.updateComplete.then(() => {
      this._onNavbarContext = !!this.closest("atlas-navbar");
    });
  }
  /**
   * @internal
   */
  connectedCallback() {
    var _a;
    (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
    this.addEventListener("atlas-changed-is-new", this.syncTriggerWithContent);
    this.addEventListener("atlas-dropdown-trigger-close", this.hide);
    this.addEventListener("atlas-bottom-sheet-close", this.hide);
    this.addEventListener("atlas-open-advanced-filter", this.hide);
    this.addEventListener("atlas-filter-close", this.hide);
  }
  /**
   * @internal
   */
  disconnectedCallback() {
    var _a;
    (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
    this.removeEventListener("atlas-changed-is-new", this.syncTriggerWithContent);
    this.removeEventListener("atlas-dropdown-trigger-close", this.hide);
    this.removeEventListener("atlas-bottom-sheet-close", this.hide);
    this.removeEventListener("atlas-open-advanced-filter", this.hide);
    this.removeEventListener("atlas-filter-close", this.hide);
  }
  /**
   * @internal
   */
  getFloatingElement() {
    return this.shadowRoot.querySelector(".dropdown-wrapper") || this;
  }
  /**
   * @internal
   */
  syncTriggerElement() {
    super.syncTriggerElement();
    this.syncTriggerWithContent();
  }
  /**
   * @internal
   */
  updatePosition() {
    this._modifierMaxHeight = null;
    this.updateComplete.then(() => {
      super.updatePosition();
    });
  }
  onOpenOverlay() {
    return __async(this, null, function* () {
      this._modifierMaxHeight = null;
      yield __superGet(AtlasDropdown.prototype, this, "onOpenOverlay").call(this);
      document.addEventListener("click", this.onDocumentClick);
      document.body.classList.toggle("disable-scroll-dropdown", this.isOnNavbarContext() || this.isBottomSheet());
      this._triggerController.triggerElement.setAttribute("active", "");
      this._triggerController.triggerElement.setAttribute("aria-expanded", "true");
    });
  }
  onCloseOverlay() {
    return __async(this, null, function* () {
      yield __superGet(AtlasDropdown.prototype, this, "onCloseOverlay").call(this);
      document.removeEventListener("click", this.onDocumentClick);
      document.body.classList.remove("disable-scroll-dropdown");
      this._triggerController.triggerElement.removeAttribute("active");
      this._triggerController.triggerElement.setAttribute("aria-expanded", "false");
    });
  }
  isOnNavbarContext() {
    return this._onNavbarContext && this._deviceController.isMobile;
  }
  isBottomSheet() {
    return !this._onNavbarContext && this._deviceController.isMobile;
  }
  syncTriggerWithContent() {
    const {
      triggerElement
    } = this._triggerController;
    setTimeout(() => {
      if (triggerElement.tagName === "ATLAS-AVATAR") {
        const defaultSlot = this.shadowRoot.querySelector("slot:not([name])");
        const dropdownItems = defaultSlot.assignedElements({
          flatten: true
        });
        const hasItemWithNewTag = dropdownItems.some(item => item.hasAttribute("is-new"));
        triggerElement.toggleAttribute("show-badge", hasItemWithNewTag);
      }
    }, 0);
  }
  getFloatingCustomMiddlewares() {
    const isDesktop = !this.isOnNavbarContext() && !this.isBottomSheet();
    const {
      triggerElement
    } = this._triggerController;
    const customMiddlewares = [];
    customMiddlewares.push(size({
      apply: ({
        availableHeight
      }) => {
        const applyScrennMaxHeight = !this.maxHeight || availableHeight < this.maxHeight;
        this._modifierMaxHeight = applyScrennMaxHeight ? availableHeight - 8 : null;
      }
    }));
    if (!isDesktop) {
      customMiddlewares.push({
        name: "fullScreenMiddleware",
        fn: () => ({
          x: 0,
          y: 0
        })
      });
    }
    if (isDesktop && triggerElement.classList.contains("form-control")) {
      customMiddlewares.push({
        name: "sameSizeMiddleware",
        fn: () => {
          this.width = triggerElement.getBoundingClientRect().width;
          this.maxWidth = "unset";
          return {};
        }
      });
    }
    return customMiddlewares;
  }
  onDocumentClick(event) {
    if (!this.autoClose || !this.open || this.isBottomSheet()) {
      return;
    }
    const composedPath = event.composedPath();
    const isToggleTarget = composedPath.includes(this._triggerController.triggerElement);
    const isMenuTarget = composedPath.includes(this.getFloatingElement());
    if (isToggleTarget || this.autoCloseTrigger === "inside" && !isMenuTarget || this.autoCloseTrigger === "outside" && isMenuTarget) {
      return;
    }
    this.hide();
  }
  onSubheadingChange() {
    this._hasSlottedSubheading = !isEmptySlot(this, "subheading");
  }
  renderLoading() {
    return when22(this.loading, () => html38`<atlas-dropdown-item loading>${this.loadingText || "Carregando op\xE7\xF5es"}</atlas-dropdown-item>`);
  }
  renderDropdownContent() {
    const defaultSlotStyle = {
      display: this.loading ? "none" : "contents"
    };
    return html38`
            <slot name="subheading" slot="subheading" @slotchange=${this.onSubheadingChange}></slot>
            ${this.renderLoading()}
            <slot style=${styleMap9(defaultSlotStyle)}></slot>
        `;
  }
  /**
   * @internal
   */
  render() {
    var _a;
    const dropdownClass = {
      "dropdown-wrapper": true,
      "loading": this.loading,
      "has-subheading": this._hasSlottedSubheading
    };
    if (this.isOnNavbarContext()) {
      return html38`
                <atlas-navbar-dropdown
                    class=${classMap24(dropdownClass)}
                    header=${this.header}
                    ?spaced-content=${this.spacedContent}
                    ?no-gap=${this.noGap}
                    ?open=${this.open}
                >
                    ${this.renderDropdownContent()}
                </atlas-navbar-dropdown>
            `;
    }
    if (this.isBottomSheet()) {
      return html38`
                <atlas-bottom-sheet
                    class=${classMap24(dropdownClass)}
                    header=${this.header}
                    ?open=${this.open}
                    ?fullscreen=${this.mobileFullScreen}
                    ?has-footer=${this.hasFooter}
                    ?spaced-content=${this.spacedContent}
                    ?show-close-button=${this.showCloseButton}
                >
                    ${this.renderDropdownContent()}
                </atlas-bottom-sheet>
            `;
    }
    return html38`
            <atlas-desktop-dropdown
                class=${classMap24(dropdownClass)}
                header=${this.header}
                width=${this.width}
                max-width=${this.maxWidth}
                max-height=${this._modifierMaxHeight || this.maxHeight}
                ?spaced-content=${this.spacedContent}
                ?no-gap=${this.noGap}
                ?open=${this.open}
                ?scale-vertically=${(_a = this._triggerController.triggerElement) == null ? void 0 : _a.classList.contains("form-control")}
                ?overflow=${this.overflow}
            >
                ${this.renderDropdownContent()}
            </atlas-desktop-dropdown>
        `;
  }
};
__decorateClass([property38({
  type: String
})], AtlasDropdown.prototype, "header", 2);
__decorateClass([property38({
  type: Number
})], AtlasDropdown.prototype, "width", 2);
__decorateClass([property38({
  type: String,
  attribute: "max-width"
})], AtlasDropdown.prototype, "maxWidth", 2);
__decorateClass([property38({
  type: Number,
  attribute: "max-height"
})], AtlasDropdown.prototype, "maxHeight", 2);
__decorateClass([property38({
  type: Boolean,
  attribute: "spaced-content"
})], AtlasDropdown.prototype, "spacedContent", 2);
__decorateClass([property38({
  type: Boolean,
  attribute: "no-gap"
})], AtlasDropdown.prototype, "noGap", 2);
__decorateClass([property38({
  type: Boolean,
  attribute: "mobile-fullscreen"
})], AtlasDropdown.prototype, "mobileFullScreen", 2);
__decorateClass([property38({
  type: Boolean,
  attribute: "auto-close"
})], AtlasDropdown.prototype, "autoClose", 2);
__decorateClass([property38({
  type: String,
  attribute: "auto-close-trigger"
})], AtlasDropdown.prototype, "autoCloseTrigger", 2);
__decorateClass([property38({
  type: Boolean
})], AtlasDropdown.prototype, "overflow", 2);
__decorateClass([property38({
  type: Boolean,
  attribute: "has-footer"
})], AtlasDropdown.prototype, "hasFooter", 2);
__decorateClass([property38({
  type: Boolean
})], AtlasDropdown.prototype, "loading", 2);
__decorateClass([property38({
  type: String,
  attribute: "loading-text"
})], AtlasDropdown.prototype, "loadingText", 2);
__decorateClass([property38({
  type: Boolean,
  attribute: "show-close-button"
})], AtlasDropdown.prototype, "showCloseButton", 2);
__decorateClass([state12()], AtlasDropdown.prototype, "_onNavbarContext", 2);
__decorateClass([state12()], AtlasDropdown.prototype, "_hasSlottedSubheading", 2);
__decorateClass([state12()], AtlasDropdown.prototype, "_modifierMaxHeight", 2);
AtlasDropdown = __decorateClass([customElement32("atlas-dropdown")], AtlasDropdown);

// src/components/display/atlas-button-group/atlas-button-group.ts
var AtlasButtonGroup = /*#__PURE__*/(() => {
  let AtlasButtonGroup = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.gap = 4;
      this.moreButtonType = "filled";
      this.moreButtonTheme = "primary";
      this.moreButtonSize = "3x";
      this.loadingText = "Carregando a\xE7\xF5es";
      this._buttons = [];
      this._deviceController = new DeviceController(this);
    }
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.extractSlottedButtonsProps = this.extractSlottedButtonsProps.bind(this);
      this.onButtonClick = this.onButtonClick.bind(this);
      this.updateComplete.then(() => {
        this.shadowRoot.querySelector("slot").addEventListener("atlas-element-update", this.extractSlottedButtonsProps);
      });
    }
    /**
     * Abre o dropdown de "Mais opções"
     */
    openMoreOptions() {
      var _a;
      (_a = this.shadowRoot.querySelector("atlas-dropdown")) == null ? void 0 : _a.show();
    }
    /**
     * Fecha o dropdown de "Mais opções"
     */
    closeMoreOptions() {
      var _a;
      (_a = this.shadowRoot.querySelector("atlas-dropdown")) == null ? void 0 : _a.hide();
    }
    updateDropdownRef() {
      this.updateComplete.then(() => {
        var _a;
        (_a = this.shadowRoot.querySelector("atlas-dropdown")) == null ? void 0 : _a.syncTriggerElement();
      });
    }
    getButtonTheme(button) {
      return button.props.theme || "primary";
    }
    getCountBeforeMore() {
      if (this.groupAll || this._deviceController.isMobile) return 0;
      if (this.groupAfter) return this.groupAfter;
      return this._buttons.length;
    }
    getShowMoreOptions() {
      return this._buttons.length > 1 && this._buttons.length > this.getCountBeforeMore();
    }
    extractSlottedButtonsProps() {
      const slottedButtons = this.shadowRoot.querySelector("slot").assignedElements();
      this._buttons = slottedButtons.map(button => {
        const tag = button.tagName.toLowerCase();
        const attrs = button.attributes;
        const extractedProps = {};
        for (let i = 0; i < attrs.length; i++) {
          extractedProps[attrs[i].nodeName] = attrs[i].nodeValue;
        }
        return {
          tag,
          props: extractedProps,
          element: button
        };
      });
    }
    onButtonClick(event) {
      var _a;
      const target = event.currentTarget;
      const buttonIndex = parseInt(target.dataset.buttonIndex, 10);
      const buttonElement = (_a = this._buttons[buttonIndex]) == null ? void 0 : _a.element;
      if (!buttonElement) return;
      if (buttonElement.hasAttribute("disabled") || buttonElement.hasAttribute("loading")) return;
      const buttonGroupClickEvent = emit(this, "atlas-button-group-button-click", {
        detail: {
          button: buttonElement
        },
        trackDisable: true
      });
      if (Boolean(buttonElement.getAttribute("href"))) event.stopPropagation();
      if (buttonGroupClickEvent.defaultPrevented) event.preventDefault();
    }
    renderButtonsBeforeGroup() {
      let buttonsBeforeGroup = this._buttons.slice(0, this.getCountBeforeMore());
      if (buttonsBeforeGroup.length === 0 && this._buttons.length === 1) {
        buttonsBeforeGroup = [this._buttons[0]];
      }
      return buttonsBeforeGroup.map((button, index) => {
        const tag = unsafeStatic2(button.tag);
        button.props.theme = this.getButtonTheme(button);
        let attributes = Object.entries(button.props).map(entry => `${entry[0]}="${entry[1]}"`);
        if (button.tag === "atlas-icon-button") {
          attributes = attributes.filter(attr => !attr.includes("size"));
          attributes.push("hoverable");
          attributes.push(`size="${this.moreButtonSize}"`);
        }
        return html39`
                <${tag}
                    ${unsafeStatic2(attributes.join(" "))}
                    data-button-index=${index}
                    @click=${this.onButtonClick}
                    data-track-disable
                ></${tag}>
            `;
      });
    }
    renderGroupedButtons() {
      const groupedButtons = this._buttons.slice(this.getCountBeforeMore());
      return groupedButtons.map((button, index) => {
        const itemTheme = this.getButtonTheme(button);
        return html39`
                <atlas-dropdown-item
                    class=${button.props.class}
                    theme=${itemTheme}
                    icon=${button.props.icon}
                    ?disabled=${"disabled" in button.props}
                    ?loading=${"loading" in button.props}
                    ?hidden=${"hidden" in button.props}
                    tooltip=${button.props.tooltip}
                    data-button-index=${this.getCountBeforeMore() + index}
                    @atlas-dropdown-item-click=${this.onButtonClick}
                    data-track-disable
                    href=${ifDefined8(button.props.href)}
                    ?external=${"is_external_link" in button.props}
                >
                    ${button.props.description}
                </atlas-dropdown-item>
            `;
      });
    }
    renderMoreButton() {
      if (!this.getShowMoreOptions()) {
        return null;
      }
      return when23(this.moreButtonType === "icon", () => html39`
                <atlas-icon-button
                    icon="three-dots"
                    data-atlas-dropdown="button-group-dropdown"
                    size=${this.moreButtonSize}
                    theme=${this.moreButtonTheme}
                    aria-label="Ações"
                    hoverable
                ></atlas-icon-button>
            `, () => html39`
                <atlas-button
                    icon="three-dots"
                    data-atlas-dropdown="button-group-dropdown"
                    type=${this.moreButtonType}
                    theme=${this.moreButtonTheme}
                    aria-label="Ações"
                ></atlas-button>
            `);
    }
    renderMoreDropdown() {
      return when23(this.getShowMoreOptions(), () => html39`
                <atlas-dropdown
                    id="button-group-dropdown"
                    no-gap
                    auto-close
                    ?loading=${this.loading}
                    loading-text=${this.loadingText}
                >
                    ${this.renderGroupedButtons()}
                </atlas-dropdown>
            `);
    }
    /** @internal */
    render() {
      const buttonGroupClass = {
        "button-group": true,
        [`gap-${this.gap}`]: !!this.gap
      };
      return html39`
            <div class=${classMap25(buttonGroupClass)}>${this.renderButtonsBeforeGroup()}${this.renderMoreButton()}</div>
            <slot @slotchange=${this.extractSlottedButtonsProps}></slot>
            ${this.renderMoreDropdown()}
        `;
    }
  };
  AtlasButtonGroup.styles = atlas_button_group_default;
  return AtlasButtonGroup;
})();
__decorateClass([property39({
  type: Number
})], AtlasButtonGroup.prototype, "gap", 2);
__decorateClass([property39({
  type: Number,
  attribute: "group-after"
})], AtlasButtonGroup.prototype, "groupAfter", 2);
__decorateClass([property39({
  type: Boolean,
  attribute: "group-all"
})], AtlasButtonGroup.prototype, "groupAll", 2);
__decorateClass([property39({
  type: String,
  attribute: "more-button-type"
})], AtlasButtonGroup.prototype, "moreButtonType", 2);
__decorateClass([property39({
  type: String,
  attribute: "more-button-theme"
})], AtlasButtonGroup.prototype, "moreButtonTheme", 2);
__decorateClass([property39({
  type: String,
  attribute: "more-button-size"
})], AtlasButtonGroup.prototype, "moreButtonSize", 2);
__decorateClass([property39({
  type: Boolean
})], AtlasButtonGroup.prototype, "loading", 2);
__decorateClass([property39({
  type: String,
  attribute: "loading-text"
})], AtlasButtonGroup.prototype, "loadingText", 2);
__decorateClass([state13()], AtlasButtonGroup.prototype, "_buttons", 2);
__decorateClass([Watch("moreButtonType", true)], AtlasButtonGroup.prototype, "updateDropdownRef", 1);
AtlasButtonGroup = __decorateClass([customElement33("atlas-button-group")], AtlasButtonGroup);

// src/components/display/atlas-card/atlas-card.ts
import { html as html40 } from "lit";
import { customElement as customElement34, property as property40, state as state14 } from "lit/decorators.js";
import { classMap as classMap26 } from "lit/directives/class-map.js";
import { styleMap as styleMap10 } from "lit/directives/style-map.js";
import { when as when24 } from "lit/directives/when.js";

// src/components/display/atlas-card/atlas-card.scss
import { css as css34 } from "lit-element/lit-element.js";
var atlas_card_default = css34`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.color-white {
  color: #ffffff !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.color-primary {
  color: var(--atlas-primary) !important;
}

.bg-primary {
  background-color: var(--atlas-primary) !important;
}

.color-primary-100 {
  color: var(--atlas-primary-100) !important;
}

.bg-primary-100 {
  background-color: var(--atlas-primary-100) !important;
}

.color-primary-200 {
  color: var(--atlas-primary-200) !important;
}

.bg-primary-200 {
  background-color: var(--atlas-primary-200) !important;
}

.color-primary-300 {
  color: var(--atlas-primary-300) !important;
}

.bg-primary-300 {
  background-color: var(--atlas-primary-300) !important;
}

.color-primary-400 {
  color: var(--atlas-primary-400) !important;
}

.bg-primary-400 {
  background-color: var(--atlas-primary-400) !important;
}

.color-primary-500 {
  color: var(--atlas-primary-500) !important;
}

.bg-primary-500 {
  background-color: var(--atlas-primary-500) !important;
}

.color-primary-600 {
  color: var(--atlas-primary-600) !important;
}

.bg-primary-600 {
  background-color: var(--atlas-primary-600) !important;
}

.color-primary-700 {
  color: var(--atlas-primary-700) !important;
}

.bg-primary-700 {
  background-color: var(--atlas-primary-700) !important;
}

.color-primary-800 {
  color: var(--atlas-primary-800) !important;
}

.bg-primary-800 {
  background-color: var(--atlas-primary-800) !important;
}

.color-primary-900 {
  color: var(--atlas-primary-900) !important;
}

.bg-primary-900 {
  background-color: var(--atlas-primary-900) !important;
}

.active-primary[active], .active-primary.active, .active-primary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-secondary {
  color: var(--atlas-secondary) !important;
}

.bg-secondary {
  background-color: var(--atlas-secondary) !important;
}

.color-secondary-100 {
  color: var(--atlas-secondary-100) !important;
}

.bg-secondary-100 {
  background-color: var(--atlas-secondary-100) !important;
}

.color-secondary-200 {
  color: var(--atlas-secondary-200) !important;
}

.bg-secondary-200 {
  background-color: var(--atlas-secondary-200) !important;
}

.color-secondary-300 {
  color: var(--atlas-secondary-300) !important;
}

.bg-secondary-300 {
  background-color: var(--atlas-secondary-300) !important;
}

.color-secondary-400 {
  color: var(--atlas-secondary-400) !important;
}

.bg-secondary-400 {
  background-color: var(--atlas-secondary-400) !important;
}

.color-secondary-500 {
  color: var(--atlas-secondary-500) !important;
}

.bg-secondary-500 {
  background-color: var(--atlas-secondary-500) !important;
}

.color-secondary-600 {
  color: var(--atlas-secondary-600) !important;
}

.bg-secondary-600 {
  background-color: var(--atlas-secondary-600) !important;
}

.color-secondary-700 {
  color: var(--atlas-secondary-700) !important;
}

.bg-secondary-700 {
  background-color: var(--atlas-secondary-700) !important;
}

.color-secondary-800 {
  color: var(--atlas-secondary-800) !important;
}

.bg-secondary-800 {
  background-color: var(--atlas-secondary-800) !important;
}

.color-secondary-900 {
  color: var(--atlas-secondary-900) !important;
}

.bg-secondary-900 {
  background-color: var(--atlas-secondary-900) !important;
}

.active-secondary[active], .active-secondary.active, .active-secondary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-success {
  color: var(--atlas-success) !important;
}

.bg-success {
  background-color: var(--atlas-success) !important;
}

.color-success-100 {
  color: var(--atlas-success-100) !important;
}

.bg-success-100 {
  background-color: var(--atlas-success-100) !important;
}

.color-success-200 {
  color: var(--atlas-success-200) !important;
}

.bg-success-200 {
  background-color: var(--atlas-success-200) !important;
}

.color-success-300 {
  color: var(--atlas-success-300) !important;
}

.bg-success-300 {
  background-color: var(--atlas-success-300) !important;
}

.color-success-400 {
  color: var(--atlas-success-400) !important;
}

.bg-success-400 {
  background-color: var(--atlas-success-400) !important;
}

.color-success-500 {
  color: var(--atlas-success-500) !important;
}

.bg-success-500 {
  background-color: var(--atlas-success-500) !important;
}

.color-success-600 {
  color: var(--atlas-success-600) !important;
}

.bg-success-600 {
  background-color: var(--atlas-success-600) !important;
}

.color-success-700 {
  color: var(--atlas-success-700) !important;
}

.bg-success-700 {
  background-color: var(--atlas-success-700) !important;
}

.color-success-800 {
  color: var(--atlas-success-800) !important;
}

.bg-success-800 {
  background-color: var(--atlas-success-800) !important;
}

.color-success-900 {
  color: var(--atlas-success-900) !important;
}

.bg-success-900 {
  background-color: var(--atlas-success-900) !important;
}

.active-success[active], .active-success.active, .active-success:active {
  background-color: var(--atlas-success) !important;
  color: var(--atlas-contrast-success) !important;
}

.color-warning {
  color: var(--atlas-warning) !important;
}

.bg-warning {
  background-color: var(--atlas-warning) !important;
}

.color-warning-100 {
  color: var(--atlas-warning-100) !important;
}

.bg-warning-100 {
  background-color: var(--atlas-warning-100) !important;
}

.color-warning-200 {
  color: var(--atlas-warning-200) !important;
}

.bg-warning-200 {
  background-color: var(--atlas-warning-200) !important;
}

.color-warning-300 {
  color: var(--atlas-warning-300) !important;
}

.bg-warning-300 {
  background-color: var(--atlas-warning-300) !important;
}

.color-warning-400 {
  color: var(--atlas-warning-400) !important;
}

.bg-warning-400 {
  background-color: var(--atlas-warning-400) !important;
}

.color-warning-500 {
  color: var(--atlas-warning-500) !important;
}

.bg-warning-500 {
  background-color: var(--atlas-warning-500) !important;
}

.color-warning-600 {
  color: var(--atlas-warning-600) !important;
}

.bg-warning-600 {
  background-color: var(--atlas-warning-600) !important;
}

.color-warning-700 {
  color: var(--atlas-warning-700) !important;
}

.bg-warning-700 {
  background-color: var(--atlas-warning-700) !important;
}

.color-warning-800 {
  color: var(--atlas-warning-800) !important;
}

.bg-warning-800 {
  background-color: var(--atlas-warning-800) !important;
}

.color-warning-900 {
  color: var(--atlas-warning-900) !important;
}

.bg-warning-900 {
  background-color: var(--atlas-warning-900) !important;
}

.active-warning[active], .active-warning.active, .active-warning:active {
  background-color: var(--atlas-warning) !important;
  color: var(--atlas-contrast-warning) !important;
}

.color-danger {
  color: var(--atlas-danger) !important;
}

.bg-danger {
  background-color: var(--atlas-danger) !important;
}

.color-danger-100 {
  color: var(--atlas-danger-100) !important;
}

.bg-danger-100 {
  background-color: var(--atlas-danger-100) !important;
}

.color-danger-200 {
  color: var(--atlas-danger-200) !important;
}

.bg-danger-200 {
  background-color: var(--atlas-danger-200) !important;
}

.color-danger-300 {
  color: var(--atlas-danger-300) !important;
}

.bg-danger-300 {
  background-color: var(--atlas-danger-300) !important;
}

.color-danger-400 {
  color: var(--atlas-danger-400) !important;
}

.bg-danger-400 {
  background-color: var(--atlas-danger-400) !important;
}

.color-danger-500 {
  color: var(--atlas-danger-500) !important;
}

.bg-danger-500 {
  background-color: var(--atlas-danger-500) !important;
}

.color-danger-600 {
  color: var(--atlas-danger-600) !important;
}

.bg-danger-600 {
  background-color: var(--atlas-danger-600) !important;
}

.color-danger-700 {
  color: var(--atlas-danger-700) !important;
}

.bg-danger-700 {
  background-color: var(--atlas-danger-700) !important;
}

.color-danger-800 {
  color: var(--atlas-danger-800) !important;
}

.bg-danger-800 {
  background-color: var(--atlas-danger-800) !important;
}

.color-danger-900 {
  color: var(--atlas-danger-900) !important;
}

.bg-danger-900 {
  background-color: var(--atlas-danger-900) !important;
}

.active-danger[active], .active-danger.active, .active-danger:active {
  background-color: var(--atlas-danger) !important;
  color: var(--atlas-contrast-danger) !important;
}

.color-highlight {
  color: var(--atlas-highlight) !important;
}

.bg-highlight {
  background-color: var(--atlas-highlight) !important;
}

.color-highlight-100 {
  color: var(--atlas-highlight-100) !important;
}

.bg-highlight-100 {
  background-color: var(--atlas-highlight-100) !important;
}

.color-highlight-200 {
  color: var(--atlas-highlight-200) !important;
}

.bg-highlight-200 {
  background-color: var(--atlas-highlight-200) !important;
}

.color-highlight-300 {
  color: var(--atlas-highlight-300) !important;
}

.bg-highlight-300 {
  background-color: var(--atlas-highlight-300) !important;
}

.color-highlight-400 {
  color: var(--atlas-highlight-400) !important;
}

.bg-highlight-400 {
  background-color: var(--atlas-highlight-400) !important;
}

.color-highlight-500 {
  color: var(--atlas-highlight-500) !important;
}

.bg-highlight-500 {
  background-color: var(--atlas-highlight-500) !important;
}

.color-highlight-600 {
  color: var(--atlas-highlight-600) !important;
}

.bg-highlight-600 {
  background-color: var(--atlas-highlight-600) !important;
}

.color-highlight-700 {
  color: var(--atlas-highlight-700) !important;
}

.bg-highlight-700 {
  background-color: var(--atlas-highlight-700) !important;
}

.color-highlight-800 {
  color: var(--atlas-highlight-800) !important;
}

.bg-highlight-800 {
  background-color: var(--atlas-highlight-800) !important;
}

.color-highlight-900 {
  color: var(--atlas-highlight-900) !important;
}

.bg-highlight-900 {
  background-color: var(--atlas-highlight-900) !important;
}

.active-highlight[active], .active-highlight.active, .active-highlight:active {
  background-color: var(--atlas-highlight) !important;
  color: var(--atlas-contrast-highlight) !important;
}

.color-info {
  color: var(--atlas-info) !important;
}

.bg-info {
  background-color: var(--atlas-info) !important;
}

.color-info-100 {
  color: var(--atlas-info-100) !important;
}

.bg-info-100 {
  background-color: var(--atlas-info-100) !important;
}

.color-info-200 {
  color: var(--atlas-info-200) !important;
}

.bg-info-200 {
  background-color: var(--atlas-info-200) !important;
}

.color-info-300 {
  color: var(--atlas-info-300) !important;
}

.bg-info-300 {
  background-color: var(--atlas-info-300) !important;
}

.color-info-400 {
  color: var(--atlas-info-400) !important;
}

.bg-info-400 {
  background-color: var(--atlas-info-400) !important;
}

.color-info-500 {
  color: var(--atlas-info-500) !important;
}

.bg-info-500 {
  background-color: var(--atlas-info-500) !important;
}

.color-info-600 {
  color: var(--atlas-info-600) !important;
}

.bg-info-600 {
  background-color: var(--atlas-info-600) !important;
}

.color-info-700 {
  color: var(--atlas-info-700) !important;
}

.bg-info-700 {
  background-color: var(--atlas-info-700) !important;
}

.color-info-800 {
  color: var(--atlas-info-800) !important;
}

.bg-info-800 {
  background-color: var(--atlas-info-800) !important;
}

.color-info-900 {
  color: var(--atlas-info-900) !important;
}

.bg-info-900 {
  background-color: var(--atlas-info-900) !important;
}

.active-info[active], .active-info.active, .active-info:active {
  background-color: var(--atlas-info) !important;
  color: var(--atlas-contrast-info) !important;
}

/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: inline-flex;
  width: 100%;
  min-width: 0;
}

:host([skeleton-loading]) {
  display: inline-flex;
  pointer-events: none;
}

:host([fluid]) {
  min-height: 100%;
}

.card-wrapper {
  border: 1px solid #ced4da;
  border-radius: 0.5rem;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.hero-image {
  height: 180px;
  width: 100%;
  position: relative;
}
.hero-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.hero-image .skeleton {
  height: 100%;
}
.hero-image.position-top img {
  object-position: center top;
}
.hero-image.position-center img {
  object-position: center center;
}
.hero-image.position-bottom img {
  object-position: center bottom;
}
.hero-image.position-top-start img {
  object-position: left top;
}
.hero-image.position-top-end img {
  object-position: right top;
}
.hero-image.position-center-start img {
  object-position: left center;
}
.hero-image.position-center-end img {
  object-position: right center;
}
.hero-image.position-bottom-start img {
  object-position: left bottom;
}
.hero-image.position-bottom-end img {
  object-position: right bottom;
}

.card {
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: #ffffff;
}
.card .card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
}
.card .card-header atlas-badge {
  flex-shrink: 0;
}
.card .card-header atlas-heading {
  min-width: 0;
  color: #212529;
  height: 1.5rem;
  width: 100%;
  overflow: hidden;
}
.card .card-body {
  display: none;
}
.card .card-footer {
  margin-top: auto;
  display: none;
}
.card.bg-light {
  background: var(--atlas-light);
}
.card.has-badge .card-header {
  flex-direction: column;
}
.card.has-body .card-body {
  display: block;
}
.card.has-footer .card-footer {
  display: block;
}
.card.padding-md {
  padding: 1rem;
}
.card.padding-lg {
  padding: 1.5rem;
}

@media screen and (min-width: 992px) {
  .card {
    padding: 1.5rem;
  }
  .card.has-badge .card-header {
    flex-direction: row;
  }
}`;

// src/components/display/atlas-card/atlas-card.ts
var ComposedClass2 = WithBadgeMixin(WithPopoverMixin(AtlasElement));
var AtlasCard = /*#__PURE__*/(() => {
  let AtlasCard = class extends ComposedClass2 {
    constructor() {
      super();
      this.background = "white";
      this.padding = "md";
      this._showBody = false;
      this._showFooter = false;
      this._deviceController = new DeviceController(this, this.onChangeScreenType.bind(this));
      this.badgeTheme = this.badgeTheme || "primary";
    }
    getSlottedActions() {
      const actionsSlot = this.shadowRoot.querySelector("slot[name=actions]");
      return actionsSlot.assignedElements();
    }
    getBackgroundStyle() {
      if (["light", "white"].includes(this.background)) return {};
      return {
        "background-color": this.background
      };
    }
    onChangeSlotBody() {
      this._showBody = !isEmptySlot(this);
    }
    onChangeSlotActions() {
      this._showFooter = !isEmptySlot(this, "actions");
    }
    onChangeScreenType() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this.getSlottedActions().filter(element => element.tagName === "ATLAS-BUTTON").forEach(element => element.toggleAttribute("block", this._deviceController.isMobile));
      });
    }
    renderSkeletonImage() {
      return when24(this.skeletonLoading, () => html40` <div class="skeleton"></div> `, () => html40` <img src=${this.image} alt=${this.imageDescription} /> `);
    }
    renderHeroImage() {
      const heroImgClass = {
        "hero-image": true,
        [`position-${this.imagePosition}`]: !!this.imagePosition
      };
      return when24(!!this.image, () => html40` <div class=${classMap26(heroImgClass)}>${this.renderSkeletonImage()}</div> `);
    }
    renderInfoIcon() {
      return when24(!this.badgeText, () => html40` ${this.renderPopoverInfoIcon()} `);
    }
    renderHeader() {
      return when24(!!this.header, () => html40`
                <div class="card-header">
                    <atlas-heading size="h6" ellipsis>${this.header}</atlas-heading>
                    ${this.renderBadge()} ${this.renderInfoIcon()}
                </div>
            `);
    }
    renderFooter() {
      return html40`
            <div class="card-footer">
                <slot name="actions" @slotchange=${this.onChangeSlotActions}></slot>
            </div>
        `;
    }
    /**
     * @internal
     * @override
     */
    hasBadge() {
      return (!!this.badgeText || !!this.badgeIcon) && !this.skeletonLoading;
    }
    /** @internal */
    render() {
      const cardClass = {
        "card": true,
        "bg-light": this.background === "light",
        "has-body": this._showBody,
        "has-footer": this._showFooter,
        "has-badge": !!this.badgeText,
        [`padding-${this.padding}`]: !!this.padding
      };
      const cardStyle = __spreadValues({}, this.getBackgroundStyle());
      return html40`
            <div class="card-wrapper">
                ${this.renderHeroImage()}
                <div class=${classMap26(cardClass)} style=${styleMap10(cardStyle)}>
                    ${this.renderHeader()}
                    <div class="card-body">
                        <slot @slotchange=${this.onChangeSlotBody}></slot>
                    </div>
                    ${this.renderFooter()}
                </div>
            </div>
        `;
    }
  };
  AtlasCard.styles = atlas_card_default;
  return AtlasCard;
})();
__decorateClass([property40({
  type: String
})], AtlasCard.prototype, "image", 2);
__decorateClass([property40({
  type: String,
  attribute: "image-description"
})], AtlasCard.prototype, "imageDescription", 2);
__decorateClass([property40({
  type: String,
  attribute: "image-position"
})], AtlasCard.prototype, "imagePosition", 2);
__decorateClass([property40({
  type: String
})], AtlasCard.prototype, "header", 2);
__decorateClass([property40({
  type: String
})], AtlasCard.prototype, "background", 2);
__decorateClass([property40({
  type: Boolean,
  reflect: true
})], AtlasCard.prototype, "fluid", 2);
__decorateClass([property40({
  type: String
})], AtlasCard.prototype, "padding", 2);
__decorateClass([state14()], AtlasCard.prototype, "_showBody", 2);
__decorateClass([state14()], AtlasCard.prototype, "_showFooter", 2);
AtlasCard = __decorateClass([customElement34("atlas-card")], AtlasCard);

// src/components/display/atlas-card-brand/atlas-card-brand.ts
import { html as html41 } from "lit";
import { customElement as customElement35, property as property41, state as state15 } from "lit/decorators.js";

// src/helpers/card.ts
var card_exports = {};
__export(card_exports, {
  CARD_BRANDS: () => CARD_BRANDS,
  CREDIT_CARD_BRANDS: () => CREDIT_CARD_BRANDS,
  CardBrandEnum: () => CardBrandEnum,
  DEBIT_CARD_BRANDS: () => DEBIT_CARD_BRANDS,
  detectCardBrand: () => detectCardBrand,
  getCardBrandInfo: () => getCardBrandInfo
});
var CardBrandEnum = /* @__PURE__ */(CardBrandEnum2 => {
  CardBrandEnum2["ELO"] = "ELO";
  CardBrandEnum2["CABAL"] = "CABAL";
  CardBrandEnum2["HIPERCARD"] = "HIPERCARD";
  CardBrandEnum2["DINERS"] = "DINERS";
  CardBrandEnum2["AMEX"] = "AMEX";
  CardBrandEnum2["JCB"] = "JCB";
  CardBrandEnum2["DISCOVER"] = "DISCOVER";
  CardBrandEnum2["VISA"] = "VISA";
  CardBrandEnum2["VISA_ELECTRON"] = "VISA_ELECTRON";
  CardBrandEnum2["MASTERCARD"] = "MASTERCARD";
  CardBrandEnum2["MAESTRO"] = "MAESTRO";
  CardBrandEnum2["BANESCARD"] = "BANESCARD";
  CardBrandEnum2["SOROCRED"] = "SOROCRED";
  CardBrandEnum2["CREDZ"] = "CREDZ";
  CardBrandEnum2["CREDSYSTEM"] = "CREDSYSTEM";
  CardBrandEnum2["UNKNOWN"] = "UNKNOWN";
  return CardBrandEnum2;
})(CardBrandEnum || {});
var CREDIT_CARD_BRANDS = ["ELO" /* ELO */, "CABAL" /* CABAL */, "HIPERCARD" /* HIPERCARD */, "DINERS" /* DINERS */, "AMEX" /* AMEX */, "JCB" /* JCB */, "DISCOVER" /* DISCOVER */, "VISA" /* VISA */, "MASTERCARD" /* MASTERCARD */, "BANESCARD" /* BANESCARD */, "SOROCRED" /* SOROCRED */, "CREDZ" /* CREDZ */, "CREDSYSTEM" /* CREDSYSTEM */];
var DEBIT_CARD_BRANDS = ["VISA_ELECTRON" /* VISA_ELECTRON */, "MAESTRO" /* MAESTRO */];
var CARD_BRANDS = {
  ["ELO" /* ELO */]: {
    brandName: "Elo",
    brandFlag: "assets/images/card-brands/elo.svg",
    mask: "9999 9999 9999 9999",
    regex: /^(4(0117[89]|3(1274|8935)|5(1416|7(393|63[12])))|50(4175|6(699|7([0-6]\d|7[0-8]))|9\d{3})|6(27780|36(297|368)|5(0(0(3[1-35-9]|4\d|5[01])|4(0[5-9]|([1-3]\d|8[5-9]|9\d))|5([0-2]\d|3[0-8]|4[1-9]|[5-8]\d|9[0-8])|7(0\d|1[0-8]|2[0-7])|9(0[1-9]|[1-6]\d|7[0-8]))|16(5[2-9]|[67]\d)|50([01]\d|2[1-9]|[34]\d|5[0-8]))))/
  },
  ["MASTERCARD" /* MASTERCARD */]: {
    brandName: "Mastercard",
    brandFlag: "assets/images/card-brands/mastercard.svg",
    mask: "9999 9999 9999 9999",
    regex: /^(5[1-5]\d{4}|2(2(2[1-9]\d{2}|[3-9]\d{3})|[3-6]\d{4}|7([01]\d{3}|20\d{2})))/
  },
  ["MAESTRO" /* MAESTRO */]: {
    brandName: "Mastercard Maestro",
    brandFlag: "assets/images/card-brands/maestro.svg",
    mask: "9999 9999 9999 9999",
    regex: /^(5018|5020|5038|5893|6304|6759|6761|6762|6763)[0-9]/
  },
  ["DISCOVER" /* DISCOVER */]: {
    brandName: "Discover",
    brandFlag: "assets/images/card-brands/discover.svg",
    mask: "9999 9999 9999 9999",
    regex: /^65[4-9][0-9]|64[4-9][0-9]|6011[0-9]|(622(?:12[6-9]|1[3-9][0-9]|[2-8][0-9][0-9]|9[01][0-9]|92[0-5])[0-9])/
  },
  ["CABAL" /* CABAL */]: {
    brandName: "Cabal",
    brandFlag: "assets/images/card-brands/cabal.svg",
    mask: "9999 9999 9999 9999",
    regex: /^(60420[1-9]|6042[1-9][0-9]|6043[0-9]{2}|604400)/
  },
  ["HIPERCARD" /* HIPERCARD */]: {
    brandName: "Hipercard",
    brandFlag: "assets/images/card-brands/hipercard.svg",
    mask: "9999 9999 9999 9999",
    regex: /^(?:3841[046]0|6(?:06282|37(?:095|5(?:68|99)|6(?:09|12))))/
  },
  ["DINERS" /* DINERS */]: {
    brandName: "Diners",
    brandFlag: "assets/images/card-brands/diners.svg",
    mask: "9999 999999 9999",
    regex: /^3(?:0[0-5]|[68][0-9])/
  },
  ["AMEX" /* AMEX */]: {
    brandName: "American Express",
    brandFlag: "assets/images/card-brands/amex.svg",
    mask: "9999 999999 99999",
    regex: /^3[47]\d{4}/
  },
  ["JCB" /* JCB */]: {
    brandName: "JCB",
    brandFlag: "assets/images/card-brands/jcb.svg",
    mask: "9999 9999 9999 9999",
    regex: /^(?:2131|1800|35\d{3})/
  },
  ["VISA" /* VISA */]: {
    brandName: "Visa",
    brandFlag: "assets/images/card-brands/visa.svg",
    mask: "9999 9999 9999 9999",
    regex: /^4\d{5}/
  },
  ["VISA_ELECTRON" /* VISA_ELECTRON */]: {
    brandName: "Visa",
    brandFlag: "assets/images/card-brands/visa-electron.svg",
    mask: "9999 9999 9999 9999",
    regex: /^4\d{5}/
  },
  ["BANESCARD" /* BANESCARD */]: {
    brandName: "Banescard",
    brandFlag: "assets/images/card-brands/banescard.svg",
    mask: "9999 9999 9999 9999",
    regex: /^636117/
  },
  ["SOROCRED" /* SOROCRED */]: {
    brandName: "Sorocred",
    brandFlag: "assets/images/card-brands/sorocred.svg",
    mask: "9999 9999 9999 9999",
    regex: /^627892|^636414/
  },
  ["CREDZ" /* CREDZ */]: {
    brandName: "Credz",
    brandFlag: "assets/images/card-brands/credz.svg",
    mask: "9999 9999 9999 9999",
    regex: /^636760/
  },
  ["CREDSYSTEM" /* CREDSYSTEM */]: {
    brandName: "Banescard",
    brandFlag: "assets/images/card-brands/credsystem.svg",
    mask: "9999 9999 9999 9999",
    regex: /^628028/
  },
  ["UNKNOWN" /* UNKNOWN */]: {
    brandName: "Desconhecido",
    brandFlag: "assets/images/card-brands/card.svg",
    mask: "9999 9999 9999 9999"
  }
};
function getCardBrandInfo(brand) {
  return CARD_BRANDS[brand];
}
function detectCardBrand(cardNumberValue, isDebitCard, acceptedBrands) {
  const cardNumber = removeNonNumeric(cardNumberValue);
  if (cardNumber.length < 6) return "UNKNOWN" /* UNKNOWN */;
  let brands = isDebitCard ? DEBIT_CARD_BRANDS : CREDIT_CARD_BRANDS;
  if (acceptedBrands && acceptedBrands.length > 0) {
    brands = brands.filter(brand => acceptedBrands.includes(brand));
  }
  const cardBrand = brands.find(brand => {
    if (brand === "UNKNOWN" /* UNKNOWN */) return false;
    return CARD_BRANDS[brand].regex.test(cardNumber);
  });
  return cardBrand || "UNKNOWN" /* UNKNOWN */;
}

// src/components/display/atlas-card-brand/atlas-card-brand.scss
import { css as css35 } from "lit-element/lit-element.js";
var atlas_card_brand_default = css35`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: inline-flex;
}

.card-brands .card-brand-flag {
  height: 25px;
}`;

// src/components/display/atlas-card-brand/atlas-card-brand.ts
var AtlasCardBrand = /*#__PURE__*/(() => {
  let AtlasCardBrand = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.acceptedBrands = [];
      this._cardBrandsInfo = [];
    }
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.updateComplete.then(() => {
        if (this.acceptedBrands) this.setCardBrandsInfo();
      });
    }
    setCardBrandsInfo() {
      this._cardBrandsInfo = this.acceptedBrands.map(card => getCardBrandInfo(card));
    }
    renderFlags() {
      return this._cardBrandsInfo.filter(card => card.brandName !== CARD_BRANDS["UNKNOWN" /* UNKNOWN */].brandName).map(card => html41`
                    <img src="${getAssetPath(card.brandFlag)}" alt="${card.brandName}" class="card-brand-flag" />
                `);
    }
    render() {
      return html41`
            <atlas-layout class="card-brands" inline mobile-inline wrap gap="2"> ${this.renderFlags()} </atlas-layout>
        `;
    }
  };
  AtlasCardBrand.styles = atlas_card_brand_default;
  return AtlasCardBrand;
})();
__decorateClass([property41({
  type: Array,
  attribute: "accepted-brands"
})], AtlasCardBrand.prototype, "acceptedBrands", 2);
__decorateClass([state15()], AtlasCardBrand.prototype, "_cardBrandsInfo", 2);
__decorateClass([Watch("acceptedBrands")], AtlasCardBrand.prototype, "setCardBrandsInfo", 1);
AtlasCardBrand = __decorateClass([customElement35("atlas-card-brand")], AtlasCardBrand);

// src/components/display/atlas-card-button/atlas-card-button.ts
import { literal as literal6, html as html42 } from "lit/static-html.js";
import { customElement as customElement36, property as property42 } from "lit/decorators.js";
import { classMap as classMap27 } from "lit/directives/class-map.js";
import { ifDefined as ifDefined9 } from "lit/directives/if-defined.js";
import { when as when25 } from "lit/directives/when.js";

// src/components/display/atlas-card-button/atlas-card-button.scss
import { css as css36 } from "lit-element/lit-element.js";
var atlas_card_button_default = css36`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: block;
}

.btn {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.5rem;
  margin-left: -0.5rem;
  margin-right: -0.5rem;
  box-sizing: content-box;
  background: none;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #212529;
  cursor: pointer;
  text-decoration: none;
}
.btn span {
  flex-grow: 1;
  text-align: left;
  white-space: break-spaces;
}
.btn:focus-visible {
  outline: none;
  border-color: #adb5bd;
}
.btn:hover, .btn:active {
  background: rgba(var(--atlas-dark-rgb), 5%);
}
.btn:disabled, .btn.disabled {
  opacity: 0.65;
  pointer-events: none;
}
.btn.skeleton span {
  height: 1.3125rem;
  width: 100%;
}`;

// src/components/display/atlas-card-button/atlas-card-button.ts
var AtlasCardButton = /*#__PURE__*/(() => {
  let AtlasCardButton = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.theme = "primary";
    }
    handleButtonClick() {
      emit(this, "atlas-card-button-click");
    }
    renderButtonIcon(icon) {
      return when25(!!icon, () => html42`<atlas-icon size="2x" name=${icon} theme=${this.theme}></atlas-icon>`);
    }
    /** @override */
    renderElement() {
      const buttonClass = {
        btn: true,
        disabled: this.disabled,
        [`btn-${this.theme}`]: true
      };
      const tag = this.href ? literal6`a` : literal6`button`;
      return html42`
            <${tag}
                class=${classMap27(buttonClass)}
                ?disabled=${this.disabled}
                @click=${this.handleButtonClick}
                href=${ifDefined9(this.href ? this.href : void 0)}
                rel="${ifDefined9(this.href && this.isExternalLink ? "noreferrer" : void 0)}"
                target="${ifDefined9(this.href && this.isExternalLink ? "_blank" : void 0)}"
                tabindex="${ifDefined9(this.disabled ? "-1" : "0")}"
            >
                ${this.renderButtonIcon(this.icon)}
                <span>${this.description}</span>
                ${this.renderButtonIcon("chevron-right")}
            </${tag}>
        `;
    }
    /** @override */
    renderSkeleton() {
      return html42`
            <div class="btn skeleton">
                <atlas-icon size="2x"></atlas-icon>
                <span class="skeleton"></span>
            </div>
        `;
    }
  };
  AtlasCardButton.styles = atlas_card_button_default;
  return AtlasCardButton;
})();
__decorateClass([property42({
  type: String
})], AtlasCardButton.prototype, "theme", 2);
__decorateClass([property42({
  type: String
})], AtlasCardButton.prototype, "description", 2);
__decorateClass([property42({
  type: Boolean
})], AtlasCardButton.prototype, "disabled", 2);
__decorateClass([property42({
  type: String
})], AtlasCardButton.prototype, "icon", 2);
__decorateClass([property42({
  type: String
})], AtlasCardButton.prototype, "href", 2);
__decorateClass([property42({
  type: Boolean,
  attribute: "is-external-link"
})], AtlasCardButton.prototype, "isExternalLink", 2);
AtlasCardButton = __decorateClass([customElement36("atlas-card-button")], AtlasCardButton);

// src/components/display/atlas-card-preview/atlas-card-preview.ts
import { html as html43, nothing } from "lit";
import { customElement as customElement37, property as property43, state as state16 } from "lit/decorators.js";
import { classMap as classMap28 } from "lit/directives/class-map.js";
import { map } from "lit/directives/map.js";
import { styleMap as styleMap11 } from "lit/directives/style-map.js";
import { when as when26 } from "lit/directives/when.js";

// src/helpers/card-preview.ts
var card_preview_exports = {};
__export(card_preview_exports, {
  CARD_PREVIEWS: () => CARD_PREVIEWS,
  CardPreviewBrandEnum: () => CardPreviewBrandEnum,
  getCardPreviewImageInfo: () => getCardPreviewImageInfo
});
var CardPreviewBrandEnum = /* @__PURE__ */(CardPreviewBrandEnum3 => {
  CardPreviewBrandEnum3["ELO"] = "ELO";
  CardPreviewBrandEnum3["MASTERCARD"] = "MASTERCARD";
  return CardPreviewBrandEnum3;
})(CardPreviewBrandEnum || {});
var CARD_PREVIEWS = {
  ["MASTERCARD" /* MASTERCARD */]: {
    horizontal: {
      "front-image": "assets/images/card-previews/mastercard/mastercard-horizontal-front.svg"
    },
    vertical: {
      "front-image": "assets/images/card-previews/mastercard/mastercard-vertical-front.svg",
      "back-image": "assets/images/card-previews/mastercard/mastercard-vertical-back.svg"
    }
  },
  ["ELO" /* ELO */]: {
    horizontal: {
      "front-image": "assets/images/card-previews/elo/elo-horizontal-front.svg"
    }
  }
};
function getCardPreviewImageInfo(brand, orientation) {
  var _a;
  return ((_a = CARD_PREVIEWS[brand]) == null ? void 0 : _a[orientation]) || {};
}

// src/components/display/atlas-card-preview/atlas-card-preview.scss
import { css as css37 } from "lit-element/lit-element.js";
var atlas_card_preview_default = css37`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Z-index mapping for the floating elements */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host {
  display: block;
  width: fit-content;
  height: fit-content;
}

:host([block]) {
  width: 100%;
}

.card-preview {
  --card-preview-base-width: 256;
  --card-preview-base-height: 408;
  pointer-events: none;
  box-sizing: border-box;
  position: relative;
  min-width: 200px;
  max-width: 320px;
  aspect-ratio: var(--card-preview-base-width)/var(--card-preview-base-height);
  perspective: 600px;
  border-radius: 1rem;
}
.card-preview.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.card-preview.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}
.card-preview.skeleton.rounded {
  border-radius: 1rem !important;
}
.card-preview.unavailable {
  background: var(--atlas-secondary-100);
  padding: 1rem;
  border-radius: 1rem;
  text-align: center;
}
.card-preview.has-horizontal-orientation {
  --card-preview-base-width: 408;
  --card-preview-base-height: 256;
  min-width: 235px;
  max-width: 576px;
}
.card-preview .card-preview-side {
  width: 100%;
  height: 100%;
  overflow: hidden;
  backface-visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
  transition: transform 1s;
  display: flex;
  justify-content: center;
}
.card-preview .card-preview-side.front {
  transform: rotateY(-180deg);
}
.card-preview .card-preview-side.back {
  transform: rotateY(180deg);
}
.card-preview .card-preview-side.show {
  transform: rotateY(0deg);
}
.card-preview .card-preview-image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.card-preview .card-preview-image.disabled {
  opacity: 0.6;
  pointer-events: none;
}
.card-preview .number {
  display: inline-flex !important;
  align-items: center;
  gap: 1ch;
}
.card-preview .card-preview-element {
  --card-preview-element-relative-top: calc(
      var(--card-preview-element-top, 0) / var(--card-preview-base-height) * 100%
  );
  --card-preview-element-relative-bottom: calc(
      var(--card-preview-element-bottom, 0) / var(--card-preview-base-height) * 100%
  );
  --card-preview-element-relative-left: calc(
      var(--card-preview-element-left, 19.6) / var(--card-preview-base-width) * 100%
  );
  --card-preview-element-relative-right: calc(
      var(--card-preview-element-right, 19.6) / var(--card-preview-base-width) * 100%
  );
  --card-preview-element-relative-max-width: calc(
      100% - var(--card-preview-element-relative-left) - var(--card-preview-element-relative-right)
  );
  pointer-events: none;
  width: fit-content;
  height: fit-content;
  display: inline-block;
  word-wrap: break-word;
  position: absolute;
  z-index: 5;
  top: var(--card-preview-element-relative-top);
  left: var(--card-preview-element-relative-left);
  right: var(--card-preview-element-relative-right);
  bottom: var(--card-preview-element-relative-bottom);
  max-width: var(--card-preview-element-relative-max-width);
}
.card-preview .card-preview-element.holder {
  --card-preview-element-top: 171.75;
  white-space: nowrap;
  overflow: hidden;
  text-transform: uppercase;
}
.card-preview .card-preview-element.holder.has-due-date-and-cvc-group {
  --card-preview-element-top: 117.15;
}
.card-preview .card-preview-element.number {
  --card-preview-element-top: 205.85;
}
.card-preview .card-preview-element.number.has-due-date-and-cvc-group {
  --card-preview-element-top: 150.78;
}
.card-preview .card-preview-element.holder-and-number-group {
  --card-preview-element-bottom: 16;
  --card-preview-element-left: 16;
  --card-preview-element-right: 16;
  --card-preview-flag-relative-width: calc(100 / var(--card-preview-base-width) * 100%);
  height: auto;
  top: unset;
  text-transform: uppercase;
  max-width: calc(var(--card-preview-element-relative-max-width) - var(--card-preview-flag-relative-width));
  display: grid;
  grid-template-areas: "number" "holder";
  row-gap: 0.5rem;
}
.card-preview .card-preview-element.holder-and-number-group .number {
  grid-area: number;
}
.card-preview .card-preview-element.holder-and-number-group .holder {
  min-height: 17.5px;
  grid-area: holder;
}
.card-preview .card-preview-element.tier {
  --card-preview-element-top: 305.89;
}
.card-preview .card-preview-element.company {
  --card-preview-element-top: 240.36;
}
.card-preview .card-preview-element.balance {
  --card-preview-element-top: 82;
  --card-preview-element-left: 16;
  --card-preview-element-right: 16;
  --card-preview-chip-relative-width: calc(136 / var(--card-preview-base-width) * 100%);
  left: unset;
  text-align: end;
  max-width: calc(var(--card-preview-element-relative-max-width) - var(--card-preview-chip-relative-width));
  overflow: hidden;
  white-space: nowrap;
}
.card-preview .card-preview-element.due-date-and-cvc-group {
  --card-preview-element-top: 190;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: space-between;
}
.card-preview .card-preview-element.due-date-and-cvc-group .highlight {
  width: fit-content;
}
.card-preview .card-preview-element.due-date-and-cvc-group .group-item {
  display: flex;
  flex-direction: column;
}

.card-preview .number .group-digit.highlight, .card-preview .card-preview-element.due-date-and-cvc-group .highlight {
  position: relative;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}
.card-preview .number .group-digit.highlight::after, .card-preview .card-preview-element.due-date-and-cvc-group .highlight::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 0 0.125rem;
  border: 2px solid transparent;
  border-radius: 2px;
}
.card-preview .number .highlight-theme-primary.group-digit.highlight::after, .card-preview .card-preview-element.due-date-and-cvc-group .highlight-theme-primary.highlight::after {
  border-color: var(--atlas-primary);
}
.card-preview .number .highlight-theme-secondary.group-digit.highlight::after, .card-preview .card-preview-element.due-date-and-cvc-group .highlight-theme-secondary.highlight::after {
  border-color: var(--atlas-secondary);
}
.card-preview .number .highlight-theme-success.group-digit.highlight::after, .card-preview .card-preview-element.due-date-and-cvc-group .highlight-theme-success.highlight::after {
  border-color: var(--atlas-success);
}
.card-preview .number .highlight-theme-warning.group-digit.highlight::after, .card-preview .card-preview-element.due-date-and-cvc-group .highlight-theme-warning.highlight::after {
  border-color: var(--atlas-warning);
}
.card-preview .number .highlight-theme-danger.group-digit.highlight::after, .card-preview .card-preview-element.due-date-and-cvc-group .highlight-theme-danger.highlight::after {
  border-color: var(--atlas-danger);
}
.card-preview .number .highlight-theme-highlight.group-digit.highlight::after, .card-preview .card-preview-element.due-date-and-cvc-group .highlight-theme-highlight.highlight::after {
  border-color: var(--atlas-highlight);
}
.card-preview .number .highlight-theme-info.group-digit.highlight::after, .card-preview .card-preview-element.due-date-and-cvc-group .highlight-theme-info.highlight::after {
  border-color: var(--atlas-info);
}`;

// src/components/display/atlas-card-preview/atlas-card-preview.ts
var AtlasCardPreview = /*#__PURE__*/(() => {
  let AtlasCardPreview = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.initialSide = "front";
      this.orientation = "vertical";
      this.block = false;
      this.balanceLabel = "Saldo";
      this.highlightLastDigits = false;
      this.highlightCvc = false;
      this.highlightTheme = "warning";
      this._cardNumberLength = 16;
      this._cvcPattern = /^[\d*]{3}$/;
      this._dueDatePattern = /^(?:(\d{2})\/)?(\d{2})\/(\d{2}|\d{4})$/;
    }
    /** @internal */
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.normalizeProperties();
    }
    /**
     * Alterna a visualização do cartão entre frente e verso.
     * @param {CardPreviewSide} forceSide - Lado que deve ser exibido.
     */
    flip(forceSide) {
      if (!this.flipIsEnabled() || forceSide === this._currentSide) return;
      const acceptedValues = ["front", "back", void 0, null];
      if (!acceptedValues.includes(forceSide)) return;
      this._currentSide = forceSide || this.getOppositeSide();
    }
    normalizeProperties() {
      this._cardPreviewImageInfo = getCardPreviewImageInfo(this.brand, this.orientation);
      this.initialSide = this.previewImageIsAvailable(this.initialSide) ? this.initialSide : "front";
      this._currentSide = this.initialSide;
      this.width = this.width || (this.isHorizontalOrientation() ? 408 : 256);
    }
    previewIsAvailable() {
      return Object.keys(this._cardPreviewImageInfo).length > 0;
    }
    previewImageIsAvailable(side) {
      return this._cardPreviewImageInfo.hasOwnProperty(`${side}-image`);
    }
    isHorizontalOrientation() {
      return this.orientation === "horizontal";
    }
    flipIsEnabled() {
      if (!this.previewIsAvailable() || this.disabled) return false;
      const hasBothSides = ["front", "back"].every(side => this.previewImageIsAvailable(side));
      return hasBothSides && !this.skeletonLoading;
    }
    hasBalance() {
      return !!this.balanceValue;
    }
    hasCardNumber() {
      return this.cardNumber && this.getNormalizedCardNumber().length === this._cardNumberLength;
    }
    hasDueDate() {
      return !!this.dueDate && this._dueDatePattern.test(String(this.dueDate));
    }
    hasCvc() {
      return !!this.cvc && this._cvcPattern.test(String(this.cvc));
    }
    hasDueDateAndCvcGroup() {
      return this.hasDueDate() && this.hasCvc();
    }
    getOppositeSide() {
      return this._currentSide === "front" ? "back" : "front";
    }
    getNormalizedCardNumber() {
      return String(this.cardNumber).replace(/[^\d*]/g, "");
    }
    getFormattedBalanceValue() {
      if (isNaN(Number(this.balanceValue))) return this.balanceValue;
      const value = Number(this.balanceValue) || 0;
      return value.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2
      });
    }
    getFormattedDueDate() {
      if (!this.hasDueDate()) return "";
      const dueDate = String(this.dueDate);
      const [month, year] = dueDate.match(this._dueDatePattern).slice(2);
      return `${month}/${year.slice(-2)}`;
    }
    getCapitalizedBrandName() {
      return this.brand.charAt(0).toUpperCase() + this.brand.slice(1).toLowerCase();
    }
    getBackgroundImage(side) {
      if (!this.previewImageIsAvailable(side)) return void 0;
      const path = this._cardPreviewImageInfo[`${side}-image`];
      return getAssetPath(path);
    }
    getBackgroundImageAlt(side) {
      if (!this.previewImageIsAvailable(side)) return "Pr\xE9via Indispon\xEDvel";
      const sideLabel = side === "front" ? "Frente" : "Verso";
      const brandName = this.getCapitalizedBrandName();
      const imageAlt = `${sideLabel} do Cart\xE3o Asaas ${brandName}`;
      if (side === "back" && !!this.holder) {
        return `${imageAlt} com impress\xE3o do nome do portador ${this.holder}`;
      }
      if (side === "front" && !!this.company) {
        return `${imageAlt} com impress\xE3o do nome da empresa ${this.company}`;
      }
      return imageAlt;
    }
    getWidthStyle() {
      if (this.block) return {
        width: "100%"
      };
      return {
        width: `${this.width}px`
      };
    }
    renderElement() {
      const cardPreviewClass = {
        "card-preview": true,
        "has-horizontal-orientation": this.isHorizontalOrientation()
      };
      return when26(this.previewIsAvailable(), () => html43`
                <div class=${classMap28(cardPreviewClass)} style=${styleMap11(this.getWidthStyle())}>
                    ${this.renderFrontSide()} ${this.renderBackSide()}
                </div>
            `, () => this.renderUnavailablePreview());
    }
    renderSkeleton() {
      const skeletonClass = {
        "card-preview": true,
        "skeleton": true,
        "rounded": true,
        "has-horizontal-orientation": this.isHorizontalOrientation()
      };
      return html43`<div class=${classMap28(skeletonClass)} style=${styleMap11(this.getWidthStyle())}></div>`;
    }
    renderCompanyName() {
      return when26(!!this.company, () => html43`
                <atlas-text class="card-preview-element company" theme="primary" theme-variation="200" size="sm">
                    ${this.company}
                </atlas-text>
            `);
    }
    renderFormattedCardNumber() {
      if (!this.hasCardNumber()) return nothing;
      const cardNumber = this.getNormalizedCardNumber();
      const groupDigits = cardNumber.match(/.{1,4}/g) || [];
      return html43`
            ${map(groupDigits, (groupDigit, index) => {
        const shouldHighlight = this.highlightLastDigits && index === groupDigits.length - 1;
        const groupDigitClass = {
          "group-digit": true,
          "highlight": shouldHighlight,
          [`highlight-theme-${this.highlightTheme}`]: shouldHighlight
        };
        return html43`<atlas-text white bold class=${classMap28(groupDigitClass)}>${groupDigit}</atlas-text>`;
      })}
        `;
    }
    renderCardNumber() {
      const cardNumberClass = {
        "card-preview-element": true,
        "number": true,
        "has-due-date-and-cvc-group": this.hasDueDateAndCvcGroup()
      };
      return when26(this.hasCardNumber(), () => html43` <div class=${classMap28(cardNumberClass)}>${this.renderFormattedCardNumber()}</div> `);
    }
    renderHolderName() {
      const holderNameClass = {
        "card-preview-element": true,
        "holder": true,
        "has-due-date-and-cvc-group": this.hasDueDateAndCvcGroup()
      };
      return when26(!!this.holder, () => html43` <atlas-text class=${classMap28(holderNameClass)} white size="sm"> ${this.holder} </atlas-text> `);
    }
    renderDueDate() {
      return html43`
            <div class="group-item">
                <atlas-text white size="xs"> Validade </atlas-text>
                <atlas-text white size="sm" bold> ${this.getFormattedDueDate()} </atlas-text>
            </div>
        `;
    }
    renderCvc() {
      const cvcClass = {
        highlight: this.highlightCvc,
        [`highlight-theme-${this.highlightTheme}`]: this.highlightCvc
      };
      return html43`
            <div class="group-item">
                <atlas-text white size="xs"> CVC </atlas-text>
                <atlas-text white size="sm" bold class=${classMap28(cvcClass)}> ${this.cvc} </atlas-text>
            </div>
        `;
    }
    renderHolderAndNumberGroup() {
      return html43`
            <div class="card-preview-element holder-and-number-group">
                <div class="number">${this.renderFormattedCardNumber()}</div>
                <atlas-text class="holder" white size="xs" bold> ${this.holder} </atlas-text>
            </div>
        `;
    }
    renderDueDateAndCvcGroup() {
      return when26(this.hasDueDateAndCvcGroup(), () => html43`
                <div class="card-preview-element due-date-and-cvc-group">
                    ${this.renderDueDate()} ${this.renderCvc()}
                </div>
            `);
    }
    renderTier() {
      return when26(!!this.tier, () => html43`<atlas-text class="card-preview-element tier" white bold>${this.tier}</atlas-text>`);
    }
    renderBalance() {
      return when26(this.hasBalance(), () => html43`
                <atlas-layout class="card-preview-element balance">
                    <atlas-text class="balance-label" white size="xs" ellipsis>${this.balanceLabel}</atlas-text>
                    <atlas-text white size="xs" bold>${this.getFormattedBalanceValue()}</atlas-text>
                </atlas-layout>
            `);
    }
    renderBackgroundImage(side) {
      const backgroundImageClass = {
        "card-preview-image": true,
        "disabled": this.disabled
      };
      return html43`
            <img
                class=${classMap28(backgroundImageClass)}
                src=${this.getBackgroundImage(side)}
                alt=${this.getBackgroundImageAlt(side)}
            />
        `;
    }
    renderUnavailablePreview() {
      const unavailablePreviewClass = {
        "card-preview": true,
        "unavailable": true,
        "has-horizontal-orientation": this.isHorizontalOrientation()
      };
      return html43`
            <div class=${classMap28(unavailablePreviewClass)} style=${styleMap11(this.getWidthStyle())}>
                <atlas-layout fluid justify="center" alignment="center" gap="2">
                    <atlas-icon name="alert-triangle" theme="warning"></atlas-icon>
                    <atlas-text theme="warning" size="lg">Prévia Indisponível</atlas-text>
                </atlas-layout>
            </div>
        `;
    }
    renderFrontSideContent() {
      return when26(this.isHorizontalOrientation(), () => html43` ${this.renderBalance()} ${this.renderHolderAndNumberGroup()} `, () => html43` ${this.renderCompanyName()} `);
    }
    renderBackSideContent() {
      return when26(!this.isHorizontalOrientation(), () => html43`
                ${this.renderHolderName()} ${this.renderCardNumber()} ${this.renderDueDateAndCvcGroup()}
                ${this.renderTier()}
            `);
    }
    renderFrontSide() {
      const frontSideClass = {
        "card-preview-side": true,
        "front": true,
        "show": this._currentSide === "front"
      };
      return html43`
            <div class=${classMap28(frontSideClass)}>
                ${this.renderBackgroundImage("front")} ${this.renderFrontSideContent()}
            </div>
        `;
    }
    renderBackSide() {
      const backSideClass = {
        "card-preview-side": true,
        "back": true,
        "show": this._currentSide === "back"
      };
      return when26(this.previewImageIsAvailable("back"), () => html43`
                <div class=${classMap28(backSideClass)}>
                    ${this.renderBackgroundImage("back")} ${this.renderBackSideContent()}
                </div>
            `);
    }
  };
  AtlasCardPreview.styles = atlas_card_preview_default;
  return AtlasCardPreview;
})();
__decorateClass([property43({
  type: String
})], AtlasCardPreview.prototype, "company", 2);
__decorateClass([property43({
  type: String,
  attribute: "card-number"
})], AtlasCardPreview.prototype, "cardNumber", 2);
__decorateClass([property43({
  type: String
})], AtlasCardPreview.prototype, "brand", 2);
__decorateClass([property43({
  type: String
})], AtlasCardPreview.prototype, "holder", 2);
__decorateClass([property43({
  type: String,
  reflect: true,
  attribute: "initial-side"
})], AtlasCardPreview.prototype, "initialSide", 2);
__decorateClass([property43({
  type: String
})], AtlasCardPreview.prototype, "tier", 2);
__decorateClass([property43({
  type: Number
})], AtlasCardPreview.prototype, "width", 2);
__decorateClass([property43({
  type: String
})], AtlasCardPreview.prototype, "orientation", 2);
__decorateClass([property43({
  type: Boolean,
  reflect: true
})], AtlasCardPreview.prototype, "block", 2);
__decorateClass([property43({
  type: Boolean
})], AtlasCardPreview.prototype, "disabled", 2);
__decorateClass([property43({
  type: String,
  attribute: "balance-value"
})], AtlasCardPreview.prototype, "balanceValue", 2);
__decorateClass([property43({
  type: String,
  attribute: "balance-label"
})], AtlasCardPreview.prototype, "balanceLabel", 2);
__decorateClass([property43({
  type: Boolean,
  reflect: true,
  attribute: "highlight-last-digits"
})], AtlasCardPreview.prototype, "highlightLastDigits", 2);
__decorateClass([property43({
  type: Boolean,
  reflect: true,
  attribute: "highlight-cvc"
})], AtlasCardPreview.prototype, "highlightCvc", 2);
__decorateClass([property43({
  type: String,
  attribute: "highlight-theme"
})], AtlasCardPreview.prototype, "highlightTheme", 2);
__decorateClass([property43({
  type: String,
  attribute: "due-date"
})], AtlasCardPreview.prototype, "dueDate", 2);
__decorateClass([property43({
  type: String
})], AtlasCardPreview.prototype, "cvc", 2);
__decorateClass([state16()], AtlasCardPreview.prototype, "_cardPreviewImageInfo", 2);
__decorateClass([state16()], AtlasCardPreview.prototype, "_currentSide", 2);
AtlasCardPreview = __decorateClass([customElement37("atlas-card-preview")], AtlasCardPreview);

// src/components/display/atlas-collapse-button/atlas-collapse-button.ts
import { html as html44 } from "lit";
import { customElement as customElement38, property as property44 } from "lit/decorators.js";
import { classMap as classMap29 } from "lit/directives/class-map.js";

// src/components/display/atlas-collapse-button/atlas-collapse-button.scss
import { css as css38 } from "lit-element/lit-element.js";
var atlas_collapse_button_default = css38`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
/* Transitions */
.collapse-button {
  justify-content: flex-end;
  border: none;
  box-shadow: none;
  background: none;
  display: inline-flex;
  align-items: center;
  font-family: inherit;
  outline: none;
  padding: 0.25rem;
  box-sizing: border-box;
  border-radius: 50%;
  transition: background 0.35s ease;
}
.collapse-button atlas-icon {
  color: #6c757d;
  margin-top: -1px;
  transform-origin: 50% 54%;
  transition: transform 0.35s ease, color 0.35s ease;
}
.collapse-button.collapsed atlas-icon {
  transform: rotate(-180deg);
}
.collapse-button:hover {
  cursor: pointer;
}

.collapse-button.theme-primary:hover {
  background-color: var(--atlas-secondary-100);
  cursor: pointer;
}
.collapse-button.theme-primary:focus {
  background-color: var(--atlas-primary-100);
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-500-rgb), 0.25);
}
.collapse-button.theme-primary:focus atlas-icon {
  color: var(--atlas-primary);
}
.collapse-button.theme-primary:active {
  background-color: none;
}
.collapse-button.theme-primary:active atlas-icon {
  color: var(--atlas-primary);
}

.collapse-button.color-primary atlas-icon {
  color: var(--atlas-primary);
}

.collapse-button.theme-secondary:hover {
  background-color: var(--atlas-secondary-100);
  cursor: pointer;
}
.collapse-button.theme-secondary:focus {
  background-color: var(--atlas-secondary-100);
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-secondary-500-rgb), 0.25);
}
.collapse-button.theme-secondary:focus atlas-icon {
  color: var(--atlas-secondary);
}
.collapse-button.theme-secondary:active {
  background-color: none;
}
.collapse-button.theme-secondary:active atlas-icon {
  color: var(--atlas-secondary);
}

.collapse-button.color-secondary atlas-icon {
  color: var(--atlas-secondary);
}

.collapse-button.theme-success:hover {
  background-color: var(--atlas-secondary-100);
  cursor: pointer;
}
.collapse-button.theme-success:focus {
  background-color: var(--atlas-success-100);
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
}
.collapse-button.theme-success:focus atlas-icon {
  color: var(--atlas-success);
}
.collapse-button.theme-success:active {
  background-color: none;
}
.collapse-button.theme-success:active atlas-icon {
  color: var(--atlas-success);
}

.collapse-button.color-success atlas-icon {
  color: var(--atlas-success);
}

.collapse-button.theme-warning:hover {
  background-color: var(--atlas-secondary-100);
  cursor: pointer;
}
.collapse-button.theme-warning:focus {
  background-color: var(--atlas-warning-100);
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
}
.collapse-button.theme-warning:focus atlas-icon {
  color: var(--atlas-warning);
}
.collapse-button.theme-warning:active {
  background-color: none;
}
.collapse-button.theme-warning:active atlas-icon {
  color: var(--atlas-warning);
}

.collapse-button.color-warning atlas-icon {
  color: var(--atlas-warning);
}

.collapse-button.theme-danger:hover {
  background-color: var(--atlas-secondary-100);
  cursor: pointer;
}
.collapse-button.theme-danger:focus {
  background-color: var(--atlas-danger-100);
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
}
.collapse-button.theme-danger:focus atlas-icon {
  color: var(--atlas-danger);
}
.collapse-button.theme-danger:active {
  background-color: none;
}
.collapse-button.theme-danger:active atlas-icon {
  color: var(--atlas-danger);
}

.collapse-button.color-danger atlas-icon {
  color: var(--atlas-danger);
}

.collapse-button.theme-highlight:hover {
  background-color: var(--atlas-secondary-100);
  cursor: pointer;
}
.collapse-button.theme-highlight:focus {
  background-color: var(--atlas-highlight-100);
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-highlight-500-rgb), 0.25);
}
.collapse-button.theme-highlight:focus atlas-icon {
  color: var(--atlas-highlight);
}
.collapse-button.theme-highlight:active {
  background-color: none;
}
.collapse-button.theme-highlight:active atlas-icon {
  color: var(--atlas-highlight);
}

.collapse-button.color-highlight atlas-icon {
  color: var(--atlas-highlight);
}

.collapse-button.theme-info:hover {
  background-color: var(--atlas-secondary-100);
  cursor: pointer;
}
.collapse-button.theme-info:focus {
  background-color: var(--atlas-info-100);
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-info-500-rgb), 0.25);
}
.collapse-button.theme-info:focus atlas-icon {
  color: var(--atlas-info);
}
.collapse-button.theme-info:active {
  background-color: none;
}
.collapse-button.theme-info:active atlas-icon {
  color: var(--atlas-info);
}

.collapse-button.color-info atlas-icon {
  color: var(--atlas-info);
}

.collapse-button.theme-critical-action:focus-within {
  background-color: rgba(52, 58, 64, 0.1);
}
.collapse-button.theme-critical-action:focus-within atlas-icon {
  color: #343a40;
}

.collapse-button.color-critical-action atlas-icon {
  color: #343a40;
}

.collapse-button.theme-critical-action-item:focus-within {
  background-color: rgba(108, 117, 125, 0.1);
}
.collapse-button.theme-critical-action-item:focus-within atlas-icon {
  color: #6c757d;
}

.collapse-button.color-critical-action-item atlas-icon {
  color: #6c757d;
}`;

// src/components/display/atlas-collapse-button/atlas-collapse-button.ts
var AtlasCollapseButton = /*#__PURE__*/(() => {
  let AtlasCollapseButton = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.size = "3x";
      this.theme = "primary";
      this.iconColor = "secondary";
    }
    render() {
      const collapseButtonClass = {
        "collapse-button": true,
        "collapsed": this.collapsed,
        [`theme-${this.theme}`]: !!this.theme,
        [`color-${this.iconColor}`]: !!this.iconColor
      };
      return html44`
            <button type="button" class="${classMap29(collapseButtonClass)}">
                <atlas-icon name="chevron-up" size="${this.size}" class="collapse-icon"></atlas-icon>
            </button>
        `;
    }
  };
  AtlasCollapseButton.styles = atlas_collapse_button_default;
  return AtlasCollapseButton;
})();
__decorateClass([property44({
  type: Boolean
})], AtlasCollapseButton.prototype, "collapsed", 2);
__decorateClass([property44({
  type: String
})], AtlasCollapseButton.prototype, "size", 2);
__decorateClass([property44({
  type: String
})], AtlasCollapseButton.prototype, "theme", 2);
__decorateClass([property44({
  type: String,
  attribute: "icon-color"
})], AtlasCollapseButton.prototype, "iconColor", 2);
AtlasCollapseButton = __decorateClass([customElement38("atlas-collapse-button")], AtlasCollapseButton);

// src/components/display/atlas-collapsible-text/atlas-collapsible-text.ts
import { html as html45 } from "lit";
import { customElement as customElement39, property as property45, state as state17 } from "lit/decorators.js";
import { classMap as classMap30 } from "lit/directives/class-map.js";
import { when as when27 } from "lit/directives/when.js";

// src/components/display/atlas-collapsible-text/atlas-collapsible-text.scss
import { css as css39 } from "lit-element/lit-element.js";
var atlas_collapsible_text_default = css39`/* Transitions */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.color-white {
  color: #ffffff !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.color-primary {
  color: var(--atlas-primary) !important;
}

.bg-primary {
  background-color: var(--atlas-primary) !important;
}

.color-primary-100 {
  color: var(--atlas-primary-100) !important;
}

.bg-primary-100 {
  background-color: var(--atlas-primary-100) !important;
}

.color-primary-200 {
  color: var(--atlas-primary-200) !important;
}

.bg-primary-200 {
  background-color: var(--atlas-primary-200) !important;
}

.color-primary-300 {
  color: var(--atlas-primary-300) !important;
}

.bg-primary-300 {
  background-color: var(--atlas-primary-300) !important;
}

.color-primary-400 {
  color: var(--atlas-primary-400) !important;
}

.bg-primary-400 {
  background-color: var(--atlas-primary-400) !important;
}

.color-primary-500 {
  color: var(--atlas-primary-500) !important;
}

.bg-primary-500 {
  background-color: var(--atlas-primary-500) !important;
}

.color-primary-600 {
  color: var(--atlas-primary-600) !important;
}

.bg-primary-600 {
  background-color: var(--atlas-primary-600) !important;
}

.color-primary-700 {
  color: var(--atlas-primary-700) !important;
}

.bg-primary-700 {
  background-color: var(--atlas-primary-700) !important;
}

.color-primary-800 {
  color: var(--atlas-primary-800) !important;
}

.bg-primary-800 {
  background-color: var(--atlas-primary-800) !important;
}

.color-primary-900 {
  color: var(--atlas-primary-900) !important;
}

.bg-primary-900 {
  background-color: var(--atlas-primary-900) !important;
}

.active-primary[active], .active-primary.active, .active-primary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-secondary {
  color: var(--atlas-secondary) !important;
}

.bg-secondary {
  background-color: var(--atlas-secondary) !important;
}

.color-secondary-100 {
  color: var(--atlas-secondary-100) !important;
}

.bg-secondary-100 {
  background-color: var(--atlas-secondary-100) !important;
}

.color-secondary-200 {
  color: var(--atlas-secondary-200) !important;
}

.bg-secondary-200 {
  background-color: var(--atlas-secondary-200) !important;
}

.color-secondary-300 {
  color: var(--atlas-secondary-300) !important;
}

.bg-secondary-300 {
  background-color: var(--atlas-secondary-300) !important;
}

.color-secondary-400 {
  color: var(--atlas-secondary-400) !important;
}

.bg-secondary-400 {
  background-color: var(--atlas-secondary-400) !important;
}

.color-secondary-500 {
  color: var(--atlas-secondary-500) !important;
}

.bg-secondary-500 {
  background-color: var(--atlas-secondary-500) !important;
}

.color-secondary-600 {
  color: var(--atlas-secondary-600) !important;
}

.bg-secondary-600 {
  background-color: var(--atlas-secondary-600) !important;
}

.color-secondary-700 {
  color: var(--atlas-secondary-700) !important;
}

.bg-secondary-700 {
  background-color: var(--atlas-secondary-700) !important;
}

.color-secondary-800 {
  color: var(--atlas-secondary-800) !important;
}

.bg-secondary-800 {
  background-color: var(--atlas-secondary-800) !important;
}

.color-secondary-900 {
  color: var(--atlas-secondary-900) !important;
}

.bg-secondary-900 {
  background-color: var(--atlas-secondary-900) !important;
}

.active-secondary[active], .active-secondary.active, .active-secondary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-success {
  color: var(--atlas-success) !important;
}

.bg-success {
  background-color: var(--atlas-success) !important;
}

.color-success-100 {
  color: var(--atlas-success-100) !important;
}

.bg-success-100 {
  background-color: var(--atlas-success-100) !important;
}

.color-success-200 {
  color: var(--atlas-success-200) !important;
}

.bg-success-200 {
  background-color: var(--atlas-success-200) !important;
}

.color-success-300 {
  color: var(--atlas-success-300) !important;
}

.bg-success-300 {
  background-color: var(--atlas-success-300) !important;
}

.color-success-400 {
  color: var(--atlas-success-400) !important;
}

.bg-success-400 {
  background-color: var(--atlas-success-400) !important;
}

.color-success-500 {
  color: var(--atlas-success-500) !important;
}

.bg-success-500 {
  background-color: var(--atlas-success-500) !important;
}

.color-success-600 {
  color: var(--atlas-success-600) !important;
}

.bg-success-600 {
  background-color: var(--atlas-success-600) !important;
}

.color-success-700 {
  color: var(--atlas-success-700) !important;
}

.bg-success-700 {
  background-color: var(--atlas-success-700) !important;
}

.color-success-800 {
  color: var(--atlas-success-800) !important;
}

.bg-success-800 {
  background-color: var(--atlas-success-800) !important;
}

.color-success-900 {
  color: var(--atlas-success-900) !important;
}

.bg-success-900 {
  background-color: var(--atlas-success-900) !important;
}

.active-success[active], .active-success.active, .active-success:active {
  background-color: var(--atlas-success) !important;
  color: var(--atlas-contrast-success) !important;
}

.color-warning {
  color: var(--atlas-warning) !important;
}

.bg-warning {
  background-color: var(--atlas-warning) !important;
}

.color-warning-100 {
  color: var(--atlas-warning-100) !important;
}

.bg-warning-100 {
  background-color: var(--atlas-warning-100) !important;
}

.color-warning-200 {
  color: var(--atlas-warning-200) !important;
}

.bg-warning-200 {
  background-color: var(--atlas-warning-200) !important;
}

.color-warning-300 {
  color: var(--atlas-warning-300) !important;
}

.bg-warning-300 {
  background-color: var(--atlas-warning-300) !important;
}

.color-warning-400 {
  color: var(--atlas-warning-400) !important;
}

.bg-warning-400 {
  background-color: var(--atlas-warning-400) !important;
}

.color-warning-500 {
  color: var(--atlas-warning-500) !important;
}

.bg-warning-500 {
  background-color: var(--atlas-warning-500) !important;
}

.color-warning-600 {
  color: var(--atlas-warning-600) !important;
}

.bg-warning-600 {
  background-color: var(--atlas-warning-600) !important;
}

.color-warning-700 {
  color: var(--atlas-warning-700) !important;
}

.bg-warning-700 {
  background-color: var(--atlas-warning-700) !important;
}

.color-warning-800 {
  color: var(--atlas-warning-800) !important;
}

.bg-warning-800 {
  background-color: var(--atlas-warning-800) !important;
}

.color-warning-900 {
  color: var(--atlas-warning-900) !important;
}

.bg-warning-900 {
  background-color: var(--atlas-warning-900) !important;
}

.active-warning[active], .active-warning.active, .active-warning:active {
  background-color: var(--atlas-warning) !important;
  color: var(--atlas-contrast-warning) !important;
}

.color-danger {
  color: var(--atlas-danger) !important;
}

.bg-danger {
  background-color: var(--atlas-danger) !important;
}

.color-danger-100 {
  color: var(--atlas-danger-100) !important;
}

.bg-danger-100 {
  background-color: var(--atlas-danger-100) !important;
}

.color-danger-200 {
  color: var(--atlas-danger-200) !important;
}

.bg-danger-200 {
  background-color: var(--atlas-danger-200) !important;
}

.color-danger-300 {
  color: var(--atlas-danger-300) !important;
}

.bg-danger-300 {
  background-color: var(--atlas-danger-300) !important;
}

.color-danger-400 {
  color: var(--atlas-danger-400) !important;
}

.bg-danger-400 {
  background-color: var(--atlas-danger-400) !important;
}

.color-danger-500 {
  color: var(--atlas-danger-500) !important;
}

.bg-danger-500 {
  background-color: var(--atlas-danger-500) !important;
}

.color-danger-600 {
  color: var(--atlas-danger-600) !important;
}

.bg-danger-600 {
  background-color: var(--atlas-danger-600) !important;
}

.color-danger-700 {
  color: var(--atlas-danger-700) !important;
}

.bg-danger-700 {
  background-color: var(--atlas-danger-700) !important;
}

.color-danger-800 {
  color: var(--atlas-danger-800) !important;
}

.bg-danger-800 {
  background-color: var(--atlas-danger-800) !important;
}

.color-danger-900 {
  color: var(--atlas-danger-900) !important;
}

.bg-danger-900 {
  background-color: var(--atlas-danger-900) !important;
}

.active-danger[active], .active-danger.active, .active-danger:active {
  background-color: var(--atlas-danger) !important;
  color: var(--atlas-contrast-danger) !important;
}

.color-highlight {
  color: var(--atlas-highlight) !important;
}

.bg-highlight {
  background-color: var(--atlas-highlight) !important;
}

.color-highlight-100 {
  color: var(--atlas-highlight-100) !important;
}

.bg-highlight-100 {
  background-color: var(--atlas-highlight-100) !important;
}

.color-highlight-200 {
  color: var(--atlas-highlight-200) !important;
}

.bg-highlight-200 {
  background-color: var(--atlas-highlight-200) !important;
}

.color-highlight-300 {
  color: var(--atlas-highlight-300) !important;
}

.bg-highlight-300 {
  background-color: var(--atlas-highlight-300) !important;
}

.color-highlight-400 {
  color: var(--atlas-highlight-400) !important;
}

.bg-highlight-400 {
  background-color: var(--atlas-highlight-400) !important;
}

.color-highlight-500 {
  color: var(--atlas-highlight-500) !important;
}

.bg-highlight-500 {
  background-color: var(--atlas-highlight-500) !important;
}

.color-highlight-600 {
  color: var(--atlas-highlight-600) !important;
}

.bg-highlight-600 {
  background-color: var(--atlas-highlight-600) !important;
}

.color-highlight-700 {
  color: var(--atlas-highlight-700) !important;
}

.bg-highlight-700 {
  background-color: var(--atlas-highlight-700) !important;
}

.color-highlight-800 {
  color: var(--atlas-highlight-800) !important;
}

.bg-highlight-800 {
  background-color: var(--atlas-highlight-800) !important;
}

.color-highlight-900 {
  color: var(--atlas-highlight-900) !important;
}

.bg-highlight-900 {
  background-color: var(--atlas-highlight-900) !important;
}

.active-highlight[active], .active-highlight.active, .active-highlight:active {
  background-color: var(--atlas-highlight) !important;
  color: var(--atlas-contrast-highlight) !important;
}

.color-info {
  color: var(--atlas-info) !important;
}

.bg-info {
  background-color: var(--atlas-info) !important;
}

.color-info-100 {
  color: var(--atlas-info-100) !important;
}

.bg-info-100 {
  background-color: var(--atlas-info-100) !important;
}

.color-info-200 {
  color: var(--atlas-info-200) !important;
}

.bg-info-200 {
  background-color: var(--atlas-info-200) !important;
}

.color-info-300 {
  color: var(--atlas-info-300) !important;
}

.bg-info-300 {
  background-color: var(--atlas-info-300) !important;
}

.color-info-400 {
  color: var(--atlas-info-400) !important;
}

.bg-info-400 {
  background-color: var(--atlas-info-400) !important;
}

.color-info-500 {
  color: var(--atlas-info-500) !important;
}

.bg-info-500 {
  background-color: var(--atlas-info-500) !important;
}

.color-info-600 {
  color: var(--atlas-info-600) !important;
}

.bg-info-600 {
  background-color: var(--atlas-info-600) !important;
}

.color-info-700 {
  color: var(--atlas-info-700) !important;
}

.bg-info-700 {
  background-color: var(--atlas-info-700) !important;
}

.color-info-800 {
  color: var(--atlas-info-800) !important;
}

.bg-info-800 {
  background-color: var(--atlas-info-800) !important;
}

.color-info-900 {
  color: var(--atlas-info-900) !important;
}

.bg-info-900 {
  background-color: var(--atlas-info-900) !important;
}

.active-info[active], .active-info.active, .active-info:active {
  background-color: var(--atlas-info) !important;
  color: var(--atlas-contrast-info) !important;
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
:host([alignment=left]),
.text-align-left {
  text-align: left;
}

:host([alignment=center]),
.text-align-center {
  text-align: center;
}

:host([alignment=right]),
.text-align-right {
  text-align: right;
}

:host([alignment=justify]),
.text-align-justify {
  text-align: justify;
}

.text-muted {
  color: #687078 !important;
}

.text-white {
  color: #ffffff !important;
}

:host([ellipsis]) {
  width: 100%;
  overflow: hidden;
}

.ellipsis {
  display: block !important;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.line-clamp {
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

:host {
  display: inline;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}

.atlas-text {
  display: inline;
  line-height: 1.5;
  font-weight: 400;
  color: var(--atlas-text-color, #212529);
}

.bold {
  font-weight: 700;
}

.italic {
  font-style: italic;
}

.underline {
  text-decoration: underline;
}

.strikethrough {
  text-decoration: line-through;
}

.lg {
  font-size: 1.25rem;
}
.lg.skeleton {
  display: block;
  height: 1.875rem;
}

.md {
  font-size: 1rem;
}
.md.skeleton {
  display: block;
  height: 1.5rem;
}

.sm {
  font-size: 0.875rem;
}
.sm.skeleton {
  display: block;
  height: 1.3125rem;
}

.xs {
  font-size: 0.8rem;
}
.xs.skeleton {
  display: block;
  height: 1.2rem;
}

.atlas-text {
  transition: max-height 0.25s ease;
}

.collapsible-text-wrapper {
  white-space: pre-line;
  word-break: break-word;
}
.collapsible-text-wrapper.normal-white-space {
  white-space: normal;
}`;

// src/components/display/atlas-collapsible-text/atlas-collapsible-text.ts
var AtlasCollapsibleText = /*#__PURE__*/(() => {
  let AtlasCollapsibleText = class extends AtlasText {
    constructor() {
      super(...arguments);
      this.loadMoreButtonLabel = "Carregar mais informa\xE7\xF5es";
      this.loadLessButtonLabel = "Carregar menos informa\xE7\xF5es";
      this.hideToggleButton = false;
      this.normalWhiteSpace = false;
      this._isExpanded = false;
      this._shouldShowButton = false;
      this._lastLineClamp = null;
      this._elementWidth = null;
      this._heightBeforeExpand = null;
      this._trimmedHTML = "";
    }
    /**
     * Carrega o texto completo
     */
    loadMoreText() {
      this._heightBeforeExpand = this._textWrapperReference.offsetHeight;
      this._textWrapperReference.style.maxHeight = `${this._heightBeforeExpand}px`;
      this._textWrapperReference.style.overflow = "hidden";
      this._lastLineClamp = this.lineClamp;
      this.lineClamp = null;
      setTimeout(() => {
        this._textWrapperReference.style.maxHeight = `${this._textWrapperReference.scrollHeight}px`;
        setTimeout(() => {
          this._textWrapperReference.style.maxHeight = null;
          this._textWrapperReference.style.overflow = null;
        }, 250);
      }, 0);
    }
    /**
     * Carrega o texto reduzido, respeitando o line clamp
     */
    loadLessText() {
      return __async(this, null, function* () {
        this._textWrapperReference.style.maxHeight = `${this._textWrapperReference.offsetHeight}px`;
        this._textWrapperReference.style.overflow = "hidden";
        setTimeout(() => {
          this._textWrapperReference.style.maxHeight = `${this._heightBeforeExpand}px`;
          setTimeout(() => {
            this._textWrapperReference.style.maxHeight = null;
            this._textWrapperReference.style.overflow = null;
            this.lineClamp = this._lastLineClamp;
            this._lastLineClamp = null;
          }, 250);
        }, 0);
      });
    }
    /**
     * Alterna entre expandir e retrair o texto
     */
    toggleExpandText() {
      this._isExpanded = !this._isExpanded;
      if (this._isExpanded) {
        this.loadMoreText();
      } else {
        this.loadLessText();
      }
    }
    onTextResize() {
      return __async(this, null, function* () {
        yield __superGet(AtlasCollapsibleText.prototype, this, "onTextResize").call(this);
        const textVisibleHeight = this._textWrapperReference.offsetHeight;
        const textTotalHeight = this._textWrapperReference.scrollHeight;
        if (textVisibleHeight < textTotalHeight) {
          this._shouldShowButton = true;
          this._elementWidth = this._textWrapperReference.offsetWidth;
        } else if (this._isExpanded) {
          if (this._elementWidth === this._textWrapperReference.scrollWidth) return;
          this._isExpanded = false;
          this._shouldShowButton = true;
          this._elementWidth = null;
          this.loadLessText();
        } else {
          this._shouldShowButton = false;
          this._elementWidth = null;
        }
      });
    }
    onSlotChange() {
      if (this.skeletonLoading) return;
      const slotContent = getSlotInnerHTML(this.shadowRoot.querySelector("slot"));
      if (this._trimmedHTML === slotContent) return;
      setTimeout(() => {
        this._trimmedHTML = slotContent.trim();
        this.innerHTML = this._trimmedHTML;
      }, 0);
    }
    renderContentSlot() {
      const wrapperClass = {
        "collapsible-text-wrapper": true,
        "normal-white-space": this.normalWhiteSpace
      };
      return html45`<slot class=${classMap30(wrapperClass)} @slotchange=${this.onSlotChange}></slot>`;
    }
    renderToggleButton() {
      return when27(this._shouldShowButton && !this.hideToggleButton, () => html45`
                <atlas-button
                    type="outlined"
                    description=${this._isExpanded ? this.loadLessButtonLabel : this.loadMoreButtonLabel}
                    @atlas-button-click=${this.toggleExpandText}
                ></atlas-button>
            `);
    }
    renderElement() {
      return html45`<atlas-layout gap="2">${super.renderElement()} ${this.renderToggleButton()}</atlas-layout>`;
    }
  };
  AtlasCollapsibleText.styles = atlas_collapsible_text_default;
  return AtlasCollapsibleText;
})();
__decorateClass([property45({
  type: String,
  attribute: "load-more-button-label"
})], AtlasCollapsibleText.prototype, "loadMoreButtonLabel", 2);
__decorateClass([property45({
  type: String,
  attribute: "load-less-button-label"
})], AtlasCollapsibleText.prototype, "loadLessButtonLabel", 2);
__decorateClass([property45({
  type: Boolean,
  attribute: "hide-toggle-button"
})], AtlasCollapsibleText.prototype, "hideToggleButton", 2);
__decorateClass([property45({
  type: Boolean,
  attribute: "normal-white-space"
})], AtlasCollapsibleText.prototype, "normalWhiteSpace", 2);
__decorateClass([state17()], AtlasCollapsibleText.prototype, "_isExpanded", 2);
__decorateClass([state17()], AtlasCollapsibleText.prototype, "_shouldShowButton", 2);
__decorateClass([state17()], AtlasCollapsibleText.prototype, "_lastLineClamp", 2);
__decorateClass([state17()], AtlasCollapsibleText.prototype, "_elementWidth", 2);
__decorateClass([state17()], AtlasCollapsibleText.prototype, "_heightBeforeExpand", 2);
__decorateClass([state17()], AtlasCollapsibleText.prototype, "_trimmedHTML", 2);
AtlasCollapsibleText = __decorateClass([customElement39("atlas-collapsible-text")], AtlasCollapsibleText);

// src/components/display/atlas-dialog/atlas-dialog.ts
import { html as html46 } from "lit";
import { customElement as customElement40, property as property46, state as state18 } from "lit/decorators.js";
import { classMap as classMap31 } from "lit/directives/class-map.js";
import { when as when28 } from "lit/directives/when.js";

// src/components/display/atlas-dialog/atlas-dialog.scss
import { css as css40 } from "lit-element/lit-element.js";
var atlas_dialog_default = css40`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
/* Transitions */
/* Z-index mapping for the floating elements */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: block;
  position: fixed;
  bottom: 24px;
  right: 24px;
  pointer-events: none;
  z-index: 600;
  transform: translateY(calc(100% + 32px));
  transition: transform 0.5s ease-out;
  width: 100%;
  max-width: min(400px, 100% - 48px);
}

:host([open]) {
  pointer-events: all;
  transform: translateY(0);
}

:host(.disabled-animation) {
  transition: none;
}

.atlas-dialog {
  background-color: #ffffff;
  border-radius: 0.5rem;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.25);
  border: 1px solid #ced4da;
  box-sizing: border-box;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-height: 400px;
  width: 100%;
  position: relative;
}
.atlas-dialog .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.atlas-dialog .footer {
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;
}

.atlas-dialog:not(.has-content) .content {
  display: none;
}

.atlas-dialog:not(.has-actions) .footer {
  display: none;
}

.atlas-dialog.vertical-actions .footer {
  flex-direction: column;
}

.atlas-dialog.block-actions .footer slot[name=actions]::slotted(*) {
  flex-grow: 1;
}

@media screen and (min-width: 992px) {
  :host {
    bottom: 40px;
    right: 40px;
    transform: translateY(calc(100% + 48px));
    max-width: 360px;
  }
  :host([size=sm]) {
    max-width: 320px;
  }
  :host([size=lg]) {
    max-width: 400px;
  }
}`;

// src/components/display/atlas-dialog/atlas-dialog.ts
var AtlasDialog = /*#__PURE__*/(() => {
  let AtlasDialog = class extends AtlasElement {
    constructor() {
      super();
      this.header = "";
      this.size = "md";
      this.verticalActions = false;
      this.blockActions = false;
      this._hasContent = false;
      this._hasActions = false;
      this.openDialog = this.openDialog.bind(this);
      this.closeDialog = this.closeDialog.bind(this);
      this.onSlottedButtonClick = this.onSlottedButtonClick.bind(this);
      this._triggerController = new TriggerController(this, "click");
    }
    /**
     * @internal
     */
    connectedCallback() {
      super.connectedCallback();
      this.classList.add("disabled-animation");
      this.addEventListener("atlas-button-click", this.onSlottedButtonClick);
    }
    /**
     * @internal
     */
    disconnectedCallback() {
      super.disconnectedCallback();
      this.removeEventListener("atlas-button-click", this.onSlottedButtonClick);
    }
    /**
     * @internal
     */
    firstUpdated() {
      requestAnimationFrame(() => {
        this.classList.remove("disabled-animation");
      });
    }
    /**
     * Abre o dialog
     */
    openDialog() {
      this._triggerController.show();
    }
    /**
     * Fecha o dialog
     */
    closeDialog() {
      this._triggerController.hide();
    }
    /**
     * @internal
     */
    onTriggerActivate() {
      var _a;
      this.open = this._triggerController.open;
      (_a = this._triggerController.triggerElement) == null ? void 0 : _a.blur();
    }
    onChangeOpenState() {
      if (this.open) {
        this.onOpenDialog();
      } else {
        this.onCloseDialog();
      }
    }
    onSlottedButtonClick(event) {
      const button = event.target;
      if (button.hasAttribute("data-close-dialog")) {
        this.closeDialog();
      }
    }
    onOpenDialog() {
      emit(this, "atlas-dialog-open");
    }
    onCloseDialog() {
      emit(this, "atlas-dialog-close");
    }
    handleSlotChange() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this._hasContent = !isEmptySlot(this);
      });
    }
    handleActionsSlotChange() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this._hasActions = !isEmptySlot(this, "actions");
        if (!this._hasActions) return;
        const actionsSlot = this.shadowRoot.querySelector("slot[name='actions']");
        const slottedElements = actionsSlot.assignedElements({
          flatten: true
        });
        slottedElements.forEach(element => {
          element.toggleAttribute("block", this.blockActions || this.verticalActions);
        });
      });
    }
    renderHeader() {
      return when28(this.header, () => html46`
                <div class="header">
                    <atlas-heading size="h6">${this.header}</atlas-heading>
                    <atlas-icon-button icon="x" size="2x" @click=${this.closeDialog}></atlas-icon-button>
                </div>
            `);
    }
    /**
     * @internal
     */
    render() {
      const dialogClass = {
        "atlas-dialog": true,
        "has-content": this._hasContent,
        "has-actions": this._hasActions,
        "vertical-actions": this.verticalActions,
        "block-actions": this.blockActions,
        [this.size]: !!this.size
      };
      return html46`
            <div class="${classMap31(dialogClass)}">
                ${this.renderHeader()}
                <div class="content">
                    <slot @slotchange=${this.handleSlotChange}></slot>
                </div>
                <div class="footer">
                    <slot name="actions" @slotchange=${this.handleActionsSlotChange}></slot>
                </div>
            </div>
        `;
    }
  };
  AtlasDialog.styles = atlas_dialog_default;
  return AtlasDialog;
})();
__decorateClass([property46({
  type: Boolean,
  reflect: true
})], AtlasDialog.prototype, "open", 2);
__decorateClass([property46({
  type: String
})], AtlasDialog.prototype, "header", 2);
__decorateClass([property46({
  type: String
})], AtlasDialog.prototype, "size", 2);
__decorateClass([property46({
  type: Boolean,
  attribute: "vertical-actions",
  reflect: true
})], AtlasDialog.prototype, "verticalActions", 2);
__decorateClass([property46({
  type: Boolean,
  attribute: "block-actions",
  reflect: true
})], AtlasDialog.prototype, "blockActions", 2);
__decorateClass([state18()], AtlasDialog.prototype, "_hasContent", 2);
__decorateClass([state18()], AtlasDialog.prototype, "_hasActions", 2);
__decorateClass([Watch("open")], AtlasDialog.prototype, "onChangeOpenState", 1);
AtlasDialog = __decorateClass([customElement40("atlas-dialog")], AtlasDialog);

// src/components/display/atlas-display/atlas-display.ts
import { html as html47 } from "lit";
import { customElement as customElement41, property as property47 } from "lit/decorators.js";
import { classMap as classMap32 } from "lit/directives/class-map.js";
import { styleMap as styleMap12 } from "lit/directives/style-map.js";

// src/components/display/atlas-display/atlas-display.scss
import { css as css41 } from "lit-element/lit-element.js";
var atlas_display_default = css41`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.color-white {
  color: #ffffff !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.color-primary {
  color: var(--atlas-primary) !important;
}

.bg-primary {
  background-color: var(--atlas-primary) !important;
}

.color-primary-100 {
  color: var(--atlas-primary-100) !important;
}

.bg-primary-100 {
  background-color: var(--atlas-primary-100) !important;
}

.color-primary-200 {
  color: var(--atlas-primary-200) !important;
}

.bg-primary-200 {
  background-color: var(--atlas-primary-200) !important;
}

.color-primary-300 {
  color: var(--atlas-primary-300) !important;
}

.bg-primary-300 {
  background-color: var(--atlas-primary-300) !important;
}

.color-primary-400 {
  color: var(--atlas-primary-400) !important;
}

.bg-primary-400 {
  background-color: var(--atlas-primary-400) !important;
}

.color-primary-500 {
  color: var(--atlas-primary-500) !important;
}

.bg-primary-500 {
  background-color: var(--atlas-primary-500) !important;
}

.color-primary-600 {
  color: var(--atlas-primary-600) !important;
}

.bg-primary-600 {
  background-color: var(--atlas-primary-600) !important;
}

.color-primary-700 {
  color: var(--atlas-primary-700) !important;
}

.bg-primary-700 {
  background-color: var(--atlas-primary-700) !important;
}

.color-primary-800 {
  color: var(--atlas-primary-800) !important;
}

.bg-primary-800 {
  background-color: var(--atlas-primary-800) !important;
}

.color-primary-900 {
  color: var(--atlas-primary-900) !important;
}

.bg-primary-900 {
  background-color: var(--atlas-primary-900) !important;
}

.active-primary[active], .active-primary.active, .active-primary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-secondary {
  color: var(--atlas-secondary) !important;
}

.bg-secondary {
  background-color: var(--atlas-secondary) !important;
}

.color-secondary-100 {
  color: var(--atlas-secondary-100) !important;
}

.bg-secondary-100 {
  background-color: var(--atlas-secondary-100) !important;
}

.color-secondary-200 {
  color: var(--atlas-secondary-200) !important;
}

.bg-secondary-200 {
  background-color: var(--atlas-secondary-200) !important;
}

.color-secondary-300 {
  color: var(--atlas-secondary-300) !important;
}

.bg-secondary-300 {
  background-color: var(--atlas-secondary-300) !important;
}

.color-secondary-400 {
  color: var(--atlas-secondary-400) !important;
}

.bg-secondary-400 {
  background-color: var(--atlas-secondary-400) !important;
}

.color-secondary-500 {
  color: var(--atlas-secondary-500) !important;
}

.bg-secondary-500 {
  background-color: var(--atlas-secondary-500) !important;
}

.color-secondary-600 {
  color: var(--atlas-secondary-600) !important;
}

.bg-secondary-600 {
  background-color: var(--atlas-secondary-600) !important;
}

.color-secondary-700 {
  color: var(--atlas-secondary-700) !important;
}

.bg-secondary-700 {
  background-color: var(--atlas-secondary-700) !important;
}

.color-secondary-800 {
  color: var(--atlas-secondary-800) !important;
}

.bg-secondary-800 {
  background-color: var(--atlas-secondary-800) !important;
}

.color-secondary-900 {
  color: var(--atlas-secondary-900) !important;
}

.bg-secondary-900 {
  background-color: var(--atlas-secondary-900) !important;
}

.active-secondary[active], .active-secondary.active, .active-secondary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-success {
  color: var(--atlas-success) !important;
}

.bg-success {
  background-color: var(--atlas-success) !important;
}

.color-success-100 {
  color: var(--atlas-success-100) !important;
}

.bg-success-100 {
  background-color: var(--atlas-success-100) !important;
}

.color-success-200 {
  color: var(--atlas-success-200) !important;
}

.bg-success-200 {
  background-color: var(--atlas-success-200) !important;
}

.color-success-300 {
  color: var(--atlas-success-300) !important;
}

.bg-success-300 {
  background-color: var(--atlas-success-300) !important;
}

.color-success-400 {
  color: var(--atlas-success-400) !important;
}

.bg-success-400 {
  background-color: var(--atlas-success-400) !important;
}

.color-success-500 {
  color: var(--atlas-success-500) !important;
}

.bg-success-500 {
  background-color: var(--atlas-success-500) !important;
}

.color-success-600 {
  color: var(--atlas-success-600) !important;
}

.bg-success-600 {
  background-color: var(--atlas-success-600) !important;
}

.color-success-700 {
  color: var(--atlas-success-700) !important;
}

.bg-success-700 {
  background-color: var(--atlas-success-700) !important;
}

.color-success-800 {
  color: var(--atlas-success-800) !important;
}

.bg-success-800 {
  background-color: var(--atlas-success-800) !important;
}

.color-success-900 {
  color: var(--atlas-success-900) !important;
}

.bg-success-900 {
  background-color: var(--atlas-success-900) !important;
}

.active-success[active], .active-success.active, .active-success:active {
  background-color: var(--atlas-success) !important;
  color: var(--atlas-contrast-success) !important;
}

.color-warning {
  color: var(--atlas-warning) !important;
}

.bg-warning {
  background-color: var(--atlas-warning) !important;
}

.color-warning-100 {
  color: var(--atlas-warning-100) !important;
}

.bg-warning-100 {
  background-color: var(--atlas-warning-100) !important;
}

.color-warning-200 {
  color: var(--atlas-warning-200) !important;
}

.bg-warning-200 {
  background-color: var(--atlas-warning-200) !important;
}

.color-warning-300 {
  color: var(--atlas-warning-300) !important;
}

.bg-warning-300 {
  background-color: var(--atlas-warning-300) !important;
}

.color-warning-400 {
  color: var(--atlas-warning-400) !important;
}

.bg-warning-400 {
  background-color: var(--atlas-warning-400) !important;
}

.color-warning-500 {
  color: var(--atlas-warning-500) !important;
}

.bg-warning-500 {
  background-color: var(--atlas-warning-500) !important;
}

.color-warning-600 {
  color: var(--atlas-warning-600) !important;
}

.bg-warning-600 {
  background-color: var(--atlas-warning-600) !important;
}

.color-warning-700 {
  color: var(--atlas-warning-700) !important;
}

.bg-warning-700 {
  background-color: var(--atlas-warning-700) !important;
}

.color-warning-800 {
  color: var(--atlas-warning-800) !important;
}

.bg-warning-800 {
  background-color: var(--atlas-warning-800) !important;
}

.color-warning-900 {
  color: var(--atlas-warning-900) !important;
}

.bg-warning-900 {
  background-color: var(--atlas-warning-900) !important;
}

.active-warning[active], .active-warning.active, .active-warning:active {
  background-color: var(--atlas-warning) !important;
  color: var(--atlas-contrast-warning) !important;
}

.color-danger {
  color: var(--atlas-danger) !important;
}

.bg-danger {
  background-color: var(--atlas-danger) !important;
}

.color-danger-100 {
  color: var(--atlas-danger-100) !important;
}

.bg-danger-100 {
  background-color: var(--atlas-danger-100) !important;
}

.color-danger-200 {
  color: var(--atlas-danger-200) !important;
}

.bg-danger-200 {
  background-color: var(--atlas-danger-200) !important;
}

.color-danger-300 {
  color: var(--atlas-danger-300) !important;
}

.bg-danger-300 {
  background-color: var(--atlas-danger-300) !important;
}

.color-danger-400 {
  color: var(--atlas-danger-400) !important;
}

.bg-danger-400 {
  background-color: var(--atlas-danger-400) !important;
}

.color-danger-500 {
  color: var(--atlas-danger-500) !important;
}

.bg-danger-500 {
  background-color: var(--atlas-danger-500) !important;
}

.color-danger-600 {
  color: var(--atlas-danger-600) !important;
}

.bg-danger-600 {
  background-color: var(--atlas-danger-600) !important;
}

.color-danger-700 {
  color: var(--atlas-danger-700) !important;
}

.bg-danger-700 {
  background-color: var(--atlas-danger-700) !important;
}

.color-danger-800 {
  color: var(--atlas-danger-800) !important;
}

.bg-danger-800 {
  background-color: var(--atlas-danger-800) !important;
}

.color-danger-900 {
  color: var(--atlas-danger-900) !important;
}

.bg-danger-900 {
  background-color: var(--atlas-danger-900) !important;
}

.active-danger[active], .active-danger.active, .active-danger:active {
  background-color: var(--atlas-danger) !important;
  color: var(--atlas-contrast-danger) !important;
}

.color-highlight {
  color: var(--atlas-highlight) !important;
}

.bg-highlight {
  background-color: var(--atlas-highlight) !important;
}

.color-highlight-100 {
  color: var(--atlas-highlight-100) !important;
}

.bg-highlight-100 {
  background-color: var(--atlas-highlight-100) !important;
}

.color-highlight-200 {
  color: var(--atlas-highlight-200) !important;
}

.bg-highlight-200 {
  background-color: var(--atlas-highlight-200) !important;
}

.color-highlight-300 {
  color: var(--atlas-highlight-300) !important;
}

.bg-highlight-300 {
  background-color: var(--atlas-highlight-300) !important;
}

.color-highlight-400 {
  color: var(--atlas-highlight-400) !important;
}

.bg-highlight-400 {
  background-color: var(--atlas-highlight-400) !important;
}

.color-highlight-500 {
  color: var(--atlas-highlight-500) !important;
}

.bg-highlight-500 {
  background-color: var(--atlas-highlight-500) !important;
}

.color-highlight-600 {
  color: var(--atlas-highlight-600) !important;
}

.bg-highlight-600 {
  background-color: var(--atlas-highlight-600) !important;
}

.color-highlight-700 {
  color: var(--atlas-highlight-700) !important;
}

.bg-highlight-700 {
  background-color: var(--atlas-highlight-700) !important;
}

.color-highlight-800 {
  color: var(--atlas-highlight-800) !important;
}

.bg-highlight-800 {
  background-color: var(--atlas-highlight-800) !important;
}

.color-highlight-900 {
  color: var(--atlas-highlight-900) !important;
}

.bg-highlight-900 {
  background-color: var(--atlas-highlight-900) !important;
}

.active-highlight[active], .active-highlight.active, .active-highlight:active {
  background-color: var(--atlas-highlight) !important;
  color: var(--atlas-contrast-highlight) !important;
}

.color-info {
  color: var(--atlas-info) !important;
}

.bg-info {
  background-color: var(--atlas-info) !important;
}

.color-info-100 {
  color: var(--atlas-info-100) !important;
}

.bg-info-100 {
  background-color: var(--atlas-info-100) !important;
}

.color-info-200 {
  color: var(--atlas-info-200) !important;
}

.bg-info-200 {
  background-color: var(--atlas-info-200) !important;
}

.color-info-300 {
  color: var(--atlas-info-300) !important;
}

.bg-info-300 {
  background-color: var(--atlas-info-300) !important;
}

.color-info-400 {
  color: var(--atlas-info-400) !important;
}

.bg-info-400 {
  background-color: var(--atlas-info-400) !important;
}

.color-info-500 {
  color: var(--atlas-info-500) !important;
}

.bg-info-500 {
  background-color: var(--atlas-info-500) !important;
}

.color-info-600 {
  color: var(--atlas-info-600) !important;
}

.bg-info-600 {
  background-color: var(--atlas-info-600) !important;
}

.color-info-700 {
  color: var(--atlas-info-700) !important;
}

.bg-info-700 {
  background-color: var(--atlas-info-700) !important;
}

.color-info-800 {
  color: var(--atlas-info-800) !important;
}

.bg-info-800 {
  background-color: var(--atlas-info-800) !important;
}

.color-info-900 {
  color: var(--atlas-info-900) !important;
}

.bg-info-900 {
  background-color: var(--atlas-info-900) !important;
}

.active-info[active], .active-info.active, .active-info:active {
  background-color: var(--atlas-info) !important;
  color: var(--atlas-contrast-info) !important;
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
:host([alignment=left]),
.text-align-left {
  text-align: left;
}

:host([alignment=center]),
.text-align-center {
  text-align: center;
}

:host([alignment=right]),
.text-align-right {
  text-align: right;
}

:host([alignment=justify]),
.text-align-justify {
  text-align: justify;
}

.text-muted {
  color: #687078 !important;
}

.text-white {
  color: #ffffff !important;
}

:host([ellipsis]) {
  width: 100%;
  overflow: hidden;
}

.ellipsis {
  display: block !important;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.line-clamp {
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

:host {
  display: block;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}

.atlas-display {
  font-weight: 300;
  line-height: 1.2;
  color: #212529;
}

.display1 {
  font-size: 6rem;
}
.display1.skeleton {
  height: 7.2rem;
}

.display2 {
  font-size: 5.5rem;
}
.display2.skeleton {
  height: 6.6rem;
}

.display3 {
  font-size: 4.5rem;
}
.display3.skeleton {
  height: 5.4rem;
}

.display4 {
  font-size: 3.5rem;
}
.display4.skeleton {
  height: 4.2rem;
}`;

// src/components/display/atlas-display/atlas-display.ts
var AtlasDisplay = /*#__PURE__*/(() => {
  let AtlasDisplay = class extends TextElement {
    constructor() {
      super(...arguments);
      this.size = "display4";
    }
    /** @internal */
    renderSkeleton() {
      const skeletonClass = {
        "atlas-display": true,
        "skeleton": true,
        [`${this.size}`]: true
      };
      return html47`<div class="${classMap32(skeletonClass)}"></div>`;
    }
    /** @internal */
    renderElement() {
      const displayClass = __spreadValues({
        "atlas-display": true,
        [this.size]: !!this.size
      }, this.getTextClasses());
      return html47`
            <div
                class=${classMap32(displayClass)}
                style=${styleMap12(this.getTextStyles())}
                data-atlas-tooltip="text-tooltip"
            >
                ${this.renderContentSlot()}
            </div>
            ${this.renderEllipsisTooltip()}
        `;
    }
  };
  AtlasDisplay.styles = atlas_display_default;
  return AtlasDisplay;
})();
__decorateClass([property47({
  type: String
})], AtlasDisplay.prototype, "size", 2);
AtlasDisplay = __decorateClass([customElement41("atlas-display")], AtlasDisplay);

// src/components/display/atlas-dropdown-button/atlas-dropdown-button.ts
import { html as html48 } from "lit";
import { customElement as customElement42, property as property48 } from "lit/decorators.js";
import { classMap as classMap33 } from "lit/directives/class-map.js";
import { when as when29 } from "lit/directives/when.js";

// src/components/display/atlas-dropdown-button/atlas-dropdown-button.scss
import { css as css42 } from "lit-element/lit-element.js";
var atlas_dropdown_button_default = css42`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
.btn {
  --atlas-btn-padding-x: 1rem;
  --atlas-btn-padding-y: 0.5rem;
  --atlas-btn-font-size: 1rem;
  --atlas-btn-color: #000000;
  --atlas-btn-bg: transparent;
  --atlas-btn-border-color: transparent;
  --atlas-btn-border-radius: 0.25rem;
  --atlas-btn-hover-border-color: transparent;
  --atlas-btn-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-rgb), 40%);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-300-rgb), 0.25);
  --atlas-btn-min-height: 2.625rem;
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  box-sizing: border-box;
  padding: var(--atlas-btn-padding-y) var(--atlas-btn-padding-x);
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: var(--atlas-btn-font-size);
  font-weight: 400;
  line-height: 1.5;
  color: var(--atlas-btn-color);
  min-height: var(--atlas-btn-min-height);
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border: 1px solid var(--atlas-btn-border-color);
  border-radius: var(--atlas-btn-border-radius);
  background: var(--atlas-btn-bg);
  box-shadow: var(--atlas-btn-box-shadow);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.btn:hover {
  color: var(--atlas-btn-hover-color);
  background-color: var(--atlas-btn-hover-bg);
  border-color: var(--atlas-btn-hover-border-color);
}
.btn:focus-visible {
  color: var(--atlas-btn-color);
  background: var(--atlas-btn-bg);
  border-color: var(--atlas-btn-border-color);
  box-shadow: var(--atlas-btn-focus-box-shadow);
  outline: 0;
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--atlas-btn-disabled-color);
  pointer-events: none;
  background-color: var(--atlas-btn-disabled-bg);
  background-image: none;
  border-color: var(--atlas-btn-disabled-border-color);
  opacity: 0.35;
  box-shadow: none;
}
.btn-check + .btn:hover {
  color: var(--atlas-btn-check-hover-color);
  background-color: var(--atlas-btn-check-hover-bg);
  border-color: var(--atlas-btn-check-hover-border-color);
}
.btn-check:focus-visible + .btn {
  border-color: var(--atlas-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--atlas-btn-focus-box-shadow);
}
.btn-check:checked + .btn {
  color: var(--atlas-btn-checked-color);
  background-color: var(--atlas-btn-checked-bg);
  border-color: var(--atlas-btn-checked-border-color);
}
:not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--atlas-btn-active-color);
  background-color: var(--atlas-btn-active-bg);
  background-image: none;
  border-color: var(--atlas-btn-active-border-color);
  box-shadow: var(--atlas-btn-active-shadow);
}
:not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--atlas-btn-focus-box-shadow);
}
.btn-check:checked + .btn:hover {
  color: var(--atlas-btn-hover-color);
  background-color: var(--atlas-btn-hover-bg);
  border-color: var(--atlas-btn-hover-border-color);
}
.btn atlas-icon {
  font-size: 1.25rem;
}

.btn-sm {
  --atlas-btn-padding-y: 0.25rem;
  --atlas-btn-padding-x: 0.5rem;
  --atlas-btn-font-size: 0.875rem;
  --atlas-btn-border-radius: 0.25rem;
  --atlas-btn-min-height: 1.9375rem;
}
.btn-sm atlas-icon {
  font-size: 1rem;
}

.btn-lg {
  --atlas-btn-padding-y: 0.5rem;
  --atlas-btn-padding-x: 1rem;
  --atlas-btn-font-size: 1.25rem;
  --atlas-btn-border-radius: 0.25rem;
  --atlas-btn-min-height: 3rem;
}
.btn-lg atlas-icon {
  font-size: 1.5rem;
}

.skeleton.btn-sm {
  height: 1.9375rem;
  width: 100px;
}
.skeleton.btn-md {
  height: 2.625rem;
  width: 120px;
}
.skeleton.btn-lg {
  height: 3rem;
  width: 140px;
}

.btn-block {
  width: 100% !important;
}

.rounded-pill {
  border-radius: 9999px;
}

slot[name=hotspot]::slotted(atlas-hotspot) {
  position: absolute;
  top: -20px;
  right: -20px;
}

.btn-primary {
  --atlas-btn-bg: var(--atlas-primary);
  --atlas-btn-color: var(--atlas-contrast-primary);
  --atlas-btn-border-color: var(--atlas-primary);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-primary-600);
  --atlas-btn-hover-border-color: var(--atlas-primary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-primary-700);
  --atlas-btn-active-border-color: var(--atlas-primary-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-primary);
  --atlas-btn-disabled-border-color: var(--atlas-primary);
  --atlas-btn-disabled-bg: var(--atlas-primary);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-primary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-primary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-primary-500);
  --atlas-btn-checked-border-color: var(--atlas-primary-500);
}

.btn-outline-primary {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-primary);
  --atlas-btn-border-color: var(--atlas-primary);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-primary-600);
  --atlas-btn-hover-border-color: var(--atlas-primary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-primary-700);
  --atlas-btn-active-border-color: var(--atlas-primary-700);
  --atlas-btn-disabled-color: var(--atlas-primary);
  --atlas-btn-disabled-bg: var(--atlas-primary-100);
  --atlas-btn-disabled-border-color: var(--atlas-primary);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-primary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-primary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-primary-500);
  --atlas-btn-checked-border-color: var(--atlas-primary-500);
}

.btn-ghost-primary {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-primary);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-primary-600);
  --atlas-btn-hover-border-color: var(--atlas-primary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-primary-700);
  --atlas-btn-active-border-color: var(--atlas-primary-700);
  --atlas-btn-disabled-color: var(--atlas-primary);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-primary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-primary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-primary-500);
  --atlas-btn-checked-border-color: var(--atlas-primary-500);
}

.btn-primary-white {
  --atlas-btn-bg: #f8f9fa;
  --atlas-btn-color: var(--atlas-primary);
  --atlas-btn-border-color: #f8f9fa;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-primary);
  --atlas-btn-hover-bg: rgb(198.4, 199.2, 200);
  --atlas-btn-hover-border-color: rgb(198.4, 199.2, 200);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(#f8f9fa, 0.25);
  --atlas-btn-active-color: var(--atlas-primary);
  --atlas-btn-active-bg: rgb(148.8, 149.4, 150);
  --atlas-btn-active-border-color: rgb(148.8, 149.4, 150);
  --atlas-btn-disabled-color: var(--atlas-primary);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-disabled-bg: #f8f9fa;
  --atlas-btn-check-hover-color: none;
  --atlas-btn-check-hover-bg: none;
  --atlas-btn-check-hover-border-color: none;
  --atlas-btn-checked-color: none;
  --atlas-btn-checked-bg: none;
  --atlas-btn-checked-border-color: none;
}

.btn-outline-primary-white {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: #f8f9fa;
  --atlas-btn-border-color: #f8f9fa;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-primary);
  --atlas-btn-hover-bg: rgb(198.4, 199.2, 200);
  --atlas-btn-hover-border-color: rgb(198.4, 199.2, 200);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(#f8f9fa, 0.25);
  --atlas-btn-active-color: var(--atlas-primary);
  --atlas-btn-active-bg: rgb(148.8, 149.4, 150);
  --atlas-btn-active-border-color: rgb(148.8, 149.4, 150);
  --atlas-btn-disabled-color: var(--atlas-primary);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-disabled-bg: #f8f9fa;
  --atlas-btn-check-hover-color: none;
  --atlas-btn-check-hover-bg: none;
  --atlas-btn-check-hover-border-color: none;
  --atlas-btn-checked-color: none;
  --atlas-btn-checked-bg: none;
  --atlas-btn-checked-border-color: none;
}

.btn-secondary {
  --atlas-btn-bg: var(--atlas-secondary);
  --atlas-btn-color: var(--atlas-contrast-secondary);
  --atlas-btn-border-color: var(--atlas-secondary);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-secondary);
  --atlas-btn-hover-bg: var(--atlas-secondary-600);
  --atlas-btn-hover-border-color: var(--atlas-secondary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-secondary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-secondary);
  --atlas-btn-active-bg: var(--atlas-secondary-700);
  --atlas-btn-active-border-color: var(--atlas-secondary-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-secondary);
  --atlas-btn-disabled-border-color: var(--atlas-secondary);
  --atlas-btn-disabled-bg: var(--atlas-secondary);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-secondary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-secondary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-secondary-500);
  --atlas-btn-checked-border-color: var(--atlas-secondary-500);
}

.btn-outline-secondary {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-secondary);
  --atlas-btn-border-color: var(--atlas-secondary);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-secondary-600);
  --atlas-btn-hover-border-color: var(--atlas-secondary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-secondary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-secondary-700);
  --atlas-btn-active-border-color: var(--atlas-secondary-700);
  --atlas-btn-disabled-color: var(--atlas-secondary);
  --atlas-btn-disabled-bg: var(--atlas-secondary-100);
  --atlas-btn-disabled-border-color: var(--atlas-secondary);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-secondary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-secondary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-secondary-500);
  --atlas-btn-checked-border-color: var(--atlas-secondary-500);
}

.btn-ghost-secondary {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-secondary);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-secondary-600);
  --atlas-btn-hover-border-color: var(--atlas-secondary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-secondary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-secondary-700);
  --atlas-btn-active-border-color: var(--atlas-secondary-700);
  --atlas-btn-disabled-color: var(--atlas-secondary);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-secondary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-secondary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-secondary-500);
  --atlas-btn-checked-border-color: var(--atlas-secondary-500);
}

.btn-success {
  --atlas-btn-bg: var(--atlas-success);
  --atlas-btn-color: var(--atlas-contrast-success);
  --atlas-btn-border-color: var(--atlas-success);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-success);
  --atlas-btn-hover-bg: var(--atlas-success-600);
  --atlas-btn-hover-border-color: var(--atlas-success-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-success);
  --atlas-btn-active-bg: var(--atlas-success-700);
  --atlas-btn-active-border-color: var(--atlas-success-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-success);
  --atlas-btn-disabled-border-color: var(--atlas-success);
  --atlas-btn-disabled-bg: var(--atlas-success);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-success-400);
  --atlas-btn-check-hover-border-color: var(--atlas-success-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-success-500);
  --atlas-btn-checked-border-color: var(--atlas-success-500);
}

.btn-outline-success {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-success);
  --atlas-btn-border-color: var(--atlas-success);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-success-600);
  --atlas-btn-hover-border-color: var(--atlas-success-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-success-700);
  --atlas-btn-active-border-color: var(--atlas-success-700);
  --atlas-btn-disabled-color: var(--atlas-success);
  --atlas-btn-disabled-bg: var(--atlas-success-100);
  --atlas-btn-disabled-border-color: var(--atlas-success);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-success-400);
  --atlas-btn-check-hover-border-color: var(--atlas-success-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-success-500);
  --atlas-btn-checked-border-color: var(--atlas-success-500);
}

.btn-ghost-success {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-success);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-success-600);
  --atlas-btn-hover-border-color: var(--atlas-success-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-success-700);
  --atlas-btn-active-border-color: var(--atlas-success-700);
  --atlas-btn-disabled-color: var(--atlas-success);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-success-400);
  --atlas-btn-check-hover-border-color: var(--atlas-success-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-success-500);
  --atlas-btn-checked-border-color: var(--atlas-success-500);
}

.btn-warning {
  --atlas-btn-bg: var(--atlas-warning);
  --atlas-btn-color: var(--atlas-contrast-warning);
  --atlas-btn-border-color: var(--atlas-warning);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-warning);
  --atlas-btn-hover-bg: var(--atlas-warning-600);
  --atlas-btn-hover-border-color: var(--atlas-warning-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-warning);
  --atlas-btn-active-bg: var(--atlas-warning-700);
  --atlas-btn-active-border-color: var(--atlas-warning-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-warning);
  --atlas-btn-disabled-border-color: var(--atlas-warning);
  --atlas-btn-disabled-bg: var(--atlas-warning);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-warning-400);
  --atlas-btn-check-hover-border-color: var(--atlas-warning-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-warning-500);
  --atlas-btn-checked-border-color: var(--atlas-warning-500);
}

.btn-outline-warning {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-warning);
  --atlas-btn-border-color: var(--atlas-warning);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-warning-600);
  --atlas-btn-hover-border-color: var(--atlas-warning-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-warning-700);
  --atlas-btn-active-border-color: var(--atlas-warning-700);
  --atlas-btn-disabled-color: var(--atlas-warning);
  --atlas-btn-disabled-bg: var(--atlas-warning-100);
  --atlas-btn-disabled-border-color: var(--atlas-warning);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-warning-400);
  --atlas-btn-check-hover-border-color: var(--atlas-warning-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-warning-500);
  --atlas-btn-checked-border-color: var(--atlas-warning-500);
}

.btn-ghost-warning {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-warning);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-warning-600);
  --atlas-btn-hover-border-color: var(--atlas-warning-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-warning-700);
  --atlas-btn-active-border-color: var(--atlas-warning-700);
  --atlas-btn-disabled-color: var(--atlas-warning);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-warning-400);
  --atlas-btn-check-hover-border-color: var(--atlas-warning-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-warning-500);
  --atlas-btn-checked-border-color: var(--atlas-warning-500);
}

.btn-danger {
  --atlas-btn-bg: var(--atlas-danger);
  --atlas-btn-color: var(--atlas-contrast-danger);
  --atlas-btn-border-color: var(--atlas-danger);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-danger);
  --atlas-btn-hover-bg: var(--atlas-danger-600);
  --atlas-btn-hover-border-color: var(--atlas-danger-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-danger);
  --atlas-btn-active-bg: var(--atlas-danger-700);
  --atlas-btn-active-border-color: var(--atlas-danger-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-danger);
  --atlas-btn-disabled-border-color: var(--atlas-danger);
  --atlas-btn-disabled-bg: var(--atlas-danger);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-danger-400);
  --atlas-btn-check-hover-border-color: var(--atlas-danger-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-danger-500);
  --atlas-btn-checked-border-color: var(--atlas-danger-500);
}

.btn-outline-danger {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-danger);
  --atlas-btn-border-color: var(--atlas-danger);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-danger-600);
  --atlas-btn-hover-border-color: var(--atlas-danger-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-danger-700);
  --atlas-btn-active-border-color: var(--atlas-danger-700);
  --atlas-btn-disabled-color: var(--atlas-danger);
  --atlas-btn-disabled-bg: var(--atlas-danger-100);
  --atlas-btn-disabled-border-color: var(--atlas-danger);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-danger-400);
  --atlas-btn-check-hover-border-color: var(--atlas-danger-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-danger-500);
  --atlas-btn-checked-border-color: var(--atlas-danger-500);
}

.btn-ghost-danger {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-danger);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-danger-600);
  --atlas-btn-hover-border-color: var(--atlas-danger-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-danger-700);
  --atlas-btn-active-border-color: var(--atlas-danger-700);
  --atlas-btn-disabled-color: var(--atlas-danger);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-danger-400);
  --atlas-btn-check-hover-border-color: var(--atlas-danger-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-danger-500);
  --atlas-btn-checked-border-color: var(--atlas-danger-500);
}

.btn-highlight {
  --atlas-btn-bg: var(--atlas-highlight);
  --atlas-btn-color: var(--atlas-contrast-highlight);
  --atlas-btn-border-color: var(--atlas-highlight);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-highlight);
  --atlas-btn-hover-bg: var(--atlas-highlight-600);
  --atlas-btn-hover-border-color: var(--atlas-highlight-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-highlight-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-highlight);
  --atlas-btn-active-bg: var(--atlas-highlight-700);
  --atlas-btn-active-border-color: var(--atlas-highlight-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-highlight);
  --atlas-btn-disabled-border-color: var(--atlas-highlight);
  --atlas-btn-disabled-bg: var(--atlas-highlight);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-highlight-400);
  --atlas-btn-check-hover-border-color: var(--atlas-highlight-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-highlight-500);
  --atlas-btn-checked-border-color: var(--atlas-highlight-500);
}

.btn-outline-highlight {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-highlight);
  --atlas-btn-border-color: var(--atlas-highlight);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-highlight-600);
  --atlas-btn-hover-border-color: var(--atlas-highlight-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-highlight-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-highlight-700);
  --atlas-btn-active-border-color: var(--atlas-highlight-700);
  --atlas-btn-disabled-color: var(--atlas-highlight);
  --atlas-btn-disabled-bg: var(--atlas-highlight-100);
  --atlas-btn-disabled-border-color: var(--atlas-highlight);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-highlight-400);
  --atlas-btn-check-hover-border-color: var(--atlas-highlight-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-highlight-500);
  --atlas-btn-checked-border-color: var(--atlas-highlight-500);
}

.btn-ghost-highlight {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-highlight);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-highlight-600);
  --atlas-btn-hover-border-color: var(--atlas-highlight-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-highlight-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-highlight-700);
  --atlas-btn-active-border-color: var(--atlas-highlight-700);
  --atlas-btn-disabled-color: var(--atlas-highlight);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-highlight-400);
  --atlas-btn-check-hover-border-color: var(--atlas-highlight-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-highlight-500);
  --atlas-btn-checked-border-color: var(--atlas-highlight-500);
}

.btn-info {
  --atlas-btn-bg: var(--atlas-info);
  --atlas-btn-color: var(--atlas-contrast-info);
  --atlas-btn-border-color: var(--atlas-info);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-info);
  --atlas-btn-hover-bg: var(--atlas-info-600);
  --atlas-btn-hover-border-color: var(--atlas-info-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-info-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-info);
  --atlas-btn-active-bg: var(--atlas-info-700);
  --atlas-btn-active-border-color: var(--atlas-info-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-info);
  --atlas-btn-disabled-border-color: var(--atlas-info);
  --atlas-btn-disabled-bg: var(--atlas-info);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-info-400);
  --atlas-btn-check-hover-border-color: var(--atlas-info-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-info-500);
  --atlas-btn-checked-border-color: var(--atlas-info-500);
}

.btn-outline-info {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-info);
  --atlas-btn-border-color: var(--atlas-info);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-info-600);
  --atlas-btn-hover-border-color: var(--atlas-info-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-info-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-info-700);
  --atlas-btn-active-border-color: var(--atlas-info-700);
  --atlas-btn-disabled-color: var(--atlas-info);
  --atlas-btn-disabled-bg: var(--atlas-info-100);
  --atlas-btn-disabled-border-color: var(--atlas-info);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-info-400);
  --atlas-btn-check-hover-border-color: var(--atlas-info-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-info-500);
  --atlas-btn-checked-border-color: var(--atlas-info-500);
}

.btn-ghost-info {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-info);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-info-600);
  --atlas-btn-hover-border-color: var(--atlas-info-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-info-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-info-700);
  --atlas-btn-active-border-color: var(--atlas-info-700);
  --atlas-btn-disabled-color: var(--atlas-info);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-info-400);
  --atlas-btn-check-hover-border-color: var(--atlas-info-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-info-500);
  --atlas-btn-checked-border-color: var(--atlas-info-500);
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* stylelint-disable no-descending-specificity */
.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-group {
  border-radius: 0.25rem;
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1;
}
.btn-group > .btn:not(:last-child, .dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check, slot) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group.show .dropdown-toggle {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}
.btn-group.show .dropdown-toggle.btn-link {
  box-shadow: none;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1;
}
.btn-group-vertical > .btn:not(:last-child, .dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

/* stylelint-enable no-descending-specificity */
:host {
  display: block;
}

.dropdown-toggle atlas-icon[name=chevron-down] {
  transition: transform 0.35s ease;
}
.dropdown-toggle[active] atlas-icon[name=chevron-down] {
  transform: rotate(-180deg);
}
.dropdown-toggle::after {
  display: none;
}

.btn-group.rounded-pill .btn:first-of-type {
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.btn-group.rounded-pill .dropdown-toggle {
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}

.main-button.loading {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}`;

// src/components/display/atlas-dropdown-button/atlas-dropdown-button.ts
var AtlasDropdownButton = /*#__PURE__*/(() => {
  let AtlasDropdownButton = class extends AtlasButtonBase {
    constructor() {
      super();
      this.syncDropdownRef();
    }
    /**
     * Retorna a referência do dropdown
     * @returns {AtlasDropdown} - Referência do dropdown
     */
    getDropdownRef() {
      return this._dropdownRef;
    }
    onChangeSplit() {
      this.updateComplete.then(() => {
        var _a;
        (_a = this._dropdownRef) == null ? void 0 : _a.syncTriggerElement();
      });
    }
    syncDropdownRef() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this._dropdownRef = this.shadowRoot.querySelector("atlas-dropdown");
      });
    }
    handleButtonClick() {
      if (this.split) {
        super.handleButtonClick();
      }
    }
    handleSplitButtonClick() {
      emit(this, "atlas-split-button-click");
    }
    renderSplitMode() {
      const mainButtonClass = __spreadProps(__spreadValues({}, this.getButtonClasses()), {
        "main-button": true,
        "loading": this.loading
      });
      const splitButtonClass = __spreadProps(__spreadValues({}, this.getButtonClasses()), {
        "btn-block": false,
        "dropdown-toggle": true,
        "dropdown-toggle-split": true
      });
      return html48`
            <button class=${classMap33(mainButtonClass)} ?disabled=${this.isDisabled()} @click=${this.handleButtonClick}>
                ${this.getButtonIcon(this.getCurrentIcon())} ${this.getButtonText()}
            </button>
            <button
                class=${classMap33(splitButtonClass)}
                ?disabled=${this.isDisabled()}
                @click=${this.handleSplitButtonClick}
                data-atlas-dropdown="btn-dropdown"
            >
                ${this.getButtonIcon("chevron-down")}
            </button>
        `;
    }
    renderDropdownMode() {
      const mainButtonClass = __spreadValues({
        "dropdown-toggle": true
      }, this.getButtonClasses());
      return html48`
            <button
                class=${classMap33(mainButtonClass)}
                ?disabled=${this.isDisabled()}
                @click=${this.handleButtonClick}
                data-atlas-dropdown="btn-dropdown"
            >
                ${this.getButtonIcon(this.getCurrentIcon())} ${this.getButtonText()}
                ${when29(!this.hideArrow, () => this.getButtonIcon("chevron-down"))}
            </button>
        `;
    }
    renderElement() {
      const containerClass = {
        "btn-group": true,
        "btn-block": this.block,
        "rounded-pill": this.pill
      };
      const button = when29(this.split, () => this.renderSplitMode(), () => this.renderDropdownMode());
      return html48`
            <div
                tabindex=${this.isDisabled() ? "0" : "-1"}
                class="${classMap33(containerClass)}"
                data-atlas-tooltip="dropdown-button-tooltip"
            >
                ${this.renderHotspotSlot()} ${button}
                <atlas-dropdown
                    id="btn-dropdown"
                    no-gap
                    auto-close
                    auto-close-trigger="${this.filter ? "outside" : "any"}"
                    max-width=${this.filter ? "unset" : ""}
                    ?overflow=${this.filter}
                    placement=${this.dropdownPlacement}
                >
                    <slot></slot>
                </atlas-dropdown>
            </div>
            ${this.renderTooltip("dropdown-button-tooltip")}
        `;
    }
  };
  AtlasDropdownButton.styles = atlas_dropdown_button_default;
  return AtlasDropdownButton;
})();
__decorateClass([property48({
  type: Boolean
})], AtlasDropdownButton.prototype, "filter", 2);
__decorateClass([property48({
  type: Boolean
})], AtlasDropdownButton.prototype, "split", 2);
__decorateClass([property48({
  type: Boolean,
  attribute: "hide-arrow"
})], AtlasDropdownButton.prototype, "hideArrow", 2);
__decorateClass([property48({
  type: String,
  attribute: "dropdown-placement"
})], AtlasDropdownButton.prototype, "dropdownPlacement", 2);
__decorateClass([Watch("split")], AtlasDropdownButton.prototype, "onChangeSplit", 1);
AtlasDropdownButton = __decorateClass([customElement42("atlas-dropdown-button")], AtlasDropdownButton);

// src/components/display/atlas-empty-state/atlas-empty-state.ts
import { html as html49 } from "lit";
import { customElement as customElement43, property as property49 } from "lit/decorators.js";
import { classMap as classMap34 } from "lit/directives/class-map.js";
import { when as when30 } from "lit/directives/when.js";

// src/components/display/atlas-empty-state/atlas-empty-state.scss
import { css as css43 } from "lit-element/lit-element.js";
var atlas_empty_state_default = css43`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

*[hidden] {
  display: none !important;
}

:host {
  display: contents;
}

:host([skeleton-loading]) .empty-state.small {
  gap: 0.5rem;
}

.empty-state {
  height: 100%;
  max-width: 720px;
  margin: 1.5rem auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  /* stylelint-disable-next-line no-descending-specificity */
  /* stylelint-enable-next-line no-descending-specificity */
}
.empty-state atlas-illustration {
  margin-bottom: 1.5rem;
  display: block;
}
.empty-state atlas-icon,
.empty-state atlas-heading {
  margin-bottom: 1rem;
}
.empty-state slot[name=button] {
  display: flex;
  gap: 0.5rem;
  width: 100%;
  justify-content: center;
}
.empty-state ::slotted(atlas-button) {
  margin-top: 1.5rem !important;
}
.empty-state.small {
  margin: 0 auto;
}
.empty-state.small atlas-icon,
.empty-state.small atlas-heading {
  margin-bottom: 0.5rem;
}
.empty-state.small ::slotted(atlas-button) {
  margin-top: 1rem !important;
}`;

// src/components/display/atlas-empty-state/atlas-empty-state.ts
var AtlasEmptyState = /*#__PURE__*/(() => {
  let AtlasEmptyState = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this._deviceController = new DeviceController(this);
    }
    renderIllustrationOrIcon() {
      return when30(!!this.illustration, () => html49`
                <atlas-illustration
                    name=${this.illustration}
                    alt=${this.illustrationAlt}
                    size=${this._deviceController.isMobile ? "sm" : "md"}
                ></atlas-illustration>
            `, () => html49`<atlas-icon name=${this.icon} theme="primary" size=${this.small ? "5x" : "6x"}></atlas-icon>`);
    }
    renderMessage() {
      return when30(!!this.description, () => html49`<atlas-text size=${this.small ? "xs" : "md"} muted>${this.description}</atlas-text>`, () => html49`<atlas-text size=${this.small ? "xs" : "md"} muted><slot></slot></atlas-text>`);
    }
    render() {
      const emptyStateClass = {
        "empty-state": true,
        "small": this.small
      };
      return html49`
            <div class=${classMap34(emptyStateClass)}>
                ${this.renderIllustrationOrIcon()}
                <atlas-heading size=${this.small ? "h6" : "h5"} alignment="center" muted ?hidden=${!this.header}>
                    ${this.header}
                </atlas-heading>
                ${this.renderMessage()}
                <slot name="button"></slot>
            </div>
        `;
    }
  };
  AtlasEmptyState.styles = atlas_empty_state_default;
  return AtlasEmptyState;
})();
__decorateClass([property49({
  type: String
})], AtlasEmptyState.prototype, "icon", 2);
__decorateClass([property49({
  type: String
})], AtlasEmptyState.prototype, "illustration", 2);
__decorateClass([property49({
  type: String,
  attribute: "illustration-alt"
})], AtlasEmptyState.prototype, "illustrationAlt", 2);
__decorateClass([property49({
  type: String
})], AtlasEmptyState.prototype, "header", 2);
__decorateClass([property49({
  type: String
})], AtlasEmptyState.prototype, "description", 2);
__decorateClass([property49({
  type: Boolean
})], AtlasEmptyState.prototype, "small", 2);
AtlasEmptyState = __decorateClass([customElement43("atlas-empty-state")], AtlasEmptyState);

// src/components/display/atlas-fixed-alert/atlas-fixed-alert.ts
import { html as html50 } from "lit";
import { customElement as customElement44, property as property50, state as state19 } from "lit/decorators.js";
import { classMap as classMap35 } from "lit/directives/class-map.js";
import { styleMap as styleMap13 } from "lit/directives/style-map.js";
import { when as when31 } from "lit/directives/when.js";

// src/components/display/atlas-fixed-alert/atlas-fixed-alert.scss
import { css as css44 } from "lit-element/lit-element.js";
var atlas_fixed_alert_default = css44`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  --atlas-link-weight: 700;
  display: block;
}

.fixed-alert {
  width: 100%;
  padding: 1rem;
  border-radius: 0.25rem;
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
}
.fixed-alert.skeleton {
  min-height: 73px;
}
.fixed-alert .alert-content {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.fixed-alert.alert-sm {
  padding: 0.5rem 1rem;
  gap: 0.5rem;
}
.fixed-alert.alert-sm .alert-content {
  gap: 0.5rem;
}
.fixed-alert.inline {
  flex-direction: row;
  align-items: center;
}
.fixed-alert.inline .alert-content {
  flex-direction: row;
  align-items: center;
}
.fixed-alert.inline .alert-content > atlas-text {
  display: inline-flex;
}
.fixed-alert:not(.has-content) .alert-content > atlas-text {
  display: none;
}

.alert-info,
.alert-info ::slotted(ul.atlas-simple-list) {
  --atlas-link-color: var(--atlas-info-800);
  --atlas-link-color-hover: var(--atlas-info-900);
  --atlas-text-color: var(--atlas-info-800);
  color: var(--atlas-info-800) !important;
  background-color: var(--atlas-info-100) !important;
}

.alert-success,
.alert-success ::slotted(ul.atlas-simple-list) {
  --atlas-link-color: var(--atlas-success-800);
  --atlas-link-color-hover: var(--atlas-success-900);
  --atlas-text-color: var(--atlas-success-800);
  color: var(--atlas-success-800) !important;
  background-color: var(--atlas-success-100) !important;
}

.alert-error,
.alert-error ::slotted(ul.atlas-simple-list) {
  --atlas-link-color: var(--atlas-danger-800);
  --atlas-link-color-hover: var(--atlas-danger-900);
  --atlas-text-color: var(--atlas-danger-800);
  color: var(--atlas-danger-800) !important;
  background-color: var(--atlas-danger-100) !important;
}

.alert-warning,
.alert-warning ::slotted(ul.atlas-simple-list) {
  --atlas-link-color: var(--atlas-warning-800);
  --atlas-link-color-hover: var(--atlas-warning-900);
  --atlas-text-color: var(--atlas-warning-800);
  color: var(--atlas-warning-800) !important;
  background-color: var(--atlas-warning-100) !important;
}

.alert-primary,
.alert-primary ::slotted(ul.atlas-simple-list) {
  --atlas-link-color: var(--atlas-primary-800);
  --atlas-link-color-hover: var(--atlas-primary-900);
  --atlas-text-color: var(--atlas-primary-800);
  color: var(--atlas-primary-800) !important;
  background-color: var(--atlas-primary-100) !important;
}

@media screen and (min-width: 992px) {
  .fixed-alert {
    padding: 1.5rem;
  }
  .fixed-alert .alert-content {
    gap: 1rem;
  }
  .fixed-alert.alert-sm {
    padding: 1rem 1.5rem;
    gap: 1rem;
  }
  .fixed-alert.alert-sm .alert-content {
    gap: 1rem;
  }
}`;

// src/components/display/atlas-fixed-alert/atlas-fixed-alert.ts
var AtlasFixedAlert = /*#__PURE__*/(() => {
  let AtlasFixedAlert = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.type = "info";
      this.size = "md";
      this.inline = false;
      this._hasSlottedContent = false;
      this._skeletonLoadingHeight = null;
      this._deviceController = new DeviceController(this);
    }
    updateHeightOnSkeletonLoading() {
      if (!this.skeletonLoading) return;
      this._skeletonLoadingHeight = this.getBoundingClientRect().height;
    }
    getAlertIcon() {
      if (this.icon) return this.icon;
      return {
        success: "check",
        error: "alert-triangle",
        warning: "alert-triangle",
        info: "info"
      }[this.type];
    }
    getAlertIconSize() {
      return this._deviceController.isMobile && this.size === "sm" ? "2x" : "3x";
    }
    getAlertTheme() {
      return {
        success: "success",
        error: "danger",
        warning: "warning",
        info: "info",
        primary: "primary"
      }[this.type];
    }
    getAlertTextSize() {
      if (this.size === "sm") return this._deviceController.isMobile ? "xs" : "sm";
      return "md";
    }
    getAlertHeadingSize() {
      return this._deviceController.isMobile && this.size === "sm" ? "h6" : "h5";
    }
    onChangeSlottedContent() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        if (this.skeletonLoading) return;
        const slottedNodes = this.shadowRoot.querySelector("slot").assignedNodes({
          flatten: true
        });
        const filteredNodes = filterEmptyNodes(slottedNodes);
        this._hasSlottedContent = filteredNodes.length > 0;
      });
    }
    /** @override */
    renderSkeleton() {
      const containerStyles = {
        height: this._skeletonLoadingHeight ? `${this._skeletonLoadingHeight}px` : null
      };
      return html50` <div class="fixed-alert skeleton" style=${styleMap13(containerStyles)}></div> `;
    }
    renderHeader() {
      return when31(!!this.header, () => html50`
                <atlas-heading size=${this.getAlertHeadingSize()} theme=${this.getAlertTheme()} theme-variation="800">
                    ${this.header}
                </atlas-heading>
            `);
    }
    /** @override */
    renderElement() {
      const alertClass = {
        "fixed-alert": true,
        "inline": this.inline,
        [`alert-${this.type}`]: true,
        [`alert-${this.size}`]: true,
        "has-content": this._hasSlottedContent
      };
      return html50`
            <div class=${classMap35(alertClass)}>
                <atlas-icon name=${this.getAlertIcon()} size=${this.getAlertIconSize()}></atlas-icon>
                <div class="alert-content">
                    ${this.renderHeader()}
                    <atlas-text theme=${this.getAlertTheme()} theme-variation="800" size=${this.getAlertTextSize()}>
                        <slot @slotchange=${this.onChangeSlottedContent}></slot>
                    </atlas-text>
                </div>
            </div>
        `;
    }
  };
  AtlasFixedAlert.styles = atlas_fixed_alert_default;
  return AtlasFixedAlert;
})();
__decorateClass([property50({
  type: String
})], AtlasFixedAlert.prototype, "header", 2);
__decorateClass([property50({
  type: String
})], AtlasFixedAlert.prototype, "type", 2);
__decorateClass([property50({
  type: String
})], AtlasFixedAlert.prototype, "size", 2);
__decorateClass([property50({
  type: String
})], AtlasFixedAlert.prototype, "icon", 2);
__decorateClass([property50({
  type: Boolean,
  reflect: true
})], AtlasFixedAlert.prototype, "inline", 2);
__decorateClass([state19()], AtlasFixedAlert.prototype, "_hasSlottedContent", 2);
__decorateClass([state19()], AtlasFixedAlert.prototype, "_skeletonLoadingHeight", 2);
__decorateClass([Watch("skeletonLoading", true)], AtlasFixedAlert.prototype, "updateHeightOnSkeletonLoading", 1);
AtlasFixedAlert = __decorateClass([customElement44("atlas-fixed-alert")], AtlasFixedAlert);

// src/components/display/atlas-helper/atlas-helper.ts
import { html as html51 } from "lit";
import { customElement as customElement45, property as property51 } from "lit/decorators.js";
import { when as when32 } from "lit/directives/when.js";
import { ifDefined as ifDefined10 } from "lit/directives/if-defined.js";
import { classMap as classMap36 } from "lit/directives/class-map.js";

// src/components/display/atlas-helper/atlas-helper.scss
import { css as css45 } from "lit-element/lit-element.js";
var atlas_helper_default = css45`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  width: 100%;
  display: inline-flex;
}

.atlas-helper {
  position: relative;
  align-items: center;
  display: flex;
  min-height: 56px;
  width: 100%;
  padding: 1rem;
  gap: 1rem;
  border: 0;
  border-radius: 0.25rem;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  text-decoration: none;
  cursor: pointer;
  background-color: var(--atlas-info-100);
}
.atlas-helper .helper-icon {
  color: var(--atlas-info-800);
}
.atlas-helper .helper-text {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  text-align: left;
  flex-grow: 1;
  color: var(--atlas-info-800);
}
.atlas-helper:active {
  background-color: var(--atlas-info-200);
}
.atlas-helper:focus-visible {
  outline-offset: 0;
  box-shadow: none;
  outline: 4px solid rgba(var(--atlas-info-rgb), 25%);
}`;

// src/components/display/atlas-helper/atlas-helper.ts
var AtlasHelper = /*#__PURE__*/(() => {
  let AtlasHelper = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.message = "";
      this.href = "";
    }
    onClickHelper() {
      emit(this, "atlas-helper-click");
    }
    renderContent() {
      return html51`
            <atlas-icon name="help-circle" size="3x" class="helper-icon"></atlas-icon>
            <span class="helper-text">
                ${when32(!!this.message, () => this.message, () => html51`<slot></slot>`)}
            </span>
            <atlas-icon name="chevron-right" size="3x" class="helper-icon"></atlas-icon>
        `;
    }
    /**
     * @internal
     */
    render() {
      const helperClass = {
        "atlas-helper": true
      };
      return when32(!!this.href, () => html51`
                <a
                    class="${classMap36(helperClass)}"
                    href=${this.href}
                    rel="${ifDefined10(this.external ? "noreferrer noopener" : void 0)}"
                    target="${ifDefined10(this.external ? "_blank" : void 0)}"
                    @click=${this.onClickHelper}
                >
                    ${this.renderContent()}
                </a>
            `, () => html51`
                <button
                    class="${classMap36(helperClass)}"
                    @click=${this.onClickHelper}
                >
                    ${this.renderContent()}
                </button>
            `);
    }
  };
  AtlasHelper.styles = atlas_helper_default;
  return AtlasHelper;
})();
__decorateClass([property51({
  type: String
})], AtlasHelper.prototype, "message", 2);
__decorateClass([property51({
  type: String
})], AtlasHelper.prototype, "href", 2);
__decorateClass([property51({
  type: Boolean
})], AtlasHelper.prototype, "external", 2);
AtlasHelper = __decorateClass([customElement45("atlas-helper")], AtlasHelper);

// src/components/display/atlas-hotspot/atlas-hotspot.ts
import { html as html52 } from "lit";
import { customElement as customElement46, property as property52, state as state20 } from "lit/decorators.js";
import { classMap as classMap37 } from "lit/directives/class-map.js";
import { when as when33 } from "lit/directives/when.js";

// src/components/display/atlas-hotspot/atlas-hotspot.scss
import { css as css46 } from "lit-element/lit-element.js";
var atlas_hotspot_default = css46`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Transitions */
/* Shadows */
/* Elevations */
/* Z-index mapping for the floating elements */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: inline-flex;
}

:host([skeleton-loading]) {
  display: none;
}

.hotspot {
  width: 40px;
  height: 40px;
  background: none;
  border: 0;
  padding: 0;
  opacity: 0;
  position: relative;
  cursor: pointer;
  transition: all 0.25s ease;
}
.hotspot .inner-circle, .hotspot::after {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center;
  border-radius: 50%;
}
.hotspot .inner-circle {
  display: block;
  width: 1rem;
  height: 1rem;
  background: var(--atlas-warning-500);
  border: 2px solid #ffffff;
  z-index: 2;
  transition: background 0.25s ease;
}
.hotspot.visible {
  opacity: 1;
}
.hotspot::after {
  content: " ";
  width: 0.5rem;
  height: 0.5rem;
  border: 4px solid var(--atlas-warning-200);
  border-radius: 50%;
  animation: pulse 1s ease-out infinite;
  z-index: 1;
}
.hotspot:hover, .hotspot:focus-visible {
  outline: none;
}
.hotspot:hover .inner-circle, .hotspot:focus-visible .inner-circle {
  background: var(--atlas-warning-600);
}

.hotspot-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1050;
  opacity: 0;
  transition: all 0.25s ease;
  pointer-events: none;
}
.hotspot-overlay.visible {
  opacity: 1;
  pointer-events: all;
}

:host([active]) .hotspot {
  z-index: 2000;
}
:host([active]) .hotspot .inner-circle {
  background: var(--atlas-warning-700);
}

@keyframes pulse {
  0% {
    width: 0.5rem;
    height: 0.5rem;
  }
  100% {
    width: 2rem;
    height: 2rem;
  }
}`;

// src/components/display/atlas-hotspot/atlas-hotspot.ts
var AtlasHotspot = /*#__PURE__*/(() => {
  let AtlasHotspot = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this._isHotspotVisible = true;
      this._isOverlayVisible = false;
      this._deviceController = new DeviceController(this);
    }
    connectedCallback() {
      super.connectedCallback();
      this.onClickHotspot = this.onClickHotspot.bind(this);
      this.onClickOverlay = this.onClickOverlay.bind(this);
      this.onCloseHotspotPopover = this.onCloseHotspotPopover.bind(this);
      this.onRenderHighlightHotspot();
    }
    /**
     * Retorna o popover associado ao hotspot
     * @returns {AtlasPopover} Instância do popover associado ao hotspot
     */
    getHotspotPopover() {
      const popoverId = this.getAttribute("data-atlas-popover");
      return document.querySelector(`#${popoverId}`);
    }
    onRenderHighlightHotspot() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        if (!this.highlightTarget) return;
        setTimeout(() => {
          if (this.isConnected) {
            this.toggleHighlightOverlay();
            this.openHotspotPopoverAndBindEvents();
          }
        }, 1e3);
      });
    }
    onClickHotspot(event) {
      event.preventDefault();
      emit(this, "atlas-hotspot-click");
    }
    onClickOverlay(event) {
      event.preventDefault();
      event.stopPropagation();
    }
    onCloseHotspotPopover() {
      const popover = this.getHotspotPopover();
      if (!popover) return;
      this._isHotspotVisible = false;
      this._isOverlayVisible = false;
      document.body.classList.remove("disable-scroll-hotspot");
      popover.removeEventListener("atlas-popover-closed", this.onCloseHotspotPopover);
      popover.hide();
      setTimeout(() => {
        popover.remove();
        this.remove();
      }, 350);
    }
    toggleHighlightOverlay() {
      const targetElement = document.querySelector(this.target);
      if (!targetElement || this._deviceController.isMobile) return;
      const rect = targetElement.getBoundingClientRect();
      const extraPadding = 8;
      const top = rect.top - extraPadding;
      const left = rect.left - extraPadding;
      const width = rect.width + 2 * extraPadding;
      const height = rect.height + 2 * extraPadding;
      const hotspotOverlay = this.shadowRoot.querySelector(".hotspot-overlay");
      hotspotOverlay.style.clipPath = `polygon(
            0 0, 
            100% 0, 
            100% 100%, 
            0 100%, 
            0 ${top}px, 
            ${left}px ${top}px, 
            ${left}px ${top + height}px, 
            ${left + width}px ${top + height}px, 
            ${left + width}px ${top}px, 
            0 ${top}px
        )`;
      this._isOverlayVisible = true;
      document.body.classList.add("disable-scroll-hotspot");
    }
    openHotspotPopoverAndBindEvents() {
      const popover = this.getHotspotPopover();
      if (!popover) return;
      popover.show();
      popover.addEventListener("atlas-popover-closed", this.onCloseHotspotPopover);
    }
    render() {
      return html52`
            <button class=${classMap37({
        hotspot: true,
        visible: this._isHotspotVisible
      })} @click=${this.onClickHotspot}>
                <span class="inner-circle"></span>
            </button>
            ${when33(this.highlightTarget, () => html52`
                    <div
                        class=${classMap37({
        "hotspot-overlay": true,
        "visible": this._isOverlayVisible
      })}
                        @click=${this.onClickOverlay}
                    ></div>
                `)}
        `;
    }
  };
  AtlasHotspot.styles = atlas_hotspot_default;
  return AtlasHotspot;
})();
__decorateClass([property52({
  type: Boolean,
  attribute: "highlight-target"
})], AtlasHotspot.prototype, "highlightTarget", 2);
__decorateClass([property52({
  type: String
})], AtlasHotspot.prototype, "target", 2);
__decorateClass([state20()], AtlasHotspot.prototype, "_isHotspotVisible", 2);
__decorateClass([state20()], AtlasHotspot.prototype, "_isOverlayVisible", 2);
AtlasHotspot = __decorateClass([customElement46("atlas-hotspot")], AtlasHotspot);

// src/components/display/atlas-image/atlas-image.ts
import { html as html53 } from "lit";
import { customElement as customElement47, property as property53, state as state21 } from "lit/decorators.js";
import { classMap as classMap38 } from "lit/directives/class-map.js";
import { ifDefined as ifDefined11 } from "lit/directives/if-defined.js";
import { styleMap as styleMap14 } from "lit/directives/style-map.js";

// src/components/display/atlas-image/atlas-image.scss
import { css as css47 } from "lit-element/lit-element.js";
var atlas_image_default = css47`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: inline-block;
  width: fit-content;
  height: fit-content;
}

.image-skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 0.35s ease;
  opacity: 0;
}
.image-skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}
.image-skeleton.show {
  opacity: 1;
}

.image {
  display: block;
  border-radius: inherit;
  transition: opacity 0.35s ease;
}

.image-wrapper {
  position: relative;
  width: fit-content;
  height: fit-content;
}
.image-wrapper.is-loading .image {
  opacity: 0;
}`;

// src/components/display/atlas-image/atlas-image.ts
var AtlasImage = /*#__PURE__*/(() => {
  let AtlasImage = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.borderRadius = "0px";
      this._status = "IDLE" /* IDLE */;
    }
    onSourceChange() {
      this._status = "LOADING" /* LOADING */;
    }
    onFallbackSourceChange() {
      if (this.isUsingFallback()) {
        this._status = "FALLBACK_LOADING" /* FALLBACK_LOADING */;
      }
    }
    getSource() {
      return this.isUsingFallback() ? this.fallbackSrc : this.src;
    }
    isUsingFallback() {
      if (!this.fallbackSrc) return false;
      const fallbackOrErrorStatusList = ["ERROR" /* ERROR */, "FALLBACK_LOADING" /* FALLBACK_LOADING */, "FALLBACK_LOADED" /* FALLBACK_LOADED */];
      return fallbackOrErrorStatusList.includes(this._status);
    }
    isLoading() {
      if (this.skeletonLoading) return true;
      const loadingStatusList = ["LOADING" /* LOADING */, "FALLBACK_LOADING" /* FALLBACK_LOADING */];
      return loadingStatusList.includes(this._status);
    }
    onLoad() {
      if (this._status === "FALLBACK_LOADING" /* FALLBACK_LOADING */) {
        this._status = "FALLBACK_LOADED" /* FALLBACK_LOADED */;
        return;
      }
      this._status = "LOADED" /* LOADED */;
    }
    onLoadError() {
      if (this._status === "ERROR" /* ERROR */) return;
      if (this._status === "LOADING" /* LOADING */ && !!this.fallbackSrc && this.fallbackSrc !== this.src) {
        this._status = "FALLBACK_LOADING" /* FALLBACK_LOADING */;
        return;
      }
      this._status = "ERROR" /* ERROR */;
    }
    renderImage() {
      return html53`
            <img
                class="image"
                src=${ifDefined11(this.getSource() || void 0)}
                width=${this.width}
                height=${this.height}
                alt=${this.alt || "basic image"}
                @load=${this.onLoad}
                @error=${this.onLoadError}
            />
        `;
    }
    renderImageSkeleton() {
      const imageSkeletonClass = {
        "image-skeleton": true,
        "show": this.isLoading()
      };
      return html53` <div class=${classMap38(imageSkeletonClass)}></div> `;
    }
    /** @internal */
    render() {
      const imageWrapperClass = {
        "image-wrapper": true,
        "is-loading": this.isLoading()
      };
      const imageWrapperStyles = {
        "border-radius": this.borderRadius
      };
      return html53`
            <div class=${classMap38(imageWrapperClass)} style=${styleMap14(imageWrapperStyles)}>
                ${this.renderImage()} ${this.renderImageSkeleton()}
            </div>
        `;
    }
  };
  AtlasImage.styles = atlas_image_default;
  return AtlasImage;
})();
__decorateClass([property53({
  type: String
})], AtlasImage.prototype, "src", 2);
__decorateClass([property53({
  type: String
})], AtlasImage.prototype, "alt", 2);
__decorateClass([property53({
  type: Number
})], AtlasImage.prototype, "width", 2);
__decorateClass([property53({
  type: Number
})], AtlasImage.prototype, "height", 2);
__decorateClass([property53({
  type: String,
  attribute: "border-radius"
})], AtlasImage.prototype, "borderRadius", 2);
__decorateClass([property53({
  type: String,
  attribute: "fallback-src"
})], AtlasImage.prototype, "fallbackSrc", 2);
__decorateClass([state21()], AtlasImage.prototype, "_status", 2);
__decorateClass([Watch("src")], AtlasImage.prototype, "onSourceChange", 1);
__decorateClass([Watch("fallbackSrc")], AtlasImage.prototype, "onFallbackSourceChange", 1);
AtlasImage = __decorateClass([customElement47("atlas-image")], AtlasImage);

// src/components/display/atlas-image-preview/atlas-image-preview.ts
import { html as html55, nothing as nothing2 } from "lit";
import { customElement as customElement49, property as property55, query as query8, state as state22 } from "lit/decorators.js";
import { classMap as classMap40 } from "lit/directives/class-map.js";
import { when as when34 } from "lit/directives/when.js";

// src/components/display/atlas-image-preview/atlas-image-preview.scss
import { css as css48 } from "lit-element/lit-element.js";
var atlas_image_preview_default = css48`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Z-index mapping for the floating elements */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: contents;
}

.atlas-image-preview-wrapper {
  display: none;
  box-sizing: border-box;
  overflow: hidden;
}
.atlas-image-preview-wrapper.open {
  display: block;
}
.atlas-image-preview-wrapper * {
  box-sizing: border-box;
}

.atlas-image-preview-backdrop {
  position: fixed;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100dvw;
  height: 100dvh;
  background: rgba(var(--atlas-dark-rgb), 40%);
  pointer-events: none;
  z-index: 50;
  transition: opacity 0.3ms ease-in 0s;
}
.atlas-image-preview-backdrop.open {
  opacity: 1;
  pointer-events: all;
}

.atlas-image-preview {
  position: fixed;
  top: 0;
  left: 0;
  width: 100dvw;
  height: 100dvh;
  z-index: 51;
  text-align: left;
  overflow: hidden;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.15s ease 0s;
}
.atlas-image-preview.open {
  opacity: 1;
  pointer-events: all;
}
.atlas-image-preview .atlas-image-header {
  font-size: 14px;
  color: #ffffff;
  font-weight: 700;
  width: 100%;
  text-align: center;
  padding: 2.125rem 5rem;
  position: relative;
  z-index: 53;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.atlas-image-preview .atlas-image-preview-close,
.atlas-image-preview .atlas-image-preview-prev,
.atlas-image-preview .atlas-image-preview-next {
  position: absolute;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  border-radius: 50%;
  z-index: 54;
}
.atlas-image-preview .atlas-image-preview-close {
  top: 1.5rem;
  right: 1.5rem;
}
.atlas-image-preview .atlas-image-preview-prev {
  left: 1rem;
  bottom: 1.5rem;
}
.atlas-image-preview .atlas-image-preview-next {
  right: 1rem;
  bottom: 1.5rem;
}
.atlas-image-preview .atlas-image-preview-controls {
  position: absolute;
  bottom: 1.5rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--atlas-secondary-100);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  border-radius: 9999px;
  z-index: 54;
}
.atlas-image-preview .atlas-image-preview-counter {
  position: absolute;
  bottom: 4.5rem;
  left: 50%;
  transform: translateX(-50%);
  font-size: 14px;
  color: #ffffff;
  font-weight: 700;
  z-index: 53;
}
.atlas-image-preview .atlas-image-preview-content {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  white-space: nowrap;
}
.atlas-image-preview .atlas-image-item {
  display: block;
  text-align: center;
  position: absolute;
  opacity: 0;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.atlas-image-preview .atlas-image-item .atlas-image-wrapper {
  will-change: transform;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  margin: auto;
  white-space: nowrap;
  vertical-align: middle;
  text-align: center;
  transform: translate3d(0, 0, 0);
}
.atlas-image-preview .atlas-image-item .atlas-image-wrapper .atlas-image-flip,
.atlas-image-preview .atlas-image-item .atlas-image-wrapper .atlas-image-rotate {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transition: transform 0.4s cubic-bezier(0, 0, 0.25, 1) 0s;
}
.atlas-image-preview .atlas-image-item .atlas-image-wrapper .atlas-image {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: auto;
  width: 100%;
  margin: auto;
  display: inline-block;
  vertical-align: middle;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transform: scale3d(1, 1, 1);
  cursor: grab;
  transition: transform 0.4s cubic-bezier(0, 0, 0.25, 1) 0s;
}
.atlas-image-preview .atlas-image-item.active {
  opacity: 1;
  pointer-events: all;
  transform: translate3d(0, 0, 0);
  transition: transform 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;
  z-index: 52;
}
.atlas-image-preview .atlas-image-item.prev {
  transform: translate3d(-150%, 0, 0);
}
.atlas-image-preview .atlas-image-item.next {
  transform: translate3d(150%, 0, 0);
}

@media screen and (min-width: 992px) {
  .atlas-image-preview .atlas-image-preview-controls {
    gap: 0.25rem;
  }
  .atlas-image-preview .atlas-image-item .atlas-image-wrapper .atlas-image {
    width: auto;
    max-width: calc(100% - 8rem);
    max-height: calc(100% - 192px);
  }
  .atlas-image-preview .atlas-image-preview-prev {
    left: 1.5rem;
    top: 50%;
    bottom: unset;
    transform: translateY(-50%);
  }
  .atlas-image-preview .atlas-image-preview-next {
    right: 1.5rem;
    top: 50%;
    bottom: unset;
    transform: translateY(-50%);
  }
}`;

// src/components/display/atlas-image-preview-control/atlas-image-preview-control.ts
import { html as html54 } from "lit";
import { customElement as customElement48, property as property54 } from "lit/decorators.js";
import { classMap as classMap39 } from "lit/directives/class-map.js";

// src/components/display/atlas-image-preview-control/atlas-image-preview-control.scss
import { css as css49 } from "lit-element/lit-element.js";
var atlas_image_preview_control_default = css49`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: inline-flex;
}

.atlas-image-preview-control {
  border: none;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: transparent;
  border-radius: 50%;
  background-color: var(--atlas-secondary-100);
}
.atlas-image-preview-control:hover {
  background-color: var(--atlas-secondary-200);
}
.atlas-image-preview-control:active {
  background-color: var(--atlas-secondary-300);
}
.atlas-image-preview-control:disabled, .atlas-image-preview-control.disabled {
  opacity: 0.65;
  pointer-events: none;
}
.atlas-image-preview-control:focus, .atlas-image-preview-control:focus-visible, .atlas-image-preview-control:focus-within {
  outline: none;
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-secondary-500-rgb), 0.25);
}`;

// src/components/display/atlas-image-preview-control/atlas-image-preview-control.ts
var AtlasImagePreviewControl = /*#__PURE__*/(() => {
  let AtlasImagePreviewControl = class extends WithTooltipMixin(AtlasElement) {
    onClick(event) {
      event.preventDefault();
      event.stopPropagation();
      emit(this, "atlas-image-preview-control-click");
    }
    render() {
      const atlasImagePreviewControlClass = {
        "atlas-image-preview-control": true,
        "disabled": this.disabled
      };
      return html54`
            <button
                data-atlas-tooltip="image-preview-control-tooltip"
                class="${classMap39(atlasImagePreviewControlClass)}"
                @click=${this.onClick}
            >
                <atlas-icon name="${this.icon}" size="2x"></atlas-icon>
            </button>
            ${this.renderTooltip("image-preview-control-tooltip")}
        `;
    }
  };
  AtlasImagePreviewControl.styles = atlas_image_preview_control_default;
  return AtlasImagePreviewControl;
})();
__decorateClass([property54({
  type: String
})], AtlasImagePreviewControl.prototype, "icon", 2);
__decorateClass([property54({
  type: Boolean,
  reflect: true
})], AtlasImagePreviewControl.prototype, "disabled", 2);
AtlasImagePreviewControl = __decorateClass([customElement48("atlas-image-preview-control")], AtlasImagePreviewControl);

// src/components/display/atlas-image-preview/atlas-image-preview.ts
var AtlasImagePreview = /*#__PURE__*/(() => {
  let AtlasImagePreview = class extends AtlasElement {
    constructor() {
      super();
      this.open = false;
      this.preventClose = false;
      this.preventOpenPreviewOnClick = false;
      this.actions = [];
      this._activeImage = null;
      this._activeImageIndex = 0;
      this._isChangingActiveImage = false;
      this._isDragging = false;
      this._isZooming = false;
      this._currentTranslation = {
        x: 0,
        y: 0
      };
      this._zoomLimit = {
        min: 0.4,
        max: 4
      };
      this.zoomWithWheel = this.zoomWithWheel.bind(this);
      this.zoomWithTouch = this.zoomWithTouch.bind(this);
      this.dragStart = this.dragStart.bind(this);
      this.drag = this.drag.bind(this);
      this.dragEnd = this.dragEnd.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
      this.touchStart = this.touchStart.bind(this);
      this.touchMove = this.touchMove.bind(this);
      this.touchEnd = this.touchEnd.bind(this);
      this.imageClick = this.imageClick.bind(this);
    }
    onSlotChange() {
      this.getSlottedImageElements();
      this.setImagesInPreview();
      this.getImagesInPreview();
      this.setClickEventOnImageElements();
    }
    getSlottedImageElements() {
      const slottedElements = this.querySelectorAll("atlas-image, atlas-preview");
      if (!slottedElements) return;
      this._slottedImageElements = Array.from(slottedElements);
    }
    setImagesInPreview() {
      this._imagePreviewContainer.innerHTML = "";
      this._slottedImageElements.forEach((imageElement, index) => {
        imageElement.setAttribute("data-preview-image-index", index.toString());
        const imagePreviewElement = this.createImagePreviewElement(imageElement, index);
        this._imagePreviewContainer.appendChild(imagePreviewElement);
      });
    }
    getImagesInPreview() {
      this._imagePreviewItems = Array.from(this._imagePreviewContainer.querySelectorAll(".atlas-image-item"));
    }
    createImagePreviewElement(imageElement, index) {
      const imagePreviewTemplate = this.shadowRoot.querySelector("template").content.cloneNode(true);
      imagePreviewTemplate.querySelector(".atlas-image-item").setAttribute("data-preview-image-index", index.toString());
      const imagePreview = imagePreviewTemplate.querySelector(".atlas-image");
      const src = imageElement.getAttribute("src") || imageElement.getAttribute("image");
      const alt = imageElement.getAttribute("alt") || imageElement.getAttribute("image-name");
      imagePreview.setAttribute("src", src);
      imagePreview.setAttribute("alt", alt);
      if (imageElement.hasAttribute("data-name") || imageElement.getAttribute("image-name")) {
        const imageName = imageElement.getAttribute("data-name") || imageElement.getAttribute("image-name");
        imagePreview.setAttribute("data-name", imageName);
      }
      if (imageElement.hasAttribute("data-download-url")) {
        imagePreview.setAttribute("data-download-url", imageElement.getAttribute("download-url"));
      }
      imagePreview.addEventListener("wheel", this.zoomWithWheel);
      imagePreview.addEventListener("mousedown", this.dragStart);
      imagePreview.addEventListener("touchstart", this.touchStart);
      imagePreview.addEventListener("click", this.imageClick);
      return imagePreviewTemplate;
    }
    setClickEventOnImageElements() {
      if (this.preventOpenPreviewOnClick) return;
      this._slottedImageElements.forEach(imageElement => {
        imageElement.addEventListener("click", () => {
          const clickedImageIndex = this.getPreviewImageIndex(imageElement);
          this.openPreview(clickedImageIndex);
        });
      });
    }
    resetImagesStates() {
      this._imagePreviewItems.forEach(imageItem => {
        imageItem.classList.remove("active");
        imageItem.classList.remove("prev");
        imageItem.classList.remove("next");
      });
      this._activeImage = null;
      this._activeImageIndex = 0;
    }
    openPreview(activeImageIndex) {
      this.open = true;
      this.setActiveImage(activeImageIndex);
      document.body.classList.toggle("disable-scroll", true);
      document.addEventListener("keydown", this.onKeyDown);
    }
    closePreview() {
      if (this._isDragging) return;
      this.open = false;
      this.resetImagesStates();
      document.body.classList.toggle("disable-scroll", false);
      document.removeEventListener("keydown", this.onKeyDown);
    }
    imageClick(event) {
      event.stopPropagation();
      event.preventDefault();
    }
    getPreviewImageIndex(imageItem) {
      return parseInt(imageItem.getAttribute("data-preview-image-index"), 10);
    }
    indexOutOfBounds(index) {
      return index < 0 || index >= this._imagePreviewItems.length;
    }
    setActiveImage(index) {
      if (this.indexOutOfBounds(index)) return;
      if (this._isChangingActiveImage) return;
      this._isChangingActiveImage = true;
      const lastActiveImage = this._activeImage;
      this._activeImageIndex = index;
      this._activeImage = this._imagePreviewItems.find(imageItem => this.getPreviewImageIndex(imageItem) === index);
      this.defineNextAndPrevImages();
      this._activeImage.classList.add("active");
      this.setImageTitle();
      setTimeout(() => {
        lastActiveImage == null ? void 0 : lastActiveImage.classList.remove("active");
        this._isChangingActiveImage = false;
      }, 1e3);
    }
    setImageTitle() {
      const imageTitle = this._activeImage.querySelector(".atlas-image").getAttribute("data-name");
      const imagePreviewHeader = this.shadowRoot.querySelector(".atlas-image-header");
      imagePreviewHeader.innerHTML = imageTitle || "";
    }
    resetNextAndPrevImages() {
      this._imagePreviewItems.forEach(imageItem => {
        imageItem.classList.remove("prev");
        imageItem.classList.remove("next");
      });
    }
    defineNextAndPrevImages() {
      this.resetNextAndPrevImages();
      const step = 1;
      const previousImageIndex = this._activeImageIndex - step;
      const nextImageIndex = this._activeImageIndex + step;
      this.setPrevImage(previousImageIndex);
      this.setNextImage(nextImageIndex);
    }
    setPrevImage(previousImageIndex) {
      const hasPreviousImage = previousImageIndex >= 0;
      if (hasPreviousImage) {
        this._imagePreviewItems[previousImageIndex].classList.add("prev");
      }
      this._imagePreviewPrev.disabled = !hasPreviousImage;
    }
    setNextImage(nextImageIndex) {
      const hasNextImage = nextImageIndex < this._imagePreviewItems.length;
      if (hasNextImage) {
        this._imagePreviewItems[nextImageIndex].classList.add("next");
      }
      this._imagePreviewNext.disabled = !hasNextImage;
    }
    goToPreviousImage(event) {
      event.stopPropagation();
      event.preventDefault();
      const previousImageIndex = this._activeImageIndex - 1;
      this.setActiveImage(previousImageIndex);
    }
    goToNextImage(event) {
      event.stopPropagation();
      event.preventDefault();
      const nextImageIndex = this._activeImageIndex + 1;
      this.setActiveImage(nextImageIndex);
    }
    onKeyDown(event) {
      if (event.key === "Escape") {
        this.closePreview();
      }
      if (event.key === "ArrowLeft") {
        this.goToPreviousImage(event);
      }
      if (event.key === "ArrowRight") {
        this.goToNextImage(event);
      }
      if (event.ctrlKey && event.key === "=") {
        this.zoomIn(event);
      }
      if (event.ctrlKey && event.key === "-") {
        this.zoomOut(event);
      }
      if (event.ctrlKey && event.key === "1") {
        this.resetZoom(event);
      }
    }
    dragStart(event) {
      event.stopPropagation();
      event.preventDefault();
      this._isDragging = true;
      this.setCurrentTranslation(event.clientX, event.clientY);
      this._activeImage.addEventListener("mousemove", this.drag);
      this._activeImage.addEventListener("mouseup", this.dragEnd);
    }
    drag(event) {
      if (!this._isDragging) return;
      event.stopPropagation();
      event.preventDefault();
      this.updateTranslation(event.clientX, event.clientY);
    }
    dragEnd(event) {
      event.stopPropagation();
      event.preventDefault();
      this._isDragging = false;
      this._activeImage.removeEventListener("mousemove", this.drag);
      this._activeImage.removeEventListener("mouseup", this.dragEnd);
    }
    touchStart(event) {
      event.stopPropagation();
      event.preventDefault();
      if (event.targetTouches.length == 2) {
        const x = event.targetTouches[0].clientX - event.targetTouches[1].clientX;
        const y = event.targetTouches[0].clientY - event.targetTouches[1].clientY;
        this._isZooming = true;
        this.setZoomTouchStartDistance(Math.hypot(x, y));
      } else if (event.targetTouches.length == 1) {
        const x = event.targetTouches[0].clientX;
        const y = event.targetTouches[0].clientY;
        this._isDragging = true;
        this.setCurrentTranslation(x, y);
      }
      this._activeImage.addEventListener("touchmove", this.touchMove);
      this._activeImage.addEventListener("touchend", this.touchEnd);
      this._activeImage.addEventListener("touchcancel", this.touchEnd);
    }
    touchMove(event) {
      event.stopPropagation();
      event.preventDefault();
      if (this._isZooming) this.zoomWithTouch(event);
      if (this._isDragging) this.updateTranslation(event.touches[0].clientX, event.touches[0].clientY);
    }
    touchEnd(event) {
      event.stopPropagation();
      event.preventDefault();
      this._isDragging = false;
      this._isZooming = false;
      this._activeImage.removeEventListener("touchmove", this.touchMove);
      this._activeImage.removeEventListener("touchend", this.touchEnd);
      this._activeImage.removeEventListener("touchcancel", this.touchEnd);
    }
    setZoomTouchStartDistance(distance) {
      this._zoomTouchStartDistance = distance;
    }
    setCurrentTranslation(posX, posY) {
      this._currentTranslation = {
        x: posX,
        y: posY
      };
    }
    updateTranslation(posX, posY) {
      const translatingElement = this._activeImage;
      const newX = this._currentTranslation.x - posX;
      const newY = this._currentTranslation.y - posY;
      this.setCurrentTranslation(posX, posY);
      translatingElement.style.top = translatingElement.offsetTop - newY + "px";
      translatingElement.style.left = translatingElement.offsetLeft - newX + "px";
    }
    resetTranslation() {
      const translatingElement = this._activeImage;
      translatingElement.style.top = "0px";
      translatingElement.style.left = "0px";
      this.setCurrentTranslation(0, 0);
    }
    getActiveImageScale(element) {
      const scale = element.style.transform.trim();
      if (!scale) return {
        x: 1,
        y: 1,
        z: 1
      };
      const [x, y, z] = scale.match(/scale3d\(([^)]+)\)/)[1].split(",").map(parseFloat);
      return {
        x,
        y,
        z
      };
    }
    getActiveImageRotation(element) {
      const rotation = element.style.transform.trim();
      if (!rotation) return 0;
      return parseInt(rotation.match(/rotate\(([^)]+)\)/)[1], 10);
    }
    flipImage(event) {
      if (!this.actions.includes("flip")) return;
      event.stopPropagation();
      event.preventDefault();
      const flipElement = this._activeImage.querySelector(".atlas-image-flip");
      const scale = this.getActiveImageScale(flipElement);
      flipElement.style.transform = `scale3d(${scale.x * -1},${scale.y},${scale.z})`;
    }
    rotateImage(event) {
      if (!this.actions.includes("rotate")) return;
      event.stopPropagation();
      event.preventDefault();
      const rotationElement = this._activeImage.querySelector(".atlas-image-rotate");
      const rotation = this.getActiveImageRotation(rotationElement);
      const flipElement = this._activeImage.querySelector(".atlas-image-flip");
      const isFlipped = this.getActiveImageScale(flipElement).x < 0;
      const rotatingDegree = isFlipped ? -90 : 90;
      const newRotation = rotation + rotatingDegree;
      rotationElement.style.transform = `rotate(${newRotation}deg)`;
    }
    zoomWithTouch(event) {
      event.stopPropagation();
      event.preventDefault();
      if (event.targetTouches.length !== 2 || event.changedTouches.length !== 2) return;
      const newXTouchDistance = event.changedTouches[0].clientX - event.changedTouches[1].clientX;
      const newYTouchDistance = event.changedTouches[0].clientY - event.changedTouches[1].clientY;
      const newTouchDistance = Math.hypot(newXTouchDistance, newYTouchDistance);
      if (this._zoomTouchStartDistance === newTouchDistance) return;
      const direction = this._zoomTouchStartDistance > newTouchDistance ? "out" : "in";
      this.setZoomTouchStartDistance(newTouchDistance);
      this.zoom(0.01, direction);
    }
    zoomWithWheel(event) {
      event.stopPropagation();
      event.preventDefault();
      const direction = event.deltaY < 0 ? "in" : "out";
      this.zoom(0.1, direction);
    }
    zoomIn(event) {
      event.stopPropagation();
      event.preventDefault();
      this.zoom(0.1, "in");
    }
    zoomOut(event) {
      event.stopPropagation();
      event.preventDefault();
      this.zoom(0.1, "out");
    }
    zoom(sensibility, direction) {
      const zoomElement = this._activeImage.querySelector(".atlas-image");
      const scale = this.getActiveImageScale(zoomElement);
      if (direction === "in" && !this.canZoomIn(scale)) return;
      if (direction === "out" && !this.canZoomOut(scale)) return;
      const zoomFactor = direction === "in" ? 1 : -1;
      const newX = scale.x + zoomFactor * sensibility;
      const newY = scale.y + zoomFactor * sensibility;
      const newZ = scale.z;
      zoomElement.style.transform = `scale3d(${newX},${newY},${newZ})`;
    }
    resetZoom(event) {
      if (!this.actions.includes("redefineZoom")) return;
      event.stopPropagation();
      event.preventDefault();
      const zoomElement = this._activeImage.querySelector(".atlas-image");
      zoomElement.style.transform = `scale3d(1,1,1)`;
      this.resetTranslation();
    }
    canZoomIn(scale) {
      return this.actions.includes("zoomIn") && scale.x < this._zoomLimit.max;
    }
    canZoomOut(scale) {
      return this.actions.includes("zoomOut") && scale.x > this._zoomLimit.min;
    }
    downloadImage(event) {
      if (!this.actions.includes("download")) return;
      event.stopPropagation();
      event.preventDefault();
      const imageElement = this._activeImage.querySelector(".atlas-image");
      const link = document.createElement("a");
      link.href = imageElement.getAttribute("data-download-url") || imageElement.getAttribute("src");
      link.download = imageElement.getAttribute("data-name") || "image.jpg";
      link.target = "_blank";
      link.click();
    }
    renderCloseButton() {
      return html55`
            <atlas-image-preview-control
                tooltip="Fechar"
                tooltip-placement="top"
                icon="x"
                class="atlas-image-preview-close"
                @atlas-image-preview-control-click=${this.closePreview}
            ></atlas-image-preview-control>
        `;
    }
    renderPrevButton() {
      return html55`
            <atlas-image-preview-control
                tooltip="Anterior"
                tooltip-placement="top"
                icon="chevron-left"
                class="atlas-image-preview-prev"
                @atlas-image-preview-control-click=${this.goToPreviousImage}
            ></atlas-image-preview-control>
        `;
    }
    renderNextButton() {
      return html55`
            <atlas-image-preview-control
                tooltip="Próximo"
                tooltip-placement="top"
                icon="chevron-right"
                class="atlas-image-preview-next"
                @atlas-image-preview-control-click=${this.goToNextImage}
            ></atlas-image-preview-control>
        `;
    }
    renderFlipControl() {
      return when34(this.actions.includes("flip"), () => html55`
                <atlas-image-preview-control
                    tooltip="Espelhar"
                    tooltip-placement="top"
                    icon="arrow-right-left"
                    @atlas-image-preview-control-click=${this.flipImage}
                ></atlas-image-preview-control>
            `);
    }
    renderRotateControl() {
      return when34(this.actions.includes("rotate"), () => html55`
                <atlas-image-preview-control
                    tooltip="Girar para a direita"
                    tooltip-placement="top"
                    icon="rotate"
                    @atlas-image-preview-control-click=${this.rotateImage}
                ></atlas-image-preview-control>
            `);
    }
    renderRedefineZoomControl() {
      return when34(this.actions.includes("redefineZoom"), () => html55`
                <atlas-image-preview-control
                    tooltip="Redefinir zoom"
                    tooltip-placement="top"
                    icon="maximize"
                    @atlas-image-preview-control-click=${this.resetZoom}
                ></atlas-image-preview-control>
            `);
    }
    renderZoomOutControl() {
      return when34(this.actions.includes("zoomOut"), () => html55`
                <atlas-image-preview-control
                    tooltip="Diminuir zoom"
                    tooltip-placement="top"
                    icon="minus-circle"
                    @atlas-image-preview-control-click=${this.zoomOut}
                ></atlas-image-preview-control>
            `);
    }
    renderZoomInControl() {
      return when34(this.actions.includes("zoomIn"), () => html55`
                <atlas-image-preview-control
                    tooltip="Aumentar zoom"
                    tooltip-placement="top"
                    icon="plus-circle"
                    @atlas-image-preview-control-click=${this.zoomIn}
                ></atlas-image-preview-control>
            `);
    }
    renderZoomControls() {
      return html55` ${this.renderRedefineZoomControl()} ${this.renderZoomOutControl()} ${this.renderZoomInControl()} `;
    }
    renderDownloadControl() {
      return when34(this.actions.includes("download"), () => html55`
                <atlas-image-preview-control
                    tooltip="Baixar"
                    tooltip-placement="top"
                    icon="download"
                    @atlas-image-preview-control-click=${this.downloadImage}
                ></atlas-image-preview-control>
            `);
    }
    renderImageControls() {
      return html55`
            <div class="atlas-image-preview-controls">
                ${this.renderFlipControl()} ${this.renderRotateControl()} ${this.renderZoomControls()}
                ${this.renderDownloadControl()}
            </div>
        `;
    }
    renderCounter() {
      if (!this._imagePreviewItems || this._imagePreviewItems.length === 1) return nothing2;
      return html55`
            <div class="atlas-image-preview-counter">
                ${this._activeImageIndex + 1} de ${this._imagePreviewItems.length}
            </div>
        `;
    }
    renderImageItemTemplate() {
      return html55`
            <template>
                <div class="atlas-image-item">
                    <picture class="atlas-image-wrapper">
                        <div class="atlas-image-flip">
                            <div class="atlas-image-rotate">
                                <img class="atlas-image" />
                            </div>
                        </div>
                    </picture>
                </div>
            </template>
        `;
    }
    onBackdropClick(event) {
      event.stopPropagation();
      event.preventDefault();
      if (this.preventClose) return;
      this.closePreview();
    }
    /** @internal */
    render() {
      const atlasImagePreviewWrapperClass = {
        "atlas-image-preview-wrapper": true,
        "open": this.open
      };
      const atlasImagePreviewClass = {
        "atlas-image-preview": true,
        "open": this.open
      };
      const atlasImagePreviewBackdropClass = {
        "atlas-image-preview-backdrop": true,
        "open": this.open
      };
      return html55`
            <slot @slotchange=${this.onSlotChange}></slot>
            <div class="${classMap40(atlasImagePreviewWrapperClass)}" @click=${this.onBackdropClick}>
                <div class="${classMap40(atlasImagePreviewBackdropClass)}"></div>
                <div class="${classMap40(atlasImagePreviewClass)}">
                    <div class="atlas-image-header"></div>
                    ${this.renderCloseButton()} ${this.renderPrevButton()} ${this.renderNextButton()}
                    ${this.renderImageControls()} ${this.renderCounter()}
                    <div class="atlas-image-preview-content"></div>
                </div>
            </div>
            ${this.renderImageItemTemplate()}
        `;
    }
  };
  AtlasImagePreview.styles = atlas_image_preview_default;
  return AtlasImagePreview;
})();
__decorateClass([property55({
  type: Boolean,
  reflect: true
})], AtlasImagePreview.prototype, "open", 2);
__decorateClass([property55({
  type: Boolean,
  reflect: true,
  attribute: "prevent-close"
})], AtlasImagePreview.prototype, "preventClose", 2);
__decorateClass([property55({
  type: Boolean,
  reflect: true,
  attribute: "prevent-open-preview-on-click"
})], AtlasImagePreview.prototype, "preventOpenPreviewOnClick", 2);
__decorateClass([property55({
  type: Array
})], AtlasImagePreview.prototype, "actions", 2);
__decorateClass([state22()], AtlasImagePreview.prototype, "_slottedImageElements", 2);
__decorateClass([state22()], AtlasImagePreview.prototype, "_imagePreviewItems", 2);
__decorateClass([state22()], AtlasImagePreview.prototype, "_activeImage", 2);
__decorateClass([state22()], AtlasImagePreview.prototype, "_activeImageIndex", 2);
__decorateClass([query8(".atlas-image-preview-content")], AtlasImagePreview.prototype, "_imagePreviewContainer", 2);
__decorateClass([query8(".atlas-image-preview-prev")], AtlasImagePreview.prototype, "_imagePreviewPrev", 2);
__decorateClass([query8(".atlas-image-preview-next")], AtlasImagePreview.prototype, "_imagePreviewNext", 2);
AtlasImagePreview = __decorateClass([customElement49("atlas-image-preview")], AtlasImagePreview);

// src/components/display/atlas-labeled-content/atlas-labeled-content.ts
import { html as html56 } from "lit";
import { customElement as customElement50, property as property56 } from "lit/decorators.js";
var AtlasLabeledContent = class extends WithPopoverMixin(AtlasElement) {
  /** @internal */
  render() {
    return html56`
            <atlas-layout gap="2">
                <atlas-layout gap="2" alignment="center" inline mobile-inline>
                    <atlas-text>${this.label}</atlas-text>
                    ${this.renderPopoverInfoIcon()}
                </atlas-layout>
                <slot></slot>
            </atlas-layout>
        `;
  }
};
__decorateClass([property56({
  type: String
})], AtlasLabeledContent.prototype, "label", 2);
AtlasLabeledContent = __decorateClass([customElement50("atlas-labeled-content")], AtlasLabeledContent);

// src/components/display/atlas-link/atlas-link.ts
import { html as html57 } from "lit";
import { customElement as customElement51, property as property57, state as state23 } from "lit/decorators.js";
import { classMap as classMap41 } from "lit/directives/class-map.js";
import { ifDefined as ifDefined12 } from "lit/directives/if-defined.js";
import { when as when35 } from "lit/directives/when.js";

// src/components/display/atlas-link/atlas-link.scss
import { css as css50 } from "lit-element/lit-element.js";
var atlas_link_default = css50`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: inline-block;
}

:host([block]) {
  display: block;
}

:host([skeleton-loading]) {
  width: 100%;
}

.link {
  width: fit-content;
  text-decoration: none;
  color: var(--atlas-link-color, #0d6efd);
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  display: inline;
  border-radius: 0.25rem;
  transition: all 0.2s;
  cursor: pointer;
}
.link span {
  text-decoration: underline;
  font-weight: var(--atlas-link-weight, 400);
}
.link slot {
  display: none;
}
.link.has-icon {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}
.link.skeleton {
  height: 1.5rem;
  display: block;
}
.link:hover {
  color: var(--atlas-link-color-hover, #0a58ca);
}
.link:focus-visible {
  outline: none;
  background: rgba(var(--atlas-primary-300-rgb), 0.25);
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-300-rgb), 0.25);
}
.link.disabled {
  opacity: 0.65;
  cursor: default;
}
.link.block {
  display: block;
  width: 100%;
}
.link.block span {
  display: none;
}
.link.block slot {
  display: contents;
}
.link.link-white {
  color: #ffffff;
}
.link.content-width {
  width: auto;
}
.link.lg {
  font-size: 1.25rem;
}
.link.lg.skeleton {
  height: 1.875rem;
}
.link.md {
  font-size: 1rem;
}
.link.md.skeleton {
  height: 1.5rem;
}
.link.sm {
  font-size: 0.875rem;
}
.link.sm.skeleton {
  height: 1.3125rem;
}
.link.xs {
  font-size: 0.8rem;
}
.link.xs.skeleton {
  height: 1.2rem;
}`;

// src/components/display/atlas-link/atlas-link.ts
var AtlasLink = /*#__PURE__*/(() => {
  let AtlasLink = class extends WithTooltipMixin(AtlasElement) {
    constructor() {
      super(...arguments);
      this.size = "md";
      this._trimmedText = "";
    }
    onLinkClick() {
      if (this.disabled) return;
      emit(this, "atlas-link-click", {
        detail: {
          content: this._trimmedText
        }
      });
    }
    onSlotChange() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        if (this.skeletonLoading) return;
        const slotContent = getSlotTextContent(this.shadowRoot.querySelector("slot"));
        this._trimmedText = slotContent.trim();
      });
    }
    targetValue() {
      if (this.external) return "_blank";
      return this.target;
    }
    renderSkeleton() {
      const skeletonClass = {
        link: true,
        skeleton: true,
        [this.size]: !!this.size
      };
      return html57`<div class="${classMap41(skeletonClass)}"></div>`;
    }
    renderElement() {
      const linkClass = {
        "link": true,
        "disabled": this.disabled,
        "link-white": this.white,
        "block": this.block,
        "content-width": this.contentWidth,
        "has-icon": !!this.icon,
        [this.size]: !!this.size
      };
      return html57`
            <a
                href="${ifDefined12(this.href ? this.href : void 0)}"
                class=${classMap41(linkClass)}
                rel="${ifDefined12(this.external ? "noreferrer" : void 0)}"
                target=${ifDefined12(this.target || this.external ? this.targetValue() : void 0)}
                @click=${this.onLinkClick}
                data-atlas-tooltip="link-tooltip"
            >
                ${when35(!!this.icon, () => html57`<atlas-icon name=${this.icon} size="auto"></atlas-icon>`)}
                <span>${this._trimmedText}</span>
                <slot @slotchange=${this.onSlotChange}></slot>
            </a>
            ${this.renderTooltip("link-tooltip")}
        `;
    }
  };
  AtlasLink.styles = atlas_link_default;
  return AtlasLink;
})();
__decorateClass([property57({
  type: String
})], AtlasLink.prototype, "href", 2);
__decorateClass([property57({
  type: String
})], AtlasLink.prototype, "icon", 2);
__decorateClass([property57({
  type: String
})], AtlasLink.prototype, "size", 2);
__decorateClass([property57({
  type: String
})], AtlasLink.prototype, "target", 2);
__decorateClass([property57({
  type: Boolean
})], AtlasLink.prototype, "external", 2);
__decorateClass([property57({
  type: Boolean
})], AtlasLink.prototype, "disabled", 2);
__decorateClass([property57({
  type: Boolean
})], AtlasLink.prototype, "block", 2);
__decorateClass([property57({
  type: Boolean
})], AtlasLink.prototype, "white", 2);
__decorateClass([property57({
  type: Boolean,
  attribute: "content-width"
})], AtlasLink.prototype, "contentWidth", 2);
__decorateClass([state23()], AtlasLink.prototype, "_trimmedText", 2);
AtlasLink = __decorateClass([customElement51("atlas-link")], AtlasLink);

// src/components/display/atlas-loading/atlas-loading.ts
import { LitElement as LitElement14, html as html58 } from "lit";
import { customElement as customElement52, property as property58, state as state24 } from "lit/decorators.js";
import { classMap as classMap42 } from "lit/directives/class-map.js";
import { when as when36 } from "lit/directives/when.js";

// src/components/display/atlas-loading/atlas-loading.scss
import { css as css51 } from "lit-element/lit-element.js";
var atlas_loading_default = css51`/* stylelint-disable at-rule-no-vendor-prefix, property-no-vendor-prefix */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.loading {
  display: none;
  position: relative;
  align-items: center;
  justify-items: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  gap: 1rem;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  padding: 1rem;
}
.loading .loading-image {
  align-self: end;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading .loading-image .loading-spin {
  transform-origin: 50% 50%;
  animation: spin-rotate 2s infinite linear;
  -webkit-animation: spin-rotate 2s infinite linear;
  transform-box: fill-box;
}
.loading .loading-image .circular-loader {
  width: 64px;
  -webkit-animation: spin-rotate 5s linear infinite;
  animation: spin-rotate 5s linear infinite;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
  transform-origin: center center;
  position: absolute;
}
.loading .loading-image .circular-loader.bigger-spinner {
  width: 100px;
}
.loading .loading-image .loader-path {
  stroke-dasharray: 150, 200;
  stroke-dashoffset: -10;
  -webkit-animation: dash-circle 1.5s ease-in-out infinite, dash-color 6s ease-in-out infinite;
  animation: dash-circle 1.5s ease-in-out infinite, dash-color 6s ease-in-out infinite;
  stroke-linecap: round;
  stroke: var(--atlas-primary);
}
.loading .loading-image .logo-loading {
  animation: scale-logo-loading 2.5s ease-in-out infinite;
}
.loading .loading-image path {
  fill: var(--atlas-primary);
}
@media screen and (min-width: 576px) {
  .loading .loading-image {
    align-self: end;
  }
}
.loading .loading-description {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  align-self: start;
}
.loading.show {
  display: grid;
}
.loading .close-button {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
}

@keyframes spin-rotate {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-webkit-keyframes spin-rotate {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes dash-circle {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124;
  }
}
@-webkit-keyframes dash-circle {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124;
  }
}
@keyframes dash-color {
  0% {
    stroke: var(--atlas-primary);
  }
  40% {
    stroke: var(--atlas-primary);
  }
  66% {
    stroke: var(--atlas-primary);
  }
  80%, 90% {
    stroke: var(--atlas-primary);
  }
}
@-webkit-keyframes dash-color {
  0% {
    stroke: var(--atlas-primary);
  }
  40% {
    stroke: var(--atlas-primary);
  }
  66% {
    stroke: var(--atlas-primary);
  }
  80%, 90% {
    stroke: var(--atlas-primary);
  }
}
@-webkit-keyframes scale-logo-loading {
  0% {
    scale: 1;
  }
  50% {
    scale: 1.1;
  }
  100% {
    scale: 1;
  }
}
/* stylelint-enable at-rule-no-vendor-prefix, property-no-vendor-prefix */`;

// src/components/display/atlas-loading/atlas-loading.ts
var AtlasLoading = /*#__PURE__*/(() => {
  let AtlasLoading = class extends LitElement14 {
    constructor() {
      super();
      this.contentLoading = false;
      this.showCloseButton = false;
      this.visible = false;
      this.show = this.show.bind(this);
      this.close = this.close.bind(this);
    }
    /** @internal */
    firstUpdated() {
      setTimeout(this.show, 100);
    }
    /**
     * Exibe o loading
     */
    show() {
      this.visible = true;
      emit(this, "atlas-loading-show", {
        trackDisable: true
      });
    }
    /**
     * Fecha o loading
     */
    close() {
      this.visible = false;
      emit(this, "atlas-loading-close", {
        trackDisable: true
      });
    }
    /**
     * Fecha o loading e remove o elemento do DOM
     */
    destroy() {
      this.close();
      setTimeout(() => {
        this.remove();
      }, 150);
    }
    closeFromButton() {
      this.destroy();
      emit(this, "atlas-loading-close-button-click", {
        trackDisable: true
      });
    }
    renderCustomImage() {
      return html58`
            <img
                class="logo-loading"
                src=${this.src}
                width=${this.width}
                height=${this.height}
                alt=${this.alt || "loading image"}
            />
        `;
    }
    renderDefaultImage() {
      return when36(this.contentLoading, () => html58`
                <svg class="logo-loading" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="64">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M46.2004 20.0293C45.1224 20.6835 46.6433 21.0047 39.0958 25.5836C38.1968 26.1292 30.5232 30.9105 33.7674 36.5279C34.2397 37.3463 35.3118 39.1635 35.8354 40.0523H29.1621C29.6857 39.1635 30.7578 37.3463 31.2301 36.5279C34.4744 30.9105 26.8008 26.1292 25.9017 25.5836C18.3542 21.0047 19.8737 20.6849 18.7972 20.0293C18.5273 19.8665 18.2032 20.4268 18.102 20.6013C17.4097 21.7996 18.0125 26.6396 20.3342 28.0491C19.6948 29.1549 20.8388 32.2496 23.2324 33.7016C22.235 35.4264 23.8498 37.3404 27.6074 39.7765L25.2138 43.6192C25.1286 43.7614 25.084 43.9242 25.0848 44.09C25.0848 44.5623 25.5086 44.9333 26.0484 44.9333C26.3975 44.9435 26.7258 44.7677 26.9108 44.4713L28.6018 41.7228H36.4177L38.1132 44.4581C38.2877 44.7559 38.6118 44.9333 38.9844 44.9333C39.5241 44.9333 39.948 44.5623 39.948 44.09C39.9505 43.9158 39.8965 43.7454 39.794 43.6045L37.4004 39.7692C41.1506 37.3375 42.761 35.4249 41.7652 33.7016C44.1588 32.2496 45.3028 29.1549 44.6633 28.0491C46.985 26.6411 47.5878 21.8011 46.8956 20.6028C46.7944 20.4268 46.4702 19.8665 46.2004 20.0308V20.0293Z"
                    ></path>
                </svg>
            `, () => html58`
                <svg class="logo-loading" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" width="80">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M60.5525 22.044C58.9355 23.0252 61.2169 23.507 49.8957 30.3754C48.5471 31.1938 37.0367 38.3658 41.9031 46.7918C42.6115 48.0194 44.2197 50.7452 45.0051 52.0784H34.9951C35.7805 50.7452 37.3887 48.0194 38.0971 46.7918C42.9635 38.3658 31.4531 31.1938 30.1045 30.3754C18.7833 23.507 21.0625 23.0274 19.4477 22.044C19.0429 21.7998 18.5567 22.6402 18.4049 22.902C17.3665 24.6994 18.2707 31.9594 21.7533 34.0736C20.7941 35.7324 22.5101 40.3744 26.1005 42.5524C24.6045 45.1396 27.0267 48.0106 32.6631 51.6648L29.0727 57.4288C28.9449 57.6421 28.8779 57.8863 28.8791 58.135C28.8791 58.8434 29.5149 59.4 30.3245 59.4C30.8482 59.4153 31.3407 59.1515 31.6181 58.707L34.1547 54.5842H45.8785L48.4217 58.6872C48.6835 59.1338 49.1697 59.4 49.7285 59.4C50.5381 59.4 51.1739 58.8434 51.1739 58.135C51.1777 57.8736 51.0967 57.6181 50.9429 57.4068L47.3525 51.6538C52.9779 48.0062 55.3935 45.1374 53.8997 42.5524C57.4901 40.3744 59.2061 35.7324 58.2469 34.0736C61.7295 31.9616 62.6337 24.7016 61.5953 22.9042C61.4435 22.6402 60.9573 21.7998 60.5525 22.0462V22.044Z"
                    ></path>
                </svg>
            `);
    }
    renderSpinnerLogo() {
      if (this.src) return this.renderCustomImage();
      return this.renderDefaultImage();
    }
    renderCloseButton() {
      return when36(this.showCloseButton, () => html58`
                <atlas-icon-button icon="x" class="close-button" @click=${this.closeFromButton}></atlas-icon-button>
            `);
    }
    renderHeading() {
      return when36(this.contentLoading, () => html58`
                <atlas-heading size="h6" theme="primary">Aguarde</atlas-heading>
                <atlas-text size="sm" theme="primary" alignment="center">
                    <slot>${this.message}</slot>
                </atlas-text>
            `, () => html58`
                <atlas-heading size="h3" theme="primary">Aguarde</atlas-heading>
                <atlas-heading size="h4" theme="primary" alignment="center">
                    <slot>${this.message}</slot>
                </atlas-heading>
            `);
    }
    /** @internal */
    render() {
      const spinnerClass = {
        "circular-loader": true,
        "bigger-spinner": !this.contentLoading
      };
      const loadingClass = {
        loading: true,
        show: this.visible
      };
      return html58`
            <div class="${classMap42(loadingClass)}">
                ${this.renderCloseButton()}
                <div class="loading-image">
                    <svg class="${classMap42(spinnerClass)}" viewBox="25 25 50 50">
                        <circle class="loader-path" cx="50" cy="50" r="20" fill="none" stroke-width="2"></circle>
                    </svg>
                    ${this.renderSpinnerLogo()}
                </div>
                <div class="loading-description">${this.renderHeading()}</div>
            </div>
        `;
    }
  };
  AtlasLoading.styles = atlas_loading_default;
  return AtlasLoading;
})();
__decorateClass([property58({
  type: String
})], AtlasLoading.prototype, "message", 2);
__decorateClass([property58({
  type: Boolean,
  attribute: "content-loading"
})], AtlasLoading.prototype, "contentLoading", 2);
__decorateClass([property58({
  type: String
})], AtlasLoading.prototype, "src", 2);
__decorateClass([property58({
  type: String
})], AtlasLoading.prototype, "alt", 2);
__decorateClass([property58({
  type: Number
})], AtlasLoading.prototype, "width", 2);
__decorateClass([property58({
  type: Number
})], AtlasLoading.prototype, "height", 2);
__decorateClass([property58({
  type: Boolean,
  attribute: "show-close-button"
})], AtlasLoading.prototype, "showCloseButton", 2);
__decorateClass([state24()], AtlasLoading.prototype, "visible", 2);
AtlasLoading = __decorateClass([customElement52("atlas-loading")], AtlasLoading);

// src/components/display/atlas-modal/atlas-modal.ts
import { html as html59 } from "lit";
import { customElement as customElement53, property as property59, query as query9, state as state25 } from "lit/decorators.js";
import { classMap as classMap43 } from "lit/directives/class-map.js";
import { styleMap as styleMap15 } from "lit/directives/style-map.js";
import { when as when37 } from "lit/directives/when.js";

// src/components/display/atlas-modal/atlas-modal.scss
import { css as css52 } from "lit-element/lit-element.js";
var atlas_modal_default = css52`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Transitions */
/* Z-index mapping for the floating elements */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

/* Transitions */
.fade {
  transition: opacity 0.25s ease;
}
.fade:not(.show) {
  opacity: 0;
}

.fade-and-scale {
  opacity: 0;
  transform: scale(0.7);
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.fade-and-scale.scale-vertically {
  transform: scale(1, 0.7);
}
.fade-and-scale.show {
  opacity: 1;
  transform: scale(1);
}

:host([data-popper-placement=top]),
:host([data-popper-placement=top]) .fade-and-scale,
div[data-popper-placement=top].fade-and-scale,
div[data-popper-placement=top] > .fade-and-scale,
.fade-and-scale.scale-top {
  transform-origin: center bottom;
}

:host([data-popper-placement=top-start]),
:host([data-popper-placement=top-start]) .fade-and-scale,
div[data-popper-placement=top-start].fade-and-scale,
div[data-popper-placement=top-start] > .fade-and-scale,
.fade-and-scale.scale-top-start {
  transform-origin: left bottom;
}

:host([data-popper-placement=top-end]),
:host([data-popper-placement=top-end]) .fade-and-scale,
div[data-popper-placement=top-end].fade-and-scale,
div[data-popper-placement=top-end] > .fade-and-scale,
.fade-and-scale.scale-top-end {
  transform-origin: right bottom;
}

:host([data-popper-placement=bottom]),
:host([data-popper-placement=bottom]) .fade-and-scale,
div[data-popper-placement=bottom].fade-and-scale,
div[data-popper-placement=bottom] > .fade-and-scale,
.fade-and-scale.scale-bottom {
  transform-origin: center top;
}

:host([data-popper-placement=bottom-start]),
:host([data-popper-placement=bottom-start]) .fade-and-scale,
div[data-popper-placement=bottom-start].fade-and-scale,
div[data-popper-placement=bottom-start] > .fade-and-scale,
.fade-and-scale.scale-bottom-start {
  transform-origin: left top;
}

:host([data-popper-placement=bottom-end]),
:host([data-popper-placement=bottom-end]) .fade-and-scale,
div[data-popper-placement=bottom-end].fade-and-scale,
div[data-popper-placement=bottom-end] > .fade-and-scale,
.fade-and-scale.scale-bottom-end {
  transform-origin: right top;
}

:host([data-popper-placement=left]),
:host([data-popper-placement=left]) .fade-and-scale,
div[data-popper-placement=left].fade-and-scale,
div[data-popper-placement=left] > .fade-and-scale,
.fade-and-scale.scale-left {
  transform-origin: right center;
}

:host([data-popper-placement=left-start]),
:host([data-popper-placement=left-start]) .fade-and-scale,
div[data-popper-placement=left-start].fade-and-scale,
div[data-popper-placement=left-start] > .fade-and-scale,
.fade-and-scale.scale-left-start {
  transform-origin: right top;
}

:host([data-popper-placement=left-end]),
:host([data-popper-placement=left-end]) .fade-and-scale,
div[data-popper-placement=left-end].fade-and-scale,
div[data-popper-placement=left-end] > .fade-and-scale,
.fade-and-scale.scale-left-end {
  transform-origin: right bottom;
}

:host([data-popper-placement=right]),
:host([data-popper-placement=right]) .fade-and-scale,
div[data-popper-placement=right].fade-and-scale,
div[data-popper-placement=right] > .fade-and-scale,
.fade-and-scale.scale-right {
  transform-origin: left center;
}

:host([data-popper-placement=right-start]),
:host([data-popper-placement=right-start]) .fade-and-scale,
div[data-popper-placement=right-start].fade-and-scale,
div[data-popper-placement=right-start] > .fade-and-scale,
.fade-and-scale.scale-right-start {
  transform-origin: left top;
}

:host([data-popper-placement=right-end]),
:host([data-popper-placement=right-end]) .fade-and-scale,
div[data-popper-placement=right-end].fade-and-scale,
div[data-popper-placement=right-end] > .fade-and-scale,
.fade-and-scale.scale-right-end {
  transform-origin: left bottom;
}

:host {
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  z-index: 500;
  pointer-events: none;
  width: 100dvw;
  height: 100dvh;
}

:host([open]) {
  pointer-events: all;
}

:host([skeleton-loading]) {
  display: block;
  pointer-events: none;
}

.modal-overlay {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-overlay:has(.modal.size-fullscreen) {
  align-items: flex-start;
  justify-content: flex-start;
}

.modal {
  width: calc(100% - 2rem);
  background: #ffffff;
  max-height: 92%;
  border-radius: 0.5rem;
  border: 1px solid #ced4da;
  position: relative;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: auto minmax(auto, 1fr);
}
.modal:not(.show) {
  display: none;
}

.close-button {
  position: absolute;
  top: 1.5rem;
  right: 1rem;
}

.modal-title {
  flex-shrink: 0;
  padding: 1.5rem 1rem;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #ced4da;
  height: 4.5rem;
}
.modal-title .header-logo {
  height: 100%;
}
.modal-title .header-img {
  width: 100%;
  height: 100%;
  border-radius: 0.5rem 0.5rem 0 0;
}
.modal-title .illustration-container {
  height: 200px;
}

.modal-content {
  flex-grow: 1;
  padding: 1rem;
  box-sizing: border-box;
  overflow: visible auto;
}

.modal-footer {
  flex-shrink: 0;
  padding: 1rem;
  box-sizing: border-box;
  gap: 1rem;
  display: none;
  justify-content: flex-end;
  border-top: 1px solid #ced4da;
}

.modal.with-illustration .modal-title {
  padding-top: 1rem;
  padding-bottom: 0;
  border-bottom: 0;
  height: unset;
}

.modal.with-image .modal-title {
  padding: 0;
  border-bottom: 0;
  height: 198px;
}
.modal.with-image .modal-title img {
  object-fit: cover;
}

.modal.with-logo .modal-title {
  padding: 1rem;
}

.modal.show-footer {
  grid-template-rows: auto minmax(auto, 1fr) auto;
}
.modal.show-footer .modal-footer {
  display: flex;
}

.modal.size-fullscreen {
  width: 100dvw;
  height: 100dvh;
  max-height: unset;
  border-radius: 0;
  border: 0;
}
.modal.size-fullscreen.with-image .modal-title .header-img {
  border-radius: 0;
}

.modal.is-wizard .modal-content {
  padding: 0;
}

@media screen and (min-width: 768px) {
  .modal {
    width: 500px;
  }
  .modal.with-image .modal-title {
    height: 250px;
  }
  .modal.size-large {
    width: 500px;
  }
  .modal.size-extra-large {
    width: 500px;
  }
}
@media screen and (min-width: 992px) {
  .modal:not(.is-wizard) .modal-content {
    padding: 2rem 2.5rem;
  }
  .modal.with-illustration .modal-title {
    padding-top: 2rem;
  }
  .modal.size-large {
    width: 800px;
  }
  .modal.size-large.with-image .modal-title {
    height: 360px;
  }
  .modal.size-extra-large {
    width: 800px;
  }
  .modal.size-extra-large.with-image .modal-title {
    height: 360px;
  }
}
@media screen and (min-width: 1200px) {
  .modal.size-extra-large {
    width: 1140px;
  }
  .modal.size-extra-large.with-image .modal-title {
    height: 456px;
  }
}`;

// src/components/display/atlas-modal/atlas-modal.ts
var AtlasModal = /*#__PURE__*/(() => {
  let AtlasModal = class extends AtlasElement {
    constructor() {
      super();
      this.size = "default";
      this._isVisible = false;
      this._showFooter = false;
      this._hasSlottedWizard = false;
      this._deviceController = new DeviceController(this);
      this.openModal = this.openModal.bind(this);
      this.closeModal = this.closeModal.bind(this);
      this.onDocumentKeyDown = this.onDocumentKeyDown.bind(this);
      this.onClickOverlay = this.onClickOverlay.bind(this);
      this._triggerController = new TriggerController(this, "click");
    }
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.addEventListener("atlas-wizard-close", this.closeModal);
    }
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      this.removeEventListener("atlas-wizard-close", this.closeModal);
    }
    /**
     * Abre a modal
     */
    openModal() {
      this._triggerController.show();
    }
    /**
     * Fecha a modal
     */
    closeModal() {
      this._triggerController.hide();
    }
    /**
     * @internal
     */
    onTriggerActivate() {
      var _a;
      this.open = this._triggerController.open;
      (_a = this._triggerController.triggerElement) == null ? void 0 : _a.blur();
    }
    onChangeOpenState() {
      if (this.open) {
        this.onOpenModal();
      } else {
        this.onCloseModal();
      }
    }
    onOpenModal() {
      setTimeout(() => {
        this._isVisible = true;
      }, 0);
      emit(this, "atlas-modal-open");
      document.addEventListener("keydown", this.onDocumentKeyDown);
      document.body.classList.add("disable-scroll-modal");
    }
    onCloseModal() {
      setTimeout(() => {
        this._isVisible = false;
      }, 0);
      emit(this, "atlas-modal-close");
      document.removeEventListener("keydown", this.onDocumentKeyDown);
      document.body.classList.remove("disable-scroll-modal");
      if (this.destroyOnClose) {
        setTimeout(() => this.remove(), 250);
      }
    }
    onClickClose() {
      this.closeModal();
    }
    onDocumentKeyDown(event) {
      if (!this.disableAutoClose && event.key === "Escape") {
        this.closeModal();
      }
    }
    onClickOverlay(event) {
      if (!this.open || this.disableAutoClose) return;
      const composedPath = event.composedPath();
      const isModalTarget = composedPath.includes(this._modal);
      if (!isModalTarget) {
        this.closeModal();
      }
    }
    onChangeSlottedContent() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const contentSlot = this.shadowRoot.querySelector("slot:not([name])");
        const assignedElements = (contentSlot == null ? void 0 : contentSlot.assignedElements()) || [];
        const slottedWizard = findElementByTagName(assignedElements, "ATLAS-WIZARD");
        slottedWizard == null ? void 0 : slottedWizard.toggleAttribute("hide-header", true);
        slottedWizard == null ? void 0 : slottedWizard.toggleAttribute("is-modal-wizard", true);
        this._hasSlottedWizard = !!slottedWizard;
      });
    }
    onChangeSlottedActions() {
      this._showFooter = !isEmptySlot(this, "actions");
    }
    renderCloseButton() {
      return when37(!this.hideCloseButton && !this.headerImg && !this.skeletonLoading, () => html59`
                <atlas-icon-button
                    icon="x"
                    size="3x"
                    theme="secondary"
                    class="close-button"
                    @click=${this.onClickClose}
                ></atlas-icon-button>
            `);
    }
    renderHeader() {
      if (this.headerLogo) {
        return html59`
                <div class="modal-title">
                    <img class="header-logo" src=${this.headerLogo} alt=${this.headerImgDescription} />
                </div>
            `;
      }
      if (this.headerImg) {
        return html59`
                <div class="modal-title">
                    <img class="header-img" src=${this.headerImg} alt=${this.headerImgDescription} />
                </div>
            `;
      }
      if (this.headerIllustration) {
        return html59`
                <div class="modal-title">
                    <div class="illustration-container">
                        <atlas-illustration
                            name=${this.headerIllustration}
                            alt=${this.headerImgDescription}
                            scale-vertically
                        ></atlas-illustration>
                    </div>
                </div>
            `;
      }
      return html59`
            <div class="modal-title">
                <atlas-heading size="h5">${this.header}</atlas-heading>
            </div>
        `;
    }
    render() {
      const isMobileFullscreen = this._deviceController.isMobile && this._hasSlottedWizard;
      const isFullScreen = this.size === "fullscreen" || isMobileFullscreen;
      const modalOverlayClass = {
        "modal-overlay": true,
        "fade": true,
        "show": this._isVisible
      };
      const modalClass = {
        "modal": true,
        "fade-and-scale": true,
        "show": this._isVisible,
        "with-image": !!this.headerImg,
        "with-illustration": !!this.headerIllustration,
        "with-logo": !!this.headerLogo,
        "show-footer": this._showFooter,
        "is-wizard": this._hasSlottedWizard,
        [`size-${isFullScreen ? "fullscreen" : this.size}`]: !!this.size || isFullScreen
      };
      const modalStyle = {
        height: this.height && !isFullScreen ? `${this.height}px` : null
      };
      return html59`
            <div class=${classMap43(modalOverlayClass)} @click=${this.onClickOverlay}>
                <div class=${classMap43(modalClass)} style=${styleMap15(modalStyle)}>
                    ${this.renderCloseButton()} ${this.renderHeader()}
                    <div class="modal-content">
                        <slot @slotchange=${this.onChangeSlottedContent}></slot>
                    </div>
                    <div class="modal-footer">
                        <slot name="actions" @slotchange=${this.onChangeSlottedActions}></slot>
                    </div>
                </div>
            </div>
        `;
    }
  };
  AtlasModal.styles = atlas_modal_default;
  return AtlasModal;
})();
__decorateClass([property59({
  type: String
})], AtlasModal.prototype, "size", 2);
__decorateClass([property59({
  type: Number
})], AtlasModal.prototype, "height", 2);
__decorateClass([property59({
  type: Boolean,
  reflect: true
})], AtlasModal.prototype, "open", 2);
__decorateClass([property59({
  type: Boolean,
  reflect: true,
  attribute: "disable-auto-close"
})], AtlasModal.prototype, "disableAutoClose", 2);
__decorateClass([property59({
  type: Boolean,
  reflect: true,
  attribute: "hide-close-button"
})], AtlasModal.prototype, "hideCloseButton", 2);
__decorateClass([property59({
  type: String
})], AtlasModal.prototype, "header", 2);
__decorateClass([property59({
  type: String,
  attribute: "header-logo"
})], AtlasModal.prototype, "headerLogo", 2);
__decorateClass([property59({
  type: String,
  attribute: "header-img"
})], AtlasModal.prototype, "headerImg", 2);
__decorateClass([property59({
  type: String,
  attribute: "header-illustration"
})], AtlasModal.prototype, "headerIllustration", 2);
__decorateClass([property59({
  type: String,
  attribute: "header-img-description"
})], AtlasModal.prototype, "headerImgDescription", 2);
__decorateClass([property59({
  type: Boolean,
  attribute: "destroy-on-close"
})], AtlasModal.prototype, "destroyOnClose", 2);
__decorateClass([state25()], AtlasModal.prototype, "_isVisible", 2);
__decorateClass([state25()], AtlasModal.prototype, "_showFooter", 2);
__decorateClass([state25()], AtlasModal.prototype, "_hasSlottedWizard", 2);
__decorateClass([query9(".modal")], AtlasModal.prototype, "_modal", 2);
__decorateClass([Watch("open")], AtlasModal.prototype, "onChangeOpenState", 1);
AtlasModal = __decorateClass([customElement53("atlas-modal")], AtlasModal);

// src/components/display/atlas-notification-card/atlas-notification-card.ts
import { LitElement as LitElement15, html as html60 } from "lit";
import { customElement as customElement54, property as property60 } from "lit/decorators.js";
import { ifDefined as ifDefined13 } from "lit/directives/if-defined.js";
import { when as when38 } from "lit/directives/when.js";

// src/components/display/atlas-notification-card/atlas-notification-card.scss
import { css as css53 } from "lit-element/lit-element.js";
var atlas_notification_card_default = css53`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Transitions */
:host {
  display: inline-flex;
  width: 100%;
}

.notification-card {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 16px;
  width: 100%;
  border-top: 1px solid #ced4da;
}
.notification-card .notification-icon {
  flex: 0 0 50px;
  height: 50px;
  border-radius: 50%;
  background: #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.notification-card .notification-icon .overlay-icon {
  position: absolute;
  bottom: 2px;
  right: 2px;
}
.notification-card .notification-info {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}
.notification-card .notification-info .notification-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.25;
  color: #212529;
}
.notification-card .notification-info .notification-description {
  font-size: 0.8rem;
  line-height: 1.5;
  color: #687078;
}`;

// src/components/display/atlas-notification-card/atlas-notification-card.ts
var AtlasNotificationCard = /*#__PURE__*/(() => {
  let AtlasNotificationCard = class extends LitElement15 {
    onClickLink() {
      emit(this, "atlas-notification-link-click");
    }
    renderOverlayIcon() {
      return when38(!!this.overlayIcon, () => html60`
                <atlas-icon
                    class="overlay-icon"
                    name=${this.overlayIcon}
                    theme=${this.overlayTheme || "secondary"}
                    size="2x"
                ></atlas-icon>
            `);
    }
    renderLink() {
      return when38(!!this.linkText, () => html60`
                <atlas-link
                    size="xs"
                    @atlas-link-click=${this.onClickLink}
                    href=${ifDefined13(this.linkPath || void 0)}
                    ?external=${this.externalLink}
                >
                    ${this.linkText}
                </atlas-link>
            `);
    }
    /** @internal */
    render() {
      return html60`
            <div class="notification-card">
                <div class="notification-icon">
                    <atlas-icon name=${this.icon} size="3x" theme="secondary"></atlas-icon>
                    ${this.renderOverlayIcon()}
                </div>
                <div class="notification-info">
                    <h6 class="notification-title">${this.header}</h6>
                    <span class="notification-description">${this.description}</span>
                    ${this.renderLink()}
                </div>
            </div>
        `;
    }
  };
  AtlasNotificationCard.styles = atlas_notification_card_default;
  return AtlasNotificationCard;
})();
__decorateClass([property60({
  type: String
})], AtlasNotificationCard.prototype, "icon", 2);
__decorateClass([property60({
  type: String,
  attribute: "overlay-icon"
})], AtlasNotificationCard.prototype, "overlayIcon", 2);
__decorateClass([property60({
  type: String,
  attribute: "overlay-theme"
})], AtlasNotificationCard.prototype, "overlayTheme", 2);
__decorateClass([property60({
  type: String
})], AtlasNotificationCard.prototype, "header", 2);
__decorateClass([property60({
  type: String
})], AtlasNotificationCard.prototype, "description", 2);
__decorateClass([property60({
  type: String,
  attribute: "link-text"
})], AtlasNotificationCard.prototype, "linkText", 2);
__decorateClass([property60({
  type: String,
  attribute: "link-path"
})], AtlasNotificationCard.prototype, "linkPath", 2);
__decorateClass([property60({
  type: Boolean,
  attribute: "external-link"
})], AtlasNotificationCard.prototype, "externalLink", 2);
AtlasNotificationCard = __decorateClass([customElement54("atlas-notification-card")], AtlasNotificationCard);

// src/components/display/atlas-offcanvas/atlas-offcanvas.ts
import { html as html61 } from "lit";
import { customElement as customElement55, property as property61, state as state26 } from "lit/decorators.js";
import { classMap as classMap44 } from "lit/directives/class-map.js";
import { when as when39 } from "lit/directives/when.js";

// src/components/display/atlas-offcanvas/atlas-offcanvas.scss
import { css as css54 } from "lit-element/lit-element.js";
var atlas_offcanvas_default = css54`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Z-index mapping for the floating elements */
:host {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: fixed;
  pointer-events: none;
  z-index: 99;
}

:host([open]) {
  pointer-events: all;
}

.atlas-offcanvas-backdrop {
  width: 100%;
  height: 100%;
  background: rgba(var(--atlas-dark-rgb), 40%);
  position: relative;
  visibility: hidden;
  transition: visibility 0.3s ease-in-out;
}

.atlas-offcanvas {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: absolute;
  background-color: #ffffff;
  border-left: 1px solid #ced4da;
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
}
.atlas-offcanvas .atlas-offcanvas-header {
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 1.5rem 1rem;
  min-height: 74px;
  box-sizing: border-box;
  border-bottom: 1px solid #ced4da;
}
.atlas-offcanvas .atlas-offcanvas-header .header-actions {
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-items: flex-end;
  flex-shrink: 0;
}
.atlas-offcanvas .atlas-offcanvas-header .close-button {
  position: relative;
  display: block;
  padding: 0;
  border: 0;
  cursor: pointer;
  margin: auto 0;
  background: none;
}
.atlas-offcanvas .atlas-offcanvas-header.with-image {
  justify-content: center;
}
.atlas-offcanvas .atlas-offcanvas-header.with-image .close-button {
  position: absolute;
  right: 1rem;
  top: 0;
  bottom: 0;
}
.atlas-offcanvas .atlas-offcanvas-content {
  flex-grow: 1;
  padding: 0.5rem;
  overflow: visible auto;
}
.atlas-offcanvas .atlas-offcanvas-content.filter {
  display: contents;
}
.atlas-offcanvas .atlas-offcanvas-content.padding-none {
  padding: 0;
}
.atlas-offcanvas .atlas-offcanvas-content.padding-xs {
  padding: 0.5rem;
}
.atlas-offcanvas .atlas-offcanvas-content.padding-lg {
  padding: 1rem;
}
.atlas-offcanvas .atlas-offcanvas-footer {
  flex-shrink: 0;
  padding: 1rem;
  box-sizing: border-box;
  gap: 1rem;
  display: none;
  justify-content: flex-end;
  border-top: 1px solid #ced4da;
}
.atlas-offcanvas .atlas-offcanvas-footer.has-button-block {
  width: 100%;
  justify-content: center;
  padding: 0.5rem;
}
.atlas-offcanvas .atlas-offcanvas-footer.has-button-block ::slotted(atlas-button) {
  width: 100%;
}
.atlas-offcanvas.show-footer .atlas-offcanvas-footer {
  display: flex;
}
@media screen and (min-width: 992px) {
  .atlas-offcanvas {
    width: 500px;
    right: 0;
    left: auto;
  }
  .atlas-offcanvas .atlas-offcanvas-content {
    padding: 1rem;
  }
  .atlas-offcanvas .atlas-offcanvas-content.padding-xs {
    padding: 1rem;
  }
  .atlas-offcanvas .atlas-offcanvas-content.padding-lg {
    padding: 2rem;
  }
}

.atlas-offcanvas-backdrop.show {
  visibility: visible;
}
.atlas-offcanvas-backdrop.show .atlas-offcanvas {
  transform: translateX(0%);
}`;

// src/components/display/atlas-offcanvas/atlas-offcanvas.ts
var AtlasOffcanvas = /*#__PURE__*/(() => {
  let AtlasOffcanvas = class extends AtlasElement {
    constructor() {
      super();
      this.hasButtonBlock = false;
      this.padding = "xs";
      this._showFooter = false;
      this._triggerController = new TriggerController(this, "click");
      this.onClickBackdropOffcanvas = this.onClickBackdropOffcanvas.bind(this);
    }
    onOpenChange() {
      document.body.classList.toggle("disable-scroll-offcanvas", this.open);
      if (this.open) {
        this.onOpenOverlay();
      } else {
        this.onCloseOverlay();
      }
    }
    /**
     * Mostra o offcanvas
     */
    show() {
      this._triggerController.show();
    }
    /**
     * Esconde o offcanvas
     */
    hide() {
      this._triggerController.hide();
    }
    /**
     * Alterna a visibilidade do offcanvas
     */
    toggle() {
      this._triggerController.toggle();
    }
    /**
     * @internal
     */
    onTriggerActivate() {
      this.open = this._triggerController.open;
    }
    onOpenOverlay() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        setTimeout(() => {
          emit(this, `atlas-offcanvas-open`, {
            trackDisable: true
          });
        }, 0);
      });
    }
    onCloseOverlay() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        setTimeout(() => {
          emit(this, `atlas-offcanvas-close`, {
            trackDisable: true
          });
        }, 0);
      });
    }
    onClickBackdropOffcanvas(event) {
      if (!this.open || this.preventCloseOverlay) {
        return;
      }
      const composedPath = event.composedPath();
      const isOffCanvasTarget = composedPath.includes(this.shadowRoot.querySelector(".atlas-offcanvas"));
      if (!isOffCanvasTarget) {
        this.hide();
      }
    }
    onChangeSlottedActions() {
      this._showFooter = !isEmptySlot(this, "actions");
    }
    renderHeaderInfo() {
      if (this.headerImage) {
        return html61` <atlas-image src="${this.headerImage}" alt="${this.headerImageDescription}"></atlas-image>`;
      }
      return html61`<atlas-heading size="h5" ellipsis>${this.header}</atlas-heading>`;
    }
    renderHeaderActions() {
      if (this.headerImage) {
        return this.renderCloseButton();
      }
      return html61`
            <div class="header-actions">
                <slot name="header-action"></slot>
                ${this.renderCloseButton()}
            </div>
        `;
    }
    renderHeader() {
      const headerClass = {
        "atlas-offcanvas-header": true,
        "with-image": !!this.headerImage
      };
      return html61`<div class="${classMap44(headerClass)}">
            ${this.renderHeaderInfo()} ${this.renderHeaderActions()}
        </div>`;
    }
    renderCloseButton() {
      return when39(!this.removeCloseButton, () => html61`
                <button class="close-button" @click=${this.hide}>
                    <atlas-icon name="x" size="3x" theme="secondary"></atlas-icon>
                </button>
            `);
    }
    getNormalizedPadding() {
      switch (this.padding) {
        case "default":
          return "xs";
        case "large":
          return "lg";
        default:
          return this.padding;
      }
    }
    /** @internal */
    render() {
      const offCanvasBackdropClass = {
        "atlas-offcanvas-backdrop": true,
        "show": this.open
      };
      const offCanvasClass = {
        "atlas-offcanvas": true,
        "show-footer": this._showFooter
      };
      const offCanvasContentClass = {
        "atlas-offcanvas-content": true,
        [`padding-${this.getNormalizedPadding()}`]: !!this.padding,
        "filter": this.filter
      };
      const offCanvasFooterClass = {
        "atlas-offcanvas-footer": true,
        "has-button-block": this.hasButtonBlock
      };
      return html61`
            <div class="${classMap44(offCanvasBackdropClass)}" @click=${this.onClickBackdropOffcanvas}>
                <div class="${classMap44(offCanvasClass)}">
                    ${this.renderHeader()}
                    <div class="${classMap44(offCanvasContentClass)}">
                        <slot></slot>
                    </div>
                    <div class="${classMap44(offCanvasFooterClass)}">
                        <slot name="actions" @slotchange=${this.onChangeSlottedActions}></slot>
                    </div>
                </div>
            </div>
        `;
    }
  };
  AtlasOffcanvas.styles = atlas_offcanvas_default;
  return AtlasOffcanvas;
})();
__decorateClass([property61({
  type: Boolean,
  reflect: true
})], AtlasOffcanvas.prototype, "open", 2);
__decorateClass([property61({
  type: String
})], AtlasOffcanvas.prototype, "header", 2);
__decorateClass([property61({
  type: String,
  attribute: "header-image"
})], AtlasOffcanvas.prototype, "headerImage", 2);
__decorateClass([property61({
  type: String,
  attribute: "header-image-description"
})], AtlasOffcanvas.prototype, "headerImageDescription", 2);
__decorateClass([property61({
  type: Boolean,
  attribute: "remove-close-button"
})], AtlasOffcanvas.prototype, "removeCloseButton", 2);
__decorateClass([property61({
  type: Boolean,
  attribute: "prevent-close-overlay"
})], AtlasOffcanvas.prototype, "preventCloseOverlay", 2);
__decorateClass([property61({
  type: Boolean,
  attribute: "has-button-block"
})], AtlasOffcanvas.prototype, "hasButtonBlock", 2);
__decorateClass([property61({
  type: String
})], AtlasOffcanvas.prototype, "padding", 2);
__decorateClass([property61({
  type: Boolean
})], AtlasOffcanvas.prototype, "filter", 2);
__decorateClass([state26()], AtlasOffcanvas.prototype, "_showFooter", 2);
__decorateClass([Watch("open")], AtlasOffcanvas.prototype, "onOpenChange", 1);
AtlasOffcanvas = __decorateClass([customElement55("atlas-offcanvas")], AtlasOffcanvas);

// src/components/display/atlas-preview/atlas-preview.ts
import { html as html63, nothing as nothing3 } from "lit";
import { customElement as customElement57, property as property63, state as state27 } from "lit/decorators.js";
import { classMap as classMap46 } from "lit/directives/class-map.js";
import { when as when41 } from "lit/directives/when.js";

// src/helpers/overlay.ts
var overlay_exports = {};
__export(overlay_exports, {
  closeAllOverlays: () => closeAllOverlays
});
var OVERLAY_ELEMENTS = ["atlas-dropdown", "atlas-dropdown-button", "atlas-popover", "atlas-tooltip"];
var closeAllOverlays = host => {
  const container = host || document.body;
  container.querySelectorAll(OVERLAY_ELEMENTS.toString()).forEach(overlayElement => {
    var _a;
    if (overlayElement instanceof AtlasDropdownButton) {
      (_a = overlayElement.getDropdownRef()) == null ? void 0 : _a.hide();
    } else if (overlayElement instanceof OverlayElement) {
      overlayElement.hide();
    }
  });
};

// src/internals/debounce.ts
var debounce = (fn, delay) => {
  let timeout;
  return function debounced(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
};

// src/components/display/atlas-preview/atlas-preview.scss
import { css as css55 } from "lit-element/lit-element.js";
var atlas_preview_default = css55`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.color-white {
  color: #ffffff !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.color-primary {
  color: var(--atlas-primary) !important;
}

.bg-primary {
  background-color: var(--atlas-primary) !important;
}

.color-primary-100 {
  color: var(--atlas-primary-100) !important;
}

.bg-primary-100 {
  background-color: var(--atlas-primary-100) !important;
}

.color-primary-200 {
  color: var(--atlas-primary-200) !important;
}

.bg-primary-200 {
  background-color: var(--atlas-primary-200) !important;
}

.color-primary-300 {
  color: var(--atlas-primary-300) !important;
}

.bg-primary-300 {
  background-color: var(--atlas-primary-300) !important;
}

.color-primary-400 {
  color: var(--atlas-primary-400) !important;
}

.bg-primary-400 {
  background-color: var(--atlas-primary-400) !important;
}

.color-primary-500 {
  color: var(--atlas-primary-500) !important;
}

.bg-primary-500 {
  background-color: var(--atlas-primary-500) !important;
}

.color-primary-600 {
  color: var(--atlas-primary-600) !important;
}

.bg-primary-600 {
  background-color: var(--atlas-primary-600) !important;
}

.color-primary-700 {
  color: var(--atlas-primary-700) !important;
}

.bg-primary-700 {
  background-color: var(--atlas-primary-700) !important;
}

.color-primary-800 {
  color: var(--atlas-primary-800) !important;
}

.bg-primary-800 {
  background-color: var(--atlas-primary-800) !important;
}

.color-primary-900 {
  color: var(--atlas-primary-900) !important;
}

.bg-primary-900 {
  background-color: var(--atlas-primary-900) !important;
}

.active-primary[active], .active-primary.active, .active-primary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-secondary {
  color: var(--atlas-secondary) !important;
}

.bg-secondary {
  background-color: var(--atlas-secondary) !important;
}

.color-secondary-100 {
  color: var(--atlas-secondary-100) !important;
}

.bg-secondary-100 {
  background-color: var(--atlas-secondary-100) !important;
}

.color-secondary-200 {
  color: var(--atlas-secondary-200) !important;
}

.bg-secondary-200 {
  background-color: var(--atlas-secondary-200) !important;
}

.color-secondary-300 {
  color: var(--atlas-secondary-300) !important;
}

.bg-secondary-300 {
  background-color: var(--atlas-secondary-300) !important;
}

.color-secondary-400 {
  color: var(--atlas-secondary-400) !important;
}

.bg-secondary-400 {
  background-color: var(--atlas-secondary-400) !important;
}

.color-secondary-500 {
  color: var(--atlas-secondary-500) !important;
}

.bg-secondary-500 {
  background-color: var(--atlas-secondary-500) !important;
}

.color-secondary-600 {
  color: var(--atlas-secondary-600) !important;
}

.bg-secondary-600 {
  background-color: var(--atlas-secondary-600) !important;
}

.color-secondary-700 {
  color: var(--atlas-secondary-700) !important;
}

.bg-secondary-700 {
  background-color: var(--atlas-secondary-700) !important;
}

.color-secondary-800 {
  color: var(--atlas-secondary-800) !important;
}

.bg-secondary-800 {
  background-color: var(--atlas-secondary-800) !important;
}

.color-secondary-900 {
  color: var(--atlas-secondary-900) !important;
}

.bg-secondary-900 {
  background-color: var(--atlas-secondary-900) !important;
}

.active-secondary[active], .active-secondary.active, .active-secondary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-success {
  color: var(--atlas-success) !important;
}

.bg-success {
  background-color: var(--atlas-success) !important;
}

.color-success-100 {
  color: var(--atlas-success-100) !important;
}

.bg-success-100 {
  background-color: var(--atlas-success-100) !important;
}

.color-success-200 {
  color: var(--atlas-success-200) !important;
}

.bg-success-200 {
  background-color: var(--atlas-success-200) !important;
}

.color-success-300 {
  color: var(--atlas-success-300) !important;
}

.bg-success-300 {
  background-color: var(--atlas-success-300) !important;
}

.color-success-400 {
  color: var(--atlas-success-400) !important;
}

.bg-success-400 {
  background-color: var(--atlas-success-400) !important;
}

.color-success-500 {
  color: var(--atlas-success-500) !important;
}

.bg-success-500 {
  background-color: var(--atlas-success-500) !important;
}

.color-success-600 {
  color: var(--atlas-success-600) !important;
}

.bg-success-600 {
  background-color: var(--atlas-success-600) !important;
}

.color-success-700 {
  color: var(--atlas-success-700) !important;
}

.bg-success-700 {
  background-color: var(--atlas-success-700) !important;
}

.color-success-800 {
  color: var(--atlas-success-800) !important;
}

.bg-success-800 {
  background-color: var(--atlas-success-800) !important;
}

.color-success-900 {
  color: var(--atlas-success-900) !important;
}

.bg-success-900 {
  background-color: var(--atlas-success-900) !important;
}

.active-success[active], .active-success.active, .active-success:active {
  background-color: var(--atlas-success) !important;
  color: var(--atlas-contrast-success) !important;
}

.color-warning {
  color: var(--atlas-warning) !important;
}

.bg-warning {
  background-color: var(--atlas-warning) !important;
}

.color-warning-100 {
  color: var(--atlas-warning-100) !important;
}

.bg-warning-100 {
  background-color: var(--atlas-warning-100) !important;
}

.color-warning-200 {
  color: var(--atlas-warning-200) !important;
}

.bg-warning-200 {
  background-color: var(--atlas-warning-200) !important;
}

.color-warning-300 {
  color: var(--atlas-warning-300) !important;
}

.bg-warning-300 {
  background-color: var(--atlas-warning-300) !important;
}

.color-warning-400 {
  color: var(--atlas-warning-400) !important;
}

.bg-warning-400 {
  background-color: var(--atlas-warning-400) !important;
}

.color-warning-500 {
  color: var(--atlas-warning-500) !important;
}

.bg-warning-500 {
  background-color: var(--atlas-warning-500) !important;
}

.color-warning-600 {
  color: var(--atlas-warning-600) !important;
}

.bg-warning-600 {
  background-color: var(--atlas-warning-600) !important;
}

.color-warning-700 {
  color: var(--atlas-warning-700) !important;
}

.bg-warning-700 {
  background-color: var(--atlas-warning-700) !important;
}

.color-warning-800 {
  color: var(--atlas-warning-800) !important;
}

.bg-warning-800 {
  background-color: var(--atlas-warning-800) !important;
}

.color-warning-900 {
  color: var(--atlas-warning-900) !important;
}

.bg-warning-900 {
  background-color: var(--atlas-warning-900) !important;
}

.active-warning[active], .active-warning.active, .active-warning:active {
  background-color: var(--atlas-warning) !important;
  color: var(--atlas-contrast-warning) !important;
}

.color-danger {
  color: var(--atlas-danger) !important;
}

.bg-danger {
  background-color: var(--atlas-danger) !important;
}

.color-danger-100 {
  color: var(--atlas-danger-100) !important;
}

.bg-danger-100 {
  background-color: var(--atlas-danger-100) !important;
}

.color-danger-200 {
  color: var(--atlas-danger-200) !important;
}

.bg-danger-200 {
  background-color: var(--atlas-danger-200) !important;
}

.color-danger-300 {
  color: var(--atlas-danger-300) !important;
}

.bg-danger-300 {
  background-color: var(--atlas-danger-300) !important;
}

.color-danger-400 {
  color: var(--atlas-danger-400) !important;
}

.bg-danger-400 {
  background-color: var(--atlas-danger-400) !important;
}

.color-danger-500 {
  color: var(--atlas-danger-500) !important;
}

.bg-danger-500 {
  background-color: var(--atlas-danger-500) !important;
}

.color-danger-600 {
  color: var(--atlas-danger-600) !important;
}

.bg-danger-600 {
  background-color: var(--atlas-danger-600) !important;
}

.color-danger-700 {
  color: var(--atlas-danger-700) !important;
}

.bg-danger-700 {
  background-color: var(--atlas-danger-700) !important;
}

.color-danger-800 {
  color: var(--atlas-danger-800) !important;
}

.bg-danger-800 {
  background-color: var(--atlas-danger-800) !important;
}

.color-danger-900 {
  color: var(--atlas-danger-900) !important;
}

.bg-danger-900 {
  background-color: var(--atlas-danger-900) !important;
}

.active-danger[active], .active-danger.active, .active-danger:active {
  background-color: var(--atlas-danger) !important;
  color: var(--atlas-contrast-danger) !important;
}

.color-highlight {
  color: var(--atlas-highlight) !important;
}

.bg-highlight {
  background-color: var(--atlas-highlight) !important;
}

.color-highlight-100 {
  color: var(--atlas-highlight-100) !important;
}

.bg-highlight-100 {
  background-color: var(--atlas-highlight-100) !important;
}

.color-highlight-200 {
  color: var(--atlas-highlight-200) !important;
}

.bg-highlight-200 {
  background-color: var(--atlas-highlight-200) !important;
}

.color-highlight-300 {
  color: var(--atlas-highlight-300) !important;
}

.bg-highlight-300 {
  background-color: var(--atlas-highlight-300) !important;
}

.color-highlight-400 {
  color: var(--atlas-highlight-400) !important;
}

.bg-highlight-400 {
  background-color: var(--atlas-highlight-400) !important;
}

.color-highlight-500 {
  color: var(--atlas-highlight-500) !important;
}

.bg-highlight-500 {
  background-color: var(--atlas-highlight-500) !important;
}

.color-highlight-600 {
  color: var(--atlas-highlight-600) !important;
}

.bg-highlight-600 {
  background-color: var(--atlas-highlight-600) !important;
}

.color-highlight-700 {
  color: var(--atlas-highlight-700) !important;
}

.bg-highlight-700 {
  background-color: var(--atlas-highlight-700) !important;
}

.color-highlight-800 {
  color: var(--atlas-highlight-800) !important;
}

.bg-highlight-800 {
  background-color: var(--atlas-highlight-800) !important;
}

.color-highlight-900 {
  color: var(--atlas-highlight-900) !important;
}

.bg-highlight-900 {
  background-color: var(--atlas-highlight-900) !important;
}

.active-highlight[active], .active-highlight.active, .active-highlight:active {
  background-color: var(--atlas-highlight) !important;
  color: var(--atlas-contrast-highlight) !important;
}

.color-info {
  color: var(--atlas-info) !important;
}

.bg-info {
  background-color: var(--atlas-info) !important;
}

.color-info-100 {
  color: var(--atlas-info-100) !important;
}

.bg-info-100 {
  background-color: var(--atlas-info-100) !important;
}

.color-info-200 {
  color: var(--atlas-info-200) !important;
}

.bg-info-200 {
  background-color: var(--atlas-info-200) !important;
}

.color-info-300 {
  color: var(--atlas-info-300) !important;
}

.bg-info-300 {
  background-color: var(--atlas-info-300) !important;
}

.color-info-400 {
  color: var(--atlas-info-400) !important;
}

.bg-info-400 {
  background-color: var(--atlas-info-400) !important;
}

.color-info-500 {
  color: var(--atlas-info-500) !important;
}

.bg-info-500 {
  background-color: var(--atlas-info-500) !important;
}

.color-info-600 {
  color: var(--atlas-info-600) !important;
}

.bg-info-600 {
  background-color: var(--atlas-info-600) !important;
}

.color-info-700 {
  color: var(--atlas-info-700) !important;
}

.bg-info-700 {
  background-color: var(--atlas-info-700) !important;
}

.color-info-800 {
  color: var(--atlas-info-800) !important;
}

.bg-info-800 {
  background-color: var(--atlas-info-800) !important;
}

.color-info-900 {
  color: var(--atlas-info-900) !important;
}

.bg-info-900 {
  background-color: var(--atlas-info-900) !important;
}

.active-info[active], .active-info.active, .active-info:active {
  background-color: var(--atlas-info) !important;
  color: var(--atlas-contrast-info) !important;
}

:host {
  display: inline-flex;
}

.preview-wrapper {
  width: 93px;
  height: 93px;
  border-radius: 0.5rem;
  border: 1px solid var(--atlas-primary);
  transition: box-shadow 0.25s ease;
  box-sizing: border-box;
}
.preview-wrapper .preview-content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  border-radius: 0.5rem;
}

.preview {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0;
  border: 0;
}
.preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.preview .preview-overlay {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 2;
}
.preview .preview-badge,
.preview .preview-progress {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: opacity 0.25s ease;
  opacity: 1;
  z-index: 3;
}
.preview .preview-progress {
  width: calc(100% - 1rem);
}
.preview.show-badge .preview-badge {
  display: block;
}
.preview.show-progress .preview-progress {
  display: block;
}
.preview:focus-visible {
  outline: none;
}

.preview-toolbar {
  display: flex;
  position: absolute;
  top: 0.5rem;
  left: 50%;
  background: #ffffff;
  border-radius: 0.25rem;
  border: 1px solid #ced4da;
  transition: visibility 0.25s ease, transform 0.25s ease;
  transform: translate(-50%, calc(-100% - 0.5rem));
  z-index: 4;
  visibility: hidden;
}

.preview-toolbar-button {
  margin: 0;
  border: 0;
  padding: 0.5rem;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 0.25rem;
  position: relative;
  z-index: 1;
  flex-shrink: 0;
  cursor: pointer;
  color: var(--atlas-secondary);
  transition: background 0.25s ease, color 0.25s ease;
}
.preview-toolbar-button:hover {
  background: var(--atlas-secondary-100);
}
.preview-toolbar-button:focus-visible {
  z-index: 2;
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-500-rgb), 0.25);
}

.preview-file-name {
  position: absolute;
  bottom: -1px;
  left: 0;
  background: #ffffff;
  width: 100%;
  padding: 0.5rem;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  transition: transform 0.25s ease;
  transform: translateY(100%);
  z-index: 4;
}

.preview-wrapper:not([loading]).show-floating-elements .preview-toolbar {
  transform: translate(-50%, 0%);
  visibility: visible;
}
.preview-wrapper:not([loading]).show-floating-elements .preview-file-name {
  bottom: 0;
  transform: translateY(0%);
}
.preview-wrapper:not([loading]):has(.preview:focus-visible) {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-500-rgb), 0.25);
}

@media screen and (min-width: 992px) {
  .preview-wrapper {
    width: 148px;
    height: 148px;
  }
  .preview-wrapper.show-floating-elements .preview-badge {
    z-index: 1;
  }
}`;

// src/components/display/atlas-progress-bar/atlas-progress-bar.ts
import { html as html62 } from "lit";
import { customElement as customElement56, property as property62 } from "lit/decorators.js";
import { classMap as classMap45 } from "lit/directives/class-map.js";
import { styleMap as styleMap16 } from "lit/directives/style-map.js";
import { when as when40 } from "lit/directives/when.js";

// src/components/display/atlas-progress-bar/atlas-progress-bar.scss
import { css as css56 } from "lit-element/lit-element.js";
var atlas_progress_bar_default = css56`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.color-white {
  color: #ffffff !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.color-primary {
  color: var(--atlas-primary) !important;
}

.bg-primary {
  background-color: var(--atlas-primary) !important;
}

.color-primary-100 {
  color: var(--atlas-primary-100) !important;
}

.bg-primary-100 {
  background-color: var(--atlas-primary-100) !important;
}

.color-primary-200 {
  color: var(--atlas-primary-200) !important;
}

.bg-primary-200 {
  background-color: var(--atlas-primary-200) !important;
}

.color-primary-300 {
  color: var(--atlas-primary-300) !important;
}

.bg-primary-300 {
  background-color: var(--atlas-primary-300) !important;
}

.color-primary-400 {
  color: var(--atlas-primary-400) !important;
}

.bg-primary-400 {
  background-color: var(--atlas-primary-400) !important;
}

.color-primary-500 {
  color: var(--atlas-primary-500) !important;
}

.bg-primary-500 {
  background-color: var(--atlas-primary-500) !important;
}

.color-primary-600 {
  color: var(--atlas-primary-600) !important;
}

.bg-primary-600 {
  background-color: var(--atlas-primary-600) !important;
}

.color-primary-700 {
  color: var(--atlas-primary-700) !important;
}

.bg-primary-700 {
  background-color: var(--atlas-primary-700) !important;
}

.color-primary-800 {
  color: var(--atlas-primary-800) !important;
}

.bg-primary-800 {
  background-color: var(--atlas-primary-800) !important;
}

.color-primary-900 {
  color: var(--atlas-primary-900) !important;
}

.bg-primary-900 {
  background-color: var(--atlas-primary-900) !important;
}

.active-primary[active], .active-primary.active, .active-primary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-secondary {
  color: var(--atlas-secondary) !important;
}

.bg-secondary {
  background-color: var(--atlas-secondary) !important;
}

.color-secondary-100 {
  color: var(--atlas-secondary-100) !important;
}

.bg-secondary-100 {
  background-color: var(--atlas-secondary-100) !important;
}

.color-secondary-200 {
  color: var(--atlas-secondary-200) !important;
}

.bg-secondary-200 {
  background-color: var(--atlas-secondary-200) !important;
}

.color-secondary-300 {
  color: var(--atlas-secondary-300) !important;
}

.bg-secondary-300 {
  background-color: var(--atlas-secondary-300) !important;
}

.color-secondary-400 {
  color: var(--atlas-secondary-400) !important;
}

.bg-secondary-400 {
  background-color: var(--atlas-secondary-400) !important;
}

.color-secondary-500 {
  color: var(--atlas-secondary-500) !important;
}

.bg-secondary-500 {
  background-color: var(--atlas-secondary-500) !important;
}

.color-secondary-600 {
  color: var(--atlas-secondary-600) !important;
}

.bg-secondary-600 {
  background-color: var(--atlas-secondary-600) !important;
}

.color-secondary-700 {
  color: var(--atlas-secondary-700) !important;
}

.bg-secondary-700 {
  background-color: var(--atlas-secondary-700) !important;
}

.color-secondary-800 {
  color: var(--atlas-secondary-800) !important;
}

.bg-secondary-800 {
  background-color: var(--atlas-secondary-800) !important;
}

.color-secondary-900 {
  color: var(--atlas-secondary-900) !important;
}

.bg-secondary-900 {
  background-color: var(--atlas-secondary-900) !important;
}

.active-secondary[active], .active-secondary.active, .active-secondary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-success {
  color: var(--atlas-success) !important;
}

.bg-success {
  background-color: var(--atlas-success) !important;
}

.color-success-100 {
  color: var(--atlas-success-100) !important;
}

.bg-success-100 {
  background-color: var(--atlas-success-100) !important;
}

.color-success-200 {
  color: var(--atlas-success-200) !important;
}

.bg-success-200 {
  background-color: var(--atlas-success-200) !important;
}

.color-success-300 {
  color: var(--atlas-success-300) !important;
}

.bg-success-300 {
  background-color: var(--atlas-success-300) !important;
}

.color-success-400 {
  color: var(--atlas-success-400) !important;
}

.bg-success-400 {
  background-color: var(--atlas-success-400) !important;
}

.color-success-500 {
  color: var(--atlas-success-500) !important;
}

.bg-success-500 {
  background-color: var(--atlas-success-500) !important;
}

.color-success-600 {
  color: var(--atlas-success-600) !important;
}

.bg-success-600 {
  background-color: var(--atlas-success-600) !important;
}

.color-success-700 {
  color: var(--atlas-success-700) !important;
}

.bg-success-700 {
  background-color: var(--atlas-success-700) !important;
}

.color-success-800 {
  color: var(--atlas-success-800) !important;
}

.bg-success-800 {
  background-color: var(--atlas-success-800) !important;
}

.color-success-900 {
  color: var(--atlas-success-900) !important;
}

.bg-success-900 {
  background-color: var(--atlas-success-900) !important;
}

.active-success[active], .active-success.active, .active-success:active {
  background-color: var(--atlas-success) !important;
  color: var(--atlas-contrast-success) !important;
}

.color-warning {
  color: var(--atlas-warning) !important;
}

.bg-warning {
  background-color: var(--atlas-warning) !important;
}

.color-warning-100 {
  color: var(--atlas-warning-100) !important;
}

.bg-warning-100 {
  background-color: var(--atlas-warning-100) !important;
}

.color-warning-200 {
  color: var(--atlas-warning-200) !important;
}

.bg-warning-200 {
  background-color: var(--atlas-warning-200) !important;
}

.color-warning-300 {
  color: var(--atlas-warning-300) !important;
}

.bg-warning-300 {
  background-color: var(--atlas-warning-300) !important;
}

.color-warning-400 {
  color: var(--atlas-warning-400) !important;
}

.bg-warning-400 {
  background-color: var(--atlas-warning-400) !important;
}

.color-warning-500 {
  color: var(--atlas-warning-500) !important;
}

.bg-warning-500 {
  background-color: var(--atlas-warning-500) !important;
}

.color-warning-600 {
  color: var(--atlas-warning-600) !important;
}

.bg-warning-600 {
  background-color: var(--atlas-warning-600) !important;
}

.color-warning-700 {
  color: var(--atlas-warning-700) !important;
}

.bg-warning-700 {
  background-color: var(--atlas-warning-700) !important;
}

.color-warning-800 {
  color: var(--atlas-warning-800) !important;
}

.bg-warning-800 {
  background-color: var(--atlas-warning-800) !important;
}

.color-warning-900 {
  color: var(--atlas-warning-900) !important;
}

.bg-warning-900 {
  background-color: var(--atlas-warning-900) !important;
}

.active-warning[active], .active-warning.active, .active-warning:active {
  background-color: var(--atlas-warning) !important;
  color: var(--atlas-contrast-warning) !important;
}

.color-danger {
  color: var(--atlas-danger) !important;
}

.bg-danger {
  background-color: var(--atlas-danger) !important;
}

.color-danger-100 {
  color: var(--atlas-danger-100) !important;
}

.bg-danger-100 {
  background-color: var(--atlas-danger-100) !important;
}

.color-danger-200 {
  color: var(--atlas-danger-200) !important;
}

.bg-danger-200 {
  background-color: var(--atlas-danger-200) !important;
}

.color-danger-300 {
  color: var(--atlas-danger-300) !important;
}

.bg-danger-300 {
  background-color: var(--atlas-danger-300) !important;
}

.color-danger-400 {
  color: var(--atlas-danger-400) !important;
}

.bg-danger-400 {
  background-color: var(--atlas-danger-400) !important;
}

.color-danger-500 {
  color: var(--atlas-danger-500) !important;
}

.bg-danger-500 {
  background-color: var(--atlas-danger-500) !important;
}

.color-danger-600 {
  color: var(--atlas-danger-600) !important;
}

.bg-danger-600 {
  background-color: var(--atlas-danger-600) !important;
}

.color-danger-700 {
  color: var(--atlas-danger-700) !important;
}

.bg-danger-700 {
  background-color: var(--atlas-danger-700) !important;
}

.color-danger-800 {
  color: var(--atlas-danger-800) !important;
}

.bg-danger-800 {
  background-color: var(--atlas-danger-800) !important;
}

.color-danger-900 {
  color: var(--atlas-danger-900) !important;
}

.bg-danger-900 {
  background-color: var(--atlas-danger-900) !important;
}

.active-danger[active], .active-danger.active, .active-danger:active {
  background-color: var(--atlas-danger) !important;
  color: var(--atlas-contrast-danger) !important;
}

.color-highlight {
  color: var(--atlas-highlight) !important;
}

.bg-highlight {
  background-color: var(--atlas-highlight) !important;
}

.color-highlight-100 {
  color: var(--atlas-highlight-100) !important;
}

.bg-highlight-100 {
  background-color: var(--atlas-highlight-100) !important;
}

.color-highlight-200 {
  color: var(--atlas-highlight-200) !important;
}

.bg-highlight-200 {
  background-color: var(--atlas-highlight-200) !important;
}

.color-highlight-300 {
  color: var(--atlas-highlight-300) !important;
}

.bg-highlight-300 {
  background-color: var(--atlas-highlight-300) !important;
}

.color-highlight-400 {
  color: var(--atlas-highlight-400) !important;
}

.bg-highlight-400 {
  background-color: var(--atlas-highlight-400) !important;
}

.color-highlight-500 {
  color: var(--atlas-highlight-500) !important;
}

.bg-highlight-500 {
  background-color: var(--atlas-highlight-500) !important;
}

.color-highlight-600 {
  color: var(--atlas-highlight-600) !important;
}

.bg-highlight-600 {
  background-color: var(--atlas-highlight-600) !important;
}

.color-highlight-700 {
  color: var(--atlas-highlight-700) !important;
}

.bg-highlight-700 {
  background-color: var(--atlas-highlight-700) !important;
}

.color-highlight-800 {
  color: var(--atlas-highlight-800) !important;
}

.bg-highlight-800 {
  background-color: var(--atlas-highlight-800) !important;
}

.color-highlight-900 {
  color: var(--atlas-highlight-900) !important;
}

.bg-highlight-900 {
  background-color: var(--atlas-highlight-900) !important;
}

.active-highlight[active], .active-highlight.active, .active-highlight:active {
  background-color: var(--atlas-highlight) !important;
  color: var(--atlas-contrast-highlight) !important;
}

.color-info {
  color: var(--atlas-info) !important;
}

.bg-info {
  background-color: var(--atlas-info) !important;
}

.color-info-100 {
  color: var(--atlas-info-100) !important;
}

.bg-info-100 {
  background-color: var(--atlas-info-100) !important;
}

.color-info-200 {
  color: var(--atlas-info-200) !important;
}

.bg-info-200 {
  background-color: var(--atlas-info-200) !important;
}

.color-info-300 {
  color: var(--atlas-info-300) !important;
}

.bg-info-300 {
  background-color: var(--atlas-info-300) !important;
}

.color-info-400 {
  color: var(--atlas-info-400) !important;
}

.bg-info-400 {
  background-color: var(--atlas-info-400) !important;
}

.color-info-500 {
  color: var(--atlas-info-500) !important;
}

.bg-info-500 {
  background-color: var(--atlas-info-500) !important;
}

.color-info-600 {
  color: var(--atlas-info-600) !important;
}

.bg-info-600 {
  background-color: var(--atlas-info-600) !important;
}

.color-info-700 {
  color: var(--atlas-info-700) !important;
}

.bg-info-700 {
  background-color: var(--atlas-info-700) !important;
}

.color-info-800 {
  color: var(--atlas-info-800) !important;
}

.bg-info-800 {
  background-color: var(--atlas-info-800) !important;
}

.color-info-900 {
  color: var(--atlas-info-900) !important;
}

.bg-info-900 {
  background-color: var(--atlas-info-900) !important;
}

.active-info[active], .active-info.active, .active-info:active {
  background-color: var(--atlas-info) !important;
  color: var(--atlas-contrast-info) !important;
}

:host {
  display: block;
  width: 100%;
}

.progress-bar-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.progress-bar-wrapper.horizontal {
  flex-direction: row;
  align-items: center;
}

.progress-bar {
  height: 0.5rem;
  width: 100%;
  display: block;
  position: relative;
  overflow: hidden;
  border-radius: 9999px;
  background: var(--atlas-secondary-100);
}
.progress-bar .current-progress {
  width: 100%;
  position: absolute;
  inset: 0 auto 0 0;
  border-radius: 9999px;
  background: var(--atlas-primary);
  transition: transform 0.35s ease;
  transform-origin: left center;
}

.label-and-actions {
  flex-shrink: 0;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}`;

// src/components/display/atlas-progress-bar/atlas-progress-bar.ts
var AtlasProgressBar = /*#__PURE__*/(() => {
  let AtlasProgressBar = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.minValue = 0;
      this.maxValue = 100;
      this.value = 0;
      this.unit = "percentage";
      this.theme = "primary";
      this.orientation = "vertical";
    }
    /**
     * Calcula o progresso em porcentagem.
     * @returns {number} O progresso em porcentagem.
     */
    getPercentageProgress() {
      if (!this.value) return 0;
      if (this.unit === "percentage") return this.value;
      return this.value * 100 / this.maxValue;
    }
    renderLabel() {
      const labelText = this.unit === "percentage" ? `${this.value}%` : `${this.value}/${this.maxValue}`;
      return when40(this.orientation === "vertical", () => html62`<atlas-text size="sm" ?muted=${this.mutedLabel}>${this.labelPrefix} ${labelText}</atlas-text>`, () => html62`<atlas-caption ?muted=${this.mutedLabel}>${this.labelPrefix} ${labelText}</atlas-caption>`);
    }
    renderLabelWithAction() {
      return when40(this.showLabel, () => html62`
                <div class="label-and-actions">
                    ${this.renderLabel()}
                    <slot name="action"></slot>
                </div>
            `);
    }
    /** @internal */
    render() {
      const wrapperClass = {
        "progress-bar-wrapper": true,
        "horizontal": this.orientation === "horizontal"
      };
      const currentProgressClass = {
        "current-progress": true,
        [`bg-${this.theme}`]: !!this.theme
      };
      const currentProgressStyles = {
        transform: `translateX(${this.getPercentageProgress() - 100}%)`
      };
      return html62`
            <div class=${classMap45(wrapperClass)}>
                <div
                    class="progress-bar"
                    role="progressbar"
                    aria-label="Progresso"
                    aria-valuemin=${this.minValue}
                    aria-valuemax=${this.maxValue}
                    aria-valuenow=${this.value}
                >
                    <div class=${classMap45(currentProgressClass)} style=${styleMap16(currentProgressStyles)}></div>
                </div>
                ${this.renderLabelWithAction()}
            </div>
        `;
    }
  };
  AtlasProgressBar.styles = atlas_progress_bar_default;
  return AtlasProgressBar;
})();
__decorateClass([property62({
  type: Number,
  attribute: "min-value"
})], AtlasProgressBar.prototype, "minValue", 2);
__decorateClass([property62({
  type: Number,
  attribute: "max-value"
})], AtlasProgressBar.prototype, "maxValue", 2);
__decorateClass([property62({
  type: Number
})], AtlasProgressBar.prototype, "value", 2);
__decorateClass([property62({
  type: String
})], AtlasProgressBar.prototype, "unit", 2);
__decorateClass([property62({
  type: String
})], AtlasProgressBar.prototype, "theme", 2);
__decorateClass([property62({
  type: Boolean,
  attribute: "show-label"
})], AtlasProgressBar.prototype, "showLabel", 2);
__decorateClass([property62({
  type: Boolean,
  attribute: "muted-label"
})], AtlasProgressBar.prototype, "mutedLabel", 2);
__decorateClass([property62({
  type: String,
  attribute: "label-prefix"
})], AtlasProgressBar.prototype, "labelPrefix", 2);
__decorateClass([property62({
  type: String
})], AtlasProgressBar.prototype, "orientation", 2);
AtlasProgressBar = __decorateClass([customElement56("atlas-progress-bar")], AtlasProgressBar);

// src/components/display/atlas-preview/atlas-preview.ts
var AtlasPreview = /*#__PURE__*/(() => {
  let AtlasPreview = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.loadingProgress = 0;
      this.actions = [];
      this._showFloatingElements = false;
      this._showNameTooltip = false;
      this._isMouseOverPreview = false;
      this._deviceController = new DeviceController(this);
    }
    /**
     * @internal
     * @override
     */
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.toggleNameTooltipVisibility = this.toggleNameTooltipVisibility.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onChangeFloatingVisibility = debounce(this.onChangeFloatingVisibility.bind(this), 100);
      document.addEventListener("click", this.onDocumentClick);
      this._deviceController.setScreenChangeCallback(this.toggleNameTooltipVisibility);
    }
    /**
     * @internal
     * @override
     */
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      document.removeEventListener("click", this.onDocumentClick);
    }
    onChangeFloatingVisibility() {
      if (!this._showFloatingElements && !this._isMouseOverPreview) {
        closeAllOverlays(this.shadowRoot);
      }
    }
    toggleNameTooltipVisibility() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const imageNameRef = this.shadowRoot.querySelector(".preview-file-name-text");
        if (!imageNameRef) {
          this._showNameTooltip = false;
          return;
        }
        const textWrapper = imageNameRef.getTextWrapper();
        const textVisibleWidth = textWrapper.getBoundingClientRect().width;
        const textScrollWidth = textWrapper.scrollWidth;
        this._showNameTooltip = Math.ceil(textVisibleWidth) < textScrollWidth;
      });
    }
    onDocumentClick(event) {
      if (!this._showFloatingElements) return;
      const composedPath = event.composedPath();
      const isInsidePreview = composedPath.includes(this);
      if (!isInsidePreview) {
        this._showFloatingElements = false;
      }
    }
    onClickPreview() {
      this._showFloatingElements = true;
    }
    onMouseOverPreview() {
      this._isMouseOverPreview = true;
    }
    onMouseOutPreview() {
      this._isMouseOverPreview = false;
    }
    onClickToolbarButton(event) {
      const target = event.currentTarget;
      event.stopPropagation();
      emit(this, "atlas-preview-button-click", {
        detail: {
          button: target.dataset.name
        }
      });
      closeAllOverlays(this.shadowRoot);
    }
    renderToolbarOuterButtons() {
      return this.actions.slice(0, 3).map(button => html63`
                <button
                    class=${classMap46({
        "preview-toolbar-button": true,
        "disabled": button.disabled,
        [`color-${button.theme || "secondary"}`]: true,
        [`active-${button.theme || "secondary"}`]: true
      })}
                    @click=${this.onClickToolbarButton}
                    data-name=${button.name}
                >
                    <atlas-icon name=${button.icon} size="2x"></atlas-icon>
                </button>
            `);
    }
    renderToolbarMoreButton() {
      if (this.actions.length < 4) return nothing3;
      return html63`
            <button
                class=${classMap46({
        "preview-toolbar-button": true,
        "color-secondary": true,
        "active-secondary": true
      })}
                data-atlas-dropdown="more-dropdown"
            >
                <atlas-icon name="three-dots" size="2x"></atlas-icon>
            </button>
        `;
    }
    renderDropdownButtons(buttons) {
      return buttons.map(button => html63`
                <atlas-dropdown-item
                    icon=${button.icon}
                    theme=${button.theme}
                    ?disabled=${button.disabled}
                    @atlas-dropdown-item-click=${this.onClickToolbarButton}
                    data-name=${button.name}
                >
                    ${button.label}
                </atlas-dropdown-item>
            `);
    }
    renderMoreButtonDropdown() {
      if (this.loading || this._deviceController.isMobile || this.actions.length < 4) return nothing3;
      return html63`
            <atlas-dropdown id="more-dropdown" no-gap auto-close auto-close-trigger="any">
                ${this.renderDropdownButtons(this.actions.slice(3))}
            </atlas-dropdown>
        `;
    }
    renderPreviewToolbar() {
      if (!this.actions || this.actions.length === 0) return nothing3;
      return html63`
            <div class="preview-toolbar">${this.renderToolbarOuterButtons()}${this.renderToolbarMoreButton()}</div>
        `;
    }
    renderPreviewBadge() {
      return when41(!!this.badgeText, () => html63`
                <div class="preview-badge">
                    <atlas-badge
                        icon=${this.badgeIcon}
                        text=${!this._deviceController.isMobile ? this.badgeText : ""}
                        theme=${this.badgeTheme}
                    ></atlas-badge>
                </div>
            `);
    }
    renderFloatingElements() {
      return when41(!this.loading && !this._deviceController.isMobile, () => html63`
                ${this.renderPreviewToolbar()}
                <div class="preview-file-name">
                    <atlas-text
                        class="preview-file-name-text"
                        size="xs"
                        alignment="center"
                        muted
                        ellipsis
                        hide-ellipsis-tooltip
                        data-atlas-tooltip="image-name-tooltip"
                    >
                        ${this.imageName}
                    </atlas-text>
                </div>
            `);
    }
    renderMobileDropdown() {
      return when41(!this.loading && this._deviceController.isMobile, () => html63`
                <atlas-dropdown
                    id="preview-dropdown"
                    header=${this.imageName}
                    no-gap
                    auto-close
                    auto-close-trigger="any"
                >
                    ${this.renderDropdownButtons(this.actions)}
                </atlas-dropdown>
            `);
    }
    renderNameTooltip() {
      return when41(!this.loading && !this._deviceController.isMobile && this._showNameTooltip, () => html63`<atlas-tooltip id="image-name-tooltip" placement="bottom">${this.imageName}</atlas-tooltip>`);
    }
    /**
     * @internal
     * @override
     */
    render() {
      const previewWrapperClass = {
        "preview-wrapper": true,
        "show-floating-elements": this._showFloatingElements || this._isMouseOverPreview
      };
      const previewClass = {
        "preview": true,
        "show-progress": this.loading,
        "show-badge": !this.loading
      };
      return html63`
            <div
                class=${classMap46(previewWrapperClass)}
                @mouseover=${this.onMouseOverPreview}
                @mouseout=${this.onMouseOutPreview}
            >
                <div class="preview-content">
                    <button
                        class=${classMap46(previewClass)}
                        ?disabled=${this.loading}
                        @click=${this.onClickPreview}
                        data-atlas-dropdown="preview-dropdown"
                    >
                        <img src=${this.image || getAssetPath("assets/images/image-placeholder.svg")} alt="" />
                        <div class="preview-overlay"></div>
                        ${this.renderPreviewBadge()}
                        <div class="preview-progress">
                            <atlas-progress-bar value=${this.loadingProgress}></atlas-progress-bar>
                        </div>
                    </button>
                    ${this.renderFloatingElements()}
                </div>
                ${this.renderMoreButtonDropdown()}${this.renderMobileDropdown()}${this.renderNameTooltip()}
            </div>
        `;
    }
  };
  AtlasPreview.styles = atlas_preview_default;
  return AtlasPreview;
})();
__decorateClass([property63({
  type: String
})], AtlasPreview.prototype, "image", 2);
__decorateClass([property63({
  type: String,
  attribute: "image-name"
})], AtlasPreview.prototype, "imageName", 2);
__decorateClass([property63({
  type: Boolean,
  reflect: true
})], AtlasPreview.prototype, "loading", 2);
__decorateClass([property63({
  type: Number,
  attribute: "loading-progress"
})], AtlasPreview.prototype, "loadingProgress", 2);
__decorateClass([property63({
  type: String,
  attribute: "badge-icon"
})], AtlasPreview.prototype, "badgeIcon", 2);
__decorateClass([property63({
  type: String,
  attribute: "badge-text"
})], AtlasPreview.prototype, "badgeText", 2);
__decorateClass([property63({
  type: String,
  attribute: "badge-theme"
})], AtlasPreview.prototype, "badgeTheme", 2);
__decorateClass([property63({
  type: Array
})], AtlasPreview.prototype, "actions", 2);
__decorateClass([state27()], AtlasPreview.prototype, "_showFloatingElements", 2);
__decorateClass([state27()], AtlasPreview.prototype, "_showNameTooltip", 2);
__decorateClass([state27()], AtlasPreview.prototype, "_isMouseOverPreview", 2);
__decorateClass([Watch(["_showFloatingElements", "_isMouseOverPreview"], true)], AtlasPreview.prototype, "onChangeFloatingVisibility", 1);
__decorateClass([Watch(["loading", "name"])], AtlasPreview.prototype, "toggleNameTooltipVisibility", 1);
AtlasPreview = __decorateClass([customElement57("atlas-preview")], AtlasPreview);

// src/components/display/atlas-product-card/atlas-product-card.ts
import { LitElement as LitElement17 } from "lit";
import { html as html65, literal as literal7 } from "lit/static-html.js";
import { ifDefined as ifDefined14 } from "lit/directives/if-defined.js";
import { customElement as customElement58, property as property65, state as state29 } from "lit/decorators.js";
import { classMap as classMap47 } from "lit/directives/class-map.js";
import { when as when42 } from "lit/directives/when.js";

// src/components/display/atlas-product-card/atlas-product-card.scss
import { css as css57 } from "lit-element/lit-element.js";
var atlas_product_card_default = css57`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Transitions */
:host {
  display: inline-flex;
  width: 100%;
}

.atlas-card-product-container {
  text-decoration: none;
  color: unset;
  width: 100%;
  border: 0.25rem solid transparent;
  background: unset;
  padding: 0;
  margin: 0;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background 0.25s ease;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  box-sizing: border-box;
  text-align: left;
}
.atlas-card-product-container:focus-visible {
  outline: none;
  box-shadow: none;
  border-color: rgba(var(--atlas-primary-rgb), 25%);
}
.atlas-card-product-container:hover {
  background: rgba(var(--atlas-primary-rgb), 10%);
}
.atlas-card-product-container:active {
  background-color: rgba(var(--atlas-primary-rgb), 20%);
}

.product-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px;
}
.product-card .product-logo {
  display: block;
  flex: 0 0 146px;
  text-align: center;
}
.product-card .product-info {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
}
.product-card .product-info .product-name {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #212529;
}
.product-card .product-info .product-description {
  font-size: 0.8rem;
  color: #687078;
}
.product-card .product-info .product-link {
  font-size: 0.8rem;
  color: #0d6efd;
  text-decoration: none;
}
.product-card.hide-footer-text .footer-text-wrap {
  display: none;
}
@media screen and (max-width: 992px) {
  .product-card {
    display: inline;
  }
}`;

// src/internals/mixins/with-description-mixin.ts
import { html as html64 } from "lit";
import { property as property64, state as state28 } from "lit/decorators.js";
import { styleMap as styleMap17 } from "lit/directives/style-map.js";
var WithDescriptionMixin = superClass => {
  class WithVisibilityIconClass extends superClass {
    constructor() {
      super(...arguments);
      this._hasSlottedDescription = false;
    }
    /** @internal */
    renderDescription(options = {}) {
      const {
        size: size2 = "md",
        wrapperClass = ""
      } = options;
      if (this.description) return this.renderDescriptionText(size2, wrapperClass);
      return this.renderDescriptionSlot(size2, wrapperClass);
    }
    onDescriptionChange(size2) {
      this._hasSlottedDescription = !isEmptySlot(this, "description");
      if (!this._hasSlottedDescription) return;
      const slot = this.shadowRoot.querySelector("slot[name=description]");
      const assignedElements = slot.assignedElements({
        flatten: true
      });
      this.setAttributesForAtlasTextElements(assignedElements, {
        muted: true,
        size: size2
      });
    }
    renderDescriptionText(size2, wrapperClass) {
      return html64` <atlas-text muted class=${wrapperClass} size=${size2}> ${this.description} </atlas-text> `;
    }
    renderDescriptionSlot(size2, wrapperClass) {
      const textStyle = {
        display: this._hasSlottedDescription ? "" : "none"
      };
      return html64`
                <atlas-text muted size=${size2} class=${wrapperClass} style="${styleMap17(textStyle)}">
                    <slot name="description" @slotchange=${() => this.onDescriptionChange(size2)}></slot>
                </atlas-text>
            `;
    }
    setAttributesForAtlasTextElements(elements, attributes) {
      elements.forEach(element => {
        if (element.tagName === "ATLAS-TEXT") this.applyAttributesToElement(element, attributes);
        const childElements = Array.from(element.children);
        if (childElements.length > 0) this.setAttributesForAtlasTextElements(childElements, attributes);
      });
    }
    applyAttributesToElement(element, attributes) {
      Object.entries(attributes).forEach(([key, value]) => {
        if (typeof value === "boolean") {
          element.toggleAttribute(key, value);
        } else {
          element.setAttribute(key, value);
        }
      });
    }
  }
  __decorateClass([property64({
    type: String
  })], WithVisibilityIconClass.prototype, "description", 2);
  __decorateClass([state28()], WithVisibilityIconClass.prototype, "_hasSlottedDescription", 2);
  return WithVisibilityIconClass;
};

// src/components/display/atlas-product-card/atlas-product-card.ts
var ComposedClass3 = WithDescriptionMixin(LitElement17);
var AtlasProductCard = /*#__PURE__*/(() => {
  let AtlasProductCard = class extends ComposedClass3 {
    constructor() {
      super(...arguments);
      this._hasFooterText = false;
    }
    handleClick() {
      emit(this, "atlas-product-card-click");
    }
    onChangeSlotFooterText() {
      this._hasFooterText = !isEmptySlot(this, "footer-text");
    }
    renderFooterText() {
      return when42(!!this.footerText, () => html65`<span class="product-link">${this.footerText}</span>`, () => html65`
                <atlas-text size="xs" class="footer-text-wrap">
                    <slot name="footer-text" @slotchange=${this.onChangeSlotFooterText}></slot>
                </atlas-text>
            `);
    }
    /* @internal */
    render() {
      const productCardLogo = {
        "product-card": true,
        "hide-footer-text": !this._hasFooterText
      };
      const tag = this.href ? literal7`a` : literal7`button`;
      return html65`
            <${tag}
                class="atlas-card-product-container"
                href=${ifDefined14(this.href ? this.href : void 0)}
                target=${ifDefined14(this.href ? "_blank" : void 0)}
                rel=${ifDefined14(this.href ? "noreferrer" : void 0)}
                @click=${this.handleClick}
            >
                <div class=${classMap47(productCardLogo)}>
                    <atlas-image
                        class="product-logo"
                        width="146"
                        src=${this.productLogo}
                        alt=${this.productLogoDescription}
                    ></atlas-image>
                    <div class="product-info">
                        ${when42(!!this.header, () => html65`<atlas-heading size="h6">${this.header}</atlas-heading>`)}
                        ${this.renderDescription({
        size: "xs"
      })}
                        ${this.renderFooterText()}
                    </div>
                </div>
            </${tag}>
        `;
    }
  };
  AtlasProductCard.styles = atlas_product_card_default;
  return AtlasProductCard;
})();
__decorateClass([property65({
  type: String,
  attribute: "product-logo"
})], AtlasProductCard.prototype, "productLogo", 2);
__decorateClass([property65({
  type: String,
  attribute: "product-logo-description"
})], AtlasProductCard.prototype, "productLogoDescription", 2);
__decorateClass([property65({
  type: String
})], AtlasProductCard.prototype, "header", 2);
__decorateClass([property65({
  type: String,
  attribute: "footer-text"
})], AtlasProductCard.prototype, "footerText", 2);
__decorateClass([property65({
  type: String
})], AtlasProductCard.prototype, "href", 2);
__decorateClass([state29()], AtlasProductCard.prototype, "_hasFooterText", 2);
AtlasProductCard = __decorateClass([customElement58("atlas-product-card")], AtlasProductCard);

// src/components/display/atlas-promotional-banner/atlas-promotional-banner.ts
import { html as html67, nothing as nothing4 } from "lit";
import { customElement as customElement60, property as property67, query as query10, state as state31 } from "lit/decorators.js";
import { when as when44 } from "lit/directives/when.js";
import { classMap as classMap49 } from "lit/directives/class-map.js";

// src/components/display/atlas-promotional-banner/atlas-promotional-banner.scss
import { css as css58 } from "lit-element/lit-element.js";
var atlas_promotional_banner_default = css58`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Shadows */
/* Elevations */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.atlas-promotional-banner {
  border-radius: 0.5rem;
  position: relative;
  padding: 1.5rem;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  transition: all 0.25s ease;
  overflow: hidden;
  height: auto;
}
.atlas-promotional-banner.with-margin-bottom {
  margin-bottom: 2rem;
}
.atlas-promotional-banner.light-blue {
  background: radial-gradient(100% 99.92% at 0% 0%, var(--atlas-primary-600) 0%, var(--atlas-primary-400) 100%);
}
.atlas-promotional-banner.dark-blue {
  background: radial-gradient(126.49% 126.49% at 0% 0%, var(--atlas-primary-800) 0%, var(--atlas-primary-500) 100%);
}
.atlas-promotional-banner.white {
  background-color: #ffffff;
}
.atlas-promotional-banner .illustration,
.atlas-promotional-banner .image {
  display: none;
}
.atlas-promotional-banner .background {
  display: none;
}
.atlas-promotional-banner .content {
  position: relative;
  display: flex;
  flex-direction: column;
}
.atlas-promotional-banner .content atlas-badge {
  margin-bottom: 0.75rem;
}
.atlas-promotional-banner .content .title {
  margin-bottom: 1rem;
}
.atlas-promotional-banner .content .title.has-close-button {
  margin-right: 1.5rem;
}
.atlas-promotional-banner .content .subtitle {
  margin-bottom: 0.5rem;
}
.atlas-promotional-banner .content .description {
  color: #ffffff;
}
.atlas-promotional-banner .content .actions {
  margin-top: 1.5rem;
  display: flex;
  gap: 1rem;
  flex-direction: column;
}
.atlas-promotional-banner .content .helper-text {
  margin-top: 0.75rem;
}
.atlas-promotional-banner .close {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  cursor: pointer;
}
.atlas-promotional-banner .hide {
  display: none !important;
}
.atlas-promotional-banner slot[name=actions]::slotted(atlas-button) {
  display: inline-flex;
}

@media screen and (min-width: 768px) {
  .atlas-promotional-banner {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1.5rem;
  }
  .atlas-promotional-banner .illustration,
  .atlas-promotional-banner .image {
    display: block;
    width: 100%;
    z-index: 10;
    padding: 0 3rem 0 1.5rem;
    flex: fit-content 0 0;
  }
  .atlas-promotional-banner .illustration[size=xs],
  .atlas-promotional-banner .image[size=xs] {
    flex: 160px 0 0;
  }
  .atlas-promotional-banner .illustration[size=sm],
  .atlas-promotional-banner .image[size=sm] {
    flex: 200px 0 0;
  }
  .atlas-promotional-banner .content {
    flex: auto 1 1;
  }
  .atlas-promotional-banner .content .actions {
    flex-direction: row;
  }
  .atlas-promotional-banner .background {
    display: block;
    position: absolute;
    width: 575px;
    height: 575px;
    border-radius: 50%;
    background-color: var(--atlas-primary-100);
  }
  .atlas-promotional-banner .background.sm {
    transform: translate(-53%, 0);
  }
  .atlas-promotional-banner .background.xs {
    transform: translate(-60%, 0%);
  }
}`;

// src/components/form/atlas-helper-text/atlas-helper-text.ts
import { html as html66 } from "lit";
import { customElement as customElement59, property as property66, state as state30 } from "lit/decorators.js";
import { classMap as classMap48 } from "lit/directives/class-map.js";
import { when as when43 } from "lit/directives/when.js";

// src/components/form/atlas-helper-text/atlas-helper-text.scss
import { css as css59 } from "lit-element/lit-element.js";
var atlas_helper_text_default = css59`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.form-text {
  margin-top: 0.25rem;
  box-sizing: border-box;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 0.8rem;
  line-height: 1.5;
  color: #687078;
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.form-text atlas-icon {
  position: relative;
}
.form-text.form-text-toggle {
  margin-top: 1rem;
}
.form-text.form-text-input {
  align-items: start;
}
.form-text.form-text-input atlas-icon {
  top: 2px;
}
.form-text.empty-helper {
  display: none;
}
.form-text.white {
  color: #ffffff;
}`;

// src/components/form/atlas-helper-text/atlas-helper-text.ts
var AtlasHelperText = /*#__PURE__*/(() => {
  let AtlasHelperText = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.size = "sm";
      this.isToggleHelper = false;
      this.isInputHelper = false;
      this.white = false;
      this._hasSlottedContent = true;
    }
    onChangeContent() {
      const slottedNodes = this.shadowRoot.querySelector("slot").assignedNodes({
        flatten: true
      });
      const filteredNodes = filterEmptyNodes(slottedNodes);
      this._hasSlottedContent = filteredNodes.length > 0;
    }
    getIconTheme() {
      var _a;
      const themes = {
        default: "secondary",
        warning: "warning"
      };
      return (_a = themes[this.criticality]) != null ? _a : this.iconTheme;
    }
    getIcon() {
      var _a;
      const icons = {
        default: "alert-circle",
        warning: "alert-triangle"
      };
      return (_a = icons[this.criticality]) != null ? _a : this.icon;
    }
    getTextSize() {
      const sizes = {
        lg: "md",
        md: "sm",
        sm: "xs"
      };
      return sizes[this.size];
    }
    renderIcon() {
      const iconSize = this.size === "lg" ? "3x" : "2x";
      return when43(this.criticality || this.icon, () => html66`<atlas-icon name=${this.getIcon()} theme=${this.getIconTheme()} size=${iconSize}></atlas-icon>`);
    }
    /** @internal */
    render() {
      const helperTextClass = {
        "form-text": true,
        "form-text-toggle": this.isToggleHelper,
        "form-text-input": this.isInputHelper,
        "empty-helper": !this._hasSlottedContent
      };
      return html66`
            <div id="${this.id}-helper" class="${classMap48(helperTextClass)}">
                ${this.renderIcon()}
                <atlas-text size=${this.getTextSize()} muted ?white=${this.white}>
                    <slot @slotchange=${this.onChangeContent}></slot>
                </atlas-text>
            </div>
        `;
    }
  };
  AtlasHelperText.styles = atlas_helper_text_default;
  return AtlasHelperText;
})();
__decorateClass([property66({
  type: String
})], AtlasHelperText.prototype, "icon", 2);
__decorateClass([property66({
  type: String,
  attribute: "icon-theme"
})], AtlasHelperText.prototype, "iconTheme", 2);
__decorateClass([property66({
  type: String
})], AtlasHelperText.prototype, "criticality", 2);
__decorateClass([property66({
  type: String
})], AtlasHelperText.prototype, "size", 2);
__decorateClass([property66({
  type: Boolean,
  attribute: "is-toggle-helper"
})], AtlasHelperText.prototype, "isToggleHelper", 2);
__decorateClass([property66({
  type: Boolean,
  attribute: "is-input-helper"
})], AtlasHelperText.prototype, "isInputHelper", 2);
__decorateClass([property66({
  type: Boolean
})], AtlasHelperText.prototype, "white", 2);
__decorateClass([state30()], AtlasHelperText.prototype, "_hasSlottedContent", 2);
AtlasHelperText = __decorateClass([customElement59("atlas-helper-text")], AtlasHelperText);

// src/components/display/atlas-promotional-banner/atlas-promotional-banner.ts
var AtlasPromotionalBanner = /*#__PURE__*/(() => {
  let AtlasPromotionalBanner = class extends WithBadgeMixin(AtlasElement) {
    constructor() {
      super(...arguments);
      this.type = "white";
      this.withBackground = false;
      this.showCloseButton = false;
      this.withMarginBottom = false;
      this._hasActions = false;
      this._hasText = false;
      this._hasSlottedHelperText = false;
      this._deviceController = new DeviceController(this, this.setAttributesForMobileBreakpoint.bind(this));
    }
    /** Fecha o banner */
    close() {
      this.collapseEffect();
      setTimeout(() => {
        this.remove();
      }, 280);
      emit(this, "atlas-promotional-banner-close");
    }
    getIllustrationOrImageSize() {
      if (this._deviceController.isMobile) return "xs";
      return this._hasActions ? "sm" : "xs";
    }
    isWhiteType() {
      return this.type === "white";
    }
    collapseEffect() {
      const sectionHeight = this._bannerRef.getBoundingClientRect().height;
      requestAnimationFrame(() => {
        this._bannerRef.style.height = `${sectionHeight}px`;
        requestAnimationFrame(() => {
          this._bannerRef.style.height = "0";
          this._bannerRef.style.padding = "0";
        });
      });
    }
    setAttributesForMobileBreakpoint() {
      var _a, _b;
      if (!this._hasActions) return;
      const actionSlot = this.shadowRoot.querySelector("slot[name='actions']");
      const actions = actionSlot.assignedElements();
      actions.forEach(action => {
        action.toggleAttribute("block", this._deviceController.isMobile);
      });
      (_a = this._illustrationRef) == null ? void 0 : _a.setAttribute("size", this.getIllustrationOrImageSize());
      (_b = this._imageRef) == null ? void 0 : _b.setAttribute("size", this.getIllustrationOrImageSize());
    }
    onSlotChange() {
      const slot = this.shadowRoot.querySelector("slot");
      const actionSlot = this.shadowRoot.querySelector("slot[name='actions']");
      const slotElements = slot.assignedElements({
        flatten: true
      }) || [];
      const actionsElements = actionSlot.assignedElements() || [];
      this._hasText = slotElements.length > 0;
      this._hasActions = actionsElements.length > 0;
      const elements = [...slotElements, ...actionsElements];
      elements.forEach(element => {
        element.toggleAttribute("white", !this.isWhiteType());
      });
      actionsElements.forEach(element => {
        element.toggleAttribute("block", this._deviceController.isMobile);
      });
    }
    wrapHelperTextSlot(assignedElements) {
      const wrapper = document.createElement("atlas-helper-text");
      wrapper.setAttribute("id", this.id);
      wrapper.setAttribute("slot", "helper-text");
      wrapper.toggleAttribute("white", !this.isWhiteType());
      assignedElements[0].before(wrapper);
      assignedElements.forEach(element => {
        element.removeAttribute("slot");
        wrapper.appendChild(element);
      });
    }
    onHelperTextSlotChange() {
      const helperTextSlot = this.shadowRoot.querySelector("slot[name=helper-text]");
      const assignedElements = (helperTextSlot == null ? void 0 : helperTextSlot.assignedElements()) || [];
      const slottedHelperTexts = assignedElements.filter(element => element.tagName === "ATLAS-HELPER-TEXT");
      if (slottedHelperTexts.length > 0) {
        slottedHelperTexts.forEach(element => {
          element.setAttribute("id", this.id);
          element.toggleAttribute("white", !this.isWhiteType());
        });
        this._hasSlottedHelperText = true;
        return;
      }
      if (assignedElements.length > 0) {
        this.wrapHelperTextSlot(assignedElements);
        this._hasSlottedHelperText = true;
        return;
      }
      this._hasSlottedHelperText = false;
    }
    renderTitle() {
      const titleClasses = {
        "title": true,
        "hide": !this.title,
        "has-close-button": this.showCloseButton && !this.badgeText
      };
      return html67`
            <atlas-heading class="${classMap49(titleClasses)}" size="h4" ?white=${!this.isWhiteType()}>
                ${this.title}
            </atlas-heading>
        `;
    }
    renderSubtitle() {
      return when44(this.subtitle, () => html67`
                <atlas-heading class="subtitle" size="h6" ?white=${!this.isWhiteType()}>
                    ${this.subtitle}
                </atlas-heading>
            `);
    }
    renderDescription() {
      const descriptionClasses = {
        description: true,
        hide: !this._hasText
      };
      return html67`
            <div class="${classMap49(descriptionClasses)}">
                <slot @slotchange=${this.onSlotChange}></slot>
            </div>
        `;
    }
    renderActions() {
      const actionsClasses = {
        actions: true,
        hide: !this._hasActions
      };
      const helperTextClasses = {
        "helper-text": true,
        "hide": !this._hasActions || !this.helperText && !this._hasSlottedHelperText
      };
      return html67`
            <div class="${classMap49(actionsClasses)}">
                <slot name="actions" @slotchange=${this.onSlotChange}></slot>
            </div>
            <div class="${classMap49(helperTextClasses)}">${this.renderHelperText()}</div>
        `;
    }
    renderHelperText() {
      return when44(this.helperText, () => html67`
                <atlas-helper-text id=${this.id} ?white=${!this.isWhiteType()}> ${this.helperText} </atlas-helper-text>
            `, () => html67` <slot name="helper-text" @slotchange=${() => this.onHelperTextSlotChange()}></slot> `);
    }
    renderContent() {
      return html67`
            <div class="content">
                ${this.renderBadge()} ${this.renderTitle()} ${this.renderSubtitle()} ${this.renderDescription()}
                ${this.renderActions()}
            </div>
        `;
    }
    renderCloseButton() {
      return when44(this.showCloseButton, () => html67`
                <div class="close">
                    <atlas-icon name="x" ?white=${!this.isWhiteType()} @click=${this.close}></atlas-icon>
                </div>
            `);
    }
    renderIllustrationOrImage() {
      if (this.illustration) {
        return html67`
                <atlas-illustration
                    class="illustration"
                    name="${this.illustration}"
                    alt="${this.title}"
                    size="${this.getIllustrationOrImageSize()}"
                ></atlas-illustration>
            `;
      }
      if (this.image) {
        return html67`
                <atlas-image
                    class="image"
                    src=${this.image}
                    alt=${this.title}
                    size="${this.getIllustrationOrImageSize()}"
                ></atlas-image>
            `;
      }
      return nothing4;
    }
    /** @internal */
    render() {
      const promotionalBannerClasses = {
        "atlas-promotional-banner": true,
        "with-background": this.withBackground,
        "with-margin-bottom": this.withMarginBottom,
        [`${this.type}`]: !!this.type
      };
      return html67`
            <div class="${classMap49(promotionalBannerClasses)}">
                ${when44(this.withBackground, () => html67`<div class="background ${this.getIllustrationOrImageSize()}"></div>`)}
                ${this.renderIllustrationOrImage()} ${this.renderContent()} ${this.renderCloseButton()}
            </div>
        `;
    }
  };
  AtlasPromotionalBanner.styles = atlas_promotional_banner_default;
  return AtlasPromotionalBanner;
})();
__decorateClass([property67({
  type: String
})], AtlasPromotionalBanner.prototype, "type", 2);
__decorateClass([property67({
  type: String
})], AtlasPromotionalBanner.prototype, "illustration", 2);
__decorateClass([property67({
  type: String
})], AtlasPromotionalBanner.prototype, "image", 2);
__decorateClass([property67({
  type: String
})], AtlasPromotionalBanner.prototype, "title", 2);
__decorateClass([property67({
  type: String
})], AtlasPromotionalBanner.prototype, "subtitle", 2);
__decorateClass([property67({
  type: Boolean,
  attribute: "with-background"
})], AtlasPromotionalBanner.prototype, "withBackground", 2);
__decorateClass([property67({
  type: String,
  attribute: "helper-text"
})], AtlasPromotionalBanner.prototype, "helperText", 2);
__decorateClass([property67({
  type: Boolean,
  attribute: "show-close-button"
})], AtlasPromotionalBanner.prototype, "showCloseButton", 2);
__decorateClass([property67({
  type: Boolean,
  attribute: "with-margin-bottom"
})], AtlasPromotionalBanner.prototype, "withMarginBottom", 2);
__decorateClass([state31()], AtlasPromotionalBanner.prototype, "_hasActions", 2);
__decorateClass([state31()], AtlasPromotionalBanner.prototype, "_hasText", 2);
__decorateClass([state31()], AtlasPromotionalBanner.prototype, "_hasSlottedHelperText", 2);
__decorateClass([query10(".atlas-promotional-banner")], AtlasPromotionalBanner.prototype, "_bannerRef", 2);
__decorateClass([query10(".illustration")], AtlasPromotionalBanner.prototype, "_illustrationRef", 2);
__decorateClass([query10(".image")], AtlasPromotionalBanner.prototype, "_imageRef", 2);
AtlasPromotionalBanner = __decorateClass([customElement60("atlas-promotional-banner")], AtlasPromotionalBanner);

// src/components/display/atlas-social-button/atlas-social-button.ts
import { customElement as customElement61, property as property68 } from "lit/decorators.js";

// src/components/display/atlas-social-button/atlas-social-button.scss
import { css as css60 } from "lit-element/lit-element.js";
var atlas_social_button_default = css60`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
.btn {
  --atlas-btn-padding-x: 1rem;
  --atlas-btn-padding-y: 0.5rem;
  --atlas-btn-font-size: 1rem;
  --atlas-btn-color: #000000;
  --atlas-btn-bg: transparent;
  --atlas-btn-border-color: transparent;
  --atlas-btn-border-radius: 0.25rem;
  --atlas-btn-hover-border-color: transparent;
  --atlas-btn-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-rgb), 40%);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-300-rgb), 0.25);
  --atlas-btn-min-height: 2.625rem;
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  box-sizing: border-box;
  padding: var(--atlas-btn-padding-y) var(--atlas-btn-padding-x);
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: var(--atlas-btn-font-size);
  font-weight: 400;
  line-height: 1.5;
  color: var(--atlas-btn-color);
  min-height: var(--atlas-btn-min-height);
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border: 1px solid var(--atlas-btn-border-color);
  border-radius: var(--atlas-btn-border-radius);
  background: var(--atlas-btn-bg);
  box-shadow: var(--atlas-btn-box-shadow);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.btn:hover {
  color: var(--atlas-btn-hover-color);
  background-color: var(--atlas-btn-hover-bg);
  border-color: var(--atlas-btn-hover-border-color);
}
.btn:focus-visible {
  color: var(--atlas-btn-color);
  background: var(--atlas-btn-bg);
  border-color: var(--atlas-btn-border-color);
  box-shadow: var(--atlas-btn-focus-box-shadow);
  outline: 0;
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--atlas-btn-disabled-color);
  pointer-events: none;
  background-color: var(--atlas-btn-disabled-bg);
  background-image: none;
  border-color: var(--atlas-btn-disabled-border-color);
  opacity: 0.35;
  box-shadow: none;
}
.btn-check + .btn:hover {
  color: var(--atlas-btn-check-hover-color);
  background-color: var(--atlas-btn-check-hover-bg);
  border-color: var(--atlas-btn-check-hover-border-color);
}
.btn-check:focus-visible + .btn {
  border-color: var(--atlas-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--atlas-btn-focus-box-shadow);
}
.btn-check:checked + .btn {
  color: var(--atlas-btn-checked-color);
  background-color: var(--atlas-btn-checked-bg);
  border-color: var(--atlas-btn-checked-border-color);
}
:not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--atlas-btn-active-color);
  background-color: var(--atlas-btn-active-bg);
  background-image: none;
  border-color: var(--atlas-btn-active-border-color);
  box-shadow: var(--atlas-btn-active-shadow);
}
:not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--atlas-btn-focus-box-shadow);
}
.btn-check:checked + .btn:hover {
  color: var(--atlas-btn-hover-color);
  background-color: var(--atlas-btn-hover-bg);
  border-color: var(--atlas-btn-hover-border-color);
}
.btn atlas-icon {
  font-size: 1.25rem;
}

.btn-sm {
  --atlas-btn-padding-y: 0.25rem;
  --atlas-btn-padding-x: 0.5rem;
  --atlas-btn-font-size: 0.875rem;
  --atlas-btn-border-radius: 0.25rem;
  --atlas-btn-min-height: 1.9375rem;
}
.btn-sm atlas-icon {
  font-size: 1rem;
}

.btn-lg {
  --atlas-btn-padding-y: 0.5rem;
  --atlas-btn-padding-x: 1rem;
  --atlas-btn-font-size: 1.25rem;
  --atlas-btn-border-radius: 0.25rem;
  --atlas-btn-min-height: 3rem;
}
.btn-lg atlas-icon {
  font-size: 1.5rem;
}

.skeleton.btn-sm {
  height: 1.9375rem;
  width: 100px;
}
.skeleton.btn-md {
  height: 2.625rem;
  width: 120px;
}
.skeleton.btn-lg {
  height: 3rem;
  width: 140px;
}

.btn-block {
  width: 100% !important;
}

.rounded-pill {
  border-radius: 9999px;
}

slot[name=hotspot]::slotted(atlas-hotspot) {
  position: absolute;
  top: -20px;
  right: -20px;
}

.btn-primary {
  --atlas-btn-bg: var(--atlas-primary);
  --atlas-btn-color: var(--atlas-contrast-primary);
  --atlas-btn-border-color: var(--atlas-primary);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-primary-600);
  --atlas-btn-hover-border-color: var(--atlas-primary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-primary-700);
  --atlas-btn-active-border-color: var(--atlas-primary-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-primary);
  --atlas-btn-disabled-border-color: var(--atlas-primary);
  --atlas-btn-disabled-bg: var(--atlas-primary);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-primary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-primary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-primary-500);
  --atlas-btn-checked-border-color: var(--atlas-primary-500);
}

.btn-outline-primary {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-primary);
  --atlas-btn-border-color: var(--atlas-primary);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-primary-600);
  --atlas-btn-hover-border-color: var(--atlas-primary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-primary-700);
  --atlas-btn-active-border-color: var(--atlas-primary-700);
  --atlas-btn-disabled-color: var(--atlas-primary);
  --atlas-btn-disabled-bg: var(--atlas-primary-100);
  --atlas-btn-disabled-border-color: var(--atlas-primary);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-primary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-primary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-primary-500);
  --atlas-btn-checked-border-color: var(--atlas-primary-500);
}

.btn-ghost-primary {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-primary);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-primary-600);
  --atlas-btn-hover-border-color: var(--atlas-primary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-primary-700);
  --atlas-btn-active-border-color: var(--atlas-primary-700);
  --atlas-btn-disabled-color: var(--atlas-primary);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-primary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-primary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-primary-500);
  --atlas-btn-checked-border-color: var(--atlas-primary-500);
}

.btn-primary-white {
  --atlas-btn-bg: #f8f9fa;
  --atlas-btn-color: var(--atlas-primary);
  --atlas-btn-border-color: #f8f9fa;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-primary);
  --atlas-btn-hover-bg: rgb(198.4, 199.2, 200);
  --atlas-btn-hover-border-color: rgb(198.4, 199.2, 200);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(#f8f9fa, 0.25);
  --atlas-btn-active-color: var(--atlas-primary);
  --atlas-btn-active-bg: rgb(148.8, 149.4, 150);
  --atlas-btn-active-border-color: rgb(148.8, 149.4, 150);
  --atlas-btn-disabled-color: var(--atlas-primary);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-disabled-bg: #f8f9fa;
  --atlas-btn-check-hover-color: none;
  --atlas-btn-check-hover-bg: none;
  --atlas-btn-check-hover-border-color: none;
  --atlas-btn-checked-color: none;
  --atlas-btn-checked-bg: none;
  --atlas-btn-checked-border-color: none;
}

.btn-outline-primary-white {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: #f8f9fa;
  --atlas-btn-border-color: #f8f9fa;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-primary);
  --atlas-btn-hover-bg: rgb(198.4, 199.2, 200);
  --atlas-btn-hover-border-color: rgb(198.4, 199.2, 200);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(#f8f9fa, 0.25);
  --atlas-btn-active-color: var(--atlas-primary);
  --atlas-btn-active-bg: rgb(148.8, 149.4, 150);
  --atlas-btn-active-border-color: rgb(148.8, 149.4, 150);
  --atlas-btn-disabled-color: var(--atlas-primary);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-disabled-bg: #f8f9fa;
  --atlas-btn-check-hover-color: none;
  --atlas-btn-check-hover-bg: none;
  --atlas-btn-check-hover-border-color: none;
  --atlas-btn-checked-color: none;
  --atlas-btn-checked-bg: none;
  --atlas-btn-checked-border-color: none;
}

.btn-secondary {
  --atlas-btn-bg: var(--atlas-secondary);
  --atlas-btn-color: var(--atlas-contrast-secondary);
  --atlas-btn-border-color: var(--atlas-secondary);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-secondary);
  --atlas-btn-hover-bg: var(--atlas-secondary-600);
  --atlas-btn-hover-border-color: var(--atlas-secondary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-secondary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-secondary);
  --atlas-btn-active-bg: var(--atlas-secondary-700);
  --atlas-btn-active-border-color: var(--atlas-secondary-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-secondary);
  --atlas-btn-disabled-border-color: var(--atlas-secondary);
  --atlas-btn-disabled-bg: var(--atlas-secondary);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-secondary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-secondary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-secondary-500);
  --atlas-btn-checked-border-color: var(--atlas-secondary-500);
}

.btn-outline-secondary {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-secondary);
  --atlas-btn-border-color: var(--atlas-secondary);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-secondary-600);
  --atlas-btn-hover-border-color: var(--atlas-secondary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-secondary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-secondary-700);
  --atlas-btn-active-border-color: var(--atlas-secondary-700);
  --atlas-btn-disabled-color: var(--atlas-secondary);
  --atlas-btn-disabled-bg: var(--atlas-secondary-100);
  --atlas-btn-disabled-border-color: var(--atlas-secondary);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-secondary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-secondary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-secondary-500);
  --atlas-btn-checked-border-color: var(--atlas-secondary-500);
}

.btn-ghost-secondary {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-secondary);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-secondary-600);
  --atlas-btn-hover-border-color: var(--atlas-secondary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-secondary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-secondary-700);
  --atlas-btn-active-border-color: var(--atlas-secondary-700);
  --atlas-btn-disabled-color: var(--atlas-secondary);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-secondary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-secondary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-secondary-500);
  --atlas-btn-checked-border-color: var(--atlas-secondary-500);
}

.btn-success {
  --atlas-btn-bg: var(--atlas-success);
  --atlas-btn-color: var(--atlas-contrast-success);
  --atlas-btn-border-color: var(--atlas-success);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-success);
  --atlas-btn-hover-bg: var(--atlas-success-600);
  --atlas-btn-hover-border-color: var(--atlas-success-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-success);
  --atlas-btn-active-bg: var(--atlas-success-700);
  --atlas-btn-active-border-color: var(--atlas-success-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-success);
  --atlas-btn-disabled-border-color: var(--atlas-success);
  --atlas-btn-disabled-bg: var(--atlas-success);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-success-400);
  --atlas-btn-check-hover-border-color: var(--atlas-success-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-success-500);
  --atlas-btn-checked-border-color: var(--atlas-success-500);
}

.btn-outline-success {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-success);
  --atlas-btn-border-color: var(--atlas-success);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-success-600);
  --atlas-btn-hover-border-color: var(--atlas-success-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-success-700);
  --atlas-btn-active-border-color: var(--atlas-success-700);
  --atlas-btn-disabled-color: var(--atlas-success);
  --atlas-btn-disabled-bg: var(--atlas-success-100);
  --atlas-btn-disabled-border-color: var(--atlas-success);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-success-400);
  --atlas-btn-check-hover-border-color: var(--atlas-success-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-success-500);
  --atlas-btn-checked-border-color: var(--atlas-success-500);
}

.btn-ghost-success {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-success);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-success-600);
  --atlas-btn-hover-border-color: var(--atlas-success-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-success-700);
  --atlas-btn-active-border-color: var(--atlas-success-700);
  --atlas-btn-disabled-color: var(--atlas-success);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-success-400);
  --atlas-btn-check-hover-border-color: var(--atlas-success-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-success-500);
  --atlas-btn-checked-border-color: var(--atlas-success-500);
}

.btn-warning {
  --atlas-btn-bg: var(--atlas-warning);
  --atlas-btn-color: var(--atlas-contrast-warning);
  --atlas-btn-border-color: var(--atlas-warning);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-warning);
  --atlas-btn-hover-bg: var(--atlas-warning-600);
  --atlas-btn-hover-border-color: var(--atlas-warning-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-warning);
  --atlas-btn-active-bg: var(--atlas-warning-700);
  --atlas-btn-active-border-color: var(--atlas-warning-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-warning);
  --atlas-btn-disabled-border-color: var(--atlas-warning);
  --atlas-btn-disabled-bg: var(--atlas-warning);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-warning-400);
  --atlas-btn-check-hover-border-color: var(--atlas-warning-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-warning-500);
  --atlas-btn-checked-border-color: var(--atlas-warning-500);
}

.btn-outline-warning {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-warning);
  --atlas-btn-border-color: var(--atlas-warning);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-warning-600);
  --atlas-btn-hover-border-color: var(--atlas-warning-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-warning-700);
  --atlas-btn-active-border-color: var(--atlas-warning-700);
  --atlas-btn-disabled-color: var(--atlas-warning);
  --atlas-btn-disabled-bg: var(--atlas-warning-100);
  --atlas-btn-disabled-border-color: var(--atlas-warning);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-warning-400);
  --atlas-btn-check-hover-border-color: var(--atlas-warning-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-warning-500);
  --atlas-btn-checked-border-color: var(--atlas-warning-500);
}

.btn-ghost-warning {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-warning);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-warning-600);
  --atlas-btn-hover-border-color: var(--atlas-warning-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-warning-700);
  --atlas-btn-active-border-color: var(--atlas-warning-700);
  --atlas-btn-disabled-color: var(--atlas-warning);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-warning-400);
  --atlas-btn-check-hover-border-color: var(--atlas-warning-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-warning-500);
  --atlas-btn-checked-border-color: var(--atlas-warning-500);
}

.btn-danger {
  --atlas-btn-bg: var(--atlas-danger);
  --atlas-btn-color: var(--atlas-contrast-danger);
  --atlas-btn-border-color: var(--atlas-danger);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-danger);
  --atlas-btn-hover-bg: var(--atlas-danger-600);
  --atlas-btn-hover-border-color: var(--atlas-danger-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-danger);
  --atlas-btn-active-bg: var(--atlas-danger-700);
  --atlas-btn-active-border-color: var(--atlas-danger-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-danger);
  --atlas-btn-disabled-border-color: var(--atlas-danger);
  --atlas-btn-disabled-bg: var(--atlas-danger);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-danger-400);
  --atlas-btn-check-hover-border-color: var(--atlas-danger-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-danger-500);
  --atlas-btn-checked-border-color: var(--atlas-danger-500);
}

.btn-outline-danger {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-danger);
  --atlas-btn-border-color: var(--atlas-danger);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-danger-600);
  --atlas-btn-hover-border-color: var(--atlas-danger-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-danger-700);
  --atlas-btn-active-border-color: var(--atlas-danger-700);
  --atlas-btn-disabled-color: var(--atlas-danger);
  --atlas-btn-disabled-bg: var(--atlas-danger-100);
  --atlas-btn-disabled-border-color: var(--atlas-danger);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-danger-400);
  --atlas-btn-check-hover-border-color: var(--atlas-danger-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-danger-500);
  --atlas-btn-checked-border-color: var(--atlas-danger-500);
}

.btn-ghost-danger {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-danger);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-danger-600);
  --atlas-btn-hover-border-color: var(--atlas-danger-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-danger-700);
  --atlas-btn-active-border-color: var(--atlas-danger-700);
  --atlas-btn-disabled-color: var(--atlas-danger);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-danger-400);
  --atlas-btn-check-hover-border-color: var(--atlas-danger-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-danger-500);
  --atlas-btn-checked-border-color: var(--atlas-danger-500);
}

.btn-highlight {
  --atlas-btn-bg: var(--atlas-highlight);
  --atlas-btn-color: var(--atlas-contrast-highlight);
  --atlas-btn-border-color: var(--atlas-highlight);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-highlight);
  --atlas-btn-hover-bg: var(--atlas-highlight-600);
  --atlas-btn-hover-border-color: var(--atlas-highlight-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-highlight-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-highlight);
  --atlas-btn-active-bg: var(--atlas-highlight-700);
  --atlas-btn-active-border-color: var(--atlas-highlight-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-highlight);
  --atlas-btn-disabled-border-color: var(--atlas-highlight);
  --atlas-btn-disabled-bg: var(--atlas-highlight);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-highlight-400);
  --atlas-btn-check-hover-border-color: var(--atlas-highlight-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-highlight-500);
  --atlas-btn-checked-border-color: var(--atlas-highlight-500);
}

.btn-outline-highlight {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-highlight);
  --atlas-btn-border-color: var(--atlas-highlight);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-highlight-600);
  --atlas-btn-hover-border-color: var(--atlas-highlight-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-highlight-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-highlight-700);
  --atlas-btn-active-border-color: var(--atlas-highlight-700);
  --atlas-btn-disabled-color: var(--atlas-highlight);
  --atlas-btn-disabled-bg: var(--atlas-highlight-100);
  --atlas-btn-disabled-border-color: var(--atlas-highlight);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-highlight-400);
  --atlas-btn-check-hover-border-color: var(--atlas-highlight-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-highlight-500);
  --atlas-btn-checked-border-color: var(--atlas-highlight-500);
}

.btn-ghost-highlight {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-highlight);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-highlight-600);
  --atlas-btn-hover-border-color: var(--atlas-highlight-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-highlight-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-highlight-700);
  --atlas-btn-active-border-color: var(--atlas-highlight-700);
  --atlas-btn-disabled-color: var(--atlas-highlight);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-highlight-400);
  --atlas-btn-check-hover-border-color: var(--atlas-highlight-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-highlight-500);
  --atlas-btn-checked-border-color: var(--atlas-highlight-500);
}

.btn-info {
  --atlas-btn-bg: var(--atlas-info);
  --atlas-btn-color: var(--atlas-contrast-info);
  --atlas-btn-border-color: var(--atlas-info);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-info);
  --atlas-btn-hover-bg: var(--atlas-info-600);
  --atlas-btn-hover-border-color: var(--atlas-info-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-info-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-info);
  --atlas-btn-active-bg: var(--atlas-info-700);
  --atlas-btn-active-border-color: var(--atlas-info-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-info);
  --atlas-btn-disabled-border-color: var(--atlas-info);
  --atlas-btn-disabled-bg: var(--atlas-info);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-info-400);
  --atlas-btn-check-hover-border-color: var(--atlas-info-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-info-500);
  --atlas-btn-checked-border-color: var(--atlas-info-500);
}

.btn-outline-info {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-info);
  --atlas-btn-border-color: var(--atlas-info);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-info-600);
  --atlas-btn-hover-border-color: var(--atlas-info-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-info-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-info-700);
  --atlas-btn-active-border-color: var(--atlas-info-700);
  --atlas-btn-disabled-color: var(--atlas-info);
  --atlas-btn-disabled-bg: var(--atlas-info-100);
  --atlas-btn-disabled-border-color: var(--atlas-info);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-info-400);
  --atlas-btn-check-hover-border-color: var(--atlas-info-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-info-500);
  --atlas-btn-checked-border-color: var(--atlas-info-500);
}

.btn-ghost-info {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-info);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-info-600);
  --atlas-btn-hover-border-color: var(--atlas-info-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-info-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-info-700);
  --atlas-btn-active-border-color: var(--atlas-info-700);
  --atlas-btn-disabled-color: var(--atlas-info);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-info-400);
  --atlas-btn-check-hover-border-color: var(--atlas-info-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-info-500);
  --atlas-btn-checked-border-color: var(--atlas-info-500);
}

.btn-wrapper {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}

:host {
  display: block;
}

:host:not([block]) {
  width: fit-content;
}

.btn {
  position: relative;
}
.btn atlas-badge {
  position: absolute;
  top: -8px;
  right: -8px;
}

:host([in-group-first]) .btn,
:host([in-group]) .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

:host([in-group-last]) .btn,
:host([in-group]) .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

:host {
  --facebook: #1877f2;
  --facebook-rgb: 24, 119, 242;
}
:host {
  --facebook-100: rgb(208.8, 227.8, 252.4);
  --facebook-100-rgb: 208.8, 227.8, 252.4;
}
:host {
  --facebook-200: rgb(162.6, 200.6, 249.8);
  --facebook-200-rgb: 162.6, 200.6, 249.8;
}
:host {
  --facebook-300: rgb(116.4, 173.4, 247.2);
  --facebook-300-rgb: 116.4, 173.4, 247.2;
}
:host {
  --facebook-400: rgb(70.2, 146.2, 244.6);
  --facebook-400-rgb: 70.2, 146.2, 244.6;
}
:host {
  --facebook-500: #1877f2;
  --facebook-500-rgb: 24, 119, 242;
}
:host {
  --facebook-600: rgb(19.2, 95.2, 193.6);
  --facebook-600-rgb: 19.2, 95.2, 193.6;
}
:host {
  --facebook-700: rgb(14.4, 71.4, 145.2);
  --facebook-700-rgb: 14.4, 71.4, 145.2;
}
:host {
  --facebook-800: rgb(9.6, 47.6, 96.8);
  --facebook-800-rgb: 9.6, 47.6, 96.8;
}
:host {
  --facebook-900: rgb(4.8, 23.8, 48.4);
  --facebook-900-rgb: 4.8, 23.8, 48.4;
}
:host .btn-facebook {
  --atlas-btn-bg: var(--facebook);
  --atlas-btn-color: #ffffff;
  --atlas-btn-border-color: var(--facebook);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: #ffffff;
  --atlas-btn-hover-bg: var(--facebook-600);
  --atlas-btn-hover-border-color: var(--facebook-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--facebook-rgb), 0.25);
  --atlas-btn-active-color: #ffffff;
  --atlas-btn-active-bg: var(--facebook-700);
  --atlas-btn-active-border-color: var(--facebook-700);
  --atlas-btn-disabled-color: #ffffff;
  --atlas-btn-disabled-border-color: var(--facebook);
  --atlas-btn-disabled-bg: var(--facebook);
}
:host .btn-outlined-facebook {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--facebook);
  --atlas-btn-border-color: var(--facebook);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: #ffffff;
  --atlas-btn-hover-bg: var(--facebook-600);
  --atlas-btn-hover-border-color: var(--facebook-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--facebook-rgb), 0.25);
  --atlas-btn-active-color: #ffffff;
  --atlas-btn-active-bg: var(--facebook-700);
  --atlas-btn-active-border-color: var(--facebook-700);
  --atlas-btn-disabled-color: var(--facebook);
  --atlas-btn-disabled-border-color: var(--facebook);
}
:host .btn-ghost-facebook {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--facebook);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: #ffffff;
  --atlas-btn-hover-bg: var(--facebook-600);
  --atlas-btn-hover-border-color: var(--facebook-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--facebook-rgb), 0.25);
  --atlas-btn-active-color: #ffffff;
  --atlas-btn-active-bg: var(--facebook-700);
  --atlas-btn-active-border-color: var(--facebook-700);
  --atlas-btn-disabled-color: var(--facebook);
  --atlas-btn-disabled-border-color: transparent;
}
:host {
  --whatsapp: #25d366;
  --whatsapp-rgb: 37, 211, 102;
}
:host {
  --whatsapp-100: rgb(211.4, 246.2, 224.4);
  --whatsapp-100-rgb: 211.4, 246.2, 224.4;
}
:host {
  --whatsapp-200: rgb(167.8, 237.4, 193.8);
  --whatsapp-200-rgb: 167.8, 237.4, 193.8;
}
:host {
  --whatsapp-300: rgb(124.2, 228.6, 163.2);
  --whatsapp-300-rgb: 124.2, 228.6, 163.2;
}
:host {
  --whatsapp-400: rgb(80.6, 219.8, 132.6);
  --whatsapp-400-rgb: 80.6, 219.8, 132.6;
}
:host {
  --whatsapp-500: #25d366;
  --whatsapp-500-rgb: 37, 211, 102;
}
:host {
  --whatsapp-600: rgb(29.6, 168.8, 81.6);
  --whatsapp-600-rgb: 29.6, 168.8, 81.6;
}
:host {
  --whatsapp-700: rgb(22.2, 126.6, 61.2);
  --whatsapp-700-rgb: 22.2, 126.6, 61.2;
}
:host {
  --whatsapp-800: rgb(14.8, 84.4, 40.8);
  --whatsapp-800-rgb: 14.8, 84.4, 40.8;
}
:host {
  --whatsapp-900: rgb(7.4, 42.2, 20.4);
  --whatsapp-900-rgb: 7.4, 42.2, 20.4;
}
:host .btn-whatsapp {
  --atlas-btn-bg: var(--whatsapp);
  --atlas-btn-color: #ffffff;
  --atlas-btn-border-color: var(--whatsapp);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: #ffffff;
  --atlas-btn-hover-bg: var(--whatsapp-600);
  --atlas-btn-hover-border-color: var(--whatsapp-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--whatsapp-rgb), 0.25);
  --atlas-btn-active-color: #ffffff;
  --atlas-btn-active-bg: var(--whatsapp-700);
  --atlas-btn-active-border-color: var(--whatsapp-700);
  --atlas-btn-disabled-color: #ffffff;
  --atlas-btn-disabled-border-color: var(--whatsapp);
  --atlas-btn-disabled-bg: var(--whatsapp);
}
:host .btn-outlined-whatsapp {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--whatsapp);
  --atlas-btn-border-color: var(--whatsapp);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: #ffffff;
  --atlas-btn-hover-bg: var(--whatsapp-600);
  --atlas-btn-hover-border-color: var(--whatsapp-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--whatsapp-rgb), 0.25);
  --atlas-btn-active-color: #ffffff;
  --atlas-btn-active-bg: var(--whatsapp-700);
  --atlas-btn-active-border-color: var(--whatsapp-700);
  --atlas-btn-disabled-color: var(--whatsapp);
  --atlas-btn-disabled-border-color: var(--whatsapp);
}
:host .btn-ghost-whatsapp {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--whatsapp);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: #ffffff;
  --atlas-btn-hover-bg: var(--whatsapp-600);
  --atlas-btn-hover-border-color: var(--whatsapp-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--whatsapp-rgb), 0.25);
  --atlas-btn-active-color: #ffffff;
  --atlas-btn-active-bg: var(--whatsapp-700);
  --atlas-btn-active-border-color: var(--whatsapp-700);
  --atlas-btn-disabled-color: var(--whatsapp);
  --atlas-btn-disabled-border-color: transparent;
}
:host {
  --instagram: #ff0069;
  --instagram-rgb: 255, 0, 105;
}
:host {
  --instagram-100: #ffcce1;
  --instagram-100-rgb: 255, 204, 225;
}
:host {
  --instagram-200: #ff99c3;
  --instagram-200-rgb: 255, 153, 195;
}
:host {
  --instagram-300: #ff66a5;
  --instagram-300-rgb: 255, 102, 165;
}
:host {
  --instagram-400: #ff3387;
  --instagram-400-rgb: 255, 51, 135;
}
:host {
  --instagram-500: #ff0069;
  --instagram-500-rgb: 255, 0, 105;
}
:host {
  --instagram-600: #cc0054;
  --instagram-600-rgb: 204, 0, 84;
}
:host {
  --instagram-700: #99003f;
  --instagram-700-rgb: 153, 0, 63;
}
:host {
  --instagram-800: #66002a;
  --instagram-800-rgb: 102, 0, 42;
}
:host {
  --instagram-900: #330015;
  --instagram-900-rgb: 51, 0, 21;
}
:host .btn-instagram {
  --atlas-btn-bg: var(--instagram);
  --atlas-btn-color: #ffffff;
  --atlas-btn-border-color: var(--instagram);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: #ffffff;
  --atlas-btn-hover-bg: var(--instagram-600);
  --atlas-btn-hover-border-color: var(--instagram-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--instagram-rgb), 0.25);
  --atlas-btn-active-color: #ffffff;
  --atlas-btn-active-bg: var(--instagram-700);
  --atlas-btn-active-border-color: var(--instagram-700);
  --atlas-btn-disabled-color: #ffffff;
  --atlas-btn-disabled-border-color: var(--instagram);
  --atlas-btn-disabled-bg: var(--instagram);
}
:host .btn-outlined-instagram {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--instagram);
  --atlas-btn-border-color: var(--instagram);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: #ffffff;
  --atlas-btn-hover-bg: var(--instagram-600);
  --atlas-btn-hover-border-color: var(--instagram-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--instagram-rgb), 0.25);
  --atlas-btn-active-color: #ffffff;
  --atlas-btn-active-bg: var(--instagram-700);
  --atlas-btn-active-border-color: var(--instagram-700);
  --atlas-btn-disabled-color: var(--instagram);
  --atlas-btn-disabled-border-color: var(--instagram);
}
:host .btn-ghost-instagram {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--instagram);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: #ffffff;
  --atlas-btn-hover-bg: var(--instagram-600);
  --atlas-btn-hover-border-color: var(--instagram-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--instagram-rgb), 0.25);
  --atlas-btn-active-color: #ffffff;
  --atlas-btn-active-bg: var(--instagram-700);
  --atlas-btn-active-border-color: var(--instagram-700);
  --atlas-btn-disabled-color: var(--instagram);
  --atlas-btn-disabled-border-color: transparent;
}
:host {
  --linkedin: #0077b5;
  --linkedin-rgb: 0, 119, 181;
}
:host {
  --linkedin-100: rgb(204, 227.8, 240.2);
  --linkedin-100-rgb: 204, 227.8, 240.2;
}
:host {
  --linkedin-200: rgb(153, 200.6, 225.4);
  --linkedin-200-rgb: 153, 200.6, 225.4;
}
:host {
  --linkedin-300: rgb(102, 173.4, 210.6);
  --linkedin-300-rgb: 102, 173.4, 210.6;
}
:host {
  --linkedin-400: rgb(51, 146.2, 195.8);
  --linkedin-400-rgb: 51, 146.2, 195.8;
}
:host {
  --linkedin-500: #0077b5;
  --linkedin-500-rgb: 0, 119, 181;
}
:host {
  --linkedin-600: rgb(0, 95.2, 144.8);
  --linkedin-600-rgb: 0, 95.2, 144.8;
}
:host {
  --linkedin-700: rgb(0, 71.4, 108.6);
  --linkedin-700-rgb: 0, 71.4, 108.6;
}
:host {
  --linkedin-800: rgb(0, 47.6, 72.4);
  --linkedin-800-rgb: 0, 47.6, 72.4;
}
:host {
  --linkedin-900: rgb(0, 23.8, 36.2);
  --linkedin-900-rgb: 0, 23.8, 36.2;
}
:host .btn-linkedin {
  --atlas-btn-bg: var(--linkedin);
  --atlas-btn-color: #ffffff;
  --atlas-btn-border-color: var(--linkedin);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: #ffffff;
  --atlas-btn-hover-bg: var(--linkedin-600);
  --atlas-btn-hover-border-color: var(--linkedin-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--linkedin-rgb), 0.25);
  --atlas-btn-active-color: #ffffff;
  --atlas-btn-active-bg: var(--linkedin-700);
  --atlas-btn-active-border-color: var(--linkedin-700);
  --atlas-btn-disabled-color: #ffffff;
  --atlas-btn-disabled-border-color: var(--linkedin);
  --atlas-btn-disabled-bg: var(--linkedin);
}
:host .btn-outlined-linkedin {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--linkedin);
  --atlas-btn-border-color: var(--linkedin);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: #ffffff;
  --atlas-btn-hover-bg: var(--linkedin-600);
  --atlas-btn-hover-border-color: var(--linkedin-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--linkedin-rgb), 0.25);
  --atlas-btn-active-color: #ffffff;
  --atlas-btn-active-bg: var(--linkedin-700);
  --atlas-btn-active-border-color: var(--linkedin-700);
  --atlas-btn-disabled-color: var(--linkedin);
  --atlas-btn-disabled-border-color: var(--linkedin);
}
:host .btn-ghost-linkedin {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--linkedin);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: #ffffff;
  --atlas-btn-hover-bg: var(--linkedin-600);
  --atlas-btn-hover-border-color: var(--linkedin-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--linkedin-rgb), 0.25);
  --atlas-btn-active-color: #ffffff;
  --atlas-btn-active-bg: var(--linkedin-700);
  --atlas-btn-active-border-color: var(--linkedin-700);
  --atlas-btn-disabled-color: var(--linkedin);
  --atlas-btn-disabled-border-color: transparent;
}`;

// src/components/display/atlas-social-button/atlas-social-button.ts
var AtlasSocialButton = /*#__PURE__*/(() => {
  let AtlasSocialButton = class extends AtlasButton {
    constructor() {
      super(...arguments);
      this.media = "general";
      this.showDescription = false;
    }
    /** @internal */
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.changeSocialInfo();
    }
    /** @internal */
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
    }
    toggleButtonMedia() {
      this.changeSocialInfo();
    }
    getButtonClasses() {
      const typeInfo = this.getSocialInfo();
      return __spreadProps(__spreadValues({}, super.getButtonClasses()), {
        [typeInfo == null ? void 0 : typeInfo.className]: typeInfo && !!typeInfo.className,
        [`btn-${this.type}-${this.media}`]: this.type !== "filled"
      });
    }
    getSocialInfo() {
      return {
        linkedin: {
          className: "btn-linkedin",
          icon: "linkedin",
          description: "Linkedin"
        },
        instagram: {
          className: "btn-instagram",
          icon: "instagram",
          description: "Instagram"
        },
        whatsapp: {
          className: "btn-whatsapp",
          icon: "whatsapp",
          description: "Whatsapp"
        },
        facebook: {
          className: "btn-facebook",
          icon: "facebook",
          description: "Facebook"
        },
        general: {
          icon: "link",
          description: "Link"
        }
      }[this.media];
    }
    changeSocialInfo() {
      const typeInfo = this.getSocialInfo();
      if (typeInfo && !this.icon) {
        this.icon = typeInfo.icon;
        if (this.showDescription) this.description = typeInfo.description;
      }
    }
  };
  AtlasSocialButton.styles = atlas_social_button_default;
  return AtlasSocialButton;
})();
__decorateClass([property68({
  type: String,
  reflect: true
})], AtlasSocialButton.prototype, "media", 2);
__decorateClass([property68({
  type: Boolean,
  attribute: "show-description",
  reflect: true
})], AtlasSocialButton.prototype, "showDescription", 2);
__decorateClass([Watch("media")], AtlasSocialButton.prototype, "toggleButtonMedia", 1);
AtlasSocialButton = __decorateClass([customElement61("atlas-social-button")], AtlasSocialButton);

// src/components/display/atlas-tag/atlas-tag.ts
import { LitElement as LitElement18, html as html68 } from "lit";
import { customElement as customElement62, property as property69 } from "lit/decorators.js";
import { classMap as classMap50 } from "lit/directives/class-map.js";

// src/components/display/atlas-tag/atlas-tag.scss
import { css as css61 } from "lit-element/lit-element.js";
var atlas_tag_default = css61`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
.color-white {
  color: #ffffff !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.color-primary {
  color: var(--atlas-primary) !important;
}

.bg-primary {
  background-color: var(--atlas-primary) !important;
}

.color-primary-100 {
  color: var(--atlas-primary-100) !important;
}

.bg-primary-100 {
  background-color: var(--atlas-primary-100) !important;
}

.color-primary-200 {
  color: var(--atlas-primary-200) !important;
}

.bg-primary-200 {
  background-color: var(--atlas-primary-200) !important;
}

.color-primary-300 {
  color: var(--atlas-primary-300) !important;
}

.bg-primary-300 {
  background-color: var(--atlas-primary-300) !important;
}

.color-primary-400 {
  color: var(--atlas-primary-400) !important;
}

.bg-primary-400 {
  background-color: var(--atlas-primary-400) !important;
}

.color-primary-500 {
  color: var(--atlas-primary-500) !important;
}

.bg-primary-500 {
  background-color: var(--atlas-primary-500) !important;
}

.color-primary-600 {
  color: var(--atlas-primary-600) !important;
}

.bg-primary-600 {
  background-color: var(--atlas-primary-600) !important;
}

.color-primary-700 {
  color: var(--atlas-primary-700) !important;
}

.bg-primary-700 {
  background-color: var(--atlas-primary-700) !important;
}

.color-primary-800 {
  color: var(--atlas-primary-800) !important;
}

.bg-primary-800 {
  background-color: var(--atlas-primary-800) !important;
}

.color-primary-900 {
  color: var(--atlas-primary-900) !important;
}

.bg-primary-900 {
  background-color: var(--atlas-primary-900) !important;
}

.active-primary[active], .active-primary.active, .active-primary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-secondary {
  color: var(--atlas-secondary) !important;
}

.bg-secondary {
  background-color: var(--atlas-secondary) !important;
}

.color-secondary-100 {
  color: var(--atlas-secondary-100) !important;
}

.bg-secondary-100 {
  background-color: var(--atlas-secondary-100) !important;
}

.color-secondary-200 {
  color: var(--atlas-secondary-200) !important;
}

.bg-secondary-200 {
  background-color: var(--atlas-secondary-200) !important;
}

.color-secondary-300 {
  color: var(--atlas-secondary-300) !important;
}

.bg-secondary-300 {
  background-color: var(--atlas-secondary-300) !important;
}

.color-secondary-400 {
  color: var(--atlas-secondary-400) !important;
}

.bg-secondary-400 {
  background-color: var(--atlas-secondary-400) !important;
}

.color-secondary-500 {
  color: var(--atlas-secondary-500) !important;
}

.bg-secondary-500 {
  background-color: var(--atlas-secondary-500) !important;
}

.color-secondary-600 {
  color: var(--atlas-secondary-600) !important;
}

.bg-secondary-600 {
  background-color: var(--atlas-secondary-600) !important;
}

.color-secondary-700 {
  color: var(--atlas-secondary-700) !important;
}

.bg-secondary-700 {
  background-color: var(--atlas-secondary-700) !important;
}

.color-secondary-800 {
  color: var(--atlas-secondary-800) !important;
}

.bg-secondary-800 {
  background-color: var(--atlas-secondary-800) !important;
}

.color-secondary-900 {
  color: var(--atlas-secondary-900) !important;
}

.bg-secondary-900 {
  background-color: var(--atlas-secondary-900) !important;
}

.active-secondary[active], .active-secondary.active, .active-secondary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-success {
  color: var(--atlas-success) !important;
}

.bg-success {
  background-color: var(--atlas-success) !important;
}

.color-success-100 {
  color: var(--atlas-success-100) !important;
}

.bg-success-100 {
  background-color: var(--atlas-success-100) !important;
}

.color-success-200 {
  color: var(--atlas-success-200) !important;
}

.bg-success-200 {
  background-color: var(--atlas-success-200) !important;
}

.color-success-300 {
  color: var(--atlas-success-300) !important;
}

.bg-success-300 {
  background-color: var(--atlas-success-300) !important;
}

.color-success-400 {
  color: var(--atlas-success-400) !important;
}

.bg-success-400 {
  background-color: var(--atlas-success-400) !important;
}

.color-success-500 {
  color: var(--atlas-success-500) !important;
}

.bg-success-500 {
  background-color: var(--atlas-success-500) !important;
}

.color-success-600 {
  color: var(--atlas-success-600) !important;
}

.bg-success-600 {
  background-color: var(--atlas-success-600) !important;
}

.color-success-700 {
  color: var(--atlas-success-700) !important;
}

.bg-success-700 {
  background-color: var(--atlas-success-700) !important;
}

.color-success-800 {
  color: var(--atlas-success-800) !important;
}

.bg-success-800 {
  background-color: var(--atlas-success-800) !important;
}

.color-success-900 {
  color: var(--atlas-success-900) !important;
}

.bg-success-900 {
  background-color: var(--atlas-success-900) !important;
}

.active-success[active], .active-success.active, .active-success:active {
  background-color: var(--atlas-success) !important;
  color: var(--atlas-contrast-success) !important;
}

.color-warning {
  color: var(--atlas-warning) !important;
}

.bg-warning {
  background-color: var(--atlas-warning) !important;
}

.color-warning-100 {
  color: var(--atlas-warning-100) !important;
}

.bg-warning-100 {
  background-color: var(--atlas-warning-100) !important;
}

.color-warning-200 {
  color: var(--atlas-warning-200) !important;
}

.bg-warning-200 {
  background-color: var(--atlas-warning-200) !important;
}

.color-warning-300 {
  color: var(--atlas-warning-300) !important;
}

.bg-warning-300 {
  background-color: var(--atlas-warning-300) !important;
}

.color-warning-400 {
  color: var(--atlas-warning-400) !important;
}

.bg-warning-400 {
  background-color: var(--atlas-warning-400) !important;
}

.color-warning-500 {
  color: var(--atlas-warning-500) !important;
}

.bg-warning-500 {
  background-color: var(--atlas-warning-500) !important;
}

.color-warning-600 {
  color: var(--atlas-warning-600) !important;
}

.bg-warning-600 {
  background-color: var(--atlas-warning-600) !important;
}

.color-warning-700 {
  color: var(--atlas-warning-700) !important;
}

.bg-warning-700 {
  background-color: var(--atlas-warning-700) !important;
}

.color-warning-800 {
  color: var(--atlas-warning-800) !important;
}

.bg-warning-800 {
  background-color: var(--atlas-warning-800) !important;
}

.color-warning-900 {
  color: var(--atlas-warning-900) !important;
}

.bg-warning-900 {
  background-color: var(--atlas-warning-900) !important;
}

.active-warning[active], .active-warning.active, .active-warning:active {
  background-color: var(--atlas-warning) !important;
  color: var(--atlas-contrast-warning) !important;
}

.color-danger {
  color: var(--atlas-danger) !important;
}

.bg-danger {
  background-color: var(--atlas-danger) !important;
}

.color-danger-100 {
  color: var(--atlas-danger-100) !important;
}

.bg-danger-100 {
  background-color: var(--atlas-danger-100) !important;
}

.color-danger-200 {
  color: var(--atlas-danger-200) !important;
}

.bg-danger-200 {
  background-color: var(--atlas-danger-200) !important;
}

.color-danger-300 {
  color: var(--atlas-danger-300) !important;
}

.bg-danger-300 {
  background-color: var(--atlas-danger-300) !important;
}

.color-danger-400 {
  color: var(--atlas-danger-400) !important;
}

.bg-danger-400 {
  background-color: var(--atlas-danger-400) !important;
}

.color-danger-500 {
  color: var(--atlas-danger-500) !important;
}

.bg-danger-500 {
  background-color: var(--atlas-danger-500) !important;
}

.color-danger-600 {
  color: var(--atlas-danger-600) !important;
}

.bg-danger-600 {
  background-color: var(--atlas-danger-600) !important;
}

.color-danger-700 {
  color: var(--atlas-danger-700) !important;
}

.bg-danger-700 {
  background-color: var(--atlas-danger-700) !important;
}

.color-danger-800 {
  color: var(--atlas-danger-800) !important;
}

.bg-danger-800 {
  background-color: var(--atlas-danger-800) !important;
}

.color-danger-900 {
  color: var(--atlas-danger-900) !important;
}

.bg-danger-900 {
  background-color: var(--atlas-danger-900) !important;
}

.active-danger[active], .active-danger.active, .active-danger:active {
  background-color: var(--atlas-danger) !important;
  color: var(--atlas-contrast-danger) !important;
}

.color-highlight {
  color: var(--atlas-highlight) !important;
}

.bg-highlight {
  background-color: var(--atlas-highlight) !important;
}

.color-highlight-100 {
  color: var(--atlas-highlight-100) !important;
}

.bg-highlight-100 {
  background-color: var(--atlas-highlight-100) !important;
}

.color-highlight-200 {
  color: var(--atlas-highlight-200) !important;
}

.bg-highlight-200 {
  background-color: var(--atlas-highlight-200) !important;
}

.color-highlight-300 {
  color: var(--atlas-highlight-300) !important;
}

.bg-highlight-300 {
  background-color: var(--atlas-highlight-300) !important;
}

.color-highlight-400 {
  color: var(--atlas-highlight-400) !important;
}

.bg-highlight-400 {
  background-color: var(--atlas-highlight-400) !important;
}

.color-highlight-500 {
  color: var(--atlas-highlight-500) !important;
}

.bg-highlight-500 {
  background-color: var(--atlas-highlight-500) !important;
}

.color-highlight-600 {
  color: var(--atlas-highlight-600) !important;
}

.bg-highlight-600 {
  background-color: var(--atlas-highlight-600) !important;
}

.color-highlight-700 {
  color: var(--atlas-highlight-700) !important;
}

.bg-highlight-700 {
  background-color: var(--atlas-highlight-700) !important;
}

.color-highlight-800 {
  color: var(--atlas-highlight-800) !important;
}

.bg-highlight-800 {
  background-color: var(--atlas-highlight-800) !important;
}

.color-highlight-900 {
  color: var(--atlas-highlight-900) !important;
}

.bg-highlight-900 {
  background-color: var(--atlas-highlight-900) !important;
}

.active-highlight[active], .active-highlight.active, .active-highlight:active {
  background-color: var(--atlas-highlight) !important;
  color: var(--atlas-contrast-highlight) !important;
}

.color-info {
  color: var(--atlas-info) !important;
}

.bg-info {
  background-color: var(--atlas-info) !important;
}

.color-info-100 {
  color: var(--atlas-info-100) !important;
}

.bg-info-100 {
  background-color: var(--atlas-info-100) !important;
}

.color-info-200 {
  color: var(--atlas-info-200) !important;
}

.bg-info-200 {
  background-color: var(--atlas-info-200) !important;
}

.color-info-300 {
  color: var(--atlas-info-300) !important;
}

.bg-info-300 {
  background-color: var(--atlas-info-300) !important;
}

.color-info-400 {
  color: var(--atlas-info-400) !important;
}

.bg-info-400 {
  background-color: var(--atlas-info-400) !important;
}

.color-info-500 {
  color: var(--atlas-info-500) !important;
}

.bg-info-500 {
  background-color: var(--atlas-info-500) !important;
}

.color-info-600 {
  color: var(--atlas-info-600) !important;
}

.bg-info-600 {
  background-color: var(--atlas-info-600) !important;
}

.color-info-700 {
  color: var(--atlas-info-700) !important;
}

.bg-info-700 {
  background-color: var(--atlas-info-700) !important;
}

.color-info-800 {
  color: var(--atlas-info-800) !important;
}

.bg-info-800 {
  background-color: var(--atlas-info-800) !important;
}

.color-info-900 {
  color: var(--atlas-info-900) !important;
}

.bg-info-900 {
  background-color: var(--atlas-info-900) !important;
}

.active-info[active], .active-info.active, .active-info:active {
  background-color: var(--atlas-info) !important;
  color: var(--atlas-contrast-info) !important;
}

.atlas-tag {
  border-radius: 0.25rem;
  border: 0;
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  box-sizing: border-box;
  gap: 0.75rem;
  color: #ffffff;
  cursor: pointer;
}
.atlas-tag span {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 0.75rem;
  line-height: 1;
  font-weight: 600;
}
.atlas-tag:hover {
  background: var(--atlas-secondary-600);
}
.atlas-tag:active {
  background: var(--atlas-secondary-700);
}
.atlas-tag:focus-visible {
  outline: none;
  box-shadow: 0 0 0 4px rgba(var(--atlas-secondary-rgb), 0.25);
}
.atlas-tag[disabled] {
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.65), rgba(255, 255, 255, 0.65)), var(--atlas-secondary);
  cursor: default;
}

@media screen and (min-width: 992px) {
  .atlas-tag {
    padding: 0.25rem 0.5rem;
    gap: 0.5rem;
  }
}`;

// src/components/display/atlas-tag/atlas-tag.ts
var AtlasTag = /*#__PURE__*/(() => {
  let AtlasTag = class extends WithTooltipMixin(LitElement18) {
    constructor() {
      super(...arguments);
      this.theme = "secondary";
    }
    onClickTag() {
      emit(this, "atlas-tag-click");
    }
    onClickClose(event) {
      if (this.disabled) return;
      event.stopPropagation();
      emit(this, "atlas-tag-close-click");
    }
    getTagText() {
      if (!this.maxlength) return this.text;
      if (this.text.length <= this.maxlength) return this.text;
      this.tooltip = this.text;
      return `${this.text.substring(0, this.maxlength)}...`;
    }
    /** @internal */
    render() {
      const tagClass = {
        "atlas-tag": true,
        [`bg-${this.theme}`]: !!this.theme
      };
      return html68`
            <button
                class=${classMap50(tagClass)}
                @click=${this.onClickTag}
                ?disabled=${this.disabled}
                data-atlas-tooltip="tag-tooltip"
            >
                <span>${this.getTagText()}</span>
                <atlas-icon name="x" size="2x" @click=${this.onClickClose}></atlas-icon>
                ${this.renderTooltip("tag-tooltip")}
            </button>
        `;
    }
  };
  AtlasTag.styles = atlas_tag_default;
  return AtlasTag;
})();
__decorateClass([property69({
  type: String
})], AtlasTag.prototype, "text", 2);
__decorateClass([property69({
  type: Boolean
})], AtlasTag.prototype, "disabled", 2);
__decorateClass([property69({
  type: String
})], AtlasTag.prototype, "theme", 2);
__decorateClass([property69({
  type: Number
})], AtlasTag.prototype, "maxlength", 2);
AtlasTag = __decorateClass([customElement62("atlas-tag")], AtlasTag);

// src/components/display/atlas-toast/atlas-toast.ts
import { html as html69, literal as literal8 } from "lit/static-html.js";
import { customElement as customElement63, property as property70, state as state32 } from "lit/decorators.js";
import { when as when45 } from "lit/directives/when.js";
import { classMap as classMap51 } from "lit/directives/class-map.js";
import { ifDefined as ifDefined15 } from "lit/directives/if-defined.js";

// src/components/display/atlas-toast/atlas-toast.scss
import { css as css62 } from "lit-element/lit-element.js";
var atlas_toast_default = css62`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Z-index mapping for the floating elements */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: inline-block;
}

.atlas-toast {
  display: flex;
  flex-direction: row;
  padding: 0.75rem;
  gap: 0.5rem;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  z-index: 6000;
  border-radius: 0.5rem;
  width: 328px;
  border: 1px solid transparent;
  box-sizing: border-box;
  background-color: #ffffff;
  text-align: left;
}
.atlas-toast .toast-icon,
.atlas-toast .toast-close {
  flex: 0 0 auto;
}
.atlas-toast .toast-icon {
  position: relative;
  height: min-content;
  margin-top: 0.1rem;
  flex: 0 0 1rem;
}
.atlas-toast .toast-icon.has-overlay-icon {
  flex: 0 0 2rem;
  height: 2rem;
  margin-top: 0;
  border-radius: 50%;
  background: var(--atlas-secondary-100);
  display: flex;
  align-items: center;
  justify-content: center;
}
.atlas-toast .toast-icon .overlay-icon-container {
  width: 1rem;
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 2px solid #ffffff;
  position: absolute;
  bottom: -6px;
  right: -6px;
}
.atlas-toast .toast-icon .overlay-icon-container.primary {
  background-color: var(--atlas-primary);
}
.atlas-toast .toast-icon .overlay-icon-container.secondary {
  background-color: var(--atlas-secondary);
}
.atlas-toast .toast-icon .overlay-icon-container.success {
  background-color: var(--atlas-success);
}
.atlas-toast .toast-icon .overlay-icon-container.warning {
  background-color: var(--atlas-warning);
}
.atlas-toast .toast-icon .overlay-icon-container.danger {
  background-color: var(--atlas-danger);
}
.atlas-toast .toast-icon .overlay-icon-container.highlight {
  background-color: var(--atlas-highlight);
}
.atlas-toast .toast-icon .overlay-icon-container.info {
  background-color: var(--atlas-info);
}
.atlas-toast .toast-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1 1 auto;
}
.atlas-toast .toast-info .toast-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.atlas-toast .toast-info .toast-actions {
  display: none;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.5rem;
}
@media screen and (min-width: 992px) {
  .atlas-toast .toast-info .toast-actions {
    flex-direction: row;
  }
}
.atlas-toast .toast-info .toast-actions.has-actions {
  display: flex;
}
.atlas-toast .toast-close {
  height: 1.5rem;
  width: 1.5rem;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.25s ease;
}
.atlas-toast .toast-close:hover {
  background-color: var(--atlas-secondary-200);
}
.atlas-toast .toast-close atlas-icon {
  cursor: pointer;
}
.atlas-toast.interactive {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  text-align: inherit;
  cursor: pointer;
  appearance: none;
  outline: none;
  color: inherit;
  margin: 0;
  text-decoration: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  cursor: pointer;
  padding: 0.75rem;
  text-decoration: none;
  background-color: #ffffff;
}
.atlas-toast.interactive:hover {
  background-color: var(--atlas-primary-100);
}
.atlas-toast.interactive:focus, .atlas-toast.interactive:focus-within, .atlas-toast.interactive:focus-visible {
  outline: none;
}
.atlas-toast.interactive:focus-visible {
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-rgb), 40%);
  border-color: var(--atlas-primary-500);
}

@media screen and (min-width: 992px) {
  .atlas-toast {
    width: 450px;
    padding: 1rem;
  }
  .atlas-toast.interactive {
    padding: 1rem;
  }
}`;

// src/components/display/atlas-toast/atlas-toast.ts
var AtlasToast = /*#__PURE__*/(() => {
  let AtlasToast = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.header = "";
      this.headerInfo = "";
      this.isExternalLink = false;
      this.hasAction = false;
      this._hasSlottedActions = false;
    }
    /**
     * Fecha o elemento do toast
     */
    close() {
      emit(this, "atlas-toast-close");
    }
    onToastClick() {
      emit(this, "atlas-toast-click");
    }
    onToastCloseClick(event) {
      event.preventDefault();
      this.close();
    }
    onActionsSlotChange() {
      this._hasSlottedActions = !isEmptySlot(this, "actions");
    }
    renderOverlayIcon() {
      const overlayIconClass = {
        "overlay-icon-container": true,
        [`${this.overlayIconTheme}`]: !!this.overlayIconTheme
      };
      return when45(!!this.overlayIcon, () => html69`
                <div class="${classMap51(overlayIconClass)}">
                    <atlas-icon class="overlay-icon" name=${this.overlayIcon} white size="2x"></atlas-icon>
                </div>
            `);
    }
    renderIcon() {
      const toastIconClass = {
        "toast-icon": true,
        "has-overlay-icon": !!this.overlayIcon
      };
      return when45(!!this.icon, () => html69`
                <div class="${classMap51(toastIconClass)}">
                    <atlas-icon name="${this.icon}" theme="${this.iconTheme}" size="2x"></atlas-icon>
                    ${this.renderOverlayIcon()}
                </div>
            `);
    }
    renderHeader() {
      return when45(!!this.header, () => html69`
                <div class="toast-header">
                    <atlas-text bold size="sm">${this.header}</atlas-text>
                    <atlas-text muted size="xs">${this.headerInfo}</atlas-text>
                </div>
            `);
    }
    isInteractive() {
      return (!!this.href || this.hasAction) && !this._hasSlottedActions;
    }
    getToastTag() {
      if (this._hasSlottedActions) {
        return literal8`div`;
      }
      if (!!this.href) {
        return literal8`a`;
      }
      if (this.hasAction) {
        return literal8`button`;
      }
      return literal8`div`;
    }
    /** @internal */
    render() {
      const isInteractive = this.isInteractive();
      const toastClass = {
        "atlas-toast": true,
        "interactive": isInteractive
      };
      const toastActionsClass = {
        "toast-actions": true,
        "has-actions": this._hasSlottedActions
      };
      const tag = this.getToastTag();
      return html69`
            <${tag}
                class="${classMap51(toastClass)}"
                href=${ifDefined15(this.href ? this.href : void 0)}
                rel="${ifDefined15(this.href && this.isExternalLink ? "noreferrer" : void 0)}"
                target="${ifDefined15(this.href && this.isExternalLink ? "_blank" : void 0)}"
                @click=${isInteractive ? this.onToastClick : void 0}
            >
                ${this.renderIcon()}
                <div class="toast-info">
                    ${this.renderHeader()}
                    <atlas-text size="sm">
                        <slot></slot>
                    </atlas-text>
                    <div class="${classMap51(toastActionsClass)}">
                        <slot name="actions" @slotchange=${this.onActionsSlotChange}></slot>
                    </div>
                </div>
                <atlas-icon-button
                    icon="x"
                    theme="secondary"
                    class="toast-close"
                    size="2x"
                    @click=${this.onToastCloseClick}
                    theme-on-interactions
                ></atlas-icon-button>
            </${tag}>
        `;
    }
  };
  AtlasToast.styles = atlas_toast_default;
  return AtlasToast;
})();
__decorateClass([property70({
  type: String
})], AtlasToast.prototype, "header", 2);
__decorateClass([property70({
  type: String,
  attribute: "header-info"
})], AtlasToast.prototype, "headerInfo", 2);
__decorateClass([property70({
  type: String
})], AtlasToast.prototype, "icon", 2);
__decorateClass([property70({
  type: String,
  attribute: "icon-theme"
})], AtlasToast.prototype, "iconTheme", 2);
__decorateClass([property70({
  type: String,
  attribute: "overlay-icon"
})], AtlasToast.prototype, "overlayIcon", 2);
__decorateClass([property70({
  type: String,
  attribute: "overlay-icon-theme"
})], AtlasToast.prototype, "overlayIconTheme", 2);
__decorateClass([property70({
  type: String
})], AtlasToast.prototype, "href", 2);
__decorateClass([property70({
  type: Boolean,
  attribute: "is-external-link"
})], AtlasToast.prototype, "isExternalLink", 2);
__decorateClass([property70({
  type: Boolean,
  attribute: "has-action"
})], AtlasToast.prototype, "hasAction", 2);
__decorateClass([state32()], AtlasToast.prototype, "_hasSlottedActions", 2);
AtlasToast = __decorateClass([customElement63("atlas-toast")], AtlasToast);

// src/components/display/atlas-toast-container/atlas-toast-container.ts
import { html as html70 } from "lit";
import { customElement as customElement64, query as query11, state as state33 } from "lit/decorators.js";

// src/internals/time-utils.ts
var ONE_SECOND_IN_MILLISECONDS = 1e3;
function parseSecondsToMilliseconds(seconds) {
  return seconds * ONE_SECOND_IN_MILLISECONDS;
}

// src/components/display/atlas-toast-container/atlas-toast-container.scss
import { css as css63 } from "lit-element/lit-element.js";
var atlas_toast_container_default = css63`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: contents;
}

.atlas-toast-container {
  position: fixed;
  z-index: 9998;
  top: 80px;
  margin: 0 auto;
  width: 100%;
  right: 0;
}
.atlas-toast-container ::slotted(atlas-toast) {
  position: absolute;
}

@media screen and (min-width: 992px) {
  .atlas-toast-container {
    margin: 0;
    top: 90px;
    right: 16px;
    width: 450px;
  }
}`;

// src/components/display/atlas-toast-container/atlas-toast-container.ts
var AtlasToastContainer = /*#__PURE__*/(() => {
  let AtlasToastContainer = class extends AtlasElement {
    constructor() {
      super();
      this._toasts = [];
      this._toastCount = 0;
      this._isExpanded = false;
      this.MAX_TOASTS_ON_SCREEN = 3;
      this.BASE_TOAST_Z_INDEX = 1e4;
      this.MIN_ANIMATION_TIMEOUT = 10;
      this.MOVE_IN_OUT_DURATION = 0.6;
      this.MOVE_IN_OUT_TRANSITION = `transform ${this.MOVE_IN_OUT_DURATION}s cubic-bezier(0, 0, 0.25, 1)`;
      this.EXPAND_COLLAPSE_DURATION = 0.8;
      this.EXPAND_COLLAPSE_TRANSITION = `transform ${this.EXPAND_COLLAPSE_DURATION}s cubic-bezier(0, 0, 0.25, 1)`;
      this._deviceController = new DeviceController(this);
      this.onCloseToast = this.onCloseToast.bind(this);
      this.expandToastContainer = this.expandToastContainer.bind(this);
      this.collapseToastContainer = this.collapseToastContainer.bind(this);
    }
    /** @internal */
    connectedCallback() {
      super.connectedCallback();
      this.addEventListener("atlas-toast-close", this.onCloseToast);
    }
    /** @internal */
    disconnectedCallback() {
      super.disconnectedCallback();
      this.removeEventListener("atlas-toast-close", this.onCloseToast);
    }
    /**
     * Adiciona um toast ao container.
     * @param toast {AtlasToast} - O toast que será adicionado ao container
     */
    addToast(toast) {
      if (toast.tagName.toLowerCase() !== "atlas-toast") return;
      toast.style.transform = "translateX(100%)";
      this.prepend(toast);
      const duration = parseInt(toast.getAttribute("data-duration") || "0", 10);
      if (duration <= 0) return;
      setTimeout(() => {
        this.removeToast(toast);
      }, duration);
    }
    /**
     * Remove o toast do container.
     * @param toast {AtlasToast} - O toast que será removido
     */
    removeToast(toast) {
      const toastIndex = this._toasts.indexOf(toast);
      if (toastIndex === -1) return;
      const removeToast = this._toasts[toastIndex];
      setTimeout(() => this.moveInOutAnimation(removeToast, false), this.MIN_ANIMATION_TIMEOUT);
      setTimeout(() => {
        removeToast.remove();
      }, this.getMoveInOutAnimationTimeout());
    }
    onCloseToast(event) {
      const toast = event.target;
      this.removeToast(toast);
    }
    onSlotChange() {
      var _a;
      const slot = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector("slot:not([name])");
      const slottedElements = (slot == null ? void 0 : slot.assignedElements({
        flatten: true
      })) || [];
      this._toasts = filterElementsByTagNames(slottedElements, ["ATLAS-TOAST"]);
      if (this._toasts.length === 0) return;
      const isAddingToast = this._toasts.length >= this._toastCount;
      const shouldRemoveLastToast = this._toastCount >= this.MAX_TOASTS_ON_SCREEN && isAddingToast;
      this.updateToastsOnScreen(isAddingToast, shouldRemoveLastToast);
      this._toastCount = this._toasts.length;
    }
    getMoveInOutAnimationTimeout() {
      const animationAdjustment = 100;
      return parseSecondsToMilliseconds(this.MOVE_IN_OUT_DURATION) - animationAdjustment;
    }
    getExpandCollapseAnimationTimeout() {
      return parseSecondsToMilliseconds(this.EXPAND_COLLAPSE_DURATION);
    }
    moveInOutAnimation(toast, isAddingToast) {
      let baseTranslation = "0%";
      if (this._deviceController.isMobile) {
        const hoverAreaWidth = this._hoverArea.getBoundingClientRect().width;
        const toastWidth = toast.getBoundingClientRect().width;
        baseTranslation = `${(hoverAreaWidth - toastWidth) / 2}px`;
      }
      const translationX = isAddingToast ? baseTranslation : "100%";
      toast.style.transition = this.MOVE_IN_OUT_TRANSITION;
      toast.style.transform = this.combineTransformStyle(toast, `translateX(${translationX})`);
    }
    combineTransformStyle(toast, includingTransform) {
      const currentTransform = toast.style.transform;
      const regexToMatchOnlySpaceSeparatedTransforms = /\s+(?![^()]*\))/g;
      const currentTransformParts = currentTransform.split(regexToMatchOnlySpaceSeparatedTransforms);
      const newTransform = currentTransformParts.filter(transform => {
        if (transform.includes("translateX") && includingTransform.includes("translateX")) return false;
        if (transform.includes("scale3d") && includingTransform.includes("scale3d")) return false;
        if (transform.includes("translateY") && includingTransform.includes("translateY")) return false;
        return true;
      });
      newTransform.push(includingTransform);
      const newTransformString = newTransform.join(" ").trim();
      return newTransformString;
    }
    updateToastQueueOrder() {
      this._toasts.forEach((toast, index) => {
        toast.style.transition = this.EXPAND_COLLAPSE_TRANSITION;
        this.updateZIndex(toast, index);
        this.updateScale(toast, index);
        setTimeout(() => {
          this.updateTranslation(toast, index);
        }, this.MIN_ANIMATION_TIMEOUT);
      });
    }
    updateZIndex(toast, index) {
      toast.style.zIndex = `${this.BASE_TOAST_Z_INDEX - 1 - index}`;
    }
    updateScale(toast, index) {
      const baseScale = 1;
      const shrinkingFactor = 0.05;
      const scale = this._isExpanded ? baseScale : baseScale - shrinkingFactor * index;
      toast.style.transform = this.combineTransformStyle(toast, `scale3d(${scale}, ${scale}, 1)`);
    }
    updateTranslation(toast, index) {
      const baseTranslation = this._isExpanded ? 8 : 16;
      if (index === 0) {
        toast.style.transform = this.combineTransformStyle(toast, "translateY(0)");
        toast.setAttribute("data-translation-y", "0");
        return;
      }
      const toastAboveElement = this._toasts[index - 1];
      const toastAbove = {
        element: toastAboveElement,
        height: toastAboveElement.getBoundingClientRect().height,
        translationY: parseFloat(toastAboveElement.getAttribute("data-translation-y") || "0")
      };
      let translateY = 0;
      const totalNeededHeightToTranslateY = toastAbove.height + toastAbove.translationY;
      const currentToastHeight = toast.getBoundingClientRect().height;
      if (this._isExpanded) {
        translateY = totalNeededHeightToTranslateY + baseTranslation;
      } else if (currentToastHeight <= totalNeededHeightToTranslateY) {
        translateY = totalNeededHeightToTranslateY + baseTranslation - currentToastHeight;
      } else {
        translateY = 0;
      }
      toast.style.transform = this.combineTransformStyle(toast, `translateY(${translateY}px)`);
      toast.setAttribute("data-translation-y", translateY.toString());
    }
    updateToastsOnScreen(isAddingToast, shouldRemoveLastToast) {
      if (isAddingToast) {
        this.updateAddedToast();
      }
      if (shouldRemoveLastToast) {
        this.removeToast(this._toasts[this._toasts.length - 1]);
      }
      const updateQueueAwaitTimeout = isAddingToast ? this.getMoveInOutAnimationTimeout() : this.MIN_ANIMATION_TIMEOUT;
      setTimeout(() => {
        this.updateToastQueueOrder();
        setTimeout(() => {
          this.updateHoverArea();
        }, this.getExpandCollapseAnimationTimeout());
      }, updateQueueAwaitTimeout);
    }
    updateAddedToast() {
      const addedToast = this._toasts[0];
      addedToast.addEventListener("mouseover", this.expandToastContainer);
      addedToast.addEventListener("mouseout", this.collapseToastContainer);
      addedToast.style.zIndex = this.BASE_TOAST_Z_INDEX.toString();
      setTimeout(() => this.moveInOutAnimation(addedToast, true), this.MIN_ANIMATION_TIMEOUT);
    }
    updateHoverArea() {
      if (this._toasts.length === 0) {
        this._hoverArea.style.height = "0";
        return;
      }
      const lastToast = this._toasts[this._toasts.length - 1];
      const {
        top,
        height
      } = lastToast.getBoundingClientRect();
      const containerMarginTop = this._deviceController.isMobile ? 80 : 90;
      this._hoverArea.style.height = `${top + height - containerMarginTop}px`;
    }
    expandToastContainer() {
      this._isExpanded = true;
      this.updateToastsOnScreen(false, false);
    }
    collapseToastContainer(event) {
      var _a;
      const relatedTarget = event.relatedTarget;
      const targetsToIgnore = ["atlas-toast", "atlas-button", "atlas-toast-container"];
      if (targetsToIgnore.includes((_a = relatedTarget == null ? void 0 : relatedTarget.tagName) == null ? void 0 : _a.toLowerCase())) return;
      this._isExpanded = false;
      this.updateToastsOnScreen(false, false);
    }
    /** @internal */
    render() {
      return html70`
            <div class="atlas-toast-container" @mouseover="${this.expandToastContainer}">
                <slot @slotchange="${this.onSlotChange}"></slot>
            </div>
        `;
    }
  };
  AtlasToastContainer.styles = atlas_toast_container_default;
  return AtlasToastContainer;
})();
__decorateClass([state33()], AtlasToastContainer.prototype, "_toasts", 2);
__decorateClass([state33()], AtlasToastContainer.prototype, "_toastCount", 2);
__decorateClass([state33()], AtlasToastContainer.prototype, "_isExpanded", 2);
__decorateClass([query11(".atlas-toast-container")], AtlasToastContainer.prototype, "_hoverArea", 2);
AtlasToastContainer = __decorateClass([customElement64("atlas-toast-container")], AtlasToastContainer);

// src/components/display/atlas-visibility-icon-button/atlas-visibility-icon-button.ts
import { html as html71 } from "lit";
import { customElement as customElement65, property as property71 } from "lit/decorators.js";
import { when as when46 } from "lit/directives/when.js";

// src/components/display/atlas-visibility-icon-button/atlas-visibility-icon-button.scss
import { css as css64 } from "lit-element/lit-element.js";
var atlas_visibility_icon_button_default = css64`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: inline-flex;
}

:host([block]) {
  width: 100%;
  display: block;
}`;

// src/components/display/atlas-visibility-icon-button/atlas-visibility-icon-button.ts
var AtlasVisibilityIconButton = /*#__PURE__*/(() => {
  let AtlasVisibilityIconButton = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.iconSize = "2x";
      this.isDataVisible = false;
      this.isIconButton = false;
      this.disabled = false;
      this.loading = false;
      this.block = false;
    }
    onClickVisibilityIcon() {
      this.isDataVisible = !this.isDataVisible;
      emit(this, "atlas-visibility-icon-click", {
        detail: {
          isDataVisible: this.isDataVisible
        }
      });
    }
    getIconName() {
      return this.isDataVisible ? "eye-off" : "eye";
    }
    getDescription() {
      return this.isDataVisible ? "Ocultar dados" : "Exibir dados";
    }
    getButtonDisabledTooltip() {
      return this.disabled ? "N\xE3o h\xE1 dados para serem exibidos/ocultados" : "";
    }
    renderButton() {
      return html71`
            <atlas-button
                type="ghost"
                theme="secondary"
                size="md"
                icon="${this.getIconName()}"
                description="${this.getDescription()}"
                ?block=${this.block}
                ?disabled=${this.disabled}
                ?loading=${this.loading}
                tooltip="${this.getButtonDisabledTooltip()}"
                @atlas-button-click="${this.onClickVisibilityIcon}"
            ></atlas-button>
        `;
    }
    renderIconButton() {
      return html71`
            <atlas-icon-button
                icon="${this.getIconName()}"
                size="${this.iconSize}"
                theme="secondary"
                tooltip="${this.getDescription()}"
                theme-on-interactions
                hoverable
                @click="${this.onClickVisibilityIcon}"
            >
            </atlas-icon-button>
        `;
    }
    render() {
      return when46(this.isIconButton, () => this.renderIconButton(), () => this.renderButton());
    }
  };
  AtlasVisibilityIconButton.styles = atlas_visibility_icon_button_default;
  return AtlasVisibilityIconButton;
})();
__decorateClass([property71({
  type: String,
  attribute: "icon-size"
})], AtlasVisibilityIconButton.prototype, "iconSize", 2);
__decorateClass([property71({
  type: Boolean,
  attribute: "is-data-visible",
  reflect: true
})], AtlasVisibilityIconButton.prototype, "isDataVisible", 2);
__decorateClass([property71({
  type: Boolean,
  attribute: "is-icon-button"
})], AtlasVisibilityIconButton.prototype, "isIconButton", 2);
__decorateClass([property71({
  type: Boolean
})], AtlasVisibilityIconButton.prototype, "disabled", 2);
__decorateClass([property71({
  type: Boolean
})], AtlasVisibilityIconButton.prototype, "loading", 2);
__decorateClass([property71({
  type: Boolean
})], AtlasVisibilityIconButton.prototype, "block", 2);
AtlasVisibilityIconButton = __decorateClass([customElement65("atlas-visibility-icon-button")], AtlasVisibilityIconButton);

// src/components/form/atlas-autocomplete/atlas-autocomplete.ts
import { customElement as customElement70, property as property79 } from "lit/decorators.js";

// src/components/form/atlas-select/atlas-select.ts
import { html as html78 } from "lit";
import { customElement as customElement69, property as property78, query as query13, state as state38 } from "lit/decorators.js";
import { classMap as classMap55 } from "lit/directives/class-map.js";

// src/components/form/form-control.ts
import { html as html73 } from "lit";
import { property as property73 } from "lit/decorators.js";
import { when as when48 } from "lit/directives/when.js";

// src/components/form/form-element.ts
import { html as html72 } from "lit";
import { property as property72, state as state34 } from "lit/decorators.js";
import { classMap as classMap52 } from "lit/directives/class-map.js";
import { when as when47 } from "lit/directives/when.js";

// src/internals/validators/required-validator.ts
var RequiredValidator = class {
  constructor(requiredErrorMessage) {
    this.name = "required";
    this.status = "error";
    this.global = true;
    this.requiredErrorMessage = requiredErrorMessage;
  }
  getInvalidMessage() {
    return this.requiredErrorMessage || "Esse campo \xE9 obrigat\xF3rio";
  }
  validate(element) {
    if (!element.required) {
      return true;
    }
    const elementValue = element.getElementValue();
    if (Array.isArray(elementValue)) {
      return elementValue.length > 0;
    }
    return Boolean(elementValue);
  }
};

// src/components/form/form-element.ts
var FormElement = class extends AtlasElement {
  constructor() {
    super();
    this.name = "";
    this.value = "";
    this.requiredErrorMessage = "";
    this.required = false;
    this.disabled = false;
    this.defaultValue = "";
    this.ignoreValidations = false;
    this._status = "none";
    this._showStatusMessage = false;
    this._statusMessage = "";
    this._valid = true;
    this._validationObject = {};
    this._validationMessage = "";
    this._showValidationState = false;
    this._useOnlyGlobalValidators = false;
    this._validators = [];
    this.syncInitialValue();
  }
  /** @internal */
  connectedCallback() {
    var _a;
    (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
    this.updateComplete.then(() => {
      this.addValidator(new RequiredValidator(this.requiredErrorMessage));
      this.checkValidity();
    });
  }
  onChange() {
    this.checkValidity();
    emit(this, "atlas-form-element-value-change", {
      trackDisable: true
    });
    emit(this, "atlas-form-element-touch", {
      trackDisable: true
    });
  }
  onChangeDisabled() {
    if (this.disabled) this.removeStatusMessage();
    emit(this, "atlas-form-element-disabled-change", {
      trackDisable: true
    });
  }
  onChangeRequired() {
    emit(this, "atlas-form-element-required-change", {
      trackDisable: true
    });
  }
  /**
   * Define o valor inicial do elemento
   * @param {any} value - O valor a ser definido
   */
  setInitialValue(value) {
    this._initialValue = value;
  }
  /**
   * Sincroniza o valor inicial do elemento com o valor atual
   */
  syncInitialValue() {
    return __async(this, null, function* () {
      yield this.updateComplete;
      if (CHECK_ELEMENTS.includes(this.tagName.toLowerCase())) {
        this._initialValue = this.hasAttribute("checked");
      } else {
        this._initialValue = this.value;
      }
    });
  }
  /**
   * Verifica se o valor do elemento foi atualizado
   * @returns {boolean} - Indica se o valor do elemento foi atualizado
   */
  hasUpdatedValue() {
    return this.value !== this._initialValue;
  }
  /**
   * Reseta o valor do elemento para o valor inicial
   */
  reset() {
    if (CHECK_ELEMENTS.includes(this.tagName.toLowerCase())) {
      this.toggleAttribute("checked", Boolean(this._initialValue));
    } else {
      this.value = this._initialValue;
    }
    this.updateComplete.then(() => {
      this.removeStatusMessage();
    });
  }
  /**
   * Define o estado de validação do elemento com uma mensagem de erro
   * @param message - A mensagem de erro
   */
  setErrorMessage(message) {
    this.setStatusWithMessage("error", message);
  }
  /**
   * Define o estado de validação do elemento com uma mensagem de aviso
   * @param message - A mensagem de aviso
   */
  setWarningMessage(message) {
    this.setStatusWithMessage("warning", message);
  }
  /**
   * Define o estado de validação do elemento com uma mensagem de sucesso
   * @param message - A mensagem de sucesso
   */
  setSuccessMessage(message) {
    this.setStatusWithMessage("success", message);
  }
  /**
   * Define o estado de validação do elemento com uma mensagem de informação
   * @param message - A mensagem de informação
   */
  setInfoMessage(message) {
    this.setStatusWithMessage("info", message);
  }
  /**
   * Remove a mensagem de estado de validação do elemento
   */
  removeStatusMessage() {
    this._status = "none";
    this._statusMessage = "";
    this._validationObject = {};
    this._showStatusMessage = false;
    this._valid = true;
  }
  /**
   * Define o estado de validação do elemento com uma mensagem
   * @param status - O estado de validação
   * @param message - A mensagem de validação
   */
  setStatusWithMessage(status, message) {
    this._status = status;
    this._statusMessage = message;
    this._showStatusMessage = true;
    this._valid = status !== "error";
  }
  /**
   * Define o estado de validação do elemento
   * @param validationState - Variável booleana que indica se o elemento está com o estado de validação ou não
   * @param status - O estado de validação
   */
  setValidationState(validationState, status) {
    if (!status) {
      this._status = validationState ? "none" : "error";
    } else {
      this._status = status;
    }
    this._valid = validationState;
    this._showStatusMessage = !validationState;
  }
  /**
   * Adiciona um validador ao elemento
   * @param validator - O validador a ser adicionado
   */
  addValidator(validator) {
    this._validators.push(validator);
  }
  /**
   * Remove um validador do elemento
   * @param name - O nome do validador a ser removido
   */
  removeValidator(name2) {
    this._validators = this._validators.filter(validator => validator.name !== name2);
  }
  /**
   * Obtém um validador do elemento
   * @param name - O nome do validador a ser obtido
   * @returns {FieldValidator | undefined} O validador ou undefined, caso não seja encontrado
   */
  getValidator(name2) {
    return this._validators.find(validator => validator.name === name2);
  }
  /**
   * Obtém uma lista de validadores do elemento
   * @returns {FieldValidator[]} - A lista de validadores
   */
  getValidators() {
    return this._validators;
  }
  /**
   * Habilita o elemento
   */
  enable() {
    this.disabled = false;
  }
  /**
   * Desabilita o elemento
   */
  disable() {
    this.disabled = true;
  }
  /**
   * Alterna o estado de desabilitado do elemento
   * @param forceState - Caso seja passado um valor booleano, força o estado do elemento, caso contrário, alterna o estado atual
   */
  toggleDisabled(forceState) {
    if (typeof forceState === "boolean") {
      this.disabled = forceState;
    } else {
      this.disabled = !this.disabled;
    }
  }
  /**
   * Obtém o valor do elemento
   * @returns {any} - O valor do elemento
   */
  getElementValue() {
    return this.value;
  }
  /**
   * Verifica se o elemento é válido
   * @returns {boolean} - Indica se o elemento é válido
   */
  checkValidity() {
    if (this.ignoreValidations) return true;
    let hasError = false;
    if (this._status === "error") {
      this.removeStatusMessage();
    }
    if (!this.disabled) {
      for (const validator of this._validators) {
        if (!this._useOnlyGlobalValidators || validator.global) {
          const isValid = validator.validate(this);
          if (!isValid) {
            this._validationObject[validator.name] = !isValid;
            if (!hasError) {
              hasError = true;
              this._valid = validator.status !== "error";
              this._statusMessage = validator.getInvalidMessage();
              this._status = validator.status;
            }
            if (validator.reportOnChange) {
              this._showStatusMessage = true;
            }
          }
        }
      }
    }
    return this._valid;
  }
  /**
   * Verifica se o elemento é válido e exibe uma mensagem de acordo com o estado de validação
   * @returns {boolean} - Indica se o elemento é válido
   */
  reportValidity() {
    if (this.ignoreValidations) return true;
    this.checkValidity();
    this._showStatusMessage = this._status !== "none";
    return this._valid;
  }
  /**
   * Retorna um objeto com informações sobre o estado de validação do elemento
   * @returns {object} - O objeto com informações sobre o estado de validação do elemento
   */
  getValidationsReport() {
    return this._validationObject;
  }
  getStatusTheme() {
    if (!this.getShowStatus() || this._status === "none") return null;
    return this._status === "error" ? "danger" : this._status;
  }
  getShowStatus() {
    return this._status && this._status !== "none" && this._showStatusMessage;
  }
  renderValidationMessage() {
    return when47(this._showValidationState && this._validationMessage !== "", () => html72`<div class="invalid-feedback">${this._validationMessage}</div>`);
  }
  renderStatusMessage() {
    const statusClass = {
      "status-feedback": true,
      [`status-${this._status}`]: !!this._status
    };
    return when47(this.getShowStatus() && this._statusMessage !== "", () => html72`<div class=${classMap52(statusClass)}>${this._statusMessage}</div>`);
  }
};
__decorateClass([property72({
  type: String
})], FormElement.prototype, "name", 2);
__decorateClass([property72({
  type: String
})], FormElement.prototype, "value", 2);
__decorateClass([property72({
  type: String,
  attribute: "required-error-message"
})], FormElement.prototype, "requiredErrorMessage", 2);
__decorateClass([property72({
  type: Boolean,
  reflect: true
})], FormElement.prototype, "required", 2);
__decorateClass([property72({
  type: Boolean,
  reflect: true
})], FormElement.prototype, "disabled", 2);
__decorateClass([property72({
  type: Boolean
})], FormElement.prototype, "default", 2);
__decorateClass([property72({
  type: String,
  attribute: "default-value"
})], FormElement.prototype, "defaultValue", 2);
__decorateClass([property72({
  type: Boolean,
  attribute: "ignore-validations"
})], FormElement.prototype, "ignoreValidations", 2);
__decorateClass([state34()], FormElement.prototype, "_status", 2);
__decorateClass([state34()], FormElement.prototype, "_showStatusMessage", 2);
__decorateClass([state34()], FormElement.prototype, "_statusMessage", 2);
__decorateClass([state34()], FormElement.prototype, "_valid", 2);
__decorateClass([state34()], FormElement.prototype, "_validationObject", 2);
__decorateClass([state34()], FormElement.prototype, "_validationMessage", 2);
__decorateClass([state34()], FormElement.prototype, "_showValidationState", 2);
__decorateClass([state34()], FormElement.prototype, "_initialValue", 2);
__decorateClass([state34()], FormElement.prototype, "_useOnlyGlobalValidators", 2);
__decorateClass([Watch("value", true)], FormElement.prototype, "onChange", 1);
__decorateClass([Watch("disabled", true)], FormElement.prototype, "onChangeDisabled", 1);
__decorateClass([Watch("required", true)], FormElement.prototype, "onChangeRequired", 1);

// src/components/form/form-control.ts
var FormControl = class extends WithPopoverMixin(FormElement) {
  constructor() {
    super(...arguments);
    this.label = "";
    this.helperText = "";
    this._hasSlottedHelperText = false;
  }
  renderHelperText(options = {}) {
    const {
      isToggleHelper = false,
      isInputHelper = false
    } = options;
    return when48(this.helperText, () => html73`
                <atlas-helper-text id=${this.id} ?is-toggle-helper=${isToggleHelper} ?is-input-helper=${isInputHelper}>
                    ${this.helperText}
                </atlas-helper-text>
            `, () => html73`
                <slot
                    name="helper-text"
                    @slotchange=${() => this.onHelperTextSlotChange({
      isToggleHelper,
      isInputHelper
    })}
                ></slot>
            `);
  }
  renderLabel() {
    return when48(this.label !== "", () => html73`
                <label for="${this.id}" class="form-label">
                    <atlas-text>${this.label} ${this.renderOptional()}</atlas-text>
                    ${this.renderPopoverInfoIcon()}
                </label>
            `);
  }
  wrapHelperTextSlot(elements, {
    isToggleHelper,
    isInputHelper
  }) {
    const wrapper = document.createElement("atlas-helper-text");
    wrapper.setAttribute("id", this.id);
    wrapper.setAttribute("slot", "helper-text");
    wrapper.toggleAttribute("is-toggle-helper", isToggleHelper);
    wrapper.toggleAttribute("is-input-helper", isInputHelper);
    elements[0].before(wrapper);
    elements.forEach(element => {
      element.removeAttribute("slot");
      wrapper.appendChild(element);
    });
  }
  onHelperTextSlotChange({
    isToggleHelper,
    isInputHelper
  }) {
    const helperTextSlot = this.shadowRoot.querySelector("slot[name=helper-text]");
    const assignedElements = (helperTextSlot == null ? void 0 : helperTextSlot.assignedElements()) || [];
    const slottedHelperTexts = assignedElements.filter(element => element.tagName === "ATLAS-HELPER-TEXT");
    if (slottedHelperTexts.length > 0) {
      slottedHelperTexts.forEach(element => {
        element.setAttribute("id", this.id);
        element.toggleAttribute("is-toggle-helper", isToggleHelper);
        element.toggleAttribute("is-input-helper", isInputHelper);
      });
      this._hasSlottedHelperText = true;
      return;
    }
    if (assignedElements.length > 0) {
      this.wrapHelperTextSlot(assignedElements, {
        isToggleHelper,
        isInputHelper
      });
      this._hasSlottedHelperText = true;
      return;
    }
    this._hasSlottedHelperText = false;
  }
  renderOptional() {
    return when48(!this.required && !this.hideOptional, () => html73`<span class="form-label-optional">(Opcional)</span>`);
  }
};
__decorateClass([property73({
  type: String
})], FormControl.prototype, "label", 2);
__decorateClass([property73({
  type: String,
  attribute: "helper-text"
})], FormControl.prototype, "helperText", 2);
__decorateClass([property73({
  type: Boolean,
  attribute: "hide-optional"
})], FormControl.prototype, "hideOptional", 2);

// src/helpers/request.ts
var request_exports = {};
__export(request_exports, {
  downloadBlob: () => downloadBlob,
  downloadResponseFile: () => downloadResponseFile,
  get: () => get,
  post: () => post
});

// src/internals/custom-errors.ts
var AtlasRequestError = class extends Error {
  constructor(message, response) {
    super(message);
    this.name = "AtlasRequestError";
    this.response = response;
    this.status = response.status;
  }
};

// src/helpers/request.ts
import qs from "qs";
function buildFormData(formData, params, parentKey) {
  if (params && typeof params === "object" && !(params instanceof Date) && !(params instanceof File)) {
    Object.keys(params).forEach(key => {
      buildFormData(formData, params[key], parentKey ? `${parentKey}[${key}]` : key);
    });
  } else {
    const value = params == null ? "" : params;
    formData.append(parentKey, value);
  }
}
function objectToFormData(params) {
  const formData = new FormData();
  buildFormData(formData, params);
  return formData;
}
function getRequestHeaders(jsonRequest) {
  const headers = new Headers();
  headers.append("X-Requested-With", "XMLHttpRequest");
  if (jsonRequest) {
    headers.append("content-type", "application/json");
  }
  return headers;
}
function getCredentialTypeFromUrl(url) {
  if (url.toLowerCase().includes("hashedfingerprint")) {
    return "include";
  }
  return "same-origin";
}
var post = (url, params, jsonRequest, parseResponse = true, timeout) => __async(null, null, function* () {
  const headers = getRequestHeaders(jsonRequest);
  const body = jsonRequest ? JSON.stringify(params) : objectToFormData(params);
  let signal = null;
  if (timeout > 0) {
    const controller = new AbortController();
    signal = controller.signal;
    setTimeout(() => controller.abort(), timeout);
  }
  const fetchOptions = {
    method: "POST",
    headers,
    body
  };
  if (signal) fetchOptions.signal = signal;
  const response = yield fetch(url, fetchOptions);
  executeAtlasRequestError(response);
  if (parseResponse) {
    const responseData = yield response.json();
    return responseData;
  }
  return response;
});
var get = (url, params, parseResponse = true, timeout) => __async(null, null, function* () {
  let fullPath = url;
  if (params && Object.keys(params).length > 0) {
    const separator = fullPath.includes("?") ? "&" : "?";
    fullPath += `${separator}${qs.stringify(params, {
      indices: false
    })}`;
  }
  let signal = null;
  if (timeout > 0) {
    const controller = new AbortController();
    signal = controller.signal;
    setTimeout(() => controller.abort(), timeout);
  }
  const fetchOptions = {
    method: "GET",
    credentials: getCredentialTypeFromUrl(url),
    headers: getRequestHeaders(false)
  };
  if (signal) fetchOptions.signal = signal;
  const response = yield fetch(fullPath, fetchOptions);
  executeAtlasRequestError(response);
  if (parseResponse) {
    const responseData = yield response.json();
    return responseData;
  }
  return response;
});
var executeAtlasRequestError = response => {
  if (response.ok) return;
  emit(document, "atlas-request-error", {
    detail: response,
    trackDisable: true
  });
  throw new AtlasRequestError(`Request failed with status ${response.status}: ${response.statusText}`, response);
};
var downloadBlob = (blob, fileName) => {
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.dispatchEvent(new MouseEvent("click", {
    bubbles: true,
    cancelable: true,
    view: window
  }));
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
var downloadResponseFile = response => __async(null, null, function* () {
  const filename = response.headers.get("content-disposition").split(";").find(disposition => disposition.includes("filename=")).replace("filename=", "").trim();
  const responseBlob = yield response.blob();
  downloadBlob(responseBlob, filename);
});

// src/components/form/atlas-select/atlas-select.scss
import { css as css65 } from "lit-element/lit-element.js";
var atlas_select_default = css65`:host([width=full]) {
  width: 100%;
}

:host([width=xs]) {
  width: 96px;
}

:host([width=sm]) {
  width: 152px;
}

:host([width=md]) {
  width: 264px;
}

:host([width=lg]) {
  width: 380px;
}`;

// src/components/form/atlas-select/atlas-select-dropdown.ts
import { LitElement as LitElement21, html as html77 } from "lit";
import { customElement as customElement68, property as property77, state as state37 } from "lit/decorators.js";
import { ifDefined as ifDefined18 } from "lit/directives/if-defined.js";
import { when as when52 } from "lit/directives/when.js";

// src/components/form/atlas-select/atlas-select-dropdown.scss
import { css as css66 } from "lit-element/lit-element.js";
var atlas_select_dropdown_default = css66`.dropdown-empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  padding: 1rem;
  gap: 0.5rem;
}

@media screen and (min-width: 992px) {
  .dropdown-empty-state {
    height: auto;
    width: auto;
  }
}`;

// src/components/form/atlas-input/atlas-input.ts
import { html as html75 } from "lit";
import { customElement as customElement66, property as property75, query as query12, state as state36 } from "lit/decorators.js";
import { classMap as classMap53 } from "lit/directives/class-map.js";
import { live } from "lit/directives/live.js";
import { ifDefined as ifDefined16 } from "lit/directives/if-defined.js";
import { when as when50 } from "lit/directives/when.js";

// src/internals/validators/emoji-validator.ts
import emojiRegex from "emoji-regex";
var EmojiValidator = class {
  constructor(emojiErrorMessage) {
    this.name = "emoji";
    this.status = "error";
    this.reportOnChange = true;
    this.emojiErrorMessage = emojiErrorMessage;
  }
  getInvalidMessage() {
    return this.emojiErrorMessage || "N\xE3o \xE9 permitido emoji neste campo";
  }
  validate(element) {
    const regex = emojiRegex();
    const elementValue = element.getElementValue();
    if (regex.test(elementValue)) {
      return false;
    }
    return true;
  }
};

// src/internals/validators/length-validator.ts
var MESSAGES_MAP = {
  min: "O valor inserido deve ter no m\xEDnimo {{minlength}} {{label}}",
  max: "O valor inserido ultrapassa o limite de {{maxlength}} {{label}}",
  length: "O valor inserido deve ter {{length}} {{label}}",
  none: ""
};
var LengthValidator = class {
  constructor(reportOnChange = true) {
    this.name = "length";
    this.status = "error";
    this.errorType = "none";
    this.reportOnChange = reportOnChange;
  }
  getInvalidMessage() {
    return MESSAGES_MAP[this.errorType].replace("{{maxlength}}", this.maxlength).replace("{{minlength}}", this.minlength).replace("{{length}}", this.length).replace("{{label}}", this.getCharacterLabel());
  }
  validate(element) {
    var _a, _b, _c, _d;
    this.resetState();
    const minlength = (_a = parseInt(element.getAttribute("minlength"), 10)) != null ? _a : null;
    const maxlength = (_b = parseInt(element.getAttribute("maxlength"), 10)) != null ? _b : null;
    const length = (_c = parseInt(element.getAttribute("length"), 10)) != null ? _c : null;
    const elementValueLength = String((_d = element.getElementValue()) != null ? _d : "").length;
    if (length && elementValueLength > 0 && elementValueLength < length) {
      this.errorType = "length";
      this.length = length.toString();
    }
    if (minlength && elementValueLength > 0 && elementValueLength < minlength) {
      this.errorType = "min";
      this.minlength = minlength.toString();
    }
    if (maxlength && elementValueLength > maxlength) {
      this.errorType = "max";
      this.maxlength = maxlength.toString();
    }
    return this.errorType === "none";
  }
  resetState() {
    this.errorType = "none";
    this.minlength = "";
    this.maxlength = "";
  }
  getCharacterLabel() {
    if (this.errorType === "none") return "";
    const valueToCompare = this.errorType === "max" ? this.maxlength : this.minlength;
    return valueToCompare === "1" ? "caractere" : "caracteres";
  }
};

// src/internals/validators/multiple-value-validator.ts
var MultipleValueValidator = class {
  constructor() {
    this.name = "multiple-value";
    this.status = "error";
    this.global = true;
    this.reportOnChange = true;
    this.invalidMessage = "";
  }
  getInvalidMessage() {
    return this.invalidMessage || "Existem valores que n\xE3o foram preenchidos corretamente";
  }
  validate(element) {
    if (!element.multiple) {
      return true;
    }
    const multipleValues = element.getMultipleValuesObject();
    const firstInvalidValue = multipleValues.find(value => !value.isValid);
    if (firstInvalidValue) {
      this.invalidMessage = firstInvalidValue.errorMessage;
      return false;
    }
    if (multipleValues.length > element.maxValues) {
      this.invalidMessage = element.maxValuesErrorMessage || `Voc\xEA pode adicionar no m\xE1ximo ${element.maxValues} valores`;
      return false;
    }
    return true;
  }
};

// src/internals/mixins/with-chars-counter-mixin.ts
import { html as html74 } from "lit";
import { property as property74, state as state35 } from "lit/decorators.js";
import { when as when49 } from "lit/directives/when.js";

// src/helpers/id.ts
var id_exports = {};
__export(id_exports, {
  generateUniqueId: () => generateUniqueId
});
import { v4 as uuidv4 } from "uuid";
var generateUniqueId = (suffix, hash) => {
  const uniqueHash = hash || uuidv4();
  const prefix = `atlas-${uniqueHash}`;
  const suffixWithId = suffix ? `${suffix}-id` : "id";
  return `${prefix}-${suffixWithId}`;
};

// src/internals/mixins/with-chars-counter-mixin.ts
var WithCharsCounterMixin = superClass => {
  class WithCharsCounterClass extends superClass {
    constructor() {
      super(...arguments);
      this.enableCharsCounter = false;
      this._counter = 0;
    }
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      if (this.isEnabled() && !this._charsCounterId) {
        this._charsCounterId = generateUniqueId("chars-counter", this.getAttribute("id"));
      }
    }
    renderCharsCounter() {
      return when49(this.isEnabled(), () => html74` <atlas-helper-text id=${this._charsCounterId}> ${this._label} </atlas-helper-text> `);
    }
    renderCharsCounterSkeleton() {
      return when49(this.isEnabled(), () => html74` <div class="helper-text skeleton"></div> `);
    }
    updateCharsCounterIfEnabled(value) {
      if (!this.isEnabled()) return;
      this._counter = value;
      this._label = this.getAvailableCharsLabel();
    }
    isEnabled() {
      return this.enableCharsCounter && this.hasAttribute("maxlength");
    }
    getAvailableCharsLabel() {
      const maxlength = parseInt(this.getAttribute("maxlength"), 10);
      const availableChars = Math.max(maxlength - this._counter, 0);
      const isPlural = availableChars !== 1;
      return isPlural ? `${availableChars} caracteres dispon\xEDveis` : `${availableChars} caractere dispon\xEDvel`;
    }
  }
  __decorateClass([property74({
    type: Boolean,
    reflect: true,
    attribute: "enable-chars-counter"
  })], WithCharsCounterClass.prototype, "enableCharsCounter", 2);
  __decorateClass([state35()], WithCharsCounterClass.prototype, "_counter", 2);
  __decorateClass([state35()], WithCharsCounterClass.prototype, "_label", 2);
  return WithCharsCounterClass;
};

// src/components/form/atlas-input/atlas-input.scss
import { css as css67 } from "lit-element/lit-element.js";
var atlas_input_default = css67`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Z-index mapping for the floating elements */
/* Shadows */
/* Elevations */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.form-label {
  margin-bottom: 0.5rem;
  font-style: normal;
  box-sizing: border-box;
  display: inline-block;
}
.form-label-optional {
  color: #687078;
}
.form-label atlas-icon-button {
  top: 2px;
}
.form-label[skeleton-loading] {
  min-width: 40%;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Z-index mapping for the floating elements */
/* Shadows */
/* Elevations */
.form-control {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #1a1e21;
  appearance: none;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  cursor: text;
}
.form-control > .form-control-input {
  border: none;
  appearance: none;
  background-color: transparent;
  margin: 0;
  padding: 0;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #1a1e21;
  width: 100%;
  cursor: text;
}
.form-control > .form-control-input:focus, .form-control > .form-control-input:focus-visible {
  outline: none;
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control.form-control-multiple {
  display: flex;
  flex-flow: row wrap;
  gap: 0.5rem;
  overflow-y: overlay;
  max-height: 200px;
  cursor: text;
}
.form-control.form-control-multiple > .form-control-input {
  flex-grow: 1;
  min-width: 100px;
  width: 1%;
}
.form-control .form-control-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
.form-control .form-control-sm > .form-control-input {
  font-size: 0.875rem;
}
.form-control .form-control-lg {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
}
.form-control .form-control-lg > .form-control-input {
  font-size: 1.25rem;
}
.form-control:focus, .form-control:focus-within {
  color: #1a1e21;
  background-color: #ffffff;
  border-color: var(--atlas-primary-300);
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-300-rgb), 0.25);
  outline: 0;
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder,
.form-control > .form-control-input::placeholder {
  color: #687078;
  opacity: 1;
}
.form-control:disabled, .form-control:has(.form-control-input:disabled) {
  background-color: #e9ecef;
  opacity: 1;
}
.form-control.hide-placeholder::placeholder,
.form-control.hide-placeholder > .form-control-input::placeholder {
  color: transparent;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
  /* stylelint-disable no-descending-specificity */
  /* stylelint-enable no-descending-specificity */
}
.input-group atlas-button {
  position: relative;
  z-index: 2;
}
.input-group atlas-button:focus {
  z-index: 5;
}
.input-group .input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.input-group .input-group-text.input-group-prefix {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group .input-group-text.input-group-suffix {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group .form-control {
  border-radius: 0.25rem !important;
  box-sizing: border-box;
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group .form-control.has-icon {
  padding-right: 1.75rem;
}
.input-group .form-control.has-right-element, .input-group .form-control.has-action-button {
  border-bottom-right-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
.input-group .form-control.has-left-element {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}
.input-group .form-control .input-icon,
.input-group .form-control ~ .input-icon {
  position: absolute;
  right: 0.75rem;
  top: 0.815rem;
  z-index: 5;
  pointer-events: none;
}
.input-group .form-control .input-icon.has-click,
.input-group .form-control ~ .input-icon.has-click {
  cursor: pointer;
  pointer-events: all;
}
.input-group .form-control .side-image,
.input-group .form-control ~ .side-image {
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  height: 1.75rem;
  z-index: 5;
  pointer-events: none;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus {
  z-index: 5;
}
.input-group .form-control-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
.input-group .form-control-sm.has-icon {
  padding-right: 1.5rem;
}
.input-group .form-control-sm > .form-control-input {
  font-size: 0.875rem;
}
.input-group .form-control-sm .input-icon,
.input-group .form-control-sm ~ .input-icon {
  right: 0.5rem;
  top: 0.5rem;
}
.input-group .form-control-sm .side-image,
.input-group .form-control-sm ~ .side-image {
  right: 0.5rem;
  top: 0.25rem;
  height: 1.5rem;
}
.input-group .form-control-lg {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
}
.input-group .form-control-lg > .form-control-input {
  font-size: 1.25rem;
}
.input-group .form-control-lg.has-icon {
  padding-right: 2rem;
}
.input-group .form-control-lg .input-icon,
.input-group .form-control-lg ~ .input-icon {
  right: 1rem;
  top: 1rem;
}
.input-group .form-control-lg .side-image,
.input-group .form-control-lg ~ .side-image {
  right: 1rem;
  top: 0.5rem;
  height: 2rem;
}
.input-group:has(.form-control-sm) .input-group-text {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
.input-group:has(.form-control-lg) .input-group-text {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
}
.input-group:has(atlas-button.action-button-position-left) .input-group-text {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}
.input-group:has(atlas-button.action-button-position-right) .input-group-text {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
.input-group > :not(:first-child):not(.invalid-feedback) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group.skeleton * {
  visibility: hidden;
}
.input-group.skeleton + atlas-button {
  display: none;
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
.status-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.8rem;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}

.is-info ~ .status-feedback {
  display: block;
}

.status-info {
  color: var(--atlas-secondary);
}

.is-success {
  border-color: var(--atlas-success) !important;
}
.is-success:focus, .is-success:focus-visible, .is-success.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
  border-color: var(--atlas-success);
}
.is-success ~ .status-feedback {
  display: block;
}
.is-success ~ .form-check-label {
  color: var(--atlas-success);
}
.is-success .focus-mark {
  background: var(--atlas-success-300);
}
.is-success.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-success) !important;
  background-color: rgba(var(--atlas-success-rgb), 2%);
}
.is-success.rating-buttons-group .rating-button {
  border-color: var(--atlas-success) !important;
  color: var(--atlas-success) !important;
}
.is-success.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-success-400) !important;
  color: #ffffff !important;
}
.is-success.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
}
.is-success.rating-buttons-group .rating-button:active:not(:disabled), .is-success.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-success) !important;
  color: #ffffff !important;
}

.form-check:has(.is-success) .form-check-label {
  color: var(--atlas-success);
}
.form-check:has(.is-success) .form-check-input:checked {
  background-color: var(--atlas-success);
}

.status-success {
  color: var(--atlas-success);
}

.is-warning {
  border-color: var(--atlas-warning) !important;
}
.is-warning:focus, .is-warning:focus-visible, .is-warning.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
  border-color: var(--atlas-warning);
}
.is-warning ~ .status-feedback {
  display: block;
}
.is-warning ~ .form-check-label {
  color: var(--atlas-warning);
}
.is-warning .focus-mark {
  background: var(--atlas-warning-300);
}
.is-warning.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-warning) !important;
  background-color: rgba(var(--atlas-warning-rgb), 2%);
}
.is-warning.rating-buttons-group .rating-button {
  border-color: var(--atlas-warning) !important;
  color: var(--atlas-warning) !important;
}
.is-warning.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-warning-400) !important;
  color: #ffffff !important;
}
.is-warning.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
}
.is-warning.rating-buttons-group .rating-button:active:not(:disabled), .is-warning.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-warning) !important;
  color: #ffffff !important;
}

.form-check:has(.is-warning) .form-check-label {
  color: var(--atlas-warning);
}
.form-check:has(.is-warning) .form-check-input:checked {
  background-color: var(--atlas-warning);
}

.status-warning {
  color: var(--atlas-warning);
}

.is-error {
  border-color: var(--atlas-danger) !important;
}
.is-error:focus, .is-error:focus-visible, .is-error.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
  border-color: var(--atlas-danger);
}
.is-error ~ .status-feedback {
  display: block;
}
.is-error ~ .form-check-label {
  color: var(--atlas-danger);
}
.is-error .focus-mark {
  background: var(--atlas-danger-300);
}
.is-error.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-danger) !important;
  background-color: rgba(var(--atlas-danger-rgb), 2%);
}
.is-error.rating-buttons-group .rating-button {
  border-color: var(--atlas-danger) !important;
  color: var(--atlas-danger) !important;
}
.is-error.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-danger-400) !important;
  color: #ffffff !important;
}
.is-error.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
}
.is-error.rating-buttons-group .rating-button:active:not(:disabled), .is-error.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-danger) !important;
  color: #ffffff !important;
}

.form-check:has(.is-error) .form-check-label {
  color: var(--atlas-danger);
}
.form-check:has(.is-error) .form-check-input:checked {
  background-color: var(--atlas-danger);
}

.status-error {
  color: var(--atlas-danger);
}

/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host([width=full]) {
  width: 100%;
}

:host([width=xs]) {
  width: 96px;
}

:host([width=sm]) {
  width: 152px;
}

:host([width=md]) {
  width: 264px;
}

:host([width=lg]) {
  width: 380px;
}

:host {
  outline: none;
  display: block;
}

:host([skeleton-loading]) {
  display: block;
}

:host(.one-time-code-input) input {
  text-align: center;
}
:host(.one-time-code-input) input:focus::placeholder {
  opacity: 0;
}

:host(.atlas-select-input[readonly]) .form-control,
:host(.atlas-select-input[readonly]) .form-control input,
:host(.atlas-multiselect-input[readonly]) .form-control,
:host(.atlas-multiselect-input[readonly]) .form-control input {
  cursor: pointer;
}

:host(.atlas-select-input[disabled]) .form-control,
:host(.atlas-select-input[disabled]) .form-control input,
:host(.atlas-multiselect-input[disabled]) .form-control,
:host(.atlas-multiselect-input[disabled]) .form-control input {
  cursor: default;
}

:host(.atlas-select-input) atlas-icon.input-icon,
:host(.atlas-multiselect-input) atlas-icon.input-icon {
  transition: transform 0.35s ease;
}

:host(.atlas-select-input:not(.collapsed)) atlas-icon[name=chevron-down],
:host(.atlas-multiselect-input:not(.collapsed)) atlas-icon[name=chevron-down] {
  transform: rotate(-180deg);
}

:host(.atlas-multiselect-input.has-tag) .form-control {
  padding-left: 200px;
}

:host([type=hidden]) {
  display: none !important;
}

.form-label.skeleton {
  height: 1.5rem;
  width: 50%;
}

.form-control.skeleton {
  width: 100%;
  min-height: calc(1.5em + 14px);
}

.helper-text.skeleton {
  height: 1.25rem;
  width: 100%;
  margin-top: 0.25rem;
}

.input-wrapper {
  display: flex;
  width: 100%;
}

@media screen and (min-width: 992px) {
  :host(.atlas-multiselect-input.has-tag) .form-control {
    padding-left: 190px;
  }
}`;

// src/components/form/atlas-input/atlas-input.ts
var ComposedClass4 = WithCharsCounterMixin(WithTooltipMixin(FormControl));
var AtlasInput = /*#__PURE__*/(() => {
  let AtlasInput = class extends ComposedClass4 {
    constructor() {
      super(...arguments);
      this.type = "text";
      this.size = "md";
      this.width = "auto";
      this.actionButtonPosition = "right";
      this.preventDisabledActionButton = false;
      this.readonly = false;
      this.loading = false;
      this.enableEmoji = false;
      this.multiple = false;
      this.enablePasswordManagers = false;
      this._multipleValues = [];
      this._inputValue = "";
      this._deviceController = new DeviceController(this);
    }
    /** @internal */
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.updateComplete.then(() => {
        this.addValidator(new LengthValidator());
        if (!this.enableEmoji && this.tagName === "ATLAS-INPUT") {
          this.addValidator(new EmojiValidator());
        }
        if (this._inputValue !== this.value) {
          this._inputValue = this.value;
        }
        this.updateCharsCounterIfEnabled(String(this.value).length);
        this.onChangeMultiple();
      });
    }
    onChangeValue() {
      if (this._inputValue !== this.value) {
        this._inputValue = this.value;
      }
      this.updateCharsCounterIfEnabled(String(this.value).length);
      emit(this, "atlas-input-change", {
        detail: this.value,
        trackDisable: true
      });
    }
    onChangeMultiple() {
      if (this.isInputMultiple()) {
        this.addValidator(new MultipleValueValidator());
        this._useOnlyGlobalValidators = true;
      } else {
        this.removeValidator("multiple-value");
        this._useOnlyGlobalValidators = false;
      }
    }
    /** @override */
    getElementValue() {
      return this.multiple ? this.getMultipleValues() : this.value;
    }
    /**
     * Obtém os valores do input quando o input é do tipo múltiplo
     */
    getMultipleValues() {
      return this._multipleValues.map(value => value.value);
    }
    /**
     * Obtém uma lista de objetos com os valores do input quando o input é do tipo múltiplo
     */
    getMultipleValuesObject() {
      return this._multipleValues;
    }
    /**
     * Define o foco no input
     */
    focus() {
      this._input.focus();
      setTimeout(() => {
        const valueLength = this._inputValue ? `${this._inputValue}`.length : 0;
        this._input.selectionStart = valueLength;
        this._input.selectionEnd = valueLength;
      }, 0);
    }
    /**
     * Remove o foco do input
     */
    blur() {
      this._input.blur();
    }
    handleFocus() {
      emit(this, "atlas-input-focus", {
        trackDisable: true
      });
    }
    handleBlur() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        if (this.isInputMultiple()) {
          setTimeout(() => {
            this.createTag();
            this.reportValidity();
          }, 0);
        } else {
          this.reportValidity();
        }
        emit(this, "atlas-input-blur", {
          trackDisable: true
        });
        emit(this, "atlas-form-element-touch", {
          trackDisable: true
        });
      });
    }
    handleInput() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const inputEvent = emit(this, "atlas-input-input", {
          detail: this._input.value,
          trackDisable: true
        });
        if (inputEvent.defaultPrevented) {
          return;
        }
        this._inputValue = this._input.value;
        if (!this.isInputMultiple()) {
          this.value = this._input.value;
        }
      });
    }
    handleInputKeyDown(event) {
      return __async(this, null, function* () {
        const keyDownEvent = emit(this, "atlas-input-keydown", {
          detail: {
            key: event.key
          },
          trackDisable: true
        });
        if (keyDownEvent.defaultPrevented) {
          event.preventDefault();
        }
        if (!this.isInputMultiple()) return;
        yield this.updateComplete;
        const validKeysToCreateTag = ["Enter", " ", ";", ","];
        if (validKeysToCreateTag.includes(event.key)) {
          this.createTag();
        }
        if (event.key === "Backspace" && !this._inputValue) {
          this.removeLastTag();
        }
      });
    }
    handlePaste(event) {
      return __async(this, null, function* () {
        const pastEvent = emit(this, "atlas-input-paste", {
          detail: {
            clipboardData: event.clipboardData
          },
          trackDisable: true
        });
        if (pastEvent.defaultPrevented) {
          event.preventDefault();
          return;
        }
        if (!this.isInputMultiple()) return;
        yield this.updateComplete;
        setTimeout(() => this.createTag(), 0);
      });
    }
    handleInputClick() {
      emit(this, "atlas-input-click", {
        trackDisable: true
      });
    }
    onInputIconClick() {
      emit(this, "atlas-input-icon-click", {
        trackDisable: true
      });
    }
    onActionButtonClick() {
      emit(this, "atlas-input-action-button-click");
    }
    onClickFormControl() {
      this._input.focus();
    }
    onTagRemoveClick(event) {
      const tagElement = event.target;
      this._multipleValues = this._multipleValues.filter((_value, index) => index !== Number(tagElement.dataset.id));
      this.syncValueWithMultipleValues();
    }
    renderIcon() {
      return when50(this.loading || !!this.icon, () => {
        const iconClass = {
          "input-icon": true,
          "has-click": !this.loading && this.hasIconEvent
        };
        return html75`
                <atlas-icon
                    name=${this.loading ? "loader" : this.icon}
                    size="2x"
                    class=${classMap53(iconClass)}
                    @click=${this.onInputIconClick}
                ></atlas-icon>
            `;
      });
    }
    isInputMultiple() {
      return this.multiple && ["ATLAS-INPUT", "ATLAS-MASKED-INPUT"].includes(this.tagName);
    }
    validateNewValue(value) {
      const specificValidators = this.getValidators().filter(validator => !validator.global);
      const validationClone = this.cloneNode(true);
      validationClone.value = value;
      validationClone.multiple = false;
      for (const validator of specificValidators) {
        const isValid = validator.validate(validationClone);
        if (!isValid) {
          return {
            isValid: false,
            errorMessage: validator.getInvalidMessage()
          };
        }
      }
      return {
        isValid: true,
        errorMessage: ""
      };
    }
    createTag() {
      if (!this._inputValue) return;
      const newValueValidation = this.validateNewValue(this._inputValue);
      const newValue = {
        value: this._inputValue,
        isValid: newValueValidation.isValid,
        errorMessage: newValueValidation.errorMessage
      };
      this._multipleValues = [...this._multipleValues, newValue];
      this.syncValueWithMultipleValues();
      setTimeout(() => {
        this._inputValue = "";
        this.scrollBottom();
      }, 0);
    }
    removeLastTag() {
      this._multipleValues = this._multipleValues.slice(0, -1);
      this.syncValueWithMultipleValues();
      this.scrollBottom();
    }
    scrollBottom() {
      const formControlMultiple = this.shadowRoot.querySelector(".form-control-multiple");
      formControlMultiple.scrollTo({
        top: formControlMultiple.scrollHeight,
        behavior: "smooth"
      });
    }
    syncValueWithMultipleValues() {
      this.value = this._multipleValues.map(value => value.value).join(",");
    }
    isElementOnSide(side) {
      const hasActionButton = !!this.actionButtonIcon || !!this.actionButtonDescription;
      const hasActionButtonOnSide = this.actionButtonPosition === side && hasActionButton;
      const hasPrefixOrSuffixOnSide = side === "left" ? !!this.inputGroupPrefix : !!this.inputGroupSuffix;
      return hasActionButtonOnSide || hasPrefixOrSuffixOnSide;
    }
    renderElementLeftElements() {
      return html75`${this.renderActionButton("left")} ${this.renderInputPrefix()}`;
    }
    renderElementRightElements() {
      return html75`${this.renderInputSuffix()} ${this.renderActionButton("right")}`;
    }
    renderInputPrefix() {
      return when50(!!this.inputGroupPrefix, () => html75`<span class="input-group-text input-group-prefix">${this.inputGroupPrefix}</span>`);
    }
    renderInputSuffix() {
      return when50(!!this.inputGroupSuffix, () => html75`<span class="input-group-text input-group-suffix">${this.inputGroupSuffix}</span>`);
    }
    renderSideImage() {
      return when50(!this.loading && !!this.sideImage, () => html75`<img class="side-image" src=${this.sideImage} alt="" />`);
    }
    renderTags() {
      return this._multipleValues.map((value, index) => html75`
                <atlas-tag
                    text=${value.value}
                    data-id=${index}
                    maxlength=${this.tagMaxLength}
                    theme=${value.isValid ? "secondary" : "danger"}
                    @atlas-tag-close-click=${this.onTagRemoveClick}
                ></atlas-tag>
            `);
    }
    renderInput() {
      const ariaLabel = this.disabled || this.readonly ? this.placeholder : "";
      const ariaDescribedBy = this.helperText ? `${this.id}-helper` : "";
      const formControlClass = {
        "form-control": true,
        "form-control-sm": this.size === "sm",
        "form-control-lg": this.size === "lg",
        "form-control-multiple": this.isInputMultiple(),
        "has-icon": this.loading || !!this.icon,
        "has-right-element": this.isElementOnSide("right"),
        "has-left-element": this.isElementOnSide("left"),
        "hide-placeholder": this.isInputMultiple() && this._multipleValues.length > 0,
        [`is-${this._status}`]: this.getShowStatus()
      };
      const inputClass = {
        "form-control-input": true,
        "keeper-ignore": !this.enablePasswordManagers
      };
      return html75`
            <div class=${classMap53(formControlClass)} @click=${this.onClickFormControl}>
                ${this.renderTags()}
                <input
                    aria-describedby="${ariaDescribedBy}"
                    aria-label="${ariaLabel}"
                    id="${this.id}"
                    name="${this.name}"
                    class=${classMap53(inputClass)}
                    type=${this.type}
                    inputmode=${ifDefined16(this.inputMode)}
                    placeholder=${this.placeholder}
                    .value=${live(this._inputValue)}
                    ?disabled=${this.disabled}
                    ?readonly=${this.readonly}
                    ?required=${this.required}
                    @focus=${this.handleFocus}
                    @blur=${this.handleBlur}
                    @input=${this.handleInput}
                    @keydown=${this.handleInputKeyDown}
                    @paste=${this.handlePaste}
                    @click=${this.handleInputClick}
                    autocomplete="off"
                    data-lpignore=${ifDefined16(this.enablePasswordManagers ? void 0 : "")}
                    data-1p-ignore=${ifDefined16(this.enablePasswordManagers ? void 0 : "")}
                    data-form-type=${ifDefined16(this.enablePasswordManagers ? void 0 : "other")}
                />
                ${this.renderIcon()} ${this.renderSideImage()}
            </div>
        `;
    }
    renderActionButton(side) {
      const hasActionButton = !!this.actionButtonIcon || !!this.actionButtonDescription;
      const canRender = this.actionButtonPosition === side && hasActionButton;
      const disabledActionButton = this.preventDisabledActionButton ? false : this.disabled || this.loading;
      return when50(canRender, () => html75`
                <atlas-button
                    class="action-button-position-${this.actionButtonPosition}"
                    ?disabled=${disabledActionButton}
                    icon=${this.actionButtonIcon}
                    description=${this.actionButtonDescription}
                    size=${this.size}
                    theme="secondary"
                    type="outlined"
                    ?in-group-last=${this.actionButtonPosition === "right"}
                    ?in-group-first=${this.actionButtonPosition === "left"}
                    @atlas-button-click=${this.onActionButtonClick}
                    aria-label=${this.actionButtonLabel}
                ></atlas-button>
            `);
    }
    /**
     * @internal
     * @override
     */
    render() {
      const inputGroupClass = {
        "input-group": true,
        "skeleton": this.skeletonLoading
      };
      return html75`
            ${this.renderLabel()}
            <div class="input-wrapper">
                <div class=${classMap53(inputGroupClass)} data-atlas-tooltip="input-tooltip">
                    ${this.renderElementLeftElements()} ${this.renderInput()} ${this.renderElementRightElements()}
                    ${this.renderStatusMessage()}
                </div>
            </div>
            ${this.renderCharsCounter()} ${this.renderHelperText({
        isInputHelper: true
      })}
            ${this.renderTooltip("input-tooltip")}
        `;
    }
  };
  AtlasInput.styles = atlas_input_default;
  return AtlasInput;
})();
__decorateClass([property75({
  type: String
})], AtlasInput.prototype, "type", 2);
__decorateClass([property75({
  type: String
})], AtlasInput.prototype, "size", 2);
__decorateClass([property75({
  type: String
})], AtlasInput.prototype, "width", 2);
__decorateClass([property75({
  type: String
})], AtlasInput.prototype, "placeholder", 2);
__decorateClass([property75({
  type: String,
  attribute: "prefix"
})], AtlasInput.prototype, "inputGroupPrefix", 2);
__decorateClass([property75({
  type: String,
  attribute: "suffix"
})], AtlasInput.prototype, "inputGroupSuffix", 2);
__decorateClass([property75({
  type: String
})], AtlasInput.prototype, "icon", 2);
__decorateClass([property75({
  type: String,
  attribute: "side-image"
})], AtlasInput.prototype, "sideImage", 2);
__decorateClass([property75({
  type: Boolean,
  attribute: "has-icon-event"
})], AtlasInput.prototype, "hasIconEvent", 2);
__decorateClass([property75({
  type: String,
  attribute: "action-button-icon"
})], AtlasInput.prototype, "actionButtonIcon", 2);
__decorateClass([property75({
  type: String,
  attribute: "action-button-description"
})], AtlasInput.prototype, "actionButtonDescription", 2);
__decorateClass([property75({
  type: String,
  attribute: "action-button-label"
})], AtlasInput.prototype, "actionButtonLabel", 2);
__decorateClass([property75({
  type: String,
  attribute: "action-button-position"
})], AtlasInput.prototype, "actionButtonPosition", 2);
__decorateClass([property75({
  type: Boolean,
  attribute: "prevent-disabled-action-button"
})], AtlasInput.prototype, "preventDisabledActionButton", 2);
__decorateClass([property75({
  type: Number,
  reflect: true
})], AtlasInput.prototype, "maxlength", 2);
__decorateClass([property75({
  type: Number,
  reflect: true
})], AtlasInput.prototype, "minlength", 2);
__decorateClass([property75({
  type: Boolean,
  reflect: true
})], AtlasInput.prototype, "readonly", 2);
__decorateClass([property75({
  type: Boolean
})], AtlasInput.prototype, "loading", 2);
__decorateClass([property75({
  type: Boolean,
  attribute: "enable-emoji"
})], AtlasInput.prototype, "enableEmoji", 2);
__decorateClass([property75({
  type: Boolean
})], AtlasInput.prototype, "multiple", 2);
__decorateClass([property75({
  type: Number,
  attribute: "max-values"
})], AtlasInput.prototype, "maxValues", 2);
__decorateClass([property75({
  type: String,
  attribute: "max-values-error-message"
})], AtlasInput.prototype, "maxValuesErrorMessage", 2);
__decorateClass([property75({
  type: Number,
  attribute: "tag-max-length"
})], AtlasInput.prototype, "tagMaxLength", 2);
__decorateClass([property75({
  type: Boolean,
  attribute: "enable-password-managers"
})], AtlasInput.prototype, "enablePasswordManagers", 2);
__decorateClass([state36()], AtlasInput.prototype, "_multipleValues", 2);
__decorateClass([state36()], AtlasInput.prototype, "_inputValue", 2);
__decorateClass([query12(".form-control")], AtlasInput.prototype, "_formControl", 2);
__decorateClass([query12("input")], AtlasInput.prototype, "_input", 2);
__decorateClass([Watch("value", true)], AtlasInput.prototype, "onChangeValue", 1);
__decorateClass([Watch("multiple", true)], AtlasInput.prototype, "onChangeMultiple", 1);
AtlasInput = __decorateClass([customElement66("atlas-input")], AtlasInput);

// src/components/form/atlas-select-item/atlas-select-item.ts
import { LitElement as LitElement20 } from "lit";
import { html as html76, literal as literal9 } from "lit/static-html.js";
import { live as live2 } from "lit/directives/live.js";
import { customElement as customElement67, property as property76 } from "lit/decorators.js";
import { classMap as classMap54 } from "lit/directives/class-map.js";
import { ifDefined as ifDefined17 } from "lit/directives/if-defined.js";
import { when as when51 } from "lit/directives/when.js";
import escapeStringRegexp from "escape-string-regexp";

// src/components/form/atlas-select-item/atlas-select-item.scss
import { css as css68 } from "lit-element/lit-element.js";
var atlas_select_item_default = css68`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Shadows */
/* Elevations */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
.form-check-label {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  color: #212529;
  cursor: pointer;
}

.form-check-input {
  --atlas-form-check-bg: #ffffff;
  width: 1.25rem;
  height: 1.25rem;
  margin-top: 0;
  vertical-align: top;
  appearance: none;
  background-color: var(--atlas-form-check-bg);
  background-image: var(--atlas-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid #ced4da;
  print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25rem;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: var(--atlas-primary-200);
  outline: 0;
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-500-rgb), 0.25);
}
.form-check-input:checked {
  background-color: var(--atlas-primary);
  border-color: var(--atlas-primary);
}
.form-check-input:checked[type=checkbox] {
  --atlas-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M16.2448 5.6674L7.46524 15.4628L3.78516 11.6991L5.21517 10.3008L7.40175 12.5371L14.7555 4.33252L16.2448 5.6674Z' fill='%23ffffff'/%3e%3c/svg%3e");
}
.form-check-input:checked[type=radio] {
  --atlas-form-check-bg-image: url("data:image/svg+xml,%3csvg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle stroke='white' stroke-width='3.5' cx='10' cy='10' r='8' /%3e%3c/svg%3e");
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: var(--atlas-primary);
  border-color: var(--atlas-primary);
  --atlas-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e");
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.35;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  color: #687078;
}
.form-check-input.form-check-input-expired {
  background-color: #dc3545;
  border-color: #dc3545;
  opacity: 0.35;
  pointer-events: none;
}
.form-check-input.form-check-input-expired ~ .form-check-label {
  color: #dc3545;
}

.form-check {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  padding: 0;
  min-height: 1.5rem;
}
.form-check .form-check-input {
  float: left;
  cursor: pointer;
  margin: 0;
  flex-shrink: 0;
}
.form-check.form-check-expired {
  pointer-events: none;
}
.form-check:not(.has-label) .form-check-label {
  display: none;
}

:host {
  display: inline-flex;
}

:host([is-group-title]) {
  position: sticky;
  z-index: 10;
  background-color: #ffffff;
  top: 0;
}

.select-item {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 1rem;
  clear: both;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
  color: #212529;
  text-align: inherit;
  text-decoration: none;
  background-color: transparent;
  border: 0;
  box-sizing: border-box;
  cursor: pointer;
}
.select-item:hover {
  background-color: var(--atlas-primary-100);
}
.select-item:focus, .select-item:focus-visible, .select-item:focus-within {
  appearance: none;
  outline: none;
  border: none;
  box-shadow: none;
}
.select-item.focused {
  border: 0.25rem solid rgba(var(--atlas-primary-500-rgb), 0.25);
  border-radius: 0.25rem;
  padding: 0.75rem;
}
@media screen and (min-width: 992px) {
  .select-item.focused {
    padding: 0.25rem 0.75rem;
  }
}
.select-item:active, .select-item.active, .select-item.selected {
  background: var(--atlas-primary);
  color: var(--atlas-contrast-primary);
}
.select-item:disabled, .select-item.disabled, .select-item.loading {
  opacity: 0.35;
  pointer-events: none;
}
.select-item:focus-visible {
  outline: none;
}
@media screen and (min-width: 992px) {
  .select-item {
    padding: 0.5rem 1rem;
  }
}
.select-item .select-item-content {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 0.5rem;
}
.select-item .select-item-label {
  text-align: left;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
.select-item.has-extra-content .select-item-label {
  font-weight: 700;
  margin-bottom: 0.25rem;
}
.select-item .extra-content {
  font-size: 0.8rem;
  line-height: 1.5;
  color: #687078;
}
.select-item .highlighted {
  color: var(--atlas-primary);
  font-weight: 700;
}
.select-item:active .extra-content,
.select-item:active .highlighted, .select-item.selected .extra-content,
.select-item.selected .highlighted {
  color: var(--atlas-contrast-primary);
}
.select-item.is-group-title {
  cursor: default;
  font-size: 0.875rem;
  font-weight: 700;
  text-transform: uppercase;
}
.select-item.is-group-title:hover {
  background: none;
}
.select-item.is-group-title:active {
  color: #212529;
}
.select-item.multiselect-item {
  flex-direction: row;
}
.select-item.multiselect-item.has-extra-content {
  align-items: flex-start;
}
.select-item.multiselect-item.has-extra-content .form-check-input {
  margin-top: 0.25rem;
}
.select-item.multiselect-item.selected {
  background: none;
  color: #212529;
}
.select-item.multiselect-item.selected .extra-content {
  color: #687078;
}
.select-item.multiselect-item.selected .highlighted {
  color: var(--atlas-primary);
}
.select-item.multiselect-item.selected:hover {
  background: var(--atlas-primary-100);
}
.select-item.multiselect-item.is-select-all {
  border-bottom: 1px solid #ced4da;
}
.select-item.multiselect-item .form-check-input:disabled {
  opacity: 1;
  background-color: var(--atlas-secondary-100);
}`;

// src/components/form/atlas-select-item/atlas-select-item.ts
var AtlasSelectItem = /*#__PURE__*/(() => {
  let AtlasSelectItem = class extends LitElement20 {
    constructor() {
      super(...arguments);
      this.selectAll = false;
    }
    onItemClick(event) {
      if (this.multiselect) {
        emit(this, "atlas-select-item-click", {
          detail: {
            shouldRemove: this.selected
          }
        });
        return;
      }
      if (this.isGroupTitle) {
        event.stopPropagation();
      } else {
        emit(this, "atlas-select-item-click");
      }
    }
    renderHighLightedText(text) {
      if (!this.highlightedText || !text) {
        return text;
      }
      const regex = new RegExp(escapeStringRegexp(this.highlightedText), "gi");
      const parts = text.replace(regex, match => `::highlight::${match}::endhighlight::`).split("::highlight::");
      return parts.map(part => {
        const subParts = part.split("::endhighlight::");
        if (subParts.length === 1) return part;
        return html76`<span class="highlighted">${subParts[0]}</span>${subParts[1]}`;
      });
    }
    renderExtraContent() {
      var _a;
      return (_a = this.extraContent) == null ? void 0 : _a.filter(content => !!content).map(content => html76`<span class="extra-content">${this.renderHighLightedText(`${content}`)}</span>`);
    }
    renderCheckbox() {
      return html76`
            <input
                class="form-check-input"
                type="checkbox"
                .checked=${live2(this.selected)}
                .indeterminate=${live2(this.indeterminate)}
                ?disabled=${this.disabled}
                aria-checked=${this.selected ? "true" : "false"}
                aria-disabled="${this.disabled}"
            />
        `;
    }
    render() {
      var _a;
      const itemClass = {
        "select-item": true,
        "multiselect-item": this.multiselect,
        "selected": this.selected,
        "disabled": this.disabled,
        "focused": this.focused,
        "has-extra-content": ((_a = this.extraContent) == null ? void 0 : _a.length) > 0,
        "is-group-title": this.isGroupTitle,
        "is-select-all": this.selectAll,
        "form-check": this.multiselect
      };
      const tag = this.multiselect ? literal9`a` : literal9`button`;
      return html76`
            <${tag}
                class=${classMap54(itemClass)}
                @click=${this.onItemClick}
                ?disabled=${this.disabled}
                tabindex=${ifDefined17(this.isGroupTitle ? "-1" : void 0)}
            >
                ${when51(this.multiselect, () => this.renderCheckbox())}
                <span class="select-item-content">
                    <span class="select-item-label">
                        ${when51(!!this.icon, () => html76`<atlas-icon name=${this.icon} size="2x"></atlas-icon>`)}
                        <span class="select-item-text">${this.renderHighLightedText(`${this.label}`)}</span>
                    </span>
                    ${this.renderExtraContent()}
                </span>
            </${tag}>
        `;
    }
  };
  AtlasSelectItem.styles = atlas_select_item_default;
  return AtlasSelectItem;
})();
__decorateClass([property76({
  type: String
})], AtlasSelectItem.prototype, "value", 2);
__decorateClass([property76({
  type: String
})], AtlasSelectItem.prototype, "label", 2);
__decorateClass([property76({
  type: String
})], AtlasSelectItem.prototype, "icon", 2);
__decorateClass([property76({
  type: Boolean
})], AtlasSelectItem.prototype, "disabled", 2);
__decorateClass([property76({
  type: Boolean,
  reflect: true
})], AtlasSelectItem.prototype, "selected", 2);
__decorateClass([property76({
  type: Boolean,
  reflect: true
})], AtlasSelectItem.prototype, "indeterminate", 2);
__decorateClass([property76({
  type: Boolean,
  attribute: "select-all"
})], AtlasSelectItem.prototype, "selectAll", 2);
__decorateClass([property76({
  type: Boolean
})], AtlasSelectItem.prototype, "focused", 2);
__decorateClass([property76({
  type: Boolean
})], AtlasSelectItem.prototype, "multiselect", 2);
__decorateClass([property76({
  type: Boolean,
  attribute: "is-group-title"
})], AtlasSelectItem.prototype, "isGroupTitle", 2);
__decorateClass([property76({
  type: String,
  attribute: "highlighted-text"
})], AtlasSelectItem.prototype, "highlightedText", 2);
__decorateClass([property76({
  type: Array,
  attribute: null
})], AtlasSelectItem.prototype, "extraContent", 2);
AtlasSelectItem = __decorateClass([customElement67("atlas-select-item")], AtlasSelectItem);

// src/components/form/atlas-select/atlas-select-dropdown.ts
var AtlasSelectDropdown = /*#__PURE__*/(() => {
  let AtlasSelectDropdown = class extends LitElement21 {
    constructor() {
      super(...arguments);
      this.enableSelectAll = false;
      this.newItemPrefix = "Criar";
      this.options = [];
      this.selectedOptions = [];
      this.emptyStateText = "Sem escolhas para fazer";
      this.groups = {};
      this._isDropdownOpen = false;
      this._focusedOption = 0;
      this._deviceController = new DeviceController(this);
    }
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.onDropdownOpen = this.onDropdownOpen.bind(this);
      this.onDropdownClose = this.onDropdownClose.bind(this);
      this.onMouseOverOption = this.onMouseOverOption.bind(this);
      this.onDocumentKeyDown = this.onDocumentKeyDown.bind(this);
      this.onSearchInputChange = this.onSearchInputChange.bind(this);
      this.onSearchInputKeyDown = this.onSearchInputKeyDown.bind(this);
      this.updateComplete.then(() => {
        this._dropdown = this.shadowRoot.querySelector("atlas-dropdown");
      });
    }
    canCreateNew() {
      return this.enableNew && this.searchValue && this.searchValue.trim() !== "";
    }
    findOptionWithValue(value) {
      return this._dropdown.querySelector(`atlas-select-item[value="${value}"]`);
    }
    findOptionWithIndex(index) {
      return this._dropdown.querySelector(`atlas-select-item[data-option-index="${index}"]`);
    }
    openDropdown() {
      this._dropdown.show();
    }
    closeDropdown() {
      this._dropdown.hide();
    }
    updateDropdownPosition() {
      this._dropdown.updatePosition();
    }
    onDropdownOpen() {
      this._isDropdownOpen = true;
      if (this._deviceController.isMobile) {
        const searchInput = this._dropdown.querySelector(".dropdown-search-input");
        setTimeout(() => {
          searchInput == null ? void 0 : searchInput.focus();
        }, 250);
      } else {
        document.addEventListener("keydown", this.onDocumentKeyDown);
        this.setFirstFocus();
      }
      emit(this, "atlas-select-dropdown-opened");
    }
    onDropdownClose() {
      this._isDropdownOpen = false;
      document.removeEventListener("keydown", this.onDocumentKeyDown);
      this.removeFocusFromOptions();
      emit(this, "atlas-select-dropdown-closed");
    }
    onDocumentKeyDown(event) {
      const escapeKeys = ["Tab", "Escape"];
      const arrowKeys = ["ArrowUp", "ArrowDown"];
      const mappedKeys = ["Enter", ...escapeKeys, ...arrowKeys];
      if (!mappedKeys.includes(event.key)) return;
      if (arrowKeys.includes(event.key)) {
        event.preventDefault();
        this.changeFocusedOption(event);
      } else if (escapeKeys.includes(event.key)) {
        this.closeDropdown();
      } else if (event.key === "Enter") {
        this.selectFocusedOption();
      }
    }
    onClickOption(event) {
      var _a;
      const option = event.target;
      const optionValue = option.getAttribute("value");
      const shouldRemove = (_a = event.detail) == null ? void 0 : _a.shouldRemove;
      if (shouldRemove) {
        this.removeOption(optionValue);
        return;
      }
      this.selectOption(optionValue);
    }
    onSearchInputChange(event) {
      emit(this, "atlas-select-dropdown-search", {
        detail: event.detail
      });
    }
    onSearchInputKeyDown() {
      emit(this, "atlas-select-dropdown-input-keydown");
    }
    onMouseOverOption(event) {
      this.removeFocusFromOptions();
      const targetOption = event.target;
      this._focusedOption = parseInt(targetOption.dataset.optionIndex, 10);
    }
    setFirstFocus() {
      var _a;
      const firstSelected = (_a = this.selectedOptions[0]) == null ? void 0 : _a.value;
      let focusedIndex = 0;
      if (firstSelected) {
        const option = this.findOptionWithValue(firstSelected);
        if (option) {
          focusedIndex = parseInt(option.dataset.optionIndex, 10);
        }
      }
      this._focusedOption = focusedIndex;
      this.removeFocusFromOptions();
    }
    removeFocusFromOptions() {
      var _a;
      (_a = this._dropdown) == null ? void 0 : _a.querySelectorAll(`atlas-select-item`).forEach(option => {
        option.removeAttribute("focused");
      });
    }
    applyFocusOnOption() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const option = this.findOptionWithIndex(this._focusedOption);
        option == null ? void 0 : option.toggleAttribute("focused", true);
        option == null ? void 0 : option.scrollIntoView({
          block: "nearest",
          behavior: "smooth"
        });
      });
    }
    changeFocusedOption(event) {
      var _a;
      if (!((_a = this.findOptionWithIndex(this._focusedOption)) == null ? void 0 : _a.hasAttribute("focused"))) {
        this.applyFocusOnOption();
        return;
      }
      this.removeFocusFromOptions();
      let numberOfGroups = 1;
      if (Object.keys(this.groups).length > 0) {
        numberOfGroups = Object.keys(this.groups).length;
      }
      const optionsLength = this.canCreateNew() ? this.options.length + numberOfGroups : this.options.length;
      const nextOption = event.key === "ArrowDown" ? this._focusedOption + 1 : this._focusedOption - 1;
      if (nextOption < 0) {
        this._focusedOption = optionsLength - 1;
      } else if (nextOption >= optionsLength) {
        this._focusedOption = 0;
      } else {
        this._focusedOption = nextOption;
      }
      this.applyFocusOnOption();
    }
    selectOrRemoveFocusedOption(option) {
      const isFocusedOptionSelected = this.selectedOptions.some(selected => `${selected.value}` === `${option.value}`);
      if (isFocusedOptionSelected) {
        this.removeOption(option.value);
      } else {
        this.selectOption(option.value);
      }
      if (option == null ? void 0 : option.hasAttribute("data-is-create-new")) {
        option.dispatchEvent(new CustomEvent("atlas-select-item-click"));
      }
    }
    selectFocusedOption() {
      const option = this.findOptionWithIndex(this._focusedOption);
      if (this.multiselect) {
        this.selectOrRemoveFocusedOption(option);
        return;
      }
      if (option) {
        this.selectOption(option.value);
      }
      if (option == null ? void 0 : option.hasAttribute("data-is-create-new")) {
        option.dispatchEvent(new CustomEvent("atlas-select-item-click"));
      }
    }
    selectOption(optionValue) {
      emit(this, "atlas-select-dropdown-change", {
        detail: {
          option: optionValue
        }
      });
      if (this.shouldHideDropdown()) {
        this.closeDropdown();
      }
    }
    removeOption(optionValue) {
      emit(this, "atlas-select-dropdown-change", {
        detail: {
          option: optionValue,
          removeOption: true
        }
      });
      if (this.shouldHideDropdown()) {
        this.closeDropdown();
      }
    }
    createNewOption(event) {
      const {
        group
      } = event.target.dataset;
      emit(this, "atlas-select-dropdown-create-new", {
        detail: {
          optionLabel: this.searchValue,
          group
        }
      });
      if (this.shouldHideDropdown()) {
        this.closeDropdown();
      }
    }
    selectAllOptions() {
      const selectedValues = this.selectedOptions.map(option => option.value);
      const allValues = this.options.map(option => option.value);
      if (selectedValues.length === allValues.length) {
        emit(this, "atlas-select-dropdown-change", {
          detail: {
            option: "",
            removeOption: true
          }
        });
        return;
      }
      emit(this, "atlas-select-dropdown-change", {
        detail: {
          option: allValues.join(",")
        }
      });
    }
    shouldHideDropdown() {
      return !this.multiselect;
    }
    shouldRenderFooterButtons() {
      return this._deviceController.isMobile && this.multiselect && this.enableSearch;
    }
    renderDropdownSearch() {
      return when52(this._deviceController.isMobile && this.enableSearch, () => html77`
                <atlas-input
                    slot="subheading"
                    size="lg"
                    icon="magnifier"
                    class="dropdown-search-input"
                    placeholder=${this.searchPlaceholder}
                    value=${this.searchValue}
                    ?loading=${this.loading}
                    @atlas-input-change=${this.onSearchInputChange}
                    @keydown=${this.onSearchInputKeyDown}
                ></atlas-input>
            `);
    }
    renderOptionsFromGroup(optionsFromGroup, baseIndex) {
      const extraKeys = this.extraKeys && this.extraKeys.trim() ? this.extraKeys.split(";") : [];
      return optionsFromGroup.map((option, index) => html77`
                <atlas-select-item
                    value=${option.value}
                    label=${option.label}
                    highlighted-text=${this.isTyping ? this.searchValue : ""}
                    ?selected=${this.selectedOptions.some(selected => `${selected.value}` === `${option.value}`)}
                    ?disabled=${option.disabled}
                    ?multiselect=${this.multiselect}
                    .extraContent=${extraKeys.map(key => option.customProperties[key])}
                    @atlas-select-item-click=${this.onClickOption}
                    @mouseover=${this.onMouseOverOption}
                    data-option-index=${baseIndex + index}
                ></atlas-select-item>
            `);
    }
    renderSelectOptions() {
      const groupKeys = Object.keys(this.groups);
      const enableSelectAll = this.enableSelectAll && this.options.length > 0;
      const selectAll = enableSelectAll ? this.renderSelectAll() : html77``;
      if (groupKeys.length > 0) {
        return html77`${selectAll}${this.renderSelectOptionWithGroup()}`;
      }
      return html77`${selectAll}${this.renderOptionsFromGroup(this.options, 0)}${this.renderCreateNew()}`;
    }
    renderSelectOptionWithGroup() {
      const groupKeys = Object.keys(this.groups);
      let countOptions = 0;
      return groupKeys.map((groupName, groupIndex) => {
        const groupOptions = this.options.filter(option => option.group === groupName);
        countOptions += groupOptions.length;
        if (groupOptions.length === 0 && !this.canCreateNew()) return html77``;
        const baseIndex = this.canCreateNew() ? countOptions - groupOptions.length + groupIndex : countOptions - groupOptions.length;
        const createNewIndex = countOptions + groupIndex;
        return html77`
                <atlas-select-item label=${this.groups[groupName]} is-group-title></atlas-select-item>
                ${this.renderOptionsFromGroup(groupOptions, baseIndex)}
                ${this.renderCreateNew(groupName, createNewIndex)}
            `;
      });
    }
    renderCreateNew(groupName, index) {
      return when52(this.canCreateNew(), () => html77`
                <atlas-select-item
                    label=${`${this.newItemPrefix} ${this.searchValue}`}
                    icon="plus"
                    highlighted-text=${this.isTyping ? this.searchValue : ""}
                    @atlas-select-item-click=${this.createNewOption}
                    @mouseover=${this.onMouseOverOption}
                    data-option-index=${index ? index : this.options.length}
                    data-group=${groupName}
                    data-is-create-new
                ></atlas-select-item>
            `);
    }
    renderSelectAll() {
      return when52(this.enableSelectAll, () => html77`
                <atlas-select-item
                    label="Selecionar todos"
                    multiselect
                    select-all
                    ?selected=${this.options.length === this.selectedOptions.length}
                    ?indeterminate=${this.selectedOptions.length > 0 && this.selectedOptions.length < this.options.length}
                    @atlas-select-item-click=${this.selectAllOptions}
                ></atlas-select-item>
            `);
    }
    renderDropdownContent() {
      if (this.loading) {
        return html77`
                <div class="dropdown-empty-state">
                    <atlas-icon name="loader" size="2x"></atlas-icon>
                    <atlas-text muted>Carregando opções</atlas-text>
                </div>
            `;
      }
      if (this.options.length === 0 && !this.canCreateNew()) {
        return html77`
                <div class="dropdown-empty-state">
                    <atlas-icon name="magnifier" size="2x"></atlas-icon>
                    <atlas-text muted>
                        ${this.multiselect ? "Nenhum resultado encontrado. Tente novamente com outros termos." : this.emptyStateText}
                    </atlas-text>
                </div>
            `;
      }
      return html77`${this.renderSelectOptions()}`;
    }
    render() {
      return html77`
            <atlas-dropdown
                no-gap
                auto-close
                ?mobile-fullscreen=${this.enableSearch}
                ?disabled=${this.disabled}
                ?has-footer=${this.shouldRenderFooterButtons()}
                auto-close-trigger=${this.multiselect ? "outside" : "any"}
                max-height=${this.extraKeys ? 340 : 420}
                header=${this._deviceController.isMobile ? this.header : ""}
                @atlas-dropdown-opened=${this.onDropdownOpen}
                @atlas-dropdown-closed=${this.onDropdownClose}
                tabindex=${ifDefined18(this._isDropdownOpen ? void 0 : "-1")}
                id="select-dropdown"
            >
                ${this.renderDropdownSearch()} ${this.renderDropdownContent()}
            </atlas-dropdown>
        `;
    }
  };
  AtlasSelectDropdown.styles = atlas_select_dropdown_default;
  return AtlasSelectDropdown;
})();
__decorateClass([property77({
  type: String
})], AtlasSelectDropdown.prototype, "header", 2);
__decorateClass([property77({
  type: Boolean
})], AtlasSelectDropdown.prototype, "loading", 2);
__decorateClass([property77({
  type: Boolean
})], AtlasSelectDropdown.prototype, "multiselect", 2);
__decorateClass([property77({
  type: Boolean
})], AtlasSelectDropdown.prototype, "disabled", 2);
__decorateClass([property77({
  type: Boolean,
  attribute: "enable-select-all"
})], AtlasSelectDropdown.prototype, "enableSelectAll", 2);
__decorateClass([property77({
  type: Boolean,
  attribute: "enable-new"
})], AtlasSelectDropdown.prototype, "enableNew", 2);
__decorateClass([property77({
  type: String,
  attribute: "new-item-prefix"
})], AtlasSelectDropdown.prototype, "newItemPrefix", 2);
__decorateClass([property77({
  type: Array
})], AtlasSelectDropdown.prototype, "options", 2);
__decorateClass([property77({
  type: Array
})], AtlasSelectDropdown.prototype, "selectedOptions", 2);
__decorateClass([property77({
  type: String,
  attribute: "search-value"
})], AtlasSelectDropdown.prototype, "searchValue", 2);
__decorateClass([property77({
  type: String,
  attribute: "search-placeholder"
})], AtlasSelectDropdown.prototype, "searchPlaceholder", 2);
__decorateClass([property77({
  type: String,
  attribute: "empty-state-text"
})], AtlasSelectDropdown.prototype, "emptyStateText", 2);
__decorateClass([property77({
  type: String,
  attribute: "extra-keys"
})], AtlasSelectDropdown.prototype, "extraKeys", 2);
__decorateClass([property77({
  type: Boolean,
  attribute: "is-typing"
})], AtlasSelectDropdown.prototype, "isTyping", 2);
__decorateClass([property77({
  type: Boolean,
  attribute: "enable-search"
})], AtlasSelectDropdown.prototype, "enableSearch", 2);
__decorateClass([property77({
  type: Object
})], AtlasSelectDropdown.prototype, "groups", 2);
__decorateClass([state37()], AtlasSelectDropdown.prototype, "_isDropdownOpen", 2);
__decorateClass([state37()], AtlasSelectDropdown.prototype, "_focusedOption", 2);
__decorateClass([Watch("searchValue", true)], AtlasSelectDropdown.prototype, "setFirstFocus", 1);
AtlasSelectDropdown = __decorateClass([customElement68("atlas-select-dropdown")], AtlasSelectDropdown);

// src/components/form/atlas-select/atlas-select.ts
var AtlasSelect = /*#__PURE__*/(() => {
  let AtlasSelect = class extends WithTooltipMixin(FormControl) {
    constructor() {
      super(...arguments);
      this.size = "md";
      this.width = "auto";
      this.newItemPrefix = "Criar";
      this.emptyStateText = "Sem escolhas para fazer";
      this.searchParams = "q";
      this.groups = {};
      this.preventDisabledActionButton = false;
      this._isDropdownOpen = false;
      this._syncInputValueOnNextChange = true;
      this._showLoadingOnSearch = true;
      this._inputValue = "";
      this._lastInputValue = "";
      this._selectOptions = [];
      this._selected = [];
      this._countNewOptions = 0;
      this._isTyping = false;
      this._hasDoneFirstSearch = false;
    }
    /** @internal */
    connectedCallback() {
      return __async(this, null, function* () {
        var _a;
        yield (_a = __superGet(AtlasSelect.prototype, this, "connectedCallback")) == null ? void 0 : _a.call(this);
        yield this.updateComplete;
        this.onSelectDropdownChange = this.onSelectDropdownChange.bind(this);
        this.onCreateNewOption = this.onCreateNewOption.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.onInputFocus = this.onInputFocus.bind(this);
        this.onInputKeyDown = this.onInputKeyDown.bind(this);
        this.onSelectDropdownInputKeyDown = this.onSelectDropdownInputKeyDown.bind(this);
        this.onDropdownOpen = this.onDropdownOpen.bind(this);
        this.onDropdownClose = this.onDropdownClose.bind(this);
        this.searchOptions = debounce(this.searchOptions.bind(this), 350);
        this.addEventListener("atlas-select-dropdown-change", this.onSelectDropdownChange);
        this.addEventListener("atlas-select-dropdown-create-new", this.onCreateNewOption);
        this.addEventListener("atlas-select-dropdown-search", this.onInputChange);
        this.addEventListener("atlas-select-dropdown-input-keydown", this.onSelectDropdownInputKeyDown);
        this.addEventListener("atlas-select-dropdown-opened", this.onDropdownOpen);
        this.addEventListener("atlas-select-dropdown-closed", this.onDropdownClose);
        this.addEventListener("atlas-form-element-value-change", this.syncInputValidation);
        if (this.searchOnRender) {
          this.searchOptions();
        }
      });
    }
    /** @internal */
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      this.removeEventListener("atlas-select-dropdown-change", this.onSelectDropdownChange);
      this.removeEventListener("atlas-select-dropdown-create-new", this.onCreateNewOption);
      this.removeEventListener("atlas-select-dropdown-search", this.onInputChange);
      this.removeEventListener("atlas-select-dropdown-input-keydown", this.onSelectDropdownInputKeyDown);
      this.removeEventListener("atlas-select-dropdown-opened", this.onDropdownOpen);
      this.removeEventListener("atlas-select-dropdown-closed", this.onDropdownClose);
      this.removeEventListener("atlas-form-element-value-change", this.syncInputValidation);
    }
    syncInputValidation() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this._selectInput._status = this._status;
        this._selectInput._statusMessage = this._statusMessage;
        this._selectInput._valid = this._valid;
        this._selectInput._showStatusMessage = this._showStatusMessage;
      });
    }
    onChangeValue() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const selectedValues = this.getSelectedValues();
        this._selected = this._selectOptions.filter(option => selectedValues.includes(`${option.value}`));
        this._showLoadingOnSearch = false;
        if (this._syncInputValueOnNextChange) {
          this.syncTextWithSelectedValue();
        }
        this._syncInputValueOnNextChange = true;
        emit(this, "atlas-select-change");
      });
    }
    /**
     * Retorna a(s) opção(ões) selecionada(s)
     * @returns {SelectOption[] | SelectOption | object} - Um objeto ou um array de objetos contendo as opções selecionadas, ou um objeto vazio caso não haja opção selecionada
     */
    getSelectedOptions() {
      return this._selected[0] || {};
    }
    /**
     * Retorna o valor da opção selecionada (se multiselect, um array com os valores)
     * @returns {string[]} - Array com os valores das opções selecionadas
     */
    getSelectedValues() {
      return `${this.value}`.split(",");
    }
    /**
     * Aplica o foco no input do select
     */
    focus() {
      this._selectInput.focus();
      if (this.shouldOpenDropdown()) {
        this._selectDropdown.openDropdown();
      }
    }
    /**
     * Remove o foco do input do select
     */
    blur() {
      this._selectInput.blur();
      this._selectDropdown.closeDropdown();
    }
    /**
     * Define as opções do select
     * @param options - Array de objetos contendo as opções do select
     */
    setOptions(options) {
      const selectedValues = this.getSelectedValues();
      this._selectOptions = options;
      this._selected = this._selectOptions.filter(option => selectedValues.includes(`${option.value}`));
      this.syncTextWithSelectedValue();
    }
    /**
     * Seleciona uma ou mais opções do select
     * @param option - Valor ou valores da(s) opção(ões) que deseja selecionar
     */
    selectOption(option) {
      const optionValue = [];
      if (Array.isArray(option)) {
        option.forEach(opt => {
          if (typeof opt !== "string") {
            this.createOptionIfNeeded(opt);
            optionValue.push(opt.value);
          } else {
            optionValue.push(opt);
          }
        });
      } else if (typeof option !== "string") {
        this.createOptionIfNeeded(option);
        optionValue.push(option.value);
      } else {
        optionValue.push(option);
      }
      this._syncInputValueOnNextChange = true;
      this._isTyping = false;
      this.value = optionValue.join(",");
    }
    /**
     * Realiza a busca das opções do select
     */
    searchOptions() {
      var _a;
      if (!this.hasApiSearch() || this.searchOnce && this._hasDoneFirstSearch) return;
      if (!this.shouldTriggerSearch()) return;
      this.loading = true;
      this._hasDoneFirstSearch = true;
      const searchParams = ((_a = this.searchParams) == null ? void 0 : _a.split(";")) || ["q"];
      const params = searchParams.reduce((prev, cur) => __spreadProps(__spreadValues({}, prev), {
        [cur]: this.searchOnce ? "" : this._inputValue
      }), {});
      const request = get(this.searchUrl, params);
      request.then(response => {
        this._selectOptions = this.extractOptionsFromGroups(response);
        const selectedValues = this.getSelectedValues();
        if (this._selected.length > 0) {
          this._selected.forEach(selected => this.createOptionIfNeeded(selected));
        } else if (this.value && selectedValues.length > 0) {
          this._selected = this._selectOptions.filter(option => selectedValues.includes(`${option.value}`));
          this.syncTextWithSelectedValue();
        }
        setTimeout(() => {
          this.loading = false;
          this._showLoadingOnSearch = true;
          setTimeout(() => {
            this._selectDropdown.updateDropdownPosition();
            this._selectDropdown.setFirstFocus();
          }, 0);
        }, 350);
      });
    }
    shouldTriggerSearch() {
      return true;
    }
    shouldOpenDropdown() {
      return true;
    }
    hasApiSearch() {
      return !!this.searchUrl;
    }
    hasSearch() {
      return this.enableSearch || this.enableNew;
    }
    syncTextWithSelectedValue() {
      var _a, _b;
      this._inputValue = this.value ? ((_b = (_a = this._selected) == null ? void 0 : _a[0]) == null ? void 0 : _b.label) || "" : "";
    }
    onSelectDropdownChange(event) {
      const {
        option
      } = event.detail;
      this.selectOption(`${option}`);
    }
    onCreateNewOption(event) {
      const {
        optionLabel,
        group
      } = event.detail;
      this._countNewOptions += 1;
      this.selectOption([...this._selected, {
        label: optionLabel,
        value: `${-this._countNewOptions}`,
        group
      }]);
    }
    onInputChange(event) {
      this._lastInputValue = this._inputValue;
      this._inputValue = event.detail;
      this.searchOptions();
      if (!this.hasApiSearch()) {
        this._selectDropdown.updateDropdownPosition();
      }
    }
    onInputFocus() {
      if (this.hasSearch() || this.hasApiSearch()) {
        this._selectInput._input.select();
      }
    }
    onInputBlur() {
      setTimeout(() => {
        this.reportValidity();
      }, 200);
    }
    onInputKeyDown(event) {
      const escapeKeys = ["Tab", "Escape"];
      if (escapeKeys.includes(event.key)) return;
      setTimeout(() => {
        if (this.shouldOpenDropdown()) {
          this._selectDropdown.openDropdown();
        } else if (this._isDropdownOpen) {
          this._syncInputValueOnNextChange = false;
          this._selectDropdown.closeDropdown();
        }
        if (event.key !== "Enter" && this._inputValue !== this._lastInputValue) {
          this._syncInputValueOnNextChange = false;
          this.value = "";
          this._isTyping = true;
        }
      }, 0);
    }
    onSelectDropdownInputKeyDown() {
      this._syncInputValueOnNextChange = false;
      this.value = "";
      this._isTyping = true;
    }
    onDropdownOpen() {
      this._isDropdownOpen = true;
      if (!this._hasDoneFirstSearch) {
        this.searchOptions();
      }
    }
    onDropdownClose() {
      this._isDropdownOpen = false;
      this._isTyping = false;
    }
    loadSlottedOptions() {
      const optionsSlot = this.shadowRoot.querySelector("slot:not([name])");
      const options = optionsSlot.assignedElements().map(option => ({
        label: option.label,
        value: option.value,
        disabled: option.disabled,
        group: option.group,
        customProperties: __spreadValues({}, option.dataset)
      }));
      this.setOptions(options);
    }
    hasOptionOnSelect(option) {
      return this._selectOptions.some(curOption => `${curOption.value}` === `${option.value}`);
    }
    createOptionIfNeeded(option) {
      if (!this.hasOptionOnSelect(option)) {
        this._selectOptions = [option, ...this._selectOptions];
      }
    }
    getLabelForOption(option) {
      const labelKeys = this.labelKey.split(",");
      const firstKeyWithValue = labelKeys.find(labelKey => !!option[labelKey]);
      return option[firstKeyWithValue];
    }
    extractOptionsFromGroups(response) {
      const groupsKeys = Object.keys(this.groups);
      const options = [];
      if (groupsKeys.length > 0) {
        groupsKeys.forEach(groupName => {
          response[groupName].forEach(option => {
            options.push({
              label: this.getLabelForOption(option),
              value: option[this.valueKey],
              selected: `${option[this.valueKey]}` === `${this.value}`,
              group: groupName,
              customProperties: __spreadValues({}, option)
            });
          });
        });
      } else {
        response.forEach(option => {
          options.push({
            label: this.getLabelForOption(option),
            value: option[this.valueKey],
            selected: `${option[this.valueKey]}` === `${this.value}`,
            customProperties: __spreadValues({}, option)
          });
        });
      }
      return options;
    }
    getVisibleOptions() {
      let options = this._selectOptions;
      if ((!this.hasApiSearch() || this.searchOnce) && this._isTyping) {
        options = options.filter(opt => opt.label.toUpperCase().includes(this._inputValue.toUpperCase()));
      }
      return options;
    }
    getPlaceholder() {
      var _a;
      return this.value === "" && this._selected[0] ? ((_a = this._selected[0]) == null ? void 0 : _a.label) || this.placeholder : this.placeholder;
    }
    renderInput() {
      const placeholder = this.getPlaceholder();
      const atlasSelectInputClass = {
        "atlas-select-input": true,
        "collapsed": !this._isDropdownOpen
      };
      const inputIcon = this.tagName === "ATLAS-AUTOCOMPLETE" ? "magnifier" : "chevron-down";
      return html78`
            <atlas-input
                class=${classMap55(atlasSelectInputClass)}
                label=${this.label}
                size=${this.size}
                width=${this.width}
                placeholder=${placeholder}
                icon=${inputIcon}
                value=${this._inputValue}
                ?disabled=${this.disabled}
                ?loading=${this._showLoadingOnSearch && this.loading}
                ?hide-optional=${this.required || this.hideOptional}
                action-button-description=${this.actionButtonDescription}
                helper-text=${this.helperText}
                popover-title=${this.popoverTitle}
                popover-content=${this.popoverContent}
                tooltip=${this.tooltip}
                tooltip-placement=${this.tooltipPlacement}
                tooltip-trigger=${this.tooltipTrigger}
                data-atlas-dropdown="select-dropdown"
                @atlas-input-change=${this.onInputChange}
                @atlas-input-focus=${this.onInputFocus}
                @atlas-input-blur=${this.onInputBlur}
                @keydown=${this.onInputKeyDown}
                ignore-validations
                ?readonly=${!this.hasSearch() && !this.hasApiSearch()}
                ?prevent-disabled-action-button=${this.preventDisabledActionButton}
            >
                <slot name="helper-text" slot="helper-text"></slot>
                ${this.renderNamedPopoverSlot()}
            </atlas-input>
        `;
    }
    renderSelectDropdown() {
      const placeholder = this.getPlaceholder();
      return html78`
            <atlas-select-dropdown
                header=${this.label}
                ?loading=${this.loading || this.hasApiSearch() && !this._hasDoneFirstSearch}
                ?enable-new=${this.enableNew}
                new-item-prefix=${this.newItemPrefix}
                .options=${this.getVisibleOptions()}
                .selectedOptions=${this._selected}
                search-value=${this._inputValue}
                search-placeholder=${placeholder}
                empty-state-text=${this.emptyStateText}
                extra-keys=${this.extraKeys}
                .groups=${this.groups}
                ?is-typing=${this._isTyping}
                ?enable-search=${this.hasSearch() || this.hasApiSearch()}
                ?disabled=${this.disabled || !this.shouldOpenDropdown()}
            ></atlas-select-dropdown>
        `;
    }
    /** @internal */
    render() {
      return html78`
            ${this.renderInput()} ${this.renderSelectDropdown()}
            <slot @slotchange=${this.loadSlottedOptions}></slot>
        `;
    }
  };
  AtlasSelect.styles = atlas_select_default;
  return AtlasSelect;
})();
__decorateClass([property78({
  type: String
})], AtlasSelect.prototype, "size", 2);
__decorateClass([property78({
  type: String
})], AtlasSelect.prototype, "width", 2);
__decorateClass([property78({
  type: String
})], AtlasSelect.prototype, "placeholder", 2);
__decorateClass([property78({
  type: Boolean
})], AtlasSelect.prototype, "loading", 2);
__decorateClass([property78({
  type: String,
  attribute: "new-item-prefix"
})], AtlasSelect.prototype, "newItemPrefix", 2);
__decorateClass([property78({
  type: String,
  attribute: "empty-state-text"
})], AtlasSelect.prototype, "emptyStateText", 2);
__decorateClass([property78({
  type: String,
  attribute: "search-url"
})], AtlasSelect.prototype, "searchUrl", 2);
__decorateClass([property78({
  type: Boolean,
  attribute: "search-once"
})], AtlasSelect.prototype, "searchOnce", 2);
__decorateClass([property78({
  type: String,
  attribute: "search-params"
})], AtlasSelect.prototype, "searchParams", 2);
__decorateClass([property78({
  type: String,
  attribute: "value-key"
})], AtlasSelect.prototype, "valueKey", 2);
__decorateClass([property78({
  type: String,
  attribute: "label-key"
})], AtlasSelect.prototype, "labelKey", 2);
__decorateClass([property78({
  type: String,
  attribute: "extra-keys"
})], AtlasSelect.prototype, "extraKeys", 2);
__decorateClass([property78({
  type: Boolean,
  attribute: "search-on-render"
})], AtlasSelect.prototype, "searchOnRender", 2);
__decorateClass([property78({
  type: Boolean,
  attribute: "enable-new"
})], AtlasSelect.prototype, "enableNew", 2);
__decorateClass([property78({
  type: Boolean,
  attribute: "enable-search"
})], AtlasSelect.prototype, "enableSearch", 2);
__decorateClass([property78({
  type: Object
})], AtlasSelect.prototype, "groups", 2);
__decorateClass([property78({
  type: String,
  attribute: "action-button-description"
})], AtlasSelect.prototype, "actionButtonDescription", 2);
__decorateClass([property78({
  type: Boolean,
  attribute: "prevent-disabled-action-button"
})], AtlasSelect.prototype, "preventDisabledActionButton", 2);
__decorateClass([state38()], AtlasSelect.prototype, "_isDropdownOpen", 2);
__decorateClass([state38()], AtlasSelect.prototype, "_syncInputValueOnNextChange", 2);
__decorateClass([state38()], AtlasSelect.prototype, "_showLoadingOnSearch", 2);
__decorateClass([state38()], AtlasSelect.prototype, "_inputValue", 2);
__decorateClass([state38()], AtlasSelect.prototype, "_lastInputValue", 2);
__decorateClass([state38()], AtlasSelect.prototype, "_selectOptions", 2);
__decorateClass([state38()], AtlasSelect.prototype, "_selected", 2);
__decorateClass([state38()], AtlasSelect.prototype, "_countNewOptions", 2);
__decorateClass([state38()], AtlasSelect.prototype, "_isTyping", 2);
__decorateClass([state38()], AtlasSelect.prototype, "_hasDoneFirstSearch", 2);
__decorateClass([query13(".atlas-select-input")], AtlasSelect.prototype, "_selectInput", 2);
__decorateClass([query13("atlas-select-dropdown")], AtlasSelect.prototype, "_selectDropdown", 2);
__decorateClass([Watch(["_status", "_valid", "_statusMessage", "_showStatusMessage"])], AtlasSelect.prototype, "syncInputValidation", 1);
__decorateClass([Watch("value", true)], AtlasSelect.prototype, "onChangeValue", 1);
AtlasSelect = __decorateClass([customElement69("atlas-select")], AtlasSelect);

// src/components/form/atlas-autocomplete/atlas-autocomplete.ts
var AtlasAutocomplete = class extends AtlasSelect {
  constructor() {
    super(...arguments);
    this.triggerKeyCount = 1;
    this.emptyStateText = "Nenhum resultado encontrado. Tente novamente com outros termos.";
    this._deviceController = new DeviceController(this);
  }
  /** @internal */
  connectedCallback() {
    return __async(this, null, function* () {
      yield __superGet(AtlasAutocomplete.prototype, this, "connectedCallback").call(this);
      this._hasDoneFirstSearch = true;
      this.onSelectChange = this.onSelectChange.bind(this);
      this.addEventListener("atlas-select-change", this.onSelectChange);
    });
  }
  /** @internal */
  disconnectedCallback() {
    this.removeEventListener("atlas-select-change", this.onSelectChange);
  }
  /** @override */
  shouldTriggerSearch() {
    return this._inputValue.length >= this.triggerKeyCount;
  }
  /** @override */
  shouldOpenDropdown() {
    return this._deviceController.isMobile || this._inputValue.length >= this.triggerKeyCount;
  }
  /** @override */
  hasSearch() {
    return true;
  }
  /** @override */
  onDropdownClose() {
    super.onDropdownClose();
    this._selectOptions = [];
  }
  /** @override */
  onSelectDropdownChange(event) {
    super.onSelectDropdownChange(event);
    setTimeout(() => {
      this._selectDropdown.closeDropdown();
    }, 0);
  }
  /** @override */
  onSelectDropdownInputKeyDown() {
    super.onSelectDropdownInputKeyDown();
    setTimeout(() => {
      if (this._deviceController.isMobile && this._inputValue.length < this.triggerKeyCount) {
        this._selectOptions = [];
      }
    }, 0);
  }
  onSelectChange(event) {
    emit(this, "atlas-autocomplete-change", event.detail);
  }
};
__decorateClass([property79({
  type: Number,
  attribute: "trigger-key-count"
})], AtlasAutocomplete.prototype, "triggerKeyCount", 2);
__decorateClass([property79({
  type: String,
  attribute: "empty-state-text"
})], AtlasAutocomplete.prototype, "emptyStateText", 2);
AtlasAutocomplete = __decorateClass([customElement70("atlas-autocomplete")], AtlasAutocomplete);

// src/components/form/atlas-card-number/atlas-card-number.ts
import { customElement as customElement71, property as property80 } from "lit/decorators.js";

// src/vendors/inputmask-utils.ts
import Inputmask from "inputmask/dist/inputmask.es6";

// src/helpers/cpf-cnpj.ts
var cpf_cnpj_exports = {};
__export(cpf_cnpj_exports, {
  validateCnpj: () => validateCnpj,
  validateCpf: () => validateCpf,
  validateCpfCnpj: () => validateCpfCnpj
});
var CPF_LENGTH = 11;
var CNPJ_LENGTH = 14;
function validateCpf(cpfValue) {
  const cpf = removeNonNumeric(cpfValue);
  const invalidCPFSequences = ["00000000000", "11111111111", "22222222222", "33333333333", "44444444444", "55555555555", "66666666666", "77777777777", "88888888888", "99999999999"];
  if (invalidCPFSequences.includes(cpf) || cpf.length !== CPF_LENGTH) {
    return false;
  }
  const numbers = cpf.substring(0, 9);
  const digits = cpf.substring(9);
  let d1 = 0;
  for (let i = 0; i < 9; i++) {
    d1 += parseInt(numbers.charAt(i), 10) * (10 - i);
  }
  if (d1 === 0) return false;
  d1 = 11 - d1 % 11;
  if (d1 > 9) d1 = 0;
  if (parseInt(digits.charAt(0), 10) !== d1) {
    return false;
  }
  d1 *= 2;
  for (let i = 0; i < 9; i++) {
    d1 += parseInt(numbers.charAt(i), 10) * (11 - i);
  }
  d1 = 11 - d1 % 11;
  if (d1 > 9) d1 = 0;
  if (parseInt(digits.charAt(1), 10) !== d1) {
    return false;
  }
  return true;
}
function validateCnpj(cnpjValue) {
  const cnpj = removeNonNumeric(cnpjValue);
  const invalidCNPJSequences = ["00000000000000", "11111111111111", "22222222222222", "33333333333333", "44444444444444", "55555555555555", "66666666666666", "77777777777777", "88888888888888", "99999999999999"];
  if (invalidCNPJSequences.includes(cnpj) || cnpj.length !== CNPJ_LENGTH) {
    return false;
  }
  let size2 = cnpj.length - 2;
  const digits = cnpj.substring(size2);
  let numbers = cnpj.substring(0, size2);
  let total = 0;
  let pos = size2 - 7;
  for (let i = size2; i >= 1; i--) {
    total += parseInt(numbers.charAt(size2 - i), 10) * pos;
    pos -= 1;
    if (pos < 2) {
      pos = 9;
    }
  }
  let result = total % 11 < 2 ? 0 : 11 - total % 11;
  if (result !== parseInt(digits.charAt(0), 10)) {
    return false;
  }
  size2 += 1;
  numbers = cnpj.substring(0, size2);
  total = 0;
  pos = size2 - 7;
  for (let i = size2; i >= 1; i--) {
    total += parseInt(numbers.charAt(size2 - i), 10) * pos;
    pos -= 1;
    if (pos < 2) {
      pos = 9;
    }
  }
  result = total % 11 < 2 ? 0 : 11 - total % 11;
  if (result !== parseInt(digits.charAt(1), 10)) {
    return false;
  }
  return true;
}
function validateCpfCnpj(cpfCnpj) {
  const cpfCnpjValue = removeNonNumeric(cpfCnpj);
  if (cpfCnpjValue.length === CPF_LENGTH) {
    return validateCpf(cpfCnpjValue);
  }
  if (cpfCnpjValue.length === CNPJ_LENGTH) {
    return validateCnpj(cpfCnpjValue);
  }
  return false;
}

// src/helpers/phone-number.ts
var phone_number_exports = {};
__export(phone_number_exports, {
  validateCellPhone: () => validateCellPhone,
  validateLandline: () => validateLandline,
  validatePhone: () => validatePhone
});
var LANDLINE_LENGTH = 10;
var CELL_PHONE_LENGTH = 11;
var splitAreaCodeAndPhoneNumber = phoneValue => {
  const phone = removeNonNumeric(phoneValue);
  const areaCode = phone.substring(0, 2);
  const phoneNumber = phone.substring(2, phone.length);
  return {
    areaCode,
    phoneNumber
  };
};
var validateAreaCode = phoneValue => {
  const {
    areaCode
  } = splitAreaCodeAndPhoneNumber(phoneValue);
  return parseInt(areaCode, 10) > 10;
};
var validateSize = (phoneValue, size2) => {
  if (!phoneValue) {
    return false;
  }
  const phone = removeNonNumeric(phoneValue);
  return phone.length === size2;
};
function validateLandline(phoneValue) {
  if (!validateSize(phoneValue, LANDLINE_LENGTH)) {
    return false;
  }
  return validateAreaCode(phoneValue);
}
function validateCellPhone(phoneValue) {
  if (!validateSize(phoneValue, CELL_PHONE_LENGTH) || !validateAreaCode(phoneValue)) {
    return false;
  }
  const {
    phoneNumber
  } = splitAreaCodeAndPhoneNumber(phoneValue);
  const firstDigit = phoneNumber[0];
  const cellPhonePrefix = [6, 7, 8, 9];
  return cellPhonePrefix.indexOf(parseInt(firstDigit, 10)) > -1;
}
function validatePhone(phoneValue) {
  if (!phoneValue) {
    return false;
  }
  const phone = removeNonNumeric(phoneValue);
  if (phone.length === LANDLINE_LENGTH) {
    return validateLandline(phone);
  }
  if (phone.length === CELL_PHONE_LENGTH) {
    return validateCellPhone(phone);
  }
  return false;
}

// src/helpers/mfa.ts
var mfa_exports = {};
__export(mfa_exports, {
  validateMFA: () => validateMFA
});
var MFA_LENGTH = 6;
function validateMFA(mfa) {
  if (!mfa) {
    return false;
  }
  const mfaValue = removeNonNumeric(mfa);
  return mfaValue.length === MFA_LENGTH;
}

// src/helpers/email.ts
var email_exports = {};
__export(email_exports, {
  validateEmail: () => validateEmail
});
var EMAIL_REGEX = /^[A-Za-z0-9._%+-]{1,64}@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,63}$/;
function validateEmail(email) {
  if (!email) {
    return false;
  }
  return EMAIL_REGEX.test(email);
}

// src/helpers/month-year.ts
var month_year_exports = {};
__export(month_year_exports, {
  MONTH_YEAR_REGEX_MASK: () => MONTH_YEAR_REGEX_MASK,
  validateMonthYear: () => validateMonthYear
});
var MONTH_YEAR_REGEX = /^(0[1-9]|1[0-2])\/\d{2}$/;
var MONTH_YEAR_REGEX_MASK = MONTH_YEAR_REGEX.toString().replace(/^\//, "").replace(/\/$/, "");
function validateMonthYear(value) {
  if (!value) {
    return false;
  }
  return MONTH_YEAR_REGEX.test(value);
}

// src/internals/mask-config.ts
var MaskAliasEnum = /* @__PURE__ */(MaskAliasEnum2 => {
  MaskAliasEnum2["CPF"] = "cpf";
  MaskAliasEnum2["CNPJ"] = "cnpj";
  MaskAliasEnum2["CPF_CNPJ"] = "cpf-cnpj";
  MaskAliasEnum2["LANDLINE"] = "landline";
  MaskAliasEnum2["CELL_PHONE"] = "cell-phone";
  MaskAliasEnum2["PHONE"] = "phone";
  MaskAliasEnum2["MFA"] = "mfa";
  MaskAliasEnum2["EMAIL"] = "email";
  MaskAliasEnum2["MONTH_YEAR"] = "month-year";
  return MaskAliasEnum2;
})(MaskAliasEnum || {});
var MASK_MAPPING = {
  ["cpf" /* CPF */]: {
    maskConfig: {
      mask: ["999.999.999-99"],
      jitMasking: true,
      keepStatic: true,
      showMaskOnHover: false
    },
    placeholder: "000.000.000-00",
    inputmode: "numeric",
    validator: validateCpf,
    validatorMessage: "Informe um CPF v\xE1lido"
  },
  ["cnpj" /* CNPJ */]: {
    maskConfig: {
      mask: ["99.999.999/9999-99"],
      jitMasking: true,
      keepStatic: true,
      showMaskOnHover: false
    },
    placeholder: "00.000.000/0000-00",
    inputmode: "numeric",
    validator: validateCnpj,
    validatorMessage: "Informe um CNPJ v\xE1lido"
  },
  ["cpf-cnpj" /* CPF_CNPJ */]: {
    maskConfig: {
      mask: ["999.999.999-99", "99.999.999/9999-99"],
      jitMasking: true,
      keepStatic: true,
      showMaskOnHover: false
    },
    placeholder: "000.000.000-00",
    inputmode: "numeric",
    validator: validateCpfCnpj,
    validatorMessage: "Informe um CPF ou um CNPJ v\xE1lido"
  },
  ["landline" /* LANDLINE */]: {
    maskConfig: {
      mask: ["(99) 9999-9999"],
      jitMasking: true,
      keepStatic: true,
      showMaskOnHover: false
    },
    placeholder: "(00) 0000-0000",
    inputmode: "tel",
    validator: validateLandline,
    validatorMessage: "Informe um telefone v\xE1lido"
  },
  ["cell-phone" /* CELL_PHONE */]: {
    maskConfig: {
      mask: ["(99) 99999-9999"],
      jitMasking: true,
      keepStatic: true,
      showMaskOnHover: false
    },
    placeholder: "(00) 00000-0000",
    inputmode: "tel",
    validator: validateCellPhone,
    validatorMessage: "Informe um celular v\xE1lido"
  },
  ["phone" /* PHONE */]: {
    maskConfig: {
      mask: ["(99) 9999-9999", "(99) 99999-9999"],
      jitMasking: true,
      keepStatic: true,
      showMaskOnHover: false
    },
    placeholder: "(00) 0000-0000",
    inputmode: "tel",
    validator: validatePhone,
    validatorMessage: "Informe um telefone ou um celular v\xE1lido"
  },
  ["mfa" /* MFA */]: {
    maskConfig: {
      mask: ["9 - 9 - 9 - 9 - 9 - 9"],
      jitMasking: true,
      keepStatic: true,
      showMaskOnHover: false
    },
    placeholder: "0 - 0 - 0 - 0 - 0 - 0",
    inputmode: "numeric",
    validator: validateMFA,
    validatorMessage: "Informe um c\xF3digo de verifica\xE7\xE3o v\xE1lido"
  },
  ["email" /* EMAIL */]: {
    maskConfig: {
      mask: "*{1,64}[.*{1,64}][.*{1,64}][.*{1,63}]@-{1,63}.-{1,63}[.-{1,63}]{0,8}",
      jitMasking: true,
      showMaskOnHover: false
    },
    placeholder: "",
    inputmode: "email",
    validator: validateEmail,
    validatorMessage: "Informe um email v\xE1lido"
  },
  ["month-year" /* MONTH_YEAR */]: {
    maskConfig: {
      regex: MONTH_YEAR_REGEX_MASK,
      showMaskOnHover: false,
      jitMasking: true
    },
    placeholder: "mm/yy",
    inputmode: "numeric",
    validator: validateMonthYear,
    validatorMessage: "Informe uma data v\xE1lida"
  }
};
function getMaskPlaceholder(maskAlias) {
  return MASK_MAPPING[maskAlias].placeholder;
}
function getMaskInputMode(maskAlias) {
  return MASK_MAPPING[maskAlias].inputmode;
}
function getMaskValidationFunction(maskAlias) {
  return MASK_MAPPING[maskAlias].validator;
}
function getMaskValidatorMessage(maskAlias) {
  return MASK_MAPPING[maskAlias].validatorMessage;
}

// src/vendors/inputmask-utils.ts
var maskConfigMap = Object.values(MaskAliasEnum).reduce((previous, current) => __spreadProps(__spreadValues({}, previous), {
  [current]: MASK_MAPPING[current].maskConfig
}), {});
Inputmask.extendAliases(__spreadValues({
  float: {
    alias: "currency",
    groupSeparator: ".",
    radixPoint: ",",
    rightAlign: false,
    digits: 2,
    digitsOptional: true,
    numericInput: true,
    unmaskAsNumber: true
  },
  onlyNumericDigits: {
    regex: "\\d*",
    showMaskOnHover: false,
    jitMasking: true
  },
  integer: {
    groupSeparator: ".",
    radixPoint: ",",
    rightAlign: false,
    unmaskAsNumber: true,
    shortcuts: null,
    showMaskOnHover: false,
    jitMasking: true
  },
  datepicker: {
    alias: "datetime",
    inputFormat: "dd/mm/yyyy",
    showMaskOnHover: false,
    jitMasking: true
  }
}, maskConfigMap));
var inputmask_utils_default = Inputmask;

// src/internals/validators/card-validator.ts
var CardValidator = class {
  constructor() {
    this.name = "card";
    this.status = "error";
    this.invalidMessage = "";
  }
  getInvalidMessage() {
    return this.invalidMessage;
  }
  validate(element) {
    const elementValue = element.value;
    const cardNumber = removeNonNumeric(elementValue);
    if (cardNumber.length < 6) {
      this.invalidMessage = "Informe um n\xFAmero de cart\xE3o v\xE1lido";
      return false;
    }
    return true;
  }
};

// src/components/form/atlas-card-number/atlas-card-number.ts
var AtlasCardNumber = class extends AtlasInput {
  constructor() {
    super(...arguments);
    this.cardType = "credit";
    this.acceptedBrands = [];
    this.cardBrand = "UNKNOWN" /* UNKNOWN */;
    this._mask = {
      mask: ["9999 9999 9999 9999"],
      jitMasking: true,
      keepStatic: true,
      showMaskOnHover: false
    };
  }
  /** @internal */
  connectedCallback() {
    var _a;
    (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
    this.updateComplete.then(() => {
      this.buildMask();
    });
  }
  onChangeCardBrand() {
    this.setSideImage();
  }
  /**
   * Retorna o valor do campo sem a máscara
   * @returns {string} - O valor do campo sem a máscara
   */
  getUnmaskedValue() {
    return this._maskInstance.unmaskedvalue();
  }
  /**
   * Retorna a bandeira do cartão
   * @returns {CardBrandEnum} - A bandeira do cartão
   */
  getCardBrand() {
    return this.cardBrand;
  }
  buildMask() {
    this.placeholder = this.placeholder || "0000 0000 0000 0000";
    this.inputMode = "numeric";
    this._maskInstance = inputmask_utils_default(__spreadProps(__spreadValues({}, this._mask), {
      onKeyDown: () => {
        if (!this.detectCardBrand) return;
        setTimeout(() => {
          this.cardBrand = detectCardBrand(this._input.value, this.cardType === "debit", this.acceptedBrands);
        }, 100);
      }
    })).mask(this._input);
    this._maskInstance.shadowRoot = this.shadowRoot;
    this.setSideImage();
    this.addValidator(new CardValidator());
  }
  setSideImage() {
    const brandInfo = getCardBrandInfo(this.cardBrand);
    if (!brandInfo) return;
    this._maskInstance.option({
      mask: brandInfo.mask
    });
    this.sideImage = getAssetPath(brandInfo.brandFlag);
  }
};
__decorateClass([property80({
  type: String,
  attribute: "card-type"
})], AtlasCardNumber.prototype, "cardType", 2);
__decorateClass([property80({
  type: Array,
  attribute: "accepted-brands"
})], AtlasCardNumber.prototype, "acceptedBrands", 2);
__decorateClass([property80({
  type: String,
  attribute: "card-brand"
})], AtlasCardNumber.prototype, "cardBrand", 2);
__decorateClass([property80({
  type: Boolean,
  attribute: "detect-card-brand"
})], AtlasCardNumber.prototype, "detectCardBrand", 2);
__decorateClass([Watch("cardBrand", true)], AtlasCardNumber.prototype, "onChangeCardBrand", 1);
AtlasCardNumber = __decorateClass([customElement71("atlas-card-number")], AtlasCardNumber);

// src/components/form/atlas-checkbox/atlas-checkbox.ts
import { html as html79 } from "lit";
import { customElement as customElement72, property as property81, state as state39 } from "lit/decorators.js";
import { classMap as classMap56 } from "lit/directives/class-map.js";
import { ifDefined as ifDefined19 } from "lit/directives/if-defined.js";
import { live as live3 } from "lit/directives/live.js";
import { when as when53 } from "lit/directives/when.js";

// src/components/form/atlas-checkbox/atlas-checkbox.scss
import { css as css69 } from "lit-element/lit-element.js";
var atlas_checkbox_default = css69`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
.btn {
  --atlas-btn-padding-x: 1rem;
  --atlas-btn-padding-y: 0.5rem;
  --atlas-btn-font-size: 1rem;
  --atlas-btn-color: #000000;
  --atlas-btn-bg: transparent;
  --atlas-btn-border-color: transparent;
  --atlas-btn-border-radius: 0.25rem;
  --atlas-btn-hover-border-color: transparent;
  --atlas-btn-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-rgb), 40%);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-300-rgb), 0.25);
  --atlas-btn-min-height: 2.625rem;
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  box-sizing: border-box;
  padding: var(--atlas-btn-padding-y) var(--atlas-btn-padding-x);
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: var(--atlas-btn-font-size);
  font-weight: 400;
  line-height: 1.5;
  color: var(--atlas-btn-color);
  min-height: var(--atlas-btn-min-height);
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border: 1px solid var(--atlas-btn-border-color);
  border-radius: var(--atlas-btn-border-radius);
  background: var(--atlas-btn-bg);
  box-shadow: var(--atlas-btn-box-shadow);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.btn:hover {
  color: var(--atlas-btn-hover-color);
  background-color: var(--atlas-btn-hover-bg);
  border-color: var(--atlas-btn-hover-border-color);
}
.btn:focus-visible {
  color: var(--atlas-btn-color);
  background: var(--atlas-btn-bg);
  border-color: var(--atlas-btn-border-color);
  box-shadow: var(--atlas-btn-focus-box-shadow);
  outline: 0;
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--atlas-btn-disabled-color);
  pointer-events: none;
  background-color: var(--atlas-btn-disabled-bg);
  background-image: none;
  border-color: var(--atlas-btn-disabled-border-color);
  opacity: 0.35;
  box-shadow: none;
}
.btn-check + .btn:hover {
  color: var(--atlas-btn-check-hover-color);
  background-color: var(--atlas-btn-check-hover-bg);
  border-color: var(--atlas-btn-check-hover-border-color);
}
.btn-check:focus-visible + .btn {
  border-color: var(--atlas-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--atlas-btn-focus-box-shadow);
}
.btn-check:checked + .btn {
  color: var(--atlas-btn-checked-color);
  background-color: var(--atlas-btn-checked-bg);
  border-color: var(--atlas-btn-checked-border-color);
}
:not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--atlas-btn-active-color);
  background-color: var(--atlas-btn-active-bg);
  background-image: none;
  border-color: var(--atlas-btn-active-border-color);
  box-shadow: var(--atlas-btn-active-shadow);
}
:not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--atlas-btn-focus-box-shadow);
}
.btn-check:checked + .btn:hover {
  color: var(--atlas-btn-hover-color);
  background-color: var(--atlas-btn-hover-bg);
  border-color: var(--atlas-btn-hover-border-color);
}
.btn atlas-icon {
  font-size: 1.25rem;
}

.btn-sm {
  --atlas-btn-padding-y: 0.25rem;
  --atlas-btn-padding-x: 0.5rem;
  --atlas-btn-font-size: 0.875rem;
  --atlas-btn-border-radius: 0.25rem;
  --atlas-btn-min-height: 1.9375rem;
}
.btn-sm atlas-icon {
  font-size: 1rem;
}

.btn-lg {
  --atlas-btn-padding-y: 0.5rem;
  --atlas-btn-padding-x: 1rem;
  --atlas-btn-font-size: 1.25rem;
  --atlas-btn-border-radius: 0.25rem;
  --atlas-btn-min-height: 3rem;
}
.btn-lg atlas-icon {
  font-size: 1.5rem;
}

.skeleton.btn-sm {
  height: 1.9375rem;
  width: 100px;
}
.skeleton.btn-md {
  height: 2.625rem;
  width: 120px;
}
.skeleton.btn-lg {
  height: 3rem;
  width: 140px;
}

.btn-block {
  width: 100% !important;
}

.rounded-pill {
  border-radius: 9999px;
}

slot[name=hotspot]::slotted(atlas-hotspot) {
  position: absolute;
  top: -20px;
  right: -20px;
}

.btn-primary {
  --atlas-btn-bg: var(--atlas-primary);
  --atlas-btn-color: var(--atlas-contrast-primary);
  --atlas-btn-border-color: var(--atlas-primary);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-primary-600);
  --atlas-btn-hover-border-color: var(--atlas-primary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-primary-700);
  --atlas-btn-active-border-color: var(--atlas-primary-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-primary);
  --atlas-btn-disabled-border-color: var(--atlas-primary);
  --atlas-btn-disabled-bg: var(--atlas-primary);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-primary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-primary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-primary-500);
  --atlas-btn-checked-border-color: var(--atlas-primary-500);
}

.btn-outline-primary {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-primary);
  --atlas-btn-border-color: var(--atlas-primary);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-primary-600);
  --atlas-btn-hover-border-color: var(--atlas-primary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-primary-700);
  --atlas-btn-active-border-color: var(--atlas-primary-700);
  --atlas-btn-disabled-color: var(--atlas-primary);
  --atlas-btn-disabled-bg: var(--atlas-primary-100);
  --atlas-btn-disabled-border-color: var(--atlas-primary);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-primary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-primary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-primary-500);
  --atlas-btn-checked-border-color: var(--atlas-primary-500);
}

.btn-ghost-primary {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-primary);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-primary-600);
  --atlas-btn-hover-border-color: var(--atlas-primary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-primary-700);
  --atlas-btn-active-border-color: var(--atlas-primary-700);
  --atlas-btn-disabled-color: var(--atlas-primary);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-primary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-primary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-primary-500);
  --atlas-btn-checked-border-color: var(--atlas-primary-500);
}

.btn-primary-white {
  --atlas-btn-bg: #f8f9fa;
  --atlas-btn-color: var(--atlas-primary);
  --atlas-btn-border-color: #f8f9fa;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-primary);
  --atlas-btn-hover-bg: rgb(198.4, 199.2, 200);
  --atlas-btn-hover-border-color: rgb(198.4, 199.2, 200);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(#f8f9fa, 0.25);
  --atlas-btn-active-color: var(--atlas-primary);
  --atlas-btn-active-bg: rgb(148.8, 149.4, 150);
  --atlas-btn-active-border-color: rgb(148.8, 149.4, 150);
  --atlas-btn-disabled-color: var(--atlas-primary);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-disabled-bg: #f8f9fa;
  --atlas-btn-check-hover-color: none;
  --atlas-btn-check-hover-bg: none;
  --atlas-btn-check-hover-border-color: none;
  --atlas-btn-checked-color: none;
  --atlas-btn-checked-bg: none;
  --atlas-btn-checked-border-color: none;
}

.btn-outline-primary-white {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: #f8f9fa;
  --atlas-btn-border-color: #f8f9fa;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-primary);
  --atlas-btn-hover-bg: rgb(198.4, 199.2, 200);
  --atlas-btn-hover-border-color: rgb(198.4, 199.2, 200);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(#f8f9fa, 0.25);
  --atlas-btn-active-color: var(--atlas-primary);
  --atlas-btn-active-bg: rgb(148.8, 149.4, 150);
  --atlas-btn-active-border-color: rgb(148.8, 149.4, 150);
  --atlas-btn-disabled-color: var(--atlas-primary);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-disabled-bg: #f8f9fa;
  --atlas-btn-check-hover-color: none;
  --atlas-btn-check-hover-bg: none;
  --atlas-btn-check-hover-border-color: none;
  --atlas-btn-checked-color: none;
  --atlas-btn-checked-bg: none;
  --atlas-btn-checked-border-color: none;
}

.btn-secondary {
  --atlas-btn-bg: var(--atlas-secondary);
  --atlas-btn-color: var(--atlas-contrast-secondary);
  --atlas-btn-border-color: var(--atlas-secondary);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-secondary);
  --atlas-btn-hover-bg: var(--atlas-secondary-600);
  --atlas-btn-hover-border-color: var(--atlas-secondary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-secondary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-secondary);
  --atlas-btn-active-bg: var(--atlas-secondary-700);
  --atlas-btn-active-border-color: var(--atlas-secondary-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-secondary);
  --atlas-btn-disabled-border-color: var(--atlas-secondary);
  --atlas-btn-disabled-bg: var(--atlas-secondary);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-secondary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-secondary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-secondary-500);
  --atlas-btn-checked-border-color: var(--atlas-secondary-500);
}

.btn-outline-secondary {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-secondary);
  --atlas-btn-border-color: var(--atlas-secondary);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-secondary-600);
  --atlas-btn-hover-border-color: var(--atlas-secondary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-secondary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-secondary-700);
  --atlas-btn-active-border-color: var(--atlas-secondary-700);
  --atlas-btn-disabled-color: var(--atlas-secondary);
  --atlas-btn-disabled-bg: var(--atlas-secondary-100);
  --atlas-btn-disabled-border-color: var(--atlas-secondary);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-secondary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-secondary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-secondary-500);
  --atlas-btn-checked-border-color: var(--atlas-secondary-500);
}

.btn-ghost-secondary {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-secondary);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-secondary-600);
  --atlas-btn-hover-border-color: var(--atlas-secondary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-secondary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-secondary-700);
  --atlas-btn-active-border-color: var(--atlas-secondary-700);
  --atlas-btn-disabled-color: var(--atlas-secondary);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-secondary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-secondary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-secondary-500);
  --atlas-btn-checked-border-color: var(--atlas-secondary-500);
}

.btn-success {
  --atlas-btn-bg: var(--atlas-success);
  --atlas-btn-color: var(--atlas-contrast-success);
  --atlas-btn-border-color: var(--atlas-success);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-success);
  --atlas-btn-hover-bg: var(--atlas-success-600);
  --atlas-btn-hover-border-color: var(--atlas-success-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-success);
  --atlas-btn-active-bg: var(--atlas-success-700);
  --atlas-btn-active-border-color: var(--atlas-success-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-success);
  --atlas-btn-disabled-border-color: var(--atlas-success);
  --atlas-btn-disabled-bg: var(--atlas-success);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-success-400);
  --atlas-btn-check-hover-border-color: var(--atlas-success-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-success-500);
  --atlas-btn-checked-border-color: var(--atlas-success-500);
}

.btn-outline-success {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-success);
  --atlas-btn-border-color: var(--atlas-success);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-success-600);
  --atlas-btn-hover-border-color: var(--atlas-success-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-success-700);
  --atlas-btn-active-border-color: var(--atlas-success-700);
  --atlas-btn-disabled-color: var(--atlas-success);
  --atlas-btn-disabled-bg: var(--atlas-success-100);
  --atlas-btn-disabled-border-color: var(--atlas-success);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-success-400);
  --atlas-btn-check-hover-border-color: var(--atlas-success-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-success-500);
  --atlas-btn-checked-border-color: var(--atlas-success-500);
}

.btn-ghost-success {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-success);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-success-600);
  --atlas-btn-hover-border-color: var(--atlas-success-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-success-700);
  --atlas-btn-active-border-color: var(--atlas-success-700);
  --atlas-btn-disabled-color: var(--atlas-success);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-success-400);
  --atlas-btn-check-hover-border-color: var(--atlas-success-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-success-500);
  --atlas-btn-checked-border-color: var(--atlas-success-500);
}

.btn-warning {
  --atlas-btn-bg: var(--atlas-warning);
  --atlas-btn-color: var(--atlas-contrast-warning);
  --atlas-btn-border-color: var(--atlas-warning);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-warning);
  --atlas-btn-hover-bg: var(--atlas-warning-600);
  --atlas-btn-hover-border-color: var(--atlas-warning-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-warning);
  --atlas-btn-active-bg: var(--atlas-warning-700);
  --atlas-btn-active-border-color: var(--atlas-warning-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-warning);
  --atlas-btn-disabled-border-color: var(--atlas-warning);
  --atlas-btn-disabled-bg: var(--atlas-warning);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-warning-400);
  --atlas-btn-check-hover-border-color: var(--atlas-warning-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-warning-500);
  --atlas-btn-checked-border-color: var(--atlas-warning-500);
}

.btn-outline-warning {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-warning);
  --atlas-btn-border-color: var(--atlas-warning);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-warning-600);
  --atlas-btn-hover-border-color: var(--atlas-warning-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-warning-700);
  --atlas-btn-active-border-color: var(--atlas-warning-700);
  --atlas-btn-disabled-color: var(--atlas-warning);
  --atlas-btn-disabled-bg: var(--atlas-warning-100);
  --atlas-btn-disabled-border-color: var(--atlas-warning);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-warning-400);
  --atlas-btn-check-hover-border-color: var(--atlas-warning-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-warning-500);
  --atlas-btn-checked-border-color: var(--atlas-warning-500);
}

.btn-ghost-warning {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-warning);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-warning-600);
  --atlas-btn-hover-border-color: var(--atlas-warning-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-warning-700);
  --atlas-btn-active-border-color: var(--atlas-warning-700);
  --atlas-btn-disabled-color: var(--atlas-warning);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-warning-400);
  --atlas-btn-check-hover-border-color: var(--atlas-warning-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-warning-500);
  --atlas-btn-checked-border-color: var(--atlas-warning-500);
}

.btn-danger {
  --atlas-btn-bg: var(--atlas-danger);
  --atlas-btn-color: var(--atlas-contrast-danger);
  --atlas-btn-border-color: var(--atlas-danger);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-danger);
  --atlas-btn-hover-bg: var(--atlas-danger-600);
  --atlas-btn-hover-border-color: var(--atlas-danger-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-danger);
  --atlas-btn-active-bg: var(--atlas-danger-700);
  --atlas-btn-active-border-color: var(--atlas-danger-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-danger);
  --atlas-btn-disabled-border-color: var(--atlas-danger);
  --atlas-btn-disabled-bg: var(--atlas-danger);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-danger-400);
  --atlas-btn-check-hover-border-color: var(--atlas-danger-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-danger-500);
  --atlas-btn-checked-border-color: var(--atlas-danger-500);
}

.btn-outline-danger {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-danger);
  --atlas-btn-border-color: var(--atlas-danger);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-danger-600);
  --atlas-btn-hover-border-color: var(--atlas-danger-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-danger-700);
  --atlas-btn-active-border-color: var(--atlas-danger-700);
  --atlas-btn-disabled-color: var(--atlas-danger);
  --atlas-btn-disabled-bg: var(--atlas-danger-100);
  --atlas-btn-disabled-border-color: var(--atlas-danger);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-danger-400);
  --atlas-btn-check-hover-border-color: var(--atlas-danger-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-danger-500);
  --atlas-btn-checked-border-color: var(--atlas-danger-500);
}

.btn-ghost-danger {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-danger);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-danger-600);
  --atlas-btn-hover-border-color: var(--atlas-danger-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-danger-700);
  --atlas-btn-active-border-color: var(--atlas-danger-700);
  --atlas-btn-disabled-color: var(--atlas-danger);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-danger-400);
  --atlas-btn-check-hover-border-color: var(--atlas-danger-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-danger-500);
  --atlas-btn-checked-border-color: var(--atlas-danger-500);
}

.btn-highlight {
  --atlas-btn-bg: var(--atlas-highlight);
  --atlas-btn-color: var(--atlas-contrast-highlight);
  --atlas-btn-border-color: var(--atlas-highlight);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-highlight);
  --atlas-btn-hover-bg: var(--atlas-highlight-600);
  --atlas-btn-hover-border-color: var(--atlas-highlight-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-highlight-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-highlight);
  --atlas-btn-active-bg: var(--atlas-highlight-700);
  --atlas-btn-active-border-color: var(--atlas-highlight-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-highlight);
  --atlas-btn-disabled-border-color: var(--atlas-highlight);
  --atlas-btn-disabled-bg: var(--atlas-highlight);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-highlight-400);
  --atlas-btn-check-hover-border-color: var(--atlas-highlight-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-highlight-500);
  --atlas-btn-checked-border-color: var(--atlas-highlight-500);
}

.btn-outline-highlight {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-highlight);
  --atlas-btn-border-color: var(--atlas-highlight);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-highlight-600);
  --atlas-btn-hover-border-color: var(--atlas-highlight-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-highlight-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-highlight-700);
  --atlas-btn-active-border-color: var(--atlas-highlight-700);
  --atlas-btn-disabled-color: var(--atlas-highlight);
  --atlas-btn-disabled-bg: var(--atlas-highlight-100);
  --atlas-btn-disabled-border-color: var(--atlas-highlight);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-highlight-400);
  --atlas-btn-check-hover-border-color: var(--atlas-highlight-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-highlight-500);
  --atlas-btn-checked-border-color: var(--atlas-highlight-500);
}

.btn-ghost-highlight {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-highlight);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-highlight-600);
  --atlas-btn-hover-border-color: var(--atlas-highlight-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-highlight-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-highlight-700);
  --atlas-btn-active-border-color: var(--atlas-highlight-700);
  --atlas-btn-disabled-color: var(--atlas-highlight);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-highlight-400);
  --atlas-btn-check-hover-border-color: var(--atlas-highlight-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-highlight-500);
  --atlas-btn-checked-border-color: var(--atlas-highlight-500);
}

.btn-info {
  --atlas-btn-bg: var(--atlas-info);
  --atlas-btn-color: var(--atlas-contrast-info);
  --atlas-btn-border-color: var(--atlas-info);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-info);
  --atlas-btn-hover-bg: var(--atlas-info-600);
  --atlas-btn-hover-border-color: var(--atlas-info-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-info-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-info);
  --atlas-btn-active-bg: var(--atlas-info-700);
  --atlas-btn-active-border-color: var(--atlas-info-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-info);
  --atlas-btn-disabled-border-color: var(--atlas-info);
  --atlas-btn-disabled-bg: var(--atlas-info);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-info-400);
  --atlas-btn-check-hover-border-color: var(--atlas-info-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-info-500);
  --atlas-btn-checked-border-color: var(--atlas-info-500);
}

.btn-outline-info {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-info);
  --atlas-btn-border-color: var(--atlas-info);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-info-600);
  --atlas-btn-hover-border-color: var(--atlas-info-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-info-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-info-700);
  --atlas-btn-active-border-color: var(--atlas-info-700);
  --atlas-btn-disabled-color: var(--atlas-info);
  --atlas-btn-disabled-bg: var(--atlas-info-100);
  --atlas-btn-disabled-border-color: var(--atlas-info);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-info-400);
  --atlas-btn-check-hover-border-color: var(--atlas-info-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-info-500);
  --atlas-btn-checked-border-color: var(--atlas-info-500);
}

.btn-ghost-info {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-info);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-info-600);
  --atlas-btn-hover-border-color: var(--atlas-info-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-info-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-info-700);
  --atlas-btn-active-border-color: var(--atlas-info-700);
  --atlas-btn-disabled-color: var(--atlas-info);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-info-400);
  --atlas-btn-check-hover-border-color: var(--atlas-info-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-info-500);
  --atlas-btn-checked-border-color: var(--atlas-info-500);
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
.form-check-label {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  color: #212529;
  cursor: pointer;
}

.form-check-input {
  --atlas-form-check-bg: #ffffff;
  width: 1.25rem;
  height: 1.25rem;
  margin-top: 0;
  vertical-align: top;
  appearance: none;
  background-color: var(--atlas-form-check-bg);
  background-image: var(--atlas-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid #ced4da;
  print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25rem;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: var(--atlas-primary-200);
  outline: 0;
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-500-rgb), 0.25);
}
.form-check-input:checked {
  background-color: var(--atlas-primary);
  border-color: var(--atlas-primary);
}
.form-check-input:checked[type=checkbox] {
  --atlas-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M16.2448 5.6674L7.46524 15.4628L3.78516 11.6991L5.21517 10.3008L7.40175 12.5371L14.7555 4.33252L16.2448 5.6674Z' fill='%23ffffff'/%3e%3c/svg%3e");
}
.form-check-input:checked[type=radio] {
  --atlas-form-check-bg-image: url("data:image/svg+xml,%3csvg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle stroke='white' stroke-width='3.5' cx='10' cy='10' r='8' /%3e%3c/svg%3e");
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: var(--atlas-primary);
  border-color: var(--atlas-primary);
  --atlas-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e");
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.35;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  color: #687078;
}
.form-check-input.form-check-input-expired {
  background-color: #dc3545;
  border-color: #dc3545;
  opacity: 0.35;
  pointer-events: none;
}
.form-check-input.form-check-input-expired ~ .form-check-label {
  color: #dc3545;
}

.form-check {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  padding: 0;
  min-height: 1.5rem;
}
.form-check .form-check-input {
  float: left;
  cursor: pointer;
  margin: 0;
  flex-shrink: 0;
}
.form-check.form-check-expired {
  pointer-events: none;
}
.form-check:not(.has-label) .form-check-label {
  display: none;
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
.status-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.8rem;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}

.is-info ~ .status-feedback {
  display: block;
}

.status-info {
  color: var(--atlas-secondary);
}

.is-success {
  border-color: var(--atlas-success) !important;
}
.is-success:focus, .is-success:focus-visible, .is-success.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
  border-color: var(--atlas-success);
}
.is-success ~ .status-feedback {
  display: block;
}
.is-success ~ .form-check-label {
  color: var(--atlas-success);
}
.is-success .focus-mark {
  background: var(--atlas-success-300);
}
.is-success.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-success) !important;
  background-color: rgba(var(--atlas-success-rgb), 2%);
}
.is-success.rating-buttons-group .rating-button {
  border-color: var(--atlas-success) !important;
  color: var(--atlas-success) !important;
}
.is-success.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-success-400) !important;
  color: #ffffff !important;
}
.is-success.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
}
.is-success.rating-buttons-group .rating-button:active:not(:disabled), .is-success.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-success) !important;
  color: #ffffff !important;
}

.form-check:has(.is-success) .form-check-label {
  color: var(--atlas-success);
}
.form-check:has(.is-success) .form-check-input:checked {
  background-color: var(--atlas-success);
}

.status-success {
  color: var(--atlas-success);
}

.is-warning {
  border-color: var(--atlas-warning) !important;
}
.is-warning:focus, .is-warning:focus-visible, .is-warning.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
  border-color: var(--atlas-warning);
}
.is-warning ~ .status-feedback {
  display: block;
}
.is-warning ~ .form-check-label {
  color: var(--atlas-warning);
}
.is-warning .focus-mark {
  background: var(--atlas-warning-300);
}
.is-warning.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-warning) !important;
  background-color: rgba(var(--atlas-warning-rgb), 2%);
}
.is-warning.rating-buttons-group .rating-button {
  border-color: var(--atlas-warning) !important;
  color: var(--atlas-warning) !important;
}
.is-warning.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-warning-400) !important;
  color: #ffffff !important;
}
.is-warning.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
}
.is-warning.rating-buttons-group .rating-button:active:not(:disabled), .is-warning.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-warning) !important;
  color: #ffffff !important;
}

.form-check:has(.is-warning) .form-check-label {
  color: var(--atlas-warning);
}
.form-check:has(.is-warning) .form-check-input:checked {
  background-color: var(--atlas-warning);
}

.status-warning {
  color: var(--atlas-warning);
}

.is-error {
  border-color: var(--atlas-danger) !important;
}
.is-error:focus, .is-error:focus-visible, .is-error.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
  border-color: var(--atlas-danger);
}
.is-error ~ .status-feedback {
  display: block;
}
.is-error ~ .form-check-label {
  color: var(--atlas-danger);
}
.is-error .focus-mark {
  background: var(--atlas-danger-300);
}
.is-error.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-danger) !important;
  background-color: rgba(var(--atlas-danger-rgb), 2%);
}
.is-error.rating-buttons-group .rating-button {
  border-color: var(--atlas-danger) !important;
  color: var(--atlas-danger) !important;
}
.is-error.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-danger-400) !important;
  color: #ffffff !important;
}
.is-error.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
}
.is-error.rating-buttons-group .rating-button:active:not(:disabled), .is-error.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-danger) !important;
  color: #ffffff !important;
}

.form-check:has(.is-error) .form-check-label {
  color: var(--atlas-danger);
}
.form-check:has(.is-error) .form-check-input:checked {
  background-color: var(--atlas-danger);
}

.status-error {
  color: var(--atlas-danger);
}

:host {
  display: inline-block;
  outline: none;
}

:host([button-style]),
.block {
  width: 100%;
}
@media screen and (min-width: 992px) {
  :host([button-style]),
  .block {
    width: auto;
  }
}

.btn {
  gap: 10px;
  padding: 8px 24px;
  min-height: auto;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.35;
}
.btn-check:focus + .btn {
  outline: 0;
  box-shadow: var(--atlas-btn-focus-box-shadow);
  border-color: var(--atlas-btn-hover-border-color);
}`;

// src/components/form/atlas-checkbox/atlas-checkbox.ts
var AtlasCheckbox = /*#__PURE__*/(() => {
  let AtlasCheckbox = class extends WithTooltipMixin(FormElement) {
    constructor() {
      super(...arguments);
      this.icon = "";
      this.checked = false;
      this.indeterminate = false;
      this.expired = false;
      this.buttonStyle = false;
      this._hasSlottedLabel = false;
    }
    onChangeChecked() {
      const eventObject = {
        detail: {
          elementId: this.id,
          elementName: this.name,
          elementValue: this.value,
          checked: this.checked,
          trackDisable: true
        }
      };
      emit(this, `atlas-checkbox-${this.checked ? "check" : "uncheck"}`, eventObject);
      emit(this, "atlas-checkbox-change", eventObject);
      emit(this, "atlas-form-element-touch", {
        trackDisable: true
      });
    }
    /**
     * Obtém o valor do elemento (se estiver marcado) ou uma string vazia.
     * Se o checkbox for indeterminado, retorna "indeterminate"
     * @returns {string} O valor do elemento ou uma string vazia ou "indeterminate" (se o checkbox for indeterminado)
     * @override
     */
    getElementValue() {
      if (this.indeterminate) {
        return "indeterminate";
      }
      return this.checked ? this.value : "";
    }
    /**
     * Define o foco no checkbox
     */
    focus() {
      this.shadowRoot.querySelector(".form-check-input, .btn-check").focus();
    }
    /**
     * Marca o checkbox
     */
    check() {
      this.checked = true;
      this.indeterminate = false;
    }
    /**
     * Desmarca o checkbox
     */
    uncheck() {
      this.checked = false;
      this.indeterminate = false;
    }
    /**
     * Alterna o estado de marcação do checkbox
     * @param checked - Indica se o checkbox deve ser marcado ou desmarcado, caso não seja definido, o estado atual será invertido
     */
    toggleChecked(checked) {
      if (typeof checked === "boolean") {
        this.checked = checked;
      } else {
        this.checked = !this.checked;
      }
    }
    changeChecked() {
      this.checked = !this.checked;
      this.onChange();
    }
    onLabelChange() {
      const slottedNodes = this.shadowRoot.querySelector("slot").assignedNodes({
        flatten: true
      });
      const filteredNodes = filterEmptyNodes(slottedNodes);
      this._hasSlottedLabel = filteredNodes.length > 0;
    }
    renderIcon() {
      return when53(this.buttonStyle && this.icon, () => html79`<atlas-icon size="3x" name="${this.icon}"></atlas-icon>`);
    }
    render() {
      const checkContainerClass = {
        "form-check": !this.buttonStyle,
        "form-check-disabled": this.disabled,
        "has-label": this._hasSlottedLabel,
        "block": this.buttonStyle,
        "form-check-expired": this.expired
      };
      const formCheckClass = {
        "form-check-input": !this.buttonStyle,
        "form-check-input-expired": this.expired,
        "btn-check": this.buttonStyle,
        [`is-${this._status}`]: this.getShowStatus()
      };
      const labelClass = {
        "form-check-label": !this.buttonStyle,
        "btn": this.buttonStyle,
        "btn-outline-primary": this.buttonStyle,
        "btn-outline-danger": this.buttonStyle && this.getShowStatus() && this._status === "error",
        "btn-outline-warning": this.buttonStyle && this.getShowStatus() && this._status === "warning",
        "btn-outline-success": this.buttonStyle && this.getShowStatus() && this._status === "success",
        "rounded-pill": this.buttonStyle,
        "block": this.buttonStyle
      };
      return html79`
            <div class="${classMap56(checkContainerClass)}" data-atlas-tooltip="checkbox-tooltip">
                <input
                    class="${classMap56(formCheckClass)}"
                    type="checkbox"
                    id="${this.id || "checkbox_id"}"
                    name="${this.name}"
                    .value=${ifDefined19(this.value ? this.value : void 0)}
                    .checked=${live3(this.checked)}
                    .indeterminate=${live3(this.indeterminate)}
                    ?required=${this.required}
                    ?disabled=${this.disabled}
                    aria-checked=${this.checked ? "true" : "false"}
                    aria-labelledby="${this.id}"
                    aria-disabled="${this.disabled}"
                    aria-required="${this.required}"
                    @change="${this.changeChecked}"
                />
                <label class=${classMap56(labelClass)} for="${this.id || "checkbox_id"}">
                    ${this.renderIcon()}
                    <slot @slotchange=${this.onLabelChange}></slot>
                </label>
            </div>
            ${this.renderTooltip("checkbox-tooltip")}
        `;
    }
  };
  AtlasCheckbox.styles = atlas_checkbox_default;
  return AtlasCheckbox;
})();
__decorateClass([property81({
  type: String
})], AtlasCheckbox.prototype, "icon", 2);
__decorateClass([property81({
  type: Boolean,
  reflect: true
})], AtlasCheckbox.prototype, "checked", 2);
__decorateClass([property81({
  type: Boolean,
  reflect: true
})], AtlasCheckbox.prototype, "indeterminate", 2);
__decorateClass([property81({
  type: Boolean,
  reflect: true
})], AtlasCheckbox.prototype, "expired", 2);
__decorateClass([property81({
  type: Boolean,
  attribute: "button-style"
})], AtlasCheckbox.prototype, "buttonStyle", 2);
__decorateClass([state39()], AtlasCheckbox.prototype, "_hasSlottedLabel", 2);
__decorateClass([Watch("checked", true)], AtlasCheckbox.prototype, "onChangeChecked", 1);
AtlasCheckbox = __decorateClass([customElement72("atlas-checkbox")], AtlasCheckbox);

// src/components/form/atlas-date-picker/atlas-date-picker.ts
import { html as html80 } from "lit";
import { customElement as customElement73, property as property82, query as query14, state as state40 } from "lit/decorators.js";
import { classMap as classMap57 } from "lit/directives/class-map.js";
import { when as when54 } from "lit/directives/when.js";
import VanillaCalendar from "vanilla-calendar-pro";
import { autoUpdate as autoUpdate2, computePosition as computePosition2, flip as flip2, offset as offset3, shift as shift2 } from "@floating-ui/dom";

// src/internals/date-utils.ts
var NUMBER_OF_DAYS_IN_WEEK = 7;
function isYearMonthDay(date) {
  return /^\d{4}-\d{2}-\d{2}$/.test(date);
}
function stripTime(date) {
  const dateObj = new Date(date);
  dateObj.setHours(0, 0, 0, 0);
  return dateObj;
}
function getTodayDate() {
  return stripTime(Date.now());
}
function getDateFromString(date) {
  const isYearMonthDayFormat = isYearMonthDay(date);
  const dateParts = date.split(isYearMonthDayFormat ? "-" : "/");
  const day = parseInt(isYearMonthDayFormat ? dateParts[2] : dateParts[0], 10);
  const month = parseInt(dateParts[1], 10) - 1;
  const year = parseInt(isYearMonthDayFormat ? dateParts[0] : dateParts[2], 10);
  const dateObj = new Date(year, month, day);
  return stripTime(dateObj);
}
function getWeekday(date) {
  const parsedDate = typeof date === "string" ? getDateFromString(date) : stripTime(date);
  const weekday = parsedDate.getDay();
  return weekday;
}
function parseDate(date) {
  if (date instanceof Date || typeof date === "number") {
    return stripTime(date);
  }
  if (!date) {
    return void 0;
  }
  return getDateFromString(date);
}
function formatDate(date, options) {
  if (!date) return "";
  const parsedDate = parseDate(date);
  const day = parsedDate.getDate();
  const dayString = day.toString().padStart(2, "0");
  const month = parsedDate.getMonth() + 1;
  const monthString = month.toString().padStart(2, "0");
  let year = parsedDate.getFullYear();
  let yearString = year.toString();
  if (options == null ? void 0 : options.yearLastDigits) {
    year = year % 100;
    yearString = year.toString().padStart(2, "0");
  }
  return `${dayString}/${monthString}/${yearString}`;
}
function formatDateToYearMonthDay(date) {
  if (!date) return "";
  const parsedDate = parseDate(date);
  const day = parsedDate.getDate();
  const month = parsedDate.getMonth() + 1;
  const year = parsedDate.getFullYear();
  return `${year}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
}

// src/internals/validators/date-validator.ts
var DateValidator = class {
  constructor() {
    this.name = "date";
    this.status = "error";
    this.errorType = "none";
  }
  getInvalidMessage() {
    const messageMap = {
      min: () => `A data informada n\xE3o deve ser menor que ${this.formatDate(this.minDate)}`,
      max: () => `A data informada n\xE3o deve ser maior que ${this.formatDate(this.maxDate)}`,
      both: () => `Informe uma data entre ${this.formatDate(this.minDate)} e ${this.formatDate(this.maxDate)}`,
      format: () => "Formato de data inv\xE1lido, utilize o formato DD/MM/AAAA",
      prevented: () => this.preventedDatesErrorMessage || "Esta data n\xE3o pode ser selecionada"
    };
    return this.errorType === "none" ? "" : messageMap[this.errorType]();
  }
  validate(element) {
    const value = element.getElementValue();
    if (!value) return true;
    if (value.length < 10) {
      this.errorType = "format";
      return false;
    }
    this.updateMinAndMax(element);
    this.errorType = "none";
    const valueAsTime = DatepickerExtended.parseDate(value, DatepickerExtended.dateFormat);
    if (this.isPreventedDate(element) || this.isPreventedWeekday(element)) {
      this.errorType = "prevented";
      this.preventedDatesErrorMessage = element.preventedDatesErrorMessage;
    } else if (this.minDate && valueAsTime < this.minDate.getTime()) {
      this.errorType = this.maxDate ? "both" : "min";
    } else if (this.maxDate && valueAsTime > this.maxDate.getTime()) {
      this.errorType = this.minDate ? "both" : "max";
    }
    return this.errorType === "none";
  }
  updateMinAndMax(element) {
    const preventPastDate = element.preventPastDate;
    const minDate = element.minDate;
    this.minDate = DatepickerExtended.getDatepickerMinDate(preventPastDate, minDate);
    if (this.minDate) {
      this.minDate.setHours(0, 0, 0, 0);
    }
    const preventLaterDate = element.preventLaterDate;
    const maxDate = element.maxDate;
    this.maxDate = DatepickerExtended.getDatepickerMaxDate(preventLaterDate, maxDate);
    if (this.maxDate) {
      this.maxDate.setHours(23, 59, 59, 999);
    }
  }
  formatDate(date) {
    return DatepickerExtended.formatDate(date, DatepickerExtended.dateFormat);
  }
  isPreventedDate(element) {
    if (isEmptyValue(element.preventDates)) return false;
    const elementValue = element.getElementValue();
    if (!elementValue) return false;
    return element.preventDates.includes(elementValue);
  }
  isPreventedWeekday(element) {
    if (isEmptyValue(element.preventWeekdays) && !element.preventWeekends) return false;
    const elementValue = element.getElementValue();
    if (!elementValue) return false;
    const preventWeekdays = new Set(element.preventWeekdays);
    if (element.preventWeekends) {
      preventWeekdays.add(0 /* SUNDAY */);
      preventWeekdays.add(6 /* SATURDAY */);
    }
    const weekday = getWeekday(elementValue);
    return preventWeekdays.has(weekday);
  }
};

// src/components/form/atlas-date-picker/atlas-date-picker.scss
import { css as css70 } from "lit-element/lit-element.js";
var atlas_date_picker_default = css70`/* stylelint-disable selector-class-pattern */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Z-index mapping for the floating elements */
/*! name: vanilla-calendar-pro v2.9.10 | url: https://github.com/uvarov-frontend/vanilla-calendar-pro */
.vanilla-calendar {
  position: relative;
  box-sizing: border-box;
  display: flex;
  width: 300px;
  min-width: 272px;
  max-width: 100%;
  flex-direction: column;
  border-radius: 0.75rem;
  padding: 1rem;
  opacity: 1;
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 0.15s;
}

@supports ((width: -webkit-max-content) or (width: max-content)) and ((height: -webkit-max-content) or (height: max-content)) {
  .vanilla-calendar {
    height: -webkit-max-content;
    height: max-content;
    width: -webkit-max-content;
    width: max-content;
  }
}
.vanilla-calendar_multiple {
  width: 550px;
}

@supports (width: -webkit-fit-content) or (width: -moz-fit-content) or (width: fit-content) {
  .vanilla-calendar_multiple {
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
  }
}
.vanilla-calendar button:focus-visible {
  border-radius: 0.5rem;
  outline-style: solid;
  outline-width: 1px;
  outline-offset: -1px;
}

.vanilla-calendar.vanilla-calendar_multiple .vanilla-calendar-days {
  flex-grow: 0;
}

.vanilla-calendar_hidden {
  pointer-events: none;
  opacity: 0;
}

.vanilla-calendar_hidden * {
  pointer-events: none !important;
}

.vanilla-calendar_to-input {
  position: absolute;
}

.vanilla-calendar_to-input_bottom {
  margin-top: 0.25rem;
}

.vanilla-calendar_to-input_top {
  margin-top: -0.25rem;
}

.vanilla-calendar-controls {
  pointer-events: none;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  z-index: 20;
  box-sizing: content-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 1.25rem;
}

.vanilla-calendar-arrow {
  pointer-events: auto;
  position: relative;
  display: block;
  height: 1.5rem;
  width: 1.5rem;
  cursor: pointer;
  border-width: 0px;
  background-color: transparent;
}

.vanilla-calendar-arrow:before {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  --tw-content: "";
  content: var(--tw-content);
}

.vanilla-calendar-arrow.vanilla-calendar-arrow_prev:before {
  transform: rotate(90deg);
}

.vanilla-calendar-arrow.vanilla-calendar-arrow_next:before {
  transform: rotate(-90deg);
}

.vanilla-calendar-grid {
  display: flex;
  flex-grow: 1;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.75rem;
}

.vanilla-calendar-grid.vanilla-calendar-grid_disabled .vanilla-calendar-column {
  pointer-events: none;
  opacity: 0.3;
}

.vanilla-calendar-grid.vanilla-calendar-grid_disabled .vanilla-calendar-column.vanilla-calendar-column_month, .vanilla-calendar-grid.vanilla-calendar-grid_disabled .vanilla-calendar-column.vanilla-calendar-column_year {
  pointer-events: auto;
  opacity: 1;
}

.vanilla-calendar-column {
  display: flex;
  min-width: -webkit-min-content;
  min-width: min-content;
  flex-direction: column;
}

.vanilla-calendar-header {
  position: relative;
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
}

.vanilla-calendar-header__content {
  display: grid;
  flex-grow: 1;
  grid-auto-columns: -webkit-max-content;
  grid-auto-columns: max-content;
  grid-auto-flow: column;
  align-items: center;
  justify-content: center;
  white-space: pre-wrap;
  padding-left: 1rem;
  padding-right: 1rem;
}

.vanilla-calendar-month, .vanilla-calendar-year {
  cursor: pointer;
  border-radius: 0.25rem;
  border-width: 0px;
  background-color: transparent;
  padding: 0.25rem;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 700;
}

.vanilla-calendar-month.vanilla-calendar-month_disabled, .vanilla-calendar-year.vanilla-calendar-year_disabled {
  pointer-events: none;
}

.vanilla-calendar-months {
  display: grid;
  flex-grow: 1;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  align-items: center;
  row-gap: 1rem;
  column-gap: 0.5rem;
}

.vanilla-calendar-years {
  display: grid;
  flex-grow: 1;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  align-items: center;
  row-gap: 1rem;
  column-gap: 0.5rem;
}

.vanilla-calendar-months_selecting .vanilla-calendar-months__month, .vanilla-calendar-years_selecting .vanilla-calendar-years__year {
  cursor: pointer;
}

.vanilla-calendar-months_selecting .vanilla-calendar-months__month .vanilla-calendar-months__month_disabled, .vanilla-calendar-years_selecting .vanilla-calendar-years__year .vanilla-calendar-years__year_disabled {
  cursor: default;
}

.vanilla-calendar-months__month, .vanilla-calendar-years__year {
  display: flex;
  height: 2.5rem;
  align-items: center;
  justify-content: center;
  word-break: break-all;
  border-radius: 0.5rem;
  border-width: 0px;
  padding: 0.25rem;
  text-align: center;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 600;
}

.vanilla-calendar-months__month.vanilla-calendar-months__month_disabled, .vanilla-calendar-years__year.vanilla-calendar-years__year_disabled {
  pointer-events: none;
}

.vanilla-calendar-week-numbers {
  display: flex;
  flex-direction: column;
}

.vanilla-calendar-week-numbers__title {
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 700;
}

.vanilla-calendar-week-numbers__content {
  display: grid;
  grid-auto-flow: row;
  align-items: center;
  justify-items: center;
  row-gap: 0.25rem;
}

.vanilla-calendar-week-number {
  margin: 0;
  display: flex;
  min-height: 1.875rem;
  width: 100%;
  min-width: 1.875rem;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-style: none;
  background-color: transparent;
  padding: 0;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 600;
}

.vanilla-calendar-wrapper {
  display: flex;
  flex-grow: 1;
}

.vanilla-calendar-content {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}

.vanilla-calendar-week {
  margin-bottom: 0.5rem;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  justify-items: center;
}

.vanilla-calendar-week__day {
  display: flex;
  width: 100%;
  min-width: 1.875rem;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 700;
}

.vanilla-calendar-days {
  display: grid;
  flex-grow: 1;
  grid-template-columns: repeat(7, 1fr);
  align-items: center;
  justify-items: center;
  row-gap: 0.25rem;
}

.vanilla-calendar-days_selecting .vanilla-calendar-day__btn {
  cursor: pointer;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 75ms;
}

.vanilla-calendar-days_selecting .vanilla-calendar-day__btn_disabled {
  cursor: default;
}

.vanilla-calendar-day {
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.vanilla-calendar-day_hover-intermediate .vanilla-calendar-day__btn {
  border-radius: 0;
}

.vanilla-calendar-day_hover-first .vanilla-calendar-day__btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}

.vanilla-calendar-day_hover-last .vanilla-calendar-day__btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

.vanilla-calendar-day_hover-first.vanilla-calendar-day_hover-last .vanilla-calendar-day__btn {
  border-radius: 0.5rem;
}

.vanilla-calendar-day:focus-visible .vanilla-calendar-day__popup, .vanilla-calendar-day:hover .vanilla-calendar-day__popup {
  pointer-events: auto;
  opacity: 1;
}

.vanilla-calendar-day_selected-first .vanilla-calendar-day__btn_selected {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}

.vanilla-calendar-day_selected-last .vanilla-calendar-day__btn_selected {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

.vanilla-calendar-day_selected-first.vanilla-calendar-day_selected-last .vanilla-calendar-day__btn_selected {
  border-radius: 0.5rem;
}

.vanilla-calendar-day_selected-intermediate .vanilla-calendar-day__btn_selected {
  border-radius: 0;
}

.vanilla-calendar-day__btn {
  display: flex;
  height: 100%;
  min-height: 1.875rem;
  width: 100%;
  min-width: 1.875rem;
  cursor: default;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  border-width: 0px;
  padding: 0;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 400;
}

.vanilla-calendar-day__btn_today {
  font-weight: 700;
}

.vanilla-calendar-day__btn_disabled {
  pointer-events: none;
}

.vanilla-calendar-day__popup {
  transform: translate(-50%);
  pointer-events: none;
  position: absolute;
  left: 50%;
  top: 100%;
  z-index: 20;
  width: 8rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 400;
  opacity: 0;
}

.vanilla-calendar-day__popup:before {
  content: var(--tw-content);
  position: absolute;
}

.vanilla-calendar-day__popup:after {
  content: var(--tw-content);
  position: absolute;
}

.vanilla-calendar-day__popup:hover {
  pointer-events: auto;
  opacity: 1;
}

.vanilla-calendar-day__popup:before {
  content: "";
  left: 0;
  bottom: 0;
  z-index: -10;
  display: block;
  height: calc(100% - 4px);
  width: 100%;
  border-radius: 0.5rem;
}

.vanilla-calendar-time {
  margin-top: 0.75rem;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.75rem;
  border-top-width: 1px;
  border-bottom-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-style: solid;
  padding-top: 0.75rem;
}

.vanilla-calendar-time__content {
  display: grid;
  grid-auto-flow: column;
  align-items: center;
}

.vanilla-calendar-time__hours {
  position: relative;
  margin-right: 0.35rem;
  width: 1.75rem;
}

.vanilla-calendar-time__hours:after {
  position: absolute;
  right: -5px;
  top: 50%;
  margin-top: calc(-50% + 1px);
  display: block;
  --tw-content: ":";
  content: var(--tw-content);
}

.vanilla-calendar-time__minutes {
  width: 1.75rem;
}

.vanilla-calendar-time__hours input, .vanilla-calendar-time__minutes input {
  position: relative;
  margin: 0;
  box-sizing: border-box;
  display: block;
  width: 100%;
  border-radius: 0.25rem;
  border-width: 0px;
  padding: 0.125rem;
  text-align: center;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.125rem;
}

.vanilla-calendar-time__hours input:focus-visible, .vanilla-calendar-time__minutes input:focus-visible {
  outline-style: solid;
  outline-width: 1px;
}

.vanilla-calendar-time__hours input:disabled, .vanilla-calendar-time__minutes input:disabled {
  cursor: default;
}

.vanilla-calendar-time__hours input:hover:disabled, .vanilla-calendar-time__minutes input:hover:disabled {
  background-color: transparent;
}

.vanilla-calendar-time__keeping {
  margin-left: 1px;
  margin-top: 0.25rem;
  width: 22px;
  cursor: pointer;
  border-radius: 0.25rem;
  border-width: 0px;
  background-color: transparent;
  padding: 0;
  font-size: 0.69rem;
}

.vanilla-calendar-time__keeping:focus-visible {
  outline-style: solid;
  outline-width: 1px;
}

.vanilla-calendar-time__keeping:disabled {
  cursor: default;
}

.vanilla-calendar-time__keeping:hover:disabled {
  background-color: transparent;
}

.vanilla-calendar-time__ranges {
  display: grid;
  grid-auto-flow: row;
}

.vanilla-calendar-time__range {
  position: relative;
  z-index: 10;
  font-size: 0;
}

.vanilla-calendar-time__range:before {
  content: var(--tw-content);
  left: 0;
}

.vanilla-calendar-time__range:after {
  content: var(--tw-content);
  right: 0;
}

.vanilla-calendar-time__range:before, .vanilla-calendar-time__range:after {
  content: "";
  transform: translateY(-50%);
  pointer-events: none;
  position: absolute;
  top: 50%;
  z-index: 10;
  height: 0.5rem;
  width: 1px;
}

.vanilla-calendar-time__range input {
  position: relative;
  margin: 0;
  height: 1.25rem;
  width: 100%;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
  outline-width: 0px;
}

.vanilla-calendar-time__range input::-webkit-slider-thumb {
  position: relative;
  z-index: 20;
  margin-top: -0.5rem;
  box-sizing: border-box;
  height: 1rem;
  width: 0.75rem;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
  border-radius: 0.25rem;
  border-width: 1px;
  border-style: solid;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.vanilla-calendar-time__range input::-moz-range-thumb {
  position: relative;
  z-index: 20;
  box-sizing: border-box;
  height: 1rem;
  width: 0.75rem;
  cursor: pointer;
  border-radius: 0.25rem;
  border-width: 1px;
  border-style: solid;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.vanilla-calendar-time__range input::-webkit-slider-runnable-track {
  margin-top: 1px;
  box-sizing: border-box;
  height: 1px;
  width: 100%;
  cursor: pointer;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.vanilla-calendar-time__range input::-moz-range-track {
  margin-top: 1px;
  box-sizing: border-box;
  height: 1px;
  width: 100%;
  cursor: pointer;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

@font-face {
  font-family: "Atlas-Icons";
  src: url("fonts/Atlas-Icons.eot?ku8bqy");
  src: url("fonts/Atlas-Icons.eot?ku8bqy#iefix") format("embedded-opentype"), url("fonts/Atlas-Icons.ttf?ku8bqy") format("truetype"), url("fonts/Atlas-Icons.woff?ku8bqy") format("woff"), url("fonts/Atlas-Icons.svg?ku8bqy#Atlas-Icons") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
.atlas-icon {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "Atlas-Icons" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.ati-address-book:before {
  content: "\\e905";
}

.ati-alert:before {
  content: "\\e96f";
}

.ati-alert-circle:before {
  content: "\\e902";
}

.ati-alert-triangle:before {
  content: "\\e904";
}

.ati-align-justify:before {
  content: "\\e906";
}

.ati-apps:before {
  content: "\\e907";
}

.ati-arrow-down:before {
  content: "\\e90c";
}

.ati-arrow-down-circle:before {
  content: "\\e90d";
}

.ati-arrow-left:before {
  content: "\\e910";
}

.ati-arrow-right:before {
  content: "\\e912";
}

.ati-arrow-right-left:before {
  content: "\\e908";
}

.ati-arrow-up:before {
  content: "\\e914";
}

.ati-arrow-up-circle:before {
  content: "\\e93f";
}

.ati-arrow-up-right:before {
  content: "\\e909";
}

.ati-asaas-logo:before {
  content: "\\e90a";
}

.ati-backspace:before {
  content: "\\e970";
}

.ati-banco-do-brasil:before {
  content: "\\e976";
}

.ati-bank:before {
  content: "\\e932";
}

.ati-bar-chart:before {
  content: "\\e91b";
}

.ati-barcode:before {
  content: "\\e921";
}

.ati-bars:before {
  content: "\\e998";
}

.ati-base-logo:before {
  content: "\\e93e";
}

.ati-bell:before {
  content: "\\e91e";
}

.ati-box:before {
  content: "\\e923";
}

.ati-briefcase:before {
  content: "\\e926";
}

.ati-caixa:before {
  content: "\\e977";
}

.ati-calendar:before {
  content: "\\e93b";
}

.ati-calendar-sync:before {
  content: "\\e96d";
}

.ati-camera:before {
  content: "\\e90b";
}

.ati-card:before {
  content: "\\e951";
}

.ati-card-mastercard:before {
  content: "\\e953";
}

.ati-celebrate:before {
  content: "\\e948";
}

.ati-check:before {
  content: "\\e92b";
}

.ati-check-circle:before {
  content: "\\e92c";
}

.ati-check-filled:before {
  content: "\\e95d";
}

.ati-chevron-down:before {
  content: "\\e92e";
}

.ati-chevron-left:before {
  content: "\\e92f";
}

.ati-chevron-right:before {
  content: "\\e930";
}

.ati-chevron-up:before {
  content: "\\e931";
}

.ati-circle:before {
  content: "\\e937";
}

.ati-clock:before {
  content: "\\e939";
}

.ati-clock-filled:before {
  content: "\\e95e";
}

.ati-cog:before {
  content: "\\e9cf";
}

.ati-concentric-circles:before {
  content: "\\e93a";
}

.ati-contactless:before {
  content: "\\e959";
}

.ati-copy:before {
  content: "\\e947";
}

.ati-corner-up-right:before {
  content: "\\e94f";
}

.ati-credisis:before {
  content: "\\e978";
}

.ati-dashboard:before {
  content: "\\e90e";
}

.ati-dollar-sign:before {
  content: "\\e957";
}

.ati-dollar-zap:before {
  content: "\\e903";
}

.ati-double-check:before {
  content: "\\e971";
}

.ati-download:before {
  content: "\\e958";
}

.ati-envelope:before {
  content: "\\e992";
}

.ati-eye:before {
  content: "\\e95f";
}

.ati-eye-filled:before {
  content: "\\e966";
}

.ati-eye-off:before {
  content: "\\e960";
}

.ati-facebook:before {
  content: "\\e943";
}

.ati-file:before {
  content: "\\e965";
}

.ati-file-check:before {
  content: "\\e96c";
}

.ati-file-dollar:before {
  content: "\\e901";
}

.ati-file-text:before {
  content: "\\e968";
}

.ati-file-users:before {
  content: "\\e96b";
}

.ati-files:before {
  content: "\\e90f";
}

.ati-filter:before {
  content: "\\e96a";
}

.ati-flapp-store-logo:before {
  content: "\\e96e";
}

.ati-flash:before {
  content: "\\e973";
}

.ati-gift:before {
  content: "\\e92d";
}

.ati-github:before {
  content: "\\e94a";
}

.ati-globe:before {
  content: "\\e94d";
}

.ati-hammer:before {
  content: "\\e974";
}

.ati-hand-card:before {
  content: "\\e952";
}

.ati-hand-holding-money:before {
  content: "\\e946";
}

.ati-hand-shake:before {
  content: "\\e911";
}

.ati-help-circle:before {
  content: "\\e97e";
}

.ati-hierarchy:before {
  content: "\\e945";
}

.ati-home:before {
  content: "\\e938";
}

.ati-id-card:before {
  content: "\\e933";
}

.ati-info:before {
  content: "\\e983";
}

.ati-instagram:before {
  content: "\\e984";
}

.ati-inter:before {
  content: "\\e979";
}

.ati-invoice:before {
  content: "\\e900";
}

.ati-itau:before {
  content: "\\e97a";
}

.ati-key:before {
  content: "\\e913";
}

.ati-keyboard:before {
  content: "\\ea1a";
}

.ati-link:before {
  content: "\\e98a";
}

.ati-linkedin:before {
  content: "\\e944";
}

.ati-list:before {
  content: "\\e98d";
}

.ati-loader:before {
  content: "\\e934";
}

.ati-lock:before {
  content: "\\e98f";
}

.ati-lock-filled:before {
  content: "\\e963";
}

.ati-log-in:before {
  content: "\\e990";
}

.ati-magnifier:before {
  content: "\\e9cc";
}

.ati-mail-box:before {
  content: "\\e915";
}

.ati-map-pin:before {
  content: "\\e954";
}

.ati-market-pin:before {
  content: "\\e97d";
}

.ati-maximize:before {
  content: "\\e967";
}

.ati-megaphone:before {
  content: "\\e936";
}

.ati-message-circle:before {
  content: "\\e999";
}

.ati-mic:before {
  content: "\\e97f";
}

.ati-minus:before {
  content: "\\e99f";
}

.ati-minus-circle:before {
  content: "\\e9a0";
}

.ati-money:before {
  content: "\\e916";
}

.ati-money-filled:before {
  content: "\\e961";
}

.ati-money-notes:before {
  content: "\\e949";
}

.ati-monitor:before {
  content: "\\e9a2";
}

.ati-monitor-chart-up:before {
  content: "\\e924";
}

.ati-moon:before {
  content: "\\e94e";
}

.ati-nubank:before {
  content: "\\e97b";
}

.ati-open-finance:before {
  content: "\\e91c";
}

.ati-paperclip:before {
  content: "\\e9ad";
}

.ati-pencil:before {
  content: "\\e95c";
}

.ati-phone:before {
  content: "\\e9b2";
}

.ati-pix:before {
  content: "\\e922";
}

.ati-plus:before {
  content: "\\e9bc";
}

.ati-plus-circle:before {
  content: "\\e9bd";
}

.ati-power:before {
  content: "\\e9c0";
}

.ati-printer:before {
  content: "\\e9c1";
}

.ati-receipt:before {
  content: "\\e975";
}

.ati-refresh:before {
  content: "\\e9c3";
}

.ati-refresh-dollar:before {
  content: "\\e917";
}

.ati-repeat:before {
  content: "\\e929";
}

.ati-rotate:before {
  content: "\\e9c8";
}

.ati-rotate-dollar:before {
  content: "\\e918";
}

.ati-santander:before {
  content: "\\e97c";
}

.ati-send:before {
  content: "\\e9cd";
}

.ati-serasa:before {
  content: "\\e919";
}

.ati-share:before {
  content: "\\e941";
}

.ati-shield:before {
  content: "\\e91a";
}

.ati-shopping-bag:before {
  content: "\\e95a";
}

.ati-shopping-cart-down:before {
  content: "\\e925";
}

.ati-shopping-cart-right:before {
  content: "\\e969";
}

.ati-slash:before {
  content: "\\e9db";
}

.ati-sliders:before {
  content: "\\e9dc";
}

.ati-smartphone:before {
  content: "\\e9dd";
}

.ati-smartphone-contactless:before {
  content: "\\e972";
}

.ati-sort:before {
  content: "\\e935";
}

.ati-spanner:before {
  content: "\\e927";
}

.ati-split-arrows:before {
  content: "\\e93d";
}

.ati-square:before {
  content: "\\e9e0";
}

.ati-square-signs:before {
  content: "\\e91d";
}

.ati-star:before {
  content: "\\e940";
}

.ati-star-filled:before {
  content: "\\e964";
}

.ati-sun:before {
  content: "\\e950";
}

.ati-tag:before {
  content: "\\e9e7";
}

.ati-three-dots:before {
  content: "\\e9a5";
}

.ati-three-dots-horinzontal:before {
  content: "\\e93c";
}

.ati-thumbs-down:before {
  content: "\\e94c";
}

.ati-thumbs-up:before {
  content: "\\e94b";
}

.ati-ticket:before {
  content: "\\e956";
}

.ati-trash:before {
  content: "\\e9f1";
}

.ati-truck:before {
  content: "\\e9f6";
}

.ati-unlink:before {
  content: "\\e980";
}

.ati-unlock:before {
  content: "\\e955";
}

.ati-upload:before {
  content: "\\e9fe";
}

.ati-user:before {
  content: "\\ea00";
}

.ati-user-filled:before {
  content: "\\e95b";
}

.ati-user-plus:before {
  content: "\\ea03";
}

.ati-users:before {
  content: "\\ea05";
}

.ati-video:before {
  content: "\\e92a";
}

.ati-virtual-card:before {
  content: "\\e91f";
}

.ati-wallet:before {
  content: "\\e920";
}

.ati-whatsapp:before {
  content: "\\e928";
}

.ati-x:before {
  content: "\\ea11";
}

.ati-x-filled:before {
  content: "\\e962";
}

.ati-youtube:before {
  content: "\\e942";
}

/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

/* Transitions */
.fade {
  transition: opacity 0.25s ease;
}
.fade:not(.show) {
  opacity: 0;
}

.fade-and-scale {
  opacity: 0;
  transform: scale(0.7);
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.fade-and-scale.scale-vertically {
  transform: scale(1, 0.7);
}
.fade-and-scale.show {
  opacity: 1;
  transform: scale(1);
}

:host([data-popper-placement=top]),
:host([data-popper-placement=top]) .fade-and-scale,
div[data-popper-placement=top].fade-and-scale,
div[data-popper-placement=top] > .fade-and-scale,
.fade-and-scale.scale-top {
  transform-origin: center bottom;
}

:host([data-popper-placement=top-start]),
:host([data-popper-placement=top-start]) .fade-and-scale,
div[data-popper-placement=top-start].fade-and-scale,
div[data-popper-placement=top-start] > .fade-and-scale,
.fade-and-scale.scale-top-start {
  transform-origin: left bottom;
}

:host([data-popper-placement=top-end]),
:host([data-popper-placement=top-end]) .fade-and-scale,
div[data-popper-placement=top-end].fade-and-scale,
div[data-popper-placement=top-end] > .fade-and-scale,
.fade-and-scale.scale-top-end {
  transform-origin: right bottom;
}

:host([data-popper-placement=bottom]),
:host([data-popper-placement=bottom]) .fade-and-scale,
div[data-popper-placement=bottom].fade-and-scale,
div[data-popper-placement=bottom] > .fade-and-scale,
.fade-and-scale.scale-bottom {
  transform-origin: center top;
}

:host([data-popper-placement=bottom-start]),
:host([data-popper-placement=bottom-start]) .fade-and-scale,
div[data-popper-placement=bottom-start].fade-and-scale,
div[data-popper-placement=bottom-start] > .fade-and-scale,
.fade-and-scale.scale-bottom-start {
  transform-origin: left top;
}

:host([data-popper-placement=bottom-end]),
:host([data-popper-placement=bottom-end]) .fade-and-scale,
div[data-popper-placement=bottom-end].fade-and-scale,
div[data-popper-placement=bottom-end] > .fade-and-scale,
.fade-and-scale.scale-bottom-end {
  transform-origin: right top;
}

:host([data-popper-placement=left]),
:host([data-popper-placement=left]) .fade-and-scale,
div[data-popper-placement=left].fade-and-scale,
div[data-popper-placement=left] > .fade-and-scale,
.fade-and-scale.scale-left {
  transform-origin: right center;
}

:host([data-popper-placement=left-start]),
:host([data-popper-placement=left-start]) .fade-and-scale,
div[data-popper-placement=left-start].fade-and-scale,
div[data-popper-placement=left-start] > .fade-and-scale,
.fade-and-scale.scale-left-start {
  transform-origin: right top;
}

:host([data-popper-placement=left-end]),
:host([data-popper-placement=left-end]) .fade-and-scale,
div[data-popper-placement=left-end].fade-and-scale,
div[data-popper-placement=left-end] > .fade-and-scale,
.fade-and-scale.scale-left-end {
  transform-origin: right bottom;
}

:host([data-popper-placement=right]),
:host([data-popper-placement=right]) .fade-and-scale,
div[data-popper-placement=right].fade-and-scale,
div[data-popper-placement=right] > .fade-and-scale,
.fade-and-scale.scale-right {
  transform-origin: left center;
}

:host([data-popper-placement=right-start]),
:host([data-popper-placement=right-start]) .fade-and-scale,
div[data-popper-placement=right-start].fade-and-scale,
div[data-popper-placement=right-start] > .fade-and-scale,
.fade-and-scale.scale-right-start {
  transform-origin: left top;
}

:host([data-popper-placement=right-end]),
:host([data-popper-placement=right-end]) .fade-and-scale,
div[data-popper-placement=right-end].fade-and-scale,
div[data-popper-placement=right-end] > .fade-and-scale,
.fade-and-scale.scale-right-end {
  transform-origin: left bottom;
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Z-index mapping for the floating elements */
/* Shadows */
/* Elevations */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.form-label {
  margin-bottom: 0.5rem;
  font-style: normal;
  box-sizing: border-box;
  display: inline-block;
}
.form-label-optional {
  color: #687078;
}
.form-label atlas-icon-button {
  top: 2px;
}
.form-label[skeleton-loading] {
  min-width: 40%;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Z-index mapping for the floating elements */
/* Shadows */
/* Elevations */
.form-control {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #1a1e21;
  appearance: none;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  cursor: text;
}
.form-control > .form-control-input {
  border: none;
  appearance: none;
  background-color: transparent;
  margin: 0;
  padding: 0;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #1a1e21;
  width: 100%;
  cursor: text;
}
.form-control > .form-control-input:focus, .form-control > .form-control-input:focus-visible {
  outline: none;
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control.form-control-multiple {
  display: flex;
  flex-flow: row wrap;
  gap: 0.5rem;
  overflow-y: overlay;
  max-height: 200px;
  cursor: text;
}
.form-control.form-control-multiple > .form-control-input {
  flex-grow: 1;
  min-width: 100px;
  width: 1%;
}
.form-control .form-control-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
.form-control .form-control-sm > .form-control-input {
  font-size: 0.875rem;
}
.form-control .form-control-lg {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
}
.form-control .form-control-lg > .form-control-input {
  font-size: 1.25rem;
}
.form-control:focus, .form-control:focus-within {
  color: #1a1e21;
  background-color: #ffffff;
  border-color: var(--atlas-primary-300);
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-300-rgb), 0.25);
  outline: 0;
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder,
.form-control > .form-control-input::placeholder {
  color: #687078;
  opacity: 1;
}
.form-control:disabled, .form-control:has(.form-control-input:disabled) {
  background-color: #e9ecef;
  opacity: 1;
}
.form-control.hide-placeholder::placeholder,
.form-control.hide-placeholder > .form-control-input::placeholder {
  color: transparent;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
  /* stylelint-disable no-descending-specificity */
  /* stylelint-enable no-descending-specificity */
}
.input-group atlas-button {
  position: relative;
  z-index: 2;
}
.input-group atlas-button:focus {
  z-index: 5;
}
.input-group .input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.input-group .input-group-text.input-group-prefix {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group .input-group-text.input-group-suffix {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group .form-control {
  border-radius: 0.25rem !important;
  box-sizing: border-box;
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group .form-control.has-icon {
  padding-right: 1.75rem;
}
.input-group .form-control.has-right-element, .input-group .form-control.has-action-button {
  border-bottom-right-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
.input-group .form-control.has-left-element {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}
.input-group .form-control .input-icon,
.input-group .form-control ~ .input-icon {
  position: absolute;
  right: 0.75rem;
  top: 0.815rem;
  z-index: 5;
  pointer-events: none;
}
.input-group .form-control .input-icon.has-click,
.input-group .form-control ~ .input-icon.has-click {
  cursor: pointer;
  pointer-events: all;
}
.input-group .form-control .side-image,
.input-group .form-control ~ .side-image {
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  height: 1.75rem;
  z-index: 5;
  pointer-events: none;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus {
  z-index: 5;
}
.input-group .form-control-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
.input-group .form-control-sm.has-icon {
  padding-right: 1.5rem;
}
.input-group .form-control-sm > .form-control-input {
  font-size: 0.875rem;
}
.input-group .form-control-sm .input-icon,
.input-group .form-control-sm ~ .input-icon {
  right: 0.5rem;
  top: 0.5rem;
}
.input-group .form-control-sm .side-image,
.input-group .form-control-sm ~ .side-image {
  right: 0.5rem;
  top: 0.25rem;
  height: 1.5rem;
}
.input-group .form-control-lg {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
}
.input-group .form-control-lg > .form-control-input {
  font-size: 1.25rem;
}
.input-group .form-control-lg.has-icon {
  padding-right: 2rem;
}
.input-group .form-control-lg .input-icon,
.input-group .form-control-lg ~ .input-icon {
  right: 1rem;
  top: 1rem;
}
.input-group .form-control-lg .side-image,
.input-group .form-control-lg ~ .side-image {
  right: 1rem;
  top: 0.5rem;
  height: 2rem;
}
.input-group:has(.form-control-sm) .input-group-text {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
.input-group:has(.form-control-lg) .input-group-text {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
}
.input-group:has(atlas-button.action-button-position-left) .input-group-text {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}
.input-group:has(atlas-button.action-button-position-right) .input-group-text {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
.input-group > :not(:first-child):not(.invalid-feedback) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group.skeleton * {
  visibility: hidden;
}
.input-group.skeleton + atlas-button {
  display: none;
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
.status-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.8rem;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}

.is-info ~ .status-feedback {
  display: block;
}

.status-info {
  color: var(--atlas-secondary);
}

.is-success {
  border-color: var(--atlas-success) !important;
}
.is-success:focus, .is-success:focus-visible, .is-success.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
  border-color: var(--atlas-success);
}
.is-success ~ .status-feedback {
  display: block;
}
.is-success ~ .form-check-label {
  color: var(--atlas-success);
}
.is-success .focus-mark {
  background: var(--atlas-success-300);
}
.is-success.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-success) !important;
  background-color: rgba(var(--atlas-success-rgb), 2%);
}
.is-success.rating-buttons-group .rating-button {
  border-color: var(--atlas-success) !important;
  color: var(--atlas-success) !important;
}
.is-success.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-success-400) !important;
  color: #ffffff !important;
}
.is-success.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
}
.is-success.rating-buttons-group .rating-button:active:not(:disabled), .is-success.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-success) !important;
  color: #ffffff !important;
}

.form-check:has(.is-success) .form-check-label {
  color: var(--atlas-success);
}
.form-check:has(.is-success) .form-check-input:checked {
  background-color: var(--atlas-success);
}

.status-success {
  color: var(--atlas-success);
}

.is-warning {
  border-color: var(--atlas-warning) !important;
}
.is-warning:focus, .is-warning:focus-visible, .is-warning.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
  border-color: var(--atlas-warning);
}
.is-warning ~ .status-feedback {
  display: block;
}
.is-warning ~ .form-check-label {
  color: var(--atlas-warning);
}
.is-warning .focus-mark {
  background: var(--atlas-warning-300);
}
.is-warning.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-warning) !important;
  background-color: rgba(var(--atlas-warning-rgb), 2%);
}
.is-warning.rating-buttons-group .rating-button {
  border-color: var(--atlas-warning) !important;
  color: var(--atlas-warning) !important;
}
.is-warning.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-warning-400) !important;
  color: #ffffff !important;
}
.is-warning.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
}
.is-warning.rating-buttons-group .rating-button:active:not(:disabled), .is-warning.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-warning) !important;
  color: #ffffff !important;
}

.form-check:has(.is-warning) .form-check-label {
  color: var(--atlas-warning);
}
.form-check:has(.is-warning) .form-check-input:checked {
  background-color: var(--atlas-warning);
}

.status-warning {
  color: var(--atlas-warning);
}

.is-error {
  border-color: var(--atlas-danger) !important;
}
.is-error:focus, .is-error:focus-visible, .is-error.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
  border-color: var(--atlas-danger);
}
.is-error ~ .status-feedback {
  display: block;
}
.is-error ~ .form-check-label {
  color: var(--atlas-danger);
}
.is-error .focus-mark {
  background: var(--atlas-danger-300);
}
.is-error.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-danger) !important;
  background-color: rgba(var(--atlas-danger-rgb), 2%);
}
.is-error.rating-buttons-group .rating-button {
  border-color: var(--atlas-danger) !important;
  color: var(--atlas-danger) !important;
}
.is-error.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-danger-400) !important;
  color: #ffffff !important;
}
.is-error.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
}
.is-error.rating-buttons-group .rating-button:active:not(:disabled), .is-error.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-danger) !important;
  color: #ffffff !important;
}

.form-check:has(.is-error) .form-check-label {
  color: var(--atlas-danger);
}
.form-check:has(.is-error) .form-check-input:checked {
  background-color: var(--atlas-danger);
}

.status-error {
  color: var(--atlas-danger);
}

/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host([width=full]) {
  width: 100%;
}

:host([width=xs]) {
  width: 96px;
}

:host([width=sm]) {
  width: 152px;
}

:host([width=md]) {
  width: 264px;
}

:host([width=lg]) {
  width: 380px;
}

:host {
  outline: none;
  display: block;
}

:host([skeleton-loading]) {
  display: block;
}

:host(.one-time-code-input) input {
  text-align: center;
}
:host(.one-time-code-input) input:focus::placeholder {
  opacity: 0;
}

:host(.atlas-select-input[readonly]) .form-control,
:host(.atlas-select-input[readonly]) .form-control input,
:host(.atlas-multiselect-input[readonly]) .form-control,
:host(.atlas-multiselect-input[readonly]) .form-control input {
  cursor: pointer;
}

:host(.atlas-select-input[disabled]) .form-control,
:host(.atlas-select-input[disabled]) .form-control input,
:host(.atlas-multiselect-input[disabled]) .form-control,
:host(.atlas-multiselect-input[disabled]) .form-control input {
  cursor: default;
}

:host(.atlas-select-input) atlas-icon.input-icon,
:host(.atlas-multiselect-input) atlas-icon.input-icon {
  transition: transform 0.35s ease;
}

:host(.atlas-select-input:not(.collapsed)) atlas-icon[name=chevron-down],
:host(.atlas-multiselect-input:not(.collapsed)) atlas-icon[name=chevron-down] {
  transform: rotate(-180deg);
}

:host(.atlas-multiselect-input.has-tag) .form-control {
  padding-left: 200px;
}

:host([type=hidden]) {
  display: none !important;
}

.form-label.skeleton {
  height: 1.5rem;
  width: 50%;
}

.form-control.skeleton {
  width: 100%;
  min-height: calc(1.5em + 14px);
}

.helper-text.skeleton {
  height: 1.25rem;
  width: 100%;
  margin-top: 0.25rem;
}

.input-wrapper {
  display: flex;
  width: 100%;
}

@media screen and (min-width: 992px) {
  :host(.atlas-multiselect-input.has-tag) .form-control {
    padding-left: 190px;
  }
}
:host {
  box-sizing: border-box;
  position: relative;
}

.calendar-backdrop {
  width: 100vw;
  height: 100vh;
  background: rgba(var(--atlas-dark-rgb), 40%);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  visibility: hidden;
}
.calendar-backdrop.show {
  visibility: visible;
}

.vanilla-calendar {
  position: fixed;
  border-radius: 0.5rem;
  border: 1px solid #ced4da;
  padding: 1rem;
  width: 314px;
  z-index: 1000;
  background: #ffffff;
  inset: 0;
  margin: auto;
}
.vanilla-calendar:not(.show) {
  pointer-events: none;
}

.vanilla-calendar-header {
  margin-bottom: 1rem;
  height: 24px;
}
.vanilla-calendar-header .vanilla-calendar-header__content {
  gap: 0.75rem;
  padding: 0;
}
.vanilla-calendar-header .vanilla-calendar-arrow {
  width: 24px;
  height: 24px;
  font-size: 24px;
  padding: 0;
  line-height: normal;
  color: #687078;
  border-radius: 50%;
  transition: all 0.15s ease;
}
.vanilla-calendar-header .vanilla-calendar-arrow:hover {
  background: var(--atlas-secondary-100);
}
.vanilla-calendar-header .vanilla-calendar-arrow:active {
  background: var(--atlas-primary-100);
  color: var(--atlas-primary);
}
.vanilla-calendar-header .vanilla-calendar-month,
.vanilla-calendar-header .vanilla-calendar-year {
  border: 0;
  padding: 0;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  transition: all 0.15s ease;
}
.vanilla-calendar-header .vanilla-calendar-month:hover,
.vanilla-calendar-header .vanilla-calendar-year:hover {
  color: var(--atlas-primary);
}

.vanilla-calendar-content .vanilla-calendar-week {
  margin-bottom: 0.75rem;
}
.vanilla-calendar-content .vanilla-calendar-week .vanilla-calendar-week__day {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--atlas-primary);
  width: 40px;
  box-sizing: border-box;
  padding: 0 0.25rem;
}
.vanilla-calendar-content .vanilla-calendar-days {
  row-gap: 0;
  flex-grow: 0;
}

.vanilla-calendar-day {
  width: 40px;
  height: 40px;
  box-sizing: border-box;
  padding: 0.25rem;
}

.vanilla-calendar-day__btn,
.vanilla-calendar-months__month,
.vanilla-calendar-years__year {
  box-sizing: border-box;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background: #ffffff;
  border-radius: 50%;
  transition: all 0.15s ease;
}
.vanilla-calendar-day__btn.vanilla-calendar-months__month, .vanilla-calendar-day__btn.vanilla-calendar-years__year,
.vanilla-calendar-months__month.vanilla-calendar-months__month,
.vanilla-calendar-months__month.vanilla-calendar-years__year,
.vanilla-calendar-years__year.vanilla-calendar-months__month,
.vanilla-calendar-years__year.vanilla-calendar-years__year {
  width: 54px;
  height: 54px;
}
.vanilla-calendar-day__btn.vanilla-calendar-day__btn_disabled, .vanilla-calendar-day__btn.vanilla-calendar-months__month_disabled, .vanilla-calendar-day__btn.vanilla-calendar-years__year_disabled,
.vanilla-calendar-months__month.vanilla-calendar-day__btn_disabled,
.vanilla-calendar-months__month.vanilla-calendar-months__month_disabled,
.vanilla-calendar-months__month.vanilla-calendar-years__year_disabled,
.vanilla-calendar-years__year.vanilla-calendar-day__btn_disabled,
.vanilla-calendar-years__year.vanilla-calendar-months__month_disabled,
.vanilla-calendar-years__year.vanilla-calendar-years__year_disabled {
  opacity: 0.35;
}
.vanilla-calendar-day__btn:hover,
.vanilla-calendar-months__month:hover,
.vanilla-calendar-years__year:hover {
  background: var(--atlas-primary-100);
}
.vanilla-calendar-day__btn.vanilla-calendar-day__btn_selected, .vanilla-calendar-day__btn.vanilla-calendar-months__month_selected, .vanilla-calendar-day__btn.vanilla-calendar-years__year_selected,
.vanilla-calendar-months__month.vanilla-calendar-day__btn_selected,
.vanilla-calendar-months__month.vanilla-calendar-months__month_selected,
.vanilla-calendar-months__month.vanilla-calendar-years__year_selected,
.vanilla-calendar-years__year.vanilla-calendar-day__btn_selected,
.vanilla-calendar-years__year.vanilla-calendar-months__month_selected,
.vanilla-calendar-years__year.vanilla-calendar-years__year_selected {
  background: var(--atlas-primary);
  color: #ffffff;
  font-weight: 700;
}
.vanilla-calendar-day__btn.vanilla-calendar-day__btn_today,
.vanilla-calendar-months__month.vanilla-calendar-day__btn_today,
.vanilla-calendar-years__year.vanilla-calendar-day__btn_today {
  border: 1px solid var(--atlas-primary);
}

.vanilla-calendar-footer {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1rem;
}

@media screen and (min-width: 992px) {
  .vanilla-calendar {
    inset: unset;
    margin: unset;
  }
  .vanilla-calendar-footer {
    display: none;
  }
}
/* stylelint-enable selector-class-pattern */`;

// src/components/form/atlas-date-picker/atlas-date-picker.ts
var AtlasDatePicker = /*#__PURE__*/(() => {
  let AtlasDatePicker = class extends AtlasInput {
    constructor() {
      super();
      this.placeholder = "___/___/____";
      this.preventDates = [];
      this.preventWeekdays = [];
      this.preventWeekends = false;
      this.preventedDatesErrorMessage = "Esta data n\xE3o pode ser selecionada";
      this._showCalendar = false;
      this._selectedDate = "";
      this._dateMinDigits = 8;
      this._isInsideFilter = false;
      this._hasAvailableDates = false;
      this.updateCalendarPosition = this.updateCalendarPosition.bind(this);
      this.onChangeScreenType = this.onChangeScreenType.bind(this);
      this.onClickCalendarIcon = this.onClickCalendarIcon.bind(this);
      this.onInitAndUpdateCalendar = this.onInitAndUpdateCalendar.bind(this);
      this.onClickCalendarDay = this.onClickCalendarDay.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
    }
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this._deviceController.setScreenChangeCallback(this.onChangeScreenType);
      this.updateComplete.then(() => {
        this.updateIconType();
        this.inputMode = "numeric";
        this.addValidator(new DateValidator());
        this.checkIfIsInsideFilter();
        this.createMask();
        this.createCalendar();
        this._hasAvailableDates = this.checkAvailableDates();
      });
    }
    disconnectedCallback() {
      var _a, _b;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      (_b = this._floatingUiCleanup) == null ? void 0 : _b.call(this);
      this._calendarInstance.destroy();
      this.removeEventListener("atlas-input-icon-click", this.onClickCalendarIcon);
    }
    /**
     * Método que retorna o valor do campo sem a máscara
     * @returns Valor do campo sem a máscara
     */
    getUnmaskedValue() {
      return this._maskInstance.unmaskedvalue();
    }
    /**
     * Método que retorna a instância do calendário
     * @returns Instância do calendário
     */
    getCalendarInstance() {
      return this._calendarInstance;
    }
    /**
     * @internal
     * @override
     */
    onChangeValue() {
      if (this.value.length >= this._dateMinDigits && !inputmask_utils_default.isValid(this.value, {
        alias: "datepicker"
      })) {
        this.value = inputmask_utils_default.format(this.value, {
          alias: "datepicker"
        });
      }
      if (this.value !== this._input.value) {
        this._input.value = "";
        this._input.value = this.value;
        emit(this, "atlas-date-picker-change");
      }
      this.updateCalendarSelectedDate();
      this.resetInputPlaceholder();
      super.onChangeValue();
    }
    updateCalendarDateLimits() {
      this._calendarInstance.settings.range.min = formatDateToYearMonthDay(this.getCalendarMinDate());
      this._calendarInstance.settings.range.max = formatDateToYearMonthDay(this.getCalendarMaxDate());
      this._calendarInstance.settings.selected = this.getCalendarSettingsSelectedDate();
      this._calendarInstance.update({
        dates: true,
        month: true,
        year: true
      });
      this._hasAvailableDates = this.checkAvailableDates();
      if (!!this.value) this.reportValidity();
    }
    updateCalendarPreventDates() {
      this._calendarInstance.settings.range.disabled = this.getCalendarPreventDates();
      this._calendarInstance.settings.range.disableWeekday = this.getCalendarPreventWeekdays();
      this._calendarInstance.update({
        dates: true,
        month: true,
        year: true
      });
      this._hasAvailableDates = this.checkAvailableDates();
      if (!!this.value) this.reportValidity();
    }
    checkIfIsInsideFilter() {
      this._isInsideFilter = Boolean(this.closest("atlas-filter"));
    }
    createMask() {
      this._maskInstance = inputmask_utils_default({
        alias: "datepicker"
      }).mask(this._input);
    }
    createCalendar() {
      this._calendarInstance = new VanillaCalendar(this._calendarWrapper, {
        jumpToSelectedDate: true,
        date: {
          min: "",
          max: ""
        },
        settings: {
          lang: "pt-BR",
          iso8601: false,
          range: {
            min: formatDateToYearMonthDay(this.getCalendarMinDate()),
            max: formatDateToYearMonthDay(this.getCalendarMaxDate()),
            disabled: this.getCalendarPreventDates(),
            disableWeekday: this.getCalendarPreventWeekdays()
          },
          visibility: {
            daysOutside: false
          }
        },
        actions: {
          clickDay: this.onClickCalendarDay,
          initCalendar: this.onInitAndUpdateCalendar,
          updateCalendar: this.onInitAndUpdateCalendar
        },
        DOMTemplates: {
          default: this.getCalendarDaysTemplate(),
          month: this.getCalendarMonthsTemplate(),
          year: this.getCalendarYearsTemplate()
        },
        CSSClasses: {
          arrowPrev: "atlas-icon ati-chevron-left",
          arrowNext: "atlas-icon ati-chevron-right"
        }
      });
      this._calendarInstance.init();
      this.registerFloatingUi();
      this.updateCalendarSelectedDate();
    }
    getCalendarHeaderTemplate(renderArrows) {
      return `
            <div class="vanilla-calendar-header">
                ${renderArrows ? "<#ArrowPrev />" : ""}
                <div class="vanilla-calendar-header__content">
                    <#Month />
                    <#Year />
                </div>
                ${renderArrows ? "<#ArrowNext />" : ""}
            </div>
        `;
    }
    getCalendarFooterTemplate() {
      return `
            <div class="vanilla-calendar-footer">
                <atlas-button type="ghost" description="Fechar" class="close-button"></atlas-button>
                <atlas-button type="ghost" description="Confirmar" class="confirm-button"></atlas-button>
            </div>
        `;
    }
    getCalendarDaysTemplate() {
      return `
            ${this.getCalendarHeaderTemplate(true)}
            <div class="vanilla-calendar-wrapper">
                <#WeekNumbers />
                <div class="vanilla-calendar-content">
                    <#Week />
                    <#Days />
                </div>
            </div>
            ${this.getCalendarFooterTemplate()}
        `;
    }
    getCalendarMonthsTemplate() {
      return `
            ${this.getCalendarHeaderTemplate(false)}
            <div class="vanilla-calendar-wrapper">
                <div class="vanilla-calendar-content">
                    <#Months />
                </div>
            </div>
            ${this.getCalendarFooterTemplate()}
        `;
    }
    getCalendarYearsTemplate() {
      return `
            ${this.getCalendarHeaderTemplate(true)}
            <div class="vanilla-calendar-wrapper">
                <div class="vanilla-calendar-content">
                    <#Years />
                </div>
            </div>
            ${this.getCalendarFooterTemplate()}
        `;
    }
    getCalendarSettingsSelectedDate() {
      if (inputmask_utils_default.isValid(this.value, {
        alias: "datepicker"
      })) {
        return {
          dates: [formatDateToYearMonthDay(this.value)]
        };
      }
      const today = getTodayDate();
      const minDate = this.getCalendarMinDate();
      const maxDate = this.getCalendarMaxDate();
      const minDateIsAfterToday = minDate && minDate > today;
      const maxDateIsBeforeToday = maxDate && maxDate < today;
      if (!minDateIsAfterToday && !maxDateIsBeforeToday) {
        return {
          year: today.getFullYear(),
          month: today.getMonth()
        };
      }
      if (minDateIsAfterToday) {
        return {
          year: minDate.getFullYear(),
          month: minDate.getMonth()
        };
      }
      return {
        year: maxDate.getFullYear(),
        month: maxDate.getMonth()
      };
    }
    updateCalendarSelectedDate() {
      var _a;
      const calendarSettingsSelectedDate = this.getCalendarSettingsSelectedDate();
      this._calendarInstance.settings.selected = calendarSettingsSelectedDate;
      this._calendarInstance.update({
        dates: true,
        month: true,
        year: true
      });
      this._selectedDate = ((_a = calendarSettingsSelectedDate.dates) == null ? void 0 : _a[0]) ? this.value : "";
    }
    getCalendarMaxDate() {
      if (this.maxDate) {
        return parseDate(this.maxDate);
      }
      const currentDate = getTodayDate();
      const currentYear = currentDate.getFullYear();
      const maxDate = new Date(this.preventLaterDate ? currentYear : currentYear + 80, currentDate.getMonth(), currentDate.getDate());
      return maxDate;
    }
    getCalendarMinDate() {
      if (this.minDate) {
        return parseDate(this.minDate);
      }
      if (this.preventPastDate) {
        return getTodayDate();
      }
      return parseDate("01/01/1000");
    }
    getCalendarPreventDates() {
      var _a;
      return ((_a = this.preventDates) == null ? void 0 : _a.map(date => formatDateToYearMonthDay(date))) || [];
    }
    getCalendarPreventWeekdays() {
      const preventWeekdays = new Set(this.preventWeekdays);
      if (this.preventWeekends) {
        preventWeekdays.add(0 /* SUNDAY */);
        preventWeekdays.add(6 /* SATURDAY */);
      }
      return Array.from(preventWeekdays);
    }
    registerFloatingUi() {
      var _a;
      (_a = this._floatingUiCleanup) == null ? void 0 : _a.call(this);
      this._calendarWrapper.style.top = "";
      this._calendarWrapper.style.left = "";
      const options = {
        animationFrame: this._isInsideFilter
      };
      if (!this._deviceController.isMobile) {
        this._floatingUiCleanup = autoUpdate2(this._formControl, this._calendarWrapper, this.updateCalendarPosition, options);
      }
    }
    updateCalendarPosition() {
      computePosition2(this._formControl, this._calendarWrapper, {
        placement: "bottom-start",
        strategy: "fixed",
        middleware: [offset3({
          mainAxis: 4,
          crossAxis: 0
        }), flip2(), shift2({
          padding: 8
        })]
      }).then(({
        x,
        y,
        placement
      }) => {
        this._calendarWrapper.setAttribute("data-popper-placement", placement);
        Object.assign(this._calendarWrapper.style, {
          left: `${x}px`,
          top: `${y}px`
        });
      });
    }
    showCalendar() {
      if (this._showCalendar) return;
      this.updateCalendarSelectedDate();
      this._showCalendar = true;
      this._calendarWrapper.removeAttribute("aria-hidden");
      if (!this._deviceController.isMobile) {
        setTimeout(() => {
          document.addEventListener("click", this.onDocumentClick);
        }, 50);
      }
    }
    hideCalendar() {
      this._showCalendar = false;
      this._calendarWrapper.setAttribute("aria-hidden", "true");
      document.removeEventListener("click", this.onDocumentClick);
    }
    resetInputPlaceholder() {
      this._input.placeholder = this.placeholder;
    }
    updateIconType() {
      if (this._deviceController.isMobile) {
        this.addEventListener("atlas-input-action-button-click", this.onClickCalendarIcon);
        this.icon = "";
        this.actionButtonIcon = "calendar";
      } else {
        this.removeEventListener("atlas-input-action-button-click", this.onClickCalendarIcon);
        this.icon = "calendar";
        this.actionButtonIcon = "";
      }
    }
    /** @override */
    handleInputKeyDown(event) {
      return __async(this, null, function* () {
        __superGet(AtlasDatePicker.prototype, this, "handleInputKeyDown").call(this, event);
        switch (event.key) {
          case "ArrowUp":
          case "ArrowDown":
            this.incrementOrDecrementCurrentDate(event);
            event.preventDefault();
            break;
          case "Tab":
            this.hideCalendar();
            break;
        }
      });
    }
    /** @override */
    handleFocus() {
      super.handleFocus();
      if (!this._deviceController.isMobile) {
        this.showCalendar();
      }
    }
    /** @override */
    handleInputClick() {
      super.handleInputClick();
      if (!this._deviceController.isMobile) {
        this.showCalendar();
      }
    }
    isDatePrevented(date) {
      if (date < this.getCalendarMinDate()) return true;
      if (date > this.getCalendarMaxDate()) return true;
      if (this.getCalendarPreventWeekdays().includes(getWeekday(date))) return true;
      if (this.getCalendarPreventDates().includes(formatDateToYearMonthDay(date))) return true;
      return false;
    }
    checkAvailableDates() {
      if (this.getCalendarPreventWeekdays().length === NUMBER_OF_DAYS_IN_WEEK) return false;
      const minDate = this.getCalendarMinDate();
      const maxDate = this.getCalendarMaxDate();
      if (minDate > maxDate) return false;
      const currentDate = new Date(minDate);
      while (currentDate <= maxDate) {
        if (!this.isDatePrevented(currentDate)) return true;
        currentDate.setDate(currentDate.getDate() + 1);
      }
      return false;
    }
    getAvailableDate(date, direction) {
      if (!this._hasAvailableDates) return null;
      if (direction === "next") {
        return this.getNextAvailableDate(date);
      }
      if (direction === "previous") {
        return this.getPreviousAvailableDate(date);
      }
      return null;
    }
    getNextAvailableDate(date) {
      if (!this._hasAvailableDates) return null;
      if (date >= this.getCalendarMaxDate()) return null;
      const nextDate = new Date(date);
      nextDate.setDate(nextDate.getDate() + 1);
      while (this.isDatePrevented(nextDate)) {
        if (nextDate > this.getCalendarMaxDate()) return null;
        nextDate.setDate(nextDate.getDate() + 1);
      }
      return nextDate;
    }
    getPreviousAvailableDate(date) {
      if (!this._hasAvailableDates) return null;
      if (date <= this.getCalendarMinDate()) return null;
      const previousDate = new Date(date);
      previousDate.setDate(previousDate.getDate() - 1);
      while (this.isDatePrevented(previousDate)) {
        if (previousDate < this.getCalendarMinDate()) return null;
        previousDate.setDate(previousDate.getDate() - 1);
      }
      return previousDate;
    }
    incrementOrDecrementCurrentDate(event) {
      if (!this._hasAvailableDates) return;
      const currentDate = this.value ? getDateFromString(this.value) : getTodayDate();
      const direction = event.key === "ArrowUp" ? "next" : "previous";
      const newDate = this.getAvailableDate(currentDate, direction);
      if (!newDate) return;
      if (event.key === "ArrowUp" && newDate > this.getCalendarMaxDate()) return;
      if (event.key === "ArrowDown" && newDate < this.getCalendarMinDate()) return;
      this.value = formatDate(newDate);
    }
    bindCalendarCustomButtons() {
      this._calendarWrapper.addEventListener("atlas-button-click", event => {
        const button = event.target;
        if (button.classList.contains("confirm-button")) {
          this.value = this._selectedDate;
        } else {
          this._selectedDate = "";
        }
        this.hideCalendar();
      });
      this._calendarWrapper.addEventListener("mouseover", event => {
        const target = event.target;
        const isDayDiv = target.classList.contains("vanilla-calendar-day");
        const dayButton = isDayDiv ? target.querySelector(".vanilla-calendar-day__btn") : target;
        if (dayButton == null ? void 0 : dayButton.classList.contains("vanilla-calendar-day__btn_disabled")) return;
        const formattedDate = dayButton == null ? void 0 : dayButton.getAttribute("data-calendar-day");
        if (this._input && !this._deviceController.isMobile) {
          this._input.placeholder = formatDate(formattedDate) || this.placeholder;
        }
      });
      this._calendarWrapper.addEventListener("mouseout", () => {
        if (this._input && !this._deviceController.isMobile) {
          this.resetInputPlaceholder();
        }
      });
    }
    onChangeScreenType() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this.updateIconType();
        this.registerFloatingUi();
        if (this._showCalendar && !this._deviceController.isMobile) {
          document.addEventListener("click", this.onDocumentClick);
        } else {
          document.removeEventListener("click", this.onDocumentClick);
        }
      });
    }
    onClickCalendarIcon() {
      if (this._showCalendar) {
        this.hideCalendar();
      } else {
        this.showCalendar();
      }
    }
    onInitAndUpdateCalendar() {
      this.bindCalendarCustomButtons();
      this._calendarWrapper.querySelectorAll("button, atlas-button, [tabindex='0']").forEach(el => el.setAttribute("tabindex", "-1"));
    }
    onClickCalendarDay(event) {
      const target = event.target;
      const selectedDate = target.getAttribute("data-calendar-day");
      this._selectedDate = formatDate(selectedDate);
      if (!this._deviceController.isMobile) {
        this.value = this._selectedDate;
        this.focus();
        this.hideCalendar();
      }
    }
    onDocumentClick(event) {
      return __async(this, null, function* () {
        if (!this._showCalendar) return;
        const composedPath = event.composedPath();
        const isCalendarTarget = composedPath.includes(this._calendarWrapper);
        const isInputTarget = composedPath.includes(this._formControl);
        if (isCalendarTarget || isInputTarget) {
          return;
        }
        this.hideCalendar();
      });
    }
    render() {
      const calendarClass = {
        "calendar-wrapper": true,
        "fade-and-scale": true,
        "show": this._showCalendar
      };
      const calendarBackdropClass = {
        "calendar-backdrop": true,
        "show": this._showCalendar
      };
      return html80`
            ${super.render()}
            ${when54(this._deviceController.isMobile, () => html80`<div class=${classMap57(calendarBackdropClass)}></div>`)}
            <div class=${classMap57(calendarClass)} aria-hidden="true"></div>
        `;
    }
  };
  AtlasDatePicker.styles = atlas_date_picker_default;
  return AtlasDatePicker;
})();
__decorateClass([property82({
  type: String
})], AtlasDatePicker.prototype, "placeholder", 2);
__decorateClass([property82({
  type: String,
  attribute: "min-date"
})], AtlasDatePicker.prototype, "minDate", 2);
__decorateClass([property82({
  type: String,
  attribute: "max-date"
})], AtlasDatePicker.prototype, "maxDate", 2);
__decorateClass([property82({
  type: Boolean,
  reflect: true,
  attribute: "prevent-past-date"
})], AtlasDatePicker.prototype, "preventPastDate", 2);
__decorateClass([property82({
  type: Boolean,
  reflect: true,
  attribute: "prevent-later-date"
})], AtlasDatePicker.prototype, "preventLaterDate", 2);
__decorateClass([property82({
  type: Array,
  attribute: "prevent-dates"
})], AtlasDatePicker.prototype, "preventDates", 2);
__decorateClass([property82({
  type: Array,
  attribute: "prevent-weekdays"
})], AtlasDatePicker.prototype, "preventWeekdays", 2);
__decorateClass([property82({
  type: Boolean,
  attribute: "prevent-weekends"
})], AtlasDatePicker.prototype, "preventWeekends", 2);
__decorateClass([property82({
  type: String,
  attribute: "prevented-dates-error-message"
})], AtlasDatePicker.prototype, "preventedDatesErrorMessage", 2);
__decorateClass([state40()], AtlasDatePicker.prototype, "_showCalendar", 2);
__decorateClass([state40()], AtlasDatePicker.prototype, "_selectedDate", 2);
__decorateClass([query14(".calendar-wrapper")], AtlasDatePicker.prototype, "_calendarWrapper", 2);
__decorateClass([Watch(["minDate", "maxDate", "preventPastDate", "preventLaterDate"], true)], AtlasDatePicker.prototype, "updateCalendarDateLimits", 1);
__decorateClass([Watch(["preventDates", "preventWeekdays", "preventWeekends"], true)], AtlasDatePicker.prototype, "updateCalendarPreventDates", 1);
AtlasDatePicker = __decorateClass([customElement73("atlas-date-picker")], AtlasDatePicker);

// src/components/form/atlas-date-range/atlas-date-range.ts
import { html as html81 } from "lit";
import { customElement as customElement74, property as property83, query as query15, state as state41 } from "lit/decorators.js";
import { classMap as classMap58 } from "lit/directives/class-map.js";
import { live as live4 } from "lit/directives/live.js";
import { when as when55 } from "lit/directives/when.js";
import VanillaCalendar2 from "vanilla-calendar-pro";
import { autoUpdate as autoUpdate3, computePosition as computePosition3, flip as flip3, offset as offset4, shift as shift3 } from "@floating-ui/dom";

// src/internals/validators/date-range-validator.ts
var FULL_DATE_DIGITS = 10;
var MESSAGES_MAP2 = {
  format: "Formato de data inv\xE1lido, utilize o formato DD/MM/AAAA",
  range: "A data final deve ser igual ou maior que a data inicial",
  minStart: "A data inicial informada n\xE3o deve ser menor que {{minDate}}",
  maxStart: "A data inicial informada n\xE3o deve ser maior que {{maxDate}}",
  bothStart: "Informe uma data inicial entre {{minDate}} e {{maxDate}}",
  minEnd: "A data final informada n\xE3o deve ser menor que {{minDate}}",
  maxEnd: "A data final informada n\xE3o deve ser maior que {{maxDate}}",
  bothEnd: "Informe uma data final entre {{minDate}} e {{maxDate}}",
  bothRequired: "Informe a data inicial e final",
  none: ""
};
var DateRangeValidator = class {
  constructor() {
    this.name = "date";
    this.status = "error";
    this.errorType = "none";
  }
  getInvalidMessage() {
    return MESSAGES_MAP2[this.errorType].replace("{{minDate}}", formatDate(this.minDate)).replace("{{maxDate}}", formatDate(this.maxDate));
  }
  validate(element) {
    const dateRangeElement = element;
    const selectedRange = dateRangeElement.getSelectedRange();
    if (!selectedRange.start && !selectedRange.end) return true;
    if (dateRangeElement.requireFullRange && (!selectedRange.start || !selectedRange.end)) {
      this.errorType = "bothRequired";
      return false;
    }
    if (selectedRange.start && selectedRange.start.length < FULL_DATE_DIGITS || selectedRange.end && selectedRange.end.length < FULL_DATE_DIGITS) {
      this.errorType = "format";
      return false;
    }
    this.errorType = "none";
    const rangeStart = parseDate(selectedRange.start);
    const rangeEnd = parseDate(selectedRange.end);
    if (rangeStart && rangeEnd && rangeStart.getTime() > rangeEnd.getTime()) {
      this.errorType = "range";
    }
    this.maxDate = dateRangeElement.getCalendarMaxDate();
    this.minDate = dateRangeElement.getCalendarMinDate();
    if (rangeStart && this.minDate && rangeStart.getTime() < this.minDate.getTime()) {
      this.errorType = this.maxDate ? "bothStart" : "minStart";
    } else if (rangeStart && this.maxDate && rangeStart.getTime() > this.maxDate.getTime()) {
      this.errorType = this.minDate ? "bothStart" : "maxStart";
    }
    if (rangeEnd && this.minDate && rangeEnd.getTime() < this.minDate.getTime()) {
      this.errorType = this.maxDate ? "bothEnd" : "minEnd";
    } else if (rangeEnd && this.maxDate && rangeEnd.getTime() > this.maxDate.getTime()) {
      this.errorType = this.minDate ? "bothEnd" : "maxEnd";
    }
    return this.errorType === "none";
  }
};

// src/components/form/atlas-date-range/atlas-date-range.scss
import { css as css71 } from "lit-element/lit-element.js";
var atlas_date_range_default = css71`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Z-index mapping for the floating elements */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Z-index mapping for the floating elements */
/* Shadows */
/* Elevations */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.form-label {
  margin-bottom: 0.5rem;
  font-style: normal;
  box-sizing: border-box;
  display: inline-block;
}
.form-label-optional {
  color: #687078;
}
.form-label atlas-icon-button {
  top: 2px;
}
.form-label[skeleton-loading] {
  min-width: 40%;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Z-index mapping for the floating elements */
/* Shadows */
/* Elevations */
.form-control {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #1a1e21;
  appearance: none;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  cursor: text;
}
.form-control > .form-control-input {
  border: none;
  appearance: none;
  background-color: transparent;
  margin: 0;
  padding: 0;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #1a1e21;
  width: 100%;
  cursor: text;
}
.form-control > .form-control-input:focus, .form-control > .form-control-input:focus-visible {
  outline: none;
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control.form-control-multiple {
  display: flex;
  flex-flow: row wrap;
  gap: 0.5rem;
  overflow-y: overlay;
  max-height: 200px;
  cursor: text;
}
.form-control.form-control-multiple > .form-control-input {
  flex-grow: 1;
  min-width: 100px;
  width: 1%;
}
.form-control .form-control-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
.form-control .form-control-sm > .form-control-input {
  font-size: 0.875rem;
}
.form-control .form-control-lg {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
}
.form-control .form-control-lg > .form-control-input {
  font-size: 1.25rem;
}
.form-control:focus, .form-control:focus-within {
  color: #1a1e21;
  background-color: #ffffff;
  border-color: var(--atlas-primary-300);
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-300-rgb), 0.25);
  outline: 0;
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder,
.form-control > .form-control-input::placeholder {
  color: #687078;
  opacity: 1;
}
.form-control:disabled, .form-control:has(.form-control-input:disabled) {
  background-color: #e9ecef;
  opacity: 1;
}
.form-control.hide-placeholder::placeholder,
.form-control.hide-placeholder > .form-control-input::placeholder {
  color: transparent;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
  /* stylelint-disable no-descending-specificity */
  /* stylelint-enable no-descending-specificity */
}
.input-group atlas-button {
  position: relative;
  z-index: 2;
}
.input-group atlas-button:focus {
  z-index: 5;
}
.input-group .input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.input-group .input-group-text.input-group-prefix {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group .input-group-text.input-group-suffix {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group .form-control {
  border-radius: 0.25rem !important;
  box-sizing: border-box;
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group .form-control.has-icon {
  padding-right: 1.75rem;
}
.input-group .form-control.has-right-element, .input-group .form-control.has-action-button {
  border-bottom-right-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
.input-group .form-control.has-left-element {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}
.input-group .form-control .input-icon,
.input-group .form-control ~ .input-icon {
  position: absolute;
  right: 0.75rem;
  top: 0.815rem;
  z-index: 5;
  pointer-events: none;
}
.input-group .form-control .input-icon.has-click,
.input-group .form-control ~ .input-icon.has-click {
  cursor: pointer;
  pointer-events: all;
}
.input-group .form-control .side-image,
.input-group .form-control ~ .side-image {
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  height: 1.75rem;
  z-index: 5;
  pointer-events: none;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus {
  z-index: 5;
}
.input-group .form-control-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
.input-group .form-control-sm.has-icon {
  padding-right: 1.5rem;
}
.input-group .form-control-sm > .form-control-input {
  font-size: 0.875rem;
}
.input-group .form-control-sm .input-icon,
.input-group .form-control-sm ~ .input-icon {
  right: 0.5rem;
  top: 0.5rem;
}
.input-group .form-control-sm .side-image,
.input-group .form-control-sm ~ .side-image {
  right: 0.5rem;
  top: 0.25rem;
  height: 1.5rem;
}
.input-group .form-control-lg {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
}
.input-group .form-control-lg > .form-control-input {
  font-size: 1.25rem;
}
.input-group .form-control-lg.has-icon {
  padding-right: 2rem;
}
.input-group .form-control-lg .input-icon,
.input-group .form-control-lg ~ .input-icon {
  right: 1rem;
  top: 1rem;
}
.input-group .form-control-lg .side-image,
.input-group .form-control-lg ~ .side-image {
  right: 1rem;
  top: 0.5rem;
  height: 2rem;
}
.input-group:has(.form-control-sm) .input-group-text {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
.input-group:has(.form-control-lg) .input-group-text {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
}
.input-group:has(atlas-button.action-button-position-left) .input-group-text {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}
.input-group:has(atlas-button.action-button-position-right) .input-group-text {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
.input-group > :not(:first-child):not(.invalid-feedback) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group.skeleton * {
  visibility: hidden;
}
.input-group.skeleton + atlas-button {
  display: none;
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
.status-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.8rem;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}

.is-info ~ .status-feedback {
  display: block;
}

.status-info {
  color: var(--atlas-secondary);
}

.is-success {
  border-color: var(--atlas-success) !important;
}
.is-success:focus, .is-success:focus-visible, .is-success.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
  border-color: var(--atlas-success);
}
.is-success ~ .status-feedback {
  display: block;
}
.is-success ~ .form-check-label {
  color: var(--atlas-success);
}
.is-success .focus-mark {
  background: var(--atlas-success-300);
}
.is-success.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-success) !important;
  background-color: rgba(var(--atlas-success-rgb), 2%);
}
.is-success.rating-buttons-group .rating-button {
  border-color: var(--atlas-success) !important;
  color: var(--atlas-success) !important;
}
.is-success.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-success-400) !important;
  color: #ffffff !important;
}
.is-success.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
}
.is-success.rating-buttons-group .rating-button:active:not(:disabled), .is-success.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-success) !important;
  color: #ffffff !important;
}

.form-check:has(.is-success) .form-check-label {
  color: var(--atlas-success);
}
.form-check:has(.is-success) .form-check-input:checked {
  background-color: var(--atlas-success);
}

.status-success {
  color: var(--atlas-success);
}

.is-warning {
  border-color: var(--atlas-warning) !important;
}
.is-warning:focus, .is-warning:focus-visible, .is-warning.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
  border-color: var(--atlas-warning);
}
.is-warning ~ .status-feedback {
  display: block;
}
.is-warning ~ .form-check-label {
  color: var(--atlas-warning);
}
.is-warning .focus-mark {
  background: var(--atlas-warning-300);
}
.is-warning.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-warning) !important;
  background-color: rgba(var(--atlas-warning-rgb), 2%);
}
.is-warning.rating-buttons-group .rating-button {
  border-color: var(--atlas-warning) !important;
  color: var(--atlas-warning) !important;
}
.is-warning.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-warning-400) !important;
  color: #ffffff !important;
}
.is-warning.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
}
.is-warning.rating-buttons-group .rating-button:active:not(:disabled), .is-warning.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-warning) !important;
  color: #ffffff !important;
}

.form-check:has(.is-warning) .form-check-label {
  color: var(--atlas-warning);
}
.form-check:has(.is-warning) .form-check-input:checked {
  background-color: var(--atlas-warning);
}

.status-warning {
  color: var(--atlas-warning);
}

.is-error {
  border-color: var(--atlas-danger) !important;
}
.is-error:focus, .is-error:focus-visible, .is-error.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
  border-color: var(--atlas-danger);
}
.is-error ~ .status-feedback {
  display: block;
}
.is-error ~ .form-check-label {
  color: var(--atlas-danger);
}
.is-error .focus-mark {
  background: var(--atlas-danger-300);
}
.is-error.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-danger) !important;
  background-color: rgba(var(--atlas-danger-rgb), 2%);
}
.is-error.rating-buttons-group .rating-button {
  border-color: var(--atlas-danger) !important;
  color: var(--atlas-danger) !important;
}
.is-error.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-danger-400) !important;
  color: #ffffff !important;
}
.is-error.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
}
.is-error.rating-buttons-group .rating-button:active:not(:disabled), .is-error.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-danger) !important;
  color: #ffffff !important;
}

.form-check:has(.is-error) .form-check-label {
  color: var(--atlas-danger);
}
.form-check:has(.is-error) .form-check-input:checked {
  background-color: var(--atlas-danger);
}

.status-error {
  color: var(--atlas-danger);
}

/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host([width=full]) {
  width: 100%;
}

:host([width=xs]) {
  width: 96px;
}

:host([width=sm]) {
  width: 152px;
}

:host([width=md]) {
  width: 264px;
}

:host([width=lg]) {
  width: 380px;
}

:host {
  outline: none;
  display: block;
}

:host([skeleton-loading]) {
  display: block;
}

:host(.one-time-code-input) input {
  text-align: center;
}
:host(.one-time-code-input) input:focus::placeholder {
  opacity: 0;
}

:host(.atlas-select-input[readonly]) .form-control,
:host(.atlas-select-input[readonly]) .form-control input,
:host(.atlas-multiselect-input[readonly]) .form-control,
:host(.atlas-multiselect-input[readonly]) .form-control input {
  cursor: pointer;
}

:host(.atlas-select-input[disabled]) .form-control,
:host(.atlas-select-input[disabled]) .form-control input,
:host(.atlas-multiselect-input[disabled]) .form-control,
:host(.atlas-multiselect-input[disabled]) .form-control input {
  cursor: default;
}

:host(.atlas-select-input) atlas-icon.input-icon,
:host(.atlas-multiselect-input) atlas-icon.input-icon {
  transition: transform 0.35s ease;
}

:host(.atlas-select-input:not(.collapsed)) atlas-icon[name=chevron-down],
:host(.atlas-multiselect-input:not(.collapsed)) atlas-icon[name=chevron-down] {
  transform: rotate(-180deg);
}

:host(.atlas-multiselect-input.has-tag) .form-control {
  padding-left: 200px;
}

:host([type=hidden]) {
  display: none !important;
}

.form-label.skeleton {
  height: 1.5rem;
  width: 50%;
}

.form-control.skeleton {
  width: 100%;
  min-height: calc(1.5em + 14px);
}

.helper-text.skeleton {
  height: 1.25rem;
  width: 100%;
  margin-top: 0.25rem;
}

.input-wrapper {
  display: flex;
  width: 100%;
}

@media screen and (min-width: 992px) {
  :host(.atlas-multiselect-input.has-tag) .form-control {
    padding-left: 190px;
  }
}
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Z-index mapping for the floating elements */
/* stylelint-disable selector-class-pattern */
/*! name: vanilla-calendar-pro v2.9.10 | url: https://github.com/uvarov-frontend/vanilla-calendar-pro */
.vanilla-calendar {
  position: relative;
  box-sizing: border-box;
  display: flex;
  width: 300px;
  min-width: 272px;
  max-width: 100%;
  flex-direction: column;
  border-radius: 0.75rem;
  padding: 1rem;
  opacity: 1;
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 0.15s;
}

@supports ((width: -webkit-max-content) or (width: max-content)) and ((height: -webkit-max-content) or (height: max-content)) {
  .vanilla-calendar {
    height: -webkit-max-content;
    height: max-content;
    width: -webkit-max-content;
    width: max-content;
  }
}
.vanilla-calendar_multiple {
  width: 550px;
}

@supports (width: -webkit-fit-content) or (width: -moz-fit-content) or (width: fit-content) {
  .vanilla-calendar_multiple {
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
  }
}
.vanilla-calendar button:focus-visible {
  border-radius: 0.5rem;
  outline-style: solid;
  outline-width: 1px;
  outline-offset: -1px;
}

.vanilla-calendar.vanilla-calendar_multiple .vanilla-calendar-days {
  flex-grow: 0;
}

.vanilla-calendar_hidden {
  pointer-events: none;
  opacity: 0;
}

.vanilla-calendar_hidden * {
  pointer-events: none !important;
}

.vanilla-calendar_to-input {
  position: absolute;
}

.vanilla-calendar_to-input_bottom {
  margin-top: 0.25rem;
}

.vanilla-calendar_to-input_top {
  margin-top: -0.25rem;
}

.vanilla-calendar-controls {
  pointer-events: none;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  z-index: 20;
  box-sizing: content-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 1.25rem;
}

.vanilla-calendar-arrow {
  pointer-events: auto;
  position: relative;
  display: block;
  height: 1.5rem;
  width: 1.5rem;
  cursor: pointer;
  border-width: 0px;
  background-color: transparent;
}

.vanilla-calendar-arrow:before {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  --tw-content: "";
  content: var(--tw-content);
}

.vanilla-calendar-arrow.vanilla-calendar-arrow_prev:before {
  transform: rotate(90deg);
}

.vanilla-calendar-arrow.vanilla-calendar-arrow_next:before {
  transform: rotate(-90deg);
}

.vanilla-calendar-grid {
  display: flex;
  flex-grow: 1;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.75rem;
}

.vanilla-calendar-grid.vanilla-calendar-grid_disabled .vanilla-calendar-column {
  pointer-events: none;
  opacity: 0.3;
}

.vanilla-calendar-grid.vanilla-calendar-grid_disabled .vanilla-calendar-column.vanilla-calendar-column_month, .vanilla-calendar-grid.vanilla-calendar-grid_disabled .vanilla-calendar-column.vanilla-calendar-column_year {
  pointer-events: auto;
  opacity: 1;
}

.vanilla-calendar-column {
  display: flex;
  min-width: -webkit-min-content;
  min-width: min-content;
  flex-direction: column;
}

.vanilla-calendar-header {
  position: relative;
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
}

.vanilla-calendar-header__content {
  display: grid;
  flex-grow: 1;
  grid-auto-columns: -webkit-max-content;
  grid-auto-columns: max-content;
  grid-auto-flow: column;
  align-items: center;
  justify-content: center;
  white-space: pre-wrap;
  padding-left: 1rem;
  padding-right: 1rem;
}

.vanilla-calendar-month, .vanilla-calendar-year {
  cursor: pointer;
  border-radius: 0.25rem;
  border-width: 0px;
  background-color: transparent;
  padding: 0.25rem;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 700;
}

.vanilla-calendar-month.vanilla-calendar-month_disabled, .vanilla-calendar-year.vanilla-calendar-year_disabled {
  pointer-events: none;
}

.vanilla-calendar-months {
  display: grid;
  flex-grow: 1;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  align-items: center;
  row-gap: 1rem;
  column-gap: 0.5rem;
}

.vanilla-calendar-years {
  display: grid;
  flex-grow: 1;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  align-items: center;
  row-gap: 1rem;
  column-gap: 0.5rem;
}

.vanilla-calendar-months_selecting .vanilla-calendar-months__month, .vanilla-calendar-years_selecting .vanilla-calendar-years__year {
  cursor: pointer;
}

.vanilla-calendar-months_selecting .vanilla-calendar-months__month .vanilla-calendar-months__month_disabled, .vanilla-calendar-years_selecting .vanilla-calendar-years__year .vanilla-calendar-years__year_disabled {
  cursor: default;
}

.vanilla-calendar-months__month, .vanilla-calendar-years__year {
  display: flex;
  height: 2.5rem;
  align-items: center;
  justify-content: center;
  word-break: break-all;
  border-radius: 0.5rem;
  border-width: 0px;
  padding: 0.25rem;
  text-align: center;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 600;
}

.vanilla-calendar-months__month.vanilla-calendar-months__month_disabled, .vanilla-calendar-years__year.vanilla-calendar-years__year_disabled {
  pointer-events: none;
}

.vanilla-calendar-week-numbers {
  display: flex;
  flex-direction: column;
}

.vanilla-calendar-week-numbers__title {
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 700;
}

.vanilla-calendar-week-numbers__content {
  display: grid;
  grid-auto-flow: row;
  align-items: center;
  justify-items: center;
  row-gap: 0.25rem;
}

.vanilla-calendar-week-number {
  margin: 0;
  display: flex;
  min-height: 1.875rem;
  width: 100%;
  min-width: 1.875rem;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-style: none;
  background-color: transparent;
  padding: 0;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 600;
}

.vanilla-calendar-wrapper {
  display: flex;
  flex-grow: 1;
}

.vanilla-calendar-content {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}

.vanilla-calendar-week {
  margin-bottom: 0.5rem;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  justify-items: center;
}

.vanilla-calendar-week__day {
  display: flex;
  width: 100%;
  min-width: 1.875rem;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 700;
}

.vanilla-calendar-days {
  display: grid;
  flex-grow: 1;
  grid-template-columns: repeat(7, 1fr);
  align-items: center;
  justify-items: center;
  row-gap: 0.25rem;
}

.vanilla-calendar-days_selecting .vanilla-calendar-day__btn {
  cursor: pointer;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 75ms;
}

.vanilla-calendar-days_selecting .vanilla-calendar-day__btn_disabled {
  cursor: default;
}

.vanilla-calendar-day {
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.vanilla-calendar-day_hover-intermediate .vanilla-calendar-day__btn {
  border-radius: 0;
}

.vanilla-calendar-day_hover-first .vanilla-calendar-day__btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}

.vanilla-calendar-day_hover-last .vanilla-calendar-day__btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

.vanilla-calendar-day_hover-first.vanilla-calendar-day_hover-last .vanilla-calendar-day__btn {
  border-radius: 0.5rem;
}

.vanilla-calendar-day:focus-visible .vanilla-calendar-day__popup, .vanilla-calendar-day:hover .vanilla-calendar-day__popup {
  pointer-events: auto;
  opacity: 1;
}

.vanilla-calendar-day_selected-first .vanilla-calendar-day__btn_selected {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}

.vanilla-calendar-day_selected-last .vanilla-calendar-day__btn_selected {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

.vanilla-calendar-day_selected-first.vanilla-calendar-day_selected-last .vanilla-calendar-day__btn_selected {
  border-radius: 0.5rem;
}

.vanilla-calendar-day_selected-intermediate .vanilla-calendar-day__btn_selected {
  border-radius: 0;
}

.vanilla-calendar-day__btn {
  display: flex;
  height: 100%;
  min-height: 1.875rem;
  width: 100%;
  min-width: 1.875rem;
  cursor: default;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  border-width: 0px;
  padding: 0;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 400;
}

.vanilla-calendar-day__btn_today {
  font-weight: 700;
}

.vanilla-calendar-day__btn_disabled {
  pointer-events: none;
}

.vanilla-calendar-day__popup {
  transform: translate(-50%);
  pointer-events: none;
  position: absolute;
  left: 50%;
  top: 100%;
  z-index: 20;
  width: 8rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 400;
  opacity: 0;
}

.vanilla-calendar-day__popup:before {
  content: var(--tw-content);
  position: absolute;
}

.vanilla-calendar-day__popup:after {
  content: var(--tw-content);
  position: absolute;
}

.vanilla-calendar-day__popup:hover {
  pointer-events: auto;
  opacity: 1;
}

.vanilla-calendar-day__popup:before {
  content: "";
  left: 0;
  bottom: 0;
  z-index: -10;
  display: block;
  height: calc(100% - 4px);
  width: 100%;
  border-radius: 0.5rem;
}

.vanilla-calendar-time {
  margin-top: 0.75rem;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.75rem;
  border-top-width: 1px;
  border-bottom-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-style: solid;
  padding-top: 0.75rem;
}

.vanilla-calendar-time__content {
  display: grid;
  grid-auto-flow: column;
  align-items: center;
}

.vanilla-calendar-time__hours {
  position: relative;
  margin-right: 0.35rem;
  width: 1.75rem;
}

.vanilla-calendar-time__hours:after {
  position: absolute;
  right: -5px;
  top: 50%;
  margin-top: calc(-50% + 1px);
  display: block;
  --tw-content: ":";
  content: var(--tw-content);
}

.vanilla-calendar-time__minutes {
  width: 1.75rem;
}

.vanilla-calendar-time__hours input, .vanilla-calendar-time__minutes input {
  position: relative;
  margin: 0;
  box-sizing: border-box;
  display: block;
  width: 100%;
  border-radius: 0.25rem;
  border-width: 0px;
  padding: 0.125rem;
  text-align: center;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.125rem;
}

.vanilla-calendar-time__hours input:focus-visible, .vanilla-calendar-time__minutes input:focus-visible {
  outline-style: solid;
  outline-width: 1px;
}

.vanilla-calendar-time__hours input:disabled, .vanilla-calendar-time__minutes input:disabled {
  cursor: default;
}

.vanilla-calendar-time__hours input:hover:disabled, .vanilla-calendar-time__minutes input:hover:disabled {
  background-color: transparent;
}

.vanilla-calendar-time__keeping {
  margin-left: 1px;
  margin-top: 0.25rem;
  width: 22px;
  cursor: pointer;
  border-radius: 0.25rem;
  border-width: 0px;
  background-color: transparent;
  padding: 0;
  font-size: 0.69rem;
}

.vanilla-calendar-time__keeping:focus-visible {
  outline-style: solid;
  outline-width: 1px;
}

.vanilla-calendar-time__keeping:disabled {
  cursor: default;
}

.vanilla-calendar-time__keeping:hover:disabled {
  background-color: transparent;
}

.vanilla-calendar-time__ranges {
  display: grid;
  grid-auto-flow: row;
}

.vanilla-calendar-time__range {
  position: relative;
  z-index: 10;
  font-size: 0;
}

.vanilla-calendar-time__range:before {
  content: var(--tw-content);
  left: 0;
}

.vanilla-calendar-time__range:after {
  content: var(--tw-content);
  right: 0;
}

.vanilla-calendar-time__range:before, .vanilla-calendar-time__range:after {
  content: "";
  transform: translateY(-50%);
  pointer-events: none;
  position: absolute;
  top: 50%;
  z-index: 10;
  height: 0.5rem;
  width: 1px;
}

.vanilla-calendar-time__range input {
  position: relative;
  margin: 0;
  height: 1.25rem;
  width: 100%;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
  outline-width: 0px;
}

.vanilla-calendar-time__range input::-webkit-slider-thumb {
  position: relative;
  z-index: 20;
  margin-top: -0.5rem;
  box-sizing: border-box;
  height: 1rem;
  width: 0.75rem;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
  border-radius: 0.25rem;
  border-width: 1px;
  border-style: solid;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.vanilla-calendar-time__range input::-moz-range-thumb {
  position: relative;
  z-index: 20;
  box-sizing: border-box;
  height: 1rem;
  width: 0.75rem;
  cursor: pointer;
  border-radius: 0.25rem;
  border-width: 1px;
  border-style: solid;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.vanilla-calendar-time__range input::-webkit-slider-runnable-track {
  margin-top: 1px;
  box-sizing: border-box;
  height: 1px;
  width: 100%;
  cursor: pointer;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.vanilla-calendar-time__range input::-moz-range-track {
  margin-top: 1px;
  box-sizing: border-box;
  height: 1px;
  width: 100%;
  cursor: pointer;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

@font-face {
  font-family: "Atlas-Icons";
  src: url("fonts/Atlas-Icons.eot?ku8bqy");
  src: url("fonts/Atlas-Icons.eot?ku8bqy#iefix") format("embedded-opentype"), url("fonts/Atlas-Icons.ttf?ku8bqy") format("truetype"), url("fonts/Atlas-Icons.woff?ku8bqy") format("woff"), url("fonts/Atlas-Icons.svg?ku8bqy#Atlas-Icons") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
.atlas-icon {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "Atlas-Icons" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.ati-address-book:before {
  content: "\\e905";
}

.ati-alert:before {
  content: "\\e96f";
}

.ati-alert-circle:before {
  content: "\\e902";
}

.ati-alert-triangle:before {
  content: "\\e904";
}

.ati-align-justify:before {
  content: "\\e906";
}

.ati-apps:before {
  content: "\\e907";
}

.ati-arrow-down:before {
  content: "\\e90c";
}

.ati-arrow-down-circle:before {
  content: "\\e90d";
}

.ati-arrow-left:before {
  content: "\\e910";
}

.ati-arrow-right:before {
  content: "\\e912";
}

.ati-arrow-right-left:before {
  content: "\\e908";
}

.ati-arrow-up:before {
  content: "\\e914";
}

.ati-arrow-up-circle:before {
  content: "\\e93f";
}

.ati-arrow-up-right:before {
  content: "\\e909";
}

.ati-asaas-logo:before {
  content: "\\e90a";
}

.ati-backspace:before {
  content: "\\e970";
}

.ati-banco-do-brasil:before {
  content: "\\e976";
}

.ati-bank:before {
  content: "\\e932";
}

.ati-bar-chart:before {
  content: "\\e91b";
}

.ati-barcode:before {
  content: "\\e921";
}

.ati-bars:before {
  content: "\\e998";
}

.ati-base-logo:before {
  content: "\\e93e";
}

.ati-bell:before {
  content: "\\e91e";
}

.ati-box:before {
  content: "\\e923";
}

.ati-briefcase:before {
  content: "\\e926";
}

.ati-caixa:before {
  content: "\\e977";
}

.ati-calendar:before {
  content: "\\e93b";
}

.ati-calendar-sync:before {
  content: "\\e96d";
}

.ati-camera:before {
  content: "\\e90b";
}

.ati-card:before {
  content: "\\e951";
}

.ati-card-mastercard:before {
  content: "\\e953";
}

.ati-celebrate:before {
  content: "\\e948";
}

.ati-check:before {
  content: "\\e92b";
}

.ati-check-circle:before {
  content: "\\e92c";
}

.ati-check-filled:before {
  content: "\\e95d";
}

.ati-chevron-down:before {
  content: "\\e92e";
}

.ati-chevron-left:before {
  content: "\\e92f";
}

.ati-chevron-right:before {
  content: "\\e930";
}

.ati-chevron-up:before {
  content: "\\e931";
}

.ati-circle:before {
  content: "\\e937";
}

.ati-clock:before {
  content: "\\e939";
}

.ati-clock-filled:before {
  content: "\\e95e";
}

.ati-cog:before {
  content: "\\e9cf";
}

.ati-concentric-circles:before {
  content: "\\e93a";
}

.ati-contactless:before {
  content: "\\e959";
}

.ati-copy:before {
  content: "\\e947";
}

.ati-corner-up-right:before {
  content: "\\e94f";
}

.ati-credisis:before {
  content: "\\e978";
}

.ati-dashboard:before {
  content: "\\e90e";
}

.ati-dollar-sign:before {
  content: "\\e957";
}

.ati-dollar-zap:before {
  content: "\\e903";
}

.ati-double-check:before {
  content: "\\e971";
}

.ati-download:before {
  content: "\\e958";
}

.ati-envelope:before {
  content: "\\e992";
}

.ati-eye:before {
  content: "\\e95f";
}

.ati-eye-filled:before {
  content: "\\e966";
}

.ati-eye-off:before {
  content: "\\e960";
}

.ati-facebook:before {
  content: "\\e943";
}

.ati-file:before {
  content: "\\e965";
}

.ati-file-check:before {
  content: "\\e96c";
}

.ati-file-dollar:before {
  content: "\\e901";
}

.ati-file-text:before {
  content: "\\e968";
}

.ati-file-users:before {
  content: "\\e96b";
}

.ati-files:before {
  content: "\\e90f";
}

.ati-filter:before {
  content: "\\e96a";
}

.ati-flapp-store-logo:before {
  content: "\\e96e";
}

.ati-flash:before {
  content: "\\e973";
}

.ati-gift:before {
  content: "\\e92d";
}

.ati-github:before {
  content: "\\e94a";
}

.ati-globe:before {
  content: "\\e94d";
}

.ati-hammer:before {
  content: "\\e974";
}

.ati-hand-card:before {
  content: "\\e952";
}

.ati-hand-holding-money:before {
  content: "\\e946";
}

.ati-hand-shake:before {
  content: "\\e911";
}

.ati-help-circle:before {
  content: "\\e97e";
}

.ati-hierarchy:before {
  content: "\\e945";
}

.ati-home:before {
  content: "\\e938";
}

.ati-id-card:before {
  content: "\\e933";
}

.ati-info:before {
  content: "\\e983";
}

.ati-instagram:before {
  content: "\\e984";
}

.ati-inter:before {
  content: "\\e979";
}

.ati-invoice:before {
  content: "\\e900";
}

.ati-itau:before {
  content: "\\e97a";
}

.ati-key:before {
  content: "\\e913";
}

.ati-keyboard:before {
  content: "\\ea1a";
}

.ati-link:before {
  content: "\\e98a";
}

.ati-linkedin:before {
  content: "\\e944";
}

.ati-list:before {
  content: "\\e98d";
}

.ati-loader:before {
  content: "\\e934";
}

.ati-lock:before {
  content: "\\e98f";
}

.ati-lock-filled:before {
  content: "\\e963";
}

.ati-log-in:before {
  content: "\\e990";
}

.ati-magnifier:before {
  content: "\\e9cc";
}

.ati-mail-box:before {
  content: "\\e915";
}

.ati-map-pin:before {
  content: "\\e954";
}

.ati-market-pin:before {
  content: "\\e97d";
}

.ati-maximize:before {
  content: "\\e967";
}

.ati-megaphone:before {
  content: "\\e936";
}

.ati-message-circle:before {
  content: "\\e999";
}

.ati-mic:before {
  content: "\\e97f";
}

.ati-minus:before {
  content: "\\e99f";
}

.ati-minus-circle:before {
  content: "\\e9a0";
}

.ati-money:before {
  content: "\\e916";
}

.ati-money-filled:before {
  content: "\\e961";
}

.ati-money-notes:before {
  content: "\\e949";
}

.ati-monitor:before {
  content: "\\e9a2";
}

.ati-monitor-chart-up:before {
  content: "\\e924";
}

.ati-moon:before {
  content: "\\e94e";
}

.ati-nubank:before {
  content: "\\e97b";
}

.ati-open-finance:before {
  content: "\\e91c";
}

.ati-paperclip:before {
  content: "\\e9ad";
}

.ati-pencil:before {
  content: "\\e95c";
}

.ati-phone:before {
  content: "\\e9b2";
}

.ati-pix:before {
  content: "\\e922";
}

.ati-plus:before {
  content: "\\e9bc";
}

.ati-plus-circle:before {
  content: "\\e9bd";
}

.ati-power:before {
  content: "\\e9c0";
}

.ati-printer:before {
  content: "\\e9c1";
}

.ati-receipt:before {
  content: "\\e975";
}

.ati-refresh:before {
  content: "\\e9c3";
}

.ati-refresh-dollar:before {
  content: "\\e917";
}

.ati-repeat:before {
  content: "\\e929";
}

.ati-rotate:before {
  content: "\\e9c8";
}

.ati-rotate-dollar:before {
  content: "\\e918";
}

.ati-santander:before {
  content: "\\e97c";
}

.ati-send:before {
  content: "\\e9cd";
}

.ati-serasa:before {
  content: "\\e919";
}

.ati-share:before {
  content: "\\e941";
}

.ati-shield:before {
  content: "\\e91a";
}

.ati-shopping-bag:before {
  content: "\\e95a";
}

.ati-shopping-cart-down:before {
  content: "\\e925";
}

.ati-shopping-cart-right:before {
  content: "\\e969";
}

.ati-slash:before {
  content: "\\e9db";
}

.ati-sliders:before {
  content: "\\e9dc";
}

.ati-smartphone:before {
  content: "\\e9dd";
}

.ati-smartphone-contactless:before {
  content: "\\e972";
}

.ati-sort:before {
  content: "\\e935";
}

.ati-spanner:before {
  content: "\\e927";
}

.ati-split-arrows:before {
  content: "\\e93d";
}

.ati-square:before {
  content: "\\e9e0";
}

.ati-square-signs:before {
  content: "\\e91d";
}

.ati-star:before {
  content: "\\e940";
}

.ati-star-filled:before {
  content: "\\e964";
}

.ati-sun:before {
  content: "\\e950";
}

.ati-tag:before {
  content: "\\e9e7";
}

.ati-three-dots:before {
  content: "\\e9a5";
}

.ati-three-dots-horinzontal:before {
  content: "\\e93c";
}

.ati-thumbs-down:before {
  content: "\\e94c";
}

.ati-thumbs-up:before {
  content: "\\e94b";
}

.ati-ticket:before {
  content: "\\e956";
}

.ati-trash:before {
  content: "\\e9f1";
}

.ati-truck:before {
  content: "\\e9f6";
}

.ati-unlink:before {
  content: "\\e980";
}

.ati-unlock:before {
  content: "\\e955";
}

.ati-upload:before {
  content: "\\e9fe";
}

.ati-user:before {
  content: "\\ea00";
}

.ati-user-filled:before {
  content: "\\e95b";
}

.ati-user-plus:before {
  content: "\\ea03";
}

.ati-users:before {
  content: "\\ea05";
}

.ati-video:before {
  content: "\\e92a";
}

.ati-virtual-card:before {
  content: "\\e91f";
}

.ati-wallet:before {
  content: "\\e920";
}

.ati-whatsapp:before {
  content: "\\e928";
}

.ati-x:before {
  content: "\\ea11";
}

.ati-x-filled:before {
  content: "\\e962";
}

.ati-youtube:before {
  content: "\\e942";
}

.calendar-backdrop {
  width: 100vw;
  height: 100vh;
  background: rgba(var(--atlas-dark-rgb), 40%);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  visibility: hidden;
}
.calendar-backdrop.show {
  visibility: visible;
}

.vanilla-calendar {
  position: fixed;
  border-radius: 0.5rem;
  border: 1px solid #ced4da;
  padding: 1rem;
  width: 314px;
  z-index: 1000;
  background: #ffffff;
  inset: 0;
  margin: auto;
}
.vanilla-calendar:not(.show) {
  pointer-events: none;
}
.vanilla-calendar.vanilla-calendar_multiple {
  width: max-content;
  max-width: initial;
}

.vanilla-calendar-controls {
  padding: 1rem 1rem 0;
}

.vanilla-calendar-mobile-header {
  box-sizing: border-box;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #ced4da;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.vanilla-calendar-mobile-header .mobile-header-title {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #687078;
}
.vanilla-calendar-mobile-header .mobile-header-controls {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.vanilla-calendar-mobile-header .mobile-header-controls .control-button {
  background: none;
  border: 0;
  padding: 0;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.25;
  color: #687078;
}
.vanilla-calendar-mobile-header .mobile-header-controls .control-button.active {
  color: #212529;
}

.vanilla-calendar-header {
  margin-bottom: 1rem;
  height: 24px;
}
.vanilla-calendar-header .vanilla-calendar-header__content {
  gap: 0.75rem;
  padding: 0;
}
.vanilla-calendar-header .vanilla-calendar-month,
.vanilla-calendar-header .vanilla-calendar-year {
  border: 0;
  padding: 0;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  transition: all 0.15s ease;
}
.vanilla-calendar-header .vanilla-calendar-month:hover,
.vanilla-calendar-header .vanilla-calendar-year:hover {
  color: var(--atlas-primary);
}

.vanilla-calendar-arrow {
  width: 24px;
  height: 24px;
  font-size: 24px;
  padding: 0;
  line-height: normal;
  color: #687078;
  border-radius: 50%;
  transition: all 0.15s ease;
}
.vanilla-calendar-arrow:hover {
  background: var(--atlas-secondary-100);
}
.vanilla-calendar-arrow:active {
  background: var(--atlas-primary-100);
  color: var(--atlas-primary);
}

.vanilla-calendar-grid {
  gap: 0;
}
.vanilla-calendar-grid atlas-divider {
  margin-top: 40px;
}
.vanilla-calendar-grid atlas-divider:last-of-type {
  display: none;
}

.vanilla-calendar-content .vanilla-calendar-week {
  margin-bottom: 0.75rem;
}
.vanilla-calendar-content .vanilla-calendar-week .vanilla-calendar-week__day {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--atlas-primary);
  width: 40px;
  box-sizing: border-box;
  padding: 0 0.25rem;
}
.vanilla-calendar-content .vanilla-calendar-days {
  row-gap: 0;
  flex-grow: 0;
}

.vanilla-calendar-day {
  width: 40px;
  height: 40px;
  box-sizing: border-box;
  padding: 0.25rem;
  transition: background 0.15s ease;
}

.vanilla-calendar-day__btn,
.vanilla-calendar-months__month,
.vanilla-calendar-years__year {
  box-sizing: border-box;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background: #ffffff;
  border-radius: 50%;
  transition: all 0.15s ease;
}
.vanilla-calendar-day__btn.vanilla-calendar-months__month, .vanilla-calendar-day__btn.vanilla-calendar-years__year,
.vanilla-calendar-months__month.vanilla-calendar-months__month,
.vanilla-calendar-months__month.vanilla-calendar-years__year,
.vanilla-calendar-years__year.vanilla-calendar-months__month,
.vanilla-calendar-years__year.vanilla-calendar-years__year {
  width: 54px;
  height: 54px;
}
.vanilla-calendar-day__btn.vanilla-calendar-day__btn_disabled, .vanilla-calendar-day__btn.vanilla-calendar-months__month_disabled, .vanilla-calendar-day__btn.vanilla-calendar-years__year_disabled,
.vanilla-calendar-months__month.vanilla-calendar-day__btn_disabled,
.vanilla-calendar-months__month.vanilla-calendar-months__month_disabled,
.vanilla-calendar-months__month.vanilla-calendar-years__year_disabled,
.vanilla-calendar-years__year.vanilla-calendar-day__btn_disabled,
.vanilla-calendar-years__year.vanilla-calendar-months__month_disabled,
.vanilla-calendar-years__year.vanilla-calendar-years__year_disabled {
  opacity: 0.35;
}
.vanilla-calendar-day__btn:hover,
.vanilla-calendar-months__month:hover,
.vanilla-calendar-years__year:hover {
  background: var(--atlas-primary-100);
}
.vanilla-calendar-day__btn.vanilla-calendar-day__btn_selected, .vanilla-calendar-day__btn.vanilla-calendar-months__month_selected, .vanilla-calendar-day__btn.vanilla-calendar-years__year_selected,
.vanilla-calendar-months__month.vanilla-calendar-day__btn_selected,
.vanilla-calendar-months__month.vanilla-calendar-months__month_selected,
.vanilla-calendar-months__month.vanilla-calendar-years__year_selected,
.vanilla-calendar-years__year.vanilla-calendar-day__btn_selected,
.vanilla-calendar-years__year.vanilla-calendar-months__month_selected,
.vanilla-calendar-years__year.vanilla-calendar-years__year_selected {
  background: var(--atlas-primary);
  color: #ffffff;
  font-weight: 700;
}
.vanilla-calendar-day__btn.vanilla-calendar-day__btn_today,
.vanilla-calendar-months__month.vanilla-calendar-day__btn_today,
.vanilla-calendar-years__year.vanilla-calendar-day__btn_today {
  border: 1px solid var(--atlas-primary);
}

.vanilla-calendar-day_selected-first,
.vanilla-calendar-day_hover-first {
  border-top-left-radius: 50%;
  border-bottom-left-radius: 50%;
}

.vanilla-calendar-day_selected-last,
.vanilla-calendar-day_hover-last {
  border-top-right-radius: 50%;
  border-bottom-right-radius: 50%;
}

.vanilla-calendar-day_selected-first:has(.vanilla-calendar-day__btn),
.vanilla-calendar-day_selected-last:has(.vanilla-calendar-day__btn),
.vanilla-calendar-day_selected-intermediate:has(.vanilla-calendar-day__btn),
.vanilla-calendar-day_hover-intermediate:has(.vanilla-calendar-day__btn) {
  background: var(--atlas-primary-100);
}

.vanilla-calendar-day_selected-first .vanilla-calendar-day__btn,
.vanilla-calendar-day_selected-last .vanilla-calendar-day__btn,
.vanilla-calendar-day_hover-first .vanilla-calendar-day__btn,
.vanilla-calendar-day_hover-last .vanilla-calendar-day__btn,
.vanilla-calendar-day_hover-first.vanilla-calendar-day_hover-last .vanilla-calendar-day__btn {
  border-radius: 50%;
}

.vanilla-calendar-day_selected-first.vanilla-calendar-day_selected-last .vanilla-calendar-day__btn {
  border-radius: 50%;
}

.vanilla-calendar-day_hover-intermediate .vanilla-calendar-day__btn:not(.vanilla-calendar-day__btn_selected) {
  background: var(--atlas-primary-100);
  font-weight: 400;
  color: #212529;
  border-radius: 50%;
}

.vanilla-calendar-day_selected-intermediate {
  /* stylelint-disable-next-line */
}
.vanilla-calendar-day_selected-intermediate .vanilla-calendar-day__btn {
  background: var(--atlas-primary-100);
  font-weight: 400;
  color: #212529;
  border-radius: 50%;
}

.vanilla-calendar-footer {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1rem;
}

@media screen and (min-width: 992px) {
  .vanilla-calendar {
    inset: unset;
    margin: unset;
  }
  .vanilla-calendar-mobile-header {
    display: none;
  }
  .vanilla-calendar-footer {
    display: none;
  }
}
/* stylelint-enable selector-class-pattern */
/* Transitions */
.fade {
  transition: opacity 0.25s ease;
}
.fade:not(.show) {
  opacity: 0;
}

.fade-and-scale {
  opacity: 0;
  transform: scale(0.7);
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.fade-and-scale.scale-vertically {
  transform: scale(1, 0.7);
}
.fade-and-scale.show {
  opacity: 1;
  transform: scale(1);
}

:host([data-popper-placement=top]),
:host([data-popper-placement=top]) .fade-and-scale,
div[data-popper-placement=top].fade-and-scale,
div[data-popper-placement=top] > .fade-and-scale,
.fade-and-scale.scale-top {
  transform-origin: center bottom;
}

:host([data-popper-placement=top-start]),
:host([data-popper-placement=top-start]) .fade-and-scale,
div[data-popper-placement=top-start].fade-and-scale,
div[data-popper-placement=top-start] > .fade-and-scale,
.fade-and-scale.scale-top-start {
  transform-origin: left bottom;
}

:host([data-popper-placement=top-end]),
:host([data-popper-placement=top-end]) .fade-and-scale,
div[data-popper-placement=top-end].fade-and-scale,
div[data-popper-placement=top-end] > .fade-and-scale,
.fade-and-scale.scale-top-end {
  transform-origin: right bottom;
}

:host([data-popper-placement=bottom]),
:host([data-popper-placement=bottom]) .fade-and-scale,
div[data-popper-placement=bottom].fade-and-scale,
div[data-popper-placement=bottom] > .fade-and-scale,
.fade-and-scale.scale-bottom {
  transform-origin: center top;
}

:host([data-popper-placement=bottom-start]),
:host([data-popper-placement=bottom-start]) .fade-and-scale,
div[data-popper-placement=bottom-start].fade-and-scale,
div[data-popper-placement=bottom-start] > .fade-and-scale,
.fade-and-scale.scale-bottom-start {
  transform-origin: left top;
}

:host([data-popper-placement=bottom-end]),
:host([data-popper-placement=bottom-end]) .fade-and-scale,
div[data-popper-placement=bottom-end].fade-and-scale,
div[data-popper-placement=bottom-end] > .fade-and-scale,
.fade-and-scale.scale-bottom-end {
  transform-origin: right top;
}

:host([data-popper-placement=left]),
:host([data-popper-placement=left]) .fade-and-scale,
div[data-popper-placement=left].fade-and-scale,
div[data-popper-placement=left] > .fade-and-scale,
.fade-and-scale.scale-left {
  transform-origin: right center;
}

:host([data-popper-placement=left-start]),
:host([data-popper-placement=left-start]) .fade-and-scale,
div[data-popper-placement=left-start].fade-and-scale,
div[data-popper-placement=left-start] > .fade-and-scale,
.fade-and-scale.scale-left-start {
  transform-origin: right top;
}

:host([data-popper-placement=left-end]),
:host([data-popper-placement=left-end]) .fade-and-scale,
div[data-popper-placement=left-end].fade-and-scale,
div[data-popper-placement=left-end] > .fade-and-scale,
.fade-and-scale.scale-left-end {
  transform-origin: right bottom;
}

:host([data-popper-placement=right]),
:host([data-popper-placement=right]) .fade-and-scale,
div[data-popper-placement=right].fade-and-scale,
div[data-popper-placement=right] > .fade-and-scale,
.fade-and-scale.scale-right {
  transform-origin: left center;
}

:host([data-popper-placement=right-start]),
:host([data-popper-placement=right-start]) .fade-and-scale,
div[data-popper-placement=right-start].fade-and-scale,
div[data-popper-placement=right-start] > .fade-and-scale,
.fade-and-scale.scale-right-start {
  transform-origin: left top;
}

:host([data-popper-placement=right-end]),
:host([data-popper-placement=right-end]) .fade-and-scale,
div[data-popper-placement=right-end].fade-and-scale,
div[data-popper-placement=right-end] > .fade-and-scale,
.fade-and-scale.scale-right-end {
  transform-origin: left bottom;
}

:host {
  box-sizing: border-box;
  position: relative;
}

.form-control-range {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.form-control-range > .form-control-input {
  width: 85px;
}

.focus-mark {
  position: absolute;
  width: 85px;
  bottom: 0;
  left: 0;
  height: 2px;
  background: var(--atlas-primary-300);
}`;

// src/components/form/atlas-date-range/atlas-date-range.ts
var AtlasDateRange = /*#__PURE__*/(() => {
  let AtlasDateRange = class extends WithTooltipMixin(FormControl) {
    constructor() {
      super();
      this.size = "md";
      this.width = "auto";
      this.readonly = false;
      this.loading = false;
      this.requireFullRange = false;
      this._showCalendar = false;
      this._startDate = "";
      this._endDate = "";
      this._focusedInput = "";
      this._fullDateDigits = 10;
      this._defaultPlaceholder = "___/___/____";
      this._deviceController = new DeviceController(this);
      this.updateCalendarPosition = this.updateCalendarPosition.bind(this);
      this.onChangeScreenType = this.onChangeScreenType.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onInitAndUpdateCalendar = this.onInitAndUpdateCalendar.bind(this);
      this.onClickCalendarDay = this.onClickCalendarDay.bind(this);
    }
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this._deviceController.setScreenChangeCallback(this.onChangeScreenType);
      this.updateComplete.then(() => {
        this.addValidator(new DateRangeValidator());
        this.createMask();
        this.createCalendar();
        this.registerFloatingUi();
        this.updateFocusMark();
      });
    }
    /**
     * Sincroniza o valor inicial do elemento com o valor atual
     * @override
     */
    syncInitialValue() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this._initialValue = this.getSelectedRange();
      });
    }
    /**
     * Reseta o valor do elemento para o valor inicial
     * @override
     */
    reset() {
      this.valueStart = this._startDate = this._initialValue.start;
      this.valueEnd = this._endDate = this._initialValue.end;
      this._inputStart.placeholder = this._defaultPlaceholder;
      this._inputEnd.placeholder = this._defaultPlaceholder;
      this.updateCalendarSelectedDate();
      this.updateComplete.then(() => {
        this.removeStatusMessage();
      });
    }
    /**
     * Método que retorna o valor do campo de data inicial sem a máscara
     * @returns Valor do campo sem a máscara
     */
    getStartDateUnmaskedValue() {
      return this._maskInstanceStartDate.unmaskedvalue();
    }
    /**
     * Método que retorna o valor do campo de data final sem a máscara
     * @returns Valor do campo sem a máscara
     */
    getEndDateUnmaskedValue() {
      return this._maskInstanceEndDate.unmaskedvalue();
    }
    /**
     * Método que retorna o valor do campo de range, incluindo a data inicial e final
     * @returns Objeto contendo a data inicial e final
     */
    getSelectedRange() {
      return {
        start: this.valueStart || "",
        end: this.valueEnd || ""
      };
    }
    /**
     * Método que retorna a instância do calendário
     * @returns Instância do calendário
     */
    getCalendarInstance() {
      return this._calendarInstance;
    }
    /**
     * Retorna a data máxima que pode ser selecionada no calendário
     * @returns Data máxima que pode ser selecionada
     */
    getCalendarMaxDate() {
      if (this.maxDate) {
        return parseDate(this.maxDate);
      }
      const currentDate = getTodayDate();
      const currentYear = currentDate.getFullYear();
      const maxDate = new Date(this.preventLaterDate ? currentYear : currentYear + 80, currentDate.getMonth(), currentDate.getDate());
      return maxDate;
    }
    /**
     * Retorna a data mínima que pode ser selecionada no calendário
     * @returns Data mínima que pode ser selecionada
     */
    getCalendarMinDate() {
      if (this.minDate) {
        return parseDate(this.minDate);
      }
      if (this.preventPastDate) {
        return getTodayDate();
      }
      return null;
    }
    /**
     * Retorna o nome do campo de input de acordo com o tipo de range
     * @param rangeType - Tipo de range
     * @returns Nome do campo de input
     */
    getInputName(rangeType) {
      if (this.nameInputStart && this.nameInputEnd) {
        return rangeType === "start" ? this.nameInputStart : this.nameInputEnd;
      }
      const suffix = rangeType === "start" ? "Start" : "End";
      return this.name ? this.name + suffix : "";
    }
    updateCalendarDateLimits() {
      this._calendarInstance.settings.range.min = formatDateToYearMonthDay(this.getCalendarMinDate());
      this._calendarInstance.settings.range.max = formatDateToYearMonthDay(this.getCalendarMaxDate());
      this._calendarInstance.update({
        dates: true,
        month: true,
        year: true
      });
      if (!!this.value) this.reportValidity();
    }
    syncValueWithRange() {
      if (this.valueStart || this.valueEnd) {
        this.value = `${this.valueStart || ""},${this.valueEnd || ""}`;
      } else {
        this.value = "";
        this._inputStart.placeholder = this._defaultPlaceholder;
        this._inputEnd.placeholder = this._defaultPlaceholder;
      }
    }
    getFocusedInput() {
      return this.shadowRoot.querySelector(`input[data-range-type="${this._focusedInput}"]`);
    }
    setInputValue(value, rangeType) {
      if (rangeType === "start") {
        this.valueStart = value;
      } else {
        this.valueEnd = value;
      }
    }
    setInputValueIfNotMobile(value, rangeType) {
      if (!this._deviceController.isMobile) {
        this.setInputValue(value, rangeType);
      }
    }
    setSelectedDate(value, rangeType) {
      if (rangeType === "start") {
        this._startDate = value;
      } else {
        this._endDate = value;
      }
    }
    updateCalendarSelectedDate(dontJumpToSelectedDate) {
      this._calendarInstance.settings.selected.dates = [formatDateToYearMonthDay(this._startDate), formatDateToYearMonthDay(this._endDate)].filter(Boolean);
      this._calendarInstance.update({
        dates: true,
        month: !dontJumpToSelectedDate,
        year: !dontJumpToSelectedDate
      });
    }
    createMask() {
      this._maskInstanceStartDate = inputmask_utils_default({
        alias: "datepicker"
      }).mask(this._inputStart);
      this._maskInstanceEndDate = inputmask_utils_default({
        alias: "datepicker"
      }).mask(this._inputEnd);
    }
    createCalendar() {
      if (this._calendarInstance) this._calendarInstance.destroy();
      this._calendarInstance = new VanillaCalendar2(this._calendarWrapper, {
        type: this._deviceController.isMobile ? "default" : "multiple",
        months: this._deviceController.isMobile ? 1 : 2,
        jumpMonths: 1,
        jumpToSelectedDate: true,
        date: {
          min: "",
          max: ""
        },
        settings: {
          lang: "pt-BR",
          iso8601: false,
          range: {
            min: formatDateToYearMonthDay(this.getCalendarMinDate()),
            max: formatDateToYearMonthDay(this.getCalendarMaxDate()),
            edgesOnly: true
          },
          visibility: {
            daysOutside: false
          },
          selection: {
            day: "multiple-ranged"
          }
        },
        actions: {
          clickDay: this.onClickCalendarDay,
          initCalendar: this.onInitAndUpdateCalendar,
          updateCalendar: this.onInitAndUpdateCalendar
        },
        DOMTemplates: {
          default: this.getCalendarDaysTemplate(),
          multiple: this.getCalendarDaysMultipleTemplate(),
          month: this.getCalendarMonthsTemplate(),
          year: this.getCalendarYearsTemplate()
        },
        CSSClasses: {
          arrowPrev: "atlas-icon ati-chevron-left",
          arrowNext: "atlas-icon ati-chevron-right"
        }
      });
      this._calendarInstance.init();
      this.setSelectedDate(this.valueStart || "", "start");
      this.setSelectedDate(this.valueEnd || "", "end");
      this.updateCalendarSelectedDate();
    }
    getCalendarHeaderTemplate(renderArrows) {
      return `
            <div class="vanilla-calendar-mobile-header">
                <span class="mobile-header-title">Selecione o per\xEDodo</span>
                <div class="mobile-header-controls">
                    <button class="control-button control-button-start">Data inicial</button>
                    <atlas-icon name="arrow-right" size="2x" theme="secondary"></atlas-icon>
                    <button class="control-button control-button-end">Data final</button>
                </div>
            </div>
            <div class="vanilla-calendar-header">
                ${renderArrows ? "<#ArrowPrev />" : ""}
                <div class="vanilla-calendar-header__content">
                    <#Month />
                    <#Year />
                </div>
                ${renderArrows ? "<#ArrowNext />" : ""}
            </div>
        `;
    }
    getCalendarFooterTemplate() {
      return `
            <div class="vanilla-calendar-footer">
                <atlas-button type="ghost" description="Fechar" class="close-button"></atlas-button>
                <atlas-button type="ghost" description="Confirmar" class="confirm-button"></atlas-button>
            </div>
        `;
    }
    getCalendarDaysTemplate() {
      return `
            ${this.getCalendarHeaderTemplate(true)}
            <div class="vanilla-calendar-wrapper">
                <#WeekNumbers />
                <div class="vanilla-calendar-content">
                    <#Week />
                    <#Days />
                </div>
            </div>
            ${this.getCalendarFooterTemplate()}
        `;
    }
    getCalendarDaysMultipleTemplate() {
      return `
            <div class="vanilla-calendar-controls">
                <#ArrowPrev />
                <#ArrowNext />
            </div>
            <div class="vanilla-calendar-grid">
                <#Multiple>
                    <div class="vanilla-calendar-column">
                        ${this.getCalendarHeaderTemplate(false)}
                        <div class="vanilla-calendar-wrapper">
                            <#WeekNumbers />
                            <div class="vanilla-calendar-content">
                                <#Week />
                                <#Days />
                            </div>
                        </div>
                    </div>
                    <atlas-divider vertical></atlas-divider>
                <#/Multiple>
            </div>
            ${this.getCalendarFooterTemplate()}
        `;
    }
    getCalendarMonthsTemplate() {
      return `
            ${this.getCalendarHeaderTemplate(false)}
            <div class="vanilla-calendar-wrapper">
                <div class="vanilla-calendar-content">
                    <#Months />
                </div>
            </div>
            ${this.getCalendarFooterTemplate()}
        `;
    }
    getCalendarYearsTemplate() {
      return `
            ${this.getCalendarHeaderTemplate(true)}
            <div class="vanilla-calendar-wrapper">
                <div class="vanilla-calendar-content">
                    <#Years />
                </div>
            </div>
            ${this.getCalendarFooterTemplate()}
        `;
    }
    onActionButtonClick() {
      if (this._showCalendar) {
        this.hideCalendar();
      } else {
        this.showCalendar();
      }
    }
    onClickFormControl() {
      if (this._startDate.length === this._fullDateDigits && this._endDate.length !== this._fullDateDigits) {
        this._inputEnd.focus();
      } else {
        this._inputStart.focus();
      }
    }
    onChangeScreenType() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this.createCalendar();
        this.registerFloatingUi();
        if (this._showCalendar && !this._deviceController.isMobile) {
          document.addEventListener("click", this.onDocumentClick);
        } else {
          document.removeEventListener("click", this.onDocumentClick);
        }
      });
    }
    onDocumentClick(event) {
      return __async(this, null, function* () {
        if (!this._showCalendar) return;
        const composedPath = event.composedPath();
        const isCalendarTarget = composedPath.includes(this._calendarWrapper);
        const isInputTarget = composedPath.includes(this._formControl);
        if (isCalendarTarget || isInputTarget) return;
        this.hideCalendar();
      });
    }
    onInitAndUpdateCalendar() {
      this.bindCalendarCustomButtons();
      this.bindCalendarDaysHover();
      this.bindCalendarControlButtons();
      this._calendarWrapper.querySelectorAll("button, atlas-button, [tabindex='0']").forEach(el => el.setAttribute("tabindex", "-1"));
      this.updateCalendarFocusControl();
    }
    onClickCalendarDay(event) {
      const target = event.target;
      const selectedDate = target.getAttribute("data-calendar-day");
      const formattedDate = formatDate(selectedDate);
      this.setSelectedDate(formattedDate, this._focusedInput);
      this.setInputValueIfNotMobile(formattedDate, this._focusedInput);
      this.updateCalendarSelectedDate(true);
      setTimeout(() => {
        const parsedStartDate = parseDate(this._startDate);
        const parsedEndDate = parseDate(this._endDate);
        if (this._focusedInput === "start") {
          if (parsedEndDate && parsedStartDate > parsedEndDate) {
            this.swapStartDateOnCalendarDayClick(formattedDate);
          }
          this._inputEnd.focus();
          return;
        }
        if (this._focusedInput === "end") {
          if (!parsedStartDate) {
            this._inputStart.focus();
            return;
          }
          if (parsedStartDate > parsedEndDate) {
            this.swapStartDateOnCalendarDayClick(formattedDate);
            this._inputEnd.focus();
            return;
          }
          if (!this._deviceController.isMobile) {
            this.hideCalendar();
          } else {
            this._inputStart.focus();
          }
        }
      }, 0);
    }
    swapStartDateOnCalendarDayClick(formattedDate) {
      this.setSelectedDate(formattedDate, "start");
      this.setInputValueIfNotMobile(formattedDate, "start");
      this.setSelectedDate("", "end");
      this.setInputValueIfNotMobile("", "end");
      this.updateCalendarSelectedDate(true);
    }
    handleInputClick(event) {
      event.stopPropagation();
      if (!this._deviceController.isMobile) {
        this.showCalendar();
      }
    }
    handleFocus(event) {
      const input = event.target;
      this._focusedInput = input.getAttribute("data-range-type");
      this.updateFocusMark();
      if (!this._deviceController.isMobile) {
        this.showCalendar();
      }
    }
    handleBlur() {
      if (!this._showCalendar) {
        this._focusedInput = "";
        this.updateFocusMark();
      }
      setTimeout(() => {
        if (document.activeElement !== this) {
          this.reportValidity();
          emit(this, "atlas-form-element-touch", {
            trackDisable: true
          });
        }
      }, 0);
    }
    handleInput(event) {
      const input = event.target;
      const rangeType = input.getAttribute("data-range-type");
      this.setInputValue(input.value, rangeType);
      this.setSelectedDate(inputmask_utils_default.isValid(input.value, {
        alias: "datepicker"
      }) ? input.value : "", rangeType);
      this.updateCalendarSelectedDate();
      if (input.value.length === this._fullDateDigits) {
        if (rangeType === "start" && this._inputEnd.value.length !== this._fullDateDigits) {
          this._inputEnd.focus();
        } else if (this._inputStart.value.length !== this._fullDateDigits) {
          this._inputStart.focus();
        }
      }
    }
    handleInputKeydown(event) {
      switch (event.key) {
        case "ArrowUp":
        case "ArrowDown":
          this.incrementOrDecrementCurrentDate(event);
          event.preventDefault();
          break;
        case "Backspace":
          this.changeFocusOnBackspace(event);
          break;
        case "Tab":
          this.hideCalendar();
          break;
      }
    }
    incrementOrDecrementCurrentDate(event) {
      const input = event.target;
      const rangeType = input.getAttribute("data-range-type");
      const todayDate = getTodayDate();
      const factor = event.key === "ArrowUp" ? 1 : -1;
      let newDate = todayDate;
      if (!!input.value) {
        newDate = getDateFromString(input.value);
        newDate.setDate(newDate.getDate() + factor);
      }
      if (event.key === "ArrowUp" && newDate > this.getCalendarMaxDate()) return;
      if (event.key === "ArrowDown" && this.getCalendarMinDate() && newDate < this.getCalendarMinDate()) return;
      const formattedNewDate = formatDate(newDate);
      this.setInputValue(formattedNewDate, rangeType);
      this.setSelectedDate(formattedNewDate, rangeType);
      this.updateCalendarSelectedDate();
    }
    changeFocusOnBackspace(event) {
      const input = event.target;
      const rangeType = input.getAttribute("data-range-type");
      if (input.value.length === 0 && rangeType === "end") {
        this._inputStart.focus();
      }
    }
    showCalendar() {
      if (this._showCalendar) return;
      this._showCalendar = true;
      this._calendarWrapper.removeAttribute("aria-hidden");
      if (!this._focusedInput) {
        this._focusedInput = "start";
        this.updateFocusMark();
      }
      if (!this._deviceController.isMobile) {
        setTimeout(() => {
          document.addEventListener("click", this.onDocumentClick);
        }, 350);
      }
    }
    hideCalendar() {
      this._showCalendar = false;
      this._calendarWrapper.setAttribute("aria-hidden", "true");
      this._focusedInput = "";
      this.updateFocusMark();
      document.removeEventListener("click", this.onDocumentClick);
    }
    registerFloatingUi() {
      var _a;
      (_a = this._floatingUiCleanup) == null ? void 0 : _a.call(this);
      this._calendarWrapper.style.top = "";
      this._calendarWrapper.style.left = "";
      if (!this._deviceController.isMobile) {
        this._floatingUiCleanup = autoUpdate3(this._formControl, this._calendarWrapper, this.updateCalendarPosition);
      }
    }
    updateCalendarPosition() {
      computePosition3(this._formControl, this._calendarWrapper, {
        placement: "bottom-start",
        strategy: "fixed",
        middleware: [offset4({
          mainAxis: 4,
          crossAxis: 0
        }), flip3(), shift3({
          padding: 8
        })]
      }).then(({
        x,
        y,
        placement
      }) => {
        this._calendarWrapper.setAttribute("data-popper-placement", placement);
        Object.assign(this._calendarWrapper.style, {
          left: `${x}px`,
          top: `${y}px`
        });
      });
    }
    bindCalendarCustomButtons() {
      this._calendarWrapper.addEventListener("atlas-button-click", event => {
        const button = event.target;
        if (button.classList.contains("confirm-button")) {
          this.setInputValue(this._startDate, "start");
          this.setInputValue(this._endDate, "end");
        } else {
          this.setSelectedDate("", "start");
          this.setSelectedDate("", "end");
        }
        this.hideCalendar();
      });
    }
    bindCalendarDaysHover() {
      this._calendarWrapper.addEventListener("mouseover", event => {
        const input = this.getFocusedInput();
        const target = event.target;
        const isDayDiv = target.classList.contains("vanilla-calendar-day");
        const dayButton = isDayDiv ? target.querySelector(".vanilla-calendar-day__btn") : target;
        const formattedDate = dayButton == null ? void 0 : dayButton.getAttribute("data-calendar-day");
        if (input && !this._deviceController.isMobile) {
          input.placeholder = formatDate(formattedDate) || this._defaultPlaceholder;
        }
      });
      this._calendarWrapper.addEventListener("mouseout", () => {
        const input = this.getFocusedInput();
        if (input && !this._deviceController.isMobile) {
          input.placeholder = this._defaultPlaceholder;
        }
      });
    }
    bindCalendarControlButtons() {
      this._calendarWrapper.querySelectorAll(".control-button").forEach(button => {
        button.addEventListener("click", () => {
          const rangeType = button.classList.contains("control-button-start") ? "start" : "end";
          this._focusedInput = rangeType;
          this.updateFocusMark();
        });
      });
    }
    updateFocusMark() {
      const input = this.getFocusedInput();
      const focusMark = this.shadowRoot.querySelector(".focus-mark");
      if (input) {
        focusMark.style.left = `${input.offsetLeft}px`;
        focusMark.style.width = `${input.offsetWidth}px`;
        focusMark.style.display = "block";
      } else {
        focusMark.style.display = "none";
      }
      this.updateCalendarFocusControl();
    }
    updateCalendarFocusControl() {
      this._calendarWrapper.querySelectorAll(".control-button").forEach(button => {
        button.classList.toggle("active", button.classList.contains(`control-button-${this._focusedInput}`));
        if (button.classList.contains("control-button-start")) {
          button.innerHTML = this._startDate || "Data inicial";
        } else {
          button.innerHTML = this._endDate || "Data final";
        }
      });
    }
    renderIcon() {
      return when55(this.loading || !this._deviceController.isMobile, () => {
        return html81`
                <atlas-icon name=${this.loading ? "loader" : "calendar"} size="2x" class="input-icon"></atlas-icon>
            `;
      });
    }
    renderInput(rangeType) {
      const ariaDescribedBy = this.helperText ? `${this.id}-helper` : "";
      const value = this.getSelectedRange()[rangeType] || "";
      const inputClass = {
        "form-control-input": true
      };
      return html81`
            <input
                aria-describedby="${ariaDescribedBy}"
                id=${this.id + "-" + rangeType}
                name="${this.getInputName(rangeType)}"
                class=${classMap58(inputClass)}
                type="text"
                inputmode="numeric"
                placeholder=${this._defaultPlaceholder}
                .value=${live4(value)}
                ?disabled=${this.disabled}
                ?readonly=${this.readonly}
                ?required=${this.required}
                @focus=${this.handleFocus}
                @blur=${this.handleBlur}
                @click=${this.handleInputClick}
                @input=${this.handleInput}
                @keydown=${this.handleInputKeydown}
                autocomplete="off"
                data-range-type=${rangeType}
            />
        `;
    }
    renderFormControl() {
      const formControlClass = {
        "form-control": true,
        "form-control-range": true,
        "form-control-sm": this.size === "sm",
        "form-control-lg": this.size === "lg",
        "has-icon": this.loading || !this._deviceController.isMobile,
        "has-action-button": this._deviceController.isMobile,
        [`is-${this._status}`]: this.getShowStatus()
      };
      return html81`
            <div class=${classMap58(formControlClass)} @click=${this.onClickFormControl}>
                ${this.renderInput("start")}
                <atlas-icon name="arrow-right" size="2x"></atlas-icon>
                ${this.renderInput("end")}
                <div class="focus-mark"></div>
            </div>
            ${this.renderIcon()} ${this.renderStatusMessage()}
        `;
    }
    renderActionButton() {
      return when55(this._deviceController.isMobile, () => html81`
                <atlas-button
                    ?disabled=${this.disabled || this.loading}
                    icon="calendar"
                    size=${this.size}
                    theme="secondary"
                    type="outlined"
                    in-group-last
                    @atlas-button-click=${this.onActionButtonClick}
                ></atlas-button>
            `);
    }
    /**
     * @internal
     * @override
     */
    render() {
      const inputGroupClass = {
        "input-group": true,
        "skeleton": this.skeletonLoading
      };
      const calendarClass = {
        "calendar-wrapper": true,
        "fade-and-scale": true,
        "show": this._showCalendar
      };
      const calendarBackdropClass = {
        "calendar-backdrop": true,
        "show": this._showCalendar
      };
      return html81`
            ${this.renderLabel()}
            <div class="input-wrapper">
                <div class=${classMap58(inputGroupClass)} data-atlas-tooltip="date-range-tooltip">
                    ${this.renderFormControl()}
                </div>
                ${this.renderActionButton()}
            </div>
            ${this.renderHelperText({
        isInputHelper: true
      })} ${this.renderTooltip("date-range-tooltip")}
            ${when55(this._deviceController.isMobile, () => html81`<div class=${classMap58(calendarBackdropClass)}></div>`)}
            <div class=${classMap58(calendarClass)} aria-hidden="true"></div>
        `;
    }
  };
  AtlasDateRange.styles = atlas_date_range_default;
  return AtlasDateRange;
})();
__decorateClass([property83({
  type: String
})], AtlasDateRange.prototype, "size", 2);
__decorateClass([property83({
  type: String
})], AtlasDateRange.prototype, "width", 2);
__decorateClass([property83({
  type: Boolean,
  reflect: true
})], AtlasDateRange.prototype, "readonly", 2);
__decorateClass([property83({
  type: Boolean
})], AtlasDateRange.prototype, "loading", 2);
__decorateClass([property83({
  type: String,
  attribute: "min-date"
})], AtlasDateRange.prototype, "minDate", 2);
__decorateClass([property83({
  type: String,
  attribute: "max-date"
})], AtlasDateRange.prototype, "maxDate", 2);
__decorateClass([property83({
  type: Boolean,
  reflect: true,
  attribute: "prevent-past-date"
})], AtlasDateRange.prototype, "preventPastDate", 2);
__decorateClass([property83({
  type: Boolean,
  reflect: true,
  attribute: "prevent-later-date"
})], AtlasDateRange.prototype, "preventLaterDate", 2);
__decorateClass([property83({
  type: String,
  attribute: "value-start"
})], AtlasDateRange.prototype, "valueStart", 2);
__decorateClass([property83({
  type: String,
  attribute: "value-end"
})], AtlasDateRange.prototype, "valueEnd", 2);
__decorateClass([property83({
  type: String,
  attribute: "name-input-start"
})], AtlasDateRange.prototype, "nameInputStart", 2);
__decorateClass([property83({
  type: String,
  attribute: "name-input-end"
})], AtlasDateRange.prototype, "nameInputEnd", 2);
__decorateClass([property83({
  type: Boolean,
  attribute: "require-full-range"
})], AtlasDateRange.prototype, "requireFullRange", 2);
__decorateClass([state41()], AtlasDateRange.prototype, "_showCalendar", 2);
__decorateClass([state41()], AtlasDateRange.prototype, "_startDate", 2);
__decorateClass([state41()], AtlasDateRange.prototype, "_endDate", 2);
__decorateClass([state41()], AtlasDateRange.prototype, "_focusedInput", 2);
__decorateClass([query15(".form-control")], AtlasDateRange.prototype, "_formControl", 2);
__decorateClass([query15("input[data-range-type='start']")], AtlasDateRange.prototype, "_inputStart", 2);
__decorateClass([query15("input[data-range-type='end']")], AtlasDateRange.prototype, "_inputEnd", 2);
__decorateClass([query15(".calendar-wrapper")], AtlasDateRange.prototype, "_calendarWrapper", 2);
__decorateClass([Watch(["minDate", "maxDate", "preventPastDate", "preventLaterDate"], true)], AtlasDateRange.prototype, "updateCalendarDateLimits", 1);
__decorateClass([Watch(["valueStart", "valueEnd"])], AtlasDateRange.prototype, "syncValueWithRange", 1);
AtlasDateRange = __decorateClass([customElement74("atlas-date-range")], AtlasDateRange);

// src/components/form/atlas-editor/atlas-editor.ts
import { html as html82 } from "lit";
import { customElement as customElement75, property as property84, query as query16, state as state42 } from "lit/decorators.js";
import { classMap as classMap59 } from "lit/directives/class-map.js";
import { when as when56 } from "lit/directives/when.js";
import Tribute from "tributejs";

// src/vendors/froala-editor.ts
import FroalaEditor from "froala-editor";
FroalaEditor.DefineIcon("variables", {
  NAME: "Vari\xE1veis",
  template: "text"
});
FroalaEditor.RegisterCommand("variables", {
  title: "Vari\xE1veis",
  focus: true,
  undo: true,
  refreshAfterCallback: true,
  callback: function () {
    this.events.trigger("variables:click", []);
  }
});
FroalaEditor.PLUGINS.fixPasteBug = function fixPasteBugPlugin(editor) {
  return {
    _init() {
      editor.events.on("paste.after", () => {
        editor.selection.save();
        const t = document.createElement("template");
        t.innerHTML = editor.html.get(true);
        const offender = t.content.querySelector("#isPasted");
        if (offender) {
          offender.removeAttribute("id");
          editor.html.set(t.innerHTML);
        }
        editor.selection.restore();
      });
    }
  };
};

// src/components/form/atlas-editor/atlas-editor.ts
import "froala-editor/js/languages/pt_br.js";
import "froala-editor/js/plugins/align.min.js";
var AtlasEditor = class extends WithCharsCounterMixin(FormElement) {
  constructor() {
    super();
    this.placeholder = "";
    this.variablesTrigger = "{";
    this._hasFocus = false;
    this.onEditorInitialized = this.onEditorInitialized.bind(this);
    this.onEditorContentChanged = this.onEditorContentChanged.bind(this);
    this.onEditorKeyDown = this.onEditorKeyDown.bind(this);
    this.onEditorBlur = this.onEditorBlur.bind(this);
    this.onEditorFocus = this.onEditorFocus.bind(this);
    this.onEditorToolbarShow = this.onEditorToolbarShow.bind(this);
    this.onVariablesButtonClick = this.onVariablesButtonClick.bind(this);
    this.onSelectVariable = this.onSelectVariable.bind(this);
    this.onEditorCommandsAfter = this.onEditorCommandsAfter.bind(this);
  }
  connectedCallback() {
    super.connectedCallback();
    this.updateComplete.then(() => {
      this.registerTribute();
      this.createHtmlEditor();
    });
  }
  disconnectedCallback() {
    var _a, _b, _c;
    super.disconnectedCallback();
    (_b = this._tributeInstace) == null ? void 0 : _b.detach((_a = this._editorInstance) == null ? void 0 : _a.el);
    (_c = this._editorInstance) == null ? void 0 : _c.destroy();
  }
  /**
   * @override
   *
   * Obtém o valor do elemento
   * @returns {string} - O valor do elemento
   */
  getElementValue() {
    return this.textOnly ? this.getCleanValue() : this.value;
  }
  /**
   * Retorna o valor do editor sem tags HTML, apenas o texto limpo
   * @returns {string} O texto limpo
   */
  getCleanValue() {
    var _a;
    if ((_a = this._editorInstance) == null ? void 0 : _a.el) {
      return this._editorInstance.el.innerText;
    }
    const tempContainer = document.createElement("div");
    tempContainer.innerHTML = this.value;
    const innerText = tempContainer.innerText;
    tempContainer.remove();
    return innerText;
  }
  /**
   * Define o foco no editor
   */
  focus() {
    const textValue = this.getCleanValue().trim();
    if (textValue === "") {
      this._editorInstance.selection.setAtStart(this._editorInstance.$el.get(0), true);
    } else {
      this._editorInstance.selection.setAtEnd(this._editorInstance.$el.get(0), true);
    }
    this._editorInstance.selection.restore();
  }
  onChangeValue() {
    if (this._editorInstance.html.get() !== this.value) {
      this._editorInstance.html.set(this.value);
    }
    this.updateCharsCounterWithEditorContent();
    emit(this, "atlas-editor-change", {
      detail: this.value,
      trackDisable: true
    });
  }
  /**
   * @internal
   * @override
   */
  onChangeDisabled() {
    super.onChangeDisabled();
    if (this.disabled) {
      this._editorInstance.edit.off();
    } else {
      this._editorInstance.edit.on();
    }
  }
  /**
   * @internal
   * @override
   */
  applySkeleton() {
    return __async(this, null, function* () {
      yield this.updateComplete;
      const allElements = this.querySelectorAll("*");
      allElements.forEach(element => {
        element.toggleAttribute("skeleton-loading", this.skeletonLoading);
      });
      emit(this, "atlas-element-change-skeleton", {
        trackDisable: true
      });
    });
  }
  hasVariables() {
    var _a;
    return !!((_a = this.variables) == null ? void 0 : _a.length);
  }
  /**
   * Retorna as variáveis utilizadas no editor
   * @returns {Array<string>} - As variáveis utilizadas
   */
  getUsedVariables() {
    const content = this.getCleanValue();
    const usedVariables = content.match(/{{(.*?)}}/g);
    return usedVariables != null ? usedVariables : [];
  }
  getToolbarTextButtons() {
    if (!this.showTextButtons) return {};
    return {
      moreText: {
        buttons: ["bold", "italic", "underline", "strikeThrough"],
        buttonsVisible: 4
      }
    };
  }
  getToolbarParagraphButtons() {
    if (!this.showParagraphButtons) return {};
    return {
      moreParagraph: {
        buttons: ["alignLeft", "alignCenter", "alignRight", "alignJustify"],
        buttonsVisible: 4
      }
    };
  }
  getToolbarVariablesButtons() {
    if (!this.showVariablesButtons || !this.hasVariables()) return {};
    return {
      moreVariables: {
        buttons: ["variables"],
        align: "right",
        buttonsVisible: 1
      }
    };
  }
  getToolbarMiscellaneousButtons() {
    if (!this.showMiscellaneousButtons) return {};
    return {
      moreMisc: {
        buttons: ["undo", "redo", "selectAll"],
        align: "right",
        buttonsVisible: 3
      }
    };
  }
  registerTribute() {
    if (!this.hasVariables()) return;
    this._tributeInstace = new Tribute({
      trigger: this.variablesTrigger,
      requireLeadingSpace: false,
      values: this.variables,
      noMatchTemplate: () => '<span class="not-found">N\xE3o foram encontradas vari\xE1veis com esse termo<span>',
      selectTemplate: this.onSelectVariable
    });
  }
  createHtmlEditor() {
    const froalaConfig = {
      key: "jUA1yD4C3A1C3A1F1F2qYFa1UQRFQIVc2MSMd1IWPNb1IFd1yD2I2D1B2C7D2C1C5D1C1==",
      attribution: false,
      language: "pt_br",
      pluginsEnabled: ["align", "fixPasteBug"],
      toolbarInline: this.inline,
      multiLine: !this.inline && !this.disableLineBreak,
      placeholderText: this.placeholder || "",
      toolbarVisibleWithoutSelection: true,
      height: this.inline ? null : this.height || 150,
      pastePlain: true,
      toolbarButtons: __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, this.getToolbarTextButtons()), this.getToolbarParagraphButtons()), this.getToolbarVariablesButtons()), this.getToolbarMiscellaneousButtons()),
      fullPage: false,
      events: {
        "initialized": this.onEditorInitialized,
        "contentChanged": this.onEditorContentChanged,
        "keyup": this.onEditorContentChanged,
        "blur": this.onEditorBlur,
        "focus": this.onEditorFocus,
        "toolbar.show": this.onEditorToolbarShow,
        "variables:click": this.onVariablesButtonClick,
        "commands.after": this.onEditorCommandsAfter
      }
    };
    if (this.textOnly) {
      froalaConfig.shortcutsEnabled = ["undo", "redo"];
      froalaConfig.htmlAllowedTags = ["p", "span"];
    }
    this._editorInstance = new FroalaEditor(this._editorElement, froalaConfig);
  }
  onEditorInitialized() {
    if (this.hasVariables()) {
      this._tributeInstace.attach(this._editorInstance.el);
    }
    if (this.value) {
      this._editorInstance.html.set(this.value);
    }
    if (this.disabled) {
      this._editorInstance.edit.off();
    }
    this._editorInstance.events.on("keydown", this.onEditorKeyDown, true);
    this.updateCharsCounterWithEditorContent();
  }
  onEditorContentChanged() {
    this.value = this._editorInstance.html.get();
  }
  fixVariablesHTML() {
    let content = this._editorInstance.html.get();
    const innerTagsRegex = /{{\s*(<[^>]+>)([^<]+)<\/[^>]+>\s*}}/g;
    content = content.replace(innerTagsRegex, (_, tagStart, variableContent) => {
      return `${tagStart}{{${variableContent}}}</${tagStart.match(/<(\w+)/)[1]}>`;
    });
    const brokenTagsRegex = /<([a-zA-Z0-9]+)[^>]*>\s*\{\{[^}]*\}\}\s*<\/\1>/g;
    const correctTagsRegex = /^<([a-zA-Z]+)[^>]*>\{\{[^<]+?\}\}<\/\1>$/;
    content = content.replace(brokenTagsRegex, match => {
      if (correctTagsRegex.test(match)) {
        return match;
      }
      return match.replace(/<[^>]+>/g, "");
    });
    this._editorInstance.html.set(content);
  }
  onEditorCommandsAfter(command) {
    const formattingCommands = ["bold", "italic", "underline", "strikeThrough"];
    if (formattingCommands.includes(command)) {
      this.fixVariablesHTML();
    }
  }
  onEditorKeyDown(e) {
    if (!this.hasVariables()) return true;
    if (e.key == "Enter" && this._tributeInstace.isActive) {
      return false;
    }
    return true;
  }
  onEditorBlur() {
    this._hasFocus = false;
    this.reportValidity();
    emit(this, "atlas-editor-blur", {
      trackDisable: true
    });
    emit(this, "atlas-form-element-touch", {
      trackDisable: true
    });
  }
  onEditorFocus() {
    setTimeout(() => {
      this._hasFocus = true;
      emit(this, "atlas-editor-focus", {
        trackDisable: true
      });
    }, 0);
  }
  onEditorToolbarShow() {
    if (!this.inline) return true;
    const toolbar = this._editorInstance.$tb.get(0);
    const editor = this._editorInstance.el;
    const {
      x,
      y
    } = editor.getBoundingClientRect();
    setTimeout(() => {
      toolbar.style.display = "block";
      const toolbarTop = y - toolbar.offsetHeight - 20 + window.scrollY;
      toolbar.style.top = `${toolbarTop}px`;
      toolbar.style.left = `${x - 12}px`;
    }, 0);
    return false;
  }
  onVariablesButtonClick() {
    if (!this._hasFocus) {
      this.focus();
    }
    if (!this._tributeInstace.isActive) {
      this._tributeInstace.current.mentionText = "";
      this._tributeInstace.showMenuForCollection(this._editorInstance.el);
    }
  }
  onSelectVariable(item) {
    if (typeof item === "undefined") return null;
    const selection = window.getSelection();
    const range6 = selection.getRangeAt(0);
    const container = range6.startContainer;
    if (container.nodeType === Node.TEXT_NODE) {
      const text = container.textContent;
      const variableRegex = /{{([^{}]*)}}/g;
      const matches = [...text.matchAll(variableRegex)];
      let foundVariable = null;
      matches.forEach(match => {
        const posStart = match.index;
        const posEnd = match.index + match[0].length;
        if (range6.startOffset >= posStart && range6.startOffset <= posEnd) {
          foundVariable = {
            start: posStart,
            end: posEnd
          };
          return;
        }
      });
      if (foundVariable) {
        const before = text.substring(0, foundVariable.start);
        const after = text.substring(foundVariable.end);
        container.textContent = before + item.original.value + after;
        const newCursorPosition = foundVariable.start + item.original.value.length;
        const newRange = document.createRange();
        newRange.setStart(container, newCursorPosition);
        newRange.setEnd(container, newCursorPosition);
        selection.removeAllRanges();
        selection.addRange(newRange);
        this._editorInstance.events.trigger("contentChanged", []);
        return null;
      }
    }
    return item.original.value;
  }
  updateCharsCounterWithEditorContent() {
    if (!this.enableCharsCounter) return;
    const usedVariables = this.value ? this.getUsedVariables() : [];
    let content = this.value ? this.getCleanValue() : "";
    let variablesWeight = 0;
    usedVariables.forEach(variable => {
      content = content.replace(variable, "");
      const variableObject = this.variables.find(v => v.key === variable);
      variablesWeight += (variableObject == null ? void 0 : variableObject.weight) || (variableObject == null ? void 0 : variableObject.value.length) || 0;
    });
    this.updateCharsCounterIfEnabled(content.length + variablesWeight);
  }
  render() {
    const editorClass = {
      "atlas-editor": true,
      "atlas-editor-inline": this.inline,
      "atlas-editor-disabled": this.disabled,
      "atlas-editor-skeleton": this.skeletonLoading,
      "resizable": this.resizable,
      [`is-${this._status}`]: this.getShowStatus()
    };
    return html82`
            <div class=${classMap59(editorClass)}></div>
            ${when56(!this.disabled, () => this.renderCharsCounter())} ${this.renderStatusMessage()}
        `;
  }
  createRenderRoot() {
    return this;
  }
};
__decorateClass([property84({
  type: String
})], AtlasEditor.prototype, "placeholder", 2);
__decorateClass([property84({
  type: Boolean
})], AtlasEditor.prototype, "inline", 2);
__decorateClass([property84({
  type: Number
})], AtlasEditor.prototype, "height", 2);
__decorateClass([property84({
  type: Boolean
})], AtlasEditor.prototype, "resizable", 2);
__decorateClass([property84({
  type: Boolean,
  attribute: "show-text-buttons"
})], AtlasEditor.prototype, "showTextButtons", 2);
__decorateClass([property84({
  type: Boolean,
  attribute: "show-paragraph-buttons"
})], AtlasEditor.prototype, "showParagraphButtons", 2);
__decorateClass([property84({
  type: Boolean,
  attribute: "show-miscellaneous-buttons"
})], AtlasEditor.prototype, "showMiscellaneousButtons", 2);
__decorateClass([property84({
  type: Boolean,
  attribute: "show-variables-buttons"
})], AtlasEditor.prototype, "showVariablesButtons", 2);
__decorateClass([property84({
  type: Array
})], AtlasEditor.prototype, "variables", 2);
__decorateClass([property84({
  type: String,
  attribute: "variables-trigger"
})], AtlasEditor.prototype, "variablesTrigger", 2);
__decorateClass([property84({
  type: Number
})], AtlasEditor.prototype, "maxlength", 2);
__decorateClass([property84({
  type: Boolean,
  attribute: "text-only"
})], AtlasEditor.prototype, "textOnly", 2);
__decorateClass([property84({
  type: Boolean,
  attribute: "disable-line-break"
})], AtlasEditor.prototype, "disableLineBreak", 2);
__decorateClass([state42()], AtlasEditor.prototype, "_hasFocus", 2);
__decorateClass([query16(".atlas-editor")], AtlasEditor.prototype, "_editorElement", 2);
__decorateClass([Watch("value", true)], AtlasEditor.prototype, "onChangeValue", 1);
AtlasEditor = __decorateClass([customElement75("atlas-editor")], AtlasEditor);

// src/components/form/atlas-filter/atlas-filter.ts
import { html as html83 } from "lit";
import { customElement as customElement76, property as property85, state as state43 } from "lit/decorators.js";
import { when as when57 } from "lit/directives/when.js";
var AtlasFilter = class extends AtlasElement {
  /** @internal */
  constructor() {
    super();
    this.description = "Filtros";
    this.date = false;
    this.block = false;
    this._openAdvanced = false;
    this._counter = 0;
    this._advancedFilterCounter = 0;
    this._simpleFilterCounter = 0;
    this._deviceController = new DeviceController(this);
    this.openAdvancedFilter = this.openAdvancedFilter.bind(this);
    this.cleanFilter = this.cleanFilter.bind(this);
    this.applyFilter = this.applyFilter.bind(this);
    this.hideAdvancedFilter = this.hideAdvancedFilter.bind(this);
    this.updateCounter = this.updateCounter.bind(this);
    this.syncFilterForms();
  }
  connectedCallback() {
    var _a;
    (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
    this.updateComplete.then(() => {
      this.buildDescription();
    });
  }
  disconnectedCallback() {
    var _a;
    (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
    this.clearFilterEvents();
  }
  /** @internal */
  getUpdateComplete() {
    return __async(this, null, function* () {
      var _a, _b;
      yield __superGet(AtlasFilter.prototype, this, "getUpdateComplete").call(this);
      yield Promise.all([(_a = this.simpleFilterForm) == null ? void 0 : _a.updateComplete, (_b = this.advancedFilterForm) == null ? void 0 : _b.updateComplete]);
      return true;
    });
  }
  /**
   * Retorna os dados dos filtros
   * @param asFormData - Retorna os dados dos filtros em FormData
   * @returns {object | FormData} - Os dados dos filtros
   */
  getFilterData(asFormData = false) {
    if (this.advancedFilterForm) {
      return this.getAdvancedFilterData(asFormData);
    }
    return this.getSimpleFilterData(asFormData);
  }
  /**
   * Retorna os dados do filtro simples
   * @param asFormData - Retorna os dados dos filtros em FormData
   * @returns {object | FormData} - Os dados do filtro
   */
  getSimpleFilterData(asFormData = false) {
    var _a;
    return (_a = this.simpleFilterForm) == null ? void 0 : _a.getFilterFormData(asFormData);
  }
  /**
   * Retorna os dados dos filtro avançado
   * @param asFormData - Retorna os dados dos filtros em FormData
   * @returns {object | FormData} - Os dados do filtro
   */
  getAdvancedFilterData(asFormData = false) {
    var _a;
    return (_a = this.advancedFilterForm) == null ? void 0 : _a.getFilterFormData(asFormData);
  }
  /**
   * Retorna os dados agrupados por grupo do filtro simples
   * @returns {object} - Os dados agrupados por grupo do filtro
   */
  getGroupedSimpleFilterData() {
    var _a;
    return (_a = this.simpleFilterForm) == null ? void 0 : _a.getGroupedFilterData();
  }
  /**
   * Retorna os dados agrupados por grupo do filtro avançado
   * @returns {object} - Os dados agrupados por grupo do filtro
   */
  getGroupedAdvancedFilterData() {
    var _a;
    return (_a = this.advancedFilterForm) == null ? void 0 : _a.getGroupedFilterData();
  }
  /**
   * Habilita os botões do filtro
   */
  enableButtons() {
    var _a, _b;
    (_a = this.simpleFilterForm) == null ? void 0 : _a.enableButtons();
    (_b = this.advancedFilterForm) == null ? void 0 : _b.enableButtons();
  }
  /**
   * Desabilita os botões do filtro
   */
  disableButtons() {
    var _a, _b;
    (_a = this.simpleFilterForm) == null ? void 0 : _a.disableButtons();
    (_b = this.advancedFilterForm) == null ? void 0 : _b.disableButtons();
  }
  syncFilterForms() {
    return __async(this, null, function* () {
      yield this.updateComplete;
      const simpleFilterSlot = this.shadowRoot.querySelector("slot[name=simple-filter]");
      const advancedFilterSlot = this.shadowRoot.querySelector("slot[name=advanced-filter]");
      if (simpleFilterSlot.assignedElements()[0]) {
        this.simpleFilterForm = simpleFilterSlot.assignedElements()[0];
        this.simpleFilterForm.type = "simple";
      }
      if (advancedFilterSlot.assignedElements()[0]) {
        this.advancedFilterForm = advancedFilterSlot.assignedElements()[0];
        this.advancedFilterForm.type = "advanced";
        if (this._deviceController.isMobile) {
          this.simpleFilterForm.hidden = true;
        }
        this.simpleFilterForm.type = "simple";
        this.simpleFilterForm.hasAdvancedFilter = true;
      }
      this.bindFilterEvents();
    });
  }
  bindFilterEvents() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    (_a = this.simpleFilterForm) == null ? void 0 : _a.addEventListener("atlas-open-advanced-filter", this.openAdvancedFilter);
    (_b = this.simpleFilterForm) == null ? void 0 : _b.addEventListener("atlas-clean-filter", this.cleanFilter);
    (_c = this.simpleFilterForm) == null ? void 0 : _c.addEventListener("atlas-apply-filter", this.applyFilter);
    (_d = this.simpleFilterForm) == null ? void 0 : _d.addEventListener("atlas-filter-close", this.hideAdvancedFilter);
    (_e = this.simpleFilterForm) == null ? void 0 : _e.addEventListener("atlas-filter-form-count", this.updateCounter);
    (_f = this.advancedFilterForm) == null ? void 0 : _f.addEventListener("atlas-clean-filter", this.cleanFilter);
    (_g = this.advancedFilterForm) == null ? void 0 : _g.addEventListener("atlas-apply-filter", this.applyFilter);
    (_h = this.advancedFilterForm) == null ? void 0 : _h.addEventListener("atlas-filter-close", this.hideAdvancedFilter);
    (_i = this.advancedFilterForm) == null ? void 0 : _i.addEventListener("atlas-filter-form-count", this.updateCounter);
    this.addEventListener("atlas-offcanvas-close", this.hideAdvancedFilter);
  }
  clearFilterEvents() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    (_a = this.simpleFilterForm) == null ? void 0 : _a.removeEventListener("atlas-open-advanced-filter", this.openAdvancedFilter);
    (_b = this.simpleFilterForm) == null ? void 0 : _b.removeEventListener("atlas-clean-filter", this.cleanFilter);
    (_c = this.simpleFilterForm) == null ? void 0 : _c.removeEventListener("atlas-apply-filter", this.applyFilter);
    (_d = this.simpleFilterForm) == null ? void 0 : _d.removeEventListener("atlas-filter-close", this.hideAdvancedFilter);
    (_e = this.simpleFilterForm) == null ? void 0 : _e.removeEventListener("atlas-filter-form-count", this.updateCounter);
    (_f = this.advancedFilterForm) == null ? void 0 : _f.removeEventListener("atlas-clean-filter", this.cleanFilter);
    (_g = this.advancedFilterForm) == null ? void 0 : _g.removeEventListener("atlas-apply-filter", this.applyFilter);
    (_h = this.advancedFilterForm) == null ? void 0 : _h.removeEventListener("atlas-filter-close", this.hideAdvancedFilter);
    (_i = this.advancedFilterForm) == null ? void 0 : _i.removeEventListener("atlas-filter-form-count", this.updateCounter);
    this.removeEventListener("atlas-offcanvas-close", this.hideAdvancedFilter);
  }
  cleanFilter(event) {
    return __async(this, null, function* () {
      var _a, _b;
      (_a = this.simpleFilterForm) == null ? void 0 : _a.resetFilterForm();
      (_b = this.advancedFilterForm) == null ? void 0 : _b.resetFilterForm();
      yield this.updateComplete;
      this.updateDescription();
      event.stopPropagation();
      emit(this, "atlas-clean-filter", {
        detail: event.detail
      });
    });
  }
  applyFilter(event) {
    var _a, _b, _c, _d;
    const filterForm = event.target;
    if (filterForm.type === "advanced") {
      (_b = this.simpleFilterForm) == null ? void 0 : _b.mergeFilterForm((_a = this.advancedFilterForm) == null ? void 0 : _a.getFilterFormElements());
    }
    if (filterForm.type === "simple") {
      (_d = this.advancedFilterForm) == null ? void 0 : _d.mergeFilterForm((_c = this.simpleFilterForm) == null ? void 0 : _c.getFilterFormElements());
    }
    this.updateDescription();
    event.stopPropagation();
    emit(this, "atlas-apply-filter", {
      detail: event.detail
    });
  }
  openAdvancedFilter() {
    var _a, _b;
    this._openAdvanced = true;
    (_b = this.advancedFilterForm) == null ? void 0 : _b.mergeFilterForm((_a = this.simpleFilterForm) == null ? void 0 : _a.getFilterFormElements());
  }
  updateDescription() {
    var _a, _b;
    (_a = this.simpleFilterForm) == null ? void 0 : _a.countFilters();
    (_b = this.advancedFilterForm) == null ? void 0 : _b.countFilters();
  }
  updateCounter(event) {
    const filterForm = event.target;
    if (filterForm.type === "advanced") {
      this._advancedFilterCounter = event.detail.counter;
    }
    if (filterForm.type === "simple") {
      this._simpleFilterCounter = event.detail.counter;
    }
    this._counter = this._advancedFilterCounter > this._simpleFilterCounter ? this._advancedFilterCounter : this._simpleFilterCounter;
    if (this.advancedFilterForm) {
      this.simpleFilterForm.advancedFilterCounter = this._advancedFilterCounter - this._simpleFilterCounter;
    }
    this.buildDescription();
  }
  hideAdvancedFilter() {
    this._openAdvanced = false;
  }
  buildDescription() {
    if (this.date) {
      this.buildDescriptionForDateFilter();
      return;
    }
    this.description = `Filtros ${this._counter > 0 ? `(${this._counter})` : ``}`;
  }
  buildDescriptionForDateFilter() {
    const selectedRadioElement = Array.from(this.simpleFilterForm.querySelectorAll("atlas-radio")).find(radioElement => radioElement.checked);
    if (!selectedRadioElement) {
      this.description = `Filtros`;
      return;
    }
    if (selectedRadioElement.value === "custom") {
      const datepickers = this.querySelectorAll("atlas-date-picker");
      this._startDate = datepickers[0].value;
      this._finalDate = datepickers[1].value;
      this.description = `${this._startDate} - ${this._finalDate}`;
    } else {
      this.description = getSlotTextContent(selectedRadioElement.shadowRoot.querySelector("slot"));
    }
  }
  getIcon() {
    return this.date ? "calendar" : "filter";
  }
  renderMobileButton() {
    return html83`
            <atlas-button
                description="${this.description}"
                icon="${this.getIcon()}"
                type="outlined"
                @atlas-button-click=${this.openAdvancedFilter}
                ?block=${this.block}
            ></atlas-button>

            <atlas-offcanvas class="dropdown-wrapper" header=${this.header} ?open=${this._openAdvanced} filter>
                <slot name="advanced-filter"></slot>
                <slot name="simple-filter"></slot>
            </atlas-offcanvas>
        `;
  }
  renderButton() {
    return html83`
            <atlas-dropdown-button
                description="${this.description}"
                icon="${this.getIcon()}"
                type="outlined"
                ?block=${this.block}
                dropdown-placement=${this.dropdownPlacement}
                filter
            >
                <slot name="simple-filter"></slot>
            </atlas-dropdown-button>

            <atlas-offcanvas header=${this.header} ?open=${this._openAdvanced} filter>
                <slot name="advanced-filter"></slot>
            </atlas-offcanvas>
        `;
  }
  /** @internal */
  render() {
    const button = when57(!this._deviceController.isMobile, () => this.renderButton(), () => this.renderMobileButton());
    return html83` <div class="atlas-filter">${button}</div> `;
  }
};
__decorateClass([property85({
  type: String
})], AtlasFilter.prototype, "header", 2);
__decorateClass([property85({
  type: String
})], AtlasFilter.prototype, "description", 2);
__decorateClass([property85({
  type: Boolean
})], AtlasFilter.prototype, "date", 2);
__decorateClass([property85({
  type: Boolean
})], AtlasFilter.prototype, "block", 2);
__decorateClass([property85({
  type: String,
  attribute: "dropdown-placement"
})], AtlasFilter.prototype, "dropdownPlacement", 2);
__decorateClass([state43()], AtlasFilter.prototype, "_openAdvanced", 2);
__decorateClass([state43()], AtlasFilter.prototype, "_counter", 2);
AtlasFilter = __decorateClass([customElement76("atlas-filter")], AtlasFilter);

// src/components/form/atlas-filter-form/atlas-filter-form.ts
import { html as html84 } from "lit";
import { customElement as customElement77, property as property86, queryAssignedElements, state as state44 } from "lit/decorators.js";
import { when as when58 } from "lit/directives/when.js";
import { classMap as classMap60 } from "lit/directives/class-map.js";

// src/components/form/atlas-filter-form/atlas-filter-form.scss
import { css as css72 } from "lit-element/lit-element.js";
var atlas_filter_form_default = css72`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
:host {
  display: contents;
}

.atlas-filter-form {
  display: flex;
  flex-direction: column;
}
.atlas-filter-form .atlas-filter-form-content {
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  padding: 1.5rem;
}
.atlas-filter-form .atlas-filter-form-content .col {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.atlas-filter-form .atlas-filter-form-content .auto-col {
  display: flex;
  box-sizing: border-box;
  gap: 1.5rem;
  flex-direction: row;
}
.atlas-filter-form .atlas-filter-form-footer {
  border-top: 1px solid #ced4da;
  padding: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;
}
.atlas-filter-form .atlas-filter-form-footer .actions-buttons {
  display: flex;
  flex-direction: row;
  gap: 16px;
}
.atlas-filter-form.atlas-advanced-filter-form {
  height: calc(100% - 4.5rem);
}
.atlas-filter-form.atlas-advanced-filter-form .atlas-filter-form-content {
  height: calc(100% - 5rem);
  flex: 1 0 auto;
  flex-direction: column;
  overflow-y: auto;
  gap: 0;
  padding: 0;
}
.atlas-filter-form.atlas-advanced-filter-form .atlas-filter-form-content .col {
  gap: 0;
  max-width: unset;
}
.atlas-filter-form.atlas-advanced-filter-form .atlas-filter-form-content .auto-col {
  display: contents;
}
.atlas-filter-form.atlas-advanced-filter-form .atlas-filter-form-content ::slotted(atlas-filter-group) {
  max-width: unset;
  padding: 1.5rem 1rem;
}
.atlas-filter-form.atlas-advanced-filter-form .atlas-filter-form-content ::slotted(atlas-filter-group:not(:last-child)) {
  border-bottom: 1px solid #ced4da;
}
.atlas-filter-form.atlas-advanced-filter-form .atlas-filter-form-footer {
  flex: 0 0 auto;
}`;

// src/components/form/atlas-filter-form/atlas-filter-form.ts
var AtlasFilterForm = /*#__PURE__*/(() => {
  let AtlasFilterForm = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.hasAdvancedFilter = false;
      this.advancedFilterCounter = 0;
      this._filterHiddenInputs = [];
      this._deviceController = new DeviceController(this);
    }
    /** @internal */
    getUpdateComplete() {
      return __async(this, null, function* () {
        const filterGroups = this.getFilterGroups();
        yield __superGet(AtlasFilterForm.prototype, this, "getUpdateComplete").call(this);
        yield Promise.all(filterGroups.map(element => element.updateComplete));
        return true;
      });
    }
    /** 
     * Desabilita os botões de ação do formulário
     */
    disableButtons() {
      const atlasButtons = this.shadowRoot.querySelectorAll("atlas-button");
      atlasButtons.forEach(button => {
        button.disable();
      });
    }
    /** 
     * Habilita os botões de ação do formulário
     */
    enableButtons() {
      const atlasButtons = this.shadowRoot.querySelectorAll("atlas-button");
      atlasButtons.forEach(button => {
        button.loading = false;
        button.enable();
      });
    }
    /** 
     * Retorna os dados do formulário de filtro
     * @param {boolean} asFormData - Define se os dados devem ser retornados como FormData
     * @returns {object | FormData} - Os dados do formulário
     */
    getFilterFormData(asFormData) {
      return getFormValues(this, asFormData);
    }
    /** 
     * Retorna os elementos do formulário de filtro
     * @returns {FormElement[]} - Array de elementos do formulário
     */
    getFilterFormElements() {
      return getAllFormElements(this);
    }
    /** 
     * Retorna os dados do formulário de filtro agrupados por grupo
     * @returns {object[]} - Array de objetos contendo os dados do formulário agrupados por grupo
     */
    getGroupedFilterData() {
      const filterGroups = this.getFilterGroups();
      const groupedFilterData = [];
      filterGroups.forEach(filterGroup => {
        groupedFilterData.push({
          name: filterGroup.name,
          value: filterGroup.getFilterGroupData(false)
        });
      });
      return groupedFilterData;
    }
    /** 
     * Permite mesclar os dados de um formulário de filtro com os dados do formulário atual(utilizado para mesclar os dados de um formulário de filtro avançado com um formulário de filtro simples, e vice-versa)
     */
    mergeFilterForm(formElements) {
      this.getFilterGroups().forEach(filter => filter.mergeFilterGroup(formElements));
    }
    /** 
     * Reseta os dados do formulário de filtro
     */
    resetFilterForm() {
      this.getFilterGroups().forEach(filter => filter.resetFilterData());
      this._filterHiddenInputs.forEach(input => input.value = input.defaultValue);
    }
    /**
     * Atualiza o contador de filtro
     */
    countFilters() {
      const filterGroups = this.getFilterGroups();
      const counter = filterGroups.reduce((acc, filter) => acc + filter.countFilters(), 0);
      emit(this, "atlas-filter-form-count", {
        detail: {
          counter
        },
        trackDisable: true
      });
    }
    onChangeCol1Slot() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this.shadowRoot.querySelector(".auto-col").style.display = "none";
        this.shadowRoot.querySelector(".col-1").style.display = "flex";
        if (this.type === "advanced" || this.type === "simple" && this._deviceController.isMobile) {
          this.setCollapsibleGroups();
        }
        this.countFilters();
      });
    }
    onChangeCol2Slot() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this.shadowRoot.querySelector(".auto-col").style.display = "none";
        this.shadowRoot.querySelector(".col-2").style.display = "flex";
        if (this.type === "advanced" || this.type === "simple" && this._deviceController.isMobile) {
          this.setCollapsibleGroups();
        }
        this.countFilters();
      });
    }
    onChangeCol3Slot() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this.shadowRoot.querySelector(".auto-col").style.display = "none";
        this.shadowRoot.querySelector(".col-3").style.display = "flex";
        if (this.type === "advanced" || this.type === "simple" && this._deviceController.isMobile) {
          this.setCollapsibleGroups();
        }
        this.countFilters();
      });
    }
    onChangeCol4Slot() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this.shadowRoot.querySelector(".auto-col").style.display = "none";
        this.shadowRoot.querySelector(".col-4").style.display = "flex";
        if (this.type === "advanced" || this.type === "simple" && this._deviceController.isMobile) {
          this.setCollapsibleGroups();
        }
        this.countFilters();
      });
    }
    onChangeMainSlot() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this.shadowRoot.querySelectorAll(".col").forEach(col => {
          col.style.display = "none";
        });
        if (this.type === "advanced" || this.type === "simple" && this._deviceController.isMobile) {
          this.setCollapsibleGroups();
        }
        this.countFilters();
        this._filterHiddenInputs = this.getFilterHiddenInputs();
      });
    }
    setCollapsibleGroups() {
      const filterGroups = this.getFilterGroups();
      filterGroups.forEach(filterGroup => {
        if (filterGroup.header) {
          filterGroup.collapsible = true;
        }
      });
    }
    openAdvancedFilter() {
      emit(this, "atlas-open-advanced-filter", {
        detail: {
          filterData: this.getFilterFormData(false),
          groupedFilterData: this.getGroupedFilterData()
        }
      });
    }
    cleanFilter(event) {
      const {
        target
      } = event;
      target.loading = true;
      this.disableButtons();
      emit(this, "atlas-clean-filter", {
        detail: {
          filterData: this.getFilterFormData(false),
          groupedFilterData: this.getGroupedFilterData()
        }
      });
      emit(this, "atlas-filter-close", {
        trackDisable: true
      });
    }
    applyFilter(event) {
      const {
        target
      } = event;
      target.loading = true;
      this.disableButtons();
      emit(this, "atlas-apply-filter", {
        detail: {
          filterData: this.getFilterFormData(false),
          groupedFilterData: this.getGroupedFilterData()
        }
      });
      emit(this, "atlas-filter-close", {
        trackDisable: true
      });
    }
    getFilterGroups() {
      return [...this._filterGroups, ...this._filterGroupsCol1, ...this._filterGroupsCol2, ...this._filterGroupsCol3, ...this._filterGroupsCol4];
    }
    getFilterHiddenInputs() {
      const slot = this.shadowRoot.querySelector("slot:not([name])");
      if (!slot) return [];
      return slot.assignedElements({
        flatten: true
      }).filter(element => INPUT_ELEMENTS.includes(element.tagName.toLowerCase())).filter(input => input.type === "hidden");
    }
    renderFooter() {
      const advancedFilterButton = when58(this.type === "simple" && this.hasAdvancedFilter, () => html84`
                <atlas-button
                    description=${this.advancedFilterCounter > 0 ? `Filtros avan\xE7ados (${this.advancedFilterCounter})` : `Filtros avan\xE7ados`}
                    theme="secondary"
                    type="outlined"
                    @atlas-button-click=${this.openAdvancedFilter}
                ></atlas-button>
            `);
      return html84`
            <div class="atlas-filter-form-footer">
                <div>${advancedFilterButton}</div>
                <div class="actions-buttons">
                    <atlas-button
                        description="Limpar"
                        theme="secondary"
                        @atlas-button-click=${this.cleanFilter}
                    ></atlas-button>
                    <atlas-button description="Aplicar" @atlas-button-click=${this.applyFilter}></atlas-button>
                </div>
            </div>
        `;
    }
    /** @internal */
    render() {
      const filterClass = {
        "atlas-filter-form": true,
        "atlas-advanced-filter-form": this.type === "advanced" || this._deviceController.isMobile
      };
      return html84`
            <div class="${classMap60(filterClass)}">
                <div class="atlas-filter-form-content">
                    <div class="auto-col">
                        <slot @slotchange=${this.onChangeMainSlot}></slot>
                    </div>

                    <div class="col col-1">
                        <slot name="col-1" @slotchange=${this.onChangeCol1Slot}> </slot>
                    </div>

                    <div class="col col-2">
                        <slot name="col-2" @slotchange=${this.onChangeCol2Slot}> </slot>
                    </div>

                    <div class="col col-3">
                        <slot name="col-3" @slotchange=${this.onChangeCol3Slot}> </slot>
                    </div>

                    <div class="col col-4">
                        <slot name="col-4" @slotchange=${this.onChangeCol4Slot}> </slot>
                    </div>
                </div>
                ${this.renderFooter()}
            </div>
        `;
    }
  };
  AtlasFilterForm.styles = atlas_filter_form_default;
  return AtlasFilterForm;
})();
__decorateClass([property86({
  type: String
})], AtlasFilterForm.prototype, "type", 2);
__decorateClass([state44()], AtlasFilterForm.prototype, "hasAdvancedFilter", 2);
__decorateClass([state44()], AtlasFilterForm.prototype, "advancedFilterCounter", 2);
__decorateClass([queryAssignedElements({
  selector: "atlas-filter-group",
  flatten: true
})], AtlasFilterForm.prototype, "_filterGroups", 2);
__decorateClass([queryAssignedElements({
  slot: "col-1",
  selector: "atlas-filter-group",
  flatten: true
})], AtlasFilterForm.prototype, "_filterGroupsCol1", 2);
__decorateClass([queryAssignedElements({
  slot: "col-2",
  selector: "atlas-filter-group",
  flatten: true
})], AtlasFilterForm.prototype, "_filterGroupsCol2", 2);
__decorateClass([queryAssignedElements({
  slot: "col-3",
  selector: "atlas-filter-group",
  flatten: true
})], AtlasFilterForm.prototype, "_filterGroupsCol3", 2);
__decorateClass([queryAssignedElements({
  slot: "col-4",
  selector: "atlas-filter-group",
  flatten: true
})], AtlasFilterForm.prototype, "_filterGroupsCol4", 2);
AtlasFilterForm = __decorateClass([customElement77("atlas-filter-form")], AtlasFilterForm);

// src/components/form/atlas-filter-group/atlas-filter-group.ts
import { html as html88 } from "lit";
import { customElement as customElement80, property as property90, query as query18 } from "lit/decorators.js";
import { when as when61 } from "lit/directives/when.js";
import { classMap as classMap61 } from "lit/directives/class-map.js";

// src/internals/mixins/with-collapse-mixin.ts
import { html as html86 } from "lit";
import { property as property88 } from "lit/decorators.js";
import { when as when59 } from "lit/directives/when.js";

// src/components/layout/atlas-collapse/atlas-collapse.ts
import { LitElement as LitElement22, html as html85 } from "lit";
import { customElement as customElement78, property as property87, query as query17, state as state45 } from "lit/decorators.js";
import { styleMap as styleMap18 } from "lit/directives/style-map.js";

// src/components/layout/atlas-collapse/atlas-collapse.scss
import { css as css73 } from "lit-element/lit-element.js";
var atlas_collapse_default = css73`/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
:host {
  display: inherit;
  height: 100%;
}

.collapse-wrapper {
  transition: max-height 0.35s ease;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  width: 100%;
  height: 100%;
}`;

// src/components/layout/atlas-collapse/atlas-collapse.ts
var AtlasCollapse = /*#__PURE__*/(() => {
  let AtlasCollapse = class extends LitElement22 {
    constructor() {
      super(...arguments);
      this.show = false;
      this._maxHeight = "0px";
      this._overflow = "hidden";
    }
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.updateComplete.then(() => {
        if (this.show) {
          this._overflow = "visible";
          this._maxHeight = "unset";
        } else {
          this._overflow = "hidden";
          this._maxHeight = `0px`;
        }
      });
    }
    applyMaxHeight() {
      this._overflow = "hidden";
      this._maxHeight = `${this._wrapperRef.scrollHeight}px`;
      if (!this.show) {
        setTimeout(() => {
          this._maxHeight = `0px`;
        }, 0);
      } else {
        this._maxHeight = `${this._wrapperRef.scrollHeight}px`;
        setTimeout(() => {
          this._overflow = "visible";
          this._maxHeight = "unset";
        }, 350);
      }
    }
    render() {
      const wrapperStyles = {
        maxHeight: this._maxHeight,
        overflow: this._overflow
      };
      return html85`
            <div class="collapse-wrapper" style=${styleMap18(wrapperStyles)}>
                <slot></slot>
            </div>
        `;
    }
  };
  AtlasCollapse.styles = atlas_collapse_default;
  return AtlasCollapse;
})();
__decorateClass([property87({
  type: Boolean
})], AtlasCollapse.prototype, "show", 2);
__decorateClass([state45()], AtlasCollapse.prototype, "_maxHeight", 2);
__decorateClass([state45()], AtlasCollapse.prototype, "_overflow", 2);
__decorateClass([query17(".collapse-wrapper")], AtlasCollapse.prototype, "_wrapperRef", 2);
__decorateClass([Watch("show", true)], AtlasCollapse.prototype, "applyMaxHeight", 1);
AtlasCollapse = __decorateClass([customElement78("atlas-collapse")], AtlasCollapse);

// src/internals/mixins/with-collapse-mixin.ts
var WithCollapseMixin = superClass => {
  class WithCollapseClass extends superClass {
    constructor() {
      super(...arguments);
      this.collapsed = false;
      this.expanded = false;
      this.hideCollapsibleButton = false;
    }
    collapse() {
      if (!this.collapsible) return;
      this.collapsed = true;
    }
    expand() {
      if (!this.collapsible) return;
      this.collapsed = false;
    }
    toggleCollapse(event) {
      if (!this.collapsible) return;
      event.stopPropagation();
      this.collapsed = !this.collapsed;
      emit(this, "atlas-collapse-button-click", {
        detail: {
          collapsed: this.collapsed
        }
      });
    }
    renderContentWithCollapse(template) {
      return html86`
                <atlas-collapse ?show=${this.collapsible ? !this.collapsed : true}> ${template} </atlas-collapse>
            `;
    }
    renderCollapseButton(theme, iconColor) {
      return when59(!this.hideCollapsibleButton, () => html86`
                    <atlas-collapse-button
                        icon-color=${iconColor || "secondary"}
                        theme=${theme || "primary"}
                        @click=${this.toggleCollapse}
                        ?collapsed=${this.collapsed}
                    ></atlas-collapse-button>
                `);
    }
  }
  __decorateClass([property88({
    type: Boolean
  })], WithCollapseClass.prototype, "collapsible", 2);
  __decorateClass([property88({
    type: Boolean,
    reflect: true
  })], WithCollapseClass.prototype, "collapsed", 2);
  __decorateClass([property88({
    type: Boolean,
    reflect: true
  })], WithCollapseClass.prototype, "expanded", 2);
  __decorateClass([property88({
    type: Boolean,
    reflect: true,
    attribute: "hide-collapsible-button"
  })], WithCollapseClass.prototype, "hideCollapsibleButton", 2);
  return WithCollapseClass;
};

// src/components/layout/atlas-element-group/atlas-element-group.ts
import { html as html87 } from "lit";
import { customElement as customElement79, property as property89, queryAssignedElements as queryAssignedElements2, state as state46 } from "lit/decorators.js";
import { when as when60 } from "lit/directives/when.js";

// src/components/layout/atlas-element-group/atlas-element-group.scss
import { css as css74 } from "lit-element/lit-element.js";
var atlas_element_group_default = css74`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  width: 100%;
}

:host([auto]) {
  width: auto;
}

:host([fluid]) {
  width: 100%;
  height: 100%;
}

.atlas-layout {
  margin: 0;
  padding: 0;
  width: 100%;
  box-sizing: border-box;
  align-items: normal;
}
.atlas-layout.grid {
  display: grid;
}
.atlas-layout.grid.mobile {
  grid-template-columns: 1fr;
}
.atlas-layout.grid.mobile slot::slotted(*) {
  grid-column: 1 !important;
}
.atlas-layout:not(.grid) {
  display: flex;
  flex-direction: column;
}
.atlas-layout:not(.grid).wrap {
  flex-wrap: wrap;
}
.atlas-layout:not(.grid).inline {
  flex-direction: row;
}
.atlas-layout.fluid {
  height: 100%;
}
.atlas-layout.align-top {
  align-items: flex-start;
}
.atlas-layout.align-center {
  align-items: center;
}
.atlas-layout.align-bottom {
  align-items: flex-end;
}
.atlas-layout.justify-start {
  justify-content: flex-start;
}
.atlas-layout.justify-center {
  justify-content: center;
}
.atlas-layout.justify-end {
  justify-content: flex-end;
}
.atlas-layout.justify-space-between {
  justify-content: space-between;
}
.atlas-layout.justify-space-around {
  justify-content: space-around;
}
.atlas-layout.justify-space-evenly {
  justify-content: space-evenly;
}
.atlas-layout.mobile:not(.inline) slot::slotted(*:not(.no-expand)) {
  width: 100% !important;
}

.gap-0 {
  gap: 0;
}

.grid.row-gap-0 {
  row-gap: 0;
}
.grid.column-gap-0 {
  column-gap: 0;
}

.mobile-gap-0 {
  gap: 0 !important;
}
.mobile-gap-0.grid {
  row-gap: 0 !important;
  column-gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem;
}

.grid.row-gap-1 {
  row-gap: 0.25rem;
}
.grid.column-gap-1 {
  column-gap: 0.25rem;
}

.mobile-gap-1 {
  gap: 0.25rem !important;
}
.mobile-gap-1.grid {
  row-gap: 0.25rem !important;
  column-gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem;
}

.grid.row-gap-2 {
  row-gap: 0.5rem;
}
.grid.column-gap-2 {
  column-gap: 0.5rem;
}

.mobile-gap-2 {
  gap: 0.5rem !important;
}
.mobile-gap-2.grid {
  row-gap: 0.5rem !important;
  column-gap: 0.5rem !important;
}

.gap-3 {
  gap: 0.75rem;
}

.grid.row-gap-3 {
  row-gap: 0.75rem;
}
.grid.column-gap-3 {
  column-gap: 0.75rem;
}

.mobile-gap-3 {
  gap: 0.75rem !important;
}
.mobile-gap-3.grid {
  row-gap: 0.75rem !important;
  column-gap: 0.75rem !important;
}

.gap-4 {
  gap: 1rem;
}

.grid.row-gap-4 {
  row-gap: 1rem;
}
.grid.column-gap-4 {
  column-gap: 1rem;
}

.mobile-gap-4 {
  gap: 1rem !important;
}
.mobile-gap-4.grid {
  row-gap: 1rem !important;
  column-gap: 1rem !important;
}

.gap-5 {
  gap: 1.25rem;
}

.grid.row-gap-5 {
  row-gap: 1.25rem;
}
.grid.column-gap-5 {
  column-gap: 1.25rem;
}

.mobile-gap-5 {
  gap: 1.25rem !important;
}
.mobile-gap-5.grid {
  row-gap: 1.25rem !important;
  column-gap: 1.25rem !important;
}

.gap-6 {
  gap: 1.5rem;
}

.grid.row-gap-6 {
  row-gap: 1.5rem;
}
.grid.column-gap-6 {
  column-gap: 1.5rem;
}

.mobile-gap-6 {
  gap: 1.5rem !important;
}
.mobile-gap-6.grid {
  row-gap: 1.5rem !important;
  column-gap: 1.5rem !important;
}

.gap-7 {
  gap: 2rem;
}

.grid.row-gap-7 {
  row-gap: 2rem;
}
.grid.column-gap-7 {
  column-gap: 2rem;
}

.mobile-gap-7 {
  gap: 2rem !important;
}
.mobile-gap-7.grid {
  row-gap: 2rem !important;
  column-gap: 2rem !important;
}

.gap-8 {
  gap: 2.5rem;
}

.grid.row-gap-8 {
  row-gap: 2.5rem;
}
.grid.column-gap-8 {
  column-gap: 2.5rem;
}

.mobile-gap-8 {
  gap: 2.5rem !important;
}
.mobile-gap-8.grid {
  row-gap: 2.5rem !important;
  column-gap: 2.5rem !important;
}

.gap-9 {
  gap: 3rem;
}

.grid.row-gap-9 {
  row-gap: 3rem;
}
.grid.column-gap-9 {
  column-gap: 3rem;
}

.mobile-gap-9 {
  gap: 3rem !important;
}
.mobile-gap-9.grid {
  row-gap: 3rem !important;
  column-gap: 3rem !important;
}`;

// src/components/layout/atlas-element-group/atlas-element-group.ts
var AtlasElementGroup = /*#__PURE__*/(() => {
  let AtlasElementGroup = class extends AtlasLayout {
    constructor() {
      super();
      this.name = "";
      this.disabled = false;
      this.requiredFields = 0;
      this.requiredFieldsErrorMessage = "";
      this._valid = true;
      this.onChangeCheckedState = this.onChangeCheckedState.bind(this);
    }
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.addEventListener("atlas-checkbox-change", this.onChangeCheckedState);
      this.addEventListener("atlas-radio-change", this.onChangeCheckedState);
    }
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      this.removeEventListener("atlas-checkbox-change", this.onChangeCheckedState);
      this.removeEventListener("atlas-radio-change", this.onChangeCheckedState);
    }
    setErrorMessage(message) {
      this._errorMessage = message;
      this._valid = false;
      this.validateRequiredFields();
    }
    removeErrorMessage() {
      this._errorMessage = "";
      this._valid = true;
      this.validateRequiredFields();
    }
    reset() {
      const checkElements = this.getAllChildrenCheckElements();
      checkElements.forEach(element => element.reset());
      this.updateComplete.then(() => {
        this._valid = true;
      });
    }
    checkValidity() {
      this._valid = this.countCheckedFields() >= this.requiredFields;
      return this._valid;
    }
    reportValidity() {
      const isValid = this.checkValidity();
      this.validateRequiredFields();
      return isValid;
    }
    onChangeCheckedState() {
      this.reportValidity();
    }
    getAllChildrenCheckElements() {
      return Array.from(this.querySelectorAll(CHECK_ELEMENTS.toString()));
    }
    getAllChildrenSelectElements() {
      return Array.from(this.querySelectorAll(SELECT_ELEMENTS.toString()));
    }
    getAllChildrenInputElements() {
      return Array.from(this.querySelectorAll(INPUT_ELEMENTS.toString()));
    }
    getElementValue() {
      var _a;
      const checkElements = this.getAllChildrenCheckElements();
      const checkedFields = checkElements.filter(field => field.checked);
      const allElementsAreRadio = checkElements.every(field => field.tagName === "ATLAS-RADIO");
      const allElementsAreSelectCardRadio = checkElements.every(field => {
        return field.tagName === "ATLAS-SELECTION-CARD" && field.type === "radio";
      });
      if (allElementsAreRadio || allElementsAreSelectCardRadio) return (_a = checkedFields[0]) == null ? void 0 : _a.getElementValue();
      return checkedFields.map(field => field.getElementValue());
    }
    validateRequiredFields() {
      this.getAllChildrenCheckElements().forEach(slotted => {
        slotted.setValidationState(this._valid);
      });
    }
    countCheckedFields() {
      return this.getAllChildrenCheckElements().reduce((acc, slotted) => slotted.checked ? acc + 1 : acc, 0);
    }
    toggleDisabled(forceState) {
      this.disabled = typeof forceState === "boolean" ? forceState : !this.disabled;
    }
    setPropertiesToSlottedElements() {
      this.getAllChildrenCheckElements().filter(element => element.tagName !== "ATLAS-SELECTION-CARD").forEach(element => {
        element.toggleAttribute("disabled", this.disabled);
        element.toggleAttribute("ignore-validations", this.requiredFields > 0);
        if (!this.name || element.name) return;
        element.setAttribute("name", this.name);
      });
    }
    setRequiredFieldsErrorMessage() {
      if (this.requiredFieldsErrorMessage) {
        this._errorMessage = this.requiredFieldsErrorMessage;
        return;
      }
      this._errorMessage = `Selecione pelo menos ${this.requiredFields} 
        ${this.requiredFields > 1 ? " op\xE7\xF5es " : " op\xE7\xE3o "} para continuar`;
    }
    shouldDisableSlottedElements() {
      this.getAllChildrenCheckElements().filter(element => element.tagName !== "ATLAS-SELECTION-CARD").forEach(slotted => {
        slotted.toggleAttribute("disabled", this.disabled);
      });
    }
    onSlotChange() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const buttonElements = ["ATLAS-BUTTON", "ATLAS-DROPDOWN-BUTTON"];
        this.slottedElements.filter(element => buttonElements.includes(element.tagName)).forEach(element => {
          element.toggleAttribute("block", this._deviceController.isMobile);
        });
        this.setPropertiesToSlottedElements();
      });
    }
    renderValidationMessage() {
      return when60(!this._valid, () => html87`
                <atlas-text size="xs" theme="danger" class="invalid-feedback"> ${this._errorMessage} </atlas-text>
            `);
    }
    render() {
      return html87` ${super.render()} ${this.renderValidationMessage()} `;
    }
  };
  AtlasElementGroup.styles = atlas_element_group_default;
  return AtlasElementGroup;
})();
__decorateClass([property89({
  type: String
})], AtlasElementGroup.prototype, "name", 2);
__decorateClass([property89({
  type: Boolean
})], AtlasElementGroup.prototype, "disabled", 2);
__decorateClass([property89({
  type: Number,
  attribute: "required-fields"
})], AtlasElementGroup.prototype, "requiredFields", 2);
__decorateClass([property89({
  type: String,
  attribute: "required-fields-error-message"
})], AtlasElementGroup.prototype, "requiredFieldsErrorMessage", 2);
__decorateClass([state46()], AtlasElementGroup.prototype, "_valid", 2);
__decorateClass([queryAssignedElements2({
  flatten: true
})], AtlasElementGroup.prototype, "slottedElements", 2);
__decorateClass([Watch(["requiredFields", "requiredFieldsErrorMessage"], false)], AtlasElementGroup.prototype, "setRequiredFieldsErrorMessage", 1);
__decorateClass([Watch("disabled", true)], AtlasElementGroup.prototype, "shouldDisableSlottedElements", 1);
AtlasElementGroup = __decorateClass([customElement79("atlas-element-group")], AtlasElementGroup);

// src/components/form/atlas-filter-group/atlas-filter-group.scss
import { css as css75 } from "lit-element/lit-element.js";
var atlas_filter_group_default = css75`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  width: 100%;
}

:host([auto]) {
  width: auto;
}

:host([fluid]) {
  width: 100%;
  height: 100%;
}

.atlas-layout {
  margin: 0;
  padding: 0;
  width: 100%;
  box-sizing: border-box;
  align-items: normal;
}
.atlas-layout.grid {
  display: grid;
}
.atlas-layout.grid.mobile {
  grid-template-columns: 1fr;
}
.atlas-layout.grid.mobile slot::slotted(*) {
  grid-column: 1 !important;
}
.atlas-layout:not(.grid) {
  display: flex;
  flex-direction: column;
}
.atlas-layout:not(.grid).wrap {
  flex-wrap: wrap;
}
.atlas-layout:not(.grid).inline {
  flex-direction: row;
}
.atlas-layout.fluid {
  height: 100%;
}
.atlas-layout.align-top {
  align-items: flex-start;
}
.atlas-layout.align-center {
  align-items: center;
}
.atlas-layout.align-bottom {
  align-items: flex-end;
}
.atlas-layout.justify-start {
  justify-content: flex-start;
}
.atlas-layout.justify-center {
  justify-content: center;
}
.atlas-layout.justify-end {
  justify-content: flex-end;
}
.atlas-layout.justify-space-between {
  justify-content: space-between;
}
.atlas-layout.justify-space-around {
  justify-content: space-around;
}
.atlas-layout.justify-space-evenly {
  justify-content: space-evenly;
}
.atlas-layout.mobile:not(.inline) slot::slotted(*:not(.no-expand)) {
  width: 100% !important;
}

.gap-0 {
  gap: 0;
}

.grid.row-gap-0 {
  row-gap: 0;
}
.grid.column-gap-0 {
  column-gap: 0;
}

.mobile-gap-0 {
  gap: 0 !important;
}
.mobile-gap-0.grid {
  row-gap: 0 !important;
  column-gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem;
}

.grid.row-gap-1 {
  row-gap: 0.25rem;
}
.grid.column-gap-1 {
  column-gap: 0.25rem;
}

.mobile-gap-1 {
  gap: 0.25rem !important;
}
.mobile-gap-1.grid {
  row-gap: 0.25rem !important;
  column-gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem;
}

.grid.row-gap-2 {
  row-gap: 0.5rem;
}
.grid.column-gap-2 {
  column-gap: 0.5rem;
}

.mobile-gap-2 {
  gap: 0.5rem !important;
}
.mobile-gap-2.grid {
  row-gap: 0.5rem !important;
  column-gap: 0.5rem !important;
}

.gap-3 {
  gap: 0.75rem;
}

.grid.row-gap-3 {
  row-gap: 0.75rem;
}
.grid.column-gap-3 {
  column-gap: 0.75rem;
}

.mobile-gap-3 {
  gap: 0.75rem !important;
}
.mobile-gap-3.grid {
  row-gap: 0.75rem !important;
  column-gap: 0.75rem !important;
}

.gap-4 {
  gap: 1rem;
}

.grid.row-gap-4 {
  row-gap: 1rem;
}
.grid.column-gap-4 {
  column-gap: 1rem;
}

.mobile-gap-4 {
  gap: 1rem !important;
}
.mobile-gap-4.grid {
  row-gap: 1rem !important;
  column-gap: 1rem !important;
}

.gap-5 {
  gap: 1.25rem;
}

.grid.row-gap-5 {
  row-gap: 1.25rem;
}
.grid.column-gap-5 {
  column-gap: 1.25rem;
}

.mobile-gap-5 {
  gap: 1.25rem !important;
}
.mobile-gap-5.grid {
  row-gap: 1.25rem !important;
  column-gap: 1.25rem !important;
}

.gap-6 {
  gap: 1.5rem;
}

.grid.row-gap-6 {
  row-gap: 1.5rem;
}
.grid.column-gap-6 {
  column-gap: 1.5rem;
}

.mobile-gap-6 {
  gap: 1.5rem !important;
}
.mobile-gap-6.grid {
  row-gap: 1.5rem !important;
  column-gap: 1.5rem !important;
}

.gap-7 {
  gap: 2rem;
}

.grid.row-gap-7 {
  row-gap: 2rem;
}
.grid.column-gap-7 {
  column-gap: 2rem;
}

.mobile-gap-7 {
  gap: 2rem !important;
}
.mobile-gap-7.grid {
  row-gap: 2rem !important;
  column-gap: 2rem !important;
}

.gap-8 {
  gap: 2.5rem;
}

.grid.row-gap-8 {
  row-gap: 2.5rem;
}
.grid.column-gap-8 {
  column-gap: 2.5rem;
}

.mobile-gap-8 {
  gap: 2.5rem !important;
}
.mobile-gap-8.grid {
  row-gap: 2.5rem !important;
  column-gap: 2.5rem !important;
}

.gap-9 {
  gap: 3rem;
}

.grid.row-gap-9 {
  row-gap: 3rem;
}
.grid.column-gap-9 {
  column-gap: 3rem;
}

.mobile-gap-9 {
  gap: 3rem !important;
}
.mobile-gap-9.grid {
  row-gap: 3rem !important;
  column-gap: 3rem !important;
}

:host {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  box-sizing: border-box;
}

.atlas-filter-group .atlas-filter-group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 1.5rem;
}
.atlas-filter-group .atlas-filter-group-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.atlas-filter-group.with-header .atlas-filter-group-content {
  margin-top: 1rem;
}`;

// src/components/form/atlas-filter-group/atlas-filter-group.ts
var ComposedClass5 = WithPopoverMixin(WithCollapseMixin(AtlasElementGroup));
var AtlasFilterGroup = /*#__PURE__*/(() => {
  let AtlasFilterGroup = class extends ComposedClass5 {
    /** @internal */
    getUpdateComplete() {
      return __async(this, null, function* () {
        yield __superGet(AtlasFilterGroup.prototype, this, "getUpdateComplete").call(this);
        yield Promise.all(this.slottedElements.map(element => element.updateComplete));
        return true;
      });
    }
    /** @internal */
    onChangeCheckedState() {
      super.onChangeCheckedState();
      if (!this.hasSelectAll) return;
      const checkElements = this.getAllChildrenCheckElements();
      const checkedElements = checkElements.filter(element => element.tagName === "ATLAS-CHECKBOX").reduce((acc, element) => element.checked ? acc + 1 : acc, 0);
      if (checkedElements === 0) {
        this._selectAllCheckbox.uncheck();
      } else if (checkedElements === checkElements.length) {
        this._selectAllCheckbox.check();
      } else {
        this._selectAllCheckbox.indeterminate = true;
      }
    }
    /**
     * Retorna os dados do grupo de filtro
     * @param {boolean} asFormData - Retorna os dados do grupo em FormData
     * @returns {object | FormData} - Os dados do grupo
     */
    getFilterGroupData(asFormData) {
      return getFormValues(this, asFormData);
    }
    /**
     * Reseta os elementos do grupo de filtro
     * @returns {Element[]} - Os elementos do grupo
     */
    getFilterGroupElements() {
      return getAllFormElements(this);
    }
    /**
     * Retorna o número de filtros aplicados
     * @returns {number} - O número de filtros aplicados
     */
    countFilters() {
      let filterCounter = 0;
      filterCounter += this.countFilteredCheckedFields();
      filterCounter += this.countFilteredSelectInputFields();
      return filterCounter;
    }
    /**
     * Reseta os dados do grupo de filtro
     */
    resetFilterData() {
      this.getFilterGroupElements().forEach(formElement => {
        formElement.reset();
      });
    }
    /**
     * Atualiza os dados do grupo de filtro com os dados do grupo atual
     * @param {FormElement[]} formElements - Array de elementos do formulário
     */
    mergeFilterGroup(formElements) {
      const elementMap = new Map(formElements.map(formElement => {
        const tagName = formElement.tagName.toLowerCase();
        if (CHECK_ELEMENTS.includes(tagName)) {
          return [`${formElement.name};${formElement.value}`, formElement];
        }
        return [formElement.name, formElement];
      }));
      this.getFilterGroupElements().forEach(formElement => {
        const nameAndValue = `${formElement.name};${formElement.value}`;
        const tagName = formElement.tagName.toLowerCase();
        if (!elementMap.has(formElement.name) && !elementMap.has(nameAndValue)) return;
        if (INPUT_ELEMENTS.includes(tagName) || SELECT_ELEMENTS.includes(tagName)) {
          formElement.value = elementMap.get(formElement.name).value || "";
        }
        if (CHECK_ELEMENTS.includes(tagName)) {
          const checkElementOrigin = elementMap.get(nameAndValue);
          const checkElementDestination = formElement;
          checkElementDestination.toggleChecked(checkElementOrigin.checked);
        }
      });
    }
    onSelectAllChange(event) {
      const selectAllCheckbox = event.target;
      const childrenCheckboxes = this.getAllChildrenCheckElements();
      childrenCheckboxes.forEach(checkbox => {
        checkbox.toggleChecked(selectAllCheckbox.checked);
      });
    }
    countFilteredCheckedFields() {
      return this.getAllChildrenCheckElements().filter(element => !element.default).reduce((acc, slotted) => slotted.checked ? acc + 1 : acc, 0);
    }
    countFilteredSelectInputFields() {
      const selectInputElements = [...this.getAllChildrenInputElements(), ...this.getAllChildrenSelectElements()];
      return selectInputElements.filter(element => element.defaultValue !== element.value).length;
    }
    getFilterWidth() {
      const elementRect = this.shadowRoot.querySelector(".atlas-filter-group").getBoundingClientRect();
      return `width: ${elementRect.width}px`;
    }
    /** @internal */
    renderValidationMessage() {
      return when61(!this._valid, () => html88`
                <atlas-text size="xs" theme="danger" class="invalid-feedback" style=${this.getFilterWidth()}>
                    ${this._errorMessage}
                </atlas-text>
            `);
    }
    renderSelectAll() {
      return when61(this.hasSelectAll, () => html88`
                <atlas-checkbox @atlas-checkbox-change=${this.onSelectAllChange} class="select-all"
                    >Selecionar todos</atlas-checkbox
                >
            `);
    }
    renderHeader() {
      return when61(!!this.header, () => html88`
                <div class="atlas-filter-group-header">
                    <atlas-layout inline gap="2" alignment="center">
                        <atlas-heading size="h6">${this.header}</atlas-heading>
                        ${this.renderPopoverInfoIcon()}
                    </atlas-layout>
                    ${when61(this.collapsible, () => this.renderCollapseButton())}
                </div>
            `);
    }
    /** @internal */
    render() {
      const elementGroupClass = {
        "atlas-filter-group": true,
        "is-invalid": !this._valid,
        "with-header": !!this.header
      };
      const layoutClass = {
        "atlas-filter-group-content": true,
        "atlas-layout": true,
        "inline": this.getIsInline(),
        "mobile": this._deviceController.isMobile,
        "fluid": this.fluid,
        [`align-${this.alignment}`]: !!this.alignment,
        [`justify-${this.justify}`]: !!this.justify,
        [`gap-${this.gap}`]: !!this.gap
      };
      return html88`
            <div class=${classMap61(elementGroupClass)}>
                ${this.renderHeader()}
                ${this.renderContentWithCollapse(html88`
                    <div class="${classMap61(layoutClass)}">
                        ${this.renderSelectAll()}
                        <slot @slotchange=${this.onSlotChange}></slot>
                    </div>
                `)}
            </div>
            ${this.renderValidationMessage()}
        `;
    }
  };
  AtlasFilterGroup.styles = atlas_filter_group_default;
  return AtlasFilterGroup;
})();
__decorateClass([property90({
  type: String
})], AtlasFilterGroup.prototype, "header", 2);
__decorateClass([property90({
  type: Boolean,
  attribute: "has-select-all"
})], AtlasFilterGroup.prototype, "hasSelectAll", 2);
__decorateClass([query18(".select-all")], AtlasFilterGroup.prototype, "_selectAllCheckbox", 2);
AtlasFilterGroup = __decorateClass([customElement80("atlas-filter-group")], AtlasFilterGroup);

// src/components/form/atlas-float-input/atlas-float-input.ts
import { customElement as customElement81, property as property91 } from "lit/decorators.js";

// src/internals/validators/range-validator.ts
var RangeValidator = class {
  constructor(maxValueErrorMessage, minValueErrorMessage) {
    this.name = "range";
    this.status = "error";
    this.errorType = "none";
    this.maxValueErrorMessage = maxValueErrorMessage || "O valor inserido excede o valor m\xE1ximo";
    this.minValueErrorMessage = minValueErrorMessage || "O valor inserido \xE9 menor que o valor m\xEDnimo";
  }
  getInvalidMessage() {
    return this.errorType === "min" ? this.minValueErrorMessage : this.maxValueErrorMessage;
  }
  validate(element) {
    this.errorType = "none";
    const minValue = element.getAttribute("min-value");
    const maxValue = element.getAttribute("max-value");
    const elementValue = typeof element.getUnmaskedValue === "function" ? element.getUnmaskedValue() : element.getElementValue();
    const value = stringToNumber(elementValue);
    if (minValue && value < stringToNumber(minValue)) {
      this.errorType = "min";
    }
    if (maxValue && value > stringToNumber(maxValue)) {
      this.errorType = "max";
    }
    return this.errorType === "none";
  }
};

// src/components/form/atlas-float-input/atlas-float-input.ts
var AtlasFloatInput = class extends AtlasInput {
  constructor() {
    super(...arguments);
    this.decimalPrecision = 2;
    this.allowNegative = false;
    this._maskOptions = {};
  }
  /**
   * @internal
   * @override
   */
  connectedCallback() {
    var _a;
    (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
    this.fixCarretPosition = this.fixCarretPosition.bind(this);
    this.updateComplete.then(() => {
      this.addValidator(new RangeValidator(this.maxValueErrorMessage, this.minValueErrorMessage));
      if (!this.placeholder) {
        this.placeholder = this.getMaskedPlaceholder();
      }
      this.inputMode = "decimal";
      this.normalizeMinMaxLength();
      this.buildMask();
      this._input.addEventListener("click", this.fixCarretPosition);
    });
  }
  /**
   * @internal
   * @override
   */
  disconnectedCallback() {
    var _a;
    (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
    this._input.removeEventListener("click", this.fixCarretPosition);
  }
  onChangeAttributes() {
    const validator = this.getValidator("range");
    validator.maxValueErrorMessage = this.maxValueErrorMessage;
    validator.minValueErrorMessage = this.minValueErrorMessage;
    this.reportValidity();
  }
  /**
   * @internal
   * @override
   */
  onChangeValue() {
    this.formatValueWithMaskIfNecessary();
    super.onChangeValue();
  }
  /**
   * @override
   * @inheritdoc
   */
  focus() {
    this._input.focus();
  }
  /**
   * Retorna o valor do campo sem a máscara
   * @returns {string | number} - O valor do campo sem a máscara
   */
  getUnmaskedValue() {
    return this._maskInstance.unmaskedvalue();
  }
  /** @override */
  handleFocus() {
    super.handleFocus();
    this.fixCarretPosition();
  }
  /** @override */
  handlePaste(event) {
    return __async(this, null, function* () {
      var _a;
      yield this.updateComplete;
      const pastedValue = removeNonNumeric(event.clipboardData.getData("text"), {
        allowNegative: this.allowNegative
      });
      if (!pastedValue) return;
      const {
        selectionStart,
        selectionEnd
      } = this._input;
      const currentValue = this.value ? String(this.value) : this.getMaskedPlaceholder();
      const isFullSelection = selectionStart === 0 && selectionEnd === currentValue.length;
      const newValue = isFullSelection ? pastedValue : this.getCombinedValue(pastedValue);
      const newValueWithoutLeadingZeros = removeLeadingZeros(newValue, {
        allowNegative: this.allowNegative
      });
      this.value = convertToDecimalFormat(newValueWithoutLeadingZeros, {
        decimalPrecision: this.decimalPrecision,
        allowNegative: this.allowNegative
      });
      (_a = __superGet(AtlasFloatInput.prototype, this, "handlePaste")) == null ? void 0 : _a.call(this, event);
    });
  }
  getCombinedValue(pastedValue) {
    const currentValue = this.value ? String(this.value) : this.getMaskedPlaceholder();
    const cleanedCurrentValue = removeNonNumeric(currentValue, {
      allowNegative: this.allowNegative
    });
    const combinedValue = cleanedCurrentValue + removeNegativeSign(pastedValue);
    return combinedValue;
  }
  fixCarretPosition() {
    setTimeout(() => {
      const length = this.value ? this.value.length : this.decimalPrecision + 2;
      if (this._input.setSelectionRange) {
        this._input.setSelectionRange(length, length);
      }
    }, 0);
  }
  normalizeMinMaxLength() {
    var _a;
    const computedMinlength = this.decimalPrecision + 2;
    if (this.minlength) {
      this.minlength = Math.max(this.minlength, computedMinlength, 0);
    }
    if (this.maxlength) {
      this.maxlength = Math.max(this.maxlength, (_a = this.minlength) != null ? _a : computedMinlength);
    }
  }
  getValueReplacedDotByComma(value) {
    if (!value) return "";
    const stringValue = String(value);
    const hasDot = stringValue.includes(".");
    const hasComma = stringValue.includes(",");
    if (!hasDot && !hasComma) return stringValue;
    if (!hasComma) return stringValue.replace(".", ",");
    return stringValue.replace(/\./g, "");
  }
  getMaskedPlaceholder() {
    return this.decimalPrecision <= 0 ? "0" : `0,${"0".repeat(this.decimalPrecision)}`;
  }
  formatValueWithMaskIfNecessary() {
    if (inputmask_utils_default.isValid(this.value, this._maskOptions)) return;
    const normalizedValue = this.getValueReplacedDotByComma(this.value);
    this.value = inputmask_utils_default.format(normalizedValue, this._maskOptions);
  }
  buildMask() {
    this._maskOptions = {
      alias: "float",
      allowMinus: this.allowNegative,
      digits: this.decimalPrecision,
      onKeyDown: event => {
        const arrowKeys = ["ArrowLeft", "ArrowUp", "ArrowDown", "ArrowRight"];
        if (arrowKeys.includes(event.key)) {
          event.preventDefault();
        }
      },
      // @ts-expect-error
      onBeforePaste: () => false
    };
    this._maskInstance = inputmask_utils_default(this._maskOptions).mask(this._input);
    this._maskInstance.shadowRoot = this.shadowRoot;
    if (this.value) this.formatValueWithMaskIfNecessary();
  }
};
__decorateClass([property91({
  type: Number,
  attribute: "decimal-precision"
})], AtlasFloatInput.prototype, "decimalPrecision", 2);
__decorateClass([property91({
  type: Number,
  attribute: "max-value"
})], AtlasFloatInput.prototype, "maxValue", 2);
__decorateClass([property91({
  type: String,
  attribute: "max-value-error-message"
})], AtlasFloatInput.prototype, "maxValueErrorMessage", 2);
__decorateClass([property91({
  type: Number,
  attribute: "min-value"
})], AtlasFloatInput.prototype, "minValue", 2);
__decorateClass([property91({
  type: String,
  attribute: "min-value-error-message"
})], AtlasFloatInput.prototype, "minValueErrorMessage", 2);
__decorateClass([property91({
  type: Boolean,
  attribute: "allow-negative"
})], AtlasFloatInput.prototype, "allowNegative", 2);
__decorateClass([Watch(["maxValueErrorMessage", "minValueErrorMessage"], true)], AtlasFloatInput.prototype, "onChangeAttributes", 1);
AtlasFloatInput = __decorateClass([customElement81("atlas-float-input")], AtlasFloatInput);

// src/components/form/atlas-form-panel/atlas-form-panel.ts
import { html as html93 } from "lit";
import { customElement as customElement85, property as property96, query as query19, queryAsync } from "lit/decorators.js";
import { classMap as classMap64 } from "lit/directives/class-map.js";
import { ifDefined as ifDefined20 } from "lit/directives/if-defined.js";
import { when as when66 } from "lit/directives/when.js";

// src/helpers/notifications.ts
var notifications_exports = {};
__export(notifications_exports, {
  closeAllAlerts: () => closeAllAlerts,
  showAlert: () => showAlert,
  showConfirmation: () => showConfirmation,
  showToast: () => showToast
});

// src/components/display/atlas-alert/alert-system.ts
var MESSAGE_CONTAINER_CLASS = "atlas-alert-container";
var MESSAGE_CONTAINER_SELECTOR = `.${MESSAGE_CONTAINER_CLASS}`;
var MAX_ALERTS_IN_QUEUE = 4;
var CLOSE_TIMEOUT_TIME = 5e3;
var TIMEOUT_KEY = "atlas-alert-timeout-id";
var getAllAlerts = function () {
  const container = document.querySelector(MESSAGE_CONTAINER_SELECTOR);
  const alertList = container == null ? void 0 : container.querySelectorAll("atlas-alert");
  return [].concat(...(alertList || []));
};
var createContainerIfNeeded = function () {
  if (document.querySelector(MESSAGE_CONTAINER_SELECTOR)) {
    return;
  }
  const container = document.createElement("div");
  container.classList.add(MESSAGE_CONTAINER_CLASS);
  document.body.append(container);
};
var removeEqualAlerts = function (message) {
  getAllAlerts().forEach(element => {
    if (element.innerHTML.trim() === message.trim()) {
      element.destroy();
    }
  });
};
var createAlertElement = function (message, type, ignoreTimeout) {
  const element = document.createElement("atlas-alert");
  element.setAttribute("type", type);
  element.toggleAttribute("ignore-timeout", ignoreTimeout);
  element.innerHTML = message.trim();
  return element;
};
var removeLastVisibleAlert = function () {
  getAllAlerts().forEach((element, index) => {
    if (index >= MAX_ALERTS_IN_QUEUE - 1) {
      if (element.getAttribute("type") === "error") {
        return;
      }
      element.destroy();
    }
  });
};
var addInQueue = function (alertElement) {
  if (alertElement.getAttribute("type") === "error") {
    document.querySelector(MESSAGE_CONTAINER_SELECTOR).prepend(alertElement);
    return;
  }
  const alertsWithErrorList = getAllAlerts().filter(element => element.getAttribute("type") === "error");
  if (alertsWithErrorList.length > 0) {
    const nextElementAfterLastAlertWithError = alertsWithErrorList[alertsWithErrorList.length - 1].nextSibling;
    document.querySelector(MESSAGE_CONTAINER_SELECTOR).insertBefore(alertElement, nextElementAfterLastAlertWithError);
  } else {
    document.querySelector(MESSAGE_CONTAINER_SELECTOR).prepend(alertElement);
  }
};
var setAlertTimeout = function (element) {
  const timeoutId = setTimeout(() => {
    element.destroy();
    localStorage.removeItem(TIMEOUT_KEY);
  }, CLOSE_TIMEOUT_TIME);
  localStorage.setItem(TIMEOUT_KEY, String(timeoutId));
  return timeoutId;
};
var closeAlertsTimeout = function () {
  const alertTriggerList = getAllAlerts();
  if (!alertTriggerList) {
    return;
  }
  clearTimeout(parseInt(localStorage.getItem(TIMEOUT_KEY), 10));
  alertTriggerList.forEach(element => {
    if (element.getAttribute("type") === "error" || element.getAttribute("type") === "warning") return;
    if (element.hasAttribute("ignore-timeout")) return;
    let timeoutId = setAlertTimeout(element);
    element.addEventListener("mouseover", () => {
      clearTimeout(timeoutId);
    });
    element.addEventListener("mouseout", () => {
      timeoutId = setAlertTimeout(element);
    });
  });
};
function showAlert(message, type, shouldIgnoreTimeout) {
  if (!message || !type) return;
  createContainerIfNeeded();
  removeEqualAlerts(message);
  const alertType = type == null ? void 0 : type.toLowerCase();
  const ignoreTimeout = shouldIgnoreTimeout && alertType === "info" ? shouldIgnoreTimeout : false;
  const element = createAlertElement(message, alertType, ignoreTimeout);
  const visibleAlertsCount = getAllAlerts().length;
  if (visibleAlertsCount >= MAX_ALERTS_IN_QUEUE) {
    removeLastVisibleAlert();
  }
  addInQueue(element);
  closeAlertsTimeout();
}
function closeAllAlerts() {
  getAllAlerts().forEach(element => {
    element.destroy();
  });
}

// src/components/display/atlas-toast/toast-system.ts
var TOAST_CONTAINER_COMPONENT = "atlas-toast-container";
var iconStatus = {
  default: {
    success: {
      icon: "check",
      theme: "success"
    },
    error: {
      icon: "alert-triangle",
      theme: "danger"
    },
    warning: {
      icon: "alert-circle",
      theme: "warning"
    },
    info: {
      icon: "info",
      theme: "info"
    },
    none: {
      icon: "info",
      theme: "info"
    }
  },
  notification: {
    "success": {
      icon: "check",
      theme: "success"
    },
    "error": {
      icon: "x",
      theme: "danger"
    },
    "attention": {
      icon: "alert",
      theme: "warning"
    },
    "in-progress": {
      icon: "clock",
      theme: "info"
    },
    "none": {
      icon: "info",
      theme: "info"
    }
  }
};
var isToastDefaultStatus = status => {
  return ["success", "error", "warning", "info", "none"].includes(status);
};
var isToastNotificationStatus = status => {
  return ["success", "in-progress", "attention", "error", "none"].includes(status);
};
var createToastContainerIfNeeded = () => {
  let container = document.querySelector(TOAST_CONTAINER_COMPONENT);
  if (container) return container;
  container = document.createElement(TOAST_CONTAINER_COMPONENT);
  document.body.append(container);
  return container;
};
var getIconAttributes = (status, type) => {
  let iconAttributes;
  if (type === "default" && isToastDefaultStatus(status)) {
    iconAttributes = iconStatus["default"][status];
  } else if (isToastNotificationStatus(status)) {
    iconAttributes = iconStatus["notification"][status];
  }
  return iconAttributes;
};
var createToast = ({
  status = "none",
  icon,
  type = "default",
  header,
  headerInfo,
  content,
  href,
  isExternalLink = false,
  hasAction = false,
  primaryActionButton,
  secondaryActionButton
}) => {
  const toast = document.createElement("atlas-toast");
  if (!!icon) toast.setAttribute("icon", icon);
  if (!!status && status !== "none") {
    const iconAttributes = getIconAttributes(status, type);
    if (type === "notification") {
      toast.setAttribute("overlay-icon", iconAttributes.icon);
      toast.setAttribute("overlay-icon-theme", iconAttributes.theme);
    } else {
      toast.setAttribute("icon", iconAttributes.icon);
      toast.setAttribute("icon-theme", iconAttributes.theme);
    }
  }
  if (!!header) toast.setAttribute("header", header);
  if (!!headerInfo) toast.setAttribute("header-info", headerInfo);
  if (!!href) {
    toast.setAttribute("href", href);
    toast.toggleAttribute("is-external-link", isExternalLink);
  }
  if (hasAction) toast.toggleAttribute("has-action", hasAction);
  toast.innerHTML = content;
  if (primaryActionButton && Object.keys(primaryActionButton).length > 0) {
    const primaryButton = document.createElement("atlas-button");
    primaryButton.setAttribute("size", "sm");
    primaryButton.setAttribute("id", primaryActionButton.id);
    primaryButton.setAttribute("class", primaryActionButton.class);
    primaryButton.setAttribute("description", primaryActionButton.description);
    primaryButton.setAttribute("href", primaryActionButton.href);
    primaryButton.setAttribute("icon", primaryActionButton.icon);
    primaryButton.toggleAttribute("is-external-link", primaryActionButton.isExternalLink);
    primaryButton.setAttribute("slot", "actions");
    toast.appendChild(primaryButton);
  }
  if (secondaryActionButton && Object.keys(secondaryActionButton).length > 0) {
    const secondaryButton = document.createElement("atlas-button");
    secondaryButton.setAttribute("size", "sm");
    secondaryButton.setAttribute("type", "ghost");
    secondaryButton.setAttribute("id", secondaryActionButton.id);
    secondaryButton.setAttribute("class", secondaryActionButton.class);
    secondaryButton.setAttribute("description", secondaryActionButton.description);
    secondaryButton.setAttribute("href", secondaryActionButton.href);
    secondaryButton.setAttribute("icon", secondaryActionButton.icon);
    secondaryButton.toggleAttribute("is-external-link", secondaryActionButton.isExternalLink);
    secondaryButton.setAttribute("slot", "actions");
    toast.appendChild(secondaryButton);
  }
  return toast;
};
function showToast({
  toastElement,
  status,
  icon,
  type = "default",
  header,
  headerInfo,
  content,
  href,
  isExternalLink = false,
  hasAction = false,
  primaryActionButton,
  secondaryActionButton,
  duration = 5e3
}) {
  const container = createToastContainerIfNeeded();
  let toast = toastElement;
  if (!toast) {
    toast = createToast({
      status,
      icon,
      type,
      header,
      headerInfo,
      content,
      href,
      isExternalLink,
      hasAction,
      primaryActionButton,
      secondaryActionButton
    });
  }
  if (isEmptyValue(primaryActionButton) && isEmptyValue(secondaryActionButton)) {
    toast.setAttribute("data-duration", duration.toString());
  }
  container.addToast(toast);
}

// src/helpers/notifications.ts
var setModalContent = (options, modalContent) => {
  if (options.content) {
    const modalText = document.createElement("atlas-text");
    modalText.alignment = "center";
    modalText.innerHTML = options.content || "";
    modalContent.appendChild(modalText);
  } else if (options.templateSelector) {
    const templateElement = document.querySelector(options.templateSelector);
    const templateContent = templateElement.content.cloneNode(true);
    modalContent.appendChild(templateContent);
  }
};
var showConfirmation = options => {
  var _a, _b;
  const modal = document.createElement("atlas-modal");
  modal.destroyOnClose = true;
  modal.headerIllustration = options.illustration;
  modal.disableAutoClose = options.disableAutoClose;
  modal.hideCloseButton = options.hideCloseButton;
  modal.size = options.size || "default";
  const modalTitle = document.createElement("atlas-heading");
  modalTitle.size = "h4";
  modalTitle.alignment = "center";
  modalTitle.innerHTML = options.title;
  const modalContent = document.createElement("atlas-layout");
  modalContent.gap = 6;
  modalContent.alignment = "center";
  setModalContent(options, modalContent);
  modalContent.prepend(modalTitle);
  const cancelButton = document.createElement("atlas-button");
  cancelButton.theme = "secondary";
  cancelButton.description = "Cancelar";
  cancelButton.slot = "actions";
  cancelButton.addEventListener("atlas-button-click", () => {
    modal.closeModal();
  });
  const confirmButton = document.createElement("atlas-button");
  confirmButton.theme = ((_a = options.confirmButton) == null ? void 0 : _a.theme) || "primary";
  confirmButton.description = ((_b = options.confirmButton) == null ? void 0 : _b.description) || "Confirmar";
  confirmButton.slot = "actions";
  confirmButton.addEventListener("atlas-button-click", () => {
    var _a2;
    (_a2 = options.onConfirm) == null ? void 0 : _a2.call(options, modal);
  });
  modal.appendChild(modalContent);
  modal.appendChild(cancelButton);
  modal.appendChild(confirmButton);
  document.body.appendChild(modal);
  modal.openModal();
  setTimeout(() => {
    var _a2;
    (_a2 = options.onOpenModal) == null ? void 0 : _a2.call(options, modal);
  }, 0);
};

// src/components/layout/atlas-panel/atlas-panel.ts
import { html as html92 } from "lit";
import { customElement as customElement84, property as property95, state as state49 } from "lit/decorators.js";
import { classMap as classMap63 } from "lit/directives/class-map.js";
import { styleMap as styleMap20 } from "lit/directives/style-map.js";
import { when as when65 } from "lit/directives/when.js";

// src/internals/mixins/with-visibility-icon-mixin.ts
import { html as html89 } from "lit";
import { property as property92, state as state47 } from "lit/decorators.js";
import { when as when62 } from "lit/directives/when.js";
var WithVisibilityIconMixin = superClass => {
  class WithVisibilityIconClass extends superClass {
    constructor() {
      super(...arguments);
      this.visibilityIconSize = "2x";
      this.isDataVisible = false;
      this._isVisibilityIconButton = true;
    }
    /**
     * Define o estado de carregamento do ícone de visibilidade
     * @param {boolean} loading - Indica se o ícone de visibilidade está em estado de carregamento
     */
    setVisibilityIconLoading(loading) {
      if (!this.hasVisibilityIcon) return;
      this.shadowRoot.querySelector("atlas-visibility-icon-button").loading = loading;
    }
    /**
     * Define o estado de desabilitado do ícone de visibilidade
     * @param {boolean} disabled - Indica se o ícone de visibilidade está desabilitado
     */
    setVisibilityIconDisabled(disabled) {
      if (!this.hasVisibilityIcon) return;
      this.shadowRoot.querySelector("atlas-visibility-icon-button").disabled = disabled;
    }
    onClickVisibilityIcon(event) {
      this.isDataVisible = event.detail.isDataVisible;
    }
    /** @internal */
    renderVisibilityIcon() {
      return when62(this.hasVisibilityIcon, () => html89`
                    <atlas-visibility-icon-button
                        icon-size="${this.visibilityIconSize}"
                        ?is-data-visible=${this.isDataVisible}
                        ?is-icon-button=${this._isVisibilityIconButton}
                        @atlas-visibility-icon-click="${this.onClickVisibilityIcon}"
                    ></atlas-visibility-icon-button>
                `);
    }
  }
  __decorateClass([property92({
    type: Boolean,
    attribute: "has-visibility-icon",
    reflect: true
  })], WithVisibilityIconClass.prototype, "hasVisibilityIcon", 2);
  __decorateClass([property92({
    type: String,
    attribute: "visibility-icon-size"
  })], WithVisibilityIconClass.prototype, "visibilityIconSize", 2);
  __decorateClass([property92({
    type: Boolean,
    attribute: "is-data-visible",
    reflect: true
  })], WithVisibilityIconClass.prototype, "isDataVisible", 2);
  __decorateClass([state47()], WithVisibilityIconClass.prototype, "_isVisibilityIconButton", 2);
  return WithVisibilityIconClass;
};

// src/components/layout/atlas-carousel/atlas-carousel.ts
import { html as html90 } from "lit";
import { customElement as customElement82, property as property93, state as state48 } from "lit/decorators.js";
import { classMap as classMap62 } from "lit/directives/class-map.js";
import { map as map2 } from "lit/directives/map.js";
import { range } from "lit/directives/range.js";
import { styleMap as styleMap19 } from "lit/directives/style-map.js";
import { when as when63 } from "lit/directives/when.js";

// src/internals/variables.ts
var ROOT_FONT_SIZE = 16;

// src/components/layout/atlas-carousel/atlas-carousel.scss
import { css as css76 } from "lit-element/lit-element.js";
var atlas_carousel_default = css76`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: block;
  width: 100%;
  height: auto;
}

.carousel .carousel-content {
  overflow: hidden;
}
.carousel .carousel-content .carousel-items {
  display: flex;
  flex-wrap: nowrap;
  gap: 1rem;
}
.carousel .carousel-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  margin-top: 1rem;
}
.carousel .carousel-controls button {
  display: inline-flex;
  padding: 0;
  margin: 0;
  border: 0;
  cursor: pointer;
  border-radius: 50%;
}
.carousel .carousel-controls button atlas-icon {
  color: var(--atlas-secondary);
}
.carousel .carousel-controls button:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-300-rgb), 0.25);
  background: rgba(var(--atlas-primary-300-rgb), 0.25);
}
.carousel .carousel-controls button:focus-within atlas-icon {
  color: var(--atlas-primary);
}
.carousel .carousel-controls button:not(.skeleton) {
  background: none;
}
.carousel .carousel-controls .carousel-page-control {
  border-radius: 50%;
  width: 0.5rem;
  height: 0.5rem;
  padding: 0;
  margin: 0;
}
.carousel .carousel-controls .carousel-page-control:not(.skeleton) {
  background: none;
  border: 1px solid var(--atlas-primary);
}
.carousel .carousel-controls .carousel-page-control:not(.skeleton).active {
  background: var(--atlas-primary);
}
.carousel .carousel-controls.inside-content {
  margin-top: -3rem;
}
.carousel .carousel-controls.inside-content button atlas-icon {
  color: #ffffff;
}
.carousel .carousel-controls.inside-content button:focus-within atlas-icon {
  color: #ffffff;
}
.carousel .carousel-controls.inside-content .carousel-page-control {
  border: 1px solid #ffffff;
}
.carousel .carousel-controls.inside-content .carousel-page-control.active {
  background: #ffffff;
}

@media screen and (min-width: 992px) {
  .carousel .carousel-content .carousel-items.gap-0 {
    gap: 0;
  }
  .carousel .carousel-content .carousel-items.gap-1 {
    gap: 0.25rem;
  }
  .carousel .carousel-content .carousel-items.gap-2 {
    gap: 0.5rem;
  }
  .carousel .carousel-content .carousel-items.gap-3 {
    gap: 0.75rem;
  }
  .carousel .carousel-content .carousel-items.gap-4 {
    gap: 1rem;
  }
  .carousel .carousel-content .carousel-items.gap-5 {
    gap: 1.25rem;
  }
  .carousel .carousel-content .carousel-items.gap-6 {
    gap: 1.5rem;
  }
  .carousel .carousel-content .carousel-items.gap-7 {
    gap: 2rem;
  }
  .carousel .carousel-content .carousel-items.gap-8 {
    gap: 2.5rem;
  }
  .carousel .carousel-content .carousel-items.gap-9 {
    gap: 3rem;
  }
  .carousel .carousel-controls {
    margin-top: 1.5rem;
  }
}`;

// src/components/layout/atlas-carousel/atlas-carousel.ts
var AtlasCarousel = /*#__PURE__*/(() => {
  let AtlasCarousel = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.itemsPerPage = 1;
      this.insideContent = false;
      this.disableAutoPlay = false;
      this.gap = 4;
      this._currentPage = 0;
      this._countItems = 0;
      this._countPages = 0;
      this._deviceController = new DeviceController(this, this.onScreenModeChange.bind(this));
    }
    /** @internal */
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.addEventListener("mouseover", this.pauseAutoPlay);
      this.addEventListener("mouseout", this.resumeAutoPlay);
      this.updateComplete.then(() => {
        if (!this.disableAutoPlay) this.registerCarouselAutoPlay();
      });
    }
    /** @internal */
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      this.cancelCarouselAutoPlay();
      this.removeEventListener("mouseover", this.pauseAutoPlay);
      this.removeEventListener("mouseout", this.resumeAutoPlay);
    }
    onDisableAutoPlayChange() {
      if (this.disableAutoPlay) {
        this.cancelCarouselAutoPlay();
      } else {
        this.registerCarouselAutoPlay();
      }
    }
    /**
     * Pausa a troca automática de páginas do carrossel
    */
    pauseAutoPlay() {
      this._autoPlayPaused = true;
    }
    /**
     * Retoma a troca automática de páginas do carrossel
     */
    resumeAutoPlay() {
      this._autoPlayPaused = false;
    }
    /**
     * Altera a página atual do carrossel
     * @param {number} pageNumber Número da página que será exibida
     */
    changePage(pageNumber) {
      this._currentPage = pageNumber;
      this.showItemsFromCurrentPage();
    }
    registerCarouselAutoPlay() {
      if (!this._deviceController.isMobile && this._countPages > 1) {
        this._autoPlayId = setInterval(() => {
          if (!this._autoPlayPaused) {
            this.onClickNextPage();
          }
        }, 15e3);
      }
    }
    cancelCarouselAutoPlay() {
      if (this._autoPlayId) {
        clearInterval(this._autoPlayId);
      }
    }
    getSlottedItems(slotElement = null) {
      var _a;
      if (((_a = slotElement.assignedElements()[0]) == null ? void 0 : _a.tagName) === "SLOT") {
        return this.getSlottedItems(slotElement.assignedElements()[0]);
      }
      return slotElement.assignedElements();
    }
    getItemsPerPage() {
      if (this._deviceController.isMobile || this.itemsPerPage < 1) return 1;
      return this.itemsPerPage;
    }
    updatePagesCount() {
      this._countPages = Math.ceil(this._countItems / this.getItemsPerPage());
    }
    updateItemsSize() {
      const items = this.getSlottedItems(this.shadowRoot.querySelector("slot:not([name])"));
      const sizeInPercent = 100 / this.getItemsPerPage();
      items.forEach(element => {
        element.style.display = `flex`;
        element.style.flex = `1 0 ${sizeInPercent}%`;
        element.style.width = `${sizeInPercent}%`;
        element.style.boxSizing = "border-box";
      });
      this.toggleEmptySlots();
    }
    toggleEmptySlots() {
      const itemsPerPage = this.getItemsPerPage();
      const remainingItemsOnLastPage = this._countPages === 1 ? itemsPerPage - this._countItems : this._countPages * itemsPerPage - this._countItems;
      this.shadowRoot.querySelectorAll(".carousel-items .ghost").forEach(ghostItem => {
        ghostItem.remove();
      });
      if (remainingItemsOnLastPage > 0) {
        const sizeInPercent = 100 / itemsPerPage;
        for (let i = 0; i < remainingItemsOnLastPage; i++) {
          const ghostElement = document.createElement("div");
          ghostElement.style.flex = `1 0 ${sizeInPercent}%`;
          ghostElement.classList.add("ghost");
          this.shadowRoot.querySelector(".carousel-items").appendChild(ghostElement);
        }
      }
    }
    adjustCarouselContentWidth() {
      const carouselContent = this.shadowRoot.querySelector(".carousel-content");
      const pageWidth = carouselContent.getBoundingClientRect().width;
      if (!Number.isInteger(pageWidth)) {
        carouselContent.style.marginRight = "0.25px";
        carouselContent.style.marginLeft = "0.25px";
      }
    }
    getGapScale() {
      return {
        "0": 0,
        "1": 0.25,
        "2": 0.5,
        "3": 0.75,
        "4": 1,
        "5": 1.25,
        "6": 1.5,
        "7": 2,
        "8": 2.5,
        "9": 3
      }[this.gap];
    }
    showItemsFromCurrentPage() {
      this.adjustCarouselContentWidth();
      const carouselContent = this.shadowRoot.querySelector(".carousel-content");
      const pageWidth = carouselContent.getBoundingClientRect().width;
      const gapScale = this.getGapScale();
      const gap = gapScale * ROOT_FONT_SIZE;
      const leftScroll = (pageWidth + gap) * this._currentPage;
      carouselContent.scroll({
        top: 0,
        left: leftScroll,
        behavior: "smooth"
      });
    }
    onClickPreviousPage() {
      let previousPage = this._currentPage - 1;
      if (previousPage < 0) {
        previousPage = this._countPages - 1;
      }
      this.changePage(previousPage);
    }
    onClickNextPage() {
      let nextPage = this._currentPage + 1;
      if (nextPage > this._countPages - 1) {
        nextPage = 0;
      }
      this.changePage(nextPage);
    }
    onSlotChange() {
      const items = this.getSlottedItems(this.shadowRoot.querySelector("slot:not([name])"));
      this._countItems = items.length;
      this.updatePagesCount();
      this.updateItemsSize();
      this.showItemsFromCurrentPage();
    }
    onScreenModeChange() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        if (this._deviceController.isMobile) {
          this.cancelCarouselAutoPlay();
        } else {
          this.registerCarouselAutoPlay();
        }
        this._currentPage = 0;
        this.updatePagesCount();
        this.updateItemsSize();
        this.showItemsFromCurrentPage();
      });
    }
    renderCarouselPages() {
      return map2(range(this._countPages), pageNumber => {
        const onClick = this.changePage.bind(this, pageNumber);
        const buttonClass = {
          "carousel-page-control": true,
          "skeleton": this.skeletonLoading,
          "active": pageNumber === this._currentPage
        };
        return html90`
                <button
                    class=${classMap62(buttonClass)}
                    @click=${onClick}
                    aria-label=${`P\xE1gina ${pageNumber + 1}`}
                ></button>
            `;
      });
    }
    renderCarouselControls() {
      const carouselControlsClass = {
        "carousel-controls": true,
        "inside-content": this.insideContent
      };
      return when63(this._countItems > this.getItemsPerPage(), () => html90`
                <div class="${classMap62(carouselControlsClass)}">
                    <button @click=${this.onClickPreviousPage}>
                        <atlas-icon name="chevron-left" size="3x"></atlas-icon>
                    </button>
                    ${this.renderCarouselPages()}
                    <button @click=${this.onClickNextPage}>
                        <atlas-icon name="chevron-right" size="3x"></atlas-icon>
                    </button>
                </div>
            `);
    }
    renderContent() {
      const itemsPerPage = this.getItemsPerPage();
      const gapScale = this.getGapScale();
      const sizeDiff = itemsPerPage > 1 ? `${(itemsPerPage - 1) * gapScale}rem` : `0`;
      const carouselStyles = itemsPerPage > 1 ? {
        paddingLeft: sizeDiff,
        marginLeft: `-${sizeDiff}`,
        marginRight: sizeDiff
      } : {};
      const carouselItemsClass = {
        "carousel-items": true,
        [`gap-${this.gap}`]: !!this.gap
      };
      return html90`
            <div class="${classMap62(carouselItemsClass)}" style=${styleMap19(carouselStyles)}>
                <slot @slotchange=${this.onSlotChange}></slot>
            </div>
        `;
    }
    /** @internal */
    render() {
      return html90`
            <div class="carousel">
                <div class="carousel-content">${this.renderContent()}</div>
                ${this.renderCarouselControls()}
            </div>
        `;
    }
  };
  AtlasCarousel.styles = atlas_carousel_default;
  return AtlasCarousel;
})();
__decorateClass([property93({
  type: Number,
  attribute: "items-per-page"
})], AtlasCarousel.prototype, "itemsPerPage", 2);
__decorateClass([property93({
  type: Boolean,
  attribute: "inside-content"
})], AtlasCarousel.prototype, "insideContent", 2);
__decorateClass([property93({
  type: Boolean,
  attribute: "disable-auto-play"
})], AtlasCarousel.prototype, "disableAutoPlay", 2);
__decorateClass([property93({
  type: Number
})], AtlasCarousel.prototype, "gap", 2);
__decorateClass([state48()], AtlasCarousel.prototype, "_currentPage", 2);
__decorateClass([state48()], AtlasCarousel.prototype, "_countItems", 2);
__decorateClass([state48()], AtlasCarousel.prototype, "_countPages", 2);
__decorateClass([state48()], AtlasCarousel.prototype, "_autoPlayId", 2);
__decorateClass([state48()], AtlasCarousel.prototype, "_autoPlayPaused", 2);
__decorateClass([Watch("disableAutoPlay", true)], AtlasCarousel.prototype, "onDisableAutoPlayChange", 1);
AtlasCarousel = __decorateClass([customElement82("atlas-carousel")], AtlasCarousel);

// src/components/layout/atlas-toolbar/atlas-toolbar.ts
import { html as html91 } from "lit";
import { customElement as customElement83, property as property94 } from "lit/decorators.js";
import { when as when64 } from "lit/directives/when.js";

// src/components/layout/atlas-toolbar/atlas-toolbar.scss
import { css as css77 } from "lit-element/lit-element.js";
var atlas_toolbar_default = css77`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.atlas-toolbar {
  display: flex;
  gap: 1rem;
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: wrap;
}
.atlas-toolbar .search-and-filter {
  display: flex;
  gap: 1rem;
  flex-direction: column;
}
.atlas-toolbar .actions-wrapper {
  display: flex;
  gap: 1rem;
  flex-direction: column;
}

@media screen and (min-width: 992px) {
  .atlas-toolbar {
    flex-direction: row;
  }
  .atlas-toolbar .search-and-filter {
    flex-direction: row;
  }
  .atlas-toolbar .search-and-filter slot[name=search]::slotted(*) {
    min-width: 400px;
  }
  .atlas-toolbar .actions-wrapper {
    flex-direction: row;
  }
}`;

// src/components/layout/atlas-toolbar/atlas-toolbar.ts
var AtlasToolbar = /*#__PURE__*/(() => {
  let AtlasToolbar = class extends WithVisibilityIconMixin(AtlasElement) {
    constructor() {
      super(...arguments);
      this._deviceController = new DeviceController(this, this.adjustButtonsSize.bind(this));
    }
    /** @internal */
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this._isVisibilityIconButton = false;
    }
    adjustButtonsSize() {
      return __async(this, null, function* () {
        var _a;
        yield this.updateComplete;
        const actionsSlot = this.shadowRoot.querySelector("slot[name=actions]");
        const filterSlot = this.shadowRoot.querySelector("slot[name=filter]");
        const slottedButtons = [...((actionsSlot == null ? void 0 : actionsSlot.assignedElements({
          flatten: true
        })) || []), ...((filterSlot == null ? void 0 : filterSlot.assignedElements({
          flatten: true
        })) || [])];
        slottedButtons.forEach(element => {
          element.toggleAttribute("block", this._deviceController.isMobile);
        });
        (_a = this.shadowRoot.querySelector("atlas-visibility-icon-button")) == null ? void 0 : _a.toggleAttribute("block", this._deviceController.isMobile);
      });
    }
    renderSearchAndFilter() {
      return when64(!this.onlyActions, () => html91`
                <div class="search-and-filter">
                    <slot name="search"></slot>
                    <slot name="filter" @slotchange=${this.adjustButtonsSize}></slot>
                </div>
            `);
    }
    render() {
      return html91`
            <div class="atlas-toolbar">
                ${this.renderSearchAndFilter()}
                <div class="actions-wrapper">
                    ${this.renderVisibilityIcon()}
                    <slot name="actions" @slotchange=${this.adjustButtonsSize}></slot>
                </div>
            </div>
        `;
    }
  };
  AtlasToolbar.styles = atlas_toolbar_default;
  return AtlasToolbar;
})();
__decorateClass([property94({
  type: Boolean,
  attribute: "only-actions"
})], AtlasToolbar.prototype, "onlyActions", 2);
AtlasToolbar = __decorateClass([customElement83("atlas-toolbar")], AtlasToolbar);

// src/components/layout/atlas-panel/atlas-panel.scss
import { css as css78 } from "lit-element/lit-element.js";
var atlas_panel_default = css78`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: inline-flex;
  position: relative;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  width: 100%;
}

:host([skeleton-loading]) {
  display: inline-flex;
  pointer-events: none;
}

:host([fluid]:not([height], [collapsed])) {
  height: 100%;
}

.panel {
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0.5rem;
  box-sizing: border-box;
  padding: 1rem;
}
.panel.has-content:not(.collapsed) {
  gap: 1rem;
}
.panel .panel-header {
  display: flex;
  gap: 1rem;
  align-items: center;
  box-sizing: border-box;
  flex-wrap: wrap;
  flex-shrink: 0;
}
.panel .panel-header .panel-title {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex-grow: 1;
}
.panel .panel-header .panel-title .title-with-button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  width: auto;
}
.panel .panel-header .panel-title .title-with-button[skeleton-loading] {
  min-width: 300px;
}
.panel .panel-header atlas-collapse-button {
  order: 2;
}
.panel .panel-header .panel-description {
  width: 100%;
  display: block;
  order: 4;
}
.panel .panel-header atlas-toolbar {
  width: 100%;
  display: block;
  order: 3;
}
.panel .panel-body-wrapper {
  box-sizing: border-box;
  flex-grow: 1;
}
.panel .panel-body-wrapper.has-height {
  overflow-y: auto;
}
.panel .panel-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-sizing: border-box;
  height: 100%;
}
.panel .panel-body slot::slotted(atlas-table),
.panel .panel-body slot::slotted(atlas-easy-table:not([total-records="0"])),
.panel .panel-body slot::slotted(atlas-easy-table[skeleton-loading]) {
  margin-left: -1rem !important;
  margin-right: -1rem !important;
}
.panel.hide-header .panel-header {
  display: none;
}
.panel:not(.has-toolbar) atlas-toolbar {
  display: none;
}
.panel.collapsed {
  height: auto !important;
}

@media screen and (min-width: 992px) {
  .panel {
    padding: 1.5rem;
  }
  .panel.has-content:not(.collapsed) {
    gap: 1.5rem;
  }
  .panel .panel-header atlas-collapse-button {
    order: 3;
  }
  .panel .panel-header atlas-toolbar {
    width: auto;
    order: 2;
  }
  .panel .panel-body slot::slotted(atlas-table),
  .panel .panel-body slot::slotted(atlas-easy-table:not([total-records="0"])),
  .panel .panel-body slot::slotted(atlas-easy-table[skeleton-loading]) {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}`;

// src/components/layout/atlas-panel/atlas-panel.ts
var ComposedClass6 = WithDescriptionMixin(WithVisibilityIconMixin(WithBadgeMixin(WithCollapseMixin(AtlasElement))));
var AtlasPanel = /*#__PURE__*/(() => {
  let AtlasPanel = class extends ComposedClass6 {
    constructor() {
      super(...arguments);
      this.itemsPerPage = 1;
      this.height = "auto";
      this._hasSlottedActions = false;
      this._hasSlottedToolbar = false;
      this._deviceController = new DeviceController(this);
    }
    /** @internal */
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.emitPanelEvent = this.emitPanelEvent.bind(this);
      this._isVisibilityIconButton = false;
      if (this.collapsible) {
        this.collapsed = !this.expanded;
      }
      if (this.panelHasHeight()) {
        this.fluid = false;
      }
      this.updateComplete.then(() => {
        this.addEventListener("atlas-collapse-button-click", this.emitPanelEvent);
        if (this.carousel) {
          this.carouselElement = this.shadowRoot.querySelector("atlas-carousel");
        }
        if (this.hasContent()) {
          this.shadowRoot.querySelector(".panel").classList.add("has-content");
        }
      });
    }
    /** @internal */
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      this.removeEventListener("atlas-collapse-button-click", this.emitPanelEvent);
    }
    onVisibilityIconChange() {
      const slottedToolbar = this.getSlottedToolbar();
      if (!slottedToolbar) return;
      this._hasSlottedToolbar = true;
      slottedToolbar.toggleAttribute("has-visibility-icon", Boolean(this.hasVisibilityIcon));
    }
    /**
     * Retorna a referência do ícone de visibilidade
     * @returns {AtlasVisibilityIconButton} - A referência do ícone de visibilidade
     */
    getVisibilityIconButton() {
      if (!this.shadowRoot) return null;
      const toolbar = this.getSlottedToolbar() || this.shadowRoot.querySelector("atlas-toolbar");
      if (!toolbar || !toolbar.hasVisibilityIcon) return null;
      return toolbar.shadowRoot.querySelector("atlas-visibility-icon-button");
    }
    /** @override */
    setVisibilityIconLoading(loading) {
      if (!this.shadowRoot || !this.hasVisibilityIcon) return;
      const toolbar = this.getSlottedToolbar() || this.shadowRoot.querySelector("atlas-toolbar");
      if (!toolbar || !toolbar.hasVisibilityIcon) return;
      toolbar.setVisibilityIconLoading(loading);
    }
    /** @override */
    setVisibilityIconDisabled(disabled) {
      if (!this.shadowRoot || !this.hasVisibilityIcon) return;
      const toolbar = this.getSlottedToolbar() || this.shadowRoot.querySelector("atlas-toolbar");
      if (!toolbar || !toolbar.hasVisibilityIcon) return;
      toolbar.setVisibilityIconDisabled(disabled);
    }
    getSlottedToolbar() {
      const slot = this.shadowRoot.querySelector("slot:not([name])");
      return slot == null ? void 0 : slot.assignedElements().find(element => element.tagName === "ATLAS-TOOLBAR");
    }
    panelHasHeight() {
      return this.height !== "auto";
    }
    emitPanelEvent() {
      emit(this, `atlas-panel-${this.collapsed ? "collapse" : "expand"}`);
    }
    onActionsSlotChange() {
      const actionsSlot = this.shadowRoot.querySelector("slot[name=actions]");
      this._hasSlottedActions = actionsSlot.assignedElements().length > 0;
    }
    isHeaderVisible() {
      return this.header || this.collapsible && !this._deviceController.isMobile || this._hasSlottedActions || this.hasVisibilityIcon;
    }
    hasContent() {
      if (this.carousel) {
        return !isEmptySlot(this.carouselElement);
      }
      return !isEmptySlot(this);
    }
    renderContent() {
      if (this.carousel) {
        return html92`
                <atlas-carousel items-per-page=${this.itemsPerPage}>
                    <slot @slotchange=${this.onVisibilityIconChange}></slot>
                </atlas-carousel>
            `;
      }
      return html92` <slot @slotchange=${this.onVisibilityIconChange}></slot> `;
    }
    renderActionsToolbar() {
      return html92`
            <atlas-toolbar only-actions ?has-visibility-icon=${this.hasVisibilityIcon}>
                <slot slot="actions" name="actions" @slotchange=${this.onActionsSlotChange}></slot>
            </atlas-toolbar>
        `;
    }
    renderHeader() {
      const showCollapseButton = this.collapsible && !this._deviceController.isMobile;
      const showMobileCollapseButton = this.collapsible && this._deviceController.isMobile;
      return html92`
            <div class="panel-header">
                <div class="panel-title">
                    <atlas-layout gap="4" alignment="center" inline>
                        <div class="title-with-button">
                            <atlas-heading size="h5">${this.header}</atlas-heading>
                            ${when65(showMobileCollapseButton, () => this.renderCollapseButton())}
                        </div>
                        ${this.renderBadge()}
                    </atlas-layout>
                </div>
                ${this.renderActionsToolbar()} ${when65(showCollapseButton, () => this.renderCollapseButton())}
                ${this.renderDescription({
        wrapperClass: "panel-description"
      })}
            </div>
        `;
    }
    renderBody() {
      const panelBodyClass = {
        "panel-body": true,
        "fluid": this.fluid
      };
      const bodyHtml = html92` <div class="${classMap63(panelBodyClass)}">${this.renderContent()}</div> `;
      return when65(this.collapsible, () => this.renderContentWithCollapse(bodyHtml), () => bodyHtml);
    }
    /** @internal */
    render() {
      const panelClass = {
        "panel": true,
        "collapsible": this.collapsible,
        "collapsed": this.collapsible && this.collapsed,
        "hide-header": !this.isHeaderVisible(),
        "has-toolbar": !this._hasSlottedToolbar && (this._hasSlottedActions || this.hasVisibilityIcon)
      };
      const panelBodyWrapperClass = {
        "panel-body-wrapper": true,
        "collapsed": this.collapsible && this.collapsed,
        "fluid": this.fluid,
        "has-height": this.panelHasHeight()
      };
      return html92`
            <div class=${classMap63(panelClass)} style=${styleMap20({
        height: this.height
      })}>
                ${this.renderHeader()}
                <div class=${classMap63(panelBodyWrapperClass)}>${this.renderBody()}</div>
            </div>
        `;
    }
  };
  AtlasPanel.styles = atlas_panel_default;
  return AtlasPanel;
})();
__decorateClass([property95({
  type: String
})], AtlasPanel.prototype, "header", 2);
__decorateClass([property95({
  type: Boolean
})], AtlasPanel.prototype, "carousel", 2);
__decorateClass([property95({
  type: Number,
  attribute: "items-per-page"
})], AtlasPanel.prototype, "itemsPerPage", 2);
__decorateClass([property95({
  type: Boolean
})], AtlasPanel.prototype, "fluid", 2);
__decorateClass([property95({
  type: String
})], AtlasPanel.prototype, "height", 2);
__decorateClass([state49()], AtlasPanel.prototype, "_hasSlottedActions", 2);
__decorateClass([state49()], AtlasPanel.prototype, "_hasSlottedToolbar", 2);
__decorateClass([Watch("hasVisibilityIcon", true)], AtlasPanel.prototype, "onVisibilityIconChange", 1);
AtlasPanel = __decorateClass([customElement84("atlas-panel")], AtlasPanel);

// src/components/form/atlas-form-panel/atlas-form-panel.scss
import { css as css79 } from "lit-element/lit-element.js";
var atlas_form_panel_default = css79`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Transitions */
.fade {
  transition: opacity 0.25s ease;
}
.fade:not(.show) {
  opacity: 0;
}

.fade-and-scale {
  opacity: 0;
  transform: scale(0.7);
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.fade-and-scale.scale-vertically {
  transform: scale(1, 0.7);
}
.fade-and-scale.show {
  opacity: 1;
  transform: scale(1);
}

:host([data-popper-placement=top]),
:host([data-popper-placement=top]) .fade-and-scale,
div[data-popper-placement=top].fade-and-scale,
div[data-popper-placement=top] > .fade-and-scale,
.fade-and-scale.scale-top {
  transform-origin: center bottom;
}

:host([data-popper-placement=top-start]),
:host([data-popper-placement=top-start]) .fade-and-scale,
div[data-popper-placement=top-start].fade-and-scale,
div[data-popper-placement=top-start] > .fade-and-scale,
.fade-and-scale.scale-top-start {
  transform-origin: left bottom;
}

:host([data-popper-placement=top-end]),
:host([data-popper-placement=top-end]) .fade-and-scale,
div[data-popper-placement=top-end].fade-and-scale,
div[data-popper-placement=top-end] > .fade-and-scale,
.fade-and-scale.scale-top-end {
  transform-origin: right bottom;
}

:host([data-popper-placement=bottom]),
:host([data-popper-placement=bottom]) .fade-and-scale,
div[data-popper-placement=bottom].fade-and-scale,
div[data-popper-placement=bottom] > .fade-and-scale,
.fade-and-scale.scale-bottom {
  transform-origin: center top;
}

:host([data-popper-placement=bottom-start]),
:host([data-popper-placement=bottom-start]) .fade-and-scale,
div[data-popper-placement=bottom-start].fade-and-scale,
div[data-popper-placement=bottom-start] > .fade-and-scale,
.fade-and-scale.scale-bottom-start {
  transform-origin: left top;
}

:host([data-popper-placement=bottom-end]),
:host([data-popper-placement=bottom-end]) .fade-and-scale,
div[data-popper-placement=bottom-end].fade-and-scale,
div[data-popper-placement=bottom-end] > .fade-and-scale,
.fade-and-scale.scale-bottom-end {
  transform-origin: right top;
}

:host([data-popper-placement=left]),
:host([data-popper-placement=left]) .fade-and-scale,
div[data-popper-placement=left].fade-and-scale,
div[data-popper-placement=left] > .fade-and-scale,
.fade-and-scale.scale-left {
  transform-origin: right center;
}

:host([data-popper-placement=left-start]),
:host([data-popper-placement=left-start]) .fade-and-scale,
div[data-popper-placement=left-start].fade-and-scale,
div[data-popper-placement=left-start] > .fade-and-scale,
.fade-and-scale.scale-left-start {
  transform-origin: right top;
}

:host([data-popper-placement=left-end]),
:host([data-popper-placement=left-end]) .fade-and-scale,
div[data-popper-placement=left-end].fade-and-scale,
div[data-popper-placement=left-end] > .fade-and-scale,
.fade-and-scale.scale-left-end {
  transform-origin: right bottom;
}

:host([data-popper-placement=right]),
:host([data-popper-placement=right]) .fade-and-scale,
div[data-popper-placement=right].fade-and-scale,
div[data-popper-placement=right] > .fade-and-scale,
.fade-and-scale.scale-right {
  transform-origin: left center;
}

:host([data-popper-placement=right-start]),
:host([data-popper-placement=right-start]) .fade-and-scale,
div[data-popper-placement=right-start].fade-and-scale,
div[data-popper-placement=right-start] > .fade-and-scale,
.fade-and-scale.scale-right-start {
  transform-origin: left top;
}

:host([data-popper-placement=right-end]),
:host([data-popper-placement=right-end]) .fade-and-scale,
div[data-popper-placement=right-end].fade-and-scale,
div[data-popper-placement=right-end] > .fade-and-scale,
.fade-and-scale.scale-right-end {
  transform-origin: left bottom;
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: inline-flex;
  position: relative;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  width: 100%;
}

:host([skeleton-loading]) {
  display: inline-flex;
  pointer-events: none;
}

:host([fluid]:not([height], [collapsed])) {
  height: 100%;
}

.panel {
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0.5rem;
  box-sizing: border-box;
  padding: 1rem;
}
.panel.has-content:not(.collapsed) {
  gap: 1rem;
}
.panel .panel-header {
  display: flex;
  gap: 1rem;
  align-items: center;
  box-sizing: border-box;
  flex-wrap: wrap;
  flex-shrink: 0;
}
.panel .panel-header .panel-title {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex-grow: 1;
}
.panel .panel-header .panel-title .title-with-button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  width: auto;
}
.panel .panel-header .panel-title .title-with-button[skeleton-loading] {
  min-width: 300px;
}
.panel .panel-header atlas-collapse-button {
  order: 2;
}
.panel .panel-header .panel-description {
  width: 100%;
  display: block;
  order: 4;
}
.panel .panel-header atlas-toolbar {
  width: 100%;
  display: block;
  order: 3;
}
.panel .panel-body-wrapper {
  box-sizing: border-box;
  flex-grow: 1;
}
.panel .panel-body-wrapper.has-height {
  overflow-y: auto;
}
.panel .panel-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-sizing: border-box;
  height: 100%;
}
.panel .panel-body slot::slotted(atlas-table),
.panel .panel-body slot::slotted(atlas-easy-table:not([total-records="0"])),
.panel .panel-body slot::slotted(atlas-easy-table[skeleton-loading]) {
  margin-left: -1rem !important;
  margin-right: -1rem !important;
}
.panel.hide-header .panel-header {
  display: none;
}
.panel:not(.has-toolbar) atlas-toolbar {
  display: none;
}
.panel.collapsed {
  height: auto !important;
}

@media screen and (min-width: 992px) {
  .panel {
    padding: 1.5rem;
  }
  .panel.has-content:not(.collapsed) {
    gap: 1.5rem;
  }
  .panel .panel-header atlas-collapse-button {
    order: 3;
  }
  .panel .panel-header atlas-toolbar {
    width: auto;
    order: 2;
  }
  .panel .panel-body slot::slotted(atlas-table),
  .panel .panel-body slot::slotted(atlas-easy-table:not([total-records="0"])),
  .panel .panel-body slot::slotted(atlas-easy-table[skeleton-loading]) {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
.footer-actions-anchor .footer-actions {
  position: fixed;
  bottom: 0;
  left: 1rem;
  padding: 1rem;
  background: #ffffff;
  border-top: 1px solid #ced4da;
  width: calc(100% - 2rem);
  box-sizing: border-box;
  z-index: 10;
}
.footer-actions-anchor .footer-actions:not(.show) {
  pointer-events: none;
}
.footer-actions-anchor.is-intersecting .footer-actions {
  position: unset;
  padding: unset;
  background: unset;
  border: unset;
  width: unset !important;
  left: unset !important;
}`;

// src/components/form/atlas-form-panel/atlas-form-panel.ts
var AtlasFormPanel = /*#__PURE__*/(() => {
  let AtlasFormPanel = class extends AtlasPanel {
    constructor() {
      super(...arguments);
      this.cancelButtonLabel = "Cancelar";
      this.method = "get";
      this.editing = false;
      this.hideBadge = false;
      this.ignoreResetOnCancel = false;
      this.showConfirmationOnCancel = false;
      this._badgePropsBeforeEditing = {};
    }
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.onActionButtonClick = this.onActionButtonClick.bind(this);
      this.onChangeEditing = this.onChangeEditing.bind(this);
      this.onStartEditing = this.onStartEditing.bind(this);
      this.onEndEditing = this.onEndEditing.bind(this);
      this.onFormSubmit = this.onFormSubmit.bind(this);
      this.observeFooterActions = this.observeFooterActions.bind(this);
      this.onIntersection = this.onIntersection.bind(this);
      this.addEventListener("atlas-button-click", this.onActionButtonClick);
      this.addEventListener("atlas-dropdown-item-click", this.onActionButtonClick);
      this.addEventListener("atlas-form-submit", this.onFormSubmit);
      this._deviceController.setScreenChangeCallback(this.observeFooterActions);
      this.updateComplete.then(() => {
        this.onActionsSlotChange();
        this.observeContentChange();
      });
    }
    disconnectedCallback() {
      var _a, _b, _c;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      this.removeEventListener("atlas-button-click", this.onActionButtonClick);
      this.removeEventListener("atlas-dropdown-item-click", this.onActionButtonClick);
      this.removeEventListener("atlas-form-submit", this.onFormSubmit);
      (_b = this._intersectionObserver) == null ? void 0 : _b.disconnect();
      (_c = this._mutationObserver) == null ? void 0 : _c.disconnect();
    }
    /**
     * Cancela a edição do painel
     */
    cancelEditing() {
      return __async(this, null, function* () {
        this.editing = false;
        if (!this.ignoreResetOnCancel) {
          (yield this._panelForm).reset();
        }
      });
    }
    /**
     * Finaliza o modo de edição do painel
     */
    finishEditing() {
      this.editing = false;
    }
    /**
     * Reseta o formulário do painel
     */
    reset() {
      return __async(this, null, function* () {
        (yield this._panelForm).reset();
      });
    }
    /**
     * Ativa os botões do painel
     */
    enablePanelButtons() {
      this._submitButton.loading = false;
      this._cancelButton.enable();
    }
    /**
     * @override
     */
    onActionsSlotChange() {
      if (this.editing) {
        this._hasSlottedActions = true;
        return;
      }
      super.onActionsSlotChange();
    }
    onActionButtonClick(event) {
      const target = event.target;
      if (target.hasAttribute("data-panel-start-editing")) {
        this.editing = true;
      }
    }
    onStartEditing() {
      this.togglePanelFormElements(true);
      this.enablePanelButtons();
      this._badgePropsBeforeEditing = this.getAllBadgeProps();
      this.updatePanelBadge();
      const footerActionsAnchor = this.shadowRoot.querySelector(".footer-actions-anchor");
      footerActionsAnchor.hideElement();
      emit(this, "atlas-form-panel-start-editing", {
        trackDisable: true
      });
    }
    onEndEditing() {
      this.togglePanelFormElements(false);
      this.updatePanelBadge();
      this._badgePropsBeforeEditing = {};
      emit(this, "atlas-form-panel-end-editing", {
        trackDisable: true
      });
    }
    onFormSubmit(event) {
      event.stopPropagation();
      this._submitButton.loading = true;
      this._cancelButton.disable();
      const submitEvent = emit(this, "atlas-form-panel-submit", {
        trackDisable: true
      });
      if (submitEvent.defaultPrevented) {
        event.preventDefault();
      }
    }
    onChangeEditing() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        closeAllOverlays();
        this.observeFooterActions();
        if (this.editing) {
          this._hasSlottedActions = true;
          this.onStartEditing();
        } else {
          this.onEndEditing();
        }
      });
    }
    onClickCancelButton() {
      return __async(this, null, function* () {
        const cancelEvent = emit(this, "atlas-form-panel-cancel", {
          trackDisable: true
        });
        if (cancelEvent.defaultPrevented) return;
        if (!this.showConfirmationOnCancel || !this.hasUpdatedFormField()) {
          this.cancelEditing();
          return;
        }
        showConfirmation({
          illustration: "triangle-exclamation-mark-siren",
          size: "large",
          title: "Descartar altera\xE7\xF5es",
          content: "Algumas altera\xE7\xF5es n\xE3o foram salvas. Ao cancelar, todas as informa\xE7\xF5es ser\xE3o perdidas. Tem certeza que deseja descartar as altera\xE7\xF5es?",
          confirmButton: {
            theme: "danger",
            description: "Descartar altera\xE7\xF5es"
          },
          disableAutoClose: true,
          hideCloseButton: true,
          onConfirm: modal => __async(this, null, function* () {
            modal.closeModal();
            this.cancelEditing();
          })
        });
      });
    }
    onClickSubmitButton() {
      return __async(this, null, function* () {
        (yield this._panelForm).submit();
      });
    }
    hasUpdatedFormField() {
      return getAllFormElements(this).some(element => element.hasUpdatedValue());
    }
    togglePanelFormElements(enable) {
      setTimeout(() => {
        getAllFormElements(this).forEach(element => {
          if (enable && element.hasAttribute("data-atlas-form-panel-keep-disabled")) return;
          element.toggleDisabled(!enable);
        });
      }, 0);
    }
    observeFooterActions() {
      return __async(this, null, function* () {
        var _a;
        yield this.updateComplete;
        if (!this.editing) {
          (_a = this._intersectionObserver) == null ? void 0 : _a.disconnect();
          return;
        }
        this._intersectionObserver = new IntersectionObserver(this.onIntersection, {
          root: null,
          threshold: 0
        });
        if (!this._deviceController.isMobile) {
          this._intersectionObserver.observe(this.shadowRoot.querySelector(".form-panel-toolbar"));
        }
        this._intersectionObserver.observe(this.shadowRoot.querySelector(".footer-actions-anchor"));
      });
    }
    observeContentChange() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this._mutationObserver = new MutationObserver(mutations => {
          const hasUpdatedContent = mutations.some(mutation => mutation.type === "childList");
          if (hasUpdatedContent) {
            this.togglePanelFormElements(this.editing);
          }
        });
        this._mutationObserver.observe(this, {
          childList: true,
          subtree: true
        });
      });
    }
    onIntersection(entries) {
      const footerActionsAnchor = this.shadowRoot.querySelector(".footer-actions-anchor");
      const footerActions = footerActionsAnchor.querySelector(".footer-actions");
      const toolbar = this.shadowRoot.querySelector(".form-panel-toolbar");
      let isScrollBeforeToolbar = false;
      let isScrollAfterFooterActionsAnchor = false;
      const isToolbarInViewport = toolbar == null ? void 0 : toolbar.isVisibleInViewport();
      let isFooterActionsAnchorInViewPort = false;
      entries.forEach(entry => {
        if (entry.target.classList.contains("form-panel-toolbar")) {
          isScrollBeforeToolbar = entry.boundingClientRect.top > 0;
        } else if (entry.target.classList.contains("footer-actions-anchor")) {
          isFooterActionsAnchorInViewPort = entry.isIntersecting;
          isScrollAfterFooterActionsAnchor = entry.boundingClientRect.top < 0;
        }
      });
      const isIntersecting = isFooterActionsAnchorInViewPort || isScrollBeforeToolbar || isScrollAfterFooterActionsAnchor;
      const borderWidthModifier = this._deviceController.isMobile ? 1 : 0;
      footerActions.style.left = `${this.offsetLeft}px`;
      footerActions.style.width = `${this.offsetWidth - borderWidthModifier}px`;
      if (this._deviceController.isMobile) {
        footerActionsAnchor.showElement();
        footerActions.classList.add("show");
        footerActionsAnchor.classList.toggle("is-intersecting", isIntersecting);
      } else if (isToolbarInViewport || isScrollBeforeToolbar) {
        footerActions.classList.remove("show");
        setTimeout(() => {
          footerActionsAnchor.hideElement();
        }, 250);
      } else {
        footerActionsAnchor.showElement();
        setTimeout(() => {
          footerActions.classList.add("show");
          footerActionsAnchor.classList.toggle("is-intersecting", isIntersecting);
        }, 50);
      }
    }
    updatePanelBadge() {
      if (this.editing && !this.hideBadge) {
        this.setAttribute("badge-type", "outlined");
        this.setAttribute("badge-text", "Em edi\xE7\xE3o");
        this.setAttribute("badge-icon", "pencil");
        this.setAttribute("badge-theme", "primary");
        this.setAttribute("badge-tooltip", "");
        return;
      }
      Object.entries(this._badgePropsBeforeEditing).forEach(([prop, value]) => {
        if (typeof value === "boolean") {
          this.toggleAttribute(prop, value);
        } else if (value) {
          this.setAttribute(prop, value.toString());
        } else {
          this.removeAttribute(prop);
        }
      });
    }
    renderFormPanelActions(isFooterActions) {
      return html93`
            <atlas-layout
                gap="4"
                inline
                mobile-inline
                slot=${ifDefined20(!this._deviceController.isMobile ? "actions" : void 0)}
                justify=${ifDefined20(!this._deviceController.isMobile && isFooterActions ? "end" : void 0)}
            >
                <atlas-button
                    description=${this.cancelButtonLabel}
                    theme="secondary"
                    @atlas-button-click=${this.onClickCancelButton}
                    class="action-button-cancel"
                ></atlas-button>
                <atlas-button
                    description=${this.submitButtonLabel || "Salvar"}
                    theme="success"
                    @atlas-button-click=${this.onClickSubmitButton}
                    class="action-button-submit"
                ></atlas-button>
            </atlas-layout>
        `;
    }
    renderFooterActions() {
      const footerActionsClass = {
        "footer-actions": true,
        "fade-and-scale": true,
        "scale-vertically": true,
        "scale-top": true
      };
      return when66(this.editing, () => html93`
                <div class="footer-actions-anchor">
                    <div class=${classMap64(footerActionsClass)}>${this.renderFormPanelActions(true)}</div>
                </div>
            `);
    }
    /**
     * @override
     */
    renderContent() {
      return html93`
            <atlas-form action=${this.action} method=${this.method} target=${this.target}>
                <atlas-layout gap="6"> ${super.renderContent()} ${this.renderFooterActions()} </atlas-layout>
            </atlas-form>
        `;
    }
    /**
     * @override
     */
    renderActionsToolbar() {
      if (this._deviceController.isMobile && this.editing) return null;
      return html93`
            <atlas-toolbar class="form-panel-toolbar" only-actions ?has-visibility-icon=${this.hasVisibilityIcon}>
                ${when66(this.editing, () => this.renderFormPanelActions(false), () => html93`<slot slot="actions" name="actions" @slotchange=${this.onActionsSlotChange}></slot>`)}
            </atlas-toolbar>
        `;
    }
  };
  AtlasFormPanel.styles = atlas_form_panel_default;
  return AtlasFormPanel;
})();
__decorateClass([property96({
  type: String,
  attribute: "submit-button-label"
})], AtlasFormPanel.prototype, "submitButtonLabel", 2);
__decorateClass([property96({
  type: String,
  attribute: "cancel-button-label"
})], AtlasFormPanel.prototype, "cancelButtonLabel", 2);
__decorateClass([property96({
  type: String
})], AtlasFormPanel.prototype, "action", 2);
__decorateClass([property96({
  type: String
})], AtlasFormPanel.prototype, "method", 2);
__decorateClass([property96({
  type: String
})], AtlasFormPanel.prototype, "target", 2);
__decorateClass([property96({
  type: Boolean
})], AtlasFormPanel.prototype, "editing", 2);
__decorateClass([property96({
  type: Boolean,
  attribute: "hide-badge"
})], AtlasFormPanel.prototype, "hideBadge", 2);
__decorateClass([property96({
  type: Boolean,
  attribute: "ignore-reset-on-cancel"
})], AtlasFormPanel.prototype, "ignoreResetOnCancel", 2);
__decorateClass([property96({
  type: Boolean,
  attribute: "show-confirmation-on-cancel"
})], AtlasFormPanel.prototype, "showConfirmationOnCancel", 2);
__decorateClass([query19(".action-button-submit")], AtlasFormPanel.prototype, "_submitButton", 2);
__decorateClass([query19(".action-button-cancel")], AtlasFormPanel.prototype, "_cancelButton", 2);
__decorateClass([queryAsync("atlas-form")], AtlasFormPanel.prototype, "_panelForm", 2);
__decorateClass([Watch("editing")], AtlasFormPanel.prototype, "onChangeEditing", 1);
AtlasFormPanel = __decorateClass([customElement85("atlas-form-panel")], AtlasFormPanel);

// src/components/form/atlas-form-step/atlas-form-step.ts
import { html as html94 } from "lit";
import { customElement as customElement86, property as property97, state as state50 } from "lit/decorators.js";

// src/components/form/atlas-form-step/atlas-form-step.scss
import { css as css80 } from "lit-element/lit-element.js";
var atlas_form_step_default = css80`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: none;
  width: 100%;
}

:host([visible]) {
  display: block;
}`;

// src/components/form/atlas-form-step/atlas-form-step.ts
var AtlasFormStep = /*#__PURE__*/(() => {
  let AtlasFormStep = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this._visible = false;
    }
    toggleStep(show) {
      this._visible = show;
      this.toggleAttribute("visible", this._visible);
    }
    getStepValues(asFormData) {
      return getFormValues(this, asFormData);
    }
    validate() {
      return reportFormValidity(this);
    }
    render() {
      return html94`<slot></slot>`;
    }
  };
  AtlasFormStep.styles = atlas_form_step_default;
  return AtlasFormStep;
})();
__decorateClass([property97({
  type: String
})], AtlasFormStep.prototype, "name", 2);
__decorateClass([state50()], AtlasFormStep.prototype, "_visible", 2);
AtlasFormStep = __decorateClass([customElement86("atlas-form-step")], AtlasFormStep);

// src/components/form/atlas-integer-input/atlas-integer-input.ts
import { customElement as customElement87, property as property98 } from "lit/decorators.js";
var AtlasIntegerInput = class extends AtlasInput {
  constructor() {
    super(...arguments);
    this.allowNegative = false;
    this.allowLeadingZero = false;
    this._maskOptions = {};
  }
  /**
   * @internal
   * @override
   */
  connectedCallback() {
    var _a;
    (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
    this.updateComplete.then(() => {
      this.buildMask();
    });
  }
  /**
   * @internal
   * @override
   */
  onChangeValue() {
    this.formatValueWithMaskIfNecessary();
    super.onChangeValue();
  }
  /**
   * Retorna o valor do campo sem a máscara
   * @returns {string | number} - O valor do campo sem a máscara
   */
  getUnmaskedValue() {
    return this._maskInstance.unmaskedvalue();
  }
  handlePaste(event) {
    return __async(this, null, function* () {
      var _a, _b;
      if (this.allowLeadingZero) {
        (_a = __superGet(AtlasIntegerInput.prototype, this, "handlePaste")) == null ? void 0 : _a.call(this, event);
        return;
      }
      yield this.updateComplete;
      const pastedValue = removeNonNumeric(event.clipboardData.getData("text"), {
        allowNegative: this.allowNegative
      });
      if (!pastedValue) return;
      const {
        selectionStart,
        selectionEnd
      } = this._input;
      const currentValue = this.value ? String(this.value) : "";
      const isFullSelection = selectionStart === 0 && selectionEnd === currentValue.length;
      if (isFullSelection) {
        this.value = pastedValue;
      } else {
        this.value = this.getCombinedValue(pastedValue, selectionStart, selectionEnd);
      }
      (_b = __superGet(AtlasIntegerInput.prototype, this, "handlePaste")) == null ? void 0 : _b.call(this, event);
    });
  }
  getCombinedValue(pastedValue, selectionStart, selectionEnd) {
    const currentValue = this.value ? String(this.value) : "";
    const combinedValue = currentValue.slice(0, selectionStart) + pastedValue + currentValue.slice(selectionEnd);
    return removeNonNumeric(combinedValue, {
      allowNegative: this.allowNegative
    });
  }
  formatValueWithMaskIfNecessary() {
    if (!inputmask_utils_default.isValid(this.value, this._maskOptions)) {
      this.value = inputmask_utils_default.format(this.value, this._maskOptions);
    }
  }
  buildMask() {
    var _a;
    this.inputMode = "numeric";
    if (this.allowLeadingZero) this.placeholder = (_a = this.placeholder) != null ? _a : "0".repeat(this.maxlength || 0);
    this._maskOptions = {
      allowMinus: this.allowNegative,
      alias: this.allowLeadingZero ? "onlyNumericDigits" : "integer"
    };
    if (!this.allowLeadingZero) {
      this._maskOptions.onBeforePaste = () => false;
    }
    this._maskInstance = inputmask_utils_default(this._maskOptions).mask(this._input);
    this._maskInstance.shadowRoot = this.shadowRoot;
    this.addValidator(new RangeValidator(this.maxValueErrorMessage, this.minValueErrorMessage));
    if (this.value) this.formatValueWithMaskIfNecessary();
  }
};
__decorateClass([property98({
  type: Number,
  attribute: "max-value"
})], AtlasIntegerInput.prototype, "maxValue", 2);
__decorateClass([property98({
  type: String,
  attribute: "max-value-error-message"
})], AtlasIntegerInput.prototype, "maxValueErrorMessage", 2);
__decorateClass([property98({
  type: Number,
  attribute: "min-value"
})], AtlasIntegerInput.prototype, "minValue", 2);
__decorateClass([property98({
  type: String,
  attribute: "min-value-error-message"
})], AtlasIntegerInput.prototype, "minValueErrorMessage", 2);
__decorateClass([property98({
  type: Boolean,
  attribute: "allow-negative"
})], AtlasIntegerInput.prototype, "allowNegative", 2);
__decorateClass([property98({
  type: Boolean,
  attribute: "allow-leading-zero"
})], AtlasIntegerInput.prototype, "allowLeadingZero", 2);
AtlasIntegerInput = __decorateClass([customElement87("atlas-integer-input")], AtlasIntegerInput);

// src/components/form/atlas-masked-input/atlas-masked-input.ts
import { customElement as customElement88, property as property99 } from "lit/decorators.js";

// src/internals/validators/mask-validator.ts
var MaskValidator = class {
  constructor(type, customErrorMessage) {
    this.name = "mask";
    this.status = "error";
    this.type = type;
    this.customErrorMessage = customErrorMessage;
  }
  getInvalidMessage() {
    return this.customErrorMessage || getMaskValidatorMessage(this.type);
  }
  validate(element) {
    const elementValue = element.getElementValue();
    const validationFn = getMaskValidationFunction(this.type);
    if (elementValue) {
      return validationFn(elementValue);
    }
    return true;
  }
};

// src/components/form/atlas-masked-input/atlas-masked-input.ts
var AtlasMaskedInput = class extends AtlasInput {
  constructor() {
    super(...arguments);
    this._configPlaceholder = "";
  }
  /** @internal */
  connectedCallback() {
    var _a;
    (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
    this.updateComplete.then(() => {
      this._configPlaceholder = this.placeholder;
      this.buildMask();
    });
  }
  /**
   * @internal
   * @override
   */
  onChangeValue() {
    if (this._maskInstance && !inputmask_utils_default.isValid(this.value, this._maskInstance.userOptions)) {
      this.value = inputmask_utils_default.format(this.value, this._maskInstance.userOptions);
    }
    super.onChangeValue();
  }
  onChangeMask() {
    this.value = "";
    this.buildMask();
  }
  /**
   * Retorna o valor do campo sem a máscara
   * @returns {string} - O valor do campo sem a máscara
   */
  getUnmaskedValue() {
    return this._maskInstance.unmaskedvalue();
  }
  buildMask() {
    if (this.mask) {
      this.buildCustomMask();
    } else if (this.maskAlias) {
      this.buildAliasMask();
    }
  }
  buildAliasMask() {
    const maskObject = {
      alias: this.maskAlias
    };
    this.placeholder = this._configPlaceholder || getMaskPlaceholder(this.maskAlias);
    this.inputMode = getMaskInputMode(this.maskAlias);
    this._maskInstance = inputmask_utils_default(maskObject).mask(this._input);
    if (this.value) this.value = inputmask_utils_default.format(this.value, maskObject);
    this._maskInstance.shadowRoot = this.shadowRoot;
    const maskValidator = this.getValidator("mask");
    if (!maskValidator) {
      this.addValidator(new MaskValidator(this.maskAlias, this.invalidMaskErrorMessage));
    } else {
      maskValidator.type = this.maskAlias;
      maskValidator.customErrorMessage = this.invalidMaskErrorMessage;
    }
  }
  buildCustomMask() {
    const maskObject = {
      mask: [this.mask],
      jitMasking: true,
      keepStatic: true,
      showMaskOnHover: false
    };
    this._maskInstance = inputmask_utils_default(maskObject).mask(this._input);
    this.placeholder = this._configPlaceholder || this.mask.replace(/[1-9]/g, "0");
    if (this.value) this.value = inputmask_utils_default.format(this.value, maskObject);
  }
};
__decorateClass([property99({
  type: String,
  attribute: "mask-alias"
})], AtlasMaskedInput.prototype, "maskAlias", 2);
__decorateClass([property99({
  type: String,
  attribute: "invalid-mask-error-message"
})], AtlasMaskedInput.prototype, "invalidMaskErrorMessage", 2);
__decorateClass([property99({
  type: String,
  attribute: "mask"
})], AtlasMaskedInput.prototype, "mask", 2);
__decorateClass([Watch(["maskAlias", "mask"], true)], AtlasMaskedInput.prototype, "onChangeMask", 1);
AtlasMaskedInput = __decorateClass([customElement88("atlas-masked-input")], AtlasMaskedInput);

// src/components/form/atlas-money/atlas-money.ts
import { customElement as customElement89, property as property100 } from "lit/decorators.js";
var AtlasMoney = class extends AtlasFloatInput {
  constructor() {
    super(...arguments);
    this.maxlength = 15;
  }
  /** @internal */
  connectedCallback() {
    var _a;
    (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
    this.updateComplete.then(() => {
      this.inputGroupPrefix = "R$";
    });
  }
};
__decorateClass([property100({
  type: Number,
  reflect: true
})], AtlasMoney.prototype, "maxlength", 2);
AtlasMoney = __decorateClass([customElement89("atlas-money")], AtlasMoney);

// src/components/form/atlas-multiselect/atlas-multiselect.ts
import { html as html95 } from "lit";
import { customElement as customElement90, state as state51, query as query20, property as property101 } from "lit/decorators.js";
import { classMap as classMap65 } from "lit/directives/class-map.js";

// src/components/form/atlas-multiselect/atlas-multiselect.scss
import { css as css81 } from "lit-element/lit-element.js";
var atlas_multiselect_default = css81`:host([width=full]) {
  width: 100%;
}

:host([width=xs]) {
  width: 96px;
}

:host([width=sm]) {
  width: 152px;
}

:host([width=md]) {
  width: 264px;
}

:host([width=lg]) {
  width: 380px;
}

.atlas-multiselect-container {
  position: relative;
  cursor: pointer;
}
.atlas-multiselect-container.has-search {
  cursor: text;
}
.atlas-multiselect-container atlas-tag {
  position: absolute;
  left: 0.75rem;
}`;

// src/components/form/atlas-multiselect/atlas-multiselect.ts
var AtlasMultiselect = /*#__PURE__*/(() => {
  let AtlasMultiselect = class extends AtlasSelect {
    constructor() {
      super(...arguments);
      this.enableSelectAll = false;
      this.getValueAsArray = false;
      this._selected = [];
      this._tagMarginTop = "0";
      this._deviceController = new DeviceController(this);
    }
    /** @override */
    getElementValue() {
      if (this.getValueAsArray) {
        return this.value.split(",");
      }
      return this.value;
    }
    /** @override */
    getSelectedOptions() {
      return this._selected;
    }
    /** @override */
    onTagRemove() {
      this.value = "";
    }
    /** @override */
    onInputKeyDown(event) {
      const escapeKeys = ["Tab", "Escape"];
      if (escapeKeys.includes(event.key)) return;
      this._selectDropdown.openDropdown();
      setTimeout(() => {
        if (event.key !== "Enter" && this._inputValue !== this._lastInputValue) {
          this._isTyping = true;
        }
      }, 0);
    }
    /** @override */
    onSelectDropdownInputKeyDown() {
      this._isTyping = true;
    }
    onChangeValue() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const selectedValues = this.getSelectedValues();
        this._selected = this._selectOptions.filter(option => selectedValues.includes(`${option.value}`));
        this._showLoadingOnSearch = false;
        if (this._syncInputValueOnNextChange) {
          this.syncTextWithSelectedValue();
        }
        this._syncInputValueOnNextChange = true;
        emit(this, "atlas-multiselect-change");
      });
    }
    /** @override */
    getVisibleOptions() {
      if ((!this.hasApiSearch() || this.searchOnce) && this._isTyping) {
        return this._selectOptions.filter(opt => opt.label.toUpperCase().includes(this._inputValue.toUpperCase()));
      }
      return this._selectOptions;
    }
    /** @override */
    getPlaceholder() {
      return this.placeholder || "Selecione as op\xE7\xF5es";
    }
    /** @override */
    syncTextWithSelectedValue() {
      this._inputValue = "";
    }
    /** @override */
    onSelectDropdownChange(event) {
      const {
        option,
        removeOption
      } = event.detail;
      if (removeOption) {
        this.removeOption(option);
        return;
      }
      if (this.value) {
        this.selectOption(`${this.value},${option}`);
      } else {
        this.selectOption(`${option}`);
      }
    }
    calculateTagPosition() {
      return __async(this, null, function* () {
        yield this._selectInput.updateComplete;
        const label = this._selectInput.shadowRoot.querySelector(".form-label");
        const labelPadding = 8;
        const borderAdjust = 1;
        const inputPadding = this._deviceController.isMobile ? 4 : 8;
        if (!label) {
          this._tagMarginTop = `${inputPadding + borderAdjust}px`;
          return;
        }
        const labelPosition = label.getBoundingClientRect();
        this._tagMarginTop = `${labelPosition.height + labelPadding + inputPadding + borderAdjust}px`;
      });
    }
    getTagText() {
      if (this._selected.length === 1) {
        return `${this._selected.length} op\xE7\xE3o selecionada`;
      }
      return `${this._selected.length} op\xE7\xF5es selecionadas`;
    }
    removeOption(optionValue) {
      if (optionValue === "") {
        this.value = "";
        return;
      }
      this.value = this.getSelectedValues().filter(value => optionValue !== value).join(",");
    }
    /** @override */
    renderTag() {
      if (this._selected.length === 0) return html95``;
      this.calculateTagPosition();
      return html95`
            <atlas-tag
                text=${this.getTagText()}
                ?disabled=${this.disabled}
                @atlas-tag-close-click=${this.onTagRemove}
                style="top: ${this._tagMarginTop}"
            ></atlas-tag>
        `;
    }
    /** @override */
    renderInput() {
      const inputClass = {
        "atlas-multiselect-input": true,
        "has-tag": this._selected.length > 0,
        "collapsed": !this._isDropdownOpen
      };
      const placeholder = this.getPlaceholder();
      return html95`
            <atlas-input
                class="${classMap65(inputClass)}"
                label=${this.label}
                size=${this.size}
                width=${this.width}
                placeholder=${placeholder}
                icon="chevron-down"
                value=${this._inputValue}
                ?disabled=${this.disabled}
                ?loading=${this._showLoadingOnSearch && this.loading}
                ?hide-optional=${this.required || this.hideOptional}
                action-button-description=${this.actionButtonDescription}
                helper-text=${this.helperText}
                popover-title=${this.popoverTitle}
                popover-content=${this.popoverContent}
                tooltip=${this.tooltip}
                tooltip-placement=${this.tooltipPlacement}
                tooltip-trigger=${this.tooltipTrigger}
                data-atlas-dropdown="select-dropdown"
                @atlas-input-change=${this.onInputChange}
                @atlas-input-focus=${this.onInputFocus}
                @atlas-input-blur=${this.onInputBlur}
                @keydown=${this.onInputKeyDown}
                ignore-validations
                ?readonly=${!this.hasSearch() && !this.hasApiSearch()}
                ?prevent-disabled-action-button=${this.preventDisabledActionButton}
            >
                <slot name="helper-text" slot="helper-text"></slot>
                ${this.renderNamedPopoverSlot()}
            </atlas-input>
        `;
    }
    /** @override */
    renderSelectDropdown() {
      const placeholder = this.getPlaceholder();
      return html95`
            <atlas-select-dropdown
                header=${this.label}
                ?loading=${this.loading || this.hasApiSearch() && !this._hasDoneFirstSearch}
                ?enable-new=${this.enableNew}
                ?enable-select-all=${this.enableSelectAll}
                new-item-prefix=${this.newItemPrefix}
                .options=${this.getVisibleOptions()}
                .selectedOptions=${this._selected}
                search-value=${this._inputValue}
                search-placeholder=${placeholder}
                empty-state-text=${this.emptyStateText}
                extra-keys=${this.extraKeys}
                .groups=${this.groups}
                ?is-typing=${this._isTyping}
                ?enable-search=${this.hasSearch() || this.hasApiSearch()}
                ?disabled=${this.disabled}
                multiselect
            ></atlas-select-dropdown>
        `;
    }
    /** @internal */
    render() {
      const multiselectClass = {
        "atlas-multiselect-container": true,
        "has-search": this.hasSearch() || this.hasApiSearch()
      };
      return html95`
            <div class="${classMap65(multiselectClass)}">${this.renderInput()} ${this.renderTag()}</div>
            ${this.renderSelectDropdown()}
            <slot @slotchange=${this.loadSlottedOptions}></slot>
        `;
    }
  };
  AtlasMultiselect.styles = atlas_multiselect_default;
  return AtlasMultiselect;
})();
__decorateClass([property101({
  type: Boolean,
  attribute: "enable-select-all"
})], AtlasMultiselect.prototype, "enableSelectAll", 2);
__decorateClass([property101({
  type: Boolean,
  attribute: "get-value-as-array"
})], AtlasMultiselect.prototype, "getValueAsArray", 2);
__decorateClass([state51()], AtlasMultiselect.prototype, "_selected", 2);
__decorateClass([state51()], AtlasMultiselect.prototype, "_tagMarginTop", 2);
__decorateClass([query20(".atlas-multiselect-input")], AtlasMultiselect.prototype, "_selectInput", 2);
__decorateClass([Watch("value", true)], AtlasMultiselect.prototype, "onChangeValue", 1);
AtlasMultiselect = __decorateClass([customElement90("atlas-multiselect")], AtlasMultiselect);

// src/components/form/atlas-one-time-code/atlas-one-time-code.ts
import { html as html96 } from "lit";
import { customElement as customElement91, property as property102, state as state52 } from "lit/decorators.js";
import { classMap as classMap66 } from "lit/directives/class-map.js";
import { map as map3 } from "lit/directives/map.js";
import { range as range2 } from "lit/directives/range.js";
import { live as live5 } from "lit/directives/live.js";

// src/components/form/atlas-one-time-code/atlas-one-time-code.scss
import { css as css82 } from "lit-element/lit-element.js";
var atlas_one_time_code_default = css82`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
.status-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.8rem;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}

.is-info ~ .status-feedback {
  display: block;
}

.status-info {
  color: var(--atlas-secondary);
}

.is-success {
  border-color: var(--atlas-success) !important;
}
.is-success:focus, .is-success:focus-visible, .is-success.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
  border-color: var(--atlas-success);
}
.is-success ~ .status-feedback {
  display: block;
}
.is-success ~ .form-check-label {
  color: var(--atlas-success);
}
.is-success .focus-mark {
  background: var(--atlas-success-300);
}
.is-success.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-success) !important;
  background-color: rgba(var(--atlas-success-rgb), 2%);
}
.is-success.rating-buttons-group .rating-button {
  border-color: var(--atlas-success) !important;
  color: var(--atlas-success) !important;
}
.is-success.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-success-400) !important;
  color: #ffffff !important;
}
.is-success.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
}
.is-success.rating-buttons-group .rating-button:active:not(:disabled), .is-success.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-success) !important;
  color: #ffffff !important;
}

.form-check:has(.is-success) .form-check-label {
  color: var(--atlas-success);
}
.form-check:has(.is-success) .form-check-input:checked {
  background-color: var(--atlas-success);
}

.status-success {
  color: var(--atlas-success);
}

.is-warning {
  border-color: var(--atlas-warning) !important;
}
.is-warning:focus, .is-warning:focus-visible, .is-warning.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
  border-color: var(--atlas-warning);
}
.is-warning ~ .status-feedback {
  display: block;
}
.is-warning ~ .form-check-label {
  color: var(--atlas-warning);
}
.is-warning .focus-mark {
  background: var(--atlas-warning-300);
}
.is-warning.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-warning) !important;
  background-color: rgba(var(--atlas-warning-rgb), 2%);
}
.is-warning.rating-buttons-group .rating-button {
  border-color: var(--atlas-warning) !important;
  color: var(--atlas-warning) !important;
}
.is-warning.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-warning-400) !important;
  color: #ffffff !important;
}
.is-warning.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
}
.is-warning.rating-buttons-group .rating-button:active:not(:disabled), .is-warning.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-warning) !important;
  color: #ffffff !important;
}

.form-check:has(.is-warning) .form-check-label {
  color: var(--atlas-warning);
}
.form-check:has(.is-warning) .form-check-input:checked {
  background-color: var(--atlas-warning);
}

.status-warning {
  color: var(--atlas-warning);
}

.is-error {
  border-color: var(--atlas-danger) !important;
}
.is-error:focus, .is-error:focus-visible, .is-error.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
  border-color: var(--atlas-danger);
}
.is-error ~ .status-feedback {
  display: block;
}
.is-error ~ .form-check-label {
  color: var(--atlas-danger);
}
.is-error .focus-mark {
  background: var(--atlas-danger-300);
}
.is-error.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-danger) !important;
  background-color: rgba(var(--atlas-danger-rgb), 2%);
}
.is-error.rating-buttons-group .rating-button {
  border-color: var(--atlas-danger) !important;
  color: var(--atlas-danger) !important;
}
.is-error.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-danger-400) !important;
  color: #ffffff !important;
}
.is-error.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
}
.is-error.rating-buttons-group .rating-button:active:not(:disabled), .is-error.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-danger) !important;
  color: #ffffff !important;
}

.form-check:has(.is-error) .form-check-label {
  color: var(--atlas-danger);
}
.form-check:has(.is-error) .form-check-input:checked {
  background-color: var(--atlas-danger);
}

.status-error {
  color: var(--atlas-danger);
}

.sm {
  width: 2rem;
}

.md {
  width: 2.5rem;
}

.lg {
  width: 3rem;
}`;

// src/components/form/atlas-one-time-code/atlas-one-time-code.ts
var AtlasOneTimeCode = /*#__PURE__*/(() => {
  let AtlasOneTimeCode = class extends FormControl {
    constructor() {
      super();
      this.length = 6;
      this.type = "numeric";
      this.size = "md";
      this.required = true;
      this._digits = [];
      this._slotInputList = [];
      this.handleBlur = this.handleBlur.bind(this);
      this.handleKeyDown = this.handleKeyDown.bind(this);
      this.handleInput = this.handleInput.bind(this);
      this.handleFocus = this.handleFocus.bind(this);
      this.handlePaste = this.handlePaste.bind(this);
      this.addValidator(new LengthValidator(false));
    }
    /** @internal */
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.buildEmptyDigitsList();
      this.updateComplete.then(() => {
        this.buildSlotInputList();
      });
    }
    onStatusChange() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this.updateInputStatus();
      });
    }
    onLengthChange() {
      this.buildEmptyDigitsList();
      this.buildSlotInputList();
    }
    onValueChange() {
      if (this.value === this._digits.join("")) return;
      if (!this.value) {
        this.buildEmptyDigitsList();
        this._slotInputList.forEach(input => {
          input.value = "";
        });
        return;
      }
      const digits = this.validateAndFilterCode(this.value);
      this.value = digits.join("");
      this.buildDigitsListFromValue(digits);
    }
    /**
     * Retorna o regex de validação de dígitos de acordo com o tipo de código
     * @returns {RegExp} O regex de validação de dígitos
     */
    getDigitValidationRegex() {
      return this.type === "numeric" ? AtlasOneTimeCode.NUMERIC_REGEX : AtlasOneTimeCode.ALPHANUMERIC_REGEX;
    }
    validateAndFilterCode(code) {
      const digits = code.split("");
      const validCodeTypeRegex = this.getDigitValidationRegex();
      return digits.filter(digit => {
        return validCodeTypeRegex.test(digit);
      }).slice(0, this.length);
    }
    buildSlotInputList() {
      this._slotInputList = [...this.shadowRoot.querySelectorAll("atlas-input")];
    }
    onChangeDigits() {
      this.updateValue();
      this.checkValidity();
      if (this.value.length === this.length) {
        emit(this, "atlas-one-time-code-fulfilled", {
          detail: this._digits,
          trackDisable: true
        });
      }
    }
    buildEmptyDigitsList() {
      this._digits = Array.from({
        length: this.length
      }, () => "");
    }
    buildDigitsListFromValue(value) {
      this._digits = Array.from({
        length: this.length
      }, (_, index) => value[index] || "");
    }
    goToFirstEmptyInput() {
      const firstEmptyInputIndex = this.getFirstEmptyInputIndex();
      if (firstEmptyInputIndex === null) return;
      const input = this._slotInputList[firstEmptyInputIndex];
      input.focus();
    }
    goToIndex(index) {
      if (index < 0 || index > this.length) return;
      const firstEmptyInputIndex = this.getFirstEmptyInputIndex();
      const isFirstEmptyInputIndexValid = firstEmptyInputIndex !== null && index > firstEmptyInputIndex;
      const inputIndex = isFirstEmptyInputIndexValid ? firstEmptyInputIndex : index;
      const input = this._slotInputList[inputIndex];
      input.focus();
      this.selectInputValue(input);
    }
    getInputIndex(input) {
      return parseInt(input.dataset.inputIndex, 10);
    }
    getFirstEmptyInputIndex() {
      const index = this._digits.findIndex(code => !code);
      return index === -1 ? null : index;
    }
    checkIfAllInputsAreFilled() {
      return this._digits.every(Boolean);
    }
    updateInputStatus() {
      this._slotInputList.forEach(input => {
        input._status = this._status;
        input._valid = this._valid;
        input._showStatusMessage = this._showStatusMessage;
      });
    }
    updateValue() {
      this.value = this._digits.filter(Boolean).join("");
    }
    selectInputValue(input) {
      setTimeout(() => {
        var _a;
        (_a = input.shadowRoot) == null ? void 0 : _a.querySelector("input").select();
      }, 0);
    }
    handleKeyDown(event) {
      const target = event.target;
      const index = this.getInputIndex(target);
      const key = event.detail.key;
      switch (key) {
        case "ArrowRight":
        case "ArrowUp":
          event.preventDefault();
          this.goToIndex(index + 1);
          break;
        case "ArrowLeft":
        case "ArrowDown":
          event.preventDefault();
          this.goToIndex(index - 1);
          break;
        case "Home":
          event.preventDefault();
          this.goToIndex(0);
          break;
        case "End":
          event.preventDefault();
          this.goToIndex(this.length - 1);
          break;
        case "Backspace":
          if (!this._digits[index]) {
            this._digits[index] = "";
            this.goToIndex(index - 1);
          }
          break;
      }
    }
    handlePaste(event) {
      var _a;
      event.preventDefault();
      const clipboardData = ((_a = event.detail.clipboardData) == null ? void 0 : _a.getData("text")) || "";
      if (clipboardData.length > this.length) {
        return;
      }
      const digits = this.validateAndFilterCode(clipboardData);
      this.buildDigitsListFromValue(digits);
      this.onChangeDigits();
      this.goToFirstEmptyInput();
    }
    handleInput(event) {
      const input = event.target;
      const index = this.getInputIndex(input);
      const value = event.detail;
      const validCodeTypeRegex = this.getDigitValidationRegex();
      if (!validCodeTypeRegex.test(value)) {
        event.preventDefault();
        input.requestUpdate();
        return;
      }
      this._digits[index] = value;
      this.onChangeDigits();
      if (this.checkIfAllInputsAreFilled()) return;
      if (value.length !== 1) {
        return;
      }
      this.goToIndex(index + 1);
    }
    handleFocus(event) {
      const input = event.target;
      const index = this.getInputIndex(input);
      const hasValue = !!input.value;
      const firstEmptyInputIndex = this.getFirstEmptyInputIndex();
      const allInputsAreFilled = this.checkIfAllInputsAreFilled();
      if (!hasValue && firstEmptyInputIndex !== index && !allInputsAreFilled) {
        this.goToIndex(firstEmptyInputIndex);
        return;
      }
      if (!hasValue) {
        return;
      }
      this.selectInputValue(input);
    }
    handleBlur() {
      setTimeout(() => {
        if (document.activeElement !== this) {
          this.reportValidity();
        }
      }, 0);
    }
    getInputMode() {
      return this.type === "numeric" ? "numeric" : "text";
    }
    renderSlotInputs() {
      const inputClasses = {
        "one-time-code-input": true,
        "sm": this.size === "sm",
        "md": this.size === "md",
        "lg": this.size === "lg"
      };
      return map3(range2(this.length), index => html96`
                <atlas-input
                    class="${classMap66(inputClasses)}"
                    ?disabled="${this.disabled}"
                    ignore-validations
                    placeholder="-"
                    size="${this.size}"
                    type="text"
                    value="${live5(this._digits[index])}"
                    inputmode="${this.getInputMode()}"
                    @atlas-input-keydown=${this.handleKeyDown}
                    @atlas-input-input="${this.handleInput}"
                    @atlas-input-focus="${this.handleFocus}"
                    @atlas-input-blur="${this.handleBlur}"
                    @atlas-input-paste="${this.handlePaste}"
                    data-input-index="${index}"
                ></atlas-input>
            `);
    }
    /** @internal */
    render() {
      const classes = {
        [`is-${this._status}`]: this.getShowStatus()
      };
      return html96`
            <atlas-layout gap="1">
                ${this.renderLabel()}
                <atlas-layout inline mobile-inline gap="2" class=${classMap66(classes)}>
                    ${this.renderSlotInputs()}
                </atlas-layout>
                ${this.renderHelperText({
        isInputHelper: true
      })} ${this.renderStatusMessage()}
            </atlas-layout>
        `;
    }
  };
  AtlasOneTimeCode.styles = atlas_one_time_code_default;
  AtlasOneTimeCode.NUMERIC_REGEX = /^[0-9]{0,1}$/;
  AtlasOneTimeCode.ALPHANUMERIC_REGEX = /^[0-9A-Za-z]{0,1}$/;
  return AtlasOneTimeCode;
})();
__decorateClass([property102({
  type: Number,
  reflect: true
})], AtlasOneTimeCode.prototype, "length", 2);
__decorateClass([property102({
  type: String
})], AtlasOneTimeCode.prototype, "type", 2);
__decorateClass([property102({
  type: String
})], AtlasOneTimeCode.prototype, "size", 2);
__decorateClass([property102({
  type: Boolean
})], AtlasOneTimeCode.prototype, "required", 2);
__decorateClass([state52()], AtlasOneTimeCode.prototype, "_digits", 2);
__decorateClass([Watch(["_status", "_valid", "_showStatusMessage"], true)], AtlasOneTimeCode.prototype, "onStatusChange", 1);
__decorateClass([Watch(["length"], true)], AtlasOneTimeCode.prototype, "onLengthChange", 1);
__decorateClass([Watch(["value"], false)], AtlasOneTimeCode.prototype, "onValueChange", 1);
AtlasOneTimeCode = __decorateClass([customElement91("atlas-one-time-code")], AtlasOneTimeCode);

// src/components/form/atlas-option/atlas-option.ts
import { LitElement as LitElement26 } from "lit";
import { customElement as customElement92, property as property103 } from "lit/decorators.js";
var AtlasOption = class extends LitElement26 {
  constructor() {
    super(...arguments);
    this.value = "";
    this.label = "";
    this.group = "";
    this.disabled = false;
    this.selected = false;
  }
};
__decorateClass([property103({
  type: String
})], AtlasOption.prototype, "value", 2);
__decorateClass([property103({
  type: String
})], AtlasOption.prototype, "label", 2);
__decorateClass([property103({
  type: String
})], AtlasOption.prototype, "group", 2);
__decorateClass([property103({
  type: Boolean,
  reflect: true
})], AtlasOption.prototype, "disabled", 2);
__decorateClass([property103({
  type: Boolean,
  reflect: true
})], AtlasOption.prototype, "selected", 2);
AtlasOption = __decorateClass([customElement92("atlas-option")], AtlasOption);

// src/components/form/atlas-password-input/atlas-password-input.ts
import { customElement as customElement93, property as property104 } from "lit/decorators.js";
import { when as when67 } from "lit/directives/when.js";

// src/components/form/atlas-password-input/atlas-password-input.scss
import { css as css83 } from "lit-element/lit-element.js";
var atlas_password_input_default = css83`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Z-index mapping for the floating elements */
/* Shadows */
/* Elevations */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.form-label {
  margin-bottom: 0.5rem;
  font-style: normal;
  box-sizing: border-box;
  display: inline-block;
}
.form-label-optional {
  color: #687078;
}
.form-label atlas-icon-button {
  top: 2px;
}
.form-label[skeleton-loading] {
  min-width: 40%;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Z-index mapping for the floating elements */
/* Shadows */
/* Elevations */
.form-control {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #1a1e21;
  appearance: none;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  cursor: text;
}
.form-control > .form-control-input {
  border: none;
  appearance: none;
  background-color: transparent;
  margin: 0;
  padding: 0;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #1a1e21;
  width: 100%;
  cursor: text;
}
.form-control > .form-control-input:focus, .form-control > .form-control-input:focus-visible {
  outline: none;
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control.form-control-multiple {
  display: flex;
  flex-flow: row wrap;
  gap: 0.5rem;
  overflow-y: overlay;
  max-height: 200px;
  cursor: text;
}
.form-control.form-control-multiple > .form-control-input {
  flex-grow: 1;
  min-width: 100px;
  width: 1%;
}
.form-control .form-control-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
.form-control .form-control-sm > .form-control-input {
  font-size: 0.875rem;
}
.form-control .form-control-lg {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
}
.form-control .form-control-lg > .form-control-input {
  font-size: 1.25rem;
}
.form-control:focus, .form-control:focus-within {
  color: #1a1e21;
  background-color: #ffffff;
  border-color: var(--atlas-primary-300);
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-300-rgb), 0.25);
  outline: 0;
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder,
.form-control > .form-control-input::placeholder {
  color: #687078;
  opacity: 1;
}
.form-control:disabled, .form-control:has(.form-control-input:disabled) {
  background-color: #e9ecef;
  opacity: 1;
}
.form-control.hide-placeholder::placeholder,
.form-control.hide-placeholder > .form-control-input::placeholder {
  color: transparent;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
  /* stylelint-disable no-descending-specificity */
  /* stylelint-enable no-descending-specificity */
}
.input-group atlas-button {
  position: relative;
  z-index: 2;
}
.input-group atlas-button:focus {
  z-index: 5;
}
.input-group .input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.input-group .input-group-text.input-group-prefix {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group .input-group-text.input-group-suffix {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group .form-control {
  border-radius: 0.25rem !important;
  box-sizing: border-box;
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group .form-control.has-icon {
  padding-right: 1.75rem;
}
.input-group .form-control.has-right-element, .input-group .form-control.has-action-button {
  border-bottom-right-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
.input-group .form-control.has-left-element {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}
.input-group .form-control .input-icon,
.input-group .form-control ~ .input-icon {
  position: absolute;
  right: 0.75rem;
  top: 0.815rem;
  z-index: 5;
  pointer-events: none;
}
.input-group .form-control .input-icon.has-click,
.input-group .form-control ~ .input-icon.has-click {
  cursor: pointer;
  pointer-events: all;
}
.input-group .form-control .side-image,
.input-group .form-control ~ .side-image {
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  height: 1.75rem;
  z-index: 5;
  pointer-events: none;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus {
  z-index: 5;
}
.input-group .form-control-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
.input-group .form-control-sm.has-icon {
  padding-right: 1.5rem;
}
.input-group .form-control-sm > .form-control-input {
  font-size: 0.875rem;
}
.input-group .form-control-sm .input-icon,
.input-group .form-control-sm ~ .input-icon {
  right: 0.5rem;
  top: 0.5rem;
}
.input-group .form-control-sm .side-image,
.input-group .form-control-sm ~ .side-image {
  right: 0.5rem;
  top: 0.25rem;
  height: 1.5rem;
}
.input-group .form-control-lg {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
}
.input-group .form-control-lg > .form-control-input {
  font-size: 1.25rem;
}
.input-group .form-control-lg.has-icon {
  padding-right: 2rem;
}
.input-group .form-control-lg .input-icon,
.input-group .form-control-lg ~ .input-icon {
  right: 1rem;
  top: 1rem;
}
.input-group .form-control-lg .side-image,
.input-group .form-control-lg ~ .side-image {
  right: 1rem;
  top: 0.5rem;
  height: 2rem;
}
.input-group:has(.form-control-sm) .input-group-text {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
.input-group:has(.form-control-lg) .input-group-text {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
}
.input-group:has(atlas-button.action-button-position-left) .input-group-text {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}
.input-group:has(atlas-button.action-button-position-right) .input-group-text {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
.input-group > :not(:first-child):not(.invalid-feedback) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group.skeleton * {
  visibility: hidden;
}
.input-group.skeleton + atlas-button {
  display: none;
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
.status-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.8rem;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}

.is-info ~ .status-feedback {
  display: block;
}

.status-info {
  color: var(--atlas-secondary);
}

.is-success {
  border-color: var(--atlas-success) !important;
}
.is-success:focus, .is-success:focus-visible, .is-success.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
  border-color: var(--atlas-success);
}
.is-success ~ .status-feedback {
  display: block;
}
.is-success ~ .form-check-label {
  color: var(--atlas-success);
}
.is-success .focus-mark {
  background: var(--atlas-success-300);
}
.is-success.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-success) !important;
  background-color: rgba(var(--atlas-success-rgb), 2%);
}
.is-success.rating-buttons-group .rating-button {
  border-color: var(--atlas-success) !important;
  color: var(--atlas-success) !important;
}
.is-success.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-success-400) !important;
  color: #ffffff !important;
}
.is-success.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
}
.is-success.rating-buttons-group .rating-button:active:not(:disabled), .is-success.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-success) !important;
  color: #ffffff !important;
}

.form-check:has(.is-success) .form-check-label {
  color: var(--atlas-success);
}
.form-check:has(.is-success) .form-check-input:checked {
  background-color: var(--atlas-success);
}

.status-success {
  color: var(--atlas-success);
}

.is-warning {
  border-color: var(--atlas-warning) !important;
}
.is-warning:focus, .is-warning:focus-visible, .is-warning.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
  border-color: var(--atlas-warning);
}
.is-warning ~ .status-feedback {
  display: block;
}
.is-warning ~ .form-check-label {
  color: var(--atlas-warning);
}
.is-warning .focus-mark {
  background: var(--atlas-warning-300);
}
.is-warning.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-warning) !important;
  background-color: rgba(var(--atlas-warning-rgb), 2%);
}
.is-warning.rating-buttons-group .rating-button {
  border-color: var(--atlas-warning) !important;
  color: var(--atlas-warning) !important;
}
.is-warning.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-warning-400) !important;
  color: #ffffff !important;
}
.is-warning.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
}
.is-warning.rating-buttons-group .rating-button:active:not(:disabled), .is-warning.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-warning) !important;
  color: #ffffff !important;
}

.form-check:has(.is-warning) .form-check-label {
  color: var(--atlas-warning);
}
.form-check:has(.is-warning) .form-check-input:checked {
  background-color: var(--atlas-warning);
}

.status-warning {
  color: var(--atlas-warning);
}

.is-error {
  border-color: var(--atlas-danger) !important;
}
.is-error:focus, .is-error:focus-visible, .is-error.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
  border-color: var(--atlas-danger);
}
.is-error ~ .status-feedback {
  display: block;
}
.is-error ~ .form-check-label {
  color: var(--atlas-danger);
}
.is-error .focus-mark {
  background: var(--atlas-danger-300);
}
.is-error.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-danger) !important;
  background-color: rgba(var(--atlas-danger-rgb), 2%);
}
.is-error.rating-buttons-group .rating-button {
  border-color: var(--atlas-danger) !important;
  color: var(--atlas-danger) !important;
}
.is-error.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-danger-400) !important;
  color: #ffffff !important;
}
.is-error.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
}
.is-error.rating-buttons-group .rating-button:active:not(:disabled), .is-error.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-danger) !important;
  color: #ffffff !important;
}

.form-check:has(.is-error) .form-check-label {
  color: var(--atlas-danger);
}
.form-check:has(.is-error) .form-check-input:checked {
  background-color: var(--atlas-danger);
}

.status-error {
  color: var(--atlas-danger);
}

/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host([width=full]) {
  width: 100%;
}

:host([width=xs]) {
  width: 96px;
}

:host([width=sm]) {
  width: 152px;
}

:host([width=md]) {
  width: 264px;
}

:host([width=lg]) {
  width: 380px;
}

:host {
  outline: none;
  display: block;
}

:host([skeleton-loading]) {
  display: block;
}

:host(.one-time-code-input) input {
  text-align: center;
}
:host(.one-time-code-input) input:focus::placeholder {
  opacity: 0;
}

:host(.atlas-select-input[readonly]) .form-control,
:host(.atlas-select-input[readonly]) .form-control input,
:host(.atlas-multiselect-input[readonly]) .form-control,
:host(.atlas-multiselect-input[readonly]) .form-control input {
  cursor: pointer;
}

:host(.atlas-select-input[disabled]) .form-control,
:host(.atlas-select-input[disabled]) .form-control input,
:host(.atlas-multiselect-input[disabled]) .form-control,
:host(.atlas-multiselect-input[disabled]) .form-control input {
  cursor: default;
}

:host(.atlas-select-input) atlas-icon.input-icon,
:host(.atlas-multiselect-input) atlas-icon.input-icon {
  transition: transform 0.35s ease;
}

:host(.atlas-select-input:not(.collapsed)) atlas-icon[name=chevron-down],
:host(.atlas-multiselect-input:not(.collapsed)) atlas-icon[name=chevron-down] {
  transform: rotate(-180deg);
}

:host(.atlas-multiselect-input.has-tag) .form-control {
  padding-left: 200px;
}

:host([type=hidden]) {
  display: none !important;
}

.form-label.skeleton {
  height: 1.5rem;
  width: 50%;
}

.form-control.skeleton {
  width: 100%;
  min-height: calc(1.5em + 14px);
}

.helper-text.skeleton {
  height: 1.25rem;
  width: 100%;
  margin-top: 0.25rem;
}

.input-wrapper {
  display: flex;
  width: 100%;
}

@media screen and (min-width: 992px) {
  :host(.atlas-multiselect-input.has-tag) .form-control {
    padding-left: 190px;
  }
}
.input-group .input-icon {
  color: #6c757d;
  cursor: pointer;
}`;

// src/components/form/atlas-password-input/atlas-password-input.ts
var AtlasPasswordInput = /*#__PURE__*/(() => {
  let AtlasPasswordInput = class extends AtlasInput {
    constructor() {
      super(...arguments);
      this.removeVisibilityIcon = false;
      this.onlyNumbers = false;
      this._onlyNumbersMaskOptions = {
        alias: "onlyNumericDigits"
      };
    }
    /** @internal */
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.togglePasswordVisibility = this.togglePasswordVisibility.bind(this);
      this.addEventListener("atlas-input-icon-click", this.togglePasswordVisibility);
      this.hasIconEvent = true;
      this.setInputToPassword();
      if (!this.onlyNumbers) return;
      this.updateComplete.then(() => {
        this.buildOnlyNumbersMask();
      });
    }
    /** @internal */
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      this.removeEventListener("atlas-input-icon-click", this.togglePasswordVisibility);
    }
    /**
     * @internal
     * @override
     */
    onChangeValue() {
      this.formatValueWithMaskIfNecessary();
      super.onChangeValue();
    }
    /** @override */
    renderIcon() {
      return when67(!this.removeVisibilityIcon, () => super.renderIcon());
    }
    formatValueWithMaskIfNecessary() {
      if (this.onlyNumbers && !inputmask_utils_default.isValid(this.value, this._onlyNumbersMaskOptions)) {
        this.value = inputmask_utils_default.format(this.value, this._onlyNumbersMaskOptions);
      }
    }
    togglePasswordVisibility() {
      if (this.type === "password") {
        this.setInputToText();
      } else {
        this.setInputToPassword();
      }
    }
    setInputToPassword() {
      this.type = "password";
      this.icon = "eye-off";
    }
    setInputToText() {
      this.type = "text";
      this.icon = "eye";
    }
    buildOnlyNumbersMask() {
      this.inputMode = "numeric";
      if (!this.placeholder) this.placeholder = "0".repeat(this.maxlength || 0);
      this._onlyNumbersMaskInstance = inputmask_utils_default(this._onlyNumbersMaskOptions).mask(this._input);
      this._onlyNumbersMaskInstance.shadowRoot = this.shadowRoot;
      if (this.value) this.formatValueWithMaskIfNecessary();
    }
  };
  AtlasPasswordInput.styles = atlas_password_input_default;
  return AtlasPasswordInput;
})();
__decorateClass([property104({
  type: Boolean,
  attribute: "remove-visibility-icon"
})], AtlasPasswordInput.prototype, "removeVisibilityIcon", 2);
__decorateClass([property104({
  type: Boolean,
  attribute: "only-numbers"
})], AtlasPasswordInput.prototype, "onlyNumbers", 2);
AtlasPasswordInput = __decorateClass([customElement93("atlas-password-input")], AtlasPasswordInput);

// src/components/form/atlas-percentage/atlas-percentage.ts
import { customElement as customElement94 } from "lit/decorators.js";
var AtlasPercentage = class extends AtlasFloatInput {
  /** @internal */
  connectedCallback() {
    var _a;
    (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
    this.updateComplete.then(() => {
      this.inputGroupPrefix = "%";
    });
  }
};
AtlasPercentage = __decorateClass([customElement94("atlas-percentage")], AtlasPercentage);

// src/components/form/atlas-postal-code/atlas-postal-code.ts
import { customElement as customElement95, property as property105, state as state53 } from "lit/decorators.js";

// src/helpers/postal-code.ts
var postal_code_exports = {};
__export(postal_code_exports, {
  validatePostalCode: () => validatePostalCode
});
var POSTAL_CODE_LENGTH = 8;
var POSTAL_CODE_PATTERN = /^[0-9]{5}-[0-9]{3}$/;
function validatePostalCode(postalCode) {
  const postalCodeValue = removeNonNumeric(postalCode);
  return postalCodeValue.length === POSTAL_CODE_LENGTH && POSTAL_CODE_PATTERN.test(postalCode);
}

// src/internals/validators/postal-code-validator.ts
var PostalCodeValidator = class {
  constructor() {
    this.name = "postal-code";
    this.status = "error";
  }
  getInvalidMessage() {
    return "Informe um CEP v\xE1lido";
  }
  validate(element) {
    const elementValue = element.getElementValue();
    if (elementValue) {
      return validatePostalCode(elementValue);
    }
    return true;
  }
};

// src/components/form/atlas-postal-code/atlas-postal-code.ts
var AtlasPostalCode = class extends AtlasInput {
  constructor() {
    super(...arguments);
    this.customParamName = "postalCode";
    this._postalCodeData = {};
    this.mask = {
      mask: ["99999-999"],
      jitMasking: true,
      keepStatic: true,
      showMaskOnHover: false
    };
  }
  /** @internal */
  connectedCallback() {
    var _a;
    (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
    this.updateComplete.then(() => {
      this.buildMask();
      this.fillPostalCodeData();
    });
  }
  /**
   * @internal
   * @override
   */
  onChangeValue() {
    if (!inputmask_utils_default.isValid(this.value, this.mask)) {
      this.value = inputmask_utils_default.format(this.value, this.mask);
    }
    super.onChangeValue();
  }
  /**
   * Retorna o valor do campo sem a máscara
   * @returns {string} - O valor do campo sem a máscara
   */
  getUnmaskedValue() {
    return this._maskInstance.unmaskedvalue();
  }
  /**
   * Retorna os dados do CEP
   * @returns {PostalCode | {}} - Um objeto com os dados do CEP ou um objeto vazio, caso o endereço não tenha sido encontrado
   */
  getPostalCodeData() {
    return this._postalCodeData;
  }
  /**
   * Faz uma requisição para obter os dados do CEP a partir de uma URL
   * @param {string} postalCode - O CEP a ser pesquisado
   * @returns {Promise<PostalCodeApiResponse>} - Uma Promise contendo os dados da resposta da API
   */
  fetchPostalCodeData(postalCode) {
    const postalCodeValue = removeNonNumeric(postalCode);
    const queryParam = {
      [this.customParamName]: postalCodeValue
    };
    return get(this.searchUrl, queryParam);
  }
  /**
   * Preenche os dados do CEP
   */
  fillPostalCodeData() {
    return __async(this, null, function* () {
      if (!this._valid || !this.value || this.disableSearch) {
        return;
      }
      let result = {};
      this.loading = true;
      try {
        result = yield this.fetchPostalCodeData(this.value);
      } catch (e) {
        result = {
          success: false
        };
        console.error(e);
      }
      this._postalCodeData = result.success ? result.postalCode : {};
      this.loading = false;
      emit(this, "atlas-postal-code-change");
    });
  }
  handleInput() {
    return __async(this, null, function* () {
      yield __superGet(AtlasPostalCode.prototype, this, "handleInput").call(this);
      if (inputmask_utils_default.isValid(this.value, this.mask)) {
        this.fillPostalCodeData();
      }
    });
  }
  buildMask() {
    this.placeholder = "00000-000";
    this.inputMode = "numeric";
    this._maskInstance = inputmask_utils_default(this.mask).mask(this._input);
    if (this.value) this.value = inputmask_utils_default.format(this.value, this.mask);
    this.addValidator(new PostalCodeValidator());
  }
};
__decorateClass([property105({
  type: Boolean,
  attribute: "disable-search"
})], AtlasPostalCode.prototype, "disableSearch", 2);
__decorateClass([property105({
  type: String,
  attribute: "search-url"
})], AtlasPostalCode.prototype, "searchUrl", 2);
__decorateClass([property105({
  type: String,
  attribute: "custom-param-name"
})], AtlasPostalCode.prototype, "customParamName", 2);
__decorateClass([state53()], AtlasPostalCode.prototype, "_postalCodeData", 2);
AtlasPostalCode = __decorateClass([customElement95("atlas-postal-code")], AtlasPostalCode);

// src/components/form/atlas-radio/atlas-radio.ts
import { html as html97 } from "lit";
import { customElement as customElement96, property as property106, state as state54 } from "lit/decorators.js";
import { classMap as classMap67 } from "lit/directives/class-map.js";

// src/components/form/atlas-radio/atlas-radio.scss
import { css as css84 } from "lit-element/lit-element.js";
var atlas_radio_default = css84`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
.form-check-label {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  color: #212529;
  cursor: pointer;
}

.form-check-input {
  --atlas-form-check-bg: #ffffff;
  width: 1.25rem;
  height: 1.25rem;
  margin-top: 0;
  vertical-align: top;
  appearance: none;
  background-color: var(--atlas-form-check-bg);
  background-image: var(--atlas-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid #ced4da;
  print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25rem;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: var(--atlas-primary-200);
  outline: 0;
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-500-rgb), 0.25);
}
.form-check-input:checked {
  background-color: var(--atlas-primary);
  border-color: var(--atlas-primary);
}
.form-check-input:checked[type=checkbox] {
  --atlas-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M16.2448 5.6674L7.46524 15.4628L3.78516 11.6991L5.21517 10.3008L7.40175 12.5371L14.7555 4.33252L16.2448 5.6674Z' fill='%23ffffff'/%3e%3c/svg%3e");
}
.form-check-input:checked[type=radio] {
  --atlas-form-check-bg-image: url("data:image/svg+xml,%3csvg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle stroke='white' stroke-width='3.5' cx='10' cy='10' r='8' /%3e%3c/svg%3e");
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: var(--atlas-primary);
  border-color: var(--atlas-primary);
  --atlas-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e");
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.35;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  color: #687078;
}
.form-check-input.form-check-input-expired {
  background-color: #dc3545;
  border-color: #dc3545;
  opacity: 0.35;
  pointer-events: none;
}
.form-check-input.form-check-input-expired ~ .form-check-label {
  color: #dc3545;
}

.form-check {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  padding: 0;
  min-height: 1.5rem;
}
.form-check .form-check-input {
  float: left;
  cursor: pointer;
  margin: 0;
  flex-shrink: 0;
}
.form-check.form-check-expired {
  pointer-events: none;
}
.form-check:not(.has-label) .form-check-label {
  display: none;
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
.status-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.8rem;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}

.is-info ~ .status-feedback {
  display: block;
}

.status-info {
  color: var(--atlas-secondary);
}

.is-success {
  border-color: var(--atlas-success) !important;
}
.is-success:focus, .is-success:focus-visible, .is-success.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
  border-color: var(--atlas-success);
}
.is-success ~ .status-feedback {
  display: block;
}
.is-success ~ .form-check-label {
  color: var(--atlas-success);
}
.is-success .focus-mark {
  background: var(--atlas-success-300);
}
.is-success.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-success) !important;
  background-color: rgba(var(--atlas-success-rgb), 2%);
}
.is-success.rating-buttons-group .rating-button {
  border-color: var(--atlas-success) !important;
  color: var(--atlas-success) !important;
}
.is-success.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-success-400) !important;
  color: #ffffff !important;
}
.is-success.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
}
.is-success.rating-buttons-group .rating-button:active:not(:disabled), .is-success.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-success) !important;
  color: #ffffff !important;
}

.form-check:has(.is-success) .form-check-label {
  color: var(--atlas-success);
}
.form-check:has(.is-success) .form-check-input:checked {
  background-color: var(--atlas-success);
}

.status-success {
  color: var(--atlas-success);
}

.is-warning {
  border-color: var(--atlas-warning) !important;
}
.is-warning:focus, .is-warning:focus-visible, .is-warning.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
  border-color: var(--atlas-warning);
}
.is-warning ~ .status-feedback {
  display: block;
}
.is-warning ~ .form-check-label {
  color: var(--atlas-warning);
}
.is-warning .focus-mark {
  background: var(--atlas-warning-300);
}
.is-warning.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-warning) !important;
  background-color: rgba(var(--atlas-warning-rgb), 2%);
}
.is-warning.rating-buttons-group .rating-button {
  border-color: var(--atlas-warning) !important;
  color: var(--atlas-warning) !important;
}
.is-warning.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-warning-400) !important;
  color: #ffffff !important;
}
.is-warning.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
}
.is-warning.rating-buttons-group .rating-button:active:not(:disabled), .is-warning.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-warning) !important;
  color: #ffffff !important;
}

.form-check:has(.is-warning) .form-check-label {
  color: var(--atlas-warning);
}
.form-check:has(.is-warning) .form-check-input:checked {
  background-color: var(--atlas-warning);
}

.status-warning {
  color: var(--atlas-warning);
}

.is-error {
  border-color: var(--atlas-danger) !important;
}
.is-error:focus, .is-error:focus-visible, .is-error.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
  border-color: var(--atlas-danger);
}
.is-error ~ .status-feedback {
  display: block;
}
.is-error ~ .form-check-label {
  color: var(--atlas-danger);
}
.is-error .focus-mark {
  background: var(--atlas-danger-300);
}
.is-error.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-danger) !important;
  background-color: rgba(var(--atlas-danger-rgb), 2%);
}
.is-error.rating-buttons-group .rating-button {
  border-color: var(--atlas-danger) !important;
  color: var(--atlas-danger) !important;
}
.is-error.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-danger-400) !important;
  color: #ffffff !important;
}
.is-error.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
}
.is-error.rating-buttons-group .rating-button:active:not(:disabled), .is-error.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-danger) !important;
  color: #ffffff !important;
}

.form-check:has(.is-error) .form-check-label {
  color: var(--atlas-danger);
}
.form-check:has(.is-error) .form-check-input:checked {
  background-color: var(--atlas-danger);
}

.status-error {
  color: var(--atlas-danger);
}

:host {
  display: inline-block;
  outline: none;
}`;

// src/components/form/atlas-radio/atlas-radio.ts
var AtlasRadio = /*#__PURE__*/(() => {
  let AtlasRadio = class extends FormElement {
    constructor() {
      super(...arguments);
      this.checked = false;
      this._hasSlottedLabel = false;
    }
    /** @internal */
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.onCustomRadioCheck = this.onCustomRadioCheck.bind(this);
      window.addEventListener("atlas-radio-check", this.onCustomRadioCheck);
    }
    /** @internal */
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      window.removeEventListener("atlas-radio-check", this.onCustomRadioCheck);
    }
    onChangeChecked() {
      const eventObject = {
        detail: {
          elementId: this.id,
          elementName: this.name,
          elementValue: this.value,
          checked: this.checked
        },
        trackDisable: true
      };
      emit(this, `atlas-radio-${this.checked ? "check" : "uncheck"}`, eventObject);
      emit(this, "atlas-radio-change", eventObject);
      emit(this, "atlas-form-element-touch", {
        trackDisable: true
      });
    }
    /**
     * Obtém o valor do elemento (se estiver marcado) ou uma string vazia
     * @returns {string} O valor do elemento ou uma string vazia
     * @override
     */
    getElementValue() {
      return this.checked ? this.value : "";
    }
    /**
     * Define o foco no radio
     */
    focus() {
      this.shadowRoot.querySelector(".form-check-input").focus();
    }
    /**
     * Marca o radio
     */
    check() {
      this.checked = true;
    }
    /**
     * Desmarca o radio
     */
    uncheck() {
      this.checked = false;
    }
    /**
     * Alterna o estado de marcação do radio
     * @param checked - Indica se o radio deve ser marcado ou desmarcado, caso não seja definido, o estado atual será invertido
     */
    toggleChecked(checked) {
      if (typeof checked === "boolean") {
        this.checked = checked;
      } else {
        this.checked = !this.checked;
      }
    }
    changeChecked() {
      this.checked = !this.checked;
      this.onChange();
    }
    onCustomRadioCheck(event) {
      const target = event.target;
      const radioTarget = target instanceof AtlasRadio ? target : target.shadowRoot.querySelector("atlas-radio");
      const isInsideFilter = radioTarget.closest("atlas-filter") !== null;
      const {
        checked
      } = event.detail;
      const hasSameName = radioTarget.name === this.name;
      const isDifferentElement = isInsideFilter ? radioTarget.value !== this.value : radioTarget !== this;
      if (checked && this.checked && hasSameName && isDifferentElement) {
        this.uncheck();
      }
    }
    onLabelChange() {
      this._hasSlottedLabel = !isEmptySlot(this);
    }
    /** @internal */
    render() {
      const checkContainerClass = {
        "form-check": true,
        "form-check-disabled": this.disabled,
        "has-label": this._hasSlottedLabel
      };
      const formCheckClass = {
        "form-check-input": true,
        [`is-${this._status}`]: this.getShowStatus()
      };
      return html97`
            <div class="${classMap67(checkContainerClass)}">
                <input
                    class="${classMap67(formCheckClass)}"
                    type="radio"
                    id="${this.id || "radio_element"}"
                    name="${this.name}"
                    .value="${this.value}"
                    .checked=${this.checked}
                    ?disabled=${this.disabled}
                    aria-checked="${this.checked}"
                    aria-disabled="${this.disabled}"
                    @change="${this.changeChecked}"
                />
                <label class="form-check-label" for="${this.id || "radio_element"}">
                    <slot @slotchange=${this.onLabelChange}></slot>
                </label>
            </div>
        `;
    }
  };
  AtlasRadio.styles = atlas_radio_default;
  return AtlasRadio;
})();
__decorateClass([property106({
  type: Boolean,
  reflect: true
})], AtlasRadio.prototype, "checked", 2);
__decorateClass([state54()], AtlasRadio.prototype, "_hasSlottedLabel", 2);
__decorateClass([Watch("checked", true)], AtlasRadio.prototype, "onChangeChecked", 1);
AtlasRadio = __decorateClass([customElement96("atlas-radio")], AtlasRadio);

// src/components/form/atlas-rating/atlas-rating.ts
import { html as html98 } from "lit";
import { customElement as customElement97, property as property107, state as state55 } from "lit/decorators.js";
import { classMap as classMap68 } from "lit/directives/class-map.js";
import { map as map4 } from "lit/directives/map.js";
import { range as range3 } from "lit/directives/range.js";
import { when as when68 } from "lit/directives/when.js";

// src/components/form/atlas-rating/atlas-rating.scss
import { css as css85 } from "lit-element/lit-element.js";
var atlas_rating_default = css85`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Transitions */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
.status-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.8rem;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}

.is-info ~ .status-feedback {
  display: block;
}

.status-info {
  color: var(--atlas-secondary);
}

.is-success {
  border-color: var(--atlas-success) !important;
}
.is-success:focus, .is-success:focus-visible, .is-success.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
  border-color: var(--atlas-success);
}
.is-success ~ .status-feedback {
  display: block;
}
.is-success ~ .form-check-label {
  color: var(--atlas-success);
}
.is-success .focus-mark {
  background: var(--atlas-success-300);
}
.is-success.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-success) !important;
  background-color: rgba(var(--atlas-success-rgb), 2%);
}
.is-success.rating-buttons-group .rating-button {
  border-color: var(--atlas-success) !important;
  color: var(--atlas-success) !important;
}
.is-success.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-success-400) !important;
  color: #ffffff !important;
}
.is-success.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
}
.is-success.rating-buttons-group .rating-button:active:not(:disabled), .is-success.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-success) !important;
  color: #ffffff !important;
}

.form-check:has(.is-success) .form-check-label {
  color: var(--atlas-success);
}
.form-check:has(.is-success) .form-check-input:checked {
  background-color: var(--atlas-success);
}

.status-success {
  color: var(--atlas-success);
}

.is-warning {
  border-color: var(--atlas-warning) !important;
}
.is-warning:focus, .is-warning:focus-visible, .is-warning.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
  border-color: var(--atlas-warning);
}
.is-warning ~ .status-feedback {
  display: block;
}
.is-warning ~ .form-check-label {
  color: var(--atlas-warning);
}
.is-warning .focus-mark {
  background: var(--atlas-warning-300);
}
.is-warning.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-warning) !important;
  background-color: rgba(var(--atlas-warning-rgb), 2%);
}
.is-warning.rating-buttons-group .rating-button {
  border-color: var(--atlas-warning) !important;
  color: var(--atlas-warning) !important;
}
.is-warning.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-warning-400) !important;
  color: #ffffff !important;
}
.is-warning.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
}
.is-warning.rating-buttons-group .rating-button:active:not(:disabled), .is-warning.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-warning) !important;
  color: #ffffff !important;
}

.form-check:has(.is-warning) .form-check-label {
  color: var(--atlas-warning);
}
.form-check:has(.is-warning) .form-check-input:checked {
  background-color: var(--atlas-warning);
}

.status-warning {
  color: var(--atlas-warning);
}

.is-error {
  border-color: var(--atlas-danger) !important;
}
.is-error:focus, .is-error:focus-visible, .is-error.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
  border-color: var(--atlas-danger);
}
.is-error ~ .status-feedback {
  display: block;
}
.is-error ~ .form-check-label {
  color: var(--atlas-danger);
}
.is-error .focus-mark {
  background: var(--atlas-danger-300);
}
.is-error.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-danger) !important;
  background-color: rgba(var(--atlas-danger-rgb), 2%);
}
.is-error.rating-buttons-group .rating-button {
  border-color: var(--atlas-danger) !important;
  color: var(--atlas-danger) !important;
}
.is-error.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-danger-400) !important;
  color: #ffffff !important;
}
.is-error.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
}
.is-error.rating-buttons-group .rating-button:active:not(:disabled), .is-error.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-danger) !important;
  color: #ffffff !important;
}

.form-check:has(.is-error) .form-check-label {
  color: var(--atlas-danger);
}
.form-check:has(.is-error) .form-check-input:checked {
  background-color: var(--atlas-danger);
}

.status-error {
  color: var(--atlas-danger);
}

:host {
  display: block;
  width: fit-content;
}

.atlas-rating {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: fit-content;
}

.rating-labels {
  position: absolute;
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  width: 100%;
}

.rating-buttons-group {
  display: flex;
  gap: 0;
}
.rating-buttons-group.has-labels {
  margin-top: 2rem;
}

.rating-button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border: 1px solid var(--atlas-primary);
  border-radius: 0.25rem;
  box-sizing: border-box;
  background: #ffffff;
  margin: 0;
  padding: 0.75rem 0.25rem;
  font-size: 1rem;
  line-height: 1.5;
  font-weight: 400;
  color: var(--atlas-primary);
  transition: color 0.25s ease, background 0.25s ease;
}
.rating-button:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.rating-button:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right-width: 0;
}
.rating-button:disabled {
  opacity: 0.35;
}
.rating-button:not(:disabled) {
  cursor: pointer;
}
.rating-button:not(:disabled):hover {
  background: var(--atlas-primary-400);
  color: #ffffff;
}
.rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-500-rgb), 0.25);
  z-index: 1;
}
.rating-button:active:not(:disabled), .rating-button.is-selected {
  background: var(--atlas-primary) !important;
  color: #ffffff;
  font-weight: 700;
}

@media screen and (min-width: 992px) {
  .rating-buttons-group {
    gap: 0.5rem;
  }
  .rating-button:not(:first-child) {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }
  .rating-button:not(:last-child) {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    border-right-width: 1px;
  }
}`;

// src/components/form/atlas-rating/atlas-rating.ts
var AtlasRating = /*#__PURE__*/(() => {
  let AtlasRating = class extends FormElement {
    constructor() {
      super(...arguments);
      this.rating = 10;
      this.helperText = "";
      this.allowZero = false;
      this._focusedRating = 0;
    }
    handleRatingButtonClick(event) {
      const target = event.target;
      const value = target.getAttribute("data-rating");
      this.value = value;
    }
    handleRatingButtonKeyDown(event) {
      const previousRatingKeys = ["ArrowDown", "ArrowLeft"];
      const nextRatingKeys = ["ArrowUp", "ArrowRight"];
      if (![...previousRatingKeys, ...nextRatingKeys].includes(event.key)) return;
      if (previousRatingKeys.includes(event.key)) {
        this._focusedRating = this._focusedRating === 0 ? 0 : this._focusedRating - 1;
      } else if (nextRatingKeys.includes(event.key)) {
        this._focusedRating = this._focusedRating === this.rating ? this.rating : this._focusedRating + 1;
      }
      const ratingButton = this.shadowRoot.querySelector(`.rating-button[data-rating="${this._focusedRating}"]`);
      ratingButton == null ? void 0 : ratingButton.focus();
    }
    handleRatingButtonFocus(event) {
      const target = event.target;
      this._focusedRating = parseInt(target.getAttribute("data-rating"), 10);
    }
    renderLabels() {
      return when68(this.minValueLabel && this.maxValueLabel, () => html98`
                <div class="rating-labels">
                    <atlas-text size="xs">${this.minValueLabel}</atlas-text>
                    <atlas-text size="xs">${this.maxValueLabel}</atlas-text>
                </div>
            `);
    }
    renderRatingButtons() {
      const rangeStart = this.allowZero ? 0 : 1;
      const ratingRange = this.rating === 5 ? range3(rangeStart, 6) : range3(rangeStart, 11);
      return map4(ratingRange, value => {
        const selected = this.value === value.toString();
        const buttonClasses = {
          "rating-button": true,
          "is-selected": selected
        };
        const buttonLabel = `Bot\xE3o de op\xE7\xE3o ${value} ${selected ? "marcado" : "n\xE3o marcado"}, ${value} de ${this.rating}.`;
        return html98`
                <button
                    class=${classMap68(buttonClasses)}
                    @click=${this.handleRatingButtonClick}
                    @keydown=${this.handleRatingButtonKeyDown}
                    @focus=${this.handleRatingButtonFocus}
                    data-rating="${value}"
                    role="radio"
                    aria-checked=${selected}
                    aria-posinset=${value}
                    aria-setsize=${this.rating}
                    aria-label=${buttonLabel}
                    ?disabled=${this.disabled}
                >
                    ${value}
                </button>
            `;
      });
    }
    renderHelperText() {
      return when68(this.helperText, () => html98`<atlas-helper-text id=${this.id}>${this.helperText}</atlas-helper-text>`, () => html98`<slot name="helper-text"></slot>`);
    }
    /** @internal */
    render() {
      const buttonGroupClasses = {
        "rating-buttons-group": true,
        "has-labels": this.minValueLabel && this.maxValueLabel,
        [`is-${this._status}`]: this.getShowStatus()
      };
      return html98`
            <div class="atlas-rating">
                ${this.renderLabels()}
                <div class=${classMap68(buttonGroupClasses)}>${this.renderRatingButtons()}</div>
                ${this.renderStatusMessage()} ${this.renderHelperText()}
            </div>
        `;
    }
  };
  AtlasRating.styles = atlas_rating_default;
  return AtlasRating;
})();
__decorateClass([property107({
  type: Number
})], AtlasRating.prototype, "rating", 2);
__decorateClass([property107({
  type: String,
  attribute: "min-value-label"
})], AtlasRating.prototype, "minValueLabel", 2);
__decorateClass([property107({
  type: String,
  attribute: "max-value-label"
})], AtlasRating.prototype, "maxValueLabel", 2);
__decorateClass([property107({
  type: String,
  attribute: "helper-text"
})], AtlasRating.prototype, "helperText", 2);
__decorateClass([property107({
  type: Boolean,
  attribute: "allow-zero"
})], AtlasRating.prototype, "allowZero", 2);
__decorateClass([state55()], AtlasRating.prototype, "_focusedRating", 2);
AtlasRating = __decorateClass([customElement97("atlas-rating")], AtlasRating);

// src/components/form/atlas-search-input/atlas-search-input.ts
import { html as html99 } from "lit";
import { customElement as customElement98 } from "lit/decorators.js";
import { classMap as classMap69 } from "lit/directives/class-map.js";
var AtlasSearchInput = class extends AtlasInput {
  /** @internal */
  connectedCallback() {
    var _a;
    (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
    this.onInputKeyDown = this.onInputKeyDown.bind(this);
    this.onClickClear = this.onClickClear.bind(this);
    this.triggerSearch = this.triggerSearch.bind(this);
    this.hasIconEvent = true;
    this.actionButtonIcon = "magnifier";
    this.actionButtonLabel = "Pesquisar";
    this.updateComplete.then(() => {
      this.addEventListener("atlas-input-icon-click", this.onClickClear);
      this.addEventListener("atlas-input-action-button-click", this.triggerSearch);
      this._input.addEventListener("keydown", this.onInputKeyDown);
    });
  }
  /** @internal */
  disconnectedCallback() {
    var _a;
    (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
    this.removeEventListener("atlas-input-icon-click", this.onClickClear);
    this.removeEventListener("atlas-input-action-button-click", this.triggerSearch);
    this.updateComplete.then(() => {
      this._input.removeEventListener("keydown", this.onInputKeyDown);
    });
  }
  setClearIcon() {
    this.icon = this.value ? "x" : "";
  }
  /** 
   * Aciona a pesquisa 
   */
  triggerSearch() {
    if (this.readonly || this.disabled || this.loading) return;
    emit(this, "atlas-input-trigger-search", {
      detail: this.value
    });
  }
  /** @override */
  renderSkeleton() {
    const inputSkeletonClass = {
      "skeleton": true,
      "form-control": true,
      "form-control-sm": this.size === "sm",
      "form-control-lg": this.size === "lg" || this._deviceController.isMobile
    };
    return html99` <div class="${classMap69(inputSkeletonClass)}" style="width: 100%;"></div> `;
  }
  onInputKeyDown(event) {
    if (event.key === "Enter") {
      this.triggerSearch();
    }
  }
  onClickClear() {
    this.value = "";
    this.triggerSearch();
  }
};
__decorateClass([Watch("value")], AtlasSearchInput.prototype, "setClearIcon", 1);
AtlasSearchInput = __decorateClass([customElement98("atlas-search-input")], AtlasSearchInput);

// src/components/form/atlas-selection-card/atlas-selection-card.ts
import { html as html100, nothing as nothing5 } from "lit";
import { classMap as classMap70 } from "lit/directives/class-map.js";
import { customElement as customElement99, property as property108, state as state56 } from "lit/decorators.js";
import { choose } from "lit/directives/choose.js";
import { when as when69 } from "lit/directives/when.js";

// src/components/form/atlas-selection-card/atlas-selection-card.scss
import { css as css86 } from "lit-element/lit-element.js";
var atlas_selection_card_default = css86`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.color-white {
  color: #ffffff !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.color-primary {
  color: var(--atlas-primary) !important;
}

.bg-primary {
  background-color: var(--atlas-primary) !important;
}

.color-primary-100 {
  color: var(--atlas-primary-100) !important;
}

.bg-primary-100 {
  background-color: var(--atlas-primary-100) !important;
}

.color-primary-200 {
  color: var(--atlas-primary-200) !important;
}

.bg-primary-200 {
  background-color: var(--atlas-primary-200) !important;
}

.color-primary-300 {
  color: var(--atlas-primary-300) !important;
}

.bg-primary-300 {
  background-color: var(--atlas-primary-300) !important;
}

.color-primary-400 {
  color: var(--atlas-primary-400) !important;
}

.bg-primary-400 {
  background-color: var(--atlas-primary-400) !important;
}

.color-primary-500 {
  color: var(--atlas-primary-500) !important;
}

.bg-primary-500 {
  background-color: var(--atlas-primary-500) !important;
}

.color-primary-600 {
  color: var(--atlas-primary-600) !important;
}

.bg-primary-600 {
  background-color: var(--atlas-primary-600) !important;
}

.color-primary-700 {
  color: var(--atlas-primary-700) !important;
}

.bg-primary-700 {
  background-color: var(--atlas-primary-700) !important;
}

.color-primary-800 {
  color: var(--atlas-primary-800) !important;
}

.bg-primary-800 {
  background-color: var(--atlas-primary-800) !important;
}

.color-primary-900 {
  color: var(--atlas-primary-900) !important;
}

.bg-primary-900 {
  background-color: var(--atlas-primary-900) !important;
}

.active-primary[active], .active-primary.active, .active-primary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-secondary {
  color: var(--atlas-secondary) !important;
}

.bg-secondary {
  background-color: var(--atlas-secondary) !important;
}

.color-secondary-100 {
  color: var(--atlas-secondary-100) !important;
}

.bg-secondary-100 {
  background-color: var(--atlas-secondary-100) !important;
}

.color-secondary-200 {
  color: var(--atlas-secondary-200) !important;
}

.bg-secondary-200 {
  background-color: var(--atlas-secondary-200) !important;
}

.color-secondary-300 {
  color: var(--atlas-secondary-300) !important;
}

.bg-secondary-300 {
  background-color: var(--atlas-secondary-300) !important;
}

.color-secondary-400 {
  color: var(--atlas-secondary-400) !important;
}

.bg-secondary-400 {
  background-color: var(--atlas-secondary-400) !important;
}

.color-secondary-500 {
  color: var(--atlas-secondary-500) !important;
}

.bg-secondary-500 {
  background-color: var(--atlas-secondary-500) !important;
}

.color-secondary-600 {
  color: var(--atlas-secondary-600) !important;
}

.bg-secondary-600 {
  background-color: var(--atlas-secondary-600) !important;
}

.color-secondary-700 {
  color: var(--atlas-secondary-700) !important;
}

.bg-secondary-700 {
  background-color: var(--atlas-secondary-700) !important;
}

.color-secondary-800 {
  color: var(--atlas-secondary-800) !important;
}

.bg-secondary-800 {
  background-color: var(--atlas-secondary-800) !important;
}

.color-secondary-900 {
  color: var(--atlas-secondary-900) !important;
}

.bg-secondary-900 {
  background-color: var(--atlas-secondary-900) !important;
}

.active-secondary[active], .active-secondary.active, .active-secondary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-success {
  color: var(--atlas-success) !important;
}

.bg-success {
  background-color: var(--atlas-success) !important;
}

.color-success-100 {
  color: var(--atlas-success-100) !important;
}

.bg-success-100 {
  background-color: var(--atlas-success-100) !important;
}

.color-success-200 {
  color: var(--atlas-success-200) !important;
}

.bg-success-200 {
  background-color: var(--atlas-success-200) !important;
}

.color-success-300 {
  color: var(--atlas-success-300) !important;
}

.bg-success-300 {
  background-color: var(--atlas-success-300) !important;
}

.color-success-400 {
  color: var(--atlas-success-400) !important;
}

.bg-success-400 {
  background-color: var(--atlas-success-400) !important;
}

.color-success-500 {
  color: var(--atlas-success-500) !important;
}

.bg-success-500 {
  background-color: var(--atlas-success-500) !important;
}

.color-success-600 {
  color: var(--atlas-success-600) !important;
}

.bg-success-600 {
  background-color: var(--atlas-success-600) !important;
}

.color-success-700 {
  color: var(--atlas-success-700) !important;
}

.bg-success-700 {
  background-color: var(--atlas-success-700) !important;
}

.color-success-800 {
  color: var(--atlas-success-800) !important;
}

.bg-success-800 {
  background-color: var(--atlas-success-800) !important;
}

.color-success-900 {
  color: var(--atlas-success-900) !important;
}

.bg-success-900 {
  background-color: var(--atlas-success-900) !important;
}

.active-success[active], .active-success.active, .active-success:active {
  background-color: var(--atlas-success) !important;
  color: var(--atlas-contrast-success) !important;
}

.color-warning {
  color: var(--atlas-warning) !important;
}

.bg-warning {
  background-color: var(--atlas-warning) !important;
}

.color-warning-100 {
  color: var(--atlas-warning-100) !important;
}

.bg-warning-100 {
  background-color: var(--atlas-warning-100) !important;
}

.color-warning-200 {
  color: var(--atlas-warning-200) !important;
}

.bg-warning-200 {
  background-color: var(--atlas-warning-200) !important;
}

.color-warning-300 {
  color: var(--atlas-warning-300) !important;
}

.bg-warning-300 {
  background-color: var(--atlas-warning-300) !important;
}

.color-warning-400 {
  color: var(--atlas-warning-400) !important;
}

.bg-warning-400 {
  background-color: var(--atlas-warning-400) !important;
}

.color-warning-500 {
  color: var(--atlas-warning-500) !important;
}

.bg-warning-500 {
  background-color: var(--atlas-warning-500) !important;
}

.color-warning-600 {
  color: var(--atlas-warning-600) !important;
}

.bg-warning-600 {
  background-color: var(--atlas-warning-600) !important;
}

.color-warning-700 {
  color: var(--atlas-warning-700) !important;
}

.bg-warning-700 {
  background-color: var(--atlas-warning-700) !important;
}

.color-warning-800 {
  color: var(--atlas-warning-800) !important;
}

.bg-warning-800 {
  background-color: var(--atlas-warning-800) !important;
}

.color-warning-900 {
  color: var(--atlas-warning-900) !important;
}

.bg-warning-900 {
  background-color: var(--atlas-warning-900) !important;
}

.active-warning[active], .active-warning.active, .active-warning:active {
  background-color: var(--atlas-warning) !important;
  color: var(--atlas-contrast-warning) !important;
}

.color-danger {
  color: var(--atlas-danger) !important;
}

.bg-danger {
  background-color: var(--atlas-danger) !important;
}

.color-danger-100 {
  color: var(--atlas-danger-100) !important;
}

.bg-danger-100 {
  background-color: var(--atlas-danger-100) !important;
}

.color-danger-200 {
  color: var(--atlas-danger-200) !important;
}

.bg-danger-200 {
  background-color: var(--atlas-danger-200) !important;
}

.color-danger-300 {
  color: var(--atlas-danger-300) !important;
}

.bg-danger-300 {
  background-color: var(--atlas-danger-300) !important;
}

.color-danger-400 {
  color: var(--atlas-danger-400) !important;
}

.bg-danger-400 {
  background-color: var(--atlas-danger-400) !important;
}

.color-danger-500 {
  color: var(--atlas-danger-500) !important;
}

.bg-danger-500 {
  background-color: var(--atlas-danger-500) !important;
}

.color-danger-600 {
  color: var(--atlas-danger-600) !important;
}

.bg-danger-600 {
  background-color: var(--atlas-danger-600) !important;
}

.color-danger-700 {
  color: var(--atlas-danger-700) !important;
}

.bg-danger-700 {
  background-color: var(--atlas-danger-700) !important;
}

.color-danger-800 {
  color: var(--atlas-danger-800) !important;
}

.bg-danger-800 {
  background-color: var(--atlas-danger-800) !important;
}

.color-danger-900 {
  color: var(--atlas-danger-900) !important;
}

.bg-danger-900 {
  background-color: var(--atlas-danger-900) !important;
}

.active-danger[active], .active-danger.active, .active-danger:active {
  background-color: var(--atlas-danger) !important;
  color: var(--atlas-contrast-danger) !important;
}

.color-highlight {
  color: var(--atlas-highlight) !important;
}

.bg-highlight {
  background-color: var(--atlas-highlight) !important;
}

.color-highlight-100 {
  color: var(--atlas-highlight-100) !important;
}

.bg-highlight-100 {
  background-color: var(--atlas-highlight-100) !important;
}

.color-highlight-200 {
  color: var(--atlas-highlight-200) !important;
}

.bg-highlight-200 {
  background-color: var(--atlas-highlight-200) !important;
}

.color-highlight-300 {
  color: var(--atlas-highlight-300) !important;
}

.bg-highlight-300 {
  background-color: var(--atlas-highlight-300) !important;
}

.color-highlight-400 {
  color: var(--atlas-highlight-400) !important;
}

.bg-highlight-400 {
  background-color: var(--atlas-highlight-400) !important;
}

.color-highlight-500 {
  color: var(--atlas-highlight-500) !important;
}

.bg-highlight-500 {
  background-color: var(--atlas-highlight-500) !important;
}

.color-highlight-600 {
  color: var(--atlas-highlight-600) !important;
}

.bg-highlight-600 {
  background-color: var(--atlas-highlight-600) !important;
}

.color-highlight-700 {
  color: var(--atlas-highlight-700) !important;
}

.bg-highlight-700 {
  background-color: var(--atlas-highlight-700) !important;
}

.color-highlight-800 {
  color: var(--atlas-highlight-800) !important;
}

.bg-highlight-800 {
  background-color: var(--atlas-highlight-800) !important;
}

.color-highlight-900 {
  color: var(--atlas-highlight-900) !important;
}

.bg-highlight-900 {
  background-color: var(--atlas-highlight-900) !important;
}

.active-highlight[active], .active-highlight.active, .active-highlight:active {
  background-color: var(--atlas-highlight) !important;
  color: var(--atlas-contrast-highlight) !important;
}

.color-info {
  color: var(--atlas-info) !important;
}

.bg-info {
  background-color: var(--atlas-info) !important;
}

.color-info-100 {
  color: var(--atlas-info-100) !important;
}

.bg-info-100 {
  background-color: var(--atlas-info-100) !important;
}

.color-info-200 {
  color: var(--atlas-info-200) !important;
}

.bg-info-200 {
  background-color: var(--atlas-info-200) !important;
}

.color-info-300 {
  color: var(--atlas-info-300) !important;
}

.bg-info-300 {
  background-color: var(--atlas-info-300) !important;
}

.color-info-400 {
  color: var(--atlas-info-400) !important;
}

.bg-info-400 {
  background-color: var(--atlas-info-400) !important;
}

.color-info-500 {
  color: var(--atlas-info-500) !important;
}

.bg-info-500 {
  background-color: var(--atlas-info-500) !important;
}

.color-info-600 {
  color: var(--atlas-info-600) !important;
}

.bg-info-600 {
  background-color: var(--atlas-info-600) !important;
}

.color-info-700 {
  color: var(--atlas-info-700) !important;
}

.bg-info-700 {
  background-color: var(--atlas-info-700) !important;
}

.color-info-800 {
  color: var(--atlas-info-800) !important;
}

.bg-info-800 {
  background-color: var(--atlas-info-800) !important;
}

.color-info-900 {
  color: var(--atlas-info-900) !important;
}

.bg-info-900 {
  background-color: var(--atlas-info-900) !important;
}

.active-info[active], .active-info.active, .active-info:active {
  background-color: var(--atlas-info) !important;
  color: var(--atlas-contrast-info) !important;
}

/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
.status-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.8rem;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}

.is-info ~ .status-feedback {
  display: block;
}

.status-info {
  color: var(--atlas-secondary);
}

.is-success {
  border-color: var(--atlas-success) !important;
}
.is-success:focus, .is-success:focus-visible, .is-success.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
  border-color: var(--atlas-success);
}
.is-success ~ .status-feedback {
  display: block;
}
.is-success ~ .form-check-label {
  color: var(--atlas-success);
}
.is-success .focus-mark {
  background: var(--atlas-success-300);
}
.is-success.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-success) !important;
  background-color: rgba(var(--atlas-success-rgb), 2%);
}
.is-success.rating-buttons-group .rating-button {
  border-color: var(--atlas-success) !important;
  color: var(--atlas-success) !important;
}
.is-success.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-success-400) !important;
  color: #ffffff !important;
}
.is-success.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
}
.is-success.rating-buttons-group .rating-button:active:not(:disabled), .is-success.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-success) !important;
  color: #ffffff !important;
}

.form-check:has(.is-success) .form-check-label {
  color: var(--atlas-success);
}
.form-check:has(.is-success) .form-check-input:checked {
  background-color: var(--atlas-success);
}

.status-success {
  color: var(--atlas-success);
}

.is-warning {
  border-color: var(--atlas-warning) !important;
}
.is-warning:focus, .is-warning:focus-visible, .is-warning.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
  border-color: var(--atlas-warning);
}
.is-warning ~ .status-feedback {
  display: block;
}
.is-warning ~ .form-check-label {
  color: var(--atlas-warning);
}
.is-warning .focus-mark {
  background: var(--atlas-warning-300);
}
.is-warning.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-warning) !important;
  background-color: rgba(var(--atlas-warning-rgb), 2%);
}
.is-warning.rating-buttons-group .rating-button {
  border-color: var(--atlas-warning) !important;
  color: var(--atlas-warning) !important;
}
.is-warning.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-warning-400) !important;
  color: #ffffff !important;
}
.is-warning.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
}
.is-warning.rating-buttons-group .rating-button:active:not(:disabled), .is-warning.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-warning) !important;
  color: #ffffff !important;
}

.form-check:has(.is-warning) .form-check-label {
  color: var(--atlas-warning);
}
.form-check:has(.is-warning) .form-check-input:checked {
  background-color: var(--atlas-warning);
}

.status-warning {
  color: var(--atlas-warning);
}

.is-error {
  border-color: var(--atlas-danger) !important;
}
.is-error:focus, .is-error:focus-visible, .is-error.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
  border-color: var(--atlas-danger);
}
.is-error ~ .status-feedback {
  display: block;
}
.is-error ~ .form-check-label {
  color: var(--atlas-danger);
}
.is-error .focus-mark {
  background: var(--atlas-danger-300);
}
.is-error.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-danger) !important;
  background-color: rgba(var(--atlas-danger-rgb), 2%);
}
.is-error.rating-buttons-group .rating-button {
  border-color: var(--atlas-danger) !important;
  color: var(--atlas-danger) !important;
}
.is-error.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-danger-400) !important;
  color: #ffffff !important;
}
.is-error.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
}
.is-error.rating-buttons-group .rating-button:active:not(:disabled), .is-error.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-danger) !important;
  color: #ffffff !important;
}

.form-check:has(.is-error) .form-check-label {
  color: var(--atlas-danger);
}
.form-check:has(.is-error) .form-check-input:checked {
  background-color: var(--atlas-danger);
}

.status-error {
  color: var(--atlas-danger);
}

:host {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  width: 100%;
}

.atlas-form-card {
  box-sizing: border-box;
  border-radius: 0.25rem;
  border: 1px solid #ced4da;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  text-decoration: none;
  text-align: left;
}
.atlas-form-card:hover {
  cursor: pointer;
}
.atlas-form-card:not(:first-of-type) {
  border-top: 1px solid #ced4da;
}
.atlas-form-card.checked {
  border-color: var(--atlas-primary);
}
.atlas-form-card .atlas-card-header {
  display: grid;
  grid-template-columns: auto auto;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  gap: 0.25rem;
  position: relative;
}
.atlas-form-card .atlas-card-header atlas-radio,
.atlas-form-card .atlas-card-header atlas-checkbox {
  font-weight: 700;
}
.atlas-form-card .atlas-card-header-subtitle {
  font-size: initial;
  grid-row-start: 2;
  color: #687078;
  margin-left: 0;
}
.atlas-form-card .atlas-card-header-subtitle:is([class*=color-]) {
  font-weight: 700;
}
.atlas-form-card .atlas-card-header-subtitle.has-input {
  margin-left: 2rem;
}
.atlas-form-card .atlas-card-header .disabled-reason-tooltip-wrapper {
  position: absolute;
  width: 100%;
}
.atlas-form-card .atlas-card-body {
  padding: 0 1rem 1rem 3rem;
  font-size: 0.875rem;
  color: #687078;
}
.atlas-form-card.hide-selection-card-body .atlas-card-body {
  display: none;
}
.atlas-form-card.atlas-form-card-disabled {
  border: 1px solid #ced4da !important;
  background: var(--atlas-secondary-100);
}
.atlas-form-card.atlas-form-card-disabled .atlas-card-label,
.atlas-form-card.atlas-form-card-disabled .atlas-card-header-subtitle,
.atlas-form-card.atlas-form-card-disabled .atlas-card-body,
.atlas-form-card.atlas-form-card-disabled .atlas-card-collapse atlas-icon,
.atlas-form-card.atlas-form-card-disabled .form-check-label {
  color: #687078;
}
.atlas-form-card.atlas-form-card-disabled:hover {
  cursor: default;
}
.atlas-form-card.atlas-form-card-disabled .atlas-card-collapse:hover {
  cursor: default;
}
.atlas-form-card.atlas-read-card .atlas-card-label {
  font-weight: 700;
}
.atlas-form-card.atlas-read-card .atlas-card-body {
  padding-left: 1rem;
}
.atlas-form-card.atlas-read-card:hover {
  cursor: default;
}
.atlas-form-card.atlas-form-card-hide-control {
  padding: 1rem;
  border-radius: 0.5rem;
  position: relative;
  transition: border 0.15s ease, box-shadow 0.15s ease;
}
.atlas-form-card.atlas-form-card-hide-control atlas-radio,
.atlas-form-card.atlas-form-card-hide-control atlas-checkbox {
  display: none;
}
.atlas-form-card.atlas-form-card-hide-control .atlas-card-header-subtitle {
  display: none;
}
.atlas-form-card.atlas-form-card-hide-control .atlas-card-header {
  padding: 0 0 1rem;
}
.atlas-form-card.atlas-form-card-hide-control .atlas-card-header .atlas-card-label {
  font-weight: 600;
}
.atlas-form-card.atlas-form-card-hide-control .atlas-card-body {
  padding: 0;
}
.atlas-form-card.atlas-form-card-hide-control .hide-control-checked-icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  border-radius: 50%;
  background-color: var(--atlas-primary);
  width: 1.25rem;
  height: 1.25rem;
  right: -0.3rem;
  top: -0.3rem;
}
.atlas-form-card.atlas-form-card-hide-control .hide-control-checked-icon-container.error {
  background-color: #dc3545;
}
.atlas-form-card.atlas-form-card-hide-control:focus, .atlas-form-card.atlas-form-card-hide-control:focus-visible, .atlas-form-card.atlas-form-card-hide-control:focus-within {
  outline: none;
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-secondary-500-rgb), 0.25);
}
.atlas-form-card.atlas-form-card-hide-control:hover {
  border-color: var(--atlas-secondary);
}
.atlas-form-card.atlas-form-card-hide-control.checked:hover {
  border-color: var(--atlas-primary);
}
.atlas-form-card.atlas-form-card-hide-control.checked:focus, .atlas-form-card.atlas-form-card-hide-control.checked:focus-visible, .atlas-form-card.atlas-form-card-hide-control.checked:focus-within {
  outline: none;
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-500-rgb), 0.25);
}
.atlas-form-card.atlas-form-card-hide-control.is-error:focus, .atlas-form-card.atlas-form-card-hide-control.is-error:focus-visible, .atlas-form-card.atlas-form-card-hide-control.is-error:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
}
.atlas-form-card.atlas-form-card-hide-control.atlas-form-card-disabled:focus, .atlas-form-card.atlas-form-card-hide-control.atlas-form-card-disabled:focus-visible, .atlas-form-card.atlas-form-card-hide-control.atlas-form-card-disabled:focus-within {
  box-shadow: none;
}

:host([fluid]) {
  min-height: 100%;
}
:host([fluid]) .atlas-form-card {
  min-height: 100%;
}

@media screen and (min-width: 992px) {
  .atlas-form-card .atlas-card-header {
    display: flex;
    justify-content: space-between;
  }
  .atlas-form-card .atlas-card-header-subtitle {
    margin-left: auto;
  }
  .atlas-form-card .atlas-card-header-subtitle.has-input {
    margin-left: auto;
  }
  .atlas-form-card.atlas-form-card-reduced {
    padding: 1.5rem;
  }
}`;

// src/components/form/atlas-selection-card/atlas-selection-card.ts
var AtlasSelectionCard = /*#__PURE__*/(() => {
  let AtlasSelectionCard = class extends WithCollapseMixin(FormControl) {
    constructor() {
      super();
      this.type = "read";
      this.subtitle = "";
      this.disabledReason = "";
      this.checked = false;
      this.hideControl = false;
      this.fluid = false;
      this._hasSlottedBody = false;
      this.onClickCard = this.onClickCard.bind(this);
      this.onFormElementChange = this.onFormElementChange.bind(this);
    }
    /** @internal */
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      if (!this.collapsible) {
        this.collapsed = false;
      } else {
        this.collapsed = !this.checked;
      }
    }
    /**
     * @internal
     * @override
     */
    checkValidity() {
      return this._valid;
    }
    /**
     * @internal
     * @override
     */
    getElementValue() {
      const formElement = this.getFormElement();
      if (!formElement) return null;
      return formElement.getElementValue();
    }
    /**
     * Marca o input do card
     */
    check() {
      const formElement = this.getFormElement();
      formElement.check();
    }
    /**
     * Desmarca o input do card
     */
    uncheck() {
      const formElement = this.getFormElement();
      formElement.uncheck();
    }
    /**
     * Alterna o estado do input do card
     * @param {boolean} checked - Se informado, define o estado do input do card
     */
    toggleChecked(checked) {
      const formElement = this.getFormElement();
      formElement.toggleChecked(checked);
    }
    getFormElement() {
      if (this.type === "checkbox") {
        const formElement = this.shadowRoot.querySelector("atlas-checkbox");
        return formElement;
      }
      if (this.type === "radio") {
        const formElement = this.shadowRoot.querySelector("atlas-radio");
        return formElement;
      }
      return null;
    }
    canCardReceiveFocus() {
      return this.type !== "read" && !this.disabled && this.hideControl;
    }
    onKeyDown(event) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        this.selectCard(event.target);
      }
    }
    onClickCard(event) {
      this.selectCard(event.target);
    }
    selectCard(targetElement) {
      if (this.type === "read" || this.disabled) return;
      const formElement = this.getFormElement();
      if (targetElement === formElement) return;
      if (this.type === "radio" && formElement.checked) return;
      formElement.focus();
      formElement.checked = !formElement.checked;
    }
    onFormElementChange(event) {
      this.checked = event.detail.checked;
      if (this.checked && this.collapsible) this.collapsed = false;
      emit(this, `atlas-selection-card-${this.checked ? "check" : "uncheck"}`, {
        detail: event.detail
      });
      emit(this, "atlas-selection-card-change", {
        detail: event.detail
      });
      emit(this, "atlas-form-element-touch");
    }
    onChangeSelectionCardBody() {
      const selectionCardBody = this.shadowRoot.querySelector("slot:not([name])");
      const assignedNodes = selectionCardBody.assignedNodes({
        flatten: true
      });
      const filteredNodes = filterEmptyNodes(assignedNodes);
      this._hasSlottedBody = filteredNodes.length >= 1;
    }
    changeFormElementValidationState() {
      var _a;
      (_a = this.getFormElement()) == null ? void 0 : _a.setValidationState(this._valid, this._status);
    }
    renderHideControlCheckedItemIcon() {
      if (this.type === "read") return nothing5;
      const selectionCardCheckedIconClass = {
        "hide-control-checked-icon-container": true,
        [`${this._status}`]: this.getShowStatus()
      };
      return when69(this.hideControl && this.checked, () => html100`
                <div class="${classMap70(selectionCardCheckedIconClass)}">
                    <atlas-icon name="check" size="2x" theme="primary" white></atlas-icon>
                </div>
            `);
    }
    renderDisabledTooltip() {
      return when69(this.disabled && this.disabledReason && this.hideControl, () => html100`<div class="disabled-reason-tooltip-wrapper" data-atlas-tooltip="disabled-reason" tabindex="-1">
                    <atlas-tooltip id="disabled-reason" placement="bottom">${this.disabledReason}</atlas-tooltip>
                </div>`);
    }
    renderCardTitle() {
      return when69(this.type === "read" || this.hideControl, () => html100`<label class="atlas-card-label" for="${this.id}"> ${this.label} </label>`);
    }
    renderCardInput() {
      return choose(this.type, [["checkbox", () => html100`
                    <atlas-checkbox
                        id="${this.id}"
                        name="${this.name}"
                        value="${this.value}"
                        ?checked=${this.checked}
                        ?disabled=${this.disabled}
                        @atlas-checkbox-change=${this.onFormElementChange}
                    >
                        ${this.label}
                    </atlas-checkbox>
                `], ["radio", () => html100`
                    <atlas-radio
                        id="${this.id}"
                        name="${this.name}"
                        value="${this.value}"
                        ?checked=${this.checked}
                        ?disabled=${this.disabled}
                        @atlas-radio-change=${this.onFormElementChange}
                    >
                        ${this.label}
                    </atlas-radio>
                `]]);
    }
    renderCardSubtitle() {
      const selectionCardHeaderSubtitleClass = {
        "atlas-card-header-subtitle": true,
        "has-input": this.type !== "read",
        [`color-${this.subtitleTheme}`]: this.subtitleTheme
      };
      return when69(!!this.subtitle, () => html100`<span class="${classMap70(selectionCardHeaderSubtitleClass)}"> ${this.subtitle} </span>`);
    }
    renderCardHeader() {
      return html100`
            <div class="atlas-card-header">
                ${this.renderCardInput()} ${this.renderCardTitle()} ${this.renderCardSubtitle()}
                ${when69(this.collapsible, () => this.renderCollapseButton())} ${this.renderDisabledTooltip()}
            </div>
        `;
    }
    onMouseOver() {
      if (this.disabled && this.disabledReason) {
        const tooltip = this.shadowRoot.querySelector("#disabled-reason");
        tooltip.show();
      }
    }
    onMouseLeave() {
      if (this.disabled && this.disabledReason) {
        const tooltip = this.shadowRoot.querySelector("#disabled-reason");
        tooltip.hide();
      }
    }
    /** @internal */
    render() {
      const cardClass = {
        "atlas-read-card": this.type === "read",
        "atlas-form-card": true,
        "atlas-form-card-disabled": this.disabled,
        "atlas-form-card-hide-control": this.hideControl,
        "checked": this.type !== "read" && this.checked,
        [`is-${this._status}`]: this.getShowStatus(),
        "hide-selection-card-body": !this._hasSlottedBody
      };
      const canCardReceiveFocus = this.canCardReceiveFocus();
      return html100`
            <div
                class="${classMap70(cardClass)}"
                @click=${this.onClickCard}
                @keydown=${canCardReceiveFocus ? this.onKeyDown : void 0}
                role="button"
                tabindex="${canCardReceiveFocus ? "0" : "-1"}"
                @mouseover=${this.onMouseOver}
                @mouseleave=${this.onMouseLeave}
            >
                ${this.renderCardHeader()}
                ${this.renderContentWithCollapse(html100`
                    <div class="atlas-card-body">
                        <slot @slotchange=${this.onChangeSelectionCardBody}></slot>
                    </div>
                `)}
                ${this.renderHideControlCheckedItemIcon()}
            </div>
            ${this.renderValidationMessage()} ${this.renderHelperText({
        isInputHelper: true
      })}
        `;
    }
  };
  AtlasSelectionCard.styles = atlas_selection_card_default;
  return AtlasSelectionCard;
})();
__decorateClass([property108({
  type: String
})], AtlasSelectionCard.prototype, "type", 2);
__decorateClass([property108({
  type: String
})], AtlasSelectionCard.prototype, "subtitle", 2);
__decorateClass([property108({
  type: String,
  attribute: "disabled-reason"
})], AtlasSelectionCard.prototype, "disabledReason", 2);
__decorateClass([property108({
  type: String,
  attribute: "subtitle-theme"
})], AtlasSelectionCard.prototype, "subtitleTheme", 2);
__decorateClass([property108({
  type: Boolean,
  reflect: true
})], AtlasSelectionCard.prototype, "checked", 2);
__decorateClass([property108({
  type: Boolean,
  reflect: true,
  attribute: "hide-control"
})], AtlasSelectionCard.prototype, "hideControl", 2);
__decorateClass([property108({
  type: Boolean,
  reflect: true
})], AtlasSelectionCard.prototype, "fluid", 2);
__decorateClass([state56()], AtlasSelectionCard.prototype, "_hasSlottedBody", 2);
__decorateClass([Watch(["_valid", "_status"], true)], AtlasSelectionCard.prototype, "changeFormElementValidationState", 1);
AtlasSelectionCard = __decorateClass([customElement99("atlas-selection-card")], AtlasSelectionCard);

// src/components/form/atlas-switch/atlas-switch.ts
import { html as html101 } from "lit";
import { customElement as customElement100, property as property109 } from "lit/decorators.js";
import { classMap as classMap71 } from "lit/directives/class-map.js";
import { when as when70 } from "lit/directives/when.js";

// src/components/form/atlas-switch/atlas-switch.scss
import { css as css87 } from "lit-element/lit-element.js";
var atlas_switch_default = css87`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
.form-check-label {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  color: #212529;
  cursor: pointer;
}

.form-check-input {
  --atlas-form-check-bg: #ffffff;
  width: 1.25rem;
  height: 1.25rem;
  margin-top: 0;
  vertical-align: top;
  appearance: none;
  background-color: var(--atlas-form-check-bg);
  background-image: var(--atlas-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid #ced4da;
  print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25rem;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: var(--atlas-primary-200);
  outline: 0;
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-500-rgb), 0.25);
}
.form-check-input:checked {
  background-color: var(--atlas-primary);
  border-color: var(--atlas-primary);
}
.form-check-input:checked[type=checkbox] {
  --atlas-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M16.2448 5.6674L7.46524 15.4628L3.78516 11.6991L5.21517 10.3008L7.40175 12.5371L14.7555 4.33252L16.2448 5.6674Z' fill='%23ffffff'/%3e%3c/svg%3e");
}
.form-check-input:checked[type=radio] {
  --atlas-form-check-bg-image: url("data:image/svg+xml,%3csvg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle stroke='white' stroke-width='3.5' cx='10' cy='10' r='8' /%3e%3c/svg%3e");
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: var(--atlas-primary);
  border-color: var(--atlas-primary);
  --atlas-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e");
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.35;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  color: #687078;
}
.form-check-input.form-check-input-expired {
  background-color: #dc3545;
  border-color: #dc3545;
  opacity: 0.35;
  pointer-events: none;
}
.form-check-input.form-check-input-expired ~ .form-check-label {
  color: #dc3545;
}

.form-check {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  padding: 0;
  min-height: 1.5rem;
}
.form-check .form-check-input {
  float: left;
  cursor: pointer;
  margin: 0;
  flex-shrink: 0;
}
.form-check.form-check-expired {
  pointer-events: none;
}
.form-check:not(.has-label) .form-check-label {
  display: none;
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
.status-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.8rem;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}

.is-info ~ .status-feedback {
  display: block;
}

.status-info {
  color: var(--atlas-secondary);
}

.is-success {
  border-color: var(--atlas-success) !important;
}
.is-success:focus, .is-success:focus-visible, .is-success.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
  border-color: var(--atlas-success);
}
.is-success ~ .status-feedback {
  display: block;
}
.is-success ~ .form-check-label {
  color: var(--atlas-success);
}
.is-success .focus-mark {
  background: var(--atlas-success-300);
}
.is-success.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-success) !important;
  background-color: rgba(var(--atlas-success-rgb), 2%);
}
.is-success.rating-buttons-group .rating-button {
  border-color: var(--atlas-success) !important;
  color: var(--atlas-success) !important;
}
.is-success.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-success-400) !important;
  color: #ffffff !important;
}
.is-success.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
}
.is-success.rating-buttons-group .rating-button:active:not(:disabled), .is-success.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-success) !important;
  color: #ffffff !important;
}

.form-check:has(.is-success) .form-check-label {
  color: var(--atlas-success);
}
.form-check:has(.is-success) .form-check-input:checked {
  background-color: var(--atlas-success);
}

.status-success {
  color: var(--atlas-success);
}

.is-warning {
  border-color: var(--atlas-warning) !important;
}
.is-warning:focus, .is-warning:focus-visible, .is-warning.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
  border-color: var(--atlas-warning);
}
.is-warning ~ .status-feedback {
  display: block;
}
.is-warning ~ .form-check-label {
  color: var(--atlas-warning);
}
.is-warning .focus-mark {
  background: var(--atlas-warning-300);
}
.is-warning.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-warning) !important;
  background-color: rgba(var(--atlas-warning-rgb), 2%);
}
.is-warning.rating-buttons-group .rating-button {
  border-color: var(--atlas-warning) !important;
  color: var(--atlas-warning) !important;
}
.is-warning.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-warning-400) !important;
  color: #ffffff !important;
}
.is-warning.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
}
.is-warning.rating-buttons-group .rating-button:active:not(:disabled), .is-warning.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-warning) !important;
  color: #ffffff !important;
}

.form-check:has(.is-warning) .form-check-label {
  color: var(--atlas-warning);
}
.form-check:has(.is-warning) .form-check-input:checked {
  background-color: var(--atlas-warning);
}

.status-warning {
  color: var(--atlas-warning);
}

.is-error {
  border-color: var(--atlas-danger) !important;
}
.is-error:focus, .is-error:focus-visible, .is-error.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
  border-color: var(--atlas-danger);
}
.is-error ~ .status-feedback {
  display: block;
}
.is-error ~ .form-check-label {
  color: var(--atlas-danger);
}
.is-error .focus-mark {
  background: var(--atlas-danger-300);
}
.is-error.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-danger) !important;
  background-color: rgba(var(--atlas-danger-rgb), 2%);
}
.is-error.rating-buttons-group .rating-button {
  border-color: var(--atlas-danger) !important;
  color: var(--atlas-danger) !important;
}
.is-error.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-danger-400) !important;
  color: #ffffff !important;
}
.is-error.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
}
.is-error.rating-buttons-group .rating-button:active:not(:disabled), .is-error.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-danger) !important;
  color: #ffffff !important;
}

.form-check:has(.is-error) .form-check-label {
  color: var(--atlas-danger);
}
.form-check:has(.is-error) .form-check-input:checked {
  background-color: var(--atlas-danger);
}

.status-error {
  color: var(--atlas-danger);
}

/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: inline-block;
  outline: none;
}

:host([description]) {
  width: 100%;
}

.form-switch {
  margin-bottom: 0;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  position: relative;
}
.form-switch .form-check-input {
  width: 2.5rem;
  height: 1.5rem;
  box-sizing: content-box;
  cursor: pointer;
  margin: 0;
  background-image: none;
  transition: border 0.35s ease;
  border-radius: 2.5rem;
  border-color: #ced4da;
}
.form-switch .form-check-input:focus {
  background-image: none;
}
.form-switch .form-check-label {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}
.form-switch .form-check-label.with-description .label {
  color: var(--atlas-primary);
  font-weight: 700;
}
.form-switch .form-check-label.with-description atlas-text {
  margin-top: 4px;
}
.form-switch .form-check-label.with-skeleton-loading {
  display: grid;
  grid-gap: 4px;
}
.form-switch .form-check-label.skeleton {
  height: 1.5rem;
  width: 200px;
}
.form-switch .switch-input-container {
  position: relative;
}
.form-switch.has-description .switch-input-container {
  flex-shrink: 0;
}
.form-switch.has-description .form-check-label {
  flex-grow: 1;
}
.form-switch .switch-handle {
  width: 18px;
  height: 18px;
  position: absolute;
  left: 4px;
  top: 50%;
  transform: translate(0, -50%);
  cursor: pointer;
  transition: left 0.35s ease;
}
.form-switch .switch-handle circle {
  fill: var(--atlas-secondary-400);
  transition: fill 0.35s ease;
}
.form-switch .form-check-input:checked {
  background-image: none;
  border-color: var(--atlas-primary);
}
.form-switch .form-check-input:checked + .switch-handle {
  left: calc(100% - 22px);
}
.form-switch .form-check-input:checked + .switch-handle circle {
  fill: #ffffff;
}
.form-switch .form-check-input:disabled + .switch-handle {
  cursor: default;
}
.form-switch .form-check-input:disabled:not(:checked) {
  background: var(--atlas-secondary-100);
}
.form-switch.form-check-disabled .form-check-label {
  color: #687078;
  cursor: default;
}
.form-switch:not(.form-check-disabled):hover .form-check-input {
  border-color: var(--atlas-primary);
}
.form-switch:not(.form-check-disabled):hover .form-check-input:focus {
  background-image: none;
}
.form-switch:not(.form-check-disabled):hover .switch-handle circle {
  fill: var(--atlas-primary-200);
}`;

// src/components/form/atlas-switch/atlas-switch.ts
var AtlasSwitch = /*#__PURE__*/(() => {
  let AtlasSwitch = class extends WithTooltipMixin(FormElement) {
    constructor() {
      super(...arguments);
      this.label = "";
      this.description = "";
      this.checked = false;
      this.labelBefore = false;
    }
    /**
     * Obtém o valor booleano correspondente ao estado de marcação do switch
     * @returns {boolean} - `true` se o switch estiver marcado, `false` caso contrário
     * @override
     */
    getElementValue() {
      return this.checked;
    }
    /**
     * Define o foco no switch
     */
    focus() {
      this.shadowRoot.querySelector(".form-check-input").focus();
    }
    /**
     * Marca o switch
     */
    check() {
      this.checked = true;
    }
    /**
     * Desmarca o switch
     */
    uncheck() {
      this.checked = false;
    }
    /**
     * Habilita o switch
     */
    enable() {
      this.disabled = false;
    }
    /**
     * Desabilita o switch
     */
    disable() {
      this.disabled = true;
    }
    /**
     * Alterna o estado do switch
     * @param checked - Indica se o switch deve ser marcado ou desmarcado, caso não seja definido, o estado atual será invertido
     */
    toggleChecked(checked) {
      if (typeof checked === "boolean") {
        this.checked = checked;
      } else {
        this.checked = !this.checked;
      }
    }
    handleChange() {
      if (!this.disabled) {
        this.checked = !this.checked;
        emit(this, "atlas-switch-change");
        emit(this, "atlas-form-element-touch");
      }
    }
    renderLabel() {
      if (this.description) {
        return html101`
                <label class="form-check-label with-description" for="${this.id || "checkbox_id"}">
                    <span class="label"> ${this.label} </span>
                    <div>
                        <atlas-text muted size="xs">${this.description}</atlas-text>
                    </div>
                </label>
            `;
      }
      return html101`<label class="form-check-label" for="${this.id || "checkbox_id"}">${this.label}</label>`;
    }
    renderSwitchHandle() {
      return html101`
            <svg
                class="switch-handle"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                @click=${this.handleChange}
            >
                <circle cx="10" cy="10" r="10" fill="#000000" />
            </svg>
        `;
    }
    renderSwitch() {
      const switchClass = {
        "form-check-input": true,
        [`is-${this._status}`]: this.getShowStatus()
      };
      return html101`
            <span class="switch-input-container" data-atlas-tooltip="switch-tooltip">
                <input
                    class="${classMap71(switchClass)}"
                    type="checkbox"
                    role="switch"
                    id="${this.id || "checkbox_id"}"
                    name="${this.name}"
                    .checked=${this.checked}
                    .value=${this.value}
                    ?required=${this.required}
                    ?disabled=${this.disabled}
                    aria-labelledby="${this.id}"
                    aria-checked="${this.checked}"
                    aria-disabled="${this.disabled}"
                    aria-required="${this.required}"
                    @change="${this.handleChange}"
                />
                ${this.renderSwitchHandle()}
            </span>
        `;
    }
    renderSwitchSkeleton() {
      return html101`
            <span class="switch-input-container">
                <input class="form-check-input skeleton"></input>
            </span>
        `;
    }
    /** @override */
    renderElement() {
      const switchContainerClass = {
        "form-check": true,
        "form-switch": true,
        "form-check-disabled": this.disabled,
        "has-description": !!this.description,
        "has-label": !!this.label
      };
      const content = when70(this.labelBefore, () => html101` ${this.renderLabel()} ${this.renderSwitch()} `, () => html101` ${this.renderSwitch()} ${this.renderLabel()} `);
      return html101`
            <div class="${classMap71(switchContainerClass)}">${content}</div>
            ${this.renderTooltip("switch-tooltip")}
        `;
    }
    /** @override */
    renderSkeleton() {
      const switchSkeletonClass = {
        "form-check": true,
        "form-switch": true,
        "has-description": !!this.description,
        "has-label": !!this.label
      };
      return html101`
            <div class="${classMap71(switchSkeletonClass)}">
                ${when70(!this.labelBefore, () => html101` ${this.renderSwitchSkeleton()}`)}
                ${when70(this.description, () => html101`
                        <label class="form-check-label with-description with-skeleton-loading">
                            <atlas-text size="xs"></atlas-text>
                            <atlas-text size="xs"></atlas-text>
                        </label>
                    `, () => html101`<label class="form-check-label skeleton"></label>`)}
                ${when70(this.labelBefore, () => html101`${this.renderSwitchSkeleton()}`)}
            </div>
        `;
    }
  };
  AtlasSwitch.styles = atlas_switch_default;
  return AtlasSwitch;
})();
__decorateClass([property109({
  type: String
})], AtlasSwitch.prototype, "label", 2);
__decorateClass([property109({
  type: String
})], AtlasSwitch.prototype, "description", 2);
__decorateClass([property109({
  type: Boolean,
  reflect: true
})], AtlasSwitch.prototype, "checked", 2);
__decorateClass([property109({
  type: Boolean,
  attribute: "label-before"
})], AtlasSwitch.prototype, "labelBefore", 2);
AtlasSwitch = __decorateClass([customElement100("atlas-switch")], AtlasSwitch);

// src/components/form/atlas-textarea/atlas-textarea.ts
import { html as html102 } from "lit";
import { customElement as customElement101, property as property110, query as query21 } from "lit/decorators.js";
import { classMap as classMap72 } from "lit/directives/class-map.js";
import { ifDefined as ifDefined21 } from "lit/directives/if-defined.js";
import { live as live6 } from "lit/directives/live.js";
import { when as when71 } from "lit/directives/when.js";

// src/components/form/atlas-textarea/atlas-textarea.scss
import { css as css88 } from "lit-element/lit-element.js";
var atlas_textarea_default = css88`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.form-label {
  margin-bottom: 0.5rem;
  font-style: normal;
  box-sizing: border-box;
  display: inline-block;
}
.form-label-optional {
  color: #687078;
}
.form-label atlas-icon-button {
  top: 2px;
}
.form-label[skeleton-loading] {
  min-width: 40%;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Z-index mapping for the floating elements */
/* Shadows */
/* Elevations */
.form-control {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #1a1e21;
  appearance: none;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  cursor: text;
}
.form-control > .form-control-input {
  border: none;
  appearance: none;
  background-color: transparent;
  margin: 0;
  padding: 0;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #1a1e21;
  width: 100%;
  cursor: text;
}
.form-control > .form-control-input:focus, .form-control > .form-control-input:focus-visible {
  outline: none;
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control.form-control-multiple {
  display: flex;
  flex-flow: row wrap;
  gap: 0.5rem;
  overflow-y: overlay;
  max-height: 200px;
  cursor: text;
}
.form-control.form-control-multiple > .form-control-input {
  flex-grow: 1;
  min-width: 100px;
  width: 1%;
}
.form-control .form-control-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
.form-control .form-control-sm > .form-control-input {
  font-size: 0.875rem;
}
.form-control .form-control-lg {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
}
.form-control .form-control-lg > .form-control-input {
  font-size: 1.25rem;
}
.form-control:focus, .form-control:focus-within {
  color: #1a1e21;
  background-color: #ffffff;
  border-color: var(--atlas-primary-300);
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-300-rgb), 0.25);
  outline: 0;
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder,
.form-control > .form-control-input::placeholder {
  color: #687078;
  opacity: 1;
}
.form-control:disabled, .form-control:has(.form-control-input:disabled) {
  background-color: #e9ecef;
  opacity: 1;
}
.form-control.hide-placeholder::placeholder,
.form-control.hide-placeholder > .form-control-input::placeholder {
  color: transparent;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
  /* stylelint-disable no-descending-specificity */
  /* stylelint-enable no-descending-specificity */
}
.input-group atlas-button {
  position: relative;
  z-index: 2;
}
.input-group atlas-button:focus {
  z-index: 5;
}
.input-group .input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.input-group .input-group-text.input-group-prefix {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group .input-group-text.input-group-suffix {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group .form-control {
  border-radius: 0.25rem !important;
  box-sizing: border-box;
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group .form-control.has-icon {
  padding-right: 1.75rem;
}
.input-group .form-control.has-right-element, .input-group .form-control.has-action-button {
  border-bottom-right-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
.input-group .form-control.has-left-element {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}
.input-group .form-control .input-icon,
.input-group .form-control ~ .input-icon {
  position: absolute;
  right: 0.75rem;
  top: 0.815rem;
  z-index: 5;
  pointer-events: none;
}
.input-group .form-control .input-icon.has-click,
.input-group .form-control ~ .input-icon.has-click {
  cursor: pointer;
  pointer-events: all;
}
.input-group .form-control .side-image,
.input-group .form-control ~ .side-image {
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  height: 1.75rem;
  z-index: 5;
  pointer-events: none;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus {
  z-index: 5;
}
.input-group .form-control-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
.input-group .form-control-sm.has-icon {
  padding-right: 1.5rem;
}
.input-group .form-control-sm > .form-control-input {
  font-size: 0.875rem;
}
.input-group .form-control-sm .input-icon,
.input-group .form-control-sm ~ .input-icon {
  right: 0.5rem;
  top: 0.5rem;
}
.input-group .form-control-sm .side-image,
.input-group .form-control-sm ~ .side-image {
  right: 0.5rem;
  top: 0.25rem;
  height: 1.5rem;
}
.input-group .form-control-lg {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
}
.input-group .form-control-lg > .form-control-input {
  font-size: 1.25rem;
}
.input-group .form-control-lg.has-icon {
  padding-right: 2rem;
}
.input-group .form-control-lg .input-icon,
.input-group .form-control-lg ~ .input-icon {
  right: 1rem;
  top: 1rem;
}
.input-group .form-control-lg .side-image,
.input-group .form-control-lg ~ .side-image {
  right: 1rem;
  top: 0.5rem;
  height: 2rem;
}
.input-group:has(.form-control-sm) .input-group-text {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
.input-group:has(.form-control-lg) .input-group-text {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
}
.input-group:has(atlas-button.action-button-position-left) .input-group-text {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}
.input-group:has(atlas-button.action-button-position-right) .input-group-text {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
.input-group > :not(:first-child):not(.invalid-feedback) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group.skeleton * {
  visibility: hidden;
}
.input-group.skeleton + atlas-button {
  display: none;
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
.status-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.8rem;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}

.is-info ~ .status-feedback {
  display: block;
}

.status-info {
  color: var(--atlas-secondary);
}

.is-success {
  border-color: var(--atlas-success) !important;
}
.is-success:focus, .is-success:focus-visible, .is-success.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
  border-color: var(--atlas-success);
}
.is-success ~ .status-feedback {
  display: block;
}
.is-success ~ .form-check-label {
  color: var(--atlas-success);
}
.is-success .focus-mark {
  background: var(--atlas-success-300);
}
.is-success.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-success) !important;
  background-color: rgba(var(--atlas-success-rgb), 2%);
}
.is-success.rating-buttons-group .rating-button {
  border-color: var(--atlas-success) !important;
  color: var(--atlas-success) !important;
}
.is-success.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-success-400) !important;
  color: #ffffff !important;
}
.is-success.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
}
.is-success.rating-buttons-group .rating-button:active:not(:disabled), .is-success.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-success) !important;
  color: #ffffff !important;
}

.form-check:has(.is-success) .form-check-label {
  color: var(--atlas-success);
}
.form-check:has(.is-success) .form-check-input:checked {
  background-color: var(--atlas-success);
}

.status-success {
  color: var(--atlas-success);
}

.is-warning {
  border-color: var(--atlas-warning) !important;
}
.is-warning:focus, .is-warning:focus-visible, .is-warning.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
  border-color: var(--atlas-warning);
}
.is-warning ~ .status-feedback {
  display: block;
}
.is-warning ~ .form-check-label {
  color: var(--atlas-warning);
}
.is-warning .focus-mark {
  background: var(--atlas-warning-300);
}
.is-warning.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-warning) !important;
  background-color: rgba(var(--atlas-warning-rgb), 2%);
}
.is-warning.rating-buttons-group .rating-button {
  border-color: var(--atlas-warning) !important;
  color: var(--atlas-warning) !important;
}
.is-warning.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-warning-400) !important;
  color: #ffffff !important;
}
.is-warning.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
}
.is-warning.rating-buttons-group .rating-button:active:not(:disabled), .is-warning.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-warning) !important;
  color: #ffffff !important;
}

.form-check:has(.is-warning) .form-check-label {
  color: var(--atlas-warning);
}
.form-check:has(.is-warning) .form-check-input:checked {
  background-color: var(--atlas-warning);
}

.status-warning {
  color: var(--atlas-warning);
}

.is-error {
  border-color: var(--atlas-danger) !important;
}
.is-error:focus, .is-error:focus-visible, .is-error.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
  border-color: var(--atlas-danger);
}
.is-error ~ .status-feedback {
  display: block;
}
.is-error ~ .form-check-label {
  color: var(--atlas-danger);
}
.is-error .focus-mark {
  background: var(--atlas-danger-300);
}
.is-error.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-danger) !important;
  background-color: rgba(var(--atlas-danger-rgb), 2%);
}
.is-error.rating-buttons-group .rating-button {
  border-color: var(--atlas-danger) !important;
  color: var(--atlas-danger) !important;
}
.is-error.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-danger-400) !important;
  color: #ffffff !important;
}
.is-error.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
}
.is-error.rating-buttons-group .rating-button:active:not(:disabled), .is-error.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-danger) !important;
  color: #ffffff !important;
}

.form-check:has(.is-error) .form-check-label {
  color: var(--atlas-danger);
}
.form-check:has(.is-error) .form-check-input:checked {
  background-color: var(--atlas-danger);
}

.status-error {
  color: var(--atlas-danger);
}

/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host([width=full]) {
  width: 100%;
}

:host([width=xs]) {
  width: 96px;
}

:host([width=sm]) {
  width: 152px;
}

:host([width=md]) {
  width: 264px;
}

:host([width=lg]) {
  width: 380px;
}

.form-label.skeleton {
  height: 1.5rem;
  width: 50%;
}

.form-control.skeleton {
  width: 100%;
  min-height: 110px;
}

.helper-text.skeleton {
  height: 1.25rem;
  width: 100%;
  margin-top: 0.25rem;
}

:host {
  position: relative;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  outline: none;
}

.form-control {
  box-sizing: border-box;
  min-height: calc(1.5em + 0.75rem + 2px);
  resize: none;
}
.form-control.resizable {
  resize: vertical;
}`;

// src/components/form/atlas-textarea/atlas-textarea.ts
var AtlasTextarea = /*#__PURE__*/(() => {
  let AtlasTextarea = class extends WithCharsCounterMixin(FormControl) {
    constructor() {
      super(...arguments);
      this.size = "md";
      this.width = "auto";
      this.placeholder = "";
      this.rows = 4;
      this.readonly = false;
      this.resize = false;
      this.enableEmoji = false;
    }
    /** @internal */
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.updateComplete.then(() => {
        this.addValidator(new LengthValidator());
        if (!this.enableEmoji) {
          this.addValidator(new EmojiValidator());
        }
        this.updateCharsCounterIfEnabled(this.value.length);
      });
    }
    onChangeValue() {
      this.updateCharsCounterIfEnabled(this.value.length);
      emit(this, "atlas-textarea-change", {
        detail: this.value,
        trackDisable: true
      });
    }
    /**
     * Define o foco no textarea
     */
    focus() {
      this.textareaRef.focus();
    }
    /**
     * Remove o foco do textarea
     */
    blur() {
      this.textareaRef.blur();
    }
    handleFocus() {
      emit(this, "atlas-textarea-focus", {
        trackDisable: true
      });
    }
    handleBlur() {
      this.reportValidity();
      emit(this, "atlas-textarea-blur", {
        trackDisable: true
      });
      emit(this, "atlas-form-element-touch", {
        trackDisable: true
      });
    }
    handleInput() {
      this.value = this.textareaRef.value;
    }
    renderTextarea() {
      const ariaLabel = this.disabled || this.readonly ? this.placeholder : "";
      const ariaDescribedBy = this.helperText ? `${this.id}-helper` : null;
      const inputClass = {
        "form-control": true,
        "form-control-sm": this.size === "sm",
        "form-control-lg": this.size === "lg",
        "resizable": this.resize,
        [`is-${this._status}`]: this.getShowStatus()
      };
      return html102`
            <div class="input-group">
                <textarea
                    aria-describedby="${ifDefined21(ariaDescribedBy)}"
                    aria-label="${ariaLabel}"
                    id="${this.id}"
                    name="${this.name}"
                    class=${classMap72(inputClass)}
                    placeholder="${this.placeholder}"
                    rows=${ifDefined21(this.rows || void 0)}
                    .value=${live6(this.value)}
                    ?disabled=${this.disabled}
                    ?readonly=${this.readonly}
                    ?required=${this.required}
                    @focus=${this.handleFocus}
                    @blur=${this.handleBlur}
                    @input=${this.handleInput}
                    autocomplete="off"
                >
                </textarea>
                ${this.renderStatusMessage()}
            </div>
        `;
    }
    /** @override */
    renderElement() {
      return html102`
            ${this.renderLabel()} ${this.renderTextarea()} ${this.renderCharsCounter()}
            ${this.renderHelperText({
        isInputHelper: true
      })}
        `;
    }
    /** @override */
    renderSkeleton() {
      const inputClass = {
        "skeleton": true,
        "form-control": true,
        "form-control-sm": this.size === "sm",
        "form-control-lg": this.size === "lg"
      };
      return html102`
            ${when71(!!this.label, () => html102`<div class="form-label skeleton"></div>`)}
            <div class="input-group">
                <div class="${classMap72(inputClass)}"></div>
            </div>
            ${this.renderCharsCounterSkeleton()}
            ${when71(!!this.helperText || this._hasSlottedHelperText, () => html102`<div class="helper-text skeleton"></div>`)}
        `;
    }
  };
  AtlasTextarea.styles = atlas_textarea_default;
  return AtlasTextarea;
})();
__decorateClass([property110({
  type: String
})], AtlasTextarea.prototype, "size", 2);
__decorateClass([property110({
  type: String
})], AtlasTextarea.prototype, "width", 2);
__decorateClass([property110({
  type: String
})], AtlasTextarea.prototype, "placeholder", 2);
__decorateClass([property110({
  type: Number
})], AtlasTextarea.prototype, "rows", 2);
__decorateClass([property110({
  type: Number
})], AtlasTextarea.prototype, "maxlength", 2);
__decorateClass([property110({
  type: Boolean
})], AtlasTextarea.prototype, "readonly", 2);
__decorateClass([property110({
  type: Boolean
})], AtlasTextarea.prototype, "resize", 2);
__decorateClass([property110({
  type: Boolean,
  attribute: "enable-emoji"
})], AtlasTextarea.prototype, "enableEmoji", 2);
__decorateClass([query21("textarea")], AtlasTextarea.prototype, "textareaRef", 2);
__decorateClass([Watch("value")], AtlasTextarea.prototype, "onChangeValue", 1);
AtlasTextarea = __decorateClass([customElement101("atlas-textarea")], AtlasTextarea);

// src/components/form/atlas-toggle/atlas-toggle.ts
import { html as html103 } from "lit";
import { customElement as customElement102, queryAssignedElements as queryAssignedElements3, state as state57 } from "lit/decorators.js";
import { styleMap as styleMap21 } from "lit/directives/style-map.js";

// src/components/form/atlas-toggle/atlas-toggle.scss
import { css as css89 } from "lit-element/lit-element.js";
var atlas_toggle_default = css89`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.form-label {
  margin-bottom: 0.5rem;
  font-style: normal;
  box-sizing: border-box;
  display: inline-block;
}
.form-label-optional {
  color: #687078;
}
.form-label atlas-icon-button {
  top: 2px;
}
.form-label[skeleton-loading] {
  min-width: 40%;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

:host {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  display: block;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
}
@media screen and (min-width: 992px) {
  :host {
    width: max-content;
  }
}

.atlas-toggle {
  box-sizing: border-box;
}
.atlas-toggle .btn-group {
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
  align-items: center;
  display: grid;
  border: 1px solid var(--atlas-primary-500);
  border-radius: 9999px;
  padding: 2px;
  min-width: 100%;
}
@media screen and (min-width: 992px) {
  .atlas-toggle .btn-group {
    min-width: 400px;
    width: max-content;
  }
}
.atlas-toggle .btn-group .checked-active-mark {
  position: absolute;
  height: calc(100% - 4px);
  background-color: var(--atlas-primary-500);
  border-radius: 9999px;
  z-index: 0;
  pointer-events: none;
}
.atlas-toggle .btn-group .checked-active-mark.transition {
  transition: all 0.3s ease-out;
}`;

// src/components/form/atlas-toggle/atlas-toggle.ts
var AtlasToggle = /*#__PURE__*/(() => {
  let AtlasToggle = class extends FormControl {
    constructor() {
      super();
      this._checkedActiveMarkStyles = {};
      this._initialHelperText = "";
      this._resizeObserver = null;
      this.toggleActiveItem = this.toggleActiveItem.bind(this);
      this.onElementUpdate = this.onElementUpdate.bind(this);
    }
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.addEventListener("atlas-toggle-item-check", this.toggleActiveItem);
      this.addEventListener("atlas-element-update", this.onElementUpdate);
      this.updateComplete.then(() => {
        this._initialHelperText = this.helperText;
        if (this.value) this.syncValue();else this.findSelectedItem();
        if (this.disabled) this.syncDisabled();
        this.registerResizeObserver();
      });
    }
    disconnectedCallback() {
      var _a, _b;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      this.removeEventListener("atlas-toggle-item-check", this.toggleActiveItem);
      this.removeEventListener("atlas-element-update", this.onElementUpdate);
      (_b = this._resizeObserver) == null ? void 0 : _b.disconnect();
    }
    getUpdateComplete() {
      return __async(this, null, function* () {
        yield __superGet(AtlasToggle.prototype, this, "getUpdateComplete").call(this);
        yield Promise.all(this.toggleItems.map(element => element.updateComplete));
        return true;
      });
    }
    syncValue() {
      this.toggleItems.forEach(item => {
        if (this.value === item.value) {
          item.check();
        } else {
          item.uncheck();
        }
      });
      emit(this, "atlas-toggle-change");
      emit(this, "atlas-form-element-touch");
    }
    syncDisabled() {
      this.toggleItems.forEach(item => {
        item.toggleAttribute("disabled", this.disabled);
      });
      this.moveActiveMark();
    }
    onElementUpdate(event) {
      const changedProperties = event.detail;
      if (changedProperties == null ? void 0 : changedProperties.has("disabled")) this.moveActiveMark();
    }
    toggleActiveItem(event) {
      var _a;
      (_a = this.shadowRoot.querySelector(".checked-active-mark")) == null ? void 0 : _a.classList.add("transition");
      const element = event.target;
      this.setSelectedItem(element);
      this.moveActiveMark();
    }
    moveActiveMark() {
      const element = this.selectedItem;
      if (!element) return;
      const toggleRect = this.getBoundingClientRect();
      const rect = element.shadowRoot.querySelector("label").getBoundingClientRect();
      const offsetLeft = rect.left - toggleRect.left - 1;
      this._checkedActiveMarkStyles = {
        width: `${rect.width}px`,
        transform: `translateX(${offsetLeft}px)`,
        opacity: this.disabled || element.disabled ? "0.5" : "1"
      };
      setTimeout(() => {
        var _a;
        (_a = this.shadowRoot.querySelector(".checked-active-mark")) == null ? void 0 : _a.classList.remove("transition");
      }, 300);
    }
    setSelectedItem(selectedItem) {
      this.selectedItem = selectedItem;
      this.value = selectedItem.value;
      if (selectedItem.helperText) this.helperText = selectedItem.helperText;else this.helperText = this._initialHelperText;
    }
    findSelectedItem() {
      this.toggleItems.forEach(item => {
        if (item.checked) this.setSelectedItem(item);
      });
    }
    renderCheckedMark() {
      return html103`<div class="checked-active-mark" style=${styleMap21(this._checkedActiveMarkStyles)}></div>`;
    }
    registerResizeObserver() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this._resizeObserver = new ResizeObserver(() => __async(this, null, function* () {
          this.moveActiveMark();
        }));
        this._resizeObserver.observe(this);
      });
    }
    /** @internal */
    render() {
      const btnGroupStyles = {
        "grid-template-columns": `repeat(${this.toggleItems.length}, 1fr)`
      };
      return html103`
            ${this.renderLabel()}
            <div class="atlas-toggle">
                <div class="btn-group" style=${styleMap21(btnGroupStyles)}>
                    <slot></slot>

                    ${this.renderCheckedMark()}
                </div>
                ${this.renderHelperText({
        isToggleHelper: true
      })}
            </div>
        `;
    }
  };
  AtlasToggle.styles = atlas_toggle_default;
  return AtlasToggle;
})();
__decorateClass([state57()], AtlasToggle.prototype, "selectedItem", 2);
__decorateClass([state57()], AtlasToggle.prototype, "_checkedActiveMarkStyles", 2);
__decorateClass([queryAssignedElements3({
  selector: "atlas-toggle-item",
  flatten: true
})], AtlasToggle.prototype, "toggleItems", 2);
__decorateClass([Watch("value", true)], AtlasToggle.prototype, "syncValue", 1);
__decorateClass([Watch("disabled", true)], AtlasToggle.prototype, "syncDisabled", 1);
AtlasToggle = __decorateClass([customElement102("atlas-toggle")], AtlasToggle);

// src/components/form/atlas-toggle-item/atlas-toggle-item.ts
import { html as html104 } from "lit";
import { customElement as customElement103, property as property111 } from "lit/decorators.js";
import { classMap as classMap73 } from "lit/directives/class-map.js";
import { live as live7 } from "lit/directives/live.js";

// src/components/form/atlas-toggle-item/atlas-toggle-item.scss
import { css as css90 } from "lit-element/lit-element.js";
var atlas_toggle_item_default = css90`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Transitions */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
.btn {
  --atlas-btn-padding-x: 1rem;
  --atlas-btn-padding-y: 0.5rem;
  --atlas-btn-font-size: 1rem;
  --atlas-btn-color: #000000;
  --atlas-btn-bg: transparent;
  --atlas-btn-border-color: transparent;
  --atlas-btn-border-radius: 0.25rem;
  --atlas-btn-hover-border-color: transparent;
  --atlas-btn-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-rgb), 40%);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-300-rgb), 0.25);
  --atlas-btn-min-height: 2.625rem;
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  box-sizing: border-box;
  padding: var(--atlas-btn-padding-y) var(--atlas-btn-padding-x);
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: var(--atlas-btn-font-size);
  font-weight: 400;
  line-height: 1.5;
  color: var(--atlas-btn-color);
  min-height: var(--atlas-btn-min-height);
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border: 1px solid var(--atlas-btn-border-color);
  border-radius: var(--atlas-btn-border-radius);
  background: var(--atlas-btn-bg);
  box-shadow: var(--atlas-btn-box-shadow);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.btn:hover {
  color: var(--atlas-btn-hover-color);
  background-color: var(--atlas-btn-hover-bg);
  border-color: var(--atlas-btn-hover-border-color);
}
.btn:focus-visible {
  color: var(--atlas-btn-color);
  background: var(--atlas-btn-bg);
  border-color: var(--atlas-btn-border-color);
  box-shadow: var(--atlas-btn-focus-box-shadow);
  outline: 0;
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--atlas-btn-disabled-color);
  pointer-events: none;
  background-color: var(--atlas-btn-disabled-bg);
  background-image: none;
  border-color: var(--atlas-btn-disabled-border-color);
  opacity: 0.35;
  box-shadow: none;
}
.btn-check + .btn:hover {
  color: var(--atlas-btn-check-hover-color);
  background-color: var(--atlas-btn-check-hover-bg);
  border-color: var(--atlas-btn-check-hover-border-color);
}
.btn-check:focus-visible + .btn {
  border-color: var(--atlas-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--atlas-btn-focus-box-shadow);
}
.btn-check:checked + .btn {
  color: var(--atlas-btn-checked-color);
  background-color: var(--atlas-btn-checked-bg);
  border-color: var(--atlas-btn-checked-border-color);
}
:not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--atlas-btn-active-color);
  background-color: var(--atlas-btn-active-bg);
  background-image: none;
  border-color: var(--atlas-btn-active-border-color);
  box-shadow: var(--atlas-btn-active-shadow);
}
:not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--atlas-btn-focus-box-shadow);
}
.btn-check:checked + .btn:hover {
  color: var(--atlas-btn-hover-color);
  background-color: var(--atlas-btn-hover-bg);
  border-color: var(--atlas-btn-hover-border-color);
}
.btn atlas-icon {
  font-size: 1.25rem;
}

.btn-sm {
  --atlas-btn-padding-y: 0.25rem;
  --atlas-btn-padding-x: 0.5rem;
  --atlas-btn-font-size: 0.875rem;
  --atlas-btn-border-radius: 0.25rem;
  --atlas-btn-min-height: 1.9375rem;
}
.btn-sm atlas-icon {
  font-size: 1rem;
}

.btn-lg {
  --atlas-btn-padding-y: 0.5rem;
  --atlas-btn-padding-x: 1rem;
  --atlas-btn-font-size: 1.25rem;
  --atlas-btn-border-radius: 0.25rem;
  --atlas-btn-min-height: 3rem;
}
.btn-lg atlas-icon {
  font-size: 1.5rem;
}

.skeleton.btn-sm {
  height: 1.9375rem;
  width: 100px;
}
.skeleton.btn-md {
  height: 2.625rem;
  width: 120px;
}
.skeleton.btn-lg {
  height: 3rem;
  width: 140px;
}

.btn-block {
  width: 100% !important;
}

.rounded-pill {
  border-radius: 9999px;
}

slot[name=hotspot]::slotted(atlas-hotspot) {
  position: absolute;
  top: -20px;
  right: -20px;
}

.btn-primary {
  --atlas-btn-bg: var(--atlas-primary);
  --atlas-btn-color: var(--atlas-contrast-primary);
  --atlas-btn-border-color: var(--atlas-primary);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-primary-600);
  --atlas-btn-hover-border-color: var(--atlas-primary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-primary-700);
  --atlas-btn-active-border-color: var(--atlas-primary-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-primary);
  --atlas-btn-disabled-border-color: var(--atlas-primary);
  --atlas-btn-disabled-bg: var(--atlas-primary);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-primary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-primary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-primary-500);
  --atlas-btn-checked-border-color: var(--atlas-primary-500);
}

.btn-outline-primary {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-primary);
  --atlas-btn-border-color: var(--atlas-primary);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-primary-600);
  --atlas-btn-hover-border-color: var(--atlas-primary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-primary-700);
  --atlas-btn-active-border-color: var(--atlas-primary-700);
  --atlas-btn-disabled-color: var(--atlas-primary);
  --atlas-btn-disabled-bg: var(--atlas-primary-100);
  --atlas-btn-disabled-border-color: var(--atlas-primary);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-primary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-primary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-primary-500);
  --atlas-btn-checked-border-color: var(--atlas-primary-500);
}

.btn-ghost-primary {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-primary);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-primary-600);
  --atlas-btn-hover-border-color: var(--atlas-primary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-primary-700);
  --atlas-btn-active-border-color: var(--atlas-primary-700);
  --atlas-btn-disabled-color: var(--atlas-primary);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-primary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-primary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-primary-500);
  --atlas-btn-checked-border-color: var(--atlas-primary-500);
}

.btn-primary-white {
  --atlas-btn-bg: #f8f9fa;
  --atlas-btn-color: var(--atlas-primary);
  --atlas-btn-border-color: #f8f9fa;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-primary);
  --atlas-btn-hover-bg: rgb(198.4, 199.2, 200);
  --atlas-btn-hover-border-color: rgb(198.4, 199.2, 200);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(#f8f9fa, 0.25);
  --atlas-btn-active-color: var(--atlas-primary);
  --atlas-btn-active-bg: rgb(148.8, 149.4, 150);
  --atlas-btn-active-border-color: rgb(148.8, 149.4, 150);
  --atlas-btn-disabled-color: var(--atlas-primary);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-disabled-bg: #f8f9fa;
  --atlas-btn-check-hover-color: none;
  --atlas-btn-check-hover-bg: none;
  --atlas-btn-check-hover-border-color: none;
  --atlas-btn-checked-color: none;
  --atlas-btn-checked-bg: none;
  --atlas-btn-checked-border-color: none;
}

.btn-outline-primary-white {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: #f8f9fa;
  --atlas-btn-border-color: #f8f9fa;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-primary);
  --atlas-btn-hover-bg: rgb(198.4, 199.2, 200);
  --atlas-btn-hover-border-color: rgb(198.4, 199.2, 200);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(#f8f9fa, 0.25);
  --atlas-btn-active-color: var(--atlas-primary);
  --atlas-btn-active-bg: rgb(148.8, 149.4, 150);
  --atlas-btn-active-border-color: rgb(148.8, 149.4, 150);
  --atlas-btn-disabled-color: var(--atlas-primary);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-disabled-bg: #f8f9fa;
  --atlas-btn-check-hover-color: none;
  --atlas-btn-check-hover-bg: none;
  --atlas-btn-check-hover-border-color: none;
  --atlas-btn-checked-color: none;
  --atlas-btn-checked-bg: none;
  --atlas-btn-checked-border-color: none;
}

.btn-secondary {
  --atlas-btn-bg: var(--atlas-secondary);
  --atlas-btn-color: var(--atlas-contrast-secondary);
  --atlas-btn-border-color: var(--atlas-secondary);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-secondary);
  --atlas-btn-hover-bg: var(--atlas-secondary-600);
  --atlas-btn-hover-border-color: var(--atlas-secondary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-secondary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-secondary);
  --atlas-btn-active-bg: var(--atlas-secondary-700);
  --atlas-btn-active-border-color: var(--atlas-secondary-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-secondary);
  --atlas-btn-disabled-border-color: var(--atlas-secondary);
  --atlas-btn-disabled-bg: var(--atlas-secondary);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-secondary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-secondary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-secondary-500);
  --atlas-btn-checked-border-color: var(--atlas-secondary-500);
}

.btn-outline-secondary {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-secondary);
  --atlas-btn-border-color: var(--atlas-secondary);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-secondary-600);
  --atlas-btn-hover-border-color: var(--atlas-secondary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-secondary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-secondary-700);
  --atlas-btn-active-border-color: var(--atlas-secondary-700);
  --atlas-btn-disabled-color: var(--atlas-secondary);
  --atlas-btn-disabled-bg: var(--atlas-secondary-100);
  --atlas-btn-disabled-border-color: var(--atlas-secondary);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-secondary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-secondary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-secondary-500);
  --atlas-btn-checked-border-color: var(--atlas-secondary-500);
}

.btn-ghost-secondary {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-secondary);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-secondary-600);
  --atlas-btn-hover-border-color: var(--atlas-secondary-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-secondary-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-secondary-700);
  --atlas-btn-active-border-color: var(--atlas-secondary-700);
  --atlas-btn-disabled-color: var(--atlas-secondary);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-secondary-400);
  --atlas-btn-check-hover-border-color: var(--atlas-secondary-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-secondary-500);
  --atlas-btn-checked-border-color: var(--atlas-secondary-500);
}

.btn-success {
  --atlas-btn-bg: var(--atlas-success);
  --atlas-btn-color: var(--atlas-contrast-success);
  --atlas-btn-border-color: var(--atlas-success);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-success);
  --atlas-btn-hover-bg: var(--atlas-success-600);
  --atlas-btn-hover-border-color: var(--atlas-success-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-success);
  --atlas-btn-active-bg: var(--atlas-success-700);
  --atlas-btn-active-border-color: var(--atlas-success-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-success);
  --atlas-btn-disabled-border-color: var(--atlas-success);
  --atlas-btn-disabled-bg: var(--atlas-success);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-success-400);
  --atlas-btn-check-hover-border-color: var(--atlas-success-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-success-500);
  --atlas-btn-checked-border-color: var(--atlas-success-500);
}

.btn-outline-success {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-success);
  --atlas-btn-border-color: var(--atlas-success);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-success-600);
  --atlas-btn-hover-border-color: var(--atlas-success-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-success-700);
  --atlas-btn-active-border-color: var(--atlas-success-700);
  --atlas-btn-disabled-color: var(--atlas-success);
  --atlas-btn-disabled-bg: var(--atlas-success-100);
  --atlas-btn-disabled-border-color: var(--atlas-success);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-success-400);
  --atlas-btn-check-hover-border-color: var(--atlas-success-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-success-500);
  --atlas-btn-checked-border-color: var(--atlas-success-500);
}

.btn-ghost-success {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-success);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-success-600);
  --atlas-btn-hover-border-color: var(--atlas-success-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-success-700);
  --atlas-btn-active-border-color: var(--atlas-success-700);
  --atlas-btn-disabled-color: var(--atlas-success);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-success-400);
  --atlas-btn-check-hover-border-color: var(--atlas-success-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-success-500);
  --atlas-btn-checked-border-color: var(--atlas-success-500);
}

.btn-warning {
  --atlas-btn-bg: var(--atlas-warning);
  --atlas-btn-color: var(--atlas-contrast-warning);
  --atlas-btn-border-color: var(--atlas-warning);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-warning);
  --atlas-btn-hover-bg: var(--atlas-warning-600);
  --atlas-btn-hover-border-color: var(--atlas-warning-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-warning);
  --atlas-btn-active-bg: var(--atlas-warning-700);
  --atlas-btn-active-border-color: var(--atlas-warning-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-warning);
  --atlas-btn-disabled-border-color: var(--atlas-warning);
  --atlas-btn-disabled-bg: var(--atlas-warning);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-warning-400);
  --atlas-btn-check-hover-border-color: var(--atlas-warning-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-warning-500);
  --atlas-btn-checked-border-color: var(--atlas-warning-500);
}

.btn-outline-warning {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-warning);
  --atlas-btn-border-color: var(--atlas-warning);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-warning-600);
  --atlas-btn-hover-border-color: var(--atlas-warning-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-warning-700);
  --atlas-btn-active-border-color: var(--atlas-warning-700);
  --atlas-btn-disabled-color: var(--atlas-warning);
  --atlas-btn-disabled-bg: var(--atlas-warning-100);
  --atlas-btn-disabled-border-color: var(--atlas-warning);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-warning-400);
  --atlas-btn-check-hover-border-color: var(--atlas-warning-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-warning-500);
  --atlas-btn-checked-border-color: var(--atlas-warning-500);
}

.btn-ghost-warning {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-warning);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-warning-600);
  --atlas-btn-hover-border-color: var(--atlas-warning-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-warning-700);
  --atlas-btn-active-border-color: var(--atlas-warning-700);
  --atlas-btn-disabled-color: var(--atlas-warning);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-warning-400);
  --atlas-btn-check-hover-border-color: var(--atlas-warning-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-warning-500);
  --atlas-btn-checked-border-color: var(--atlas-warning-500);
}

.btn-danger {
  --atlas-btn-bg: var(--atlas-danger);
  --atlas-btn-color: var(--atlas-contrast-danger);
  --atlas-btn-border-color: var(--atlas-danger);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-danger);
  --atlas-btn-hover-bg: var(--atlas-danger-600);
  --atlas-btn-hover-border-color: var(--atlas-danger-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-danger);
  --atlas-btn-active-bg: var(--atlas-danger-700);
  --atlas-btn-active-border-color: var(--atlas-danger-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-danger);
  --atlas-btn-disabled-border-color: var(--atlas-danger);
  --atlas-btn-disabled-bg: var(--atlas-danger);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-danger-400);
  --atlas-btn-check-hover-border-color: var(--atlas-danger-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-danger-500);
  --atlas-btn-checked-border-color: var(--atlas-danger-500);
}

.btn-outline-danger {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-danger);
  --atlas-btn-border-color: var(--atlas-danger);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-danger-600);
  --atlas-btn-hover-border-color: var(--atlas-danger-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-danger-700);
  --atlas-btn-active-border-color: var(--atlas-danger-700);
  --atlas-btn-disabled-color: var(--atlas-danger);
  --atlas-btn-disabled-bg: var(--atlas-danger-100);
  --atlas-btn-disabled-border-color: var(--atlas-danger);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-danger-400);
  --atlas-btn-check-hover-border-color: var(--atlas-danger-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-danger-500);
  --atlas-btn-checked-border-color: var(--atlas-danger-500);
}

.btn-ghost-danger {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-danger);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-danger-600);
  --atlas-btn-hover-border-color: var(--atlas-danger-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-danger-700);
  --atlas-btn-active-border-color: var(--atlas-danger-700);
  --atlas-btn-disabled-color: var(--atlas-danger);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-danger-400);
  --atlas-btn-check-hover-border-color: var(--atlas-danger-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-danger-500);
  --atlas-btn-checked-border-color: var(--atlas-danger-500);
}

.btn-highlight {
  --atlas-btn-bg: var(--atlas-highlight);
  --atlas-btn-color: var(--atlas-contrast-highlight);
  --atlas-btn-border-color: var(--atlas-highlight);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-highlight);
  --atlas-btn-hover-bg: var(--atlas-highlight-600);
  --atlas-btn-hover-border-color: var(--atlas-highlight-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-highlight-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-highlight);
  --atlas-btn-active-bg: var(--atlas-highlight-700);
  --atlas-btn-active-border-color: var(--atlas-highlight-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-highlight);
  --atlas-btn-disabled-border-color: var(--atlas-highlight);
  --atlas-btn-disabled-bg: var(--atlas-highlight);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-highlight-400);
  --atlas-btn-check-hover-border-color: var(--atlas-highlight-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-highlight-500);
  --atlas-btn-checked-border-color: var(--atlas-highlight-500);
}

.btn-outline-highlight {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-highlight);
  --atlas-btn-border-color: var(--atlas-highlight);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-highlight-600);
  --atlas-btn-hover-border-color: var(--atlas-highlight-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-highlight-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-highlight-700);
  --atlas-btn-active-border-color: var(--atlas-highlight-700);
  --atlas-btn-disabled-color: var(--atlas-highlight);
  --atlas-btn-disabled-bg: var(--atlas-highlight-100);
  --atlas-btn-disabled-border-color: var(--atlas-highlight);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-highlight-400);
  --atlas-btn-check-hover-border-color: var(--atlas-highlight-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-highlight-500);
  --atlas-btn-checked-border-color: var(--atlas-highlight-500);
}

.btn-ghost-highlight {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-highlight);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-highlight-600);
  --atlas-btn-hover-border-color: var(--atlas-highlight-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-highlight-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-highlight-700);
  --atlas-btn-active-border-color: var(--atlas-highlight-700);
  --atlas-btn-disabled-color: var(--atlas-highlight);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-highlight-400);
  --atlas-btn-check-hover-border-color: var(--atlas-highlight-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-highlight-500);
  --atlas-btn-checked-border-color: var(--atlas-highlight-500);
}

.btn-info {
  --atlas-btn-bg: var(--atlas-info);
  --atlas-btn-color: var(--atlas-contrast-info);
  --atlas-btn-border-color: var(--atlas-info);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-info);
  --atlas-btn-hover-bg: var(--atlas-info-600);
  --atlas-btn-hover-border-color: var(--atlas-info-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-info-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-info);
  --atlas-btn-active-bg: var(--atlas-info-700);
  --atlas-btn-active-border-color: var(--atlas-info-700);
  --atlas-btn-disabled-color: var(--atlas-contrast-info);
  --atlas-btn-disabled-border-color: var(--atlas-info);
  --atlas-btn-disabled-bg: var(--atlas-info);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-info-400);
  --atlas-btn-check-hover-border-color: var(--atlas-info-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-info-500);
  --atlas-btn-checked-border-color: var(--atlas-info-500);
}

.btn-outline-info {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-info);
  --atlas-btn-border-color: var(--atlas-info);
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-info-600);
  --atlas-btn-hover-border-color: var(--atlas-info-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-info-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-info-700);
  --atlas-btn-active-border-color: var(--atlas-info-700);
  --atlas-btn-disabled-color: var(--atlas-info);
  --atlas-btn-disabled-bg: var(--atlas-info-100);
  --atlas-btn-disabled-border-color: var(--atlas-info);
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-info-400);
  --atlas-btn-check-hover-border-color: var(--atlas-info-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-info-500);
  --atlas-btn-checked-border-color: var(--atlas-info-500);
}

.btn-ghost-info {
  --atlas-btn-bg: transparent;
  --atlas-btn-color: var(--atlas-info);
  --atlas-btn-border-color: transparent;
  --atlas-btn-box-shadow: none;
  --atlas-btn-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-hover-bg: var(--atlas-info-600);
  --atlas-btn-hover-border-color: var(--atlas-info-600);
  --atlas-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--atlas-info-rgb), 0.25);
  --atlas-btn-active-color: var(--atlas-contrast-primary);
  --atlas-btn-active-bg: var(--atlas-info-700);
  --atlas-btn-active-border-color: var(--atlas-info-700);
  --atlas-btn-disabled-color: var(--atlas-info);
  --atlas-btn-disabled-border-color: transparent;
  --atlas-btn-check-hover-color: var(--atlas-contrast-primary);
  --atlas-btn-check-hover-bg: var(--atlas-info-400);
  --atlas-btn-check-hover-border-color: var(--atlas-info-400);
  --atlas-btn-checked-color: var(--atlas-contrast-primary);
  --atlas-btn-checked-bg: var(--atlas-info-500);
  --atlas-btn-checked-border-color: var(--atlas-info-500);
}

:host {
  display: contents;
}

.btn-label {
  --atlas-text-color: var(--atlas-primary-500);
  box-sizing: border-box;
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  border-radius: 9999px;
  padding: 0.5rem 0.75rem;
  line-height: 1.5;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  width: 100%;
  height: 100%;
  max-width: 100%;
  transition: background-color 0.25s ease, color 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
  z-index: 1;
}
@media screen and (min-width: 992px) {
  .btn-label {
    max-width: 300px;
    padding: 0.5rem 1.5rem;
  }
}
.btn-label:hover:not(.disabled) {
  --atlas-text-color: #ffffff;
  background-color: var(--atlas-primary-500);
}
.btn-label:active:not(.disabled) {
  --atlas-text-color: #ffffff;
  background-color: var(--atlas-primary-600);
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check:disabled + .btn-label {
  --atlas-text-color: var(--atlas-primary-500);
  opacity: 0.35;
}
.btn-check:focus + .btn-label, .btn-check:focus-visible + .btn-label, .btn-check:focus-within + .btn-label {
  --atlas-text-color: var(--atlas-primary-500);
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-500-rgb), 0.25);
  outline: 1px solid var(--atlas-primary-500);
}
.btn-check:checked + .btn-label {
  --atlas-text-color: #ffffff;
}
.btn-check:checked:disabled + .btn-label {
  --atlas-text-color: #ffffff;
  opacity: 1;
}`;

// src/components/form/atlas-toggle-item/atlas-toggle-item.ts
var AtlasToggleItem = /*#__PURE__*/(() => {
  let AtlasToggleItem = class extends AtlasElement {
    constructor() {
      super();
      this.value = "";
      this.label = "";
      this.helperText = "";
      this.disabled = false;
      this.checked = false;
      this._deviceController = new DeviceController(this);
      this._uid = generateUniqueId("toggle-item");
    }
    /**
     * Marca o item como selecionado
     */
    check() {
      this.checked = true;
    }
    /**
     * Desmarca o item
     */
    uncheck() {
      this.checked = false;
    }
    onItemClick() {
      if (this.checked) return;
      this.check();
    }
    onChangeChecked() {
      const eventObject = {
        detail: {
          checked: this.checked
        }
      };
      emit(this, `atlas-toggle-item-${this.checked ? "check" : "uncheck"}`, eventObject);
      emit(this, "atlas-toggle-item-change", eventObject);
    }
    renderElement() {
      const btnClass = {
        "btn-label": true,
        "disabled": this.disabled,
        "active": this.checked
      };
      return html104`
            <input
                id=${this._uid}
                class="btn-check"
                type="radio"
                .value="${this.value}"
                .checked=${live7(this.checked)}
                ?disabled=${this.disabled}
                @click=${this.onItemClick}
                tabindex="0"
            />
            <label class=${classMap73(btnClass)} for=${this._uid} tabindex="-1">
                <atlas-text
                    line-clamp="2"
                    show-line-clamp-tooltip
                    size="${this._deviceController.isMobile ? "sm" : "md"}"
                >
                    ${this.label}
                </atlas-text>
            </label>
        `;
    }
    renderSkeleton() {
      const skeletonClass = {
        "skeleton": true,
        "btn-md": true,
        "btn-block": true
      };
      return html104` <div class="${classMap73(skeletonClass)}"></div> `;
    }
  };
  AtlasToggleItem.styles = atlas_toggle_item_default;
  return AtlasToggleItem;
})();
__decorateClass([property111({
  type: String
})], AtlasToggleItem.prototype, "value", 2);
__decorateClass([property111({
  type: String
})], AtlasToggleItem.prototype, "label", 2);
__decorateClass([property111({
  type: String,
  attribute: "helper-text"
})], AtlasToggleItem.prototype, "helperText", 2);
__decorateClass([property111({
  type: Boolean,
  reflect: true
})], AtlasToggleItem.prototype, "disabled", 2);
__decorateClass([property111({
  type: Boolean,
  reflect: true
})], AtlasToggleItem.prototype, "checked", 2);
__decorateClass([Watch("checked", true)], AtlasToggleItem.prototype, "onChangeChecked", 1);
AtlasToggleItem = __decorateClass([customElement103("atlas-toggle-item")], AtlasToggleItem);

// src/components/form/atlas-uploader/atlas-uploader.ts
import { html as html110, nothing as nothing8 } from "lit";
import { customElement as customElement109, property as property117, queryAsync as queryAsync5, state as state61 } from "lit/decorators.js";
import { classMap as classMap77 } from "lit/directives/class-map.js";
import { when as when75 } from "lit/directives/when.js";

// src/internals/validators/uploader-validator.ts
var UploaderValidator = class {
  constructor() {
    this.name = "uploader";
    this.status = "error";
  }
  getInvalidMessage() {
    return "Aguarde a conclus\xE3o do carregamento";
  }
  validate(element) {
    return !element.isUploadingFiles();
  }
};

// src/vendors/dropzone-utils.ts
import Dropzone from "dropzone";
var DropzoneExtended = class extends Dropzone {
  constructor(container, options) {
    let hasFakeUrl = false;
    if (!options.url) {
      Object.assign(options, {
        url: "fakeUrl",
        parallelUploads: 1
      });
      hasFakeUrl = true;
    }
    super(container, options);
    this._hasFakeUrl = false;
    this._hasFakeUrl = hasFakeUrl;
  }
  _uploadData(files, dataBlocks) {
    if (!this._hasFakeUrl && !files[0].alreadyUploaded) {
      super._uploadData(files, dataBlocks);
    } else {
      this._finishedUploading(files, null, null);
    }
  }
  _finishedUploading(files, xhr, e) {
    if (!this._hasFakeUrl && !files[0].alreadyUploaded) {
      super._finishedUploading(files, xhr, e);
    } else {
      this._finished(files, {
        success: true
      }, e);
    }
  }
  cancelAllUploads() {
    this.getActiveFiles().forEach(file => {
      this.cancelUpload(file);
    });
  }
};

// src/components/form/atlas-uploader/atlas-uploader.scss
import { css as css91 } from "lit-element/lit-element.js";
var atlas_uploader_default = css91`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
.status-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.8rem;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}

.is-info ~ .status-feedback {
  display: block;
}

.status-info {
  color: var(--atlas-secondary);
}

.is-success {
  border-color: var(--atlas-success) !important;
}
.is-success:focus, .is-success:focus-visible, .is-success.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
  border-color: var(--atlas-success);
}
.is-success ~ .status-feedback {
  display: block;
}
.is-success ~ .form-check-label {
  color: var(--atlas-success);
}
.is-success .focus-mark {
  background: var(--atlas-success-300);
}
.is-success.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-success) !important;
  background-color: rgba(var(--atlas-success-rgb), 2%);
}
.is-success.rating-buttons-group .rating-button {
  border-color: var(--atlas-success) !important;
  color: var(--atlas-success) !important;
}
.is-success.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-success-400) !important;
  color: #ffffff !important;
}
.is-success.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
}
.is-success.rating-buttons-group .rating-button:active:not(:disabled), .is-success.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-success) !important;
  color: #ffffff !important;
}

.form-check:has(.is-success) .form-check-label {
  color: var(--atlas-success);
}
.form-check:has(.is-success) .form-check-input:checked {
  background-color: var(--atlas-success);
}

.status-success {
  color: var(--atlas-success);
}

.is-warning {
  border-color: var(--atlas-warning) !important;
}
.is-warning:focus, .is-warning:focus-visible, .is-warning.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
  border-color: var(--atlas-warning);
}
.is-warning ~ .status-feedback {
  display: block;
}
.is-warning ~ .form-check-label {
  color: var(--atlas-warning);
}
.is-warning .focus-mark {
  background: var(--atlas-warning-300);
}
.is-warning.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-warning) !important;
  background-color: rgba(var(--atlas-warning-rgb), 2%);
}
.is-warning.rating-buttons-group .rating-button {
  border-color: var(--atlas-warning) !important;
  color: var(--atlas-warning) !important;
}
.is-warning.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-warning-400) !important;
  color: #ffffff !important;
}
.is-warning.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
}
.is-warning.rating-buttons-group .rating-button:active:not(:disabled), .is-warning.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-warning) !important;
  color: #ffffff !important;
}

.form-check:has(.is-warning) .form-check-label {
  color: var(--atlas-warning);
}
.form-check:has(.is-warning) .form-check-input:checked {
  background-color: var(--atlas-warning);
}

.status-warning {
  color: var(--atlas-warning);
}

.is-error {
  border-color: var(--atlas-danger) !important;
}
.is-error:focus, .is-error:focus-visible, .is-error.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
  border-color: var(--atlas-danger);
}
.is-error ~ .status-feedback {
  display: block;
}
.is-error ~ .form-check-label {
  color: var(--atlas-danger);
}
.is-error .focus-mark {
  background: var(--atlas-danger-300);
}
.is-error.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-danger) !important;
  background-color: rgba(var(--atlas-danger-rgb), 2%);
}
.is-error.rating-buttons-group .rating-button {
  border-color: var(--atlas-danger) !important;
  color: var(--atlas-danger) !important;
}
.is-error.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-danger-400) !important;
  color: #ffffff !important;
}
.is-error.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
}
.is-error.rating-buttons-group .rating-button:active:not(:disabled), .is-error.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-danger) !important;
  color: #ffffff !important;
}

.form-check:has(.is-error) .form-check-label {
  color: var(--atlas-danger);
}
.form-check:has(.is-error) .form-check-input:checked {
  background-color: var(--atlas-danger);
}

.status-error {
  color: var(--atlas-danger);
}

:host {
  display: block;
  width: 100%;
}

.uploader-wrapper {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.uploader {
  width: 100%;
  height: 125px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-shrink: 0;
  padding: 1.5rem 1rem;
  box-sizing: border-box;
  border-radius: 0.5rem;
  position: relative;
  background-color: rgba(var(--atlas-primary-rgb), 2%);
  border: 1px dashed var(--atlas-primary);
  cursor: pointer;
  transition: width 0.15s ease, border 0.25s ease, background 0.25s ease;
}
.uploader .uploader-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  pointer-events: none;
  width: 100%;
}
.uploader .uploader-content atlas-link {
  pointer-events: all;
}
.uploader .disabled-text {
  color: rgb(177.3, 178.7, 180.1);
}
.uploader:hover {
  background-color: rgba(var(--atlas-primary-rgb), 10%);
}
.uploader.dz-drag-hover {
  background-color: rgba(var(--atlas-primary-rgb), 10%);
  border: 1px solid var(--atlas-primary);
}
.uploader.disabled {
  pointer-events: none;
  background-color: #e9ecef;
  border-color: #ced4da;
  opacity: 1;
}
.uploader.disabled atlas-link {
  pointer-events: none;
}

.uploader-preview {
  display: none;
  gap: 1rem;
}

.uploader-wrapper:not(.has-files).has-files-list atlas-table {
  display: none;
}

.uploader-wrapper.has-files.has-preview .uploader {
  padding: 1rem;
  height: 93px;
  width: 93px;
}
.uploader-wrapper.has-files.has-preview .uploader atlas-link {
  display: none;
}
.uploader-wrapper.has-files.has-preview .uploader-preview {
  display: flex;
}
.uploader-wrapper.has-files.has-max-files .uploader {
  display: none;
}
.uploader-wrapper.has-files.has-files-list {
  flex-direction: column;
  flex-wrap: nowrap;
}

@media screen and (min-width: 992px) {
  .uploader {
    height: 148px;
  }
  .uploader-wrapper.has-files.has-preview .uploader {
    padding: 1rem;
    width: 148px;
    height: 148px;
  }
  .uploader-wrapper.has-files.has-preview .uploader atlas-link {
    display: contents;
  }
}`;

// src/components/table/atlas-table-body/atlas-table-body.ts
import { html as html105 } from "lit";
import { customElement as customElement104, property as property112, queryAsync as queryAsync2, state as state58 } from "lit/decorators.js";
import { map as map5 } from "lit/directives/map.js";
import { range as range4 } from "lit/directives/range.js";

// src/components/table/atlas-table-body/atlas-table-body.scss
import { css as css92 } from "lit-element/lit-element.js";
var atlas_table_body_default = css92`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: contents;
}`;

// src/components/table/atlas-table-body/atlas-table-body.ts
var AtlasTableBody = /*#__PURE__*/(() => {
  let AtlasTableBody = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.hasActions = false;
      this.selectable = false;
      this.selectionName = "";
      this.selectionType = "multiple";
      this._headerColsProps = [];
    }
    getSlottedRows() {
      return __async(this, null, function* () {
        const defaultSlot = yield this._defaultSlotPromise;
        const assignedElements = (defaultSlot == null ? void 0 : defaultSlot.assignedElements({
          flatten: true
        })) || [];
        return filterElementsByTagNames(assignedElements, ["ATLAS-TABLE-ROW"]);
      });
    }
    applyPropsInSlottedRows() {
      return __async(this, null, function* () {
        const slottedRows = yield this.getSlottedRows();
        slottedRows.forEach(row => {
          row.toggleAttribute("selectable", this.selectable);
          row.toggleAttribute("has-actions", this.hasActions);
          row.setAttribute("selection-name", this.selectionName);
          row.setAttribute("selection-type", this.selectionType);
        });
      });
    }
    applyPropsFromHeader(colsProps) {
      this._headerColsProps = colsProps;
      this.applyHeaderColsPropsInSlottedCols();
    }
    applyHeaderColsPropsInSlottedCols() {
      return __async(this, null, function* () {
        if (!this._headerColsProps || this._headerColsProps.length === 0) return;
        const slottedRows = yield this.getSlottedRows();
        slottedRows.forEach(row => __async(this, null, function* () {
          const slottedCols = yield row.getSlottedCols();
          slottedCols.forEach((col, index) => {
            Object.entries(this._headerColsProps[index]).forEach(([attribute, value]) => {
              if (typeof value === "boolean") {
                col.toggleAttribute(attribute, value);
              } else {
                col.setAttribute(attribute, `${value}`);
              }
            });
          });
        }));
      });
    }
    onChangeSlottedRows() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const slottedRows = yield this.getSlottedRows();
        this.applyHeaderColsPropsInSlottedCols();
        this.applyPropsInSlottedRows();
        emit(this, "atlas-table-body-slot-change", {
          trackDisable: true,
          detail: {
            rows: slottedRows
          }
        });
      });
    }
    renderElement() {
      return html105`<slot @slotchange=${this.onChangeSlottedRows}></slot>`;
    }
    renderSkeleton() {
      return map5(range4(5), () => html105`
                <atlas-table-row
                    skeleton-loading
                    ?selectable=${this.selectable}
                    ?has-actions=${this.hasActions}
                    selection-name=${this.selectionName}
                    selection-type=${this.selectionType}
                >
                    ${this._headerColsProps.map(() => html105`<atlas-table-col></atlas-table-col>`)}
                </atlas-table-row>
            `);
    }
  };
  AtlasTableBody.styles = atlas_table_body_default;
  return AtlasTableBody;
})();
__decorateClass([property112({
  type: Boolean,
  attribute: "has-actions"
})], AtlasTableBody.prototype, "hasActions", 2);
__decorateClass([property112({
  type: Boolean
})], AtlasTableBody.prototype, "selectable", 2);
__decorateClass([property112({
  type: String,
  attribute: "selection-name"
})], AtlasTableBody.prototype, "selectionName", 2);
__decorateClass([property112({
  type: String,
  attribute: "selection-type"
})], AtlasTableBody.prototype, "selectionType", 2);
__decorateClass([state58()], AtlasTableBody.prototype, "_headerColsProps", 2);
__decorateClass([queryAsync2("slot")], AtlasTableBody.prototype, "_defaultSlotPromise", 2);
__decorateClass([Watch(["selectable", "hasActions", "selectionType", "selectionName"])], AtlasTableBody.prototype, "applyPropsInSlottedRows", 1);
AtlasTableBody = __decorateClass([customElement104("atlas-table-body")], AtlasTableBody);

// src/components/table/atlas-table-col/atlas-table-col.ts
import { html as html106 } from "lit";
import { customElement as customElement105, property as property113 } from "lit/decorators.js";
import { classMap as classMap74 } from "lit/directives/class-map.js";
import { when as when72 } from "lit/directives/when.js";

// src/components/table/atlas-table-col/atlas-table-col.scss
import { css as css93 } from "lit-element/lit-element.js";
var atlas_table_col_default = css93`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: flex !important;
  flex-direction: column;
}

:host([is-selection-column]) {
  width: fit-content;
  cursor: pointer;
  display: none;
}
:host([is-selection-column]) .column-content {
  height: 24px;
}

:host([is-selection-disabled]) {
  cursor: default;
}

:host([is-action-column]) {
  cursor: pointer;
  position: relative;
}
:host([is-action-column])::before {
  min-width: 118px;
}

:host([is-action-column]:not([is-header-column])) {
  --atlas-icon-button-hoverable-padding: 4px;
}

:host([has-visibility-icon]) {
  cursor: pointer;
  position: relative;
}

.atlas-table-column {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  background: none;
  position: relative;
  border: 0;
  padding: 0;
  text-align: left;
}
.atlas-table-column .column-label {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 0.8rem;
  color: #687078;
}
.atlas-table-column .column-content.skeleton {
  min-height: 1rem;
}
.atlas-table-column.is-selection:not(.is-selection-disabled) {
  cursor: pointer;
}
.atlas-table-column.is-selection .column-content, .atlas-table-column.is-actions .column-content {
  line-height: 1;
}

.atlas-table-column.header-column {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
  border: 0;
  gap: 0.5rem;
}
.atlas-table-column.header-column atlas-icon {
  display: none;
}
.atlas-table-column.header-column.is-actions {
  display: flex;
  justify-content: center;
  align-items: center;
}
.atlas-table-column.header-column.sortable {
  cursor: pointer;
}
.atlas-table-column.header-column.sortable atlas-icon {
  display: inline-flex;
}

.atlas-table-column:not(.header-column) {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.atlas-table-column:not(.header-column).is-actions {
  align-items: center;
}
.atlas-table-column:not(.header-column).ellipsis .column-content {
  width: 100%;
}

@media screen and (min-width: 992px) {
  :host {
    display: table-cell !important;
    vertical-align: middle;
    white-space: normal;
    --atlas-table-column-padding-left: 0.375rem;
    --atlas-table-column-padding-right: 0.375rem;
  }
  :host([size=sm]) {
    width: 15%;
  }
  :host([size=md]) {
    width: 20%;
  }
  :host([size=lg]) {
    width: 30%;
  }
  :host([size=sm][ellipsis]:not([is-header-column])) {
    max-width: 150px;
  }
  :host([size=md][ellipsis]:not([is-header-column])) {
    max-width: 200px;
  }
  :host([size=lg][ellipsis]:not([is-header-column])) {
    max-width: 280px;
  }
  :host([disable-line-break]) {
    white-space: nowrap;
  }
  :host([is-header-column]) {
    vertical-align: bottom;
    white-space: normal;
  }
  :host([ellipsis]:not([is-header-column])) {
    white-space: nowrap;
  }
  :host([is-selection-column]) {
    min-width: fit-content;
    width: 0%;
    display: table-cell;
  }
  :host([is-action-column]) {
    min-width: 90px;
    width: 0%;
    position: relative;
    top: unset;
    right: unset;
  }
  :host([has-visibility-icon]) {
    width: 1rem;
  }
  :host([is-action-column]:not([is-header-column])) {
    --atlas-table-column-padding-left: 0.125rem;
    --atlas-table-column-padding-right: 0.125rem;
  }
  .atlas-table-column {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: var(--atlas-table-column-padding-left);
    padding-right: var(--atlas-table-column-padding-right);
    align-items: center;
  }
  .atlas-table-column:not(.header-column).ellipsis {
    box-sizing: border-box;
  }
  .atlas-table-column:not(.header-column).ellipsis .column-content {
    width: calc(100% - (var(--atlas-table-column-padding-left) + var(--atlas-table-column-padding-right)));
  }
}`;

// src/components/table/atlas-table-col/atlas-table-col.ts
var ComposedClass7 = WithVisibilityIconMixin(WithPopoverMixin(AtlasElement));
var AtlasTableCol = /*#__PURE__*/(() => {
  let AtlasTableCol = class extends ComposedClass7 {
    constructor() {
      super(...arguments);
      this.disableLineBreak = false;
      this.sort = "none";
      this._deviceController = new DeviceController(this);
    }
    getSort() {
      return this.sort;
    }
    setSort(sort) {
      this.sort = sort;
    }
    onClickCol(event) {
      if (this.isSelectionColumn && this.isSelectionDisabled) return;
      event.preventDefault();
      emit(this, "atlas-table-col-click", {
        trackDisable: true
      });
    }
    onDefaultSlotChange() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const slot = this.shadowRoot.querySelector("slot:not([name])");
        const assignedElements = (slot == null ? void 0 : slot.assignedElements()) || [];
        const badge = findElementByTagName(assignedElements, "ATLAS-BADGE");
        badge == null ? void 0 : badge.toggleAttribute("in-table-col", true);
      });
    }
    getSortingIcon(sort) {
      switch (sort) {
        case "asc":
          return "chevron-up";
        case "desc":
          return "chevron-down";
        default:
          return "sort";
      }
    }
    renderColumnLabel() {
      return when72(this._deviceController.isMobile && this.columnLabel, () => html106` <span class="column-label"> ${this.columnLabel} </span> `);
    }
    renderContent() {
      return when72(this.isHeaderColumn && !this.isSelectionColumn, () => html106`
                <atlas-text size="xs" muted>
                    <slot></slot>
                </atlas-text>
                ${this.renderPopoverInfoIcon()}
                <atlas-icon name=${this.getSortingIcon(this.sort)} size="2x" theme="secondary"></atlas-icon>
            `, () => html106`
                <atlas-text
                    size="sm"
                    class="column-content"
                    ?ellipsis=${this.ellipsis && !this._deviceController.isMobile}
                >
                    <slot @slotchange=${this.onDefaultSlotChange}></slot>
                </atlas-text>
            `);
    }
    renderElement() {
      const columnClass = {
        "atlas-table-column": true,
        "header-column": this.isHeaderColumn,
        "is-selection": this.isSelectionColumn,
        "is-selection-disabled": this.isSelectionDisabled,
        "is-actions": this.isActionColumn,
        "has-visibility-icon": this.hasVisibilityIcon,
        "sortable": this.sortable,
        "ellipsis": this.ellipsis,
        [`size-${this.size}`]: !!this.size && this.isHeaderColumn && !this.isSelectionColumn && !this.isActionColumn
      };
      if (this.isHeaderColumn || this.isSelectionColumn || this.isActionColumn) {
        return html106`
                <button
                    class=${classMap74(columnClass)}
                    @click=${this.onClickCol}
                    tabindex=${!this.sortable ? "-1" : "1"}
                >
                    ${this.renderContent()}
                </button>
            `;
      }
      if (this.hasVisibilityIcon) {
        return html106`
                <button class=${classMap74(columnClass)} @click=${this.onClickCol} tabindex="-1">
                    ${this.renderVisibilityIcon()}
                </button>
            `;
      }
      return html106` <div class=${classMap74(columnClass)}>${this.renderColumnLabel()}${this.renderContent()}</div> `;
    }
    renderSkeleton() {
      return html106`
            <div class="atlas-table-column">
                <div class="column-content skeleton"></div>
            </div>
        `;
    }
  };
  AtlasTableCol.styles = atlas_table_col_default;
  return AtlasTableCol;
})();
__decorateClass([property113({
  type: String
})], AtlasTableCol.prototype, "name", 2);
__decorateClass([property113({
  type: String,
  reflect: true
})], AtlasTableCol.prototype, "size", 2);
__decorateClass([property113({
  type: Boolean
})], AtlasTableCol.prototype, "ellipsis", 2);
__decorateClass([property113({
  type: Boolean
})], AtlasTableCol.prototype, "sortable", 2);
__decorateClass([property113({
  type: Boolean,
  attribute: "is-header-column",
  reflect: true
})], AtlasTableCol.prototype, "isHeaderColumn", 2);
__decorateClass([property113({
  type: Boolean,
  attribute: "is-selection-column",
  reflect: true
})], AtlasTableCol.prototype, "isSelectionColumn", 2);
__decorateClass([property113({
  type: Boolean,
  attribute: "is-selection-disabled",
  reflect: true
})], AtlasTableCol.prototype, "isSelectionDisabled", 2);
__decorateClass([property113({
  type: Boolean,
  attribute: "is-action-column",
  reflect: true
})], AtlasTableCol.prototype, "isActionColumn", 2);
__decorateClass([property113({
  type: String,
  attribute: "column-label"
})], AtlasTableCol.prototype, "columnLabel", 2);
__decorateClass([property113({
  type: Boolean,
  attribute: "disable-line-break"
})], AtlasTableCol.prototype, "disableLineBreak", 2);
__decorateClass([property113({
  type: String
})], AtlasTableCol.prototype, "sort", 2);
AtlasTableCol = __decorateClass([customElement105("atlas-table-col")], AtlasTableCol);

// src/components/table/atlas-table-header/atlas-table-header.ts
import { html as html107, nothing as nothing6 } from "lit";
import { customElement as customElement106, property as property114, queryAsync as queryAsync3 } from "lit/decorators.js";
import { when as when73 } from "lit/directives/when.js";

// src/components/table/atlas-table-header/atlas-table-header.scss
import { css as css94 } from "lit-element/lit-element.js";
var atlas_table_header_default = css94`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: table-row !important;
}

:host([selectable]) atlas-table-col:first-of-type {
  --atlas-table-column-padding-left: 0.75rem !important;
}

:host([has-actions]) atlas-table-col:last-of-type {
  --atlas-table-column-padding-right: 0.75rem !important;
}

:host(:not([selectable])) ::slotted(atlas-table-col:first-of-type) {
  --atlas-table-column-padding-left: 0.75rem !important;
}

:host(:not([has-actions])) ::slotted(atlas-table-col:last-of-type) {
  --atlas-table-column-padding-right: 0.75rem !important;
}`;

// src/components/table/atlas-table-header/atlas-table-header.ts
var AtlasTableHeader = /*#__PURE__*/(() => {
  let AtlasTableHeader = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.hasActions = false;
      this.selectable = false;
      this.allSelected = false;
      this.selectionDisabled = false;
      this.selectionName = "";
      this.selectionType = "multiple";
    }
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.onClickHeaderCol = this.onClickHeaderCol.bind(this);
      this.onClickMultipleSelectionColumn = this.onClickMultipleSelectionColumn.bind(this);
    }
    getSlottedCols() {
      return __async(this, null, function* () {
        const defaultSlot = yield this._defaultSlotPromise;
        const assignedElements = (defaultSlot == null ? void 0 : defaultSlot.assignedElements({
          flatten: true
        })) || [];
        return assignedElements.filter(element => element.tagName === "ATLAS-TABLE-COL");
      });
    }
    getColumnNewSort(currentSort) {
      let newSort = "none";
      if (!currentSort || currentSort === "none") {
        newSort = "asc";
      } else if (currentSort === "asc") {
        newSort = "desc";
      }
      return newSort;
    }
    onClickHeaderCol(event) {
      const column = event.target;
      if (column.sortable) {
        this.onClickSort(column);
      }
    }
    onClickSort(column) {
      return __async(this, null, function* () {
        const newOrder = this.getColumnNewSort(column.getSort());
        const slottedCols = yield this.getSlottedCols();
        slottedCols.forEach(col => {
          col.setSort(column.name === col.name ? newOrder : "none");
        });
        emit(this, "atlas-table-change-sorting", {
          detail: {
            column: column.name,
            order: newOrder
          }
        });
      });
    }
    onClickMultipleSelectionColumn() {
      if (this.selectionDisabled) return;
      setTimeout(() => {
        this.allSelected = !this.allSelected;
        emit(this, "atlas-table-select-all", {
          detail: this.allSelected
        });
      }, 0);
    }
    applyPropsInSlots() {
      return __async(this, null, function* () {
        const slottedCols = yield this.getSlottedCols();
        slottedCols.forEach(col => {
          col.toggleAttribute("is-header-column", true);
        });
      });
    }
    onChangeSlottedCols() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const colsProps = [];
        const slottedCols = yield this.getSlottedCols();
        slottedCols.forEach(col => {
          col.toggleAttribute("is-header-column", true);
          col.addEventListener("atlas-table-col-click", this.onClickHeaderCol);
          colsProps.push({
            "size": col.getAttribute("size"),
            "ellipsis": col.hasAttribute("ellipsis"),
            "disable-line-break": col.hasAttribute("disable-line-break"),
            "column-label": col.innerText.trim()
          });
        });
        emit(this, "atlas-table-header-sync-cols", {
          detail: colsProps,
          trackDisable: true
        });
      });
    }
    renderSingleSelectionColumn() {
      return when73(this.selectable && this.selectionType === "single", () => html107` <atlas-table-col is-header-column is-selection-column is-selection-disabled></atlas-table-col> `);
    }
    renderMultipleSelectionColumn() {
      return when73(this.selectable && this.selectionType === "multiple", () => html107`
                <atlas-table-col
                    is-header-column
                    is-selection-column
                    ?is-selection-disabled=${this.selectionDisabled}
                    @atlas-table-col-click=${this.onClickMultipleSelectionColumn}
                >
                    <atlas-checkbox ?checked=${this.allSelected} ?disabled=${this.selectionDisabled}></atlas-checkbox>
                </atlas-table-col>
            `);
    }
    renderSelectionColumn() {
      if (!this.selectable) return nothing6;
      return when73(this.selectionType === "single", () => this.renderSingleSelectionColumn(), () => this.renderMultipleSelectionColumn());
    }
    renderActionsColumn() {
      return when73(this.hasActions, () => html107` <atlas-table-col is-header-column is-action-column>Ações</atlas-table-col> `);
    }
    render() {
      return html107`
            ${this.renderSelectionColumn()}
            <slot @slotchange=${this.onChangeSlottedCols}></slot>
            ${this.renderActionsColumn()}
        `;
    }
  };
  AtlasTableHeader.styles = atlas_table_header_default;
  return AtlasTableHeader;
})();
__decorateClass([property114({
  type: Boolean,
  attribute: "has-actions"
})], AtlasTableHeader.prototype, "hasActions", 2);
__decorateClass([property114({
  type: Boolean
})], AtlasTableHeader.prototype, "selectable", 2);
__decorateClass([property114({
  type: Boolean,
  attribute: "all-selected",
  reflect: true
})], AtlasTableHeader.prototype, "allSelected", 2);
__decorateClass([property114({
  type: Boolean,
  attribute: "selection-disabled",
  reflect: true
})], AtlasTableHeader.prototype, "selectionDisabled", 2);
__decorateClass([property114({
  type: String,
  attribute: "selection-name"
})], AtlasTableHeader.prototype, "selectionName", 2);
__decorateClass([property114({
  type: String,
  attribute: "selection-type"
})], AtlasTableHeader.prototype, "selectionType", 2);
__decorateClass([queryAsync3("slot")], AtlasTableHeader.prototype, "_defaultSlotPromise", 2);
__decorateClass([Watch(["isHeaderColumn"])], AtlasTableHeader.prototype, "applyPropsInSlots", 1);
AtlasTableHeader = __decorateClass([customElement106("atlas-table-header")], AtlasTableHeader);

// src/components/table/atlas-table-row/atlas-table-row.ts
import { html as html108, nothing as nothing7 } from "lit";
import { customElement as customElement107, property as property115, queryAsync as queryAsync4, state as state59 } from "lit/decorators.js";
import { classMap as classMap75 } from "lit/directives/class-map.js";
import { ifDefined as ifDefined22 } from "lit/directives/if-defined.js";
import { when as when74 } from "lit/directives/when.js";
import { autoUpdate as autoUpdate4, computePosition as computePosition4, offset as offset5 } from "@floating-ui/dom";

// src/components/table/atlas-table-row/atlas-table-row.scss
import { css as css95 } from "lit-element/lit-element.js";
var atlas_table_row_default = css95`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: contents;
}

.atlas-table-row {
  width: 100%;
  box-sizing: border-box;
  text-decoration: none;
  color: currentcolor;
  cursor: default;
  flex-direction: column;
  display: flex;
  border-top: 1px solid #ced4da;
  padding: 1rem;
  gap: 0.5rem;
  position: relative;
}
.atlas-table-row ::slotted(atlas-table-col:first-of-type) {
  padding-right: 2rem;
}
.atlas-table-row .floating-mobile-actions {
  display: flex;
  gap: 0.5rem;
  flex-direction: row;
  position: absolute;
  right: 1rem;
  top: 1rem;
}

slot[name=hotspot]::slotted(atlas-hotspot) {
  position: fixed;
}

@media screen and (min-width: 992px) {
  .atlas-table-row {
    display: table-row;
    border-top: 0;
    padding: 0;
    border-radius: 0.5rem;
  }
  .atlas-table-row ::slotted(atlas-table-col:first-of-type) {
    padding-right: 0;
  }
  .atlas-table-row .floating-mobile-actions {
    display: contents;
  }
  .atlas-table-row.has-link {
    cursor: pointer;
  }
  .atlas-table-row.selectable atlas-table-col:first-of-type {
    --atlas-table-column-padding-left: 0.75rem !important;
  }
  .atlas-table-row.has-visibility-icon atlas-table-col:last-of-type {
    --atlas-table-column-padding-right: 0.75rem !important;
  }
  .atlas-table-row.has-actions:not(.has-visibility-icon) atlas-table-col:last-of-type {
    --atlas-table-column-padding-right: 0.5rem !important;
  }
  .atlas-table-row:not(.selectable) ::slotted(atlas-table-col:first-of-type) {
    --atlas-table-column-padding-left: 0.75rem !important;
  }
  .atlas-table-row:not(.has-actions, .has-visibility-icon) ::slotted(atlas-table-col:last-of-type) {
    --atlas-table-column-padding-right: 0.75rem !important;
  }
  .atlas-table-row.theme-primary {
    transition: background 0.25s ease, box-shadow 0.25s ease;
    background: linear-gradient(0deg, rgba(var(--atlas-primary-rgb), 2.5%), rgba(var(--atlas-primary-rgb), 2.5%)), #ffffff;
  }
  .atlas-table-row.theme-primary atlas-table-col,
  .atlas-table-row.theme-primary ::slotted(atlas-table-col) {
    border-top: 1px solid rgba(var(--atlas-primary-rgb), 10%);
    border-bottom: 1px solid rgba(var(--atlas-primary-rgb), 10%);
  }
  .atlas-table-row.theme-primary.has-link:hover:not(:has(slot[name=hotspot]:hover)) {
    background: linear-gradient(0deg, rgba(var(--atlas-primary-rgb), 5%), rgba(var(--atlas-primary-rgb), 5%)), #ffffff;
  }
  .atlas-table-row.theme-primary.has-link:focus-visible:not(:has(slot[name=hotspot]:focus-visible)) {
    outline: none;
    box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-500-rgb), 0.25);
  }
  .atlas-table-row.theme-primary.has-link:active:not(:has(slot[name=hotspot]:active)) {
    background: linear-gradient(0deg, rgba(var(--atlas-primary-rgb), 8%), rgba(var(--atlas-primary-rgb), 8%)), #ffffff;
  }
  .atlas-table-row.theme-primary.selected {
    background: linear-gradient(0deg, rgba(var(--atlas-primary-rgb), 8%), rgba(var(--atlas-primary-rgb), 8%)), #ffffff;
  }
  .atlas-table-row.theme-primary.selectable atlas-table-col[is-selection-column] {
    border-left: 1px solid rgba(var(--atlas-primary-rgb), 10%);
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  .atlas-table-row.theme-primary.has-actions:not(.has-visibility-icon) atlas-table-col[is-action-column] {
    border-right: 1px solid rgba(var(--atlas-primary-rgb), 10%);
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  .atlas-table-row.theme-primary.has-visibility-icon atlas-table-col[has-visibility-icon] {
    border-right: 1px solid rgba(var(--atlas-primary-rgb), 10%);
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  .atlas-table-row.theme-primary:not(.selectable) ::slotted(atlas-table-col:first-of-type) {
    border-left: 1px solid rgba(var(--atlas-primary-rgb), 10%);
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  .atlas-table-row.theme-primary:not(.has-actions, .has-visibility-icon) ::slotted(atlas-table-col:last-of-type) {
    border-right: 1px solid rgba(var(--atlas-primary-rgb), 10%);
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  .atlas-table-row.theme-secondary {
    transition: background 0.25s ease, box-shadow 0.25s ease;
    background: linear-gradient(0deg, rgba(var(--atlas-secondary-rgb), 2.5%), rgba(var(--atlas-secondary-rgb), 2.5%)), #ffffff;
  }
  .atlas-table-row.theme-secondary atlas-table-col,
  .atlas-table-row.theme-secondary ::slotted(atlas-table-col) {
    border-top: 1px solid rgba(var(--atlas-secondary-rgb), 10%);
    border-bottom: 1px solid rgba(var(--atlas-secondary-rgb), 10%);
  }
  .atlas-table-row.theme-secondary.has-link:hover:not(:has(slot[name=hotspot]:hover)) {
    background: linear-gradient(0deg, rgba(var(--atlas-secondary-rgb), 5%), rgba(var(--atlas-secondary-rgb), 5%)), #ffffff;
  }
  .atlas-table-row.theme-secondary.has-link:focus-visible:not(:has(slot[name=hotspot]:focus-visible)) {
    outline: none;
    box-shadow: 0 0 0 0.25rem rgba(var(--atlas-secondary-500-rgb), 0.25);
  }
  .atlas-table-row.theme-secondary.has-link:active:not(:has(slot[name=hotspot]:active)) {
    background: linear-gradient(0deg, rgba(var(--atlas-secondary-rgb), 8%), rgba(var(--atlas-secondary-rgb), 8%)), #ffffff;
  }
  .atlas-table-row.theme-secondary.selected {
    background: linear-gradient(0deg, rgba(var(--atlas-secondary-rgb), 8%), rgba(var(--atlas-secondary-rgb), 8%)), #ffffff;
  }
  .atlas-table-row.theme-secondary.selectable atlas-table-col[is-selection-column] {
    border-left: 1px solid rgba(var(--atlas-secondary-rgb), 10%);
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  .atlas-table-row.theme-secondary.has-actions:not(.has-visibility-icon) atlas-table-col[is-action-column] {
    border-right: 1px solid rgba(var(--atlas-secondary-rgb), 10%);
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  .atlas-table-row.theme-secondary.has-visibility-icon atlas-table-col[has-visibility-icon] {
    border-right: 1px solid rgba(var(--atlas-secondary-rgb), 10%);
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  .atlas-table-row.theme-secondary:not(.selectable) ::slotted(atlas-table-col:first-of-type) {
    border-left: 1px solid rgba(var(--atlas-secondary-rgb), 10%);
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  .atlas-table-row.theme-secondary:not(.has-actions, .has-visibility-icon) ::slotted(atlas-table-col:last-of-type) {
    border-right: 1px solid rgba(var(--atlas-secondary-rgb), 10%);
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  .atlas-table-row.theme-success {
    transition: background 0.25s ease, box-shadow 0.25s ease;
    background: linear-gradient(0deg, rgba(var(--atlas-success-rgb), 2.5%), rgba(var(--atlas-success-rgb), 2.5%)), #ffffff;
  }
  .atlas-table-row.theme-success atlas-table-col,
  .atlas-table-row.theme-success ::slotted(atlas-table-col) {
    border-top: 1px solid rgba(var(--atlas-success-rgb), 10%);
    border-bottom: 1px solid rgba(var(--atlas-success-rgb), 10%);
  }
  .atlas-table-row.theme-success.has-link:hover:not(:has(slot[name=hotspot]:hover)) {
    background: linear-gradient(0deg, rgba(var(--atlas-success-rgb), 5%), rgba(var(--atlas-success-rgb), 5%)), #ffffff;
  }
  .atlas-table-row.theme-success.has-link:focus-visible:not(:has(slot[name=hotspot]:focus-visible)) {
    outline: none;
    box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
  }
  .atlas-table-row.theme-success.has-link:active:not(:has(slot[name=hotspot]:active)) {
    background: linear-gradient(0deg, rgba(var(--atlas-success-rgb), 8%), rgba(var(--atlas-success-rgb), 8%)), #ffffff;
  }
  .atlas-table-row.theme-success.selected {
    background: linear-gradient(0deg, rgba(var(--atlas-success-rgb), 8%), rgba(var(--atlas-success-rgb), 8%)), #ffffff;
  }
  .atlas-table-row.theme-success.selectable atlas-table-col[is-selection-column] {
    border-left: 1px solid rgba(var(--atlas-success-rgb), 10%);
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  .atlas-table-row.theme-success.has-actions:not(.has-visibility-icon) atlas-table-col[is-action-column] {
    border-right: 1px solid rgba(var(--atlas-success-rgb), 10%);
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  .atlas-table-row.theme-success.has-visibility-icon atlas-table-col[has-visibility-icon] {
    border-right: 1px solid rgba(var(--atlas-success-rgb), 10%);
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  .atlas-table-row.theme-success:not(.selectable) ::slotted(atlas-table-col:first-of-type) {
    border-left: 1px solid rgba(var(--atlas-success-rgb), 10%);
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  .atlas-table-row.theme-success:not(.has-actions, .has-visibility-icon) ::slotted(atlas-table-col:last-of-type) {
    border-right: 1px solid rgba(var(--atlas-success-rgb), 10%);
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  .atlas-table-row.theme-warning {
    transition: background 0.25s ease, box-shadow 0.25s ease;
    background: linear-gradient(0deg, rgba(var(--atlas-warning-rgb), 2.5%), rgba(var(--atlas-warning-rgb), 2.5%)), #ffffff;
  }
  .atlas-table-row.theme-warning atlas-table-col,
  .atlas-table-row.theme-warning ::slotted(atlas-table-col) {
    border-top: 1px solid rgba(var(--atlas-warning-rgb), 10%);
    border-bottom: 1px solid rgba(var(--atlas-warning-rgb), 10%);
  }
  .atlas-table-row.theme-warning.has-link:hover:not(:has(slot[name=hotspot]:hover)) {
    background: linear-gradient(0deg, rgba(var(--atlas-warning-rgb), 5%), rgba(var(--atlas-warning-rgb), 5%)), #ffffff;
  }
  .atlas-table-row.theme-warning.has-link:focus-visible:not(:has(slot[name=hotspot]:focus-visible)) {
    outline: none;
    box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
  }
  .atlas-table-row.theme-warning.has-link:active:not(:has(slot[name=hotspot]:active)) {
    background: linear-gradient(0deg, rgba(var(--atlas-warning-rgb), 8%), rgba(var(--atlas-warning-rgb), 8%)), #ffffff;
  }
  .atlas-table-row.theme-warning.selected {
    background: linear-gradient(0deg, rgba(var(--atlas-warning-rgb), 8%), rgba(var(--atlas-warning-rgb), 8%)), #ffffff;
  }
  .atlas-table-row.theme-warning.selectable atlas-table-col[is-selection-column] {
    border-left: 1px solid rgba(var(--atlas-warning-rgb), 10%);
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  .atlas-table-row.theme-warning.has-actions:not(.has-visibility-icon) atlas-table-col[is-action-column] {
    border-right: 1px solid rgba(var(--atlas-warning-rgb), 10%);
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  .atlas-table-row.theme-warning.has-visibility-icon atlas-table-col[has-visibility-icon] {
    border-right: 1px solid rgba(var(--atlas-warning-rgb), 10%);
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  .atlas-table-row.theme-warning:not(.selectable) ::slotted(atlas-table-col:first-of-type) {
    border-left: 1px solid rgba(var(--atlas-warning-rgb), 10%);
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  .atlas-table-row.theme-warning:not(.has-actions, .has-visibility-icon) ::slotted(atlas-table-col:last-of-type) {
    border-right: 1px solid rgba(var(--atlas-warning-rgb), 10%);
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  .atlas-table-row.theme-danger {
    transition: background 0.25s ease, box-shadow 0.25s ease;
    background: linear-gradient(0deg, rgba(var(--atlas-danger-rgb), 2.5%), rgba(var(--atlas-danger-rgb), 2.5%)), #ffffff;
  }
  .atlas-table-row.theme-danger atlas-table-col,
  .atlas-table-row.theme-danger ::slotted(atlas-table-col) {
    border-top: 1px solid rgba(var(--atlas-danger-rgb), 10%);
    border-bottom: 1px solid rgba(var(--atlas-danger-rgb), 10%);
  }
  .atlas-table-row.theme-danger.has-link:hover:not(:has(slot[name=hotspot]:hover)) {
    background: linear-gradient(0deg, rgba(var(--atlas-danger-rgb), 5%), rgba(var(--atlas-danger-rgb), 5%)), #ffffff;
  }
  .atlas-table-row.theme-danger.has-link:focus-visible:not(:has(slot[name=hotspot]:focus-visible)) {
    outline: none;
    box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
  }
  .atlas-table-row.theme-danger.has-link:active:not(:has(slot[name=hotspot]:active)) {
    background: linear-gradient(0deg, rgba(var(--atlas-danger-rgb), 8%), rgba(var(--atlas-danger-rgb), 8%)), #ffffff;
  }
  .atlas-table-row.theme-danger.selected {
    background: linear-gradient(0deg, rgba(var(--atlas-danger-rgb), 8%), rgba(var(--atlas-danger-rgb), 8%)), #ffffff;
  }
  .atlas-table-row.theme-danger.selectable atlas-table-col[is-selection-column] {
    border-left: 1px solid rgba(var(--atlas-danger-rgb), 10%);
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  .atlas-table-row.theme-danger.has-actions:not(.has-visibility-icon) atlas-table-col[is-action-column] {
    border-right: 1px solid rgba(var(--atlas-danger-rgb), 10%);
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  .atlas-table-row.theme-danger.has-visibility-icon atlas-table-col[has-visibility-icon] {
    border-right: 1px solid rgba(var(--atlas-danger-rgb), 10%);
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  .atlas-table-row.theme-danger:not(.selectable) ::slotted(atlas-table-col:first-of-type) {
    border-left: 1px solid rgba(var(--atlas-danger-rgb), 10%);
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  .atlas-table-row.theme-danger:not(.has-actions, .has-visibility-icon) ::slotted(atlas-table-col:last-of-type) {
    border-right: 1px solid rgba(var(--atlas-danger-rgb), 10%);
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  .atlas-table-row.theme-highlight {
    transition: background 0.25s ease, box-shadow 0.25s ease;
    background: linear-gradient(0deg, rgba(var(--atlas-highlight-rgb), 2.5%), rgba(var(--atlas-highlight-rgb), 2.5%)), #ffffff;
  }
  .atlas-table-row.theme-highlight atlas-table-col,
  .atlas-table-row.theme-highlight ::slotted(atlas-table-col) {
    border-top: 1px solid rgba(var(--atlas-highlight-rgb), 10%);
    border-bottom: 1px solid rgba(var(--atlas-highlight-rgb), 10%);
  }
  .atlas-table-row.theme-highlight.has-link:hover:not(:has(slot[name=hotspot]:hover)) {
    background: linear-gradient(0deg, rgba(var(--atlas-highlight-rgb), 5%), rgba(var(--atlas-highlight-rgb), 5%)), #ffffff;
  }
  .atlas-table-row.theme-highlight.has-link:focus-visible:not(:has(slot[name=hotspot]:focus-visible)) {
    outline: none;
    box-shadow: 0 0 0 0.25rem rgba(var(--atlas-highlight-500-rgb), 0.25);
  }
  .atlas-table-row.theme-highlight.has-link:active:not(:has(slot[name=hotspot]:active)) {
    background: linear-gradient(0deg, rgba(var(--atlas-highlight-rgb), 8%), rgba(var(--atlas-highlight-rgb), 8%)), #ffffff;
  }
  .atlas-table-row.theme-highlight.selected {
    background: linear-gradient(0deg, rgba(var(--atlas-highlight-rgb), 8%), rgba(var(--atlas-highlight-rgb), 8%)), #ffffff;
  }
  .atlas-table-row.theme-highlight.selectable atlas-table-col[is-selection-column] {
    border-left: 1px solid rgba(var(--atlas-highlight-rgb), 10%);
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  .atlas-table-row.theme-highlight.has-actions:not(.has-visibility-icon) atlas-table-col[is-action-column] {
    border-right: 1px solid rgba(var(--atlas-highlight-rgb), 10%);
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  .atlas-table-row.theme-highlight.has-visibility-icon atlas-table-col[has-visibility-icon] {
    border-right: 1px solid rgba(var(--atlas-highlight-rgb), 10%);
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  .atlas-table-row.theme-highlight:not(.selectable) ::slotted(atlas-table-col:first-of-type) {
    border-left: 1px solid rgba(var(--atlas-highlight-rgb), 10%);
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  .atlas-table-row.theme-highlight:not(.has-actions, .has-visibility-icon) ::slotted(atlas-table-col:last-of-type) {
    border-right: 1px solid rgba(var(--atlas-highlight-rgb), 10%);
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  .atlas-table-row.theme-info {
    transition: background 0.25s ease, box-shadow 0.25s ease;
    background: linear-gradient(0deg, rgba(var(--atlas-info-rgb), 2.5%), rgba(var(--atlas-info-rgb), 2.5%)), #ffffff;
  }
  .atlas-table-row.theme-info atlas-table-col,
  .atlas-table-row.theme-info ::slotted(atlas-table-col) {
    border-top: 1px solid rgba(var(--atlas-info-rgb), 10%);
    border-bottom: 1px solid rgba(var(--atlas-info-rgb), 10%);
  }
  .atlas-table-row.theme-info.has-link:hover:not(:has(slot[name=hotspot]:hover)) {
    background: linear-gradient(0deg, rgba(var(--atlas-info-rgb), 5%), rgba(var(--atlas-info-rgb), 5%)), #ffffff;
  }
  .atlas-table-row.theme-info.has-link:focus-visible:not(:has(slot[name=hotspot]:focus-visible)) {
    outline: none;
    box-shadow: 0 0 0 0.25rem rgba(var(--atlas-info-500-rgb), 0.25);
  }
  .atlas-table-row.theme-info.has-link:active:not(:has(slot[name=hotspot]:active)) {
    background: linear-gradient(0deg, rgba(var(--atlas-info-rgb), 8%), rgba(var(--atlas-info-rgb), 8%)), #ffffff;
  }
  .atlas-table-row.theme-info.selected {
    background: linear-gradient(0deg, rgba(var(--atlas-info-rgb), 8%), rgba(var(--atlas-info-rgb), 8%)), #ffffff;
  }
  .atlas-table-row.theme-info.selectable atlas-table-col[is-selection-column] {
    border-left: 1px solid rgba(var(--atlas-info-rgb), 10%);
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  .atlas-table-row.theme-info.has-actions:not(.has-visibility-icon) atlas-table-col[is-action-column] {
    border-right: 1px solid rgba(var(--atlas-info-rgb), 10%);
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  .atlas-table-row.theme-info.has-visibility-icon atlas-table-col[has-visibility-icon] {
    border-right: 1px solid rgba(var(--atlas-info-rgb), 10%);
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  .atlas-table-row.theme-info:not(.selectable) ::slotted(atlas-table-col:first-of-type) {
    border-left: 1px solid rgba(var(--atlas-info-rgb), 10%);
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  .atlas-table-row.theme-info:not(.has-actions, .has-visibility-icon) ::slotted(atlas-table-col:last-of-type) {
    border-right: 1px solid rgba(var(--atlas-info-rgb), 10%);
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  .atlas-table-row-fade {
    box-sizing: border-box;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 24px;
    height: 56px;
    pointer-events: none;
    z-index: 10;
    transition: opacity 0.3s ease-in-out;
    opacity: 1;
  }
  .atlas-table-row-fade.left {
    left: -0.25rem;
    background: linear-gradient(270deg, rgba(108, 117, 125, 0) 0%, rgba(108, 117, 125, 0.02) 20%, rgba(108, 117, 125, 0.04) 50.5%, rgba(108, 117, 125, 0.08) 75%, rgba(108, 117, 125, 0.12) 100%);
  }
  .atlas-table-row-fade.right {
    right: 0.25rem;
    background: linear-gradient(90deg, rgba(108, 117, 125, 0) 0%, rgba(108, 117, 125, 0.02) 20%, rgba(108, 117, 125, 0.04) 50.5%, rgba(108, 117, 125, 0.08) 75%, rgba(108, 117, 125, 0.12) 100%);
  }
  .atlas-table-row-fade.hide {
    visibility: hidden !important;
    opacity: 0;
  }
}`;

// src/components/table/atlas-table-row/atlas-table-row.ts
var AtlasTableRow = /*#__PURE__*/(() => {
  let AtlasTableRow = class extends WithVisibilityIconMixin(AtlasElement) {
    constructor() {
      super(...arguments);
      this.theme = "primary";
      this.hasActions = false;
      this.selectable = false;
      this.selected = false;
      this.selectionDisabled = false;
      this.selectionName = "";
      this.selectionType = "multiple";
      this._showLeftFade = false;
      this._showRightFade = false;
      this._deviceController = new DeviceController(this);
    }
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.setPropsOnButtonGroup = this.setPropsOnButtonGroup.bind(this);
      this.onActionClick = this.onActionClick.bind(this);
      this.updateHotspotPosition = this.updateHotspotPosition.bind(this);
      this._deviceController.setScreenChangeCallback(this.setPropsOnButtonGroup);
      this.addEventListener("atlas-button-group-button-click", this.onActionClick);
    }
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      this.removeEventListener("atlas-button-group-button-click", this.onActionClick);
    }
    selectionDisabledChanged() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        emit(this, "atlas-table-row-selection-disabled-change", {
          detail: {
            selectionDisabled: this.selectionDisabled
          },
          trackDisable: true
        });
      });
    }
    toggleLeftFade(forceState) {
      this._showLeftFade = typeof forceState === "boolean" ? forceState : !this._showLeftFade;
    }
    toggleRightFade(forceState) {
      this._showRightFade = typeof forceState === "boolean" ? forceState : !this._showRightFade;
    }
    toggleSelection(selected) {
      if (this.selectionDisabled) return;
      this.selected = selected;
    }
    getSlottedCols() {
      return __async(this, null, function* () {
        var _a;
        return ((_a = yield this._defaultSlot) == null ? void 0 : _a.assignedElements({
          flatten: true
        }).filter(element => element.tagName === "ATLAS-TABLE-COL")) || [];
      });
    }
    getSlottedButtonGroup() {
      return __async(this, null, function* () {
        var _a;
        return (_a = yield this._actionsSlot) == null ? void 0 : _a.assignedElements()[0];
      });
    }
    getSlottedHotspot() {
      return __async(this, null, function* () {
        var _a;
        return (_a = yield this._hotspotSlot) == null ? void 0 : _a.assignedElements()[0];
      });
    }
    adjustRowFade(tableWrapperTop) {
      if (this._deviceController.isMobile) return;
      const rowElement = this.shadowRoot.querySelector(".atlas-table-row");
      const rowRect = rowElement.getBoundingClientRect();
      const fadeList = this.shadowRoot.querySelectorAll(".atlas-table-row-fade");
      fadeList.forEach(fade => {
        fade.style.height = `${rowRect.height}px`;
        fade.style.top = `${rowRect.top - tableWrapperTop}px`;
      });
    }
    onClickSelectionColumn() {
      if (this.selectionDisabled) return;
      if (this.selectionType === "single" && this.selected) return;
      setTimeout(() => {
        this.selected = !this.selected;
        emit(this, "atlas-table-row-select", {
          trackDisable: true
        });
      }, 0);
    }
    onActionClick(event) {
      const actionClickEvent = emit(this, "atlas-table-action-click", {
        detail: __spreadValues({
          row: this
        }, event.detail)
      });
      if (actionClickEvent.defaultPrevented) event.preventDefault();
    }
    onSingleSelectionControlUncheck() {
      this.toggleSelection(false);
    }
    updateHotspotPosition() {
      this.getSlottedHotspot().then(hotspot => {
        computePosition4(this.shadowRoot.querySelector(".atlas-table-row"), hotspot, {
          placement: "top-end",
          strategy: "fixed",
          middleware: [offset5({
            mainAxis: -20,
            crossAxis: 20
          })]
        }).then(({
          x,
          y
        }) => {
          Object.assign(hotspot.style, {
            left: `${x}px`,
            top: `${y}px`
          });
        });
      });
    }
    registerFloatingHotspot() {
      return __async(this, null, function* () {
        var _a;
        yield this.updateComplete;
        const hotspot = yield this.getSlottedHotspot();
        if (!hotspot) {
          (_a = this._floatingUiCleanup) == null ? void 0 : _a.call(this);
          return;
        }
        this._floatingUiCleanup = autoUpdate4(this.shadowRoot.querySelector(".atlas-table-row"), hotspot, this.updateHotspotPosition);
      });
    }
    setPropsOnButtonGroup() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const slottedButtonGroup = yield this.getSlottedButtonGroup();
        if (!slottedButtonGroup) return;
        slottedButtonGroup.setAttribute("more-button-type", "icon");
        slottedButtonGroup.setAttribute("more-button-theme", this.theme);
        slottedButtonGroup.setAttribute("more-button-size", this._deviceController.isMobile ? "3x" : "2x");
        slottedButtonGroup.setAttribute("gap", "1");
      });
    }
    renderSingleSelectionControl() {
      return html108`
            <atlas-radio
                value=${this.id}
                ?checked=${this.selected}
                name=${this.selectionName}
                ?disabled=${this.selectionDisabled}
                tooltip-disabled-reason=${this.selectionDisabledReason}
                @atlas-radio-uncheck=${this.onSingleSelectionControlUncheck}
            ></atlas-radio>
        `;
    }
    renderMultipleSelectionControl() {
      return html108`
            <atlas-checkbox
                value=${this.id}
                ?checked=${this.selected}
                name=${this.selectionName}
                ?disabled=${this.selectionDisabled}
                tooltip-disabled-reason=${this.selectionDisabledReason}
            ></atlas-checkbox>
        `;
    }
    renderSelectionColumn() {
      if (!this.selectable) return nothing7;
      return html108`
            <atlas-table-col
                is-selection-column
                ?is-selection-disabled=${this.selectionDisabled}
                @atlas-table-col-click=${this.onClickSelectionColumn}
            >
                ${when74(this.selectionType === "single", () => this.renderSingleSelectionControl(), () => this.renderMultipleSelectionControl())}
            </atlas-table-col>
        `;
    }
    renderActionsColumn() {
      return when74(this.hasActions, () => html108`
                <atlas-table-col is-action-column>
                    <slot name="actions" @slotchange=${this.setPropsOnButtonGroup}></slot>
                </atlas-table-col>
            `);
    }
    renderVisibilityIconColumn() {
      const visibilityIconSize = this._deviceController.isMobile ? "3x" : "2x";
      return when74(this.hasVisibilityIcon, () => html108`
                <atlas-table-col
                    has-visibility-icon
                    ?is-data-visible=${this.isDataVisible}
                    visibility-icon-size="${visibilityIconSize}"
                ></atlas-table-col>
            `);
    }
    renderFade(side) {
      const fadeClass = {
        "atlas-table-row-fade": true,
        [`${side}`]: true,
        "hide": side === "left" ? !this._showLeftFade : !this._showRightFade
      };
      return when74(!this._deviceController.isMobile, () => html108`<div class=${classMap75(fadeClass)}></div>`);
    }
    render() {
      const rowClass = {
        "atlas-table-row": true,
        "selected": this.selected,
        "selectable": this.selectable,
        "has-actions": this.hasActions,
        "has-visibility-icon": this.hasVisibilityIcon,
        "has-link": this.href,
        [`theme-${this.theme}`]: !!this.theme
      };
      return html108`
            ${this.renderFade("left")}
            <a class=${classMap75(rowClass)} href=${ifDefined22(this.href)}>
                ${this.renderSelectionColumn()}
                <slot></slot>
                <div class="floating-mobile-actions">
                    ${this.renderActionsColumn()} ${this.renderVisibilityIconColumn()}
                </div>
                <slot name="hotspot" @slotchange=${this.registerFloatingHotspot}></slot>
            </a>
            ${this.renderFade("right")}
        `;
    }
  };
  AtlasTableRow.styles = atlas_table_row_default;
  return AtlasTableRow;
})();
__decorateClass([property115({
  type: String
})], AtlasTableRow.prototype, "theme", 2);
__decorateClass([property115({
  type: String
})], AtlasTableRow.prototype, "href", 2);
__decorateClass([property115({
  type: Boolean,
  attribute: "has-actions"
})], AtlasTableRow.prototype, "hasActions", 2);
__decorateClass([property115({
  type: Boolean
})], AtlasTableRow.prototype, "selectable", 2);
__decorateClass([property115({
  type: Boolean
})], AtlasTableRow.prototype, "selected", 2);
__decorateClass([property115({
  type: Boolean,
  attribute: "selection-disabled",
  reflect: true
})], AtlasTableRow.prototype, "selectionDisabled", 2);
__decorateClass([property115({
  type: String,
  attribute: "selection-disabled-reason"
})], AtlasTableRow.prototype, "selectionDisabledReason", 2);
__decorateClass([property115({
  type: String,
  attribute: "selection-name"
})], AtlasTableRow.prototype, "selectionName", 2);
__decorateClass([property115({
  type: String,
  attribute: "selection-type"
})], AtlasTableRow.prototype, "selectionType", 2);
__decorateClass([state59()], AtlasTableRow.prototype, "_showLeftFade", 2);
__decorateClass([state59()], AtlasTableRow.prototype, "_showRightFade", 2);
__decorateClass([queryAsync4("slot:not([name])")], AtlasTableRow.prototype, "_defaultSlot", 2);
__decorateClass([queryAsync4("slot[name=actions]")], AtlasTableRow.prototype, "_actionsSlot", 2);
__decorateClass([queryAsync4("slot[name=hotspot]")], AtlasTableRow.prototype, "_hotspotSlot", 2);
__decorateClass([Watch("selectionDisabled")], AtlasTableRow.prototype, "selectionDisabledChanged", 1);
AtlasTableRow = __decorateClass([customElement107("atlas-table-row")], AtlasTableRow);

// src/components/table/atlas-table/atlas-table.ts
import { html as html109 } from "lit";
import { customElement as customElement108, property as property116, query as query22, state as state60 } from "lit/decorators.js";
import { classMap as classMap76 } from "lit/directives/class-map.js";

// src/components/table/atlas-table/atlas-table.scss
import { css as css96 } from "lit-element/lit-element.js";
var atlas_table_default = css96`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.table-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.table-scroll {
  width: 100%;
}

.atlas-table {
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.atlas-table .table-header {
  display: none;
}
.atlas-table .table-body {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

@media screen and (min-width: 992px) {
  .table-wrapper {
    gap: 1rem;
    position: relative;
  }
  .table-scroll {
    overflow-x: auto;
    padding: 0 0.25rem;
    margin-left: -0.25rem;
    margin-right: -0.25rem;
    box-sizing: border-box;
  }
  .atlas-table {
    display: table;
    border-collapse: separate;
    border-spacing: 0 0.125rem;
    table-layout: auto;
  }
  .atlas-table .table-header {
    display: table-header-group;
  }
  .atlas-table .table-body {
    display: table-row-group;
  }
}`;

// src/components/table/atlas-table/atlas-table.ts
var AtlasTable = /*#__PURE__*/(() => {
  let AtlasTable = class extends AtlasElement {
    constructor() {
      super();
      this.selectable = false;
      this.hasActions = false;
      this.selectionType = "multiple";
      this.selectionName = "";
      this._hasFooter = false;
      this._deviceController = new DeviceController(this);
      this._tableWrapperHeight = null;
      this._hasScroll = null;
      this._selectedRows = /* @__PURE__ */new Set();
      this.adjustRowFadePosition = this.adjustRowFadePosition.bind(this);
      this.adjustRowFadeVisibility = this.adjustRowFadeVisibility.bind(this);
      this.onTableWrapperResize = this.onTableWrapperResize.bind(this);
      this.onTableScrollResize = this.onTableScrollResize.bind(this);
      this.applyColumnPropsFromSync = this.applyColumnPropsFromSync.bind(this);
      this.onSelectAll = this.onSelectAll.bind(this);
      this.onTableRowSelectionDisabledChange = this.onTableRowSelectionDisabledChange.bind(this);
      this.onTableBodySlotChange = this.onTableBodySlotChange.bind(this);
    }
    /** @internal */
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.addEventListener("atlas-table-header-sync-cols", this.applyColumnPropsFromSync);
      this.addEventListener("atlas-table-select-all", this.onSelectAll);
      this.addEventListener("atlas-table-row-select", this.onSelectRow);
      this.addEventListener("atlas-table-row-selection-disabled-change", this.onTableRowSelectionDisabledChange);
      this.addEventListener("atlas-table-body-slot-change", this.onTableBodySlotChange);
      this._deviceController.setScreenChangeCallback(this.adjustRowFadeVisibility);
      this._tableWrapperResizeObserver = new ResizeObserver(this.onTableWrapperResize);
      this._tableScrollResizeObserver = new ResizeObserver(this.onTableScrollResize);
      this.updateComplete.then(() => {
        this._tableWrapperResizeObserver.observe(this._tableWrapper);
        this._tableScrollResizeObserver.observe(this._tableScroll);
      });
    }
    /** @internal */
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      this.removeEventListener("atlas-table-header-sync-cols", this.applyColumnPropsFromSync);
      this.removeEventListener("atlas-table-select-all", this.onSelectAll);
      this.removeEventListener("atlas-table-row-select", this.onSelectRow);
      this.removeEventListener("atlas-table-row-selection-disabled-change", this.onTableRowSelectionDisabledChange);
      this.removeEventListener("atlas-table-body-slot-change", this.onTableBodySlotChange);
      this._tableWrapperResizeObserver.disconnect();
      this._tableScrollResizeObserver.disconnect();
    }
    /**
     * Retorna as linhas selecionadas da tabela.
     * @returns Um array com as linhas selecionadas da tabela.
     */
    getSelectedRows() {
      return Array.from(this._selectedRows);
    }
    getSlottedHeader() {
      var _a;
      const headerSlot = this.shadowRoot.querySelector("slot[name=header]");
      const slottedElements = (_a = headerSlot == null ? void 0 : headerSlot.assignedElements()) != null ? _a : [];
      return slottedElements[0] || null;
    }
    getSlottedBody() {
      var _a;
      const bodySlot = this.shadowRoot.querySelector("slot[name=body]");
      const slottedElements = (_a = bodySlot == null ? void 0 : bodySlot.assignedElements()) != null ? _a : [];
      return slottedElements[0] || null;
    }
    onSlotChangeFooter() {
      const footerSlot = this.shadowRoot.querySelector("slot[name=footer]");
      const footerContent = footerSlot.assignedElements();
      this._hasFooter = footerContent.length > 0;
    }
    onTableWrapperResize(entries) {
      entries.forEach(entry => {
        const tableWrapperNewHeight = entry.contentRect.height;
        if (this._tableWrapperHeight === tableWrapperNewHeight) return;
        this._tableWrapperHeight = tableWrapperNewHeight;
        this.adjustRowFadePosition();
      });
    }
    onTableScrollResize(entries) {
      entries.forEach(entry => {
        const entryHasScroll = entry.target.scrollWidth > entry.target.clientWidth;
        if (this._hasScroll === entryHasScroll) return;
        this._hasScroll = entryHasScroll;
        this.adjustRowFadeVisibility();
      });
    }
    onTableRowSelectionDisabledChange(event) {
      return __async(this, null, function* () {
        var _a, _b;
        const {
          selectionDisabled
        } = event.detail;
        const tableHeader = this.getSlottedHeader();
        if (!selectionDisabled) {
          tableHeader == null ? void 0 : tableHeader.toggleAttribute("selection-disabled", false);
          return;
        }
        const slottedRows = (_b = yield (_a = this.getSlottedBody()) == null ? void 0 : _a.getSlottedRows()) != null ? _b : [];
        const isAllSlottedRowsSelectionDisabled = slottedRows.every(row => row.selectionDisabled);
        tableHeader == null ? void 0 : tableHeader.toggleAttribute("selection-disabled", isAllSlottedRowsSelectionDisabled);
      });
    }
    onTableBodySlotChange(event) {
      var _a;
      const slottedRows = event.detail.rows;
      const selectedRows = slottedRows.filter(row => row.selected);
      this._selectedRows = new Set(selectedRows);
      const isAllSelected = slottedRows.length === selectedRows.length;
      (_a = this.getSlottedHeader()) == null ? void 0 : _a.toggleAttribute("all-selected", isAllSelected);
    }
    applyPropsInSlots() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const tableHeader = this.getSlottedHeader();
        const tableBody = this.getSlottedBody();
        tableHeader == null ? void 0 : tableHeader.toggleAttribute("selectable", this.selectable);
        tableHeader == null ? void 0 : tableHeader.toggleAttribute("has-actions", this.hasActions);
        tableHeader == null ? void 0 : tableHeader.setAttribute("selection-name", this.selectionName);
        tableHeader == null ? void 0 : tableHeader.setAttribute("selection-type", this.selectionType);
        tableBody == null ? void 0 : tableBody.toggleAttribute("selectable", this.selectable);
        tableBody == null ? void 0 : tableBody.toggleAttribute("has-actions", this.hasActions);
        tableBody == null ? void 0 : tableBody.setAttribute("selection-name", this.selectionName);
        tableBody == null ? void 0 : tableBody.setAttribute("selection-type", this.selectionType);
      });
    }
    applyColumnPropsFromSync(event) {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const tableBody = this.getSlottedBody();
        const colsProps = event.detail;
        tableBody.applyPropsFromHeader(colsProps);
      });
    }
    getTableScrollMarginX(side) {
      const marginStyleKey = side === "left" ? "marginLeft" : "marginRight";
      const margin = getComputedStyle(this._tableScroll)[marginStyleKey];
      return -1 * parseFloat(margin.toString().replace("px", ""));
    }
    adjustRowFadeVisibility() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        if (this.skeletonLoading || this._deviceController.isMobile) return;
        const tableBody = this.getSlottedBody();
        const tableRows = yield tableBody == null ? void 0 : tableBody.getSlottedRows();
        if (tableRows.length === 0) return;
        const {
          scrollLeft,
          clientWidth,
          scrollWidth
        } = this._tableScroll;
        const marginLeft = this.getTableScrollMarginX("left");
        const marginRight = this.getTableScrollMarginX("right");
        tableRows.forEach(tableRow => {
          tableRow.toggleLeftFade(scrollLeft > marginLeft);
          tableRow.toggleRightFade(scrollLeft + clientWidth < scrollWidth - marginRight);
        });
      });
    }
    adjustRowFadePosition() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        if (this.skeletonLoading || this._deviceController.isMobile) return;
        const tableBody = this.getSlottedBody();
        const tableRows = yield tableBody == null ? void 0 : tableBody.getSlottedRows();
        tableRows.forEach(tableRow => {
          tableRow.adjustRowFade(this._tableWrapper.getBoundingClientRect().top);
        });
      });
    }
    onSelectAll(event) {
      return __async(this, null, function* () {
        const tableBody = this.getSlottedBody();
        const allSelected = event.detail;
        const slottedRows = yield tableBody.getSlottedRows();
        slottedRows.forEach(row => {
          row.toggleSelection(allSelected);
        });
        if (allSelected) {
          this._selectedRows = new Set(slottedRows);
        } else {
          this._selectedRows.clear();
        }
      });
    }
    onSelectRow(event) {
      return __async(this, null, function* () {
        const tableRow = event.target;
        if (tableRow.selected) {
          if (this.selectionType === "single") this._selectedRows.clear();
          this._selectedRows.add(tableRow);
        } else {
          this._selectedRows.delete(tableRow);
        }
        const tableBody = this.getSlottedBody();
        const allSelected = (yield tableBody.getSlottedRows()).every(row => row.selected);
        this.getSlottedHeader().allSelected = allSelected;
      });
    }
    render() {
      const tableClass = {
        "atlas-table": true,
        "has-footer": this._hasFooter
      };
      return html109`
            <div class="table-wrapper">
                <div class="table-scroll" @scroll=${this.adjustRowFadeVisibility}>
                    <div class=${classMap76(tableClass)}>
                        <div class="table-header">
                            <slot name="header"></slot>
                        </div>
                        <div class="table-body">
                            <slot name="body"></slot>
                        </div>
                    </div>
                </div>
                <slot name="footer" @slotchange=${this.onSlotChangeFooter}></slot>
            </div>
        `;
    }
  };
  AtlasTable.styles = atlas_table_default;
  return AtlasTable;
})();
__decorateClass([property116({
  type: Boolean
})], AtlasTable.prototype, "selectable", 2);
__decorateClass([property116({
  type: Boolean,
  attribute: "has-actions"
})], AtlasTable.prototype, "hasActions", 2);
__decorateClass([property116({
  type: String,
  attribute: "selection-type"
})], AtlasTable.prototype, "selectionType", 2);
__decorateClass([property116({
  type: String,
  attribute: "selection-name"
})], AtlasTable.prototype, "selectionName", 2);
__decorateClass([state60()], AtlasTable.prototype, "_hasFooter", 2);
__decorateClass([query22(".table-wrapper")], AtlasTable.prototype, "_tableWrapper", 2);
__decorateClass([query22(".table-scroll")], AtlasTable.prototype, "_tableScroll", 2);
__decorateClass([Watch(["selectable", "hasActions", "selectionName", "selectionType"])], AtlasTable.prototype, "applyPropsInSlots", 1);
AtlasTable = __decorateClass([customElement108("atlas-table")], AtlasTable);

// src/components/form/atlas-uploader/atlas-uploader.ts
var AtlasUploader = /*#__PURE__*/(() => {
  let AtlasUploader = class extends WithTooltipMixin(FormControl) {
    constructor() {
      super(...arguments);
      this.maxFileSize = 20;
      this.warningMaxFilesExceeded = "Quantidade m\xE1xima de arquivos atingida";
      this.previewActions = [];
      this.filesListActions = [];
      this.uploadMessage = "Adicione ou arraste os arquivos aqui";
      this.loadingMessage = "Carregando...";
      this._isDragOver = false;
      this._addedFiles = [];
      this._uploadedFiles = [];
      this._uploadingFiles = [];
      this._uploadedCount = 0;
      this._parallelUploadFiles = 4;
    }
    /** @internal */
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.onDropzoneDragOver = this.onDropzoneDragOver.bind(this);
      this.onDropzoneDragOut = this.onDropzoneDragOut.bind(this);
      this.onUploadAddedFile = this.onUploadAddedFile.bind(this);
      this.onUploadRemovedFile = this.onUploadRemovedFile.bind(this);
      this.onUploadThumbnail = this.onUploadThumbnail.bind(this);
      this.onUploadProgress = this.onUploadProgress.bind(this);
      this.onUploadError = this.onUploadError.bind(this);
      this.onUploadSuccess = this.onUploadSuccess.bind(this);
      this.onUploadComplete = this.onUploadComplete.bind(this);
      this.onUploadQueueComplete = this.onUploadQueueComplete.bind(this);
      this.updateComplete.then(() => {
        this.addValidator(new UploaderValidator());
        this.updateDroppableReference();
        this.createDropzoneInstance();
      });
    }
    /** @internal */
    disconnectedCallback() {
      var _a, _b;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      if (this.droppableAreaSelector) {
        (_b = this._droppableReference.querySelector(".atlas-droppable-area")) == null ? void 0 : _b.remove();
      }
    }
    /**
     * Indica se possui ou não arquivos na fila de upload.
     * @returns {boolean} True caso existem arquivos na fila, ou false caso não existam
     */
    isUploadingFiles() {
      return this._uploadingFiles.length > 0;
    }
    /**
     * Retorna a instância da dropzone.
     * @returns {DropzoneExtended} Retorna a instância de um DropzoneExtended
     */
    getDropzoneInstance() {
      return this._dropzone;
    }
    /**
     * Se o uploader recebeu uma URL, retorna os arquivos os quais já foi feito o upload.
     * Caso contrário, retorna os arquivos adicionados.
     * @returns {UploaderFile[] | DropzoneFileExt[]} Lista de arquivos enviados
     */
    getElementValue() {
      return this.url ? this._uploadedFiles : this._addedFiles;
    }
    /**
     * Retorna os tipos de arquivos ou extensões permitidas.
     * @returns {string} Os tipos de arquivos ou extensões permitidas.
     */
    getAcceptedExtensions() {
      const filesByType = {
        images: ".jpg, .jpeg, .gif, .png",
        docs: ".pdf, .doc, .docx",
        pdf: ".pdf",
        imagesOrPdf: ".jpg, .jpeg, .gif, .png, .pdf",
        all: "*"
      }[this.acceptedFiles];
      return filesByType || this.acceptedFiles;
    }
    /**
     * Pesquisa e retorna um arquivo pelo seu UUID. Se não encontrar, retorna `undefined`.
     * @param {string} uuid - UUID do arquivo que se quer obter.
     * @returns {DropzoneFileExt | undefined} Um arquivo da lista de arquivos adicionados ou `undefined`.
     */
    getFileByUUID(uuid) {
      return this._addedFiles.find(addedFile => addedFile.upload.uuid === uuid);
    }
    /**
     * Retorna os arquivos adicionados.
     * @returns {DropzoneFileExt[]} Lista de arquivos adicionados
     */
    getAllFiles() {
      return this._addedFiles;
    }
    /**
     * Remove um arquivo tanto dos uploads, quanto dos adicionados.
     * @param {string} fileUUID - UUID do arquivo que se quer remover
     */
    removeFile(fileUUID) {
      const file = this.getFileByUUID(fileUUID);
      this._addedFiles = this._addedFiles.filter(addedFile => addedFile.upload.uuid !== fileUUID);
      this._uploadedFiles = this._uploadedFiles.filter(uploadedFile => uploadedFile.uuid !== fileUUID);
      this.updateValue();
      if (file) {
        this.getDropzoneInstance().removeFile(file);
      }
    }
    /** Remove todos os arquivos tanto dos uploads, quanto dos adicionados. */
    clear() {
      return __async(this, null, function* () {
        var _a;
        yield this.updateComplete;
        this._addedFiles = [];
        this._uploadedFiles = [];
        this.updateValue();
        (_a = this.getDropzoneInstance()) == null ? void 0 : _a.removeAllFiles(true);
      });
    }
    /**
     * Baixa um arquivo específico pelo UUID.
     * @param {string} fileUUID - UUID do arquivo que se quer baixar
     */
    downloadFile(fileUUID) {
      const file = this.getFileByUUID(fileUUID);
      downloadBlob(file, file.name);
    }
    /**
     * Retorna a URL de preview de um arquivo pelo UUID.
     * @param {string} fileUUID - UUID do arquivo que se quer pegar a URL de preview
     * @returns {string | undefined} URL de preview do arquivo desejado
     */
    getPreviewURL(fileUUID) {
      var _a;
      return (_a = this.getFileByUUID(fileUUID)) == null ? void 0 : _a.dataURL;
    }
    onUpdateDisabled() {
      return __async(this, null, function* () {
        var _a, _b;
        yield this.updateComplete;
        if (this.disabled) {
          (_a = this.getDropzoneInstance()) == null ? void 0 : _a.disable();
        } else {
          (_b = this.getDropzoneInstance()) == null ? void 0 : _b.enable();
        }
      });
    }
    updateValue() {
      const values = this._uploadedFiles.map(uploadedFile => uploadedFile.tempFileId || uploadedFile.uuid);
      this.value = values.length === 0 ? "" : values.toString();
    }
    updateAddedFile(file) {
      this._addedFiles = this._addedFiles.map(addedFile => {
        if (addedFile.upload.uuid !== file.upload.uuid) {
          return addedFile;
        }
        return file;
      });
    }
    getUploaderIconTheme() {
      if (this.disabled) return "secondary";
      return this.getStatusTheme() || "primary";
    }
    updateDroppableReference() {
      return __async(this, null, function* () {
        if (!this.droppableAreaSelector) {
          this._droppableReference = yield this._uploaderReference;
          return;
        }
        this._droppableReference = document.querySelector(`${this.droppableAreaSelector}`);
        this._droppableReference.classList.add("atlas-uploader-expanded-drop");
        const droppableElement = document.createElement("div");
        droppableElement.classList.add("atlas-droppable-area");
        droppableElement.innerHTML = '<atlas-text size="lg" theme="primary">Solte os arquivos aqui</atlas-text>';
        this._droppableReference.appendChild(droppableElement);
      });
    }
    createDropzoneInstance() {
      return __async(this, null, function* () {
        const uploaderRef = yield this._uploaderReference;
        const uploaderWrapper = yield this._uploaderWrapper;
        this._dropzone = new DropzoneExtended(this._droppableReference, {
          url: this.url,
          paramName: this.name,
          acceptedFiles: this.getAcceptedExtensions(),
          parallelUploads: this._parallelUploadFiles,
          maxFiles: this.maxFiles ? this.maxFiles : null,
          maxFilesize: this.maxFileSize,
          maxThumbnailFilesize: this.maxFileSize,
          // @ts-expect-error
          disablePreviews: true,
          dictUploadCanceled: "Envio cancelado.",
          dictMaxFilesExceeded: this.warningMaxFilesExceeded,
          dictInvalidFileType: "Formato de arquivo n\xE3o permitido.",
          dictFileTooBig: "Tamanho de arquivo(s) ultrapassa o permitido.",
          hiddenInputContainer: uploaderWrapper,
          clickable: uploaderRef
        });
        this._dropzone.on("drop", this.onDropzoneDragOut);
        this._dropzone.on("dragend", this.onDropzoneDragOut);
        this._dropzone.on("dragleave", this.onDropzoneDragOut);
        this._dropzone.on("dragenter", this.onDropzoneDragOver);
        this._dropzone.on("dragover", this.onDropzoneDragOver);
        this._dropzone.on("addedfile", this.onUploadAddedFile);
        this._dropzone.on("removedfile", this.onUploadRemovedFile);
        this._dropzone.on("thumbnail", this.onUploadThumbnail);
        this._dropzone.on("uploadprogress", this.onUploadProgress);
        this._dropzone.on("error", this.onUploadError);
        this._dropzone.on("success", this.onUploadSuccess);
        this._dropzone.on("complete", this.onUploadComplete);
        this._dropzone.on("queuecomplete", this.onUploadQueueComplete);
        if (this.disabled) {
          this._dropzone.disable();
        }
      });
    }
    onDropzoneDragOver() {
      this._isDragOver = true;
    }
    onDropzoneDragOut() {
      this._isDragOver = false;
    }
    onUploadAddedFile(file) {
      this._addedFiles = [...this._addedFiles, file];
      this._uploadingFiles.push(file.upload.uuid);
      if (!file.alreadyUploaded) {
        emit(this, "atlas-uploader-addedfile", {
          detail: {
            file
          }
        });
      }
    }
    onUploadRemovedFile(file) {
      this._uploadingFiles = this._uploadingFiles.filter(uuid => uuid !== file.upload.uuid);
      emit(this, "atlas-uploader-removedfile", {
        detail: {
          file
        }
      });
    }
    onUploadThumbnail(file) {
      this.updateAddedFile(file);
    }
    onUploadProgress(file) {
      this.updateAddedFile(file);
      if (!file.alreadyUploaded) {
        emit(this, "atlas-uploader-progress", {
          detail: {
            file
          }
        });
      }
    }
    onUploadError(file, error) {
      const message = error instanceof Error ? error.message : error;
      if (typeof message === "string") {
        if (/<\/?[a-z][\s\S]*>/i.test(message)) {
          const responseHTML = new DOMParser().parseFromString(message, "text/html");
          showAlert(responseHTML.body.textContent, "warning");
        } else {
          showAlert(message, "warning");
        }
      } else {
        showAlert(message == null ? void 0 : message.text, "warning");
      }
      this.removeFile(file.upload.uuid);
      if (!file.alreadyUploaded) {
        emit(this, "atlas-uploader-error", {
          detail: {
            file,
            error
          }
        });
      }
    }
    onUploadSuccess(file, response) {
      if (!response.success) {
        this.onUploadError(file, response.message);
        return;
      }
      const {
        tempFileId,
        tempFileName
      } = response;
      this._uploadedFiles = [...this._uploadedFiles, {
        uuid: file.upload.uuid,
        name: file.name,
        type: file.type,
        size: file.size,
        tempFileId,
        tempFileName
      }];
      this._uploadingFiles = this._uploadingFiles.filter(uuid => uuid !== file.upload.uuid);
      this.updateValue();
      if (!file.alreadyUploaded) {
        emit(this, "atlas-uploader-success", {
          detail: {
            file,
            response
          }
        });
      }
    }
    onUploadComplete(file) {
      this.updateAddedFile(file);
      this._uploadedCount += 1;
      if (!file.alreadyUploaded) {
        emit(this, "atlas-uploader-complete", {
          detail: {
            file
          }
        });
      }
    }
    onUploadQueueComplete() {
      this._uploadingFiles = [];
      this._uploadedCount = 0;
      this.checkValidity();
      emit(this, "atlas-uploader-queue-complete");
    }
    onUploadLinkClick(event) {
      if (event instanceof PointerEvent || event.code === "Space") {
        this.getDropzoneInstance().element.click();
      }
    }
    onCancelLinkClick(event) {
      if (event instanceof PointerEvent || event.code === "Space") {
        this.getDropzoneInstance().cancelAllUploads();
      }
    }
    onPreviewButtonClick(event) {
      const {
        button
      } = event.detail;
      const target = event.target;
      const file = this.getFileByUUID(target.dataset.fileUuid);
      const clickEvent = emit(this, "atlas-uploader-preview-button-click", {
        detail: {
          button,
          file
        }
      });
      if (clickEvent.defaultPrevented) return;
      if (button === "delete") {
        this.removeFile(file.upload.uuid);
      } else if (button === "download") {
        this.downloadFile(file.upload.uuid);
      }
    }
    onFilesSlotChange() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const slot = this.shadowRoot.querySelector("slot");
        const slottedFiles = slot.assignedElements().filter(element => element.tagName === "ATLAS-UPLOADER-FILE");
        for (const uploaderFile of slottedFiles) {
          const fileObject = yield uploaderFile.getFileObject();
          fileObject.alreadyUploaded = true;
          fileObject.dataset = uploaderFile.dataset;
          fileObject.badgeText = uploaderFile.badgeText;
          fileObject.badgeIcon = uploaderFile.badgeIcon;
          fileObject.badgeTheme = uploaderFile.badgeTheme;
          this.getDropzoneInstance().addFile(fileObject);
        }
      });
    }
    onFileActionButtonClick(event) {
      const {
        button
      } = event.detail;
      const file = this.getFileByUUID(button.dataset.fileUuid);
      const actionName = button.dataset.action;
      const clickEvent = emit(this, "atlas-uploader-file-action-button-click", {
        detail: {
          button,
          file
        },
        trackDisable: true
      });
      if (clickEvent.defaultPrevented) return;
      if (actionName === "delete") {
        this.removeFile(file.upload.uuid);
      } else if (actionName === "download") {
        this.downloadFile(file.upload.uuid);
      }
    }
    onMouseOver() {
      if (!this.disabled || !this.tooltipDisabledReason) return;
      const tooltip = this.shadowRoot.querySelector("atlas-tooltip");
      tooltip.show();
    }
    onMouseLeave() {
      if (!this.disabled || !this.tooltipDisabledReason) return;
      const tooltip = this.shadowRoot.querySelector("atlas-tooltip");
      tooltip.hide();
    }
    renderFileActions(file) {
      const defaultActions = [{
        name: "download",
        label: "Baixar",
        icon: "download"
      }, {
        name: "delete",
        label: "Excluir",
        icon: "trash",
        theme: "danger"
      }];
      const actions = this.filesListActions.length > 0 ? this.filesListActions : defaultActions;
      return html110`
            <atlas-button-group
                slot="actions"
                group-all
                @atlas-button-group-button-click=${this.onFileActionButtonClick}
            >
                ${actions.map(action => {
        var _a;
        return html110`
                        <atlas-icon-button
                            name=${action.name}
                            description=${action.label}
                            icon=${action.icon}
                            theme=${action.theme}
                            tooltip=${action.label}
                            ?disabled=${action.disabled}
                            data-file-uuid=${(_a = file.upload) == null ? void 0 : _a.uuid}
                            data-action=${action.name}
                        ></atlas-icon-button>
                    `;
      })}
            </atlas-button-group>
        `;
    }
    renderFileRow(file) {
      return html110`
            <atlas-table-row data-file-uuid=${file.upload.uuid}>
                <atlas-table-col column-label="Nome do arquivo">
                    <atlas-layout inline alignment="center" gap="2">
                        <atlas-icon size="2x" name="file"></atlas-icon>
                        <atlas-text>${file.name}</atlas-text>
                    </atlas-layout>
                </atlas-table-col>
                ${this.renderFileActions(file)}
            </atlas-table-row>
        `;
    }
    renderFilesList() {
      if (!this.filesList) return nothing8;
      return html110`
            <atlas-table has-actions>
                <atlas-table-header slot="header">
                    <atlas-table-col size="lg" ellipsis>Nome do arquivo</atlas-table-col>
                </atlas-table-header>
                <atlas-table-body slot="body">
                    ${this._addedFiles.map(file => this.renderFileRow(file))}
                </atlas-table-body>
            </atlas-table>
        `;
    }
    renderPreviewElements() {
      if (!this.preview) return nothing8;
      return this._addedFiles.map(file => {
        var _a, _b;
        const previewDefaultActions = [{
          name: "download",
          label: "Baixar",
          icon: "download"
        }, {
          name: "delete",
          label: "Excluir",
          icon: "trash",
          theme: "danger"
        }];
        const previewActions = this.previewActions.length > 0 ? this.previewActions : previewDefaultActions;
        return html110`
                <atlas-preview
                    image=${file.dataURL}
                    image-name=${file.name}
                    badge-icon=${file.badgeIcon}
                    badge-text=${file.badgeText}
                    badge-theme=${file.badgeTheme || "primary"}
                    ?loading=${file.status !== "success"}
                    loading-progress=${(_a = file.upload) == null ? void 0 : _a.progress}
                    .actions=${previewActions}
                    @atlas-preview-button-click=${this.onPreviewButtonClick}
                    data-file-uuid=${(_b = file.upload) == null ? void 0 : _b.uuid}
                ></atlas-preview>
            `;
      });
    }
    renderUploadLinkOrProgress() {
      if (this.disabled) {
        return html110`<span class="disabled-text">${this.uploadMessage}</span>`;
      }
      if (!this.preview && this._uploadingFiles.length > 0) {
        return html110`
                <atlas-progress-bar
                    value=${this._uploadedCount}
                    max-value=${this._uploadingFiles.length}
                    unit="integer"
                    theme=${this.getStatusTheme() || "primary"}
                    show-label
                    muted-label
                    label-prefix=${this.loadingMessage}
                >
                    <atlas-link
                        slot="action"
                        href="javascript:void(0)"
                        size="sm"
                        @keydown=${this.onCancelLinkClick}
                        @click=${this.onCancelLinkClick}
                    >
                        Cancelar
                    </atlas-link>
                </atlas-progress-bar>
            `;
      }
      return html110`
            <atlas-link
                href="javascript:void(0)"
                size="sm"
                @keydown=${this.onUploadLinkClick}
                @click=${this.onUploadLinkClick}
            >
                ${this.uploadMessage}
            </atlas-link>
        `;
    }
    renderContentOrDragging() {
      return when75(this._isDragOver && !this.droppableAreaSelector, () => html110`<atlas-text size="sm" theme="primary">Solte os arquivos aqui</atlas-text>`, () => html110`
                <atlas-icon
                    name="upload"
                    size="5x"
                    theme=${this.getUploaderIconTheme()}
                    ?disabled=${this.disabled}
                    data-atlas-tooltip="uploader-tooltip"
                ></atlas-icon>
                ${this.renderUploadLinkOrProgress()}
            `);
    }
    /* @internal */
    render() {
      const wrapperClass = {
        "uploader-wrapper": true,
        "has-preview": this.preview,
        "has-files-list": this.filesList,
        "has-files": this._addedFiles.length > 0,
        "has-max-files": this.maxFiles > 0 && this._addedFiles.length >= this.maxFiles,
        [`is-${this._status}`]: this.getShowStatus()
      };
      const uploaderClass = {
        uploader: true,
        disabled: this.disabled
      };
      return html110`
            <div class=${classMap77(wrapperClass)} @mouseover=${this.onMouseOver} @mouseleave=${this.onMouseLeave}>
                <div class=${classMap77(uploaderClass)}>
                    <div class="uploader-content">${this.renderContentOrDragging()}</div>
                </div>
                ${this.renderPreviewElements()} ${this.renderFilesList()}
            </div>
            ${this.renderStatusMessage()} ${this.renderHelperText()} ${this.renderTooltip("uploader-tooltip")}
            <slot @slotchange=${this.onFilesSlotChange}></slot>
        `;
    }
  };
  AtlasUploader.styles = atlas_uploader_default;
  return AtlasUploader;
})();
__decorateClass([property117({
  type: String
})], AtlasUploader.prototype, "url", 2);
__decorateClass([property117({
  type: Boolean
})], AtlasUploader.prototype, "preview", 2);
__decorateClass([property117({
  type: Boolean,
  attribute: "files-list"
})], AtlasUploader.prototype, "filesList", 2);
__decorateClass([property117({
  type: String,
  attribute: "accepted-files"
})], AtlasUploader.prototype, "acceptedFiles", 2);
__decorateClass([property117({
  type: Number,
  attribute: "max-files"
})], AtlasUploader.prototype, "maxFiles", 2);
__decorateClass([property117({
  type: Number,
  attribute: "max-file-size"
})], AtlasUploader.prototype, "maxFileSize", 2);
__decorateClass([property117({
  type: String,
  attribute: "warning-max-files-exceeded"
})], AtlasUploader.prototype, "warningMaxFilesExceeded", 2);
__decorateClass([property117({
  type: String,
  attribute: "droppable-area-selector"
})], AtlasUploader.prototype, "droppableAreaSelector", 2);
__decorateClass([property117({
  type: Array,
  attribute: "preview-actions"
})], AtlasUploader.prototype, "previewActions", 2);
__decorateClass([property117({
  type: Array,
  attribute: "files-list-actions"
})], AtlasUploader.prototype, "filesListActions", 2);
__decorateClass([property117({
  type: String,
  attribute: "upload-message"
})], AtlasUploader.prototype, "uploadMessage", 2);
__decorateClass([property117({
  type: String,
  attribute: "loading-message"
})], AtlasUploader.prototype, "loadingMessage", 2);
__decorateClass([state61()], AtlasUploader.prototype, "_isDragOver", 2);
__decorateClass([state61()], AtlasUploader.prototype, "_addedFiles", 2);
__decorateClass([state61()], AtlasUploader.prototype, "_uploadedFiles", 2);
__decorateClass([state61()], AtlasUploader.prototype, "_uploadingFiles", 2);
__decorateClass([state61()], AtlasUploader.prototype, "_uploadedCount", 2);
__decorateClass([queryAsync5(".uploader")], AtlasUploader.prototype, "_uploaderReference", 2);
__decorateClass([queryAsync5(".uploader-wrapper")], AtlasUploader.prototype, "_uploaderWrapper", 2);
__decorateClass([Watch("disabled")], AtlasUploader.prototype, "onUpdateDisabled", 1);
AtlasUploader = __decorateClass([customElement109("atlas-uploader")], AtlasUploader);

// src/components/form/atlas-uploader-file/atlas-uploader-file.ts
import { LitElement as LitElement27 } from "lit";
import { customElement as customElement110, property as property118 } from "lit/decorators.js";
var AtlasUploaderFile = class extends LitElement27 {
  constructor() {
    super(...arguments);
    this.badgeTheme = "primary";
  }
  getFileObject() {
    return __async(this, null, function* () {
      const fileObject = yield fetch(this.src).then(response => __async(this, null, function* () {
        const contentType = response.headers.get("content-type");
        const blob = yield response.blob();
        const file = new File([blob], this.name, {
          type: contentType
        });
        return file;
      }));
      return fileObject;
    });
  }
};
__decorateClass([property118({
  type: String
})], AtlasUploaderFile.prototype, "src", 2);
__decorateClass([property118({
  type: String
})], AtlasUploaderFile.prototype, "name", 2);
__decorateClass([property118({
  type: String,
  attribute: "badge-text"
})], AtlasUploaderFile.prototype, "badgeText", 2);
__decorateClass([property118({
  type: String,
  attribute: "badge-icon"
})], AtlasUploaderFile.prototype, "badgeIcon", 2);
__decorateClass([property118({
  type: String,
  attribute: "badge-theme"
})], AtlasUploaderFile.prototype, "badgeTheme", 2);
AtlasUploaderFile = __decorateClass([customElement110("atlas-uploader-file")], AtlasUploaderFile);

// src/components/layout/atlas-checklist/atlas-checklist.ts
import { LitElement as LitElement28, html as html111 } from "lit";
import { customElement as customElement111, property as property119 } from "lit/decorators.js";
import { classMap as classMap78 } from "lit/directives/class-map.js";

// src/components/layout/atlas-checklist/atlas-checklist.scss
import { css as css97 } from "lit-element/lit-element.js";
var atlas_checklist_default = css97`.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 0.75rem !important;
}

.gap-4 {
  gap: 1rem !important;
}

.gap-5 {
  gap: 1.25rem !important;
}

.gap-6 {
  gap: 1.5rem !important;
}

.gap-7 {
  gap: 2rem !important;
}

.gap-8 {
  gap: 2.5rem !important;
}

.gap-9 {
  gap: 3rem !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 0.75rem !important;
}

.mt-4 {
  margin-top: 1rem !important;
}

.mt-5 {
  margin-top: 1.25rem !important;
}

.mt-6 {
  margin-top: 1.5rem !important;
}

.mt-7 {
  margin-top: 2rem !important;
}

.mt-8 {
  margin-top: 2.5rem !important;
}

.mt-9 {
  margin-top: 3rem !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 0.75rem !important;
}

.mb-4 {
  margin-bottom: 1rem !important;
}

.mb-5 {
  margin-bottom: 1.25rem !important;
}

.mb-6 {
  margin-bottom: 1.5rem !important;
}

.mb-7 {
  margin-bottom: 2rem !important;
}

.mb-8 {
  margin-bottom: 2.5rem !important;
}

.mb-9 {
  margin-bottom: 3rem !important;
}

.container {
  flex: 1 1 100%;
  box-sizing: border-box;
  padding: 0.5rem 1rem 1rem;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
@media screen and (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}
@media screen and (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}
@media screen and (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}
@media screen and (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}
@media screen and (min-width: 1400px) {
  .container {
    max-width: 1320px;
  }
}

.atlas-checklist {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}`;

// src/components/layout/atlas-checklist/atlas-checklist.ts
var AtlasChecklist = /*#__PURE__*/(() => {
  let AtlasChecklist = class extends LitElement28 {
    /** 
     * @internal
     */
    render() {
      const checklistClass = {
        "atlas-checklist": true,
        [`gap-${this.gap}`]: this.gap
      };
      return html111`
            <div class="${classMap78(checklistClass)}" role="list">
                <slot></slot>
            </div>
        `;
    }
  };
  AtlasChecklist.styles = atlas_checklist_default;
  return AtlasChecklist;
})();
__decorateClass([property119({
  type: Number
})], AtlasChecklist.prototype, "gap", 2);
AtlasChecklist = __decorateClass([customElement111("atlas-checklist")], AtlasChecklist);

// src/components/layout/atlas-checklist-item/atlas-checklist-item.ts
import { LitElement as LitElement29, html as html112 } from "lit";
import { customElement as customElement112, property as property120 } from "lit/decorators.js";
import { classMap as classMap79 } from "lit/directives/class-map.js";

// src/components/layout/atlas-checklist-item/atlas-checklist-item.scss
import { css as css98 } from "lit-element/lit-element.js";
var atlas_checklist_item_default = css98`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
.atlas-checklist-item {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
.atlas-checklist-item .atlas-checklist-default-marker {
  border-radius: 50%;
  width: 0.25rem;
  height: 0.25rem;
  margin: 0.3125rem;
  padding: 0;
}
.atlas-checklist-item .atlas-checklist-default-marker.primary {
  border: 1px solid var(--atlas-primary);
  background: var(--atlas-primary);
}
.atlas-checklist-item .atlas-checklist-default-marker.secondary {
  border: 1px solid var(--atlas-secondary);
  background: var(--atlas-secondary);
}
.atlas-checklist-item .atlas-checklist-default-marker .primary {
  border: 1px solid var(--atlas-primary-500);
  background: var(--atlas-primary-500);
}
.atlas-checklist-item .atlas-checklist-default-marker .secondary {
  border: 1px solid var(--atlas-secondary-500);
  background: var(--atlas-secondary-500);
}
.atlas-checklist-item .atlas-checklist-default-marker .success {
  border: 1px solid var(--atlas-success-500);
  background: var(--atlas-success-500);
}
.atlas-checklist-item .atlas-checklist-default-marker .warning {
  border: 1px solid var(--atlas-warning-500);
  background: var(--atlas-warning-500);
}
.atlas-checklist-item .atlas-checklist-default-marker .danger {
  border: 1px solid var(--atlas-danger-500);
  background: var(--atlas-danger-500);
}
.atlas-checklist-item .atlas-checklist-default-marker .highlight {
  border: 1px solid var(--atlas-highlight-500);
  background: var(--atlas-highlight-500);
}
.atlas-checklist-item .atlas-checklist-default-marker .info {
  border: 1px solid var(--atlas-info-500);
  background: var(--atlas-info-500);
}`;

// src/components/layout/atlas-checklist-item/atlas-checklist-item.ts
var AtlasChecklistItem = /*#__PURE__*/(() => {
  let AtlasChecklistItem = class extends LitElement29 {
    constructor() {
      super(...arguments);
      this.status = "default";
    }
    getStatusInfo() {
      const statusDetails = {
        default: {
          theme: "secondary",
          icon: "circle"
        },
        success: {
          theme: "success",
          icon: "check-circle"
        },
        warning: {
          theme: "warning",
          icon: "alert-triangle"
        },
        error: {
          theme: "danger",
          icon: "x"
        },
        info: {
          theme: "info",
          icon: "info"
        }
      };
      return statusDetails[this.status] || statusDetails.default;
    }
    /**
     * @internal
     */
    render() {
      const {
        theme,
        icon
      } = this.getStatusInfo();
      const statusClass = {
        "atlas-checklist-item": true,
        [`${theme}`]: this.status
      };
      return html112`
            <div class="${classMap79(statusClass)}" role="listitem">
                <atlas-icon size="2x" theme="${theme}" name="${icon}"></atlas-icon>
                <atlas-text theme="${theme}">
                    <slot></slot>
                </atlas-text>
            </div>
        `;
    }
  };
  AtlasChecklistItem.styles = atlas_checklist_item_default;
  return AtlasChecklistItem;
})();
__decorateClass([property120({
  type: String
})], AtlasChecklistItem.prototype, "status", 2);
AtlasChecklistItem = __decorateClass([customElement112("atlas-checklist-item")], AtlasChecklistItem);

// src/components/layout/atlas-col/atlas-col.ts
import { html as html113 } from "lit";
import { customElement as customElement113, property as property121 } from "lit/decorators.js";

// src/components/layout/atlas-col/atlas-col.scss
import { css as css99 } from "lit-element/lit-element.js";
var atlas_col_default = css99`:host([sm="1"]) {
  grid-column: span 1;
}

:host([sm="2"]) {
  grid-column: span 2;
}

@media screen and (min-width: 768px) {
  :host([md="1"]) {
    grid-column: span 1;
  }
  :host([md="2"]) {
    grid-column: span 2;
  }
  :host([md="3"]) {
    grid-column: span 3;
  }
  :host([md="4"]) {
    grid-column: span 4;
  }
  :host([md="5"]) {
    grid-column: span 5;
  }
  :host([md="6"]) {
    grid-column: span 6;
  }
}
@media screen and (min-width: 992px) {
  :host([lg="1"]) {
    grid-column: span 1;
  }
  :host([lg="2"]) {
    grid-column: span 2;
  }
  :host([lg="3"]) {
    grid-column: span 3;
  }
  :host([lg="4"]) {
    grid-column: span 4;
  }
  :host([lg="5"]) {
    grid-column: span 5;
  }
  :host([lg="6"]) {
    grid-column: span 6;
  }
  :host([lg="7"]) {
    grid-column: span 7;
  }
  :host([lg="8"]) {
    grid-column: span 8;
  }
  :host([lg="9"]) {
    grid-column: span 9;
  }
  :host([lg="10"]) {
    grid-column: span 10;
  }
  :host([lg="11"]) {
    grid-column: span 11;
  }
  :host([lg="12"]) {
    grid-column: span 12;
  }
}
@media screen and (min-width: 1200px) {
  :host([xl="1"]) {
    grid-column: span 1;
  }
  :host([xl="2"]) {
    grid-column: span 2;
  }
  :host([xl="3"]) {
    grid-column: span 3;
  }
  :host([xl="4"]) {
    grid-column: span 4;
  }
  :host([xl="5"]) {
    grid-column: span 5;
  }
  :host([xl="6"]) {
    grid-column: span 6;
  }
  :host([xl="7"]) {
    grid-column: span 7;
  }
  :host([xl="8"]) {
    grid-column: span 8;
  }
  :host([xl="9"]) {
    grid-column: span 9;
  }
  :host([xl="10"]) {
    grid-column: span 10;
  }
  :host([xl="11"]) {
    grid-column: span 11;
  }
  :host([xl="12"]) {
    grid-column: span 12;
  }
}
@media screen and (min-width: 1400px) {
  :host([xxl="1"]) {
    grid-column: span 1;
  }
  :host([xxl="2"]) {
    grid-column: span 2;
  }
  :host([xxl="3"]) {
    grid-column: span 3;
  }
  :host([xxl="4"]) {
    grid-column: span 4;
  }
  :host([xxl="5"]) {
    grid-column: span 5;
  }
  :host([xxl="6"]) {
    grid-column: span 6;
  }
  :host([xxl="7"]) {
    grid-column: span 7;
  }
  :host([xxl="8"]) {
    grid-column: span 8;
  }
  :host([xxl="9"]) {
    grid-column: span 9;
  }
  :host([xxl="10"]) {
    grid-column: span 10;
  }
  :host([xxl="11"]) {
    grid-column: span 11;
  }
  :host([xxl="12"]) {
    grid-column: span 12;
  }
}`;

// src/components/layout/atlas-col/atlas-col.ts
var AtlasCol = /*#__PURE__*/(() => {
  let AtlasCol = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.sm = 2;
      this.md = 6;
      this.lg = 12;
    }
    render() {
      return html113`<slot></slot>`;
    }
  };
  AtlasCol.styles = atlas_col_default;
  return AtlasCol;
})();
__decorateClass([property121({
  type: Number,
  reflect: true
})], AtlasCol.prototype, "sm", 2);
__decorateClass([property121({
  type: Number,
  reflect: true
})], AtlasCol.prototype, "md", 2);
__decorateClass([property121({
  type: Number,
  reflect: true
})], AtlasCol.prototype, "lg", 2);
__decorateClass([property121({
  type: Number,
  reflect: true
})], AtlasCol.prototype, "xl", 2);
__decorateClass([property121({
  type: Number,
  reflect: true
})], AtlasCol.prototype, "xxl", 2);
AtlasCol = __decorateClass([customElement113("atlas-col")], AtlasCol);

// src/components/layout/atlas-divider/atlas-divider.ts
import { html as html114, LitElement as LitElement30 } from "lit";
import { customElement as customElement114, property as property122 } from "lit/decorators.js";
import { styleMap as styleMap22 } from "lit/directives/style-map.js";

// src/components/layout/atlas-divider/atlas-divider.scss
import { css as css100 } from "lit-element/lit-element.js";
var atlas_divider_default = css100`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.atlas-divider {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  border: none;
  background-color: #ced4da;
}`;

// src/components/layout/atlas-divider/atlas-divider.ts
var AtlasDivider = /*#__PURE__*/(() => {
  let AtlasDivider = class extends LitElement30 {
    constructor() {
      super(...arguments);
      this.vertical = false;
      this.mobileVertical = false;
      this.spacing = 16;
      this._deviceController = new DeviceController(this);
    }
    getIsVertical() {
      const {
        isMobile: isMobile2
      } = this._deviceController;
      return !isMobile2 && this.vertical || isMobile2 && this.mobileVertical;
    }
    /** @internal */
    render() {
      var _a;
      const thickness = this.thickness > 1 ? this.thickness : 1;
      const spacing = (_a = this.spacing) != null ? _a : 16;
      const isVertical = this.getIsVertical();
      const layoutStyle = {
        margin: isVertical ? `0 ${spacing}px` : `${spacing}px 0`,
        width: isVertical ? `${thickness}px` : "100%",
        height: isVertical ? "100%" : `${thickness}px`,
        display: isVertical ? "inline-block" : "block"
      };
      if (this.color) {
        layoutStyle["background-color"] = this.color;
      }
      return html114`<div class="atlas-divider" style=${styleMap22(layoutStyle)}></div>`;
    }
  };
  AtlasDivider.styles = atlas_divider_default;
  return AtlasDivider;
})();
__decorateClass([property122({
  type: Boolean
})], AtlasDivider.prototype, "vertical", 2);
__decorateClass([property122({
  type: Boolean,
  attribute: "mobile-vertical"
})], AtlasDivider.prototype, "mobileVertical", 2);
__decorateClass([property122({
  type: Number
})], AtlasDivider.prototype, "spacing", 2);
__decorateClass([property122({
  type: String
})], AtlasDivider.prototype, "color", 2);
__decorateClass([property122({
  type: Number
})], AtlasDivider.prototype, "thickness", 2);
AtlasDivider = __decorateClass([customElement114("atlas-divider")], AtlasDivider);

// src/components/layout/atlas-grid/atlas-grid.ts
import { html as html115 } from "lit";
import { customElement as customElement115, property as property123 } from "lit/decorators.js";
import { classMap as classMap80 } from "lit/directives/class-map.js";

// src/components/layout/atlas-grid/atlas-grid.scss
import { css as css101 } from "lit-element/lit-element.js";
var atlas_grid_default = css101`.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 0.75rem !important;
}

.gap-4 {
  gap: 1rem !important;
}

.gap-5 {
  gap: 1.25rem !important;
}

.gap-6 {
  gap: 1.5rem !important;
}

.gap-7 {
  gap: 2rem !important;
}

.gap-8 {
  gap: 2.5rem !important;
}

.gap-9 {
  gap: 3rem !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 0.75rem !important;
}

.mt-4 {
  margin-top: 1rem !important;
}

.mt-5 {
  margin-top: 1.25rem !important;
}

.mt-6 {
  margin-top: 1.5rem !important;
}

.mt-7 {
  margin-top: 2rem !important;
}

.mt-8 {
  margin-top: 2.5rem !important;
}

.mt-9 {
  margin-top: 3rem !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 0.75rem !important;
}

.mb-4 {
  margin-bottom: 1rem !important;
}

.mb-5 {
  margin-bottom: 1.25rem !important;
}

.mb-6 {
  margin-bottom: 1.5rem !important;
}

.mb-7 {
  margin-bottom: 2rem !important;
}

.mb-8 {
  margin-bottom: 2.5rem !important;
}

.mb-9 {
  margin-bottom: 3rem !important;
}

.container {
  flex: 1 1 100%;
  box-sizing: border-box;
  padding: 0.5rem 1rem 1rem;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
@media screen and (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}
@media screen and (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}
@media screen and (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}
@media screen and (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}
@media screen and (min-width: 1400px) {
  .container {
    max-width: 1320px;
  }
}

.atlas-grid {
  display: grid;
  grid-auto-rows: auto;
  grid-row-gap: var(--atlas-grid-row-gap);
}

:host {
  --atlas-grid-columns: 2;
  --atlas-grid-gutter: 0.5rem;
  --atlas-grid-row-gap: 1rem;
}

@media screen and (min-width: 768px) {
  :host {
    --atlas-grid-columns: 6;
    --atlas-grid-gutter: 1rem;
  }
}
@media screen and (min-width: 992px) {
  :host {
    --atlas-grid-columns: 12;
    --atlas-grid-gutter: 2rem;
    --atlas-grid-row-gap: 1.5rem;
  }
}
@media screen and (min-width: 1400px) {
  :host {
    --atlas-grid-columns: 12;
    --atlas-grid-gutter: 2rem;
    --atlas-grid-row-gap: 2rem;
  }
}`;

// src/components/layout/atlas-grid/atlas-grid.ts
var AtlasGrid = /*#__PURE__*/(() => {
  let AtlasGrid = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.container = false;
    }
    render() {
      const containerClasses = {
        "atlas-grid": true,
        "container": this.container
      };
      return html115`
            <div class="${classMap80(containerClasses)}">
                <slot></slot>
            </div>
        `;
    }
  };
  AtlasGrid.styles = atlas_grid_default;
  return AtlasGrid;
})();
__decorateClass([property123({
  type: Boolean
})], AtlasGrid.prototype, "container", 2);
AtlasGrid = __decorateClass([customElement115("atlas-grid")], AtlasGrid);

// src/components/layout/atlas-page/atlas-page.ts
import { html as html116 } from "lit";
import { customElement as customElement116, property as property124, state as state62 } from "lit/decorators.js";
import { classMap as classMap81 } from "lit/directives/class-map.js";
import { when as when76 } from "lit/directives/when.js";

// src/components/layout/atlas-page/atlas-page.scss
import { css as css102 } from "lit-element/lit-element.js";
var atlas_page_default = css102`.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 0.75rem !important;
}

.gap-4 {
  gap: 1rem !important;
}

.gap-5 {
  gap: 1.25rem !important;
}

.gap-6 {
  gap: 1.5rem !important;
}

.gap-7 {
  gap: 2rem !important;
}

.gap-8 {
  gap: 2.5rem !important;
}

.gap-9 {
  gap: 3rem !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 0.75rem !important;
}

.mt-4 {
  margin-top: 1rem !important;
}

.mt-5 {
  margin-top: 1.25rem !important;
}

.mt-6 {
  margin-top: 1.5rem !important;
}

.mt-7 {
  margin-top: 2rem !important;
}

.mt-8 {
  margin-top: 2.5rem !important;
}

.mt-9 {
  margin-top: 3rem !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 0.75rem !important;
}

.mb-4 {
  margin-bottom: 1rem !important;
}

.mb-5 {
  margin-bottom: 1.25rem !important;
}

.mb-6 {
  margin-bottom: 1.5rem !important;
}

.mb-7 {
  margin-bottom: 2rem !important;
}

.mb-8 {
  margin-bottom: 2.5rem !important;
}

.mb-9 {
  margin-bottom: 3rem !important;
}

.container {
  flex: 1 1 100%;
  box-sizing: border-box;
  padding: 0.5rem 1rem 1rem;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
@media screen and (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}
@media screen and (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}
@media screen and (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}
@media screen and (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}
@media screen and (min-width: 1400px) {
  .container {
    max-width: 1320px;
  }
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Z-index mapping for the floating elements */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: block;
  width: 100%;
  height: 100%;
}

* {
  box-sizing: border-box;
}

.hidden {
  display: none !important;
}

.container {
  flex: none;
  padding: 0 !important;
}

.page {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.page.has-fixed-header, .page.has-fixed-footer {
  height: 100vh;
  overflow-y: auto;
}

.page-fixed-header {
  width: 100%;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 20;
  background-color: #ffffff;
  border-bottom: 1px solid #ced4da;
  padding: 1.5rem 1rem 0.75rem;
}
.page-fixed-header.has-uniform-padding {
  padding: 1rem !important;
}

.page-scrollable-area {
  width: 100%;
  padding: 1rem;
}
.page-scrollable-area .page-scrollable-content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.page-scrollable-area.has-fixed-header, .page-scrollable-area.has-fixed-footer {
  padding: 1.5rem 1rem;
}
.page-scrollable-area.has-fixed-header .page-scrollable-content, .page-scrollable-area.has-fixed-footer .page-scrollable-content {
  gap: 2.5rem;
}
.page-scrollable-area.has-fluid-content, .page-scrollable-area.has-fixed-footer {
  flex-grow: 1;
}
.page-scrollable-area.has-fluid-content .page-scrollable-content, .page-scrollable-area.has-fixed-footer .page-scrollable-content {
  height: 100%;
}
.page-scrollable-area.has-fluid-content .page-scrollable-content .page-content, .page-scrollable-area.has-fixed-footer .page-scrollable-content .page-content {
  height: 100%;
}

.page-fixed-footer {
  width: 100%;
  position: sticky;
  bottom: 0;
  left: 0;
  z-index: 20;
  background-color: #ffffff;
  border-top: 1px solid #ced4da;
  padding: 1rem;
}

@media screen and (min-width: 992px) {
  .page-fixed-header {
    padding: 2rem 1rem 1rem;
  }
  .page-scrollable-area {
    padding: 2rem;
  }
  .page-scrollable-area .page-scrollable-content {
    gap: 2rem;
  }
  .page-scrollable-area.has-fixed-header, .page-scrollable-area.has-fixed-footer {
    padding: 2rem 1rem;
  }
  .page-scrollable-area.has-fixed-header .page-scrollable-content, .page-scrollable-area.has-fixed-footer .page-scrollable-content {
    gap: 3rem;
  }
}`;

// src/components/layout/atlas-page/atlas-page.ts
var AtlasPage = /*#__PURE__*/(() => {
  let AtlasPage = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.container = false;
      this.fixedHeader = false;
      this.fixedFooter = false;
      this.uniformPaddingHeader = false;
      this._hasHeader = false;
      this._hasFooter = false;
    }
    hasFixedHeader() {
      return this._hasHeader && this.fixedHeader;
    }
    hasFixedFooter() {
      return this._hasFooter && this.fixedFooter;
    }
    onHeaderChange() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this._hasHeader = !isEmptySlot(this, "header");
      });
    }
    onFooterChange() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this._hasFooter = !isEmptySlot(this, "footer");
      });
    }
    onContentChange() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const contentSlot = this.shadowRoot.querySelector("slot[name='content']");
        const assignedElements = (contentSlot == null ? void 0 : contentSlot.assignedElements()) || [];
        const pageContent = findElementByTagName(assignedElements, "ATLAS-PAGE-CONTENT");
        if (!pageContent) return;
        if (this.fluidContent) {
          pageContent.toggleAttribute("fluid", true);
        } else if (pageContent.hasAttribute("fluid")) {
          this.fluidContent = true;
        }
      });
    }
    renderScrollableArea() {
      const scrollableAreaClass = {
        "page-scrollable-area": true,
        "has-fluid-content": this.fluidContent,
        "has-fixed-header": this.hasFixedHeader(),
        "has-fixed-footer": this.hasFixedFooter(),
        "has-container": this.container
      };
      const scrollableContentClass = {
        "page-scrollable-content": true,
        "container": this.container
      };
      return html116`
            <div class=${classMap81(scrollableAreaClass)}>
                <div class=${classMap81(scrollableContentClass)}>
                    ${this.renderHeader()} ${this.renderContent()} ${this.renderFooter()}
                </div>
            </div>
        `;
    }
    renderHeader() {
      const headerClass = {
        "page-header": true,
        "hidden": !this._hasHeader
      };
      return when76(!this.fixedHeader, () => html116`
                <div class=${classMap81(headerClass)}>
                    <slot name="header" @slotchange=${this.onHeaderChange}></slot>
                </div>
            `);
    }
    renderContent() {
      return html116`
            <div class="page-content">
                <slot name="content" @slotchange=${this.onContentChange}></slot>
            </div>
        `;
    }
    renderFooter() {
      const footerClass = {
        "page-footer": true,
        "hidden": !this._hasFooter
      };
      return when76(!this.fixedFooter, () => html116`
                <div class=${classMap81(footerClass)}>
                    <slot name="footer" @slotchange=${this.onFooterChange}></slot>
                </div>
            `);
    }
    renderFixedHeader() {
      const headerClass = {
        "page-fixed-header": true,
        "hidden": !this._hasHeader,
        "has-uniform-padding": this.uniformPaddingHeader
      };
      const headerContentClass = {
        container: this.container
      };
      return when76(this.fixedHeader, () => html116`
                <div class=${classMap81(headerClass)}>
                    <div class=${classMap81(headerContentClass)}>
                        <slot name="header" @slotchange=${this.onHeaderChange}></slot>
                    </div>
                </div>
            `);
    }
    renderFixedFooter() {
      const footerClass = {
        "page-fixed-footer": true,
        "hidden": !this._hasFooter
      };
      const footerContentClass = {
        container: this.container
      };
      return when76(this.fixedFooter, () => html116`
                <div class=${classMap81(footerClass)}>
                    <div class=${classMap81(footerContentClass)}>
                        <slot name="footer" @slotchange=${this.onFooterChange}></slot>
                    </div>
                </div>
            `);
    }
    /** @internal */
    render() {
      const pageClass = {
        "page": true,
        "has-fixed-header": this.hasFixedHeader(),
        "has-fixed-footer": this.hasFixedFooter()
      };
      return html116`
            <div class=${classMap81(pageClass)}>
                ${this.renderFixedHeader()} ${this.renderScrollableArea()} ${this.renderFixedFooter()}
            </div>
        `;
    }
  };
  AtlasPage.styles = atlas_page_default;
  return AtlasPage;
})();
__decorateClass([property124({
  type: Boolean,
  reflect: true
})], AtlasPage.prototype, "container", 2);
__decorateClass([property124({
  type: Boolean,
  reflect: true,
  attribute: "fixed-header"
})], AtlasPage.prototype, "fixedHeader", 2);
__decorateClass([property124({
  type: Boolean,
  reflect: true,
  attribute: "fixed-footer"
})], AtlasPage.prototype, "fixedFooter", 2);
__decorateClass([property124({
  type: Boolean,
  reflect: true,
  attribute: "fluid-content"
})], AtlasPage.prototype, "fluidContent", 2);
__decorateClass([property124({
  type: Boolean,
  reflect: true,
  attribute: "uniform-padding-header"
})], AtlasPage.prototype, "uniformPaddingHeader", 2);
__decorateClass([state62()], AtlasPage.prototype, "_hasHeader", 2);
__decorateClass([state62()], AtlasPage.prototype, "_hasFooter", 2);
AtlasPage = __decorateClass([customElement116("atlas-page")], AtlasPage);

// src/components/layout/atlas-page-content/atlas-page-content.ts
import { html as html117 } from "lit";
import { customElement as customElement117, property as property125 } from "lit/decorators.js";

// src/components/layout/atlas-page-content/atlas-page-content.scss
import { css as css103 } from "lit-element/lit-element.js";
var atlas_page_content_default = css103`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host([fluid]) {
  display: block;
  height: 100%;
}

.page-content {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
:host([fluid]) .page-content {
  height: 100%;
}`;

// src/components/layout/atlas-page-content/atlas-page-content.ts
var AtlasPageContent = /*#__PURE__*/(() => {
  let AtlasPageContent = class extends AtlasElement {
    render() {
      return html117`
            <div class="page-content">
                <slot></slot>
            </div>
        `;
    }
  };
  AtlasPageContent.styles = atlas_page_content_default;
  return AtlasPageContent;
})();
__decorateClass([property125({
  type: Boolean,
  reflect: true,
  attribute: "fluid"
})], AtlasPageContent.prototype, "fluid", 2);
AtlasPageContent = __decorateClass([customElement117("atlas-page-content")], AtlasPageContent);

// src/components/layout/atlas-page-footer/atlas-page-footer.ts
import { html as html118 } from "lit";
import { customElement as customElement118 } from "lit/decorators.js";

// src/components/layout/atlas-page-footer/atlas-page-footer.scss
import { css as css104 } from "lit-element/lit-element.js";
var atlas_page_footer_default = css104`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: block;
}`;

// src/components/layout/atlas-page-footer/atlas-page-footer.ts
var AtlasPageFooter = /*#__PURE__*/(() => {
  let AtlasPageFooter = class extends AtlasElement {
    render() {
      return html118`
            <div class="page-footer">
                <slot></slot>
            </div>
        `;
    }
  };
  AtlasPageFooter.styles = atlas_page_footer_default;
  return AtlasPageFooter;
})();
AtlasPageFooter = __decorateClass([customElement118("atlas-page-footer")], AtlasPageFooter);

// src/components/layout/atlas-page-header/atlas-page-header.ts
import { html as html119, nothing as nothing9 } from "lit";
import { customElement as customElement119, property as property126, state as state63 } from "lit/decorators.js";
import { classMap as classMap82 } from "lit/directives/class-map.js";
import { when as when77 } from "lit/directives/when.js";

// src/components/layout/atlas-page-header/atlas-page-header.scss
import { css as css105 } from "lit-element/lit-element.js";
var atlas_page_header_default = css105`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.page-header {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.page-header .page-breadcrumb {
  display: none;
}
.page-header .page-title {
  display: flex;
  align-items: flex-end;
  gap: 1.5rem;
  justify-content: space-between;
}
.page-header .page-title .header-with-badge {
  display: flex;
  align-items: start;
  flex-direction: column-reverse;
  gap: 0.25rem;
}
.page-header .page-title .header-with-badge .heading-skeleton {
  margin: 0;
  display: block;
  line-height: 1.25;
  font-weight: 600;
  color: transparent !important;
  font-size: 1.5rem;
  height: 1.875rem;
}
.page-header .page-title .page-actions {
  display: none;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
}
.page-header:not(.has-page-name, .has-actions) .page-title {
  display: none !important;
}
.page-header.has-actions .page-actions {
  display: flex;
}

@media screen and (min-width: 992px) {
  .page-header.has-breadcrumb .page-breadcrumb {
    display: block;
  }
  .page-header .page-title .header-with-badge {
    flex-direction: row;
    align-items: center;
    gap: 1rem;
  }
}`;

// src/components/layout/atlas-page-header/atlas-page-header.ts
var AtlasPageHeader = /*#__PURE__*/(() => {
  let AtlasPageHeader = class extends WithBadgeMixin(AtlasElement) {
    constructor() {
      super(...arguments);
      this._hasActions = false;
      this._hasBreadcrumb = false;
    }
    onActionsChange() {
      const actionsSlot = this.shadowRoot.querySelector("slot[name=actions]");
      this._hasActions = actionsSlot.assignedElements().length > 0;
    }
    onBreadcrumbChange() {
      const breadcrumbSlot = this.shadowRoot.querySelector("slot[name=breadcrumb]");
      this._hasBreadcrumb = breadcrumbSlot.assignedElements().length > 0;
    }
    /**
     * @internal
     * @override
     */
    renderBadge() {
      if (this.isNew) {
        this.badgeText = "Novo";
        this.badgeTheme = "danger";
        this.badgeTooltip = "";
      }
      return super.renderBadge();
    }
    renderBreadcrumb() {
      return html119`
            <div class="page-breadcrumb">
                <slot name="breadcrumb" @slotchange=${this.onBreadcrumbChange}></slot>
            </div>
        `;
    }
    renderHeading() {
      if (!this.pageName) return nothing9;
      return when77(this.skeletonLoading, () => html119`<h4 class="heading-skeleton skeleton-pill">${this.pageName}</h4>`, () => html119`<atlas-heading size="h4" line-clamp="2">${this.pageName}</atlas-heading>`);
    }
    renderPageName() {
      return when77(!!this.pageName, () => html119` <div class="header-with-badge">${this.renderHeading()} ${this.renderBadge()}</div> `);
    }
    renderActions() {
      return html119`
            <div class="page-actions">
                <slot name="actions" @slotchange=${this.onActionsChange}></slot>
            </div>
        `;
    }
    renderDefaultSlot() {
      return html119` <slot></slot> `;
    }
    /** @internal */
    render() {
      const headerClass = {
        "page-header": true,
        "has-actions": this._hasActions,
        "has-page-name": !!this.pageName,
        "has-breadcrumb": this._hasBreadcrumb
      };
      return html119`
            <div class=${classMap82(headerClass)}>
                ${this.renderBreadcrumb()}
                <div class="page-title">${this.renderPageName()} ${this.renderActions()}</div>
                ${this.renderDefaultSlot()}
            </div>
        `;
    }
  };
  AtlasPageHeader.styles = atlas_page_header_default;
  return AtlasPageHeader;
})();
__decorateClass([property126({
  type: String,
  attribute: "page-name"
})], AtlasPageHeader.prototype, "pageName", 2);
__decorateClass([property126({
  type: Boolean,
  attribute: "is-new"
})], AtlasPageHeader.prototype, "isNew", 2);
__decorateClass([state63()], AtlasPageHeader.prototype, "_hasActions", 2);
__decorateClass([state63()], AtlasPageHeader.prototype, "_hasBreadcrumb", 2);
AtlasPageHeader = __decorateClass([customElement119("atlas-page-header")], AtlasPageHeader);

// src/components/layout/atlas-page-section/atlas-page-section.ts
import { html as html120 } from "lit";
import { customElement as customElement120, property as property127 } from "lit/decorators.js";
import { classMap as classMap83 } from "lit/directives/class-map.js";
import { styleMap as styleMap23 } from "lit/directives/style-map.js";

// src/components/layout/atlas-page-section/atlas-page-section.scss
import { css as css106 } from "lit-element/lit-element.js";
var atlas_page_section_default = css106`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.color-white {
  color: #ffffff !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.color-primary {
  color: var(--atlas-primary) !important;
}

.bg-primary {
  background-color: var(--atlas-primary) !important;
}

.color-primary-100 {
  color: var(--atlas-primary-100) !important;
}

.bg-primary-100 {
  background-color: var(--atlas-primary-100) !important;
}

.color-primary-200 {
  color: var(--atlas-primary-200) !important;
}

.bg-primary-200 {
  background-color: var(--atlas-primary-200) !important;
}

.color-primary-300 {
  color: var(--atlas-primary-300) !important;
}

.bg-primary-300 {
  background-color: var(--atlas-primary-300) !important;
}

.color-primary-400 {
  color: var(--atlas-primary-400) !important;
}

.bg-primary-400 {
  background-color: var(--atlas-primary-400) !important;
}

.color-primary-500 {
  color: var(--atlas-primary-500) !important;
}

.bg-primary-500 {
  background-color: var(--atlas-primary-500) !important;
}

.color-primary-600 {
  color: var(--atlas-primary-600) !important;
}

.bg-primary-600 {
  background-color: var(--atlas-primary-600) !important;
}

.color-primary-700 {
  color: var(--atlas-primary-700) !important;
}

.bg-primary-700 {
  background-color: var(--atlas-primary-700) !important;
}

.color-primary-800 {
  color: var(--atlas-primary-800) !important;
}

.bg-primary-800 {
  background-color: var(--atlas-primary-800) !important;
}

.color-primary-900 {
  color: var(--atlas-primary-900) !important;
}

.bg-primary-900 {
  background-color: var(--atlas-primary-900) !important;
}

.active-primary[active], .active-primary.active, .active-primary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-secondary {
  color: var(--atlas-secondary) !important;
}

.bg-secondary {
  background-color: var(--atlas-secondary) !important;
}

.color-secondary-100 {
  color: var(--atlas-secondary-100) !important;
}

.bg-secondary-100 {
  background-color: var(--atlas-secondary-100) !important;
}

.color-secondary-200 {
  color: var(--atlas-secondary-200) !important;
}

.bg-secondary-200 {
  background-color: var(--atlas-secondary-200) !important;
}

.color-secondary-300 {
  color: var(--atlas-secondary-300) !important;
}

.bg-secondary-300 {
  background-color: var(--atlas-secondary-300) !important;
}

.color-secondary-400 {
  color: var(--atlas-secondary-400) !important;
}

.bg-secondary-400 {
  background-color: var(--atlas-secondary-400) !important;
}

.color-secondary-500 {
  color: var(--atlas-secondary-500) !important;
}

.bg-secondary-500 {
  background-color: var(--atlas-secondary-500) !important;
}

.color-secondary-600 {
  color: var(--atlas-secondary-600) !important;
}

.bg-secondary-600 {
  background-color: var(--atlas-secondary-600) !important;
}

.color-secondary-700 {
  color: var(--atlas-secondary-700) !important;
}

.bg-secondary-700 {
  background-color: var(--atlas-secondary-700) !important;
}

.color-secondary-800 {
  color: var(--atlas-secondary-800) !important;
}

.bg-secondary-800 {
  background-color: var(--atlas-secondary-800) !important;
}

.color-secondary-900 {
  color: var(--atlas-secondary-900) !important;
}

.bg-secondary-900 {
  background-color: var(--atlas-secondary-900) !important;
}

.active-secondary[active], .active-secondary.active, .active-secondary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-success {
  color: var(--atlas-success) !important;
}

.bg-success {
  background-color: var(--atlas-success) !important;
}

.color-success-100 {
  color: var(--atlas-success-100) !important;
}

.bg-success-100 {
  background-color: var(--atlas-success-100) !important;
}

.color-success-200 {
  color: var(--atlas-success-200) !important;
}

.bg-success-200 {
  background-color: var(--atlas-success-200) !important;
}

.color-success-300 {
  color: var(--atlas-success-300) !important;
}

.bg-success-300 {
  background-color: var(--atlas-success-300) !important;
}

.color-success-400 {
  color: var(--atlas-success-400) !important;
}

.bg-success-400 {
  background-color: var(--atlas-success-400) !important;
}

.color-success-500 {
  color: var(--atlas-success-500) !important;
}

.bg-success-500 {
  background-color: var(--atlas-success-500) !important;
}

.color-success-600 {
  color: var(--atlas-success-600) !important;
}

.bg-success-600 {
  background-color: var(--atlas-success-600) !important;
}

.color-success-700 {
  color: var(--atlas-success-700) !important;
}

.bg-success-700 {
  background-color: var(--atlas-success-700) !important;
}

.color-success-800 {
  color: var(--atlas-success-800) !important;
}

.bg-success-800 {
  background-color: var(--atlas-success-800) !important;
}

.color-success-900 {
  color: var(--atlas-success-900) !important;
}

.bg-success-900 {
  background-color: var(--atlas-success-900) !important;
}

.active-success[active], .active-success.active, .active-success:active {
  background-color: var(--atlas-success) !important;
  color: var(--atlas-contrast-success) !important;
}

.color-warning {
  color: var(--atlas-warning) !important;
}

.bg-warning {
  background-color: var(--atlas-warning) !important;
}

.color-warning-100 {
  color: var(--atlas-warning-100) !important;
}

.bg-warning-100 {
  background-color: var(--atlas-warning-100) !important;
}

.color-warning-200 {
  color: var(--atlas-warning-200) !important;
}

.bg-warning-200 {
  background-color: var(--atlas-warning-200) !important;
}

.color-warning-300 {
  color: var(--atlas-warning-300) !important;
}

.bg-warning-300 {
  background-color: var(--atlas-warning-300) !important;
}

.color-warning-400 {
  color: var(--atlas-warning-400) !important;
}

.bg-warning-400 {
  background-color: var(--atlas-warning-400) !important;
}

.color-warning-500 {
  color: var(--atlas-warning-500) !important;
}

.bg-warning-500 {
  background-color: var(--atlas-warning-500) !important;
}

.color-warning-600 {
  color: var(--atlas-warning-600) !important;
}

.bg-warning-600 {
  background-color: var(--atlas-warning-600) !important;
}

.color-warning-700 {
  color: var(--atlas-warning-700) !important;
}

.bg-warning-700 {
  background-color: var(--atlas-warning-700) !important;
}

.color-warning-800 {
  color: var(--atlas-warning-800) !important;
}

.bg-warning-800 {
  background-color: var(--atlas-warning-800) !important;
}

.color-warning-900 {
  color: var(--atlas-warning-900) !important;
}

.bg-warning-900 {
  background-color: var(--atlas-warning-900) !important;
}

.active-warning[active], .active-warning.active, .active-warning:active {
  background-color: var(--atlas-warning) !important;
  color: var(--atlas-contrast-warning) !important;
}

.color-danger {
  color: var(--atlas-danger) !important;
}

.bg-danger {
  background-color: var(--atlas-danger) !important;
}

.color-danger-100 {
  color: var(--atlas-danger-100) !important;
}

.bg-danger-100 {
  background-color: var(--atlas-danger-100) !important;
}

.color-danger-200 {
  color: var(--atlas-danger-200) !important;
}

.bg-danger-200 {
  background-color: var(--atlas-danger-200) !important;
}

.color-danger-300 {
  color: var(--atlas-danger-300) !important;
}

.bg-danger-300 {
  background-color: var(--atlas-danger-300) !important;
}

.color-danger-400 {
  color: var(--atlas-danger-400) !important;
}

.bg-danger-400 {
  background-color: var(--atlas-danger-400) !important;
}

.color-danger-500 {
  color: var(--atlas-danger-500) !important;
}

.bg-danger-500 {
  background-color: var(--atlas-danger-500) !important;
}

.color-danger-600 {
  color: var(--atlas-danger-600) !important;
}

.bg-danger-600 {
  background-color: var(--atlas-danger-600) !important;
}

.color-danger-700 {
  color: var(--atlas-danger-700) !important;
}

.bg-danger-700 {
  background-color: var(--atlas-danger-700) !important;
}

.color-danger-800 {
  color: var(--atlas-danger-800) !important;
}

.bg-danger-800 {
  background-color: var(--atlas-danger-800) !important;
}

.color-danger-900 {
  color: var(--atlas-danger-900) !important;
}

.bg-danger-900 {
  background-color: var(--atlas-danger-900) !important;
}

.active-danger[active], .active-danger.active, .active-danger:active {
  background-color: var(--atlas-danger) !important;
  color: var(--atlas-contrast-danger) !important;
}

.color-highlight {
  color: var(--atlas-highlight) !important;
}

.bg-highlight {
  background-color: var(--atlas-highlight) !important;
}

.color-highlight-100 {
  color: var(--atlas-highlight-100) !important;
}

.bg-highlight-100 {
  background-color: var(--atlas-highlight-100) !important;
}

.color-highlight-200 {
  color: var(--atlas-highlight-200) !important;
}

.bg-highlight-200 {
  background-color: var(--atlas-highlight-200) !important;
}

.color-highlight-300 {
  color: var(--atlas-highlight-300) !important;
}

.bg-highlight-300 {
  background-color: var(--atlas-highlight-300) !important;
}

.color-highlight-400 {
  color: var(--atlas-highlight-400) !important;
}

.bg-highlight-400 {
  background-color: var(--atlas-highlight-400) !important;
}

.color-highlight-500 {
  color: var(--atlas-highlight-500) !important;
}

.bg-highlight-500 {
  background-color: var(--atlas-highlight-500) !important;
}

.color-highlight-600 {
  color: var(--atlas-highlight-600) !important;
}

.bg-highlight-600 {
  background-color: var(--atlas-highlight-600) !important;
}

.color-highlight-700 {
  color: var(--atlas-highlight-700) !important;
}

.bg-highlight-700 {
  background-color: var(--atlas-highlight-700) !important;
}

.color-highlight-800 {
  color: var(--atlas-highlight-800) !important;
}

.bg-highlight-800 {
  background-color: var(--atlas-highlight-800) !important;
}

.color-highlight-900 {
  color: var(--atlas-highlight-900) !important;
}

.bg-highlight-900 {
  background-color: var(--atlas-highlight-900) !important;
}

.active-highlight[active], .active-highlight.active, .active-highlight:active {
  background-color: var(--atlas-highlight) !important;
  color: var(--atlas-contrast-highlight) !important;
}

.color-info {
  color: var(--atlas-info) !important;
}

.bg-info {
  background-color: var(--atlas-info) !important;
}

.color-info-100 {
  color: var(--atlas-info-100) !important;
}

.bg-info-100 {
  background-color: var(--atlas-info-100) !important;
}

.color-info-200 {
  color: var(--atlas-info-200) !important;
}

.bg-info-200 {
  background-color: var(--atlas-info-200) !important;
}

.color-info-300 {
  color: var(--atlas-info-300) !important;
}

.bg-info-300 {
  background-color: var(--atlas-info-300) !important;
}

.color-info-400 {
  color: var(--atlas-info-400) !important;
}

.bg-info-400 {
  background-color: var(--atlas-info-400) !important;
}

.color-info-500 {
  color: var(--atlas-info-500) !important;
}

.bg-info-500 {
  background-color: var(--atlas-info-500) !important;
}

.color-info-600 {
  color: var(--atlas-info-600) !important;
}

.bg-info-600 {
  background-color: var(--atlas-info-600) !important;
}

.color-info-700 {
  color: var(--atlas-info-700) !important;
}

.bg-info-700 {
  background-color: var(--atlas-info-700) !important;
}

.color-info-800 {
  color: var(--atlas-info-800) !important;
}

.bg-info-800 {
  background-color: var(--atlas-info-800) !important;
}

.color-info-900 {
  color: var(--atlas-info-900) !important;
}

.bg-info-900 {
  background-color: var(--atlas-info-900) !important;
}

.active-info[active], .active-info.active, .active-info:active {
  background-color: var(--atlas-info) !important;
  color: var(--atlas-contrast-info) !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 0.75rem !important;
}

.gap-4 {
  gap: 1rem !important;
}

.gap-5 {
  gap: 1.25rem !important;
}

.gap-6 {
  gap: 1.5rem !important;
}

.gap-7 {
  gap: 2rem !important;
}

.gap-8 {
  gap: 2.5rem !important;
}

.gap-9 {
  gap: 3rem !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 0.75rem !important;
}

.mt-4 {
  margin-top: 1rem !important;
}

.mt-5 {
  margin-top: 1.25rem !important;
}

.mt-6 {
  margin-top: 1.5rem !important;
}

.mt-7 {
  margin-top: 2rem !important;
}

.mt-8 {
  margin-top: 2.5rem !important;
}

.mt-9 {
  margin-top: 3rem !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 0.75rem !important;
}

.mb-4 {
  margin-bottom: 1rem !important;
}

.mb-5 {
  margin-bottom: 1.25rem !important;
}

.mb-6 {
  margin-bottom: 1.5rem !important;
}

.mb-7 {
  margin-bottom: 2rem !important;
}

.mb-8 {
  margin-bottom: 2.5rem !important;
}

.mb-9 {
  margin-bottom: 3rem !important;
}

.container {
  flex: 1 1 100%;
  box-sizing: border-box;
  padding: 0.5rem 1rem 1rem;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
@media screen and (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}
@media screen and (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}
@media screen and (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}
@media screen and (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}
@media screen and (min-width: 1400px) {
  .container {
    max-width: 1320px;
  }
}

:host {
  display: inline-flex;
  width: 100%;
}

.page-section {
  position: relative;
  z-index: 1;
  width: 100%;
  background-color: var(--atlas-light);
}
.page-section.with-background {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.page-section.padding-none {
  padding: 0;
}
.page-section.padding-sm {
  padding: 2rem 0;
}
.page-section.padding-md {
  padding: 3rem 0;
}
.page-section.padding-lg {
  padding: 4rem 0;
}
.page-section.white {
  background-color: #ffffff;
}

.container {
  padding: 0;
}`;

// src/components/layout/atlas-page-section/atlas-page-section.ts
var AtlasPageSection = /*#__PURE__*/(() => {
  let AtlasPageSection = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.container = false;
      this.white = false;
      this.verticalPadding = "md";
    }
    getThemeClass() {
      if (this.theme) {
        if (this.themeVariation) {
          return `bg-${this.theme}-${this.themeVariation}`;
        }
        return `bg-${this.theme}`;
      }
      return "";
    }
    render() {
      const themeClass = this.getThemeClass();
      const pageSectionClasses = {
        "page-section": true,
        "white": this.white,
        "with-background": !!this.backgroundImage,
        [`padding-${this.verticalPadding}`]: !!this.verticalPadding,
        [themeClass]: !!themeClass
      };
      const containerClasses = {
        container: this.container
      };
      const pageSectionStyles = this.backgroundImage ? {
        backgroundImage: `url("${this.backgroundImage}")`
      } : {};
      return html120`
            <div class="${classMap83(pageSectionClasses)}" style=${styleMap23(pageSectionStyles)}>
                <div class="${classMap83(containerClasses)}">
                    <slot></slot>
                </div>
            </div>
        `;
    }
  };
  AtlasPageSection.styles = atlas_page_section_default;
  return AtlasPageSection;
})();
__decorateClass([property127({
  type: Boolean,
  reflect: true
})], AtlasPageSection.prototype, "container", 2);
__decorateClass([property127({
  type: Boolean,
  reflect: true
})], AtlasPageSection.prototype, "white", 2);
__decorateClass([property127({
  type: String
})], AtlasPageSection.prototype, "theme", 2);
__decorateClass([property127({
  type: Number,
  attribute: "theme-variation"
})], AtlasPageSection.prototype, "themeVariation", 2);
__decorateClass([property127({
  type: String,
  attribute: "background-image"
})], AtlasPageSection.prototype, "backgroundImage", 2);
__decorateClass([property127({
  type: String,
  attribute: "vertical-padding"
})], AtlasPageSection.prototype, "verticalPadding", 2);
AtlasPageSection = __decorateClass([customElement120("atlas-page-section")], AtlasPageSection);

// src/components/layout/atlas-page-tab/atlas-page-tab.ts
import { html as html121 } from "lit";
import { customElement as customElement121, property as property128 } from "lit/decorators.js";

// src/components/layout/atlas-page-tab/atlas-page-tab.scss
import { css as css107 } from "lit-element/lit-element.js";
var atlas_page_tab_default = css107`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host(:not([active])) {
  display: none;
}

.page-tab-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}`;

// src/components/layout/atlas-page-tab/atlas-page-tab.ts
var AtlasPageTab = /*#__PURE__*/(() => {
  let AtlasPageTab = class extends AtlasElement {
    onPropertiesChange() {
      return __async(this, null, function* () {
        var _a;
        yield this.updateComplete;
        (_a = this.closest("atlas-page-content")) == null ? void 0 : _a.requestUpdate();
      });
    }
    render() {
      return html121`
            <div class="page-tab-content">
                <slot></slot>
            </div>
        `;
    }
  };
  AtlasPageTab.styles = atlas_page_tab_default;
  return AtlasPageTab;
})();
__decorateClass([property128({
  type: String
})], AtlasPageTab.prototype, "name", 2);
__decorateClass([property128({
  type: String
})], AtlasPageTab.prototype, "icon", 2);
__decorateClass([property128({
  type: Boolean,
  reflect: true
})], AtlasPageTab.prototype, "active", 2);
__decorateClass([property128({
  type: Boolean,
  reflect: true
})], AtlasPageTab.prototype, "disabled", 2);
__decorateClass([property128({
  type: Boolean,
  attribute: "is-new",
  reflect: true
})], AtlasPageTab.prototype, "isNew", 2);
__decorateClass([Watch(["isNew", "disabled"], true)], AtlasPageTab.prototype, "onPropertiesChange", 1);
AtlasPageTab = __decorateClass([customElement121("atlas-page-tab")], AtlasPageTab);

// src/components/layout/atlas-page-tabs-wrapper/atlas-page-tabs-wrapper.ts
import { html as html122 } from "lit";
import { customElement as customElement122, property as property129, state as state64 } from "lit/decorators.js";
import { classMap as classMap84 } from "lit/directives/class-map.js";
import { styleMap as styleMap24 } from "lit/directives/style-map.js";
import { when as when78 } from "lit/directives/when.js";

// src/components/layout/atlas-page-tabs-wrapper/atlas-page-tabs-wrapper.scss
import { css as css108 } from "lit-element/lit-element.js";
var atlas_page_tabs_wrapper_default = css108`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Transitions */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.page-tabs-wrapper {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.page-tabs-navigation-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  border-bottom: 1px solid #ced4da;
}
.page-tabs-navigation-wrapper .page-tabs-navigation {
  display: flex;
  align-items: flex-start;
  width: 100%;
}
.page-tabs-navigation-wrapper .page-tabs-navigation .page-tabs-navigation-scroll {
  display: flex;
  align-items: flex-start;
  width: 100%;
  overflow: hidden;
  position: relative;
  margin: 0 -0.25rem;
  padding: 0 0.25rem;
  box-sizing: border-box;
}

.page-tab-scroll-button {
  display: flex;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
  color: #687078;
  position: relative;
  top: 0.25rem;
  border-radius: 50%;
  transition: all 0.25s ease;
}
.page-tab-scroll-button:first-of-type {
  margin-right: 1rem;
}
.page-tab-scroll-button:last-of-type {
  margin-left: 1rem;
}
.page-tab-scroll-button:hover {
  background: var(--atlas-secondary-100);
}
.page-tab-scroll-button:active {
  color: var(--atlas-primary);
  background: none;
}
.page-tab-scroll-button:focus-visible {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-500-rgb), 0.25);
  color: var(--atlas-primary);
  background: rgba(var(--atlas-primary-rgb), 0.1);
}
.page-tab-scroll-button:disabled {
  color: #687078;
  opacity: 0.35;
  pointer-events: none;
}

.page-tab-button {
  --atlas-heading-color: #687078;
  display: flex;
  border: 0;
  background: none;
  cursor: pointer;
  color: #687078;
  padding: 0.25rem 0.5rem 0.75rem;
  box-sizing: border-box;
  white-space: nowrap;
}
.page-tab-button .page-tab-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border-radius: 0.25rem;
  transition: box-shadow 0.25s ease;
}
.page-tab-button .page-tab-info atlas-icon {
  display: none;
}
.page-tab-button:first-of-type {
  padding-left: 0;
}
.page-tab-button:last-of-type {
  padding-right: 0;
}
.page-tab-button:hover {
  --atlas-heading-color: colors.\$text-body;
  color: #212529;
}
.page-tab-button:focus-visible {
  outline: none;
}
.page-tab-button:focus-visible .page-tab-info {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-500-rgb), 0.25);
}
.page-tab-button.disabled {
  color: #687078;
  opacity: 0.35;
  pointer-events: none;
}
.page-tab-button.disabled:focus-visible {
  outline: none;
}
.page-tab-button.disabled:focus-visible .page-tab-info {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-secondary-500-rgb), 0.25);
}
.page-tab-button.active {
  --atlas-heading-color: colors.\$atlas-primary;
  color: var(--atlas-primary);
}

.divider-active-mark {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 4px;
  background-color: var(--atlas-primary);
  border-radius: 9999px;
  transition: all 0.25s ease;
}

@media screen and (min-width: 992px) {
  .page-tab-button {
    padding: 0.25rem 1rem 0.75rem;
  }
  .page-tab-button .page-tab-info atlas-icon {
    display: inline-flex;
  }
}`;

// src/components/layout/atlas-page-tabs-wrapper/atlas-page-tabs-wrapper.ts
var AtlasPageTabsWrapper = /*#__PURE__*/(() => {
  let AtlasPageTabsWrapper = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this._tabs = [];
      this._showScroll = false;
      this._leftScrollButtonDisabled = false;
      this._rightScrollButtonDisabled = false;
      this._dividerActiveMarkStyles = {};
      this._focusedTabIndex = null;
      this._resizeObserver = null;
      this._deviceController = new DeviceController(this);
    }
    disconnectedCallback() {
      var _a;
      super.disconnectedCallback();
      (_a = this._resizeObserver) == null ? void 0 : _a.disconnect();
    }
    /**
     * Define a aba ativa pelo id
     * @param tabId - Id da aba que será ativada
     */
    setActiveTabById(tabId) {
      if (!tabId) return;
      const tabWithId = this._tabs.find(tab => tab.id === tabId);
      if (!tabWithId || tabWithId.disabled) return;
      this.activeTabId = tabId;
    }
    /**
     * Define a aba ativa pelo índice
     * @param index - Índice da aba que será ativada
     */
    setActiveTabByIndex(index) {
      const tab = this._tabs[index];
      if (tab) {
        this.setActiveTabById(tab.id);
      }
    }
    /**
     * Retorna a referência da aba ativa
     * @returns A referência da aba ativa
     */
    getActiveTab() {
      return this._tabs.find(tab => tab.active);
    }
    /**
     * Retorna o índice da aba ativa
     * @returns O índice da aba ativa
     */
    getActiveTabIndex() {
      return this._tabs.findIndex(tab => tab.active);
    }
    onActiveTabChange() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this._tabs.forEach(tab => {
          tab.active = tab.id === this.activeTabId;
        });
        emit(this, "atlas-page-tab-change", {
          detail: {
            tabId: this.activeTabId
          }
        });
        yield this.scrollToActiveTab();
        yield this.updateDividerActiveMark();
        this._focusedTabIndex = this.getActiveTabIndex();
      });
    }
    onClickTab(event) {
      const target = event.currentTarget;
      const tabId = target.getAttribute("data-tab-id");
      this.setActiveTabById(tabId);
    }
    onKeyDownTab(event) {
      let tabIndex = null;
      switch (event.key) {
        case "Home":
          tabIndex = 0;
          break;
        case "End":
          tabIndex = this._tabs.length - 1;
          break;
        case "ArrowLeft":
          tabIndex = this._focusedTabIndex - 1;
          tabIndex = tabIndex < 0 ? 0 : tabIndex;
          break;
        case "ArrowRight":
          tabIndex = this._focusedTabIndex + 1;
          tabIndex = tabIndex >= this._tabs.length ? this._tabs.length - 1 : tabIndex;
          break;
        default:
          return;
      }
      const focusTabSelector = `.page-tab-button[data-tab-index="${tabIndex}"]`;
      const tabToFocus = this.shadowRoot.querySelector(focusTabSelector);
      tabToFocus.focus();
      tabToFocus.scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      });
      this._focusedTabIndex = tabIndex;
    }
    onClickNavigationButton(direction) {
      const tabsNavigation = this.shadowRoot.querySelector(".page-tabs-navigation-scroll");
      const scrollAmount = tabsNavigation.offsetWidth / 2;
      tabsNavigation.scroll({
        left: direction === "left" ? tabsNavigation.scrollLeft - scrollAmount : tabsNavigation.scrollLeft + scrollAmount,
        behavior: "smooth"
      });
      setTimeout(() => {
        this.toggleNavigationButtonDisabledState();
      }, 500);
    }
    onChangeSlottedContent() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const slot = this.shadowRoot.querySelector("slot");
        const tabs = slot.assignedElements().filter(element => element.tagName === "ATLAS-PAGE-TAB");
        this._tabs = tabs;
        if (this._tabs.length > 0) {
          this.observeTabsResize();
          if (this.activeTabId) {
            this.onActiveTabChange();
          } else {
            this.setActiveTabById(this._tabs[0].id);
          }
        }
      });
    }
    observeTabsResize() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const tabsNavigation = this.shadowRoot.querySelector(".page-tabs-navigation-scroll");
        this._resizeObserver = new ResizeObserver(() => __async(this, null, function* () {
          yield this.showScrollIfNecessary();
          yield this.updateDividerActiveMark();
        }));
        this._resizeObserver.observe(tabsNavigation);
      });
    }
    showScrollIfNecessary() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const tabsNavigation = this.shadowRoot.querySelector(".page-tabs-navigation-scroll");
        this._showScroll = tabsNavigation.scrollWidth > tabsNavigation.offsetWidth;
        yield this.toggleNavigationButtonDisabledState();
      });
    }
    toggleNavigationButtonDisabledState() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const tabsNavigation = this.shadowRoot.querySelector(".page-tabs-navigation-scroll");
        this._leftScrollButtonDisabled = tabsNavigation.scrollLeft === 0;
        this._rightScrollButtonDisabled = tabsNavigation.scrollLeft + tabsNavigation.offsetWidth === tabsNavigation.scrollWidth;
      });
    }
    updateDividerActiveMark() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const activeTabSelector = `.page-tab-button[data-tab-id=${this.activeTabId}]`;
        const activeTabButton = this.shadowRoot.querySelector(activeTabSelector);
        if (!activeTabButton) {
          this._dividerActiveMarkStyles = {};
          return;
        }
        const paddingModifier = this._deviceController.isMobile ? 8 : 16;
        const activeTabIndex = parseInt(activeTabButton.getAttribute("data-tab-index") || "0", 10);
        const widthModifier = this.getWidthModifier(activeTabIndex, paddingModifier);
        const leftModifier = activeTabIndex === 0 ? 0 : paddingModifier;
        this._dividerActiveMarkStyles = {
          left: `${activeTabButton.offsetLeft + leftModifier}px`,
          width: `${activeTabButton.offsetWidth - widthModifier}px`
        };
      });
    }
    getWidthModifier(activeTabIndex, paddingModifier) {
      const hasMoreThenOneTab = this._tabs.length > 1;
      if (activeTabIndex === 0 && hasMoreThenOneTab) {
        return paddingModifier;
      }
      if (activeTabIndex === 0 && !hasMoreThenOneTab) {
        return 0;
      }
      return activeTabIndex === this._tabs.length - 1 ? paddingModifier : paddingModifier * 2;
    }
    scrollToActiveTab() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const activeTabSelector = `.page-tab-button[data-tab-id=${this.activeTabId}]`;
        const activeTabButton = this.shadowRoot.querySelector(activeTabSelector);
        if (!activeTabButton) return;
        const tabsNavigation = this.shadowRoot.querySelector(".page-tabs-navigation-scroll");
        const scrollLeft = tabsNavigation.scrollLeft;
        const scrollRight = scrollLeft + tabsNavigation.offsetWidth;
        if (activeTabButton.offsetLeft < scrollLeft) {
          tabsNavigation.scrollLeft = activeTabButton.offsetLeft - 4;
        } else if (activeTabButton.offsetLeft + activeTabButton.offsetWidth > scrollRight) {
          tabsNavigation.scrollLeft = activeTabButton.offsetLeft + activeTabButton.offsetWidth - tabsNavigation.offsetWidth + 4;
        }
        yield this.toggleNavigationButtonDisabledState();
      });
    }
    renderNavigationButton(direction) {
      const isDisabled = direction === "left" ? this._leftScrollButtonDisabled : this._rightScrollButtonDisabled;
      return when78(this._showScroll, () => html122`
                <button
                    class="page-tab-scroll-button"
                    @click=${() => this.onClickNavigationButton(direction)}
                    ?disabled=${isDisabled}
                    tabindex="-1"
                >
                    <atlas-icon name=${direction === "left" ? "chevron-left" : "chevron-right"} size="3x"></atlas-icon>
                </button>
            `);
    }
    renderPageTab(tab, index) {
      const tabClasses = {
        "page-tab-button": true,
        "active": tab.active,
        "disabled": tab.disabled
      };
      return html122`
            <button
                class=${classMap84(tabClasses)}
                @click=${this.onClickTab}
                @keydown=${this.onKeyDownTab}
                data-tab-id=${tab.id}
                data-tab-index=${index}
                tabindex=${tab.active ? "1" : "-1"}
            >
                <div class="page-tab-info">
                    <atlas-icon name=${tab.icon} size="3x"></atlas-icon>
                    <atlas-heading size="h6">${tab.name}</atlas-heading>
                    ${when78(tab.isNew, () => html122`<atlas-badge text="1" is-counter></atlas-badge>`)}
                </div>
            </button>
        `;
    }
    renderDividerActiveMark() {
      return when78(!!this.activeTabId, () => html122`<div class="divider-active-mark" style=${styleMap24(this._dividerActiveMarkStyles)}></div>`);
    }
    renderPageTabs() {
      return when78(this._tabs.length > 0, () => html122`
                <div class="page-tabs-navigation-wrapper">
                    <div class=${classMap84({
        "page-tabs-navigation": true,
        "has-scroll": this._showScroll
      })}>
                        ${this.renderNavigationButton("left")}
                        <div class="page-tabs-navigation-scroll">
                            ${this._tabs.map((tab, index) => this.renderPageTab(tab, index))}
                            ${this.renderDividerActiveMark()}
                        </div>
                        ${this.renderNavigationButton("right")}
                    </div>
                </div>
            `);
    }
    render() {
      return html122`
            <div class="page-tabs-wrapper">
                ${this.renderPageTabs()}
                <slot @slotchange=${this.onChangeSlottedContent}></slot>
            </div>
        `;
    }
  };
  AtlasPageTabsWrapper.styles = atlas_page_tabs_wrapper_default;
  return AtlasPageTabsWrapper;
})();
__decorateClass([property129({
  type: String,
  attribute: "active-tab-id",
  reflect: true
})], AtlasPageTabsWrapper.prototype, "activeTabId", 2);
__decorateClass([state64()], AtlasPageTabsWrapper.prototype, "_tabs", 2);
__decorateClass([state64()], AtlasPageTabsWrapper.prototype, "_showScroll", 2);
__decorateClass([state64()], AtlasPageTabsWrapper.prototype, "_leftScrollButtonDisabled", 2);
__decorateClass([state64()], AtlasPageTabsWrapper.prototype, "_rightScrollButtonDisabled", 2);
__decorateClass([state64()], AtlasPageTabsWrapper.prototype, "_dividerActiveMarkStyles", 2);
__decorateClass([state64()], AtlasPageTabsWrapper.prototype, "_focusedTabIndex", 2);
__decorateClass([Watch("activeTabId", true)], AtlasPageTabsWrapper.prototype, "onActiveTabChange", 1);
AtlasPageTabsWrapper = __decorateClass([customElement122("atlas-page-tabs-wrapper")], AtlasPageTabsWrapper);

// src/components/layout/atlas-row/atlas-row.ts
import { html as html123 } from "lit";
import { customElement as customElement123, property as property130 } from "lit/decorators.js";
import { classMap as classMap85 } from "lit/directives/class-map.js";

// src/components/layout/atlas-row/atlas-row.scss
import { css as css109 } from "lit-element/lit-element.js";
var atlas_row_default = css109`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 0.75rem !important;
}

.gap-4 {
  gap: 1rem !important;
}

.gap-5 {
  gap: 1.25rem !important;
}

.gap-6 {
  gap: 1.5rem !important;
}

.gap-7 {
  gap: 2rem !important;
}

.gap-8 {
  gap: 2.5rem !important;
}

.gap-9 {
  gap: 3rem !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 0.75rem !important;
}

.mt-4 {
  margin-top: 1rem !important;
}

.mt-5 {
  margin-top: 1.25rem !important;
}

.mt-6 {
  margin-top: 1.5rem !important;
}

.mt-7 {
  margin-top: 2rem !important;
}

.mt-8 {
  margin-top: 2.5rem !important;
}

.mt-9 {
  margin-top: 3rem !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 0.75rem !important;
}

.mb-4 {
  margin-bottom: 1rem !important;
}

.mb-5 {
  margin-bottom: 1.25rem !important;
}

.mb-6 {
  margin-bottom: 1.5rem !important;
}

.mb-7 {
  margin-bottom: 2rem !important;
}

.mb-8 {
  margin-bottom: 2.5rem !important;
}

.mb-9 {
  margin-bottom: 3rem !important;
}

.container {
  flex: 1 1 100%;
  box-sizing: border-box;
  padding: 0.5rem 1rem 1rem;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
@media screen and (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}
@media screen and (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}
@media screen and (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}
@media screen and (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}
@media screen and (min-width: 1400px) {
  .container {
    max-width: 1320px;
  }
}

.atlas-row {
  display: grid;
  grid-template-columns: repeat(var(--atlas-grid-columns), 1fr);
  column-gap: var(--atlas-grid-gutter);
  row-gap: var(--atlas-grid-row-gap);
}`;

// src/components/layout/atlas-row/atlas-row.ts
var AtlasRow = /*#__PURE__*/(() => {
  let AtlasRow = class extends AtlasElement {
    render() {
      const rowClass = {
        "atlas-row": true,
        [`mt-${this.marginTop}`]: !!this.marginTop,
        [`mb-${this.marginBottom}`]: !!this.marginBottom,
        [`gap-${this.gap}`]: !!this.gap
      };
      return html123`
            <div class=${classMap85(rowClass)}>
                <slot></slot>
            </div>
        `;
    }
  };
  AtlasRow.styles = atlas_row_default;
  return AtlasRow;
})();
__decorateClass([property130({
  type: Number,
  attribute: "margin-top"
})], AtlasRow.prototype, "marginTop", 2);
__decorateClass([property130({
  type: Number,
  attribute: "margin-bottom"
})], AtlasRow.prototype, "marginBottom", 2);
__decorateClass([property130({
  type: Number
})], AtlasRow.prototype, "gap", 2);
AtlasRow = __decorateClass([customElement123("atlas-row")], AtlasRow);

// src/components/layout/atlas-section/atlas-section.ts
import { html as html124, nothing as nothing10 } from "lit";
import { customElement as customElement124, property as property131, state as state65 } from "lit/decorators.js";
import { classMap as classMap86 } from "lit/directives/class-map.js";
import { when as when79 } from "lit/directives/when.js";

// src/components/layout/atlas-section/atlas-section.scss
import { css as css110 } from "lit-element/lit-element.js";
var atlas_section_default = css110`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
:host {
  display: block;
  margin-bottom: 2rem !important;
}

:host([is-faq]) {
  margin-bottom: 0.5rem !important;
}

:host(:last-of-type),
:host([no-margin-bottom]) {
  margin-bottom: 0 !important;
}

.section .section-header,
.section .section-header-title {
  background: none;
  width: 100%;
  border: 0;
  padding: 0;
  transition: margin-bottom 0.3s ease-in-out;
}
.section:not(.collapsed) .section-header {
  margin-bottom: 1rem;
}
.section .section-header:focus-within {
  outline: none;
}
.section .section-header-items {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.section .section-header-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  gap: 0.5rem;
}
.section .section-header-title .section-header-title-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.section .section-action {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.section .section-description {
  display: inline-block;
  margin: 0 0 1rem;
}
.section.collapsible .section-header {
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #ced4da;
}
.section.collapsible .section-header-title .section-header-collapsible-area {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  gap: 0.5rem;
  cursor: pointer;
}
.section.is-faq {
  border-bottom: 1px solid #ced4da;
  margin-bottom: 1rem;
}
.section.is-faq .section-header-items {
  display: block;
}
.section.is-faq .section-header {
  padding: 0 0.5rem;
  margin-bottom: 0.5rem;
  border: 0;
  box-sizing: border-box;
  cursor: pointer;
}
.section.is-faq .section-header-title {
  justify-content: space-between;
}
.section.is-faq .section-body {
  padding: 0 0.5rem;
  margin: 0;
}
.section.is-faq .section-description {
  margin: 0 0 0.5rem;
}
.section.is-faq .section-content {
  margin: 0 0 0.5rem;
}
.section:not(.has-content) .section-header {
  margin-bottom: 0;
}
.section:not(.has-content) .section-body {
  display: none;
}

@media screen and (min-width: 992px) {
  .section:not(.is-faq) .section-header-items {
    flex-direction: row;
  }
  .section:not(.is-faq) .section-header-title {
    justify-content: flex-start;
  }
  .section:not(.is-faq) .section-action {
    flex-direction: row;
  }
  .section:not(.is-faq) .section-subheading {
    margin-top: 1rem;
    height: 1.5rem;
    text-align: left;
  }
  .section:not(.is-faq) .section-description {
    margin: 0 0 1.5rem;
  }
}`;

// src/components/layout/atlas-section/atlas-section.ts
var ComposedClass8 = WithBadgeMixin(WithDescriptionMixin(WithPopoverMixin(WithCollapseMixin(AtlasElement))));
var AtlasSection = /*#__PURE__*/(() => {
  let AtlasSection = class extends ComposedClass8 {
    constructor() {
      super(...arguments);
      this.headerSize = "h4";
      this.optional = false;
      this.isFaq = false;
      this.hideOptional = false;
      this.noMarginBottom = false;
      this.isNew = false;
      this._hasSlottedSubheading = false;
      this._hasSlottedAction = false;
      this._hasSlottedContent = false;
      this._deviceController = new DeviceController(this);
    }
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.onContentSlotChange = this.onContentSlotChange.bind(this);
      this.updateOptionalState = this.updateOptionalState.bind(this);
      this.addEventListener("atlas-form-element-required-change", this.updateOptionalState);
      this.addEventListener("atlas-collapse-button-click", this.emitSectionEvent);
      if (this.collapsible) {
        this.collapsed = !this.expanded;
      }
      this.updateComplete.then(() => {
        this.updateOptionalState();
      });
    }
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      this.removeEventListener("atlas-form-element-required-change", this.updateOptionalState);
      this.removeEventListener("atlas-collapse-button-click", this.emitSectionEvent);
    }
    /** Abre a seção colapsada */
    open() {
      if (!this.collapsible) return;
      this.collapsed = false;
      this.emitSectionEvent();
    }
    /** Fecha a seção aberta */
    close() {
      if (!this.collapsible) return;
      this.collapsed = true;
      this.emitSectionEvent();
    }
    /** Alterna entre aberto e fechado */
    toggle() {
      if (!this.collapsible) return;
      if (this.collapsed) {
        this.open();
      } else {
        this.close();
      }
    }
    /**
     * @internal
     * @override
     */
    renderBadge() {
      if (this.isNew) {
        this.badgeText = "Novo";
        this.badgeTheme = "danger";
        this.badgeTooltip = "";
      }
      return super.renderBadge();
    }
    toggleCollapsibleSection(event) {
      if (this.hasPopover()) {
        const composedPath = event.composedPath();
        const isPopoverTarget = composedPath.includes(this.shadowRoot.querySelector("atlas-icon-button"));
        if (isPopoverTarget) return;
      }
      this.toggle();
    }
    emitSectionEvent() {
      emit(this, `atlas-section-${this.collapsed ? "collapse" : "expand"}`);
    }
    onActionSlotChange() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const actionsSlot = this.shadowRoot.querySelector("slot[name=action]");
        const slottedButtons = (actionsSlot == null ? void 0 : actionsSlot.assignedElements({
          flatten: true
        })) || [];
        slottedButtons.forEach(element => {
          element.toggleAttribute("block", this._deviceController.isMobile);
        });
        this._hasSlottedAction = slottedButtons.length > 0;
      });
    }
    updateOptionalState() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const formElements = getAllFormElements(this);
        if (formElements.length <= 0) {
          this.optional = false;
          return;
        }
        const allOptional = formElements.every(element => {
          if (element instanceof AtlasElementGroup) {
            return element.requiredFields === 0;
          }
          return !element.required;
        });
        this.optional = allOptional;
        formElements.forEach(element => {
          element.toggleAttribute("hide-optional", allOptional);
        });
      });
    }
    onSubheadingSlotChange() {
      const subheadingSlot = this.shadowRoot.querySelector("slot[name=subheading]");
      this._hasSlottedSubheading = (subheadingSlot == null ? void 0 : subheadingSlot.assignedElements().length) > 0;
    }
    onContentSlotChange() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this._hasSlottedContent = !isEmptySlot(this);
      });
    }
    shouldRenderOptionalSuffix() {
      return this.optional && !this.hideOptional;
    }
    renderActionSlot() {
      return html124`
            <div class="section-action" style="${!this._hasSlottedAction ? "display: none;" : ""}">
                <slot name="action" @slotchange=${this.onActionSlotChange}></slot>
            </div>
        `;
    }
    renderSubheadingSlot() {
      return html124`
            <div class="section-subheading" style="${!this._hasSlottedSubheading ? "display: none;" : ""}">
                <slot name="subheading" @slotchange=${this.onSubheadingSlotChange}></slot>
            </div>
        `;
    }
    renderHeading() {
      const headerSize = this.isFaq ? "h6" : this.headerSize;
      const headerSizesWithSmallerPopover = ["h6", "h5"];
      const popoverSize = headerSizesWithSmallerPopover.includes(headerSize) ? "2x" : "3x";
      return html124`
            <atlas-heading size="${headerSize}">
                ${this.header}${this.shouldRenderOptionalSuffix() ? " (Opcional)" : ""}
            </atlas-heading>
            ${this.renderPopoverInfoIcon(popoverSize)}
            ${this.renderBadge()}
        `;
    }
    renderFaqHeader() {
      return html124`
            <div class="section-header" @click=${this.toggleCollapsibleSection}>
                <div class="section-header-items">
                    <div class="section-header-title">
                        <div class="section-header-title-info">${this.renderHeading()}</div>
                        ${this.renderCollapseButton("primary", "primary")}
                    </div>
                </div>
            </div>
        `;
    }
    renderMobileHeader() {
      return html124`
            <div class="section-header">
                <div class="section-header-items">
                    <div class="section-header-title" @click=${this.toggleCollapsibleSection}>
                        <div class="section-header-title-info">${this.renderHeading()}</div>
                        ${this.renderCollapseButton("primary", "secondary")}
                    </div>
                    ${this.renderSubheadingSlot()} ${this.renderActionSlot()}
                </div>
            </div>
        `;
    }
    renderCollapsibleHeader() {
      if (this.isFaq) {
        return this.renderFaqHeader();
      }
      if (this._deviceController.isMobile) {
        return this.renderMobileHeader();
      }
      return html124`
            <div class="section-header">
                <div class="section-header-items">
                    <div class="section-header-title">
                        <div class="section-header-collapsible-area" @click=${this.toggleCollapsibleSection}>
                            ${this.renderHeading()} ${this.renderCollapseButton("primary", "secondary")}
                        </div>
                    </div>
                    ${this.renderActionSlot()}
                </div>

                ${this.renderSubheadingSlot()}
            </div>
        `;
    }
    renderDefaultHeader() {
      return html124`
            <div class="section-header">
                <div class="section-header-items">
                    <div class="section-header-title">${this.renderHeading()}</div>
                    ${this.renderActionSlot()}
                </div>

                ${this.renderSubheadingSlot()}
            </div>
        `;
    }
    renderHeader() {
      if (!this.header) return nothing10;
      return when79(this.collapsible, () => this.renderCollapsibleHeader(), () => this.renderDefaultHeader());
    }
    renderContent() {
      const contentHtml = html124`
            ${this.renderDescription({
        wrapperClass: "section-description"
      })}
            <div class="section-content">
                <slot @slotchange=${this.onContentSlotChange}></slot>
            </div>
        `;
      return when79(this.collapsible, () => this.renderContentWithCollapse(contentHtml), () => contentHtml);
    }
    render() {
      const sectionClass = {
        "section": true,
        "collapsible": this.collapsible,
        "collapsed": this.collapsed,
        "is-faq": this.isFaq,
        "has-content": this._hasSlottedContent
      };
      return html124`
            <div class=${classMap86(sectionClass)}>
                ${this.renderHeader()}
                <div class="section-body">${this.renderContent()}</div>
            </div>
        `;
    }
  };
  AtlasSection.styles = atlas_section_default;
  return AtlasSection;
})();
__decorateClass([property131({
  type: String
})], AtlasSection.prototype, "header", 2);
__decorateClass([property131({
  type: String,
  attribute: "header-size"
})], AtlasSection.prototype, "headerSize", 2);
__decorateClass([property131({
  type: Boolean,
  reflect: true
})], AtlasSection.prototype, "optional", 2);
__decorateClass([property131({
  type: Boolean,
  attribute: "is-faq"
})], AtlasSection.prototype, "isFaq", 2);
__decorateClass([property131({
  type: Boolean,
  reflect: true,
  attribute: "hide-optional"
})], AtlasSection.prototype, "hideOptional", 2);
__decorateClass([property131({
  type: Boolean,
  reflect: true,
  attribute: "no-margin-bottom"
})], AtlasSection.prototype, "noMarginBottom", 2);
__decorateClass([property131({
  type: Boolean,
  reflect: true,
  attribute: "is-new"
})], AtlasSection.prototype, "isNew", 2);
__decorateClass([state65()], AtlasSection.prototype, "_hasSlottedSubheading", 2);
__decorateClass([state65()], AtlasSection.prototype, "_hasSlottedAction", 2);
__decorateClass([state65()], AtlasSection.prototype, "_hasSlottedContent", 2);
AtlasSection = __decorateClass([customElement124("atlas-section")], AtlasSection);

// src/components/layout/atlas-section-group/atlas-section-group.ts
import { LitElement as LitElement31, html as html125 } from "lit";
import { customElement as customElement125 } from "lit/decorators.js";

// src/components/layout/atlas-section-group/atlas-section-group.scss
import { css as css111 } from "lit-element/lit-element.js";
var atlas_section_group_default = css111`.section-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

::slotted(atlas-section) {
  margin-bottom: 0;
}`;

// src/components/layout/atlas-section-group/atlas-section-group.ts
var AtlasSectionGroup = /*#__PURE__*/(() => {
  let AtlasSectionGroup = class extends LitElement31 {
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.addEventListener("atlas-section-expand", this.onSectionExpand);
    }
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      this.removeEventListener("atlas-section-expand", this.onSectionExpand);
    }
    getSlottedSections() {
      return this.shadowRoot.querySelector("slot").assignedElements() || [];
    }
    onSectionExpand(event) {
      this.getSlottedSections().forEach(section => {
        if (event.target !== section && section.collapsed !== true) {
          section.close();
        }
      });
    }
    render() {
      return html125`
            <div class="section-group">
                <slot></slot>
            </div>
        `;
    }
  };
  AtlasSectionGroup.styles = atlas_section_group_default;
  return AtlasSectionGroup;
})();
AtlasSectionGroup = __decorateClass([customElement125("atlas-section-group")], AtlasSectionGroup);

// src/components/structure/atlas-critical-action/atlas-critical-action.ts
import { LitElement as LitElement32, html as html126 } from "lit";
import { customElement as customElement126, property as property132 } from "lit/decorators.js";
import { when as when80 } from "lit/directives/when.js";

// src/components/structure/atlas-critical-action/atlas-critical-action.scss
import { css as css112 } from "lit-element/lit-element.js";
var atlas_critical_action_default = css112`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Shadows */
/* Elevations */
.critical-action-container {
  background: #ffe69c;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
}
.critical-action-container .critical-action-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  background: #ffcd39;
  padding: 1rem 2rem;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
}
.critical-action-container .critical-action-header atlas-collapse-button {
  margin-left: auto;
}
.critical-action-container .critical-action-content {
  padding: 1.5rem 2.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.critical-action-container .critical-action-content .critical-action-footer {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
}`;

// src/components/structure/atlas-critical-action/atlas-critical-action.ts
var AtlasCriticalAction = /*#__PURE__*/(() => {
  let AtlasCriticalAction = class extends WithCollapseMixin(LitElement32) {
    constructor() {
      super(...arguments);
      this.blocked = false;
    }
    /**
     * Returna a lista de ações críticas que estão checadas
     * @returns {object[]} - A lista de ações críticas que estão checadas
     */
    getCheckedActions() {
      var _a;
      return (_a = this._actionList) == null ? void 0 : _a.getCheckedActions();
    }
    /**
     * Retorna o número de ações críticas que estão checadas
     * @returns {number} - O número de ações críticas que estão checadas
     */
    getCheckedActionsCounter() {
      var _a;
      return (_a = this._actionList) == null ? void 0 : _a.getCheckedActionsCounter();
    }
    onSlotChange() {
      if (isEmptySlot(this)) return;
      const criticalActionContent = this.shadowRoot.querySelector(".critical-action-content");
      criticalActionContent.style.display = "flex";
      const slottedElements = criticalActionContent.querySelector("slot").assignedElements();
      const actionListElement = slottedElements.find(slotted => slotted.tagName.toLowerCase() === "atlas-critical-action-list");
      if (!actionListElement) return;
      this._actionList = actionListElement;
    }
    renderHeader() {
      return when80(!!this.header, () => html126`
                <div class="critical-action-header">
                    <atlas-icon name="${this.blocked ? "x" : "alert-triangle"}"></atlas-icon>
                    <atlas-text bold>${this.header}</atlas-text>
                    <slot name="header-action"></slot>
                    ${this.renderHeaderCollapseButton()}
                </div>
            `);
    }
    renderHeaderCollapseButton() {
      return when80(this.collapsible && !this.blocked, () => html126` ${this.renderCollapseButton("critical-action", "critical-action")} `);
    }
    renderContent() {
      return this.renderContentWithCollapse(html126`
            <div class="critical-action-content" style="display: none">
                <slot @slotchange=${this.onSlotChange}></slot>
            </div>
        `);
    }
    /** @internal */
    render() {
      return html126` <div class="critical-action-container">${this.renderHeader()} ${this.renderContent()}</div> `;
    }
  };
  AtlasCriticalAction.styles = atlas_critical_action_default;
  return AtlasCriticalAction;
})();
__decorateClass([property132({
  type: String
})], AtlasCriticalAction.prototype, "header", 2);
__decorateClass([property132({
  type: Boolean
})], AtlasCriticalAction.prototype, "blocked", 2);
AtlasCriticalAction = __decorateClass([customElement126("atlas-critical-action")], AtlasCriticalAction);

// src/components/structure/atlas-critical-action-item/atlas-critical-action-item.ts
import { html as html127 } from "lit";
import { customElement as customElement127, property as property133, queryAssignedElements as queryAssignedElements4 } from "lit/decorators.js";
import { when as when81 } from "lit/directives/when.js";
import { classMap as classMap87 } from "lit/directives/class-map.js";

// src/components/structure/atlas-critical-action-item/atlas-critical-action-item.scss
import { css as css113 } from "lit-element/lit-element.js";
var atlas_critical_action_item_default = css113`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
:host {
  display: flex;
  flex-direction: column;
}

.critical-action-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.critical-action-sub-item {
  display: none;
  margin-top: 0.25rem;
  margin-left: 2rem;
  gap: 0.25rem;
  flex-direction: column;
}
.critical-action-sub-item.has-sub-items {
  display: flex;
}`;

// src/components/structure/atlas-critical-action-item/atlas-critical-action-item.ts
var AtlasCriticalActionItem = /*#__PURE__*/(() => {
  let AtlasCriticalActionItem = class extends WithCollapseMixin(FormElement) {
    constructor() {
      super();
      this.checked = false;
      this.expired = false;
      this.removeCheckbox = false;
      this._preventCheckDefaultBehavior = false;
      this.onCheckboxChange = this.onCheckboxChange.bind(this);
    }
    /** @internal */
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.addEventListener("atlas-checkbox-change", this.onCheckboxChange);
    }
    /** @internal */
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      this.removeEventListener("atlas-checkbox-change", this.onCheckboxChange);
    }
    setExpiredState() {
      var _a;
      if (!this.hasSubItems()) {
        (_a = this.ownerElement) == null ? void 0 : _a.updateExpiredState();
        return;
      }
      this.subItems.forEach(element => {
        element.expired = this.expired;
      });
    }
    setDisabledState() {
      var _a;
      if (!this.hasSubItems()) {
        (_a = this.ownerElement) == null ? void 0 : _a.updateDisabledState();
        return;
      }
      this.subItems.forEach(element => {
        element.disabled = this.disabled;
      });
    }
    setRemoveCheckboxState() {
      var _a;
      if (!this.hasSubItems()) {
        (_a = this.ownerElement) == null ? void 0 : _a.updateRemoveCheckboxState();
        return;
      }
      this.subItems.forEach(element => {
        element.removeCheckbox = this.removeCheckbox;
      });
    }
    onChangeChecked() {
      if (this.removeCheckbox) return;
      const eventObject = {
        detail: {
          group: this.hasSubItems(),
          name: this.name,
          value: this.value,
          checked: this.checked
        }
      };
      emit(this, `atlas-critical-action-item-${this.checked ? "check" : "uncheck"}`, eventObject);
      emit(this, "atlas-critical-action-item-change", eventObject);
    }
    /**
     * Marca o item
     */
    check() {
      if (this.removeCheckbox) return;
      this._preventCheckDefaultBehavior = true;
      this.checked = true;
    }
    /**
     * Desmarca o item
     */
    uncheck() {
      if (this.removeCheckbox) return;
      this._preventCheckDefaultBehavior = true;
      this.checked = false;
    }
    /**
     * Alterna o estado de checagem do item
     * @param {boolean} checked - Se definido, altera o estado de checagem para o valor fornecido
     */
    toggleChecked(checked) {
      if (this.removeCheckbox) return;
      this._preventCheckDefaultBehavior = true;
      if (typeof checked === "boolean") {
        this.checked = checked;
      } else {
        this.checked = !this.checked;
      }
    }
    /**
     * Retorna o valor do elemento
     * @returns {boolean | string} - O valor do elemento
     */
    getElementValue() {
      if (this.value && this.checked) {
        return this.value;
      }
      return this.checked;
    }
    /**
     * Retorna se o elemento possui subitens
     * @returns {boolean} - Se o elemento possui subitens
     */
    hasSubItems() {
      return this.subItems.length > 0;
    }
    setOwnerElement(ownerElement) {
      this.ownerElement = ownerElement;
    }
    onSlotChange() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        if (!this.hasSubItems()) return;
        this.collapsible = true;
        this.collapsed = true;
        this.subItems.forEach(element => {
          element.setAttribute("owner", this.name || "");
          element.setOwnerElement(this);
        });
        this.updateDisabledState();
        this.updateExpiredState();
      });
    }
    updateDisabledState() {
      if (this.disabled) this.setDisabledState();else this.disabled = this.subItems.every(element => element.disabled);
    }
    updateExpiredState() {
      if (this.expired) this.setExpiredState();else this.expired = this.subItems.every(element => element.expired);
    }
    updateRemoveCheckboxState() {
      if (this.removeCheckbox) this.setRemoveCheckboxState();else this.removeCheckbox = this.subItems.every(element => element.removeCheckbox);
    }
    getSubItemsType() {
      let expiredSubItems = 0;
      let pendingSubItems = 0;
      let disabledSubItems = 0;
      this.subItems.forEach(element => {
        if (element.expired) expiredSubItems += 1;else if (element.disabled) disabledSubItems += 1;else pendingSubItems += 1;
      });
      return {
        expiredSubItems,
        pendingSubItems,
        disabledSubItems
      };
    }
    getPluralizedSubItemsTypeDescription(type, quantity) {
      return `evento${quantity > 1 ? "s" : ""} ${type}${quantity > 1 ? "s" : ""}`;
    }
    getSubItemsDescription() {
      const {
        expiredSubItems,
        pendingSubItems,
        disabledSubItems
      } = this.getSubItemsType();
      const description = [];
      if (pendingSubItems) {
        description.push(`${pendingSubItems}${pendingSubItems !== this.subItems.length ? ` ${this.getPluralizedSubItemsTypeDescription("pendente", pendingSubItems)}` : ""}`);
      }
      if (expiredSubItems) {
        description.push(`${expiredSubItems}${expiredSubItems !== this.subItems.length ? ` ${this.getPluralizedSubItemsTypeDescription("expirado", expiredSubItems)}` : ""}`);
      }
      if (disabledSubItems) {
        description.push(`${disabledSubItems}${disabledSubItems !== this.subItems.length ? ` ${this.getPluralizedSubItemsTypeDescription("desabilitado", disabledSubItems)}` : ""}`);
      }
      return description.join(" e ");
    }
    toggleCheckedAllSubItems() {
      if (this.removeCheckbox) return;
      this.subItems.forEach(element => {
        if (element.expired || element.disabled) return;
        if (this.checked) {
          if (element.checked) return;
          element.check();
        } else {
          if (!element.checked) return;
          element.uncheck();
        }
      });
    }
    toggleCheckedActionGroup() {
      if (this.removeCheckbox) return;
      const groupElement = this.ownerElement;
      if (!groupElement) return;
      const hasAnyChildrenChecked = groupElement.subItems.some(element => element.checked);
      if (hasAnyChildrenChecked) {
        if (groupElement.checked) return;
        groupElement.check();
      } else {
        if (!groupElement.checked) return;
        groupElement.uncheck();
      }
    }
    onCheckboxChange(event) {
      if (this.removeCheckbox) return;
      event.stopImmediatePropagation();
      const {
        checked
      } = event.detail;
      this.checked = checked;
      if (this._preventCheckDefaultBehavior) {
        this._preventCheckDefaultBehavior = false;
        return;
      }
      if (this.hasSubItems()) this.toggleCheckedAllSubItems();else this.toggleCheckedActionGroup();
    }
    renderItemCollapse() {
      return when81(this.hasSubItems(), () => html127` ${this.renderCollapseButton("critical-action-item", "critical-action-item")} `);
    }
    renderCheckbox() {
      return when81(!this.removeCheckbox, () => html127`
                <atlas-checkbox
                    name="${this.name}"
                    value="${this.value}"
                    ?checked=${this.checked}
                    ?required=${this.required}
                    ?disabled=${this.disabled}
                    ?expired=${this.expired}
                >
                    ${this.renderLabel()}
                </atlas-checkbox>
            `, () => this.renderLabel());
    }
    renderLabel() {
      return when81(!!this.ownerElement, () => html127` <atlas-text theme="${this.expired ? "danger" : null}"> ${this.label} </atlas-text> `, () => html127`
                <atlas-heading size="h6" theme="${this.expired ? "danger" : null}">
                    ${this.label} ${when81(this.hasSubItems(), () => html127`(${this.getSubItemsDescription()})`)}
                </atlas-heading>
            `);
    }
    /** @internal */
    render() {
      const criticalActionItemClass = {
        "critical-action-item": true
      };
      const criticalActionSubItemClass = {
        "critical-action-sub-item": true,
        "has-sub-items": this.hasSubItems()
      };
      return html127`
            <div class="${classMap87(criticalActionItemClass)}">
                ${this.renderCheckbox()} ${this.renderItemCollapse()}
            </div>
            ${this.renderContentWithCollapse(html127`
                <div class="${classMap87(criticalActionSubItemClass)}">
                    <slot @slotchange=${this.onSlotChange}></slot>
                </div>
            `)}
        `;
    }
  };
  AtlasCriticalActionItem.styles = atlas_critical_action_item_default;
  return AtlasCriticalActionItem;
})();
__decorateClass([property133({
  type: String
})], AtlasCriticalActionItem.prototype, "owner", 2);
__decorateClass([property133({
  type: String
})], AtlasCriticalActionItem.prototype, "label", 2);
__decorateClass([property133({
  type: Boolean,
  reflect: true
})], AtlasCriticalActionItem.prototype, "checked", 2);
__decorateClass([property133({
  type: Boolean,
  reflect: true
})], AtlasCriticalActionItem.prototype, "expired", 2);
__decorateClass([property133({
  type: Boolean,
  reflect: true,
  attribute: "remove-checkbox"
})], AtlasCriticalActionItem.prototype, "removeCheckbox", 2);
__decorateClass([queryAssignedElements4({
  selector: "atlas-critical-action-item",
  flatten: true
})], AtlasCriticalActionItem.prototype, "subItems", 2);
__decorateClass([Watch("expired", true)], AtlasCriticalActionItem.prototype, "setExpiredState", 1);
__decorateClass([Watch("disabled", true)], AtlasCriticalActionItem.prototype, "setDisabledState", 1);
__decorateClass([Watch("removeCheckbox", true)], AtlasCriticalActionItem.prototype, "setRemoveCheckboxState", 1);
__decorateClass([Watch("checked", true)], AtlasCriticalActionItem.prototype, "onChangeChecked", 1);
AtlasCriticalActionItem = __decorateClass([customElement127("atlas-critical-action-item")], AtlasCriticalActionItem);

// src/components/structure/atlas-critical-action-list/atlas-critical-action-list.ts
import { LitElement as LitElement33, html as html128 } from "lit";
import { customElement as customElement128, queryAssignedElements as queryAssignedElements5 } from "lit/decorators.js";

// src/components/structure/atlas-critical-action-list/atlas-critical-action-list.scss
import { css as css114 } from "lit-element/lit-element.js";
var atlas_critical_action_list_default = css114`.critical-action-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}`;

// src/components/structure/atlas-critical-action-list/atlas-critical-action-list.ts
var AtlasCriticalActionList = /*#__PURE__*/(() => {
  let AtlasCriticalActionList = class extends LitElement33 {
    /**
     * Retorna o número de ações críticas que estão checadas
     * @returns {number} - O número de ações críticas que estão checadas
     */
    getCheckedActionsCounter() {
      const actions = this.getCheckedActions();
      return actions.length;
    }
    /**
     * Returna a lista de ações críticas que estão checadas
     * @returns {object[]} - A lista de ações críticas que estão checadas
     */
    getCheckedActions() {
      const checkedItems = this._actionItems.filter(actionItem => actionItem.checked);
      const checkedSubItems = [];
      checkedItems.forEach(actionItem => {
        if (!actionItem.hasSubItems()) return;
        checkedSubItems.push(...actionItem.subItems.filter(actionSubItem => actionSubItem.checked));
      });
      checkedItems.push(...checkedSubItems);
      const actions = [];
      checkedItems.forEach(actionItem => {
        if (actionItem.hasSubItems()) return;
        actions.push({
          name: actionItem.name,
          value: actionItem.value
        });
      });
      return actions;
    }
    /** @internal */
    render() {
      return html128`
            <div class="critical-action-list">
                <slot></slot>
            </div>
        `;
    }
  };
  AtlasCriticalActionList.styles = atlas_critical_action_list_default;
  return AtlasCriticalActionList;
})();
__decorateClass([queryAssignedElements5({
  selector: "atlas-critical-action-item",
  flatten: false
})], AtlasCriticalActionList.prototype, "_actionItems", 2);
AtlasCriticalActionList = __decorateClass([customElement128("atlas-critical-action-list")], AtlasCriticalActionList);

// src/components/structure/atlas-navbar/atlas-navbar.ts
import { LitElement as LitElement34, html as html129 } from "lit";
import { customElement as customElement129, property as property134 } from "lit/decorators.js";
import { classMap as classMap88 } from "lit/directives/class-map.js";
import { when as when82 } from "lit/directives/when.js";

// src/components/structure/atlas-navbar/atlas-navbar.scss
import { css as css115 } from "lit-element/lit-element.js";
var atlas_navbar_default = css115`.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 0.75rem !important;
}

.gap-4 {
  gap: 1rem !important;
}

.gap-5 {
  gap: 1.25rem !important;
}

.gap-6 {
  gap: 1.5rem !important;
}

.gap-7 {
  gap: 2rem !important;
}

.gap-8 {
  gap: 2.5rem !important;
}

.gap-9 {
  gap: 3rem !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 0.75rem !important;
}

.mt-4 {
  margin-top: 1rem !important;
}

.mt-5 {
  margin-top: 1.25rem !important;
}

.mt-6 {
  margin-top: 1.5rem !important;
}

.mt-7 {
  margin-top: 2rem !important;
}

.mt-8 {
  margin-top: 2.5rem !important;
}

.mt-9 {
  margin-top: 3rem !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 0.75rem !important;
}

.mb-4 {
  margin-bottom: 1rem !important;
}

.mb-5 {
  margin-bottom: 1.25rem !important;
}

.mb-6 {
  margin-bottom: 1.5rem !important;
}

.mb-7 {
  margin-bottom: 2rem !important;
}

.mb-8 {
  margin-bottom: 2.5rem !important;
}

.mb-9 {
  margin-bottom: 3rem !important;
}

.container {
  flex: 1 1 100%;
  box-sizing: border-box;
  padding: 0.5rem 1rem 1rem;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
@media screen and (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}
@media screen and (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}
@media screen and (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}
@media screen and (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}
@media screen and (min-width: 1400px) {
  .container {
    max-width: 1320px;
  }
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Z-index mapping for the floating elements */
:host {
  position: relative;
  z-index: 10;
}

.navbar-wrapper {
  display: block;
  position: relative;
  width: 100%;
  height: 64px;
  padding: 16px 32px;
  box-sizing: border-box;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  z-index: 2;
  background: #ffffff;
}

.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  gap: 1.5rem;
}
.navbar .title-wrapper {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}
.navbar .title-wrapper .title {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.25;
  color: #687078;
}

.content {
  display: none;
  flex: 1 1 100%;
  align-items: center;
  gap: 2rem;
}
.content.keep-content-on-mobile {
  display: flex;
}

.container {
  flex: none;
  padding: 0;
}

.actions-group {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-shrink: 0;
}

@media screen and (min-width: 992px) {
  .content {
    display: flex;
  }
  .navbar-wrapper {
    height: 80px;
  }
}`;

// src/components/structure/atlas-navbar/atlas-navbar.ts
var AtlasNavbar = /*#__PURE__*/(() => {
  let AtlasNavbar = class extends LitElement34 {
    constructor() {
      super(...arguments);
      this.container = false;
      this.pageTitle = "";
      this.hideMenu = false;
      this.keepContentOnMobile = false;
      this.deviceController = new DeviceController(this);
    }
    handleToggleSidebarClick(event) {
      event.stopPropagation();
      emit(this, "atlas-sidebar-toggle-click");
    }
    renderNavbarTitle() {
      return when82(this.deviceController.isMobile && !this.hideMenu, () => html129`
                <div class="title-wrapper">
                    ${when82(!this.hideMenu, () => html129`
                            <atlas-icon
                                name="bars"
                                size="3x"
                                theme="primary"
                                @click=${this.handleToggleSidebarClick}
                            ></atlas-icon>
                        `)}

                    <span class="title">${this.pageTitle}</span>
                </div>
            `);
    }
    render() {
      const navbarClasses = {
        navbar: true,
        container: this.container
      };
      const navbarContentClasses = {
        "content": true,
        "keep-content-on-mobile": this.keepContentOnMobile
      };
      return html129`
            <div class="navbar-wrapper">
                <div class=${classMap88(navbarClasses)}>
                    ${this.renderNavbarTitle()}
                    <div class=${classMap88(navbarContentClasses)}>
                        <slot></slot>
                    </div>
                    <div class="actions-group">
                        <slot name="actions"></slot>
                    </div>
                </div>
            </div>
        `;
    }
  };
  AtlasNavbar.styles = atlas_navbar_default;
  return AtlasNavbar;
})();
__decorateClass([property134({
  type: Boolean,
  reflect: true
})], AtlasNavbar.prototype, "container", 2);
__decorateClass([property134({
  type: String,
  attribute: "page-title"
})], AtlasNavbar.prototype, "pageTitle", 2);
__decorateClass([property134({
  type: Boolean,
  reflect: true,
  attribute: "hide-menu"
})], AtlasNavbar.prototype, "hideMenu", 2);
__decorateClass([property134({
  type: Boolean,
  reflect: true,
  attribute: "keep-content-on-mobile"
})], AtlasNavbar.prototype, "keepContentOnMobile", 2);
AtlasNavbar = __decorateClass([customElement129("atlas-navbar")], AtlasNavbar);

// src/components/structure/atlas-new-sidebar/atlas-new-sidebar.ts
import { html as html131, nothing as nothing11 } from "lit";
import { customElement as customElement131, property as property136, queryAssignedElements as queryAssignedElements7, state as state66 } from "lit/decorators.js";
import { classMap as classMap90 } from "lit/directives/class-map.js";
import { when as when83 } from "lit/directives/when.js";
import Cookies from "js-cookie";

// src/internals/cookies.ts
var SIDEBAR_COLLAPSE_COOKIE = {
  name: "atlas_sidebar_collapse_1734448768",
  config: {
    expires: 365,
    sameSite: "strict"
  }
};

// src/internals/product-info.ts
var PRODUCT_MAPPING = {
  asaas: {
    name: "Asaas",
    description: "Simplifique o recebimento de cobran\xE7as e automatize seu neg\xF3cio.",
    alt: "Logomarca Asaas",
    logoDefault: "assets/images/logos/asaas-logo.svg",
    logoMini: "assets/images/logos/asaas-small-logo.svg",
    logoPresentation: "assets/images/logos/asaas-logo.svg",
    homePage: "https://www.asaas.com/"
  },
  base: {
    name: "BASE by Asaas",
    description: "O sistema de gest\xE3o financeira e fiscal ideal para a sua empresa.",
    alt: "Logomarca BASE",
    logoDefault: "assets/images/logos/base-logo.svg",
    logoMini: "assets/images/logos/base-small-logo.svg",
    logoPresentation: "assets/images/logos/base-small-logo.svg",
    homePage: "https://apps.baseerp.com.br"
  },
  money: {
    name: "Asaas Money",
    description: "O seu aplicativo de pagamentos. Agilidade na hora de pagar e receber.",
    alt: "Logomarca Asaas money",
    logoDefault: "assets/images/logos/money-logo.svg",
    logoMini: "assets/images/logos/money-small-logo.svg",
    logoPresentation: "assets/images/logos/money-logo-alt.svg",
    homePage: "https://asaasmoney.com.br/"
  }
};
function getProductInfo(product) {
  return PRODUCT_MAPPING[product];
}
function getHomePage(product) {
  return getProductInfo(product).homePage;
}
var product_info_default = {
  getProductInfo,
  getHomePage
};

// src/components/structure/atlas-new-sidebar/atlas-new-sidebar.scss
import { css as css116 } from "lit-element/lit-element.js";
var atlas_new_sidebar_default = css116`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Shadows */
/* Elevations */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Z-index mapping for the floating elements */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: block;
  width: 100vw;
  height: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 15;
  opacity: 1;
  transition: opacity 0.25s ease;
  background: rgba(0, 0, 0, 0.4);
}

:host([collapsed]) {
  pointer-events: none;
  opacity: 0;
}

.atlas-sidebar {
  box-sizing: border-box;
  width: 280px;
  height: 100%;
  padding-top: 4rem;
  transition: width 0.5s ease;
  background-color: #ffffff;
  overflow-y: auto;
}
.atlas-sidebar.collapsed {
  width: 0;
}
.atlas-sidebar * {
  box-sizing: border-box;
}

.atlas-sidebar-mobile-header {
  width: 100%;
  height: 4rem;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 15;
  display: flex;
  align-items: center;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  padding: 1.25rem 1rem;
  gap: 1rem;
}

.atlas-sidebar-mobile-content {
  width: 100%;
  height: 100%;
}
.atlas-sidebar-mobile-content.menu-context-view {
  padding: 0.5rem 1rem;
}
.atlas-sidebar-mobile-content.menu-context-view .atlas-sidebar-mobile-menu-context-view {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.atlas-sidebar-mobile-content.menu-context-view .atlas-sidebar-mobile-menu-item-view {
  display: none !important;
}
.atlas-sidebar-mobile-content.menu-item-view {
  padding: 0.75rem 1rem;
}
.atlas-sidebar-mobile-content.menu-item-view .atlas-sidebar-mobile-menu-context-view {
  display: none !important;
}
.atlas-sidebar-mobile-content.menu-item-view .atlas-sidebar-mobile-menu-item-view {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.atlas-sidebar-mobile-content.menu-item-view .atlas-sidebar-mobile-menu-item-view atlas-text {
  padding: 0 1rem;
}

@media screen and (min-width: 992px) {
  :host {
    width: auto;
    position: relative;
    min-height: 100%;
    background: none;
    transition: none;
    pointer-events: unset !important;
    opacity: 1 !important;
  }
  .atlas-sidebar {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding: 1rem 0;
    width: 368px;
    position: relative;
    transition: width 0.35s cubic-bezier(0.25, 1.25, 0.5, 1);
    overflow-y: clip;
    background: linear-gradient(to right, rgba(var(--atlas-primary-100-rgb), 30%) 88px, #ffffff 88px);
    box-shadow: 1px 0 4px rgba(0, 0, 0, 0.1);
  }
  .atlas-sidebar.collapsed {
    width: 88px;
    box-shadow: none;
    transition: width 0.35s cubic-bezier(0.25, 1.25, 0.5, 1), box-shadow 0.35s cubic-bezier(0.25, 1.25, 0.5, 1);
  }
  .atlas-sidebar-product-logo-wrapper {
    position: relative;
    width: 100%;
    height: 56px;
    transition: width 0.35s cubic-bezier(0.25, 1.25, 0.5, 1);
  }
  .atlas-sidebar-product-logo-wrapper .atlas-sidebar-product-logo {
    width: calc(280px - 2rem);
    display: block;
    height: 100%;
    position: absolute;
    top: 0;
    left: calc(88px + 1rem);
    transition: left 0.35s cubic-bezier(0.25, 1.25, 0.5, 1), width 0.35s cubic-bezier(0.25, 1.25, 0.5, 1);
  }
  .atlas-sidebar-product-logo-wrapper .atlas-sidebar-product-logo .image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
    transition: opacity 0.35s cubic-bezier(0.25, 1.25, 0.5, 1);
  }
  .atlas-sidebar-product-logo-wrapper .atlas-sidebar-product-logo .image.default {
    opacity: 1;
  }
  .atlas-sidebar-product-logo-wrapper .atlas-sidebar-product-logo .image.small {
    opacity: 0;
  }
  .atlas-sidebar-product-logo-wrapper.collapsed .atlas-sidebar-product-logo {
    width: 56px;
    top: 0;
    left: 16px;
  }
  .atlas-sidebar-product-logo-wrapper.collapsed .atlas-sidebar-product-logo .image.default {
    opacity: 0;
  }
  .atlas-sidebar-product-logo-wrapper.collapsed .atlas-sidebar-product-logo .image.small {
    opacity: 1;
  }
  .atlas-sidebar-header-wrapper {
    position: relative;
    width: 100%;
    height: 48px;
    transition: width 0.35s cubic-bezier(0.25, 1.25, 0.5, 1);
  }
  .atlas-sidebar-header-wrapper .atlas-sidebar-header {
    display: block;
    width: calc(280px - 2rem);
    height: 100%;
    position: absolute;
    top: 0;
    left: calc(88px + 1rem);
    transition: left 0.35s cubic-bezier(0.25, 1.25, 0.5, 1), width 0.35s cubic-bezier(0.25, 1.25, 0.5, 1);
  }
  .atlas-sidebar-header-wrapper .atlas-sidebar-header ::slotted(atlas-dropdown-button),
  .atlas-sidebar-header-wrapper .atlas-sidebar-header ::slotted(atlas-button) {
    transition: all 0.35s cubic-bezier(0.25, 1.25, 0.5, 1);
  }
  .atlas-sidebar-header-wrapper.collapsed .atlas-sidebar-header {
    width: 56px;
    top: 0;
    left: 16px;
  }
  .atlas-sidebar-header-wrapper:not(.has-slotted-header) {
    display: none !important;
  }
  .atlas-fixed-sidebar {
    width: 88px;
    height: 100%;
  }
  .atlas-collapsible-sidebar {
    width: 280px;
    height: 100%;
    transition: width 0.35s cubic-bezier(0.25, 1.25, 0.5, 1);
  }
  .atlas-collapsible-sidebar .atlas-collapsible-sidebar-menu {
    width: 100%;
    height: 100%;
    padding: 0 1rem;
    display: block;
    box-sizing: border-box;
    opacity: 1;
  }
  .atlas-collapsible-sidebar.collapsed {
    width: 0;
  }
  .atlas-sidebar-toggle-collapse-button {
    cursor: pointer;
    position: absolute;
    width: 28px;
    height: 32px;
    top: 64px;
    left: 368px;
    z-index: 15;
    padding: 4px 4px 4px 0;
    border: 0;
    border-radius: 0 40px 40px 0;
    background: var(--atlas-primary-100);
    box-shadow: 4px 0 4px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: left 0.35s cubic-bezier(0.25, 1.25, 0.5, 1);
  }
  .atlas-sidebar-toggle-collapse-button atlas-icon {
    transition: transform 0.35s cubic-bezier(0.25, 1.25, 0.5, 1);
    transform-origin: center;
  }
  .atlas-sidebar-toggle-collapse-button:focus-visible {
    outline: none;
    box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-500-rgb), 0.25);
  }
  .atlas-sidebar-toggle-collapse-button.collapsed {
    left: 88px;
  }
  .atlas-sidebar-toggle-collapse-button.collapsed atlas-icon {
    transform: rotate(180deg);
  }
}`;

// src/components/structure/atlas-sidebar-menu/atlas-sidebar-menu.ts
import { LitElement as LitElement35, html as html130 } from "lit";
import { customElement as customElement130, property as property135, queryAssignedElements as queryAssignedElements6 } from "lit/decorators.js";
import { classMap as classMap89 } from "lit/directives/class-map.js";

// src/components/structure/atlas-sidebar-menu/atlas-sidebar-menu.scss
import { css as css117 } from "lit-element/lit-element.js";
var atlas_sidebar_menu_default = css117`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Transitions */
/* Border radius */
/* Base borders */
:host {
  display: inline-block;
  width: 100%;
}

.sidebar-menu {
  margin: 0;
  padding: 0;
  overflow: hidden;
  position: relative;
}
.sidebar-menu ::slotted(atlas-sidebar-menu-item:not(:first-of-type)) {
  margin-top: 8px !important;
}
.sidebar-menu ::slotted(atlas-sidebar-menu-group:not(:first-of-type)) {
  margin-top: 1rem !important;
}
.sidebar-menu.nested {
  margin: 8px 0 0 28px;
  transition: all 0.25s ease;
}
.sidebar-menu.nested::before {
  content: " ";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  border-left: 1px solid #ced4da;
}
.sidebar-menu.nested.shrinked {
  background: rgba(52, 58, 64, 0.05);
  margin-left: 0;
  border-radius: 50px;
}
.sidebar-menu.nested.shrinked::before {
  border-left: 0;
}
.sidebar-menu.nested ::slotted(atlas-sidebar-menu-item:not(:first-of-type)) {
  margin-top: 0 !important;
}`;

// src/components/structure/atlas-sidebar-menu/atlas-sidebar-menu.ts
var AtlasSidebarMenu = /*#__PURE__*/(() => {
  let AtlasSidebarMenu = class extends LitElement35 {
    constructor() {
      super();
      this.nested = false;
      this.shrinked = false;
      this._allSlottedItems = [];
      this.onItemClick = this.onItemClick.bind(this);
      this.onItemCollapse = this.onItemCollapse.bind(this);
      this.addEventListener("atlas-menu-item-click", this.onItemClick);
      this.addEventListener("atlas-menu-item-collapse", this.onItemCollapse);
    }
    applyPropsInChildren() {
      const slottedGroupItems = this._slottedGrouṕs.flatMap(group => group.getItems());
      this._allSlottedItems = [...this._slottedItems, ...slottedGroupItems];
      this._slottedGrouṕs.forEach(element => {
        element.toggleAttribute("shrinked", this.shrinked);
      });
      this._allSlottedItems.forEach(element => {
        element.toggleAttribute("nested", this.nested);
        element.toggleAttribute("shrinked", this.shrinked);
      });
    }
    onItemClick(event) {
      const {
        item,
        owner
      } = event.detail;
      this._allSlottedItems.forEach(element => {
        element.toggleAttribute("active", [item, owner].includes(element.value));
      });
      this._slottedGrouṕs.forEach(group => {
        group.syncActive();
        group.syncCollapsed();
      });
      if (!this.nested) {
        emit(this, "atlas-menu-item-change", {
          detail: {
            item,
            owner
          }
        });
      }
    }
    onItemCollapse(event) {
      const {
        item
      } = event.detail;
      this._allSlottedItems.forEach(element => {
        if (element.value !== item && !element.active) {
          element.setCollapsed(true);
        }
      });
    }
    render() {
      const menuClass = {
        "sidebar-menu": true,
        "nested": this.nested,
        "shrinked": this.shrinked
      };
      return html130`
            <div class=${classMap89(menuClass)} part="menu-container">
                <slot @slotchange=${this.applyPropsInChildren}></slot>
            </div>
        `;
    }
  };
  AtlasSidebarMenu.styles = atlas_sidebar_menu_default;
  return AtlasSidebarMenu;
})();
__decorateClass([property135({
  type: Boolean
})], AtlasSidebarMenu.prototype, "nested", 2);
__decorateClass([property135({
  type: Boolean
})], AtlasSidebarMenu.prototype, "shrinked", 2);
__decorateClass([queryAssignedElements6({
  selector: "atlas-sidebar-menu-item",
  flatten: true
})], AtlasSidebarMenu.prototype, "_slottedItems", 2);
__decorateClass([queryAssignedElements6({
  selector: "atlas-sidebar-menu-group",
  flatten: true
})], AtlasSidebarMenu.prototype, "_slottedGrou\u1E55s", 2);
__decorateClass([Watch("nested", true), Watch("shrinked", true)], AtlasSidebarMenu.prototype, "applyPropsInChildren", 1);
AtlasSidebarMenu = __decorateClass([customElement130("atlas-sidebar-menu")], AtlasSidebarMenu);

// src/components/structure/atlas-new-sidebar/atlas-new-sidebar.ts
var AtlasNewSidebar = /*#__PURE__*/(() => {
  let AtlasNewSidebar = class extends AtlasElement {
    constructor() {
      super();
      this.product = "asaas";
      this.collapsed = false;
      this.defaultCollapsed = false;
      this._view = "menu-context";
      this._visibleMenuContext = null;
      this._hasSlottedHeader = false;
      this._activeMenuContext = null;
      this._lastVisibleMenuContext = null;
      this.bindMethods();
      this._deviceController = new DeviceController(this, this.onChangeScreenType);
    }
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.addEventListener("atlas-sidebar-menu-context-active", this.onMenuContextActive);
      this.addEventListener("atlas-sidebar-menu-context-click", this.onMenuContextClick);
      this.addEventListener("atlas-sidebar-menu-context-slotted-item-update", this.onSlottedItemUpdateProperties);
      this.addEventListener("atlas-sidebar-menu-context-change-slotted-items", this.onChangeSlottedItems);
      this.onChangeScreenType();
      this.initCookies();
    }
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      this.removeEventListener("atlas-sidebar-menu-context-active", this.onMenuContextActive);
      this.removeEventListener("atlas-sidebar-menu-context-click", this.onMenuContextClick);
      this.removeEventListener("atlas-sidebar-menu-context-slotted-item-update", this.onSlottedItemUpdateProperties);
      this.removeEventListener("atlas-sidebar-menu-context-change-slotted-items", this.onChangeSlottedItems);
      document.removeEventListener("click", this.onDocumentClick);
    }
    /**
     * Alterna o estado de recolhimento da barra lateral
     * @param {{ forceState?: boolean, updateCookie?: boolean }} options - Opções para a alteração do estado de recolhimento
     * @param {boolean} options.forceState - Força o estado de recolhimento da barra lateral
     * @param {boolean} options.updateCookie - Atualiza o cookie que armazena o estado de recolhimento da barra lateral
     */
    toggleCollapse({
      forceState,
      updateCookie
    } = {}) {
      const hasForceState = typeof forceState === "boolean";
      const newCollapsedValue = hasForceState ? forceState : !this.collapsed;
      if (updateCookie) this.setCollapsedCookie(newCollapsedValue);
      if (hasForceState && this.collapsed === forceState) return;
      this.collapsed = newCollapsedValue;
      emit(this, "atlas-sidebar-toggle", {
        detail: {
          collapsed: this.collapsed
        }
      });
    }
    onCollapsedChange() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this.updateActionButtonAttributes();
        this.syncSidebarCollapsed();
        this.bindDocumentClick();
        const newView = this._deviceController.isMobile || this.collapsed ? "menu-context" : "menu-item";
        const sidebarCollapseDurationMs = newView === "menu-item" ? 0 : 500;
        setTimeout(() => this.setMenuView(newView), sidebarCollapseDurationMs);
      });
    }
    onVisibleMenuContextChange() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this._slottedMenuContexts.forEach(context => {
          context.toggleAttribute("items-visible", context === this._visibleMenuContext);
        });
      });
    }
    bindMethods() {
      this.onChangeScreenType = this.onChangeScreenType.bind(this);
      this.onMobileHeaderButtonClick = this.onMobileHeaderButtonClick.bind(this);
      this.onToggleCollapseButtonClick = this.onToggleCollapseButtonClick.bind(this);
      this.onHeaderSlotChange = this.onHeaderSlotChange.bind(this);
      this.onMenuContextActive = this.onMenuContextActive.bind(this);
      this.onMenuContextClick = this.onMenuContextClick.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onSlottedItemUpdateProperties = this.onSlottedItemUpdateProperties.bind(this);
      this.onChangeSlottedItems = this.onChangeSlottedItems.bind(this);
    }
    isMenuContextView() {
      return this._view === "menu-context";
    }
    isMenuItemView() {
      return this._view === "menu-item";
    }
    getVisibleMenuItems() {
      var _a;
      const visibleMenuItems = ((_a = this._visibleMenuContext) == null ? void 0 : _a.getItems()) || [];
      const menuItems = visibleMenuItems.map(item => item.cloneNode(true));
      menuItems.forEach(item => {
        item.toggleAttribute("in-menu-context", true);
      });
      return menuItems;
    }
    setMenuView(view, context = null) {
      const firstContext = this._slottedMenuContexts[0];
      const displayedContext = context || this._lastVisibleMenuContext || this._activeMenuContext || firstContext;
      this._view = displayedContext === null ? "menu-context" : view;
      this._lastVisibleMenuContext = this._visibleMenuContext;
      this._visibleMenuContext = this._view === "menu-item" ? displayedContext : null;
    }
    syncSidebarCollapsed() {
      var _a;
      (_a = this._slottedMenuContexts) == null ? void 0 : _a.forEach(context => {
        context.toggleAttribute("sidebar-collapsed", this.collapsed);
      });
    }
    updateActionButtonAttributes() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        if (!this._hasSlottedHeader) return;
        const buttonTagNames = ["ATLAS-BUTTON", "ATLAS-DROPDOWN-BUTTON"];
        const headerSlot = this.shadowRoot.querySelector("slot[name=header]");
        const assignedElements = (headerSlot == null ? void 0 : headerSlot.assignedElements()) || [];
        const button = assignedElements.find(({
          tagName
        }) => buttonTagNames.includes(tagName));
        if (!button) return;
        button.toggleAttribute("pill", this.collapsed);
        button.toggleAttribute("block", !this.collapsed);
        button.toggleAttribute("hide-description", this.collapsed);
        button.toggleAttribute("hide-tooltip", !this.collapsed);
        button.toggleAttribute("hide-icon", !this.collapsed);
        if (this.product === "asaas") {
          button.toggleAttribute("split", !this.collapsed);
          button.toggleAttribute("hide-arrow", this.collapsed);
        }
      });
    }
    bindDocumentClick() {
      if (this._deviceController.isMobile && !this.collapsed) {
        document.addEventListener("click", this.onDocumentClick);
        return;
      }
      document.removeEventListener("click", this.onDocumentClick);
    }
    initCookies() {
      if (this._deviceController.isMobile) return;
      const cookieValue = this.getCollapsedCookieValue();
      if (cookieValue !== null) {
        this.toggleCollapse({
          forceState: cookieValue
        });
        return;
      }
      this.toggleCollapse({
        forceState: this.defaultCollapsed,
        updateCookie: true
      });
    }
    getCollapsedCookieValue() {
      const cookieValue = Cookies.get(SIDEBAR_COLLAPSE_COOKIE.name);
      return typeof cookieValue === "string" ? cookieValue === "true" : null;
    }
    setCollapsedCookie(value) {
      Cookies.set(SIDEBAR_COLLAPSE_COOKIE.name, value.toString(), SIDEBAR_COLLAPSE_COOKIE.config);
    }
    getMenuItem(item) {
      return __async(this, null, function* () {
        yield this.updateComplete;
        if (!this._visibleMenuContext) return null;
        const menu = this.shadowRoot.querySelector("#atlas-sidebar-menu");
        const selector = `atlas-sidebar-menu-item[value="${item.value}"][text="${item.text}"]`;
        const menuItem = menu.querySelector(selector);
        return menuItem;
      });
    }
    onDocumentClick(event) {
      if (this.collapsed) return;
      const sidebarElement = this.shadowRoot.querySelector(".atlas-sidebar");
      if (event.composedPath().includes(sidebarElement)) return;
      this.toggleCollapse({
        forceState: true,
        updateCookie: true
      });
    }
    onChangeScreenType() {
      this.toggleCollapse({
        forceState: this._deviceController.isMobile ? true : !!this.getCollapsedCookieValue()
      });
    }
    onMobileHeaderButtonClick() {
      if (this.isMenuContextView()) {
        this.toggleCollapse();
        return;
      }
      this.setMenuView("menu-context");
    }
    onToggleCollapseButtonClick() {
      this.toggleCollapse({
        updateCookie: true
      });
    }
    onHeaderSlotChange() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this._hasSlottedHeader = !isEmptySlot(this, "header");
        this.updateActionButtonAttributes();
      });
    }
    onMenuContextActive(event) {
      const newActiveMenuContext = event.target;
      if (this._activeMenuContext && newActiveMenuContext !== this._activeMenuContext) {
        this._activeMenuContext.deactivate();
      }
      this._lastVisibleMenuContext = this._visibleMenuContext;
      this._activeMenuContext = newActiveMenuContext;
      this._visibleMenuContext = newActiveMenuContext;
    }
    onMenuContextClick(event) {
      if (this.collapsed) return;
      const context = event.target;
      if (context.href && this._deviceController.isMobile) return;
      this.setMenuView("menu-item", context);
    }
    onSlottedItemUpdateProperties(event) {
      return __async(this, null, function* () {
        const {
          item
        } = event.detail;
        const menuItem = yield this.getMenuItem(item);
        const cloneItem = item.cloneNode(true);
        cloneItem.toggleAttribute("in-menu-context", true);
        menuItem == null ? void 0 : menuItem.replaceWith(cloneItem);
      });
    }
    onChangeSlottedItems(event) {
      if (!this._visibleMenuContext || event.target !== this._visibleMenuContext) return;
      this.requestUpdate("_visibleMenuContext", this._visibleMenuContext, {
        hasChanged: () => true
      });
    }
    renderMobileHeaderHeading() {
      return when83(this._deviceController.isMobile && this.isMenuItemView(), () => html131`<atlas-text theme="primary">Menu Principal</atlas-text>`);
    }
    renderMobileSidebarContent() {
      const contentClass = {
        "atlas-sidebar-mobile-content": true,
        [`${this._view}-view`]: true
      };
      return when83(this._deviceController.isMobile, () => {
        var _a;
        return html131`
                <div class="atlas-sidebar-mobile-header">
                    <atlas-icon-button
                        icon=${this.isMenuItemView() ? "arrow-left" : "x"}
                        size="3x"
                        theme="primary"
                        @atlas-icon-button-click=${this.onMobileHeaderButtonClick}
                    ></atlas-icon-button>
                    ${this.renderMobileHeaderHeading()}
                </div>
                <div class=${classMap90(contentClass)}>
                    <slot class="atlas-sidebar-mobile-menu-context-view"></slot>
                    <div class="atlas-sidebar-mobile-menu-item-view">
                        <atlas-text size="lg" bold theme="primary">${(_a = this._visibleMenuContext) == null ? void 0 : _a.text}</atlas-text>
                        <atlas-sidebar-menu id="atlas-sidebar-menu"> ${this.getVisibleMenuItems()} </atlas-sidebar-menu>
                    </div>
                </div>
            `;
      });
    }
    renderToggleCollapseButton() {
      const buttonClass = {
        "atlas-sidebar-toggle-collapse-button": true,
        "collapsed": this.collapsed
      };
      return when83(!this._deviceController.isMobile, () => html131`
                <button class=${classMap90(buttonClass)} @click=${this.onToggleCollapseButtonClick}>
                    <atlas-icon name="chevron-left" size="3x" theme="primary"></atlas-icon>
                </button>
            `);
    }
    renderProductLogo() {
      if (this._deviceController.isMobile) return nothing11;
      const {
        alt,
        logoDefault,
        logoMini,
        name: name2,
        homePage
      } = getProductInfo(this.product);
      const logoSmallSrc = this.productLogoSmall || getAssetPath(logoMini);
      const logDefaultSrc = this.productLogo || getAssetPath(logoDefault);
      const logoClass = {
        "atlas-sidebar-product-logo-wrapper": true,
        "collapsed": this.collapsed
      };
      return html131`
            <div class=${classMap90(logoClass)}>
                <a href=${this.homePath || homePage} class="atlas-sidebar-product-logo" title=${name2}>
                    <img class="image default" src=${logDefaultSrc} title=${name2} alt=${alt} />
                    <img class="image small" src=${logoSmallSrc} title=${name2} alt=${alt} />
                </a>
            </div>
        `;
    }
    renderHeaderSlot() {
      const buttonClass = {
        "atlas-sidebar-header-wrapper": true,
        "collapsed": this.collapsed,
        "has-slotted-header": this._hasSlottedHeader
      };
      return when83(!this._deviceController.isMobile, () => html131`
                <div class=${classMap90(buttonClass)}>
                    <div class="atlas-sidebar-header">
                        <slot name="header" @slotchange=${this.onHeaderSlotChange}></slot>
                    </div>
                </div>
            `);
    }
    renderFixedSidebar() {
      const fixedSidebarClass = {
        "atlas-fixed-sidebar": true,
        "collapsed": this.collapsed
      };
      return html131`
            <div class=${classMap90(fixedSidebarClass)}>
                <atlas-layout auto gap="2" justify="center" alignment="center" class="atlas-fixed-sidebar-content">
                    <slot></slot>
                </atlas-layout>
            </div>
        `;
    }
    renderCollapsibleSidebar() {
      const collapsibleSidebarClass = {
        "atlas-collapsible-sidebar": true,
        "collapsed": this.collapsed
      };
      return html131`
            <div class=${classMap90(collapsibleSidebarClass)}>
                <atlas-sidebar-menu id="atlas-sidebar-menu" class="atlas-collapsible-sidebar-menu">
                    ${this.getVisibleMenuItems()}
                </atlas-sidebar-menu>
            </div>
        `;
    }
    renderDesktopSidebarContent() {
      return when83(!this._deviceController.isMobile, () => html131`
                ${this.renderProductLogo()} ${this.renderHeaderSlot()} ${this.renderToggleCollapseButton()}
                <atlas-layout inline mobile-inline>
                    ${this.renderFixedSidebar()} ${this.renderCollapsibleSidebar()}
                </atlas-layout>
            `);
    }
    /** @internal */
    render() {
      const sidebarClass = {
        "atlas-sidebar": true,
        "collapsed": this.collapsed,
        "has-slotted-header": this._hasSlottedHeader,
        [`${this._view}-view`]: true
      };
      return html131`
            <aside class="${classMap90(sidebarClass)}">
                ${this.renderMobileSidebarContent()} ${this.renderDesktopSidebarContent()}
            </aside>
        `;
    }
  };
  AtlasNewSidebar.styles = atlas_new_sidebar_default;
  return AtlasNewSidebar;
})();
__decorateClass([property136({
  type: String
})], AtlasNewSidebar.prototype, "product", 2);
__decorateClass([property136({
  type: String,
  attribute: "product-logo"
})], AtlasNewSidebar.prototype, "productLogo", 2);
__decorateClass([property136({
  type: String,
  attribute: "product-logo-small"
})], AtlasNewSidebar.prototype, "productLogoSmall", 2);
__decorateClass([property136({
  type: String,
  attribute: "home-path"
})], AtlasNewSidebar.prototype, "homePath", 2);
__decorateClass([property136({
  type: Boolean,
  reflect: true
})], AtlasNewSidebar.prototype, "collapsed", 2);
__decorateClass([property136({
  type: Boolean,
  attribute: "default-collapsed"
})], AtlasNewSidebar.prototype, "defaultCollapsed", 2);
__decorateClass([queryAssignedElements7({
  selector: "atlas-sidebar-menu-context"
})], AtlasNewSidebar.prototype, "_slottedMenuContexts", 2);
__decorateClass([state66()], AtlasNewSidebar.prototype, "_view", 2);
__decorateClass([state66()], AtlasNewSidebar.prototype, "_visibleMenuContext", 2);
__decorateClass([state66()], AtlasNewSidebar.prototype, "_hasSlottedHeader", 2);
__decorateClass([Watch("collapsed")], AtlasNewSidebar.prototype, "onCollapsedChange", 1);
__decorateClass([Watch("_visibleMenuContext", true)], AtlasNewSidebar.prototype, "onVisibleMenuContextChange", 1);
AtlasNewSidebar = __decorateClass([customElement131("atlas-new-sidebar")], AtlasNewSidebar);

// src/components/structure/atlas-notification-center-card/atlas-notification-center-card.ts
import { html as html132 } from "lit";
import { customElement as customElement132, property as property137, state as state67 } from "lit/decorators.js";
import { ifDefined as ifDefined23 } from "lit/directives/if-defined.js";
import { when as when84 } from "lit/directives/when.js";

// src/components/structure/atlas-notification-center-card/atlas-notification-center-card.scss
import { css as css118 } from "lit-element/lit-element.js";
var atlas_notification_center_card_default = css118`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.color-white {
  color: #ffffff !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.color-primary {
  color: var(--atlas-primary) !important;
}

.bg-primary {
  background-color: var(--atlas-primary) !important;
}

.color-primary-100 {
  color: var(--atlas-primary-100) !important;
}

.bg-primary-100 {
  background-color: var(--atlas-primary-100) !important;
}

.color-primary-200 {
  color: var(--atlas-primary-200) !important;
}

.bg-primary-200 {
  background-color: var(--atlas-primary-200) !important;
}

.color-primary-300 {
  color: var(--atlas-primary-300) !important;
}

.bg-primary-300 {
  background-color: var(--atlas-primary-300) !important;
}

.color-primary-400 {
  color: var(--atlas-primary-400) !important;
}

.bg-primary-400 {
  background-color: var(--atlas-primary-400) !important;
}

.color-primary-500 {
  color: var(--atlas-primary-500) !important;
}

.bg-primary-500 {
  background-color: var(--atlas-primary-500) !important;
}

.color-primary-600 {
  color: var(--atlas-primary-600) !important;
}

.bg-primary-600 {
  background-color: var(--atlas-primary-600) !important;
}

.color-primary-700 {
  color: var(--atlas-primary-700) !important;
}

.bg-primary-700 {
  background-color: var(--atlas-primary-700) !important;
}

.color-primary-800 {
  color: var(--atlas-primary-800) !important;
}

.bg-primary-800 {
  background-color: var(--atlas-primary-800) !important;
}

.color-primary-900 {
  color: var(--atlas-primary-900) !important;
}

.bg-primary-900 {
  background-color: var(--atlas-primary-900) !important;
}

.active-primary[active], .active-primary.active, .active-primary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-secondary {
  color: var(--atlas-secondary) !important;
}

.bg-secondary {
  background-color: var(--atlas-secondary) !important;
}

.color-secondary-100 {
  color: var(--atlas-secondary-100) !important;
}

.bg-secondary-100 {
  background-color: var(--atlas-secondary-100) !important;
}

.color-secondary-200 {
  color: var(--atlas-secondary-200) !important;
}

.bg-secondary-200 {
  background-color: var(--atlas-secondary-200) !important;
}

.color-secondary-300 {
  color: var(--atlas-secondary-300) !important;
}

.bg-secondary-300 {
  background-color: var(--atlas-secondary-300) !important;
}

.color-secondary-400 {
  color: var(--atlas-secondary-400) !important;
}

.bg-secondary-400 {
  background-color: var(--atlas-secondary-400) !important;
}

.color-secondary-500 {
  color: var(--atlas-secondary-500) !important;
}

.bg-secondary-500 {
  background-color: var(--atlas-secondary-500) !important;
}

.color-secondary-600 {
  color: var(--atlas-secondary-600) !important;
}

.bg-secondary-600 {
  background-color: var(--atlas-secondary-600) !important;
}

.color-secondary-700 {
  color: var(--atlas-secondary-700) !important;
}

.bg-secondary-700 {
  background-color: var(--atlas-secondary-700) !important;
}

.color-secondary-800 {
  color: var(--atlas-secondary-800) !important;
}

.bg-secondary-800 {
  background-color: var(--atlas-secondary-800) !important;
}

.color-secondary-900 {
  color: var(--atlas-secondary-900) !important;
}

.bg-secondary-900 {
  background-color: var(--atlas-secondary-900) !important;
}

.active-secondary[active], .active-secondary.active, .active-secondary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-success {
  color: var(--atlas-success) !important;
}

.bg-success {
  background-color: var(--atlas-success) !important;
}

.color-success-100 {
  color: var(--atlas-success-100) !important;
}

.bg-success-100 {
  background-color: var(--atlas-success-100) !important;
}

.color-success-200 {
  color: var(--atlas-success-200) !important;
}

.bg-success-200 {
  background-color: var(--atlas-success-200) !important;
}

.color-success-300 {
  color: var(--atlas-success-300) !important;
}

.bg-success-300 {
  background-color: var(--atlas-success-300) !important;
}

.color-success-400 {
  color: var(--atlas-success-400) !important;
}

.bg-success-400 {
  background-color: var(--atlas-success-400) !important;
}

.color-success-500 {
  color: var(--atlas-success-500) !important;
}

.bg-success-500 {
  background-color: var(--atlas-success-500) !important;
}

.color-success-600 {
  color: var(--atlas-success-600) !important;
}

.bg-success-600 {
  background-color: var(--atlas-success-600) !important;
}

.color-success-700 {
  color: var(--atlas-success-700) !important;
}

.bg-success-700 {
  background-color: var(--atlas-success-700) !important;
}

.color-success-800 {
  color: var(--atlas-success-800) !important;
}

.bg-success-800 {
  background-color: var(--atlas-success-800) !important;
}

.color-success-900 {
  color: var(--atlas-success-900) !important;
}

.bg-success-900 {
  background-color: var(--atlas-success-900) !important;
}

.active-success[active], .active-success.active, .active-success:active {
  background-color: var(--atlas-success) !important;
  color: var(--atlas-contrast-success) !important;
}

.color-warning {
  color: var(--atlas-warning) !important;
}

.bg-warning {
  background-color: var(--atlas-warning) !important;
}

.color-warning-100 {
  color: var(--atlas-warning-100) !important;
}

.bg-warning-100 {
  background-color: var(--atlas-warning-100) !important;
}

.color-warning-200 {
  color: var(--atlas-warning-200) !important;
}

.bg-warning-200 {
  background-color: var(--atlas-warning-200) !important;
}

.color-warning-300 {
  color: var(--atlas-warning-300) !important;
}

.bg-warning-300 {
  background-color: var(--atlas-warning-300) !important;
}

.color-warning-400 {
  color: var(--atlas-warning-400) !important;
}

.bg-warning-400 {
  background-color: var(--atlas-warning-400) !important;
}

.color-warning-500 {
  color: var(--atlas-warning-500) !important;
}

.bg-warning-500 {
  background-color: var(--atlas-warning-500) !important;
}

.color-warning-600 {
  color: var(--atlas-warning-600) !important;
}

.bg-warning-600 {
  background-color: var(--atlas-warning-600) !important;
}

.color-warning-700 {
  color: var(--atlas-warning-700) !important;
}

.bg-warning-700 {
  background-color: var(--atlas-warning-700) !important;
}

.color-warning-800 {
  color: var(--atlas-warning-800) !important;
}

.bg-warning-800 {
  background-color: var(--atlas-warning-800) !important;
}

.color-warning-900 {
  color: var(--atlas-warning-900) !important;
}

.bg-warning-900 {
  background-color: var(--atlas-warning-900) !important;
}

.active-warning[active], .active-warning.active, .active-warning:active {
  background-color: var(--atlas-warning) !important;
  color: var(--atlas-contrast-warning) !important;
}

.color-danger {
  color: var(--atlas-danger) !important;
}

.bg-danger {
  background-color: var(--atlas-danger) !important;
}

.color-danger-100 {
  color: var(--atlas-danger-100) !important;
}

.bg-danger-100 {
  background-color: var(--atlas-danger-100) !important;
}

.color-danger-200 {
  color: var(--atlas-danger-200) !important;
}

.bg-danger-200 {
  background-color: var(--atlas-danger-200) !important;
}

.color-danger-300 {
  color: var(--atlas-danger-300) !important;
}

.bg-danger-300 {
  background-color: var(--atlas-danger-300) !important;
}

.color-danger-400 {
  color: var(--atlas-danger-400) !important;
}

.bg-danger-400 {
  background-color: var(--atlas-danger-400) !important;
}

.color-danger-500 {
  color: var(--atlas-danger-500) !important;
}

.bg-danger-500 {
  background-color: var(--atlas-danger-500) !important;
}

.color-danger-600 {
  color: var(--atlas-danger-600) !important;
}

.bg-danger-600 {
  background-color: var(--atlas-danger-600) !important;
}

.color-danger-700 {
  color: var(--atlas-danger-700) !important;
}

.bg-danger-700 {
  background-color: var(--atlas-danger-700) !important;
}

.color-danger-800 {
  color: var(--atlas-danger-800) !important;
}

.bg-danger-800 {
  background-color: var(--atlas-danger-800) !important;
}

.color-danger-900 {
  color: var(--atlas-danger-900) !important;
}

.bg-danger-900 {
  background-color: var(--atlas-danger-900) !important;
}

.active-danger[active], .active-danger.active, .active-danger:active {
  background-color: var(--atlas-danger) !important;
  color: var(--atlas-contrast-danger) !important;
}

.color-highlight {
  color: var(--atlas-highlight) !important;
}

.bg-highlight {
  background-color: var(--atlas-highlight) !important;
}

.color-highlight-100 {
  color: var(--atlas-highlight-100) !important;
}

.bg-highlight-100 {
  background-color: var(--atlas-highlight-100) !important;
}

.color-highlight-200 {
  color: var(--atlas-highlight-200) !important;
}

.bg-highlight-200 {
  background-color: var(--atlas-highlight-200) !important;
}

.color-highlight-300 {
  color: var(--atlas-highlight-300) !important;
}

.bg-highlight-300 {
  background-color: var(--atlas-highlight-300) !important;
}

.color-highlight-400 {
  color: var(--atlas-highlight-400) !important;
}

.bg-highlight-400 {
  background-color: var(--atlas-highlight-400) !important;
}

.color-highlight-500 {
  color: var(--atlas-highlight-500) !important;
}

.bg-highlight-500 {
  background-color: var(--atlas-highlight-500) !important;
}

.color-highlight-600 {
  color: var(--atlas-highlight-600) !important;
}

.bg-highlight-600 {
  background-color: var(--atlas-highlight-600) !important;
}

.color-highlight-700 {
  color: var(--atlas-highlight-700) !important;
}

.bg-highlight-700 {
  background-color: var(--atlas-highlight-700) !important;
}

.color-highlight-800 {
  color: var(--atlas-highlight-800) !important;
}

.bg-highlight-800 {
  background-color: var(--atlas-highlight-800) !important;
}

.color-highlight-900 {
  color: var(--atlas-highlight-900) !important;
}

.bg-highlight-900 {
  background-color: var(--atlas-highlight-900) !important;
}

.active-highlight[active], .active-highlight.active, .active-highlight:active {
  background-color: var(--atlas-highlight) !important;
  color: var(--atlas-contrast-highlight) !important;
}

.color-info {
  color: var(--atlas-info) !important;
}

.bg-info {
  background-color: var(--atlas-info) !important;
}

.color-info-100 {
  color: var(--atlas-info-100) !important;
}

.bg-info-100 {
  background-color: var(--atlas-info-100) !important;
}

.color-info-200 {
  color: var(--atlas-info-200) !important;
}

.bg-info-200 {
  background-color: var(--atlas-info-200) !important;
}

.color-info-300 {
  color: var(--atlas-info-300) !important;
}

.bg-info-300 {
  background-color: var(--atlas-info-300) !important;
}

.color-info-400 {
  color: var(--atlas-info-400) !important;
}

.bg-info-400 {
  background-color: var(--atlas-info-400) !important;
}

.color-info-500 {
  color: var(--atlas-info-500) !important;
}

.bg-info-500 {
  background-color: var(--atlas-info-500) !important;
}

.color-info-600 {
  color: var(--atlas-info-600) !important;
}

.bg-info-600 {
  background-color: var(--atlas-info-600) !important;
}

.color-info-700 {
  color: var(--atlas-info-700) !important;
}

.bg-info-700 {
  background-color: var(--atlas-info-700) !important;
}

.color-info-800 {
  color: var(--atlas-info-800) !important;
}

.bg-info-800 {
  background-color: var(--atlas-info-800) !important;
}

.color-info-900 {
  color: var(--atlas-info-900) !important;
}

.bg-info-900 {
  background-color: var(--atlas-info-900) !important;
}

.active-info[active], .active-info.active, .active-info:active {
  background-color: var(--atlas-info) !important;
  color: var(--atlas-contrast-info) !important;
}

:host {
  display: block;
  width: 100%;
}

.notification-card {
  display: flex;
  width: 100%;
  background: #ffffff;
  border-radius: 0.5rem;
  padding: 0.5rem;
  gap: 0.5rem;
  box-sizing: border-box;
  text-decoration: none;
  color: var(--atlas-secondary-600);
  border: 1px solid transparent;
  text-align: left;
  transition: background 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease;
}
.notification-card.interactive {
  cursor: pointer;
}
.notification-card.interactive:hover {
  background: var(--atlas-primary-100);
}
.notification-card.interactive:focus-visible {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-500-rgb), 0.25);
  border-color: var(--atlas-primary);
}

.visual-support {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--atlas-secondary-100);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.visual-support .visual-support-status {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: -4px;
  right: -4px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid #ffffff;
}
.visual-support .visual-support-status atlas-icon {
  width: 8px;
  height: 8px;
  font-size: 8px !important;
}

.body-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.25rem;
}
.body-wrapper .notification-card-header {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  width: 100%;
}
.body-wrapper .notification-card-header .notification-title {
  width: 100%;
  display: grid;
}
.body-wrapper .notification-card-header .notification-date {
  min-width: 50px;
}
.body-wrapper .notification-card-header .collapse-button {
  align-self: flex-start;
}

@media screen and (min-width: 992px) {
  .notification-card {
    padding: 0.75rem;
    gap: 0.75rem;
  }
  .visual-support {
    width: 40px;
    height: 40px;
  }
  .visual-support .visual-support-status {
    width: 16px;
    height: 16px;
  }
  .visual-support .visual-support-status atlas-icon {
    width: 12px;
    height: 12px;
    font-size: 12px !important;
  }
}`;

// src/components/structure/atlas-notification-center-card/atlas-notification-center-card.ts
var AtlasNotificationCenterCard = /*#__PURE__*/(() => {
  let AtlasNotificationCenterCard = class extends AtlasElement {
    constructor() {
      super();
      this.status = "none";
      this.read = false;
      this.disableEllipsis = false;
      this.hasAction = false;
      this._showCollapseButton = true;
      this._collapsed = true;
      this._deviceController = new DeviceController(this);
      this.verifyCanShowCollapseButton = this.verifyCanShowCollapseButton.bind(this);
      this.onClickToggleCollapse = this.onClickToggleCollapse.bind(this);
    }
    /** @internal */
    connectedCallback() {
      super.connectedCallback();
      this.verifyCanShowCollapseButton();
    }
    getStatusIcon() {
      const statusIconMap = {
        "success": "check",
        "error": "x",
        "attention": "alert",
        "in progress": "clock",
        "none": ""
      };
      return statusIconMap[this.status] || "";
    }
    getStatusTheme() {
      const statusThemeMap = {
        "success": "success",
        "error": "danger",
        "attention": "warning",
        "in progress": "info",
        "none": ""
      };
      return statusThemeMap[this.status] || "";
    }
    textElementHasEllipsis(textElement) {
      const wrapper = textElement.getTextWrapper();
      const contentHeight = wrapper.getBoundingClientRect().height;
      return Math.round(contentHeight) < wrapper.scrollHeight;
    }
    verifyCanShowCollapseButton() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const titleHasEllipsis = this.textElementHasEllipsis(this.shadowRoot.querySelector(".notification-title"));
        const contentHasEllipsis = this.textElementHasEllipsis(this.shadowRoot.querySelector(".notification-text"));
        this._showCollapseButton = titleHasEllipsis || contentHasEllipsis;
      });
    }
    onClickToggleCollapse(event) {
      event.stopPropagation();
      event.preventDefault();
      this._collapsed = !this._collapsed;
      this.shadowRoot.querySelectorAll("atlas-collapsible-text").forEach(text => {
        text.toggleExpandText();
      });
    }
    onClickNotification() {
      emit(this, "atlas-notification-center-card-click", {});
    }
    renderStatusIcon() {
      return when84(this.status !== "none" && !this.skeletonLoading, () => html132`
                <div class="visual-support-status bg-${this.getStatusTheme()}">
                    <atlas-icon name="${this.getStatusIcon()}" size="auto" white></atlas-icon>
                </div>
            `);
    }
    renderCollapseButton() {
      return when84(!this.disableEllipsis && this._showCollapseButton, () => html132`
                <atlas-collapse-button
                    size="2x"
                    ?collapsed=${this._collapsed}
                    @click=${this.onClickToggleCollapse}
                    class="collapse-button"
                ></atlas-collapse-button>
            `);
    }
    renderNotificationDate() {
      return when84(!!this.date, () => html132`
                <div class="notification-date">
                    <atlas-text size="xs" muted>${formatDate(this.date, {
        yearLastDigits: true
      })}</atlas-text>
                </div>
            `);
    }
    renderNotificationContent() {
      return html132`
            <div class="visual-support">
                <atlas-icon name="${this.icon}" size="2x"></atlas-icon>
                ${this.renderStatusIcon()}
            </div>
            <div class="body-wrapper">
                <div class="notification-card-header">
                    <atlas-collapsible-text
                        class="notification-title"
                        size=${this._deviceController.isMobile ? "xs" : "sm"}
                        ?bold=${!this.read}
                        ?muted=${this.read}
                        line-clamp=${ifDefined23(this.disableEllipsis ? void 0 : "1")}
                        hide-toggle-button
                        normal-white-space
                    >
                        ${this.header}
                    </atlas-collapsible-text>
                    ${this.renderNotificationDate()} ${this.renderCollapseButton()}
                </div>
                <atlas-collapsible-text
                    class="notification-text"
                    size="xs"
                    ?muted=${this.read}
                    line-clamp=${ifDefined23(this.disableEllipsis ? void 0 : "2")}
                    hide-toggle-button
                    normal-white-space
                >
                    <slot @slotchange=${this.verifyCanShowCollapseButton}></slot>
                </atlas-collapsible-text>
            </div>
        `;
    }
    /** @internal */
    render() {
      if (this.href) {
        return html132`
                <a class="notification-card interactive" href="${this.href}" @click=${this.onClickNotification}>
                    ${this.renderNotificationContent()}
                </a>
            `;
      }
      if (this.hasAction) {
        return html132`
                <button class="notification-card interactive" @click=${this.onClickNotification}>
                    ${this.renderNotificationContent()}
                </button>
            `;
      }
      return html132`<div class="notification-card">${this.renderNotificationContent()}</div>`;
    }
  };
  AtlasNotificationCenterCard.styles = atlas_notification_center_card_default;
  return AtlasNotificationCenterCard;
})();
__decorateClass([property137({
  type: String
})], AtlasNotificationCenterCard.prototype, "header", 2);
__decorateClass([property137({
  type: String
})], AtlasNotificationCenterCard.prototype, "date", 2);
__decorateClass([property137({
  type: String
})], AtlasNotificationCenterCard.prototype, "status", 2);
__decorateClass([property137({
  type: String
})], AtlasNotificationCenterCard.prototype, "icon", 2);
__decorateClass([property137({
  type: Boolean
})], AtlasNotificationCenterCard.prototype, "read", 2);
__decorateClass([property137({
  type: Boolean,
  attribute: "disable-ellipsis"
})], AtlasNotificationCenterCard.prototype, "disableEllipsis", 2);
__decorateClass([property137({
  type: String
})], AtlasNotificationCenterCard.prototype, "href", 2);
__decorateClass([property137({
  type: Boolean,
  attribute: "has-action"
})], AtlasNotificationCenterCard.prototype, "hasAction", 2);
__decorateClass([state67()], AtlasNotificationCenterCard.prototype, "_showCollapseButton", 2);
__decorateClass([state67()], AtlasNotificationCenterCard.prototype, "_collapsed", 2);
AtlasNotificationCenterCard = __decorateClass([customElement132("atlas-notification-center-card")], AtlasNotificationCenterCard);

// src/components/structure/atlas-notification-center-group/atlas-notification-center-group.ts
import { html as html133 } from "lit";
import { customElement as customElement133, property as property138 } from "lit/decorators.js";

// src/components/structure/atlas-notification-center-group/atlas-notification-center-group.scss
import { css as css119 } from "lit-element/lit-element.js";
var atlas_notification_center_group_default = css119`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: block;
  width: 100%;
}

.notification-group,
.notification-group-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.25rem;
}`;

// src/components/structure/atlas-notification-center-group/atlas-notification-center-group.ts
var AtlasNotificationCenterGroup = /*#__PURE__*/(() => {
  let AtlasNotificationCenterGroup = class extends AtlasElement {
    /** @internal */
    render() {
      return html133`
            <div class="notification-group">
                <atlas-text size="sm" bold muted>${this.header}</atlas-text>
                <div class="notification-group-content">
                    <slot></slot>
                </div>
            </div>
        `;
    }
  };
  AtlasNotificationCenterGroup.styles = atlas_notification_center_group_default;
  return AtlasNotificationCenterGroup;
})();
__decorateClass([property138({
  type: String
})], AtlasNotificationCenterGroup.prototype, "header", 2);
AtlasNotificationCenterGroup = __decorateClass([customElement133("atlas-notification-center-group")], AtlasNotificationCenterGroup);

// src/components/structure/atlas-screen/atlas-screen.ts
import { LitElement as LitElement36, html as html134 } from "lit";
import { customElement as customElement134, property as property139, queryAssignedElements as queryAssignedElements8 } from "lit/decorators.js";
import { classMap as classMap91 } from "lit/directives/class-map.js";

// src/components/structure/atlas-screen/atlas-screen.scss
import { css as css120 } from "lit-element/lit-element.js";
var atlas_screen_default = css120`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
:host {
  height: 100%;
  width: 100%;
}

:host([fullscreen]) {
  display: block;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  scroll-behavior: smooth;
}

.screen-wrapper {
  min-height: 100%;
  width: 100%;
  display: flex;
}

.screen-sidebar {
  flex: 0 0 auto;
}

.screen-content {
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.screen-navbar {
  width: 100%;
}

.screen-body {
  width: 100%;
  background: var(--atlas-light);
  flex: 1 1 auto;
  box-sizing: border-box;
}
.screen-body.background-white {
  background: #ffffff;
}`;

// src/components/structure/atlas-screen/atlas-screen.ts
var AtlasScreen = /*#__PURE__*/(() => {
  let AtlasScreen = class extends LitElement36 {
    constructor() {
      super();
      this.fullscreen = false;
      this.white = false;
      this._deviceController = new DeviceController(this, this.onChangeScreenType.bind(this));
      this.onSidebarToggleClick = this.onSidebarToggleClick.bind(this);
      this.onMobileSidebarToggle = this.onMobileSidebarToggle.bind(this);
    }
    /** @internal */
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.addEventListener("atlas-sidebar-toggle-click", this.onSidebarToggleClick);
      this.addEventListener("atlas-sidebar-toggle", this.onMobileSidebarToggle);
    }
    /** @internal */
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      this.removeEventListener("atlas-sidebar-toggle-click", this.onSidebarToggleClick);
      this.removeEventListener("atlas-sidebar-toggle", this.onMobileSidebarToggle);
    }
    /**
     * Retorna a referência do componente atlas-sidebar presente no slot correspondente (se houver)
     * @returns {AtlasSidebar | AtlasNewSidebar} - A referência do componente atlas-sidebar ou atlas-new-sidebar
     */
    getSlottedSidebar() {
      var _a;
      return (_a = this._slottedSidebar) == null ? void 0 : _a[0];
    }
    /**
     * Retorna a referência do componente atlas-navbar presente no slot correspondente (se houver)
     * @returns {AtlasNavbar} - A referência do componente atlas-navbar
     */
    getSlottedNavbar() {
      var _a;
      return (_a = this._slottedNavbar) == null ? void 0 : _a[0];
    }
    toggleCollapseSidebar() {
      const slottedSidebar = this.getSlottedSidebar();
      if (slottedSidebar.tagName === "ATLAS-SIDEBAR") {
        slottedSidebar.onToggleCollapse();
        return;
      }
      slottedSidebar.toggleCollapse();
    }
    onChangeScreenType() {
      this.onMobileSidebarToggle();
    }
    onSidebarToggleClick() {
      this.toggleCollapseSidebar();
      window.scroll(0, 0);
    }
    onMobileSidebarToggle() {
      const sidebar = this.getSlottedSidebar();
      if (sidebar) {
        setTimeout(() => {
          document.body.classList.toggle("disable-scroll", this._deviceController.isMobile && !sidebar.collapsed);
        }, 0);
      }
    }
    renderSidebar() {
      return html134`
            <div class="screen-sidebar">
                <slot name="sidebar"></slot>
            </div>
        `;
    }
    renderNavbar() {
      return html134`
            <div class="screen-navbar">
                <slot name="navbar"></slot>
            </div>
        `;
    }
    renderBody() {
      const bodyClass = {
        "screen-body": true,
        "background-white": this.white
      };
      return html134`
            <div class=${classMap91(bodyClass)} part="screen-body">
                <slot></slot>
            </div>
        `;
    }
    /** @internal */
    render() {
      return html134`
            <div class="screen-wrapper">
                ${this.renderSidebar()}
                <div class="screen-content">${this.renderNavbar()} ${this.renderBody()}</div>
            </div>
        `;
    }
  };
  AtlasScreen.styles = atlas_screen_default;
  return AtlasScreen;
})();
__decorateClass([property139({
  type: Boolean,
  reflect: true
})], AtlasScreen.prototype, "fullscreen", 2);
__decorateClass([property139({
  type: Boolean,
  reflect: true
})], AtlasScreen.prototype, "white", 2);
__decorateClass([queryAssignedElements8({
  selector: "atlas-navbar",
  flatten: true,
  slot: "navbar"
})], AtlasScreen.prototype, "_slottedNavbar", 2);
__decorateClass([queryAssignedElements8({
  selector: "atlas-sidebar, atlas-new-sidebar",
  flatten: true,
  slot: "sidebar"
})], AtlasScreen.prototype, "_slottedSidebar", 2);
AtlasScreen = __decorateClass([customElement134("atlas-screen")], AtlasScreen);

// src/components/structure/atlas-sidebar/atlas-sidebar.ts
import { LitElement as LitElement37, html as html135 } from "lit";
import { customElement as customElement135, property as property140, queryAssignedElements as queryAssignedElements9 } from "lit/decorators.js";
import { classMap as classMap92 } from "lit/directives/class-map.js";
import { when as when85 } from "lit/directives/when.js";
import Cookies2 from "js-cookie";

// src/components/structure/atlas-sidebar/atlas-sidebar.scss
import { css as css121 } from "lit-element/lit-element.js";
var atlas_sidebar_default = css121`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Transitions */
/* Z-index mapping for the floating elements */
/* Shadows */
/* Elevations */
:host {
  display: block;
  padding-top: 64px;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 15;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  opacity: 1;
  transition: opacity 0.25s;
}

:host([collapsed]) {
  opacity: 0;
  pointer-events: none;
}

.sidebar {
  width: 280px;
  height: 100%;
  background: #ffffff;
  transition: width 0.5s ease;
}
.sidebar .collapse-button {
  position: absolute;
  display: none;
  top: 64px;
  right: 0;
  padding: 4px 4px 4px 0;
  transform: translateX(100%);
  border: 0;
  border-radius: 0 40px 40px 0;
  background: var(--atlas-primary-100);
  box-shadow: 4px 0 4px rgba(0, 0, 0, 0.1);
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: -1;
}
.sidebar .collapse-button atlas-icon {
  transition: transform 0.5s ease;
  transform-origin: center;
}
.sidebar .collapse-button:focus-visible {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-500-rgb), 0.25);
}
.sidebar .sidebar-mobile-header {
  position: absolute;
  top: 0;
  left: 0;
  height: 64px;
  width: 100%;
  display: flex;
  align-items: center;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  padding: 16px 32px;
  box-sizing: border-box;
  gap: 24px;
}
.sidebar .sidebar-mobile-header .title {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.25;
  color: #687078;
}
.sidebar .sidebar-mobile-header .close-mobile {
  display: inline-flex;
  background: none;
  padding: 0;
  border: 0;
}
.sidebar .sidebar-content {
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  padding: 24px 16px;
  box-sizing: border-box;
  overflow: hidden auto;
  height: 100%;
}
.sidebar .sidebar-content .product-logo {
  height: 50px;
  display: none;
  align-self: center;
  width: 100%;
  text-decoration: none;
  position: relative;
}
.sidebar .sidebar-content .product-logo img {
  height: 100%;
  width: 100%;
  top: 0;
  transition: opacity 0.5s ease;
}
.sidebar .sidebar-content .product-logo .logo-default {
  position: absolute;
  opacity: 1;
}
.sidebar .sidebar-content .product-logo .logo-collapsed {
  position: absolute;
  opacity: 0;
}
.sidebar .sidebar-content .sidebar-header {
  display: none;
  width: 100%;
}
.sidebar .sidebar-content .sidebar-body {
  width: 100%;
}

.sidebar.collapsed {
  width: 88px;
}
.sidebar.collapsed .collapse-button atlas-icon {
  transform: rotate(180deg);
}
.sidebar.collapsed .sidebar-content .product-logo .logo-default {
  opacity: 0;
}
.sidebar.collapsed .sidebar-content .product-logo .logo-collapsed {
  opacity: 1;
}

@media screen and (min-width: 992px) {
  :host {
    width: auto;
    position: relative;
    min-height: 100%;
    box-shadow: 1px 0 4px rgba(0, 0, 0, 0.1);
    padding-top: 0;
  }
  :host([collapsed]) {
    opacity: 1;
    pointer-events: unset;
  }
  .sidebar .collapse-button {
    display: flex;
  }
  .sidebar .sidebar-content {
    height: auto;
    overflow: visible;
  }
  .sidebar .sidebar-content .product-logo,
  .sidebar .sidebar-content .sidebar-header {
    display: block;
  }
}`;

// src/components/structure/atlas-sidebar/atlas-sidebar.ts
var {
  name,
  config
} = SIDEBAR_COLLAPSE_COOKIE;
var AtlasSidebar = /*#__PURE__*/(() => {
  let AtlasSidebar = class extends LitElement37 {
    constructor() {
      super(...arguments);
      this.product = "asaas";
      this.defaultCollapsed = false;
      this.collapsed = false;
      this.deviceController = new DeviceController(this, this.onChangeScreenType.bind(this));
      this.collapseCookieName = name;
    }
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onChangeScreenType();
      this.initCookies();
    }
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
    }
    getNavbarTitle() {
      var _a;
      return ((_a = document.querySelector("atlas-navbar")) == null ? void 0 : _a.getAttribute("page-title")) || "";
    }
    onDocumentClick(event) {
      const sidebarElement = this.renderRoot.querySelector(".sidebar");
      if (this.collapsed || event.composedPath().includes(sidebarElement)) {
        return;
      }
      this.onToggleCollapse();
    }
    onChangeScreenType() {
      this.collapsed = this.deviceController.isMobile ? true : !!this.getCookieCollapseValue();
      this.emitCollapseEvent();
      this.bindDocumentClick();
    }
    onToggleCollapse() {
      this.collapsed = !this.collapsed;
      if (!this.deviceController.isMobile) {
        Cookies2.set(this.collapseCookieName, this.collapsed.toString(), config);
      }
      this.emitCollapseEvent();
      this.bindDocumentClick();
    }
    emitCollapseEvent() {
      emit(this, "atlas-sidebar-toggle", {
        detail: {
          collapsed: this.collapsed
        }
      });
    }
    bindDocumentClick() {
      if (this.deviceController.isMobile && !this.collapsed) {
        document.addEventListener("click", this.onDocumentClick);
        return;
      }
      document.removeEventListener("click", this.onDocumentClick);
    }
    getCookieCollapseValue() {
      const cookieValue = Cookies2.get(this.collapseCookieName);
      if (typeof cookieValue !== "string") {
        return null;
      }
      return cookieValue === "true";
    }
    initCookies() {
      if (this.deviceController.isMobile) return;
      const cookieValue = this.getCookieCollapseValue();
      if (cookieValue !== null) {
        this.collapsed = cookieValue;
        return;
      }
      this.collapsed = this.defaultCollapsed;
      Cookies2.set(this.collapseCookieName, this.defaultCollapsed.toString(), config);
    }
    shrinkSlottedMenus() {
      this.slottedMenus.forEach(element => {
        element.toggleAttribute("shrinked", this.collapsed);
      });
    }
    renderProductLogo() {
      const product = product_info_default.getProductInfo(this.product);
      return html135`
            <img
                class="logo-default"
                src="${this.productLogo || getAssetPath(product.logoDefault)}"
                title="${product.name}"
                alt="${product.alt}"
            />
            <img
                class="logo-collapsed"
                src="${this.productLogoSmall || getAssetPath(product.logoMini)}"
                title="${product.name}"
                alt="${product.alt}"
            />
        `;
    }
    renderCollapseButton() {
      return html135`
            <button class="collapse-button" @click=${this.onToggleCollapse}>
                <atlas-icon name="chevron-left" size="3x" theme="primary"></atlas-icon>
            </button>
        `;
    }
    renderMobileHeader() {
      return when85(this.deviceController.isMobile, () => html135`
                <div class="sidebar-mobile-header">
                    <button class="close-mobile" @click=${this.onToggleCollapse}>
                        <atlas-icon name="x" size="3x" theme="primary"></atlas-icon>
                    </button>
                    <span class="title">${this.getNavbarTitle()}</span>
                </div>
            `);
    }
    render() {
      const sidebarClass = {
        sidebar: true,
        collapsed: this.collapsed
      };
      return html135`
            <nav class="${classMap92(sidebarClass)}">
                ${this.renderCollapseButton()} ${this.renderMobileHeader()}
                <div class="sidebar-content">
                    <a class="product-logo" href="${this.homePath || product_info_default.getHomePage(this.product)}">
                        ${this.renderProductLogo()}
                    </a>
                    <div class="sidebar-header">
                        <slot name="header"></slot>
                    </div>
                    <div class="sidebar-body">
                        <slot name="body" @slotchange=${this.shrinkSlottedMenus}></slot>
                    </div>
                </div>
            </nav>
        `;
    }
  };
  AtlasSidebar.styles = atlas_sidebar_default;
  return AtlasSidebar;
})();
__decorateClass([property140({
  type: String
})], AtlasSidebar.prototype, "product", 2);
__decorateClass([property140({
  type: String,
  attribute: "product-logo"
})], AtlasSidebar.prototype, "productLogo", 2);
__decorateClass([property140({
  type: String,
  attribute: "product-logo-small"
})], AtlasSidebar.prototype, "productLogoSmall", 2);
__decorateClass([property140({
  type: String,
  attribute: "home-path"
})], AtlasSidebar.prototype, "homePath", 2);
__decorateClass([property140({
  type: Boolean,
  attribute: "default-collapsed"
})], AtlasSidebar.prototype, "defaultCollapsed", 2);
__decorateClass([property140({
  type: Boolean,
  reflect: true
})], AtlasSidebar.prototype, "collapsed", 2);
__decorateClass([queryAssignedElements9({
  slot: "body",
  selector: "atlas-sidebar-menu"
})], AtlasSidebar.prototype, "slottedMenus", 2);
__decorateClass([Watch("collapsed", true)], AtlasSidebar.prototype, "shrinkSlottedMenus", 1);
AtlasSidebar = __decorateClass([customElement135("atlas-sidebar")], AtlasSidebar);

// src/components/structure/atlas-sidebar-menu-context/atlas-sidebar-menu-context.ts
import { html as html136 } from "lit";
import { customElement as customElement136, property as property141, query as query23, state as state68 } from "lit/decorators.js";
import { classMap as classMap93 } from "lit/directives/class-map.js";
import { when as when86 } from "lit/directives/when.js";

// src/components/structure/atlas-sidebar-menu-context/atlas-sidebar-menu-context.scss
import { css as css122 } from "lit-element/lit-element.js";
var atlas_sidebar_menu_context_default = css122`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  width: 100%;
  display: inline-block;
  box-sizing: border-box;
  position: relative;
}

.atlas-sidebar-menu-context-content-slot {
  display: none !important;
}

.atlas-sidebar-menu-context {
  border: none;
  margin: 0;
  background: none;
  cursor: pointer;
  width: 100%;
  height: 48px;
  box-sizing: border-box;
  padding: 0.75rem 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-radius: 2rem;
  transition: color 0.25s ease;
}
.atlas-sidebar-menu-context:hover {
  background-color: rgba(var(--atlas-secondary-700-rgb), 10%);
}
.atlas-sidebar-menu-context.active {
  background-color: var(--atlas-primary-100);
}
.atlas-sidebar-menu-context:focus {
  outline: none;
  background-color: rgba(var(--atlas-secondary-700-rgb), 10%);
}
.atlas-sidebar-menu-context .atlas-sidebar-menu-context-text {
  flex: 2;
  text-align: start;
}

@media screen and (min-width: 992px) {
  :host {
    width: calc(56px + 2rem);
  }
  .atlas-sidebar-menu-context-wrapper {
    position: relative;
  }
  .atlas-sidebar-menu-context-popover-content {
    height: 100%;
    padding: 1rem;
    max-height: calc(400px - 2rem);
    overflow-y: auto;
    border-radius: 1rem;
  }
  .atlas-sidebar-menu-context-popover-content::-webkit-scrollbar-track {
    background-color: #ffffff;
    border-radius: 1rem;
  }
  .atlas-sidebar-menu-context-popover-content::-webkit-scrollbar {
    width: 24px;
    background-color: #ffffff;
    border-radius: 1rem;
  }
  .atlas-sidebar-menu-context-popover-content::-webkit-scrollbar-thumb {
    background-color: #adb5bd;
    border-radius: 1rem;
    border: 8px solid #ffffff;
  }
  .atlas-sidebar-menu-context {
    width: 100%;
    height: fit-content;
    flex-direction: column;
    justify-content: center;
    border-radius: 0;
    padding: 0;
    gap: 0;
  }
  .atlas-sidebar-menu-context .atlas-sidebar-menu-context-icon {
    padding: 0.5rem 1rem;
    transition: background-color 0.25s ease;
    border-radius: 2rem;
  }
  .atlas-sidebar-menu-context .atlas-sidebar-menu-context-text {
    flex: auto;
    text-align: center;
  }
  .atlas-sidebar-menu-context:hover, .atlas-sidebar-menu-context:focus {
    background: none;
  }
  .atlas-sidebar-menu-context:hover .atlas-sidebar-menu-context-icon, .atlas-sidebar-menu-context:focus .atlas-sidebar-menu-context-icon {
    background-color: rgba(var(--atlas-secondary-700-rgb), 10%);
  }
  .atlas-sidebar-menu-context.active {
    background: none;
  }
  .atlas-sidebar-menu-context.active .atlas-sidebar-menu-context-icon {
    background-color: var(--atlas-primary-100);
  }
}`;

// src/components/structure/atlas-sidebar-menu-context/atlas-sidebar-menu-context.ts
var AtlasSidebarMenuContext = /*#__PURE__*/(() => {
  let AtlasSidebarMenuContext = class extends AtlasElement {
    /** @internal */
    constructor() {
      super();
      this.active = false;
      this.itemsVisible = false;
      this.sidebarCollapsed = false;
      this._slottedItems = [];
      this._activeSlottedItem = null;
      this._deviceController = new DeviceController(this);
      this.bindMethods();
    }
    disconnectedCallback() {
      var _a, _b;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      (_b = this._mainSlot) == null ? void 0 : _b.removeEventListener("atlas-element-update", this.onSlottedItemsUpdateProperties);
    }
    /** @internal */
    syncActive() {
      this._activeSlottedItem = this._slottedItems.find(slottedItem => slottedItem.active) || null;
      this.active = this._activeSlottedItem !== null;
      if (!this.active) return;
      this.emitActivateEvent();
    }
    /**
     * @internal
     * Retorna os itens de menu associados ao menu de contexto
     * @returns {AtlasSidebarMenuItem[]} - Os itens de menu associados ao menu de contexto
     */
    getItems() {
      return this._slottedItems;
    }
    /**
     * @internal
     * Ativa o menu de contexto a partir de um item de menu ativo
     */
    activate(item) {
      if (!item || item === this._activeSlottedItem) return;
      this._activeSlottedItem = item;
      this._activeSlottedItem.toggleAttribute("active", true);
      this.active = true;
      this.emitActivateEvent();
    }
    /**
     * @internal
     * Desativa o menu de contexto
     */
    deactivate() {
      var _a;
      if (!this.active) return;
      (_a = this._activeSlottedItem) == null ? void 0 : _a.toggleAttribute("active", false);
      this.active = false;
    }
    bindMethods() {
      this.onClick = this.onClick.bind(this);
      this.onContentSlotChanged = this.onContentSlotChanged.bind(this);
      this.onSlottedItemsUpdateProperties = this.onSlottedItemsUpdateProperties.bind(this);
    }
    emitActivateEvent() {
      emit(this, "atlas-sidebar-menu-context-active");
    }
    getTheme() {
      return this.active ? "primary" : "secondary";
    }
    getSlottedItemByHref() {
      if (!this.href || this._slottedItems.length === 0) return null;
      return this._slottedItems.find(item => item.href === this.href) || null;
    }
    onContentSlotChanged() {
      return __async(this, null, function* () {
        var _a, _b, _c;
        yield this.updateComplete;
        const assignedElements = ((_a = this._mainSlot) == null ? void 0 : _a.assignedElements()) || [];
        const items = filterElementsByTagNames(assignedElements, ["ATLAS-SIDEBAR-MENU-ITEM"]);
        this._slottedItems = [...items];
        (_b = this._mainSlot) == null ? void 0 : _b.removeEventListener("atlas-element-update", this.onSlottedItemsUpdateProperties);
        (_c = this._mainSlot) == null ? void 0 : _c.addEventListener("atlas-element-update", this.onSlottedItemsUpdateProperties);
        this.syncActive();
        emit(this, "atlas-sidebar-menu-context-change-slotted-items", {
          trackDisable: true
        });
      });
    }
    onClick() {
      const anchorItem = this.getSlottedItemByHref();
      if (anchorItem) {
        anchorItem.click();
        this.activate(anchorItem);
      }
      emit(this, "atlas-sidebar-menu-context-click");
    }
    onSlottedItemsUpdateProperties(event) {
      return __async(this, null, function* () {
        const item = event.target;
        const popoverItem = yield this.getPopoverItem(item);
        const cloneItem = item.cloneNode(true);
        cloneItem.toggleAttribute("in-menu-context", true);
        cloneItem.toggleAttribute("in-menu-context-popover", true);
        popoverItem == null ? void 0 : popoverItem.replaceWith(cloneItem);
        emit(this, "atlas-sidebar-menu-context-slotted-item-update", {
          detail: {
            item
          },
          trackDisable: true
        });
      });
    }
    getPopoverItem(item) {
      return __async(this, null, function* () {
        yield this.updateComplete;
        if (!this.hasPopover()) return null;
        const popover = this.shadowRoot.querySelector("atlas-popover");
        const selector = `atlas-sidebar-menu-item[value="${item.value}"][text="${item.text}"]`;
        const popoverItem = popover.querySelector(selector);
        return popoverItem;
      });
    }
    hasPopover() {
      return !this._deviceController.isMobile && !this.href && (this.sidebarCollapsed || !this.itemsVisible);
    }
    renderIcon() {
      return html136`
            <atlas-icon class="atlas-sidebar-menu-context-icon" name=${this.icon} theme=${this.getTheme()}>
            </atlas-icon>
        `;
    }
    renderText() {
      return html136`
            <atlas-text
                class="atlas-sidebar-menu-context-text"
                ?bold=${this.active && !this._deviceController.isMobile}
                size=${this._deviceController.isMobile ? "md" : "xs"}
                theme=${this.getTheme()}
            >
                ${this.text}
            </atlas-text>
        `;
    }
    renderRightArrow() {
      return when86(this._deviceController.isMobile, () => html136` <atlas-icon name="chevron-right" theme=${this.getTheme()}></atlas-icon> `);
    }
    renderContentSlot() {
      return html136`
            <slot class="atlas-sidebar-menu-context-content-slot" @slotchange=${this.onContentSlotChanged}> </slot>
        `;
    }
    renderPopover() {
      const popoverItems = this._slottedItems.map(item => item.cloneNode(true));
      popoverItems.forEach(item => {
        item.toggleAttribute("in-menu-context", true);
        item.toggleAttribute("in-menu-context-popover", true);
      });
      return when86(this.hasPopover(), () => html136`
                <atlas-popover
                    width="284"
                    max-height="400"
                    trigger="hover"
                    in-menu-context
                    placement="right-start"
                    id="atlas-sidebar-menu-context-popover"
                >
                    <div class="atlas-sidebar-menu-context-popover-content">
                        <atlas-sidebar-menu> ${popoverItems} </atlas-sidebar-menu>
                    </div>
                </atlas-popover>
            `);
    }
    /** @internal */
    render() {
      const menuContextClass = {
        "atlas-sidebar-menu-context": true,
        "active": this.active
      };
      return html136`
            <div class="atlas-sidebar-menu-context-wrapper" data-atlas-popover="atlas-sidebar-menu-context-popover">
                <button class=${classMap93(menuContextClass)} @click=${this.onClick}>
                    ${this.renderIcon()} ${this.renderText()} ${this.renderRightArrow()}
                </button>
                ${this.renderContentSlot()} ${this.renderPopover()}
            </div>
        `;
    }
  };
  AtlasSidebarMenuContext.styles = atlas_sidebar_menu_context_default;
  return AtlasSidebarMenuContext;
})();
__decorateClass([property141({
  type: String
})], AtlasSidebarMenuContext.prototype, "icon", 2);
__decorateClass([property141({
  type: String
})], AtlasSidebarMenuContext.prototype, "text", 2);
__decorateClass([property141({
  type: Boolean,
  reflect: true
})], AtlasSidebarMenuContext.prototype, "active", 2);
__decorateClass([property141({
  type: String
})], AtlasSidebarMenuContext.prototype, "href", 2);
__decorateClass([property141({
  type: Boolean,
  attribute: "items-visible",
  reflect: true
})], AtlasSidebarMenuContext.prototype, "itemsVisible", 2);
__decorateClass([property141({
  type: Boolean,
  attribute: "sidebar-collapsed",
  reflect: true
})], AtlasSidebarMenuContext.prototype, "sidebarCollapsed", 2);
__decorateClass([query23("slot:not([name])")], AtlasSidebarMenuContext.prototype, "_mainSlot", 2);
__decorateClass([state68()], AtlasSidebarMenuContext.prototype, "_slottedItems", 2);
AtlasSidebarMenuContext = __decorateClass([customElement136("atlas-sidebar-menu-context")], AtlasSidebarMenuContext);

// src/components/structure/atlas-sidebar-menu-group/atlas-sidebar-menu-group.ts
import { LitElement as LitElement38, html as html137 } from "lit";
import { customElement as customElement137, property as property142, queryAssignedElements as queryAssignedElements10 } from "lit/decorators.js";
import { styleMap as styleMap25 } from "lit/directives/style-map.js";
import { when as when87 } from "lit/directives/when.js";

// src/components/structure/atlas-sidebar-menu-group/atlas-sidebar-menu-group.scss
import { css as css123 } from "lit-element/lit-element.js";
var atlas_sidebar_menu_group_default = css123`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Transitions */
:host {
  display: block;
}

.sidebar-menu-group-header {
  padding: 0.25rem 1rem;
}
.sidebar-menu-group-header.collapsible {
  align-items: center;
  background: none;
  border: 0;
  border-radius: 9999px;
  color: #687078;
  display: flex;
  gap: 0.5rem;
  overflow: hidden;
  text-align: left;
  transition: background 0.25s ease, color 0.25s ease;
  width: 100%;
  cursor: pointer;
  box-sizing: border-box;
  text-decoration: none;
  position: relative;
}
.sidebar-menu-group-header.collapsible:hover {
  background: rgba(var(--atlas-secondary-700-rgb), 5%);
}
.sidebar-menu-group-header.collapsible:focus-visible {
  outline: 4px solid rgba(var(--atlas-primary-rgb), 25%);
  outline-offset: -4px;
}`;

// src/components/structure/atlas-sidebar-menu-group/atlas-sidebar-menu-group.ts
var ComposedClass9 = WithTooltipMixin(WithCollapseMixin(LitElement38));
var AtlasSidebarMenuGroup = /*#__PURE__*/(() => {
  let AtlasSidebarMenuGroup = class extends ComposedClass9 {
    constructor() {
      super();
      this.enableDivider = false;
      this.shrinked = false;
      this.active = false;
      this._tooltipId = "";
      this.onGroupIconClick = this.onGroupIconClick.bind(this);
    }
    connectedCallback() {
      var _a, _b;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      if ((_b = this.text) == null ? void 0 : _b.trim()) {
        this.tooltip = this.text;
        this.tooltipPlacement = "right";
        this.tooltipTrigger = "hover";
        this._tooltipId = this.text.trim().toLowerCase().replace(/\s+/g, "-");
      }
      this.updateComplete.then(() => {
        this.syncActive();
        this.syncCollapsed();
        if (this.collapsed && this.expanded) {
          this.collapsed = false;
        }
      });
    }
    /**
     * @override
     * @internal
     */
    hasTooltip() {
      return !!this.tooltip && this.shrinked && !!this.text;
    }
    /**
     * Retorna os itens do grupo
     * @returns {AtlasSidebarMenuItem[]} - Os itens do grupo.
     */
    getItems() {
      return this._slottedItems;
    }
    /**
     * Sincroniza o estado colapsado do grupo de acordo com o estado dos seus itens.
     * Se o grupo for colapsável, ele será colapsado se todos os itens do grupo não estiverem ativos.
     */
    syncCollapsed() {
      if (!this.collapsible) return;
      this.collapsed = this._slottedItems.every(item => !item.active);
    }
    /**
     * Sincroniza o estado de ativo do grupo de acordo com o estado dos seus itens.
     * Ele será definido como ativo se um item do grupo estiver ativo.
     */
    syncActive() {
      this.active = this._slottedItems.some(item => item.active);
    }
    getTheme() {
      return this.active ? "primary" : "secondary";
    }
    onGroupIconClick() {
      if (!this.collapsible || !this.shrinked) return;
      this.collapsed = !this.collapsed;
    }
    /**
     * @override
     * @internal
     */
    renderCollapseButton() {
      const theme = this.getTheme();
      return when87(this.collapsible && !this.shrinked, () => super.renderCollapseButton("none", theme));
    }
    renderDivider() {
      return when87(this.text || this.collapsible || this.enableDivider, () => html137`<atlas-divider spacing="8"></atlas-divider>`);
    }
    renderHeaderIconButton() {
      return when87(!!this.icon, () => html137`
                <atlas-icon
                    size="3x"
                    name="${this.icon}"
                    theme=${this.getTheme()}
                    data-atlas-tooltip=${this._tooltipId}
                ></atlas-icon>
            `);
    }
    renderHeaderTitle() {
      const textStyle = {
        display: this.shrinked ? "none" : ""
      };
      return when87(this.text, () => html137`
                ${this.renderHeaderIconButton()}
                <atlas-heading
                    ellipsis
                    size="h6"
                    ?muted=${!this.active}
                    theme=${this.getTheme()}
                    style=${styleMap25(textStyle)}
                >
                    ${this.text}
                </atlas-heading>
            `);
    }
    renderHeader() {
      if (this.collapsible) {
        return html137`
                <a class="sidebar-menu-group-header collapsible" role="button" @click=${this.toggleCollapse}>
                    <atlas-layout gap="2" inline mobile-inline alignment="center">
                        ${this.renderHeaderTitle()} ${this.renderCollapseButton()}
                    </atlas-layout>
                </a>
            `;
      }
      return when87(this.text, () => html137`
                <div class="sidebar-menu-group-header">
                    <atlas-layout gap="2" inline mobile-inline alignment="center">
                        ${this.renderHeaderTitle()}
                    </atlas-layout>
                </div>
            `);
    }
    renderContent() {
      const contentHtml = html137`
            <atlas-layout gap="2">
                <slot></slot>
            </atlas-layout>
        `;
      return when87(this.collapsible, () => this.renderContentWithCollapse(contentHtml), () => contentHtml);
    }
    /** @internal */
    render() {
      return html137`
            ${this.renderHeader()} ${this.renderDivider()} ${this.renderContent()}
            ${this.renderTooltip(this._tooltipId)}
        `;
    }
  };
  AtlasSidebarMenuGroup.styles = atlas_sidebar_menu_group_default;
  return AtlasSidebarMenuGroup;
})();
__decorateClass([property142({
  type: String
})], AtlasSidebarMenuGroup.prototype, "text", 2);
__decorateClass([property142({
  type: Boolean,
  attribute: "enable-divider",
  reflect: true
})], AtlasSidebarMenuGroup.prototype, "enableDivider", 2);
__decorateClass([property142({
  type: String
})], AtlasSidebarMenuGroup.prototype, "icon", 2);
__decorateClass([property142({
  type: Boolean,
  reflect: true
})], AtlasSidebarMenuGroup.prototype, "shrinked", 2);
__decorateClass([property142({
  type: Boolean,
  reflect: true
})], AtlasSidebarMenuGroup.prototype, "active", 2);
__decorateClass([queryAssignedElements10({
  selector: "atlas-sidebar-menu-item",
  flatten: true
})], AtlasSidebarMenuGroup.prototype, "_slottedItems", 2);
AtlasSidebarMenuGroup = __decorateClass([customElement137("atlas-sidebar-menu-group")], AtlasSidebarMenuGroup);

// src/components/structure/atlas-sidebar-menu-item/atlas-sidebar-menu-item.ts
import { html as html138 } from "lit";
import { customElement as customElement138, property as property143, queryAssignedElements as queryAssignedElements11, state as state69 } from "lit/decorators.js";
import { classMap as classMap94 } from "lit/directives/class-map.js";
import { ifDefined as ifDefined24 } from "lit/directives/if-defined.js";
import { when as when88 } from "lit/directives/when.js";

// src/components/structure/atlas-sidebar-menu-item/atlas-sidebar-menu-item.scss
import { css as css124 } from "lit-element/lit-element.js";
var atlas_sidebar_menu_item_default = css124`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Border radius */
/* Base borders */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

@keyframes animate-text-wrap {
  0% {
    white-space: nowrap;
  }
  100% {
    white-space: normal;
  }
}
:host {
  display: block;
}

:host([in-menu-context-popover]) {
  margin-top: 0 !important;
}

.item-button {
  align-items: center;
  background: none;
  border: 0;
  border-radius: 9999px;
  color: #687078;
  display: flex;
  gap: 8px;
  padding: 12px 16px;
  overflow: hidden;
  text-align: left;
  transition: background 0.25s ease, color 0.25s ease;
  width: 100%;
  cursor: pointer;
  box-sizing: border-box;
  text-decoration: none;
  position: relative;
}
.item-button .item-text {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  transition: opacity 0.25s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.item-button atlas-icon.collapse-icon {
  transition: transform 0.35s ease, opacity 0.25s ease;
}
.item-button atlas-badge {
  position: absolute;
  top: 4px;
  left: 32px;
}
.item-button:hover {
  background: rgba(var(--atlas-secondary-700-rgb), 5%);
}
.item-button:focus-visible {
  outline: 4px solid rgba(var(--atlas-primary-rgb), 25%);
  outline-offset: -4px;
}

.sidebar-menu-item:not(.collapsed) .item-button {
  background: rgba(var(--atlas-secondary-700-rgb), 5%);
}
.sidebar-menu-item:not(.collapsed) atlas-icon.collapse-icon {
  transform: rotate(-180deg);
}

.sidebar-menu-item.active .item-button {
  background: var(--atlas-primary-100);
  color: var(--atlas-primary);
}

.sidebar-menu-item.in-menu-context-popover .item-button {
  padding: 0.5rem !important;
}
.sidebar-menu-item.in-menu-context-popover .item-button atlas-badge {
  left: 24px;
}

.sidebar-menu-item.shrinked .item-button .item-text {
  opacity: 0;
  white-space: nowrap !important;
}
.sidebar-menu-item.shrinked .item-button atlas-icon.collapse-icon {
  opacity: 0;
}

.sidebar-menu-item.nested .item-button {
  padding: 12px 0 12px 16px;
}
.sidebar-menu-item.nested .item-button:hover {
  color: #212529;
  background: none;
}
.sidebar-menu-item.nested.active .item-button {
  color: var(--atlas-primary);
  background: none;
}

.sidebar-menu-item.nested:not(.shrinked) .item-button .item-text {
  animation: 1s ease-out animate-text-wrap forwards;
}

.sidebar-menu-item.shrinked.active atlas-sidebar-menu::part(menu-container) {
  background: var(--atlas-primary-100);
}

@media screen and (min-width: 992px) {
  :host([in-menu-context]) {
    margin-top: 0 !important;
  }
}`;

// src/components/structure/atlas-sidebar-menu-item/atlas-sidebar-menu-item.ts
var AtlasSidebarMenuItem = /*#__PURE__*/(() => {
  let AtlasSidebarMenuItem = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.active = false;
      this.isNew = false;
      this.nested = false;
      this.shrinked = false;
      this.inMenuContextPopover = false;
      this.inMenuContext = false;
      this._collapsed = true;
      this._hasSlottedItems = false;
      this._isNewSlottedItemsCount = 0;
      this._hasTooltip = false;
    }
    onChangeActive() {
      this.updateOwnerItemActive();
      this.updateSlottedItemsActive();
    }
    onChangeIsNew() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        if (!this._slottedItems) return;
        this._isNewSlottedItemsCount = this._slottedItems.filter(item => item.hasAttribute("is-new")).length;
      });
    }
    setTooltip() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        setTimeout(() => {
          if (this.shrinked) {
            this._hasTooltip = true;
            return;
          }
          this._hasTooltip = this.checkIfTextOverflows() && !this.nested;
        }, 500);
      });
    }
    /**
     * Altera o estado de colapso do item de menu (colapsado ou expandido)
     * Deve ser utilizado caso o item possua filhos
     * @param {boolean} collapsed - Novo estado de colapso do item
     */
    setCollapsed(collapsed) {
      this._collapsed = collapsed;
    }
    /**
     * Executa o clique do mouse no item de menu
     */
    click() {
      const anchor = this.shadowRoot.querySelector(".item-button");
      anchor == null ? void 0 : anchor.click();
    }
    onClickItem(event) {
      if (!this._hasSlottedItems) {
        emit(this, "atlas-menu-item-click", {
          detail: {
            item: this.value,
            owner: this.owner
          }
        });
        return;
      }
      event.preventDefault();
      this.setCollapsed(!this._collapsed);
      emit(this, "atlas-menu-item-collapse", {
        detail: {
          item: this.value,
          collapsed: this._collapsed
        }
      });
    }
    onChangeSlottedItems() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this._hasSlottedItems = this._slottedItems && this._slottedItems.length > 0;
        if (!this._hasSlottedItems) return;
        this._slottedItems.forEach(item => {
          item.setAttribute("owner", this.value);
        });
        if (this.active) this.setCollapsed(false);
      });
    }
    updateOwnerItemActive() {
      if (!this.owner || !this.active) return;
      const rootNode = this.assignedSlot.getRootNode();
      const host = rootNode.host;
      host.toggleAttribute("active", true);
    }
    updateSlottedItemsActive() {
      if (!this._hasSlottedItems) return;
      this.setCollapsed(!this.active);
      if (!this.active) this._slottedItems.forEach(item => item.removeAttribute("active"));
    }
    checkIfTextOverflows() {
      const itemText = this.shadowRoot.querySelector(".item-text");
      const contentWidth = itemText.getBoundingClientRect().width;
      return Math.ceil(contentWidth) < itemText.scrollWidth;
    }
    renderCollapseIcon() {
      return when88(this._hasSlottedItems, () => html138`<atlas-icon name="chevron-down" size="2x" class="collapse-icon"></atlas-icon>`);
    }
    renderBadge() {
      return when88(this.isNew || this._isNewSlottedItemsCount > 0, () => html138`<atlas-badge text="${this._isNewSlottedItemsCount || 1}" is-counter></atlas-badge>`);
    }
    renderTooltip() {
      return html138`
            <atlas-tooltip id="menu-item-tooltip" placement="right" trigger="hover" ?disabled=${!this._hasTooltip}>
                ${this.text}
            </atlas-tooltip>
        `;
    }
    renderNestedMenu() {
      return html138`
            <atlas-collapse ?show=${!this._collapsed}>
                <atlas-sidebar-menu
                    nested
                    ?shrinked=${this.shrinked}
                    tabindex=${ifDefined24(this._collapsed ? "-1" : void 0)}
                >
                    <slot @slotchange=${this.onChangeSlottedItems}></slot>
                </atlas-sidebar-menu>
            </atlas-collapse>
        `;
    }
    renderAnchor() {
      return html138`
            <a
                href=${ifDefined24(this.href)}
                class="item-button"
                role="button"
                data-atlas-tooltip="menu-item-tooltip"
                target=${ifDefined24(this.target ? this.target : void 0)}
                @click=${this.onClickItem}
            >
                <atlas-icon name="${this.icon}" size="3x"></atlas-icon>
                <span class="item-text">${this.text}</span>
                ${this.renderBadge()} ${this.renderCollapseIcon()}
            </a>
        `;
    }
    /** @internal */
    render() {
      const itemClass = {
        "sidebar-menu-item": true,
        "collapsed": this._collapsed,
        "active": this.active,
        "nested": this.nested,
        "shrinked": this.shrinked,
        "in-menu-context-popover": this.inMenuContextPopover
      };
      return html138`
            <div class="${classMap94(itemClass)}">
                ${this.renderAnchor()} ${this.renderTooltip()} ${this.renderNestedMenu()}
            </div>
        `;
    }
  };
  AtlasSidebarMenuItem.styles = atlas_sidebar_menu_item_default;
  return AtlasSidebarMenuItem;
})();
__decorateClass([property143({
  type: String
})], AtlasSidebarMenuItem.prototype, "value", 2);
__decorateClass([property143({
  type: String
})], AtlasSidebarMenuItem.prototype, "icon", 2);
__decorateClass([property143({
  type: String
})], AtlasSidebarMenuItem.prototype, "text", 2);
__decorateClass([property143({
  type: String
})], AtlasSidebarMenuItem.prototype, "href", 2);
__decorateClass([property143({
  type: String
})], AtlasSidebarMenuItem.prototype, "target", 2);
__decorateClass([property143({
  type: Boolean,
  reflect: true
})], AtlasSidebarMenuItem.prototype, "active", 2);
__decorateClass([property143({
  type: Boolean,
  attribute: "is-new"
})], AtlasSidebarMenuItem.prototype, "isNew", 2);
__decorateClass([property143({
  type: String
})], AtlasSidebarMenuItem.prototype, "owner", 2);
__decorateClass([property143({
  type: Boolean
})], AtlasSidebarMenuItem.prototype, "nested", 2);
__decorateClass([property143({
  type: Boolean
})], AtlasSidebarMenuItem.prototype, "shrinked", 2);
__decorateClass([property143({
  type: Boolean,
  attribute: "in-menu-context-popover",
  reflect: true
})], AtlasSidebarMenuItem.prototype, "inMenuContextPopover", 2);
__decorateClass([property143({
  type: Boolean,
  attribute: "in-menu-context",
  reflect: true
})], AtlasSidebarMenuItem.prototype, "inMenuContext", 2);
__decorateClass([state69()], AtlasSidebarMenuItem.prototype, "_collapsed", 2);
__decorateClass([state69()], AtlasSidebarMenuItem.prototype, "_hasSlottedItems", 2);
__decorateClass([state69()], AtlasSidebarMenuItem.prototype, "_isNewSlottedItemsCount", 2);
__decorateClass([state69()], AtlasSidebarMenuItem.prototype, "_hasTooltip", 2);
__decorateClass([queryAssignedElements11({
  selector: "atlas-sidebar-menu-item",
  flatten: true
})], AtlasSidebarMenuItem.prototype, "_slottedItems", 2);
__decorateClass([Watch("active", true)], AtlasSidebarMenuItem.prototype, "onChangeActive", 1);
__decorateClass([Watch("isNew")], AtlasSidebarMenuItem.prototype, "onChangeIsNew", 1);
__decorateClass([Watch(["shrinked", "nested"], false)], AtlasSidebarMenuItem.prototype, "setTooltip", 1);
AtlasSidebarMenuItem = __decorateClass([customElement138("atlas-sidebar-menu-item")], AtlasSidebarMenuItem);

// src/components/table/atlas-easy-table/atlas-easy-table.ts
import { html as html140 } from "lit";
import { customElement as customElement140, property as property145 } from "lit/decorators.js";
import { ifDefined as ifDefined25 } from "lit/directives/if-defined.js";
import { when as when90 } from "lit/directives/when.js";

// src/components/table/atlas-easy-table/atlas-easy-table.scss
import { css as css125 } from "lit-element/lit-element.js";
var atlas_easy_table_default = css125`/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host([skeleton-loading]) {
  display: block;
}

.easy-table {
  width: 100%;
}`;

// src/components/table/atlas-table-footer/atlas-table-footer.ts
import { html as html139 } from "lit";
import { customElement as customElement139, property as property144 } from "lit/decorators.js";
import { classMap as classMap95 } from "lit/directives/class-map.js";
import { map as map6 } from "lit/directives/map.js";
import { range as range5 } from "lit/directives/range.js";
import { when as when89 } from "lit/directives/when.js";

// src/components/table/atlas-table-footer/atlas-table-footer.scss
import { css as css126 } from "lit-element/lit-element.js";
var atlas_table_footer_default = css126`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.table-footer {
  display: none;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1rem;
  border-top: 1px solid #ced4da;
}
.table-footer.has-pagination {
  display: flex;
}

.totalizer {
  display: none;
  min-width: 200px;
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.25rem;
}
.pagination .pagination-item {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  background: none;
  border: 0;
  padding: 0;
  margin: 0;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1.25rem;
  line-height: 1.5;
  color: #687078;
  cursor: pointer;
  min-width: 1.5rem;
  min-height: 1.5rem;
}
.pagination .pagination-item.dots {
  cursor: default;
}
.pagination .pagination-item.sequenced {
  padding: 0 0.5rem;
}
.pagination .pagination-item.active {
  color: var(--atlas-primary);
  font-weight: 700;
}
.pagination .pagination-item:focus-within {
  outline: none;
  background-color: rgba(var(--atlas-primary-rgb), 10%);
  border-radius: 0.25rem;
  color: var(--atlas-primary);
}
.pagination .pagination-item:hover {
  color: var(--atlas-primary);
}
.pagination.skeleton {
  width: 250px;
  height: 1.5rem;
}

@media screen and (min-width: 992px) {
  .table-footer {
    display: flex;
    padding: 0;
    border: 0;
    justify-content: space-between;
  }
  .totalizer {
    display: block;
  }
  .pagination {
    gap: 0.25rem;
  }
  .pagination .pagination-item {
    font-size: 0.875rem;
  }
}`;

// src/components/table/atlas-table-footer/atlas-table-footer.ts
var AtlasTableFooter = /*#__PURE__*/(() => {
  let AtlasTableFooter = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.totalItems = 0;
      this.itemsPerPage = 10;
      this.currentPage = 1;
      this._deviceController = new DeviceController(this);
    }
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      if (!this.currentPage || isNaN(this.currentPage)) this.currentPage = 1;
    }
    getFirstIndexOfPage() {
      return (this.currentPage - 1) * this.itemsPerPage + 1;
    }
    getLastIndexOfPage() {
      const lastIndexOfPage = this.currentPage * this.itemsPerPage;
      return lastIndexOfPage > this.totalItems ? this.totalItems : lastIndexOfPage;
    }
    getTotalPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    }
    goToPage(event) {
      const target = event.currentTarget;
      const {
        page
      } = target.dataset;
      const lastViewedPage = this.currentPage;
      if (page === "next") {
        this.currentPage += 1;
      } else if (page === "previous") {
        this.currentPage -= 1;
      } else {
        this.currentPage = parseInt(page, 10);
      }
      emit(this, "atlas-table-page-change", {
        detail: {
          page: this.currentPage,
          previousPage: lastViewedPage
        }
      });
    }
    getVisiblePagesRange() {
      const totalPages = this.getTotalPages();
      let pagesRangeStart;
      let pagesRangeEnd;
      if (totalPages < 5) {
        pagesRangeStart = this._deviceController.isMobile ? 1 : 2;
        pagesRangeEnd = this._deviceController.isMobile ? totalPages : totalPages - 1;
      } else if (this._deviceController.isMobile) {
        pagesRangeStart = 1;
        pagesRangeEnd = 4;
        if (this.currentPage > 3 && this.currentPage < totalPages - 1) {
          pagesRangeStart = this.currentPage - 2;
          pagesRangeEnd = this.currentPage + 1;
        } else if (this.currentPage >= totalPages - 1) {
          pagesRangeStart = totalPages - 3;
          pagesRangeEnd = totalPages;
        }
      } else {
        pagesRangeStart = 2;
        pagesRangeEnd = 4;
        if (this.currentPage > 2 && this.currentPage < totalPages - 2) {
          pagesRangeStart = this.currentPage - 1;
          pagesRangeEnd = this.currentPage + 1;
        } else if (this.currentPage >= totalPages - 2) {
          pagesRangeStart = totalPages - 3;
          pagesRangeEnd = totalPages - 1;
        }
      }
      return {
        rangeStart: pagesRangeStart,
        rangeEnd: pagesRangeEnd
      };
    }
    getDefaultFooterText() {
      let footerText = `${this.getFirstIndexOfPage()}`;
      let itemSuffix = this.contentName || "item";
      if (this.totalItems > 1) {
        footerText += ` a ${this.getLastIndexOfPage()}`;
        itemSuffix = this.contentNamePlural || "itens";
      }
      if (this.sequencedPagination) {
        return `${footerText} ${itemSuffix}`;
      }
      return `${footerText} do total de ${this.totalItems} ${itemSuffix}`;
    }
    renderPreviousButton() {
      const paginationItemClass = {
        "pagination-item": true,
        "sequenced": this.sequencedPagination
      };
      return when89(this.currentPage > 1, () => html139`
                <button
                    class="${classMap95(paginationItemClass)}"
                    data-page="previous"
                    @click=${this.goToPage}
                    aria-label="Página anterior"
                >
                    <atlas-icon name="chevron-left" size=${this._deviceController.isMobile ? "3x" : "2x"}></atlas-icon>
                    ${when89(this.sequencedPagination, () => html139`
                            <atlas-text size=${this._deviceController.isMobile ? "md" : "sm"} muted>
                                Anterior
                            </atlas-text>
                        `)}
                </button>
            `);
    }
    renderNextButton() {
      const paginationItemClass = {
        "pagination-item": true,
        "sequenced": this.sequencedPagination
      };
      return when89(this.currentPage < this.getTotalPages(), () => html139`
                <button
                    class="${classMap95(paginationItemClass)}"
                    data-page="next"
                    @click=${this.goToPage}
                    aria-label="Próxima página"
                >
                    ${when89(this.sequencedPagination, () => html139`
                            <atlas-text size=${this._deviceController.isMobile ? "md" : "sm"} muted>
                                Próximo
                            </atlas-text>
                        `)}
                    <atlas-icon name="chevron-right" size=${this._deviceController.isMobile ? "3x" : "2x"}></atlas-icon>
                </button>
            `);
    }
    renderDotsButton(side) {
      const totalPages = this.getTotalPages();
      let showButton = false;
      if (totalPages > 5) {
        if (side === "left") {
          showButton = this.currentPage > 3;
        } else {
          showButton = this.currentPage < totalPages - 2;
        }
      }
      return when89(showButton && !this._deviceController.isMobile, () => html139`
                <button class="pagination-item dots" disabled>
                    <atlas-icon name="three-dots-horinzontal" size="2x"></atlas-icon>
                </button>
            `);
    }
    renderFirstPageButton() {
      return when89(!this._deviceController.isMobile, () => html139`
                <button
                    class="pagination-item ${this.currentPage === 1 ? "active" : ""}"
                    data-page="1"
                    @click=${this.goToPage}
                    ?disabled=${this.currentPage === 1}
                    aria-label="Página 1"
                >
                    1
                </button>
            `);
    }
    renderLastPageButton() {
      const totalPages = this.getTotalPages();
      return when89(!this._deviceController.isMobile, () => html139`
                <button
                    class="pagination-item ${this.currentPage === totalPages ? "active" : ""}"
                    data-page="${totalPages}"
                    @click=${this.goToPage}
                    ?disabled=${this.currentPage === totalPages}
                    aria-label="Página ${totalPages}"
                >
                    ${totalPages}
                </button>
            `);
    }
    renderVisiblePages() {
      if (this.getTotalPages() < 3 && !this._deviceController.isMobile) {
        return null;
      }
      const {
        rangeStart,
        rangeEnd
      } = this.getVisiblePagesRange();
      return map6(range5(rangeStart, rangeEnd + 1), page => html139`
                <button
                    class="pagination-item ${this.currentPage === page ? "active" : ""}"
                    data-page="${page}"
                    @click=${this.goToPage}
                    ?disabled=${this.currentPage === page}
                    aria-label="Página ${page}"
                >
                    ${page}
                </button>
            `);
    }
    renderPagination() {
      if (this.skeletonLoading) {
        return html139`<div class="pagination skeleton"></div>`;
      }
      if (this.sequencedPagination) {
        return when89(this.getTotalPages() > 1, () => html139` <div class="pagination">${this.renderPreviousButton()} ${this.renderNextButton()}</div> `);
      }
      return when89(this.getTotalPages() > 1, () => html139`
                <div class="pagination">
                    ${this.renderPreviousButton()} ${this.renderFirstPageButton()} ${this.renderDotsButton("left")}
                    ${this.renderVisiblePages()} ${this.renderDotsButton("right")} ${this.renderLastPageButton()}
                    ${this.renderNextButton()}
                </div>
            `);
    }
    renderFooterText() {
      return when89(!this.hideFooterText, () => html139`<atlas-text size="sm" muted>${this.footerText || this.getDefaultFooterText()}</atlas-text>`);
    }
    render() {
      const footerClass = {
        "table-footer": true,
        "has-pagination": this.getTotalPages() > 1
      };
      return html139`
            <div class=${classMap95(footerClass)}>
                <div class="totalizer">${this.renderFooterText()}</div>
                ${this.renderPagination()}
            </div>
        `;
    }
  };
  AtlasTableFooter.styles = atlas_table_footer_default;
  return AtlasTableFooter;
})();
__decorateClass([property144({
  type: Number,
  attribute: "total-items"
})], AtlasTableFooter.prototype, "totalItems", 2);
__decorateClass([property144({
  type: Number,
  attribute: "items-per-page"
})], AtlasTableFooter.prototype, "itemsPerPage", 2);
__decorateClass([property144({
  type: Number,
  attribute: "current-page"
})], AtlasTableFooter.prototype, "currentPage", 2);
__decorateClass([property144({
  type: String,
  attribute: "footer-text"
})], AtlasTableFooter.prototype, "footerText", 2);
__decorateClass([property144({
  type: Boolean,
  attribute: "hide-footer-text"
})], AtlasTableFooter.prototype, "hideFooterText", 2);
__decorateClass([property144({
  type: Boolean,
  attribute: "sequenced-pagination"
})], AtlasTableFooter.prototype, "sequencedPagination", 2);
__decorateClass([property144({
  type: String,
  attribute: "content-name"
})], AtlasTableFooter.prototype, "contentName", 2);
__decorateClass([property144({
  type: String,
  attribute: "content-name-plural"
})], AtlasTableFooter.prototype, "contentNamePlural", 2);
AtlasTableFooter = __decorateClass([customElement139("atlas-table-footer")], AtlasTableFooter);

// src/components/table/atlas-easy-table/atlas-easy-table.ts
var AtlasEasyTable = /*#__PURE__*/(() => {
  let AtlasEasyTable = class extends AtlasElement {
    constructor() {
      super(...arguments);
      this.params = {};
      this.itemsPerPage = 10;
      this.currentPage = 1;
      this.totalRecords = 0;
      this.columns = [];
      this.enableLineBreak = false;
      this.selectionType = "multiple";
      this.selectionName = "";
    }
    /** @internal */
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      if (!this.currentPage || isNaN(this.currentPage)) this.currentPage = 1;
      this.onPageChange = this.onPageChange.bind(this);
      this.onSortChange = this.onSortChange.bind(this);
      this.addEventListener("atlas-table-page-change", this.onPageChange);
      this.addEventListener("atlas-table-change-sorting", this.onSortChange);
      if (this.searchOnRender) {
        setTimeout(() => {
          this.fetchRecords();
        }, 1e3);
      }
    }
    /** @internal */
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      this.removeEventListener("atlas-table-page-change", this.onPageChange);
      this.removeEventListener("atlas-table-change-sorting", this.onSortChange);
    }
    /**
     * Realiza a busca dos registros e atualiza o conteúdo da tabela
     *
     * @param {boolean} shouldGoToFirstPage - Indica se a tabela deve ir para a primeira página após a busca
     * @param {number} previousPage - Página anterior
     * @param {boolean} recordWasRemoved - Indica se algum registro foi removido (para ajustar a paginação conforme necessário)
     *
     * @returns {Promise<void>}
     */
    fetchRecords(shouldGoToFirstPage, previousPage, recordWasRemoved) {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this.skeletonLoading = true;
        emit(this, "atlas-table-before-search");
        setTimeout(() => {
          const params = this.getFetchParams();
          const totalRecords = recordWasRemoved ? this.totalRecords - 1 : this.totalRecords;
          const totalPages = Math.ceil(totalRecords / this.itemsPerPage);
          const shouldGoToPreviousPage = recordWasRemoved && this.currentPage > 1 && this.currentPage > totalPages;
          if (shouldGoToFirstPage) {
            params.page = 1;
          } else if (shouldGoToPreviousPage) {
            params.page = this.currentPage - 1;
          }
          get(this.url, params).then(response => {
            if (!response.success) {
              this.onFetchError(response, previousPage);
              return;
            }
            const defaultSlot = this.shadowRoot.querySelector("slot:not([name])");
            defaultSlot.assignedElements({
              flatten: true
            }).forEach(element => element.remove());
            this.innerHTML += response.content;
            this.totalRecords = response.totalRecords;
            if (shouldGoToFirstPage) {
              this.currentPage = 1;
            } else if (shouldGoToPreviousPage) {
              this.currentPage -= 1;
            }
            setTimeout(() => {
              this.skeletonLoading = false;
              emit(this, "atlas-table-after-search", {
                detail: {
                  response
                }
              });
            }, 1e3);
          });
        }, 500);
      });
    }
    /**
     * Retorna os parâmetros que serão enviados para o backend para a busca dos registros
     *
     * @returns {TableFetchParams} - Objeto com os parâmetros de busca
     */
    getFetchParams() {
      return __spreadValues(__spreadProps(__spreadValues({}, this.params), {
        page: this.currentPage,
        itemsPerPage: this.itemsPerPage
      }), this.getSortingParams());
    }
    /**
     * Retorna os parâmetros de ordenação que serão enviados para o backend para a busca dos registros
     *
     * @returns {TableSortingFetchParams} - Objeto com os parâmetros de ordenação
     */
    getSortingParams() {
      if (!this.sortedColumn || !this.sortedOrder || this.sortedOrder === "none") return {};
      return {
        sort: this.sortedColumn,
        order: this.sortedOrder
      };
    }
    /**
     * Retorna as linhas selecionadas da tabela.
     * @returns Um array com as linhas selecionadas da tabela.
     */
    getSelectedRows() {
      if (!this.selectable) return [];
      const table = this.shadowRoot.querySelector("atlas-table");
      if (!table) return [];
      return table.getSelectedRows();
    }
    onPageChange(event) {
      const {
        page,
        previousPage
      } = event.detail;
      this.currentPage = page;
      this.fetchRecords(false, previousPage);
    }
    onSortChange(event) {
      const {
        column,
        order
      } = event.detail;
      this.sortedColumn = column;
      this.sortedOrder = order;
      this.fetchRecords();
    }
    onFetchError(response, previousPage) {
      const feedbackMessage = response.message || "N\xE3o foi poss\xEDvel carregar a listagem, tente novamente.";
      if (previousPage) this.currentPage = previousPage;
      this.skeletonLoading = false;
      showAlert(feedbackMessage, "ERROR");
      emit(this, "atlas-table-after-search", {
        detail: {
          response
        }
      });
    }
    renderHeaderContent() {
      return this.columns.map(column => html140`
                <atlas-table-col
                    name=${column.name}
                    size=${column.size || "md"}
                    ?sortable=${column.sortable}
                    ?ellipsis=${column.ellipsis}
                    ?disable-line-break=${column.disableLineBreak}
                    sort=${column.name === this.sortedColumn ? this.sortedOrder || "none" : "none"}
                    popover-title=${ifDefined25(column.popoverTitle)}
                    popover-content=${ifDefined25(column.popoverContent)}
                >
                    ${column.label}
                </atlas-table-col>
            `);
    }
    renderTable() {
      return html140`
            <atlas-table
                ?selectable=${this.selectable}
                ?has-actions=${this.hasActions}
                ?enable-line-break=${this.enableLineBreak}
                selection-name=${this.selectionName}
                selection-type=${this.selectionType}
            >
                <atlas-table-header slot="header">${this.renderHeaderContent()}</atlas-table-header>
                <atlas-table-body slot="body">
                    <slot></slot>
                </atlas-table-body>
                <atlas-table-footer
                    slot="footer"
                    items-per-page=${this.itemsPerPage}
                    current-page=${this.currentPage}
                    total-items=${this.totalRecords}
                    footer-text=${this.footerText}
                    content-name=${this.contentName}
                    content-name-plural=${this.contentNamePlural}
                    ?hide-footer-text=${this.hideFooterText}
                    ?hidden=${this.hideFooter}
                    ?sequenced-pagination=${this.sequencedPagination}
                ></atlas-table-footer>
            </atlas-table>
        `;
    }
    renderEmptyState() {
      return when90(!this.emptyStateIcon || !this.emptyStateHeader || !this.emptyStateDescription, () => html140`<slot name="empty-state-template"></slot>`, () => html140`
                <atlas-empty-state
                    icon=${this.emptyStateIcon}
                    header=${this.emptyStateHeader}
                    description=${this.emptyStateDescription}
                ></atlas-empty-state>
            `);
    }
    /** @internal @override */
    render() {
      return html140`
            <div class="easy-table">
                ${when90(this.totalRecords > 0 || this.skeletonLoading, () => this.renderTable(), () => this.renderEmptyState())}
            </div>
        `;
    }
  };
  AtlasEasyTable.styles = atlas_easy_table_default;
  return AtlasEasyTable;
})();
__decorateClass([property145({
  type: Boolean
})], AtlasEasyTable.prototype, "selectable", 2);
__decorateClass([property145({
  type: Boolean,
  attribute: "has-actions"
})], AtlasEasyTable.prototype, "hasActions", 2);
__decorateClass([property145({
  type: Boolean,
  attribute: "hide-footer"
})], AtlasEasyTable.prototype, "hideFooter", 2);
__decorateClass([property145({
  type: Boolean,
  attribute: "hide-footer-text"
})], AtlasEasyTable.prototype, "hideFooterText", 2);
__decorateClass([property145({
  type: Boolean,
  attribute: "search-on-render"
})], AtlasEasyTable.prototype, "searchOnRender", 2);
__decorateClass([property145({
  type: String
})], AtlasEasyTable.prototype, "url", 2);
__decorateClass([property145({
  type: Object
})], AtlasEasyTable.prototype, "params", 2);
__decorateClass([property145({
  type: Number,
  attribute: "items-per-page"
})], AtlasEasyTable.prototype, "itemsPerPage", 2);
__decorateClass([property145({
  type: Number,
  attribute: "current-page",
  reflect: true
})], AtlasEasyTable.prototype, "currentPage", 2);
__decorateClass([property145({
  type: Number,
  attribute: "total-records",
  reflect: true
})], AtlasEasyTable.prototype, "totalRecords", 2);
__decorateClass([property145({
  type: String,
  attribute: "footer-text",
  reflect: true
})], AtlasEasyTable.prototype, "footerText", 2);
__decorateClass([property145({
  type: String,
  attribute: "content-name"
})], AtlasEasyTable.prototype, "contentName", 2);
__decorateClass([property145({
  type: String,
  attribute: "content-name-plural"
})], AtlasEasyTable.prototype, "contentNamePlural", 2);
__decorateClass([property145({
  type: Array
})], AtlasEasyTable.prototype, "columns", 2);
__decorateClass([property145({
  type: String,
  attribute: "empty-state-icon"
})], AtlasEasyTable.prototype, "emptyStateIcon", 2);
__decorateClass([property145({
  type: String,
  attribute: "empty-state-header"
})], AtlasEasyTable.prototype, "emptyStateHeader", 2);
__decorateClass([property145({
  type: String,
  attribute: "empty-state-description"
})], AtlasEasyTable.prototype, "emptyStateDescription", 2);
__decorateClass([property145({
  type: String,
  attribute: "sorted-column"
})], AtlasEasyTable.prototype, "sortedColumn", 2);
__decorateClass([property145({
  type: String,
  attribute: "sorted-order"
})], AtlasEasyTable.prototype, "sortedOrder", 2);
__decorateClass([property145({
  type: Boolean,
  attribute: "sequenced-pagination"
})], AtlasEasyTable.prototype, "sequencedPagination", 2);
__decorateClass([property145({
  type: Boolean,
  attribute: "enable-line-break"
})], AtlasEasyTable.prototype, "enableLineBreak", 2);
__decorateClass([property145({
  type: String,
  attribute: "selection-type"
})], AtlasEasyTable.prototype, "selectionType", 2);
__decorateClass([property145({
  type: String,
  attribute: "selection-name"
})], AtlasEasyTable.prototype, "selectionName", 2);
AtlasEasyTable = __decorateClass([customElement140("atlas-easy-table")], AtlasEasyTable);

// src/components/wizard/atlas-stepper/atlas-stepper.ts
import { LitElement as LitElement39, html as html141 } from "lit";
import { customElement as customElement141, property as property146 } from "lit/decorators.js";
import { classMap as classMap96 } from "lit/directives/class-map.js";
import { ifDefined as ifDefined26 } from "lit/directives/if-defined.js";

// src/components/wizard/atlas-stepper/atlas-stepper.scss
import { css as css127 } from "lit-element/lit-element.js";
var atlas_stepper_default = css127`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Shadows */
/* Elevations */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 0.75rem !important;
}

.gap-4 {
  gap: 1rem !important;
}

.gap-5 {
  gap: 1.25rem !important;
}

.gap-6 {
  gap: 1.5rem !important;
}

.gap-7 {
  gap: 2rem !important;
}

.gap-8 {
  gap: 2.5rem !important;
}

.gap-9 {
  gap: 3rem !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 0.75rem !important;
}

.mt-4 {
  margin-top: 1rem !important;
}

.mt-5 {
  margin-top: 1.25rem !important;
}

.mt-6 {
  margin-top: 1.5rem !important;
}

.mt-7 {
  margin-top: 2rem !important;
}

.mt-8 {
  margin-top: 2.5rem !important;
}

.mt-9 {
  margin-top: 3rem !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 0.75rem !important;
}

.mb-4 {
  margin-bottom: 1rem !important;
}

.mb-5 {
  margin-bottom: 1.25rem !important;
}

.mb-6 {
  margin-bottom: 1.5rem !important;
}

.mb-7 {
  margin-bottom: 2rem !important;
}

.mb-8 {
  margin-bottom: 2.5rem !important;
}

.mb-9 {
  margin-bottom: 3rem !important;
}

.container {
  flex: 1 1 100%;
  box-sizing: border-box;
  padding: 0.5rem 1rem 1rem;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
@media screen and (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}
@media screen and (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}
@media screen and (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}
@media screen and (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}
@media screen and (min-width: 1400px) {
  .container {
    max-width: 1320px;
  }
}

.atlas-stepper-container {
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  padding: 0 1rem;
}

.atlas-stepper {
  padding: 1rem 0;
  display: flex;
  margin: 0;
  position: relative;
  box-sizing: border-box;
  flex: 0 0 auto;
  width: 100%;
}
@media screen and (min-width: 992px) {
  .atlas-stepper {
    padding: 2rem 0 3.5rem;
    flex: 0 0 auto;
    width: 83.3333%;
  }
}

.atlas-stepper-step {
  float: left;
  text-align: center;
  color: #687078;
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}
.atlas-stepper-step .atlas-stepper-circle {
  height: 2.5rem;
  width: 2.5rem;
  margin: 0;
  border-radius: 50%;
  border: 2px solid #6c757d;
  background-color: #f8f9fa;
  color: #687078;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  transition: all 0.35s ease;
}
.atlas-stepper-step .atlas-stepper-circle:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-rgb), 40%);
}
.atlas-stepper-step .atlas-stepper-number {
  text-align: center;
  font-size: 1rem;
  height: 1rem;
}
.atlas-stepper-step atlas-icon {
  display: none;
}
.atlas-stepper-step .atlas-stepper-title {
  display: none;
  position: relative;
  position: absolute;
  white-space: nowrap;
  top: 3rem;
  transition: color 0.35s ease, font-weight 0.35s ease;
}
@media screen and (min-width: 992px) {
  .atlas-stepper-step .atlas-stepper-title {
    display: inline-block;
  }
}
.atlas-stepper-step:first-child {
  align-items: flex-start;
}
.atlas-stepper-step:first-child .atlas-stepper-title {
  left: 20px;
  transform: translateX(-50%);
}
.atlas-stepper-step:last-child {
  align-items: flex-end;
}
.atlas-stepper-step:last-child .atlas-stepper-title {
  left: unset;
  right: 20px;
  transform: translateX(50%);
}
.atlas-stepper-step.active {
  color: var(--atlas-primary);
  font-weight: 700;
}
.atlas-stepper-step.active .atlas-stepper-circle {
  border-color: var(--atlas-primary);
  color: var(--atlas-primary);
}
.atlas-stepper-step.completed {
  color: #212529;
}
.atlas-stepper-step.completed .atlas-stepper-circle {
  border-color: var(--atlas-primary);
  background-color: var(--atlas-primary);
  cursor: pointer;
}
.atlas-stepper-step.completed .atlas-stepper-number {
  display: none;
}
.atlas-stepper-step.completed atlas-icon {
  display: inline-flex;
  color: #ffffff;
}
.atlas-stepper-step.return-disabled .atlas-stepper-circle {
  cursor: default;
}

.atlas-stepper-line {
  flex: 1 1 auto;
  position: relative;
}
.atlas-stepper-line::before {
  content: " ";
  position: absolute;
  z-index: -1;
  border-top: 2px solid #6c757d;
  box-sizing: border-box;
  width: 100%;
  top: 50%;
  height: 20px;
  transition: border 0.35s ease;
}
.atlas-stepper-line:last-child {
  display: none;
}

.atlas-stepper-step.completed + .atlas-stepper-line::before {
  border-top: 2px solid var(--atlas-primary);
}`;

// src/components/wizard/atlas-stepper/atlas-stepper.ts
var AtlasStepper = /*#__PURE__*/(() => {
  let AtlasStepper = class extends LitElement39 {
    constructor() {
      super(...arguments);
      this.currentStepIndex = 0;
      this.disableReturn = false;
      this.steps = [];
    }
    getRealStepIndex(step) {
      return this.steps.findIndex(wizardStep => wizardStep.name === step.name);
    }
    renderStep(step, index) {
      const isCompleted = this.getRealStepIndex(step) < this.currentStepIndex;
      const canInteract = isCompleted && !this.disableReturn;
      const stepClass = {
        "atlas-stepper-step": true,
        "active": step.name === this.currentStep,
        "completed": isCompleted,
        "return-disabled": this.disableReturn
      };
      return html141`
            <div class=${classMap96(stepClass)}>
                <button
                    class="atlas-stepper-circle"
                    @click=${canInteract ? step.goToStep : void 0}
                    tabindex=${ifDefined26(!canInteract ? "-1" : void 0)}
                >
                    <span class="atlas-stepper-number">${index + 1}</span>
                    <atlas-icon name="check" size="3x"></atlas-icon>
                </button>
                <span class="atlas-stepper-title">${step.header}</span>
            </div>
            <div class="atlas-stepper-line"></div>
        `;
    }
    render() {
      const visibleSteps = this.steps.filter(step => !step.disabled && !step.isOffStep());
      return html141`
            <nav class="atlas-stepper-container container">
                <div class="atlas-stepper">
                    ${visibleSteps.map((step, index) => this.renderStep(step, index))}
                </div>
            </nav>
        `;
    }
  };
  AtlasStepper.styles = atlas_stepper_default;
  return AtlasStepper;
})();
__decorateClass([property146({
  type: String,
  attribute: "current-step"
})], AtlasStepper.prototype, "currentStep", 2);
__decorateClass([property146({
  type: Number,
  attribute: "current-step-index"
})], AtlasStepper.prototype, "currentStepIndex", 2);
__decorateClass([property146({
  type: Boolean,
  attribute: "disable-return"
})], AtlasStepper.prototype, "disableReturn", 2);
__decorateClass([property146({
  type: Array,
  attribute: null
})], AtlasStepper.prototype, "steps", 2);
AtlasStepper = __decorateClass([customElement141("atlas-stepper")], AtlasStepper);

// src/components/wizard/atlas-summary-card/atlas-summary-card.ts
import { LitElement as LitElement40, html as html142 } from "lit";
import { customElement as customElement142, property as property147 } from "lit/decorators.js";
import { classMap as classMap97 } from "lit/directives/class-map.js";
import { when as when91 } from "lit/directives/when.js";
import { ifDefined as ifDefined27 } from "lit/directives/if-defined.js";

// src/components/wizard/atlas-summary-card/atlas-summary-card.scss
import { css as css128 } from "lit-element/lit-element.js";
var atlas_summary_card_default = css128`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
@media screen and (min-width: 992px) {
  :host([expanded]),
  :host([always-expanded]) {
    grid-column: 1/3;
  }
  :host([expanded-vertically]) {
    grid-row: 1/3;
  }
}
.summary-card {
  border-radius: 0.5rem;
  padding: 1.5rem 1rem;
  box-shadow: 0 1px 4px 2px rgba(0, 0, 0, 0.15);
  height: 100%;
  box-sizing: border-box;
}
.summary-card .card-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
}
.summary-card .card-header atlas-heading {
  color: var(--atlas-primary);
}
.summary-card .card-header atlas-button {
  margin-left: auto;
}
.summary-card.has-table {
  padding: 1.5rem 0 0;
}
.summary-card.has-table .card-header {
  padding: 0 1rem;
}

@media screen and (min-width: 992px) {
  .summary-card {
    padding: 2rem;
  }
  .summary-card.has-table {
    padding: 2rem;
  }
  .summary-card.has-table .card-header {
    padding: 0;
  }
}`;

// src/components/wizard/atlas-summary-card/atlas-summary-card.ts
var AtlasSummaryCard = /*#__PURE__*/(() => {
  let AtlasSummaryCard = class extends LitElement40 {
    onChangeHidden() {
      emit(this, "atlas-summary-card-change-visibility", {
        trackDisable: true
      });
    }
    onClickEdit() {
      if (this.disabled) return;
      emit(this, "atlas-wizard-step-go", {
        detail: {
          step: this.relatedStep,
          element: this.relatedStepElement
        }
      });
    }
    renderEditButton() {
      return when91(this.relatedStep, () => html142`
                <atlas-button
                    type="ghost"
                    size="sm"
                    icon="pencil"
                    description="Editar"
                    @atlas-button-click=${this.onClickEdit}
                    ?disabled=${this.disabled}
                    tooltip=${ifDefined27(this.disabled ? this.disabledMessage : void 0)}
                ></atlas-button>
            `);
    }
    render() {
      const summaryCardClass = {
        "summary-card": true,
        "has-table": this.hasTable
      };
      return html142`
            <div class=${classMap97(summaryCardClass)}>
                <div class="card-header">
                    <atlas-heading size="h5" theme="primary">${this.header}</atlas-heading>
                    ${this.renderEditButton()}
                </div>
                <slot></slot>
            </div>
        `;
    }
  };
  AtlasSummaryCard.styles = atlas_summary_card_default;
  return AtlasSummaryCard;
})();
__decorateClass([property147({
  type: String
})], AtlasSummaryCard.prototype, "header", 2);
__decorateClass([property147({
  type: String,
  attribute: "related-step"
})], AtlasSummaryCard.prototype, "relatedStep", 2);
__decorateClass([property147({
  type: String,
  attribute: "related-step-element"
})], AtlasSummaryCard.prototype, "relatedStepElement", 2);
__decorateClass([property147({
  type: Boolean,
  attribute: "hidden"
})], AtlasSummaryCard.prototype, "isHidden", 2);
__decorateClass([property147({
  type: Boolean
})], AtlasSummaryCard.prototype, "expanded", 2);
__decorateClass([property147({
  type: Boolean,
  attribute: "always-expanded"
})], AtlasSummaryCard.prototype, "alwaysExpanded", 2);
__decorateClass([property147({
  type: Boolean,
  attribute: "expanded-vertically"
})], AtlasSummaryCard.prototype, "expandedVertically", 2);
__decorateClass([property147({
  type: Boolean
})], AtlasSummaryCard.prototype, "disabled", 2);
__decorateClass([property147({
  type: String,
  attribute: "disabled-message"
})], AtlasSummaryCard.prototype, "disabledMessage", 2);
__decorateClass([property147({
  type: Boolean,
  attribute: "has-table"
})], AtlasSummaryCard.prototype, "hasTable", 2);
__decorateClass([Watch("isHidden")], AtlasSummaryCard.prototype, "onChangeHidden", 1);
AtlasSummaryCard = __decorateClass([customElement142("atlas-summary-card")], AtlasSummaryCard);

// src/components/wizard/atlas-summary-container/atlas-summary-container.ts
import { LitElement as LitElement41, html as html143 } from "lit";
import { customElement as customElement143, queryAssignedElements as queryAssignedElements12 } from "lit/decorators.js";

// src/components/wizard/atlas-summary-container/atlas-summary-container.scss
import { css as css129 } from "lit-element/lit-element.js";
var atlas_summary_container_default = css129`.summary-container {
  margin: 2rem 0;
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 1fr;
  gap: 2rem;
}
@media screen and (min-width: 992px) {
  .summary-container {
    grid-template-columns: 1fr 1fr;
  }
}`;

// src/components/wizard/atlas-summary-container/atlas-summary-container.ts
var AtlasSummaryContainer = /*#__PURE__*/(() => {
  let AtlasSummaryContainer = class extends LitElement41 {
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.addEventListener("atlas-summary-card-change-visibility", this.expandLastCardIfNeeded);
    }
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      this.removeEventListener("atlas-summary-card-change-visibility", this.expandLastCardIfNeeded);
    }
    expandLastCardIfNeeded() {
      return __async(this, null, function* () {
        var _a;
        yield this.updateComplete;
        const expandableCards = this._slottedCards.filter(card => !card.hasAttribute("hidden") && !card.hasAttribute("always-expanded"));
        if (expandableCards.length % 2 === 0) {
          const directionAttribute = expandableCards.length === 2 ? "expanded-vertically" : "expanded";
          expandableCards[expandableCards.length - 1].toggleAttribute(directionAttribute, true);
        } else {
          expandableCards.forEach(card => {
            card.removeAttribute("expanded-vertically");
            card.removeAttribute("expanded");
          });
        }
        (_a = this._slottedCards[0]) == null ? void 0 : _a.toggleAttribute("expanded-vertically", true);
      });
    }
    render() {
      return html143`
            <div class="summary-container">
                <slot @slotchange=${this.expandLastCardIfNeeded}></slot>
            </div>
        `;
    }
  };
  AtlasSummaryContainer.styles = atlas_summary_container_default;
  return AtlasSummaryContainer;
})();
__decorateClass([queryAssignedElements12({
  selector: "atlas-summary-card"
})], AtlasSummaryContainer.prototype, "_slottedCards", 2);
AtlasSummaryContainer = __decorateClass([customElement143("atlas-summary-container")], AtlasSummaryContainer);

// src/components/wizard/atlas-summary-item/atlas-summary-item.ts
import { LitElement as LitElement42, html as html144 } from "lit";
import { customElement as customElement144, property as property148 } from "lit/decorators.js";
import { classMap as classMap98 } from "lit/directives/class-map.js";
import { when as when92 } from "lit/directives/when.js";

// src/components/wizard/atlas-summary-item/atlas-summary-item.scss
import { css as css130 } from "lit-element/lit-element.js";
var atlas_summary_item_default = css130`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
.wrapper {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
}
.wrapper .label-wrapper {
  margin-bottom: 0.5rem;
  display: inline-flex;
  gap: 0.25rem;
  align-items: center;
}
.wrapper .description {
  margin: 0 0 1rem;
  display: block;
}
.wrapper.horizontal {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-bottom: 1rem;
}
.wrapper.horizontal .label-wrapper {
  gap: 0.5rem;
  margin-bottom: 0;
}
.wrapper.horizontal .description {
  flex-shrink: 0;
  margin-bottom: 0;
  display: inline-flex;
}
@media screen and (min-width: 992px) {
  .wrapper.horizontal {
    display: grid;
    grid-template-columns: auto fit-content(100%);
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
  }
  .wrapper.horizontal .description {
    height: 100%;
    align-items: center;
  }
  .wrapper.horizontal .label-wrapper {
    height: fit-content;
    align-items: center;
  }
  .wrapper.horizontal .label-wrapper.min-height-h1 {
    min-height: 3.125rem;
  }
  .wrapper.horizontal .label-wrapper.min-height-h2 {
    min-height: 2.5rem;
  }
  .wrapper.horizontal .label-wrapper.min-height-h3 {
    min-height: 2.1875rem;
  }
  .wrapper.horizontal .label-wrapper.min-height-h4 {
    min-height: 1.875rem;
  }
  .wrapper.horizontal .label-wrapper.min-height-h5 {
    min-height: 1.5625rem;
  }
  .wrapper.horizontal .label-wrapper.min-height-h6 {
    min-height: 1.25rem;
  }
}`;

// src/components/wizard/atlas-summary-item/atlas-summary-item.ts
var AtlasSummaryItem = /*#__PURE__*/(() => {
  let AtlasSummaryItem = class extends WithPopoverMixin(LitElement42) {
    constructor() {
      super(...arguments);
      this.size = "h4";
      this.themeVariation = 500;
      this._deviceController = new DeviceController(this);
    }
    getHeadingAlignment() {
      return this._deviceController.isMobile ? "left" : "right";
    }
    renderHighLightLabel() {
      return when92(this.labelHighlight, () => html144`<atlas-text bold muted class="highlight">${this.labelHighlight}</atlas-text>`);
    }
    renderDescription() {
      return when92(this.horizontal, () => html144`
                <atlas-heading
                    class="description"
                    alignment=${this.getHeadingAlignment()}
                    size=${this.size}
                    theme=${this.theme}
                    theme-variation=${this.themeVariation}
                >
                    ${this.description}
                </atlas-heading>
            `, () => html144`
                <atlas-text class="description" bold theme=${this.theme} theme-variation=${this.themeVariation}>
                    ${this.description}
                </atlas-text>
            `);
    }
    renderLabel() {
      return html144`
            <atlas-layout auto>
                <atlas-text muted>${this.label}</atlas-text>
                ${this.renderHighLightLabel()}
            </atlas-layout>
        `;
    }
    /** @internal */
    render() {
      const wrapperClass = {
        wrapper: true,
        horizontal: this.horizontal
      };
      const labelWrapperClass = {
        "label-wrapper": true,
        "horizontal": this.horizontal,
        [`min-height-${this.size}`]: !!this.size
      };
      return html144`
            <div class=${classMap98(wrapperClass)}>
                <div class=${classMap98(labelWrapperClass)}>${this.renderLabel()} ${this.renderPopoverInfoIcon()}</div>
                ${this.renderDescription()}
            </div>
        `;
    }
  };
  AtlasSummaryItem.styles = atlas_summary_item_default;
  return AtlasSummaryItem;
})();
__decorateClass([property148({
  type: String
})], AtlasSummaryItem.prototype, "label", 2);
__decorateClass([property148({
  type: String,
  attribute: "label-highlight"
})], AtlasSummaryItem.prototype, "labelHighlight", 2);
__decorateClass([property148({
  type: String
})], AtlasSummaryItem.prototype, "description", 2);
__decorateClass([property148({
  type: String,
  attribute: "size"
})], AtlasSummaryItem.prototype, "size", 2);
__decorateClass([property148({
  type: String,
  attribute: "theme"
})], AtlasSummaryItem.prototype, "theme", 2);
__decorateClass([property148({
  type: Number,
  attribute: "theme-variation"
})], AtlasSummaryItem.prototype, "themeVariation", 2);
__decorateClass([property148({
  type: Boolean
})], AtlasSummaryItem.prototype, "horizontal", 2);
AtlasSummaryItem = __decorateClass([customElement144("atlas-summary-item")], AtlasSummaryItem);

// src/components/wizard/atlas-summary-table/atlas-summary-table.ts
import { LitElement as LitElement43, html as html145 } from "lit";
import { customElement as customElement145, queryAssignedElements as queryAssignedElements13 } from "lit/decorators.js";

// src/components/wizard/atlas-summary-table/atlas-summary-table.scss
import { css as css131 } from "lit-element/lit-element.js";
var atlas_summary_table_default = css131`.summary-table {
  width: 100%;
}`;

// src/components/wizard/atlas-summary-table/atlas-summary-table.ts
var AtlasSummaryTable = /*#__PURE__*/(() => {
  let AtlasSummaryTable = class extends LitElement43 {
    getHeadingColumns() {
      return this._headerRows[0].getColumns();
    }
    onBodyRowsChange() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        const headingColumns = this.getHeadingColumns();
        this._bodyRows.forEach(row => {
          row.getColumns().forEach((column, index) => {
            column.setAttribute("size", headingColumns[index].size.toString());
            column.setAttribute("column-name", headingColumns[index].innerText);
          });
        });
      });
    }
    render() {
      return html145`
            <div class="summary-table">
                <slot name="header"></slot>
                <slot name="body" @slotchange=${this.onBodyRowsChange}></slot>
            </div>
        `;
    }
  };
  AtlasSummaryTable.styles = atlas_summary_table_default;
  return AtlasSummaryTable;
})();
__decorateClass([queryAssignedElements13({
  slot: "header",
  selector: "atlas-summary-table-row"
})], AtlasSummaryTable.prototype, "_headerRows", 2);
__decorateClass([queryAssignedElements13({
  slot: "body",
  selector: "atlas-summary-table-row"
})], AtlasSummaryTable.prototype, "_bodyRows", 2);
AtlasSummaryTable = __decorateClass([customElement145("atlas-summary-table")], AtlasSummaryTable);

// src/components/wizard/atlas-summary-table-col/atlas-summary-table-col.ts
import { LitElement as LitElement44, html as html146 } from "lit";
import { customElement as customElement146, property as property149 } from "lit/decorators.js";
import { classMap as classMap99 } from "lit/directives/class-map.js";
import { styleMap as styleMap26 } from "lit/directives/style-map.js";
import { when as when93 } from "lit/directives/when.js";

// src/components/wizard/atlas-summary-table-col/atlas-summary-table-col.scss
import { css as css132 } from "lit-element/lit-element.js";
var atlas_summary_table_col_default = css132`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
:host {
  display: contents;
}

.table-column {
  color: #212529;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.5;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
}
.table-column atlas-icon {
  display: none;
}
.table-column .title {
  color: #687078;
  font-weight: 400;
}
.table-column.is-header {
  font-weight: 700;
  text-transform: uppercase;
  color: #212529;
}

@media screen and (min-width: 992px) {
  .table-column {
    color: #687078;
    font-weight: 400;
    flex-direction: row;
    align-items: center;
  }
  .table-column atlas-icon {
    display: inline-flex;
  }
  .table-column .title {
    display: none;
  }
}`;

// src/components/wizard/atlas-summary-table-col/atlas-summary-table-col.ts
var AtlasSummaryTableCol = /*#__PURE__*/(() => {
  let AtlasSummaryTableCol = class extends LitElement44 {
    constructor() {
      super(...arguments);
      this.size = 100;
      this._deviceController = new DeviceController(this);
    }
    render() {
      const columnClass = {
        "table-column": true,
        "is-header": this.isHeader
      };
      const columnStyles = {
        width: this._deviceController.isMobile ? "100%" : `${this.size}%`
      };
      return html146`
            <div class=${classMap99(columnClass)} style=${styleMap26(columnStyles)}>
                ${when93(!!this.icon, () => html146`<atlas-icon name=${this.icon} size="3x"></atlas-icon>`)}
                ${when93(this._deviceController.isMobile, () => html146`<span class="title">${this.columnName}</span>`)}
                <slot></slot>
            </div>
        `;
    }
  };
  AtlasSummaryTableCol.styles = atlas_summary_table_col_default;
  return AtlasSummaryTableCol;
})();
__decorateClass([property149({
  type: String
})], AtlasSummaryTableCol.prototype, "icon", 2);
__decorateClass([property149({
  type: String,
  attribute: "column-name"
})], AtlasSummaryTableCol.prototype, "columnName", 2);
__decorateClass([property149({
  type: Number
})], AtlasSummaryTableCol.prototype, "size", 2);
__decorateClass([property149({
  type: Boolean,
  attribute: "is-header"
})], AtlasSummaryTableCol.prototype, "isHeader", 2);
AtlasSummaryTableCol = __decorateClass([customElement146("atlas-summary-table-col")], AtlasSummaryTableCol);

// src/components/wizard/atlas-summary-table-row/atlas-summary-table-row.ts
import { LitElement as LitElement45, html as html147 } from "lit";
import { customElement as customElement147, property as property150, queryAssignedElements as queryAssignedElements14 } from "lit/decorators.js";
import { classMap as classMap100 } from "lit/directives/class-map.js";

// src/components/wizard/atlas-summary-table-row/atlas-summary-table-row.scss
import { css as css133 } from "lit-element/lit-element.js";
var atlas_summary_table_row_default = css133`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
:host {
  display: block;
  border-bottom: 1px solid #ced4da;
  margin-bottom: 1.5rem;
  padding-bottom: 1.5rem;
}

:host(:last-child) {
  border: 0;
  margin-bottom: 0;
  padding-bottom: 0;
}

:host([is-header]) {
  display: none;
}

.table-row {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
  border-radius: 0.5rem;
  box-sizing: border-box;
  gap: 1rem;
}
.table-row.is-header {
  display: flex;
  padding: 0 1.5rem;
  background: none;
}

@media screen and (min-width: 992px) {
  :host {
    border-bottom: 0;
    padding-bottom: 0;
  }
  :host(:not(:last-child)) {
    margin-bottom: 1rem;
  }
  :host([is-header]) {
    display: block;
  }
  .table-row {
    flex-direction: row;
    padding: 1rem 1.5rem;
    gap: 2rem;
    background: var(--atlas-light);
  }
}`;

// src/components/wizard/atlas-summary-table-row/atlas-summary-table-row.ts
var AtlasSummaryTableRow = /*#__PURE__*/(() => {
  let AtlasSummaryTableRow = class extends LitElement45 {
    constructor() {
      super(...arguments);
      this.isHeader = false;
    }
    getColumns() {
      return this._columns;
    }
    onChangeColumns() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this.getColumns().forEach(column => {
          column.toggleAttribute("is-header", this.isHeader);
        });
      });
    }
    render() {
      const rowClass = {
        "table-row": true,
        "is-header": this.isHeader
      };
      return html147`
            <div class=${classMap100(rowClass)}>
                <slot @slotchange=${this.onChangeColumns}></slot>
            </div>
        `;
    }
  };
  AtlasSummaryTableRow.styles = atlas_summary_table_row_default;
  return AtlasSummaryTableRow;
})();
__decorateClass([property150({
  type: Boolean,
  attribute: "is-header"
})], AtlasSummaryTableRow.prototype, "isHeader", 2);
__decorateClass([queryAssignedElements14({
  selector: "atlas-summary-table-col"
})], AtlasSummaryTableRow.prototype, "_columns", 2);
AtlasSummaryTableRow = __decorateClass([customElement147("atlas-summary-table-row")], AtlasSummaryTableRow);

// src/components/wizard/atlas-wizard/atlas-wizard.ts
import { LitElement as LitElement46, html as html148, nothing as nothing12 } from "lit";
import { customElement as customElement148, property as property151, state as state70 } from "lit/decorators.js";
import { when as when94 } from "lit/directives/when.js";
import { classMap as classMap101 } from "lit/directives/class-map.js";
import { Map as ImmutableMap } from "immutable";

// src/internals/base-controller.ts
var BaseController = class {
  constructor() {
    this.stepState = {};
  }
  init() {
    var _a, _b;
    this.stepState = getFormValues(this.stepReference);
    (_b = (_a = this.customController) == null ? void 0 : _a.init) == null ? void 0 : _b.call(_a);
  }
  onShowStep() {
    var _a, _b;
    if (this.elementToScroll) {
      document.querySelector(this.elementToScroll).scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      });
      this.elementToScroll = null;
    } else {
      const modal = this.stepReference.closest("atlas-modal");
      if (modal === null) {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      } else {
        const wizardBody = this.stepReference.closest("atlas-wizard").shadowRoot.querySelector(".wizard-body");
        wizardBody.scroll({
          top: 0,
          behavior: "smooth"
        });
      }
    }
    (_b = (_a = this.customController) == null ? void 0 : _a.onShowStep) == null ? void 0 : _b.call(_a);
  }
  onSubmitStep() {
    return __async(this, null, function* () {
      var _a;
      const formValues = getFormValues(this.stepReference);
      this.stepState = __spreadValues(__spreadValues({}, this.stepState), formValues);
      if ((_a = this.customController) == null ? void 0 : _a.onSubmitStep) {
        return new Promise(resolve => {
          this.customController.onSubmitStep(resolve);
        });
      }
      return true;
    });
  }
  validate() {
    return __async(this, null, function* () {
      if (!this.stepReference.disableValidations) {
        if (!reportFormValidity(this.stepReference)) return false;
      }
      if (this.customController && this.customController.validate) {
        return new Promise(resolve => {
          this.customController.validate(resolve);
        });
      }
      return true;
    });
  }
  setStepReference(reference) {
    this.stepReference = reference;
  }
  setCustomController(customController) {
    this.customController = customController;
  }
  setState(keyOrState, value) {
    if (typeof keyOrState === "object") {
      this.stepState = __spreadValues(__spreadValues({}, this.stepState), keyOrState);
    } else {
      this.stepState[keyOrState] = value;
    }
  }
  getState() {
    return this.stepState;
  }
  clearState(key) {
    const keys = !Array.isArray(key) ? [key] : key;
    keys.forEach(stepKey => {
      this.stepState[stepKey] = "";
    });
  }
  setElementToScroll(elementToScroll) {
    this.elementToScroll = elementToScroll;
  }
  getExtraButtons() {
    var _a, _b;
    return (_b = (_a = this.customController) == null ? void 0 : _a.getExtraButtons) == null ? void 0 : _b.call(_a);
  }
};

// src/components/wizard/atlas-wizard/atlas-wizard.scss
import { css as css134 } from "lit-element/lit-element.js";
var atlas_wizard_default = css134`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Transitions */
.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 0.75rem !important;
}

.gap-4 {
  gap: 1rem !important;
}

.gap-5 {
  gap: 1.25rem !important;
}

.gap-6 {
  gap: 1.5rem !important;
}

.gap-7 {
  gap: 2rem !important;
}

.gap-8 {
  gap: 2.5rem !important;
}

.gap-9 {
  gap: 3rem !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 0.75rem !important;
}

.mt-4 {
  margin-top: 1rem !important;
}

.mt-5 {
  margin-top: 1.25rem !important;
}

.mt-6 {
  margin-top: 1.5rem !important;
}

.mt-7 {
  margin-top: 2rem !important;
}

.mt-8 {
  margin-top: 2.5rem !important;
}

.mt-9 {
  margin-top: 3rem !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 0.75rem !important;
}

.mb-4 {
  margin-bottom: 1rem !important;
}

.mb-5 {
  margin-bottom: 1.25rem !important;
}

.mb-6 {
  margin-bottom: 1.5rem !important;
}

.mb-7 {
  margin-bottom: 2rem !important;
}

.mb-8 {
  margin-bottom: 2.5rem !important;
}

.mb-9 {
  margin-bottom: 3rem !important;
}

.container {
  flex: 1 1 100%;
  box-sizing: border-box;
  padding: 0.5rem 1rem 1rem;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
@media screen and (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}
@media screen and (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}
@media screen and (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}
@media screen and (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}
@media screen and (min-width: 1400px) {
  .container {
    max-width: 1320px;
  }
}

.wizard {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
}

.wizard-header {
  position: sticky;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 10;
  background: #ffffff;
}
.wizard-header .wizard-header-title {
  border-bottom: 1px solid #ced4da;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-shrink: 0;
  height: 72px;
  box-sizing: border-box;
}
.wizard-header .wizard-header-title h1 {
  margin: 0;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1.25rem;
  font-weight: 600;
  color: #212529;
  line-height: 1.5rem;
  max-width: 80%;
  max-height: 100%;
  flex-wrap: wrap;
  word-break: break-word;
  overflow: hidden;
}
.wizard-header .wizard-header-title img {
  height: 2rem;
}
.wizard-header .wizard-header-title .slotted-header {
  height: 34px;
}
.wizard-header .wizard-header-title .wizard-close-button {
  position: absolute;
  transform: translateY(-50%);
  top: 50%;
  right: 1rem;
  text-decoration: none;
  color: #212529;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: color 0.35s ease;
  display: inline-flex;
}
.wizard-header .wizard-header-title .wizard-close-button:hover {
  color: #0030b9;
}
.wizard-header.only-close-button {
  display: contents;
}
.wizard-header.only-close-button .wizard-header-title {
  display: contents;
}
.wizard-header.only-close-button .wizard-header-title .wizard-close-button {
  top: 1.5rem;
  transform: none;
  z-index: 1;
}

.wizard-body {
  flex: 1 0 auto;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.wizard-body atlas-stepper {
  position: sticky;
  top: 72px;
  background: #ffffff;
  display: block;
  z-index: 10;
  flex-shrink: 0;
}
@media screen and (min-width: 992px) {
  .wizard-body {
    padding: 0 3rem 2rem;
  }
}
.wizard-body.centralized-content {
  padding-bottom: 0 !important;
}
.wizard-body.centralized-content .container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.wizard-footer {
  flex-shrink: 0;
  background: #ffffff;
  position: sticky;
  bottom: 0;
  left: 0;
  height: 4.5rem;
  width: 100%;
  padding: 0 1rem;
  box-sizing: border-box;
  border-top: 1px solid #ced4da;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  z-index: 10;
}

.wizard.is-modal-wizard {
  height: 100%;
  min-height: unset;
}
.wizard.is-modal-wizard .wizard-body {
  min-height: calc(100% - 72px - 72px);
  height: calc(100% - 72px - 72px);
  overflow-y: auto;
  scrollbar-gutter: stable both-edges;
}
@media screen and (min-width: 992px) {
  .wizard.is-modal-wizard .wizard-body {
    padding: 0 2rem 1.5rem;
  }
}
.wizard.is-modal-wizard .wizard-body atlas-stepper {
  position: fixed;
  left: 0.25rem;
  width: calc(100% - 0.5rem);
  background: #ffffff;
  box-sizing: border-box;
}
@media screen and (min-width: 992px) {
  .wizard.is-modal-wizard .wizard-body atlas-stepper {
    left: 1rem;
    width: calc(100% - 2rem);
    padding: 0 2rem;
  }
}
.wizard.is-modal-wizard .wizard-body .container {
  margin-top: 72px;
}
@media screen and (min-width: 992px) {
  .wizard.is-modal-wizard .wizard-body .container {
    margin-top: 128px;
  }
}
.wizard.is-modal-wizard .wizard-footer {
  position: relative;
  z-index: unset;
  border-radius: 0 0 0.5rem 0.5rem;
}
.wizard.is-modal-wizard.is-stepper-hidden .wizard-body {
  padding: 2rem 2.5rem !important;
}
.wizard.is-modal-wizard.is-stepper-hidden .wizard-body .container {
  padding: 0;
  margin-top: 0;
  margin-bottom: 0;
}
.wizard.is-modal-wizard.is-stepper-hidden .wizard-body:not(.centralized-content, .horizontally-centralized-content) .container {
  margin: 0;
}`;

// src/components/wizard/atlas-wizard/atlas-wizard.ts
var AtlasWizard = /*#__PURE__*/(() => {
  let AtlasWizard = class extends LitElement46 {
    constructor() {
      super(...arguments);
      this.hideStepper = false;
      this.hideCloseButton = false;
      this.hideHeaderCloseButton = false;
      this.onlyHeaderCloseButton = false;
      this.disableReturn = false;
      this.closeButtonLabel = "Fechar";
      this.closeButtonTheme = "secondary";
      this.finishButtonLabel = "Finalizar";
      this.finishButtonTheme = "success";
      this.hideHeader = false;
      this.hideFinishButton = false;
      this.isModalWizard = false;
      this._steps = [];
      this._currentStepIndex = 0;
      this._stepControllers = /* @__PURE__ */new Map();
      this._wizardConfig = ImmutableMap();
    }
    connectedCallback() {
      var _a;
      (_a = super.connectedCallback) == null ? void 0 : _a.call(this);
      this.addEventListener("atlas-wizard-step-go", this.goToStep);
      this.addEventListener("atlas-wizard-step-changed", this.syncSteps);
    }
    disconnectedCallback() {
      var _a;
      (_a = super.disconnectedCallback) == null ? void 0 : _a.call(this);
      this.removeEventListener("atlas-wizard-step-go", this.goToStep);
      this.removeEventListener("atlas-wizard-step-changed", this.syncSteps);
    }
    /**
     * Define as configurações da wizard em um objeto imutável
     * @param config - Configurações da wizard
     */
    setWizardConfig(config2) {
      this._wizardConfig = ImmutableMap(config2);
    }
    /**
     * Atualiza as configurações do wizard
     * @param config - Configurações da wizard
     */
    updateWizardConfig(config2) {
      this._wizardConfig = this._wizardConfig.merge(config2);
    }
    /**
     * Retorna as configurações da wizard
     * @returns {ImmutableMap<string, any>} - Configurações da wizard
     */
    getWizardConfig() {
      return this._wizardConfig;
    }
    /**
     * Retorna o índice do passo a partir do nome
     * @param stepName - Nome do passo
     * @returns {number} - Índice do passo
     */
    getStepIndex(stepName) {
      return this._steps.findIndex(step => step.name === stepName);
    }
    /**
     * Define um valor no state de um passo
     * @param stepName - Nome do passo
     * @param key - Chave do state ou um objeto com as chaves e valores que serão setados
     * @param value - Valor do state
     */
    setStepState(stepName, key, value) {
      var _a;
      (_a = this.getStepController(stepName)) == null ? void 0 : _a.setState(key, value);
    }
    /**
     * Retorna o state de um passo
     * @param stepName - Nome do passo
     * @returns {object} - State do passo
     */
    getStepState(stepName) {
      var _a;
      return (_a = this.getStepController(stepName)) == null ? void 0 : _a.getState();
    }
    /**
     * Limpa o state de um passo
     * @param stepName - Nome do passo
     * @param key - Chave do state ou um array de chaves
     */
    clearStepState(stepName, key) {
      var _a;
      (_a = this.getStepController(stepName)) == null ? void 0 : _a.clearState(key);
    }
    /**
     * Retorna o state completo da wizard
     * @param merged - Indica se o state dos passos será retornado em um único objeto
     * @returns {object} - State da wizard
     */
    getFullState(merged) {
      const fullState = {};
      this._stepControllers.forEach(stepController => {
        fullState[stepController.stepReference.name] = stepController.stepState;
      });
      return !merged ? fullState : Object.values(fullState).reduce((acc, cur) => __spreadValues(__spreadValues({}, acc), cur), {});
    }
    /**
     * Retorna o controller de um passo
     * @param stepName - Nome do passo
     * @returns {BaseController} - Controller do passo
     */
    getStepController(stepName) {
      return this._stepControllers.get(stepName);
    }
    /**
     * Retorna o controller de um passo a partir do índice
     * @param stepIndex - Índice do passo
     * @returns {BaseController} - Controller do passo
     */
    getStepControllerByIndex(stepIndex) {
      return this.getStepController(this._steps[stepIndex].name);
    }
    /**
     * Retorna todos os controllers dos passos
     * @returns {Record<string, BaseController>} - Mapa com os controllers de todos os passos
     */
    getStepsControllers() {
      const controllers = {};
      this._stepControllers.forEach((controller, stepName) => {
        controllers[stepName] = controller;
      });
      return controllers;
    }
    /**
     * Retorna todos os custom controllers dos passos
     * @returns {Record<string, BaseController>} - Mapa com os custom controllers de todos os passos
     */
    getStepsCustomControllers() {
      const customControllers = {};
      this._stepControllers.forEach((controller, stepName) => {
        if (!controller.customController) return;
        customControllers[stepName] = controller.customController;
      });
      return customControllers;
    }
    /**
     * Adiciona um controller customizado a um passo
     * @param stepName - Nome do passo
     * @param customController - Controller customizado
     */
    addStepController(stepName, customController) {
      let stepController;
      if (this._stepControllers.has(stepName)) {
        stepController = this.getStepController(stepName);
        stepController.setCustomController(customController);
      } else {
        stepController = new BaseController();
        stepController.setCustomController(customController);
        this._stepControllers.set(stepName, stepController);
      }
      stepController.init();
    }
    /**
     * Retorna a referência de um passo
     * @param stepName - Nome do passo
     * @returns {AtlasWizardStep} - Referência do passo
     */
    getStepReference(stepName) {
      var _a;
      return (_a = this.getStepController(stepName)) == null ? void 0 : _a.stepReference;
    }
    /**
     * Retorna todas as referências de passos
     * @returns {Record<string, AtlasWizardStep>} - Objeto com nome do passo e referência
     */
    getStepsReferences() {
      const references = {};
      this._steps.forEach(step => {
        references[step.name] = this.getStepReference(step.name);
      });
      return references;
    }
    /**
     * Retorna a referência do passo atual
     * @returns {AtlasWizardStep} - Referência do passo atual
     */
    getCurrentStep() {
      return this.getStepReference(this._currentStep);
    }
    /**
     * Navega para um passo a partir do nome dele
     * @param stepName - Nome do passo
     * @param elementToScroll - Elemento que será focado após a navegação
     * @param ignoreValidation - Indica que a validação do passo será ignorada
     */
    goToStepWithName(stepName, elementToScroll, ignoreValidation) {
      const stepIndex = this.getStepIndex(stepName);
      this.changeStep(stepIndex, elementToScroll, ignoreValidation);
    }
    /**
     * Habilita ou desabilita os eventos dos uploaders de um passo
     * @internal
     * @param step - Referência do passo que contém os uploaders
     * @param isVisible - Indica se os eventos dos uploaders serão habilitados ou desabilitados
     */
    toggleUploaderEvents(step, isVisible) {
      step.querySelectorAll("atlas-uploader").forEach(uploader => {
        uploader.toggleAttribute("disabled", !isVisible);
      });
    }
    /**
     * Faz o scroll da wizard para o topo
     */
    scrollToTop() {
      this.shadowRoot.querySelector(".wizard-body").scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
    /**
     * Retorna a referência do botão de "Finalizar" da wizard, caso exista.
     * @returns { AtlasButton | null } - Referência do botão de "Finalizar" da wizard
     */
    getFinishButton() {
      if (!this.shouldRenderFinishButton()) return null;
      return this.shadowRoot.querySelector(".atlas-wizard-finish-button");
    }
    onChangeSlot() {
      return __async(this, null, function* () {
        yield this.updateComplete;
        this.syncSteps();
        if (this._steps.length === 0) return;
        this._steps.forEach(step => {
          step.toggleAttribute("is-modal-wizard", this.isModalWizard);
          let stepController = this.getStepController(step.name);
          if (stepController) {
            stepController.setStepReference(step);
          } else {
            stepController = new BaseController();
            stepController.setStepReference(step);
            this._stepControllers.set(step.name, stepController);
          }
          step.setStepController(stepController);
          stepController.init();
        });
        const activeStep = this._steps.find(step => step.active && !step.disabled);
        this.setActiveStep(activeStep == null ? void 0 : activeStep.name);
      });
    }
    setActiveStep(activeStepName) {
      const activeStepIndex = this.getStepIndex(activeStepName);
      this._currentStepIndex = activeStepIndex >= 0 ? activeStepIndex : 0;
      this.changeStep(this._currentStepIndex);
    }
    syncSteps() {
      const stepElements = ["ATLAS-WIZARD-STEP", "ATLAS-WIZARD-INTRO-STEP", "ATLAS-WIZARD-FINISH-STEP"];
      const defaultSlot = this.shadowRoot.querySelector("slot:not([name])");
      this._steps = defaultSlot.assignedElements().filter(element => stepElements.includes(element.tagName)).map(step => step);
    }
    showCurrentStep() {
      this._steps.forEach(step => {
        const isVisible = step.name === this._currentStep;
        step.toggleStep(isVisible);
        this.toggleUploaderEvents(step, isVisible);
        if (isVisible) {
          this.getStepController(step.name).onShowStep();
        }
      });
    }
    getNextEnabledIndex(stepIndex) {
      const nextStepIndex = stepIndex;
      if (!this._steps[stepIndex].disabled) {
        return nextStepIndex;
      }
      return this.getNextEnabledIndex(stepIndex < this._currentStepIndex ? stepIndex - 1 : stepIndex + 1);
    }
    canChangeStep(stepIndex, ignoreValidation) {
      return __async(this, null, function* () {
        if (stepIndex <= this._currentStepIndex || ignoreValidation) {
          return true;
        }
        const stepController = this.getStepControllerByIndex(this._currentStepIndex);
        const isValid = yield stepController.validate();
        return isValid;
      });
    }
    changeStep(stepIndex, elementToScroll, ignoreValidation) {
      return __async(this, null, function* () {
        const canChange = yield this.canChangeStep(stepIndex, ignoreValidation);
        if (!canChange) return;
        if (stepIndex > this._currentStepIndex) {
          const hasSubmitted = yield this.getStepControllerByIndex(this._currentStepIndex).onSubmitStep();
          if (!hasSubmitted) return;
        }
        const previousStepIndex = this._currentStepIndex;
        this._currentStepIndex = this.getNextEnabledIndex(stepIndex);
        this._currentStep = this._steps[this._currentStepIndex].name;
        this.getStepControllerByIndex(this._currentStepIndex).setElementToScroll(elementToScroll);
        this.showCurrentStep();
        closeAllAlerts();
        emit(this, "atlas-wizard-change-step", {
          detail: {
            step: this._steps[this._currentStepIndex],
            previousStep: this._steps[previousStepIndex]
          }
        });
      });
    }
    previousStep() {
      this.changeStep(this._currentStepIndex - 1);
      emit(this, "atlas-wizard-previous-step");
    }
    nextStep(ignoreValidation) {
      this.changeStep(this._currentStepIndex + 1, null, ignoreValidation);
      emit(this, "atlas-wizard-next-step");
    }
    closeWizard() {
      emit(this, "atlas-wizard-close");
    }
    finishWizard() {
      return __async(this, null, function* () {
        const stepController = this.getStepControllerByIndex(this._currentStepIndex);
        const isValid = yield stepController.validate();
        if (!isValid) return;
        const hasSubmitted = yield stepController.onSubmitStep();
        if (!hasSubmitted) return;
        emit(this, "atlas-wizard-finish", {
          detail: {
            steps: this._steps.filter(step => !step.disabled)
          }
        });
      });
    }
    goToStep(event) {
      event.stopPropagation();
      const {
        step,
        element
      } = event.detail;
      const stepName = step || event.target.name;
      this.goToStepWithName(stepName, element);
    }
    isReturnDisabled() {
      var _a;
      return this.disableReturn || ((_a = this.getStepReference(this._currentStep)) == null ? void 0 : _a.disableReturn);
    }
    isIntroOrFinishStep() {
      var _a;
      return (_a = this.getStepReference(this._currentStep)) == null ? void 0 : _a.isOffStep();
    }
    isOnlyHeaderCloseButton() {
      return this.onlyHeaderCloseButton && !this.hideHeaderCloseButton && this.isIntroOrFinishStep();
    }
    finishStepIsOnlyInfo() {
      const lastStepName = this._steps[this._steps.length - 1].name;
      const lastStep = this.getStepReference(lastStepName);
      if (!lastStep.isOffStep()) return false;
      return lastStep.onlyInfo;
    }
    shouldRenderCloseButton() {
      const stepReference = this.getStepReference(this._currentStep);
      if (stepReference == null ? void 0 : stepReference.showCloseButton) return true;
      return !this.hideCloseButton && this._currentStepIndex === 0;
    }
    shouldRenderBackButton() {
      const stepReference = this.getStepReference(this._currentStep);
      if ((stepReference == null ? void 0 : stepReference.hideButtons) || this.isReturnDisabled()) {
        return false;
      }
      return this._currentStepIndex > 0 && this._steps.length > 1;
    }
    shouldRenderFinishButton() {
      if (this.hideFinishButton) return false;
      const stepReference = this.getStepReference(this._currentStep);
      if (this._steps.length <= 0 || (stepReference == null ? void 0 : stepReference.hideButtons)) return false;
      let lastStepIndex = this._steps.length - 1;
      if (this.finishStepIsOnlyInfo()) lastStepIndex = this._steps.length - 2;
      return this._currentStepIndex === lastStepIndex;
    }
    shouldRenderNextButton() {
      if (this._steps.length <= 1) return false;
      let lastStepIndex = this._steps.length - 1;
      if (this.finishStepIsOnlyInfo()) lastStepIndex = this._steps.length - 2;
      return this._currentStepIndex !== lastStepIndex;
    }
    renderStepper() {
      return when94(!this.hideStepper && this._steps.length > 0 && !this.isIntroOrFinishStep(), () => html148`
                <atlas-stepper
                    .steps=${this._steps}
                    current-step=${this._currentStep}
                    current-step-index=${this._currentStepIndex}
                    ?disable-return=${this.isReturnDisabled()}
                ></atlas-stepper>
            `);
    }
    renderCloseButton() {
      return when94(this.shouldRenderCloseButton(), () => html148`
                <atlas-button
                    size="md"
                    theme=${this.closeButtonTheme || "secondary"}
                    description=${this.closeButtonLabel || "Fechar"}
                    @atlas-button-click=${this.closeWizard}
                ></atlas-button>
            `);
    }
    renderBackButton() {
      return when94(this.shouldRenderBackButton(), () => html148`
                <atlas-button
                    size="md"
                    theme="secondary"
                    description="Voltar"
                    @atlas-button-click=${this.previousStep}
                ></atlas-button>
            `);
    }
    renderNextButton() {
      const stepReference = this.getStepReference(this._currentStep);
      return when94(this.shouldRenderNextButton(), () => html148`
                <atlas-button
                    size="md"
                    theme=${(stepReference == null ? void 0 : stepReference.nextButtonTheme) || "primary"}
                    description=${(stepReference == null ? void 0 : stepReference.nextButtonLabel) || "Avan\xE7ar"}
                    @atlas-button-click=${() => this.nextStep()}
                ></atlas-button>
            `);
    }
    renderFinishButton() {
      return when94(this.shouldRenderFinishButton(), () => html148`
                <atlas-button
                    size="md"
                    class="atlas-wizard-finish-button"
                    theme=${this.finishButtonTheme || "success"}
                    description=${this.finishButtonLabel || "Finalizar"}
                    @atlas-button-click=${this.finishWizard}
                ></atlas-button>
            `);
    }
    renderExtraButtons() {
      var _a;
      const extraButtons = ((_a = this.getStepController(this._currentStep)) == null ? void 0 : _a.getExtraButtons()) || [];
      return extraButtons.map(customButton => html148`
                <atlas-button
                    size="md"
                    theme=${customButton.theme || "secondary"}
                    description=${customButton.description}
                    @atlas-button-click=${customButton.click}
                ></atlas-button>
            `);
    }
    renderHeader() {
      if (this.isOnlyHeaderCloseButton()) return nothing12;
      if (this.headerImage) {
        return html148`<img src=${this.headerImage} alt=${this.headerImageDescription} />`;
      }
      if (this.header) {
        return html148`<h1>${this.header}</h1>`;
      }
      return html148`
            <div class="slotted-header">
                <slot name="header"></slot>
            </div>
        `;
    }
    renderHeaderCloseButton() {
      return when94(this.isOnlyHeaderCloseButton() || !this.hideHeaderCloseButton, () => html148`
                <button @click=${this.closeWizard} class="wizard-close-button" aria-label="Fechar">
                    <atlas-icon name="x" size="3x"></atlas-icon>
                </button>
            `);
    }
    renderWizardHeader() {
      const wizardHeaderClass = {
        "wizard-header": true,
        "only-close-button": this.isOnlyHeaderCloseButton()
      };
      return when94(!this.hideHeader, () => html148`
                <header class=${classMap101(wizardHeaderClass)}>
                    <div class="wizard-header-title">${this.renderHeader()}${this.renderHeaderCloseButton()}</div>
                </header>
            `);
    }
    render() {
      var _a, _b;
      const wizardClass = {
        "wizard": true,
        "is-modal-wizard": this.isModalWizard,
        "is-stepper-hidden": this.hideStepper || this._steps.length === 0 || this.isIntroOrFinishStep()
      };
      const bodyClass = {
        "wizard-body": true,
        "centralized-content": (_a = this.getCurrentStep()) == null ? void 0 : _a.centralizedContent,
        "horizontally-centralized-content": (_b = this.getCurrentStep()) == null ? void 0 : _b.horizontallyCentralizedContent
      };
      return html148`
            <div class=${classMap101(wizardClass)}>
                ${this.renderWizardHeader()}
                <main class=${classMap101(bodyClass)}>
                    ${this.renderStepper()}
                    <div class="container">
                        <slot @slotchange=${this.onChangeSlot}></slot>
                    </div>
                </main>
                <footer class="wizard-footer">
                    ${this.renderCloseButton()} ${this.renderBackButton()} ${this.renderExtraButtons()}
                    ${this.renderNextButton()} ${this.renderFinishButton()}
                </footer>
            </div>
        `;
    }
  };
  AtlasWizard.styles = atlas_wizard_default;
  return AtlasWizard;
})();
__decorateClass([property151({
  type: String
})], AtlasWizard.prototype, "header", 2);
__decorateClass([property151({
  type: String,
  attribute: "header-image"
})], AtlasWizard.prototype, "headerImage", 2);
__decorateClass([property151({
  type: String,
  attribute: "header-image-description"
})], AtlasWizard.prototype, "headerImageDescription", 2);
__decorateClass([property151({
  type: Boolean,
  attribute: "hide-stepper"
})], AtlasWizard.prototype, "hideStepper", 2);
__decorateClass([property151({
  type: Boolean,
  attribute: "hide-close-button"
})], AtlasWizard.prototype, "hideCloseButton", 2);
__decorateClass([property151({
  type: Boolean,
  attribute: "hide-header-close-button"
})], AtlasWizard.prototype, "hideHeaderCloseButton", 2);
__decorateClass([property151({
  type: Boolean,
  attribute: "only-header-close-button"
})], AtlasWizard.prototype, "onlyHeaderCloseButton", 2);
__decorateClass([property151({
  type: Boolean,
  attribute: "disable-return"
})], AtlasWizard.prototype, "disableReturn", 2);
__decorateClass([property151({
  type: String,
  attribute: "close-button-label"
})], AtlasWizard.prototype, "closeButtonLabel", 2);
__decorateClass([property151({
  type: String,
  attribute: "close-button-theme"
})], AtlasWizard.prototype, "closeButtonTheme", 2);
__decorateClass([property151({
  type: String,
  attribute: "finish-button-label"
})], AtlasWizard.prototype, "finishButtonLabel", 2);
__decorateClass([property151({
  type: String,
  attribute: "finish-button-theme"
})], AtlasWizard.prototype, "finishButtonTheme", 2);
__decorateClass([property151({
  type: Boolean,
  attribute: "hide-header"
})], AtlasWizard.prototype, "hideHeader", 2);
__decorateClass([property151({
  type: Boolean,
  attribute: "hide-finish-button"
})], AtlasWizard.prototype, "hideFinishButton", 2);
__decorateClass([property151({
  type: Boolean,
  attribute: "is-modal-wizard"
})], AtlasWizard.prototype, "isModalWizard", 2);
__decorateClass([state70()], AtlasWizard.prototype, "_steps", 2);
__decorateClass([state70()], AtlasWizard.prototype, "_currentStep", 2);
__decorateClass([state70()], AtlasWizard.prototype, "_currentStepIndex", 2);
__decorateClass([state70()], AtlasWizard.prototype, "_stepControllers", 2);
__decorateClass([state70()], AtlasWizard.prototype, "_wizardConfig", 2);
AtlasWizard = __decorateClass([customElement148("atlas-wizard")], AtlasWizard);

// src/components/wizard/atlas-wizard-finish-step/atlas-wizard-finish-step.ts
import { customElement as customElement150, property as property153 } from "lit/decorators.js";

// src/components/wizard/atlas-wizard-step/atlas-wizard-step.ts
import { LitElement as LitElement47, html as html149 } from "lit";
import { customElement as customElement149, property as property152, state as state71 } from "lit/decorators.js";
import { classMap as classMap102 } from "lit/directives/class-map.js";

// src/components/wizard/atlas-wizard-step/atlas-wizard-step.scss
import { css as css135 } from "lit-element/lit-element.js";
var atlas_wizard_step_default = css135`:host {
  display: none;
  width: 100%;
}

:host([visible]) {
  display: inline-flex;
}

.step-content {
  display: block;
  width: 100%;
}
.step-content:not(.is-modal-wizard).off-step {
  margin-top: 0.5rem;
}

::slotted(atlas-section:last-child) {
  margin-bottom: 0;
}

@media screen and (min-width: 992px) {
  .step-content:not(.is-modal-wizard).off-step {
    margin-top: 2rem;
  }
}`;

// src/components/wizard/atlas-wizard-step/atlas-wizard-step.ts
var AtlasWizardStep = /*#__PURE__*/(() => {
  let AtlasWizardStep = class extends LitElement47 {
    constructor() {
      super();
      this.active = false;
      this.disabled = false;
      this.disableValidations = false;
      this.disableReturn = false;
      this.nextButtonTheme = "primary";
      this.centralizedContent = false;
      this.hideButtons = false;
      this.horizontallyCentralizedContent = false;
      this.showCloseButton = false;
      this.isModalWizard = false;
      this._visible = false;
      this.goToStep = this.goToStep.bind(this);
    }
    getStepCustomController() {
      return this._stepController.customController;
    }
    setStepController(stepController) {
      this._stepController = stepController;
    }
    setState(key, value) {
      var _a;
      (_a = this._stepController) == null ? void 0 : _a.setState(key, value);
    }
    getState() {
      var _a;
      return (_a = this._stepController) == null ? void 0 : _a.getState();
    }
    clearState(key) {
      var _a;
      (_a = this._stepController) == null ? void 0 : _a.clearState(key);
    }
    toggleStep(show) {
      this._visible = show;
      this.toggleAttribute("visible", this._visible);
    }
    goToStep() {
      emit(this, "atlas-wizard-step-go", {
        trackDisable: true
      });
    }
    onChangeDisabled() {
      emit(this, "atlas-wizard-step-changed", {
        trackDisable: true
      });
    }
    isOffStep() {
      return this._offStep;
    }
    render() {
      const stepClass = {
        "step-content": true,
        "off-step": this._offStep,
        "is-modal-wizard": this.isModalWizard
      };
      return html149`
            <div class="${classMap102(stepClass)}">
                <slot></slot>
            </div>
        `;
    }
  };
  AtlasWizardStep.styles = atlas_wizard_step_default;
  return AtlasWizardStep;
})();
__decorateClass([property152({
  type: String
})], AtlasWizardStep.prototype, "name", 2);
__decorateClass([property152({
  type: String
})], AtlasWizardStep.prototype, "header", 2);
__decorateClass([property152({
  type: Boolean,
  reflect: true
})], AtlasWizardStep.prototype, "active", 2);
__decorateClass([property152({
  type: Boolean,
  reflect: true
})], AtlasWizardStep.prototype, "disabled", 2);
__decorateClass([property152({
  type: Boolean,
  reflect: true,
  attribute: "disable-validations"
})], AtlasWizardStep.prototype, "disableValidations", 2);
__decorateClass([property152({
  type: Boolean,
  attribute: "disable-return"
})], AtlasWizardStep.prototype, "disableReturn", 2);
__decorateClass([property152({
  type: String,
  attribute: "next-button-label"
})], AtlasWizardStep.prototype, "nextButtonLabel", 2);
__decorateClass([property152({
  type: String,
  attribute: "next-button-theme"
})], AtlasWizardStep.prototype, "nextButtonTheme", 2);
__decorateClass([property152({
  type: Boolean,
  attribute: "centralized-content"
})], AtlasWizardStep.prototype, "centralizedContent", 2);
__decorateClass([property152({
  type: Boolean,
  attribute: "hide-buttons"
})], AtlasWizardStep.prototype, "hideButtons", 2);
__decorateClass([property152({
  type: Boolean,
  attribute: "horizontally-centralized-content"
})], AtlasWizardStep.prototype, "horizontallyCentralizedContent", 2);
__decorateClass([property152({
  type: Boolean,
  attribute: "show-close-button"
})], AtlasWizardStep.prototype, "showCloseButton", 2);
__decorateClass([property152({
  type: Boolean,
  attribute: "is-modal-wizard"
})], AtlasWizardStep.prototype, "isModalWizard", 2);
__decorateClass([state71()], AtlasWizardStep.prototype, "_visible", 2);
__decorateClass([state71()], AtlasWizardStep.prototype, "_stepController", 2);
__decorateClass([Watch("disabled", true)], AtlasWizardStep.prototype, "onChangeDisabled", 1);
AtlasWizardStep = __decorateClass([customElement149("atlas-wizard-step")], AtlasWizardStep);

// src/components/wizard/atlas-wizard-finish-step/atlas-wizard-finish-step.ts
var AtlasWizardFinishStep = class extends AtlasWizardStep {
  constructor() {
    super();
    this._offStep = true;
  }
};
__decorateClass([property153({
  type: Boolean,
  attribute: "only-info"
})], AtlasWizardFinishStep.prototype, "onlyInfo", 2);
AtlasWizardFinishStep = __decorateClass([customElement150("atlas-wizard-finish-step")], AtlasWizardFinishStep);

// src/components/wizard/atlas-wizard-intro-step/atlas-wizard-intro-step.ts
import { customElement as customElement151 } from "lit/decorators.js";
var AtlasWizardIntroStep = class extends AtlasWizardStep {
  constructor() {
    super();
    this._offStep = true;
  }
};
AtlasWizardIntroStep = __decorateClass([customElement151("atlas-wizard-intro-step")], AtlasWizardIntroStep);

// src/helpers/browser.ts
var browser_exports = {};
__export(browser_exports, {
  openWindow: () => openWindow,
  redirect: () => redirect,
  refreshPage: () => refreshPage,
  replaceUrlParamsWithoutReload: () => replaceUrlParamsWithoutReload,
  stealthOpenWindow: () => stealthOpenWindow
});
import { v4 as uuidv42 } from "uuid";
import qs2 from "qs";
var isExternalPage = options => options.external || options.popup || options.target && !["_self", "_top", "_parent"].includes(options.target);
var getCenteredPopupAttributes = (width, height) => {
  if (!width || !height) return null;
  const left = (window.screen.width - width) / 2;
  const top = (window.screen.height - height) / 4;
  return {
    top,
    left,
    width,
    height
  };
};
var refreshPage = options => {
  if (isEmptyValue(options)) {
    window.location.reload();
    return;
  }
  let lastUrlParams;
  let optionsParams;
  if (options.hasOwnProperty("keepParams") && options.keepParams) {
    lastUrlParams = Object.fromEntries(new URLSearchParams(window.location.search));
  }
  if (options.hasOwnProperty("params")) {
    optionsParams = options.params;
  }
  const urlParams = qs2.stringify(__spreadValues(__spreadValues({}, lastUrlParams), optionsParams), {
    indices: false
  });
  window.location.assign(`${window.location.pathname}${urlParams ? `?${urlParams}` : ""}`);
};
var redirect = options => {
  openWindow(options);
};
var openWindow = options => {
  let params;
  if (options.hasOwnProperty("params")) {
    params = qs2.stringify(options.params, {
      indices: false
    });
  }
  const path = `${options.path}${params ? `?${params}` : ""}`;
  const windowFeatures = [];
  const baseTarget = isExternalPage(options) ? "_blank" : "_self";
  if (options.external) {
    windowFeatures.push("noreferrer");
  }
  if (options.popup) {
    if (typeof options.popup === "object") {
      const popupAttributes = getCenteredPopupAttributes(options.popup.width, options.popup.height);
      if (popupAttributes) {
        windowFeatures.push(`width=${popupAttributes.width}`);
        windowFeatures.push(`height=${popupAttributes.height}`);
        windowFeatures.push(`top=${popupAttributes.top}`);
        windowFeatures.push(`left=${popupAttributes.left}`);
      } else {
        windowFeatures.push("popup");
      }
    } else {
      windowFeatures.push("popup");
    }
  }
  return window.open(path, options.target || baseTarget, windowFeatures.join(","));
};
var stealthOpenWindow = options => {
  const form = document.createElement("form");
  form.method = "POST";
  form.target = options.target || "_self";
  form.action = options.path;
  form.style.display = "none";
  Object.entries(options.params || {}).forEach(([key, value]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = key;
    input.value = value;
    form.appendChild(input);
  });
  if (isExternalPage(options)) {
    const windowName = `atlas-window-${options.target || uuidv42()}`;
    form.onsubmit = () => {
      openWindow({
        path: "about:blank",
        target: windowName,
        popup: options.popup
      });
      form.target = windowName;
    };
  }
  document.body.appendChild(form);
  form.requestSubmit();
  document.body.removeChild(form);
};
var removeEmptyValues = obj => {
  const cleanedEntry = Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, value === Object(value) ? removeEmptyValues(value) : value]).filter(([, value]) => !isEmptyValue(value)));
  return Array.isArray(obj) ? Object.values(cleanedEntry) : cleanedEntry;
};
var replaceUrlParamsWithoutReload = params => {
  const urlParams = qs2.stringify(removeEmptyValues(params), {
    indices: false
  });
  const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${urlParams}`;
  window.history.pushState({
    path: newurl
  }, "", newurl);
};

// src/helpers/loading.ts
var loading_exports = {};
__export(loading_exports, {
  closeLoading: () => closeLoading,
  showLoading: () => showLoading
});

// src/components/display/atlas-loading/loading-system.ts
var LOADING_BACKDROP_CLASS = "atlas-loading-backdrop";
var LOADING_BACKDROP_SELECTOR = `.${LOADING_BACKDROP_CLASS}`;
function showLoading(options) {
  let context;
  let message;
  let showCloseButton = false;
  let onClickCloseButton = null;
  let isInsideElement = false;
  if (!options || typeof options === "string") {
    message = options ? `${options}` : "";
    context = document.body;
  } else {
    message = options.message;
    context = options.element || document.body;
    isInsideElement = !!options.element;
    showCloseButton = !!options.showCloseButton;
    onClickCloseButton = options.onClickCloseButton;
  }
  if (context.querySelector(LOADING_BACKDROP_SELECTOR)) {
    context.querySelector("atlas-loading").setAttribute("message", message || "");
    return;
  }
  const loadingBackdrop = document.createElement("div");
  loadingBackdrop.classList.add(LOADING_BACKDROP_CLASS);
  loadingBackdrop.classList.toggle("inside-element", isInsideElement);
  const loadingElement = document.createElement("atlas-loading");
  loadingElement.message = message;
  loadingElement.contentLoading = isInsideElement;
  loadingElement.showCloseButton = showCloseButton;
  loadingBackdrop.prepend(loadingElement);
  context.prepend(loadingBackdrop);
  loadingElement.addEventListener("atlas-loading-close-button-click", () => {
    loadingBackdrop == null ? void 0 : loadingBackdrop.remove();
    if (typeof onClickCloseButton === "function") {
      onClickCloseButton();
    }
  });
  if (document.activeElement instanceof HTMLElement) {
    document.activeElement.blur();
  }
}
function closeLoading(element) {
  var _a, _b;
  const context = element || document.body;
  (_a = context.querySelector("atlas-loading")) == null ? void 0 : _a.destroy();
  (_b = context.querySelector(LOADING_BACKDROP_SELECTOR)) == null ? void 0 : _b.remove();
}
export { AtlasAlert, AtlasAutocomplete, AtlasAvatar, AtlasBadge, AtlasBarChartItem, AtlasBottomSheet, AtlasBreadcrumb, AtlasBreadcrumbItem, AtlasButton, AtlasButtonGroup, AtlasCalendar, AtlasCalendarTimeline, AtlasCalendarTimelineItem, AtlasCaption, AtlasCard, AtlasCardBrand, AtlasCardButton, AtlasCardNumber, AtlasCardPreview, AtlasCarousel, AtlasChart, AtlasCheckbox, AtlasChecklist, AtlasChecklistItem, AtlasCol, AtlasCollapse, AtlasCollapseButton, AtlasCollapsibleText, AtlasColumnChart, AtlasComparisonChart, AtlasCriticalAction, AtlasCriticalActionItem, AtlasCriticalActionList, AtlasDatePicker, AtlasDateRange, AtlasDesktopDropdown, AtlasDialog, AtlasDisplay, AtlasDivider, AtlasDropdown, AtlasDropdownButton, AtlasDropdownItem, AtlasEasyTable, AtlasEditor, AtlasElementGroup, AtlasEmptyState, AtlasFilter, AtlasFilterForm, AtlasFilterGroup, AtlasFixedAlert, AtlasFloatInput, AtlasFlowChart, AtlasForm, AtlasFormPanel, AtlasFormStep, AtlasGrid, AtlasHeading, AtlasHelper, AtlasHelperText, AtlasHotspot, AtlasIcon, AtlasIconButton, AtlasIllustration, AtlasImage, AtlasImagePreview, AtlasImagePreviewControl, AtlasInput, AtlasIntegerInput, AtlasLabeledContent, AtlasLayout, AtlasLink, AtlasLoading, AtlasMaskedInput, AtlasModal, AtlasMoney, AtlasMultiselect, AtlasNavbar, AtlasNavbarDropdown, AtlasNewSidebar, AtlasNotificationCard, AtlasNotificationCenterCard, AtlasNotificationCenterGroup, AtlasOffcanvas, AtlasOnboarding, AtlasOnboardingStep, AtlasOneTimeCode, AtlasOption, AtlasPage, AtlasPageContent, AtlasPageFooter, AtlasPageHeader, AtlasPageSection, AtlasPageTab, AtlasPageTabsWrapper, AtlasPanel, AtlasPasswordInput, AtlasPercentage, AtlasPopover, AtlasPostalCode, AtlasPreview, AtlasPrivateContent, AtlasProductCard, AtlasProgressBar, AtlasPromotionalBanner, AtlasRadio, AtlasRating, AtlasRow, AtlasScreen, AtlasSearchInput, AtlasSection, AtlasSectionGroup, AtlasSelect, AtlasSelectItem, AtlasSelectionCard, AtlasSidebar, AtlasSidebarMenu, AtlasSidebarMenuContext, AtlasSidebarMenuGroup, AtlasSidebarMenuItem, AtlasSocialButton, AtlasStepper, AtlasSummaryCard, AtlasSummaryContainer, AtlasSummaryItem, AtlasSummaryTable, AtlasSummaryTableCol, AtlasSummaryTableRow, AtlasSwitch, AtlasTable, AtlasTableBody, AtlasTableCol, AtlasTableFooter, AtlasTableHeader, AtlasTableRow, AtlasTag, AtlasText, AtlasTextarea, AtlasToast, AtlasToastContainer, AtlasToggle, AtlasToggleItem, AtlasToolbar, AtlasTooltip, AtlasUploader, AtlasUploaderFile, AtlasVisibilityIconButton, AtlasWizard, AtlasWizardFinishStep, AtlasWizardIntroStep, AtlasWizardStep, base_path_exports as basePath, browser_exports as browser, card_exports as card, card_preview_exports as cardPreview, cpf_cnpj_exports as cpfCnpj, device_exports as device, email_exports as email, form_exports as form, formatters_exports as formatters, id_exports as id, loading_exports as loading, mfa_exports as mfa, month_year_exports as monthYear, notifications_exports as notifications, overlay_exports as overlay, phone_number_exports as phoneNumber, postal_code_exports as postalCode, privacy_exports as privacy, request_exports as request, validations_exports as validations };